/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.0.6.0 (NJsonSchema v10.0.23.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isTenantAvailable(body: IsTenantAvailableInput | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(<any>response_);
                } catch (e) {
                    return <Observable<IsTenantAvailableOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<IsTenantAvailableOutput>><any>_observableThrow(response_);
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsTenantAvailableOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IsTenantAvailableOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resolveTenantId(body: ResolveTenantIdInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResolveTenantId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResolveTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResolveTenantId(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processResolveTenantId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    register(body: RegisterInput | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(<any>response_);
                } catch (e) {
                    return <Observable<RegisterOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegisterOutput>><any>_observableThrow(response_);
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisterOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendPasswordResetCode(body: SendPasswordResetCodeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendPasswordResetCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPasswordResetCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPasswordResetCode(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendPasswordResetCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordInput | undefined): Observable<ResetPasswordOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(<any>response_);
                } catch (e) {
                    return <Observable<ResetPasswordOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResetPasswordOutput>><any>_observableThrow(response_);
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<ResetPasswordOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResetPasswordOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResetPasswordOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendEmailActivationLink(body: SendEmailActivationLinkInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendEmailActivationLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmailActivationLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmailActivationLink(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendEmailActivationLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activateEmail(body: ActivateEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/ActivateEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateEmail(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processActivateEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    impersonate(body: ImpersonateInput | undefined): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Impersonate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonate(<any>response_);
                } catch (e) {
                    return <Observable<ImpersonateOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<ImpersonateOutput>><any>_observableThrow(response_);
        }));
    }

    protected processImpersonate(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImpersonateOutput>(<any>null);
    }

    /**
     * @return Success
     */
    backToImpersonator(): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/BackToImpersonator";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBackToImpersonator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBackToImpersonator(<any>response_);
                } catch (e) {
                    return <Observable<ImpersonateOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<ImpersonateOutput>><any>_observableThrow(response_);
        }));
    }

    protected processBackToImpersonator(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImpersonateOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    switchToLinkedAccount(body: SwitchToLinkedAccountInput | undefined): Observable<SwitchToLinkedAccountOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/SwitchToLinkedAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSwitchToLinkedAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSwitchToLinkedAccount(<any>response_);
                } catch (e) {
                    return <Observable<SwitchToLinkedAccountOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwitchToLinkedAccountOutput>><any>_observableThrow(response_);
        }));
    }

    protected processSwitchToLinkedAccount(response: HttpResponseBase): Observable<SwitchToLinkedAccountOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SwitchToLinkedAccountOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwitchToLinkedAccountOutput>(<any>null);
    }
}

@Injectable()
export class AccountsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param userNameFilter (optional) 
     * @param passwordFilter (optional) 
     * @param bankDiskTypeFilter (optional) 
     * @param accountTypeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, nameFilter: string | undefined, descriptionFilter: string | undefined, userNameFilter: string | undefined, passwordFilter: string | undefined, bankDiskTypeFilter: number | undefined, accountTypeFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAccountForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Accounts/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (userNameFilter === null)
            throw new Error("The parameter 'userNameFilter' cannot be null.");
        else if (userNameFilter !== undefined)
            url_ += "UserNameFilter=" + encodeURIComponent("" + userNameFilter) + "&"; 
        if (passwordFilter === null)
            throw new Error("The parameter 'passwordFilter' cannot be null.");
        else if (passwordFilter !== undefined)
            url_ += "PasswordFilter=" + encodeURIComponent("" + passwordFilter) + "&"; 
        if (bankDiskTypeFilter === null)
            throw new Error("The parameter 'bankDiskTypeFilter' cannot be null.");
        else if (bankDiskTypeFilter !== undefined)
            url_ += "BankDiskTypeFilter=" + encodeURIComponent("" + bankDiskTypeFilter) + "&"; 
        if (accountTypeFilter === null)
            throw new Error("The parameter 'accountTypeFilter' cannot be null.");
        else if (accountTypeFilter !== undefined)
            url_ += "AccountTypeFilter=" + encodeURIComponent("" + accountTypeFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAccountForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAccountForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetAccountForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAccountForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAccountForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAccountForView(id: number | undefined): Observable<GetAccountForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Accounts/GetAccountForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountForView(<any>response_);
                } catch (e) {
                    return <Observable<GetAccountForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAccountForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAccountForView(response: HttpResponseBase): Observable<GetAccountForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAccountForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAccountForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAccountForEdit(id: number | undefined): Observable<GetAccountForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Accounts/GetAccountForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetAccountForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAccountForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAccountForEdit(response: HttpResponseBase): Observable<GetAccountForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAccountForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAccountForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditAccountDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Accounts/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Accounts/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param userNameFilter (optional) 
     * @param passwordFilter (optional) 
     * @param isGlobalFilter (optional) 
     * @param accessListFilter (optional) 
     * @param bankDiskTypeFilter (optional) 
     * @param accountTypeFilter (optional) 
     * @param maxBankAccountTypeFilter (optional) 
     * @param minBankAccountTypeFilter (optional) 
     * @return Success
     */
    getAccountsToExcel(filter: string | undefined, nameFilter: string | undefined, descriptionFilter: string | undefined, userNameFilter: string | undefined, passwordFilter: string | undefined, isGlobalFilter: number | undefined, accessListFilter: string | undefined, bankDiskTypeFilter: number | undefined, accountTypeFilter: number | undefined, maxBankAccountTypeFilter: number | undefined, minBankAccountTypeFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Accounts/GetAccountsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (userNameFilter === null)
            throw new Error("The parameter 'userNameFilter' cannot be null.");
        else if (userNameFilter !== undefined)
            url_ += "UserNameFilter=" + encodeURIComponent("" + userNameFilter) + "&"; 
        if (passwordFilter === null)
            throw new Error("The parameter 'passwordFilter' cannot be null.");
        else if (passwordFilter !== undefined)
            url_ += "PasswordFilter=" + encodeURIComponent("" + passwordFilter) + "&"; 
        if (isGlobalFilter === null)
            throw new Error("The parameter 'isGlobalFilter' cannot be null.");
        else if (isGlobalFilter !== undefined)
            url_ += "IsGlobalFilter=" + encodeURIComponent("" + isGlobalFilter) + "&"; 
        if (accessListFilter === null)
            throw new Error("The parameter 'accessListFilter' cannot be null.");
        else if (accessListFilter !== undefined)
            url_ += "AccessListFilter=" + encodeURIComponent("" + accessListFilter) + "&"; 
        if (bankDiskTypeFilter === null)
            throw new Error("The parameter 'bankDiskTypeFilter' cannot be null.");
        else if (bankDiskTypeFilter !== undefined)
            url_ += "BankDiskTypeFilter=" + encodeURIComponent("" + bankDiskTypeFilter) + "&"; 
        if (accountTypeFilter === null)
            throw new Error("The parameter 'accountTypeFilter' cannot be null.");
        else if (accountTypeFilter !== undefined)
            url_ += "AccountTypeFilter=" + encodeURIComponent("" + accountTypeFilter) + "&"; 
        if (maxBankAccountTypeFilter === null)
            throw new Error("The parameter 'maxBankAccountTypeFilter' cannot be null.");
        else if (maxBankAccountTypeFilter !== undefined)
            url_ += "MaxBankAccountTypeFilter=" + encodeURIComponent("" + maxBankAccountTypeFilter) + "&"; 
        if (minBankAccountTypeFilter === null)
            throw new Error("The parameter 'minBankAccountTypeFilter' cannot be null.");
        else if (minBankAccountTypeFilter !== undefined)
            url_ += "MinBankAccountTypeFilter=" + encodeURIComponent("" + minBankAccountTypeFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAccountsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class AddressesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param streetAlleyFilter (optional) 
     * @param maxHouseNumberFilter (optional) 
     * @param minHouseNumberFilter (optional) 
     * @param maxFloorFilter (optional) 
     * @param minFloorFilter (optional) 
     * @param phoneNumberFilter (optional) 
     * @param postalCodeFilter (optional) 
     * @param maxLatitudeFilter (optional) 
     * @param minLatitudeFilter (optional) 
     * @param maxLongitudeFilter (optional) 
     * @param minLongitudeFilter (optional) 
     * @param maxAreaFilter (optional) 
     * @param minAreaFilter (optional) 
     * @param defaultFilter (optional) 
     * @param entityRefFilter (optional) 
     * @param maxFromDateFilter (optional) 
     * @param minFromDateFilter (optional) 
     * @param maxToDateFilter (optional) 
     * @param minToDateFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param stateNameFilter (optional) 
     * @param cityNameFilter (optional) 
     * @param countryNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, titleFilter: string | undefined, streetAlleyFilter: string | undefined, maxHouseNumberFilter: number | undefined, minHouseNumberFilter: number | undefined, maxFloorFilter: number | undefined, minFloorFilter: number | undefined, phoneNumberFilter: string | undefined, postalCodeFilter: string | undefined, maxLatitudeFilter: number | undefined, minLatitudeFilter: number | undefined, maxLongitudeFilter: number | undefined, minLongitudeFilter: number | undefined, maxAreaFilter: number | undefined, minAreaFilter: number | undefined, defaultFilter: number | undefined, entityRefFilter: number | undefined, entity: Entities, maxFromDateFilter: moment.Moment | undefined, minFromDateFilter: moment.Moment | undefined, maxToDateFilter: moment.Moment | undefined, minToDateFilter: moment.Moment | undefined, descriptionFilter: string | undefined, stateNameFilter: string | undefined, cityNameFilter: string | undefined, countryNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAddressForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Addresses/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (streetAlleyFilter === null)
            throw new Error("The parameter 'streetAlleyFilter' cannot be null.");
        else if (streetAlleyFilter !== undefined)
            url_ += "StreetAlleyFilter=" + encodeURIComponent("" + streetAlleyFilter) + "&"; 
        if (maxHouseNumberFilter === null)
            throw new Error("The parameter 'maxHouseNumberFilter' cannot be null.");
        else if (maxHouseNumberFilter !== undefined)
            url_ += "MaxHouseNumberFilter=" + encodeURIComponent("" + maxHouseNumberFilter) + "&"; 
        if (minHouseNumberFilter === null)
            throw new Error("The parameter 'minHouseNumberFilter' cannot be null.");
        else if (minHouseNumberFilter !== undefined)
            url_ += "MinHouseNumberFilter=" + encodeURIComponent("" + minHouseNumberFilter) + "&"; 
        if (maxFloorFilter === null)
            throw new Error("The parameter 'maxFloorFilter' cannot be null.");
        else if (maxFloorFilter !== undefined)
            url_ += "MaxFloorFilter=" + encodeURIComponent("" + maxFloorFilter) + "&"; 
        if (minFloorFilter === null)
            throw new Error("The parameter 'minFloorFilter' cannot be null.");
        else if (minFloorFilter !== undefined)
            url_ += "MinFloorFilter=" + encodeURIComponent("" + minFloorFilter) + "&"; 
        if (phoneNumberFilter === null)
            throw new Error("The parameter 'phoneNumberFilter' cannot be null.");
        else if (phoneNumberFilter !== undefined)
            url_ += "PhoneNumberFilter=" + encodeURIComponent("" + phoneNumberFilter) + "&"; 
        if (postalCodeFilter === null)
            throw new Error("The parameter 'postalCodeFilter' cannot be null.");
        else if (postalCodeFilter !== undefined)
            url_ += "PostalCodeFilter=" + encodeURIComponent("" + postalCodeFilter) + "&"; 
        if (maxLatitudeFilter === null)
            throw new Error("The parameter 'maxLatitudeFilter' cannot be null.");
        else if (maxLatitudeFilter !== undefined)
            url_ += "MaxLatitudeFilter=" + encodeURIComponent("" + maxLatitudeFilter) + "&"; 
        if (minLatitudeFilter === null)
            throw new Error("The parameter 'minLatitudeFilter' cannot be null.");
        else if (minLatitudeFilter !== undefined)
            url_ += "MinLatitudeFilter=" + encodeURIComponent("" + minLatitudeFilter) + "&"; 
        if (maxLongitudeFilter === null)
            throw new Error("The parameter 'maxLongitudeFilter' cannot be null.");
        else if (maxLongitudeFilter !== undefined)
            url_ += "MaxLongitudeFilter=" + encodeURIComponent("" + maxLongitudeFilter) + "&"; 
        if (minLongitudeFilter === null)
            throw new Error("The parameter 'minLongitudeFilter' cannot be null.");
        else if (minLongitudeFilter !== undefined)
            url_ += "MinLongitudeFilter=" + encodeURIComponent("" + minLongitudeFilter) + "&"; 
        if (maxAreaFilter === null)
            throw new Error("The parameter 'maxAreaFilter' cannot be null.");
        else if (maxAreaFilter !== undefined)
            url_ += "MaxAreaFilter=" + encodeURIComponent("" + maxAreaFilter) + "&"; 
        if (minAreaFilter === null)
            throw new Error("The parameter 'minAreaFilter' cannot be null.");
        else if (minAreaFilter !== undefined)
            url_ += "MinAreaFilter=" + encodeURIComponent("" + minAreaFilter) + "&"; 
        if (defaultFilter === null)
            throw new Error("The parameter 'defaultFilter' cannot be null.");
        else if (defaultFilter !== undefined)
            url_ += "DefaultFilter=" + encodeURIComponent("" + defaultFilter) + "&"; 
        if (entityRefFilter === null)
            throw new Error("The parameter 'entityRefFilter' cannot be null.");
        else if (entityRefFilter !== undefined)
            url_ += "EntityRefFilter=" + encodeURIComponent("" + entityRefFilter) + "&"; 
        if (entity === undefined || entity === null)
            throw new Error("The parameter 'entity' must be defined and cannot be null.");
        else
            url_ += "Entity=" + encodeURIComponent("" + entity) + "&"; 
        if (maxFromDateFilter === null)
            throw new Error("The parameter 'maxFromDateFilter' cannot be null.");
        else if (maxFromDateFilter !== undefined)
            url_ += "MaxFromDateFilter=" + encodeURIComponent(maxFromDateFilter ? "" + maxFromDateFilter.toJSON() : "") + "&"; 
        if (minFromDateFilter === null)
            throw new Error("The parameter 'minFromDateFilter' cannot be null.");
        else if (minFromDateFilter !== undefined)
            url_ += "MinFromDateFilter=" + encodeURIComponent(minFromDateFilter ? "" + minFromDateFilter.toJSON() : "") + "&"; 
        if (maxToDateFilter === null)
            throw new Error("The parameter 'maxToDateFilter' cannot be null.");
        else if (maxToDateFilter !== undefined)
            url_ += "MaxToDateFilter=" + encodeURIComponent(maxToDateFilter ? "" + maxToDateFilter.toJSON() : "") + "&"; 
        if (minToDateFilter === null)
            throw new Error("The parameter 'minToDateFilter' cannot be null.");
        else if (minToDateFilter !== undefined)
            url_ += "MinToDateFilter=" + encodeURIComponent(minToDateFilter ? "" + minToDateFilter.toJSON() : "") + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (stateNameFilter === null)
            throw new Error("The parameter 'stateNameFilter' cannot be null.");
        else if (stateNameFilter !== undefined)
            url_ += "StateNameFilter=" + encodeURIComponent("" + stateNameFilter) + "&"; 
        if (cityNameFilter === null)
            throw new Error("The parameter 'cityNameFilter' cannot be null.");
        else if (cityNameFilter !== undefined)
            url_ += "CityNameFilter=" + encodeURIComponent("" + cityNameFilter) + "&"; 
        if (countryNameFilter === null)
            throw new Error("The parameter 'countryNameFilter' cannot be null.");
        else if (countryNameFilter !== undefined)
            url_ += "CountryNameFilter=" + encodeURIComponent("" + countryNameFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAddressForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAddressForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetAddressForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAddressForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAddressForViewDto>(<any>null);
    }

    /**
     * @param contactId (optional) 
     * @return Success
     */
    getAddressForContacts(contactId: number | undefined): Observable<GetAddressForEditOutput[]> {
        let url_ = this.baseUrl + "/api/services/app/Addresses/GetAddressForContacts?";
        if (contactId === null)
            throw new Error("The parameter 'contactId' cannot be null.");
        else if (contactId !== undefined)
            url_ += "contactId=" + encodeURIComponent("" + contactId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAddressForContacts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAddressForContacts(<any>response_);
                } catch (e) {
                    return <Observable<GetAddressForEditOutput[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAddressForEditOutput[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAddressForContacts(response: HttpResponseBase): Observable<GetAddressForEditOutput[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAddressForEditOutput.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAddressForEditOutput[]>(<any>null);
    }

    /**
     * @param legalId (optional) 
     * @return Success
     */
    getAddressForLegalContacts(legalId: number | undefined): Observable<GetAddressForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Addresses/GetAddressForLegalContacts?";
        if (legalId === null)
            throw new Error("The parameter 'legalId' cannot be null.");
        else if (legalId !== undefined)
            url_ += "legalId=" + encodeURIComponent("" + legalId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAddressForLegalContacts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAddressForLegalContacts(<any>response_);
                } catch (e) {
                    return <Observable<GetAddressForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAddressForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAddressForLegalContacts(response: HttpResponseBase): Observable<GetAddressForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAddressForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAddressForEditOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getAddressForLOggedInUser(): Observable<GetAddressForContactsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Addresses/GetAddressForLOggedInUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAddressForLOggedInUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAddressForLOggedInUser(<any>response_);
                } catch (e) {
                    return <Observable<GetAddressForContactsDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAddressForContactsDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAddressForLOggedInUser(response: HttpResponseBase): Observable<GetAddressForContactsDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAddressForContactsDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAddressForContactsDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    ctreateOrEditAddressForLoggedInUser(body: CreateOrEditAddressDto | undefined): Observable<AddressDto> {
        let url_ = this.baseUrl + "/api/services/app/Addresses/CtreateOrEditAddressForLoggedInUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCtreateOrEditAddressForLoggedInUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCtreateOrEditAddressForLoggedInUser(<any>response_);
                } catch (e) {
                    return <Observable<AddressDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddressDto>><any>_observableThrow(response_);
        }));
    }

    protected processCtreateOrEditAddressForLoggedInUser(response: HttpResponseBase): Observable<AddressDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddressDto>(<any>null);
    }

    /**
     * @param defaultId (optional) 
     * @return Success
     */
    changeDefaultAddress(defaultId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Addresses/ChangeDefaultAddress?";
        if (defaultId === null)
            throw new Error("The parameter 'defaultId' cannot be null.");
        else if (defaultId !== undefined)
            url_ += "defaultId=" + encodeURIComponent("" + defaultId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeDefaultAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeDefaultAddress(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeDefaultAddress(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAddressForView(id: number | undefined): Observable<GetAddressForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Addresses/GetAddressForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAddressForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAddressForView(<any>response_);
                } catch (e) {
                    return <Observable<GetAddressForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAddressForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAddressForView(response: HttpResponseBase): Observable<GetAddressForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAddressForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAddressForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAddressForEdit(id: number | undefined): Observable<GetAddressForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Addresses/GetAddressForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAddressForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAddressForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetAddressForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAddressForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAddressForEdit(response: HttpResponseBase): Observable<GetAddressForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAddressForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAddressForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditAddressDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Addresses/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditAndGetId(body: CreateOrEditAddressDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Addresses/CreateOrEditAndGetId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditAndGetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditAndGetId(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditAndGetId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditAddress(body: CreateOrEditAddressDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Addresses/CreateOrEditAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditAddress(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditAddress(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    deleteConactAddresses(input: CreateOrEditAddressDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Addresses/DeleteConactAddresses?";
        if (input === null)
            throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            input && input.forEach((item, index) => { 
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "input[" + index + "]." + attr + "=" + encodeURIComponent("" + (<any>item)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteConactAddresses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteConactAddresses(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteConactAddresses(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAndGetId(body: CreateOrEditAddressDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Addresses/CreateAndGetId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAndGetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAndGetId(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateAndGetId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Addresses/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    deleteAll(input: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Addresses/DeleteAll?";
        if (input === null)
            throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            input && input.forEach(item => { url_ += "input=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAll(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteAll(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    deleteByContactId(input: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Addresses/DeleteByContactId?";
        if (input === null)
            throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteByContactId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByContactId(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteByContactId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param streetAlleyFilter (optional) 
     * @param maxHouseNumberFilter (optional) 
     * @param minHouseNumberFilter (optional) 
     * @param maxFloorFilter (optional) 
     * @param minFloorFilter (optional) 
     * @param phoneNumberFilter (optional) 
     * @param postalCodeFilter (optional) 
     * @param maxLatitudeFilter (optional) 
     * @param minLatitudeFilter (optional) 
     * @param maxLongitudeFilter (optional) 
     * @param minLongitudeFilter (optional) 
     * @param maxAreaFilter (optional) 
     * @param minAreaFilter (optional) 
     * @param defaultFilter (optional) 
     * @param entityRefFilter (optional) 
     * @param maxFromDateFilter (optional) 
     * @param minFromDateFilter (optional) 
     * @param maxToDateFilter (optional) 
     * @param minToDateFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param stateNameFilter (optional) 
     * @param cityNameFilter (optional) 
     * @param countryNameFilter (optional) 
     * @return Success
     */
    getAddressesToExcel(filter: string | undefined, titleFilter: string | undefined, streetAlleyFilter: string | undefined, maxHouseNumberFilter: number | undefined, minHouseNumberFilter: number | undefined, maxFloorFilter: number | undefined, minFloorFilter: number | undefined, phoneNumberFilter: string | undefined, postalCodeFilter: string | undefined, maxLatitudeFilter: number | undefined, minLatitudeFilter: number | undefined, maxLongitudeFilter: number | undefined, minLongitudeFilter: number | undefined, maxAreaFilter: number | undefined, minAreaFilter: number | undefined, defaultFilter: number | undefined, entityRefFilter: string | undefined, maxFromDateFilter: moment.Moment | undefined, minFromDateFilter: moment.Moment | undefined, maxToDateFilter: moment.Moment | undefined, minToDateFilter: moment.Moment | undefined, descriptionFilter: string | undefined, stateNameFilter: string | undefined, cityNameFilter: string | undefined, countryNameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Addresses/GetAddressesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (streetAlleyFilter === null)
            throw new Error("The parameter 'streetAlleyFilter' cannot be null.");
        else if (streetAlleyFilter !== undefined)
            url_ += "StreetAlleyFilter=" + encodeURIComponent("" + streetAlleyFilter) + "&"; 
        if (maxHouseNumberFilter === null)
            throw new Error("The parameter 'maxHouseNumberFilter' cannot be null.");
        else if (maxHouseNumberFilter !== undefined)
            url_ += "MaxHouseNumberFilter=" + encodeURIComponent("" + maxHouseNumberFilter) + "&"; 
        if (minHouseNumberFilter === null)
            throw new Error("The parameter 'minHouseNumberFilter' cannot be null.");
        else if (minHouseNumberFilter !== undefined)
            url_ += "MinHouseNumberFilter=" + encodeURIComponent("" + minHouseNumberFilter) + "&"; 
        if (maxFloorFilter === null)
            throw new Error("The parameter 'maxFloorFilter' cannot be null.");
        else if (maxFloorFilter !== undefined)
            url_ += "MaxFloorFilter=" + encodeURIComponent("" + maxFloorFilter) + "&"; 
        if (minFloorFilter === null)
            throw new Error("The parameter 'minFloorFilter' cannot be null.");
        else if (minFloorFilter !== undefined)
            url_ += "MinFloorFilter=" + encodeURIComponent("" + minFloorFilter) + "&"; 
        if (phoneNumberFilter === null)
            throw new Error("The parameter 'phoneNumberFilter' cannot be null.");
        else if (phoneNumberFilter !== undefined)
            url_ += "PhoneNumberFilter=" + encodeURIComponent("" + phoneNumberFilter) + "&"; 
        if (postalCodeFilter === null)
            throw new Error("The parameter 'postalCodeFilter' cannot be null.");
        else if (postalCodeFilter !== undefined)
            url_ += "PostalCodeFilter=" + encodeURIComponent("" + postalCodeFilter) + "&"; 
        if (maxLatitudeFilter === null)
            throw new Error("The parameter 'maxLatitudeFilter' cannot be null.");
        else if (maxLatitudeFilter !== undefined)
            url_ += "MaxLatitudeFilter=" + encodeURIComponent("" + maxLatitudeFilter) + "&"; 
        if (minLatitudeFilter === null)
            throw new Error("The parameter 'minLatitudeFilter' cannot be null.");
        else if (minLatitudeFilter !== undefined)
            url_ += "MinLatitudeFilter=" + encodeURIComponent("" + minLatitudeFilter) + "&"; 
        if (maxLongitudeFilter === null)
            throw new Error("The parameter 'maxLongitudeFilter' cannot be null.");
        else if (maxLongitudeFilter !== undefined)
            url_ += "MaxLongitudeFilter=" + encodeURIComponent("" + maxLongitudeFilter) + "&"; 
        if (minLongitudeFilter === null)
            throw new Error("The parameter 'minLongitudeFilter' cannot be null.");
        else if (minLongitudeFilter !== undefined)
            url_ += "MinLongitudeFilter=" + encodeURIComponent("" + minLongitudeFilter) + "&"; 
        if (maxAreaFilter === null)
            throw new Error("The parameter 'maxAreaFilter' cannot be null.");
        else if (maxAreaFilter !== undefined)
            url_ += "MaxAreaFilter=" + encodeURIComponent("" + maxAreaFilter) + "&"; 
        if (minAreaFilter === null)
            throw new Error("The parameter 'minAreaFilter' cannot be null.");
        else if (minAreaFilter !== undefined)
            url_ += "MinAreaFilter=" + encodeURIComponent("" + minAreaFilter) + "&"; 
        if (defaultFilter === null)
            throw new Error("The parameter 'defaultFilter' cannot be null.");
        else if (defaultFilter !== undefined)
            url_ += "DefaultFilter=" + encodeURIComponent("" + defaultFilter) + "&"; 
        if (entityRefFilter === null)
            throw new Error("The parameter 'entityRefFilter' cannot be null.");
        else if (entityRefFilter !== undefined)
            url_ += "EntityRefFilter=" + encodeURIComponent("" + entityRefFilter) + "&"; 
        if (maxFromDateFilter === null)
            throw new Error("The parameter 'maxFromDateFilter' cannot be null.");
        else if (maxFromDateFilter !== undefined)
            url_ += "MaxFromDateFilter=" + encodeURIComponent(maxFromDateFilter ? "" + maxFromDateFilter.toJSON() : "") + "&"; 
        if (minFromDateFilter === null)
            throw new Error("The parameter 'minFromDateFilter' cannot be null.");
        else if (minFromDateFilter !== undefined)
            url_ += "MinFromDateFilter=" + encodeURIComponent(minFromDateFilter ? "" + minFromDateFilter.toJSON() : "") + "&"; 
        if (maxToDateFilter === null)
            throw new Error("The parameter 'maxToDateFilter' cannot be null.");
        else if (maxToDateFilter !== undefined)
            url_ += "MaxToDateFilter=" + encodeURIComponent(maxToDateFilter ? "" + maxToDateFilter.toJSON() : "") + "&"; 
        if (minToDateFilter === null)
            throw new Error("The parameter 'minToDateFilter' cannot be null.");
        else if (minToDateFilter !== undefined)
            url_ += "MinToDateFilter=" + encodeURIComponent(minToDateFilter ? "" + minToDateFilter.toJSON() : "") + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (stateNameFilter === null)
            throw new Error("The parameter 'stateNameFilter' cannot be null.");
        else if (stateNameFilter !== undefined)
            url_ += "StateNameFilter=" + encodeURIComponent("" + stateNameFilter) + "&"; 
        if (cityNameFilter === null)
            throw new Error("The parameter 'cityNameFilter' cannot be null.");
        else if (cityNameFilter !== undefined)
            url_ += "CityNameFilter=" + encodeURIComponent("" + cityNameFilter) + "&"; 
        if (countryNameFilter === null)
            throw new Error("The parameter 'countryNameFilter' cannot be null.");
        else if (countryNameFilter !== undefined)
            url_ += "CountryNameFilter=" + encodeURIComponent("" + countryNameFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAddressesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAddressesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAddressesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param countryNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllStateForLookupTable(filter: string | undefined, countryNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfAddressStateLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Addresses/GetAllStateForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (countryNameFilter === null)
            throw new Error("The parameter 'countryNameFilter' cannot be null.");
        else if (countryNameFilter !== undefined)
            url_ += "CountryNameFilter=" + encodeURIComponent("" + countryNameFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStateForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStateForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfAddressStateLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfAddressStateLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllStateForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfAddressStateLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAddressStateLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfAddressStateLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param stateIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCityForLookupTable(filter: string | undefined, stateIdFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfAddressCityLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Addresses/GetAllCityForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (stateIdFilter === null)
            throw new Error("The parameter 'stateIdFilter' cannot be null.");
        else if (stateIdFilter !== undefined)
            url_ += "StateIdFilter=" + encodeURIComponent("" + stateIdFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCityForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCityForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfAddressCityLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfAddressCityLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCityForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfAddressCityLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAddressCityLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfAddressCityLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCountryForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfAddressCountryLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Addresses/GetAllCountryForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCountryForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCountryForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfAddressCountryLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfAddressCountryLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCountryForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfAddressCountryLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAddressCountryLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfAddressCountryLookupTableDto>(<any>null);
    }

    /**
     * @param latitude (optional) 
     * @param longitude (optional) 
     * @return Success
     */
    getServiceInAddress(service: Plans, latitude: number | undefined, longitude: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Addresses/GetServiceInAddress?";
        if (service === undefined || service === null)
            throw new Error("The parameter 'service' must be defined and cannot be null.");
        else
            url_ += "Service=" + encodeURIComponent("" + service) + "&"; 
        if (latitude === null)
            throw new Error("The parameter 'latitude' cannot be null.");
        else if (latitude !== undefined)
            url_ += "Latitude=" + encodeURIComponent("" + latitude) + "&"; 
        if (longitude === null)
            throw new Error("The parameter 'longitude' cannot be null.");
        else if (longitude !== undefined)
            url_ += "Longitude=" + encodeURIComponent("" + longitude) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceInAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceInAddress(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processGetServiceInAddress(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param latitude (optional) 
     * @param longitude (optional) 
     * @return Success
     */
    getDirectionsServiceInAddress(service: Plans, latitude: number | undefined, longitude: number | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/Addresses/GetDirectionsServiceInAddress?";
        if (service === undefined || service === null)
            throw new Error("The parameter 'service' must be defined and cannot be null.");
        else
            url_ += "Service=" + encodeURIComponent("" + service) + "&"; 
        if (latitude === null)
            throw new Error("The parameter 'latitude' cannot be null.");
        else if (latitude !== undefined)
            url_ += "Latitude=" + encodeURIComponent("" + latitude) + "&"; 
        if (longitude === null)
            throw new Error("The parameter 'longitude' cannot be null.");
        else if (longitude !== undefined)
            url_ += "Longitude=" + encodeURIComponent("" + longitude) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDirectionsServiceInAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDirectionsServiceInAddress(<any>response_);
                } catch (e) {
                    return <Observable<number[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<number[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetDirectionsServiceInAddress(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number[]>(<any>null);
    }

    /**
     * @param ceremonyId (optional) 
     * @return Success
     */
    getServiceInAddressByCeremony(ceremonyId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Addresses/GetServiceInAddressByCeremony?";
        if (ceremonyId === null)
            throw new Error("The parameter 'ceremonyId' cannot be null.");
        else if (ceremonyId !== undefined)
            url_ += "ceremonyId=" + encodeURIComponent("" + ceremonyId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceInAddressByCeremony(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceInAddressByCeremony(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processGetServiceInAddressByCeremony(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param locationId (optional) 
     * @return Success
     */
    getServiceInAddressByLocation(locationId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Addresses/GetServiceInAddressByLocation?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceInAddressByLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceInAddressByLocation(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processGetServiceInAddressByLocation(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getLoginAddressInfo(): Observable<GetAddressInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/Addresses/GetLoginAddressInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLoginAddressInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLoginAddressInfo(<any>response_);
                } catch (e) {
                    return <Observable<GetAddressInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAddressInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetLoginAddressInfo(response: HttpResponseBase): Observable<GetAddressInfoDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAddressInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAddressInfoDto>(<any>null);
    }
}

@Injectable()
export class AmbassadorsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxContactIdFilter (optional) 
     * @param minContactIdFilter (optional) 
     * @param directionNameFilter (optional) 
     * @param directionRefFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, maxContactIdFilter: number | undefined, minContactIdFilter: number | undefined, directionNameFilter: string | undefined, directionRefFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAmbassadorForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Ambassadors/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxContactIdFilter === null)
            throw new Error("The parameter 'maxContactIdFilter' cannot be null.");
        else if (maxContactIdFilter !== undefined)
            url_ += "MaxContactIdFilter=" + encodeURIComponent("" + maxContactIdFilter) + "&"; 
        if (minContactIdFilter === null)
            throw new Error("The parameter 'minContactIdFilter' cannot be null.");
        else if (minContactIdFilter !== undefined)
            url_ += "MinContactIdFilter=" + encodeURIComponent("" + minContactIdFilter) + "&"; 
        if (directionNameFilter === null)
            throw new Error("The parameter 'directionNameFilter' cannot be null.");
        else if (directionNameFilter !== undefined)
            url_ += "DirectionNameFilter=" + encodeURIComponent("" + directionNameFilter) + "&"; 
        if (directionRefFilter === null)
            throw new Error("The parameter 'directionRefFilter' cannot be null.");
        else if (directionRefFilter !== undefined)
            url_ += "DirectionRefFilter=" + encodeURIComponent("" + directionRefFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAmbassadorForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAmbassadorForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetAmbassadorForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAmbassadorForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAmbassadorForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAmbassadorForView(id: number | undefined): Observable<GetAmbassadorForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Ambassadors/GetAmbassadorForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAmbassadorForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAmbassadorForView(<any>response_);
                } catch (e) {
                    return <Observable<GetAmbassadorForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAmbassadorForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAmbassadorForView(response: HttpResponseBase): Observable<GetAmbassadorForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAmbassadorForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAmbassadorForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAmbassadorForEdit(id: number | undefined): Observable<GetAmbassadorForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Ambassadors/GetAmbassadorForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAmbassadorForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAmbassadorForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetAmbassadorForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAmbassadorForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAmbassadorForEdit(response: HttpResponseBase): Observable<GetAmbassadorForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAmbassadorForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAmbassadorForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditAmbassadorDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Ambassadors/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Ambassadors/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    deleteAll(input: AmbassadorDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Ambassadors/DeleteAll?";
        if (input === null)
            throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            input && input.forEach((item, index) => { 
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "input[" + index + "]." + attr + "=" + encodeURIComponent("" + (<any>item)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAll(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteAll(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param maxContactIdFilter (optional) 
     * @param minContactIdFilter (optional) 
     * @param directionNameFilter (optional) 
     * @return Success
     */
    getAmbassadorsToExcel(filter: string | undefined, maxContactIdFilter: number | undefined, minContactIdFilter: number | undefined, directionNameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Ambassadors/GetAmbassadorsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxContactIdFilter === null)
            throw new Error("The parameter 'maxContactIdFilter' cannot be null.");
        else if (maxContactIdFilter !== undefined)
            url_ += "MaxContactIdFilter=" + encodeURIComponent("" + maxContactIdFilter) + "&"; 
        if (minContactIdFilter === null)
            throw new Error("The parameter 'minContactIdFilter' cannot be null.");
        else if (minContactIdFilter !== undefined)
            url_ += "MinContactIdFilter=" + encodeURIComponent("" + minContactIdFilter) + "&"; 
        if (directionNameFilter === null)
            throw new Error("The parameter 'directionNameFilter' cannot be null.");
        else if (directionNameFilter !== undefined)
            url_ += "DirectionNameFilter=" + encodeURIComponent("" + directionNameFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAmbassadorsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAmbassadorsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAmbassadorsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllDirectionForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfAmbassadorDirectionLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Ambassadors/GetAllDirectionForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDirectionForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDirectionForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfAmbassadorDirectionLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfAmbassadorDirectionLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllDirectionForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfAmbassadorDirectionLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAmbassadorDirectionLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfAmbassadorDirectionLookupTableDto>(<any>null);
    }

    /**
     * @param contactId (optional) 
     * @return Success
     */
    getAmbassadorForContact(contactId: number | undefined): Observable<GetAmbassadorForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Ambassadors/GetAmbassadorForContact?";
        if (contactId === null)
            throw new Error("The parameter 'contactId' cannot be null.");
        else if (contactId !== undefined)
            url_ += "contactId=" + encodeURIComponent("" + contactId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAmbassadorForContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAmbassadorForContact(<any>response_);
                } catch (e) {
                    return <Observable<GetAmbassadorForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAmbassadorForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAmbassadorForContact(response: HttpResponseBase): Observable<GetAmbassadorForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAmbassadorForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAmbassadorForEditOutput>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param contactId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAmbassadorsForContact(filter: string | undefined, contactId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAmbassadorForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Ambassadors/GetAmbassadorsForContact?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (contactId === null)
            throw new Error("The parameter 'contactId' cannot be null.");
        else if (contactId !== undefined)
            url_ += "ContactId=" + encodeURIComponent("" + contactId) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAmbassadorsForContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAmbassadorsForContact(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAmbassadorForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAmbassadorForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAmbassadorsForContact(response: HttpResponseBase): Observable<PagedResultDtoOfGetAmbassadorForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAmbassadorForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAmbassadorForEditOutput>(<any>null);
    }
}

@Injectable()
export class AreasServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param stateFilter (optional) 
     * @param cityNameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, nameFilter: string | undefined, stateFilter: number | undefined, cityNameFilter: string | undefined, descriptionFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAreaForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Areas/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (cityNameFilter === null)
            throw new Error("The parameter 'cityNameFilter' cannot be null.");
        else if (cityNameFilter !== undefined)
            url_ += "CityNameFilter=" + encodeURIComponent("" + cityNameFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAreaForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAreaForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetAreaForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAreaForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAreaForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAreaForView(id: number | undefined): Observable<GetAreaForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Areas/GetAreaForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAreaForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAreaForView(<any>response_);
                } catch (e) {
                    return <Observable<GetAreaForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAreaForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAreaForView(response: HttpResponseBase): Observable<GetAreaForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAreaForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAreaForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAreaForEdit(id: number | undefined): Observable<GetAreaForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Areas/GetAreaForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAreaForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAreaForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetAreaForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAreaForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAreaForEdit(response: HttpResponseBase): Observable<GetAreaForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAreaForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAreaForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditAreaDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Areas/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Areas/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param stateFilter (optional) 
     * @param cityNameFilter (optional) 
     * @return Success
     */
    getAreasToExcel(filter: string | undefined, nameFilter: string | undefined, stateFilter: number | undefined, cityNameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Areas/GetAreasToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (cityNameFilter === null)
            throw new Error("The parameter 'cityNameFilter' cannot be null.");
        else if (cityNameFilter !== undefined)
            url_ += "CityNameFilter=" + encodeURIComponent("" + cityNameFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAreasToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAreasToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAreasToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllCityForTableDropdown(): Observable<AreaCityLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Areas/GetAllCityForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCityForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCityForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<AreaCityLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AreaCityLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCityForTableDropdown(response: HttpResponseBase): Observable<AreaCityLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AreaCityLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AreaCityLookupTableDto[]>(<any>null);
    }
}

@Injectable()
export class AttributesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param maxMinValueFilter (optional) 
     * @param minMinValueFilter (optional) 
     * @param maxMaxValueFilter (optional) 
     * @param minMaxValueFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param stateFilter (optional) 
     * @param dataTypeFilter (optional) 
     * @param requiredFilter (optional) 
     * @param isUniqueFilter (optional) 
     * @param tagsFilter (optional) 
     * @param entityFilter (optional) 
     * @param userEntityTitleFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, titleFilter: string | undefined, maxMinValueFilter: number | undefined, minMinValueFilter: number | undefined, maxMaxValueFilter: number | undefined, minMaxValueFilter: number | undefined, descriptionFilter: string | undefined, stateFilter: number | undefined, dataTypeFilter: number | undefined, requiredFilter: number | undefined, isUniqueFilter: number | undefined, tagsFilter: string | undefined, entityFilter: number | undefined, userEntityTitleFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAttributeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Attributes/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (maxMinValueFilter === null)
            throw new Error("The parameter 'maxMinValueFilter' cannot be null.");
        else if (maxMinValueFilter !== undefined)
            url_ += "MaxMinValueFilter=" + encodeURIComponent("" + maxMinValueFilter) + "&"; 
        if (minMinValueFilter === null)
            throw new Error("The parameter 'minMinValueFilter' cannot be null.");
        else if (minMinValueFilter !== undefined)
            url_ += "MinMinValueFilter=" + encodeURIComponent("" + minMinValueFilter) + "&"; 
        if (maxMaxValueFilter === null)
            throw new Error("The parameter 'maxMaxValueFilter' cannot be null.");
        else if (maxMaxValueFilter !== undefined)
            url_ += "MaxMaxValueFilter=" + encodeURIComponent("" + maxMaxValueFilter) + "&"; 
        if (minMaxValueFilter === null)
            throw new Error("The parameter 'minMaxValueFilter' cannot be null.");
        else if (minMaxValueFilter !== undefined)
            url_ += "MinMaxValueFilter=" + encodeURIComponent("" + minMaxValueFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (dataTypeFilter === null)
            throw new Error("The parameter 'dataTypeFilter' cannot be null.");
        else if (dataTypeFilter !== undefined)
            url_ += "DataTypeFilter=" + encodeURIComponent("" + dataTypeFilter) + "&"; 
        if (requiredFilter === null)
            throw new Error("The parameter 'requiredFilter' cannot be null.");
        else if (requiredFilter !== undefined)
            url_ += "RequiredFilter=" + encodeURIComponent("" + requiredFilter) + "&"; 
        if (isUniqueFilter === null)
            throw new Error("The parameter 'isUniqueFilter' cannot be null.");
        else if (isUniqueFilter !== undefined)
            url_ += "IsUniqueFilter=" + encodeURIComponent("" + isUniqueFilter) + "&"; 
        if (tagsFilter === null)
            throw new Error("The parameter 'tagsFilter' cannot be null.");
        else if (tagsFilter !== undefined)
            url_ += "TagsFilter=" + encodeURIComponent("" + tagsFilter) + "&"; 
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (userEntityTitleFilter === null)
            throw new Error("The parameter 'userEntityTitleFilter' cannot be null.");
        else if (userEntityTitleFilter !== undefined)
            url_ += "UserEntityTitleFilter=" + encodeURIComponent("" + userEntityTitleFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAttributeForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAttributeForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetAttributeForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAttributeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAttributeForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAttributeForView(id: number | undefined): Observable<GetAttributeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Attributes/GetAttributeForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttributeForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttributeForView(<any>response_);
                } catch (e) {
                    return <Observable<GetAttributeForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAttributeForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAttributeForView(response: HttpResponseBase): Observable<GetAttributeForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAttributeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAttributeForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAttributeForEdit(id: number | undefined): Observable<GetAttributeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Attributes/GetAttributeForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttributeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttributeForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetAttributeForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAttributeForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAttributeForEdit(response: HttpResponseBase): Observable<GetAttributeForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAttributeForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAttributeForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditAttributeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Attributes/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Attributes/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    deleteMultiple(input: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Attributes/DeleteMultiple?";
        if (input === null)
            throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            input && input.forEach(item => { url_ += "input=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMultiple(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMultiple(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteMultiple(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param maxMinValueFilter (optional) 
     * @param minMinValueFilter (optional) 
     * @param maxMaxValueFilter (optional) 
     * @param minMaxValueFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param stateFilter (optional) 
     * @param dataTypeFilter (optional) 
     * @param requiredFilter (optional) 
     * @param isUniqueFilter (optional) 
     * @param tagsFilter (optional) 
     * @param userEntityTitleFilter (optional) 
     * @return Success
     */
    getAttributesToExcel(filter: string | undefined, titleFilter: string | undefined, maxMinValueFilter: number | undefined, minMinValueFilter: number | undefined, maxMaxValueFilter: number | undefined, minMaxValueFilter: number | undefined, descriptionFilter: string | undefined, stateFilter: number | undefined, dataTypeFilter: number | undefined, requiredFilter: number | undefined, isUniqueFilter: number | undefined, tagsFilter: string | undefined, userEntityTitleFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Attributes/GetAttributesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (maxMinValueFilter === null)
            throw new Error("The parameter 'maxMinValueFilter' cannot be null.");
        else if (maxMinValueFilter !== undefined)
            url_ += "MaxMinValueFilter=" + encodeURIComponent("" + maxMinValueFilter) + "&"; 
        if (minMinValueFilter === null)
            throw new Error("The parameter 'minMinValueFilter' cannot be null.");
        else if (minMinValueFilter !== undefined)
            url_ += "MinMinValueFilter=" + encodeURIComponent("" + minMinValueFilter) + "&"; 
        if (maxMaxValueFilter === null)
            throw new Error("The parameter 'maxMaxValueFilter' cannot be null.");
        else if (maxMaxValueFilter !== undefined)
            url_ += "MaxMaxValueFilter=" + encodeURIComponent("" + maxMaxValueFilter) + "&"; 
        if (minMaxValueFilter === null)
            throw new Error("The parameter 'minMaxValueFilter' cannot be null.");
        else if (minMaxValueFilter !== undefined)
            url_ += "MinMaxValueFilter=" + encodeURIComponent("" + minMaxValueFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (dataTypeFilter === null)
            throw new Error("The parameter 'dataTypeFilter' cannot be null.");
        else if (dataTypeFilter !== undefined)
            url_ += "DataTypeFilter=" + encodeURIComponent("" + dataTypeFilter) + "&"; 
        if (requiredFilter === null)
            throw new Error("The parameter 'requiredFilter' cannot be null.");
        else if (requiredFilter !== undefined)
            url_ += "RequiredFilter=" + encodeURIComponent("" + requiredFilter) + "&"; 
        if (isUniqueFilter === null)
            throw new Error("The parameter 'isUniqueFilter' cannot be null.");
        else if (isUniqueFilter !== undefined)
            url_ += "IsUniqueFilter=" + encodeURIComponent("" + isUniqueFilter) + "&"; 
        if (tagsFilter === null)
            throw new Error("The parameter 'tagsFilter' cannot be null.");
        else if (tagsFilter !== undefined)
            url_ += "TagsFilter=" + encodeURIComponent("" + tagsFilter) + "&"; 
        if (userEntityTitleFilter === null)
            throw new Error("The parameter 'userEntityTitleFilter' cannot be null.");
        else if (userEntityTitleFilter !== undefined)
            url_ += "UserEntityTitleFilter=" + encodeURIComponent("" + userEntityTitleFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttributesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttributesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAttributesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param entityId (optional) 
     * @param entity (optional) 
     * @param entityFilter (optional) 
     * @param entityRefFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllUserEntityForLookupTable(filter: string | undefined, entityId: number | undefined, entity: number | undefined, entityFilter: number | undefined, entityRefFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfAttributeUserEntityLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Attributes/GetAllUserEntityForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&"; 
        if (entity === null)
            throw new Error("The parameter 'entity' cannot be null.");
        else if (entity !== undefined)
            url_ += "Entity=" + encodeURIComponent("" + entity) + "&"; 
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (entityRefFilter === null)
            throw new Error("The parameter 'entityRefFilter' cannot be null.");
        else if (entityRefFilter !== undefined)
            url_ += "EntityRefFilter=" + encodeURIComponent("" + entityRefFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUserEntityForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserEntityForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfAttributeUserEntityLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfAttributeUserEntityLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllUserEntityForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfAttributeUserEntityLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAttributeUserEntityLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfAttributeUserEntityLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param entityId (optional) 
     * @param entity (optional) 
     * @param entityFilter (optional) 
     * @param entityRefFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllAttributeForEntities(filter: string | undefined, entityId: number | undefined, entity: number | undefined, entityFilter: number | undefined, entityRefFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAttributeForFamilyDto> {
        let url_ = this.baseUrl + "/api/services/app/Attributes/GetAllAttributeForEntities?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&"; 
        if (entity === null)
            throw new Error("The parameter 'entity' cannot be null.");
        else if (entity !== undefined)
            url_ += "Entity=" + encodeURIComponent("" + entity) + "&"; 
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (entityRefFilter === null)
            throw new Error("The parameter 'entityRefFilter' cannot be null.");
        else if (entityRefFilter !== undefined)
            url_ += "EntityRefFilter=" + encodeURIComponent("" + entityRefFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAttributeForEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAttributeForEntities(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAttributeForFamilyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAttributeForFamilyDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllAttributeForEntities(response: HttpResponseBase): Observable<PagedResultDtoOfGetAttributeForFamilyDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAttributeForFamilyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAttributeForFamilyDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sourceId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllAttributeForSource(filter: string | undefined, sourceId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAttributeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Attributes/GetAllAttributeForSource?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sourceId === null)
            throw new Error("The parameter 'sourceId' cannot be null.");
        else if (sourceId !== undefined)
            url_ += "SourceId=" + encodeURIComponent("" + sourceId) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAttributeForSource(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAttributeForSource(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAttributeForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAttributeForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllAttributeForSource(response: HttpResponseBase): Observable<PagedResultDtoOfGetAttributeForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAttributeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAttributeForViewDto>(<any>null);
    }

    /**
     * @param entityId (optional) 
     * @param sourceId (optional) 
     * @return Success
     */
    getAllAttributesAndValueForSource(entityId: number | undefined, entity: Entities, sourceId: number | undefined): Observable<SourceAttribute[]> {
        let url_ = this.baseUrl + "/api/services/app/Attributes/GetAllAttributesAndValueForSource?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&"; 
        if (entity === undefined || entity === null)
            throw new Error("The parameter 'entity' must be defined and cannot be null.");
        else
            url_ += "Entity=" + encodeURIComponent("" + entity) + "&"; 
        if (sourceId === null)
            throw new Error("The parameter 'sourceId' cannot be null.");
        else if (sourceId !== undefined)
            url_ += "SourceId=" + encodeURIComponent("" + sourceId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAttributesAndValueForSource(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAttributesAndValueForSource(<any>response_);
                } catch (e) {
                    return <Observable<SourceAttribute[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SourceAttribute[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllAttributesAndValueForSource(response: HttpResponseBase): Observable<SourceAttribute[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SourceAttribute.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SourceAttribute[]>(<any>null);
    }
}

@Injectable()
export class AttributeValuesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param valueFilter (optional) 
     * @param stateFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param entityRefFilter (optional) 
     * @param entityFilter (optional) 
     * @param attributeTitleFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, valueFilter: string | undefined, stateFilter: number | undefined, descriptionFilter: string | undefined, entityRefFilter: number | undefined, entityFilter: number | undefined, attributeTitleFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAttributeValueForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/AttributeValues/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (valueFilter === null)
            throw new Error("The parameter 'valueFilter' cannot be null.");
        else if (valueFilter !== undefined)
            url_ += "ValueFilter=" + encodeURIComponent("" + valueFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (entityRefFilter === null)
            throw new Error("The parameter 'entityRefFilter' cannot be null.");
        else if (entityRefFilter !== undefined)
            url_ += "EntityRefFilter=" + encodeURIComponent("" + entityRefFilter) + "&"; 
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (attributeTitleFilter === null)
            throw new Error("The parameter 'attributeTitleFilter' cannot be null.");
        else if (attributeTitleFilter !== undefined)
            url_ += "AttributeTitleFilter=" + encodeURIComponent("" + attributeTitleFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAttributeValueForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAttributeValueForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetAttributeValueForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAttributeValueForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAttributeValueForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAttributeValueForView(id: number | undefined): Observable<GetAttributeValueForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/AttributeValues/GetAttributeValueForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttributeValueForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttributeValueForView(<any>response_);
                } catch (e) {
                    return <Observable<GetAttributeValueForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAttributeValueForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAttributeValueForView(response: HttpResponseBase): Observable<GetAttributeValueForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAttributeValueForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAttributeValueForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAttributeValueForEdit(id: number | undefined): Observable<GetAttributeValueForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AttributeValues/GetAttributeValueForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttributeValueForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttributeValueForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetAttributeValueForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAttributeValueForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAttributeValueForEdit(response: HttpResponseBase): Observable<GetAttributeValueForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAttributeValueForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAttributeValueForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditAttributeValueDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AttributeValues/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AttributeValues/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param valueFilter (optional) 
     * @param stateFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param entityRefFilter (optional) 
     * @param attributeTitleFilter (optional) 
     * @return Success
     */
    getAttributeValuesToExcel(filter: string | undefined, valueFilter: string | undefined, stateFilter: number | undefined, descriptionFilter: string | undefined, entityRefFilter: number | undefined, attributeTitleFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AttributeValues/GetAttributeValuesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (valueFilter === null)
            throw new Error("The parameter 'valueFilter' cannot be null.");
        else if (valueFilter !== undefined)
            url_ += "ValueFilter=" + encodeURIComponent("" + valueFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (entityRefFilter === null)
            throw new Error("The parameter 'entityRefFilter' cannot be null.");
        else if (entityRefFilter !== undefined)
            url_ += "EntityRefFilter=" + encodeURIComponent("" + entityRefFilter) + "&"; 
        if (attributeTitleFilter === null)
            throw new Error("The parameter 'attributeTitleFilter' cannot be null.");
        else if (attributeTitleFilter !== undefined)
            url_ += "AttributeTitleFilter=" + encodeURIComponent("" + attributeTitleFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttributeValuesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttributeValuesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAttributeValuesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllAttributeForLookupTable(filter: string | undefined, entityFilter: Entities, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfAttributeValueAttributeLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/AttributeValues/GetAllAttributeForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (entityFilter === undefined || entityFilter === null)
            throw new Error("The parameter 'entityFilter' must be defined and cannot be null.");
        else
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAttributeForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAttributeForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfAttributeValueAttributeLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfAttributeValueAttributeLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllAttributeForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfAttributeValueAttributeLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAttributeValueAttributeLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfAttributeValueAttributeLookupTableDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllUserentityForLookupTable(): Observable<AttributeValueUserentityLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AttributeValues/GetAllUserentityForLookupTable";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUserentityForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserentityForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<AttributeValueUserentityLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AttributeValueUserentityLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllUserentityForLookupTable(response: HttpResponseBase): Observable<AttributeValueUserentityLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttributeValueUserentityLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AttributeValueUserentityLookupTableDto[]>(<any>null);
    }
}

@Injectable()
export class AuditLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param serviceName (optional) 
     * @param methodName (optional) 
     * @param browserInfo (optional) 
     * @param hasException (optional) 
     * @param minExecutionDuration (optional) 
     * @param maxExecutionDuration (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getAuditLogs(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, userName: string | undefined, serviceName: string | undefined, methodName: string | undefined, browserInfo: string | undefined, hasException: boolean | undefined, minExecutionDuration: number | undefined, maxExecutionDuration: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfAuditLogListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogs?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&"; 
        if (serviceName === null)
            throw new Error("The parameter 'serviceName' cannot be null.");
        else if (serviceName !== undefined)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&"; 
        if (methodName === null)
            throw new Error("The parameter 'methodName' cannot be null.");
        else if (methodName !== undefined)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&"; 
        if (browserInfo === null)
            throw new Error("The parameter 'browserInfo' cannot be null.");
        else if (browserInfo !== undefined)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&"; 
        if (hasException === null)
            throw new Error("The parameter 'hasException' cannot be null.");
        else if (hasException !== undefined)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&"; 
        if (minExecutionDuration === null)
            throw new Error("The parameter 'minExecutionDuration' cannot be null.");
        else if (minExecutionDuration !== undefined)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&"; 
        if (maxExecutionDuration === null)
            throw new Error("The parameter 'maxExecutionDuration' cannot be null.");
        else if (maxExecutionDuration !== undefined)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditLogs(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfAuditLogListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfAuditLogListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAuditLogs(response: HttpResponseBase): Observable<PagedResultDtoOfAuditLogListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAuditLogListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfAuditLogListDto>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param serviceName (optional) 
     * @param methodName (optional) 
     * @param browserInfo (optional) 
     * @param hasException (optional) 
     * @param minExecutionDuration (optional) 
     * @param maxExecutionDuration (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getAuditLogsToExcel(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, userName: string | undefined, serviceName: string | undefined, methodName: string | undefined, browserInfo: string | undefined, hasException: boolean | undefined, minExecutionDuration: number | undefined, maxExecutionDuration: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogsToExcel?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&"; 
        if (serviceName === null)
            throw new Error("The parameter 'serviceName' cannot be null.");
        else if (serviceName !== undefined)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&"; 
        if (methodName === null)
            throw new Error("The parameter 'methodName' cannot be null.");
        else if (methodName !== undefined)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&"; 
        if (browserInfo === null)
            throw new Error("The parameter 'browserInfo' cannot be null.");
        else if (browserInfo !== undefined)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&"; 
        if (hasException === null)
            throw new Error("The parameter 'hasException' cannot be null.");
        else if (hasException !== undefined)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&"; 
        if (minExecutionDuration === null)
            throw new Error("The parameter 'minExecutionDuration' cannot be null.");
        else if (minExecutionDuration !== undefined)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&"; 
        if (maxExecutionDuration === null)
            throw new Error("The parameter 'maxExecutionDuration' cannot be null.");
        else if (maxExecutionDuration !== undefined)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditLogsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditLogsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAuditLogsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getEntityHistoryObjectTypes(): Observable<NameValueDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityHistoryObjectTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityHistoryObjectTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityHistoryObjectTypes(<any>response_);
                } catch (e) {
                    return <Observable<NameValueDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetEntityHistoryObjectTypes(response: HttpResponseBase): Observable<NameValueDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueDto[]>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param entityTypeFullName (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getEntityChanges(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, userName: string | undefined, entityTypeFullName: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfEntityChangeListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityChanges?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&"; 
        if (entityTypeFullName === null)
            throw new Error("The parameter 'entityTypeFullName' cannot be null.");
        else if (entityTypeFullName !== undefined)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityChanges(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfEntityChangeListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfEntityChangeListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEntityChanges(response: HttpResponseBase): Observable<PagedResultDtoOfEntityChangeListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfEntityChangeListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfEntityChangeListDto>(<any>null);
    }

    /**
     * @param entityTypeFullName (optional) 
     * @param entityId (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getEntityTypeChanges(entityTypeFullName: string | undefined, entityId: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfEntityChangeListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityTypeChanges?";
        if (entityTypeFullName === null)
            throw new Error("The parameter 'entityTypeFullName' cannot be null.");
        else if (entityTypeFullName !== undefined)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&"; 
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityTypeChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityTypeChanges(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfEntityChangeListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfEntityChangeListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEntityTypeChanges(response: HttpResponseBase): Observable<PagedResultDtoOfEntityChangeListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfEntityChangeListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfEntityChangeListDto>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param entityTypeFullName (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getEntityChangesToExcel(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, userName: string | undefined, entityTypeFullName: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityChangesToExcel?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&"; 
        if (entityTypeFullName === null)
            throw new Error("The parameter 'entityTypeFullName' cannot be null.");
        else if (entityTypeFullName !== undefined)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityChangesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityChangesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEntityChangesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param entityChangeId (optional) 
     * @return Success
     */
    getEntityPropertyChanges(entityChangeId: number | undefined): Observable<EntityPropertyChangeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityPropertyChanges?";
        if (entityChangeId === null)
            throw new Error("The parameter 'entityChangeId' cannot be null.");
        else if (entityChangeId !== undefined)
            url_ += "entityChangeId=" + encodeURIComponent("" + entityChangeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityPropertyChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityPropertyChanges(<any>response_);
                } catch (e) {
                    return <Observable<EntityPropertyChangeDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<EntityPropertyChangeDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetEntityPropertyChanges(response: HttpResponseBase): Observable<EntityPropertyChangeDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityPropertyChangeDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EntityPropertyChangeDto[]>(<any>null);
    }
}

@Injectable()
export class BankAccountsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param branchNameFilter (optional) 
     * @param branchIdFilter (optional) 
     * @param accountNumberFilter (optional) 
     * @param shabaNumberFilter (optional) 
     * @param defaultFilter (optional) 
     * @param maxContactIdFilter (optional) 
     * @param minContactIdFilter (optional) 
     * @param bankNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, branchNameFilter: string | undefined, branchIdFilter: string | undefined, accountNumberFilter: string | undefined, shabaNumberFilter: string | undefined, defaultFilter: number | undefined, maxContactIdFilter: number | undefined, minContactIdFilter: number | undefined, bankNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetBankAccountForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/BankAccounts/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (branchNameFilter === null)
            throw new Error("The parameter 'branchNameFilter' cannot be null.");
        else if (branchNameFilter !== undefined)
            url_ += "BranchNameFilter=" + encodeURIComponent("" + branchNameFilter) + "&"; 
        if (branchIdFilter === null)
            throw new Error("The parameter 'branchIdFilter' cannot be null.");
        else if (branchIdFilter !== undefined)
            url_ += "BranchIdFilter=" + encodeURIComponent("" + branchIdFilter) + "&"; 
        if (accountNumberFilter === null)
            throw new Error("The parameter 'accountNumberFilter' cannot be null.");
        else if (accountNumberFilter !== undefined)
            url_ += "AccountNumberFilter=" + encodeURIComponent("" + accountNumberFilter) + "&"; 
        if (shabaNumberFilter === null)
            throw new Error("The parameter 'shabaNumberFilter' cannot be null.");
        else if (shabaNumberFilter !== undefined)
            url_ += "ShabaNumberFilter=" + encodeURIComponent("" + shabaNumberFilter) + "&"; 
        if (defaultFilter === null)
            throw new Error("The parameter 'defaultFilter' cannot be null.");
        else if (defaultFilter !== undefined)
            url_ += "DefaultFilter=" + encodeURIComponent("" + defaultFilter) + "&"; 
        if (maxContactIdFilter === null)
            throw new Error("The parameter 'maxContactIdFilter' cannot be null.");
        else if (maxContactIdFilter !== undefined)
            url_ += "MaxContactIdFilter=" + encodeURIComponent("" + maxContactIdFilter) + "&"; 
        if (minContactIdFilter === null)
            throw new Error("The parameter 'minContactIdFilter' cannot be null.");
        else if (minContactIdFilter !== undefined)
            url_ += "MinContactIdFilter=" + encodeURIComponent("" + minContactIdFilter) + "&"; 
        if (bankNameFilter === null)
            throw new Error("The parameter 'bankNameFilter' cannot be null.");
        else if (bankNameFilter !== undefined)
            url_ += "BankNameFilter=" + encodeURIComponent("" + bankNameFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetBankAccountForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetBankAccountForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetBankAccountForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetBankAccountForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBankAccountForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBankAccountForView(id: number | undefined): Observable<GetBankAccountForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/BankAccounts/GetBankAccountForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBankAccountForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBankAccountForView(<any>response_);
                } catch (e) {
                    return <Observable<GetBankAccountForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBankAccountForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetBankAccountForView(response: HttpResponseBase): Observable<GetBankAccountForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBankAccountForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBankAccountForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBankAccountForViewContacts(id: number | undefined): Observable<GetBankAccountForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/BankAccounts/GetBankAccountForViewContacts?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBankAccountForViewContacts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBankAccountForViewContacts(<any>response_);
                } catch (e) {
                    return <Observable<GetBankAccountForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBankAccountForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetBankAccountForViewContacts(response: HttpResponseBase): Observable<GetBankAccountForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBankAccountForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBankAccountForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBankAccountForEdit(id: number | undefined): Observable<GetBankAccountForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/BankAccounts/GetBankAccountForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBankAccountForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBankAccountForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetBankAccountForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBankAccountForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetBankAccountForEdit(response: HttpResponseBase): Observable<GetBankAccountForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBankAccountForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBankAccountForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditBankAccountDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BankAccounts/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditForContact(body: CreateOrEditBankAccountDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BankAccounts/CreateOrEditForContact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditForContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditForContact(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditForContact(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BankAccounts/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteForContact(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BankAccounts/DeleteForContact?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteForContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteForContact(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteForContact(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param branchNameFilter (optional) 
     * @param branchIdFilter (optional) 
     * @param accountNumberFilter (optional) 
     * @param shabaNumberFilter (optional) 
     * @param defaultFilter (optional) 
     * @param maxContactIdFilter (optional) 
     * @param minContactIdFilter (optional) 
     * @param bankNameFilter (optional) 
     * @return Success
     */
    getBankAccountsToExcel(filter: string | undefined, branchNameFilter: string | undefined, branchIdFilter: string | undefined, accountNumberFilter: string | undefined, shabaNumberFilter: string | undefined, defaultFilter: number | undefined, maxContactIdFilter: number | undefined, minContactIdFilter: number | undefined, bankNameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/BankAccounts/GetBankAccountsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (branchNameFilter === null)
            throw new Error("The parameter 'branchNameFilter' cannot be null.");
        else if (branchNameFilter !== undefined)
            url_ += "BranchNameFilter=" + encodeURIComponent("" + branchNameFilter) + "&"; 
        if (branchIdFilter === null)
            throw new Error("The parameter 'branchIdFilter' cannot be null.");
        else if (branchIdFilter !== undefined)
            url_ += "BranchIdFilter=" + encodeURIComponent("" + branchIdFilter) + "&"; 
        if (accountNumberFilter === null)
            throw new Error("The parameter 'accountNumberFilter' cannot be null.");
        else if (accountNumberFilter !== undefined)
            url_ += "AccountNumberFilter=" + encodeURIComponent("" + accountNumberFilter) + "&"; 
        if (shabaNumberFilter === null)
            throw new Error("The parameter 'shabaNumberFilter' cannot be null.");
        else if (shabaNumberFilter !== undefined)
            url_ += "ShabaNumberFilter=" + encodeURIComponent("" + shabaNumberFilter) + "&"; 
        if (defaultFilter === null)
            throw new Error("The parameter 'defaultFilter' cannot be null.");
        else if (defaultFilter !== undefined)
            url_ += "DefaultFilter=" + encodeURIComponent("" + defaultFilter) + "&"; 
        if (maxContactIdFilter === null)
            throw new Error("The parameter 'maxContactIdFilter' cannot be null.");
        else if (maxContactIdFilter !== undefined)
            url_ += "MaxContactIdFilter=" + encodeURIComponent("" + maxContactIdFilter) + "&"; 
        if (minContactIdFilter === null)
            throw new Error("The parameter 'minContactIdFilter' cannot be null.");
        else if (minContactIdFilter !== undefined)
            url_ += "MinContactIdFilter=" + encodeURIComponent("" + minContactIdFilter) + "&"; 
        if (bankNameFilter === null)
            throw new Error("The parameter 'bankNameFilter' cannot be null.");
        else if (bankNameFilter !== undefined)
            url_ += "BankNameFilter=" + encodeURIComponent("" + bankNameFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBankAccountsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBankAccountsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetBankAccountsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllBankForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfBankAccountBankLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/BankAccounts/GetAllBankForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBankForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBankForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfBankAccountBankLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfBankAccountBankLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBankForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfBankAccountBankLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfBankAccountBankLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfBankAccountBankLookupTableDto>(<any>null);
    }

    /**
     * @param contactId (optional) 
     * @return Success
     */
    getBankAccountForContact(contactId: number | undefined): Observable<GetBankAccountForEditOutput[]> {
        let url_ = this.baseUrl + "/api/services/app/BankAccounts/GetBankAccountForContact?";
        if (contactId === null)
            throw new Error("The parameter 'contactId' cannot be null.");
        else if (contactId !== undefined)
            url_ += "contactId=" + encodeURIComponent("" + contactId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBankAccountForContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBankAccountForContact(<any>response_);
                } catch (e) {
                    return <Observable<GetBankAccountForEditOutput[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBankAccountForEditOutput[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetBankAccountForContact(response: HttpResponseBase): Observable<GetBankAccountForEditOutput[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetBankAccountForEditOutput.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBankAccountForEditOutput[]>(<any>null);
    }

    /**
     * @param shabaNumber (optional) 
     * @return Success
     */
    checkAccountNumber(shabaNumber: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BankAccounts/CheckAccountNumber?";
        if (shabaNumber === null)
            throw new Error("The parameter 'shabaNumber' cannot be null.");
        else if (shabaNumber !== undefined)
            url_ += "shabaNumber=" + encodeURIComponent("" + shabaNumber) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckAccountNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckAccountNumber(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processCheckAccountNumber(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    getAllCurrencyForTableDropdown(): Observable<BanckAccountCurrencyLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BankAccounts/GetAllCurrencyForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCurrencyForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCurrencyForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<BanckAccountCurrencyLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<BanckAccountCurrencyLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCurrencyForTableDropdown(response: HttpResponseBase): Observable<BanckAccountCurrencyLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BanckAccountCurrencyLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BanckAccountCurrencyLookupTableDto[]>(<any>null);
    }

    /**
     * @param paymentType (optional) 
     * @return Success
     */
    getActiveBankAccount(paymentType: PaymentType | undefined): Observable<GetBankAccountForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BankAccounts/GetActiveBankAccount?";
        if (paymentType === null)
            throw new Error("The parameter 'paymentType' cannot be null.");
        else if (paymentType !== undefined)
            url_ += "PaymentType=" + encodeURIComponent("" + paymentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveBankAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveBankAccount(<any>response_);
                } catch (e) {
                    return <Observable<GetBankAccountForViewDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBankAccountForViewDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetActiveBankAccount(response: HttpResponseBase): Observable<GetBankAccountForViewDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetBankAccountForViewDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBankAccountForViewDto[]>(<any>null);
    }

    /**
     * @param paymentType (optional) 
     * @return Success
     */
    getDirectActiveBankAccounts(paymentType: PaymentType | undefined): Observable<GetBankAccountForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BankAccounts/GetDirectActiveBankAccounts?";
        if (paymentType === null)
            throw new Error("The parameter 'paymentType' cannot be null.");
        else if (paymentType !== undefined)
            url_ += "PaymentType=" + encodeURIComponent("" + paymentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDirectActiveBankAccounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDirectActiveBankAccounts(<any>response_);
                } catch (e) {
                    return <Observable<GetBankAccountForViewDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBankAccountForViewDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetDirectActiveBankAccounts(response: HttpResponseBase): Observable<GetBankAccountForViewDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetBankAccountForViewDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBankAccountForViewDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllBanksForTableDropdown(): Observable<BankAccountBankLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BankAccounts/GetAllBanksForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBanksForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBanksForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<BankAccountBankLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<BankAccountBankLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBanksForTableDropdown(response: HttpResponseBase): Observable<BankAccountBankLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BankAccountBankLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BankAccountBankLookupTableDto[]>(<any>null);
    }
}

@Injectable()
export class BanksServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param stateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, nameFilter: string | undefined, stateFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetBankForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Banks/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetBankForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetBankForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetBankForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetBankForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBankForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBankForView(id: number | undefined): Observable<GetBankForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Banks/GetBankForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBankForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBankForView(<any>response_);
                } catch (e) {
                    return <Observable<GetBankForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBankForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetBankForView(response: HttpResponseBase): Observable<GetBankForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBankForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBankForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBankForEdit(id: number | undefined): Observable<GetBankForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Banks/GetBankForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBankForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBankForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetBankForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBankForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetBankForEdit(response: HttpResponseBase): Observable<GetBankForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBankForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBankForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditBankDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Banks/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Banks/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param stateFilter (optional) 
     * @return Success
     */
    getBanksToExcel(filter: string | undefined, nameFilter: string | undefined, stateFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Banks/GetBanksToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBanksToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBanksToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetBanksToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class BannersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param entityRefFilter (optional) 
     * @param entityFilter (optional) 
     * @param titleFilter (optional) 
     * @param fileNameFilter (optional) 
     * @param fileTypeFilter (optional) 
     * @param filePathFilter (optional) 
     * @param maxOrderFilter (optional) 
     * @param minOrderFilter (optional) 
     * @param maxTimeFilter (optional) 
     * @param minTimeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, entityRefFilter: number | undefined, entityFilter: number | undefined, titleFilter: string | undefined, fileNameFilter: string | undefined, fileTypeFilter: string | undefined, filePathFilter: string | undefined, maxOrderFilter: number | undefined, minOrderFilter: number | undefined, maxTimeFilter: number | undefined, minTimeFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetBannerForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Banners/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (entityRefFilter === null)
            throw new Error("The parameter 'entityRefFilter' cannot be null.");
        else if (entityRefFilter !== undefined)
            url_ += "EntityRefFilter=" + encodeURIComponent("" + entityRefFilter) + "&"; 
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (fileNameFilter === null)
            throw new Error("The parameter 'fileNameFilter' cannot be null.");
        else if (fileNameFilter !== undefined)
            url_ += "FileNameFilter=" + encodeURIComponent("" + fileNameFilter) + "&"; 
        if (fileTypeFilter === null)
            throw new Error("The parameter 'fileTypeFilter' cannot be null.");
        else if (fileTypeFilter !== undefined)
            url_ += "FileTypeFilter=" + encodeURIComponent("" + fileTypeFilter) + "&"; 
        if (filePathFilter === null)
            throw new Error("The parameter 'filePathFilter' cannot be null.");
        else if (filePathFilter !== undefined)
            url_ += "FilePathFilter=" + encodeURIComponent("" + filePathFilter) + "&"; 
        if (maxOrderFilter === null)
            throw new Error("The parameter 'maxOrderFilter' cannot be null.");
        else if (maxOrderFilter !== undefined)
            url_ += "MaxOrderFilter=" + encodeURIComponent("" + maxOrderFilter) + "&"; 
        if (minOrderFilter === null)
            throw new Error("The parameter 'minOrderFilter' cannot be null.");
        else if (minOrderFilter !== undefined)
            url_ += "MinOrderFilter=" + encodeURIComponent("" + minOrderFilter) + "&"; 
        if (maxTimeFilter === null)
            throw new Error("The parameter 'maxTimeFilter' cannot be null.");
        else if (maxTimeFilter !== undefined)
            url_ += "MaxTimeFilter=" + encodeURIComponent("" + maxTimeFilter) + "&"; 
        if (minTimeFilter === null)
            throw new Error("The parameter 'minTimeFilter' cannot be null.");
        else if (minTimeFilter !== undefined)
            url_ += "MinTimeFilter=" + encodeURIComponent("" + minTimeFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetBannerForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetBannerForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetBannerForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetBannerForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBannerForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBannerForView(id: number | undefined): Observable<GetBannerForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Banners/GetBannerForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBannerForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBannerForView(<any>response_);
                } catch (e) {
                    return <Observable<GetBannerForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBannerForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetBannerForView(response: HttpResponseBase): Observable<GetBannerForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBannerForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBannerForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBannerForEdit(id: number | undefined): Observable<GetBannerForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Banners/GetBannerForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBannerForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBannerForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetBannerForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBannerForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetBannerForEdit(response: HttpResponseBase): Observable<GetBannerForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBannerForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBannerForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditBannerDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Banners/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Banners/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param path (optional) 
     * @param thumbPath (optional) 
     * @return Success
     */
    deleteUploadedNotSaved(path: string | undefined, thumbPath: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Banners/DeleteUploadedNotSaved?";
        if (path === null)
            throw new Error("The parameter 'path' cannot be null.");
        else if (path !== undefined)
            url_ += "path=" + encodeURIComponent("" + path) + "&"; 
        if (thumbPath === null)
            throw new Error("The parameter 'thumbPath' cannot be null.");
        else if (thumbPath !== undefined)
            url_ += "thumbPath=" + encodeURIComponent("" + thumbPath) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUploadedNotSaved(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUploadedNotSaved(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteUploadedNotSaved(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param entityRefFilter (optional) 
     * @param entityFilter (optional) 
     * @param titleFilter (optional) 
     * @param fileNameFilter (optional) 
     * @param fileTypeFilter (optional) 
     * @param filePathFilter (optional) 
     * @param maxOrderFilter (optional) 
     * @param minOrderFilter (optional) 
     * @param maxTimeFilter (optional) 
     * @param minTimeFilter (optional) 
     * @return Success
     */
    getBannersToExcel(filter: string | undefined, entityRefFilter: number | undefined, entityFilter: number | undefined, titleFilter: string | undefined, fileNameFilter: string | undefined, fileTypeFilter: string | undefined, filePathFilter: string | undefined, maxOrderFilter: number | undefined, minOrderFilter: number | undefined, maxTimeFilter: number | undefined, minTimeFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Banners/GetBannersToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (entityRefFilter === null)
            throw new Error("The parameter 'entityRefFilter' cannot be null.");
        else if (entityRefFilter !== undefined)
            url_ += "EntityRefFilter=" + encodeURIComponent("" + entityRefFilter) + "&"; 
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (fileNameFilter === null)
            throw new Error("The parameter 'fileNameFilter' cannot be null.");
        else if (fileNameFilter !== undefined)
            url_ += "FileNameFilter=" + encodeURIComponent("" + fileNameFilter) + "&"; 
        if (fileTypeFilter === null)
            throw new Error("The parameter 'fileTypeFilter' cannot be null.");
        else if (fileTypeFilter !== undefined)
            url_ += "FileTypeFilter=" + encodeURIComponent("" + fileTypeFilter) + "&"; 
        if (filePathFilter === null)
            throw new Error("The parameter 'filePathFilter' cannot be null.");
        else if (filePathFilter !== undefined)
            url_ += "FilePathFilter=" + encodeURIComponent("" + filePathFilter) + "&"; 
        if (maxOrderFilter === null)
            throw new Error("The parameter 'maxOrderFilter' cannot be null.");
        else if (maxOrderFilter !== undefined)
            url_ += "MaxOrderFilter=" + encodeURIComponent("" + maxOrderFilter) + "&"; 
        if (minOrderFilter === null)
            throw new Error("The parameter 'minOrderFilter' cannot be null.");
        else if (minOrderFilter !== undefined)
            url_ += "MinOrderFilter=" + encodeURIComponent("" + minOrderFilter) + "&"; 
        if (maxTimeFilter === null)
            throw new Error("The parameter 'maxTimeFilter' cannot be null.");
        else if (maxTimeFilter !== undefined)
            url_ += "MaxTimeFilter=" + encodeURIComponent("" + maxTimeFilter) + "&"; 
        if (minTimeFilter === null)
            throw new Error("The parameter 'minTimeFilter' cannot be null.");
        else if (minTimeFilter !== undefined)
            url_ += "MinTimeFilter=" + encodeURIComponent("" + minTimeFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBannersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBannersToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetBannersToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class BaseTimesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param calendarFilter (optional) 
     * @param durationFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param stateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, nameFilter: string | undefined, calendarFilter: number | undefined, durationFilter: number | undefined, descriptionFilter: string | undefined, stateFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetBaseTimeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/BaseTimes/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&"; 
        if (calendarFilter === null)
            throw new Error("The parameter 'calendarFilter' cannot be null.");
        else if (calendarFilter !== undefined)
            url_ += "CalendarFilter=" + encodeURIComponent("" + calendarFilter) + "&"; 
        if (durationFilter === null)
            throw new Error("The parameter 'durationFilter' cannot be null.");
        else if (durationFilter !== undefined)
            url_ += "DurationFilter=" + encodeURIComponent("" + durationFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetBaseTimeForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetBaseTimeForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetBaseTimeForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetBaseTimeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBaseTimeForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBaseTimeForView(id: number | undefined): Observable<GetBaseTimeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/BaseTimes/GetBaseTimeForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBaseTimeForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBaseTimeForView(<any>response_);
                } catch (e) {
                    return <Observable<GetBaseTimeForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBaseTimeForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetBaseTimeForView(response: HttpResponseBase): Observable<GetBaseTimeForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBaseTimeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBaseTimeForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBaseTimeForEdit(id: number | undefined): Observable<GetBaseTimeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/BaseTimes/GetBaseTimeForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBaseTimeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBaseTimeForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetBaseTimeForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBaseTimeForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetBaseTimeForEdit(response: HttpResponseBase): Observable<GetBaseTimeForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBaseTimeForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBaseTimeForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditBaseTimeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BaseTimes/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BaseTimes/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param calendarFilter (optional) 
     * @param durationFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param stateFilter (optional) 
     * @return Success
     */
    getBaseTimesToExcel(filter: string | undefined, nameFilter: string | undefined, calendarFilter: number | undefined, durationFilter: number | undefined, descriptionFilter: string | undefined, stateFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/BaseTimes/GetBaseTimesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&"; 
        if (calendarFilter === null)
            throw new Error("The parameter 'calendarFilter' cannot be null.");
        else if (calendarFilter !== undefined)
            url_ += "CalendarFilter=" + encodeURIComponent("" + calendarFilter) + "&"; 
        if (durationFilter === null)
            throw new Error("The parameter 'durationFilter' cannot be null.");
        else if (durationFilter !== undefined)
            url_ += "DurationFilter=" + encodeURIComponent("" + durationFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBaseTimesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBaseTimesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetBaseTimesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class BillPaymentsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param paymentBankTrackingNOFilter (optional) 
     * @param billIssueTrackingFilter (optional) 
     * @param typeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, paymentBankTrackingNOFilter: string | undefined, billIssueTrackingFilter: string | undefined, typeFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetBillPaymentForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/BillPayments/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (paymentBankTrackingNOFilter === null)
            throw new Error("The parameter 'paymentBankTrackingNOFilter' cannot be null.");
        else if (paymentBankTrackingNOFilter !== undefined)
            url_ += "PaymentBankTrackingNOFilter=" + encodeURIComponent("" + paymentBankTrackingNOFilter) + "&"; 
        if (billIssueTrackingFilter === null)
            throw new Error("The parameter 'billIssueTrackingFilter' cannot be null.");
        else if (billIssueTrackingFilter !== undefined)
            url_ += "BillIssueTrackingFilter=" + encodeURIComponent("" + billIssueTrackingFilter) + "&"; 
        if (typeFilter === null)
            throw new Error("The parameter 'typeFilter' cannot be null.");
        else if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetBillPaymentForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetBillPaymentForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetBillPaymentForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetBillPaymentForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBillPaymentForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBillPaymentForView(id: number | undefined): Observable<GetBillPaymentForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/BillPayments/GetBillPaymentForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillPaymentForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillPaymentForView(<any>response_);
                } catch (e) {
                    return <Observable<GetBillPaymentForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBillPaymentForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetBillPaymentForView(response: HttpResponseBase): Observable<GetBillPaymentForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBillPaymentForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBillPaymentForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBillPaymentForEdit(id: number | undefined): Observable<GetBillPaymentForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/BillPayments/GetBillPaymentForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillPaymentForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillPaymentForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetBillPaymentForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBillPaymentForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetBillPaymentForEdit(response: HttpResponseBase): Observable<GetBillPaymentForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBillPaymentForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBillPaymentForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditBillPaymentDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BillPayments/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BillPayments/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param paymentBankTrackingNOFilter (optional) 
     * @param billIssueTrackingFilter (optional) 
     * @return Success
     */
    getBillPaymentsToExcel(filter: string | undefined, paymentBankTrackingNOFilter: string | undefined, billIssueTrackingFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/BillPayments/GetBillPaymentsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (paymentBankTrackingNOFilter === null)
            throw new Error("The parameter 'paymentBankTrackingNOFilter' cannot be null.");
        else if (paymentBankTrackingNOFilter !== undefined)
            url_ += "PaymentBankTrackingNOFilter=" + encodeURIComponent("" + paymentBankTrackingNOFilter) + "&"; 
        if (billIssueTrackingFilter === null)
            throw new Error("The parameter 'billIssueTrackingFilter' cannot be null.");
        else if (billIssueTrackingFilter !== undefined)
            url_ += "BillIssueTrackingFilter=" + encodeURIComponent("" + billIssueTrackingFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillPaymentsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillPaymentsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetBillPaymentsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllPaymentForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfBillPaymentPaymentLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/BillPayments/GetAllPaymentForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPaymentForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPaymentForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfBillPaymentPaymentLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfBillPaymentPaymentLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPaymentForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfBillPaymentPaymentLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfBillPaymentPaymentLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfBillPaymentPaymentLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllBillForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfBillPaymentBillLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/BillPayments/GetAllBillForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBillForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBillForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfBillPaymentBillLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfBillPaymentBillLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBillForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfBillPaymentBillLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfBillPaymentBillLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfBillPaymentBillLookupTableDto>(<any>null);
    }

    /**
     * @param billId (optional) 
     * @return Success
     */
    getPaymentBill(billId: number | undefined): Observable<GetPaymentBillOutput> {
        let url_ = this.baseUrl + "/api/services/app/BillPayments/GetPaymentBill?";
        if (billId === null)
            throw new Error("The parameter 'billId' cannot be null.");
        else if (billId !== undefined)
            url_ += "billId=" + encodeURIComponent("" + billId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentBill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentBill(<any>response_);
                } catch (e) {
                    return <Observable<GetPaymentBillOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPaymentBillOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentBill(response: HttpResponseBase): Observable<GetPaymentBillOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPaymentBillOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPaymentBillOutput>(<any>null);
    }

    /**
     * @param payId (optional) 
     * @param accountingTrackingNo (optional) 
     * @param isDuplicate (optional) 
     * @return Success
     */
    approvePay(payId: number | undefined, accountingTrackingNo: string | undefined, isDuplicate: boolean | undefined): Observable<ApprovePayOutput> {
        let url_ = this.baseUrl + "/api/services/app/BillPayments/ApprovePay?";
        if (payId === null)
            throw new Error("The parameter 'payId' cannot be null.");
        else if (payId !== undefined)
            url_ += "payId=" + encodeURIComponent("" + payId) + "&"; 
        if (accountingTrackingNo === null)
            throw new Error("The parameter 'accountingTrackingNo' cannot be null.");
        else if (accountingTrackingNo !== undefined)
            url_ += "accountingTrackingNo=" + encodeURIComponent("" + accountingTrackingNo) + "&"; 
        if (isDuplicate === null)
            throw new Error("The parameter 'isDuplicate' cannot be null.");
        else if (isDuplicate !== undefined)
            url_ += "isDuplicate=" + encodeURIComponent("" + isDuplicate) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprovePay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprovePay(<any>response_);
                } catch (e) {
                    return <Observable<ApprovePayOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApprovePayOutput>><any>_observableThrow(response_);
        }));
    }

    protected processApprovePay(response: HttpResponseBase): Observable<ApprovePayOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApprovePayOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApprovePayOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    notApprovePay(body: NotApprovedPayInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BillPayments/NotApprovePay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotApprovePay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotApprovePay(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processNotApprovePay(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPaymentByAdmin(body: CreatePaymentByAdminInput | undefined): Observable<CreatePaymentByAdminOutput> {
        let url_ = this.baseUrl + "/api/services/app/BillPayments/CreatePaymentByAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePaymentByAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePaymentByAdmin(<any>response_);
                } catch (e) {
                    return <Observable<CreatePaymentByAdminOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreatePaymentByAdminOutput>><any>_observableThrow(response_);
        }));
    }

    protected processCreatePaymentByAdmin(response: HttpResponseBase): Observable<CreatePaymentByAdminOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreatePaymentByAdminOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreatePaymentByAdminOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    payToPostmanByAdmin(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BillPayments/PayToPostmanByAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPayToPostmanByAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPayToPostmanByAdmin(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPayToPostmanByAdmin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param contactId (optional) 
     * @return Success
     */
    getVirtualCredit(contactId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BillPayments/GetVirtualCredit?";
        if (contactId === null)
            throw new Error("The parameter 'contactId' cannot be null.");
        else if (contactId !== undefined)
            url_ += "contactId=" + encodeURIComponent("" + contactId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVirtualCredit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVirtualCredit(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetVirtualCredit(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param billIdInput (optional) 
     * @return Success
     */
    cancelPay(billIdInput: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BillPayments/CancelPay?";
        if (billIdInput === null)
            throw new Error("The parameter 'billIdInput' cannot be null.");
        else if (billIdInput !== undefined)
            url_ += "billIdInput=" + encodeURIComponent("" + billIdInput) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelPay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelPay(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCancelPay(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approveByAccounting(body: ApproveByAccountingInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BillPayments/ApproveByAccounting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveByAccounting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveByAccounting(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApproveByAccounting(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    notApproveByAccounting(body: ApproveByAccountingInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BillPayments/NotApproveByAccounting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotApproveByAccounting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotApproveByAccounting(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processNotApproveByAccounting(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getCancelationBills(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCancelationBillsDto> {
        let url_ = this.baseUrl + "/api/services/app/BillPayments/GetCancelationBills?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCancelationBills(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCancelationBills(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCancelationBillsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCancelationBillsDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCancelationBills(response: HttpResponseBase): Observable<PagedResultDtoOfGetCancelationBillsDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCancelationBillsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCancelationBillsDto>(<any>null);
    }

    /**
     * @param contactId (optional) 
     * @param minDate (optional) 
     * @param maxDate (optional) 
     * @return Success
     */
    getUserPaymentReport(contactId: number | undefined, minDate: moment.Moment | undefined, maxDate: moment.Moment | undefined): Observable<GetUserReportOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/BillPayments/GetUserPaymentReport?";
        if (contactId === null)
            throw new Error("The parameter 'contactId' cannot be null.");
        else if (contactId !== undefined)
            url_ += "ContactId=" + encodeURIComponent("" + contactId) + "&"; 
        if (minDate === null)
            throw new Error("The parameter 'minDate' cannot be null.");
        else if (minDate !== undefined)
            url_ += "MinDate=" + encodeURIComponent(minDate ? "" + minDate.toJSON() : "") + "&"; 
        if (maxDate === null)
            throw new Error("The parameter 'maxDate' cannot be null.");
        else if (maxDate !== undefined)
            url_ += "MaxDate=" + encodeURIComponent(maxDate ? "" + maxDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPaymentReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPaymentReport(<any>response_);
                } catch (e) {
                    return <Observable<GetUserReportOutputDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetUserReportOutputDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserPaymentReport(response: HttpResponseBase): Observable<GetUserReportOutputDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserReportOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserReportOutputDto>(<any>null);
    }

    /**
     * @param minDate (optional) 
     * @param maxDate (optional) 
     * @return Success
     */
    getAllUserPaymentReport(minDate: moment.Moment | undefined, maxDate: moment.Moment | undefined): Observable<GetUserReportOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/BillPayments/GetAllUserPaymentReport?";
        if (minDate === null)
            throw new Error("The parameter 'minDate' cannot be null.");
        else if (minDate !== undefined)
            url_ += "MinDate=" + encodeURIComponent(minDate ? "" + minDate.toJSON() : "") + "&"; 
        if (maxDate === null)
            throw new Error("The parameter 'maxDate' cannot be null.");
        else if (maxDate !== undefined)
            url_ += "MaxDate=" + encodeURIComponent(maxDate ? "" + maxDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUserPaymentReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserPaymentReport(<any>response_);
                } catch (e) {
                    return <Observable<GetUserReportOutputDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetUserReportOutputDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllUserPaymentReport(response: HttpResponseBase): Observable<GetUserReportOutputDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserReportOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserReportOutputDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllContactForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfBillPaymentPaymentLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/BillPayments/GetAllContactForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllContactForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllContactForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfBillPaymentPaymentLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfBillPaymentPaymentLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllContactForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfBillPaymentPaymentLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfBillPaymentPaymentLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfBillPaymentPaymentLookupTableDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    refusalToPayment(body: RefusalToPaymentInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BillPayments/RefusalToPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefusalToPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefusalToPayment(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRefusalToPayment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param billId (optional) 
     * @return Success
     */
    updatePayedBills(billId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BillPayments/UpdatePayedBills?";
        if (billId === null)
            throw new Error("The parameter 'billId' cannot be null.");
        else if (billId !== undefined)
            url_ += "billId=" + encodeURIComponent("" + billId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePayedBills(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePayedBills(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePayedBills(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    claimWalletCharge(body: ClaimWalletChargeInput | undefined): Observable<ClaimWalletChargeResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/BillPayments/ClaimWalletCharge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClaimWalletCharge(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClaimWalletCharge(<any>response_);
                } catch (e) {
                    return <Observable<ClaimWalletChargeResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ClaimWalletChargeResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processClaimWalletCharge(response: HttpResponseBase): Observable<ClaimWalletChargeResponseDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaimWalletChargeResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClaimWalletChargeResponseDto>(<any>null);
    }

    /**
     * @return Success
     */
    checkClaimCalledBills(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BillPayments/CheckClaimCalledBills";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckClaimCalledBills(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckClaimCalledBills(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCheckClaimCalledBills(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPaymentForKiosk(body: CreatePaymentForKioskInput | undefined): Observable<CreatePaymentByAdminOutput> {
        let url_ = this.baseUrl + "/api/services/app/BillPayments/CreatePaymentForKiosk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePaymentForKiosk(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePaymentForKiosk(<any>response_);
                } catch (e) {
                    return <Observable<CreatePaymentByAdminOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreatePaymentByAdminOutput>><any>_observableThrow(response_);
        }));
    }

    protected processCreatePaymentForKiosk(response: HttpResponseBase): Observable<CreatePaymentByAdminOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreatePaymentByAdminOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreatePaymentByAdminOutput>(<any>null);
    }
}

@Injectable()
export class BillReportsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxCurrencyIdFilter (optional) 
     * @param minCurrencyIdFilter (optional) 
     * @param maxBranchRefFilter (optional) 
     * @param minBranchRefFilter (optional) 
     * @param maxCountFilter (optional) 
     * @param minCountFilter (optional) 
     * @param firstNameFilter (optional) 
     * @param maxIssueDateFilter (optional) 
     * @param minIssueDateFilter (optional) 
     * @param billCreatorUserFilter (optional) 
     * @param statusFilter (optional) 
     * @param billCodeFilter (optional) 
     * @param maxPriceFilter (optional) 
     * @param minPriceFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param extraEntityFilter (optional) 
     * @param planConstTitleFilter (optional) 
     * @param planBillCodeFilter (optional) 
     * @param benefactorNameFilter (optional) 
     * @param approveFullNameFilter (optional) 
     * @param maxLatFilter (optional) 
     * @param minLatFilter (optional) 
     * @param maxLongFilter (optional) 
     * @param minLongFilter (optional) 
     * @param maxDueDateFilter (optional) 
     * @param minDueDateFilter (optional) 
     * @param maxExtraEntityRefFilter (optional) 
     * @param minExtraEntityRefFilter (optional) 
     * @param deliveryTypeFilter (optional) 
     * @param maxContactIdFilter (optional) 
     * @param minContactIdFilter (optional) 
     * @param descriptionOneFilter (optional) 
     * @param descriptionTwoFilter (optional) 
     * @param announceTheDifferenceFilter (optional) 
     * @param maxCardTemplateRefFilter (optional) 
     * @param minCardTemplateRefFilter (optional) 
     * @param ceremonyTitleFilter (optional) 
     * @param deceasedTitleFilter (optional) 
     * @param currencyNameFilter (optional) 
     * @param cardTemplateTileFilter (optional) 
     * @param maxPlanBillIdFilter (optional) 
     * @param minPlanBillIdFilter (optional) 
     * @param maxPlanConstIdFilter (optional) 
     * @param minPlanConstIdFilter (optional) 
     * @param planTypeFilter (optional) 
     * @param lastNameFilter (optional) 
     * @param mobileNumber1Filter (optional) 
     * @param maxBillIdFilter (optional) 
     * @param minBillIdFilter (optional) 
     * @param planConstCodeFilter (optional) 
     * @param sourceAttributesFilter (optional) 
     * @param sourceAttributesValueFilter (optional) 
     * @param paymentCreatorUserFilter (optional) 
     * @param maxPaymentCreatDateFilter (optional) 
     * @param minPaymentCreatDateFilter (optional) 
     * @param maxPaymentApprovedDateFilter (optional) 
     * @param minPaymentApprovedDateFilter (optional) 
     * @param paymentTypeFilter (optional) 
     * @param bankSerialNOFilter (optional) 
     * @param branchCodeFilter (optional) 
     * @param bankPaymentFilter (optional) 
     * @param maxPaymentAmountFilter (optional) 
     * @param minPaymentAmountFilter (optional) 
     * @param paymentBankTrackingNOFilter (optional) 
     * @param paymentAccountingTrackingNOFilter (optional) 
     * @param panCardFilter (optional) 
     * @param maxPaymentDateTimeFilter (optional) 
     * @param minPaymentDateTimeFilter (optional) 
     * @param posSerialFilter (optional) 
     * @param depositIdFilter (optional) 
     * @param paymentDescriptionFilter (optional) 
     * @param bankAccountNumberFilter (optional) 
     * @param maxPaymentIdFilter (optional) 
     * @param minPaymentIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, maxCurrencyIdFilter: number | undefined, minCurrencyIdFilter: number | undefined, maxBranchRefFilter: number | undefined, minBranchRefFilter: number | undefined, maxCountFilter: number | undefined, minCountFilter: number | undefined, firstNameFilter: string | undefined, maxIssueDateFilter: moment.Moment | undefined, minIssueDateFilter: moment.Moment | undefined, billCreatorUserFilter: string | undefined, statusFilter: number | undefined, billCodeFilter: string | undefined, maxPriceFilter: number | undefined, minPriceFilter: number | undefined, descriptionFilter: string | undefined, extraEntityFilter: number | undefined, planConstTitleFilter: string | undefined, planBillCodeFilter: string | undefined, benefactorNameFilter: string | undefined, approveFullNameFilter: string | undefined, maxLatFilter: number | undefined, minLatFilter: number | undefined, maxLongFilter: number | undefined, minLongFilter: number | undefined, maxDueDateFilter: moment.Moment | undefined, minDueDateFilter: moment.Moment | undefined, maxExtraEntityRefFilter: number | undefined, minExtraEntityRefFilter: number | undefined, deliveryTypeFilter: number | undefined, maxContactIdFilter: number | undefined, minContactIdFilter: number | undefined, descriptionOneFilter: string | undefined, descriptionTwoFilter: string | undefined, announceTheDifferenceFilter: number | undefined, maxCardTemplateRefFilter: number | undefined, minCardTemplateRefFilter: number | undefined, ceremonyTitleFilter: string | undefined, deceasedTitleFilter: string | undefined, currencyNameFilter: string | undefined, cardTemplateTileFilter: string | undefined, maxPlanBillIdFilter: number | undefined, minPlanBillIdFilter: number | undefined, maxPlanConstIdFilter: number | undefined, minPlanConstIdFilter: number | undefined, planTypeFilter: number | undefined, lastNameFilter: string | undefined, mobileNumber1Filter: string | undefined, maxBillIdFilter: number | undefined, minBillIdFilter: number | undefined, planConstCodeFilter: string | undefined, sourceAttributesFilter: string | undefined, sourceAttributesValueFilter: string | undefined, paymentCreatorUserFilter: string | undefined, maxPaymentCreatDateFilter: moment.Moment | undefined, minPaymentCreatDateFilter: moment.Moment | undefined, maxPaymentApprovedDateFilter: moment.Moment | undefined, minPaymentApprovedDateFilter: moment.Moment | undefined, paymentTypeFilter: string | undefined, bankSerialNOFilter: string | undefined, branchCodeFilter: string | undefined, bankPaymentFilter: string | undefined, maxPaymentAmountFilter: number | undefined, minPaymentAmountFilter: number | undefined, paymentBankTrackingNOFilter: string | undefined, paymentAccountingTrackingNOFilter: string | undefined, panCardFilter: string | undefined, maxPaymentDateTimeFilter: moment.Moment | undefined, minPaymentDateTimeFilter: moment.Moment | undefined, posSerialFilter: string | undefined, depositIdFilter: string | undefined, paymentDescriptionFilter: string | undefined, bankAccountNumberFilter: string | undefined, maxPaymentIdFilter: number | undefined, minPaymentIdFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetBillReportForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/BillReports/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxCurrencyIdFilter === null)
            throw new Error("The parameter 'maxCurrencyIdFilter' cannot be null.");
        else if (maxCurrencyIdFilter !== undefined)
            url_ += "MaxCurrencyIdFilter=" + encodeURIComponent("" + maxCurrencyIdFilter) + "&"; 
        if (minCurrencyIdFilter === null)
            throw new Error("The parameter 'minCurrencyIdFilter' cannot be null.");
        else if (minCurrencyIdFilter !== undefined)
            url_ += "MinCurrencyIdFilter=" + encodeURIComponent("" + minCurrencyIdFilter) + "&"; 
        if (maxBranchRefFilter === null)
            throw new Error("The parameter 'maxBranchRefFilter' cannot be null.");
        else if (maxBranchRefFilter !== undefined)
            url_ += "MaxBranchRefFilter=" + encodeURIComponent("" + maxBranchRefFilter) + "&"; 
        if (minBranchRefFilter === null)
            throw new Error("The parameter 'minBranchRefFilter' cannot be null.");
        else if (minBranchRefFilter !== undefined)
            url_ += "MinBranchRefFilter=" + encodeURIComponent("" + minBranchRefFilter) + "&"; 
        if (maxCountFilter === null)
            throw new Error("The parameter 'maxCountFilter' cannot be null.");
        else if (maxCountFilter !== undefined)
            url_ += "MaxCountFilter=" + encodeURIComponent("" + maxCountFilter) + "&"; 
        if (minCountFilter === null)
            throw new Error("The parameter 'minCountFilter' cannot be null.");
        else if (minCountFilter !== undefined)
            url_ += "MinCountFilter=" + encodeURIComponent("" + minCountFilter) + "&"; 
        if (firstNameFilter === null)
            throw new Error("The parameter 'firstNameFilter' cannot be null.");
        else if (firstNameFilter !== undefined)
            url_ += "FirstNameFilter=" + encodeURIComponent("" + firstNameFilter) + "&"; 
        if (maxIssueDateFilter === null)
            throw new Error("The parameter 'maxIssueDateFilter' cannot be null.");
        else if (maxIssueDateFilter !== undefined)
            url_ += "MaxIssueDateFilter=" + encodeURIComponent(maxIssueDateFilter ? "" + maxIssueDateFilter.toJSON() : "") + "&"; 
        if (minIssueDateFilter === null)
            throw new Error("The parameter 'minIssueDateFilter' cannot be null.");
        else if (minIssueDateFilter !== undefined)
            url_ += "MinIssueDateFilter=" + encodeURIComponent(minIssueDateFilter ? "" + minIssueDateFilter.toJSON() : "") + "&"; 
        if (billCreatorUserFilter === null)
            throw new Error("The parameter 'billCreatorUserFilter' cannot be null.");
        else if (billCreatorUserFilter !== undefined)
            url_ += "BillCreatorUserFilter=" + encodeURIComponent("" + billCreatorUserFilter) + "&"; 
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (billCodeFilter === null)
            throw new Error("The parameter 'billCodeFilter' cannot be null.");
        else if (billCodeFilter !== undefined)
            url_ += "BillCodeFilter=" + encodeURIComponent("" + billCodeFilter) + "&"; 
        if (maxPriceFilter === null)
            throw new Error("The parameter 'maxPriceFilter' cannot be null.");
        else if (maxPriceFilter !== undefined)
            url_ += "MaxPriceFilter=" + encodeURIComponent("" + maxPriceFilter) + "&"; 
        if (minPriceFilter === null)
            throw new Error("The parameter 'minPriceFilter' cannot be null.");
        else if (minPriceFilter !== undefined)
            url_ += "MinPriceFilter=" + encodeURIComponent("" + minPriceFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (extraEntityFilter === null)
            throw new Error("The parameter 'extraEntityFilter' cannot be null.");
        else if (extraEntityFilter !== undefined)
            url_ += "ExtraEntityFilter=" + encodeURIComponent("" + extraEntityFilter) + "&"; 
        if (planConstTitleFilter === null)
            throw new Error("The parameter 'planConstTitleFilter' cannot be null.");
        else if (planConstTitleFilter !== undefined)
            url_ += "PlanConstTitleFilter=" + encodeURIComponent("" + planConstTitleFilter) + "&"; 
        if (planBillCodeFilter === null)
            throw new Error("The parameter 'planBillCodeFilter' cannot be null.");
        else if (planBillCodeFilter !== undefined)
            url_ += "PlanBillCodeFilter=" + encodeURIComponent("" + planBillCodeFilter) + "&"; 
        if (benefactorNameFilter === null)
            throw new Error("The parameter 'benefactorNameFilter' cannot be null.");
        else if (benefactorNameFilter !== undefined)
            url_ += "BenefactorNameFilter=" + encodeURIComponent("" + benefactorNameFilter) + "&"; 
        if (approveFullNameFilter === null)
            throw new Error("The parameter 'approveFullNameFilter' cannot be null.");
        else if (approveFullNameFilter !== undefined)
            url_ += "ApproveFullNameFilter=" + encodeURIComponent("" + approveFullNameFilter) + "&"; 
        if (maxLatFilter === null)
            throw new Error("The parameter 'maxLatFilter' cannot be null.");
        else if (maxLatFilter !== undefined)
            url_ += "MaxLatFilter=" + encodeURIComponent("" + maxLatFilter) + "&"; 
        if (minLatFilter === null)
            throw new Error("The parameter 'minLatFilter' cannot be null.");
        else if (minLatFilter !== undefined)
            url_ += "MinLatFilter=" + encodeURIComponent("" + minLatFilter) + "&"; 
        if (maxLongFilter === null)
            throw new Error("The parameter 'maxLongFilter' cannot be null.");
        else if (maxLongFilter !== undefined)
            url_ += "MaxLongFilter=" + encodeURIComponent("" + maxLongFilter) + "&"; 
        if (minLongFilter === null)
            throw new Error("The parameter 'minLongFilter' cannot be null.");
        else if (minLongFilter !== undefined)
            url_ += "MinLongFilter=" + encodeURIComponent("" + minLongFilter) + "&"; 
        if (maxDueDateFilter === null)
            throw new Error("The parameter 'maxDueDateFilter' cannot be null.");
        else if (maxDueDateFilter !== undefined)
            url_ += "MaxDueDateFilter=" + encodeURIComponent(maxDueDateFilter ? "" + maxDueDateFilter.toJSON() : "") + "&"; 
        if (minDueDateFilter === null)
            throw new Error("The parameter 'minDueDateFilter' cannot be null.");
        else if (minDueDateFilter !== undefined)
            url_ += "MinDueDateFilter=" + encodeURIComponent(minDueDateFilter ? "" + minDueDateFilter.toJSON() : "") + "&"; 
        if (maxExtraEntityRefFilter === null)
            throw new Error("The parameter 'maxExtraEntityRefFilter' cannot be null.");
        else if (maxExtraEntityRefFilter !== undefined)
            url_ += "MaxExtraEntityRefFilter=" + encodeURIComponent("" + maxExtraEntityRefFilter) + "&"; 
        if (minExtraEntityRefFilter === null)
            throw new Error("The parameter 'minExtraEntityRefFilter' cannot be null.");
        else if (minExtraEntityRefFilter !== undefined)
            url_ += "MinExtraEntityRefFilter=" + encodeURIComponent("" + minExtraEntityRefFilter) + "&"; 
        if (deliveryTypeFilter === null)
            throw new Error("The parameter 'deliveryTypeFilter' cannot be null.");
        else if (deliveryTypeFilter !== undefined)
            url_ += "DeliveryTypeFilter=" + encodeURIComponent("" + deliveryTypeFilter) + "&"; 
        if (maxContactIdFilter === null)
            throw new Error("The parameter 'maxContactIdFilter' cannot be null.");
        else if (maxContactIdFilter !== undefined)
            url_ += "MaxContactIdFilter=" + encodeURIComponent("" + maxContactIdFilter) + "&"; 
        if (minContactIdFilter === null)
            throw new Error("The parameter 'minContactIdFilter' cannot be null.");
        else if (minContactIdFilter !== undefined)
            url_ += "MinContactIdFilter=" + encodeURIComponent("" + minContactIdFilter) + "&"; 
        if (descriptionOneFilter === null)
            throw new Error("The parameter 'descriptionOneFilter' cannot be null.");
        else if (descriptionOneFilter !== undefined)
            url_ += "DescriptionOneFilter=" + encodeURIComponent("" + descriptionOneFilter) + "&"; 
        if (descriptionTwoFilter === null)
            throw new Error("The parameter 'descriptionTwoFilter' cannot be null.");
        else if (descriptionTwoFilter !== undefined)
            url_ += "DescriptionTwoFilter=" + encodeURIComponent("" + descriptionTwoFilter) + "&"; 
        if (announceTheDifferenceFilter === null)
            throw new Error("The parameter 'announceTheDifferenceFilter' cannot be null.");
        else if (announceTheDifferenceFilter !== undefined)
            url_ += "AnnounceTheDifferenceFilter=" + encodeURIComponent("" + announceTheDifferenceFilter) + "&"; 
        if (maxCardTemplateRefFilter === null)
            throw new Error("The parameter 'maxCardTemplateRefFilter' cannot be null.");
        else if (maxCardTemplateRefFilter !== undefined)
            url_ += "MaxCardTemplateRefFilter=" + encodeURIComponent("" + maxCardTemplateRefFilter) + "&"; 
        if (minCardTemplateRefFilter === null)
            throw new Error("The parameter 'minCardTemplateRefFilter' cannot be null.");
        else if (minCardTemplateRefFilter !== undefined)
            url_ += "MinCardTemplateRefFilter=" + encodeURIComponent("" + minCardTemplateRefFilter) + "&"; 
        if (ceremonyTitleFilter === null)
            throw new Error("The parameter 'ceremonyTitleFilter' cannot be null.");
        else if (ceremonyTitleFilter !== undefined)
            url_ += "CeremonyTitleFilter=" + encodeURIComponent("" + ceremonyTitleFilter) + "&"; 
        if (deceasedTitleFilter === null)
            throw new Error("The parameter 'deceasedTitleFilter' cannot be null.");
        else if (deceasedTitleFilter !== undefined)
            url_ += "DeceasedTitleFilter=" + encodeURIComponent("" + deceasedTitleFilter) + "&"; 
        if (currencyNameFilter === null)
            throw new Error("The parameter 'currencyNameFilter' cannot be null.");
        else if (currencyNameFilter !== undefined)
            url_ += "CurrencyNameFilter=" + encodeURIComponent("" + currencyNameFilter) + "&"; 
        if (cardTemplateTileFilter === null)
            throw new Error("The parameter 'cardTemplateTileFilter' cannot be null.");
        else if (cardTemplateTileFilter !== undefined)
            url_ += "CardTemplateTileFilter=" + encodeURIComponent("" + cardTemplateTileFilter) + "&"; 
        if (maxPlanBillIdFilter === null)
            throw new Error("The parameter 'maxPlanBillIdFilter' cannot be null.");
        else if (maxPlanBillIdFilter !== undefined)
            url_ += "MaxPlanBillIdFilter=" + encodeURIComponent("" + maxPlanBillIdFilter) + "&"; 
        if (minPlanBillIdFilter === null)
            throw new Error("The parameter 'minPlanBillIdFilter' cannot be null.");
        else if (minPlanBillIdFilter !== undefined)
            url_ += "MinPlanBillIdFilter=" + encodeURIComponent("" + minPlanBillIdFilter) + "&"; 
        if (maxPlanConstIdFilter === null)
            throw new Error("The parameter 'maxPlanConstIdFilter' cannot be null.");
        else if (maxPlanConstIdFilter !== undefined)
            url_ += "MaxPlanConstIdFilter=" + encodeURIComponent("" + maxPlanConstIdFilter) + "&"; 
        if (minPlanConstIdFilter === null)
            throw new Error("The parameter 'minPlanConstIdFilter' cannot be null.");
        else if (minPlanConstIdFilter !== undefined)
            url_ += "MinPlanConstIdFilter=" + encodeURIComponent("" + minPlanConstIdFilter) + "&"; 
        if (planTypeFilter === null)
            throw new Error("The parameter 'planTypeFilter' cannot be null.");
        else if (planTypeFilter !== undefined)
            url_ += "PlanTypeFilter=" + encodeURIComponent("" + planTypeFilter) + "&"; 
        if (lastNameFilter === null)
            throw new Error("The parameter 'lastNameFilter' cannot be null.");
        else if (lastNameFilter !== undefined)
            url_ += "LastNameFilter=" + encodeURIComponent("" + lastNameFilter) + "&"; 
        if (mobileNumber1Filter === null)
            throw new Error("The parameter 'mobileNumber1Filter' cannot be null.");
        else if (mobileNumber1Filter !== undefined)
            url_ += "MobileNumber1Filter=" + encodeURIComponent("" + mobileNumber1Filter) + "&"; 
        if (maxBillIdFilter === null)
            throw new Error("The parameter 'maxBillIdFilter' cannot be null.");
        else if (maxBillIdFilter !== undefined)
            url_ += "MaxBillIdFilter=" + encodeURIComponent("" + maxBillIdFilter) + "&"; 
        if (minBillIdFilter === null)
            throw new Error("The parameter 'minBillIdFilter' cannot be null.");
        else if (minBillIdFilter !== undefined)
            url_ += "MinBillIdFilter=" + encodeURIComponent("" + minBillIdFilter) + "&"; 
        if (planConstCodeFilter === null)
            throw new Error("The parameter 'planConstCodeFilter' cannot be null.");
        else if (planConstCodeFilter !== undefined)
            url_ += "PlanConstCodeFilter=" + encodeURIComponent("" + planConstCodeFilter) + "&"; 
        if (sourceAttributesFilter === null)
            throw new Error("The parameter 'sourceAttributesFilter' cannot be null.");
        else if (sourceAttributesFilter !== undefined)
            url_ += "SourceAttributesFilter=" + encodeURIComponent("" + sourceAttributesFilter) + "&"; 
        if (sourceAttributesValueFilter === null)
            throw new Error("The parameter 'sourceAttributesValueFilter' cannot be null.");
        else if (sourceAttributesValueFilter !== undefined)
            url_ += "SourceAttributesValueFilter=" + encodeURIComponent("" + sourceAttributesValueFilter) + "&"; 
        if (paymentCreatorUserFilter === null)
            throw new Error("The parameter 'paymentCreatorUserFilter' cannot be null.");
        else if (paymentCreatorUserFilter !== undefined)
            url_ += "PaymentCreatorUserFilter=" + encodeURIComponent("" + paymentCreatorUserFilter) + "&"; 
        if (maxPaymentCreatDateFilter === null)
            throw new Error("The parameter 'maxPaymentCreatDateFilter' cannot be null.");
        else if (maxPaymentCreatDateFilter !== undefined)
            url_ += "MaxPaymentCreatDateFilter=" + encodeURIComponent(maxPaymentCreatDateFilter ? "" + maxPaymentCreatDateFilter.toJSON() : "") + "&"; 
        if (minPaymentCreatDateFilter === null)
            throw new Error("The parameter 'minPaymentCreatDateFilter' cannot be null.");
        else if (minPaymentCreatDateFilter !== undefined)
            url_ += "MinPaymentCreatDateFilter=" + encodeURIComponent(minPaymentCreatDateFilter ? "" + minPaymentCreatDateFilter.toJSON() : "") + "&"; 
        if (maxPaymentApprovedDateFilter === null)
            throw new Error("The parameter 'maxPaymentApprovedDateFilter' cannot be null.");
        else if (maxPaymentApprovedDateFilter !== undefined)
            url_ += "MaxPaymentApprovedDateFilter=" + encodeURIComponent(maxPaymentApprovedDateFilter ? "" + maxPaymentApprovedDateFilter.toJSON() : "") + "&"; 
        if (minPaymentApprovedDateFilter === null)
            throw new Error("The parameter 'minPaymentApprovedDateFilter' cannot be null.");
        else if (minPaymentApprovedDateFilter !== undefined)
            url_ += "MinPaymentApprovedDateFilter=" + encodeURIComponent(minPaymentApprovedDateFilter ? "" + minPaymentApprovedDateFilter.toJSON() : "") + "&"; 
        if (paymentTypeFilter === null)
            throw new Error("The parameter 'paymentTypeFilter' cannot be null.");
        else if (paymentTypeFilter !== undefined)
            url_ += "PaymentTypeFilter=" + encodeURIComponent("" + paymentTypeFilter) + "&"; 
        if (bankSerialNOFilter === null)
            throw new Error("The parameter 'bankSerialNOFilter' cannot be null.");
        else if (bankSerialNOFilter !== undefined)
            url_ += "BankSerialNOFilter=" + encodeURIComponent("" + bankSerialNOFilter) + "&"; 
        if (branchCodeFilter === null)
            throw new Error("The parameter 'branchCodeFilter' cannot be null.");
        else if (branchCodeFilter !== undefined)
            url_ += "BranchCodeFilter=" + encodeURIComponent("" + branchCodeFilter) + "&"; 
        if (bankPaymentFilter === null)
            throw new Error("The parameter 'bankPaymentFilter' cannot be null.");
        else if (bankPaymentFilter !== undefined)
            url_ += "BankPaymentFilter=" + encodeURIComponent("" + bankPaymentFilter) + "&"; 
        if (maxPaymentAmountFilter === null)
            throw new Error("The parameter 'maxPaymentAmountFilter' cannot be null.");
        else if (maxPaymentAmountFilter !== undefined)
            url_ += "MaxPaymentAmountFilter=" + encodeURIComponent("" + maxPaymentAmountFilter) + "&"; 
        if (minPaymentAmountFilter === null)
            throw new Error("The parameter 'minPaymentAmountFilter' cannot be null.");
        else if (minPaymentAmountFilter !== undefined)
            url_ += "MinPaymentAmountFilter=" + encodeURIComponent("" + minPaymentAmountFilter) + "&"; 
        if (paymentBankTrackingNOFilter === null)
            throw new Error("The parameter 'paymentBankTrackingNOFilter' cannot be null.");
        else if (paymentBankTrackingNOFilter !== undefined)
            url_ += "PaymentBankTrackingNOFilter=" + encodeURIComponent("" + paymentBankTrackingNOFilter) + "&"; 
        if (paymentAccountingTrackingNOFilter === null)
            throw new Error("The parameter 'paymentAccountingTrackingNOFilter' cannot be null.");
        else if (paymentAccountingTrackingNOFilter !== undefined)
            url_ += "PaymentAccountingTrackingNOFilter=" + encodeURIComponent("" + paymentAccountingTrackingNOFilter) + "&"; 
        if (panCardFilter === null)
            throw new Error("The parameter 'panCardFilter' cannot be null.");
        else if (panCardFilter !== undefined)
            url_ += "PanCardFilter=" + encodeURIComponent("" + panCardFilter) + "&"; 
        if (maxPaymentDateTimeFilter === null)
            throw new Error("The parameter 'maxPaymentDateTimeFilter' cannot be null.");
        else if (maxPaymentDateTimeFilter !== undefined)
            url_ += "MaxPaymentDateTimeFilter=" + encodeURIComponent(maxPaymentDateTimeFilter ? "" + maxPaymentDateTimeFilter.toJSON() : "") + "&"; 
        if (minPaymentDateTimeFilter === null)
            throw new Error("The parameter 'minPaymentDateTimeFilter' cannot be null.");
        else if (minPaymentDateTimeFilter !== undefined)
            url_ += "MinPaymentDateTimeFilter=" + encodeURIComponent(minPaymentDateTimeFilter ? "" + minPaymentDateTimeFilter.toJSON() : "") + "&"; 
        if (posSerialFilter === null)
            throw new Error("The parameter 'posSerialFilter' cannot be null.");
        else if (posSerialFilter !== undefined)
            url_ += "PosSerialFilter=" + encodeURIComponent("" + posSerialFilter) + "&"; 
        if (depositIdFilter === null)
            throw new Error("The parameter 'depositIdFilter' cannot be null.");
        else if (depositIdFilter !== undefined)
            url_ += "DepositIdFilter=" + encodeURIComponent("" + depositIdFilter) + "&"; 
        if (paymentDescriptionFilter === null)
            throw new Error("The parameter 'paymentDescriptionFilter' cannot be null.");
        else if (paymentDescriptionFilter !== undefined)
            url_ += "PaymentDescriptionFilter=" + encodeURIComponent("" + paymentDescriptionFilter) + "&"; 
        if (bankAccountNumberFilter === null)
            throw new Error("The parameter 'bankAccountNumberFilter' cannot be null.");
        else if (bankAccountNumberFilter !== undefined)
            url_ += "BankAccountNumberFilter=" + encodeURIComponent("" + bankAccountNumberFilter) + "&"; 
        if (maxPaymentIdFilter === null)
            throw new Error("The parameter 'maxPaymentIdFilter' cannot be null.");
        else if (maxPaymentIdFilter !== undefined)
            url_ += "MaxPaymentIdFilter=" + encodeURIComponent("" + maxPaymentIdFilter) + "&"; 
        if (minPaymentIdFilter === null)
            throw new Error("The parameter 'minPaymentIdFilter' cannot be null.");
        else if (minPaymentIdFilter !== undefined)
            url_ += "MinPaymentIdFilter=" + encodeURIComponent("" + minPaymentIdFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetBillReportForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetBillReportForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetBillReportForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetBillReportForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBillReportForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBillReportForView(id: number | undefined): Observable<GetBillReportForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/BillReports/GetBillReportForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillReportForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillReportForView(<any>response_);
                } catch (e) {
                    return <Observable<GetBillReportForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBillReportForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetBillReportForView(response: HttpResponseBase): Observable<GetBillReportForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBillReportForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBillReportForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBillReportForEdit(id: number | undefined): Observable<GetBillReportForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/BillReports/GetBillReportForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillReportForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillReportForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetBillReportForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBillReportForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetBillReportForEdit(response: HttpResponseBase): Observable<GetBillReportForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBillReportForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBillReportForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditBillReportDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BillReports/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BillReports/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param maxCurrencyIdFilter (optional) 
     * @param minCurrencyIdFilter (optional) 
     * @param maxBranchRefFilter (optional) 
     * @param minBranchRefFilter (optional) 
     * @param maxCountFilter (optional) 
     * @param minCountFilter (optional) 
     * @param firstNameFilter (optional) 
     * @param maxIssueDateFilter (optional) 
     * @param minIssueDateFilter (optional) 
     * @param billCreatorUserFilter (optional) 
     * @param statusFilter (optional) 
     * @param billCodeFilter (optional) 
     * @param maxPriceFilter (optional) 
     * @param minPriceFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param extraEntityFilter (optional) 
     * @param planConstTitleFilter (optional) 
     * @param planBillCodeFilter (optional) 
     * @param benefactorNameFilter (optional) 
     * @param approveFullNameFilter (optional) 
     * @param maxLatFilter (optional) 
     * @param minLatFilter (optional) 
     * @param maxLongFilter (optional) 
     * @param minLongFilter (optional) 
     * @param maxDueDateFilter (optional) 
     * @param minDueDateFilter (optional) 
     * @param maxExtraEntityRefFilter (optional) 
     * @param minExtraEntityRefFilter (optional) 
     * @param deliveryTypeFilter (optional) 
     * @param maxContactIdFilter (optional) 
     * @param minContactIdFilter (optional) 
     * @param descriptionOneFilter (optional) 
     * @param descriptionTwoFilter (optional) 
     * @param announceTheDifferenceFilter (optional) 
     * @param maxCardTemplateRefFilter (optional) 
     * @param minCardTemplateRefFilter (optional) 
     * @param ceremonyTitleFilter (optional) 
     * @param deceasedTitleFilter (optional) 
     * @param currencyNameFilter (optional) 
     * @param cardTemplateTileFilter (optional) 
     * @param maxPlanBillIdFilter (optional) 
     * @param minPlanBillIdFilter (optional) 
     * @param maxPlanConstIdFilter (optional) 
     * @param minPlanConstIdFilter (optional) 
     * @param planTypeFilter (optional) 
     * @param lastNameFilter (optional) 
     * @param mobileNumber1Filter (optional) 
     * @param maxBillIdFilter (optional) 
     * @param minBillIdFilter (optional) 
     * @param planConstCodeFilter (optional) 
     * @param sourceAttributesFilter (optional) 
     * @param sourceAttributesValueFilter (optional) 
     * @param paymentCreatorUserFilter (optional) 
     * @param maxPaymentCreatDateFilter (optional) 
     * @param minPaymentCreatDateFilter (optional) 
     * @param maxPaymentApprovedDateFilter (optional) 
     * @param minPaymentApprovedDateFilter (optional) 
     * @param paymentTypeFilter (optional) 
     * @param bankSerialNOFilter (optional) 
     * @param branchCodeFilter (optional) 
     * @param bankPaymentFilter (optional) 
     * @param maxPaymentAmountFilter (optional) 
     * @param minPaymentAmountFilter (optional) 
     * @param paymentBankTrackingNOFilter (optional) 
     * @param paymentAccountingTrackingNOFilter (optional) 
     * @param panCardFilter (optional) 
     * @param maxPaymentDateTimeFilter (optional) 
     * @param minPaymentDateTimeFilter (optional) 
     * @param posSerialFilter (optional) 
     * @param depositIdFilter (optional) 
     * @param paymentDescriptionFilter (optional) 
     * @param bankAccountNumberFilter (optional) 
     * @param maxPaymentIdFilter (optional) 
     * @param minPaymentIdFilter (optional) 
     * @return Success
     */
    getBillReportsToExcel(filter: string | undefined, maxCurrencyIdFilter: number | undefined, minCurrencyIdFilter: number | undefined, maxBranchRefFilter: number | undefined, minBranchRefFilter: number | undefined, maxCountFilter: number | undefined, minCountFilter: number | undefined, firstNameFilter: string | undefined, maxIssueDateFilter: moment.Moment | undefined, minIssueDateFilter: moment.Moment | undefined, billCreatorUserFilter: string | undefined, statusFilter: number | undefined, billCodeFilter: string | undefined, maxPriceFilter: number | undefined, minPriceFilter: number | undefined, descriptionFilter: string | undefined, extraEntityFilter: number | undefined, planConstTitleFilter: string | undefined, planBillCodeFilter: string | undefined, benefactorNameFilter: string | undefined, approveFullNameFilter: string | undefined, maxLatFilter: number | undefined, minLatFilter: number | undefined, maxLongFilter: number | undefined, minLongFilter: number | undefined, maxDueDateFilter: moment.Moment | undefined, minDueDateFilter: moment.Moment | undefined, maxExtraEntityRefFilter: number | undefined, minExtraEntityRefFilter: number | undefined, deliveryTypeFilter: number | undefined, maxContactIdFilter: number | undefined, minContactIdFilter: number | undefined, descriptionOneFilter: string | undefined, descriptionTwoFilter: string | undefined, announceTheDifferenceFilter: number | undefined, maxCardTemplateRefFilter: number | undefined, minCardTemplateRefFilter: number | undefined, ceremonyTitleFilter: string | undefined, deceasedTitleFilter: string | undefined, currencyNameFilter: string | undefined, cardTemplateTileFilter: string | undefined, maxPlanBillIdFilter: number | undefined, minPlanBillIdFilter: number | undefined, maxPlanConstIdFilter: number | undefined, minPlanConstIdFilter: number | undefined, planTypeFilter: number | undefined, lastNameFilter: string | undefined, mobileNumber1Filter: string | undefined, maxBillIdFilter: number | undefined, minBillIdFilter: number | undefined, planConstCodeFilter: string | undefined, sourceAttributesFilter: string | undefined, sourceAttributesValueFilter: string | undefined, paymentCreatorUserFilter: string | undefined, maxPaymentCreatDateFilter: moment.Moment | undefined, minPaymentCreatDateFilter: moment.Moment | undefined, maxPaymentApprovedDateFilter: moment.Moment | undefined, minPaymentApprovedDateFilter: moment.Moment | undefined, paymentTypeFilter: string | undefined, bankSerialNOFilter: string | undefined, branchCodeFilter: string | undefined, bankPaymentFilter: string | undefined, maxPaymentAmountFilter: number | undefined, minPaymentAmountFilter: number | undefined, paymentBankTrackingNOFilter: string | undefined, paymentAccountingTrackingNOFilter: string | undefined, panCardFilter: string | undefined, maxPaymentDateTimeFilter: moment.Moment | undefined, minPaymentDateTimeFilter: moment.Moment | undefined, posSerialFilter: string | undefined, depositIdFilter: string | undefined, paymentDescriptionFilter: string | undefined, bankAccountNumberFilter: string | undefined, maxPaymentIdFilter: number | undefined, minPaymentIdFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/BillReports/GetBillReportsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxCurrencyIdFilter === null)
            throw new Error("The parameter 'maxCurrencyIdFilter' cannot be null.");
        else if (maxCurrencyIdFilter !== undefined)
            url_ += "MaxCurrencyIdFilter=" + encodeURIComponent("" + maxCurrencyIdFilter) + "&"; 
        if (minCurrencyIdFilter === null)
            throw new Error("The parameter 'minCurrencyIdFilter' cannot be null.");
        else if (minCurrencyIdFilter !== undefined)
            url_ += "MinCurrencyIdFilter=" + encodeURIComponent("" + minCurrencyIdFilter) + "&"; 
        if (maxBranchRefFilter === null)
            throw new Error("The parameter 'maxBranchRefFilter' cannot be null.");
        else if (maxBranchRefFilter !== undefined)
            url_ += "MaxBranchRefFilter=" + encodeURIComponent("" + maxBranchRefFilter) + "&"; 
        if (minBranchRefFilter === null)
            throw new Error("The parameter 'minBranchRefFilter' cannot be null.");
        else if (minBranchRefFilter !== undefined)
            url_ += "MinBranchRefFilter=" + encodeURIComponent("" + minBranchRefFilter) + "&"; 
        if (maxCountFilter === null)
            throw new Error("The parameter 'maxCountFilter' cannot be null.");
        else if (maxCountFilter !== undefined)
            url_ += "MaxCountFilter=" + encodeURIComponent("" + maxCountFilter) + "&"; 
        if (minCountFilter === null)
            throw new Error("The parameter 'minCountFilter' cannot be null.");
        else if (minCountFilter !== undefined)
            url_ += "MinCountFilter=" + encodeURIComponent("" + minCountFilter) + "&"; 
        if (firstNameFilter === null)
            throw new Error("The parameter 'firstNameFilter' cannot be null.");
        else if (firstNameFilter !== undefined)
            url_ += "FirstNameFilter=" + encodeURIComponent("" + firstNameFilter) + "&"; 
        if (maxIssueDateFilter === null)
            throw new Error("The parameter 'maxIssueDateFilter' cannot be null.");
        else if (maxIssueDateFilter !== undefined)
            url_ += "MaxIssueDateFilter=" + encodeURIComponent(maxIssueDateFilter ? "" + maxIssueDateFilter.toJSON() : "") + "&"; 
        if (minIssueDateFilter === null)
            throw new Error("The parameter 'minIssueDateFilter' cannot be null.");
        else if (minIssueDateFilter !== undefined)
            url_ += "MinIssueDateFilter=" + encodeURIComponent(minIssueDateFilter ? "" + minIssueDateFilter.toJSON() : "") + "&"; 
        if (billCreatorUserFilter === null)
            throw new Error("The parameter 'billCreatorUserFilter' cannot be null.");
        else if (billCreatorUserFilter !== undefined)
            url_ += "BillCreatorUserFilter=" + encodeURIComponent("" + billCreatorUserFilter) + "&"; 
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (billCodeFilter === null)
            throw new Error("The parameter 'billCodeFilter' cannot be null.");
        else if (billCodeFilter !== undefined)
            url_ += "BillCodeFilter=" + encodeURIComponent("" + billCodeFilter) + "&"; 
        if (maxPriceFilter === null)
            throw new Error("The parameter 'maxPriceFilter' cannot be null.");
        else if (maxPriceFilter !== undefined)
            url_ += "MaxPriceFilter=" + encodeURIComponent("" + maxPriceFilter) + "&"; 
        if (minPriceFilter === null)
            throw new Error("The parameter 'minPriceFilter' cannot be null.");
        else if (minPriceFilter !== undefined)
            url_ += "MinPriceFilter=" + encodeURIComponent("" + minPriceFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (extraEntityFilter === null)
            throw new Error("The parameter 'extraEntityFilter' cannot be null.");
        else if (extraEntityFilter !== undefined)
            url_ += "ExtraEntityFilter=" + encodeURIComponent("" + extraEntityFilter) + "&"; 
        if (planConstTitleFilter === null)
            throw new Error("The parameter 'planConstTitleFilter' cannot be null.");
        else if (planConstTitleFilter !== undefined)
            url_ += "PlanConstTitleFilter=" + encodeURIComponent("" + planConstTitleFilter) + "&"; 
        if (planBillCodeFilter === null)
            throw new Error("The parameter 'planBillCodeFilter' cannot be null.");
        else if (planBillCodeFilter !== undefined)
            url_ += "PlanBillCodeFilter=" + encodeURIComponent("" + planBillCodeFilter) + "&"; 
        if (benefactorNameFilter === null)
            throw new Error("The parameter 'benefactorNameFilter' cannot be null.");
        else if (benefactorNameFilter !== undefined)
            url_ += "BenefactorNameFilter=" + encodeURIComponent("" + benefactorNameFilter) + "&"; 
        if (approveFullNameFilter === null)
            throw new Error("The parameter 'approveFullNameFilter' cannot be null.");
        else if (approveFullNameFilter !== undefined)
            url_ += "ApproveFullNameFilter=" + encodeURIComponent("" + approveFullNameFilter) + "&"; 
        if (maxLatFilter === null)
            throw new Error("The parameter 'maxLatFilter' cannot be null.");
        else if (maxLatFilter !== undefined)
            url_ += "MaxLatFilter=" + encodeURIComponent("" + maxLatFilter) + "&"; 
        if (minLatFilter === null)
            throw new Error("The parameter 'minLatFilter' cannot be null.");
        else if (minLatFilter !== undefined)
            url_ += "MinLatFilter=" + encodeURIComponent("" + minLatFilter) + "&"; 
        if (maxLongFilter === null)
            throw new Error("The parameter 'maxLongFilter' cannot be null.");
        else if (maxLongFilter !== undefined)
            url_ += "MaxLongFilter=" + encodeURIComponent("" + maxLongFilter) + "&"; 
        if (minLongFilter === null)
            throw new Error("The parameter 'minLongFilter' cannot be null.");
        else if (minLongFilter !== undefined)
            url_ += "MinLongFilter=" + encodeURIComponent("" + minLongFilter) + "&"; 
        if (maxDueDateFilter === null)
            throw new Error("The parameter 'maxDueDateFilter' cannot be null.");
        else if (maxDueDateFilter !== undefined)
            url_ += "MaxDueDateFilter=" + encodeURIComponent(maxDueDateFilter ? "" + maxDueDateFilter.toJSON() : "") + "&"; 
        if (minDueDateFilter === null)
            throw new Error("The parameter 'minDueDateFilter' cannot be null.");
        else if (minDueDateFilter !== undefined)
            url_ += "MinDueDateFilter=" + encodeURIComponent(minDueDateFilter ? "" + minDueDateFilter.toJSON() : "") + "&"; 
        if (maxExtraEntityRefFilter === null)
            throw new Error("The parameter 'maxExtraEntityRefFilter' cannot be null.");
        else if (maxExtraEntityRefFilter !== undefined)
            url_ += "MaxExtraEntityRefFilter=" + encodeURIComponent("" + maxExtraEntityRefFilter) + "&"; 
        if (minExtraEntityRefFilter === null)
            throw new Error("The parameter 'minExtraEntityRefFilter' cannot be null.");
        else if (minExtraEntityRefFilter !== undefined)
            url_ += "MinExtraEntityRefFilter=" + encodeURIComponent("" + minExtraEntityRefFilter) + "&"; 
        if (deliveryTypeFilter === null)
            throw new Error("The parameter 'deliveryTypeFilter' cannot be null.");
        else if (deliveryTypeFilter !== undefined)
            url_ += "DeliveryTypeFilter=" + encodeURIComponent("" + deliveryTypeFilter) + "&"; 
        if (maxContactIdFilter === null)
            throw new Error("The parameter 'maxContactIdFilter' cannot be null.");
        else if (maxContactIdFilter !== undefined)
            url_ += "MaxContactIdFilter=" + encodeURIComponent("" + maxContactIdFilter) + "&"; 
        if (minContactIdFilter === null)
            throw new Error("The parameter 'minContactIdFilter' cannot be null.");
        else if (minContactIdFilter !== undefined)
            url_ += "MinContactIdFilter=" + encodeURIComponent("" + minContactIdFilter) + "&"; 
        if (descriptionOneFilter === null)
            throw new Error("The parameter 'descriptionOneFilter' cannot be null.");
        else if (descriptionOneFilter !== undefined)
            url_ += "DescriptionOneFilter=" + encodeURIComponent("" + descriptionOneFilter) + "&"; 
        if (descriptionTwoFilter === null)
            throw new Error("The parameter 'descriptionTwoFilter' cannot be null.");
        else if (descriptionTwoFilter !== undefined)
            url_ += "DescriptionTwoFilter=" + encodeURIComponent("" + descriptionTwoFilter) + "&"; 
        if (announceTheDifferenceFilter === null)
            throw new Error("The parameter 'announceTheDifferenceFilter' cannot be null.");
        else if (announceTheDifferenceFilter !== undefined)
            url_ += "AnnounceTheDifferenceFilter=" + encodeURIComponent("" + announceTheDifferenceFilter) + "&"; 
        if (maxCardTemplateRefFilter === null)
            throw new Error("The parameter 'maxCardTemplateRefFilter' cannot be null.");
        else if (maxCardTemplateRefFilter !== undefined)
            url_ += "MaxCardTemplateRefFilter=" + encodeURIComponent("" + maxCardTemplateRefFilter) + "&"; 
        if (minCardTemplateRefFilter === null)
            throw new Error("The parameter 'minCardTemplateRefFilter' cannot be null.");
        else if (minCardTemplateRefFilter !== undefined)
            url_ += "MinCardTemplateRefFilter=" + encodeURIComponent("" + minCardTemplateRefFilter) + "&"; 
        if (ceremonyTitleFilter === null)
            throw new Error("The parameter 'ceremonyTitleFilter' cannot be null.");
        else if (ceremonyTitleFilter !== undefined)
            url_ += "CeremonyTitleFilter=" + encodeURIComponent("" + ceremonyTitleFilter) + "&"; 
        if (deceasedTitleFilter === null)
            throw new Error("The parameter 'deceasedTitleFilter' cannot be null.");
        else if (deceasedTitleFilter !== undefined)
            url_ += "DeceasedTitleFilter=" + encodeURIComponent("" + deceasedTitleFilter) + "&"; 
        if (currencyNameFilter === null)
            throw new Error("The parameter 'currencyNameFilter' cannot be null.");
        else if (currencyNameFilter !== undefined)
            url_ += "CurrencyNameFilter=" + encodeURIComponent("" + currencyNameFilter) + "&"; 
        if (cardTemplateTileFilter === null)
            throw new Error("The parameter 'cardTemplateTileFilter' cannot be null.");
        else if (cardTemplateTileFilter !== undefined)
            url_ += "CardTemplateTileFilter=" + encodeURIComponent("" + cardTemplateTileFilter) + "&"; 
        if (maxPlanBillIdFilter === null)
            throw new Error("The parameter 'maxPlanBillIdFilter' cannot be null.");
        else if (maxPlanBillIdFilter !== undefined)
            url_ += "MaxPlanBillIdFilter=" + encodeURIComponent("" + maxPlanBillIdFilter) + "&"; 
        if (minPlanBillIdFilter === null)
            throw new Error("The parameter 'minPlanBillIdFilter' cannot be null.");
        else if (minPlanBillIdFilter !== undefined)
            url_ += "MinPlanBillIdFilter=" + encodeURIComponent("" + minPlanBillIdFilter) + "&"; 
        if (maxPlanConstIdFilter === null)
            throw new Error("The parameter 'maxPlanConstIdFilter' cannot be null.");
        else if (maxPlanConstIdFilter !== undefined)
            url_ += "MaxPlanConstIdFilter=" + encodeURIComponent("" + maxPlanConstIdFilter) + "&"; 
        if (minPlanConstIdFilter === null)
            throw new Error("The parameter 'minPlanConstIdFilter' cannot be null.");
        else if (minPlanConstIdFilter !== undefined)
            url_ += "MinPlanConstIdFilter=" + encodeURIComponent("" + minPlanConstIdFilter) + "&"; 
        if (planTypeFilter === null)
            throw new Error("The parameter 'planTypeFilter' cannot be null.");
        else if (planTypeFilter !== undefined)
            url_ += "PlanTypeFilter=" + encodeURIComponent("" + planTypeFilter) + "&"; 
        if (lastNameFilter === null)
            throw new Error("The parameter 'lastNameFilter' cannot be null.");
        else if (lastNameFilter !== undefined)
            url_ += "LastNameFilter=" + encodeURIComponent("" + lastNameFilter) + "&"; 
        if (mobileNumber1Filter === null)
            throw new Error("The parameter 'mobileNumber1Filter' cannot be null.");
        else if (mobileNumber1Filter !== undefined)
            url_ += "MobileNumber1Filter=" + encodeURIComponent("" + mobileNumber1Filter) + "&"; 
        if (maxBillIdFilter === null)
            throw new Error("The parameter 'maxBillIdFilter' cannot be null.");
        else if (maxBillIdFilter !== undefined)
            url_ += "MaxBillIdFilter=" + encodeURIComponent("" + maxBillIdFilter) + "&"; 
        if (minBillIdFilter === null)
            throw new Error("The parameter 'minBillIdFilter' cannot be null.");
        else if (minBillIdFilter !== undefined)
            url_ += "MinBillIdFilter=" + encodeURIComponent("" + minBillIdFilter) + "&"; 
        if (planConstCodeFilter === null)
            throw new Error("The parameter 'planConstCodeFilter' cannot be null.");
        else if (planConstCodeFilter !== undefined)
            url_ += "PlanConstCodeFilter=" + encodeURIComponent("" + planConstCodeFilter) + "&"; 
        if (sourceAttributesFilter === null)
            throw new Error("The parameter 'sourceAttributesFilter' cannot be null.");
        else if (sourceAttributesFilter !== undefined)
            url_ += "SourceAttributesFilter=" + encodeURIComponent("" + sourceAttributesFilter) + "&"; 
        if (sourceAttributesValueFilter === null)
            throw new Error("The parameter 'sourceAttributesValueFilter' cannot be null.");
        else if (sourceAttributesValueFilter !== undefined)
            url_ += "SourceAttributesValueFilter=" + encodeURIComponent("" + sourceAttributesValueFilter) + "&"; 
        if (paymentCreatorUserFilter === null)
            throw new Error("The parameter 'paymentCreatorUserFilter' cannot be null.");
        else if (paymentCreatorUserFilter !== undefined)
            url_ += "PaymentCreatorUserFilter=" + encodeURIComponent("" + paymentCreatorUserFilter) + "&"; 
        if (maxPaymentCreatDateFilter === null)
            throw new Error("The parameter 'maxPaymentCreatDateFilter' cannot be null.");
        else if (maxPaymentCreatDateFilter !== undefined)
            url_ += "MaxPaymentCreatDateFilter=" + encodeURIComponent(maxPaymentCreatDateFilter ? "" + maxPaymentCreatDateFilter.toJSON() : "") + "&"; 
        if (minPaymentCreatDateFilter === null)
            throw new Error("The parameter 'minPaymentCreatDateFilter' cannot be null.");
        else if (minPaymentCreatDateFilter !== undefined)
            url_ += "MinPaymentCreatDateFilter=" + encodeURIComponent(minPaymentCreatDateFilter ? "" + minPaymentCreatDateFilter.toJSON() : "") + "&"; 
        if (maxPaymentApprovedDateFilter === null)
            throw new Error("The parameter 'maxPaymentApprovedDateFilter' cannot be null.");
        else if (maxPaymentApprovedDateFilter !== undefined)
            url_ += "MaxPaymentApprovedDateFilter=" + encodeURIComponent(maxPaymentApprovedDateFilter ? "" + maxPaymentApprovedDateFilter.toJSON() : "") + "&"; 
        if (minPaymentApprovedDateFilter === null)
            throw new Error("The parameter 'minPaymentApprovedDateFilter' cannot be null.");
        else if (minPaymentApprovedDateFilter !== undefined)
            url_ += "MinPaymentApprovedDateFilter=" + encodeURIComponent(minPaymentApprovedDateFilter ? "" + minPaymentApprovedDateFilter.toJSON() : "") + "&"; 
        if (paymentTypeFilter === null)
            throw new Error("The parameter 'paymentTypeFilter' cannot be null.");
        else if (paymentTypeFilter !== undefined)
            url_ += "PaymentTypeFilter=" + encodeURIComponent("" + paymentTypeFilter) + "&"; 
        if (bankSerialNOFilter === null)
            throw new Error("The parameter 'bankSerialNOFilter' cannot be null.");
        else if (bankSerialNOFilter !== undefined)
            url_ += "BankSerialNOFilter=" + encodeURIComponent("" + bankSerialNOFilter) + "&"; 
        if (branchCodeFilter === null)
            throw new Error("The parameter 'branchCodeFilter' cannot be null.");
        else if (branchCodeFilter !== undefined)
            url_ += "BranchCodeFilter=" + encodeURIComponent("" + branchCodeFilter) + "&"; 
        if (bankPaymentFilter === null)
            throw new Error("The parameter 'bankPaymentFilter' cannot be null.");
        else if (bankPaymentFilter !== undefined)
            url_ += "BankPaymentFilter=" + encodeURIComponent("" + bankPaymentFilter) + "&"; 
        if (maxPaymentAmountFilter === null)
            throw new Error("The parameter 'maxPaymentAmountFilter' cannot be null.");
        else if (maxPaymentAmountFilter !== undefined)
            url_ += "MaxPaymentAmountFilter=" + encodeURIComponent("" + maxPaymentAmountFilter) + "&"; 
        if (minPaymentAmountFilter === null)
            throw new Error("The parameter 'minPaymentAmountFilter' cannot be null.");
        else if (minPaymentAmountFilter !== undefined)
            url_ += "MinPaymentAmountFilter=" + encodeURIComponent("" + minPaymentAmountFilter) + "&"; 
        if (paymentBankTrackingNOFilter === null)
            throw new Error("The parameter 'paymentBankTrackingNOFilter' cannot be null.");
        else if (paymentBankTrackingNOFilter !== undefined)
            url_ += "PaymentBankTrackingNOFilter=" + encodeURIComponent("" + paymentBankTrackingNOFilter) + "&"; 
        if (paymentAccountingTrackingNOFilter === null)
            throw new Error("The parameter 'paymentAccountingTrackingNOFilter' cannot be null.");
        else if (paymentAccountingTrackingNOFilter !== undefined)
            url_ += "PaymentAccountingTrackingNOFilter=" + encodeURIComponent("" + paymentAccountingTrackingNOFilter) + "&"; 
        if (panCardFilter === null)
            throw new Error("The parameter 'panCardFilter' cannot be null.");
        else if (panCardFilter !== undefined)
            url_ += "PanCardFilter=" + encodeURIComponent("" + panCardFilter) + "&"; 
        if (maxPaymentDateTimeFilter === null)
            throw new Error("The parameter 'maxPaymentDateTimeFilter' cannot be null.");
        else if (maxPaymentDateTimeFilter !== undefined)
            url_ += "MaxPaymentDateTimeFilter=" + encodeURIComponent(maxPaymentDateTimeFilter ? "" + maxPaymentDateTimeFilter.toJSON() : "") + "&"; 
        if (minPaymentDateTimeFilter === null)
            throw new Error("The parameter 'minPaymentDateTimeFilter' cannot be null.");
        else if (minPaymentDateTimeFilter !== undefined)
            url_ += "MinPaymentDateTimeFilter=" + encodeURIComponent(minPaymentDateTimeFilter ? "" + minPaymentDateTimeFilter.toJSON() : "") + "&"; 
        if (posSerialFilter === null)
            throw new Error("The parameter 'posSerialFilter' cannot be null.");
        else if (posSerialFilter !== undefined)
            url_ += "PosSerialFilter=" + encodeURIComponent("" + posSerialFilter) + "&"; 
        if (depositIdFilter === null)
            throw new Error("The parameter 'depositIdFilter' cannot be null.");
        else if (depositIdFilter !== undefined)
            url_ += "DepositIdFilter=" + encodeURIComponent("" + depositIdFilter) + "&"; 
        if (paymentDescriptionFilter === null)
            throw new Error("The parameter 'paymentDescriptionFilter' cannot be null.");
        else if (paymentDescriptionFilter !== undefined)
            url_ += "PaymentDescriptionFilter=" + encodeURIComponent("" + paymentDescriptionFilter) + "&"; 
        if (bankAccountNumberFilter === null)
            throw new Error("The parameter 'bankAccountNumberFilter' cannot be null.");
        else if (bankAccountNumberFilter !== undefined)
            url_ += "BankAccountNumberFilter=" + encodeURIComponent("" + bankAccountNumberFilter) + "&"; 
        if (maxPaymentIdFilter === null)
            throw new Error("The parameter 'maxPaymentIdFilter' cannot be null.");
        else if (maxPaymentIdFilter !== undefined)
            url_ += "MaxPaymentIdFilter=" + encodeURIComponent("" + maxPaymentIdFilter) + "&"; 
        if (minPaymentIdFilter === null)
            throw new Error("The parameter 'minPaymentIdFilter' cannot be null.");
        else if (minPaymentIdFilter !== undefined)
            url_ += "MinPaymentIdFilter=" + encodeURIComponent("" + minPaymentIdFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillReportsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillReportsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetBillReportsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class BillsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param maxIssueDateFilter (optional) 
     * @param minIssueDateFilter (optional) 
     * @param maxPriceFilter (optional) 
     * @param minPriceFilter (optional) 
     * @param benefactorNameFilter (optional) 
     * @param statusFilter (optional) 
     * @param contactFirstNameFilter (optional) 
     * @param billCreatorUserFilter (optional) 
     * @param currencyNameFilter (optional) 
     * @param planConstFilter (optional) 
     * @param extraEntityFilter (optional) 
     * @param extraEntityRefFilter (optional) 
     * @param postmanFilter (optional) 
     * @param directionFilter (optional) 
     * @param areaFilter (optional) 
     * @param survivorNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllFlowerAndSacreficeBills(filter: string | undefined, codeFilter: string | undefined, maxIssueDateFilter: moment.Moment | undefined, minIssueDateFilter: moment.Moment | undefined, maxPriceFilter: number | undefined, minPriceFilter: number | undefined, benefactorNameFilter: string | undefined, statusFilter: number | undefined, contactFirstNameFilter: string | undefined, billCreatorUserFilter: string | undefined, currencyNameFilter: string | undefined, planConstFilter: string | undefined, extraEntityFilter: string | undefined, extraEntityRefFilter: number | undefined, postmanFilter: string | undefined, directionFilter: string | undefined, areaFilter: string | undefined, survivorNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetBillForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetAllFlowerAndSacreficeBills?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (maxIssueDateFilter === null)
            throw new Error("The parameter 'maxIssueDateFilter' cannot be null.");
        else if (maxIssueDateFilter !== undefined)
            url_ += "MaxIssueDateFilter=" + encodeURIComponent(maxIssueDateFilter ? "" + maxIssueDateFilter.toJSON() : "") + "&"; 
        if (minIssueDateFilter === null)
            throw new Error("The parameter 'minIssueDateFilter' cannot be null.");
        else if (minIssueDateFilter !== undefined)
            url_ += "MinIssueDateFilter=" + encodeURIComponent(minIssueDateFilter ? "" + minIssueDateFilter.toJSON() : "") + "&"; 
        if (maxPriceFilter === null)
            throw new Error("The parameter 'maxPriceFilter' cannot be null.");
        else if (maxPriceFilter !== undefined)
            url_ += "MaxPriceFilter=" + encodeURIComponent("" + maxPriceFilter) + "&"; 
        if (minPriceFilter === null)
            throw new Error("The parameter 'minPriceFilter' cannot be null.");
        else if (minPriceFilter !== undefined)
            url_ += "MinPriceFilter=" + encodeURIComponent("" + minPriceFilter) + "&"; 
        if (benefactorNameFilter === null)
            throw new Error("The parameter 'benefactorNameFilter' cannot be null.");
        else if (benefactorNameFilter !== undefined)
            url_ += "BenefactorNameFilter=" + encodeURIComponent("" + benefactorNameFilter) + "&"; 
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (contactFirstNameFilter === null)
            throw new Error("The parameter 'contactFirstNameFilter' cannot be null.");
        else if (contactFirstNameFilter !== undefined)
            url_ += "ContactFirstNameFilter=" + encodeURIComponent("" + contactFirstNameFilter) + "&"; 
        if (billCreatorUserFilter === null)
            throw new Error("The parameter 'billCreatorUserFilter' cannot be null.");
        else if (billCreatorUserFilter !== undefined)
            url_ += "BillCreatorUserFilter=" + encodeURIComponent("" + billCreatorUserFilter) + "&"; 
        if (currencyNameFilter === null)
            throw new Error("The parameter 'currencyNameFilter' cannot be null.");
        else if (currencyNameFilter !== undefined)
            url_ += "CurrencyNameFilter=" + encodeURIComponent("" + currencyNameFilter) + "&"; 
        if (planConstFilter === null)
            throw new Error("The parameter 'planConstFilter' cannot be null.");
        else if (planConstFilter !== undefined)
            url_ += "PlanConstFilter=" + encodeURIComponent("" + planConstFilter) + "&"; 
        if (extraEntityFilter === null)
            throw new Error("The parameter 'extraEntityFilter' cannot be null.");
        else if (extraEntityFilter !== undefined)
            url_ += "ExtraEntityFilter=" + encodeURIComponent("" + extraEntityFilter) + "&"; 
        if (extraEntityRefFilter === null)
            throw new Error("The parameter 'extraEntityRefFilter' cannot be null.");
        else if (extraEntityRefFilter !== undefined)
            url_ += "ExtraEntityRefFilter=" + encodeURIComponent("" + extraEntityRefFilter) + "&"; 
        if (postmanFilter === null)
            throw new Error("The parameter 'postmanFilter' cannot be null.");
        else if (postmanFilter !== undefined)
            url_ += "PostmanFilter=" + encodeURIComponent("" + postmanFilter) + "&"; 
        if (directionFilter === null)
            throw new Error("The parameter 'directionFilter' cannot be null.");
        else if (directionFilter !== undefined)
            url_ += "DirectionFilter=" + encodeURIComponent("" + directionFilter) + "&"; 
        if (areaFilter === null)
            throw new Error("The parameter 'areaFilter' cannot be null.");
        else if (areaFilter !== undefined)
            url_ += "AreaFilter=" + encodeURIComponent("" + areaFilter) + "&"; 
        if (survivorNameFilter === null)
            throw new Error("The parameter 'survivorNameFilter' cannot be null.");
        else if (survivorNameFilter !== undefined)
            url_ += "SurvivorNameFilter=" + encodeURIComponent("" + survivorNameFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFlowerAndSacreficeBills(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFlowerAndSacreficeBills(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetBillForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetBillForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllFlowerAndSacreficeBills(response: HttpResponseBase): Observable<PagedResultDtoOfGetBillForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetBillForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBillForViewDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param maxIssueDateFilter (optional) 
     * @param minIssueDateFilter (optional) 
     * @param maxPriceFilter (optional) 
     * @param minPriceFilter (optional) 
     * @param benefactorNameFilter (optional) 
     * @param statusFilter (optional) 
     * @param contactFirstNameFilter (optional) 
     * @param billCreatorUserFilter (optional) 
     * @param currencyNameFilter (optional) 
     * @param planConstFilter (optional) 
     * @param extraEntityFilter (optional) 
     * @param extraEntityRefFilter (optional) 
     * @param postmanFilter (optional) 
     * @param directionFilter (optional) 
     * @param areaFilter (optional) 
     * @param survivorNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCharityBills(filter: string | undefined, codeFilter: string | undefined, maxIssueDateFilter: moment.Moment | undefined, minIssueDateFilter: moment.Moment | undefined, maxPriceFilter: number | undefined, minPriceFilter: number | undefined, benefactorNameFilter: string | undefined, statusFilter: number | undefined, contactFirstNameFilter: string | undefined, billCreatorUserFilter: string | undefined, currencyNameFilter: string | undefined, planConstFilter: string | undefined, extraEntityFilter: string | undefined, extraEntityRefFilter: number | undefined, postmanFilter: string | undefined, directionFilter: string | undefined, areaFilter: string | undefined, survivorNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetBillForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetAllCharityBills?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (maxIssueDateFilter === null)
            throw new Error("The parameter 'maxIssueDateFilter' cannot be null.");
        else if (maxIssueDateFilter !== undefined)
            url_ += "MaxIssueDateFilter=" + encodeURIComponent(maxIssueDateFilter ? "" + maxIssueDateFilter.toJSON() : "") + "&"; 
        if (minIssueDateFilter === null)
            throw new Error("The parameter 'minIssueDateFilter' cannot be null.");
        else if (minIssueDateFilter !== undefined)
            url_ += "MinIssueDateFilter=" + encodeURIComponent(minIssueDateFilter ? "" + minIssueDateFilter.toJSON() : "") + "&"; 
        if (maxPriceFilter === null)
            throw new Error("The parameter 'maxPriceFilter' cannot be null.");
        else if (maxPriceFilter !== undefined)
            url_ += "MaxPriceFilter=" + encodeURIComponent("" + maxPriceFilter) + "&"; 
        if (minPriceFilter === null)
            throw new Error("The parameter 'minPriceFilter' cannot be null.");
        else if (minPriceFilter !== undefined)
            url_ += "MinPriceFilter=" + encodeURIComponent("" + minPriceFilter) + "&"; 
        if (benefactorNameFilter === null)
            throw new Error("The parameter 'benefactorNameFilter' cannot be null.");
        else if (benefactorNameFilter !== undefined)
            url_ += "BenefactorNameFilter=" + encodeURIComponent("" + benefactorNameFilter) + "&"; 
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (contactFirstNameFilter === null)
            throw new Error("The parameter 'contactFirstNameFilter' cannot be null.");
        else if (contactFirstNameFilter !== undefined)
            url_ += "ContactFirstNameFilter=" + encodeURIComponent("" + contactFirstNameFilter) + "&"; 
        if (billCreatorUserFilter === null)
            throw new Error("The parameter 'billCreatorUserFilter' cannot be null.");
        else if (billCreatorUserFilter !== undefined)
            url_ += "BillCreatorUserFilter=" + encodeURIComponent("" + billCreatorUserFilter) + "&"; 
        if (currencyNameFilter === null)
            throw new Error("The parameter 'currencyNameFilter' cannot be null.");
        else if (currencyNameFilter !== undefined)
            url_ += "CurrencyNameFilter=" + encodeURIComponent("" + currencyNameFilter) + "&"; 
        if (planConstFilter === null)
            throw new Error("The parameter 'planConstFilter' cannot be null.");
        else if (planConstFilter !== undefined)
            url_ += "PlanConstFilter=" + encodeURIComponent("" + planConstFilter) + "&"; 
        if (extraEntityFilter === null)
            throw new Error("The parameter 'extraEntityFilter' cannot be null.");
        else if (extraEntityFilter !== undefined)
            url_ += "ExtraEntityFilter=" + encodeURIComponent("" + extraEntityFilter) + "&"; 
        if (extraEntityRefFilter === null)
            throw new Error("The parameter 'extraEntityRefFilter' cannot be null.");
        else if (extraEntityRefFilter !== undefined)
            url_ += "ExtraEntityRefFilter=" + encodeURIComponent("" + extraEntityRefFilter) + "&"; 
        if (postmanFilter === null)
            throw new Error("The parameter 'postmanFilter' cannot be null.");
        else if (postmanFilter !== undefined)
            url_ += "PostmanFilter=" + encodeURIComponent("" + postmanFilter) + "&"; 
        if (directionFilter === null)
            throw new Error("The parameter 'directionFilter' cannot be null.");
        else if (directionFilter !== undefined)
            url_ += "DirectionFilter=" + encodeURIComponent("" + directionFilter) + "&"; 
        if (areaFilter === null)
            throw new Error("The parameter 'areaFilter' cannot be null.");
        else if (areaFilter !== undefined)
            url_ += "AreaFilter=" + encodeURIComponent("" + areaFilter) + "&"; 
        if (survivorNameFilter === null)
            throw new Error("The parameter 'survivorNameFilter' cannot be null.");
        else if (survivorNameFilter !== undefined)
            url_ += "SurvivorNameFilter=" + encodeURIComponent("" + survivorNameFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCharityBills(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCharityBills(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetBillForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetBillForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCharityBills(response: HttpResponseBase): Observable<PagedResultDtoOfGetBillForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetBillForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBillForViewDto>(<any>null);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    deleteUnknownCharityBill(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bills/DeleteUnknownCharityBill?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUnknownCharityBill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUnknownCharityBill(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteUnknownCharityBill(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    updateCaches(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bills/UpdateCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCaches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCaches(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateCaches(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    checkUpdateCache(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bills/CheckUpdateCache";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckUpdateCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckUpdateCache(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCheckUpdateCache(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllBillCache(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetAllBillCache";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBillCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBillCache(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBillCache(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllCharityBillCache(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetAllCharityBillCache";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCharityBillCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCharityBillCache(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCharityBillCache(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    refreshBillCache(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bills/RefreshBillCache";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshBillCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshBillCache(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRefreshBillCache(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    refreshCharityBillCache(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bills/RefreshCharityBillCache";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshCharityBillCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshCharityBillCache(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRefreshCharityBillCache(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    refreshVwBillCache(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bills/RefreshVwBillCache";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshVwBillCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshVwBillCache(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRefreshVwBillCache(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    refreshNotApprovedCache(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bills/RefreshNotApprovedCache";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshNotApprovedCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshNotApprovedCache(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRefreshNotApprovedCache(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    refreshVirtualCreditCache(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bills/RefreshVirtualCreditCache";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshVirtualCreditCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshVirtualCreditCache(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRefreshVirtualCreditCache(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    refreshDirectionCache(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bills/RefreshDirectionCache";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshDirectionCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshDirectionCache(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRefreshDirectionCache(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    refreshContactCache(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bills/RefreshContactCache";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshContactCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshContactCache(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRefreshContactCache(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param maxIssueDateFilter (optional) 
     * @param minIssueDateFilter (optional) 
     * @param maxPaymentDateFilter (optional) 
     * @param minPaymentDateFilter (optional) 
     * @param maxPriceFilter (optional) 
     * @param minPriceFilter (optional) 
     * @param statusFilter (optional) 
     * @param contactFirstNameFilter (optional) 
     * @param billCreatorUserFilter (optional) 
     * @param benefactorNameFilter (optional) 
     * @param planConstFilter (optional) 
     * @param extraEntityFilter (optional) 
     * @param extraEntityRefFilter (optional) 
     * @param isPaid (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllEkram(filter: string | undefined, codeFilter: string | undefined, maxIssueDateFilter: moment.Moment | undefined, minIssueDateFilter: moment.Moment | undefined, maxPaymentDateFilter: moment.Moment | undefined, minPaymentDateFilter: moment.Moment | undefined, maxPriceFilter: number | undefined, minPriceFilter: number | undefined, statusFilter: number | undefined, contactFirstNameFilter: string | undefined, billCreatorUserFilter: string | undefined, benefactorNameFilter: string | undefined, planConstFilter: string[] | undefined, extraEntityFilter: string | undefined, extraEntityRefFilter: number | undefined, isPaid: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetEkramBillForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetAllEkram?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (maxIssueDateFilter === null)
            throw new Error("The parameter 'maxIssueDateFilter' cannot be null.");
        else if (maxIssueDateFilter !== undefined)
            url_ += "MaxIssueDateFilter=" + encodeURIComponent(maxIssueDateFilter ? "" + maxIssueDateFilter.toJSON() : "") + "&"; 
        if (minIssueDateFilter === null)
            throw new Error("The parameter 'minIssueDateFilter' cannot be null.");
        else if (minIssueDateFilter !== undefined)
            url_ += "MinIssueDateFilter=" + encodeURIComponent(minIssueDateFilter ? "" + minIssueDateFilter.toJSON() : "") + "&"; 
        if (maxPaymentDateFilter === null)
            throw new Error("The parameter 'maxPaymentDateFilter' cannot be null.");
        else if (maxPaymentDateFilter !== undefined)
            url_ += "MaxPaymentDateFilter=" + encodeURIComponent(maxPaymentDateFilter ? "" + maxPaymentDateFilter.toJSON() : "") + "&"; 
        if (minPaymentDateFilter === null)
            throw new Error("The parameter 'minPaymentDateFilter' cannot be null.");
        else if (minPaymentDateFilter !== undefined)
            url_ += "MinPaymentDateFilter=" + encodeURIComponent(minPaymentDateFilter ? "" + minPaymentDateFilter.toJSON() : "") + "&"; 
        if (maxPriceFilter === null)
            throw new Error("The parameter 'maxPriceFilter' cannot be null.");
        else if (maxPriceFilter !== undefined)
            url_ += "MaxPriceFilter=" + encodeURIComponent("" + maxPriceFilter) + "&"; 
        if (minPriceFilter === null)
            throw new Error("The parameter 'minPriceFilter' cannot be null.");
        else if (minPriceFilter !== undefined)
            url_ += "MinPriceFilter=" + encodeURIComponent("" + minPriceFilter) + "&"; 
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (contactFirstNameFilter === null)
            throw new Error("The parameter 'contactFirstNameFilter' cannot be null.");
        else if (contactFirstNameFilter !== undefined)
            url_ += "ContactFirstNameFilter=" + encodeURIComponent("" + contactFirstNameFilter) + "&"; 
        if (billCreatorUserFilter === null)
            throw new Error("The parameter 'billCreatorUserFilter' cannot be null.");
        else if (billCreatorUserFilter !== undefined)
            url_ += "BillCreatorUserFilter=" + encodeURIComponent("" + billCreatorUserFilter) + "&"; 
        if (benefactorNameFilter === null)
            throw new Error("The parameter 'benefactorNameFilter' cannot be null.");
        else if (benefactorNameFilter !== undefined)
            url_ += "BenefactorNameFilter=" + encodeURIComponent("" + benefactorNameFilter) + "&"; 
        if (planConstFilter === null)
            throw new Error("The parameter 'planConstFilter' cannot be null.");
        else if (planConstFilter !== undefined)
            planConstFilter && planConstFilter.forEach(item => { url_ += "PlanConstFilter=" + encodeURIComponent("" + item) + "&"; });
        if (extraEntityFilter === null)
            throw new Error("The parameter 'extraEntityFilter' cannot be null.");
        else if (extraEntityFilter !== undefined)
            url_ += "ExtraEntityFilter=" + encodeURIComponent("" + extraEntityFilter) + "&"; 
        if (extraEntityRefFilter === null)
            throw new Error("The parameter 'extraEntityRefFilter' cannot be null.");
        else if (extraEntityRefFilter !== undefined)
            url_ += "ExtraEntityRefFilter=" + encodeURIComponent("" + extraEntityRefFilter) + "&"; 
        if (isPaid === null)
            throw new Error("The parameter 'isPaid' cannot be null.");
        else if (isPaid !== undefined)
            url_ += "IsPaid=" + encodeURIComponent("" + isPaid) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEkram(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEkram(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetEkramBillForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetEkramBillForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllEkram(response: HttpResponseBase): Observable<PagedResultDtoOfGetEkramBillForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetEkramBillForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetEkramBillForViewDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param maxIssueDateFilter (optional) 
     * @param minIssueDateFilter (optional) 
     * @param maxPaymentDateFilter (optional) 
     * @param minPaymentDateFilter (optional) 
     * @param maxPriceFilter (optional) 
     * @param minPriceFilter (optional) 
     * @param statusFilter (optional) 
     * @param contactFirstNameFilter (optional) 
     * @param billCreatorUserFilter (optional) 
     * @param benefactorNameFilter (optional) 
     * @param planConstFilter (optional) 
     * @param extraEntityFilter (optional) 
     * @param extraEntityRefFilter (optional) 
     * @param isPaid (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllEkramToExel(filter: string | undefined, codeFilter: string | undefined, maxIssueDateFilter: moment.Moment | undefined, minIssueDateFilter: moment.Moment | undefined, maxPaymentDateFilter: moment.Moment | undefined, minPaymentDateFilter: moment.Moment | undefined, maxPriceFilter: number | undefined, minPriceFilter: number | undefined, statusFilter: number | undefined, contactFirstNameFilter: string | undefined, billCreatorUserFilter: string | undefined, benefactorNameFilter: string | undefined, planConstFilter: string[] | undefined, extraEntityFilter: string | undefined, extraEntityRefFilter: number | undefined, isPaid: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetAllEkramToExel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (maxIssueDateFilter === null)
            throw new Error("The parameter 'maxIssueDateFilter' cannot be null.");
        else if (maxIssueDateFilter !== undefined)
            url_ += "MaxIssueDateFilter=" + encodeURIComponent(maxIssueDateFilter ? "" + maxIssueDateFilter.toJSON() : "") + "&"; 
        if (minIssueDateFilter === null)
            throw new Error("The parameter 'minIssueDateFilter' cannot be null.");
        else if (minIssueDateFilter !== undefined)
            url_ += "MinIssueDateFilter=" + encodeURIComponent(minIssueDateFilter ? "" + minIssueDateFilter.toJSON() : "") + "&"; 
        if (maxPaymentDateFilter === null)
            throw new Error("The parameter 'maxPaymentDateFilter' cannot be null.");
        else if (maxPaymentDateFilter !== undefined)
            url_ += "MaxPaymentDateFilter=" + encodeURIComponent(maxPaymentDateFilter ? "" + maxPaymentDateFilter.toJSON() : "") + "&"; 
        if (minPaymentDateFilter === null)
            throw new Error("The parameter 'minPaymentDateFilter' cannot be null.");
        else if (minPaymentDateFilter !== undefined)
            url_ += "MinPaymentDateFilter=" + encodeURIComponent(minPaymentDateFilter ? "" + minPaymentDateFilter.toJSON() : "") + "&"; 
        if (maxPriceFilter === null)
            throw new Error("The parameter 'maxPriceFilter' cannot be null.");
        else if (maxPriceFilter !== undefined)
            url_ += "MaxPriceFilter=" + encodeURIComponent("" + maxPriceFilter) + "&"; 
        if (minPriceFilter === null)
            throw new Error("The parameter 'minPriceFilter' cannot be null.");
        else if (minPriceFilter !== undefined)
            url_ += "MinPriceFilter=" + encodeURIComponent("" + minPriceFilter) + "&"; 
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (contactFirstNameFilter === null)
            throw new Error("The parameter 'contactFirstNameFilter' cannot be null.");
        else if (contactFirstNameFilter !== undefined)
            url_ += "ContactFirstNameFilter=" + encodeURIComponent("" + contactFirstNameFilter) + "&"; 
        if (billCreatorUserFilter === null)
            throw new Error("The parameter 'billCreatorUserFilter' cannot be null.");
        else if (billCreatorUserFilter !== undefined)
            url_ += "BillCreatorUserFilter=" + encodeURIComponent("" + billCreatorUserFilter) + "&"; 
        if (benefactorNameFilter === null)
            throw new Error("The parameter 'benefactorNameFilter' cannot be null.");
        else if (benefactorNameFilter !== undefined)
            url_ += "BenefactorNameFilter=" + encodeURIComponent("" + benefactorNameFilter) + "&"; 
        if (planConstFilter === null)
            throw new Error("The parameter 'planConstFilter' cannot be null.");
        else if (planConstFilter !== undefined)
            planConstFilter && planConstFilter.forEach(item => { url_ += "PlanConstFilter=" + encodeURIComponent("" + item) + "&"; });
        if (extraEntityFilter === null)
            throw new Error("The parameter 'extraEntityFilter' cannot be null.");
        else if (extraEntityFilter !== undefined)
            url_ += "ExtraEntityFilter=" + encodeURIComponent("" + extraEntityFilter) + "&"; 
        if (extraEntityRefFilter === null)
            throw new Error("The parameter 'extraEntityRefFilter' cannot be null.");
        else if (extraEntityRefFilter !== undefined)
            url_ += "ExtraEntityRefFilter=" + encodeURIComponent("" + extraEntityRefFilter) + "&"; 
        if (isPaid === null)
            throw new Error("The parameter 'isPaid' cannot be null.");
        else if (isPaid !== undefined)
            url_ += "IsPaid=" + encodeURIComponent("" + isPaid) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEkramToExel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEkramToExel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllEkramToExel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param billId (optional) 
     * @param cardTemplateId (optional) 
     * @return Success
     */
    getFlowerCardTemplatesForBill(billId: number | undefined, cardTemplateId: number | undefined): Observable<BillCardTemplateValueDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetFlowerCardTemplatesForBill?";
        if (billId === null)
            throw new Error("The parameter 'billId' cannot be null.");
        else if (billId !== undefined)
            url_ += "billId=" + encodeURIComponent("" + billId) + "&"; 
        if (cardTemplateId === null)
            throw new Error("The parameter 'cardTemplateId' cannot be null.");
        else if (cardTemplateId !== undefined)
            url_ += "cardTemplateId=" + encodeURIComponent("" + cardTemplateId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFlowerCardTemplatesForBill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFlowerCardTemplatesForBill(<any>response_);
                } catch (e) {
                    return <Observable<BillCardTemplateValueDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<BillCardTemplateValueDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetFlowerCardTemplatesForBill(response: HttpResponseBase): Observable<BillCardTemplateValueDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BillCardTemplateValueDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillCardTemplateValueDto[]>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param maxIssueDateFilter (optional) 
     * @param minIssueDateFilter (optional) 
     * @param maxPriceFilter (optional) 
     * @param minPriceFilter (optional) 
     * @param benefactorNameFilter (optional) 
     * @param statusFilter (optional) 
     * @param contactFirstNameFilter (optional) 
     * @param billCreatorUserFilter (optional) 
     * @param currencyNameFilter (optional) 
     * @param planConstFilter (optional) 
     * @param extraEntityFilter (optional) 
     * @param extraEntityRefFilter (optional) 
     * @param postmanFilter (optional) 
     * @param directionFilter (optional) 
     * @param areaFilter (optional) 
     * @param survivorNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllForReport(filter: string | undefined, codeFilter: string | undefined, maxIssueDateFilter: moment.Moment | undefined, minIssueDateFilter: moment.Moment | undefined, maxPriceFilter: number | undefined, minPriceFilter: number | undefined, benefactorNameFilter: string | undefined, statusFilter: number | undefined, contactFirstNameFilter: string | undefined, billCreatorUserFilter: string | undefined, currencyNameFilter: string | undefined, planConstFilter: string | undefined, extraEntityFilter: string | undefined, extraEntityRefFilter: number | undefined, postmanFilter: string | undefined, directionFilter: string | undefined, areaFilter: string | undefined, survivorNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetBillForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetAllForReport?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (maxIssueDateFilter === null)
            throw new Error("The parameter 'maxIssueDateFilter' cannot be null.");
        else if (maxIssueDateFilter !== undefined)
            url_ += "MaxIssueDateFilter=" + encodeURIComponent(maxIssueDateFilter ? "" + maxIssueDateFilter.toJSON() : "") + "&"; 
        if (minIssueDateFilter === null)
            throw new Error("The parameter 'minIssueDateFilter' cannot be null.");
        else if (minIssueDateFilter !== undefined)
            url_ += "MinIssueDateFilter=" + encodeURIComponent(minIssueDateFilter ? "" + minIssueDateFilter.toJSON() : "") + "&"; 
        if (maxPriceFilter === null)
            throw new Error("The parameter 'maxPriceFilter' cannot be null.");
        else if (maxPriceFilter !== undefined)
            url_ += "MaxPriceFilter=" + encodeURIComponent("" + maxPriceFilter) + "&"; 
        if (minPriceFilter === null)
            throw new Error("The parameter 'minPriceFilter' cannot be null.");
        else if (minPriceFilter !== undefined)
            url_ += "MinPriceFilter=" + encodeURIComponent("" + minPriceFilter) + "&"; 
        if (benefactorNameFilter === null)
            throw new Error("The parameter 'benefactorNameFilter' cannot be null.");
        else if (benefactorNameFilter !== undefined)
            url_ += "BenefactorNameFilter=" + encodeURIComponent("" + benefactorNameFilter) + "&"; 
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (contactFirstNameFilter === null)
            throw new Error("The parameter 'contactFirstNameFilter' cannot be null.");
        else if (contactFirstNameFilter !== undefined)
            url_ += "ContactFirstNameFilter=" + encodeURIComponent("" + contactFirstNameFilter) + "&"; 
        if (billCreatorUserFilter === null)
            throw new Error("The parameter 'billCreatorUserFilter' cannot be null.");
        else if (billCreatorUserFilter !== undefined)
            url_ += "BillCreatorUserFilter=" + encodeURIComponent("" + billCreatorUserFilter) + "&"; 
        if (currencyNameFilter === null)
            throw new Error("The parameter 'currencyNameFilter' cannot be null.");
        else if (currencyNameFilter !== undefined)
            url_ += "CurrencyNameFilter=" + encodeURIComponent("" + currencyNameFilter) + "&"; 
        if (planConstFilter === null)
            throw new Error("The parameter 'planConstFilter' cannot be null.");
        else if (planConstFilter !== undefined)
            url_ += "PlanConstFilter=" + encodeURIComponent("" + planConstFilter) + "&"; 
        if (extraEntityFilter === null)
            throw new Error("The parameter 'extraEntityFilter' cannot be null.");
        else if (extraEntityFilter !== undefined)
            url_ += "ExtraEntityFilter=" + encodeURIComponent("" + extraEntityFilter) + "&"; 
        if (extraEntityRefFilter === null)
            throw new Error("The parameter 'extraEntityRefFilter' cannot be null.");
        else if (extraEntityRefFilter !== undefined)
            url_ += "ExtraEntityRefFilter=" + encodeURIComponent("" + extraEntityRefFilter) + "&"; 
        if (postmanFilter === null)
            throw new Error("The parameter 'postmanFilter' cannot be null.");
        else if (postmanFilter !== undefined)
            url_ += "PostmanFilter=" + encodeURIComponent("" + postmanFilter) + "&"; 
        if (directionFilter === null)
            throw new Error("The parameter 'directionFilter' cannot be null.");
        else if (directionFilter !== undefined)
            url_ += "DirectionFilter=" + encodeURIComponent("" + directionFilter) + "&"; 
        if (areaFilter === null)
            throw new Error("The parameter 'areaFilter' cannot be null.");
        else if (areaFilter !== undefined)
            url_ += "AreaFilter=" + encodeURIComponent("" + areaFilter) + "&"; 
        if (survivorNameFilter === null)
            throw new Error("The parameter 'survivorNameFilter' cannot be null.");
        else if (survivorNameFilter !== undefined)
            url_ += "SurvivorNameFilter=" + encodeURIComponent("" + survivorNameFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForReport(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetBillForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetBillForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllForReport(response: HttpResponseBase): Observable<PagedResultDtoOfGetBillForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetBillForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBillForViewDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param maxIssueDateFilter (optional) 
     * @param minIssueDateFilter (optional) 
     * @param maxPriceFilter (optional) 
     * @param minPriceFilter (optional) 
     * @param benefactorNameFilter (optional) 
     * @param statusFilter (optional) 
     * @param contactFirstNameFilter (optional) 
     * @param billCreatorUserFilter (optional) 
     * @param currencyNameFilter (optional) 
     * @param planConstFilter (optional) 
     * @param extraEntityFilter (optional) 
     * @param extraEntityRefFilter (optional) 
     * @param postmanFilter (optional) 
     * @param directionFilter (optional) 
     * @param areaFilter (optional) 
     * @param survivorNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllForCeremony(filter: string | undefined, codeFilter: string | undefined, maxIssueDateFilter: moment.Moment | undefined, minIssueDateFilter: moment.Moment | undefined, maxPriceFilter: number | undefined, minPriceFilter: number | undefined, benefactorNameFilter: string | undefined, statusFilter: number | undefined, contactFirstNameFilter: string | undefined, billCreatorUserFilter: string | undefined, currencyNameFilter: string | undefined, planConstFilter: string | undefined, extraEntityFilter: string | undefined, extraEntityRefFilter: number | undefined, postmanFilter: string | undefined, directionFilter: string | undefined, areaFilter: string | undefined, survivorNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetBillForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetAllForCeremony?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (maxIssueDateFilter === null)
            throw new Error("The parameter 'maxIssueDateFilter' cannot be null.");
        else if (maxIssueDateFilter !== undefined)
            url_ += "MaxIssueDateFilter=" + encodeURIComponent(maxIssueDateFilter ? "" + maxIssueDateFilter.toJSON() : "") + "&"; 
        if (minIssueDateFilter === null)
            throw new Error("The parameter 'minIssueDateFilter' cannot be null.");
        else if (minIssueDateFilter !== undefined)
            url_ += "MinIssueDateFilter=" + encodeURIComponent(minIssueDateFilter ? "" + minIssueDateFilter.toJSON() : "") + "&"; 
        if (maxPriceFilter === null)
            throw new Error("The parameter 'maxPriceFilter' cannot be null.");
        else if (maxPriceFilter !== undefined)
            url_ += "MaxPriceFilter=" + encodeURIComponent("" + maxPriceFilter) + "&"; 
        if (minPriceFilter === null)
            throw new Error("The parameter 'minPriceFilter' cannot be null.");
        else if (minPriceFilter !== undefined)
            url_ += "MinPriceFilter=" + encodeURIComponent("" + minPriceFilter) + "&"; 
        if (benefactorNameFilter === null)
            throw new Error("The parameter 'benefactorNameFilter' cannot be null.");
        else if (benefactorNameFilter !== undefined)
            url_ += "BenefactorNameFilter=" + encodeURIComponent("" + benefactorNameFilter) + "&"; 
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (contactFirstNameFilter === null)
            throw new Error("The parameter 'contactFirstNameFilter' cannot be null.");
        else if (contactFirstNameFilter !== undefined)
            url_ += "ContactFirstNameFilter=" + encodeURIComponent("" + contactFirstNameFilter) + "&"; 
        if (billCreatorUserFilter === null)
            throw new Error("The parameter 'billCreatorUserFilter' cannot be null.");
        else if (billCreatorUserFilter !== undefined)
            url_ += "BillCreatorUserFilter=" + encodeURIComponent("" + billCreatorUserFilter) + "&"; 
        if (currencyNameFilter === null)
            throw new Error("The parameter 'currencyNameFilter' cannot be null.");
        else if (currencyNameFilter !== undefined)
            url_ += "CurrencyNameFilter=" + encodeURIComponent("" + currencyNameFilter) + "&"; 
        if (planConstFilter === null)
            throw new Error("The parameter 'planConstFilter' cannot be null.");
        else if (planConstFilter !== undefined)
            url_ += "PlanConstFilter=" + encodeURIComponent("" + planConstFilter) + "&"; 
        if (extraEntityFilter === null)
            throw new Error("The parameter 'extraEntityFilter' cannot be null.");
        else if (extraEntityFilter !== undefined)
            url_ += "ExtraEntityFilter=" + encodeURIComponent("" + extraEntityFilter) + "&"; 
        if (extraEntityRefFilter === null)
            throw new Error("The parameter 'extraEntityRefFilter' cannot be null.");
        else if (extraEntityRefFilter !== undefined)
            url_ += "ExtraEntityRefFilter=" + encodeURIComponent("" + extraEntityRefFilter) + "&"; 
        if (postmanFilter === null)
            throw new Error("The parameter 'postmanFilter' cannot be null.");
        else if (postmanFilter !== undefined)
            url_ += "PostmanFilter=" + encodeURIComponent("" + postmanFilter) + "&"; 
        if (directionFilter === null)
            throw new Error("The parameter 'directionFilter' cannot be null.");
        else if (directionFilter !== undefined)
            url_ += "DirectionFilter=" + encodeURIComponent("" + directionFilter) + "&"; 
        if (areaFilter === null)
            throw new Error("The parameter 'areaFilter' cannot be null.");
        else if (areaFilter !== undefined)
            url_ += "AreaFilter=" + encodeURIComponent("" + areaFilter) + "&"; 
        if (survivorNameFilter === null)
            throw new Error("The parameter 'survivorNameFilter' cannot be null.");
        else if (survivorNameFilter !== undefined)
            url_ += "SurvivorNameFilter=" + encodeURIComponent("" + survivorNameFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForCeremony(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForCeremony(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetBillForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetBillForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllForCeremony(response: HttpResponseBase): Observable<PagedResultDtoOfGetBillForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetBillForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBillForViewDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param maxIssueDateFilter (optional) 
     * @param minIssueDateFilter (optional) 
     * @param maxPriceFilter (optional) 
     * @param minPriceFilter (optional) 
     * @param benefactorNameFilter (optional) 
     * @param statusFilter (optional) 
     * @param contactFirstNameFilter (optional) 
     * @param billCreatorUserFilter (optional) 
     * @param currencyNameFilter (optional) 
     * @param planConstFilter (optional) 
     * @param extraEntityFilter (optional) 
     * @param extraEntityRefFilter (optional) 
     * @param postmanFilter (optional) 
     * @param directionFilter (optional) 
     * @param areaFilter (optional) 
     * @param survivorNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllForDeceased(filter: string | undefined, codeFilter: string | undefined, maxIssueDateFilter: moment.Moment | undefined, minIssueDateFilter: moment.Moment | undefined, maxPriceFilter: number | undefined, minPriceFilter: number | undefined, benefactorNameFilter: string | undefined, statusFilter: number | undefined, contactFirstNameFilter: string | undefined, billCreatorUserFilter: string | undefined, currencyNameFilter: string | undefined, planConstFilter: string | undefined, extraEntityFilter: string | undefined, extraEntityRefFilter: number | undefined, postmanFilter: string | undefined, directionFilter: string | undefined, areaFilter: string | undefined, survivorNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetBillForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetAllForDeceased?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (maxIssueDateFilter === null)
            throw new Error("The parameter 'maxIssueDateFilter' cannot be null.");
        else if (maxIssueDateFilter !== undefined)
            url_ += "MaxIssueDateFilter=" + encodeURIComponent(maxIssueDateFilter ? "" + maxIssueDateFilter.toJSON() : "") + "&"; 
        if (minIssueDateFilter === null)
            throw new Error("The parameter 'minIssueDateFilter' cannot be null.");
        else if (minIssueDateFilter !== undefined)
            url_ += "MinIssueDateFilter=" + encodeURIComponent(minIssueDateFilter ? "" + minIssueDateFilter.toJSON() : "") + "&"; 
        if (maxPriceFilter === null)
            throw new Error("The parameter 'maxPriceFilter' cannot be null.");
        else if (maxPriceFilter !== undefined)
            url_ += "MaxPriceFilter=" + encodeURIComponent("" + maxPriceFilter) + "&"; 
        if (minPriceFilter === null)
            throw new Error("The parameter 'minPriceFilter' cannot be null.");
        else if (minPriceFilter !== undefined)
            url_ += "MinPriceFilter=" + encodeURIComponent("" + minPriceFilter) + "&"; 
        if (benefactorNameFilter === null)
            throw new Error("The parameter 'benefactorNameFilter' cannot be null.");
        else if (benefactorNameFilter !== undefined)
            url_ += "BenefactorNameFilter=" + encodeURIComponent("" + benefactorNameFilter) + "&"; 
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (contactFirstNameFilter === null)
            throw new Error("The parameter 'contactFirstNameFilter' cannot be null.");
        else if (contactFirstNameFilter !== undefined)
            url_ += "ContactFirstNameFilter=" + encodeURIComponent("" + contactFirstNameFilter) + "&"; 
        if (billCreatorUserFilter === null)
            throw new Error("The parameter 'billCreatorUserFilter' cannot be null.");
        else if (billCreatorUserFilter !== undefined)
            url_ += "BillCreatorUserFilter=" + encodeURIComponent("" + billCreatorUserFilter) + "&"; 
        if (currencyNameFilter === null)
            throw new Error("The parameter 'currencyNameFilter' cannot be null.");
        else if (currencyNameFilter !== undefined)
            url_ += "CurrencyNameFilter=" + encodeURIComponent("" + currencyNameFilter) + "&"; 
        if (planConstFilter === null)
            throw new Error("The parameter 'planConstFilter' cannot be null.");
        else if (planConstFilter !== undefined)
            url_ += "PlanConstFilter=" + encodeURIComponent("" + planConstFilter) + "&"; 
        if (extraEntityFilter === null)
            throw new Error("The parameter 'extraEntityFilter' cannot be null.");
        else if (extraEntityFilter !== undefined)
            url_ += "ExtraEntityFilter=" + encodeURIComponent("" + extraEntityFilter) + "&"; 
        if (extraEntityRefFilter === null)
            throw new Error("The parameter 'extraEntityRefFilter' cannot be null.");
        else if (extraEntityRefFilter !== undefined)
            url_ += "ExtraEntityRefFilter=" + encodeURIComponent("" + extraEntityRefFilter) + "&"; 
        if (postmanFilter === null)
            throw new Error("The parameter 'postmanFilter' cannot be null.");
        else if (postmanFilter !== undefined)
            url_ += "PostmanFilter=" + encodeURIComponent("" + postmanFilter) + "&"; 
        if (directionFilter === null)
            throw new Error("The parameter 'directionFilter' cannot be null.");
        else if (directionFilter !== undefined)
            url_ += "DirectionFilter=" + encodeURIComponent("" + directionFilter) + "&"; 
        if (areaFilter === null)
            throw new Error("The parameter 'areaFilter' cannot be null.");
        else if (areaFilter !== undefined)
            url_ += "AreaFilter=" + encodeURIComponent("" + areaFilter) + "&"; 
        if (survivorNameFilter === null)
            throw new Error("The parameter 'survivorNameFilter' cannot be null.");
        else if (survivorNameFilter !== undefined)
            url_ += "SurvivorNameFilter=" + encodeURIComponent("" + survivorNameFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForDeceased(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForDeceased(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetBillForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetBillForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllForDeceased(response: HttpResponseBase): Observable<PagedResultDtoOfGetBillForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetBillForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBillForViewDto>(<any>null);
    }

    /**
     * @param contactFirstNameFilter (optional) 
     * @param currencyNameFilter (optional) 
     * @param planConstIdFilter (optional) 
     * @param extraEntityFilter (optional) 
     * @param extraEntityRefFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllForCheckBills(contactFirstNameFilter: string | undefined, currencyNameFilter: string | undefined, planConstIdFilter: number | undefined, extraEntityFilter: number | undefined, extraEntityRefFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetAllForCheckBills?";
        if (contactFirstNameFilter === null)
            throw new Error("The parameter 'contactFirstNameFilter' cannot be null.");
        else if (contactFirstNameFilter !== undefined)
            url_ += "ContactFirstNameFilter=" + encodeURIComponent("" + contactFirstNameFilter) + "&"; 
        if (currencyNameFilter === null)
            throw new Error("The parameter 'currencyNameFilter' cannot be null.");
        else if (currencyNameFilter !== undefined)
            url_ += "CurrencyNameFilter=" + encodeURIComponent("" + currencyNameFilter) + "&"; 
        if (planConstIdFilter === null)
            throw new Error("The parameter 'planConstIdFilter' cannot be null.");
        else if (planConstIdFilter !== undefined)
            url_ += "PlanConstIdFilter=" + encodeURIComponent("" + planConstIdFilter) + "&"; 
        if (extraEntityFilter === null)
            throw new Error("The parameter 'extraEntityFilter' cannot be null.");
        else if (extraEntityFilter !== undefined)
            url_ += "ExtraEntityFilter=" + encodeURIComponent("" + extraEntityFilter) + "&"; 
        if (extraEntityRefFilter === null)
            throw new Error("The parameter 'extraEntityRefFilter' cannot be null.");
        else if (extraEntityRefFilter !== undefined)
            url_ += "ExtraEntityRefFilter=" + encodeURIComponent("" + extraEntityRefFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForCheckBills(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForCheckBills(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllForCheckBills(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param postman (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param paymentTypeFilter (optional) 
     * @param planTypeFilter (optional) 
     * @param planNameFilter (optional) 
     * @param minPriceFilter (optional) 
     * @param maxPriceFilter (optional) 
     * @param codeFilter (optional) 
     * @param posIdentityFilter (optional) 
     * @param accountNumberFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllForAccounting(filter: string | undefined, postman: boolean | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, paymentTypeFilter: number | undefined, planTypeFilter: number | undefined, planNameFilter: string | undefined, minPriceFilter: number | undefined, maxPriceFilter: number | undefined, codeFilter: string | undefined, posIdentityFilter: string | undefined, accountNumberFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetBillAndPaymentForAccountingOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetAllForAccounting?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (postman === null)
            throw new Error("The parameter 'postman' cannot be null.");
        else if (postman !== undefined)
            url_ += "Postman=" + encodeURIComponent("" + postman) + "&"; 
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (paymentTypeFilter === null)
            throw new Error("The parameter 'paymentTypeFilter' cannot be null.");
        else if (paymentTypeFilter !== undefined)
            url_ += "PaymentTypeFilter=" + encodeURIComponent("" + paymentTypeFilter) + "&"; 
        if (planTypeFilter === null)
            throw new Error("The parameter 'planTypeFilter' cannot be null.");
        else if (planTypeFilter !== undefined)
            url_ += "PlanTypeFilter=" + encodeURIComponent("" + planTypeFilter) + "&"; 
        if (planNameFilter === null)
            throw new Error("The parameter 'planNameFilter' cannot be null.");
        else if (planNameFilter !== undefined)
            url_ += "PlanNameFilter=" + encodeURIComponent("" + planNameFilter) + "&"; 
        if (minPriceFilter === null)
            throw new Error("The parameter 'minPriceFilter' cannot be null.");
        else if (minPriceFilter !== undefined)
            url_ += "MinPriceFilter=" + encodeURIComponent("" + minPriceFilter) + "&"; 
        if (maxPriceFilter === null)
            throw new Error("The parameter 'maxPriceFilter' cannot be null.");
        else if (maxPriceFilter !== undefined)
            url_ += "MaxPriceFilter=" + encodeURIComponent("" + maxPriceFilter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (posIdentityFilter === null)
            throw new Error("The parameter 'posIdentityFilter' cannot be null.");
        else if (posIdentityFilter !== undefined)
            url_ += "PosIdentityFilter=" + encodeURIComponent("" + posIdentityFilter) + "&"; 
        if (accountNumberFilter === null)
            throw new Error("The parameter 'accountNumberFilter' cannot be null.");
        else if (accountNumberFilter !== undefined)
            url_ += "AccountNumberFilter=" + encodeURIComponent("" + accountNumberFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForAccounting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForAccounting(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetBillAndPaymentForAccountingOutputDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetBillAndPaymentForAccountingOutputDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllForAccounting(response: HttpResponseBase): Observable<PagedResultDtoOfGetBillAndPaymentForAccountingOutputDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetBillAndPaymentForAccountingOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBillAndPaymentForAccountingOutputDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param postman (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param paymentTypeFilter (optional) 
     * @param planTypeFilter (optional) 
     * @param planNameFilter (optional) 
     * @param minPriceFilter (optional) 
     * @param maxPriceFilter (optional) 
     * @param codeFilter (optional) 
     * @param posIdentityFilter (optional) 
     * @param accountNumberFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllOnApproveForAccounting(filter: string | undefined, postman: boolean | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, paymentTypeFilter: number | undefined, planTypeFilter: number | undefined, planNameFilter: string | undefined, minPriceFilter: number | undefined, maxPriceFilter: number | undefined, codeFilter: string | undefined, posIdentityFilter: string | undefined, accountNumberFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetBillAndPaymentForAccountingOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetAllOnApproveForAccounting?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (postman === null)
            throw new Error("The parameter 'postman' cannot be null.");
        else if (postman !== undefined)
            url_ += "Postman=" + encodeURIComponent("" + postman) + "&"; 
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (paymentTypeFilter === null)
            throw new Error("The parameter 'paymentTypeFilter' cannot be null.");
        else if (paymentTypeFilter !== undefined)
            url_ += "PaymentTypeFilter=" + encodeURIComponent("" + paymentTypeFilter) + "&"; 
        if (planTypeFilter === null)
            throw new Error("The parameter 'planTypeFilter' cannot be null.");
        else if (planTypeFilter !== undefined)
            url_ += "PlanTypeFilter=" + encodeURIComponent("" + planTypeFilter) + "&"; 
        if (planNameFilter === null)
            throw new Error("The parameter 'planNameFilter' cannot be null.");
        else if (planNameFilter !== undefined)
            url_ += "PlanNameFilter=" + encodeURIComponent("" + planNameFilter) + "&"; 
        if (minPriceFilter === null)
            throw new Error("The parameter 'minPriceFilter' cannot be null.");
        else if (minPriceFilter !== undefined)
            url_ += "MinPriceFilter=" + encodeURIComponent("" + minPriceFilter) + "&"; 
        if (maxPriceFilter === null)
            throw new Error("The parameter 'maxPriceFilter' cannot be null.");
        else if (maxPriceFilter !== undefined)
            url_ += "MaxPriceFilter=" + encodeURIComponent("" + maxPriceFilter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (posIdentityFilter === null)
            throw new Error("The parameter 'posIdentityFilter' cannot be null.");
        else if (posIdentityFilter !== undefined)
            url_ += "PosIdentityFilter=" + encodeURIComponent("" + posIdentityFilter) + "&"; 
        if (accountNumberFilter === null)
            throw new Error("The parameter 'accountNumberFilter' cannot be null.");
        else if (accountNumberFilter !== undefined)
            url_ += "AccountNumberFilter=" + encodeURIComponent("" + accountNumberFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOnApproveForAccounting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOnApproveForAccounting(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetBillAndPaymentForAccountingOutputDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetBillAndPaymentForAccountingOutputDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllOnApproveForAccounting(response: HttpResponseBase): Observable<PagedResultDtoOfGetBillAndPaymentForAccountingOutputDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetBillAndPaymentForAccountingOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBillAndPaymentForAccountingOutputDto>(<any>null);
    }

    /**
     * @return Success
     */
    getOnApproveCountForAccounting(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetOnApproveCountForAccounting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnApproveCountForAccounting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnApproveCountForAccounting(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetOnApproveCountForAccounting(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param flowerCrownAndSacrificeBills (optional) 
     * @return Success
     */
    getOnApproveCount(flowerCrownAndSacrificeBills: boolean | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetOnApproveCount?";
        if (flowerCrownAndSacrificeBills === null)
            throw new Error("The parameter 'flowerCrownAndSacrificeBills' cannot be null.");
        else if (flowerCrownAndSacrificeBills !== undefined)
            url_ += "flowerCrownAndSacrificeBills=" + encodeURIComponent("" + flowerCrownAndSacrificeBills) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnApproveCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnApproveCount(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetOnApproveCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param flowerCrownAndSacrificeBills (optional) 
     * @return Success
     */
    getWaitingForPaymentCount(flowerCrownAndSacrificeBills: boolean | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetWaitingForPaymentCount?";
        if (flowerCrownAndSacrificeBills === null)
            throw new Error("The parameter 'flowerCrownAndSacrificeBills' cannot be null.");
        else if (flowerCrownAndSacrificeBills !== undefined)
            url_ += "flowerCrownAndSacrificeBills=" + encodeURIComponent("" + flowerCrownAndSacrificeBills) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWaitingForPaymentCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWaitingForPaymentCount(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetWaitingForPaymentCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param flowerCrownAndSacrificeBills (optional) 
     * @return Success
     */
    getNotApprovedPaymentCount(flowerCrownAndSacrificeBills: boolean | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetNotApprovedPaymentCount?";
        if (flowerCrownAndSacrificeBills === null)
            throw new Error("The parameter 'flowerCrownAndSacrificeBills' cannot be null.");
        else if (flowerCrownAndSacrificeBills !== undefined)
            url_ += "flowerCrownAndSacrificeBills=" + encodeURIComponent("" + flowerCrownAndSacrificeBills) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotApprovedPaymentCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotApprovedPaymentCount(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetNotApprovedPaymentCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param contactId (optional) 
     * @return Success
     */
    getContactOnApproveCount(contactId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetContactOnApproveCount?";
        if (contactId === null)
            throw new Error("The parameter 'contactId' cannot be null.");
        else if (contactId !== undefined)
            url_ += "contactId=" + encodeURIComponent("" + contactId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactOnApproveCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactOnApproveCount(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetContactOnApproveCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param contactId (optional) 
     * @return Success
     */
    getContactWaitingForPaymentCount(contactId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetContactWaitingForPaymentCount?";
        if (contactId === null)
            throw new Error("The parameter 'contactId' cannot be null.");
        else if (contactId !== undefined)
            url_ += "contactId=" + encodeURIComponent("" + contactId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactWaitingForPaymentCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactWaitingForPaymentCount(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetContactWaitingForPaymentCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param contactId (optional) 
     * @return Success
     */
    getContactNotApprovedPaymentCount(contactId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetContactNotApprovedPaymentCount?";
        if (contactId === null)
            throw new Error("The parameter 'contactId' cannot be null.");
        else if (contactId !== undefined)
            url_ += "contactId=" + encodeURIComponent("" + contactId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactNotApprovedPaymentCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactNotApprovedPaymentCount(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetContactNotApprovedPaymentCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param contactIdFilter (optional) 
     * @param maxIssueDateFilter (optional) 
     * @param minIssueDateFilter (optional) 
     * @param maxPriceFilter (optional) 
     * @param minPriceFilter (optional) 
     * @param benefactorNameFilter (optional) 
     * @param statusFilter (optional) 
     * @param billCreatorUserFilter (optional) 
     * @param currencyNameFilter (optional) 
     * @param planConstFilter (optional) 
     * @param extraEntityFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllForAdvancedSearch(filter: string | undefined, contactIdFilter: number | undefined, maxIssueDateFilter: moment.Moment | undefined, minIssueDateFilter: moment.Moment | undefined, maxPriceFilter: number | undefined, minPriceFilter: number | undefined, benefactorNameFilter: string | undefined, statusFilter: number | undefined, billCreatorUserFilter: string | undefined, currencyNameFilter: string | undefined, planConstFilter: string[] | undefined, extraEntityFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetBillForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetAllForAdvancedSearch?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (contactIdFilter === null)
            throw new Error("The parameter 'contactIdFilter' cannot be null.");
        else if (contactIdFilter !== undefined)
            url_ += "ContactIdFilter=" + encodeURIComponent("" + contactIdFilter) + "&"; 
        if (maxIssueDateFilter === null)
            throw new Error("The parameter 'maxIssueDateFilter' cannot be null.");
        else if (maxIssueDateFilter !== undefined)
            url_ += "MaxIssueDateFilter=" + encodeURIComponent(maxIssueDateFilter ? "" + maxIssueDateFilter.toJSON() : "") + "&"; 
        if (minIssueDateFilter === null)
            throw new Error("The parameter 'minIssueDateFilter' cannot be null.");
        else if (minIssueDateFilter !== undefined)
            url_ += "MinIssueDateFilter=" + encodeURIComponent(minIssueDateFilter ? "" + minIssueDateFilter.toJSON() : "") + "&"; 
        if (maxPriceFilter === null)
            throw new Error("The parameter 'maxPriceFilter' cannot be null.");
        else if (maxPriceFilter !== undefined)
            url_ += "MaxPriceFilter=" + encodeURIComponent("" + maxPriceFilter) + "&"; 
        if (minPriceFilter === null)
            throw new Error("The parameter 'minPriceFilter' cannot be null.");
        else if (minPriceFilter !== undefined)
            url_ += "MinPriceFilter=" + encodeURIComponent("" + minPriceFilter) + "&"; 
        if (benefactorNameFilter === null)
            throw new Error("The parameter 'benefactorNameFilter' cannot be null.");
        else if (benefactorNameFilter !== undefined)
            url_ += "BenefactorNameFilter=" + encodeURIComponent("" + benefactorNameFilter) + "&"; 
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (billCreatorUserFilter === null)
            throw new Error("The parameter 'billCreatorUserFilter' cannot be null.");
        else if (billCreatorUserFilter !== undefined)
            url_ += "BillCreatorUserFilter=" + encodeURIComponent("" + billCreatorUserFilter) + "&"; 
        if (currencyNameFilter === null)
            throw new Error("The parameter 'currencyNameFilter' cannot be null.");
        else if (currencyNameFilter !== undefined)
            url_ += "CurrencyNameFilter=" + encodeURIComponent("" + currencyNameFilter) + "&"; 
        if (planConstFilter === null)
            throw new Error("The parameter 'planConstFilter' cannot be null.");
        else if (planConstFilter !== undefined)
            planConstFilter && planConstFilter.forEach(item => { url_ += "PlanConstFilter=" + encodeURIComponent("" + item) + "&"; });
        if (extraEntityFilter === null)
            throw new Error("The parameter 'extraEntityFilter' cannot be null.");
        else if (extraEntityFilter !== undefined)
            url_ += "ExtraEntityFilter=" + encodeURIComponent("" + extraEntityFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForAdvancedSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForAdvancedSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetBillForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetBillForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllForAdvancedSearch(response: HttpResponseBase): Observable<PagedResultDtoOfGetBillForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetBillForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBillForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBillForView(id: number | undefined): Observable<GetBillForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetBillForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillForView(<any>response_);
                } catch (e) {
                    return <Observable<GetBillForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBillForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetBillForView(response: HttpResponseBase): Observable<GetBillForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBillForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBillForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBillForEdit(id: number | undefined): Observable<GetBillForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetBillForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetBillForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBillForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetBillForEdit(response: HttpResponseBase): Observable<GetBillForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBillForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBillForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditBillAndDependentForms(body: CreateOrEditBillAndDependentFormsDto | undefined): Observable<CreateOrEditBillAndDependentFormsOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Bills/CreateOrEditBillAndDependentForms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditBillAndDependentForms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditBillAndDependentForms(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditBillAndDependentFormsOutputDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditBillAndDependentFormsOutputDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditBillAndDependentForms(response: HttpResponseBase): Observable<CreateOrEditBillAndDependentFormsOutputDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditBillAndDependentFormsOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditBillAndDependentFormsOutputDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditBillForClipShop(body: CreateOrEditBillAndDependentFormsDto | undefined): Observable<CreateOrEditBillAndDependentFormsOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Bills/CreateOrEditBillForClipShop";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditBillForClipShop(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditBillForClipShop(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditBillAndDependentFormsOutputDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditBillAndDependentFormsOutputDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditBillForClipShop(response: HttpResponseBase): Observable<CreateOrEditBillAndDependentFormsOutputDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditBillAndDependentFormsOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditBillAndDependentFormsOutputDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCharityForShop(body: CreateOrEditPlanConstAndCharityForShop | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bills/CreateCharityForShop";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCharityForShop(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCharityForShop(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateCharityForShop(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditBillAndDependentCharityForms(body: CreateOrEditBillAndDependentCharityFormsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bills/CreateOrEditBillAndDependentCharityForms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditBillAndDependentCharityForms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditBillAndDependentCharityForms(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditBillAndDependentCharityForms(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param billCode (optional) 
     * @return Success
     */
    getReorderCharityFromBasket(billCode: string | undefined): Observable<CreateOrEditBillAndDependentCharityFormsDto> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetReorderCharityFromBasket?";
        if (billCode === null)
            throw new Error("The parameter 'billCode' cannot be null.");
        else if (billCode !== undefined)
            url_ += "billCode=" + encodeURIComponent("" + billCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReorderCharityFromBasket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReorderCharityFromBasket(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditBillAndDependentCharityFormsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditBillAndDependentCharityFormsDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetReorderCharityFromBasket(response: HttpResponseBase): Observable<CreateOrEditBillAndDependentCharityFormsDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditBillAndDependentCharityFormsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditBillAndDependentCharityFormsDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditBillsFromPlanBill(body: CreateOrEditBillsFromPlanBillDto | undefined): Observable<BillsFromPlanBillOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Bills/CreateOrEditBillsFromPlanBill";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditBillsFromPlanBill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditBillsFromPlanBill(<any>response_);
                } catch (e) {
                    return <Observable<BillsFromPlanBillOutputDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<BillsFromPlanBillOutputDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditBillsFromPlanBill(response: HttpResponseBase): Observable<BillsFromPlanBillOutputDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BillsFromPlanBillOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillsFromPlanBillOutputDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditBillAndPlanBill(body: CreateOrEditBillAndPlanBillDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Bills/CreateOrEditBillAndPlanBill";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditBillAndPlanBill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditBillAndPlanBill(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditBillAndPlanBill(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditBillAndDeceased(body: CreateOrEditBillAndDeceasedInput[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bills/CreateOrEditBillAndDeceased";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditBillAndDeceased(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditBillAndDeceased(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditBillAndDeceased(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    createOrEditBillFromMoneyBoxEvents(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bills/CreateOrEditBillFromMoneyBoxEvents";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditBillFromMoneyBoxEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditBillFromMoneyBoxEvents(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditBillFromMoneyBoxEvents(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditBillsForSacrifice(body: CreateOrEditBillsForSacrificeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bills/CreateOrEditBillsForSacrifice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditBillsForSacrifice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditBillsForSacrifice(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditBillsForSacrifice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditBillDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Bills/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @return Success
     */
    updateUnPayedIPGBills(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bills/UpdateUnPayedIPGBills";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUnPayedIPGBills(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUnPayedIPGBills(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateUnPayedIPGBills(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param code (optional) 
     * @param statuses (optional) 
     * @param id (optional) 
     * @param date (optional) 
     * @param page (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getContactBillsForShop(code: string | undefined, statuses: string | undefined, type: BillTypes, id: number | undefined, date: moment.Moment | undefined, page: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetContactBillsForShopDto> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetContactBillsForShop?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "Code=" + encodeURIComponent("" + code) + "&"; 
        if (statuses === null)
            throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            url_ += "Statuses=" + encodeURIComponent("" + statuses) + "&"; 
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined and cannot be null.");
        else
            url_ += "Type=" + encodeURIComponent("" + type) + "&"; 
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactBillsForShop(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactBillsForShop(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetContactBillsForShopDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetContactBillsForShopDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetContactBillsForShop(response: HttpResponseBase): Observable<PagedResultDtoOfGetContactBillsForShopDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetContactBillsForShopDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetContactBillsForShopDto>(<any>null);
    }

    /**
     * @param billId (optional) 
     * @return Success
     */
    getDetailContactBillsForShop(billId: number | undefined): Observable<Property[]> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetDetailContactBillsForShop?";
        if (billId === null)
            throw new Error("The parameter 'billId' cannot be null.");
        else if (billId !== undefined)
            url_ += "billId=" + encodeURIComponent("" + billId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetailContactBillsForShop(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetailContactBillsForShop(<any>response_);
                } catch (e) {
                    return <Observable<Property[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Property[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetDetailContactBillsForShop(response: HttpResponseBase): Observable<Property[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Property.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Property[]>(<any>null);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    getBillForShop(code: string | undefined): Observable<GetBillAndDependentFormsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetBillForShop?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillForShop(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillForShop(<any>response_);
                } catch (e) {
                    return <Observable<GetBillAndDependentFormsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBillAndDependentFormsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetBillForShop(response: HttpResponseBase): Observable<GetBillAndDependentFormsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBillAndDependentFormsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBillAndDependentFormsOutput>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBillSettings(id: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetBillSettings?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillSettings(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processGetBillSettings(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bills/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param billId (optional) 
     * @return Success
     */
    getAccessToDeleteForShop(billId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetAccessToDeleteForShop?";
        if (billId === null)
            throw new Error("The parameter 'billId' cannot be null.");
        else if (billId !== undefined)
            url_ += "billId=" + encodeURIComponent("" + billId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccessToDeleteForShop(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccessToDeleteForShop(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processGetAccessToDeleteForShop(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param maxIssueDateFilter (optional) 
     * @param minIssueDateFilter (optional) 
     * @param maxPaymentDateFilter (optional) 
     * @param minPaymentDateFilter (optional) 
     * @param maxPriceFilter (optional) 
     * @param minPriceFilter (optional) 
     * @param benefactorNameFilter (optional) 
     * @param statusFilter (optional) 
     * @param contactFirstNameFilter (optional) 
     * @param currencyNameFilter (optional) 
     * @param planConstFilter (optional) 
     * @param extraEntityFilter (optional) 
     * @param extraEntityRefFilter (optional) 
     * @param postmanFilter (optional) 
     * @param directionFilter (optional) 
     * @param areaFilter (optional) 
     * @return Success
     */
    getBillsToExcel(filter: string | undefined, codeFilter: string | undefined, maxIssueDateFilter: moment.Moment | undefined, minIssueDateFilter: moment.Moment | undefined, maxPaymentDateFilter: moment.Moment | undefined, minPaymentDateFilter: moment.Moment | undefined, maxPriceFilter: number | undefined, minPriceFilter: number | undefined, benefactorNameFilter: string | undefined, statusFilter: number | undefined, contactFirstNameFilter: string | undefined, currencyNameFilter: string | undefined, planConstFilter: string[] | undefined, extraEntityFilter: string | undefined, extraEntityRefFilter: number | undefined, postmanFilter: string | undefined, directionFilter: string | undefined, areaFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetBillsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (maxIssueDateFilter === null)
            throw new Error("The parameter 'maxIssueDateFilter' cannot be null.");
        else if (maxIssueDateFilter !== undefined)
            url_ += "MaxIssueDateFilter=" + encodeURIComponent(maxIssueDateFilter ? "" + maxIssueDateFilter.toJSON() : "") + "&"; 
        if (minIssueDateFilter === null)
            throw new Error("The parameter 'minIssueDateFilter' cannot be null.");
        else if (minIssueDateFilter !== undefined)
            url_ += "MinIssueDateFilter=" + encodeURIComponent(minIssueDateFilter ? "" + minIssueDateFilter.toJSON() : "") + "&"; 
        if (maxPaymentDateFilter === null)
            throw new Error("The parameter 'maxPaymentDateFilter' cannot be null.");
        else if (maxPaymentDateFilter !== undefined)
            url_ += "MaxPaymentDateFilter=" + encodeURIComponent(maxPaymentDateFilter ? "" + maxPaymentDateFilter.toJSON() : "") + "&"; 
        if (minPaymentDateFilter === null)
            throw new Error("The parameter 'minPaymentDateFilter' cannot be null.");
        else if (minPaymentDateFilter !== undefined)
            url_ += "MinPaymentDateFilter=" + encodeURIComponent(minPaymentDateFilter ? "" + minPaymentDateFilter.toJSON() : "") + "&"; 
        if (maxPriceFilter === null)
            throw new Error("The parameter 'maxPriceFilter' cannot be null.");
        else if (maxPriceFilter !== undefined)
            url_ += "MaxPriceFilter=" + encodeURIComponent("" + maxPriceFilter) + "&"; 
        if (minPriceFilter === null)
            throw new Error("The parameter 'minPriceFilter' cannot be null.");
        else if (minPriceFilter !== undefined)
            url_ += "MinPriceFilter=" + encodeURIComponent("" + minPriceFilter) + "&"; 
        if (benefactorNameFilter === null)
            throw new Error("The parameter 'benefactorNameFilter' cannot be null.");
        else if (benefactorNameFilter !== undefined)
            url_ += "BenefactorNameFilter=" + encodeURIComponent("" + benefactorNameFilter) + "&"; 
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (contactFirstNameFilter === null)
            throw new Error("The parameter 'contactFirstNameFilter' cannot be null.");
        else if (contactFirstNameFilter !== undefined)
            url_ += "ContactFirstNameFilter=" + encodeURIComponent("" + contactFirstNameFilter) + "&"; 
        if (currencyNameFilter === null)
            throw new Error("The parameter 'currencyNameFilter' cannot be null.");
        else if (currencyNameFilter !== undefined)
            url_ += "CurrencyNameFilter=" + encodeURIComponent("" + currencyNameFilter) + "&"; 
        if (planConstFilter === null)
            throw new Error("The parameter 'planConstFilter' cannot be null.");
        else if (planConstFilter !== undefined)
            planConstFilter && planConstFilter.forEach(item => { url_ += "PlanConstFilter=" + encodeURIComponent("" + item) + "&"; });
        if (extraEntityFilter === null)
            throw new Error("The parameter 'extraEntityFilter' cannot be null.");
        else if (extraEntityFilter !== undefined)
            url_ += "ExtraEntityFilter=" + encodeURIComponent("" + extraEntityFilter) + "&"; 
        if (extraEntityRefFilter === null)
            throw new Error("The parameter 'extraEntityRefFilter' cannot be null.");
        else if (extraEntityRefFilter !== undefined)
            url_ += "ExtraEntityRefFilter=" + encodeURIComponent("" + extraEntityRefFilter) + "&"; 
        if (postmanFilter === null)
            throw new Error("The parameter 'postmanFilter' cannot be null.");
        else if (postmanFilter !== undefined)
            url_ += "PostmanFilter=" + encodeURIComponent("" + postmanFilter) + "&"; 
        if (directionFilter === null)
            throw new Error("The parameter 'directionFilter' cannot be null.");
        else if (directionFilter !== undefined)
            url_ += "DirectionFilter=" + encodeURIComponent("" + directionFilter) + "&"; 
        if (areaFilter === null)
            throw new Error("The parameter 'areaFilter' cannot be null.");
        else if (areaFilter !== undefined)
            url_ += "AreaFilter=" + encodeURIComponent("" + areaFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetBillsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param consumeIds (optional) 
     * @return Success
     */
    getConsumesName(consumeIds: number[] | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetConsumesName?";
        if (consumeIds === null)
            throw new Error("The parameter 'consumeIds' cannot be null.");
        else if (consumeIds !== undefined)
            consumeIds && consumeIds.forEach(item => { url_ += "consumeIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsumesName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsumesName(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetConsumesName(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param consumeIds (optional) 
     * @return Success
     */
    getConsumesAccountCode(consumeIds: number[] | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetConsumesAccountCode?";
        if (consumeIds === null)
            throw new Error("The parameter 'consumeIds' cannot be null.");
        else if (consumeIds !== undefined)
            consumeIds && consumeIds.forEach(item => { url_ += "consumeIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsumesAccountCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsumesAccountCode(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetConsumesAccountCode(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    updateContactsNotInCacheForLookupTable(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bills/UpdateContactsNotInCacheForLookupTable";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateContactsNotInCacheForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateContactsNotInCacheForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateContactsNotInCacheForLookupTable(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param deacesedIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllContactForLookupTable(filter: string | undefined, deacesedIdFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfBillContactLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetAllContactForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (deacesedIdFilter === null)
            throw new Error("The parameter 'deacesedIdFilter' cannot be null.");
        else if (deacesedIdFilter !== undefined)
            url_ += "DeacesedIdFilter=" + encodeURIComponent("" + deacesedIdFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllContactForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllContactForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfBillContactLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfBillContactLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllContactForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfBillContactLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfBillContactLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfBillContactLookupTableDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllCurrencyForTableDropdown(): Observable<BillCurrencyLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetAllCurrencyForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCurrencyForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCurrencyForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<BillCurrencyLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<BillCurrencyLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCurrencyForTableDropdown(response: HttpResponseBase): Observable<BillCurrencyLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BillCurrencyLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillCurrencyLookupTableDto[]>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param deacesedIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllDeceasedForLookupTable(filter: string | undefined, deacesedIdFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfBillDeceasedLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetAllDeceasedForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (deacesedIdFilter === null)
            throw new Error("The parameter 'deacesedIdFilter' cannot be null.");
        else if (deacesedIdFilter !== undefined)
            url_ += "DeacesedIdFilter=" + encodeURIComponent("" + deacesedIdFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDeceasedForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDeceasedForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfBillDeceasedLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfBillDeceasedLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllDeceasedForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfBillDeceasedLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfBillDeceasedLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfBillDeceasedLookupTableDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllBaseTimeForTableDropdown(): Observable<BaseTimeInfo[]> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetAllBaseTimeForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBaseTimeForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBaseTimeForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<BaseTimeInfo[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseTimeInfo[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBaseTimeForTableDropdown(response: HttpResponseBase): Observable<BaseTimeInfo[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BaseTimeInfo.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseTimeInfo[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllCardTemplateForTableDropdown(typeFilter: TypesOfSolace): Observable<BillCardTemplateLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetAllCardTemplateForTableDropdown?";
        if (typeFilter === undefined || typeFilter === null)
            throw new Error("The parameter 'typeFilter' must be defined and cannot be null.");
        else
            url_ += "typeFilter=" + encodeURIComponent("" + typeFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCardTemplateForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCardTemplateForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<BillCardTemplateLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<BillCardTemplateLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCardTemplateForTableDropdown(response: HttpResponseBase): Observable<BillCardTemplateLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BillCardTemplateLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillCardTemplateLookupTableDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllCardTemplateForTableDropdownForAdmin(typeFilter: TypesOfSolace): Observable<BillCardTemplateLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetAllCardTemplateForTableDropdownForAdmin?";
        if (typeFilter === undefined || typeFilter === null)
            throw new Error("The parameter 'typeFilter' must be defined and cannot be null.");
        else
            url_ += "typeFilter=" + encodeURIComponent("" + typeFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCardTemplateForTableDropdownForAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCardTemplateForTableDropdownForAdmin(<any>response_);
                } catch (e) {
                    return <Observable<BillCardTemplateLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<BillCardTemplateLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCardTemplateForTableDropdownForAdmin(response: HttpResponseBase): Observable<BillCardTemplateLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BillCardTemplateLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillCardTemplateLookupTableDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllBillBranchForTableDropdown(): Observable<BillBranchLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetAllBillBranchForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBillBranchForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBillBranchForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<BillBranchLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<BillBranchLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBillBranchForTableDropdown(response: HttpResponseBase): Observable<BillBranchLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BillBranchLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillBranchLookupTableDto[]>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param deacesedIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCeremonyForLookupTable(filter: string | undefined, deacesedIdFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfBillCeremonyLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetAllCeremonyForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (deacesedIdFilter === null)
            throw new Error("The parameter 'deacesedIdFilter' cannot be null.");
        else if (deacesedIdFilter !== undefined)
            url_ += "DeacesedIdFilter=" + encodeURIComponent("" + deacesedIdFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCeremonyForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCeremonyForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfBillCeremonyLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfBillCeremonyLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCeremonyForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfBillCeremonyLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfBillCeremonyLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfBillCeremonyLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param baseTimeIdFilter (optional) 
     * @param contactIdFilter (optional) 
     * @param isPublicFilter (optional) 
     * @param isContinuousFilter (optional) 
     * @param currencyIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllPlanConstForLookupTable(filter: string | undefined, planType: Plans, baseTimeIdFilter: number | undefined, contactIdFilter: number | undefined, isPublicFilter: number | undefined, isContinuousFilter: number | undefined, currencyIdFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfBillPlanConstLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetAllPlanConstForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (planType === undefined || planType === null)
            throw new Error("The parameter 'planType' must be defined and cannot be null.");
        else
            url_ += "PlanType=" + encodeURIComponent("" + planType) + "&"; 
        if (baseTimeIdFilter === null)
            throw new Error("The parameter 'baseTimeIdFilter' cannot be null.");
        else if (baseTimeIdFilter !== undefined)
            url_ += "BaseTimeIdFilter=" + encodeURIComponent("" + baseTimeIdFilter) + "&"; 
        if (contactIdFilter === null)
            throw new Error("The parameter 'contactIdFilter' cannot be null.");
        else if (contactIdFilter !== undefined)
            url_ += "ContactIdFilter=" + encodeURIComponent("" + contactIdFilter) + "&"; 
        if (isPublicFilter === null)
            throw new Error("The parameter 'isPublicFilter' cannot be null.");
        else if (isPublicFilter !== undefined)
            url_ += "IsPublicFilter=" + encodeURIComponent("" + isPublicFilter) + "&"; 
        if (isContinuousFilter === null)
            throw new Error("The parameter 'isContinuousFilter' cannot be null.");
        else if (isContinuousFilter !== undefined)
            url_ += "IsContinuousFilter=" + encodeURIComponent("" + isContinuousFilter) + "&"; 
        if (currencyIdFilter === null)
            throw new Error("The parameter 'currencyIdFilter' cannot be null.");
        else if (currencyIdFilter !== undefined)
            url_ += "CurrencyIdFilter=" + encodeURIComponent("" + currencyIdFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPlanConstForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPlanConstForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfBillPlanConstLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfBillPlanConstLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPlanConstForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfBillPlanConstLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfBillPlanConstLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfBillPlanConstLookupTableDto>(<any>null);
    }

    /**
     * @param extraEntityFilterInput (optional) 
     * @return Success
     */
    getAllPlanConstForDropdownTable(extraEntityFilterInput: string | undefined): Observable<BillPlanConstLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetAllPlanConstForDropdownTable?";
        if (extraEntityFilterInput === null)
            throw new Error("The parameter 'extraEntityFilterInput' cannot be null.");
        else if (extraEntityFilterInput !== undefined)
            url_ += "extraEntityFilterInput=" + encodeURIComponent("" + extraEntityFilterInput) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPlanConstForDropdownTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPlanConstForDropdownTable(<any>response_);
                } catch (e) {
                    return <Observable<BillPlanConstLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<BillPlanConstLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPlanConstForDropdownTable(response: HttpResponseBase): Observable<BillPlanConstLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BillPlanConstLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillPlanConstLookupTableDto[]>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param billId (optional) 
     * @param contactId (optional) 
     * @param maxIssueDateFilter (optional) 
     * @param minIssueDateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getCustomBillForPayment(filter: string | undefined, billId: number | undefined, contactId: number | undefined, maxIssueDateFilter: moment.Moment | undefined, minIssueDateFilter: moment.Moment | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetBillForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetCustomBillForPayment?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (billId === null)
            throw new Error("The parameter 'billId' cannot be null.");
        else if (billId !== undefined)
            url_ += "BillId=" + encodeURIComponent("" + billId) + "&"; 
        if (contactId === null)
            throw new Error("The parameter 'contactId' cannot be null.");
        else if (contactId !== undefined)
            url_ += "ContactId=" + encodeURIComponent("" + contactId) + "&"; 
        if (maxIssueDateFilter === null)
            throw new Error("The parameter 'maxIssueDateFilter' cannot be null.");
        else if (maxIssueDateFilter !== undefined)
            url_ += "MaxIssueDateFilter=" + encodeURIComponent(maxIssueDateFilter ? "" + maxIssueDateFilter.toJSON() : "") + "&"; 
        if (minIssueDateFilter === null)
            throw new Error("The parameter 'minIssueDateFilter' cannot be null.");
        else if (minIssueDateFilter !== undefined)
            url_ += "MinIssueDateFilter=" + encodeURIComponent(minIssueDateFilter ? "" + minIssueDateFilter.toJSON() : "") + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomBillForPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomBillForPayment(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetBillForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetBillForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCustomBillForPayment(response: HttpResponseBase): Observable<PagedResultDtoOfGetBillForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetBillForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBillForViewDto>(<any>null);
    }

    /**
     * @param billIdInput (optional) 
     * @return Success
     */
    getPlanForBillView(billIdInput: number | undefined): Observable<GetPlanForBillViewOutput> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetPlanForBillView?";
        if (billIdInput === null)
            throw new Error("The parameter 'billIdInput' cannot be null.");
        else if (billIdInput !== undefined)
            url_ += "billIdInput=" + encodeURIComponent("" + billIdInput) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlanForBillView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlanForBillView(<any>response_);
                } catch (e) {
                    return <Observable<GetPlanForBillViewOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPlanForBillViewOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetPlanForBillView(response: HttpResponseBase): Observable<GetPlanForBillViewOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPlanForBillViewOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPlanForBillViewOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getBillTabsStatus(): Observable<BillStatusType[]> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetBillTabsStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillTabsStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillTabsStatus(<any>response_);
                } catch (e) {
                    return <Observable<BillStatusType[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<BillStatusType[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetBillTabsStatus(response: HttpResponseBase): Observable<BillStatusType[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BillStatusType.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillStatusType[]>(<any>null);
    }

    /**
     * @param billId (optional) 
     * @param branchId (optional) 
     * @return Success
     */
    editBillBranchRef(billId: number | undefined, branchId: number | undefined): Observable<GetBillForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Bills/EditBillBranchRef?";
        if (billId === null)
            throw new Error("The parameter 'billId' cannot be null.");
        else if (billId !== undefined)
            url_ += "billId=" + encodeURIComponent("" + billId) + "&"; 
        if (branchId === null)
            throw new Error("The parameter 'branchId' cannot be null.");
        else if (branchId !== undefined)
            url_ += "branchId=" + encodeURIComponent("" + branchId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditBillBranchRef(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditBillBranchRef(<any>response_);
                } catch (e) {
                    return <Observable<GetBillForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBillForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processEditBillBranchRef(response: HttpResponseBase): Observable<GetBillForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBillForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBillForViewDto>(<any>null);
    }

    /**
     * @param billId (optional) 
     * @return Success
     */
    cancelBill(billId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bills/CancelBill?";
        if (billId === null)
            throw new Error("The parameter 'billId' cannot be null.");
        else if (billId !== undefined)
            url_ += "billId=" + encodeURIComponent("" + billId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelBill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelBill(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCancelBill(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param billId (optional) 
     * @return Success
     */
    getAccessToCancelBill(billId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetAccessToCancelBill?";
        if (billId === null)
            throw new Error("The parameter 'billId' cannot be null.");
        else if (billId !== undefined)
            url_ += "billId=" + encodeURIComponent("" + billId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccessToCancelBill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccessToCancelBill(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processGetAccessToCancelBill(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPaymentAndGetId(body: CreateOrEditPaymentDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Bills/CreatePaymentAndGetId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePaymentAndGetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePaymentAndGetId(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreatePaymentAndGetId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param contactId (optional) 
     * @param billId (optional) 
     * @param isPayed (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getVirtualCreditsReport(filter: string | undefined, contactId: number | undefined, billId: number | undefined, isPayed: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetVirtualCreditsReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetVirtualCreditsReport?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (contactId === null)
            throw new Error("The parameter 'contactId' cannot be null.");
        else if (contactId !== undefined)
            url_ += "ContactId=" + encodeURIComponent("" + contactId) + "&"; 
        if (billId === null)
            throw new Error("The parameter 'billId' cannot be null.");
        else if (billId !== undefined)
            url_ += "BillId=" + encodeURIComponent("" + billId) + "&"; 
        if (isPayed === null)
            throw new Error("The parameter 'isPayed' cannot be null.");
        else if (isPayed !== undefined)
            url_ += "IsPayed=" + encodeURIComponent("" + isPayed) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVirtualCreditsReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVirtualCreditsReport(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetVirtualCreditsReportDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetVirtualCreditsReportDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetVirtualCreditsReport(response: HttpResponseBase): Observable<PagedResultDtoOfGetVirtualCreditsReportDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetVirtualCreditsReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetVirtualCreditsReportDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param contactWithNonZeroVirtualCredit (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllContactVirtualCredit(filter: string | undefined, contactWithNonZeroVirtualCredit: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfVirtualCreditContactOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetAllContactVirtualCredit?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (contactWithNonZeroVirtualCredit === null)
            throw new Error("The parameter 'contactWithNonZeroVirtualCredit' cannot be null.");
        else if (contactWithNonZeroVirtualCredit !== undefined)
            url_ += "ContactWithNonZeroVirtualCredit=" + encodeURIComponent("" + contactWithNonZeroVirtualCredit) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllContactVirtualCredit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllContactVirtualCredit(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfVirtualCreditContactOutputDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfVirtualCreditContactOutputDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllContactVirtualCredit(response: HttpResponseBase): Observable<PagedResultDtoOfVirtualCreditContactOutputDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfVirtualCreditContactOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfVirtualCreditContactOutputDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBillForEditFromReport(id: number | undefined): Observable<GetBillForEditFromReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetBillForEditFromReport?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillForEditFromReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillForEditFromReport(<any>response_);
                } catch (e) {
                    return <Observable<GetBillForEditFromReportOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBillForEditFromReportOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetBillForEditFromReport(response: HttpResponseBase): Observable<GetBillForEditFromReportOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBillForEditFromReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBillForEditFromReportOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditBillFromReport(body: CreateOrEditBillFromReportDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bills/CreateOrEditBillFromReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditBillFromReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditBillFromReport(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditBillFromReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param billId (optional) 
     * @return Success
     */
    sendCartLinkMessage(billId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bills/SendCartLinkMessage?";
        if (billId === null)
            throw new Error("The parameter 'billId' cannot be null.");
        else if (billId !== undefined)
            url_ += "billId=" + encodeURIComponent("" + billId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendCartLinkMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendCartLinkMessage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendCartLinkMessage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param payId (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateBillAndPaymentByBpInquery(payId: number | undefined, body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bills/UpdateBillAndPaymentByBpInquery?";
        if (payId === null)
            throw new Error("The parameter 'payId' cannot be null.");
        else if (payId !== undefined)
            url_ += "payId=" + encodeURIComponent("" + payId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBillAndPaymentByBpInquery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBillAndPaymentByBpInquery(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateBillAndPaymentByBpInquery(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param payId (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateUnpaiedBillAndIpgPayment(payId: number | undefined, body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bills/UpdateUnpaiedBillAndIpgPayment?";
        if (payId === null)
            throw new Error("The parameter 'payId' cannot be null.");
        else if (payId !== undefined)
            url_ += "payId=" + encodeURIComponent("" + payId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUnpaiedBillAndIpgPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUnpaiedBillAndIpgPayment(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateUnpaiedBillAndIpgPayment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getContactTotalPaid(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetContactTotalPaid";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactTotalPaid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactTotalPaid(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetContactTotalPaid(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @return Success
     */
    calculatePaidBills(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bills/CalculatePaidBills";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculatePaidBills(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculatePaidBills(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCalculatePaidBills(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getFlowerCharityTotalParticipation(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Bills/GetFlowerCharityTotalParticipation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFlowerCharityTotalParticipation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFlowerCharityTotalParticipation(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetFlowerCharityTotalParticipation(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditCharityBillForKiosk(body: CreateOrEditCharityBillForKioskInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Bills/CreateOrEditCharityBillForKiosk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditCharityBillForKiosk(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditCharityBillForKiosk(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditCharityBillForKiosk(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }
}

@Injectable()
export class BillSlaughteredsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxAverageWeightFilter (optional) 
     * @param minAverageWeightFilter (optional) 
     * @param maxCountFilter (optional) 
     * @param minCountFilter (optional) 
     * @param maxAveragePriceFilter (optional) 
     * @param minAveragePriceFilter (optional) 
     * @param maxAverageRatioFilter (optional) 
     * @param minAverageRatioFilter (optional) 
     * @param codeFilter (optional) 
     * @param slaughterAgentSlaughterhouseNameFilter (optional) 
     * @param slaughterAgentIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, maxAverageWeightFilter: number | undefined, minAverageWeightFilter: number | undefined, maxCountFilter: number | undefined, minCountFilter: number | undefined, maxAveragePriceFilter: number | undefined, minAveragePriceFilter: number | undefined, maxAverageRatioFilter: number | undefined, minAverageRatioFilter: number | undefined, codeFilter: string | undefined, slaughterAgentSlaughterhouseNameFilter: string | undefined, slaughterAgentIdFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetBillSlaughteredForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/BillSlaughtereds/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxAverageWeightFilter === null)
            throw new Error("The parameter 'maxAverageWeightFilter' cannot be null.");
        else if (maxAverageWeightFilter !== undefined)
            url_ += "MaxAverageWeightFilter=" + encodeURIComponent("" + maxAverageWeightFilter) + "&"; 
        if (minAverageWeightFilter === null)
            throw new Error("The parameter 'minAverageWeightFilter' cannot be null.");
        else if (minAverageWeightFilter !== undefined)
            url_ += "MinAverageWeightFilter=" + encodeURIComponent("" + minAverageWeightFilter) + "&"; 
        if (maxCountFilter === null)
            throw new Error("The parameter 'maxCountFilter' cannot be null.");
        else if (maxCountFilter !== undefined)
            url_ += "MaxCountFilter=" + encodeURIComponent("" + maxCountFilter) + "&"; 
        if (minCountFilter === null)
            throw new Error("The parameter 'minCountFilter' cannot be null.");
        else if (minCountFilter !== undefined)
            url_ += "MinCountFilter=" + encodeURIComponent("" + minCountFilter) + "&"; 
        if (maxAveragePriceFilter === null)
            throw new Error("The parameter 'maxAveragePriceFilter' cannot be null.");
        else if (maxAveragePriceFilter !== undefined)
            url_ += "MaxAveragePriceFilter=" + encodeURIComponent("" + maxAveragePriceFilter) + "&"; 
        if (minAveragePriceFilter === null)
            throw new Error("The parameter 'minAveragePriceFilter' cannot be null.");
        else if (minAveragePriceFilter !== undefined)
            url_ += "MinAveragePriceFilter=" + encodeURIComponent("" + minAveragePriceFilter) + "&"; 
        if (maxAverageRatioFilter === null)
            throw new Error("The parameter 'maxAverageRatioFilter' cannot be null.");
        else if (maxAverageRatioFilter !== undefined)
            url_ += "MaxAverageRatioFilter=" + encodeURIComponent("" + maxAverageRatioFilter) + "&"; 
        if (minAverageRatioFilter === null)
            throw new Error("The parameter 'minAverageRatioFilter' cannot be null.");
        else if (minAverageRatioFilter !== undefined)
            url_ += "MinAverageRatioFilter=" + encodeURIComponent("" + minAverageRatioFilter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (slaughterAgentSlaughterhouseNameFilter === null)
            throw new Error("The parameter 'slaughterAgentSlaughterhouseNameFilter' cannot be null.");
        else if (slaughterAgentSlaughterhouseNameFilter !== undefined)
            url_ += "SlaughterAgentSlaughterhouseNameFilter=" + encodeURIComponent("" + slaughterAgentSlaughterhouseNameFilter) + "&"; 
        if (slaughterAgentIdFilter === null)
            throw new Error("The parameter 'slaughterAgentIdFilter' cannot be null.");
        else if (slaughterAgentIdFilter !== undefined)
            url_ += "SlaughterAgentIdFilter=" + encodeURIComponent("" + slaughterAgentIdFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetBillSlaughteredForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetBillSlaughteredForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetBillSlaughteredForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetBillSlaughteredForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBillSlaughteredForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBillSlaughteredForView(id: number | undefined): Observable<GetBillSlaughteredForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/BillSlaughtereds/GetBillSlaughteredForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillSlaughteredForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillSlaughteredForView(<any>response_);
                } catch (e) {
                    return <Observable<GetBillSlaughteredForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBillSlaughteredForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetBillSlaughteredForView(response: HttpResponseBase): Observable<GetBillSlaughteredForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBillSlaughteredForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBillSlaughteredForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBillSlaughteredForEdit(id: number | undefined): Observable<GetBillSlaughteredForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/BillSlaughtereds/GetBillSlaughteredForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillSlaughteredForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillSlaughteredForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetBillSlaughteredForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBillSlaughteredForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetBillSlaughteredForEdit(response: HttpResponseBase): Observable<GetBillSlaughteredForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBillSlaughteredForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBillSlaughteredForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditBillSlaughteredDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BillSlaughtereds/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAndGetId(body: CreateOrEditBillSlaughteredDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/BillSlaughtereds/CreateAndGetId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAndGetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAndGetId(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateAndGetId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BillSlaughtereds/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param maxAverageWeightFilter (optional) 
     * @param minAverageWeightFilter (optional) 
     * @param maxCountFilter (optional) 
     * @param minCountFilter (optional) 
     * @param maxAveragePriceFilter (optional) 
     * @param minAveragePriceFilter (optional) 
     * @param maxAverageRatioFilter (optional) 
     * @param minAverageRatioFilter (optional) 
     * @param codeFilter (optional) 
     * @param slaughterAgentSlaughterhouseNameFilter (optional) 
     * @return Success
     */
    getBillSlaughteredsToExcel(filter: string | undefined, maxAverageWeightFilter: number | undefined, minAverageWeightFilter: number | undefined, maxCountFilter: number | undefined, minCountFilter: number | undefined, maxAveragePriceFilter: number | undefined, minAveragePriceFilter: number | undefined, maxAverageRatioFilter: number | undefined, minAverageRatioFilter: number | undefined, codeFilter: string | undefined, slaughterAgentSlaughterhouseNameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/BillSlaughtereds/GetBillSlaughteredsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxAverageWeightFilter === null)
            throw new Error("The parameter 'maxAverageWeightFilter' cannot be null.");
        else if (maxAverageWeightFilter !== undefined)
            url_ += "MaxAverageWeightFilter=" + encodeURIComponent("" + maxAverageWeightFilter) + "&"; 
        if (minAverageWeightFilter === null)
            throw new Error("The parameter 'minAverageWeightFilter' cannot be null.");
        else if (minAverageWeightFilter !== undefined)
            url_ += "MinAverageWeightFilter=" + encodeURIComponent("" + minAverageWeightFilter) + "&"; 
        if (maxCountFilter === null)
            throw new Error("The parameter 'maxCountFilter' cannot be null.");
        else if (maxCountFilter !== undefined)
            url_ += "MaxCountFilter=" + encodeURIComponent("" + maxCountFilter) + "&"; 
        if (minCountFilter === null)
            throw new Error("The parameter 'minCountFilter' cannot be null.");
        else if (minCountFilter !== undefined)
            url_ += "MinCountFilter=" + encodeURIComponent("" + minCountFilter) + "&"; 
        if (maxAveragePriceFilter === null)
            throw new Error("The parameter 'maxAveragePriceFilter' cannot be null.");
        else if (maxAveragePriceFilter !== undefined)
            url_ += "MaxAveragePriceFilter=" + encodeURIComponent("" + maxAveragePriceFilter) + "&"; 
        if (minAveragePriceFilter === null)
            throw new Error("The parameter 'minAveragePriceFilter' cannot be null.");
        else if (minAveragePriceFilter !== undefined)
            url_ += "MinAveragePriceFilter=" + encodeURIComponent("" + minAveragePriceFilter) + "&"; 
        if (maxAverageRatioFilter === null)
            throw new Error("The parameter 'maxAverageRatioFilter' cannot be null.");
        else if (maxAverageRatioFilter !== undefined)
            url_ += "MaxAverageRatioFilter=" + encodeURIComponent("" + maxAverageRatioFilter) + "&"; 
        if (minAverageRatioFilter === null)
            throw new Error("The parameter 'minAverageRatioFilter' cannot be null.");
        else if (minAverageRatioFilter !== undefined)
            url_ += "MinAverageRatioFilter=" + encodeURIComponent("" + minAverageRatioFilter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (slaughterAgentSlaughterhouseNameFilter === null)
            throw new Error("The parameter 'slaughterAgentSlaughterhouseNameFilter' cannot be null.");
        else if (slaughterAgentSlaughterhouseNameFilter !== undefined)
            url_ += "SlaughterAgentSlaughterhouseNameFilter=" + encodeURIComponent("" + slaughterAgentSlaughterhouseNameFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillSlaughteredsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillSlaughteredsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetBillSlaughteredsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllSlaughterAgentForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfBillSlaughteredSlaughterAgentLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/BillSlaughtereds/GetAllSlaughterAgentForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSlaughterAgentForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSlaughterAgentForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfBillSlaughteredSlaughterAgentLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfBillSlaughteredSlaughterAgentLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSlaughterAgentForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfBillSlaughteredSlaughterAgentLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfBillSlaughteredSlaughterAgentLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfBillSlaughteredSlaughterAgentLookupTableDto>(<any>null);
    }
}

@Injectable()
export class BillTokensServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param tokenFilter (optional) 
     * @param billCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, tokenFilter: string | undefined, billCodeFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetBillTokenForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/BillTokens/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (tokenFilter === null)
            throw new Error("The parameter 'tokenFilter' cannot be null.");
        else if (tokenFilter !== undefined)
            url_ += "TokenFilter=" + encodeURIComponent("" + tokenFilter) + "&"; 
        if (billCodeFilter === null)
            throw new Error("The parameter 'billCodeFilter' cannot be null.");
        else if (billCodeFilter !== undefined)
            url_ += "BillCodeFilter=" + encodeURIComponent("" + billCodeFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetBillTokenForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetBillTokenForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetBillTokenForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetBillTokenForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBillTokenForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBillTokenForEdit(id: number | undefined): Observable<GetBillTokenForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/BillTokens/GetBillTokenForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillTokenForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillTokenForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetBillTokenForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBillTokenForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetBillTokenForEdit(response: HttpResponseBase): Observable<GetBillTokenForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBillTokenForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBillTokenForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditBillTokenDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BillTokens/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BillTokens/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllBillForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfBillTokenBillLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/BillTokens/GetAllBillForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBillForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBillForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfBillTokenBillLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfBillTokenBillLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBillForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfBillTokenBillLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfBillTokenBillLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfBillTokenBillLookupTableDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendBillLinkMessage(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BillTokens/SendBillLinkMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendBillLinkMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendBillLinkMessage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendBillLinkMessage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param billId (optional) 
     * @return Success
     */
    expireBillToken(billId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BillTokens/ExpireBillToken?";
        if (billId === null)
            throw new Error("The parameter 'billId' cannot be null.");
        else if (billId !== undefined)
            url_ += "billId=" + encodeURIComponent("" + billId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExpireBillToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExpireBillToken(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExpireBillToken(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param token (optional) 
     * @return Success
     */
    getBillsByToken(token: string | undefined): Observable<GetBillsByTokenOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/BillTokens/GetBillsByToken?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillsByToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillsByToken(<any>response_);
                } catch (e) {
                    return <Observable<GetBillsByTokenOutputDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBillsByTokenOutputDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetBillsByToken(response: HttpResponseBase): Observable<GetBillsByTokenOutputDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBillsByTokenOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBillsByTokenOutputDto>(<any>null);
    }
}

@Injectable()
export class BranchCommoditiesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxInventoryFilter (optional) 
     * @param minInventoryFilter (optional) 
     * @param branchNameFilter (optional) 
     * @param commodityTitleFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, maxInventoryFilter: number | undefined, minInventoryFilter: number | undefined, branchNameFilter: string | undefined, commodityTitleFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetBranchCommodityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/BranchCommodities/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxInventoryFilter === null)
            throw new Error("The parameter 'maxInventoryFilter' cannot be null.");
        else if (maxInventoryFilter !== undefined)
            url_ += "MaxInventoryFilter=" + encodeURIComponent("" + maxInventoryFilter) + "&"; 
        if (minInventoryFilter === null)
            throw new Error("The parameter 'minInventoryFilter' cannot be null.");
        else if (minInventoryFilter !== undefined)
            url_ += "MinInventoryFilter=" + encodeURIComponent("" + minInventoryFilter) + "&"; 
        if (branchNameFilter === null)
            throw new Error("The parameter 'branchNameFilter' cannot be null.");
        else if (branchNameFilter !== undefined)
            url_ += "BranchNameFilter=" + encodeURIComponent("" + branchNameFilter) + "&"; 
        if (commodityTitleFilter === null)
            throw new Error("The parameter 'commodityTitleFilter' cannot be null.");
        else if (commodityTitleFilter !== undefined)
            url_ += "CommodityTitleFilter=" + encodeURIComponent("" + commodityTitleFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetBranchCommodityForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetBranchCommodityForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetBranchCommodityForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetBranchCommodityForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBranchCommodityForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBranchCommodityForView(id: number | undefined): Observable<GetBranchCommodityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/BranchCommodities/GetBranchCommodityForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBranchCommodityForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBranchCommodityForView(<any>response_);
                } catch (e) {
                    return <Observable<GetBranchCommodityForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBranchCommodityForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetBranchCommodityForView(response: HttpResponseBase): Observable<GetBranchCommodityForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBranchCommodityForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBranchCommodityForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBranchCommodityForEdit(id: number | undefined): Observable<GetBranchCommodityForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/BranchCommodities/GetBranchCommodityForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBranchCommodityForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBranchCommodityForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetBranchCommodityForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBranchCommodityForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetBranchCommodityForEdit(response: HttpResponseBase): Observable<GetBranchCommodityForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBranchCommodityForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBranchCommodityForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditBranchCommodityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BranchCommodities/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BranchCommodities/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param maxInventoryFilter (optional) 
     * @param minInventoryFilter (optional) 
     * @param branchNameFilter (optional) 
     * @param commodityTitleFilter (optional) 
     * @return Success
     */
    getBranchCommoditiesToExcel(filter: string | undefined, maxInventoryFilter: number | undefined, minInventoryFilter: number | undefined, branchNameFilter: string | undefined, commodityTitleFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/BranchCommodities/GetBranchCommoditiesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxInventoryFilter === null)
            throw new Error("The parameter 'maxInventoryFilter' cannot be null.");
        else if (maxInventoryFilter !== undefined)
            url_ += "MaxInventoryFilter=" + encodeURIComponent("" + maxInventoryFilter) + "&"; 
        if (minInventoryFilter === null)
            throw new Error("The parameter 'minInventoryFilter' cannot be null.");
        else if (minInventoryFilter !== undefined)
            url_ += "MinInventoryFilter=" + encodeURIComponent("" + minInventoryFilter) + "&"; 
        if (branchNameFilter === null)
            throw new Error("The parameter 'branchNameFilter' cannot be null.");
        else if (branchNameFilter !== undefined)
            url_ += "BranchNameFilter=" + encodeURIComponent("" + branchNameFilter) + "&"; 
        if (commodityTitleFilter === null)
            throw new Error("The parameter 'commodityTitleFilter' cannot be null.");
        else if (commodityTitleFilter !== undefined)
            url_ += "CommodityTitleFilter=" + encodeURIComponent("" + commodityTitleFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBranchCommoditiesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBranchCommoditiesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetBranchCommoditiesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllBranchForTableDropdown(): Observable<BranchCommodityBranchLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BranchCommodities/GetAllBranchForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBranchForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBranchForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<BranchCommodityBranchLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<BranchCommodityBranchLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBranchForTableDropdown(response: HttpResponseBase): Observable<BranchCommodityBranchLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BranchCommodityBranchLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BranchCommodityBranchLookupTableDto[]>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCommodityForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfBranchCommodityCommodityLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/BranchCommodities/GetAllCommodityForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCommodityForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCommodityForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfBranchCommodityCommodityLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfBranchCommodityCommodityLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCommodityForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfBranchCommodityCommodityLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfBranchCommodityCommodityLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfBranchCommodityCommodityLookupTableDto>(<any>null);
    }
}

@Injectable()
export class BranchDirectionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param serviseFilter (optional) 
     * @param branchNameFilter (optional) 
     * @param directionNameFilter (optional) 
     * @param branchIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, serviseFilter: number | undefined, branchNameFilter: string | undefined, directionNameFilter: string | undefined, branchIdFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetBranchDirectionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/BranchDirections/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (serviseFilter === null)
            throw new Error("The parameter 'serviseFilter' cannot be null.");
        else if (serviseFilter !== undefined)
            url_ += "ServiseFilter=" + encodeURIComponent("" + serviseFilter) + "&"; 
        if (branchNameFilter === null)
            throw new Error("The parameter 'branchNameFilter' cannot be null.");
        else if (branchNameFilter !== undefined)
            url_ += "BranchNameFilter=" + encodeURIComponent("" + branchNameFilter) + "&"; 
        if (directionNameFilter === null)
            throw new Error("The parameter 'directionNameFilter' cannot be null.");
        else if (directionNameFilter !== undefined)
            url_ += "DirectionNameFilter=" + encodeURIComponent("" + directionNameFilter) + "&"; 
        if (branchIdFilter === null)
            throw new Error("The parameter 'branchIdFilter' cannot be null.");
        else if (branchIdFilter !== undefined)
            url_ += "BranchIdFilter=" + encodeURIComponent("" + branchIdFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetBranchDirectionForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetBranchDirectionForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetBranchDirectionForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetBranchDirectionForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBranchDirectionForViewDto>(<any>null);
    }

    /**
     * @param branchId (optional) 
     * @return Success
     */
    getBranchLatLngForView(branchId: number | undefined): Observable<GetBranchLatLng> {
        let url_ = this.baseUrl + "/api/services/app/BranchDirections/GetBranchLatLngForView?";
        if (branchId === null)
            throw new Error("The parameter 'branchId' cannot be null.");
        else if (branchId !== undefined)
            url_ += "branchId=" + encodeURIComponent("" + branchId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBranchLatLngForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBranchLatLngForView(<any>response_);
                } catch (e) {
                    return <Observable<GetBranchLatLng>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBranchLatLng>><any>_observableThrow(response_);
        }));
    }

    protected processGetBranchLatLngForView(response: HttpResponseBase): Observable<GetBranchLatLng> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBranchLatLng.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBranchLatLng>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBranchDirectionForView(id: number | undefined): Observable<GetBranchDirectionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/BranchDirections/GetBranchDirectionForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBranchDirectionForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBranchDirectionForView(<any>response_);
                } catch (e) {
                    return <Observable<GetBranchDirectionForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBranchDirectionForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetBranchDirectionForView(response: HttpResponseBase): Observable<GetBranchDirectionForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBranchDirectionForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBranchDirectionForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBranchDirectionForEdit(id: number | undefined): Observable<GetBranchDirectionForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/BranchDirections/GetBranchDirectionForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBranchDirectionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBranchDirectionForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetBranchDirectionForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBranchDirectionForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetBranchDirectionForEdit(response: HttpResponseBase): Observable<GetBranchDirectionForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBranchDirectionForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBranchDirectionForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditBranchDirection(body: GetBranchDirectionAndPointsForEditOutput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BranchDirections/CreateOrEditBranchDirection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditBranchDirection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditBranchDirection(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditBranchDirection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBranchDirectionAndPointsForEdit(id: number | undefined): Observable<GetBranchDirectionAndPointsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/BranchDirections/GetBranchDirectionAndPointsForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBranchDirectionAndPointsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBranchDirectionAndPointsForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetBranchDirectionAndPointsForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBranchDirectionAndPointsForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetBranchDirectionAndPointsForEdit(response: HttpResponseBase): Observable<GetBranchDirectionAndPointsForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBranchDirectionAndPointsForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBranchDirectionAndPointsForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditBranchDirectionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BranchDirections/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BranchDirections/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param serviseFilter (optional) 
     * @param branchNameFilter (optional) 
     * @param directionNameFilter (optional) 
     * @return Success
     */
    getBranchDirectionsToExcel(filter: string | undefined, serviseFilter: number | undefined, branchNameFilter: string | undefined, directionNameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/BranchDirections/GetBranchDirectionsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (serviseFilter === null)
            throw new Error("The parameter 'serviseFilter' cannot be null.");
        else if (serviseFilter !== undefined)
            url_ += "ServiseFilter=" + encodeURIComponent("" + serviseFilter) + "&"; 
        if (branchNameFilter === null)
            throw new Error("The parameter 'branchNameFilter' cannot be null.");
        else if (branchNameFilter !== undefined)
            url_ += "BranchNameFilter=" + encodeURIComponent("" + branchNameFilter) + "&"; 
        if (directionNameFilter === null)
            throw new Error("The parameter 'directionNameFilter' cannot be null.");
        else if (directionNameFilter !== undefined)
            url_ += "DirectionNameFilter=" + encodeURIComponent("" + directionNameFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBranchDirectionsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBranchDirectionsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetBranchDirectionsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllBranchForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfBranchDirectionBranchLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/BranchDirections/GetAllBranchForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBranchForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBranchForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfBranchDirectionBranchLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfBranchDirectionBranchLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBranchForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfBranchDirectionBranchLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfBranchDirectionBranchLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfBranchDirectionBranchLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllDirectionForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfBranchDirectionDirectionLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/BranchDirections/GetAllDirectionForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDirectionForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDirectionForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfBranchDirectionDirectionLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfBranchDirectionDirectionLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllDirectionForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfBranchDirectionDirectionLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfBranchDirectionDirectionLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfBranchDirectionDirectionLookupTableDto>(<any>null);
    }
}

@Injectable()
export class BranchesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param stateFilter (optional) 
     * @param contactFirstNameFilter (optional) 
     * @param branchNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, nameFilter: string | undefined, phoneFilter: string | undefined, stateFilter: number | undefined, contactFirstNameFilter: string | undefined, branchNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetBranchForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Branches/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&"; 
        if (phoneFilter === null)
            throw new Error("The parameter 'phoneFilter' cannot be null.");
        else if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (contactFirstNameFilter === null)
            throw new Error("The parameter 'contactFirstNameFilter' cannot be null.");
        else if (contactFirstNameFilter !== undefined)
            url_ += "ContactFirstNameFilter=" + encodeURIComponent("" + contactFirstNameFilter) + "&"; 
        if (branchNameFilter === null)
            throw new Error("The parameter 'branchNameFilter' cannot be null.");
        else if (branchNameFilter !== undefined)
            url_ += "BranchNameFilter=" + encodeURIComponent("" + branchNameFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetBranchForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetBranchForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetBranchForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetBranchForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBranchForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBranchForView(id: number | undefined): Observable<GetBranchForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Branches/GetBranchForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBranchForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBranchForView(<any>response_);
                } catch (e) {
                    return <Observable<GetBranchForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBranchForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetBranchForView(response: HttpResponseBase): Observable<GetBranchForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBranchForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBranchForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBranchForEdit(id: number | undefined): Observable<GetBranchForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Branches/GetBranchForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBranchForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBranchForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetBranchForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBranchForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetBranchForEdit(response: HttpResponseBase): Observable<GetBranchForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBranchForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBranchForEditOutput>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBranchAndAddressForEdit(id: number | undefined): Observable<GetBrachAndAddressForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Branches/GetBranchAndAddressForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBranchAndAddressForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBranchAndAddressForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetBrachAndAddressForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBrachAndAddressForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetBranchAndAddressForEdit(response: HttpResponseBase): Observable<GetBrachAndAddressForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBrachAndAddressForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBrachAndAddressForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditBranchDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Branches/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditBranchAndAddress(body: CreateOrEditBranchAndAddressDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Branches/CreateOrEditBranchAndAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditBranchAndAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditBranchAndAddress(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditBranchAndAddress(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAndGetId(body: CreateOrEditBranchDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Branches/CreateAndGetId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAndGetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAndGetId(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateAndGetId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Branches/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param stateFilter (optional) 
     * @param contactFirstNameFilter (optional) 
     * @param branchNameFilter (optional) 
     * @return Success
     */
    getBranchesToExcel(filter: string | undefined, nameFilter: string | undefined, phoneFilter: string | undefined, stateFilter: number | undefined, contactFirstNameFilter: string | undefined, branchNameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Branches/GetBranchesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&"; 
        if (phoneFilter === null)
            throw new Error("The parameter 'phoneFilter' cannot be null.");
        else if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (contactFirstNameFilter === null)
            throw new Error("The parameter 'contactFirstNameFilter' cannot be null.");
        else if (contactFirstNameFilter !== undefined)
            url_ += "ContactFirstNameFilter=" + encodeURIComponent("" + contactFirstNameFilter) + "&"; 
        if (branchNameFilter === null)
            throw new Error("The parameter 'branchNameFilter' cannot be null.");
        else if (branchNameFilter !== undefined)
            url_ += "BranchNameFilter=" + encodeURIComponent("" + branchNameFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBranchesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBranchesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetBranchesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllContactForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfBranchContactLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Branches/GetAllContactForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllContactForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllContactForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfBranchContactLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfBranchContactLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllContactForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfBranchContactLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfBranchContactLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfBranchContactLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllAddressForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfBranchAddressLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Branches/GetAllAddressForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAddressForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAddressForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfBranchAddressLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfBranchAddressLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllAddressForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfBranchAddressLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfBranchAddressLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfBranchAddressLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllDirectionForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfBranchDirectionLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Branches/GetAllDirectionForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDirectionForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDirectionForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfBranchDirectionLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfBranchDirectionLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllDirectionForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfBranchDirectionLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfBranchDirectionLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfBranchDirectionLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllBranchForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfBranchBranchLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Branches/GetAllBranchForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBranchForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBranchForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfBranchBranchLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfBranchBranchLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBranchForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfBranchBranchLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfBranchBranchLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfBranchBranchLookupTableDto>(<any>null);
    }
}

@Injectable()
export class CachingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllCaches(): Observable<ListResultDtoOfCacheDto> {
        let url_ = this.baseUrl + "/api/services/app/Caching/GetAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCaches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCaches(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfCacheDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfCacheDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCaches(response: HttpResponseBase): Observable<ListResultDtoOfCacheDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfCacheDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfCacheDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    clearCache(body: EntityDtoOfString | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Caching/ClearCache";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearCache(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processClearCache(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    clearAllCaches(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Caching/ClearAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearAllCaches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearAllCaches(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processClearAllCaches(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class CardTemplatePropertiesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param displayTitleFilter (optional) 
     * @param maxXFilter (optional) 
     * @param minXFilter (optional) 
     * @param maxYFilter (optional) 
     * @param minYFilter (optional) 
     * @param fontNameFilter (optional) 
     * @param fontSizeFilter (optional) 
     * @param maxCharactersLimiteFilter (optional) 
     * @param minCharactersLimiteFilter (optional) 
     * @param defaultTitleFilter (optional) 
     * @param cardTemplateTitleFilter (optional) 
     * @param cardTemplateRefFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, displayTitleFilter: string | undefined, maxXFilter: number | undefined, minXFilter: number | undefined, maxYFilter: number | undefined, minYFilter: number | undefined, fontNameFilter: string | undefined, fontSizeFilter: string | undefined, maxCharactersLimiteFilter: number | undefined, minCharactersLimiteFilter: number | undefined, defaultTitleFilter: number | undefined, cardTemplateTitleFilter: string | undefined, cardTemplateRefFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCardTemplatePropertyForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplateProperties/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (displayTitleFilter === null)
            throw new Error("The parameter 'displayTitleFilter' cannot be null.");
        else if (displayTitleFilter !== undefined)
            url_ += "DisplayTitleFilter=" + encodeURIComponent("" + displayTitleFilter) + "&"; 
        if (maxXFilter === null)
            throw new Error("The parameter 'maxXFilter' cannot be null.");
        else if (maxXFilter !== undefined)
            url_ += "MaxXFilter=" + encodeURIComponent("" + maxXFilter) + "&"; 
        if (minXFilter === null)
            throw new Error("The parameter 'minXFilter' cannot be null.");
        else if (minXFilter !== undefined)
            url_ += "MinXFilter=" + encodeURIComponent("" + minXFilter) + "&"; 
        if (maxYFilter === null)
            throw new Error("The parameter 'maxYFilter' cannot be null.");
        else if (maxYFilter !== undefined)
            url_ += "MaxYFilter=" + encodeURIComponent("" + maxYFilter) + "&"; 
        if (minYFilter === null)
            throw new Error("The parameter 'minYFilter' cannot be null.");
        else if (minYFilter !== undefined)
            url_ += "MinYFilter=" + encodeURIComponent("" + minYFilter) + "&"; 
        if (fontNameFilter === null)
            throw new Error("The parameter 'fontNameFilter' cannot be null.");
        else if (fontNameFilter !== undefined)
            url_ += "FontNameFilter=" + encodeURIComponent("" + fontNameFilter) + "&"; 
        if (fontSizeFilter === null)
            throw new Error("The parameter 'fontSizeFilter' cannot be null.");
        else if (fontSizeFilter !== undefined)
            url_ += "FontSizeFilter=" + encodeURIComponent("" + fontSizeFilter) + "&"; 
        if (maxCharactersLimiteFilter === null)
            throw new Error("The parameter 'maxCharactersLimiteFilter' cannot be null.");
        else if (maxCharactersLimiteFilter !== undefined)
            url_ += "MaxCharactersLimiteFilter=" + encodeURIComponent("" + maxCharactersLimiteFilter) + "&"; 
        if (minCharactersLimiteFilter === null)
            throw new Error("The parameter 'minCharactersLimiteFilter' cannot be null.");
        else if (minCharactersLimiteFilter !== undefined)
            url_ += "MinCharactersLimiteFilter=" + encodeURIComponent("" + minCharactersLimiteFilter) + "&"; 
        if (defaultTitleFilter === null)
            throw new Error("The parameter 'defaultTitleFilter' cannot be null.");
        else if (defaultTitleFilter !== undefined)
            url_ += "DefaultTitleFilter=" + encodeURIComponent("" + defaultTitleFilter) + "&"; 
        if (cardTemplateTitleFilter === null)
            throw new Error("The parameter 'cardTemplateTitleFilter' cannot be null.");
        else if (cardTemplateTitleFilter !== undefined)
            url_ += "CardTemplateTitleFilter=" + encodeURIComponent("" + cardTemplateTitleFilter) + "&"; 
        if (cardTemplateRefFilter === null)
            throw new Error("The parameter 'cardTemplateRefFilter' cannot be null.");
        else if (cardTemplateRefFilter !== undefined)
            url_ += "CardTemplateRefFilter=" + encodeURIComponent("" + cardTemplateRefFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCardTemplatePropertyForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCardTemplatePropertyForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCardTemplatePropertyForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCardTemplatePropertyForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCardTemplatePropertyForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCardTemplatePropertyForView(id: number | undefined): Observable<GetCardTemplatePropertyForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplateProperties/GetCardTemplatePropertyForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCardTemplatePropertyForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCardTemplatePropertyForView(<any>response_);
                } catch (e) {
                    return <Observable<GetCardTemplatePropertyForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCardTemplatePropertyForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCardTemplatePropertyForView(response: HttpResponseBase): Observable<GetCardTemplatePropertyForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCardTemplatePropertyForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCardTemplatePropertyForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCardTemplatePropertyForEdit(id: number | undefined): Observable<GetCardTemplatePropertyForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplateProperties/GetCardTemplatePropertyForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCardTemplatePropertyForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCardTemplatePropertyForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetCardTemplatePropertyForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCardTemplatePropertyForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCardTemplatePropertyForEdit(response: HttpResponseBase): Observable<GetCardTemplatePropertyForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCardTemplatePropertyForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCardTemplatePropertyForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditCardTemplatePropertyDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplateProperties/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplateProperties/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param displayTitleFilter (optional) 
     * @param maxXFilter (optional) 
     * @param minXFilter (optional) 
     * @param maxYFilter (optional) 
     * @param minYFilter (optional) 
     * @param fontNameFilter (optional) 
     * @param fontSizeFilter (optional) 
     * @param maxCharactersLimiteFilter (optional) 
     * @param minCharactersLimiteFilter (optional) 
     * @param defaultTitleFilter (optional) 
     * @param cardTemplateTitleFilter (optional) 
     * @return Success
     */
    getCardTemplatePropertiesToExcel(filter: string | undefined, displayTitleFilter: string | undefined, maxXFilter: number | undefined, minXFilter: number | undefined, maxYFilter: number | undefined, minYFilter: number | undefined, fontNameFilter: string | undefined, fontSizeFilter: string | undefined, maxCharactersLimiteFilter: number | undefined, minCharactersLimiteFilter: number | undefined, defaultTitleFilter: number | undefined, cardTemplateTitleFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplateProperties/GetCardTemplatePropertiesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (displayTitleFilter === null)
            throw new Error("The parameter 'displayTitleFilter' cannot be null.");
        else if (displayTitleFilter !== undefined)
            url_ += "DisplayTitleFilter=" + encodeURIComponent("" + displayTitleFilter) + "&"; 
        if (maxXFilter === null)
            throw new Error("The parameter 'maxXFilter' cannot be null.");
        else if (maxXFilter !== undefined)
            url_ += "MaxXFilter=" + encodeURIComponent("" + maxXFilter) + "&"; 
        if (minXFilter === null)
            throw new Error("The parameter 'minXFilter' cannot be null.");
        else if (minXFilter !== undefined)
            url_ += "MinXFilter=" + encodeURIComponent("" + minXFilter) + "&"; 
        if (maxYFilter === null)
            throw new Error("The parameter 'maxYFilter' cannot be null.");
        else if (maxYFilter !== undefined)
            url_ += "MaxYFilter=" + encodeURIComponent("" + maxYFilter) + "&"; 
        if (minYFilter === null)
            throw new Error("The parameter 'minYFilter' cannot be null.");
        else if (minYFilter !== undefined)
            url_ += "MinYFilter=" + encodeURIComponent("" + minYFilter) + "&"; 
        if (fontNameFilter === null)
            throw new Error("The parameter 'fontNameFilter' cannot be null.");
        else if (fontNameFilter !== undefined)
            url_ += "FontNameFilter=" + encodeURIComponent("" + fontNameFilter) + "&"; 
        if (fontSizeFilter === null)
            throw new Error("The parameter 'fontSizeFilter' cannot be null.");
        else if (fontSizeFilter !== undefined)
            url_ += "FontSizeFilter=" + encodeURIComponent("" + fontSizeFilter) + "&"; 
        if (maxCharactersLimiteFilter === null)
            throw new Error("The parameter 'maxCharactersLimiteFilter' cannot be null.");
        else if (maxCharactersLimiteFilter !== undefined)
            url_ += "MaxCharactersLimiteFilter=" + encodeURIComponent("" + maxCharactersLimiteFilter) + "&"; 
        if (minCharactersLimiteFilter === null)
            throw new Error("The parameter 'minCharactersLimiteFilter' cannot be null.");
        else if (minCharactersLimiteFilter !== undefined)
            url_ += "MinCharactersLimiteFilter=" + encodeURIComponent("" + minCharactersLimiteFilter) + "&"; 
        if (defaultTitleFilter === null)
            throw new Error("The parameter 'defaultTitleFilter' cannot be null.");
        else if (defaultTitleFilter !== undefined)
            url_ += "DefaultTitleFilter=" + encodeURIComponent("" + defaultTitleFilter) + "&"; 
        if (cardTemplateTitleFilter === null)
            throw new Error("The parameter 'cardTemplateTitleFilter' cannot be null.");
        else if (cardTemplateTitleFilter !== undefined)
            url_ += "CardTemplateTitleFilter=" + encodeURIComponent("" + cardTemplateTitleFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCardTemplatePropertiesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCardTemplatePropertiesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCardTemplatePropertiesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCardTemplateForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfCardTemplatePropertyCardTemplateLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplateProperties/GetAllCardTemplateForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCardTemplateForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCardTemplateForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCardTemplatePropertyCardTemplateLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfCardTemplatePropertyCardTemplateLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCardTemplateForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfCardTemplatePropertyCardTemplateLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCardTemplatePropertyCardTemplateLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCardTemplatePropertyCardTemplateLookupTableDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generatePreviewBill(body: CardTemplatePreviewDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplateProperties/GeneratePreviewBill";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneratePreviewBill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneratePreviewBill(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGeneratePreviewBill(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generatePreviewCardTemplate(body: GenerateCardTemplatePreviewDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplateProperties/GeneratePreviewCardTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneratePreviewCardTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneratePreviewCardTemplate(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGeneratePreviewCardTemplate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class CardTemplatesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param imagePathFilter (optional) 
     * @param maxWidthFilter (optional) 
     * @param minWidthFilter (optional) 
     * @param maxLengthFilter (optional) 
     * @param minLengthFilter (optional) 
     * @param typeFilter (optional) 
     * @param isDefaultFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, titleFilter: string | undefined, isActiveFilter: number | undefined, descriptionFilter: string | undefined, imagePathFilter: string | undefined, maxWidthFilter: number | undefined, minWidthFilter: number | undefined, maxLengthFilter: number | undefined, minLengthFilter: number | undefined, typeFilter: number | undefined, isDefaultFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCardTemplateForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplates/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (isActiveFilter === null)
            throw new Error("The parameter 'isActiveFilter' cannot be null.");
        else if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (imagePathFilter === null)
            throw new Error("The parameter 'imagePathFilter' cannot be null.");
        else if (imagePathFilter !== undefined)
            url_ += "ImagePathFilter=" + encodeURIComponent("" + imagePathFilter) + "&"; 
        if (maxWidthFilter === null)
            throw new Error("The parameter 'maxWidthFilter' cannot be null.");
        else if (maxWidthFilter !== undefined)
            url_ += "MaxWidthFilter=" + encodeURIComponent("" + maxWidthFilter) + "&"; 
        if (minWidthFilter === null)
            throw new Error("The parameter 'minWidthFilter' cannot be null.");
        else if (minWidthFilter !== undefined)
            url_ += "MinWidthFilter=" + encodeURIComponent("" + minWidthFilter) + "&"; 
        if (maxLengthFilter === null)
            throw new Error("The parameter 'maxLengthFilter' cannot be null.");
        else if (maxLengthFilter !== undefined)
            url_ += "MaxLengthFilter=" + encodeURIComponent("" + maxLengthFilter) + "&"; 
        if (minLengthFilter === null)
            throw new Error("The parameter 'minLengthFilter' cannot be null.");
        else if (minLengthFilter !== undefined)
            url_ += "MinLengthFilter=" + encodeURIComponent("" + minLengthFilter) + "&"; 
        if (typeFilter === null)
            throw new Error("The parameter 'typeFilter' cannot be null.");
        else if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&"; 
        if (isDefaultFilter === null)
            throw new Error("The parameter 'isDefaultFilter' cannot be null.");
        else if (isDefaultFilter !== undefined)
            url_ += "IsDefaultFilter=" + encodeURIComponent("" + isDefaultFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCardTemplateForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCardTemplateForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCardTemplateForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCardTemplateForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCardTemplateForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCardTemplateForView(id: number | undefined): Observable<GetCardTemplateForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplates/GetCardTemplateForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCardTemplateForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCardTemplateForView(<any>response_);
                } catch (e) {
                    return <Observable<GetCardTemplateForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCardTemplateForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCardTemplateForView(response: HttpResponseBase): Observable<GetCardTemplateForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCardTemplateForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCardTemplateForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCardTemplateForEdit(id: number | undefined): Observable<GetCardTemplateForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplates/GetCardTemplateForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCardTemplateForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCardTemplateForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetCardTemplateForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCardTemplateForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCardTemplateForEdit(response: HttpResponseBase): Observable<GetCardTemplateForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCardTemplateForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCardTemplateForEditOutput>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCardTemplateAndPropertiesForEdit(id: number | undefined): Observable<GetCardTemplateAndPropertiesForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplates/GetCardTemplateAndPropertiesForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCardTemplateAndPropertiesForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCardTemplateAndPropertiesForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetCardTemplateAndPropertiesForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCardTemplateAndPropertiesForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCardTemplateAndPropertiesForEdit(response: HttpResponseBase): Observable<GetCardTemplateAndPropertiesForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCardTemplateAndPropertiesForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCardTemplateAndPropertiesForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditCardTemplateAndProperties(body: CreateOrEditCardTemplateAndProperties | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplates/CreateOrEditCardTemplateAndProperties";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditCardTemplateAndProperties(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditCardTemplateAndProperties(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditCardTemplateAndProperties(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param path (optional) 
     * @return Success
     */
    deleteImage(path: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplates/DeleteImage?";
        if (path === null)
            throw new Error("The parameter 'path' cannot be null.");
        else if (path !== undefined)
            url_ += "path=" + encodeURIComponent("" + path) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteImage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteImage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditCardTemplateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplates/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplates/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteCardTemplateAndProperty(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplates/DeleteCardTemplateAndProperty?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCardTemplateAndProperty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCardTemplateAndProperty(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteCardTemplateAndProperty(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param imagePathFilter (optional) 
     * @param maxWidthFilter (optional) 
     * @param minWidthFilter (optional) 
     * @param maxLengthFilter (optional) 
     * @param minLengthFilter (optional) 
     * @param typeFilter (optional) 
     * @return Success
     */
    getCardTemplatesToExcel(filter: string | undefined, titleFilter: string | undefined, isActiveFilter: number | undefined, descriptionFilter: string | undefined, imagePathFilter: string | undefined, maxWidthFilter: number | undefined, minWidthFilter: number | undefined, maxLengthFilter: number | undefined, minLengthFilter: number | undefined, typeFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplates/GetCardTemplatesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (isActiveFilter === null)
            throw new Error("The parameter 'isActiveFilter' cannot be null.");
        else if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (imagePathFilter === null)
            throw new Error("The parameter 'imagePathFilter' cannot be null.");
        else if (imagePathFilter !== undefined)
            url_ += "ImagePathFilter=" + encodeURIComponent("" + imagePathFilter) + "&"; 
        if (maxWidthFilter === null)
            throw new Error("The parameter 'maxWidthFilter' cannot be null.");
        else if (maxWidthFilter !== undefined)
            url_ += "MaxWidthFilter=" + encodeURIComponent("" + maxWidthFilter) + "&"; 
        if (minWidthFilter === null)
            throw new Error("The parameter 'minWidthFilter' cannot be null.");
        else if (minWidthFilter !== undefined)
            url_ += "MinWidthFilter=" + encodeURIComponent("" + minWidthFilter) + "&"; 
        if (maxLengthFilter === null)
            throw new Error("The parameter 'maxLengthFilter' cannot be null.");
        else if (maxLengthFilter !== undefined)
            url_ += "MaxLengthFilter=" + encodeURIComponent("" + maxLengthFilter) + "&"; 
        if (minLengthFilter === null)
            throw new Error("The parameter 'minLengthFilter' cannot be null.");
        else if (minLengthFilter !== undefined)
            url_ += "MinLengthFilter=" + encodeURIComponent("" + minLengthFilter) + "&"; 
        if (typeFilter === null)
            throw new Error("The parameter 'typeFilter' cannot be null.");
        else if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCardTemplatesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCardTemplatesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCardTemplatesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCardTemplateUseForBill(id: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplates/GetCardTemplateUseForBill?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCardTemplateUseForBill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCardTemplateUseForBill(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processGetCardTemplateUseForBill(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param deceasedId (optional) 
     * @return Success
     */
    getPropertiesForBill(id: number | undefined, deceasedId: number | undefined): Observable<GetPropertiesForBillDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplates/GetPropertiesForBill?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        if (deceasedId === null)
            throw new Error("The parameter 'deceasedId' cannot be null.");
        else if (deceasedId !== undefined)
            url_ += "deceasedId=" + encodeURIComponent("" + deceasedId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPropertiesForBill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPropertiesForBill(<any>response_);
                } catch (e) {
                    return <Observable<GetPropertiesForBillDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPropertiesForBillDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPropertiesForBill(response: HttpResponseBase): Observable<GetPropertiesForBillDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetPropertiesForBillDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPropertiesForBillDto[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param deceasedId (optional) 
     * @return Success
     */
    getPropertiesForBillForAdmin(id: number | undefined, deceasedId: number | undefined): Observable<GetPropertiesForBillDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplates/GetPropertiesForBillForAdmin?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        if (deceasedId === null)
            throw new Error("The parameter 'deceasedId' cannot be null.");
        else if (deceasedId !== undefined)
            url_ += "deceasedId=" + encodeURIComponent("" + deceasedId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPropertiesForBillForAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPropertiesForBillForAdmin(<any>response_);
                } catch (e) {
                    return <Observable<GetPropertiesForBillDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPropertiesForBillDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPropertiesForBillForAdmin(response: HttpResponseBase): Observable<GetPropertiesForBillDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetPropertiesForBillDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPropertiesForBillDto[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCardTemplatePropertiesByPlanConstId(id: number | undefined): Observable<GetPropertiesForBillDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplates/GetCardTemplatePropertiesByPlanConstId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCardTemplatePropertiesByPlanConstId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCardTemplatePropertiesByPlanConstId(<any>response_);
                } catch (e) {
                    return <Observable<GetPropertiesForBillDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPropertiesForBillDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCardTemplatePropertiesByPlanConstId(response: HttpResponseBase): Observable<GetPropertiesForBillDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetPropertiesForBillDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPropertiesForBillDto[]>(<any>null);
    }

    /**
     * @param billIds (optional) 
     * @param whiteBackground (optional) 
     * @param forBill (optional) 
     * @return Success
     */
    getCardTemplateAndPropertiesAndValues(billIds: number[] | undefined, whiteBackground: boolean | undefined, forBill: boolean | undefined): Observable<GetCardTemplateAndPropertiesAndValuesDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplates/GetCardTemplateAndPropertiesAndValues?";
        if (billIds === null)
            throw new Error("The parameter 'billIds' cannot be null.");
        else if (billIds !== undefined)
            billIds && billIds.forEach(item => { url_ += "billIds=" + encodeURIComponent("" + item) + "&"; });
        if (whiteBackground === null)
            throw new Error("The parameter 'whiteBackground' cannot be null.");
        else if (whiteBackground !== undefined)
            url_ += "whiteBackground=" + encodeURIComponent("" + whiteBackground) + "&"; 
        if (forBill === null)
            throw new Error("The parameter 'forBill' cannot be null.");
        else if (forBill !== undefined)
            url_ += "forBill=" + encodeURIComponent("" + forBill) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCardTemplateAndPropertiesAndValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCardTemplateAndPropertiesAndValues(<any>response_);
                } catch (e) {
                    return <Observable<GetCardTemplateAndPropertiesAndValuesDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCardTemplateAndPropertiesAndValuesDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCardTemplateAndPropertiesAndValues(response: HttpResponseBase): Observable<GetCardTemplateAndPropertiesAndValuesDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetCardTemplateAndPropertiesAndValuesDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCardTemplateAndPropertiesAndValuesDto[]>(<any>null);
    }

    /**
     * @param billCode (optional) 
     * @return Success
     */
    getCardTemplateAndPropertiesAndValuesForShop(billCode: string | undefined): Observable<GetCardTemplateAndPropertiesAndValuesDto> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplates/GetCardTemplateAndPropertiesAndValuesForShop?";
        if (billCode === null)
            throw new Error("The parameter 'billCode' cannot be null.");
        else if (billCode !== undefined)
            url_ += "billCode=" + encodeURIComponent("" + billCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCardTemplateAndPropertiesAndValuesForShop(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCardTemplateAndPropertiesAndValuesForShop(<any>response_);
                } catch (e) {
                    return <Observable<GetCardTemplateAndPropertiesAndValuesDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCardTemplateAndPropertiesAndValuesDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCardTemplateAndPropertiesAndValuesForShop(response: HttpResponseBase): Observable<GetCardTemplateAndPropertiesAndValuesDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCardTemplateAndPropertiesAndValuesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCardTemplateAndPropertiesAndValuesDto>(<any>null);
    }

    /**
     * @param _data (optional) 
     * @return Success
     */
    generateQR(_data: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplates/GenerateQR?";
        if (_data === null)
            throw new Error("The parameter '_data' cannot be null.");
        else if (_data !== undefined)
            url_ += "_data=" + encodeURIComponent("" + _data) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateQR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateQR(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateQR(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createLabelPrintingProperties(body: number[] | undefined): Observable<GetCardTemplateAndPropertiesAndValuesDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplates/CreateLabelPrintingProperties";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateLabelPrintingProperties(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateLabelPrintingProperties(<any>response_);
                } catch (e) {
                    return <Observable<GetCardTemplateAndPropertiesAndValuesDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCardTemplateAndPropertiesAndValuesDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processCreateLabelPrintingProperties(response: HttpResponseBase): Observable<GetCardTemplateAndPropertiesAndValuesDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetCardTemplateAndPropertiesAndValuesDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCardTemplateAndPropertiesAndValuesDto[]>(<any>null);
    }

    /**
     * @param billIds (optional) 
     * @return Success
     */
    getLabelPrintingProperties(billIds: number[] | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplates/GetLabelPrintingProperties?";
        if (billIds === null)
            throw new Error("The parameter 'billIds' cannot be null.");
        else if (billIds !== undefined)
            billIds && billIds.forEach(item => { url_ += "billIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLabelPrintingProperties(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLabelPrintingProperties(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetLabelPrintingProperties(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @param billIds (optional) 
     * @param whiteBackground (optional) 
     * @param forBill (optional) 
     * @return Success
     */
    getBillPrints(billIds: number[] | undefined, whiteBackground: boolean | undefined, forBill: boolean | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplates/GetBillPrints?";
        if (billIds === null)
            throw new Error("The parameter 'billIds' cannot be null.");
        else if (billIds !== undefined)
            billIds && billIds.forEach(item => { url_ += "billIds=" + encodeURIComponent("" + item) + "&"; });
        if (whiteBackground === null)
            throw new Error("The parameter 'whiteBackground' cannot be null.");
        else if (whiteBackground !== undefined)
            url_ += "whiteBackground=" + encodeURIComponent("" + whiteBackground) + "&"; 
        if (forBill === null)
            throw new Error("The parameter 'forBill' cannot be null.");
        else if (forBill !== undefined)
            url_ += "forBill=" + encodeURIComponent("" + forBill) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillPrints(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillPrints(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetBillPrints(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @param billCode (optional) 
     * @return Success
     */
    getBillPrintsForShop(billCode: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplates/GetBillPrintsForShop?";
        if (billCode === null)
            throw new Error("The parameter 'billCode' cannot be null.");
        else if (billCode !== undefined)
            url_ += "billCode=" + encodeURIComponent("" + billCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillPrintsForShop(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillPrintsForShop(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetBillPrintsForShop(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateBill(body: GetCardTemplateAndPropertiesAndValuesDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplates/GenerateBill";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateBill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateBill(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateBill(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param sentence (optional) 
     * @param fontName (optional) 
     * @param body (optional) 
     * @return Success
     */
    replaceTermsWithRegexBuilder(sentence: string | undefined, fontName: string | undefined, body: TermMapping[] | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplates/ReplaceTermsWithRegexBuilder?";
        if (sentence === null)
            throw new Error("The parameter 'sentence' cannot be null.");
        else if (sentence !== undefined)
            url_ += "sentence=" + encodeURIComponent("" + sentence) + "&"; 
        if (fontName === null)
            throw new Error("The parameter 'fontName' cannot be null.");
        else if (fontName !== undefined)
            url_ += "fontName=" + encodeURIComponent("" + fontName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplaceTermsWithRegexBuilder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplaceTermsWithRegexBuilder(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processReplaceTermsWithRegexBuilder(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param billId (optional) 
     * @param body (optional) 
     * @return Success
     */
    generateClip(billId: number | undefined, body: GetPropertiesForBillDto[] | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplates/GenerateClip?";
        if (billId === null)
            throw new Error("The parameter 'billId' cannot be null.");
        else if (billId !== undefined)
            url_ += "billId=" + encodeURIComponent("" + billId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateClip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateClip(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateClip(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateLable(body: GetCardTemplateAndPropertiesAndValuesDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplates/GenerateLable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateLable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateLable(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateLable(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param billIds (optional) 
     * @param whiteBackground (optional) 
     * @return Success
     */
    getPaymentPrints(billIds: number[] | undefined, whiteBackground: boolean | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplates/GetPaymentPrints?";
        if (billIds === null)
            throw new Error("The parameter 'billIds' cannot be null.");
        else if (billIds !== undefined)
            billIds && billIds.forEach(item => { url_ += "billIds=" + encodeURIComponent("" + item) + "&"; });
        if (whiteBackground === null)
            throw new Error("The parameter 'whiteBackground' cannot be null.");
        else if (whiteBackground !== undefined)
            url_ += "whiteBackground=" + encodeURIComponent("" + whiteBackground) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentPrints(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentPrints(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentPrints(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @param billIds (optional) 
     * @param whiteBackground (optional) 
     * @return Success
     */
    getTemporaryReceiptPrint(billIds: number[] | undefined, whiteBackground: boolean | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplates/GetTemporaryReceiptPrint?";
        if (billIds === null)
            throw new Error("The parameter 'billIds' cannot be null.");
        else if (billIds !== undefined)
            billIds && billIds.forEach(item => { url_ += "billIds=" + encodeURIComponent("" + item) + "&"; });
        if (whiteBackground === null)
            throw new Error("The parameter 'whiteBackground' cannot be null.");
        else if (whiteBackground !== undefined)
            url_ += "whiteBackground=" + encodeURIComponent("" + whiteBackground) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTemporaryReceiptPrint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemporaryReceiptPrint(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTemporaryReceiptPrint(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generatePreviewCardTemplate(body: GenerateCardTemplatePreviewDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplates/GeneratePreviewCardTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneratePreviewCardTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneratePreviewCardTemplate(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGeneratePreviewCardTemplate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class CardTemplateValuesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param valueFilter (optional) 
     * @param cardTemplatePropertyDisplayTitleFilter (optional) 
     * @param entityFilter (optional) 
     * @param entityRefFilter (optional) 
     * @param cardTemplatePropertyIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, valueFilter: string | undefined, cardTemplatePropertyDisplayTitleFilter: string | undefined, entityFilter: number | undefined, entityRefFilter: number | undefined, cardTemplatePropertyIdFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCardTemplateValueForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplateValues/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (valueFilter === null)
            throw new Error("The parameter 'valueFilter' cannot be null.");
        else if (valueFilter !== undefined)
            url_ += "ValueFilter=" + encodeURIComponent("" + valueFilter) + "&"; 
        if (cardTemplatePropertyDisplayTitleFilter === null)
            throw new Error("The parameter 'cardTemplatePropertyDisplayTitleFilter' cannot be null.");
        else if (cardTemplatePropertyDisplayTitleFilter !== undefined)
            url_ += "CardTemplatePropertyDisplayTitleFilter=" + encodeURIComponent("" + cardTemplatePropertyDisplayTitleFilter) + "&"; 
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (entityRefFilter === null)
            throw new Error("The parameter 'entityRefFilter' cannot be null.");
        else if (entityRefFilter !== undefined)
            url_ += "EntityRefFilter=" + encodeURIComponent("" + entityRefFilter) + "&"; 
        if (cardTemplatePropertyIdFilter === null)
            throw new Error("The parameter 'cardTemplatePropertyIdFilter' cannot be null.");
        else if (cardTemplatePropertyIdFilter !== undefined)
            url_ += "CardTemplatePropertyIdFilter=" + encodeURIComponent("" + cardTemplatePropertyIdFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCardTemplateValueForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCardTemplateValueForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCardTemplateValueForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCardTemplateValueForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCardTemplateValueForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCardTemplateValueForView(id: number | undefined): Observable<GetCardTemplateValueForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplateValues/GetCardTemplateValueForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCardTemplateValueForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCardTemplateValueForView(<any>response_);
                } catch (e) {
                    return <Observable<GetCardTemplateValueForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCardTemplateValueForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCardTemplateValueForView(response: HttpResponseBase): Observable<GetCardTemplateValueForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCardTemplateValueForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCardTemplateValueForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCardTemplateValueForEdit(id: number | undefined): Observable<GetCardTemplateValueForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplateValues/GetCardTemplateValueForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCardTemplateValueForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCardTemplateValueForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetCardTemplateValueForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCardTemplateValueForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCardTemplateValueForEdit(response: HttpResponseBase): Observable<GetCardTemplateValueForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCardTemplateValueForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCardTemplateValueForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditCardTemplateValueDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplateValues/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditAllowArabic(body: CreateOrEditCardTemplateValueDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplateValues/CreateOrEditAllowArabic";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditAllowArabic(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditAllowArabic(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditAllowArabic(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplateValues/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param entityRef (optional) 
     * @param cardTemplateRef (optional) 
     * @return Success
     */
    deleteByBillAndCardTemplate(entity: Entities, entityRef: number | undefined, cardTemplateRef: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplateValues/DeleteByBillAndCardTemplate?";
        if (entity === undefined || entity === null)
            throw new Error("The parameter 'entity' must be defined and cannot be null.");
        else
            url_ += "entity=" + encodeURIComponent("" + entity) + "&"; 
        if (entityRef === null)
            throw new Error("The parameter 'entityRef' cannot be null.");
        else if (entityRef !== undefined)
            url_ += "entityRef=" + encodeURIComponent("" + entityRef) + "&"; 
        if (cardTemplateRef === null)
            throw new Error("The parameter 'cardTemplateRef' cannot be null.");
        else if (cardTemplateRef !== undefined)
            url_ += "cardTemplateRef=" + encodeURIComponent("" + cardTemplateRef) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteByBillAndCardTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByBillAndCardTemplate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteByBillAndCardTemplate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param valueFilter (optional) 
     * @param cardTemplatePropertyDisplayTitleFilter (optional) 
     * @param billCodeFilter (optional) 
     * @return Success
     */
    getCardTemplateValuesToExcel(filter: string | undefined, valueFilter: string | undefined, cardTemplatePropertyDisplayTitleFilter: string | undefined, billCodeFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplateValues/GetCardTemplateValuesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (valueFilter === null)
            throw new Error("The parameter 'valueFilter' cannot be null.");
        else if (valueFilter !== undefined)
            url_ += "ValueFilter=" + encodeURIComponent("" + valueFilter) + "&"; 
        if (cardTemplatePropertyDisplayTitleFilter === null)
            throw new Error("The parameter 'cardTemplatePropertyDisplayTitleFilter' cannot be null.");
        else if (cardTemplatePropertyDisplayTitleFilter !== undefined)
            url_ += "CardTemplatePropertyDisplayTitleFilter=" + encodeURIComponent("" + cardTemplatePropertyDisplayTitleFilter) + "&"; 
        if (billCodeFilter === null)
            throw new Error("The parameter 'billCodeFilter' cannot be null.");
        else if (billCodeFilter !== undefined)
            url_ += "BillCodeFilter=" + encodeURIComponent("" + billCodeFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCardTemplateValuesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCardTemplateValuesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCardTemplateValuesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCardTemplatePropertyForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfCardTemplateValueCardTemplatePropertyLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplateValues/GetAllCardTemplatePropertyForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCardTemplatePropertyForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCardTemplatePropertyForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCardTemplateValueCardTemplatePropertyLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfCardTemplateValueCardTemplatePropertyLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCardTemplatePropertyForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfCardTemplateValueCardTemplatePropertyLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCardTemplateValueCardTemplatePropertyLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCardTemplateValueCardTemplatePropertyLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllBillForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfCardTemplateValueBillLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplateValues/GetAllBillForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBillForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBillForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCardTemplateValueBillLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfCardTemplateValueBillLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBillForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfCardTemplateValueBillLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCardTemplateValueBillLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCardTemplateValueBillLookupTableDto>(<any>null);
    }

    /**
     * @param planConstRef (optional) 
     * @param cardTemplateRef (optional) 
     * @param entityRef (optional) 
     * @param contactRef (optional) 
     * @param benefactorName (optional) 
     * @param deceasedName (optional) 
     * @param survivorName (optional) 
     * @param baseTimeRef (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrEditCardTemplateValues(planConstRef: number | undefined, cardTemplateRef: number | undefined, entityRef: number | undefined, contactRef: Entities | undefined, benefactorName: string | undefined, deceasedName: string | undefined, survivorName: string | undefined, baseTimeRef: number | undefined, body: Entities | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplateValues/CreateOrEditCardTemplateValues?";
        if (planConstRef === null)
            throw new Error("The parameter 'planConstRef' cannot be null.");
        else if (planConstRef !== undefined)
            url_ += "planConstRef=" + encodeURIComponent("" + planConstRef) + "&"; 
        if (cardTemplateRef === null)
            throw new Error("The parameter 'cardTemplateRef' cannot be null.");
        else if (cardTemplateRef !== undefined)
            url_ += "cardTemplateRef=" + encodeURIComponent("" + cardTemplateRef) + "&"; 
        if (entityRef === null)
            throw new Error("The parameter 'entityRef' cannot be null.");
        else if (entityRef !== undefined)
            url_ += "entityRef=" + encodeURIComponent("" + entityRef) + "&"; 
        if (contactRef === null)
            throw new Error("The parameter 'contactRef' cannot be null.");
        else if (contactRef !== undefined)
            url_ += "contactRef=" + encodeURIComponent("" + contactRef) + "&"; 
        if (benefactorName === null)
            throw new Error("The parameter 'benefactorName' cannot be null.");
        else if (benefactorName !== undefined)
            url_ += "benefactorName=" + encodeURIComponent("" + benefactorName) + "&"; 
        if (deceasedName === null)
            throw new Error("The parameter 'deceasedName' cannot be null.");
        else if (deceasedName !== undefined)
            url_ += "deceasedName=" + encodeURIComponent("" + deceasedName) + "&"; 
        if (survivorName === null)
            throw new Error("The parameter 'survivorName' cannot be null.");
        else if (survivorName !== undefined)
            url_ += "survivorName=" + encodeURIComponent("" + survivorName) + "&"; 
        if (baseTimeRef === null)
            throw new Error("The parameter 'baseTimeRef' cannot be null.");
        else if (baseTimeRef !== undefined)
            url_ += "baseTimeRef=" + encodeURIComponent("" + baseTimeRef) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditCardTemplateValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditCardTemplateValues(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditCardTemplateValues(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param planConstRef (optional) 
     * @param entityRef (optional) 
     * @param contactRef (optional) 
     * @param benefactorName (optional) 
     * @param creator (optional) 
     * @param tenantId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrEditCardTemplateValuesAnonymous(planConstRef: number | undefined, entityRef: number | undefined, contactRef: Entities | undefined, benefactorName: string | undefined, creator: string | undefined, tenantId: number | undefined, body: Entities | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CardTemplateValues/CreateOrEditCardTemplateValuesAnonymous?";
        if (planConstRef === null)
            throw new Error("The parameter 'planConstRef' cannot be null.");
        else if (planConstRef !== undefined)
            url_ += "planConstRef=" + encodeURIComponent("" + planConstRef) + "&"; 
        if (entityRef === null)
            throw new Error("The parameter 'entityRef' cannot be null.");
        else if (entityRef !== undefined)
            url_ += "entityRef=" + encodeURIComponent("" + entityRef) + "&"; 
        if (contactRef === null)
            throw new Error("The parameter 'contactRef' cannot be null.");
        else if (contactRef !== undefined)
            url_ += "contactRef=" + encodeURIComponent("" + contactRef) + "&"; 
        if (benefactorName === null)
            throw new Error("The parameter 'benefactorName' cannot be null.");
        else if (benefactorName !== undefined)
            url_ += "benefactorName=" + encodeURIComponent("" + benefactorName) + "&"; 
        if (creator === null)
            throw new Error("The parameter 'creator' cannot be null.");
        else if (creator !== undefined)
            url_ += "creator=" + encodeURIComponent("" + creator) + "&"; 
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditCardTemplateValuesAnonymous(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditCardTemplateValuesAnonymous(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditCardTemplateValuesAnonymous(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class CashOutsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxAmountFilter (optional) 
     * @param minAmountFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param typeFilter (optional) 
     * @param maxTransactionRefFilter (optional) 
     * @param minTransactionRefFilter (optional) 
     * @param maxTransactionTimeFilter (optional) 
     * @param minTransactionTimeFilter (optional) 
     * @param contactFirstNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, maxAmountFilter: number | undefined, minAmountFilter: number | undefined, descriptionFilter: string | undefined, typeFilter: number | undefined, maxTransactionRefFilter: number | undefined, minTransactionRefFilter: number | undefined, maxTransactionTimeFilter: moment.Moment | undefined, minTransactionTimeFilter: moment.Moment | undefined, contactFirstNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCashOutForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CashOuts/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxAmountFilter === null)
            throw new Error("The parameter 'maxAmountFilter' cannot be null.");
        else if (maxAmountFilter !== undefined)
            url_ += "MaxAmountFilter=" + encodeURIComponent("" + maxAmountFilter) + "&"; 
        if (minAmountFilter === null)
            throw new Error("The parameter 'minAmountFilter' cannot be null.");
        else if (minAmountFilter !== undefined)
            url_ += "MinAmountFilter=" + encodeURIComponent("" + minAmountFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (typeFilter === null)
            throw new Error("The parameter 'typeFilter' cannot be null.");
        else if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&"; 
        if (maxTransactionRefFilter === null)
            throw new Error("The parameter 'maxTransactionRefFilter' cannot be null.");
        else if (maxTransactionRefFilter !== undefined)
            url_ += "MaxTransactionRefFilter=" + encodeURIComponent("" + maxTransactionRefFilter) + "&"; 
        if (minTransactionRefFilter === null)
            throw new Error("The parameter 'minTransactionRefFilter' cannot be null.");
        else if (minTransactionRefFilter !== undefined)
            url_ += "MinTransactionRefFilter=" + encodeURIComponent("" + minTransactionRefFilter) + "&"; 
        if (maxTransactionTimeFilter === null)
            throw new Error("The parameter 'maxTransactionTimeFilter' cannot be null.");
        else if (maxTransactionTimeFilter !== undefined)
            url_ += "MaxTransactionTimeFilter=" + encodeURIComponent(maxTransactionTimeFilter ? "" + maxTransactionTimeFilter.toJSON() : "") + "&"; 
        if (minTransactionTimeFilter === null)
            throw new Error("The parameter 'minTransactionTimeFilter' cannot be null.");
        else if (minTransactionTimeFilter !== undefined)
            url_ += "MinTransactionTimeFilter=" + encodeURIComponent(minTransactionTimeFilter ? "" + minTransactionTimeFilter.toJSON() : "") + "&"; 
        if (contactFirstNameFilter === null)
            throw new Error("The parameter 'contactFirstNameFilter' cannot be null.");
        else if (contactFirstNameFilter !== undefined)
            url_ += "ContactFirstNameFilter=" + encodeURIComponent("" + contactFirstNameFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCashOutForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCashOutForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCashOutForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCashOutForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCashOutForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCashOutForView(id: number | undefined): Observable<GetCashOutForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CashOuts/GetCashOutForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCashOutForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCashOutForView(<any>response_);
                } catch (e) {
                    return <Observable<GetCashOutForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCashOutForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCashOutForView(response: HttpResponseBase): Observable<GetCashOutForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCashOutForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCashOutForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCashOutForEdit(id: number | undefined): Observable<GetCashOutForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/CashOuts/GetCashOutForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCashOutForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCashOutForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetCashOutForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCashOutForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCashOutForEdit(response: HttpResponseBase): Observable<GetCashOutForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCashOutForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCashOutForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditCashOutDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CashOuts/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CashOuts/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param maxAmountFilter (optional) 
     * @param minAmountFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param typeFilter (optional) 
     * @param maxTransactionRefFilter (optional) 
     * @param minTransactionRefFilter (optional) 
     * @param maxTransactionTimeFilter (optional) 
     * @param minTransactionTimeFilter (optional) 
     * @param contactFirstNameFilter (optional) 
     * @return Success
     */
    getCashOutsToExcel(filter: string | undefined, maxAmountFilter: number | undefined, minAmountFilter: number | undefined, descriptionFilter: string | undefined, typeFilter: number | undefined, maxTransactionRefFilter: number | undefined, minTransactionRefFilter: number | undefined, maxTransactionTimeFilter: moment.Moment | undefined, minTransactionTimeFilter: moment.Moment | undefined, contactFirstNameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/CashOuts/GetCashOutsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxAmountFilter === null)
            throw new Error("The parameter 'maxAmountFilter' cannot be null.");
        else if (maxAmountFilter !== undefined)
            url_ += "MaxAmountFilter=" + encodeURIComponent("" + maxAmountFilter) + "&"; 
        if (minAmountFilter === null)
            throw new Error("The parameter 'minAmountFilter' cannot be null.");
        else if (minAmountFilter !== undefined)
            url_ += "MinAmountFilter=" + encodeURIComponent("" + minAmountFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (typeFilter === null)
            throw new Error("The parameter 'typeFilter' cannot be null.");
        else if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&"; 
        if (maxTransactionRefFilter === null)
            throw new Error("The parameter 'maxTransactionRefFilter' cannot be null.");
        else if (maxTransactionRefFilter !== undefined)
            url_ += "MaxTransactionRefFilter=" + encodeURIComponent("" + maxTransactionRefFilter) + "&"; 
        if (minTransactionRefFilter === null)
            throw new Error("The parameter 'minTransactionRefFilter' cannot be null.");
        else if (minTransactionRefFilter !== undefined)
            url_ += "MinTransactionRefFilter=" + encodeURIComponent("" + minTransactionRefFilter) + "&"; 
        if (maxTransactionTimeFilter === null)
            throw new Error("The parameter 'maxTransactionTimeFilter' cannot be null.");
        else if (maxTransactionTimeFilter !== undefined)
            url_ += "MaxTransactionTimeFilter=" + encodeURIComponent(maxTransactionTimeFilter ? "" + maxTransactionTimeFilter.toJSON() : "") + "&"; 
        if (minTransactionTimeFilter === null)
            throw new Error("The parameter 'minTransactionTimeFilter' cannot be null.");
        else if (minTransactionTimeFilter !== undefined)
            url_ += "MinTransactionTimeFilter=" + encodeURIComponent(minTransactionTimeFilter ? "" + minTransactionTimeFilter.toJSON() : "") + "&"; 
        if (contactFirstNameFilter === null)
            throw new Error("The parameter 'contactFirstNameFilter' cannot be null.");
        else if (contactFirstNameFilter !== undefined)
            url_ += "ContactFirstNameFilter=" + encodeURIComponent("" + contactFirstNameFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCashOutsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCashOutsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCashOutsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllContactForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfCashOutContactLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/CashOuts/GetAllContactForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllContactForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllContactForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCashOutContactLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfCashOutContactLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllContactForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfCashOutContactLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCashOutContactLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCashOutContactLookupTableDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    transactionUseBonusScore(body: TransactionUseBonusInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CashOuts/TransactionUseBonusScore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactionUseBonusScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionUseBonusScore(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processTransactionUseBonusScore(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class CeremoniesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxStartTimeFilter (optional) 
     * @param minStartTimeFilter (optional) 
     * @param maxReturnDateFilter (optional) 
     * @param minReturnDateFilter (optional) 
     * @param ceremonyOwnerNameFilter (optional) 
     * @param ceremonyOwnerPhoneNoFilter (optional) 
     * @param codeFilter (optional) 
     * @param titleFilter (optional) 
     * @param deceasedCodeFilter (optional) 
     * @param locationCodeFilter (optional) 
     * @param eventTypeTitleFilter (optional) 
     * @param stateFilter (optional) 
     * @param isApprovedFilter (optional) 
     * @param deceasedNameFilter (optional) 
     * @param locationTitleFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, maxStartTimeFilter: moment.Moment | undefined, minStartTimeFilter: moment.Moment | undefined, maxReturnDateFilter: moment.Moment | undefined, minReturnDateFilter: moment.Moment | undefined, ceremonyOwnerNameFilter: string | undefined, ceremonyOwnerPhoneNoFilter: string | undefined, codeFilter: string | undefined, titleFilter: string | undefined, deceasedCodeFilter: string | undefined, locationCodeFilter: string | undefined, eventTypeTitleFilter: string | undefined, stateFilter: number | undefined, isApprovedFilter: number | undefined, deceasedNameFilter: string | undefined, locationTitleFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCeremonyForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Ceremonies/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxStartTimeFilter === null)
            throw new Error("The parameter 'maxStartTimeFilter' cannot be null.");
        else if (maxStartTimeFilter !== undefined)
            url_ += "MaxStartTimeFilter=" + encodeURIComponent(maxStartTimeFilter ? "" + maxStartTimeFilter.toJSON() : "") + "&"; 
        if (minStartTimeFilter === null)
            throw new Error("The parameter 'minStartTimeFilter' cannot be null.");
        else if (minStartTimeFilter !== undefined)
            url_ += "MinStartTimeFilter=" + encodeURIComponent(minStartTimeFilter ? "" + minStartTimeFilter.toJSON() : "") + "&"; 
        if (maxReturnDateFilter === null)
            throw new Error("The parameter 'maxReturnDateFilter' cannot be null.");
        else if (maxReturnDateFilter !== undefined)
            url_ += "MaxReturnDateFilter=" + encodeURIComponent(maxReturnDateFilter ? "" + maxReturnDateFilter.toJSON() : "") + "&"; 
        if (minReturnDateFilter === null)
            throw new Error("The parameter 'minReturnDateFilter' cannot be null.");
        else if (minReturnDateFilter !== undefined)
            url_ += "MinReturnDateFilter=" + encodeURIComponent(minReturnDateFilter ? "" + minReturnDateFilter.toJSON() : "") + "&"; 
        if (ceremonyOwnerNameFilter === null)
            throw new Error("The parameter 'ceremonyOwnerNameFilter' cannot be null.");
        else if (ceremonyOwnerNameFilter !== undefined)
            url_ += "CeremonyOwnerNameFilter=" + encodeURIComponent("" + ceremonyOwnerNameFilter) + "&"; 
        if (ceremonyOwnerPhoneNoFilter === null)
            throw new Error("The parameter 'ceremonyOwnerPhoneNoFilter' cannot be null.");
        else if (ceremonyOwnerPhoneNoFilter !== undefined)
            url_ += "CeremonyOwnerPhoneNoFilter=" + encodeURIComponent("" + ceremonyOwnerPhoneNoFilter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (deceasedCodeFilter === null)
            throw new Error("The parameter 'deceasedCodeFilter' cannot be null.");
        else if (deceasedCodeFilter !== undefined)
            url_ += "DeceasedCodeFilter=" + encodeURIComponent("" + deceasedCodeFilter) + "&"; 
        if (locationCodeFilter === null)
            throw new Error("The parameter 'locationCodeFilter' cannot be null.");
        else if (locationCodeFilter !== undefined)
            url_ += "LocationCodeFilter=" + encodeURIComponent("" + locationCodeFilter) + "&"; 
        if (eventTypeTitleFilter === null)
            throw new Error("The parameter 'eventTypeTitleFilter' cannot be null.");
        else if (eventTypeTitleFilter !== undefined)
            url_ += "EventTypeTitleFilter=" + encodeURIComponent("" + eventTypeTitleFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (isApprovedFilter === null)
            throw new Error("The parameter 'isApprovedFilter' cannot be null.");
        else if (isApprovedFilter !== undefined)
            url_ += "IsApprovedFilter=" + encodeURIComponent("" + isApprovedFilter) + "&"; 
        if (deceasedNameFilter === null)
            throw new Error("The parameter 'deceasedNameFilter' cannot be null.");
        else if (deceasedNameFilter !== undefined)
            url_ += "DeceasedNameFilter=" + encodeURIComponent("" + deceasedNameFilter) + "&"; 
        if (locationTitleFilter === null)
            throw new Error("The parameter 'locationTitleFilter' cannot be null.");
        else if (locationTitleFilter !== undefined)
            url_ += "LocationTitleFilter=" + encodeURIComponent("" + locationTitleFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCeremonyForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCeremonyForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCeremonyForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCeremonyForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCeremonyForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCeremonyForView(id: number | undefined): Observable<GetCeremonyForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Ceremonies/GetCeremonyForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCeremonyForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCeremonyForView(<any>response_);
                } catch (e) {
                    return <Observable<GetCeremonyForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCeremonyForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCeremonyForView(response: HttpResponseBase): Observable<GetCeremonyForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCeremonyForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCeremonyForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCeremonyForEdit(id: number | undefined): Observable<GetCeremonyForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Ceremonies/GetCeremonyForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCeremonyForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCeremonyForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetCeremonyForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCeremonyForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCeremonyForEdit(response: HttpResponseBase): Observable<GetCeremonyForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCeremonyForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCeremonyForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditCeremonyDto | undefined): Observable<CreateOrEditCeremonyOutput> {
        let url_ = this.baseUrl + "/api/services/app/Ceremonies/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditCeremonyOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditCeremonyOutput>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<CreateOrEditCeremonyOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditCeremonyOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditCeremonyOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAndGetId(body: CreateOrEditCeremonyDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Ceremonies/CreateAndGetId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAndGetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAndGetId(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateAndGetId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param deathDateFilter (optional) 
     * @param ceremonyDateFilter (optional) 
     * @param genderFilter (optional) 
     * @param eventTypeFilter (optional) 
     * @param deceasedCode (optional) 
     * @param expiredCeremony (optional) 
     * @param page (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCeremoniesForShop(filter: string | undefined, deathDateFilter: moment.Moment | undefined, ceremonyDateFilter: moment.Moment | undefined, genderFilter: number | undefined, eventTypeFilter: number | undefined, deceasedCode: string | undefined, expiredCeremony: boolean | undefined, page: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAllCeremoniesForShopDto> {
        let url_ = this.baseUrl + "/api/services/app/Ceremonies/GetAllCeremoniesForShop?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (deathDateFilter === null)
            throw new Error("The parameter 'deathDateFilter' cannot be null.");
        else if (deathDateFilter !== undefined)
            url_ += "DeathDateFilter=" + encodeURIComponent(deathDateFilter ? "" + deathDateFilter.toJSON() : "") + "&"; 
        if (ceremonyDateFilter === null)
            throw new Error("The parameter 'ceremonyDateFilter' cannot be null.");
        else if (ceremonyDateFilter !== undefined)
            url_ += "CeremonyDateFilter=" + encodeURIComponent(ceremonyDateFilter ? "" + ceremonyDateFilter.toJSON() : "") + "&"; 
        if (genderFilter === null)
            throw new Error("The parameter 'genderFilter' cannot be null.");
        else if (genderFilter !== undefined)
            url_ += "GenderFilter=" + encodeURIComponent("" + genderFilter) + "&"; 
        if (eventTypeFilter === null)
            throw new Error("The parameter 'eventTypeFilter' cannot be null.");
        else if (eventTypeFilter !== undefined)
            url_ += "EventTypeFilter=" + encodeURIComponent("" + eventTypeFilter) + "&"; 
        if (deceasedCode === null)
            throw new Error("The parameter 'deceasedCode' cannot be null.");
        else if (deceasedCode !== undefined)
            url_ += "DeceasedCode=" + encodeURIComponent("" + deceasedCode) + "&"; 
        if (expiredCeremony === null)
            throw new Error("The parameter 'expiredCeremony' cannot be null.");
        else if (expiredCeremony !== undefined)
            url_ += "ExpiredCeremony=" + encodeURIComponent("" + expiredCeremony) + "&"; 
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCeremoniesForShop(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCeremoniesForShop(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAllCeremoniesForShopDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAllCeremoniesForShopDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCeremoniesForShop(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllCeremoniesForShopDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAllCeremoniesForShopDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAllCeremoniesForShopDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Ceremonies/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param maxStartTimeFilter (optional) 
     * @param minStartTimeFilter (optional) 
     * @param maxReturnDateFilter (optional) 
     * @param minReturnDateFilter (optional) 
     * @param ceremonyOwnerNameFilter (optional) 
     * @param ceremonyOwnerPhoneNoFilter (optional) 
     * @param codeFilter (optional) 
     * @param titleFilter (optional) 
     * @param deceasedFirstNameFilter (optional) 
     * @param locationTitleFilter (optional) 
     * @param eventTypeTitleFilter (optional) 
     * @return Success
     */
    getCeremoniesToExcel(filter: string | undefined, maxStartTimeFilter: moment.Moment | undefined, minStartTimeFilter: moment.Moment | undefined, maxReturnDateFilter: moment.Moment | undefined, minReturnDateFilter: moment.Moment | undefined, ceremonyOwnerNameFilter: string | undefined, ceremonyOwnerPhoneNoFilter: string | undefined, codeFilter: string | undefined, titleFilter: string | undefined, deceasedFirstNameFilter: string | undefined, locationTitleFilter: string | undefined, eventTypeTitleFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Ceremonies/GetCeremoniesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxStartTimeFilter === null)
            throw new Error("The parameter 'maxStartTimeFilter' cannot be null.");
        else if (maxStartTimeFilter !== undefined)
            url_ += "MaxStartTimeFilter=" + encodeURIComponent(maxStartTimeFilter ? "" + maxStartTimeFilter.toJSON() : "") + "&"; 
        if (minStartTimeFilter === null)
            throw new Error("The parameter 'minStartTimeFilter' cannot be null.");
        else if (minStartTimeFilter !== undefined)
            url_ += "MinStartTimeFilter=" + encodeURIComponent(minStartTimeFilter ? "" + minStartTimeFilter.toJSON() : "") + "&"; 
        if (maxReturnDateFilter === null)
            throw new Error("The parameter 'maxReturnDateFilter' cannot be null.");
        else if (maxReturnDateFilter !== undefined)
            url_ += "MaxReturnDateFilter=" + encodeURIComponent(maxReturnDateFilter ? "" + maxReturnDateFilter.toJSON() : "") + "&"; 
        if (minReturnDateFilter === null)
            throw new Error("The parameter 'minReturnDateFilter' cannot be null.");
        else if (minReturnDateFilter !== undefined)
            url_ += "MinReturnDateFilter=" + encodeURIComponent(minReturnDateFilter ? "" + minReturnDateFilter.toJSON() : "") + "&"; 
        if (ceremonyOwnerNameFilter === null)
            throw new Error("The parameter 'ceremonyOwnerNameFilter' cannot be null.");
        else if (ceremonyOwnerNameFilter !== undefined)
            url_ += "CeremonyOwnerNameFilter=" + encodeURIComponent("" + ceremonyOwnerNameFilter) + "&"; 
        if (ceremonyOwnerPhoneNoFilter === null)
            throw new Error("The parameter 'ceremonyOwnerPhoneNoFilter' cannot be null.");
        else if (ceremonyOwnerPhoneNoFilter !== undefined)
            url_ += "CeremonyOwnerPhoneNoFilter=" + encodeURIComponent("" + ceremonyOwnerPhoneNoFilter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (deceasedFirstNameFilter === null)
            throw new Error("The parameter 'deceasedFirstNameFilter' cannot be null.");
        else if (deceasedFirstNameFilter !== undefined)
            url_ += "DeceasedFirstNameFilter=" + encodeURIComponent("" + deceasedFirstNameFilter) + "&"; 
        if (locationTitleFilter === null)
            throw new Error("The parameter 'locationTitleFilter' cannot be null.");
        else if (locationTitleFilter !== undefined)
            url_ += "LocationTitleFilter=" + encodeURIComponent("" + locationTitleFilter) + "&"; 
        if (eventTypeTitleFilter === null)
            throw new Error("The parameter 'eventTypeTitleFilter' cannot be null.");
        else if (eventTypeTitleFilter !== undefined)
            url_ += "EventTypeTitleFilter=" + encodeURIComponent("" + eventTypeTitleFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCeremoniesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCeremoniesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCeremoniesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllDeceasedForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfCeremonyDeceasedLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Ceremonies/GetAllDeceasedForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDeceasedForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDeceasedForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCeremonyDeceasedLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfCeremonyDeceasedLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllDeceasedForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfCeremonyDeceasedLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCeremonyDeceasedLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCeremonyDeceasedLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param isPublicOrPrivateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllLocationForLookupTable(filter: string | undefined, isPublicOrPrivateFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfCeremonyLocationLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Ceremonies/GetAllLocationForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (isPublicOrPrivateFilter === null)
            throw new Error("The parameter 'isPublicOrPrivateFilter' cannot be null.");
        else if (isPublicOrPrivateFilter !== undefined)
            url_ += "IsPublicOrPrivateFilter=" + encodeURIComponent("" + isPublicOrPrivateFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLocationForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLocationForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCeremonyLocationLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfCeremonyLocationLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllLocationForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfCeremonyLocationLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCeremonyLocationLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCeremonyLocationLookupTableDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllEventTypeForTableDropdown(): Observable<CeremonyEventTypeLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Ceremonies/GetAllEventTypeForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEventTypeForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEventTypeForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<CeremonyEventTypeLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CeremonyEventTypeLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllEventTypeForTableDropdown(response: HttpResponseBase): Observable<CeremonyEventTypeLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CeremonyEventTypeLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CeremonyEventTypeLookupTableDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllCeremonies(): Observable<Ceremony[]> {
        let url_ = this.baseUrl + "/api/services/app/Ceremonies/GetAllCeremonies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCeremonies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCeremonies(<any>response_);
                } catch (e) {
                    return <Observable<Ceremony[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Ceremony[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCeremonies(response: HttpResponseBase): Observable<Ceremony[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Ceremony.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Ceremony[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approveCeremony(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Ceremonies/ApproveCeremony";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveCeremony(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveCeremony(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApproveCeremony(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param minStartDateFilter (optional) 
     * @param maxStartDateFilter (optional) 
     * @param ceremonyIdFilter (optional) 
     * @param locationIdFilter (optional) 
     * @param planConstIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getDailyFlowerReport(minStartDateFilter: moment.Moment | undefined, maxStartDateFilter: moment.Moment | undefined, ceremonyIdFilter: number | undefined, locationIdFilter: number | undefined, planConstIdFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetDailyFlowerReportOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Ceremonies/GetDailyFlowerReport?";
        if (minStartDateFilter === null)
            throw new Error("The parameter 'minStartDateFilter' cannot be null.");
        else if (minStartDateFilter !== undefined)
            url_ += "MinStartDateFilter=" + encodeURIComponent(minStartDateFilter ? "" + minStartDateFilter.toJSON() : "") + "&"; 
        if (maxStartDateFilter === null)
            throw new Error("The parameter 'maxStartDateFilter' cannot be null.");
        else if (maxStartDateFilter !== undefined)
            url_ += "MaxStartDateFilter=" + encodeURIComponent(maxStartDateFilter ? "" + maxStartDateFilter.toJSON() : "") + "&"; 
        if (ceremonyIdFilter === null)
            throw new Error("The parameter 'ceremonyIdFilter' cannot be null.");
        else if (ceremonyIdFilter !== undefined)
            url_ += "CeremonyIdFilter=" + encodeURIComponent("" + ceremonyIdFilter) + "&"; 
        if (locationIdFilter === null)
            throw new Error("The parameter 'locationIdFilter' cannot be null.");
        else if (locationIdFilter !== undefined)
            url_ += "LocationIdFilter=" + encodeURIComponent("" + locationIdFilter) + "&"; 
        if (planConstIdFilter === null)
            throw new Error("The parameter 'planConstIdFilter' cannot be null.");
        else if (planConstIdFilter !== undefined)
            url_ += "planConstIdFilter=" + encodeURIComponent("" + planConstIdFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDailyFlowerReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDailyFlowerReport(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetDailyFlowerReportOutputDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetDailyFlowerReportOutputDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetDailyFlowerReport(response: HttpResponseBase): Observable<PagedResultDtoOfGetDailyFlowerReportOutputDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetDailyFlowerReportOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetDailyFlowerReportOutputDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param deacesedIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCeremonyForLookupTable(filter: string | undefined, deacesedIdFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfBillCeremonyLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Ceremonies/GetAllCeremonyForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (deacesedIdFilter === null)
            throw new Error("The parameter 'deacesedIdFilter' cannot be null.");
        else if (deacesedIdFilter !== undefined)
            url_ += "DeacesedIdFilter=" + encodeURIComponent("" + deacesedIdFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCeremonyForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCeremonyForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfBillCeremonyLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfBillCeremonyLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCeremonyForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfBillCeremonyLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfBillCeremonyLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfBillCeremonyLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param deacesedIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCeremonyForDailyFlowerLookupTable(filter: string | undefined, deacesedIdFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfBillCeremonyLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Ceremonies/GetAllCeremonyForDailyFlowerLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (deacesedIdFilter === null)
            throw new Error("The parameter 'deacesedIdFilter' cannot be null.");
        else if (deacesedIdFilter !== undefined)
            url_ += "DeacesedIdFilter=" + encodeURIComponent("" + deacesedIdFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCeremonyForDailyFlowerLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCeremonyForDailyFlowerLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfBillCeremonyLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfBillCeremonyLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCeremonyForDailyFlowerLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfBillCeremonyLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfBillCeremonyLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfBillCeremonyLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllPlanConstForDailyFlowerLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfCeremonyReportPlanConstLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Ceremonies/GetAllPlanConstForDailyFlowerLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPlanConstForDailyFlowerLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPlanConstForDailyFlowerLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCeremonyReportPlanConstLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfCeremonyReportPlanConstLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPlanConstForDailyFlowerLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfCeremonyReportPlanConstLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCeremonyReportPlanConstLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCeremonyReportPlanConstLookupTableDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    mergeAndSave(body: MergeCeremonyAndSaveInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Ceremonies/MergeAndSave";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMergeAndSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMergeAndSave(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processMergeAndSave(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class CharityPlansServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxTargetNumberFilter (optional) 
     * @param minTargetNumberFilter (optional) 
     * @param maxTargetAmountFilter (optional) 
     * @param minTargetAmountFilter (optional) 
     * @param cashOrItemsFilter (optional) 
     * @param continuousOrCaseFilter (optional) 
     * @param hasOnlinePaymentFilter (optional) 
     * @param hasAttendancePaymentFilter (optional) 
     * @param publicOrExclusiveFilter (optional) 
     * @param stateFilter (optional) 
     * @param baseTimeIdFilter (optional) 
     * @param planConstTitleFilter (optional) 
     * @param benefactorGroupSubgroupTitleFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, maxTargetNumberFilter: number | undefined, minTargetNumberFilter: number | undefined, maxTargetAmountFilter: number | undefined, minTargetAmountFilter: number | undefined, cashOrItemsFilter: number | undefined, continuousOrCaseFilter: number | undefined, hasOnlinePaymentFilter: number | undefined, hasAttendancePaymentFilter: number | undefined, publicOrExclusiveFilter: number | undefined, stateFilter: number | undefined, baseTimeIdFilter: string | undefined, planConstTitleFilter: string | undefined, benefactorGroupSubgroupTitleFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCharityPlanForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CharityPlans/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxTargetNumberFilter === null)
            throw new Error("The parameter 'maxTargetNumberFilter' cannot be null.");
        else if (maxTargetNumberFilter !== undefined)
            url_ += "MaxTargetNumberFilter=" + encodeURIComponent("" + maxTargetNumberFilter) + "&"; 
        if (minTargetNumberFilter === null)
            throw new Error("The parameter 'minTargetNumberFilter' cannot be null.");
        else if (minTargetNumberFilter !== undefined)
            url_ += "MinTargetNumberFilter=" + encodeURIComponent("" + minTargetNumberFilter) + "&"; 
        if (maxTargetAmountFilter === null)
            throw new Error("The parameter 'maxTargetAmountFilter' cannot be null.");
        else if (maxTargetAmountFilter !== undefined)
            url_ += "MaxTargetAmountFilter=" + encodeURIComponent("" + maxTargetAmountFilter) + "&"; 
        if (minTargetAmountFilter === null)
            throw new Error("The parameter 'minTargetAmountFilter' cannot be null.");
        else if (minTargetAmountFilter !== undefined)
            url_ += "MinTargetAmountFilter=" + encodeURIComponent("" + minTargetAmountFilter) + "&"; 
        if (cashOrItemsFilter === null)
            throw new Error("The parameter 'cashOrItemsFilter' cannot be null.");
        else if (cashOrItemsFilter !== undefined)
            url_ += "CashOrItemsFilter=" + encodeURIComponent("" + cashOrItemsFilter) + "&"; 
        if (continuousOrCaseFilter === null)
            throw new Error("The parameter 'continuousOrCaseFilter' cannot be null.");
        else if (continuousOrCaseFilter !== undefined)
            url_ += "ContinuousOrCaseFilter=" + encodeURIComponent("" + continuousOrCaseFilter) + "&"; 
        if (hasOnlinePaymentFilter === null)
            throw new Error("The parameter 'hasOnlinePaymentFilter' cannot be null.");
        else if (hasOnlinePaymentFilter !== undefined)
            url_ += "HasOnlinePaymentFilter=" + encodeURIComponent("" + hasOnlinePaymentFilter) + "&"; 
        if (hasAttendancePaymentFilter === null)
            throw new Error("The parameter 'hasAttendancePaymentFilter' cannot be null.");
        else if (hasAttendancePaymentFilter !== undefined)
            url_ += "HasAttendancePaymentFilter=" + encodeURIComponent("" + hasAttendancePaymentFilter) + "&"; 
        if (publicOrExclusiveFilter === null)
            throw new Error("The parameter 'publicOrExclusiveFilter' cannot be null.");
        else if (publicOrExclusiveFilter !== undefined)
            url_ += "PublicOrExclusiveFilter=" + encodeURIComponent("" + publicOrExclusiveFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (baseTimeIdFilter === null)
            throw new Error("The parameter 'baseTimeIdFilter' cannot be null.");
        else if (baseTimeIdFilter !== undefined)
            url_ += "BaseTimeIdFilter=" + encodeURIComponent("" + baseTimeIdFilter) + "&"; 
        if (planConstTitleFilter === null)
            throw new Error("The parameter 'planConstTitleFilter' cannot be null.");
        else if (planConstTitleFilter !== undefined)
            url_ += "PlanConstTitleFilter=" + encodeURIComponent("" + planConstTitleFilter) + "&"; 
        if (benefactorGroupSubgroupTitleFilter === null)
            throw new Error("The parameter 'benefactorGroupSubgroupTitleFilter' cannot be null.");
        else if (benefactorGroupSubgroupTitleFilter !== undefined)
            url_ += "BenefactorGroupSubgroupTitleFilter=" + encodeURIComponent("" + benefactorGroupSubgroupTitleFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCharityPlanForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCharityPlanForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCharityPlanForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCharityPlanForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCharityPlanForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCharityPlanForView(id: number | undefined): Observable<GetCharityPlanForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CharityPlans/GetCharityPlanForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCharityPlanForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCharityPlanForView(<any>response_);
                } catch (e) {
                    return <Observable<GetCharityPlanForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCharityPlanForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCharityPlanForView(response: HttpResponseBase): Observable<GetCharityPlanForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCharityPlanForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCharityPlanForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCharityPlanForEdit(id: number | undefined): Observable<GetCharityPlanForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/CharityPlans/GetCharityPlanForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCharityPlanForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCharityPlanForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetCharityPlanForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCharityPlanForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCharityPlanForEdit(response: HttpResponseBase): Observable<GetCharityPlanForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCharityPlanForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCharityPlanForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditCharityPlanDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CharityPlans/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CharityPlans/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param maxTargetNumberFilter (optional) 
     * @param minTargetNumberFilter (optional) 
     * @param maxTargetAmountFilter (optional) 
     * @param minTargetAmountFilter (optional) 
     * @param cashOrItemsFilter (optional) 
     * @param continuousOrCaseFilter (optional) 
     * @param hasOnlinePaymentFilter (optional) 
     * @param hasAttendancePaymentFilter (optional) 
     * @param publicOrExclusiveFilter (optional) 
     * @param stateFilter (optional) 
     * @param benefactorGroupSubgroupTitleFilter (optional) 
     * @param planConstTitleFilter (optional) 
     * @return Success
     */
    getCharityPlansToExcel(filter: string | undefined, maxTargetNumberFilter: number | undefined, minTargetNumberFilter: number | undefined, maxTargetAmountFilter: number | undefined, minTargetAmountFilter: number | undefined, cashOrItemsFilter: number | undefined, continuousOrCaseFilter: number | undefined, hasOnlinePaymentFilter: number | undefined, hasAttendancePaymentFilter: number | undefined, publicOrExclusiveFilter: number | undefined, stateFilter: number | undefined, benefactorGroupSubgroupTitleFilter: string | undefined, planConstTitleFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/CharityPlans/GetCharityPlansToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxTargetNumberFilter === null)
            throw new Error("The parameter 'maxTargetNumberFilter' cannot be null.");
        else if (maxTargetNumberFilter !== undefined)
            url_ += "MaxTargetNumberFilter=" + encodeURIComponent("" + maxTargetNumberFilter) + "&"; 
        if (minTargetNumberFilter === null)
            throw new Error("The parameter 'minTargetNumberFilter' cannot be null.");
        else if (minTargetNumberFilter !== undefined)
            url_ += "MinTargetNumberFilter=" + encodeURIComponent("" + minTargetNumberFilter) + "&"; 
        if (maxTargetAmountFilter === null)
            throw new Error("The parameter 'maxTargetAmountFilter' cannot be null.");
        else if (maxTargetAmountFilter !== undefined)
            url_ += "MaxTargetAmountFilter=" + encodeURIComponent("" + maxTargetAmountFilter) + "&"; 
        if (minTargetAmountFilter === null)
            throw new Error("The parameter 'minTargetAmountFilter' cannot be null.");
        else if (minTargetAmountFilter !== undefined)
            url_ += "MinTargetAmountFilter=" + encodeURIComponent("" + minTargetAmountFilter) + "&"; 
        if (cashOrItemsFilter === null)
            throw new Error("The parameter 'cashOrItemsFilter' cannot be null.");
        else if (cashOrItemsFilter !== undefined)
            url_ += "CashOrItemsFilter=" + encodeURIComponent("" + cashOrItemsFilter) + "&"; 
        if (continuousOrCaseFilter === null)
            throw new Error("The parameter 'continuousOrCaseFilter' cannot be null.");
        else if (continuousOrCaseFilter !== undefined)
            url_ += "ContinuousOrCaseFilter=" + encodeURIComponent("" + continuousOrCaseFilter) + "&"; 
        if (hasOnlinePaymentFilter === null)
            throw new Error("The parameter 'hasOnlinePaymentFilter' cannot be null.");
        else if (hasOnlinePaymentFilter !== undefined)
            url_ += "HasOnlinePaymentFilter=" + encodeURIComponent("" + hasOnlinePaymentFilter) + "&"; 
        if (hasAttendancePaymentFilter === null)
            throw new Error("The parameter 'hasAttendancePaymentFilter' cannot be null.");
        else if (hasAttendancePaymentFilter !== undefined)
            url_ += "HasAttendancePaymentFilter=" + encodeURIComponent("" + hasAttendancePaymentFilter) + "&"; 
        if (publicOrExclusiveFilter === null)
            throw new Error("The parameter 'publicOrExclusiveFilter' cannot be null.");
        else if (publicOrExclusiveFilter !== undefined)
            url_ += "PublicOrExclusiveFilter=" + encodeURIComponent("" + publicOrExclusiveFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (benefactorGroupSubgroupTitleFilter === null)
            throw new Error("The parameter 'benefactorGroupSubgroupTitleFilter' cannot be null.");
        else if (benefactorGroupSubgroupTitleFilter !== undefined)
            url_ += "BenefactorGroupSubgroupTitleFilter=" + encodeURIComponent("" + benefactorGroupSubgroupTitleFilter) + "&"; 
        if (planConstTitleFilter === null)
            throw new Error("The parameter 'planConstTitleFilter' cannot be null.");
        else if (planConstTitleFilter !== undefined)
            url_ += "PlanConstTitleFilter=" + encodeURIComponent("" + planConstTitleFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCharityPlansToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCharityPlansToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCharityPlansToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllClientGroupSubgroupForTableDropdown(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfCharityPlanGroupSubgroupLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/CharityPlans/GetAllClientGroupSubgroupForTableDropdown?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllClientGroupSubgroupForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllClientGroupSubgroupForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCharityPlanGroupSubgroupLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfCharityPlanGroupSubgroupLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllClientGroupSubgroupForTableDropdown(response: HttpResponseBase): Observable<PagedResultDtoOfCharityPlanGroupSubgroupLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCharityPlanGroupSubgroupLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCharityPlanGroupSubgroupLookupTableDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllBaseTimeForTableDropdown(): Observable<CharityPlanBaseTimeLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CharityPlans/GetAllBaseTimeForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBaseTimeForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBaseTimeForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<CharityPlanBaseTimeLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CharityPlanBaseTimeLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBaseTimeForTableDropdown(response: HttpResponseBase): Observable<CharityPlanBaseTimeLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CharityPlanBaseTimeLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CharityPlanBaseTimeLookupTableDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllContactForTableDropdown(): Observable<CharityPlanContactLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CharityPlans/GetAllContactForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllContactForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllContactForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<CharityPlanContactLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CharityPlanContactLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllContactForTableDropdown(response: HttpResponseBase): Observable<CharityPlanContactLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CharityPlanContactLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CharityPlanContactLookupTableDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllFamilyForTableDropdown(): Observable<CharityPlanFamilyLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CharityPlans/GetAllFamilyForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFamilyForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFamilyForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<CharityPlanFamilyLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CharityPlanFamilyLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllFamilyForTableDropdown(response: HttpResponseBase): Observable<CharityPlanFamilyLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CharityPlanFamilyLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CharityPlanFamilyLookupTableDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllPlanConstForTableDropdown(): Observable<CharityPlanPlanConstLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CharityPlans/GetAllPlanConstForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPlanConstForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPlanConstForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<CharityPlanPlanConstLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CharityPlanPlanConstLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPlanConstForTableDropdown(response: HttpResponseBase): Observable<CharityPlanPlanConstLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CharityPlanPlanConstLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CharityPlanPlanConstLookupTableDto[]>(<any>null);
    }
}

@Injectable()
export class ChatServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getUserChatFriendsWithSettings(): Observable<GetUserChatFriendsWithSettingsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Chat/GetUserChatFriendsWithSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserChatFriendsWithSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserChatFriendsWithSettings(<any>response_);
                } catch (e) {
                    return <Observable<GetUserChatFriendsWithSettingsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetUserChatFriendsWithSettingsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserChatFriendsWithSettings(response: HttpResponseBase): Observable<GetUserChatFriendsWithSettingsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserChatFriendsWithSettingsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserChatFriendsWithSettingsOutput>(<any>null);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param minMessageId (optional) 
     * @return Success
     */
    getUserChatMessages(tenantId: number | undefined, userId: number | undefined, minMessageId: number | undefined): Observable<ListResultDtoOfChatMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Chat/GetUserChatMessages?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (minMessageId === null)
            throw new Error("The parameter 'minMessageId' cannot be null.");
        else if (minMessageId !== undefined)
            url_ += "MinMessageId=" + encodeURIComponent("" + minMessageId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserChatMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserChatMessages(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfChatMessageDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfChatMessageDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserChatMessages(response: HttpResponseBase): Observable<ListResultDtoOfChatMessageDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfChatMessageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfChatMessageDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    markAllUnreadMessagesOfUserAsRead(body: MarkAllUnreadMessagesOfUserAsReadInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Chat/MarkAllUnreadMessagesOfUserAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAllUnreadMessagesOfUserAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAllUnreadMessagesOfUserAsRead(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processMarkAllUnreadMessagesOfUserAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class CitiesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param prefixFilter (optional) 
     * @param longitude (optional) 
     * @param latitude (optional) 
     * @param socialSecurityCodeFilter (optional) 
     * @param taxCodeFilter (optional) 
     * @param stateIdFilter (optional) 
     * @param isForShopCeremony (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, nameFilter: string | undefined, prefixFilter: string | undefined, longitude: number | undefined, latitude: number | undefined, socialSecurityCodeFilter: string | undefined, taxCodeFilter: string | undefined, stateIdFilter: number | undefined, isForShopCeremony: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Cities/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&"; 
        if (prefixFilter === null)
            throw new Error("The parameter 'prefixFilter' cannot be null.");
        else if (prefixFilter !== undefined)
            url_ += "PrefixFilter=" + encodeURIComponent("" + prefixFilter) + "&"; 
        if (longitude === null)
            throw new Error("The parameter 'longitude' cannot be null.");
        else if (longitude !== undefined)
            url_ += "Longitude=" + encodeURIComponent("" + longitude) + "&"; 
        if (latitude === null)
            throw new Error("The parameter 'latitude' cannot be null.");
        else if (latitude !== undefined)
            url_ += "Latitude=" + encodeURIComponent("" + latitude) + "&"; 
        if (socialSecurityCodeFilter === null)
            throw new Error("The parameter 'socialSecurityCodeFilter' cannot be null.");
        else if (socialSecurityCodeFilter !== undefined)
            url_ += "SocialSecurityCodeFilter=" + encodeURIComponent("" + socialSecurityCodeFilter) + "&"; 
        if (taxCodeFilter === null)
            throw new Error("The parameter 'taxCodeFilter' cannot be null.");
        else if (taxCodeFilter !== undefined)
            url_ += "TaxCodeFilter=" + encodeURIComponent("" + taxCodeFilter) + "&"; 
        if (stateIdFilter === null)
            throw new Error("The parameter 'stateIdFilter' cannot be null.");
        else if (stateIdFilter !== undefined)
            url_ += "StateIdFilter=" + encodeURIComponent("" + stateIdFilter) + "&"; 
        if (isForShopCeremony === null)
            throw new Error("The parameter 'isForShopCeremony' cannot be null.");
        else if (isForShopCeremony !== undefined)
            url_ += "IsForShopCeremony=" + encodeURIComponent("" + isForShopCeremony) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCityForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCityForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCityForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCityForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCityForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCityForView(id: number | undefined): Observable<GetCityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Cities/GetCityForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCityForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCityForView(<any>response_);
                } catch (e) {
                    return <Observable<GetCityForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCityForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCityForView(response: HttpResponseBase): Observable<GetCityForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCityForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCityForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCityForEdit(id: number | undefined): Observable<GetCityForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Cities/GetCityForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCityForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCityForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetCityForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCityForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCityForEdit(response: HttpResponseBase): Observable<GetCityForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCityForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCityForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditCityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Cities/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Cities/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param longitude (optional) 
     * @param latitude (optional) 
     * @param prefixFilter (optional) 
     * @param socialSecurityCodeFilter (optional) 
     * @param taxCodeFilter (optional) 
     * @param stateNameFilter (optional) 
     * @return Success
     */
    getCitiesToExcel(filter: string | undefined, nameFilter: string | undefined, longitude: number | undefined, latitude: number | undefined, prefixFilter: string | undefined, socialSecurityCodeFilter: string | undefined, taxCodeFilter: string | undefined, stateNameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Cities/GetCitiesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&"; 
        if (longitude === null)
            throw new Error("The parameter 'longitude' cannot be null.");
        else if (longitude !== undefined)
            url_ += "Longitude=" + encodeURIComponent("" + longitude) + "&"; 
        if (latitude === null)
            throw new Error("The parameter 'latitude' cannot be null.");
        else if (latitude !== undefined)
            url_ += "Latitude=" + encodeURIComponent("" + latitude) + "&"; 
        if (prefixFilter === null)
            throw new Error("The parameter 'prefixFilter' cannot be null.");
        else if (prefixFilter !== undefined)
            url_ += "PrefixFilter=" + encodeURIComponent("" + prefixFilter) + "&"; 
        if (socialSecurityCodeFilter === null)
            throw new Error("The parameter 'socialSecurityCodeFilter' cannot be null.");
        else if (socialSecurityCodeFilter !== undefined)
            url_ += "SocialSecurityCodeFilter=" + encodeURIComponent("" + socialSecurityCodeFilter) + "&"; 
        if (taxCodeFilter === null)
            throw new Error("The parameter 'taxCodeFilter' cannot be null.");
        else if (taxCodeFilter !== undefined)
            url_ += "TaxCodeFilter=" + encodeURIComponent("" + taxCodeFilter) + "&"; 
        if (stateNameFilter === null)
            throw new Error("The parameter 'stateNameFilter' cannot be null.");
        else if (stateNameFilter !== undefined)
            url_ += "StateNameFilter=" + encodeURIComponent("" + stateNameFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCitiesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCitiesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCitiesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllStateForTableDropdown(): Observable<CityStateLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Cities/GetAllStateForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStateForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStateForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<CityStateLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CityStateLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllStateForTableDropdown(response: HttpResponseBase): Observable<CityStateLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CityStateLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CityStateLookupTableDto[]>(<any>null);
    }
}

@Injectable()
export class CommentsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param commentsFilter (optional) 
     * @param isApprovedFilter (optional) 
     * @param isUnknownFilter (optional) 
     * @param maxRateFilter (optional) 
     * @param minRateFilter (optional) 
     * @param entityFilter (optional) 
     * @param entityRefFilter (optional) 
     * @param maxEntityRefFilter (optional) 
     * @param minEntityRefFilter (optional) 
     * @param contactFirstNameFilter (optional) 
     * @param commentCommentsFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, commentsFilter: string | undefined, isApprovedFilter: number | undefined, isUnknownFilter: number | undefined, maxRateFilter: number | undefined, minRateFilter: number | undefined, entityFilter: number | undefined, entityRefFilter: number | undefined, maxEntityRefFilter: number | undefined, minEntityRefFilter: number | undefined, contactFirstNameFilter: string | undefined, commentCommentsFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCommentForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Comments/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (commentsFilter === null)
            throw new Error("The parameter 'commentsFilter' cannot be null.");
        else if (commentsFilter !== undefined)
            url_ += "CommentsFilter=" + encodeURIComponent("" + commentsFilter) + "&"; 
        if (isApprovedFilter === null)
            throw new Error("The parameter 'isApprovedFilter' cannot be null.");
        else if (isApprovedFilter !== undefined)
            url_ += "IsApprovedFilter=" + encodeURIComponent("" + isApprovedFilter) + "&"; 
        if (isUnknownFilter === null)
            throw new Error("The parameter 'isUnknownFilter' cannot be null.");
        else if (isUnknownFilter !== undefined)
            url_ += "IsUnknownFilter=" + encodeURIComponent("" + isUnknownFilter) + "&"; 
        if (maxRateFilter === null)
            throw new Error("The parameter 'maxRateFilter' cannot be null.");
        else if (maxRateFilter !== undefined)
            url_ += "MaxRateFilter=" + encodeURIComponent("" + maxRateFilter) + "&"; 
        if (minRateFilter === null)
            throw new Error("The parameter 'minRateFilter' cannot be null.");
        else if (minRateFilter !== undefined)
            url_ += "MinRateFilter=" + encodeURIComponent("" + minRateFilter) + "&"; 
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (entityRefFilter === null)
            throw new Error("The parameter 'entityRefFilter' cannot be null.");
        else if (entityRefFilter !== undefined)
            url_ += "EntityRefFilter=" + encodeURIComponent("" + entityRefFilter) + "&"; 
        if (maxEntityRefFilter === null)
            throw new Error("The parameter 'maxEntityRefFilter' cannot be null.");
        else if (maxEntityRefFilter !== undefined)
            url_ += "MaxEntityRefFilter=" + encodeURIComponent("" + maxEntityRefFilter) + "&"; 
        if (minEntityRefFilter === null)
            throw new Error("The parameter 'minEntityRefFilter' cannot be null.");
        else if (minEntityRefFilter !== undefined)
            url_ += "MinEntityRefFilter=" + encodeURIComponent("" + minEntityRefFilter) + "&"; 
        if (contactFirstNameFilter === null)
            throw new Error("The parameter 'contactFirstNameFilter' cannot be null.");
        else if (contactFirstNameFilter !== undefined)
            url_ += "ContactFirstNameFilter=" + encodeURIComponent("" + contactFirstNameFilter) + "&"; 
        if (commentCommentsFilter === null)
            throw new Error("The parameter 'commentCommentsFilter' cannot be null.");
        else if (commentCommentsFilter !== undefined)
            url_ += "CommentCommentsFilter=" + encodeURIComponent("" + commentCommentsFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCommentForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCommentForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCommentForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCommentForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCommentForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCommentForView(id: number | undefined): Observable<GetCommentForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Comments/GetCommentForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommentForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommentForView(<any>response_);
                } catch (e) {
                    return <Observable<GetCommentForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCommentForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommentForView(response: HttpResponseBase): Observable<GetCommentForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCommentForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCommentForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCommentForEdit(id: number | undefined): Observable<GetCommentForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Comments/GetCommentForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommentForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommentForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetCommentForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCommentForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommentForEdit(response: HttpResponseBase): Observable<GetCommentForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCommentForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCommentForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditCommentDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Comments/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createForShop(body: CreateCommentForShopDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Comments/CreateForShop";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateForShop(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateForShop(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateForShop(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param commentId (optional) 
     * @return Success
     */
    approvedByAdmin(commentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Comments/ApprovedByAdmin?";
        if (commentId === null)
            throw new Error("The parameter 'commentId' cannot be null.");
        else if (commentId !== undefined)
            url_ += "commentId=" + encodeURIComponent("" + commentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprovedByAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprovedByAdmin(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApprovedByAdmin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Comments/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param commentsFilter (optional) 
     * @param isApprovedFilter (optional) 
     * @param isUnknownFilter (optional) 
     * @param maxRateFilter (optional) 
     * @param minRateFilter (optional) 
     * @param entityFilter (optional) 
     * @param maxEntityRefFilter (optional) 
     * @param minEntityRefFilter (optional) 
     * @param contactFirstNameFilter (optional) 
     * @param commentCommentsFilter (optional) 
     * @return Success
     */
    getCommentsToExcel(filter: string | undefined, commentsFilter: string | undefined, isApprovedFilter: number | undefined, isUnknownFilter: number | undefined, maxRateFilter: number | undefined, minRateFilter: number | undefined, entityFilter: number | undefined, maxEntityRefFilter: number | undefined, minEntityRefFilter: number | undefined, contactFirstNameFilter: string | undefined, commentCommentsFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Comments/GetCommentsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (commentsFilter === null)
            throw new Error("The parameter 'commentsFilter' cannot be null.");
        else if (commentsFilter !== undefined)
            url_ += "CommentsFilter=" + encodeURIComponent("" + commentsFilter) + "&"; 
        if (isApprovedFilter === null)
            throw new Error("The parameter 'isApprovedFilter' cannot be null.");
        else if (isApprovedFilter !== undefined)
            url_ += "IsApprovedFilter=" + encodeURIComponent("" + isApprovedFilter) + "&"; 
        if (isUnknownFilter === null)
            throw new Error("The parameter 'isUnknownFilter' cannot be null.");
        else if (isUnknownFilter !== undefined)
            url_ += "IsUnknownFilter=" + encodeURIComponent("" + isUnknownFilter) + "&"; 
        if (maxRateFilter === null)
            throw new Error("The parameter 'maxRateFilter' cannot be null.");
        else if (maxRateFilter !== undefined)
            url_ += "MaxRateFilter=" + encodeURIComponent("" + maxRateFilter) + "&"; 
        if (minRateFilter === null)
            throw new Error("The parameter 'minRateFilter' cannot be null.");
        else if (minRateFilter !== undefined)
            url_ += "MinRateFilter=" + encodeURIComponent("" + minRateFilter) + "&"; 
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (maxEntityRefFilter === null)
            throw new Error("The parameter 'maxEntityRefFilter' cannot be null.");
        else if (maxEntityRefFilter !== undefined)
            url_ += "MaxEntityRefFilter=" + encodeURIComponent("" + maxEntityRefFilter) + "&"; 
        if (minEntityRefFilter === null)
            throw new Error("The parameter 'minEntityRefFilter' cannot be null.");
        else if (minEntityRefFilter !== undefined)
            url_ += "MinEntityRefFilter=" + encodeURIComponent("" + minEntityRefFilter) + "&"; 
        if (contactFirstNameFilter === null)
            throw new Error("The parameter 'contactFirstNameFilter' cannot be null.");
        else if (contactFirstNameFilter !== undefined)
            url_ += "ContactFirstNameFilter=" + encodeURIComponent("" + contactFirstNameFilter) + "&"; 
        if (commentCommentsFilter === null)
            throw new Error("The parameter 'commentCommentsFilter' cannot be null.");
        else if (commentCommentsFilter !== undefined)
            url_ += "CommentCommentsFilter=" + encodeURIComponent("" + commentCommentsFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommentsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommentsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommentsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllContactForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfCommentContactLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Comments/GetAllContactForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllContactForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllContactForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCommentContactLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfCommentContactLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllContactForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfCommentContactLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCommentContactLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCommentContactLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCommentForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfCommentCommentLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Comments/GetAllCommentForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCommentForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCommentForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCommentCommentLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfCommentCommentLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCommentForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfCommentCommentLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCommentCommentLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCommentCommentLookupTableDto>(<any>null);
    }
}

@Injectable()
export class CommoditiesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param titleFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, codeFilter: string | undefined, titleFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCommodityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Commodities/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCommodityForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCommodityForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCommodityForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCommodityForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCommodityForViewDto>(<any>null);
    }

    /**
     * @param commodityFilter (optional) 
     * @param identityCodeFilter (optional) 
     * @param branchRefFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCommodities(commodityFilter: string | undefined, identityCodeFilter: string | undefined, branchRefFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCommoditiesDto> {
        let url_ = this.baseUrl + "/api/services/app/Commodities/GetAllCommodities?";
        if (commodityFilter === null)
            throw new Error("The parameter 'commodityFilter' cannot be null.");
        else if (commodityFilter !== undefined)
            url_ += "CommodityFilter=" + encodeURIComponent("" + commodityFilter) + "&"; 
        if (identityCodeFilter === null)
            throw new Error("The parameter 'identityCodeFilter' cannot be null.");
        else if (identityCodeFilter !== undefined)
            url_ += "IdentityCodeFilter=" + encodeURIComponent("" + identityCodeFilter) + "&"; 
        if (branchRefFilter === null)
            throw new Error("The parameter 'branchRefFilter' cannot be null.");
        else if (branchRefFilter !== undefined)
            url_ += "BranchRefFilter=" + encodeURIComponent("" + branchRefFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCommodities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCommodities(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCommoditiesDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCommoditiesDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCommodities(response: HttpResponseBase): Observable<PagedResultDtoOfGetCommoditiesDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCommoditiesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCommoditiesDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCommodityForView(id: number | undefined): Observable<GetCommodityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Commodities/GetCommodityForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommodityForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommodityForView(<any>response_);
                } catch (e) {
                    return <Observable<GetCommodityForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCommodityForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommodityForView(response: HttpResponseBase): Observable<GetCommodityForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCommodityForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCommodityForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCommodityForEdit(id: number | undefined): Observable<GetCommodityForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Commodities/GetCommodityForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommodityForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommodityForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetCommodityForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCommodityForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommodityForEdit(response: HttpResponseBase): Observable<GetCommodityForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCommodityForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCommodityForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditCommodityDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Commodities/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Commodities/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param titleFilter (optional) 
     * @return Success
     */
    getCommoditiesToExcel(filter: string | undefined, codeFilter: string | undefined, titleFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Commodities/GetCommoditiesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommoditiesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommoditiesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommoditiesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param commodityFilter (optional) 
     * @param identityCodeFilter (optional) 
     * @param branchRefFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getClientCommodities(commodityFilter: string | undefined, identityCodeFilter: string | undefined, branchRefFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCommoditiesDto> {
        let url_ = this.baseUrl + "/api/services/app/Commodities/GetClientCommodities?";
        if (commodityFilter === null)
            throw new Error("The parameter 'commodityFilter' cannot be null.");
        else if (commodityFilter !== undefined)
            url_ += "CommodityFilter=" + encodeURIComponent("" + commodityFilter) + "&"; 
        if (identityCodeFilter === null)
            throw new Error("The parameter 'identityCodeFilter' cannot be null.");
        else if (identityCodeFilter !== undefined)
            url_ += "IdentityCodeFilter=" + encodeURIComponent("" + identityCodeFilter) + "&"; 
        if (branchRefFilter === null)
            throw new Error("The parameter 'branchRefFilter' cannot be null.");
        else if (branchRefFilter !== undefined)
            url_ += "BranchRefFilter=" + encodeURIComponent("" + branchRefFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientCommodities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientCommodities(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCommoditiesDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCommoditiesDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetClientCommodities(response: HttpResponseBase): Observable<PagedResultDtoOfGetCommoditiesDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCommoditiesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCommoditiesDto>(<any>null);
    }

    /**
     * @param commodityFilter (optional) 
     * @param identityCodeFilter (optional) 
     * @param branchRefFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getFamilyCommodities(commodityFilter: string | undefined, identityCodeFilter: string | undefined, branchRefFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCommoditiesDto> {
        let url_ = this.baseUrl + "/api/services/app/Commodities/GetFamilyCommodities?";
        if (commodityFilter === null)
            throw new Error("The parameter 'commodityFilter' cannot be null.");
        else if (commodityFilter !== undefined)
            url_ += "CommodityFilter=" + encodeURIComponent("" + commodityFilter) + "&"; 
        if (identityCodeFilter === null)
            throw new Error("The parameter 'identityCodeFilter' cannot be null.");
        else if (identityCodeFilter !== undefined)
            url_ += "IdentityCodeFilter=" + encodeURIComponent("" + identityCodeFilter) + "&"; 
        if (branchRefFilter === null)
            throw new Error("The parameter 'branchRefFilter' cannot be null.");
        else if (branchRefFilter !== undefined)
            url_ += "BranchRefFilter=" + encodeURIComponent("" + branchRefFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFamilyCommodities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFamilyCommodities(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCommoditiesDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCommoditiesDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFamilyCommodities(response: HttpResponseBase): Observable<PagedResultDtoOfGetCommoditiesDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCommoditiesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCommoditiesDto>(<any>null);
    }

    /**
     * @param commodityId (optional) 
     * @param branchId (optional) 
     * @return Success
     */
    getCommodityInventory(commodityId: number | undefined, branchId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Commodities/GetCommodityInventory?";
        if (commodityId === null)
            throw new Error("The parameter 'commodityId' cannot be null.");
        else if (commodityId !== undefined)
            url_ += "commodityId=" + encodeURIComponent("" + commodityId) + "&"; 
        if (branchId === null)
            throw new Error("The parameter 'branchId' cannot be null.");
        else if (branchId !== undefined)
            url_ += "branchId=" + encodeURIComponent("" + branchId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommodityInventory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommodityInventory(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommodityInventory(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCommodityGroupForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfCommodityCommodityGroupLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Commodities/GetAllCommodityGroupForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCommodityGroupForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCommodityGroupForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCommodityCommodityGroupLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfCommodityCommodityGroupLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCommodityGroupForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfCommodityCommodityGroupLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCommodityCommodityGroupLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCommodityCommodityGroupLookupTableDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllBranchForForTableDropdown(): Observable<AllBranchLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Commodities/GetAllBranchForForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBranchForForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBranchForForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<AllBranchLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AllBranchLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBranchForForTableDropdown(response: HttpResponseBase): Observable<AllBranchLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AllBranchLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AllBranchLookupTableDto[]>(<any>null);
    }
}

@Injectable()
export class CommodityBasketDetailsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param commodityBasketRef (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, commodityBasketRef: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCommodityBasketDetailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CommodityBasketDetails/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (commodityBasketRef === null)
            throw new Error("The parameter 'commodityBasketRef' cannot be null.");
        else if (commodityBasketRef !== undefined)
            url_ += "CommodityBasketRef=" + encodeURIComponent("" + commodityBasketRef) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCommodityBasketDetailForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCommodityBasketDetailForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCommodityBasketDetailForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCommodityBasketDetailForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCommodityBasketDetailForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCommodityBasketDetailForView(id: number | undefined): Observable<GetCommodityBasketDetailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CommodityBasketDetails/GetCommodityBasketDetailForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommodityBasketDetailForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommodityBasketDetailForView(<any>response_);
                } catch (e) {
                    return <Observable<GetCommodityBasketDetailForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCommodityBasketDetailForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommodityBasketDetailForView(response: HttpResponseBase): Observable<GetCommodityBasketDetailForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCommodityBasketDetailForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCommodityBasketDetailForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCommodityBasketDetailForEdit(id: number | undefined): Observable<GetCommodityBasketDetailForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/CommodityBasketDetails/GetCommodityBasketDetailForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommodityBasketDetailForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommodityBasketDetailForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetCommodityBasketDetailForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCommodityBasketDetailForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommodityBasketDetailForEdit(response: HttpResponseBase): Observable<GetCommodityBasketDetailForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCommodityBasketDetailForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCommodityBasketDetailForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditCommodityBasketDetailDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CommodityBasketDetails/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CommodityBasketDetails/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param maxAmountFilter (optional) 
     * @param minAmountFilter (optional) 
     * @param commodityBasketTitleFilter (optional) 
     * @param commodityGroupTitleFilter (optional) 
     * @return Success
     */
    getCommodityBasketDetailsToExcel(filter: string | undefined, maxAmountFilter: number | undefined, minAmountFilter: number | undefined, commodityBasketTitleFilter: string | undefined, commodityGroupTitleFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/CommodityBasketDetails/GetCommodityBasketDetailsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxAmountFilter === null)
            throw new Error("The parameter 'maxAmountFilter' cannot be null.");
        else if (maxAmountFilter !== undefined)
            url_ += "MaxAmountFilter=" + encodeURIComponent("" + maxAmountFilter) + "&"; 
        if (minAmountFilter === null)
            throw new Error("The parameter 'minAmountFilter' cannot be null.");
        else if (minAmountFilter !== undefined)
            url_ += "MinAmountFilter=" + encodeURIComponent("" + minAmountFilter) + "&"; 
        if (commodityBasketTitleFilter === null)
            throw new Error("The parameter 'commodityBasketTitleFilter' cannot be null.");
        else if (commodityBasketTitleFilter !== undefined)
            url_ += "CommodityBasketTitleFilter=" + encodeURIComponent("" + commodityBasketTitleFilter) + "&"; 
        if (commodityGroupTitleFilter === null)
            throw new Error("The parameter 'commodityGroupTitleFilter' cannot be null.");
        else if (commodityGroupTitleFilter !== undefined)
            url_ += "CommodityGroupTitleFilter=" + encodeURIComponent("" + commodityGroupTitleFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommodityBasketDetailsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommodityBasketDetailsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommodityBasketDetailsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCommodityBasketForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfCommodityBasketDetailCommodityBasketLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/CommodityBasketDetails/GetAllCommodityBasketForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCommodityBasketForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCommodityBasketForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCommodityBasketDetailCommodityBasketLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfCommodityBasketDetailCommodityBasketLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCommodityBasketForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfCommodityBasketDetailCommodityBasketLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCommodityBasketDetailCommodityBasketLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCommodityBasketDetailCommodityBasketLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCommodityForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfCommodityBasketDetailCommodityLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/CommodityBasketDetails/GetAllCommodityForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCommodityForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCommodityForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCommodityBasketDetailCommodityLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfCommodityBasketDetailCommodityLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCommodityForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfCommodityBasketDetailCommodityLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCommodityBasketDetailCommodityLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCommodityBasketDetailCommodityLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCommodityGroupForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfCommodityBasketDetailCommodityGroupLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/CommodityBasketDetails/GetAllCommodityGroupForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCommodityGroupForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCommodityGroupForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCommodityBasketDetailCommodityGroupLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfCommodityBasketDetailCommodityGroupLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCommodityGroupForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfCommodityBasketDetailCommodityGroupLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCommodityBasketDetailCommodityGroupLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCommodityBasketDetailCommodityGroupLookupTableDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllCommodityGroupForTableDropdown(): Observable<CommodityBasketDetailCommodityGroupLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CommodityBasketDetails/GetAllCommodityGroupForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCommodityGroupForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCommodityGroupForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<CommodityBasketDetailCommodityGroupLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CommodityBasketDetailCommodityGroupLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCommodityGroupForTableDropdown(response: HttpResponseBase): Observable<CommodityBasketDetailCommodityGroupLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommodityBasketDetailCommodityGroupLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommodityBasketDetailCommodityGroupLookupTableDto[]>(<any>null);
    }
}

@Injectable()
export class CommodityBasketsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param codeFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param defaultValueFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, titleFilter: string | undefined, codeFilter: string | undefined, descriptionFilter: string | undefined, defaultValueFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCommodityBasketForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CommodityBaskets/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (defaultValueFilter === null)
            throw new Error("The parameter 'defaultValueFilter' cannot be null.");
        else if (defaultValueFilter !== undefined)
            url_ += "DefaultValueFilter=" + encodeURIComponent("" + defaultValueFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCommodityBasketForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCommodityBasketForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCommodityBasketForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCommodityBasketForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCommodityBasketForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCommodityBasketForView(id: number | undefined): Observable<GetCommodityBasketForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CommodityBaskets/GetCommodityBasketForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommodityBasketForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommodityBasketForView(<any>response_);
                } catch (e) {
                    return <Observable<GetCommodityBasketForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCommodityBasketForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommodityBasketForView(response: HttpResponseBase): Observable<GetCommodityBasketForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCommodityBasketForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCommodityBasketForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCommodityBasketForEdit(id: number | undefined): Observable<GetCommodityBasketForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/CommodityBaskets/GetCommodityBasketForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommodityBasketForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommodityBasketForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetCommodityBasketForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCommodityBasketForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommodityBasketForEdit(response: HttpResponseBase): Observable<GetCommodityBasketForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCommodityBasketForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCommodityBasketForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditCommodityBasketAndDetails(body: CreateOrEditCommodityBasketAndDetailsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CommodityBaskets/CreateOrEditCommodityBasketAndDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditCommodityBasketAndDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditCommodityBasketAndDetails(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditCommodityBasketAndDetails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditCommodityBasketDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CommodityBaskets/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CommodityBaskets/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param codeFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param defaultValueFilter (optional) 
     * @return Success
     */
    getCommodityBasketsToExcel(filter: string | undefined, titleFilter: string | undefined, codeFilter: string | undefined, descriptionFilter: string | undefined, defaultValueFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/CommodityBaskets/GetCommodityBasketsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (defaultValueFilter === null)
            throw new Error("The parameter 'defaultValueFilter' cannot be null.");
        else if (defaultValueFilter !== undefined)
            url_ += "DefaultValueFilter=" + encodeURIComponent("" + defaultValueFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommodityBasketsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommodityBasketsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommodityBasketsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class CommodityGroupsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param codeFilter (optional) 
     * @param unitFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, titleFilter: string | undefined, codeFilter: string | undefined, unitFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCommodityGroupForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CommodityGroups/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (unitFilter === null)
            throw new Error("The parameter 'unitFilter' cannot be null.");
        else if (unitFilter !== undefined)
            url_ += "UnitFilter=" + encodeURIComponent("" + unitFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCommodityGroupForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCommodityGroupForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCommodityGroupForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCommodityGroupForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCommodityGroupForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCommodityGroupForView(id: number | undefined): Observable<GetCommodityGroupForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CommodityGroups/GetCommodityGroupForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommodityGroupForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommodityGroupForView(<any>response_);
                } catch (e) {
                    return <Observable<GetCommodityGroupForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCommodityGroupForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommodityGroupForView(response: HttpResponseBase): Observable<GetCommodityGroupForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCommodityGroupForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCommodityGroupForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCommodityGroupForEdit(id: number | undefined): Observable<GetCommodityGroupForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/CommodityGroups/GetCommodityGroupForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommodityGroupForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommodityGroupForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetCommodityGroupForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCommodityGroupForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommodityGroupForEdit(response: HttpResponseBase): Observable<GetCommodityGroupForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCommodityGroupForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCommodityGroupForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditCommodityGroupDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CommodityGroups/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CommodityGroups/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param codeFilter (optional) 
     * @return Success
     */
    getCommodityGroupsToExcel(filter: string | undefined, titleFilter: string | undefined, codeFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/CommodityGroups/GetCommodityGroupsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommodityGroupsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommodityGroupsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommodityGroupsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class CommonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    createCachesFromFile(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Common/CreateCachesFromFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCachesFromFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCachesFromFile(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateCachesFromFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class CommonLookupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param onlyFreeItems (optional) 
     * @return Success
     */
    getEditionsForCombobox(onlyFreeItems: boolean | undefined): Observable<ListResultDtoOfSubscribableEditionComboboxItemDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetEditionsForCombobox?";
        if (onlyFreeItems === null)
            throw new Error("The parameter 'onlyFreeItems' cannot be null.");
        else if (onlyFreeItems !== undefined)
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionsForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionsForCombobox(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfSubscribableEditionComboboxItemDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfSubscribableEditionComboboxItemDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEditionsForCombobox(response: HttpResponseBase): Observable<ListResultDtoOfSubscribableEditionComboboxItemDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfSubscribableEditionComboboxItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfSubscribableEditionComboboxItemDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    findUsers(body: FindUsersInput | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/FindUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindUsers(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfNameValueDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfNameValueDto>><any>_observableThrow(response_);
        }));
    }

    protected processFindUsers(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfNameValueDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDefaultEditionName(): Observable<GetDefaultEditionNameOutput> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetDefaultEditionName";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultEditionName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultEditionName(<any>response_);
                } catch (e) {
                    return <Observable<GetDefaultEditionNameOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetDefaultEditionNameOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetDefaultEditionName(response: HttpResponseBase): Observable<GetDefaultEditionNameOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDefaultEditionNameOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDefaultEditionNameOutput>(<any>null);
    }
}

@Injectable()
export class ConditionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param codeFilter (optional) 
     * @param fileCodeFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param entityFilter (optional) 
     * @param propertyFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, titleFilter: string | undefined, codeFilter: string | undefined, fileCodeFilter: string | undefined, descriptionFilter: string | undefined, entityFilter: number | undefined, propertyFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetConditionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Conditions/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (fileCodeFilter === null)
            throw new Error("The parameter 'fileCodeFilter' cannot be null.");
        else if (fileCodeFilter !== undefined)
            url_ += "FileCodeFilter=" + encodeURIComponent("" + fileCodeFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (propertyFilter === null)
            throw new Error("The parameter 'propertyFilter' cannot be null.");
        else if (propertyFilter !== undefined)
            url_ += "PropertyFilter=" + encodeURIComponent("" + propertyFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetConditionForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetConditionForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetConditionForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetConditionForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetConditionForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getConditionForView(id: number | undefined): Observable<GetConditionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Conditions/GetConditionForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConditionForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConditionForView(<any>response_);
                } catch (e) {
                    return <Observable<GetConditionForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetConditionForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetConditionForView(response: HttpResponseBase): Observable<GetConditionForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetConditionForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetConditionForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getConditionForEdit(id: number | undefined): Observable<GetConditionForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Conditions/GetConditionForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConditionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConditionForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetConditionForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetConditionForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetConditionForEdit(response: HttpResponseBase): Observable<GetConditionForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetConditionForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetConditionForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditConditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Conditions/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Conditions/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param codeFilter (optional) 
     * @param fileCodeFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param entityFilter (optional) 
     * @param propertyFilter (optional) 
     * @return Success
     */
    getConditionsToExcel(filter: string | undefined, titleFilter: string | undefined, codeFilter: string | undefined, fileCodeFilter: string | undefined, descriptionFilter: string | undefined, entityFilter: number | undefined, propertyFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Conditions/GetConditionsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (fileCodeFilter === null)
            throw new Error("The parameter 'fileCodeFilter' cannot be null.");
        else if (fileCodeFilter !== undefined)
            url_ += "FileCodeFilter=" + encodeURIComponent("" + fileCodeFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (propertyFilter === null)
            throw new Error("The parameter 'propertyFilter' cannot be null.");
        else if (propertyFilter !== undefined)
            url_ += "PropertyFilter=" + encodeURIComponent("" + propertyFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConditionsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConditionsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetConditionsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getEntityProperties(entity: Entities): Observable<GetEntityPropertiesDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Conditions/GetEntityProperties?";
        if (entity === undefined || entity === null)
            throw new Error("The parameter 'entity' must be defined and cannot be null.");
        else
            url_ += "entity=" + encodeURIComponent("" + entity) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityProperties(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityProperties(<any>response_);
                } catch (e) {
                    return <Observable<GetEntityPropertiesDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetEntityPropertiesDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetEntityProperties(response: HttpResponseBase): Observable<GetEntityPropertiesDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetEntityPropertiesDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEntityPropertiesDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllAttributeForTableDropdown(): Observable<ConditionAttributeLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Conditions/GetAllAttributeForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAttributeForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAttributeForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<ConditionAttributeLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConditionAttributeLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllAttributeForTableDropdown(response: HttpResponseBase): Observable<ConditionAttributeLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConditionAttributeLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConditionAttributeLookupTableDto[]>(<any>null);
    }
}

@Injectable()
export class CondolenceMessagesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param isApprovedFilter (optional) 
     * @param messageFilter (optional) 
     * @param contactFirstNameFilter (optional) 
     * @param deceasedFirstNameFilter (optional) 
     * @param condolenceMessagemessageFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, isApprovedFilter: number | undefined, messageFilter: string | undefined, contactFirstNameFilter: string | undefined, deceasedFirstNameFilter: string | undefined, condolenceMessagemessageFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCondolenceMessageForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CondolenceMessages/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (isApprovedFilter === null)
            throw new Error("The parameter 'isApprovedFilter' cannot be null.");
        else if (isApprovedFilter !== undefined)
            url_ += "IsApprovedFilter=" + encodeURIComponent("" + isApprovedFilter) + "&"; 
        if (messageFilter === null)
            throw new Error("The parameter 'messageFilter' cannot be null.");
        else if (messageFilter !== undefined)
            url_ += "messageFilter=" + encodeURIComponent("" + messageFilter) + "&"; 
        if (contactFirstNameFilter === null)
            throw new Error("The parameter 'contactFirstNameFilter' cannot be null.");
        else if (contactFirstNameFilter !== undefined)
            url_ += "ContactFirstNameFilter=" + encodeURIComponent("" + contactFirstNameFilter) + "&"; 
        if (deceasedFirstNameFilter === null)
            throw new Error("The parameter 'deceasedFirstNameFilter' cannot be null.");
        else if (deceasedFirstNameFilter !== undefined)
            url_ += "DeceasedFirstNameFilter=" + encodeURIComponent("" + deceasedFirstNameFilter) + "&"; 
        if (condolenceMessagemessageFilter === null)
            throw new Error("The parameter 'condolenceMessagemessageFilter' cannot be null.");
        else if (condolenceMessagemessageFilter !== undefined)
            url_ += "CondolenceMessagemessageFilter=" + encodeURIComponent("" + condolenceMessagemessageFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCondolenceMessageForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCondolenceMessageForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCondolenceMessageForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCondolenceMessageForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCondolenceMessageForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCondolenceMessageForView(id: number | undefined): Observable<GetCondolenceMessageForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CondolenceMessages/GetCondolenceMessageForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCondolenceMessageForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCondolenceMessageForView(<any>response_);
                } catch (e) {
                    return <Observable<GetCondolenceMessageForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCondolenceMessageForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCondolenceMessageForView(response: HttpResponseBase): Observable<GetCondolenceMessageForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCondolenceMessageForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCondolenceMessageForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCondolenceMessageForEdit(id: number | undefined): Observable<GetCondolenceMessageForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/CondolenceMessages/GetCondolenceMessageForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCondolenceMessageForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCondolenceMessageForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetCondolenceMessageForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCondolenceMessageForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCondolenceMessageForEdit(response: HttpResponseBase): Observable<GetCondolenceMessageForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCondolenceMessageForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCondolenceMessageForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditCondolenceMessageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CondolenceMessages/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param deceasedCode (optional) 
     * @param page (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getCondolenceMessagesForShop(deceasedCode: string | undefined, page: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCondolenceMessageForShopDto> {
        let url_ = this.baseUrl + "/api/services/app/CondolenceMessages/GetCondolenceMessagesForShop?";
        if (deceasedCode === null)
            throw new Error("The parameter 'deceasedCode' cannot be null.");
        else if (deceasedCode !== undefined)
            url_ += "DeceasedCode=" + encodeURIComponent("" + deceasedCode) + "&"; 
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCondolenceMessagesForShop(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCondolenceMessagesForShop(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCondolenceMessageForShopDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCondolenceMessageForShopDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCondolenceMessagesForShop(response: HttpResponseBase): Observable<PagedResultDtoOfGetCondolenceMessageForShopDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCondolenceMessageForShopDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCondolenceMessageForShopDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CondolenceMessages/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param messageFilter (optional) 
     * @param contactFirstNameFilter (optional) 
     * @param deceasedFirstNameFilter (optional) 
     * @param condolenceMessagemessageFilter (optional) 
     * @return Success
     */
    getCondolenceMessagesToExcel(filter: string | undefined, messageFilter: string | undefined, contactFirstNameFilter: string | undefined, deceasedFirstNameFilter: string | undefined, condolenceMessagemessageFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/CondolenceMessages/GetCondolenceMessagesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (messageFilter === null)
            throw new Error("The parameter 'messageFilter' cannot be null.");
        else if (messageFilter !== undefined)
            url_ += "messageFilter=" + encodeURIComponent("" + messageFilter) + "&"; 
        if (contactFirstNameFilter === null)
            throw new Error("The parameter 'contactFirstNameFilter' cannot be null.");
        else if (contactFirstNameFilter !== undefined)
            url_ += "ContactFirstNameFilter=" + encodeURIComponent("" + contactFirstNameFilter) + "&"; 
        if (deceasedFirstNameFilter === null)
            throw new Error("The parameter 'deceasedFirstNameFilter' cannot be null.");
        else if (deceasedFirstNameFilter !== undefined)
            url_ += "DeceasedFirstNameFilter=" + encodeURIComponent("" + deceasedFirstNameFilter) + "&"; 
        if (condolenceMessagemessageFilter === null)
            throw new Error("The parameter 'condolenceMessagemessageFilter' cannot be null.");
        else if (condolenceMessagemessageFilter !== undefined)
            url_ += "CondolenceMessagemessageFilter=" + encodeURIComponent("" + condolenceMessagemessageFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCondolenceMessagesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCondolenceMessagesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCondolenceMessagesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllContactForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfCondolenceMessageContactLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/CondolenceMessages/GetAllContactForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllContactForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllContactForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCondolenceMessageContactLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfCondolenceMessageContactLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllContactForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfCondolenceMessageContactLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCondolenceMessageContactLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCondolenceMessageContactLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllDeceasedForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfCondolenceMessageDeceasedLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/CondolenceMessages/GetAllDeceasedForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDeceasedForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDeceasedForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCondolenceMessageDeceasedLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfCondolenceMessageDeceasedLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllDeceasedForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfCondolenceMessageDeceasedLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCondolenceMessageDeceasedLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCondolenceMessageDeceasedLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCondolenceMessageForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfCondolenceMessageCondolenceMessageLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/CondolenceMessages/GetAllCondolenceMessageForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCondolenceMessageForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCondolenceMessageForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCondolenceMessageCondolenceMessageLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfCondolenceMessageCondolenceMessageLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCondolenceMessageForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfCondolenceMessageCondolenceMessageLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCondolenceMessageCondolenceMessageLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCondolenceMessageCondolenceMessageLookupTableDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllApprovedCondolenceMessageForTableDropdown(): Observable<CondolenceMessageCondolenceMessageLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CondolenceMessages/GetAllApprovedCondolenceMessageForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllApprovedCondolenceMessageForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllApprovedCondolenceMessageForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<CondolenceMessageCondolenceMessageLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CondolenceMessageCondolenceMessageLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllApprovedCondolenceMessageForTableDropdown(response: HttpResponseBase): Observable<CondolenceMessageCondolenceMessageLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CondolenceMessageCondolenceMessageLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CondolenceMessageCondolenceMessageLookupTableDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approveCondolenceMessage(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CondolenceMessages/ApproveCondolenceMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveCondolenceMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveCondolenceMessage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApproveCondolenceMessage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param condolenceMessageId (optional) 
     * @param isDefault (optional) 
     * @return Success
     */
    makeDefaultCondolenceMessage(condolenceMessageId: number | undefined, isDefault: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CondolenceMessages/MakeDefaultCondolenceMessage?";
        if (condolenceMessageId === null)
            throw new Error("The parameter 'condolenceMessageId' cannot be null.");
        else if (condolenceMessageId !== undefined)
            url_ += "condolenceMessageId=" + encodeURIComponent("" + condolenceMessageId) + "&"; 
        if (isDefault === null)
            throw new Error("The parameter 'isDefault' cannot be null.");
        else if (isDefault !== undefined)
            url_ += "isDefault=" + encodeURIComponent("" + isDefault) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMakeDefaultCondolenceMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMakeDefaultCondolenceMessage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processMakeDefaultCondolenceMessage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ConsumesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param accountCodeFilter (optional) 
     * @param maxMinAllowedOnePersonInYearFilter (optional) 
     * @param minMinAllowedOnePersonInYearFilter (optional) 
     * @param maxMaxAllowedOnePersonInYearFilter (optional) 
     * @param minMaxAllowedOnePersonInYearFilter (optional) 
     * @param maxMinAgeFilter (optional) 
     * @param minMinAgeFilter (optional) 
     * @param maxMaxAgeFilter (optional) 
     * @param minMaxAgeFilter (optional) 
     * @param stateFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param genderConditionFilter (optional) 
     * @param seyedFilter (optional) 
     * @param belongFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, nameFilter: string | undefined, accountCodeFilter: string | undefined, maxMinAllowedOnePersonInYearFilter: number | undefined, minMinAllowedOnePersonInYearFilter: number | undefined, maxMaxAllowedOnePersonInYearFilter: number | undefined, minMaxAllowedOnePersonInYearFilter: number | undefined, maxMinAgeFilter: number | undefined, minMinAgeFilter: number | undefined, maxMaxAgeFilter: number | undefined, minMaxAgeFilter: number | undefined, stateFilter: number | undefined, descriptionFilter: string | undefined, genderConditionFilter: number | undefined, seyedFilter: number | undefined, belongFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetConsumeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Consumes/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&"; 
        if (accountCodeFilter === null)
            throw new Error("The parameter 'accountCodeFilter' cannot be null.");
        else if (accountCodeFilter !== undefined)
            url_ += "AccountCodeFilter=" + encodeURIComponent("" + accountCodeFilter) + "&"; 
        if (maxMinAllowedOnePersonInYearFilter === null)
            throw new Error("The parameter 'maxMinAllowedOnePersonInYearFilter' cannot be null.");
        else if (maxMinAllowedOnePersonInYearFilter !== undefined)
            url_ += "MaxMinAllowedOnePersonInYearFilter=" + encodeURIComponent("" + maxMinAllowedOnePersonInYearFilter) + "&"; 
        if (minMinAllowedOnePersonInYearFilter === null)
            throw new Error("The parameter 'minMinAllowedOnePersonInYearFilter' cannot be null.");
        else if (minMinAllowedOnePersonInYearFilter !== undefined)
            url_ += "MinMinAllowedOnePersonInYearFilter=" + encodeURIComponent("" + minMinAllowedOnePersonInYearFilter) + "&"; 
        if (maxMaxAllowedOnePersonInYearFilter === null)
            throw new Error("The parameter 'maxMaxAllowedOnePersonInYearFilter' cannot be null.");
        else if (maxMaxAllowedOnePersonInYearFilter !== undefined)
            url_ += "MaxMaxAllowedOnePersonInYearFilter=" + encodeURIComponent("" + maxMaxAllowedOnePersonInYearFilter) + "&"; 
        if (minMaxAllowedOnePersonInYearFilter === null)
            throw new Error("The parameter 'minMaxAllowedOnePersonInYearFilter' cannot be null.");
        else if (minMaxAllowedOnePersonInYearFilter !== undefined)
            url_ += "MinMaxAllowedOnePersonInYearFilter=" + encodeURIComponent("" + minMaxAllowedOnePersonInYearFilter) + "&"; 
        if (maxMinAgeFilter === null)
            throw new Error("The parameter 'maxMinAgeFilter' cannot be null.");
        else if (maxMinAgeFilter !== undefined)
            url_ += "MaxMinAgeFilter=" + encodeURIComponent("" + maxMinAgeFilter) + "&"; 
        if (minMinAgeFilter === null)
            throw new Error("The parameter 'minMinAgeFilter' cannot be null.");
        else if (minMinAgeFilter !== undefined)
            url_ += "MinMinAgeFilter=" + encodeURIComponent("" + minMinAgeFilter) + "&"; 
        if (maxMaxAgeFilter === null)
            throw new Error("The parameter 'maxMaxAgeFilter' cannot be null.");
        else if (maxMaxAgeFilter !== undefined)
            url_ += "MaxMaxAgeFilter=" + encodeURIComponent("" + maxMaxAgeFilter) + "&"; 
        if (minMaxAgeFilter === null)
            throw new Error("The parameter 'minMaxAgeFilter' cannot be null.");
        else if (minMaxAgeFilter !== undefined)
            url_ += "MinMaxAgeFilter=" + encodeURIComponent("" + minMaxAgeFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (genderConditionFilter === null)
            throw new Error("The parameter 'genderConditionFilter' cannot be null.");
        else if (genderConditionFilter !== undefined)
            url_ += "GenderConditionFilter=" + encodeURIComponent("" + genderConditionFilter) + "&"; 
        if (seyedFilter === null)
            throw new Error("The parameter 'seyedFilter' cannot be null.");
        else if (seyedFilter !== undefined)
            url_ += "SeyedFilter=" + encodeURIComponent("" + seyedFilter) + "&"; 
        if (belongFilter === null)
            throw new Error("The parameter 'belongFilter' cannot be null.");
        else if (belongFilter !== undefined)
            url_ += "BelongFilter=" + encodeURIComponent("" + belongFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetConsumeForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetConsumeForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetConsumeForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetConsumeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetConsumeForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getConsumeForView(id: number | undefined): Observable<GetConsumeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Consumes/GetConsumeForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsumeForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsumeForView(<any>response_);
                } catch (e) {
                    return <Observable<GetConsumeForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetConsumeForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetConsumeForView(response: HttpResponseBase): Observable<GetConsumeForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetConsumeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetConsumeForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getConsumeForEdit(id: number | undefined): Observable<GetConsumeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Consumes/GetConsumeForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsumeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsumeForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetConsumeForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetConsumeForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetConsumeForEdit(response: HttpResponseBase): Observable<GetConsumeForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetConsumeForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetConsumeForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditConsumeAndTags(body: CreateOrEditConsumeAndTagsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Consumes/CreateOrEditConsumeAndTags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditConsumeAndTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditConsumeAndTags(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditConsumeAndTags(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Consumes/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param accountCodeFilter (optional) 
     * @param maxMinAllowedOnePersonInYearFilter (optional) 
     * @param minMinAllowedOnePersonInYearFilter (optional) 
     * @param maxMaxAllowedOnePersonInYearFilter (optional) 
     * @param minMaxAllowedOnePersonInYearFilter (optional) 
     * @param maxMinAgeFilter (optional) 
     * @param minMinAgeFilter (optional) 
     * @param maxMaxAgeFilter (optional) 
     * @param minMaxAgeFilter (optional) 
     * @param stateFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param genderConditionFilter (optional) 
     * @param seyedFilter (optional) 
     * @param belongFilter (optional) 
     * @return Success
     */
    getConsumesToExcel(filter: string | undefined, nameFilter: string | undefined, accountCodeFilter: string | undefined, maxMinAllowedOnePersonInYearFilter: number | undefined, minMinAllowedOnePersonInYearFilter: number | undefined, maxMaxAllowedOnePersonInYearFilter: number | undefined, minMaxAllowedOnePersonInYearFilter: number | undefined, maxMinAgeFilter: number | undefined, minMinAgeFilter: number | undefined, maxMaxAgeFilter: number | undefined, minMaxAgeFilter: number | undefined, stateFilter: number | undefined, descriptionFilter: string | undefined, genderConditionFilter: number | undefined, seyedFilter: number | undefined, belongFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Consumes/GetConsumesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&"; 
        if (accountCodeFilter === null)
            throw new Error("The parameter 'accountCodeFilter' cannot be null.");
        else if (accountCodeFilter !== undefined)
            url_ += "AccountCodeFilter=" + encodeURIComponent("" + accountCodeFilter) + "&"; 
        if (maxMinAllowedOnePersonInYearFilter === null)
            throw new Error("The parameter 'maxMinAllowedOnePersonInYearFilter' cannot be null.");
        else if (maxMinAllowedOnePersonInYearFilter !== undefined)
            url_ += "MaxMinAllowedOnePersonInYearFilter=" + encodeURIComponent("" + maxMinAllowedOnePersonInYearFilter) + "&"; 
        if (minMinAllowedOnePersonInYearFilter === null)
            throw new Error("The parameter 'minMinAllowedOnePersonInYearFilter' cannot be null.");
        else if (minMinAllowedOnePersonInYearFilter !== undefined)
            url_ += "MinMinAllowedOnePersonInYearFilter=" + encodeURIComponent("" + minMinAllowedOnePersonInYearFilter) + "&"; 
        if (maxMaxAllowedOnePersonInYearFilter === null)
            throw new Error("The parameter 'maxMaxAllowedOnePersonInYearFilter' cannot be null.");
        else if (maxMaxAllowedOnePersonInYearFilter !== undefined)
            url_ += "MaxMaxAllowedOnePersonInYearFilter=" + encodeURIComponent("" + maxMaxAllowedOnePersonInYearFilter) + "&"; 
        if (minMaxAllowedOnePersonInYearFilter === null)
            throw new Error("The parameter 'minMaxAllowedOnePersonInYearFilter' cannot be null.");
        else if (minMaxAllowedOnePersonInYearFilter !== undefined)
            url_ += "MinMaxAllowedOnePersonInYearFilter=" + encodeURIComponent("" + minMaxAllowedOnePersonInYearFilter) + "&"; 
        if (maxMinAgeFilter === null)
            throw new Error("The parameter 'maxMinAgeFilter' cannot be null.");
        else if (maxMinAgeFilter !== undefined)
            url_ += "MaxMinAgeFilter=" + encodeURIComponent("" + maxMinAgeFilter) + "&"; 
        if (minMinAgeFilter === null)
            throw new Error("The parameter 'minMinAgeFilter' cannot be null.");
        else if (minMinAgeFilter !== undefined)
            url_ += "MinMinAgeFilter=" + encodeURIComponent("" + minMinAgeFilter) + "&"; 
        if (maxMaxAgeFilter === null)
            throw new Error("The parameter 'maxMaxAgeFilter' cannot be null.");
        else if (maxMaxAgeFilter !== undefined)
            url_ += "MaxMaxAgeFilter=" + encodeURIComponent("" + maxMaxAgeFilter) + "&"; 
        if (minMaxAgeFilter === null)
            throw new Error("The parameter 'minMaxAgeFilter' cannot be null.");
        else if (minMaxAgeFilter !== undefined)
            url_ += "MinMaxAgeFilter=" + encodeURIComponent("" + minMaxAgeFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (genderConditionFilter === null)
            throw new Error("The parameter 'genderConditionFilter' cannot be null.");
        else if (genderConditionFilter !== undefined)
            url_ += "GenderConditionFilter=" + encodeURIComponent("" + genderConditionFilter) + "&"; 
        if (seyedFilter === null)
            throw new Error("The parameter 'seyedFilter' cannot be null.");
        else if (seyedFilter !== undefined)
            url_ += "SeyedFilter=" + encodeURIComponent("" + seyedFilter) + "&"; 
        if (belongFilter === null)
            throw new Error("The parameter 'belongFilter' cannot be null.");
        else if (belongFilter !== undefined)
            url_ += "BelongFilter=" + encodeURIComponent("" + belongFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsumesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsumesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetConsumesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class ConsumesAndSourcesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param isCanUseFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param stateFilter (optional) 
     * @param sourceNameFilter (optional) 
     * @param consumeNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, isCanUseFilter: number | undefined, descriptionFilter: string | undefined, stateFilter: number | undefined, sourceNameFilter: string | undefined, consumeNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetConsumesAndSourceForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ConsumesAndSources/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (isCanUseFilter === null)
            throw new Error("The parameter 'isCanUseFilter' cannot be null.");
        else if (isCanUseFilter !== undefined)
            url_ += "IsCanUseFilter=" + encodeURIComponent("" + isCanUseFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (sourceNameFilter === null)
            throw new Error("The parameter 'sourceNameFilter' cannot be null.");
        else if (sourceNameFilter !== undefined)
            url_ += "SourceNameFilter=" + encodeURIComponent("" + sourceNameFilter) + "&"; 
        if (consumeNameFilter === null)
            throw new Error("The parameter 'consumeNameFilter' cannot be null.");
        else if (consumeNameFilter !== undefined)
            url_ += "ConsumeNameFilter=" + encodeURIComponent("" + consumeNameFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetConsumesAndSourceForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetConsumesAndSourceForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetConsumesAndSourceForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetConsumesAndSourceForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetConsumesAndSourceForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getConsumesAndSourceForView(id: number | undefined): Observable<GetConsumesAndSourceForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ConsumesAndSources/GetConsumesAndSourceForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsumesAndSourceForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsumesAndSourceForView(<any>response_);
                } catch (e) {
                    return <Observable<GetConsumesAndSourceForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetConsumesAndSourceForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetConsumesAndSourceForView(response: HttpResponseBase): Observable<GetConsumesAndSourceForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetConsumesAndSourceForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetConsumesAndSourceForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getConsumesAndSourceForEdit(id: number | undefined): Observable<GetConsumesAndSourceForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ConsumesAndSources/GetConsumesAndSourceForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsumesAndSourceForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsumesAndSourceForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetConsumesAndSourceForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetConsumesAndSourceForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetConsumesAndSourceForEdit(response: HttpResponseBase): Observable<GetConsumesAndSourceForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetConsumesAndSourceForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetConsumesAndSourceForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditConsumesAndSourceDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ConsumesAndSources/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param sourceId (optional) 
     * @param consumesId (optional) 
     * @return Success
     */
    delete(sourceId: number | undefined, consumesId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ConsumesAndSources/Delete?";
        if (sourceId === null)
            throw new Error("The parameter 'sourceId' cannot be null.");
        else if (sourceId !== undefined)
            url_ += "SourceId=" + encodeURIComponent("" + sourceId) + "&"; 
        if (consumesId === null)
            throw new Error("The parameter 'consumesId' cannot be null.");
        else if (consumesId !== undefined)
            url_ += "ConsumesId=" + encodeURIComponent("" + consumesId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param isCanUseFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param stateFilter (optional) 
     * @param sourceNameFilter (optional) 
     * @param consumeNameFilter (optional) 
     * @return Success
     */
    getConsumesAndSourcesToExcel(filter: string | undefined, isCanUseFilter: number | undefined, descriptionFilter: string | undefined, stateFilter: number | undefined, sourceNameFilter: string | undefined, consumeNameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ConsumesAndSources/GetConsumesAndSourcesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (isCanUseFilter === null)
            throw new Error("The parameter 'isCanUseFilter' cannot be null.");
        else if (isCanUseFilter !== undefined)
            url_ += "IsCanUseFilter=" + encodeURIComponent("" + isCanUseFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (sourceNameFilter === null)
            throw new Error("The parameter 'sourceNameFilter' cannot be null.");
        else if (sourceNameFilter !== undefined)
            url_ += "SourceNameFilter=" + encodeURIComponent("" + sourceNameFilter) + "&"; 
        if (consumeNameFilter === null)
            throw new Error("The parameter 'consumeNameFilter' cannot be null.");
        else if (consumeNameFilter !== undefined)
            url_ += "ConsumeNameFilter=" + encodeURIComponent("" + consumeNameFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsumesAndSourcesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsumesAndSourcesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetConsumesAndSourcesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllSourceForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfConsumesAndSourceSourceLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/ConsumesAndSources/GetAllSourceForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSourceForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSourceForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfConsumesAndSourceSourceLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfConsumesAndSourceSourceLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSourceForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfConsumesAndSourceSourceLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfConsumesAndSourceSourceLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfConsumesAndSourceSourceLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllConsumeForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfConsumesAndSourceConsumeLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/ConsumesAndSources/GetAllConsumeForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllConsumeForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllConsumeForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfConsumesAndSourceConsumeLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfConsumesAndSourceConsumeLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllConsumeForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfConsumesAndSourceConsumeLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfConsumesAndSourceConsumeLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfConsumesAndSourceConsumeLookupTableDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getConsumesAndSourceGroupBySourceForEdit(id: number | undefined): Observable<GetConsumesAndSourceGroupBySourceForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ConsumesAndSources/GetConsumesAndSourceGroupBySourceForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsumesAndSourceGroupBySourceForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsumesAndSourceGroupBySourceForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetConsumesAndSourceGroupBySourceForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetConsumesAndSourceGroupBySourceForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetConsumesAndSourceGroupBySourceForEdit(response: HttpResponseBase): Observable<GetConsumesAndSourceGroupBySourceForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetConsumesAndSourceGroupBySourceForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetConsumesAndSourceGroupBySourceForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditGroupBySource(body: GetConsumesAndSourceGroupBySourceForEditOutput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ConsumesAndSources/CreateOrEditGroupBySource";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditGroupBySource(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditGroupBySource(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditGroupBySource(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ContactsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param firstNameFilter (optional) 
     * @param lastNameFilter (optional) 
     * @param mobileNumberFilter (optional) 
     * @param mobileNumber2Filter (optional) 
     * @param fatherNameFilter (optional) 
     * @param identityCodeFilter (optional) 
     * @param maxBirthDateFilter (optional) 
     * @param minBirthDateFilter (optional) 
     * @param isSadatFilter (optional) 
     * @param faxFilter (optional) 
     * @param emailFilter (optional) 
     * @param introducerRelationFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param identificationCodeFilter (optional) 
     * @param isStaffFilter (optional) 
     * @param isClientFilter (optional) 
     * @param introduceTypeFilter (optional) 
     * @param genderFilter (optional) 
     * @param pocketTitleFilter (optional) 
     * @param jobTitleFilter (optional) 
     * @param educationDegreeTitleFilter (optional) 
     * @param universityTitleFilter (optional) 
     * @param educationFieldNameFilter (optional) 
     * @param countryNameFilter (optional) 
     * @param healthStatusNameFilter (optional) 
     * @param currencyNameFilter (optional) 
     * @param respectPrefixTitleFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, firstNameFilter: string | undefined, lastNameFilter: string | undefined, mobileNumberFilter: string | undefined, mobileNumber2Filter: string | undefined, fatherNameFilter: string | undefined, identityCodeFilter: string | undefined, maxBirthDateFilter: moment.Moment | undefined, minBirthDateFilter: moment.Moment | undefined, isSadatFilter: number | undefined, faxFilter: string | undefined, emailFilter: string | undefined, introducerRelationFilter: string | undefined, descriptionFilter: string | undefined, identificationCodeFilter: string | undefined, isStaffFilter: number | undefined, isClientFilter: number | undefined, introduceTypeFilter: number | undefined, genderFilter: number | undefined, pocketTitleFilter: string | undefined, jobTitleFilter: string | undefined, educationDegreeTitleFilter: string | undefined, universityTitleFilter: string | undefined, educationFieldNameFilter: string | undefined, countryNameFilter: string | undefined, healthStatusNameFilter: string | undefined, currencyNameFilter: string | undefined, respectPrefixTitleFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetContactForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Contacts/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (firstNameFilter === null)
            throw new Error("The parameter 'firstNameFilter' cannot be null.");
        else if (firstNameFilter !== undefined)
            url_ += "FirstNameFilter=" + encodeURIComponent("" + firstNameFilter) + "&"; 
        if (lastNameFilter === null)
            throw new Error("The parameter 'lastNameFilter' cannot be null.");
        else if (lastNameFilter !== undefined)
            url_ += "LastNameFilter=" + encodeURIComponent("" + lastNameFilter) + "&"; 
        if (mobileNumberFilter === null)
            throw new Error("The parameter 'mobileNumberFilter' cannot be null.");
        else if (mobileNumberFilter !== undefined)
            url_ += "MobileNumberFilter=" + encodeURIComponent("" + mobileNumberFilter) + "&"; 
        if (mobileNumber2Filter === null)
            throw new Error("The parameter 'mobileNumber2Filter' cannot be null.");
        else if (mobileNumber2Filter !== undefined)
            url_ += "MobileNumber2Filter=" + encodeURIComponent("" + mobileNumber2Filter) + "&"; 
        if (fatherNameFilter === null)
            throw new Error("The parameter 'fatherNameFilter' cannot be null.");
        else if (fatherNameFilter !== undefined)
            url_ += "FatherNameFilter=" + encodeURIComponent("" + fatherNameFilter) + "&"; 
        if (identityCodeFilter === null)
            throw new Error("The parameter 'identityCodeFilter' cannot be null.");
        else if (identityCodeFilter !== undefined)
            url_ += "IdentityCodeFilter=" + encodeURIComponent("" + identityCodeFilter) + "&"; 
        if (maxBirthDateFilter === null)
            throw new Error("The parameter 'maxBirthDateFilter' cannot be null.");
        else if (maxBirthDateFilter !== undefined)
            url_ += "MaxBirthDateFilter=" + encodeURIComponent(maxBirthDateFilter ? "" + maxBirthDateFilter.toJSON() : "") + "&"; 
        if (minBirthDateFilter === null)
            throw new Error("The parameter 'minBirthDateFilter' cannot be null.");
        else if (minBirthDateFilter !== undefined)
            url_ += "MinBirthDateFilter=" + encodeURIComponent(minBirthDateFilter ? "" + minBirthDateFilter.toJSON() : "") + "&"; 
        if (isSadatFilter === null)
            throw new Error("The parameter 'isSadatFilter' cannot be null.");
        else if (isSadatFilter !== undefined)
            url_ += "IsSadatFilter=" + encodeURIComponent("" + isSadatFilter) + "&"; 
        if (faxFilter === null)
            throw new Error("The parameter 'faxFilter' cannot be null.");
        else if (faxFilter !== undefined)
            url_ += "FaxFilter=" + encodeURIComponent("" + faxFilter) + "&"; 
        if (emailFilter === null)
            throw new Error("The parameter 'emailFilter' cannot be null.");
        else if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&"; 
        if (introducerRelationFilter === null)
            throw new Error("The parameter 'introducerRelationFilter' cannot be null.");
        else if (introducerRelationFilter !== undefined)
            url_ += "IntroducerRelationFilter=" + encodeURIComponent("" + introducerRelationFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (identificationCodeFilter === null)
            throw new Error("The parameter 'identificationCodeFilter' cannot be null.");
        else if (identificationCodeFilter !== undefined)
            url_ += "IdentificationCodeFilter=" + encodeURIComponent("" + identificationCodeFilter) + "&"; 
        if (isStaffFilter === null)
            throw new Error("The parameter 'isStaffFilter' cannot be null.");
        else if (isStaffFilter !== undefined)
            url_ += "IsStaffFilter=" + encodeURIComponent("" + isStaffFilter) + "&"; 
        if (isClientFilter === null)
            throw new Error("The parameter 'isClientFilter' cannot be null.");
        else if (isClientFilter !== undefined)
            url_ += "IsClientFilter=" + encodeURIComponent("" + isClientFilter) + "&"; 
        if (introduceTypeFilter === null)
            throw new Error("The parameter 'introduceTypeFilter' cannot be null.");
        else if (introduceTypeFilter !== undefined)
            url_ += "IntroduceTypeFilter=" + encodeURIComponent("" + introduceTypeFilter) + "&"; 
        if (genderFilter === null)
            throw new Error("The parameter 'genderFilter' cannot be null.");
        else if (genderFilter !== undefined)
            url_ += "GenderFilter=" + encodeURIComponent("" + genderFilter) + "&"; 
        if (pocketTitleFilter === null)
            throw new Error("The parameter 'pocketTitleFilter' cannot be null.");
        else if (pocketTitleFilter !== undefined)
            url_ += "PocketTitleFilter=" + encodeURIComponent("" + pocketTitleFilter) + "&"; 
        if (jobTitleFilter === null)
            throw new Error("The parameter 'jobTitleFilter' cannot be null.");
        else if (jobTitleFilter !== undefined)
            url_ += "JobTitleFilter=" + encodeURIComponent("" + jobTitleFilter) + "&"; 
        if (educationDegreeTitleFilter === null)
            throw new Error("The parameter 'educationDegreeTitleFilter' cannot be null.");
        else if (educationDegreeTitleFilter !== undefined)
            url_ += "EducationDegreeTitleFilter=" + encodeURIComponent("" + educationDegreeTitleFilter) + "&"; 
        if (universityTitleFilter === null)
            throw new Error("The parameter 'universityTitleFilter' cannot be null.");
        else if (universityTitleFilter !== undefined)
            url_ += "UniversityTitleFilter=" + encodeURIComponent("" + universityTitleFilter) + "&"; 
        if (educationFieldNameFilter === null)
            throw new Error("The parameter 'educationFieldNameFilter' cannot be null.");
        else if (educationFieldNameFilter !== undefined)
            url_ += "EducationFieldNameFilter=" + encodeURIComponent("" + educationFieldNameFilter) + "&"; 
        if (countryNameFilter === null)
            throw new Error("The parameter 'countryNameFilter' cannot be null.");
        else if (countryNameFilter !== undefined)
            url_ += "CountryNameFilter=" + encodeURIComponent("" + countryNameFilter) + "&"; 
        if (healthStatusNameFilter === null)
            throw new Error("The parameter 'healthStatusNameFilter' cannot be null.");
        else if (healthStatusNameFilter !== undefined)
            url_ += "HealthStatusNameFilter=" + encodeURIComponent("" + healthStatusNameFilter) + "&"; 
        if (currencyNameFilter === null)
            throw new Error("The parameter 'currencyNameFilter' cannot be null.");
        else if (currencyNameFilter !== undefined)
            url_ += "CurrencyNameFilter=" + encodeURIComponent("" + currencyNameFilter) + "&"; 
        if (respectPrefixTitleFilter === null)
            throw new Error("The parameter 'respectPrefixTitleFilter' cannot be null.");
        else if (respectPrefixTitleFilter !== undefined)
            url_ += "RespectPrefixTitleFilter=" + encodeURIComponent("" + respectPrefixTitleFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetContactForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetContactForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetContactForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetContactForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetContactForViewDto>(<any>null);
    }

    /**
     * @return Success
     */
    getProfileForLoggedInUser(): Observable<GetContactAndAddressesForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Contacts/GetProfileForLoggedInUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfileForLoggedInUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfileForLoggedInUser(<any>response_);
                } catch (e) {
                    return <Observable<GetContactAndAddressesForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetContactAndAddressesForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProfileForLoggedInUser(response: HttpResponseBase): Observable<GetContactAndAddressesForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetContactAndAddressesForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetContactAndAddressesForViewDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editProfileForLoggedInUser(body: EditProfileContactDto | undefined): Observable<DocumentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Contacts/EditProfileForLoggedInUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditProfileForLoggedInUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditProfileForLoggedInUser(<any>response_);
                } catch (e) {
                    return <Observable<DocumentDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processEditProfileForLoggedInUser(response: HttpResponseBase): Observable<DocumentDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentDto[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getContactForView(id: number | undefined): Observable<GetContactAndDependentFormForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Contacts/GetContactForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactForView(<any>response_);
                } catch (e) {
                    return <Observable<GetContactAndDependentFormForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetContactAndDependentFormForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetContactForView(response: HttpResponseBase): Observable<GetContactAndDependentFormForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetContactAndDependentFormForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetContactAndDependentFormForViewDto>(<any>null);
    }

    /**
     * @return Success
     */
    getContactSubscriptions(): Observable<ContactSubscriptionsDto> {
        let url_ = this.baseUrl + "/api/services/app/Contacts/GetContactSubscriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactSubscriptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactSubscriptions(<any>response_);
                } catch (e) {
                    return <Observable<ContactSubscriptionsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ContactSubscriptionsDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetContactSubscriptions(response: HttpResponseBase): Observable<ContactSubscriptionsDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactSubscriptionsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContactSubscriptionsDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editContactSubscriptions(body: ContactSubscriptionsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Contacts/EditContactSubscriptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditContactSubscriptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditContactSubscriptions(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processEditContactSubscriptions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getContactForEdit(id: number | undefined): Observable<GetContactForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Contacts/GetContactForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetContactForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetContactForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetContactForEdit(response: HttpResponseBase): Observable<GetContactForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetContactForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetContactForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditContactAndDependentForms(body: CreateOrEditContactAndDependentFormsDto | undefined): Observable<CreateOrEditContactOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Contacts/CreateOrEditContactAndDependentForms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditContactAndDependentForms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditContactAndDependentForms(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditContactOutputDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditContactOutputDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditContactAndDependentForms(response: HttpResponseBase): Observable<CreateOrEditContactOutputDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditContactOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditContactOutputDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditContactDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Contacts/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param contactId (optional) 
     * @return Success
     */
    allowDelete(contactId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Contacts/AllowDelete?";
        if (contactId === null)
            throw new Error("The parameter 'contactId' cannot be null.");
        else if (contactId !== undefined)
            url_ += "contactId=" + encodeURIComponent("" + contactId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAllowDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAllowDelete(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processAllowDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Contacts/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param currencyId (optional) 
     * @return Success
     */
    saveContactCurrency(currencyId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Contacts/SaveContactCurrency?";
        if (currencyId === null)
            throw new Error("The parameter 'currencyId' cannot be null.");
        else if (currencyId !== undefined)
            url_ += "currencyId=" + encodeURIComponent("" + currencyId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveContactCurrency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveContactCurrency(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSaveContactCurrency(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param firstNameFilter (optional) 
     * @param lastNameFilter (optional) 
     * @param mobileNumber1Filter (optional) 
     * @param mobileNumber2Filter (optional) 
     * @param fatherNameFilter (optional) 
     * @param identityCodeFilter (optional) 
     * @param maxBirthDateFilter (optional) 
     * @param minBirthDateFilter (optional) 
     * @param isSadatFilter (optional) 
     * @param genderFilter (optional) 
     * @param identityTypeFilter (optional) 
     * @return Success
     */
    getContactsToExcel(filter: string | undefined, firstNameFilter: string | undefined, lastNameFilter: string | undefined, mobileNumber1Filter: string | undefined, mobileNumber2Filter: string | undefined, fatherNameFilter: string | undefined, identityCodeFilter: string | undefined, maxBirthDateFilter: moment.Moment | undefined, minBirthDateFilter: moment.Moment | undefined, isSadatFilter: number | undefined, genderFilter: number | undefined, identityTypeFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Contacts/GetContactsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (firstNameFilter === null)
            throw new Error("The parameter 'firstNameFilter' cannot be null.");
        else if (firstNameFilter !== undefined)
            url_ += "FirstNameFilter=" + encodeURIComponent("" + firstNameFilter) + "&"; 
        if (lastNameFilter === null)
            throw new Error("The parameter 'lastNameFilter' cannot be null.");
        else if (lastNameFilter !== undefined)
            url_ += "LastNameFilter=" + encodeURIComponent("" + lastNameFilter) + "&"; 
        if (mobileNumber1Filter === null)
            throw new Error("The parameter 'mobileNumber1Filter' cannot be null.");
        else if (mobileNumber1Filter !== undefined)
            url_ += "MobileNumber1Filter=" + encodeURIComponent("" + mobileNumber1Filter) + "&"; 
        if (mobileNumber2Filter === null)
            throw new Error("The parameter 'mobileNumber2Filter' cannot be null.");
        else if (mobileNumber2Filter !== undefined)
            url_ += "MobileNumber2Filter=" + encodeURIComponent("" + mobileNumber2Filter) + "&"; 
        if (fatherNameFilter === null)
            throw new Error("The parameter 'fatherNameFilter' cannot be null.");
        else if (fatherNameFilter !== undefined)
            url_ += "FatherNameFilter=" + encodeURIComponent("" + fatherNameFilter) + "&"; 
        if (identityCodeFilter === null)
            throw new Error("The parameter 'identityCodeFilter' cannot be null.");
        else if (identityCodeFilter !== undefined)
            url_ += "IdentityCodeFilter=" + encodeURIComponent("" + identityCodeFilter) + "&"; 
        if (maxBirthDateFilter === null)
            throw new Error("The parameter 'maxBirthDateFilter' cannot be null.");
        else if (maxBirthDateFilter !== undefined)
            url_ += "MaxBirthDateFilter=" + encodeURIComponent(maxBirthDateFilter ? "" + maxBirthDateFilter.toJSON() : "") + "&"; 
        if (minBirthDateFilter === null)
            throw new Error("The parameter 'minBirthDateFilter' cannot be null.");
        else if (minBirthDateFilter !== undefined)
            url_ += "MinBirthDateFilter=" + encodeURIComponent(minBirthDateFilter ? "" + minBirthDateFilter.toJSON() : "") + "&"; 
        if (isSadatFilter === null)
            throw new Error("The parameter 'isSadatFilter' cannot be null.");
        else if (isSadatFilter !== undefined)
            url_ += "IsSadatFilter=" + encodeURIComponent("" + isSadatFilter) + "&"; 
        if (genderFilter === null)
            throw new Error("The parameter 'genderFilter' cannot be null.");
        else if (genderFilter !== undefined)
            url_ += "GenderFilter=" + encodeURIComponent("" + genderFilter) + "&"; 
        if (identityTypeFilter === null)
            throw new Error("The parameter 'identityTypeFilter' cannot be null.");
        else if (identityTypeFilter !== undefined)
            url_ += "IdentityTypeFilter=" + encodeURIComponent("" + identityTypeFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetContactsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getIsLogin(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Contacts/GetIsLogin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIsLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIsLogin(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processGetIsLogin(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllJobForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfContactJobLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Contacts/GetAllJobForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllJobForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllJobForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfContactJobLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfContactJobLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllJobForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfContactJobLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfContactJobLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfContactJobLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param hasTaxCode (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllEducationDegreeForLookupTable(filter: string | undefined, hasTaxCode: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfContactEducationDegreeLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Contacts/GetAllEducationDegreeForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (hasTaxCode === null)
            throw new Error("The parameter 'hasTaxCode' cannot be null.");
        else if (hasTaxCode !== undefined)
            url_ += "HasTaxCode=" + encodeURIComponent("" + hasTaxCode) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEducationDegreeForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEducationDegreeForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfContactEducationDegreeLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfContactEducationDegreeLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllEducationDegreeForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfContactEducationDegreeLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfContactEducationDegreeLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfContactEducationDegreeLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllUniversityForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfContactUniversityLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Contacts/GetAllUniversityForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUniversityForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUniversityForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfContactUniversityLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfContactUniversityLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllUniversityForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfContactUniversityLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfContactUniversityLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfContactUniversityLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllEducationFieldForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfContactEducationFieldLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Contacts/GetAllEducationFieldForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEducationFieldForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEducationFieldForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfContactEducationFieldLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfContactEducationFieldLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllEducationFieldForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfContactEducationFieldLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfContactEducationFieldLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfContactEducationFieldLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCountryForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfContactCountryLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Contacts/GetAllCountryForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCountryForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCountryForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfContactCountryLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfContactCountryLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCountryForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfContactCountryLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfContactCountryLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfContactCountryLookupTableDto>(<any>null);
    }

    /**
     * @param contactId (optional) 
     * @return Success
     */
    getAllRolesForContact(contactId: number | undefined): Observable<Role[]> {
        let url_ = this.baseUrl + "/api/services/app/Contacts/GetAllRolesForContact?";
        if (contactId === null)
            throw new Error("The parameter 'contactId' cannot be null.");
        else if (contactId !== undefined)
            url_ += "contactId=" + encodeURIComponent("" + contactId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRolesForContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRolesForContact(<any>response_);
                } catch (e) {
                    return <Observable<Role[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Role[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllRolesForContact(response: HttpResponseBase): Observable<Role[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Role.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Role[]>(<any>null);
    }

    /**
     * @param permissions (optional) 
     * @return Success
     */
    getRoles(permissions: string[] | undefined): Observable<ListResultDtoOfRoleListDto> {
        let url_ = this.baseUrl + "/api/services/app/Contacts/GetRoles?";
        if (permissions === null)
            throw new Error("The parameter 'permissions' cannot be null.");
        else if (permissions !== undefined)
            permissions && permissions.forEach(item => { url_ += "Permissions=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfRoleListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfRoleListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<ListResultDtoOfRoleListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfRoleListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfRoleListDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param genderFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllRespectPrefixForLookupTable(filter: string | undefined, genderFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfContactRespectPrefixLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Contacts/GetAllRespectPrefixForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (genderFilter === null)
            throw new Error("The parameter 'genderFilter' cannot be null.");
        else if (genderFilter !== undefined)
            url_ += "GenderFilter=" + encodeURIComponent("" + genderFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRespectPrefixForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRespectPrefixForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfContactRespectPrefixLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfContactRespectPrefixLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllRespectPrefixForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfContactRespectPrefixLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfContactRespectPrefixLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfContactRespectPrefixLookupTableDto>(<any>null);
    }

    /**
     * @return Success
     */
    validationIntroducer(mobileNumber: string): Observable<GetValidationIntroducerOutput> {
        let url_ = this.baseUrl + "/api/services/app/Contacts/ValidationIntroducer?";
        if (mobileNumber === undefined || mobileNumber === null)
            throw new Error("The parameter 'mobileNumber' must be defined and cannot be null.");
        else
            url_ += "MobileNumber=" + encodeURIComponent("" + mobileNumber) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidationIntroducer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidationIntroducer(<any>response_);
                } catch (e) {
                    return <Observable<GetValidationIntroducerOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetValidationIntroducerOutput>><any>_observableThrow(response_);
        }));
    }

    protected processValidationIntroducer(response: HttpResponseBase): Observable<GetValidationIntroducerOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetValidationIntroducerOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetValidationIntroducerOutput>(<any>null);
    }

    /**
     * @param contactId (optional) 
     * @return Success
     */
    getContactBankAccount(contactId: number | undefined): Observable<GetBankAccountForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Contacts/GetContactBankAccount?";
        if (contactId === null)
            throw new Error("The parameter 'contactId' cannot be null.");
        else if (contactId !== undefined)
            url_ += "contactId=" + encodeURIComponent("" + contactId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactBankAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactBankAccount(<any>response_);
                } catch (e) {
                    return <Observable<GetBankAccountForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBankAccountForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetContactBankAccount(response: HttpResponseBase): Observable<GetBankAccountForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBankAccountForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBankAccountForEditOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getRandomPassword(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Contacts/GetRandomPassword";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRandomPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRandomPassword(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetRandomPassword(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param contactId (optional) 
     * @return Success
     */
    getUserContactForEdit(contactId: number | undefined): Observable<UserContactDto> {
        let url_ = this.baseUrl + "/api/services/app/Contacts/GetUserContactForEdit?";
        if (contactId === null)
            throw new Error("The parameter 'contactId' cannot be null.");
        else if (contactId !== undefined)
            url_ += "contactId=" + encodeURIComponent("" + contactId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserContactForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserContactForEdit(<any>response_);
                } catch (e) {
                    return <Observable<UserContactDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserContactDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserContactForEdit(response: HttpResponseBase): Observable<UserContactDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserContactDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserContactDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllGroupSubgroupForDropdownTable(entityFilter: Entities): Observable<ContactGroupSubgroupLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Contacts/GetAllGroupSubgroupForDropdownTable?";
        if (entityFilter === undefined || entityFilter === null)
            throw new Error("The parameter 'entityFilter' must be defined and cannot be null.");
        else
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllGroupSubgroupForDropdownTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllGroupSubgroupForDropdownTable(<any>response_);
                } catch (e) {
                    return <Observable<ContactGroupSubgroupLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ContactGroupSubgroupLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllGroupSubgroupForDropdownTable(response: HttpResponseBase): Observable<ContactGroupSubgroupLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContactGroupSubgroupLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContactGroupSubgroupLookupTableDto[]>(<any>null);
    }

    /**
     * @param contactId (optional) 
     * @return Success
     */
    getUserWalletInfo(contactId: number | undefined): Observable<GetUserWalletInfoResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Contacts/GetUserWalletInfo?";
        if (contactId === null)
            throw new Error("The parameter 'contactId' cannot be null.");
        else if (contactId !== undefined)
            url_ += "contactId=" + encodeURIComponent("" + contactId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserWalletInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserWalletInfo(<any>response_);
                } catch (e) {
                    return <Observable<GetUserWalletInfoResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetUserWalletInfoResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserWalletInfo(response: HttpResponseBase): Observable<GetUserWalletInfoResponseDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserWalletInfoResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserWalletInfoResponseDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerUserWallet(body: WalletTypes | undefined): Observable<RegisterUserWalletResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Contacts/RegisterUserWallet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterUserWallet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterUserWallet(<any>response_);
                } catch (e) {
                    return <Observable<RegisterUserWalletResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegisterUserWalletResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processRegisterUserWallet(response: HttpResponseBase): Observable<RegisterUserWalletResponseDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterUserWalletResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisterUserWalletResponseDto>(<any>null);
    }

    /**
     * @return Success
     */
    createAndFirstChargeUserWallet(): Observable<RegisterUserWalletResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Contacts/CreateAndFirstChargeUserWallet";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAndFirstChargeUserWallet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAndFirstChargeUserWallet(<any>response_);
                } catch (e) {
                    return <Observable<RegisterUserWalletResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegisterUserWalletResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateAndFirstChargeUserWallet(response: HttpResponseBase): Observable<RegisterUserWalletResponseDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterUserWalletResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisterUserWalletResponseDto>(<any>null);
    }

    /**
     * @param contactId (optional) 
     * @return Success
     */
    birthdateWalletCharge(contactId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Contacts/BirthdateWalletCharge?";
        if (contactId === null)
            throw new Error("The parameter 'contactId' cannot be null.");
        else if (contactId !== undefined)
            url_ += "contactId=" + encodeURIComponent("" + contactId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBirthdateWalletCharge(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBirthdateWalletCharge(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processBirthdateWalletCharge(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param contactId (optional) 
     * @return Success
     */
    loyaltyWalletCharge(contactId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Contacts/LoyaltyWalletCharge?";
        if (contactId === null)
            throw new Error("The parameter 'contactId' cannot be null.");
        else if (contactId !== undefined)
            url_ += "contactId=" + encodeURIComponent("" + contactId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoyaltyWalletCharge(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoyaltyWalletCharge(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processLoyaltyWalletCharge(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param search (optional) 
     * @param contactIdFilter (optional) 
     * @param fromDateFilter (optional) 
     * @param toDateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllSettles(search: string | undefined, contactIdFilter: number | undefined, fromDateFilter: moment.Moment | undefined, toDateFilter: moment.Moment | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAllSettlesForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Contacts/GetAllSettles?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&"; 
        if (contactIdFilter === null)
            throw new Error("The parameter 'contactIdFilter' cannot be null.");
        else if (contactIdFilter !== undefined)
            url_ += "ContactIdFilter=" + encodeURIComponent("" + contactIdFilter) + "&"; 
        if (fromDateFilter === null)
            throw new Error("The parameter 'fromDateFilter' cannot be null.");
        else if (fromDateFilter !== undefined)
            url_ += "FromDateFilter=" + encodeURIComponent(fromDateFilter ? "" + fromDateFilter.toJSON() : "") + "&"; 
        if (toDateFilter === null)
            throw new Error("The parameter 'toDateFilter' cannot be null.");
        else if (toDateFilter !== undefined)
            url_ += "ToDateFilter=" + encodeURIComponent(toDateFilter ? "" + toDateFilter.toJSON() : "") + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSettles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSettles(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAllSettlesForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAllSettlesForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSettles(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllSettlesForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAllSettlesForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAllSettlesForViewDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    reassignContactBills(body: ReassignContactBillsInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Contacts/ReassignContactBills";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReassignContactBills(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReassignContactBills(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processReassignContactBills(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllContactForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfBillContactLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Contacts/GetAllContactForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllContactForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllContactForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfBillContactLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfBillContactLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllContactForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfBillContactLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfBillContactLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfBillContactLookupTableDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createContactForApps(body: CreateContactForAppsDto | undefined): Observable<CreateOrEditContactOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Contacts/CreateContactForApps";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateContactForApps(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateContactForApps(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditContactOutputDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditContactOutputDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateContactForApps(response: HttpResponseBase): Observable<CreateOrEditContactOutputDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditContactOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditContactOutputDto>(<any>null);
    }
}

@Injectable()
export class ContactWalletsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param walletCodeFilter (optional) 
     * @param maxAccountIdFilter (optional) 
     * @param minAccountIdFilter (optional) 
     * @param contactFirstNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, walletCodeFilter: string | undefined, maxAccountIdFilter: number | undefined, minAccountIdFilter: number | undefined, contactFirstNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetContactWalletForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ContactWallets/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (walletCodeFilter === null)
            throw new Error("The parameter 'walletCodeFilter' cannot be null.");
        else if (walletCodeFilter !== undefined)
            url_ += "WalletCodeFilter=" + encodeURIComponent("" + walletCodeFilter) + "&"; 
        if (maxAccountIdFilter === null)
            throw new Error("The parameter 'maxAccountIdFilter' cannot be null.");
        else if (maxAccountIdFilter !== undefined)
            url_ += "MaxAccountIdFilter=" + encodeURIComponent("" + maxAccountIdFilter) + "&"; 
        if (minAccountIdFilter === null)
            throw new Error("The parameter 'minAccountIdFilter' cannot be null.");
        else if (minAccountIdFilter !== undefined)
            url_ += "MinAccountIdFilter=" + encodeURIComponent("" + minAccountIdFilter) + "&"; 
        if (contactFirstNameFilter === null)
            throw new Error("The parameter 'contactFirstNameFilter' cannot be null.");
        else if (contactFirstNameFilter !== undefined)
            url_ += "ContactFirstNameFilter=" + encodeURIComponent("" + contactFirstNameFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetContactWalletForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetContactWalletForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetContactWalletForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetContactWalletForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetContactWalletForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getContactWalletForView(id: number | undefined): Observable<GetContactWalletForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ContactWallets/GetContactWalletForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactWalletForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactWalletForView(<any>response_);
                } catch (e) {
                    return <Observable<GetContactWalletForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetContactWalletForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetContactWalletForView(response: HttpResponseBase): Observable<GetContactWalletForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetContactWalletForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetContactWalletForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getContactWalletForEdit(id: number | undefined): Observable<GetContactWalletForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ContactWallets/GetContactWalletForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactWalletForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactWalletForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetContactWalletForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetContactWalletForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetContactWalletForEdit(response: HttpResponseBase): Observable<GetContactWalletForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetContactWalletForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetContactWalletForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditContactWalletDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ContactWallets/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ContactWallets/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param walletCodeFilter (optional) 
     * @param maxAccountIdFilter (optional) 
     * @param minAccountIdFilter (optional) 
     * @param contactFirstNameFilter (optional) 
     * @return Success
     */
    getContactWalletsToExcel(filter: string | undefined, walletCodeFilter: string | undefined, maxAccountIdFilter: number | undefined, minAccountIdFilter: number | undefined, contactFirstNameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ContactWallets/GetContactWalletsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (walletCodeFilter === null)
            throw new Error("The parameter 'walletCodeFilter' cannot be null.");
        else if (walletCodeFilter !== undefined)
            url_ += "WalletCodeFilter=" + encodeURIComponent("" + walletCodeFilter) + "&"; 
        if (maxAccountIdFilter === null)
            throw new Error("The parameter 'maxAccountIdFilter' cannot be null.");
        else if (maxAccountIdFilter !== undefined)
            url_ += "MaxAccountIdFilter=" + encodeURIComponent("" + maxAccountIdFilter) + "&"; 
        if (minAccountIdFilter === null)
            throw new Error("The parameter 'minAccountIdFilter' cannot be null.");
        else if (minAccountIdFilter !== undefined)
            url_ += "MinAccountIdFilter=" + encodeURIComponent("" + minAccountIdFilter) + "&"; 
        if (contactFirstNameFilter === null)
            throw new Error("The parameter 'contactFirstNameFilter' cannot be null.");
        else if (contactFirstNameFilter !== undefined)
            url_ += "ContactFirstNameFilter=" + encodeURIComponent("" + contactFirstNameFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactWalletsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactWalletsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetContactWalletsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllContactForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfContactWalletContactLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/ContactWallets/GetAllContactForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllContactForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllContactForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfContactWalletContactLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfContactWalletContactLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllContactForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfContactWalletContactLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfContactWalletContactLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfContactWalletContactLookupTableDto>(<any>null);
    }
}

@Injectable()
export class CountriesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param prefixFilter (optional) 
     * @param currencyNameFilter (optional) 
     * @param socialSecurityCodeFilter (optional) 
     * @param taxCode (optional) 
     * @param applicationLanguageNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, nameFilter: string | undefined, prefixFilter: string | undefined, currencyNameFilter: string | undefined, socialSecurityCodeFilter: string | undefined, taxCode: string | undefined, applicationLanguageNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCountryForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Countries/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&"; 
        if (prefixFilter === null)
            throw new Error("The parameter 'prefixFilter' cannot be null.");
        else if (prefixFilter !== undefined)
            url_ += "PrefixFilter=" + encodeURIComponent("" + prefixFilter) + "&"; 
        if (currencyNameFilter === null)
            throw new Error("The parameter 'currencyNameFilter' cannot be null.");
        else if (currencyNameFilter !== undefined)
            url_ += "CurrencyNameFilter=" + encodeURIComponent("" + currencyNameFilter) + "&"; 
        if (socialSecurityCodeFilter === null)
            throw new Error("The parameter 'socialSecurityCodeFilter' cannot be null.");
        else if (socialSecurityCodeFilter !== undefined)
            url_ += "SocialSecurityCodeFilter=" + encodeURIComponent("" + socialSecurityCodeFilter) + "&"; 
        if (taxCode === null)
            throw new Error("The parameter 'taxCode' cannot be null.");
        else if (taxCode !== undefined)
            url_ += "TaxCode=" + encodeURIComponent("" + taxCode) + "&"; 
        if (applicationLanguageNameFilter === null)
            throw new Error("The parameter 'applicationLanguageNameFilter' cannot be null.");
        else if (applicationLanguageNameFilter !== undefined)
            url_ += "ApplicationLanguageNameFilter=" + encodeURIComponent("" + applicationLanguageNameFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCountryForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCountryForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCountryForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCountryForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCountryForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCountryForView(id: number | undefined): Observable<GetCountryForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Countries/GetCountryForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountryForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountryForView(<any>response_);
                } catch (e) {
                    return <Observable<GetCountryForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCountryForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCountryForView(response: HttpResponseBase): Observable<GetCountryForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCountryForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCountryForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCountryForEdit(id: number | undefined): Observable<GetCountryForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Countries/GetCountryForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountryForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountryForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetCountryForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCountryForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCountryForEdit(response: HttpResponseBase): Observable<GetCountryForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCountryForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCountryForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditCountryDto | undefined): Observable<ViewResult> {
        let url_ = this.baseUrl + "/api/services/app/Countries/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<ViewResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<ViewResult>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<ViewResult> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ViewResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ViewResult>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Countries/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param prefixFilter (optional) 
     * @param stateFilter (optional) 
     * @param currencyNameFilter (optional) 
     * @param socialSecurityCodeFilter (optional) 
     * @param taxCode (optional) 
     * @param applicationLanguageNameFilter (optional) 
     * @return Success
     */
    getCountriesToExcel(filter: string | undefined, nameFilter: string | undefined, prefixFilter: string | undefined, stateFilter: number | undefined, currencyNameFilter: string | undefined, socialSecurityCodeFilter: string | undefined, taxCode: string | undefined, applicationLanguageNameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Countries/GetCountriesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&"; 
        if (prefixFilter === null)
            throw new Error("The parameter 'prefixFilter' cannot be null.");
        else if (prefixFilter !== undefined)
            url_ += "PrefixFilter=" + encodeURIComponent("" + prefixFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (currencyNameFilter === null)
            throw new Error("The parameter 'currencyNameFilter' cannot be null.");
        else if (currencyNameFilter !== undefined)
            url_ += "CurrencyNameFilter=" + encodeURIComponent("" + currencyNameFilter) + "&"; 
        if (socialSecurityCodeFilter === null)
            throw new Error("The parameter 'socialSecurityCodeFilter' cannot be null.");
        else if (socialSecurityCodeFilter !== undefined)
            url_ += "SocialSecurityCodeFilter=" + encodeURIComponent("" + socialSecurityCodeFilter) + "&"; 
        if (taxCode === null)
            throw new Error("The parameter 'taxCode' cannot be null.");
        else if (taxCode !== undefined)
            url_ += "TaxCode=" + encodeURIComponent("" + taxCode) + "&"; 
        if (applicationLanguageNameFilter === null)
            throw new Error("The parameter 'applicationLanguageNameFilter' cannot be null.");
        else if (applicationLanguageNameFilter !== undefined)
            url_ += "ApplicationLanguageNameFilter=" + encodeURIComponent("" + applicationLanguageNameFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountriesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountriesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCountriesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllApplicationLanguageForTableDropdown(): Observable<CountryApplicationLanguageLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Countries/GetAllApplicationLanguageForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllApplicationLanguageForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllApplicationLanguageForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<CountryApplicationLanguageLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CountryApplicationLanguageLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllApplicationLanguageForTableDropdown(response: HttpResponseBase): Observable<CountryApplicationLanguageLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountryApplicationLanguageLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CountryApplicationLanguageLookupTableDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllCurrencyForTableDropdown(): Observable<CountryCurrencyLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Countries/GetAllCurrencyForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCurrencyForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCurrencyForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<CountryCurrencyLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CountryCurrencyLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCurrencyForTableDropdown(response: HttpResponseBase): Observable<CountryCurrencyLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountryCurrencyLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CountryCurrencyLookupTableDto[]>(<any>null);
    }
}

@Injectable()
export class CurrenciesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param maxRateFilter (optional) 
     * @param minRateFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param stateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, nameFilter: string | undefined, maxRateFilter: number | undefined, minRateFilter: number | undefined, descriptionFilter: string | undefined, stateFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCurrencyForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Currencies/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&"; 
        if (maxRateFilter === null)
            throw new Error("The parameter 'maxRateFilter' cannot be null.");
        else if (maxRateFilter !== undefined)
            url_ += "MaxRateFilter=" + encodeURIComponent("" + maxRateFilter) + "&"; 
        if (minRateFilter === null)
            throw new Error("The parameter 'minRateFilter' cannot be null.");
        else if (minRateFilter !== undefined)
            url_ += "MinRateFilter=" + encodeURIComponent("" + minRateFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCurrencyForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCurrencyForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCurrencyForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCurrencyForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCurrencyForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCurrencyForView(id: number | undefined): Observable<GetCurrencyForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Currencies/GetCurrencyForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrencyForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrencyForView(<any>response_);
                } catch (e) {
                    return <Observable<GetCurrencyForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCurrencyForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCurrencyForView(response: HttpResponseBase): Observable<GetCurrencyForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrencyForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCurrencyForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCurrencyForEdit(id: number | undefined): Observable<GetCurrencyForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Currencies/GetCurrencyForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrencyForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrencyForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetCurrencyForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCurrencyForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCurrencyForEdit(response: HttpResponseBase): Observable<GetCurrencyForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrencyForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCurrencyForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditCurrencyDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Currencies/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Currencies/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteByChangeState(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Currencies/DeleteByChangeState?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteByChangeState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByChangeState(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteByChangeState(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param maxRateFilter (optional) 
     * @param minRateFilter (optional) 
     * @param descriptionFilter (optional) 
     * @return Success
     */
    getCurrenciesToExcel(filter: string | undefined, nameFilter: string | undefined, maxRateFilter: number | undefined, minRateFilter: number | undefined, descriptionFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Currencies/GetCurrenciesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&"; 
        if (maxRateFilter === null)
            throw new Error("The parameter 'maxRateFilter' cannot be null.");
        else if (maxRateFilter !== undefined)
            url_ += "MaxRateFilter=" + encodeURIComponent("" + maxRateFilter) + "&"; 
        if (minRateFilter === null)
            throw new Error("The parameter 'minRateFilter' cannot be null.");
        else if (minRateFilter !== undefined)
            url_ += "MinRateFilter=" + encodeURIComponent("" + minRateFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrenciesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrenciesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCurrenciesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class DashboardCustomizationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param dashboardName (optional) 
     * @param application (optional) 
     * @return Success
     */
    getUserDashboard(dashboardName: string | undefined, application: string | undefined): Observable<Dashboard> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/GetUserDashboard?";
        if (dashboardName === null)
            throw new Error("The parameter 'dashboardName' cannot be null.");
        else if (dashboardName !== undefined)
            url_ += "DashboardName=" + encodeURIComponent("" + dashboardName) + "&"; 
        if (application === null)
            throw new Error("The parameter 'application' cannot be null.");
        else if (application !== undefined)
            url_ += "Application=" + encodeURIComponent("" + application) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserDashboard(<any>response_);
                } catch (e) {
                    return <Observable<Dashboard>><any>_observableThrow(e);
                }
            } else
                return <Observable<Dashboard>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserDashboard(response: HttpResponseBase): Observable<Dashboard> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Dashboard.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Dashboard>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    savePage(body: SavePageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/SavePage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSavePage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavePage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSavePage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    renamePage(body: RenamePageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/RenamePage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenamePage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenamePage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRenamePage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewPage(body: AddNewPageInput | undefined): Observable<AddNewPageOutput> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/AddNewPage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddNewPage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNewPage(<any>response_);
                } catch (e) {
                    return <Observable<AddNewPageOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddNewPageOutput>><any>_observableThrow(response_);
        }));
    }

    protected processAddNewPage(response: HttpResponseBase): Observable<AddNewPageOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddNewPageOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddNewPageOutput>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param dashboardName (optional) 
     * @param application (optional) 
     * @return Success
     */
    deletePage(id: string | undefined, dashboardName: string | undefined, application: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/DeletePage?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        if (dashboardName === null)
            throw new Error("The parameter 'dashboardName' cannot be null.");
        else if (dashboardName !== undefined)
            url_ += "DashboardName=" + encodeURIComponent("" + dashboardName) + "&"; 
        if (application === null)
            throw new Error("The parameter 'application' cannot be null.");
        else if (application !== undefined)
            url_ += "Application=" + encodeURIComponent("" + application) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeletePage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addWidget(body: AddWidgetInput | undefined): Observable<Widget> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/AddWidget";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddWidget(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddWidget(<any>response_);
                } catch (e) {
                    return <Observable<Widget>><any>_observableThrow(e);
                }
            } else
                return <Observable<Widget>><any>_observableThrow(response_);
        }));
    }

    protected processAddWidget(response: HttpResponseBase): Observable<Widget> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Widget.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Widget>(<any>null);
    }

    /**
     * @param dashboardName (optional) 
     * @param application (optional) 
     * @return Success
     */
    getDashboardDefinition(dashboardName: string | undefined, application: string | undefined): Observable<DashboardOutput> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/GetDashboardDefinition?";
        if (dashboardName === null)
            throw new Error("The parameter 'dashboardName' cannot be null.");
        else if (dashboardName !== undefined)
            url_ += "DashboardName=" + encodeURIComponent("" + dashboardName) + "&"; 
        if (application === null)
            throw new Error("The parameter 'application' cannot be null.");
        else if (application !== undefined)
            url_ += "Application=" + encodeURIComponent("" + application) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardDefinition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardDefinition(<any>response_);
                } catch (e) {
                    return <Observable<DashboardOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<DashboardOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetDashboardDefinition(response: HttpResponseBase): Observable<DashboardOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashboardOutput>(<any>null);
    }

    /**
     * @param dashboardName (optional) 
     * @param application (optional) 
     * @return Success
     */
    getAllWidgetDefinitions(dashboardName: string | undefined, application: string | undefined): Observable<WidgetOutput[]> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/GetAllWidgetDefinitions?";
        if (dashboardName === null)
            throw new Error("The parameter 'dashboardName' cannot be null.");
        else if (dashboardName !== undefined)
            url_ += "DashboardName=" + encodeURIComponent("" + dashboardName) + "&"; 
        if (application === null)
            throw new Error("The parameter 'application' cannot be null.");
        else if (application !== undefined)
            url_ += "Application=" + encodeURIComponent("" + application) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWidgetDefinitions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWidgetDefinitions(<any>response_);
                } catch (e) {
                    return <Observable<WidgetOutput[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<WidgetOutput[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllWidgetDefinitions(response: HttpResponseBase): Observable<WidgetOutput[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WidgetOutput.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WidgetOutput[]>(<any>null);
    }

    /**
     * @param application (optional) 
     * @return Success
     */
    getSettingName(application: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/GetSettingName?";
        if (application === null)
            throw new Error("The parameter 'application' cannot be null.");
        else if (application !== undefined)
            url_ += "application=" + encodeURIComponent("" + application) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSettingName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSettingName(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetSettingName(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class DeceasedsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param genderFilter (optional) 
     * @param isApprovedFilter (optional) 
     * @param isApprovedImgFilter (optional) 
     * @param firstNameFilter (optional) 
     * @param lastNameFilter (optional) 
     * @param survivorNameFilter (optional) 
     * @param survivorPhoneNoFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param imagePathFilter (optional) 
     * @param maxDeathDateFilter (optional) 
     * @param minDeathDateFilter (optional) 
     * @param codeFilter (optional) 
     * @param maxCreationDateFilter (optional) 
     * @param minCreationDateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, genderFilter: number | undefined, isApprovedFilter: number | undefined, isApprovedImgFilter: number | undefined, firstNameFilter: string | undefined, lastNameFilter: string | undefined, survivorNameFilter: string | undefined, survivorPhoneNoFilter: string | undefined, descriptionFilter: string | undefined, imagePathFilter: string | undefined, maxDeathDateFilter: moment.Moment | undefined, minDeathDateFilter: moment.Moment | undefined, codeFilter: string | undefined, maxCreationDateFilter: moment.Moment | undefined, minCreationDateFilter: moment.Moment | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetDeceasedForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Deceaseds/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (genderFilter === null)
            throw new Error("The parameter 'genderFilter' cannot be null.");
        else if (genderFilter !== undefined)
            url_ += "GenderFilter=" + encodeURIComponent("" + genderFilter) + "&"; 
        if (isApprovedFilter === null)
            throw new Error("The parameter 'isApprovedFilter' cannot be null.");
        else if (isApprovedFilter !== undefined)
            url_ += "IsApprovedFilter=" + encodeURIComponent("" + isApprovedFilter) + "&"; 
        if (isApprovedImgFilter === null)
            throw new Error("The parameter 'isApprovedImgFilter' cannot be null.");
        else if (isApprovedImgFilter !== undefined)
            url_ += "IsApprovedImgFilter=" + encodeURIComponent("" + isApprovedImgFilter) + "&"; 
        if (firstNameFilter === null)
            throw new Error("The parameter 'firstNameFilter' cannot be null.");
        else if (firstNameFilter !== undefined)
            url_ += "FirstNameFilter=" + encodeURIComponent("" + firstNameFilter) + "&"; 
        if (lastNameFilter === null)
            throw new Error("The parameter 'lastNameFilter' cannot be null.");
        else if (lastNameFilter !== undefined)
            url_ += "LastNameFilter=" + encodeURIComponent("" + lastNameFilter) + "&"; 
        if (survivorNameFilter === null)
            throw new Error("The parameter 'survivorNameFilter' cannot be null.");
        else if (survivorNameFilter !== undefined)
            url_ += "SurvivorNameFilter=" + encodeURIComponent("" + survivorNameFilter) + "&"; 
        if (survivorPhoneNoFilter === null)
            throw new Error("The parameter 'survivorPhoneNoFilter' cannot be null.");
        else if (survivorPhoneNoFilter !== undefined)
            url_ += "SurvivorPhoneNoFilter=" + encodeURIComponent("" + survivorPhoneNoFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (imagePathFilter === null)
            throw new Error("The parameter 'imagePathFilter' cannot be null.");
        else if (imagePathFilter !== undefined)
            url_ += "ImagePathFilter=" + encodeURIComponent("" + imagePathFilter) + "&"; 
        if (maxDeathDateFilter === null)
            throw new Error("The parameter 'maxDeathDateFilter' cannot be null.");
        else if (maxDeathDateFilter !== undefined)
            url_ += "MaxDeathDateFilter=" + encodeURIComponent(maxDeathDateFilter ? "" + maxDeathDateFilter.toJSON() : "") + "&"; 
        if (minDeathDateFilter === null)
            throw new Error("The parameter 'minDeathDateFilter' cannot be null.");
        else if (minDeathDateFilter !== undefined)
            url_ += "MinDeathDateFilter=" + encodeURIComponent(minDeathDateFilter ? "" + minDeathDateFilter.toJSON() : "") + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (maxCreationDateFilter === null)
            throw new Error("The parameter 'maxCreationDateFilter' cannot be null.");
        else if (maxCreationDateFilter !== undefined)
            url_ += "MaxCreationDateFilter=" + encodeURIComponent(maxCreationDateFilter ? "" + maxCreationDateFilter.toJSON() : "") + "&"; 
        if (minCreationDateFilter === null)
            throw new Error("The parameter 'minCreationDateFilter' cannot be null.");
        else if (minCreationDateFilter !== undefined)
            url_ += "MinCreationDateFilter=" + encodeURIComponent(minCreationDateFilter ? "" + minCreationDateFilter.toJSON() : "") + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetDeceasedForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetDeceasedForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetDeceasedForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetDeceasedForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetDeceasedForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getDeceasedForView(id: number | undefined): Observable<GetDeceasedForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Deceaseds/GetDeceasedForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeceasedForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeceasedForView(<any>response_);
                } catch (e) {
                    return <Observable<GetDeceasedForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetDeceasedForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetDeceasedForView(response: HttpResponseBase): Observable<GetDeceasedForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDeceasedForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDeceasedForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getDeceasedForEdit(id: number | undefined): Observable<GetDeceasedForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Deceaseds/GetDeceasedForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeceasedForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeceasedForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetDeceasedForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetDeceasedForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetDeceasedForEdit(response: HttpResponseBase): Observable<GetDeceasedForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDeceasedForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDeceasedForEditOutput>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getDeceasedAndBannersForEdit(id: number | undefined): Observable<GetDeceasedAndBannersForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Deceaseds/GetDeceasedAndBannersForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeceasedAndBannersForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeceasedAndBannersForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetDeceasedAndBannersForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetDeceasedAndBannersForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetDeceasedAndBannersForEdit(response: HttpResponseBase): Observable<GetDeceasedAndBannersForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDeceasedAndBannersForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDeceasedAndBannersForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditDeceasedDto | undefined): Observable<CreateOrEditDeceasedOutput> {
        let url_ = this.baseUrl + "/api/services/app/Deceaseds/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditDeceasedOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditDeceasedOutput>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<CreateOrEditDeceasedOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditDeceasedOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditDeceasedOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAndGetId(body: CreateOrEditDeceasedDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Deceaseds/CreateAndGetId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAndGetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAndGetId(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateAndGetId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditDeceasedAndBanner(body: CreateOrEditDeceasedAndBannerDto | undefined): Observable<CreateOrEditDeceasedOutput> {
        let url_ = this.baseUrl + "/api/services/app/Deceaseds/CreateOrEditDeceasedAndBanner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditDeceasedAndBanner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditDeceasedAndBanner(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditDeceasedOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditDeceasedOutput>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditDeceasedAndBanner(response: HttpResponseBase): Observable<CreateOrEditDeceasedOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditDeceasedOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditDeceasedOutput>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param deathDateFilter (optional) 
     * @param genderFilter (optional) 
     * @param haveCeremonies (optional) 
     * @param page (optional) 
     * @param deceasedCode (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllDeceasedForShop(filter: string | undefined, deathDateFilter: moment.Moment | undefined, genderFilter: number | undefined, haveCeremonies: boolean | undefined, page: number | undefined, deceasedCode: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAllDeceasedForShopDto> {
        let url_ = this.baseUrl + "/api/services/app/Deceaseds/GetAllDeceasedForShop?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (deathDateFilter === null)
            throw new Error("The parameter 'deathDateFilter' cannot be null.");
        else if (deathDateFilter !== undefined)
            url_ += "DeathDateFilter=" + encodeURIComponent(deathDateFilter ? "" + deathDateFilter.toJSON() : "") + "&"; 
        if (genderFilter === null)
            throw new Error("The parameter 'genderFilter' cannot be null.");
        else if (genderFilter !== undefined)
            url_ += "GenderFilter=" + encodeURIComponent("" + genderFilter) + "&"; 
        if (haveCeremonies === null)
            throw new Error("The parameter 'haveCeremonies' cannot be null.");
        else if (haveCeremonies !== undefined)
            url_ += "HaveCeremonies=" + encodeURIComponent("" + haveCeremonies) + "&"; 
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (deceasedCode === null)
            throw new Error("The parameter 'deceasedCode' cannot be null.");
        else if (deceasedCode !== undefined)
            url_ += "DeceasedCode=" + encodeURIComponent("" + deceasedCode) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDeceasedForShop(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDeceasedForShop(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAllDeceasedForShopDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAllDeceasedForShopDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllDeceasedForShop(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllDeceasedForShopDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAllDeceasedForShopDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAllDeceasedForShopDto>(<any>null);
    }

    /**
     * @return Success
     */
    updateGetAllDeceasedCache(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Deceaseds/UpdateGetAllDeceasedCache";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateGetAllDeceasedCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGetAllDeceasedCache(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateGetAllDeceasedCache(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param deceasedCode (optional) 
     * @return Success
     */
    getDeceasedForShop(deceasedCode: string | undefined): Observable<GetDeceasedForShopDto> {
        let url_ = this.baseUrl + "/api/services/app/Deceaseds/GetDeceasedForShop?";
        if (deceasedCode === null)
            throw new Error("The parameter 'deceasedCode' cannot be null.");
        else if (deceasedCode !== undefined)
            url_ += "deceasedCode=" + encodeURIComponent("" + deceasedCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeceasedForShop(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeceasedForShop(<any>response_);
                } catch (e) {
                    return <Observable<GetDeceasedForShopDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetDeceasedForShopDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetDeceasedForShop(response: HttpResponseBase): Observable<GetDeceasedForShopDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDeceasedForShopDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDeceasedForShopDto>(<any>null);
    }

    /**
     * @param deceasedCode (optional) 
     * @return Success
     */
    getDeceasedAndCeremonyForShop(deceasedCode: string | undefined): Observable<GetDeceasedAndCeremonyForShopDto> {
        let url_ = this.baseUrl + "/api/services/app/Deceaseds/GetDeceasedAndCeremonyForShop?";
        if (deceasedCode === null)
            throw new Error("The parameter 'deceasedCode' cannot be null.");
        else if (deceasedCode !== undefined)
            url_ += "deceasedCode=" + encodeURIComponent("" + deceasedCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeceasedAndCeremonyForShop(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeceasedAndCeremonyForShop(<any>response_);
                } catch (e) {
                    return <Observable<GetDeceasedAndCeremonyForShopDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetDeceasedAndCeremonyForShopDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetDeceasedAndCeremonyForShop(response: HttpResponseBase): Observable<GetDeceasedAndCeremonyForShopDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDeceasedAndCeremonyForShopDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDeceasedAndCeremonyForShopDto>(<any>null);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    getKheyrat(code: string | undefined): Observable<Kheyrat> {
        let url_ = this.baseUrl + "/api/services/app/Deceaseds/GetKheyrat?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKheyrat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKheyrat(<any>response_);
                } catch (e) {
                    return <Observable<Kheyrat>><any>_observableThrow(e);
                }
            } else
                return <Observable<Kheyrat>><any>_observableThrow(response_);
        }));
    }

    protected processGetKheyrat(response: HttpResponseBase): Observable<Kheyrat> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Kheyrat.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Kheyrat>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Deceaseds/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param genderFilter (optional) 
     * @param firstNameFilter (optional) 
     * @param lastNameFilter (optional) 
     * @param survivorNameFilter (optional) 
     * @param survivorPhoneNoFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param imagePathFilter (optional) 
     * @param maxDeathDateFilter (optional) 
     * @param minDeathDateFilter (optional) 
     * @param codeFilter (optional) 
     * @return Success
     */
    getDeceasedsToExcel(filter: string | undefined, genderFilter: number | undefined, firstNameFilter: string | undefined, lastNameFilter: string | undefined, survivorNameFilter: string | undefined, survivorPhoneNoFilter: string | undefined, descriptionFilter: string | undefined, imagePathFilter: string | undefined, maxDeathDateFilter: moment.Moment | undefined, minDeathDateFilter: moment.Moment | undefined, codeFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Deceaseds/GetDeceasedsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (genderFilter === null)
            throw new Error("The parameter 'genderFilter' cannot be null.");
        else if (genderFilter !== undefined)
            url_ += "GenderFilter=" + encodeURIComponent("" + genderFilter) + "&"; 
        if (firstNameFilter === null)
            throw new Error("The parameter 'firstNameFilter' cannot be null.");
        else if (firstNameFilter !== undefined)
            url_ += "FirstNameFilter=" + encodeURIComponent("" + firstNameFilter) + "&"; 
        if (lastNameFilter === null)
            throw new Error("The parameter 'lastNameFilter' cannot be null.");
        else if (lastNameFilter !== undefined)
            url_ += "LastNameFilter=" + encodeURIComponent("" + lastNameFilter) + "&"; 
        if (survivorNameFilter === null)
            throw new Error("The parameter 'survivorNameFilter' cannot be null.");
        else if (survivorNameFilter !== undefined)
            url_ += "SurvivorNameFilter=" + encodeURIComponent("" + survivorNameFilter) + "&"; 
        if (survivorPhoneNoFilter === null)
            throw new Error("The parameter 'survivorPhoneNoFilter' cannot be null.");
        else if (survivorPhoneNoFilter !== undefined)
            url_ += "SurvivorPhoneNoFilter=" + encodeURIComponent("" + survivorPhoneNoFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (imagePathFilter === null)
            throw new Error("The parameter 'imagePathFilter' cannot be null.");
        else if (imagePathFilter !== undefined)
            url_ += "ImagePathFilter=" + encodeURIComponent("" + imagePathFilter) + "&"; 
        if (maxDeathDateFilter === null)
            throw new Error("The parameter 'maxDeathDateFilter' cannot be null.");
        else if (maxDeathDateFilter !== undefined)
            url_ += "MaxDeathDateFilter=" + encodeURIComponent(maxDeathDateFilter ? "" + maxDeathDateFilter.toJSON() : "") + "&"; 
        if (minDeathDateFilter === null)
            throw new Error("The parameter 'minDeathDateFilter' cannot be null.");
        else if (minDeathDateFilter !== undefined)
            url_ += "MinDeathDateFilter=" + encodeURIComponent(minDeathDateFilter ? "" + minDeathDateFilter.toJSON() : "") + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeceasedsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeceasedsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetDeceasedsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param genderFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllRespectPrefixForLookupTable(filter: string | undefined, genderFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfDeceasedRespectPrefixLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Deceaseds/GetAllRespectPrefixForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (genderFilter === null)
            throw new Error("The parameter 'genderFilter' cannot be null.");
        else if (genderFilter !== undefined)
            url_ += "GenderFilter=" + encodeURIComponent("" + genderFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRespectPrefixForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRespectPrefixForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfDeceasedRespectPrefixLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfDeceasedRespectPrefixLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllRespectPrefixForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfDeceasedRespectPrefixLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfDeceasedRespectPrefixLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfDeceasedRespectPrefixLookupTableDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approveDeceased(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Deceaseds/ApproveDeceased";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveDeceased(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveDeceased(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApproveDeceased(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approveDeceasedImage(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Deceaseds/ApproveDeceasedImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveDeceasedImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveDeceasedImage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApproveDeceasedImage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param deathDate (optional) 
     * @param deathDateTime (optional) 
     * @param name (optional) 
     * @param lastName (optional) 
     * @param fatherName (optional) 
     * @param ghete (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getInquiryDeceasedFromBaghrezvan(deathDate: number | undefined, deathDateTime: moment.Moment | undefined, name: string | undefined, lastName: string | undefined, fatherName: string | undefined, ghete: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetInquiryDeceasedDto> {
        let url_ = this.baseUrl + "/api/services/app/Deceaseds/GetInquiryDeceasedFromBaghrezvan?";
        if (deathDate === null)
            throw new Error("The parameter 'deathDate' cannot be null.");
        else if (deathDate !== undefined)
            url_ += "DeathDate=" + encodeURIComponent("" + deathDate) + "&"; 
        if (deathDateTime === null)
            throw new Error("The parameter 'deathDateTime' cannot be null.");
        else if (deathDateTime !== undefined)
            url_ += "DeathDateTime=" + encodeURIComponent(deathDateTime ? "" + deathDateTime.toJSON() : "") + "&"; 
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&"; 
        if (lastName === null)
            throw new Error("The parameter 'lastName' cannot be null.");
        else if (lastName !== undefined)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&"; 
        if (fatherName === null)
            throw new Error("The parameter 'fatherName' cannot be null.");
        else if (fatherName !== undefined)
            url_ += "FatherName=" + encodeURIComponent("" + fatherName) + "&"; 
        if (ghete === null)
            throw new Error("The parameter 'ghete' cannot be null.");
        else if (ghete !== undefined)
            url_ += "Ghete=" + encodeURIComponent("" + ghete) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInquiryDeceasedFromBaghrezvan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInquiryDeceasedFromBaghrezvan(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetInquiryDeceasedDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetInquiryDeceasedDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetInquiryDeceasedFromBaghrezvan(response: HttpResponseBase): Observable<PagedResultDtoOfGetInquiryDeceasedDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetInquiryDeceasedDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetInquiryDeceasedDto>(<any>null);
    }

    /**
     * @param deathDate (optional) 
     * @param deathDateTime (optional) 
     * @param name (optional) 
     * @param lastName (optional) 
     * @param fatherName (optional) 
     * @param ghete (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getNewInquiryDeceasedFromBaghrezvan(deathDate: number | undefined, deathDateTime: moment.Moment | undefined, name: string | undefined, lastName: string | undefined, fatherName: string | undefined, ghete: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetInquiryDeceasedDto> {
        let url_ = this.baseUrl + "/api/services/app/Deceaseds/GetNewInquiryDeceasedFromBaghrezvan?";
        if (deathDate === null)
            throw new Error("The parameter 'deathDate' cannot be null.");
        else if (deathDate !== undefined)
            url_ += "DeathDate=" + encodeURIComponent("" + deathDate) + "&"; 
        if (deathDateTime === null)
            throw new Error("The parameter 'deathDateTime' cannot be null.");
        else if (deathDateTime !== undefined)
            url_ += "DeathDateTime=" + encodeURIComponent(deathDateTime ? "" + deathDateTime.toJSON() : "") + "&"; 
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&"; 
        if (lastName === null)
            throw new Error("The parameter 'lastName' cannot be null.");
        else if (lastName !== undefined)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&"; 
        if (fatherName === null)
            throw new Error("The parameter 'fatherName' cannot be null.");
        else if (fatherName !== undefined)
            url_ += "FatherName=" + encodeURIComponent("" + fatherName) + "&"; 
        if (ghete === null)
            throw new Error("The parameter 'ghete' cannot be null.");
        else if (ghete !== undefined)
            url_ += "Ghete=" + encodeURIComponent("" + ghete) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewInquiryDeceasedFromBaghrezvan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewInquiryDeceasedFromBaghrezvan(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetInquiryDeceasedDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetInquiryDeceasedDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetNewInquiryDeceasedFromBaghrezvan(response: HttpResponseBase): Observable<PagedResultDtoOfGetInquiryDeceasedDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetInquiryDeceasedDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetInquiryDeceasedDto>(<any>null);
    }

    /**
     * @param deathDate (optional) 
     * @param deathDateTime (optional) 
     * @param name (optional) 
     * @param lastName (optional) 
     * @param fatherName (optional) 
     * @param ghete (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getOldInquiryAllDeceasedFromMonitoring(deathDate: number | undefined, deathDateTime: moment.Moment | undefined, name: string | undefined, lastName: string | undefined, fatherName: string | undefined, ghete: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetInquiryDeceasedDto> {
        let url_ = this.baseUrl + "/api/services/app/Deceaseds/GetOldInquiryAllDeceasedFromMonitoring?";
        if (deathDate === null)
            throw new Error("The parameter 'deathDate' cannot be null.");
        else if (deathDate !== undefined)
            url_ += "DeathDate=" + encodeURIComponent("" + deathDate) + "&"; 
        if (deathDateTime === null)
            throw new Error("The parameter 'deathDateTime' cannot be null.");
        else if (deathDateTime !== undefined)
            url_ += "DeathDateTime=" + encodeURIComponent(deathDateTime ? "" + deathDateTime.toJSON() : "") + "&"; 
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&"; 
        if (lastName === null)
            throw new Error("The parameter 'lastName' cannot be null.");
        else if (lastName !== undefined)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&"; 
        if (fatherName === null)
            throw new Error("The parameter 'fatherName' cannot be null.");
        else if (fatherName !== undefined)
            url_ += "FatherName=" + encodeURIComponent("" + fatherName) + "&"; 
        if (ghete === null)
            throw new Error("The parameter 'ghete' cannot be null.");
        else if (ghete !== undefined)
            url_ += "Ghete=" + encodeURIComponent("" + ghete) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOldInquiryAllDeceasedFromMonitoring(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOldInquiryAllDeceasedFromMonitoring(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetInquiryDeceasedDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetInquiryDeceasedDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOldInquiryAllDeceasedFromMonitoring(response: HttpResponseBase): Observable<PagedResultDtoOfGetInquiryDeceasedDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetInquiryDeceasedDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetInquiryDeceasedDto>(<any>null);
    }

    /**
     * @param deathDate (optional) 
     * @param deathDateTime (optional) 
     * @param name (optional) 
     * @param lastName (optional) 
     * @param fatherName (optional) 
     * @param ghete (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getInquiryAllDeceasedFromMonitoring(deathDate: number | undefined, deathDateTime: moment.Moment | undefined, name: string | undefined, lastName: string | undefined, fatherName: string | undefined, ghete: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetInquiryDeceasedDto> {
        let url_ = this.baseUrl + "/api/services/app/Deceaseds/GetInquiryAllDeceasedFromMonitoring?";
        if (deathDate === null)
            throw new Error("The parameter 'deathDate' cannot be null.");
        else if (deathDate !== undefined)
            url_ += "DeathDate=" + encodeURIComponent("" + deathDate) + "&"; 
        if (deathDateTime === null)
            throw new Error("The parameter 'deathDateTime' cannot be null.");
        else if (deathDateTime !== undefined)
            url_ += "DeathDateTime=" + encodeURIComponent(deathDateTime ? "" + deathDateTime.toJSON() : "") + "&"; 
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&"; 
        if (lastName === null)
            throw new Error("The parameter 'lastName' cannot be null.");
        else if (lastName !== undefined)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&"; 
        if (fatherName === null)
            throw new Error("The parameter 'fatherName' cannot be null.");
        else if (fatherName !== undefined)
            url_ += "FatherName=" + encodeURIComponent("" + fatherName) + "&"; 
        if (ghete === null)
            throw new Error("The parameter 'ghete' cannot be null.");
        else if (ghete !== undefined)
            url_ += "Ghete=" + encodeURIComponent("" + ghete) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInquiryAllDeceasedFromMonitoring(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInquiryAllDeceasedFromMonitoring(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetInquiryDeceasedDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetInquiryDeceasedDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetInquiryAllDeceasedFromMonitoring(response: HttpResponseBase): Observable<PagedResultDtoOfGetInquiryDeceasedDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetInquiryDeceasedDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetInquiryDeceasedDto>(<any>null);
    }

    /**
     * @param deceasedCode (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllFlowerCrownForDeceased(deceasedCode: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<GetDeceasedFlowerCrownsAndClipsDto> {
        let url_ = this.baseUrl + "/api/services/app/Deceaseds/GetAllFlowerCrownForDeceased?";
        if (deceasedCode === null)
            throw new Error("The parameter 'deceasedCode' cannot be null.");
        else if (deceasedCode !== undefined)
            url_ += "DeceasedCode=" + encodeURIComponent("" + deceasedCode) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFlowerCrownForDeceased(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFlowerCrownForDeceased(<any>response_);
                } catch (e) {
                    return <Observable<GetDeceasedFlowerCrownsAndClipsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetDeceasedFlowerCrownsAndClipsDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllFlowerCrownForDeceased(response: HttpResponseBase): Observable<GetDeceasedFlowerCrownsAndClipsDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDeceasedFlowerCrownsAndClipsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDeceasedFlowerCrownsAndClipsDto>(<any>null);
    }

    /**
     * @param billCode (optional) 
     * @return Success
     */
    getFlowerCrownDetailForDeceased(billCode: string | undefined): Observable<GetFlowerCrownDetailForDeceasedDto> {
        let url_ = this.baseUrl + "/api/services/app/Deceaseds/GetFlowerCrownDetailForDeceased?";
        if (billCode === null)
            throw new Error("The parameter 'billCode' cannot be null.");
        else if (billCode !== undefined)
            url_ += "billCode=" + encodeURIComponent("" + billCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFlowerCrownDetailForDeceased(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFlowerCrownDetailForDeceased(<any>response_);
                } catch (e) {
                    return <Observable<GetFlowerCrownDetailForDeceasedDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetFlowerCrownDetailForDeceasedDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFlowerCrownDetailForDeceased(response: HttpResponseBase): Observable<GetFlowerCrownDetailForDeceasedDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFlowerCrownDetailForDeceasedDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFlowerCrownDetailForDeceasedDto>(<any>null);
    }

    /**
     * @param deceasedCode (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getFlowerCrownsForDeceasedToExcel(deceasedCode: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Deceaseds/GetFlowerCrownsForDeceasedToExcel?";
        if (deceasedCode === null)
            throw new Error("The parameter 'deceasedCode' cannot be null.");
        else if (deceasedCode !== undefined)
            url_ += "DeceasedCode=" + encodeURIComponent("" + deceasedCode) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFlowerCrownsForDeceasedToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFlowerCrownsForDeceasedToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFlowerCrownsForDeceasedToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getDeceasedFromBeheshteZahra(name: string, lastName: string, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetDeceasedFromBeheshteZahraOutput> {
        let url_ = this.baseUrl + "/api/services/app/Deceaseds/GetDeceasedFromBeheshteZahra?";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined and cannot be null.");
        else
            url_ += "Name=" + encodeURIComponent("" + name) + "&"; 
        if (lastName === undefined || lastName === null)
            throw new Error("The parameter 'lastName' must be defined and cannot be null.");
        else
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeceasedFromBeheshteZahra(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeceasedFromBeheshteZahra(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetDeceasedFromBeheshteZahraOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetDeceasedFromBeheshteZahraOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetDeceasedFromBeheshteZahra(response: HttpResponseBase): Observable<PagedResultDtoOfGetDeceasedFromBeheshteZahraOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetDeceasedFromBeheshteZahraOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetDeceasedFromBeheshteZahraOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    mergeAndSave(body: MergeDeceasedAndSaveInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Deceaseds/MergeAndSave";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMergeAndSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMergeAndSave(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processMergeAndSave(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getUnApprovedCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Deceaseds/GetUnApprovedCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnApprovedCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnApprovedCount(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetUnApprovedCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }
}

@Injectable()
export class DemoUiComponentsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param date (optional) 
     * @return Success
     */
    sendAndGetDate(date: moment.Moment | undefined): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDate?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetDate(<any>response_);
                } catch (e) {
                    return <Observable<DateToStringOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<DateToStringOutput>><any>_observableThrow(response_);
        }));
    }

    protected processSendAndGetDate(response: HttpResponseBase): Observable<DateToStringOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DateToStringOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DateToStringOutput>(<any>null);
    }

    /**
     * @param date (optional) 
     * @return Success
     */
    sendAndGetDateTime(date: moment.Moment | undefined): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDateTime?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetDateTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetDateTime(<any>response_);
                } catch (e) {
                    return <Observable<DateToStringOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<DateToStringOutput>><any>_observableThrow(response_);
        }));
    }

    protected processSendAndGetDateTime(response: HttpResponseBase): Observable<DateToStringOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DateToStringOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DateToStringOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    sendAndGetDateRange(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDateRange?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetDateRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetDateRange(<any>response_);
                } catch (e) {
                    return <Observable<DateToStringOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<DateToStringOutput>><any>_observableThrow(response_);
        }));
    }

    protected processSendAndGetDateRange(response: HttpResponseBase): Observable<DateToStringOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DateToStringOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DateToStringOutput>(<any>null);
    }

    /**
     * @param searchTerm (optional) 
     * @return Success
     */
    getCountries(searchTerm: string | undefined): Observable<NameValueOfString[]> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/GetCountries?";
        if (searchTerm === null)
            throw new Error("The parameter 'searchTerm' cannot be null.");
        else if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountries(<any>response_);
                } catch (e) {
                    return <Observable<NameValueOfString[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueOfString[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCountries(response: HttpResponseBase): Observable<NameValueOfString[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueOfString.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueOfString[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendAndGetSelectedCountries(body: NameValueOfString[] | undefined): Observable<NameValueOfString[]> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetSelectedCountries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetSelectedCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetSelectedCountries(<any>response_);
                } catch (e) {
                    return <Observable<NameValueOfString[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueOfString[]>><any>_observableThrow(response_);
        }));
    }

    protected processSendAndGetSelectedCountries(response: HttpResponseBase): Observable<NameValueOfString[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueOfString.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueOfString[]>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    sendAndGetValue(input: string | undefined): Observable<StringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetValue?";
        if (input === null)
            throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetValue(<any>response_);
                } catch (e) {
                    return <Observable<StringOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<StringOutput>><any>_observableThrow(response_);
        }));
    }

    protected processSendAndGetValue(response: HttpResponseBase): Observable<StringOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StringOutput>(<any>null);
    }
}

@Injectable()
export class DirectionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param stateFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param areaNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, nameFilter: string | undefined, stateFilter: number | undefined, descriptionFilter: string | undefined, areaNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetDirectionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Directions/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (areaNameFilter === null)
            throw new Error("The parameter 'areaNameFilter' cannot be null.");
        else if (areaNameFilter !== undefined)
            url_ += "AreaNameFilter=" + encodeURIComponent("" + areaNameFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetDirectionForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetDirectionForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetDirectionForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetDirectionForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetDirectionForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getDirectionForView(id: number | undefined): Observable<GetDirectionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Directions/GetDirectionForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDirectionForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDirectionForView(<any>response_);
                } catch (e) {
                    return <Observable<GetDirectionForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetDirectionForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetDirectionForView(response: HttpResponseBase): Observable<GetDirectionForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDirectionForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDirectionForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getDirectionForEdit(id: number | undefined): Observable<GetDirectionForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Directions/GetDirectionForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDirectionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDirectionForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetDirectionForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetDirectionForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetDirectionForEdit(response: HttpResponseBase): Observable<GetDirectionForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDirectionForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDirectionForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditDirectionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Directions/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Directions/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteByChangeStatus(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Directions/DeleteByChangeStatus?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteByChangeStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByChangeStatus(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteByChangeStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param stateFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param areaNameFilter (optional) 
     * @return Success
     */
    getDirectionsToExcel(filter: string | undefined, nameFilter: string | undefined, stateFilter: number | undefined, descriptionFilter: string | undefined, areaNameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Directions/GetDirectionsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (areaNameFilter === null)
            throw new Error("The parameter 'areaNameFilter' cannot be null.");
        else if (areaNameFilter !== undefined)
            url_ += "AreaNameFilter=" + encodeURIComponent("" + areaNameFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDirectionsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDirectionsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetDirectionsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllAreaForTableDropdown(): Observable<DirectionAreaLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Directions/GetAllAreaForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAreaForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAreaForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<DirectionAreaLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DirectionAreaLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllAreaForTableDropdown(response: HttpResponseBase): Observable<DirectionAreaLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DirectionAreaLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DirectionAreaLookupTableDto[]>(<any>null);
    }

    /**
     * @param cityId (optional) 
     * @return Success
     */
    getAllAreaForTableDropdownByCityName(cityId: number | undefined): Observable<DirectionAreaLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Directions/GetAllAreaForTableDropdownByCityName?";
        if (cityId === null)
            throw new Error("The parameter 'cityId' cannot be null.");
        else if (cityId !== undefined)
            url_ += "cityId=" + encodeURIComponent("" + cityId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAreaForTableDropdownByCityName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAreaForTableDropdownByCityName(<any>response_);
                } catch (e) {
                    return <Observable<DirectionAreaLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DirectionAreaLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllAreaForTableDropdownByCityName(response: HttpResponseBase): Observable<DirectionAreaLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DirectionAreaLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DirectionAreaLookupTableDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditDirectionAndPoints(body: CreateDirectionAndPointsDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Directions/CreateOrEditDirectionAndPoints";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditDirectionAndPoints(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditDirectionAndPoints(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditDirectionAndPoints(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createDirectionAndPoint(body: CreateOrEditDirectionDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Directions/CreateDirectionAndPoint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDirectionAndPoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDirectionAndPoint(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateDirectionAndPoint(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getDirectionsByAreaId(id: number | undefined): Observable<GetDirectionAndPointsForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Directions/GetDirectionsByAreaId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDirectionsByAreaId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDirectionsByAreaId(<any>response_);
                } catch (e) {
                    return <Observable<GetDirectionAndPointsForViewDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetDirectionAndPointsForViewDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetDirectionsByAreaId(response: HttpResponseBase): Observable<GetDirectionAndPointsForViewDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetDirectionAndPointsForViewDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDirectionAndPointsForViewDto[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getDirectionsByCityId(id: number | undefined): Observable<GetDirectionByCityIdForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Directions/GetDirectionsByCityId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDirectionsByCityId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDirectionsByCityId(<any>response_);
                } catch (e) {
                    return <Observable<GetDirectionByCityIdForViewDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetDirectionByCityIdForViewDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetDirectionsByCityId(response: HttpResponseBase): Observable<GetDirectionByCityIdForViewDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetDirectionByCityIdForViewDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDirectionByCityIdForViewDto[]>(<any>null);
    }
}

@Injectable()
export class DocumentsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param documentTitleFilter (optional) 
     * @param entityRefFilter (optional) 
     * @param entityFilter (optional) 
     * @param entityDocTypeFilter (optional) 
     * @param filePathFilter (optional) 
     * @param fileNameFilter (optional) 
     * @param fileTypeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, documentTitleFilter: string | undefined, entityRefFilter: number | undefined, entityFilter: number | undefined, entityDocTypeFilter: number | undefined, filePathFilter: string | undefined, fileNameFilter: string | undefined, fileTypeFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetDocumentForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Documents/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (documentTitleFilter === null)
            throw new Error("The parameter 'documentTitleFilter' cannot be null.");
        else if (documentTitleFilter !== undefined)
            url_ += "DocumentTitleFilter=" + encodeURIComponent("" + documentTitleFilter) + "&"; 
        if (entityRefFilter === null)
            throw new Error("The parameter 'entityRefFilter' cannot be null.");
        else if (entityRefFilter !== undefined)
            url_ += "EntityRefFilter=" + encodeURIComponent("" + entityRefFilter) + "&"; 
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (entityDocTypeFilter === null)
            throw new Error("The parameter 'entityDocTypeFilter' cannot be null.");
        else if (entityDocTypeFilter !== undefined)
            url_ += "EntityDocTypeFilter=" + encodeURIComponent("" + entityDocTypeFilter) + "&"; 
        if (filePathFilter === null)
            throw new Error("The parameter 'filePathFilter' cannot be null.");
        else if (filePathFilter !== undefined)
            url_ += "FilePathFilter=" + encodeURIComponent("" + filePathFilter) + "&"; 
        if (fileNameFilter === null)
            throw new Error("The parameter 'fileNameFilter' cannot be null.");
        else if (fileNameFilter !== undefined)
            url_ += "FileNameFilter=" + encodeURIComponent("" + fileNameFilter) + "&"; 
        if (fileTypeFilter === null)
            throw new Error("The parameter 'fileTypeFilter' cannot be null.");
        else if (fileTypeFilter !== undefined)
            url_ += "FileTypeFilter=" + encodeURIComponent("" + fileTypeFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetDocumentForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetDocumentForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetDocumentForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetDocumentForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetDocumentForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getDocumentForView(id: number | undefined): Observable<GetDocumentForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Documents/GetDocumentForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentForView(<any>response_);
                } catch (e) {
                    return <Observable<GetDocumentForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetDocumentForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetDocumentForView(response: HttpResponseBase): Observable<GetDocumentForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDocumentForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDocumentForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getDocumentForEdit(id: number | undefined): Observable<GetDocumentForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Documents/GetDocumentForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetDocumentForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetDocumentForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetDocumentForEdit(response: HttpResponseBase): Observable<GetDocumentForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDocumentForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDocumentForEditOutput>(<any>null);
    }

    /**
     * @param contactId (optional) 
     * @return Success
     */
    getDocumentsForContact(contactId: number | undefined): Observable<DocumentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Documents/GetDocumentsForContact?";
        if (contactId === null)
            throw new Error("The parameter 'contactId' cannot be null.");
        else if (contactId !== undefined)
            url_ += "contactId=" + encodeURIComponent("" + contactId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentsForContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentsForContact(<any>response_);
                } catch (e) {
                    return <Observable<DocumentDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetDocumentsForContact(response: HttpResponseBase): Observable<DocumentDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditDocumentDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Documents/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    delete(input: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Documents/Delete?";
        if (input === null)
            throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            input && input.forEach(item => { url_ += "input=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    deleteItem(input: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Documents/DeleteItem?";
        if (input === null)
            throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteItem(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteItem(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param path (optional) 
     * @return Success
     */
    deleteUploadedNotSaved(path: string[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Documents/DeleteUploadedNotSaved?";
        if (path === null)
            throw new Error("The parameter 'path' cannot be null.");
        else if (path !== undefined)
            path && path.forEach(item => { url_ += "path=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUploadedNotSaved(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUploadedNotSaved(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteUploadedNotSaved(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param path (optional) 
     * @return Success
     */
    deleteNotSaved(path: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Documents/DeleteNotSaved?";
        if (path === null)
            throw new Error("The parameter 'path' cannot be null.");
        else if (path !== undefined)
            url_ += "path=" + encodeURIComponent("" + path) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteNotSaved(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteNotSaved(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteNotSaved(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param inputId (optional) 
     * @param inputName (optional) 
     * @return Success
     */
    getDocument(inputId: number | undefined, inputName: number | undefined): Observable<PagedResultDtoOfGetDocumentForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Documents/GetDocument?";
        if (inputId === null)
            throw new Error("The parameter 'inputId' cannot be null.");
        else if (inputId !== undefined)
            url_ += "inputId=" + encodeURIComponent("" + inputId) + "&"; 
        if (inputName === null)
            throw new Error("The parameter 'inputName' cannot be null.");
        else if (inputName !== undefined)
            url_ += "inputName=" + encodeURIComponent("" + inputName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocument(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetDocumentForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetDocumentForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetDocument(response: HttpResponseBase): Observable<PagedResultDtoOfGetDocumentForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetDocumentForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetDocumentForViewDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param documentTitleFilter (optional) 
     * @param maxEntityRefFilter (optional) 
     * @param minEntityRefFilter (optional) 
     * @param entityFilter (optional) 
     * @param entityDocTypeFilter (optional) 
     * @param filePathFilter (optional) 
     * @param fileNameFilter (optional) 
     * @param fileTypeFilter (optional) 
     * @return Success
     */
    getDocumentsToExcel(filter: string | undefined, documentTitleFilter: string | undefined, maxEntityRefFilter: number | undefined, minEntityRefFilter: number | undefined, entityFilter: number | undefined, entityDocTypeFilter: number | undefined, filePathFilter: string | undefined, fileNameFilter: string | undefined, fileTypeFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Documents/GetDocumentsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (documentTitleFilter === null)
            throw new Error("The parameter 'documentTitleFilter' cannot be null.");
        else if (documentTitleFilter !== undefined)
            url_ += "DocumentTitleFilter=" + encodeURIComponent("" + documentTitleFilter) + "&"; 
        if (maxEntityRefFilter === null)
            throw new Error("The parameter 'maxEntityRefFilter' cannot be null.");
        else if (maxEntityRefFilter !== undefined)
            url_ += "MaxEntityRefFilter=" + encodeURIComponent("" + maxEntityRefFilter) + "&"; 
        if (minEntityRefFilter === null)
            throw new Error("The parameter 'minEntityRefFilter' cannot be null.");
        else if (minEntityRefFilter !== undefined)
            url_ += "MinEntityRefFilter=" + encodeURIComponent("" + minEntityRefFilter) + "&"; 
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (entityDocTypeFilter === null)
            throw new Error("The parameter 'entityDocTypeFilter' cannot be null.");
        else if (entityDocTypeFilter !== undefined)
            url_ += "EntityDocTypeFilter=" + encodeURIComponent("" + entityDocTypeFilter) + "&"; 
        if (filePathFilter === null)
            throw new Error("The parameter 'filePathFilter' cannot be null.");
        else if (filePathFilter !== undefined)
            url_ += "FilePathFilter=" + encodeURIComponent("" + filePathFilter) + "&"; 
        if (fileNameFilter === null)
            throw new Error("The parameter 'fileNameFilter' cannot be null.");
        else if (fileNameFilter !== undefined)
            url_ += "FileNameFilter=" + encodeURIComponent("" + fileNameFilter) + "&"; 
        if (fileTypeFilter === null)
            throw new Error("The parameter 'fileTypeFilter' cannot be null.");
        else if (fileTypeFilter !== undefined)
            url_ += "FileTypeFilter=" + encodeURIComponent("" + fileTypeFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetDocumentsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param path (optional) 
     * @return Success
     */
    downloadDocument(path: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Documents/DownloadDocument?";
        if (path === null)
            throw new Error("The parameter 'path' cannot be null.");
        else if (path !== undefined)
            url_ += "path=" + encodeURIComponent("" + path) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadDocument(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processDownloadDocument(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class EditionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getEditions(): Observable<ListResultDtoOfEditionListDto> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditions(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEditionListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfEditionListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEditions(response: HttpResponseBase): Observable<ListResultDtoOfEditionListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfEditionListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfEditionListDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEditionForEdit(id: number | undefined): Observable<GetEditionEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditionForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetEditionEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetEditionEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetEditionForEdit(response: HttpResponseBase): Observable<GetEditionEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEditionEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEditionEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createEdition(body: CreateEditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/CreateEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEdition(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEdition(body: UpdateEditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/UpdateEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEdition(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteEdition(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/DeleteEdition?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEdition(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    moveTenantsToAnotherEdition(body: MoveTenantsToAnotherEditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/MoveTenantsToAnotherEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveTenantsToAnotherEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveTenantsToAnotherEdition(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processMoveTenantsToAnotherEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param selectedEditionId (optional) 
     * @param addAllItem (optional) 
     * @param onlyFreeItems (optional) 
     * @return Success
     */
    getEditionComboboxItems(selectedEditionId: number | undefined, addAllItem: boolean | undefined, onlyFreeItems: boolean | undefined): Observable<SubscribableEditionComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditionComboboxItems?";
        if (selectedEditionId === null)
            throw new Error("The parameter 'selectedEditionId' cannot be null.");
        else if (selectedEditionId !== undefined)
            url_ += "selectedEditionId=" + encodeURIComponent("" + selectedEditionId) + "&"; 
        if (addAllItem === null)
            throw new Error("The parameter 'addAllItem' cannot be null.");
        else if (addAllItem !== undefined)
            url_ += "addAllItem=" + encodeURIComponent("" + addAllItem) + "&"; 
        if (onlyFreeItems === null)
            throw new Error("The parameter 'onlyFreeItems' cannot be null.");
        else if (onlyFreeItems !== undefined)
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionComboboxItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionComboboxItems(<any>response_);
                } catch (e) {
                    return <Observable<SubscribableEditionComboboxItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubscribableEditionComboboxItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetEditionComboboxItems(response: HttpResponseBase): Observable<SubscribableEditionComboboxItemDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscribableEditionComboboxItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubscribableEditionComboboxItemDto[]>(<any>null);
    }

    /**
     * @param editionId (optional) 
     * @return Success
     */
    getTenantCount(editionId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetTenantCount?";
        if (editionId === null)
            throw new Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantCount(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetTenantCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }
}

@Injectable()
export class EducationDegreesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, titleFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetEducationDegreeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/EducationDegrees/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetEducationDegreeForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetEducationDegreeForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetEducationDegreeForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetEducationDegreeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetEducationDegreeForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEducationDegreeForView(id: number | undefined): Observable<GetEducationDegreeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/EducationDegrees/GetEducationDegreeForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducationDegreeForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducationDegreeForView(<any>response_);
                } catch (e) {
                    return <Observable<GetEducationDegreeForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetEducationDegreeForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEducationDegreeForView(response: HttpResponseBase): Observable<GetEducationDegreeForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEducationDegreeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEducationDegreeForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEducationDegreeForEdit(id: number | undefined): Observable<GetEducationDegreeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/EducationDegrees/GetEducationDegreeForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducationDegreeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducationDegreeForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetEducationDegreeForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetEducationDegreeForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetEducationDegreeForEdit(response: HttpResponseBase): Observable<GetEducationDegreeForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEducationDegreeForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEducationDegreeForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditEducationDegreeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EducationDegrees/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EducationDegrees/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @return Success
     */
    getEducationDegreesToExcel(filter: string | undefined, titleFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/EducationDegrees/GetEducationDegreesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducationDegreesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducationDegreesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEducationDegreesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class EducationFieldsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param socialSecurityCodeFilter (optional) 
     * @param taxCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, nameFilter: string | undefined, socialSecurityCodeFilter: string | undefined, taxCodeFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetEducationFieldForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/EducationFields/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&"; 
        if (socialSecurityCodeFilter === null)
            throw new Error("The parameter 'socialSecurityCodeFilter' cannot be null.");
        else if (socialSecurityCodeFilter !== undefined)
            url_ += "SocialSecurityCodeFilter=" + encodeURIComponent("" + socialSecurityCodeFilter) + "&"; 
        if (taxCodeFilter === null)
            throw new Error("The parameter 'taxCodeFilter' cannot be null.");
        else if (taxCodeFilter !== undefined)
            url_ += "TaxCodeFilter=" + encodeURIComponent("" + taxCodeFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetEducationFieldForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetEducationFieldForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetEducationFieldForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetEducationFieldForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetEducationFieldForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEducationFieldForView(id: number | undefined): Observable<GetEducationFieldForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/EducationFields/GetEducationFieldForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducationFieldForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducationFieldForView(<any>response_);
                } catch (e) {
                    return <Observable<GetEducationFieldForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetEducationFieldForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEducationFieldForView(response: HttpResponseBase): Observable<GetEducationFieldForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEducationFieldForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEducationFieldForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEducationFieldForEdit(id: number | undefined): Observable<GetEducationFieldForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/EducationFields/GetEducationFieldForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducationFieldForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducationFieldForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetEducationFieldForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetEducationFieldForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetEducationFieldForEdit(response: HttpResponseBase): Observable<GetEducationFieldForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEducationFieldForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEducationFieldForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditEducationFieldDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EducationFields/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EducationFields/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param socialSecurityCodeFilter (optional) 
     * @param taxCodeFilter (optional) 
     * @return Success
     */
    getEducationFieldsToExcel(filter: string | undefined, nameFilter: string | undefined, socialSecurityCodeFilter: string | undefined, taxCodeFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/EducationFields/GetEducationFieldsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&"; 
        if (socialSecurityCodeFilter === null)
            throw new Error("The parameter 'socialSecurityCodeFilter' cannot be null.");
        else if (socialSecurityCodeFilter !== undefined)
            url_ += "SocialSecurityCodeFilter=" + encodeURIComponent("" + socialSecurityCodeFilter) + "&"; 
        if (taxCodeFilter === null)
            throw new Error("The parameter 'taxCodeFilter' cannot be null.");
        else if (taxCodeFilter !== undefined)
            url_ += "TaxCodeFilter=" + encodeURIComponent("" + taxCodeFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEducationFieldsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEducationFieldsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEducationFieldsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class EmployeesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param shenasnameNumberFilter (optional) 
     * @param personnelNumberFilter (optional) 
     * @param maritalStatusFilter (optional) 
     * @param maxNumberOfChildrenFilter (optional) 
     * @param minNumberOfChildrenFilter (optional) 
     * @param trafficNumberFilter (optional) 
     * @param receiptAgentFilter (optional) 
     * @param maxContactIdFilter (optional) 
     * @param minContactIdFilter (optional) 
     * @param cityNameFilter (optional) 
     * @param cityName2Filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, shenasnameNumberFilter: string | undefined, personnelNumberFilter: string | undefined, maritalStatusFilter: number | undefined, maxNumberOfChildrenFilter: number | undefined, minNumberOfChildrenFilter: number | undefined, trafficNumberFilter: string | undefined, receiptAgentFilter: number | undefined, maxContactIdFilter: number | undefined, minContactIdFilter: number | undefined, cityNameFilter: string | undefined, cityName2Filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetEmployeeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (shenasnameNumberFilter === null)
            throw new Error("The parameter 'shenasnameNumberFilter' cannot be null.");
        else if (shenasnameNumberFilter !== undefined)
            url_ += "ShenasnameNumberFilter=" + encodeURIComponent("" + shenasnameNumberFilter) + "&"; 
        if (personnelNumberFilter === null)
            throw new Error("The parameter 'personnelNumberFilter' cannot be null.");
        else if (personnelNumberFilter !== undefined)
            url_ += "PersonnelNumberFilter=" + encodeURIComponent("" + personnelNumberFilter) + "&"; 
        if (maritalStatusFilter === null)
            throw new Error("The parameter 'maritalStatusFilter' cannot be null.");
        else if (maritalStatusFilter !== undefined)
            url_ += "MaritalStatusFilter=" + encodeURIComponent("" + maritalStatusFilter) + "&"; 
        if (maxNumberOfChildrenFilter === null)
            throw new Error("The parameter 'maxNumberOfChildrenFilter' cannot be null.");
        else if (maxNumberOfChildrenFilter !== undefined)
            url_ += "MaxNumberOfChildrenFilter=" + encodeURIComponent("" + maxNumberOfChildrenFilter) + "&"; 
        if (minNumberOfChildrenFilter === null)
            throw new Error("The parameter 'minNumberOfChildrenFilter' cannot be null.");
        else if (minNumberOfChildrenFilter !== undefined)
            url_ += "MinNumberOfChildrenFilter=" + encodeURIComponent("" + minNumberOfChildrenFilter) + "&"; 
        if (trafficNumberFilter === null)
            throw new Error("The parameter 'trafficNumberFilter' cannot be null.");
        else if (trafficNumberFilter !== undefined)
            url_ += "TrafficNumberFilter=" + encodeURIComponent("" + trafficNumberFilter) + "&"; 
        if (receiptAgentFilter === null)
            throw new Error("The parameter 'receiptAgentFilter' cannot be null.");
        else if (receiptAgentFilter !== undefined)
            url_ += "ReceiptAgentFilter=" + encodeURIComponent("" + receiptAgentFilter) + "&"; 
        if (maxContactIdFilter === null)
            throw new Error("The parameter 'maxContactIdFilter' cannot be null.");
        else if (maxContactIdFilter !== undefined)
            url_ += "MaxContactIdFilter=" + encodeURIComponent("" + maxContactIdFilter) + "&"; 
        if (minContactIdFilter === null)
            throw new Error("The parameter 'minContactIdFilter' cannot be null.");
        else if (minContactIdFilter !== undefined)
            url_ += "MinContactIdFilter=" + encodeURIComponent("" + minContactIdFilter) + "&"; 
        if (cityNameFilter === null)
            throw new Error("The parameter 'cityNameFilter' cannot be null.");
        else if (cityNameFilter !== undefined)
            url_ += "CityNameFilter=" + encodeURIComponent("" + cityNameFilter) + "&"; 
        if (cityName2Filter === null)
            throw new Error("The parameter 'cityName2Filter' cannot be null.");
        else if (cityName2Filter !== undefined)
            url_ += "CityName2Filter=" + encodeURIComponent("" + cityName2Filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetEmployeeForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetEmployeeForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetEmployeeForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetEmployeeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetEmployeeForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEmployeeForView(id: number | undefined): Observable<GetEmployeeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetEmployeeForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeForView(<any>response_);
                } catch (e) {
                    return <Observable<GetEmployeeForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetEmployeeForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEmployeeForView(response: HttpResponseBase): Observable<GetEmployeeForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmployeeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmployeeForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEmployeeForEdit(id: number | undefined): Observable<GetEmployeeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetEmployeeForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetEmployeeForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetEmployeeForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetEmployeeForEdit(response: HttpResponseBase): Observable<GetEmployeeForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmployeeForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmployeeForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditEmployeeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employees/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employees/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param shenasnameNumberFilter (optional) 
     * @param personnelNumberFilter (optional) 
     * @param maritalStatusFilter (optional) 
     * @param maxNumberOfChildrenFilter (optional) 
     * @param minNumberOfChildrenFilter (optional) 
     * @param trafficNumberFilter (optional) 
     * @param receiptAgentFilter (optional) 
     * @param maxContactIdFilter (optional) 
     * @param minContactIdFilter (optional) 
     * @param cityNameFilter (optional) 
     * @param cityName2Filter (optional) 
     * @return Success
     */
    getEmployeesToExcel(filter: string | undefined, shenasnameNumberFilter: string | undefined, personnelNumberFilter: string | undefined, maritalStatusFilter: number | undefined, maxNumberOfChildrenFilter: number | undefined, minNumberOfChildrenFilter: number | undefined, trafficNumberFilter: string | undefined, receiptAgentFilter: number | undefined, maxContactIdFilter: number | undefined, minContactIdFilter: number | undefined, cityNameFilter: string | undefined, cityName2Filter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetEmployeesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (shenasnameNumberFilter === null)
            throw new Error("The parameter 'shenasnameNumberFilter' cannot be null.");
        else if (shenasnameNumberFilter !== undefined)
            url_ += "ShenasnameNumberFilter=" + encodeURIComponent("" + shenasnameNumberFilter) + "&"; 
        if (personnelNumberFilter === null)
            throw new Error("The parameter 'personnelNumberFilter' cannot be null.");
        else if (personnelNumberFilter !== undefined)
            url_ += "PersonnelNumberFilter=" + encodeURIComponent("" + personnelNumberFilter) + "&"; 
        if (maritalStatusFilter === null)
            throw new Error("The parameter 'maritalStatusFilter' cannot be null.");
        else if (maritalStatusFilter !== undefined)
            url_ += "MaritalStatusFilter=" + encodeURIComponent("" + maritalStatusFilter) + "&"; 
        if (maxNumberOfChildrenFilter === null)
            throw new Error("The parameter 'maxNumberOfChildrenFilter' cannot be null.");
        else if (maxNumberOfChildrenFilter !== undefined)
            url_ += "MaxNumberOfChildrenFilter=" + encodeURIComponent("" + maxNumberOfChildrenFilter) + "&"; 
        if (minNumberOfChildrenFilter === null)
            throw new Error("The parameter 'minNumberOfChildrenFilter' cannot be null.");
        else if (minNumberOfChildrenFilter !== undefined)
            url_ += "MinNumberOfChildrenFilter=" + encodeURIComponent("" + minNumberOfChildrenFilter) + "&"; 
        if (trafficNumberFilter === null)
            throw new Error("The parameter 'trafficNumberFilter' cannot be null.");
        else if (trafficNumberFilter !== undefined)
            url_ += "TrafficNumberFilter=" + encodeURIComponent("" + trafficNumberFilter) + "&"; 
        if (receiptAgentFilter === null)
            throw new Error("The parameter 'receiptAgentFilter' cannot be null.");
        else if (receiptAgentFilter !== undefined)
            url_ += "ReceiptAgentFilter=" + encodeURIComponent("" + receiptAgentFilter) + "&"; 
        if (maxContactIdFilter === null)
            throw new Error("The parameter 'maxContactIdFilter' cannot be null.");
        else if (maxContactIdFilter !== undefined)
            url_ += "MaxContactIdFilter=" + encodeURIComponent("" + maxContactIdFilter) + "&"; 
        if (minContactIdFilter === null)
            throw new Error("The parameter 'minContactIdFilter' cannot be null.");
        else if (minContactIdFilter !== undefined)
            url_ += "MinContactIdFilter=" + encodeURIComponent("" + minContactIdFilter) + "&"; 
        if (cityNameFilter === null)
            throw new Error("The parameter 'cityNameFilter' cannot be null.");
        else if (cityNameFilter !== undefined)
            url_ += "CityNameFilter=" + encodeURIComponent("" + cityNameFilter) + "&"; 
        if (cityName2Filter === null)
            throw new Error("The parameter 'cityName2Filter' cannot be null.");
        else if (cityName2Filter !== undefined)
            url_ += "CityName2Filter=" + encodeURIComponent("" + cityName2Filter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEmployeesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCityForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfEmployeeCityLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetAllCityForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCityForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCityForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfEmployeeCityLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfEmployeeCityLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCityForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfEmployeeCityLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfEmployeeCityLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfEmployeeCityLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllStateForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfEmployeeStateLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetAllStateForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStateForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStateForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfEmployeeStateLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfEmployeeStateLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllStateForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfEmployeeStateLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfEmployeeStateLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfEmployeeStateLookupTableDto>(<any>null);
    }

    /**
     * @param contactId (optional) 
     * @return Success
     */
    getEmployeeForContact(contactId: number | undefined): Observable<GetEmployeeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Employees/GetEmployeeForContact?";
        if (contactId === null)
            throw new Error("The parameter 'contactId' cannot be null.");
        else if (contactId !== undefined)
            url_ += "contactId=" + encodeURIComponent("" + contactId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeForContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeForContact(<any>response_);
                } catch (e) {
                    return <Observable<GetEmployeeForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetEmployeeForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetEmployeeForContact(response: HttpResponseBase): Observable<GetEmployeeForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmployeeForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmployeeForEditOutput>(<any>null);
    }
}

@Injectable()
export class EventTypesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param isEndDateRequiredFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, titleFilter: string | undefined, isEndDateRequiredFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetEventTypeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/EventTypes/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (isEndDateRequiredFilter === null)
            throw new Error("The parameter 'isEndDateRequiredFilter' cannot be null.");
        else if (isEndDateRequiredFilter !== undefined)
            url_ += "IsEndDateRequiredFilter=" + encodeURIComponent("" + isEndDateRequiredFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetEventTypeForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetEventTypeForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetEventTypeForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetEventTypeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetEventTypeForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEventTypeForView(id: number | undefined): Observable<GetEventTypeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/EventTypes/GetEventTypeForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEventTypeForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventTypeForView(<any>response_);
                } catch (e) {
                    return <Observable<GetEventTypeForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetEventTypeForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEventTypeForView(response: HttpResponseBase): Observable<GetEventTypeForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEventTypeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEventTypeForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEventTypeForEdit(id: number | undefined): Observable<GetEventTypeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/EventTypes/GetEventTypeForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEventTypeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventTypeForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetEventTypeForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetEventTypeForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetEventTypeForEdit(response: HttpResponseBase): Observable<GetEventTypeForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEventTypeForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEventTypeForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditEventTypeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EventTypes/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EventTypes/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param isEndDateRequiredFilter (optional) 
     * @return Success
     */
    getEventTypesToExcel(filter: string | undefined, titleFilter: string | undefined, isEndDateRequiredFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/EventTypes/GetEventTypesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (isEndDateRequiredFilter === null)
            throw new Error("The parameter 'isEndDateRequiredFilter' cannot be null.");
        else if (isEndDateRequiredFilter !== undefined)
            url_ += "IsEndDateRequiredFilter=" + encodeURIComponent("" + isEndDateRequiredFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEventTypesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventTypesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEventTypesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class FamiliaritiesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param stateFilter (optional) 
     * @param maxCreatedFilter (optional) 
     * @param minCreatedFilter (optional) 
     * @param maxModifiedFilter (optional) 
     * @param minModifiedFilter (optional) 
     * @param maxCreatedByFilter (optional) 
     * @param minCreatedByFilter (optional) 
     * @param maxModifiedByFilter (optional) 
     * @param minModifiedByFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, titleFilter: string | undefined, stateFilter: number | undefined, maxCreatedFilter: moment.Moment | undefined, minCreatedFilter: moment.Moment | undefined, maxModifiedFilter: moment.Moment | undefined, minModifiedFilter: moment.Moment | undefined, maxCreatedByFilter: number | undefined, minCreatedByFilter: number | undefined, maxModifiedByFilter: number | undefined, minModifiedByFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetFamiliarityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Familiarities/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (maxCreatedFilter === null)
            throw new Error("The parameter 'maxCreatedFilter' cannot be null.");
        else if (maxCreatedFilter !== undefined)
            url_ += "MaxCreatedFilter=" + encodeURIComponent(maxCreatedFilter ? "" + maxCreatedFilter.toJSON() : "") + "&"; 
        if (minCreatedFilter === null)
            throw new Error("The parameter 'minCreatedFilter' cannot be null.");
        else if (minCreatedFilter !== undefined)
            url_ += "MinCreatedFilter=" + encodeURIComponent(minCreatedFilter ? "" + minCreatedFilter.toJSON() : "") + "&"; 
        if (maxModifiedFilter === null)
            throw new Error("The parameter 'maxModifiedFilter' cannot be null.");
        else if (maxModifiedFilter !== undefined)
            url_ += "MaxModifiedFilter=" + encodeURIComponent(maxModifiedFilter ? "" + maxModifiedFilter.toJSON() : "") + "&"; 
        if (minModifiedFilter === null)
            throw new Error("The parameter 'minModifiedFilter' cannot be null.");
        else if (minModifiedFilter !== undefined)
            url_ += "MinModifiedFilter=" + encodeURIComponent(minModifiedFilter ? "" + minModifiedFilter.toJSON() : "") + "&"; 
        if (maxCreatedByFilter === null)
            throw new Error("The parameter 'maxCreatedByFilter' cannot be null.");
        else if (maxCreatedByFilter !== undefined)
            url_ += "MaxCreatedByFilter=" + encodeURIComponent("" + maxCreatedByFilter) + "&"; 
        if (minCreatedByFilter === null)
            throw new Error("The parameter 'minCreatedByFilter' cannot be null.");
        else if (minCreatedByFilter !== undefined)
            url_ += "MinCreatedByFilter=" + encodeURIComponent("" + minCreatedByFilter) + "&"; 
        if (maxModifiedByFilter === null)
            throw new Error("The parameter 'maxModifiedByFilter' cannot be null.");
        else if (maxModifiedByFilter !== undefined)
            url_ += "MaxModifiedByFilter=" + encodeURIComponent("" + maxModifiedByFilter) + "&"; 
        if (minModifiedByFilter === null)
            throw new Error("The parameter 'minModifiedByFilter' cannot be null.");
        else if (minModifiedByFilter !== undefined)
            url_ += "MinModifiedByFilter=" + encodeURIComponent("" + minModifiedByFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetFamiliarityForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetFamiliarityForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetFamiliarityForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetFamiliarityForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetFamiliarityForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFamiliarityForView(id: number | undefined): Observable<GetFamiliarityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Familiarities/GetFamiliarityForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFamiliarityForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFamiliarityForView(<any>response_);
                } catch (e) {
                    return <Observable<GetFamiliarityForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetFamiliarityForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFamiliarityForView(response: HttpResponseBase): Observable<GetFamiliarityForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFamiliarityForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFamiliarityForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFamiliarityForEdit(id: number | undefined): Observable<GetFamiliarityForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Familiarities/GetFamiliarityForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFamiliarityForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFamiliarityForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetFamiliarityForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetFamiliarityForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetFamiliarityForEdit(response: HttpResponseBase): Observable<GetFamiliarityForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFamiliarityForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFamiliarityForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditFamiliarityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Familiarities/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Familiarities/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param stateFilter (optional) 
     * @param maxCreatedFilter (optional) 
     * @param minCreatedFilter (optional) 
     * @param maxModifiedFilter (optional) 
     * @param minModifiedFilter (optional) 
     * @param maxCreatedByFilter (optional) 
     * @param minCreatedByFilter (optional) 
     * @param maxModifiedByFilter (optional) 
     * @param minModifiedByFilter (optional) 
     * @return Success
     */
    getFamiliaritiesToExcel(filter: string | undefined, titleFilter: string | undefined, stateFilter: number | undefined, maxCreatedFilter: moment.Moment | undefined, minCreatedFilter: moment.Moment | undefined, maxModifiedFilter: moment.Moment | undefined, minModifiedFilter: moment.Moment | undefined, maxCreatedByFilter: number | undefined, minCreatedByFilter: number | undefined, maxModifiedByFilter: number | undefined, minModifiedByFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Familiarities/GetFamiliaritiesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (maxCreatedFilter === null)
            throw new Error("The parameter 'maxCreatedFilter' cannot be null.");
        else if (maxCreatedFilter !== undefined)
            url_ += "MaxCreatedFilter=" + encodeURIComponent(maxCreatedFilter ? "" + maxCreatedFilter.toJSON() : "") + "&"; 
        if (minCreatedFilter === null)
            throw new Error("The parameter 'minCreatedFilter' cannot be null.");
        else if (minCreatedFilter !== undefined)
            url_ += "MinCreatedFilter=" + encodeURIComponent(minCreatedFilter ? "" + minCreatedFilter.toJSON() : "") + "&"; 
        if (maxModifiedFilter === null)
            throw new Error("The parameter 'maxModifiedFilter' cannot be null.");
        else if (maxModifiedFilter !== undefined)
            url_ += "MaxModifiedFilter=" + encodeURIComponent(maxModifiedFilter ? "" + maxModifiedFilter.toJSON() : "") + "&"; 
        if (minModifiedFilter === null)
            throw new Error("The parameter 'minModifiedFilter' cannot be null.");
        else if (minModifiedFilter !== undefined)
            url_ += "MinModifiedFilter=" + encodeURIComponent(minModifiedFilter ? "" + minModifiedFilter.toJSON() : "") + "&"; 
        if (maxCreatedByFilter === null)
            throw new Error("The parameter 'maxCreatedByFilter' cannot be null.");
        else if (maxCreatedByFilter !== undefined)
            url_ += "MaxCreatedByFilter=" + encodeURIComponent("" + maxCreatedByFilter) + "&"; 
        if (minCreatedByFilter === null)
            throw new Error("The parameter 'minCreatedByFilter' cannot be null.");
        else if (minCreatedByFilter !== undefined)
            url_ += "MinCreatedByFilter=" + encodeURIComponent("" + minCreatedByFilter) + "&"; 
        if (maxModifiedByFilter === null)
            throw new Error("The parameter 'maxModifiedByFilter' cannot be null.");
        else if (maxModifiedByFilter !== undefined)
            url_ += "MaxModifiedByFilter=" + encodeURIComponent("" + maxModifiedByFilter) + "&"; 
        if (minModifiedByFilter === null)
            throw new Error("The parameter 'minModifiedByFilter' cannot be null.");
        else if (minModifiedByFilter !== undefined)
            url_ += "MinModifiedByFilter=" + encodeURIComponent("" + minModifiedByFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFamiliaritiesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFamiliaritiesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFamiliaritiesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class FamiliesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param maxRegisterDateFilter (optional) 
     * @param minRegisterDateFilter (optional) 
     * @param isOrphansFilter (optional) 
     * @param residenceTypeFilter (optional) 
     * @param codeFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param familyTypeRefFilter (optional) 
     * @param fileNumberFilter (optional) 
     * @param mobileNumberFilter (optional) 
     * @param identityCodeFilter (optional) 
     * @param minFamilyMemberCountFilter (optional) 
     * @param maxFamilyMemberCountFilter (optional) 
     * @param maxInactiveDateFilter (optional) 
     * @param minInactiveDateFilter (optional) 
     * @param statusFilter (optional) 
     * @param fullNameFilter (optional) 
     * @param isSadatFilter (optional) 
     * @param supportOrganizationIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, nameFilter: string | undefined, maxRegisterDateFilter: moment.Moment | undefined, minRegisterDateFilter: moment.Moment | undefined, isOrphansFilter: number | undefined, residenceTypeFilter: number | undefined, codeFilter: string | undefined, descriptionFilter: string | undefined, familyTypeRefFilter: number | undefined, fileNumberFilter: string | undefined, mobileNumberFilter: string | undefined, identityCodeFilter: string | undefined, minFamilyMemberCountFilter: number | undefined, maxFamilyMemberCountFilter: number | undefined, maxInactiveDateFilter: moment.Moment | undefined, minInactiveDateFilter: moment.Moment | undefined, statusFilter: number | undefined, fullNameFilter: string | undefined, isSadatFilter: number | undefined, supportOrganizationIdFilter: number[] | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetFamilyForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Families/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&"; 
        if (maxRegisterDateFilter === null)
            throw new Error("The parameter 'maxRegisterDateFilter' cannot be null.");
        else if (maxRegisterDateFilter !== undefined)
            url_ += "MaxRegisterDateFilter=" + encodeURIComponent(maxRegisterDateFilter ? "" + maxRegisterDateFilter.toJSON() : "") + "&"; 
        if (minRegisterDateFilter === null)
            throw new Error("The parameter 'minRegisterDateFilter' cannot be null.");
        else if (minRegisterDateFilter !== undefined)
            url_ += "MinRegisterDateFilter=" + encodeURIComponent(minRegisterDateFilter ? "" + minRegisterDateFilter.toJSON() : "") + "&"; 
        if (isOrphansFilter === null)
            throw new Error("The parameter 'isOrphansFilter' cannot be null.");
        else if (isOrphansFilter !== undefined)
            url_ += "IsOrphansFilter=" + encodeURIComponent("" + isOrphansFilter) + "&"; 
        if (residenceTypeFilter === null)
            throw new Error("The parameter 'residenceTypeFilter' cannot be null.");
        else if (residenceTypeFilter !== undefined)
            url_ += "ResidenceTypeFilter=" + encodeURIComponent("" + residenceTypeFilter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (familyTypeRefFilter === null)
            throw new Error("The parameter 'familyTypeRefFilter' cannot be null.");
        else if (familyTypeRefFilter !== undefined)
            url_ += "FamilyTypeRefFilter=" + encodeURIComponent("" + familyTypeRefFilter) + "&"; 
        if (fileNumberFilter === null)
            throw new Error("The parameter 'fileNumberFilter' cannot be null.");
        else if (fileNumberFilter !== undefined)
            url_ += "FileNumberFilter=" + encodeURIComponent("" + fileNumberFilter) + "&"; 
        if (mobileNumberFilter === null)
            throw new Error("The parameter 'mobileNumberFilter' cannot be null.");
        else if (mobileNumberFilter !== undefined)
            url_ += "MobileNumberFilter=" + encodeURIComponent("" + mobileNumberFilter) + "&"; 
        if (identityCodeFilter === null)
            throw new Error("The parameter 'identityCodeFilter' cannot be null.");
        else if (identityCodeFilter !== undefined)
            url_ += "IdentityCodeFilter=" + encodeURIComponent("" + identityCodeFilter) + "&"; 
        if (minFamilyMemberCountFilter === null)
            throw new Error("The parameter 'minFamilyMemberCountFilter' cannot be null.");
        else if (minFamilyMemberCountFilter !== undefined)
            url_ += "MinFamilyMemberCountFilter=" + encodeURIComponent("" + minFamilyMemberCountFilter) + "&"; 
        if (maxFamilyMemberCountFilter === null)
            throw new Error("The parameter 'maxFamilyMemberCountFilter' cannot be null.");
        else if (maxFamilyMemberCountFilter !== undefined)
            url_ += "MaxFamilyMemberCountFilter=" + encodeURIComponent("" + maxFamilyMemberCountFilter) + "&"; 
        if (maxInactiveDateFilter === null)
            throw new Error("The parameter 'maxInactiveDateFilter' cannot be null.");
        else if (maxInactiveDateFilter !== undefined)
            url_ += "MaxInactiveDateFilter=" + encodeURIComponent(maxInactiveDateFilter ? "" + maxInactiveDateFilter.toJSON() : "") + "&"; 
        if (minInactiveDateFilter === null)
            throw new Error("The parameter 'minInactiveDateFilter' cannot be null.");
        else if (minInactiveDateFilter !== undefined)
            url_ += "MinInactiveDateFilter=" + encodeURIComponent(minInactiveDateFilter ? "" + minInactiveDateFilter.toJSON() : "") + "&"; 
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (fullNameFilter === null)
            throw new Error("The parameter 'fullNameFilter' cannot be null.");
        else if (fullNameFilter !== undefined)
            url_ += "FullNameFilter=" + encodeURIComponent("" + fullNameFilter) + "&"; 
        if (isSadatFilter === null)
            throw new Error("The parameter 'isSadatFilter' cannot be null.");
        else if (isSadatFilter !== undefined)
            url_ += "IsSadatFilter=" + encodeURIComponent("" + isSadatFilter) + "&"; 
        if (supportOrganizationIdFilter === null)
            throw new Error("The parameter 'supportOrganizationIdFilter' cannot be null.");
        else if (supportOrganizationIdFilter !== undefined)
            supportOrganizationIdFilter && supportOrganizationIdFilter.forEach(item => { url_ += "SupportOrganizationIdFilter=" + encodeURIComponent("" + item) + "&"; });
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetFamilyForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetFamilyForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetFamilyForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetFamilyForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetFamilyForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFamilyForView(id: number | undefined): Observable<GetFamilyForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Families/GetFamilyForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFamilyForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFamilyForView(<any>response_);
                } catch (e) {
                    return <Observable<GetFamilyForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetFamilyForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFamilyForView(response: HttpResponseBase): Observable<GetFamilyForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFamilyForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFamilyForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFamilyForEdit(id: number | undefined): Observable<GetFamilyForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Families/GetFamilyForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFamilyForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFamilyForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetFamilyForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetFamilyForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetFamilyForEdit(response: HttpResponseBase): Observable<GetFamilyForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFamilyForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFamilyForEditOutput>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFamilyAndDependenciesForEdit(id: number | undefined): Observable<GetFamilyAndDependenciesForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Families/GetFamilyAndDependenciesForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFamilyAndDependenciesForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFamilyAndDependenciesForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetFamilyAndDependenciesForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetFamilyAndDependenciesForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetFamilyAndDependenciesForEdit(response: HttpResponseBase): Observable<GetFamilyAndDependenciesForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFamilyAndDependenciesForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFamilyAndDependenciesForEditOutput>(<any>null);
    }

    /**
     * @param fileNumber (optional) 
     * @return Success
     */
    familyFileNumberValidation(fileNumber: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Families/FamilyFileNumberValidation?";
        if (fileNumber === null)
            throw new Error("The parameter 'fileNumber' cannot be null.");
        else if (fileNumber !== undefined)
            url_ += "fileNumber=" + encodeURIComponent("" + fileNumber) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFamilyFileNumberValidation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFamilyFileNumberValidation(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processFamilyFileNumberValidation(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditFamilyAndDependencies(body: CreateOrEditFamilyAndDependenciesDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Families/CreateOrEditFamilyAndDependencies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditFamilyAndDependencies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditFamilyAndDependencies(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditFamilyAndDependencies(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditFamilyDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Families/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Families/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param maxRegisterDateFilter (optional) 
     * @param minRegisterDateFilter (optional) 
     * @param isOrphansFilter (optional) 
     * @param residenceTypeFilter (optional) 
     * @param codeFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param familyTypeRefFilter (optional) 
     * @param fileNumberFilter (optional) 
     * @param mobileNumberFilter (optional) 
     * @param identityCodeFilter (optional) 
     * @param minFamilyMemberCountFilter (optional) 
     * @param maxFamilyMemberCountFilter (optional) 
     * @param maxInactiveDateFilter (optional) 
     * @param minInactiveDateFilter (optional) 
     * @param statusFilter (optional) 
     * @param fullNameFilter (optional) 
     * @param isSadatFilter (optional) 
     * @param supportOrganizationIdFilter (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getFamiliesToExcel(filter: string | undefined, nameFilter: string | undefined, maxRegisterDateFilter: moment.Moment | undefined, minRegisterDateFilter: moment.Moment | undefined, isOrphansFilter: number | undefined, residenceTypeFilter: number | undefined, codeFilter: string | undefined, descriptionFilter: string | undefined, familyTypeRefFilter: number | undefined, fileNumberFilter: string | undefined, mobileNumberFilter: string | undefined, identityCodeFilter: string | undefined, minFamilyMemberCountFilter: number | undefined, maxFamilyMemberCountFilter: number | undefined, maxInactiveDateFilter: moment.Moment | undefined, minInactiveDateFilter: moment.Moment | undefined, statusFilter: number | undefined, fullNameFilter: string | undefined, isSadatFilter: number | undefined, supportOrganizationIdFilter: number[] | undefined, sorting: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Families/GetFamiliesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&"; 
        if (maxRegisterDateFilter === null)
            throw new Error("The parameter 'maxRegisterDateFilter' cannot be null.");
        else if (maxRegisterDateFilter !== undefined)
            url_ += "MaxRegisterDateFilter=" + encodeURIComponent(maxRegisterDateFilter ? "" + maxRegisterDateFilter.toJSON() : "") + "&"; 
        if (minRegisterDateFilter === null)
            throw new Error("The parameter 'minRegisterDateFilter' cannot be null.");
        else if (minRegisterDateFilter !== undefined)
            url_ += "MinRegisterDateFilter=" + encodeURIComponent(minRegisterDateFilter ? "" + minRegisterDateFilter.toJSON() : "") + "&"; 
        if (isOrphansFilter === null)
            throw new Error("The parameter 'isOrphansFilter' cannot be null.");
        else if (isOrphansFilter !== undefined)
            url_ += "IsOrphansFilter=" + encodeURIComponent("" + isOrphansFilter) + "&"; 
        if (residenceTypeFilter === null)
            throw new Error("The parameter 'residenceTypeFilter' cannot be null.");
        else if (residenceTypeFilter !== undefined)
            url_ += "ResidenceTypeFilter=" + encodeURIComponent("" + residenceTypeFilter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (familyTypeRefFilter === null)
            throw new Error("The parameter 'familyTypeRefFilter' cannot be null.");
        else if (familyTypeRefFilter !== undefined)
            url_ += "FamilyTypeRefFilter=" + encodeURIComponent("" + familyTypeRefFilter) + "&"; 
        if (fileNumberFilter === null)
            throw new Error("The parameter 'fileNumberFilter' cannot be null.");
        else if (fileNumberFilter !== undefined)
            url_ += "FileNumberFilter=" + encodeURIComponent("" + fileNumberFilter) + "&"; 
        if (mobileNumberFilter === null)
            throw new Error("The parameter 'mobileNumberFilter' cannot be null.");
        else if (mobileNumberFilter !== undefined)
            url_ += "MobileNumberFilter=" + encodeURIComponent("" + mobileNumberFilter) + "&"; 
        if (identityCodeFilter === null)
            throw new Error("The parameter 'identityCodeFilter' cannot be null.");
        else if (identityCodeFilter !== undefined)
            url_ += "IdentityCodeFilter=" + encodeURIComponent("" + identityCodeFilter) + "&"; 
        if (minFamilyMemberCountFilter === null)
            throw new Error("The parameter 'minFamilyMemberCountFilter' cannot be null.");
        else if (minFamilyMemberCountFilter !== undefined)
            url_ += "MinFamilyMemberCountFilter=" + encodeURIComponent("" + minFamilyMemberCountFilter) + "&"; 
        if (maxFamilyMemberCountFilter === null)
            throw new Error("The parameter 'maxFamilyMemberCountFilter' cannot be null.");
        else if (maxFamilyMemberCountFilter !== undefined)
            url_ += "MaxFamilyMemberCountFilter=" + encodeURIComponent("" + maxFamilyMemberCountFilter) + "&"; 
        if (maxInactiveDateFilter === null)
            throw new Error("The parameter 'maxInactiveDateFilter' cannot be null.");
        else if (maxInactiveDateFilter !== undefined)
            url_ += "MaxInactiveDateFilter=" + encodeURIComponent(maxInactiveDateFilter ? "" + maxInactiveDateFilter.toJSON() : "") + "&"; 
        if (minInactiveDateFilter === null)
            throw new Error("The parameter 'minInactiveDateFilter' cannot be null.");
        else if (minInactiveDateFilter !== undefined)
            url_ += "MinInactiveDateFilter=" + encodeURIComponent(minInactiveDateFilter ? "" + minInactiveDateFilter.toJSON() : "") + "&"; 
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (fullNameFilter === null)
            throw new Error("The parameter 'fullNameFilter' cannot be null.");
        else if (fullNameFilter !== undefined)
            url_ += "FullNameFilter=" + encodeURIComponent("" + fullNameFilter) + "&"; 
        if (isSadatFilter === null)
            throw new Error("The parameter 'isSadatFilter' cannot be null.");
        else if (isSadatFilter !== undefined)
            url_ += "IsSadatFilter=" + encodeURIComponent("" + isSadatFilter) + "&"; 
        if (supportOrganizationIdFilter === null)
            throw new Error("The parameter 'supportOrganizationIdFilter' cannot be null.");
        else if (supportOrganizationIdFilter !== undefined)
            supportOrganizationIdFilter && supportOrganizationIdFilter.forEach(item => { url_ += "SupportOrganizationIdFilter=" + encodeURIComponent("" + item) + "&"; });
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFamiliesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFamiliesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFamiliesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllSupportiveOrganizationForTableDropdown(): Observable<FamilySupportiveOrganizationsLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Families/GetAllSupportiveOrganizationForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSupportiveOrganizationForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSupportiveOrganizationForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<FamilySupportiveOrganizationsLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FamilySupportiveOrganizationsLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSupportiveOrganizationForTableDropdown(response: HttpResponseBase): Observable<FamilySupportiveOrganizationsLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FamilySupportiveOrganizationsLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FamilySupportiveOrganizationsLookupTableDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllFamilyTypeForTableDropdown(): Observable<FamilyFamilyTypesLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Families/GetAllFamilyTypeForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFamilyTypeForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFamilyTypeForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<FamilyFamilyTypesLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FamilyFamilyTypesLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllFamilyTypeForTableDropdown(response: HttpResponseBase): Observable<FamilyFamilyTypesLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FamilyFamilyTypesLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FamilyFamilyTypesLookupTableDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllBranchForTableDropdown(): Observable<FamilyBranchesLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Families/GetAllBranchForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBranchForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBranchForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<FamilyBranchesLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FamilyBranchesLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBranchForTableDropdown(response: HttpResponseBase): Observable<FamilyBranchesLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FamilyBranchesLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FamilyBranchesLookupTableDto[]>(<any>null);
    }

    /**
     * @param contactIds (optional) 
     * @return Success
     */
    getAllBankAccountForTableDropdown(contactIds: number[] | undefined): Observable<FamilyBankAccountsLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Families/GetAllBankAccountForTableDropdown?";
        if (contactIds === null)
            throw new Error("The parameter 'contactIds' cannot be null.");
        else if (contactIds !== undefined)
            contactIds && contactIds.forEach(item => { url_ += "contactIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBankAccountForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBankAccountForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<FamilyBankAccountsLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FamilyBankAccountsLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBankAccountForTableDropdown(response: HttpResponseBase): Observable<FamilyBankAccountsLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FamilyBankAccountsLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FamilyBankAccountsLookupTableDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllGroupSubgroupForDropdownTable(): Observable<FamilyGroupSubgroupLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Families/GetAllGroupSubgroupForDropdownTable";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllGroupSubgroupForDropdownTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllGroupSubgroupForDropdownTable(<any>response_);
                } catch (e) {
                    return <Observable<FamilyGroupSubgroupLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FamilyGroupSubgroupLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllGroupSubgroupForDropdownTable(response: HttpResponseBase): Observable<FamilyGroupSubgroupLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FamilyGroupSubgroupLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FamilyGroupSubgroupLookupTableDto[]>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllContactForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfFamilyContactLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Families/GetAllContactForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllContactForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllContactForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfFamilyContactLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfFamilyContactLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllContactForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfFamilyContactLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfFamilyContactLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfFamilyContactLookupTableDto>(<any>null);
    }

    /**
     * @return Success
     */
    checkExpiredFamily(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Families/CheckExpiredFamily";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckExpiredFamily(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckExpiredFamily(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCheckExpiredFamily(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param familyId (optional) 
     * @return Success
     */
    getFamilyReport(familyId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Families/GetFamilyReport?";
        if (familyId === null)
            throw new Error("The parameter 'familyId' cannot be null.");
        else if (familyId !== undefined)
            url_ += "familyId=" + encodeURIComponent("" + familyId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFamilyReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFamilyReport(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetFamilyReport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class FamilyIncomeOutcomesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxAmountFilter (optional) 
     * @param minAmountFilter (optional) 
     * @param maxStartDateFilter (optional) 
     * @param minStartDateFilter (optional) 
     * @param maxEndDateFilter (optional) 
     * @param minEndDateFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param familyCodeFilter (optional) 
     * @param familyIdFilter (optional) 
     * @param incomeOutcomeCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, maxAmountFilter: number | undefined, minAmountFilter: number | undefined, maxStartDateFilter: moment.Moment | undefined, minStartDateFilter: moment.Moment | undefined, maxEndDateFilter: moment.Moment | undefined, minEndDateFilter: moment.Moment | undefined, descriptionFilter: string | undefined, familyCodeFilter: string | undefined, familyIdFilter: number | undefined, incomeOutcomeCodeFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetFamilyIncomeOutcomeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/FamilyIncomeOutcomes/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxAmountFilter === null)
            throw new Error("The parameter 'maxAmountFilter' cannot be null.");
        else if (maxAmountFilter !== undefined)
            url_ += "MaxAmountFilter=" + encodeURIComponent("" + maxAmountFilter) + "&"; 
        if (minAmountFilter === null)
            throw new Error("The parameter 'minAmountFilter' cannot be null.");
        else if (minAmountFilter !== undefined)
            url_ += "MinAmountFilter=" + encodeURIComponent("" + minAmountFilter) + "&"; 
        if (maxStartDateFilter === null)
            throw new Error("The parameter 'maxStartDateFilter' cannot be null.");
        else if (maxStartDateFilter !== undefined)
            url_ += "MaxStartDateFilter=" + encodeURIComponent(maxStartDateFilter ? "" + maxStartDateFilter.toJSON() : "") + "&"; 
        if (minStartDateFilter === null)
            throw new Error("The parameter 'minStartDateFilter' cannot be null.");
        else if (minStartDateFilter !== undefined)
            url_ += "MinStartDateFilter=" + encodeURIComponent(minStartDateFilter ? "" + minStartDateFilter.toJSON() : "") + "&"; 
        if (maxEndDateFilter === null)
            throw new Error("The parameter 'maxEndDateFilter' cannot be null.");
        else if (maxEndDateFilter !== undefined)
            url_ += "MaxEndDateFilter=" + encodeURIComponent(maxEndDateFilter ? "" + maxEndDateFilter.toJSON() : "") + "&"; 
        if (minEndDateFilter === null)
            throw new Error("The parameter 'minEndDateFilter' cannot be null.");
        else if (minEndDateFilter !== undefined)
            url_ += "MinEndDateFilter=" + encodeURIComponent(minEndDateFilter ? "" + minEndDateFilter.toJSON() : "") + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (familyCodeFilter === null)
            throw new Error("The parameter 'familyCodeFilter' cannot be null.");
        else if (familyCodeFilter !== undefined)
            url_ += "FamilyCodeFilter=" + encodeURIComponent("" + familyCodeFilter) + "&"; 
        if (familyIdFilter === null)
            throw new Error("The parameter 'familyIdFilter' cannot be null.");
        else if (familyIdFilter !== undefined)
            url_ += "FamilyIdFilter=" + encodeURIComponent("" + familyIdFilter) + "&"; 
        if (incomeOutcomeCodeFilter === null)
            throw new Error("The parameter 'incomeOutcomeCodeFilter' cannot be null.");
        else if (incomeOutcomeCodeFilter !== undefined)
            url_ += "IncomeOutcomeCodeFilter=" + encodeURIComponent("" + incomeOutcomeCodeFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetFamilyIncomeOutcomeForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetFamilyIncomeOutcomeForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetFamilyIncomeOutcomeForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetFamilyIncomeOutcomeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetFamilyIncomeOutcomeForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFamilyIncomeOutcomeForView(id: number | undefined): Observable<GetFamilyIncomeOutcomeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/FamilyIncomeOutcomes/GetFamilyIncomeOutcomeForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFamilyIncomeOutcomeForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFamilyIncomeOutcomeForView(<any>response_);
                } catch (e) {
                    return <Observable<GetFamilyIncomeOutcomeForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetFamilyIncomeOutcomeForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFamilyIncomeOutcomeForView(response: HttpResponseBase): Observable<GetFamilyIncomeOutcomeForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFamilyIncomeOutcomeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFamilyIncomeOutcomeForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFamilyIncomeOutcomeForEdit(id: number | undefined): Observable<GetFamilyIncomeOutcomeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/FamilyIncomeOutcomes/GetFamilyIncomeOutcomeForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFamilyIncomeOutcomeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFamilyIncomeOutcomeForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetFamilyIncomeOutcomeForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetFamilyIncomeOutcomeForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetFamilyIncomeOutcomeForEdit(response: HttpResponseBase): Observable<GetFamilyIncomeOutcomeForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFamilyIncomeOutcomeForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFamilyIncomeOutcomeForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditFamilyIncomeOutcomeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FamilyIncomeOutcomes/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FamilyIncomeOutcomes/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param maxAmountFilter (optional) 
     * @param minAmountFilter (optional) 
     * @param maxStartDateFilter (optional) 
     * @param minStartDateFilter (optional) 
     * @param maxEndDateFilter (optional) 
     * @param minEndDateFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param familyCodeFilter (optional) 
     * @param incomeOutcomeCodeFilter (optional) 
     * @return Success
     */
    getFamilyIncomeOutcomesToExcel(filter: string | undefined, maxAmountFilter: number | undefined, minAmountFilter: number | undefined, maxStartDateFilter: moment.Moment | undefined, minStartDateFilter: moment.Moment | undefined, maxEndDateFilter: moment.Moment | undefined, minEndDateFilter: moment.Moment | undefined, descriptionFilter: string | undefined, familyCodeFilter: string | undefined, incomeOutcomeCodeFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/FamilyIncomeOutcomes/GetFamilyIncomeOutcomesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxAmountFilter === null)
            throw new Error("The parameter 'maxAmountFilter' cannot be null.");
        else if (maxAmountFilter !== undefined)
            url_ += "MaxAmountFilter=" + encodeURIComponent("" + maxAmountFilter) + "&"; 
        if (minAmountFilter === null)
            throw new Error("The parameter 'minAmountFilter' cannot be null.");
        else if (minAmountFilter !== undefined)
            url_ += "MinAmountFilter=" + encodeURIComponent("" + minAmountFilter) + "&"; 
        if (maxStartDateFilter === null)
            throw new Error("The parameter 'maxStartDateFilter' cannot be null.");
        else if (maxStartDateFilter !== undefined)
            url_ += "MaxStartDateFilter=" + encodeURIComponent(maxStartDateFilter ? "" + maxStartDateFilter.toJSON() : "") + "&"; 
        if (minStartDateFilter === null)
            throw new Error("The parameter 'minStartDateFilter' cannot be null.");
        else if (minStartDateFilter !== undefined)
            url_ += "MinStartDateFilter=" + encodeURIComponent(minStartDateFilter ? "" + minStartDateFilter.toJSON() : "") + "&"; 
        if (maxEndDateFilter === null)
            throw new Error("The parameter 'maxEndDateFilter' cannot be null.");
        else if (maxEndDateFilter !== undefined)
            url_ += "MaxEndDateFilter=" + encodeURIComponent(maxEndDateFilter ? "" + maxEndDateFilter.toJSON() : "") + "&"; 
        if (minEndDateFilter === null)
            throw new Error("The parameter 'minEndDateFilter' cannot be null.");
        else if (minEndDateFilter !== undefined)
            url_ += "MinEndDateFilter=" + encodeURIComponent(minEndDateFilter ? "" + minEndDateFilter.toJSON() : "") + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (familyCodeFilter === null)
            throw new Error("The parameter 'familyCodeFilter' cannot be null.");
        else if (familyCodeFilter !== undefined)
            url_ += "FamilyCodeFilter=" + encodeURIComponent("" + familyCodeFilter) + "&"; 
        if (incomeOutcomeCodeFilter === null)
            throw new Error("The parameter 'incomeOutcomeCodeFilter' cannot be null.");
        else if (incomeOutcomeCodeFilter !== undefined)
            url_ += "IncomeOutcomeCodeFilter=" + encodeURIComponent("" + incomeOutcomeCodeFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFamilyIncomeOutcomesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFamilyIncomeOutcomesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFamilyIncomeOutcomesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllFamilyForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfFamilyIncomeOutcomeFamilyLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/FamilyIncomeOutcomes/GetAllFamilyForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFamilyForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFamilyForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfFamilyIncomeOutcomeFamilyLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfFamilyIncomeOutcomeFamilyLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllFamilyForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfFamilyIncomeOutcomeFamilyLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfFamilyIncomeOutcomeFamilyLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfFamilyIncomeOutcomeFamilyLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllIncomeOutcomeForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfFamilyIncomeOutcomeIncomeOutcomeLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/FamilyIncomeOutcomes/GetAllIncomeOutcomeForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllIncomeOutcomeForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllIncomeOutcomeForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfFamilyIncomeOutcomeIncomeOutcomeLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfFamilyIncomeOutcomeIncomeOutcomeLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllIncomeOutcomeForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfFamilyIncomeOutcomeIncomeOutcomeLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfFamilyIncomeOutcomeIncomeOutcomeLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfFamilyIncomeOutcomeIncomeOutcomeLookupTableDto>(<any>null);
    }
}

@Injectable()
export class FamilyMembersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param notIsAliveFilter (optional) 
     * @param deathCauseFilter (optional) 
     * @param deathCauseExplanationFilter (optional) 
     * @param maxDeathDateFilter (optional) 
     * @param minDeathDateFilter (optional) 
     * @param insuranceTypeFilter (optional) 
     * @param familyMemberRelationFilter (optional) 
     * @param contactIdFilter (optional) 
     * @param otherRelationFilter (optional) 
     * @param familyNameFilter (optional) 
     * @param familyMembersRoleTitleFilter (optional) 
     * @param familyIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, notIsAliveFilter: number | undefined, deathCauseFilter: number | undefined, deathCauseExplanationFilter: string | undefined, maxDeathDateFilter: moment.Moment | undefined, minDeathDateFilter: moment.Moment | undefined, insuranceTypeFilter: number | undefined, familyMemberRelationFilter: number | undefined, contactIdFilter: number | undefined, otherRelationFilter: string | undefined, familyNameFilter: string | undefined, familyMembersRoleTitleFilter: string | undefined, familyIdFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetFamilyMemberForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/FamilyMembers/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (notIsAliveFilter === null)
            throw new Error("The parameter 'notIsAliveFilter' cannot be null.");
        else if (notIsAliveFilter !== undefined)
            url_ += "NotIsAliveFilter=" + encodeURIComponent("" + notIsAliveFilter) + "&"; 
        if (deathCauseFilter === null)
            throw new Error("The parameter 'deathCauseFilter' cannot be null.");
        else if (deathCauseFilter !== undefined)
            url_ += "DeathCauseFilter=" + encodeURIComponent("" + deathCauseFilter) + "&"; 
        if (deathCauseExplanationFilter === null)
            throw new Error("The parameter 'deathCauseExplanationFilter' cannot be null.");
        else if (deathCauseExplanationFilter !== undefined)
            url_ += "DeathCauseExplanationFilter=" + encodeURIComponent("" + deathCauseExplanationFilter) + "&"; 
        if (maxDeathDateFilter === null)
            throw new Error("The parameter 'maxDeathDateFilter' cannot be null.");
        else if (maxDeathDateFilter !== undefined)
            url_ += "MaxDeathDateFilter=" + encodeURIComponent(maxDeathDateFilter ? "" + maxDeathDateFilter.toJSON() : "") + "&"; 
        if (minDeathDateFilter === null)
            throw new Error("The parameter 'minDeathDateFilter' cannot be null.");
        else if (minDeathDateFilter !== undefined)
            url_ += "MinDeathDateFilter=" + encodeURIComponent(minDeathDateFilter ? "" + minDeathDateFilter.toJSON() : "") + "&"; 
        if (insuranceTypeFilter === null)
            throw new Error("The parameter 'insuranceTypeFilter' cannot be null.");
        else if (insuranceTypeFilter !== undefined)
            url_ += "InsuranceTypeFilter=" + encodeURIComponent("" + insuranceTypeFilter) + "&"; 
        if (familyMemberRelationFilter === null)
            throw new Error("The parameter 'familyMemberRelationFilter' cannot be null.");
        else if (familyMemberRelationFilter !== undefined)
            url_ += "FamilyMemberRelationFilter=" + encodeURIComponent("" + familyMemberRelationFilter) + "&"; 
        if (contactIdFilter === null)
            throw new Error("The parameter 'contactIdFilter' cannot be null.");
        else if (contactIdFilter !== undefined)
            url_ += "ContactIdFilter=" + encodeURIComponent("" + contactIdFilter) + "&"; 
        if (otherRelationFilter === null)
            throw new Error("The parameter 'otherRelationFilter' cannot be null.");
        else if (otherRelationFilter !== undefined)
            url_ += "OtherRelationFilter=" + encodeURIComponent("" + otherRelationFilter) + "&"; 
        if (familyNameFilter === null)
            throw new Error("The parameter 'familyNameFilter' cannot be null.");
        else if (familyNameFilter !== undefined)
            url_ += "FamilyNameFilter=" + encodeURIComponent("" + familyNameFilter) + "&"; 
        if (familyMembersRoleTitleFilter === null)
            throw new Error("The parameter 'familyMembersRoleTitleFilter' cannot be null.");
        else if (familyMembersRoleTitleFilter !== undefined)
            url_ += "FamilyMembersRoleTitleFilter=" + encodeURIComponent("" + familyMembersRoleTitleFilter) + "&"; 
        if (familyIdFilter === null)
            throw new Error("The parameter 'familyIdFilter' cannot be null.");
        else if (familyIdFilter !== undefined)
            url_ += "FamilyIdFilter=" + encodeURIComponent("" + familyIdFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetFamilyMemberForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetFamilyMemberForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetFamilyMemberForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetFamilyMemberForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetFamilyMemberForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFamilyMemberForView(id: number | undefined): Observable<GetFamilyMemberForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/FamilyMembers/GetFamilyMemberForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFamilyMemberForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFamilyMemberForView(<any>response_);
                } catch (e) {
                    return <Observable<GetFamilyMemberForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetFamilyMemberForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFamilyMemberForView(response: HttpResponseBase): Observable<GetFamilyMemberForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFamilyMemberForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFamilyMemberForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFamilyMemberForEdit(id: number | undefined): Observable<GetFamilyMemberForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/FamilyMembers/GetFamilyMemberForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFamilyMemberForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFamilyMemberForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetFamilyMemberForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetFamilyMemberForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetFamilyMemberForEdit(response: HttpResponseBase): Observable<GetFamilyMemberForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFamilyMemberForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFamilyMemberForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditFamilyMemberDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FamilyMembers/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FamilyMembers/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param maxRegisterDateFilter (optional) 
     * @param minRegisterDateFilter (optional) 
     * @param isOrphansFilter (optional) 
     * @param residenceTypeFilter (optional) 
     * @param codeFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param familyTypeRefFilter (optional) 
     * @param fileNumberFilter (optional) 
     * @param mobileNumberFilter (optional) 
     * @param identityCodeFilter (optional) 
     * @param minFamilyMemberCountFilter (optional) 
     * @param maxFamilyMemberCountFilter (optional) 
     * @param maxInactiveDateFilter (optional) 
     * @param minInactiveDateFilter (optional) 
     * @param statusFilter (optional) 
     * @param fullNameFilter (optional) 
     * @param isSadatFilter (optional) 
     * @param supportOrganizationIdFilter (optional) 
     * @return Success
     */
    getFamilyMembersToExcel(filter: string | undefined, nameFilter: string | undefined, maxRegisterDateFilter: moment.Moment | undefined, minRegisterDateFilter: moment.Moment | undefined, isOrphansFilter: number | undefined, residenceTypeFilter: number | undefined, codeFilter: string | undefined, descriptionFilter: string | undefined, familyTypeRefFilter: number | undefined, fileNumberFilter: string | undefined, mobileNumberFilter: string | undefined, identityCodeFilter: string | undefined, minFamilyMemberCountFilter: number | undefined, maxFamilyMemberCountFilter: number | undefined, maxInactiveDateFilter: moment.Moment | undefined, minInactiveDateFilter: moment.Moment | undefined, statusFilter: number | undefined, fullNameFilter: string | undefined, isSadatFilter: number | undefined, supportOrganizationIdFilter: number[] | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/FamilyMembers/GetFamilyMembersToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&"; 
        if (maxRegisterDateFilter === null)
            throw new Error("The parameter 'maxRegisterDateFilter' cannot be null.");
        else if (maxRegisterDateFilter !== undefined)
            url_ += "MaxRegisterDateFilter=" + encodeURIComponent(maxRegisterDateFilter ? "" + maxRegisterDateFilter.toJSON() : "") + "&"; 
        if (minRegisterDateFilter === null)
            throw new Error("The parameter 'minRegisterDateFilter' cannot be null.");
        else if (minRegisterDateFilter !== undefined)
            url_ += "MinRegisterDateFilter=" + encodeURIComponent(minRegisterDateFilter ? "" + minRegisterDateFilter.toJSON() : "") + "&"; 
        if (isOrphansFilter === null)
            throw new Error("The parameter 'isOrphansFilter' cannot be null.");
        else if (isOrphansFilter !== undefined)
            url_ += "IsOrphansFilter=" + encodeURIComponent("" + isOrphansFilter) + "&"; 
        if (residenceTypeFilter === null)
            throw new Error("The parameter 'residenceTypeFilter' cannot be null.");
        else if (residenceTypeFilter !== undefined)
            url_ += "ResidenceTypeFilter=" + encodeURIComponent("" + residenceTypeFilter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (familyTypeRefFilter === null)
            throw new Error("The parameter 'familyTypeRefFilter' cannot be null.");
        else if (familyTypeRefFilter !== undefined)
            url_ += "FamilyTypeRefFilter=" + encodeURIComponent("" + familyTypeRefFilter) + "&"; 
        if (fileNumberFilter === null)
            throw new Error("The parameter 'fileNumberFilter' cannot be null.");
        else if (fileNumberFilter !== undefined)
            url_ += "FileNumberFilter=" + encodeURIComponent("" + fileNumberFilter) + "&"; 
        if (mobileNumberFilter === null)
            throw new Error("The parameter 'mobileNumberFilter' cannot be null.");
        else if (mobileNumberFilter !== undefined)
            url_ += "MobileNumberFilter=" + encodeURIComponent("" + mobileNumberFilter) + "&"; 
        if (identityCodeFilter === null)
            throw new Error("The parameter 'identityCodeFilter' cannot be null.");
        else if (identityCodeFilter !== undefined)
            url_ += "IdentityCodeFilter=" + encodeURIComponent("" + identityCodeFilter) + "&"; 
        if (minFamilyMemberCountFilter === null)
            throw new Error("The parameter 'minFamilyMemberCountFilter' cannot be null.");
        else if (minFamilyMemberCountFilter !== undefined)
            url_ += "MinFamilyMemberCountFilter=" + encodeURIComponent("" + minFamilyMemberCountFilter) + "&"; 
        if (maxFamilyMemberCountFilter === null)
            throw new Error("The parameter 'maxFamilyMemberCountFilter' cannot be null.");
        else if (maxFamilyMemberCountFilter !== undefined)
            url_ += "MaxFamilyMemberCountFilter=" + encodeURIComponent("" + maxFamilyMemberCountFilter) + "&"; 
        if (maxInactiveDateFilter === null)
            throw new Error("The parameter 'maxInactiveDateFilter' cannot be null.");
        else if (maxInactiveDateFilter !== undefined)
            url_ += "MaxInactiveDateFilter=" + encodeURIComponent(maxInactiveDateFilter ? "" + maxInactiveDateFilter.toJSON() : "") + "&"; 
        if (minInactiveDateFilter === null)
            throw new Error("The parameter 'minInactiveDateFilter' cannot be null.");
        else if (minInactiveDateFilter !== undefined)
            url_ += "MinInactiveDateFilter=" + encodeURIComponent(minInactiveDateFilter ? "" + minInactiveDateFilter.toJSON() : "") + "&"; 
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (fullNameFilter === null)
            throw new Error("The parameter 'fullNameFilter' cannot be null.");
        else if (fullNameFilter !== undefined)
            url_ += "FullNameFilter=" + encodeURIComponent("" + fullNameFilter) + "&"; 
        if (isSadatFilter === null)
            throw new Error("The parameter 'isSadatFilter' cannot be null.");
        else if (isSadatFilter !== undefined)
            url_ += "IsSadatFilter=" + encodeURIComponent("" + isSadatFilter) + "&"; 
        if (supportOrganizationIdFilter === null)
            throw new Error("The parameter 'supportOrganizationIdFilter' cannot be null.");
        else if (supportOrganizationIdFilter !== undefined)
            supportOrganizationIdFilter && supportOrganizationIdFilter.forEach(item => { url_ += "SupportOrganizationIdFilter=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFamilyMembersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFamilyMembersToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFamilyMembersToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param isClient (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllFamilyForLookupTable(filter: string | undefined, isClient: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfFamilyMemberFamilyLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/FamilyMembers/GetAllFamilyForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (isClient === null)
            throw new Error("The parameter 'isClient' cannot be null.");
        else if (isClient !== undefined)
            url_ += "IsClient=" + encodeURIComponent("" + isClient) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFamilyForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFamilyForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfFamilyMemberFamilyLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfFamilyMemberFamilyLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllFamilyForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfFamilyMemberFamilyLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfFamilyMemberFamilyLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfFamilyMemberFamilyLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param isClient (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllFamilyMembersRoleForLookupTable(filter: string | undefined, isClient: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfFamilyMemberFamilyMembersRoleLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/FamilyMembers/GetAllFamilyMembersRoleForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (isClient === null)
            throw new Error("The parameter 'isClient' cannot be null.");
        else if (isClient !== undefined)
            url_ += "IsClient=" + encodeURIComponent("" + isClient) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFamilyMembersRoleForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFamilyMembersRoleForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfFamilyMemberFamilyMembersRoleLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfFamilyMemberFamilyMembersRoleLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllFamilyMembersRoleForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfFamilyMemberFamilyMembersRoleLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfFamilyMemberFamilyMembersRoleLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfFamilyMemberFamilyMembersRoleLookupTableDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllFamilyMembersRoleForTableDropdown(): Observable<FamilyMemberFamilyMembersRoleLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FamilyMembers/GetAllFamilyMembersRoleForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFamilyMembersRoleForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFamilyMembersRoleForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<FamilyMemberFamilyMembersRoleLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FamilyMemberFamilyMembersRoleLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllFamilyMembersRoleForTableDropdown(response: HttpResponseBase): Observable<FamilyMemberFamilyMembersRoleLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FamilyMemberFamilyMembersRoleLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FamilyMemberFamilyMembersRoleLookupTableDto[]>(<any>null);
    }

    /**
     * @param contactId (optional) 
     * @return Success
     */
    getFamilyMemberFamilyForContact(contactId: number | undefined): Observable<PagedResultDtoOfGetFamilyMemberFamilyForContactDto> {
        let url_ = this.baseUrl + "/api/services/app/FamilyMembers/GetFamilyMemberFamilyForContact?";
        if (contactId === null)
            throw new Error("The parameter 'contactId' cannot be null.");
        else if (contactId !== undefined)
            url_ += "contactId=" + encodeURIComponent("" + contactId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFamilyMemberFamilyForContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFamilyMemberFamilyForContact(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetFamilyMemberFamilyForContactDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetFamilyMemberFamilyForContactDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFamilyMemberFamilyForContact(response: HttpResponseBase): Observable<PagedResultDtoOfGetFamilyMemberFamilyForContactDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetFamilyMemberFamilyForContactDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetFamilyMemberFamilyForContactDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param isClient (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllContactForLookupTable(filter: string | undefined, isClient: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfFamilyMemberContactLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/FamilyMembers/GetAllContactForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (isClient === null)
            throw new Error("The parameter 'isClient' cannot be null.");
        else if (isClient !== undefined)
            url_ += "IsClient=" + encodeURIComponent("" + isClient) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllContactForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllContactForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfFamilyMemberContactLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfFamilyMemberContactLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllContactForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfFamilyMemberContactLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfFamilyMemberContactLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfFamilyMemberContactLookupTableDto>(<any>null);
    }

    /**
     * @return Success
     */
    checkExpiredFamilyMember(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FamilyMembers/CheckExpiredFamilyMember";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckExpiredFamilyMember(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckExpiredFamilyMember(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCheckExpiredFamilyMember(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class FamilyMembersRolesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param isPrimaryFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, titleFilter: string | undefined, isPrimaryFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetFamilyMembersRoleForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/FamilyMembersRoles/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (isPrimaryFilter === null)
            throw new Error("The parameter 'isPrimaryFilter' cannot be null.");
        else if (isPrimaryFilter !== undefined)
            url_ += "IsPrimaryFilter=" + encodeURIComponent("" + isPrimaryFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetFamilyMembersRoleForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetFamilyMembersRoleForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetFamilyMembersRoleForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetFamilyMembersRoleForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetFamilyMembersRoleForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFamilyMembersRoleForView(id: number | undefined): Observable<GetFamilyMembersRoleForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/FamilyMembersRoles/GetFamilyMembersRoleForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFamilyMembersRoleForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFamilyMembersRoleForView(<any>response_);
                } catch (e) {
                    return <Observable<GetFamilyMembersRoleForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetFamilyMembersRoleForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFamilyMembersRoleForView(response: HttpResponseBase): Observable<GetFamilyMembersRoleForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFamilyMembersRoleForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFamilyMembersRoleForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFamilyMembersRoleForEdit(id: number | undefined): Observable<GetFamilyMembersRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/FamilyMembersRoles/GetFamilyMembersRoleForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFamilyMembersRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFamilyMembersRoleForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetFamilyMembersRoleForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetFamilyMembersRoleForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetFamilyMembersRoleForEdit(response: HttpResponseBase): Observable<GetFamilyMembersRoleForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFamilyMembersRoleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFamilyMembersRoleForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditFamilyMembersRoleDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FamilyMembersRoles/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FamilyMembersRoles/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param isPrimaryFilter (optional) 
     * @return Success
     */
    getFamilyMembersRolesToExcel(filter: string | undefined, titleFilter: string | undefined, isPrimaryFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/FamilyMembersRoles/GetFamilyMembersRolesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (isPrimaryFilter === null)
            throw new Error("The parameter 'isPrimaryFilter' cannot be null.");
        else if (isPrimaryFilter !== undefined)
            url_ += "IsPrimaryFilter=" + encodeURIComponent("" + isPrimaryFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFamilyMembersRolesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFamilyMembersRolesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFamilyMembersRolesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class FamilySupportOrganizationsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param stateFilter (optional) 
     * @param fileCodeFilter (optional) 
     * @param familyNameFilter (optional) 
     * @param familyRefFilter (optional) 
     * @param supportiveOrganizationNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, stateFilter: number | undefined, fileCodeFilter: string | undefined, familyNameFilter: string | undefined, familyRefFilter: number | undefined, supportiveOrganizationNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetFamilySupportOrganizationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/FamilySupportOrganizations/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (fileCodeFilter === null)
            throw new Error("The parameter 'fileCodeFilter' cannot be null.");
        else if (fileCodeFilter !== undefined)
            url_ += "FileCodeFilter=" + encodeURIComponent("" + fileCodeFilter) + "&"; 
        if (familyNameFilter === null)
            throw new Error("The parameter 'familyNameFilter' cannot be null.");
        else if (familyNameFilter !== undefined)
            url_ += "FamilyNameFilter=" + encodeURIComponent("" + familyNameFilter) + "&"; 
        if (familyRefFilter === null)
            throw new Error("The parameter 'familyRefFilter' cannot be null.");
        else if (familyRefFilter !== undefined)
            url_ += "FamilyRefFilter=" + encodeURIComponent("" + familyRefFilter) + "&"; 
        if (supportiveOrganizationNameFilter === null)
            throw new Error("The parameter 'supportiveOrganizationNameFilter' cannot be null.");
        else if (supportiveOrganizationNameFilter !== undefined)
            url_ += "SupportiveOrganizationNameFilter=" + encodeURIComponent("" + supportiveOrganizationNameFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetFamilySupportOrganizationForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetFamilySupportOrganizationForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetFamilySupportOrganizationForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetFamilySupportOrganizationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetFamilySupportOrganizationForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFamilySupportOrganizationForView(id: number | undefined): Observable<GetFamilySupportOrganizationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/FamilySupportOrganizations/GetFamilySupportOrganizationForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFamilySupportOrganizationForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFamilySupportOrganizationForView(<any>response_);
                } catch (e) {
                    return <Observable<GetFamilySupportOrganizationForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetFamilySupportOrganizationForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFamilySupportOrganizationForView(response: HttpResponseBase): Observable<GetFamilySupportOrganizationForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFamilySupportOrganizationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFamilySupportOrganizationForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFamilySupportOrganizationForEdit(id: number | undefined): Observable<GetFamilySupportOrganizationForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/FamilySupportOrganizations/GetFamilySupportOrganizationForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFamilySupportOrganizationForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFamilySupportOrganizationForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetFamilySupportOrganizationForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetFamilySupportOrganizationForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetFamilySupportOrganizationForEdit(response: HttpResponseBase): Observable<GetFamilySupportOrganizationForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFamilySupportOrganizationForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFamilySupportOrganizationForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditFamilySupportOrganizationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FamilySupportOrganizations/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FamilySupportOrganizations/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param stateFilter (optional) 
     * @param fileCodeFilter (optional) 
     * @param familyNameFilter (optional) 
     * @param supportiveOrganizationNameFilter (optional) 
     * @return Success
     */
    getFamilySupportOrganizationsToExcel(filter: string | undefined, stateFilter: number | undefined, fileCodeFilter: string | undefined, familyNameFilter: string | undefined, supportiveOrganizationNameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/FamilySupportOrganizations/GetFamilySupportOrganizationsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (fileCodeFilter === null)
            throw new Error("The parameter 'fileCodeFilter' cannot be null.");
        else if (fileCodeFilter !== undefined)
            url_ += "FileCodeFilter=" + encodeURIComponent("" + fileCodeFilter) + "&"; 
        if (familyNameFilter === null)
            throw new Error("The parameter 'familyNameFilter' cannot be null.");
        else if (familyNameFilter !== undefined)
            url_ += "FamilyNameFilter=" + encodeURIComponent("" + familyNameFilter) + "&"; 
        if (supportiveOrganizationNameFilter === null)
            throw new Error("The parameter 'supportiveOrganizationNameFilter' cannot be null.");
        else if (supportiveOrganizationNameFilter !== undefined)
            url_ += "SupportiveOrganizationNameFilter=" + encodeURIComponent("" + supportiveOrganizationNameFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFamilySupportOrganizationsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFamilySupportOrganizationsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFamilySupportOrganizationsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllFamilyForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfFamilySupportOrganizationFamilyLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/FamilySupportOrganizations/GetAllFamilyForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFamilyForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFamilyForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfFamilySupportOrganizationFamilyLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfFamilySupportOrganizationFamilyLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllFamilyForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfFamilySupportOrganizationFamilyLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfFamilySupportOrganizationFamilyLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfFamilySupportOrganizationFamilyLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllSupportiveOrganizationForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfFamilySupportOrganizationSupportiveOrganizationLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/FamilySupportOrganizations/GetAllSupportiveOrganizationForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSupportiveOrganizationForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSupportiveOrganizationForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfFamilySupportOrganizationSupportiveOrganizationLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfFamilySupportOrganizationSupportiveOrganizationLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSupportiveOrganizationForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfFamilySupportOrganizationSupportiveOrganizationLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfFamilySupportOrganizationSupportiveOrganizationLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfFamilySupportOrganizationSupportiveOrganizationLookupTableDto>(<any>null);
    }
}

@Injectable()
export class FamilyTypesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param codeFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, titleFilter: string | undefined, codeFilter: number | undefined, descriptionFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetFamilyTypeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/FamilyTypes/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetFamilyTypeForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetFamilyTypeForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetFamilyTypeForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetFamilyTypeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetFamilyTypeForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFamilyTypeForView(id: number | undefined): Observable<GetFamilyTypeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/FamilyTypes/GetFamilyTypeForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFamilyTypeForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFamilyTypeForView(<any>response_);
                } catch (e) {
                    return <Observable<GetFamilyTypeForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetFamilyTypeForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFamilyTypeForView(response: HttpResponseBase): Observable<GetFamilyTypeForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFamilyTypeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFamilyTypeForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFamilyTypeForEdit(id: number | undefined): Observable<GetFamilyTypeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/FamilyTypes/GetFamilyTypeForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFamilyTypeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFamilyTypeForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetFamilyTypeForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetFamilyTypeForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetFamilyTypeForEdit(response: HttpResponseBase): Observable<GetFamilyTypeForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFamilyTypeForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFamilyTypeForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditFamilyTypeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FamilyTypes/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FamilyTypes/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param codeFilter (optional) 
     * @param descriptionFilter (optional) 
     * @return Success
     */
    getFamilyTypesToExcel(filter: string | undefined, titleFilter: string | undefined, codeFilter: number | undefined, descriptionFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/FamilyTypes/GetFamilyTypesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFamilyTypesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFamilyTypesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFamilyTypesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class FinancialYearsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param titleCodeFilter (optional) 
     * @param maxStartDateFilter (optional) 
     * @param minStartDateFilter (optional) 
     * @param maxEndDateFilter (optional) 
     * @param minEndDateFilter (optional) 
     * @param statusFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, titleCodeFilter: string | undefined, maxStartDateFilter: moment.Moment | undefined, minStartDateFilter: moment.Moment | undefined, maxEndDateFilter: moment.Moment | undefined, minEndDateFilter: moment.Moment | undefined, statusFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetFinancialYearForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/FinancialYears/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleCodeFilter === null)
            throw new Error("The parameter 'titleCodeFilter' cannot be null.");
        else if (titleCodeFilter !== undefined)
            url_ += "TitleCodeFilter=" + encodeURIComponent("" + titleCodeFilter) + "&"; 
        if (maxStartDateFilter === null)
            throw new Error("The parameter 'maxStartDateFilter' cannot be null.");
        else if (maxStartDateFilter !== undefined)
            url_ += "MaxStartDateFilter=" + encodeURIComponent(maxStartDateFilter ? "" + maxStartDateFilter.toJSON() : "") + "&"; 
        if (minStartDateFilter === null)
            throw new Error("The parameter 'minStartDateFilter' cannot be null.");
        else if (minStartDateFilter !== undefined)
            url_ += "MinStartDateFilter=" + encodeURIComponent(minStartDateFilter ? "" + minStartDateFilter.toJSON() : "") + "&"; 
        if (maxEndDateFilter === null)
            throw new Error("The parameter 'maxEndDateFilter' cannot be null.");
        else if (maxEndDateFilter !== undefined)
            url_ += "MaxEndDateFilter=" + encodeURIComponent(maxEndDateFilter ? "" + maxEndDateFilter.toJSON() : "") + "&"; 
        if (minEndDateFilter === null)
            throw new Error("The parameter 'minEndDateFilter' cannot be null.");
        else if (minEndDateFilter !== undefined)
            url_ += "MinEndDateFilter=" + encodeURIComponent(minEndDateFilter ? "" + minEndDateFilter.toJSON() : "") + "&"; 
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetFinancialYearForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetFinancialYearForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetFinancialYearForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetFinancialYearForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetFinancialYearForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFinancialYearForView(id: number | undefined): Observable<GetFinancialYearForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/FinancialYears/GetFinancialYearForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFinancialYearForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinancialYearForView(<any>response_);
                } catch (e) {
                    return <Observable<GetFinancialYearForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetFinancialYearForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFinancialYearForView(response: HttpResponseBase): Observable<GetFinancialYearForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFinancialYearForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFinancialYearForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFinancialYearForEdit(id: number | undefined): Observable<GetFinancialYearForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/FinancialYears/GetFinancialYearForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFinancialYearForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinancialYearForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetFinancialYearForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetFinancialYearForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetFinancialYearForEdit(response: HttpResponseBase): Observable<GetFinancialYearForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFinancialYearForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFinancialYearForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditFinancialYearDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FinancialYears/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FinancialYears/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param titleCodeFilter (optional) 
     * @param maxStartDateFilter (optional) 
     * @param minStartDateFilter (optional) 
     * @param maxEndDateFilter (optional) 
     * @param minEndDateFilter (optional) 
     * @param statusFilter (optional) 
     * @return Success
     */
    getFinancialYearsToExcel(filter: string | undefined, titleCodeFilter: string | undefined, maxStartDateFilter: moment.Moment | undefined, minStartDateFilter: moment.Moment | undefined, maxEndDateFilter: moment.Moment | undefined, minEndDateFilter: moment.Moment | undefined, statusFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/FinancialYears/GetFinancialYearsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleCodeFilter === null)
            throw new Error("The parameter 'titleCodeFilter' cannot be null.");
        else if (titleCodeFilter !== undefined)
            url_ += "TitleCodeFilter=" + encodeURIComponent("" + titleCodeFilter) + "&"; 
        if (maxStartDateFilter === null)
            throw new Error("The parameter 'maxStartDateFilter' cannot be null.");
        else if (maxStartDateFilter !== undefined)
            url_ += "MaxStartDateFilter=" + encodeURIComponent(maxStartDateFilter ? "" + maxStartDateFilter.toJSON() : "") + "&"; 
        if (minStartDateFilter === null)
            throw new Error("The parameter 'minStartDateFilter' cannot be null.");
        else if (minStartDateFilter !== undefined)
            url_ += "MinStartDateFilter=" + encodeURIComponent(minStartDateFilter ? "" + minStartDateFilter.toJSON() : "") + "&"; 
        if (maxEndDateFilter === null)
            throw new Error("The parameter 'maxEndDateFilter' cannot be null.");
        else if (maxEndDateFilter !== undefined)
            url_ += "MaxEndDateFilter=" + encodeURIComponent(maxEndDateFilter ? "" + maxEndDateFilter.toJSON() : "") + "&"; 
        if (minEndDateFilter === null)
            throw new Error("The parameter 'minEndDateFilter' cannot be null.");
        else if (minEndDateFilter !== undefined)
            url_ += "MinEndDateFilter=" + encodeURIComponent(minEndDateFilter ? "" + minEndDateFilter.toJSON() : "") + "&"; 
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFinancialYearsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinancialYearsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFinancialYearsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class FlowerCrownBranchsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxStockFilter (optional) 
     * @param minStockFilter (optional) 
     * @param isGenerallyUsedFilter (optional) 
     * @param branchNameFilter (optional) 
     * @param flowerCrownColorFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, maxStockFilter: number | undefined, minStockFilter: number | undefined, isGenerallyUsedFilter: number | undefined, branchNameFilter: string | undefined, flowerCrownColorFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetFlowerCrownBranchForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/FlowerCrownBranchs/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxStockFilter === null)
            throw new Error("The parameter 'maxStockFilter' cannot be null.");
        else if (maxStockFilter !== undefined)
            url_ += "MaxStockFilter=" + encodeURIComponent("" + maxStockFilter) + "&"; 
        if (minStockFilter === null)
            throw new Error("The parameter 'minStockFilter' cannot be null.");
        else if (minStockFilter !== undefined)
            url_ += "MinStockFilter=" + encodeURIComponent("" + minStockFilter) + "&"; 
        if (isGenerallyUsedFilter === null)
            throw new Error("The parameter 'isGenerallyUsedFilter' cannot be null.");
        else if (isGenerallyUsedFilter !== undefined)
            url_ += "IsGenerallyUsedFilter=" + encodeURIComponent("" + isGenerallyUsedFilter) + "&"; 
        if (branchNameFilter === null)
            throw new Error("The parameter 'branchNameFilter' cannot be null.");
        else if (branchNameFilter !== undefined)
            url_ += "BranchNameFilter=" + encodeURIComponent("" + branchNameFilter) + "&"; 
        if (flowerCrownColorFilter === null)
            throw new Error("The parameter 'flowerCrownColorFilter' cannot be null.");
        else if (flowerCrownColorFilter !== undefined)
            url_ += "FlowerCrownColorFilter=" + encodeURIComponent("" + flowerCrownColorFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetFlowerCrownBranchForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetFlowerCrownBranchForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetFlowerCrownBranchForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetFlowerCrownBranchForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetFlowerCrownBranchForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFlowerCrownBranchForView(id: number | undefined): Observable<GetFlowerCrownBranchForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/FlowerCrownBranchs/GetFlowerCrownBranchForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFlowerCrownBranchForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFlowerCrownBranchForView(<any>response_);
                } catch (e) {
                    return <Observable<GetFlowerCrownBranchForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetFlowerCrownBranchForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFlowerCrownBranchForView(response: HttpResponseBase): Observable<GetFlowerCrownBranchForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFlowerCrownBranchForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFlowerCrownBranchForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFlowerCrownBranchForEdit(id: number | undefined): Observable<GetFlowerCrownBranchForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/FlowerCrownBranchs/GetFlowerCrownBranchForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFlowerCrownBranchForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFlowerCrownBranchForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetFlowerCrownBranchForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetFlowerCrownBranchForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetFlowerCrownBranchForEdit(response: HttpResponseBase): Observable<GetFlowerCrownBranchForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFlowerCrownBranchForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFlowerCrownBranchForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditFlowerCrownBranchDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FlowerCrownBranchs/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FlowerCrownBranchs/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param maxStockFilter (optional) 
     * @param minStockFilter (optional) 
     * @param isGenerallyUsedFilter (optional) 
     * @param branchNameFilter (optional) 
     * @param flowerCrownColorFilter (optional) 
     * @return Success
     */
    getFlowerCrownBranchsToExcel(filter: string | undefined, maxStockFilter: number | undefined, minStockFilter: number | undefined, isGenerallyUsedFilter: number | undefined, branchNameFilter: string | undefined, flowerCrownColorFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/FlowerCrownBranchs/GetFlowerCrownBranchsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxStockFilter === null)
            throw new Error("The parameter 'maxStockFilter' cannot be null.");
        else if (maxStockFilter !== undefined)
            url_ += "MaxStockFilter=" + encodeURIComponent("" + maxStockFilter) + "&"; 
        if (minStockFilter === null)
            throw new Error("The parameter 'minStockFilter' cannot be null.");
        else if (minStockFilter !== undefined)
            url_ += "MinStockFilter=" + encodeURIComponent("" + minStockFilter) + "&"; 
        if (isGenerallyUsedFilter === null)
            throw new Error("The parameter 'isGenerallyUsedFilter' cannot be null.");
        else if (isGenerallyUsedFilter !== undefined)
            url_ += "IsGenerallyUsedFilter=" + encodeURIComponent("" + isGenerallyUsedFilter) + "&"; 
        if (branchNameFilter === null)
            throw new Error("The parameter 'branchNameFilter' cannot be null.");
        else if (branchNameFilter !== undefined)
            url_ += "BranchNameFilter=" + encodeURIComponent("" + branchNameFilter) + "&"; 
        if (flowerCrownColorFilter === null)
            throw new Error("The parameter 'flowerCrownColorFilter' cannot be null.");
        else if (flowerCrownColorFilter !== undefined)
            url_ += "FlowerCrownColorFilter=" + encodeURIComponent("" + flowerCrownColorFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFlowerCrownBranchsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFlowerCrownBranchsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFlowerCrownBranchsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllBranchForTableDropdown(): Observable<FlowerCrownBranchBranchLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FlowerCrownBranchs/GetAllBranchForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBranchForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBranchForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<FlowerCrownBranchBranchLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FlowerCrownBranchBranchLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBranchForTableDropdown(response: HttpResponseBase): Observable<FlowerCrownBranchBranchLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FlowerCrownBranchBranchLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FlowerCrownBranchBranchLookupTableDto[]>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllFlowerCrownForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfFlowerCrownBranchFlowerCrownLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/FlowerCrownBranchs/GetAllFlowerCrownForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFlowerCrownForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFlowerCrownForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfFlowerCrownBranchFlowerCrownLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfFlowerCrownBranchFlowerCrownLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllFlowerCrownForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfFlowerCrownBranchFlowerCrownLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfFlowerCrownBranchFlowerCrownLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfFlowerCrownBranchFlowerCrownLookupTableDto>(<any>null);
    }
}

@Injectable()
export class FlowerCrownsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxWidthFilter (optional) 
     * @param minWidthFilter (optional) 
     * @param maxLengthFilter (optional) 
     * @param minLengthFilter (optional) 
     * @param maxThicknessFilter (optional) 
     * @param minThicknessFilter (optional) 
     * @param isReversibleFilter (optional) 
     * @param colorFilter (optional) 
     * @param maxSecondPriceFilter (optional) 
     * @param minSecondPriceFilter (optional) 
     * @param maxThirdPriceFilter (optional) 
     * @param minThirdPriceFilter (optional) 
     * @param planConstTitleFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, maxWidthFilter: number | undefined, minWidthFilter: number | undefined, maxLengthFilter: number | undefined, minLengthFilter: number | undefined, maxThicknessFilter: number | undefined, minThicknessFilter: number | undefined, isReversibleFilter: number | undefined, colorFilter: string | undefined, maxSecondPriceFilter: number | undefined, minSecondPriceFilter: number | undefined, maxThirdPriceFilter: number | undefined, minThirdPriceFilter: number | undefined, planConstTitleFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetFlowerCrownForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/FlowerCrowns/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxWidthFilter === null)
            throw new Error("The parameter 'maxWidthFilter' cannot be null.");
        else if (maxWidthFilter !== undefined)
            url_ += "MaxWidthFilter=" + encodeURIComponent("" + maxWidthFilter) + "&"; 
        if (minWidthFilter === null)
            throw new Error("The parameter 'minWidthFilter' cannot be null.");
        else if (minWidthFilter !== undefined)
            url_ += "MinWidthFilter=" + encodeURIComponent("" + minWidthFilter) + "&"; 
        if (maxLengthFilter === null)
            throw new Error("The parameter 'maxLengthFilter' cannot be null.");
        else if (maxLengthFilter !== undefined)
            url_ += "MaxLengthFilter=" + encodeURIComponent("" + maxLengthFilter) + "&"; 
        if (minLengthFilter === null)
            throw new Error("The parameter 'minLengthFilter' cannot be null.");
        else if (minLengthFilter !== undefined)
            url_ += "MinLengthFilter=" + encodeURIComponent("" + minLengthFilter) + "&"; 
        if (maxThicknessFilter === null)
            throw new Error("The parameter 'maxThicknessFilter' cannot be null.");
        else if (maxThicknessFilter !== undefined)
            url_ += "MaxThicknessFilter=" + encodeURIComponent("" + maxThicknessFilter) + "&"; 
        if (minThicknessFilter === null)
            throw new Error("The parameter 'minThicknessFilter' cannot be null.");
        else if (minThicknessFilter !== undefined)
            url_ += "MinThicknessFilter=" + encodeURIComponent("" + minThicknessFilter) + "&"; 
        if (isReversibleFilter === null)
            throw new Error("The parameter 'isReversibleFilter' cannot be null.");
        else if (isReversibleFilter !== undefined)
            url_ += "IsReversibleFilter=" + encodeURIComponent("" + isReversibleFilter) + "&"; 
        if (colorFilter === null)
            throw new Error("The parameter 'colorFilter' cannot be null.");
        else if (colorFilter !== undefined)
            url_ += "ColorFilter=" + encodeURIComponent("" + colorFilter) + "&"; 
        if (maxSecondPriceFilter === null)
            throw new Error("The parameter 'maxSecondPriceFilter' cannot be null.");
        else if (maxSecondPriceFilter !== undefined)
            url_ += "MaxSecondPriceFilter=" + encodeURIComponent("" + maxSecondPriceFilter) + "&"; 
        if (minSecondPriceFilter === null)
            throw new Error("The parameter 'minSecondPriceFilter' cannot be null.");
        else if (minSecondPriceFilter !== undefined)
            url_ += "MinSecondPriceFilter=" + encodeURIComponent("" + minSecondPriceFilter) + "&"; 
        if (maxThirdPriceFilter === null)
            throw new Error("The parameter 'maxThirdPriceFilter' cannot be null.");
        else if (maxThirdPriceFilter !== undefined)
            url_ += "MaxThirdPriceFilter=" + encodeURIComponent("" + maxThirdPriceFilter) + "&"; 
        if (minThirdPriceFilter === null)
            throw new Error("The parameter 'minThirdPriceFilter' cannot be null.");
        else if (minThirdPriceFilter !== undefined)
            url_ += "MinThirdPriceFilter=" + encodeURIComponent("" + minThirdPriceFilter) + "&"; 
        if (planConstTitleFilter === null)
            throw new Error("The parameter 'planConstTitleFilter' cannot be null.");
        else if (planConstTitleFilter !== undefined)
            url_ += "PlanConstTitleFilter=" + encodeURIComponent("" + planConstTitleFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetFlowerCrownForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetFlowerCrownForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetFlowerCrownForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetFlowerCrownForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetFlowerCrownForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFlowerCrownForView(id: number | undefined): Observable<GetFlowerCrownForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/FlowerCrowns/GetFlowerCrownForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFlowerCrownForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFlowerCrownForView(<any>response_);
                } catch (e) {
                    return <Observable<GetFlowerCrownForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetFlowerCrownForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFlowerCrownForView(response: HttpResponseBase): Observable<GetFlowerCrownForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFlowerCrownForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFlowerCrownForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFlowerCrownForEdit(id: number | undefined): Observable<GetFlowerCrownForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/FlowerCrowns/GetFlowerCrownForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFlowerCrownForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFlowerCrownForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetFlowerCrownForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetFlowerCrownForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetFlowerCrownForEdit(response: HttpResponseBase): Observable<GetFlowerCrownForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFlowerCrownForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFlowerCrownForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditFlowerCrownDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FlowerCrowns/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FlowerCrowns/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param maxWidthFilter (optional) 
     * @param minWidthFilter (optional) 
     * @param maxLengthFilter (optional) 
     * @param minLengthFilter (optional) 
     * @param maxThicknessFilter (optional) 
     * @param minThicknessFilter (optional) 
     * @param isReversibleFilter (optional) 
     * @param colorFilter (optional) 
     * @param maxSecondPriceFilter (optional) 
     * @param minSecondPriceFilter (optional) 
     * @param maxThirdPriceFilter (optional) 
     * @param minThirdPriceFilter (optional) 
     * @param planConstTitleFilter (optional) 
     * @return Success
     */
    getFlowerCrownsToExcel(filter: string | undefined, maxWidthFilter: number | undefined, minWidthFilter: number | undefined, maxLengthFilter: number | undefined, minLengthFilter: number | undefined, maxThicknessFilter: number | undefined, minThicknessFilter: number | undefined, isReversibleFilter: number | undefined, colorFilter: string | undefined, maxSecondPriceFilter: number | undefined, minSecondPriceFilter: number | undefined, maxThirdPriceFilter: number | undefined, minThirdPriceFilter: number | undefined, planConstTitleFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/FlowerCrowns/GetFlowerCrownsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxWidthFilter === null)
            throw new Error("The parameter 'maxWidthFilter' cannot be null.");
        else if (maxWidthFilter !== undefined)
            url_ += "MaxWidthFilter=" + encodeURIComponent("" + maxWidthFilter) + "&"; 
        if (minWidthFilter === null)
            throw new Error("The parameter 'minWidthFilter' cannot be null.");
        else if (minWidthFilter !== undefined)
            url_ += "MinWidthFilter=" + encodeURIComponent("" + minWidthFilter) + "&"; 
        if (maxLengthFilter === null)
            throw new Error("The parameter 'maxLengthFilter' cannot be null.");
        else if (maxLengthFilter !== undefined)
            url_ += "MaxLengthFilter=" + encodeURIComponent("" + maxLengthFilter) + "&"; 
        if (minLengthFilter === null)
            throw new Error("The parameter 'minLengthFilter' cannot be null.");
        else if (minLengthFilter !== undefined)
            url_ += "MinLengthFilter=" + encodeURIComponent("" + minLengthFilter) + "&"; 
        if (maxThicknessFilter === null)
            throw new Error("The parameter 'maxThicknessFilter' cannot be null.");
        else if (maxThicknessFilter !== undefined)
            url_ += "MaxThicknessFilter=" + encodeURIComponent("" + maxThicknessFilter) + "&"; 
        if (minThicknessFilter === null)
            throw new Error("The parameter 'minThicknessFilter' cannot be null.");
        else if (minThicknessFilter !== undefined)
            url_ += "MinThicknessFilter=" + encodeURIComponent("" + minThicknessFilter) + "&"; 
        if (isReversibleFilter === null)
            throw new Error("The parameter 'isReversibleFilter' cannot be null.");
        else if (isReversibleFilter !== undefined)
            url_ += "IsReversibleFilter=" + encodeURIComponent("" + isReversibleFilter) + "&"; 
        if (colorFilter === null)
            throw new Error("The parameter 'colorFilter' cannot be null.");
        else if (colorFilter !== undefined)
            url_ += "ColorFilter=" + encodeURIComponent("" + colorFilter) + "&"; 
        if (maxSecondPriceFilter === null)
            throw new Error("The parameter 'maxSecondPriceFilter' cannot be null.");
        else if (maxSecondPriceFilter !== undefined)
            url_ += "MaxSecondPriceFilter=" + encodeURIComponent("" + maxSecondPriceFilter) + "&"; 
        if (minSecondPriceFilter === null)
            throw new Error("The parameter 'minSecondPriceFilter' cannot be null.");
        else if (minSecondPriceFilter !== undefined)
            url_ += "MinSecondPriceFilter=" + encodeURIComponent("" + minSecondPriceFilter) + "&"; 
        if (maxThirdPriceFilter === null)
            throw new Error("The parameter 'maxThirdPriceFilter' cannot be null.");
        else if (maxThirdPriceFilter !== undefined)
            url_ += "MaxThirdPriceFilter=" + encodeURIComponent("" + maxThirdPriceFilter) + "&"; 
        if (minThirdPriceFilter === null)
            throw new Error("The parameter 'minThirdPriceFilter' cannot be null.");
        else if (minThirdPriceFilter !== undefined)
            url_ += "MinThirdPriceFilter=" + encodeURIComponent("" + minThirdPriceFilter) + "&"; 
        if (planConstTitleFilter === null)
            throw new Error("The parameter 'planConstTitleFilter' cannot be null.");
        else if (planConstTitleFilter !== undefined)
            url_ += "PlanConstTitleFilter=" + encodeURIComponent("" + planConstTitleFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFlowerCrownsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFlowerCrownsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFlowerCrownsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllPlanConstForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfFlowerCrownPlanConstLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/FlowerCrowns/GetAllPlanConstForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPlanConstForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPlanConstForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfFlowerCrownPlanConstLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfFlowerCrownPlanConstLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPlanConstForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfFlowerCrownPlanConstLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfFlowerCrownPlanConstLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfFlowerCrownPlanConstLookupTableDto>(<any>null);
    }
}

@Injectable()
export class FollowUpsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param typeFilter (optional) 
     * @param billCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, typeFilter: number | undefined, billCodeFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetFollowUpForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/FollowUps/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (typeFilter === null)
            throw new Error("The parameter 'typeFilter' cannot be null.");
        else if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&"; 
        if (billCodeFilter === null)
            throw new Error("The parameter 'billCodeFilter' cannot be null.");
        else if (billCodeFilter !== undefined)
            url_ += "BillCodeFilter=" + encodeURIComponent("" + billCodeFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetFollowUpForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetFollowUpForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetFollowUpForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetFollowUpForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetFollowUpForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFollowUpForView(id: number | undefined): Observable<GetFollowUpForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/FollowUps/GetFollowUpForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFollowUpForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFollowUpForView(<any>response_);
                } catch (e) {
                    return <Observable<GetFollowUpForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetFollowUpForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFollowUpForView(response: HttpResponseBase): Observable<GetFollowUpForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFollowUpForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFollowUpForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFollowUpForEdit(id: number | undefined): Observable<GetFollowUpForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/FollowUps/GetFollowUpForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFollowUpForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFollowUpForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetFollowUpForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetFollowUpForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetFollowUpForEdit(response: HttpResponseBase): Observable<GetFollowUpForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFollowUpForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFollowUpForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditCustom(body: CreateOrEditFollowUpDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FollowUps/CreateOrEditCustom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditCustom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditCustom(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditCustom(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createFollowUpAndBillSlaughteredForSacrifice(body: CreateOrEditFollowUpForSacrificeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FollowUps/CreateFollowUpAndBillSlaughteredForSacrifice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFollowUpAndBillSlaughteredForSacrifice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFollowUpAndBillSlaughteredForSacrifice(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateFollowUpAndBillSlaughteredForSacrifice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditFollowUpDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FollowUps/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createRange(body: CreateOrEditFollowUpDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FollowUps/CreateRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRange(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateRange(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createSimple(body: CreateOrEditFollowUpDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FollowUps/CreateSimple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSimple(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSimple(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateSimple(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FollowUps/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param typeFilter (optional) 
     * @param billCodeFilter (optional) 
     * @return Success
     */
    getFollowUpsToExcel(filter: string | undefined, typeFilter: number | undefined, billCodeFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/FollowUps/GetFollowUpsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (typeFilter === null)
            throw new Error("The parameter 'typeFilter' cannot be null.");
        else if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&"; 
        if (billCodeFilter === null)
            throw new Error("The parameter 'billCodeFilter' cannot be null.");
        else if (billCodeFilter !== undefined)
            url_ += "BillCodeFilter=" + encodeURIComponent("" + billCodeFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFollowUpsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFollowUpsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFollowUpsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllBillForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfFollowUpBillLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/FollowUps/GetAllBillForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBillForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBillForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfFollowUpBillLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfFollowUpBillLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBillForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfFollowUpBillLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfFollowUpBillLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfFollowUpBillLookupTableDto>(<any>null);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    getBillFollowUpForShop(code: string | undefined): Observable<GetBillFollowUpDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FollowUps/GetBillFollowUpForShop?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillFollowUpForShop(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillFollowUpForShop(<any>response_);
                } catch (e) {
                    return <Observable<GetBillFollowUpDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBillFollowUpDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetBillFollowUpForShop(response: HttpResponseBase): Observable<GetBillFollowUpDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetBillFollowUpDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBillFollowUpDto[]>(<any>null);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    getBillFollowUp(code: string | undefined): Observable<GetBillFollowUpDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FollowUps/GetBillFollowUp?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillFollowUp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillFollowUp(<any>response_);
                } catch (e) {
                    return <Observable<GetBillFollowUpDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBillFollowUpDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetBillFollowUp(response: HttpResponseBase): Observable<GetBillFollowUpDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetBillFollowUpDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBillFollowUpDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getFollowUpsCount(): Observable<GetFollowUpsCountDto> {
        let url_ = this.baseUrl + "/api/services/app/FollowUps/GetFollowUpsCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFollowUpsCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFollowUpsCount(<any>response_);
                } catch (e) {
                    return <Observable<GetFollowUpsCountDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetFollowUpsCountDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFollowUpsCount(response: HttpResponseBase): Observable<GetFollowUpsCountDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFollowUpsCountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFollowUpsCountDto>(<any>null);
    }

    /**
     * @param today (optional) 
     * @param billCode (optional) 
     * @param permission (optional) 
     * @param filter (optional) 
     * @param branchFilter (optional) 
     * @param billBranchFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxStartTimeFilter (optional) 
     * @param minStartTimeFilter (optional) 
     * @param ceremonyIdFilter (optional) 
     * @param emp (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllFollowUpsForStaff(today: boolean | undefined, billCode: string | undefined, permission: string | undefined, filter: string | undefined, branchFilter: number[] | undefined, billBranchFilter: number[] | undefined, statusFilter: number[] | undefined, maxStartTimeFilter: moment.Moment | undefined, minStartTimeFilter: moment.Moment | undefined, ceremonyIdFilter: number | undefined, emp: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAllFollowUpsForStaffDto> {
        let url_ = this.baseUrl + "/api/services/app/FollowUps/GetAllFollowUpsForStaff?";
        if (today === null)
            throw new Error("The parameter 'today' cannot be null.");
        else if (today !== undefined)
            url_ += "Today=" + encodeURIComponent("" + today) + "&"; 
        if (billCode === null)
            throw new Error("The parameter 'billCode' cannot be null.");
        else if (billCode !== undefined)
            url_ += "BillCode=" + encodeURIComponent("" + billCode) + "&"; 
        if (permission === null)
            throw new Error("The parameter 'permission' cannot be null.");
        else if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&"; 
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (branchFilter === null)
            throw new Error("The parameter 'branchFilter' cannot be null.");
        else if (branchFilter !== undefined)
            branchFilter && branchFilter.forEach(item => { url_ += "BranchFilter=" + encodeURIComponent("" + item) + "&"; });
        if (billBranchFilter === null)
            throw new Error("The parameter 'billBranchFilter' cannot be null.");
        else if (billBranchFilter !== undefined)
            billBranchFilter && billBranchFilter.forEach(item => { url_ += "BillBranchFilter=" + encodeURIComponent("" + item) + "&"; });
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            statusFilter && statusFilter.forEach(item => { url_ += "StatusFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxStartTimeFilter === null)
            throw new Error("The parameter 'maxStartTimeFilter' cannot be null.");
        else if (maxStartTimeFilter !== undefined)
            url_ += "MaxStartTimeFilter=" + encodeURIComponent(maxStartTimeFilter ? "" + maxStartTimeFilter.toJSON() : "") + "&"; 
        if (minStartTimeFilter === null)
            throw new Error("The parameter 'minStartTimeFilter' cannot be null.");
        else if (minStartTimeFilter !== undefined)
            url_ += "MinStartTimeFilter=" + encodeURIComponent(minStartTimeFilter ? "" + minStartTimeFilter.toJSON() : "") + "&"; 
        if (ceremonyIdFilter === null)
            throw new Error("The parameter 'ceremonyIdFilter' cannot be null.");
        else if (ceremonyIdFilter !== undefined)
            url_ += "CeremonyIdFilter=" + encodeURIComponent("" + ceremonyIdFilter) + "&"; 
        if (emp === null)
            throw new Error("The parameter 'emp' cannot be null.");
        else if (emp !== undefined)
            url_ += "Emp=" + encodeURIComponent("" + emp) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFollowUpsForStaff(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFollowUpsForStaff(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAllFollowUpsForStaffDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAllFollowUpsForStaffDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllFollowUpsForStaff(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllFollowUpsForStaffDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAllFollowUpsForStaffDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAllFollowUpsForStaffDto>(<any>null);
    }

    /**
     * @param today (optional) 
     * @param billCode (optional) 
     * @param permission (optional) 
     * @param filter (optional) 
     * @param branchFilter (optional) 
     * @param billBranchFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxStartTimeFilter (optional) 
     * @param minStartTimeFilter (optional) 
     * @param ceremonyIdFilter (optional) 
     * @param emp (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportFollowUpsForStaff(today: boolean | undefined, billCode: string | undefined, permission: string | undefined, filter: string | undefined, branchFilter: number[] | undefined, billBranchFilter: number[] | undefined, statusFilter: number[] | undefined, maxStartTimeFilter: moment.Moment | undefined, minStartTimeFilter: moment.Moment | undefined, ceremonyIdFilter: number | undefined, emp: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetDailyFlowerReportOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/FollowUps/GetReportFollowUpsForStaff?";
        if (today === null)
            throw new Error("The parameter 'today' cannot be null.");
        else if (today !== undefined)
            url_ += "Today=" + encodeURIComponent("" + today) + "&"; 
        if (billCode === null)
            throw new Error("The parameter 'billCode' cannot be null.");
        else if (billCode !== undefined)
            url_ += "BillCode=" + encodeURIComponent("" + billCode) + "&"; 
        if (permission === null)
            throw new Error("The parameter 'permission' cannot be null.");
        else if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&"; 
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (branchFilter === null)
            throw new Error("The parameter 'branchFilter' cannot be null.");
        else if (branchFilter !== undefined)
            branchFilter && branchFilter.forEach(item => { url_ += "BranchFilter=" + encodeURIComponent("" + item) + "&"; });
        if (billBranchFilter === null)
            throw new Error("The parameter 'billBranchFilter' cannot be null.");
        else if (billBranchFilter !== undefined)
            billBranchFilter && billBranchFilter.forEach(item => { url_ += "BillBranchFilter=" + encodeURIComponent("" + item) + "&"; });
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            statusFilter && statusFilter.forEach(item => { url_ += "StatusFilter=" + encodeURIComponent("" + item) + "&"; });
        if (maxStartTimeFilter === null)
            throw new Error("The parameter 'maxStartTimeFilter' cannot be null.");
        else if (maxStartTimeFilter !== undefined)
            url_ += "MaxStartTimeFilter=" + encodeURIComponent(maxStartTimeFilter ? "" + maxStartTimeFilter.toJSON() : "") + "&"; 
        if (minStartTimeFilter === null)
            throw new Error("The parameter 'minStartTimeFilter' cannot be null.");
        else if (minStartTimeFilter !== undefined)
            url_ += "MinStartTimeFilter=" + encodeURIComponent(minStartTimeFilter ? "" + minStartTimeFilter.toJSON() : "") + "&"; 
        if (ceremonyIdFilter === null)
            throw new Error("The parameter 'ceremonyIdFilter' cannot be null.");
        else if (ceremonyIdFilter !== undefined)
            url_ += "CeremonyIdFilter=" + encodeURIComponent("" + ceremonyIdFilter) + "&"; 
        if (emp === null)
            throw new Error("The parameter 'emp' cannot be null.");
        else if (emp !== undefined)
            url_ += "Emp=" + encodeURIComponent("" + emp) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportFollowUpsForStaff(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportFollowUpsForStaff(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetDailyFlowerReportOutputDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetDailyFlowerReportOutputDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetReportFollowUpsForStaff(response: HttpResponseBase): Observable<PagedResultDtoOfGetDailyFlowerReportOutputDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetDailyFlowerReportOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetDailyFlowerReportOutputDto>(<any>null);
    }

    /**
     * @return Success
     */
    refreshFollowUpCache(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FollowUps/RefreshFollowUpCache";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshFollowUpCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshFollowUpCache(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRefreshFollowUpCache(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param tenantId (optional) 
     * @param followUpIds (optional) 
     * @return Success
     */
    updateGetAllFollowUpsForStaffCache(tenantId: number | undefined, methodName: MethodNameForCache, followUpIds: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FollowUps/UpdateGetAllFollowUpsForStaffCache?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (methodName === undefined || methodName === null)
            throw new Error("The parameter 'methodName' must be defined and cannot be null.");
        else
            url_ += "methodName=" + encodeURIComponent("" + methodName) + "&"; 
        if (followUpIds === null)
            throw new Error("The parameter 'followUpIds' cannot be null.");
        else if (followUpIds !== undefined)
            followUpIds && followUpIds.forEach(item => { url_ += "followUpIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateGetAllFollowUpsForStaffCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGetAllFollowUpsForStaffCache(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateGetAllFollowUpsForStaffCache(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param isParticipatory (optional) 
     * @param billCode (optional) 
     * @param permission (optional) 
     * @param filter (optional) 
     * @param sacrificeTypeIdFilter (optional) 
     * @param minDateFilter (optional) 
     * @param maxDateFilter (optional) 
     * @param slaughterAgentFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllSacrificeFollowUps(isParticipatory: number | undefined, billCode: string | undefined, permission: string | undefined, filter: string | undefined, sacrificeTypeIdFilter: number | undefined, minDateFilter: moment.Moment | undefined, maxDateFilter: moment.Moment | undefined, slaughterAgentFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAllSacrificeFollowUpsDto> {
        let url_ = this.baseUrl + "/api/services/app/FollowUps/GetAllSacrificeFollowUps?";
        if (isParticipatory === null)
            throw new Error("The parameter 'isParticipatory' cannot be null.");
        else if (isParticipatory !== undefined)
            url_ += "IsParticipatory=" + encodeURIComponent("" + isParticipatory) + "&"; 
        if (billCode === null)
            throw new Error("The parameter 'billCode' cannot be null.");
        else if (billCode !== undefined)
            url_ += "BillCode=" + encodeURIComponent("" + billCode) + "&"; 
        if (permission === null)
            throw new Error("The parameter 'permission' cannot be null.");
        else if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&"; 
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sacrificeTypeIdFilter === null)
            throw new Error("The parameter 'sacrificeTypeIdFilter' cannot be null.");
        else if (sacrificeTypeIdFilter !== undefined)
            url_ += "SacrificeTypeIdFilter=" + encodeURIComponent("" + sacrificeTypeIdFilter) + "&"; 
        if (minDateFilter === null)
            throw new Error("The parameter 'minDateFilter' cannot be null.");
        else if (minDateFilter !== undefined)
            url_ += "MinDateFilter=" + encodeURIComponent(minDateFilter ? "" + minDateFilter.toJSON() : "") + "&"; 
        if (maxDateFilter === null)
            throw new Error("The parameter 'maxDateFilter' cannot be null.");
        else if (maxDateFilter !== undefined)
            url_ += "MaxDateFilter=" + encodeURIComponent(maxDateFilter ? "" + maxDateFilter.toJSON() : "") + "&"; 
        if (slaughterAgentFilter === null)
            throw new Error("The parameter 'slaughterAgentFilter' cannot be null.");
        else if (slaughterAgentFilter !== undefined)
            url_ += "SlaughterAgentFilter=" + encodeURIComponent("" + slaughterAgentFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSacrificeFollowUps(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSacrificeFollowUps(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAllSacrificeFollowUpsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAllSacrificeFollowUpsDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSacrificeFollowUps(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllSacrificeFollowUpsDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAllSacrificeFollowUpsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAllSacrificeFollowUpsDto>(<any>null);
    }

    /**
     * @param billCode (optional) 
     * @return Success
     */
    getAllSlaughterAgentForLookupTable(billCode: string | undefined): Observable<FollowUpSlaughterAgentLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FollowUps/GetAllSlaughterAgentForLookupTable?";
        if (billCode === null)
            throw new Error("The parameter 'billCode' cannot be null.");
        else if (billCode !== undefined)
            url_ += "BillCode=" + encodeURIComponent("" + billCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSlaughterAgentForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSlaughterAgentForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<FollowUpSlaughterAgentLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FollowUpSlaughterAgentLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSlaughterAgentForLookupTable(response: HttpResponseBase): Observable<FollowUpSlaughterAgentLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FollowUpSlaughterAgentLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FollowUpSlaughterAgentLookupTableDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllSacrificeTypeForLookupTable(): Observable<FollowUpSacrificeTypeLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FollowUps/GetAllSacrificeTypeForLookupTable";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSacrificeTypeForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSacrificeTypeForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<FollowUpSacrificeTypeLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FollowUpSacrificeTypeLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSacrificeTypeForLookupTable(response: HttpResponseBase): Observable<FollowUpSacrificeTypeLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FollowUpSacrificeTypeLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FollowUpSacrificeTypeLookupTableDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllBranchForTableDropdown(): Observable<BranchLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FollowUps/GetAllBranchForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBranchForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBranchForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<BranchLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<BranchLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBranchForTableDropdown(response: HttpResponseBase): Observable<BranchLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BranchLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BranchLookupTableDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllPlanConstForTableDropdown(): Observable<PlanConstLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FollowUps/GetAllPlanConstForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPlanConstForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPlanConstForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<PlanConstLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PlanConstLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPlanConstForTableDropdown(response: HttpResponseBase): Observable<PlanConstLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlanConstLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlanConstLookupTableDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editCardTemlateValuesFromAction(body: EditCardTemlateFromActionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FollowUps/EditCardTemlateValuesFromAction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditCardTemlateValuesFromAction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditCardTemlateValuesFromAction(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processEditCardTemlateValuesFromAction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createWithoutUpdateCache(body: CreateOrEditFollowUpDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FollowUps/CreateWithoutUpdateCache";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWithoutUpdateCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWithoutUpdateCache(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateWithoutUpdateCache(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param branchRefFilter (optional) 
     * @param fromTimeFilter (optional) 
     * @param toTimeFilter (optional) 
     * @param billCodeFilter (optional) 
     * @param benefactorNameFilter (optional) 
     * @param planConstRefFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getDeliveryToContactReport(branchRefFilter: number | undefined, fromTimeFilter: moment.Moment | undefined, toTimeFilter: moment.Moment | undefined, billCodeFilter: string | undefined, benefactorNameFilter: string | undefined, planConstRefFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetDeliveryToContactReportDto> {
        let url_ = this.baseUrl + "/api/services/app/FollowUps/GetDeliveryToContactReport?";
        if (branchRefFilter === null)
            throw new Error("The parameter 'branchRefFilter' cannot be null.");
        else if (branchRefFilter !== undefined)
            url_ += "BranchRefFilter=" + encodeURIComponent("" + branchRefFilter) + "&"; 
        if (fromTimeFilter === null)
            throw new Error("The parameter 'fromTimeFilter' cannot be null.");
        else if (fromTimeFilter !== undefined)
            url_ += "FromTimeFilter=" + encodeURIComponent(fromTimeFilter ? "" + fromTimeFilter.toJSON() : "") + "&"; 
        if (toTimeFilter === null)
            throw new Error("The parameter 'toTimeFilter' cannot be null.");
        else if (toTimeFilter !== undefined)
            url_ += "ToTimeFilter=" + encodeURIComponent(toTimeFilter ? "" + toTimeFilter.toJSON() : "") + "&"; 
        if (billCodeFilter === null)
            throw new Error("The parameter 'billCodeFilter' cannot be null.");
        else if (billCodeFilter !== undefined)
            url_ += "BillCodeFilter=" + encodeURIComponent("" + billCodeFilter) + "&"; 
        if (benefactorNameFilter === null)
            throw new Error("The parameter 'benefactorNameFilter' cannot be null.");
        else if (benefactorNameFilter !== undefined)
            url_ += "BenefactorNameFilter=" + encodeURIComponent("" + benefactorNameFilter) + "&"; 
        if (planConstRefFilter === null)
            throw new Error("The parameter 'planConstRefFilter' cannot be null.");
        else if (planConstRefFilter !== undefined)
            url_ += "PlanConstRefFilter=" + encodeURIComponent("" + planConstRefFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeliveryToContactReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeliveryToContactReport(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetDeliveryToContactReportDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetDeliveryToContactReportDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetDeliveryToContactReport(response: HttpResponseBase): Observable<PagedResultDtoOfGetDeliveryToContactReportDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetDeliveryToContactReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetDeliveryToContactReportDto>(<any>null);
    }
}

@Injectable()
export class FriendshipServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createFriendshipRequest(body: CreateFriendshipRequestInput | undefined): Observable<FriendDto> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/CreateFriendshipRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFriendshipRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFriendshipRequest(<any>response_);
                } catch (e) {
                    return <Observable<FriendDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FriendDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateFriendshipRequest(response: HttpResponseBase): Observable<FriendDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FriendDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FriendDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createFriendshipRequestByUserName(body: CreateFriendshipRequestByUserNameInput | undefined): Observable<FriendDto> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/CreateFriendshipRequestByUserName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFriendshipRequestByUserName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFriendshipRequestByUserName(<any>response_);
                } catch (e) {
                    return <Observable<FriendDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FriendDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateFriendshipRequestByUserName(response: HttpResponseBase): Observable<FriendDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FriendDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FriendDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    blockUser(body: BlockUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/BlockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBlockUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBlockUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processBlockUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unblockUser(body: UnblockUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/UnblockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnblockUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnblockUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUnblockUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    acceptFriendshipRequest(body: AcceptFriendshipRequestInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/AcceptFriendshipRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptFriendshipRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptFriendshipRequest(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAcceptFriendshipRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class GeneralSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param logoFilter (optional) 
     * @param siteTitleFilter (optional) 
     * @param faviconFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param addressesFilter (optional) 
     * @param phonesFilter (optional) 
     * @param emailsFilter (optional) 
     * @param appsFilter (optional) 
     * @param socialMediaFilter (optional) 
     * @param themTemplateCodeFilter (optional) 
     * @param planConstIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, logoFilter: string | undefined, siteTitleFilter: string | undefined, faviconFilter: string | undefined, descriptionFilter: string | undefined, addressesFilter: string | undefined, phonesFilter: string | undefined, emailsFilter: string | undefined, appsFilter: string | undefined, socialMediaFilter: string | undefined, themTemplateCodeFilter: string | undefined, planConstIdFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetGeneralSettingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GeneralSettings/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (logoFilter === null)
            throw new Error("The parameter 'logoFilter' cannot be null.");
        else if (logoFilter !== undefined)
            url_ += "LogoFilter=" + encodeURIComponent("" + logoFilter) + "&"; 
        if (siteTitleFilter === null)
            throw new Error("The parameter 'siteTitleFilter' cannot be null.");
        else if (siteTitleFilter !== undefined)
            url_ += "SiteTitleFilter=" + encodeURIComponent("" + siteTitleFilter) + "&"; 
        if (faviconFilter === null)
            throw new Error("The parameter 'faviconFilter' cannot be null.");
        else if (faviconFilter !== undefined)
            url_ += "FaviconFilter=" + encodeURIComponent("" + faviconFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (addressesFilter === null)
            throw new Error("The parameter 'addressesFilter' cannot be null.");
        else if (addressesFilter !== undefined)
            url_ += "AddressesFilter=" + encodeURIComponent("" + addressesFilter) + "&"; 
        if (phonesFilter === null)
            throw new Error("The parameter 'phonesFilter' cannot be null.");
        else if (phonesFilter !== undefined)
            url_ += "PhonesFilter=" + encodeURIComponent("" + phonesFilter) + "&"; 
        if (emailsFilter === null)
            throw new Error("The parameter 'emailsFilter' cannot be null.");
        else if (emailsFilter !== undefined)
            url_ += "EmailsFilter=" + encodeURIComponent("" + emailsFilter) + "&"; 
        if (appsFilter === null)
            throw new Error("The parameter 'appsFilter' cannot be null.");
        else if (appsFilter !== undefined)
            url_ += "AppsFilter=" + encodeURIComponent("" + appsFilter) + "&"; 
        if (socialMediaFilter === null)
            throw new Error("The parameter 'socialMediaFilter' cannot be null.");
        else if (socialMediaFilter !== undefined)
            url_ += "SocialMediaFilter=" + encodeURIComponent("" + socialMediaFilter) + "&"; 
        if (themTemplateCodeFilter === null)
            throw new Error("The parameter 'themTemplateCodeFilter' cannot be null.");
        else if (themTemplateCodeFilter !== undefined)
            url_ += "ThemTemplateCodeFilter=" + encodeURIComponent("" + themTemplateCodeFilter) + "&"; 
        if (planConstIdFilter === null)
            throw new Error("The parameter 'planConstIdFilter' cannot be null.");
        else if (planConstIdFilter !== undefined)
            url_ += "PlanConstIdFilter=" + encodeURIComponent("" + planConstIdFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGeneralSettingForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGeneralSettingForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetGeneralSettingForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetGeneralSettingForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGeneralSettingForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGeneralSettingForView(id: number | undefined): Observable<GetGeneralSettingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GeneralSettings/GetGeneralSettingForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeneralSettingForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralSettingForView(<any>response_);
                } catch (e) {
                    return <Observable<GetGeneralSettingForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGeneralSettingForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetGeneralSettingForView(response: HttpResponseBase): Observable<GetGeneralSettingForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeneralSettingForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGeneralSettingForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGeneralSettingForEdit(id: number | undefined): Observable<GetGeneralSettingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/GeneralSettings/GetGeneralSettingForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeneralSettingForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralSettingForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetGeneralSettingForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGeneralSettingForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGeneralSettingForEdit(response: HttpResponseBase): Observable<GetGeneralSettingForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeneralSettingForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGeneralSettingForEditOutput>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGeneralSettingByObjectForEdit(id: number | undefined): Observable<GetGeneralSettingByObjectForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/GeneralSettings/GetGeneralSettingByObjectForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeneralSettingByObjectForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralSettingByObjectForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetGeneralSettingByObjectForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGeneralSettingByObjectForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGeneralSettingByObjectForEdit(response: HttpResponseBase): Observable<GetGeneralSettingByObjectForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeneralSettingByObjectForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGeneralSettingByObjectForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditGeneralSettingDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GeneralSettings/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditByObjects(body: CreateOrEditGeneralSettingByObjectDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GeneralSettings/CreateOrEditByObjects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditByObjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditByObjects(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditByObjects(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    createGeneralSettingsCashForShop(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GeneralSettings/CreateGeneralSettingsCashForShop";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateGeneralSettingsCashForShop(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateGeneralSettingsCashForShop(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateGeneralSettingsCashForShop(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getGeneralSettingsForShop(): Observable<GetGeneralSettingsForShopDto> {
        let url_ = this.baseUrl + "/api/services/app/GeneralSettings/GetGeneralSettingsForShop";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeneralSettingsForShop(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralSettingsForShop(<any>response_);
                } catch (e) {
                    return <Observable<GetGeneralSettingsForShopDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGeneralSettingsForShopDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetGeneralSettingsForShop(response: HttpResponseBase): Observable<GetGeneralSettingsForShopDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeneralSettingsForShopDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGeneralSettingsForShopDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GeneralSettings/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param logoFilter (optional) 
     * @param siteTitleFilter (optional) 
     * @param faviconFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param addressesFilter (optional) 
     * @param phonesFilter (optional) 
     * @param emailsFilter (optional) 
     * @param appsFilter (optional) 
     * @param socialMediaFilter (optional) 
     * @param themTemplateCodeFilter (optional) 
     * @return Success
     */
    getGeneralSettingsToExcel(filter: string | undefined, logoFilter: string | undefined, siteTitleFilter: string | undefined, faviconFilter: string | undefined, descriptionFilter: string | undefined, addressesFilter: string | undefined, phonesFilter: string | undefined, emailsFilter: string | undefined, appsFilter: string | undefined, socialMediaFilter: string | undefined, themTemplateCodeFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/GeneralSettings/GetGeneralSettingsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (logoFilter === null)
            throw new Error("The parameter 'logoFilter' cannot be null.");
        else if (logoFilter !== undefined)
            url_ += "LogoFilter=" + encodeURIComponent("" + logoFilter) + "&"; 
        if (siteTitleFilter === null)
            throw new Error("The parameter 'siteTitleFilter' cannot be null.");
        else if (siteTitleFilter !== undefined)
            url_ += "SiteTitleFilter=" + encodeURIComponent("" + siteTitleFilter) + "&"; 
        if (faviconFilter === null)
            throw new Error("The parameter 'faviconFilter' cannot be null.");
        else if (faviconFilter !== undefined)
            url_ += "FaviconFilter=" + encodeURIComponent("" + faviconFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (addressesFilter === null)
            throw new Error("The parameter 'addressesFilter' cannot be null.");
        else if (addressesFilter !== undefined)
            url_ += "AddressesFilter=" + encodeURIComponent("" + addressesFilter) + "&"; 
        if (phonesFilter === null)
            throw new Error("The parameter 'phonesFilter' cannot be null.");
        else if (phonesFilter !== undefined)
            url_ += "PhonesFilter=" + encodeURIComponent("" + phonesFilter) + "&"; 
        if (emailsFilter === null)
            throw new Error("The parameter 'emailsFilter' cannot be null.");
        else if (emailsFilter !== undefined)
            url_ += "EmailsFilter=" + encodeURIComponent("" + emailsFilter) + "&"; 
        if (appsFilter === null)
            throw new Error("The parameter 'appsFilter' cannot be null.");
        else if (appsFilter !== undefined)
            url_ += "AppsFilter=" + encodeURIComponent("" + appsFilter) + "&"; 
        if (socialMediaFilter === null)
            throw new Error("The parameter 'socialMediaFilter' cannot be null.");
        else if (socialMediaFilter !== undefined)
            url_ += "SocialMediaFilter=" + encodeURIComponent("" + socialMediaFilter) + "&"; 
        if (themTemplateCodeFilter === null)
            throw new Error("The parameter 'themTemplateCodeFilter' cannot be null.");
        else if (themTemplateCodeFilter !== undefined)
            url_ += "ThemTemplateCodeFilter=" + encodeURIComponent("" + themTemplateCodeFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeneralSettingsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralSettingsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetGeneralSettingsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllThemTemplateForTableDropdown(): Observable<GeneralSettingThemTemplateLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/GeneralSettings/GetAllThemTemplateForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllThemTemplateForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllThemTemplateForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<GeneralSettingThemTemplateLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GeneralSettingThemTemplateLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllThemTemplateForTableDropdown(response: HttpResponseBase): Observable<GeneralSettingThemTemplateLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralSettingThemTemplateLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralSettingThemTemplateLookupTableDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllCurrencyForTableDropdown(): Observable<GeneralSettingCurrencyLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/GeneralSettings/GetAllCurrencyForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCurrencyForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCurrencyForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<GeneralSettingCurrencyLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GeneralSettingCurrencyLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCurrencyForTableDropdown(response: HttpResponseBase): Observable<GeneralSettingCurrencyLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralSettingCurrencyLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralSettingCurrencyLookupTableDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllBranchForTableDropdown(): Observable<GeneralSettingBranchLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/GeneralSettings/GetAllBranchForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBranchForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBranchForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<GeneralSettingBranchLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GeneralSettingBranchLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBranchForTableDropdown(response: HttpResponseBase): Observable<GeneralSettingBranchLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralSettingBranchLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralSettingBranchLookupTableDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDefaultCurrency(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/GeneralSettings/GetDefaultCurrency";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultCurrency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultCurrency(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetDefaultCurrency(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getProviderAccountsForTableDropdown(input: GetProviderAccountsRequestDto | undefined): Observable<GetProviderAccountsResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/GeneralSettings/GetProviderAccountsForTableDropdown?";
        if (input === null)
            throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProviderAccountsForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProviderAccountsForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<GetProviderAccountsResponseDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetProviderAccountsResponseDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetProviderAccountsForTableDropdown(response: HttpResponseBase): Observable<GetProviderAccountsResponseDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetProviderAccountsResponseDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProviderAccountsResponseDto[]>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getApplicationServiceTypesForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetApplicationServiceTypesResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/GeneralSettings/GetApplicationServiceTypesForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationServiceTypesForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationServiceTypesForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetApplicationServiceTypesResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetApplicationServiceTypesResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetApplicationServiceTypesForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfGetApplicationServiceTypesResponseDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetApplicationServiceTypesResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetApplicationServiceTypesResponseDto>(<any>null);
    }
}

@Injectable()
export class GroupSubgroupsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param accessListFilter (optional) 
     * @param entityFilter (optional) 
     * @param groupSubgroupTitleFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, titleFilter: string | undefined, accessListFilter: string | undefined, entityFilter: number | undefined, groupSubgroupTitleFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetGroupSubgroupForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GroupSubgroups/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (accessListFilter === null)
            throw new Error("The parameter 'accessListFilter' cannot be null.");
        else if (accessListFilter !== undefined)
            url_ += "AccessListFilter=" + encodeURIComponent("" + accessListFilter) + "&"; 
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (groupSubgroupTitleFilter === null)
            throw new Error("The parameter 'groupSubgroupTitleFilter' cannot be null.");
        else if (groupSubgroupTitleFilter !== undefined)
            url_ += "GroupSubgroupTitleFilter=" + encodeURIComponent("" + groupSubgroupTitleFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGroupSubgroupForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGroupSubgroupForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetGroupSubgroupForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetGroupSubgroupForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGroupSubgroupForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGroupSubgroupForView(id: number | undefined): Observable<GetGroupSubgroupForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GroupSubgroups/GetGroupSubgroupForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGroupSubgroupForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroupSubgroupForView(<any>response_);
                } catch (e) {
                    return <Observable<GetGroupSubgroupForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGroupSubgroupForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetGroupSubgroupForView(response: HttpResponseBase): Observable<GetGroupSubgroupForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGroupSubgroupForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGroupSubgroupForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGroupSubgroupForEdit(id: number | undefined): Observable<GetGroupSubgroupForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/GroupSubgroups/GetGroupSubgroupForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGroupSubgroupForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroupSubgroupForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetGroupSubgroupForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGroupSubgroupForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGroupSubgroupForEdit(response: HttpResponseBase): Observable<GetGroupSubgroupForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGroupSubgroupForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGroupSubgroupForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditGroupSubgroupDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GroupSubgroups/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GroupSubgroups/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param entityFilter (optional) 
     * @param accessListFilter (optional) 
     * @param groupSubgroupTitleFilter (optional) 
     * @return Success
     */
    getGroupSubgroupsToExcel(filter: string | undefined, titleFilter: string | undefined, entityFilter: number | undefined, accessListFilter: string | undefined, groupSubgroupTitleFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/GroupSubgroups/GetGroupSubgroupsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (accessListFilter === null)
            throw new Error("The parameter 'accessListFilter' cannot be null.");
        else if (accessListFilter !== undefined)
            url_ += "AccessListFilter=" + encodeURIComponent("" + accessListFilter) + "&"; 
        if (groupSubgroupTitleFilter === null)
            throw new Error("The parameter 'groupSubgroupTitleFilter' cannot be null.");
        else if (groupSubgroupTitleFilter !== undefined)
            url_ += "GroupSubgroupTitleFilter=" + encodeURIComponent("" + groupSubgroupTitleFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGroupSubgroupsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroupSubgroupsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetGroupSubgroupsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllGroupSubgroupForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGroupSubgroupGroupSubgroupLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/GroupSubgroups/GetAllGroupSubgroupForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllGroupSubgroupForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllGroupSubgroupForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGroupSubgroupGroupSubgroupLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGroupSubgroupGroupSubgroupLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllGroupSubgroupForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfGroupSubgroupGroupSubgroupLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGroupSubgroupGroupSubgroupLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGroupSubgroupGroupSubgroupLookupTableDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllGroupSubgroupForDropdownTable(): Observable<GroupSubgroupGroupSubgroupLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/GroupSubgroups/GetAllGroupSubgroupForDropdownTable";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllGroupSubgroupForDropdownTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllGroupSubgroupForDropdownTable(<any>response_);
                } catch (e) {
                    return <Observable<GroupSubgroupGroupSubgroupLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GroupSubgroupGroupSubgroupLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllGroupSubgroupForDropdownTable(response: HttpResponseBase): Observable<GroupSubgroupGroupSubgroupLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroupSubgroupGroupSubgroupLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GroupSubgroupGroupSubgroupLookupTableDto[]>(<any>null);
    }
}

@Injectable()
export class HealthStatusesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param stateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, titleFilter: string | undefined, descriptionFilter: string | undefined, stateFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetHealthStatusForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthStatuses/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetHealthStatusForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetHealthStatusForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetHealthStatusForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetHealthStatusForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetHealthStatusForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getHealthStatusForView(id: number | undefined): Observable<GetHealthStatusForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthStatuses/GetHealthStatusForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHealthStatusForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHealthStatusForView(<any>response_);
                } catch (e) {
                    return <Observable<GetHealthStatusForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetHealthStatusForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetHealthStatusForView(response: HttpResponseBase): Observable<GetHealthStatusForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetHealthStatusForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetHealthStatusForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getHealthStatusForEdit(id: number | undefined): Observable<GetHealthStatusForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/HealthStatuses/GetHealthStatusForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHealthStatusForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHealthStatusForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetHealthStatusForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetHealthStatusForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetHealthStatusForEdit(response: HttpResponseBase): Observable<GetHealthStatusForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetHealthStatusForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetHealthStatusForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditHealthStatusDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthStatuses/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthStatuses/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param stateFilter (optional) 
     * @return Success
     */
    getHealthStatusesToExcel(filter: string | undefined, titleFilter: string | undefined, descriptionFilter: string | undefined, stateFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthStatuses/GetHealthStatusesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHealthStatusesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHealthStatusesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetHealthStatusesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class HostDashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getTopStatsData(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<TopStatsData> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetTopStatsData?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTopStatsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTopStatsData(<any>response_);
                } catch (e) {
                    return <Observable<TopStatsData>><any>_observableThrow(e);
                }
            } else
                return <Observable<TopStatsData>><any>_observableThrow(response_);
        }));
    }

    protected processGetTopStatsData(response: HttpResponseBase): Observable<TopStatsData> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TopStatsData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TopStatsData>(<any>null);
    }

    /**
     * @return Success
     */
    getRecentTenantsData(): Observable<GetRecentTenantsOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetRecentTenantsData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentTenantsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentTenantsData(<any>response_);
                } catch (e) {
                    return <Observable<GetRecentTenantsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRecentTenantsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRecentTenantsData(response: HttpResponseBase): Observable<GetRecentTenantsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRecentTenantsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRecentTenantsOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getSubscriptionExpiringTenantsData(): Observable<GetExpiringTenantsOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetSubscriptionExpiringTenantsData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubscriptionExpiringTenantsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscriptionExpiringTenantsData(<any>response_);
                } catch (e) {
                    return <Observable<GetExpiringTenantsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetExpiringTenantsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSubscriptionExpiringTenantsData(response: HttpResponseBase): Observable<GetExpiringTenantsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExpiringTenantsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetExpiringTenantsOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getIncomeStatistics(incomeStatisticsDateInterval: ChartDateInterval, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<GetIncomeStatisticsDataOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetIncomeStatistics?";
        if (incomeStatisticsDateInterval === undefined || incomeStatisticsDateInterval === null)
            throw new Error("The parameter 'incomeStatisticsDateInterval' must be defined and cannot be null.");
        else
            url_ += "IncomeStatisticsDateInterval=" + encodeURIComponent("" + incomeStatisticsDateInterval) + "&"; 
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncomeStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncomeStatistics(<any>response_);
                } catch (e) {
                    return <Observable<GetIncomeStatisticsDataOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetIncomeStatisticsDataOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetIncomeStatistics(response: HttpResponseBase): Observable<GetIncomeStatisticsDataOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetIncomeStatisticsDataOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetIncomeStatisticsDataOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getEditionTenantStatistics(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<GetEditionTenantStatisticsOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetEditionTenantStatistics?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionTenantStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionTenantStatistics(<any>response_);
                } catch (e) {
                    return <Observable<GetEditionTenantStatisticsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetEditionTenantStatisticsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetEditionTenantStatistics(response: HttpResponseBase): Observable<GetEditionTenantStatisticsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEditionTenantStatisticsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEditionTenantStatisticsOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getTenantData(): Observable<GetTenantPlanInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetTenantData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantData(<any>response_);
                } catch (e) {
                    return <Observable<GetTenantPlanInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTenantPlanInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTenantData(response: HttpResponseBase): Observable<GetTenantPlanInfoDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTenantPlanInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTenantPlanInfoDto>(<any>null);
    }
}

@Injectable()
export class HostSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllSettings(): Observable<HostSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSettings(<any>response_);
                } catch (e) {
                    return <Observable<HostSettingsEditDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<HostSettingsEditDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSettings(response: HttpResponseBase): Observable<HostSettingsEditDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HostSettingsEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HostSettingsEditDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAllSettings(body: HostSettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllSettings(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateAllSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendTestEmail(body: SendTestEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class IncomeOutcomesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param isEffectiveFilter (optional) 
     * @param effectFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, codeFilter: string | undefined, nameFilter: string | undefined, descriptionFilter: string | undefined, isEffectiveFilter: number | undefined, effectFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetIncomeOutcomeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/IncomeOutcomes/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (isEffectiveFilter === null)
            throw new Error("The parameter 'isEffectiveFilter' cannot be null.");
        else if (isEffectiveFilter !== undefined)
            url_ += "IsEffectiveFilter=" + encodeURIComponent("" + isEffectiveFilter) + "&"; 
        if (effectFilter === null)
            throw new Error("The parameter 'effectFilter' cannot be null.");
        else if (effectFilter !== undefined)
            url_ += "EffectFilter=" + encodeURIComponent("" + effectFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetIncomeOutcomeForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetIncomeOutcomeForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetIncomeOutcomeForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetIncomeOutcomeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetIncomeOutcomeForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getIncomeOutcomeForView(id: number | undefined): Observable<GetIncomeOutcomeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/IncomeOutcomes/GetIncomeOutcomeForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncomeOutcomeForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncomeOutcomeForView(<any>response_);
                } catch (e) {
                    return <Observable<GetIncomeOutcomeForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetIncomeOutcomeForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetIncomeOutcomeForView(response: HttpResponseBase): Observable<GetIncomeOutcomeForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetIncomeOutcomeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetIncomeOutcomeForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getIncomeOutcomeForEdit(id: number | undefined): Observable<GetIncomeOutcomeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/IncomeOutcomes/GetIncomeOutcomeForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncomeOutcomeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncomeOutcomeForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetIncomeOutcomeForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetIncomeOutcomeForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetIncomeOutcomeForEdit(response: HttpResponseBase): Observable<GetIncomeOutcomeForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetIncomeOutcomeForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetIncomeOutcomeForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditIncomeOutcomeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/IncomeOutcomes/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/IncomeOutcomes/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param isEffectiveFilter (optional) 
     * @return Success
     */
    getIncomeOutcomesToExcel(filter: string | undefined, codeFilter: string | undefined, nameFilter: string | undefined, descriptionFilter: string | undefined, isEffectiveFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/IncomeOutcomes/GetIncomeOutcomesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (isEffectiveFilter === null)
            throw new Error("The parameter 'isEffectiveFilter' cannot be null.");
        else if (isEffectiveFilter !== undefined)
            url_ += "IsEffectiveFilter=" + encodeURIComponent("" + isEffectiveFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncomeOutcomesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncomeOutcomesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetIncomeOutcomesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class InstallServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setup(body: InstallDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Install/Setup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetup(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAppSettingsJson(): Observable<AppSettingsJsonDto> {
        let url_ = this.baseUrl + "/api/services/app/Install/GetAppSettingsJson";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppSettingsJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppSettingsJson(<any>response_);
                } catch (e) {
                    return <Observable<AppSettingsJsonDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AppSettingsJsonDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAppSettingsJson(response: HttpResponseBase): Observable<AppSettingsJsonDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppSettingsJsonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppSettingsJsonDto>(<any>null);
    }

    /**
     * @return Success
     */
    checkDatabase(): Observable<CheckDatabaseOutput> {
        let url_ = this.baseUrl + "/api/services/app/Install/CheckDatabase";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckDatabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckDatabase(<any>response_);
                } catch (e) {
                    return <Observable<CheckDatabaseOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<CheckDatabaseOutput>><any>_observableThrow(response_);
        }));
    }

    protected processCheckDatabase(response: HttpResponseBase): Observable<CheckDatabaseOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckDatabaseOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckDatabaseOutput>(<any>null);
    }
}

@Injectable()
export class IntroductionMethodsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param stateFilter (optional) 
     * @param maxCreatedFilter (optional) 
     * @param minCreatedFilter (optional) 
     * @param maxCreatedByFilter (optional) 
     * @param minCreatedByFilter (optional) 
     * @param maxModifiedFilter (optional) 
     * @param minModifiedFilter (optional) 
     * @param maxModifiedByFilter (optional) 
     * @param minModifiedByFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, titleFilter: string | undefined, stateFilter: number | undefined, maxCreatedFilter: moment.Moment | undefined, minCreatedFilter: moment.Moment | undefined, maxCreatedByFilter: number | undefined, minCreatedByFilter: number | undefined, maxModifiedFilter: moment.Moment | undefined, minModifiedFilter: moment.Moment | undefined, maxModifiedByFilter: number | undefined, minModifiedByFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetIntroductionMethodForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/IntroductionMethods/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (maxCreatedFilter === null)
            throw new Error("The parameter 'maxCreatedFilter' cannot be null.");
        else if (maxCreatedFilter !== undefined)
            url_ += "MaxCreatedFilter=" + encodeURIComponent(maxCreatedFilter ? "" + maxCreatedFilter.toJSON() : "") + "&"; 
        if (minCreatedFilter === null)
            throw new Error("The parameter 'minCreatedFilter' cannot be null.");
        else if (minCreatedFilter !== undefined)
            url_ += "MinCreatedFilter=" + encodeURIComponent(minCreatedFilter ? "" + minCreatedFilter.toJSON() : "") + "&"; 
        if (maxCreatedByFilter === null)
            throw new Error("The parameter 'maxCreatedByFilter' cannot be null.");
        else if (maxCreatedByFilter !== undefined)
            url_ += "MaxCreatedByFilter=" + encodeURIComponent("" + maxCreatedByFilter) + "&"; 
        if (minCreatedByFilter === null)
            throw new Error("The parameter 'minCreatedByFilter' cannot be null.");
        else if (minCreatedByFilter !== undefined)
            url_ += "MinCreatedByFilter=" + encodeURIComponent("" + minCreatedByFilter) + "&"; 
        if (maxModifiedFilter === null)
            throw new Error("The parameter 'maxModifiedFilter' cannot be null.");
        else if (maxModifiedFilter !== undefined)
            url_ += "MaxModifiedFilter=" + encodeURIComponent(maxModifiedFilter ? "" + maxModifiedFilter.toJSON() : "") + "&"; 
        if (minModifiedFilter === null)
            throw new Error("The parameter 'minModifiedFilter' cannot be null.");
        else if (minModifiedFilter !== undefined)
            url_ += "MinModifiedFilter=" + encodeURIComponent(minModifiedFilter ? "" + minModifiedFilter.toJSON() : "") + "&"; 
        if (maxModifiedByFilter === null)
            throw new Error("The parameter 'maxModifiedByFilter' cannot be null.");
        else if (maxModifiedByFilter !== undefined)
            url_ += "MaxModifiedByFilter=" + encodeURIComponent("" + maxModifiedByFilter) + "&"; 
        if (minModifiedByFilter === null)
            throw new Error("The parameter 'minModifiedByFilter' cannot be null.");
        else if (minModifiedByFilter !== undefined)
            url_ += "MinModifiedByFilter=" + encodeURIComponent("" + minModifiedByFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetIntroductionMethodForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetIntroductionMethodForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetIntroductionMethodForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetIntroductionMethodForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetIntroductionMethodForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getIntroductionMethodForView(id: number | undefined): Observable<GetIntroductionMethodForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/IntroductionMethods/GetIntroductionMethodForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIntroductionMethodForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIntroductionMethodForView(<any>response_);
                } catch (e) {
                    return <Observable<GetIntroductionMethodForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetIntroductionMethodForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetIntroductionMethodForView(response: HttpResponseBase): Observable<GetIntroductionMethodForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetIntroductionMethodForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetIntroductionMethodForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getIntroductionMethodForEdit(id: number | undefined): Observable<GetIntroductionMethodForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/IntroductionMethods/GetIntroductionMethodForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIntroductionMethodForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIntroductionMethodForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetIntroductionMethodForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetIntroductionMethodForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetIntroductionMethodForEdit(response: HttpResponseBase): Observable<GetIntroductionMethodForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetIntroductionMethodForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetIntroductionMethodForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditIntroductionMethodDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/IntroductionMethods/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/IntroductionMethods/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param stateFilter (optional) 
     * @param maxCreatedFilter (optional) 
     * @param minCreatedFilter (optional) 
     * @param maxCreatedByFilter (optional) 
     * @param minCreatedByFilter (optional) 
     * @param maxModifiedFilter (optional) 
     * @param minModifiedFilter (optional) 
     * @param maxModifiedByFilter (optional) 
     * @param minModifiedByFilter (optional) 
     * @return Success
     */
    getIntroductionMethodsToExcel(filter: string | undefined, titleFilter: string | undefined, stateFilter: number | undefined, maxCreatedFilter: moment.Moment | undefined, minCreatedFilter: moment.Moment | undefined, maxCreatedByFilter: number | undefined, minCreatedByFilter: number | undefined, maxModifiedFilter: moment.Moment | undefined, minModifiedFilter: moment.Moment | undefined, maxModifiedByFilter: number | undefined, minModifiedByFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/IntroductionMethods/GetIntroductionMethodsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (maxCreatedFilter === null)
            throw new Error("The parameter 'maxCreatedFilter' cannot be null.");
        else if (maxCreatedFilter !== undefined)
            url_ += "MaxCreatedFilter=" + encodeURIComponent(maxCreatedFilter ? "" + maxCreatedFilter.toJSON() : "") + "&"; 
        if (minCreatedFilter === null)
            throw new Error("The parameter 'minCreatedFilter' cannot be null.");
        else if (minCreatedFilter !== undefined)
            url_ += "MinCreatedFilter=" + encodeURIComponent(minCreatedFilter ? "" + minCreatedFilter.toJSON() : "") + "&"; 
        if (maxCreatedByFilter === null)
            throw new Error("The parameter 'maxCreatedByFilter' cannot be null.");
        else if (maxCreatedByFilter !== undefined)
            url_ += "MaxCreatedByFilter=" + encodeURIComponent("" + maxCreatedByFilter) + "&"; 
        if (minCreatedByFilter === null)
            throw new Error("The parameter 'minCreatedByFilter' cannot be null.");
        else if (minCreatedByFilter !== undefined)
            url_ += "MinCreatedByFilter=" + encodeURIComponent("" + minCreatedByFilter) + "&"; 
        if (maxModifiedFilter === null)
            throw new Error("The parameter 'maxModifiedFilter' cannot be null.");
        else if (maxModifiedFilter !== undefined)
            url_ += "MaxModifiedFilter=" + encodeURIComponent(maxModifiedFilter ? "" + maxModifiedFilter.toJSON() : "") + "&"; 
        if (minModifiedFilter === null)
            throw new Error("The parameter 'minModifiedFilter' cannot be null.");
        else if (minModifiedFilter !== undefined)
            url_ += "MinModifiedFilter=" + encodeURIComponent(minModifiedFilter ? "" + minModifiedFilter.toJSON() : "") + "&"; 
        if (maxModifiedByFilter === null)
            throw new Error("The parameter 'maxModifiedByFilter' cannot be null.");
        else if (maxModifiedByFilter !== undefined)
            url_ += "MaxModifiedByFilter=" + encodeURIComponent("" + maxModifiedByFilter) + "&"; 
        if (minModifiedByFilter === null)
            throw new Error("The parameter 'minModifiedByFilter' cannot be null.");
        else if (minModifiedByFilter !== undefined)
            url_ += "MinModifiedByFilter=" + encodeURIComponent("" + minModifiedByFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIntroductionMethodsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIntroductionMethodsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetIntroductionMethodsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class InvoiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getInvoiceInfo(id: number | undefined): Observable<InvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetInvoiceInfo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceInfo(<any>response_);
                } catch (e) {
                    return <Observable<InvoiceDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<InvoiceDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetInvoiceInfo(response: HttpResponseBase): Observable<InvoiceDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createInvoice(body: CreateInvoiceDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/CreateInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvoice(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateInvoice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class JobsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, titleFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetJobForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Jobs/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetJobForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetJobForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetJobForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetJobForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetJobForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getJobForView(id: number | undefined): Observable<GetJobForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Jobs/GetJobForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobForView(<any>response_);
                } catch (e) {
                    return <Observable<GetJobForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetJobForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetJobForView(response: HttpResponseBase): Observable<GetJobForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJobForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetJobForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getJobForEdit(id: number | undefined): Observable<GetJobForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Jobs/GetJobForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetJobForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetJobForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetJobForEdit(response: HttpResponseBase): Observable<GetJobForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJobForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetJobForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditJobDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Jobs/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Jobs/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @return Success
     */
    getJobsToExcel(filter: string | undefined, titleFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Jobs/GetJobsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetJobsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class LanguageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getLanguages(): Observable<GetLanguagesOutput> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguages(<any>response_);
                } catch (e) {
                    return <Observable<GetLanguagesOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetLanguagesOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetLanguages(response: HttpResponseBase): Observable<GetLanguagesOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLanguagesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLanguagesOutput>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLanguageForEdit(id: number | undefined): Observable<GetLanguageForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetLanguageForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetLanguageForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetLanguageForEdit(response: HttpResponseBase): Observable<GetLanguageForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLanguageForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLanguageForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLanguage(body: CreateOrUpdateLanguageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/CreateOrUpdateLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLanguage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdateLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteLanguage(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/DeleteLanguage?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLanguage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setDefaultLanguage(body: SetDefaultLanguageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/SetDefaultLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDefaultLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDefaultLanguage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetDefaultLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @param baseLanguageName (optional) 
     * @param targetValueFilter (optional) 
     * @param filterText (optional) 
     * @return Success
     */
    getLanguageTexts(maxResultCount: number | undefined, skipCount: number | undefined, sorting: string | undefined, sourceName: string, baseLanguageName: string | undefined, targetLanguageName: string, targetValueFilter: string | undefined, filterText: string | undefined): Observable<PagedResultDtoOfLanguageTextListDto> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageTexts?";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (sourceName === undefined || sourceName === null)
            throw new Error("The parameter 'sourceName' must be defined and cannot be null.");
        else
            url_ += "SourceName=" + encodeURIComponent("" + sourceName) + "&"; 
        if (baseLanguageName === null)
            throw new Error("The parameter 'baseLanguageName' cannot be null.");
        else if (baseLanguageName !== undefined)
            url_ += "BaseLanguageName=" + encodeURIComponent("" + baseLanguageName) + "&"; 
        if (targetLanguageName === undefined || targetLanguageName === null)
            throw new Error("The parameter 'targetLanguageName' must be defined and cannot be null.");
        else
            url_ += "TargetLanguageName=" + encodeURIComponent("" + targetLanguageName) + "&"; 
        if (targetValueFilter === null)
            throw new Error("The parameter 'targetValueFilter' cannot be null.");
        else if (targetValueFilter !== undefined)
            url_ += "TargetValueFilter=" + encodeURIComponent("" + targetValueFilter) + "&"; 
        if (filterText === null)
            throw new Error("The parameter 'filterText' cannot be null.");
        else if (filterText !== undefined)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageTexts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageTexts(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfLanguageTextListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfLanguageTextListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetLanguageTexts(response: HttpResponseBase): Observable<PagedResultDtoOfLanguageTextListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLanguageTextListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfLanguageTextListDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateLanguageText(body: UpdateLanguageTextInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/UpdateLanguageText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLanguageText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLanguageText(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateLanguageText(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class LegalContactsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param identityCodeFilter (optional) 
     * @param economicCodeFilter (optional) 
     * @param registrationNumberFilter (optional) 
     * @param phoneFilter (optional) 
     * @param managerFilter (optional) 
     * @param postalCodeFilter (optional) 
     * @param activityFieldFilter (optional) 
     * @param stateFilter (optional) 
     * @param contactFirstNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, nameFilter: string | undefined, identityCodeFilter: string | undefined, economicCodeFilter: string | undefined, registrationNumberFilter: string | undefined, phoneFilter: string | undefined, managerFilter: string | undefined, postalCodeFilter: string | undefined, activityFieldFilter: string | undefined, stateFilter: number | undefined, contactFirstNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetLegalContactForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/LegalContacts/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&"; 
        if (identityCodeFilter === null)
            throw new Error("The parameter 'identityCodeFilter' cannot be null.");
        else if (identityCodeFilter !== undefined)
            url_ += "IdentityCodeFilter=" + encodeURIComponent("" + identityCodeFilter) + "&"; 
        if (economicCodeFilter === null)
            throw new Error("The parameter 'economicCodeFilter' cannot be null.");
        else if (economicCodeFilter !== undefined)
            url_ += "EconomicCodeFilter=" + encodeURIComponent("" + economicCodeFilter) + "&"; 
        if (registrationNumberFilter === null)
            throw new Error("The parameter 'registrationNumberFilter' cannot be null.");
        else if (registrationNumberFilter !== undefined)
            url_ += "RegistrationNumberFilter=" + encodeURIComponent("" + registrationNumberFilter) + "&"; 
        if (phoneFilter === null)
            throw new Error("The parameter 'phoneFilter' cannot be null.");
        else if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&"; 
        if (managerFilter === null)
            throw new Error("The parameter 'managerFilter' cannot be null.");
        else if (managerFilter !== undefined)
            url_ += "ManagerFilter=" + encodeURIComponent("" + managerFilter) + "&"; 
        if (postalCodeFilter === null)
            throw new Error("The parameter 'postalCodeFilter' cannot be null.");
        else if (postalCodeFilter !== undefined)
            url_ += "PostalCodeFilter=" + encodeURIComponent("" + postalCodeFilter) + "&"; 
        if (activityFieldFilter === null)
            throw new Error("The parameter 'activityFieldFilter' cannot be null.");
        else if (activityFieldFilter !== undefined)
            url_ += "ActivityFieldFilter=" + encodeURIComponent("" + activityFieldFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (contactFirstNameFilter === null)
            throw new Error("The parameter 'contactFirstNameFilter' cannot be null.");
        else if (contactFirstNameFilter !== undefined)
            url_ += "ContactFirstNameFilter=" + encodeURIComponent("" + contactFirstNameFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetLegalContactForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetLegalContactForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetLegalContactForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetLegalContactForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetLegalContactForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLegalContactForView(id: number | undefined): Observable<GetLegalContactForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/LegalContacts/GetLegalContactForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLegalContactForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLegalContactForView(<any>response_);
                } catch (e) {
                    return <Observable<GetLegalContactForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetLegalContactForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetLegalContactForView(response: HttpResponseBase): Observable<GetLegalContactForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLegalContactForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLegalContactForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLegalContactForEdit(id: number | undefined): Observable<GetLegalContactForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/LegalContacts/GetLegalContactForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLegalContactForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLegalContactForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetLegalContactForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetLegalContactForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetLegalContactForEdit(response: HttpResponseBase): Observable<GetLegalContactForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLegalContactForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLegalContactForEditOutput>(<any>null);
    }

    /**
     * @param contactId (optional) 
     * @return Success
     */
    getLegalContactForContact(contactId: number | undefined): Observable<CreateOrEditLegalContactDto> {
        let url_ = this.baseUrl + "/api/services/app/LegalContacts/getLegalContactForContact?";
        if (contactId === null)
            throw new Error("The parameter 'contactId' cannot be null.");
        else if (contactId !== undefined)
            url_ += "contactId=" + encodeURIComponent("" + contactId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLegalContactForContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLegalContactForContact(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditLegalContactDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditLegalContactDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetLegalContactForContact(response: HttpResponseBase): Observable<CreateOrEditLegalContactDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditLegalContactDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditLegalContactDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditLegalContactDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LegalContacts/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAndGetIdOrEdit(body: CreateOrEditLegalContactDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/LegalContacts/CreateAndGetIdOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAndGetIdOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAndGetIdOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateAndGetIdOrEdit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LegalContacts/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param identityCodeFilter (optional) 
     * @param economicCodeFilter (optional) 
     * @param registrationNumberFilter (optional) 
     * @param phoneFilter (optional) 
     * @param managerFilter (optional) 
     * @param postalCodeFilter (optional) 
     * @param activityFieldFilter (optional) 
     * @param stateFilter (optional) 
     * @param contactFirstNameFilter (optional) 
     * @return Success
     */
    getLegalContactsToExcel(filter: string | undefined, nameFilter: string | undefined, identityCodeFilter: string | undefined, economicCodeFilter: string | undefined, registrationNumberFilter: string | undefined, phoneFilter: string | undefined, managerFilter: string | undefined, postalCodeFilter: string | undefined, activityFieldFilter: string | undefined, stateFilter: number | undefined, contactFirstNameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/LegalContacts/GetLegalContactsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&"; 
        if (identityCodeFilter === null)
            throw new Error("The parameter 'identityCodeFilter' cannot be null.");
        else if (identityCodeFilter !== undefined)
            url_ += "IdentityCodeFilter=" + encodeURIComponent("" + identityCodeFilter) + "&"; 
        if (economicCodeFilter === null)
            throw new Error("The parameter 'economicCodeFilter' cannot be null.");
        else if (economicCodeFilter !== undefined)
            url_ += "EconomicCodeFilter=" + encodeURIComponent("" + economicCodeFilter) + "&"; 
        if (registrationNumberFilter === null)
            throw new Error("The parameter 'registrationNumberFilter' cannot be null.");
        else if (registrationNumberFilter !== undefined)
            url_ += "RegistrationNumberFilter=" + encodeURIComponent("" + registrationNumberFilter) + "&"; 
        if (phoneFilter === null)
            throw new Error("The parameter 'phoneFilter' cannot be null.");
        else if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&"; 
        if (managerFilter === null)
            throw new Error("The parameter 'managerFilter' cannot be null.");
        else if (managerFilter !== undefined)
            url_ += "ManagerFilter=" + encodeURIComponent("" + managerFilter) + "&"; 
        if (postalCodeFilter === null)
            throw new Error("The parameter 'postalCodeFilter' cannot be null.");
        else if (postalCodeFilter !== undefined)
            url_ += "PostalCodeFilter=" + encodeURIComponent("" + postalCodeFilter) + "&"; 
        if (activityFieldFilter === null)
            throw new Error("The parameter 'activityFieldFilter' cannot be null.");
        else if (activityFieldFilter !== undefined)
            url_ += "ActivityFieldFilter=" + encodeURIComponent("" + activityFieldFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (contactFirstNameFilter === null)
            throw new Error("The parameter 'contactFirstNameFilter' cannot be null.");
        else if (contactFirstNameFilter !== undefined)
            url_ += "ContactFirstNameFilter=" + encodeURIComponent("" + contactFirstNameFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLegalContactsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLegalContactsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetLegalContactsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllContactForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfLegalContactContactLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/LegalContacts/GetAllContactForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllContactForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllContactForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfLegalContactContactLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfLegalContactContactLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllContactForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfLegalContactContactLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLegalContactContactLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfLegalContactContactLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllAddressForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfLegalContactAddressLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/LegalContacts/GetAllAddressForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAddressForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAddressForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfLegalContactAddressLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfLegalContactAddressLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllAddressForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfLegalContactAddressLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLegalContactAddressLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfLegalContactAddressLookupTableDto>(<any>null);
    }
}

@Injectable()
export class LocationGroupsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param maxCapacityFilter (optional) 
     * @param minCapacityFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, titleFilter: string | undefined, maxCapacityFilter: number | undefined, minCapacityFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetLocationGroupForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/LocationGroups/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (maxCapacityFilter === null)
            throw new Error("The parameter 'maxCapacityFilter' cannot be null.");
        else if (maxCapacityFilter !== undefined)
            url_ += "MaxCapacityFilter=" + encodeURIComponent("" + maxCapacityFilter) + "&"; 
        if (minCapacityFilter === null)
            throw new Error("The parameter 'minCapacityFilter' cannot be null.");
        else if (minCapacityFilter !== undefined)
            url_ += "MinCapacityFilter=" + encodeURIComponent("" + minCapacityFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetLocationGroupForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetLocationGroupForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetLocationGroupForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetLocationGroupForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetLocationGroupForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLocationGroupForView(id: number | undefined): Observable<GetLocationGroupForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/LocationGroups/GetLocationGroupForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationGroupForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationGroupForView(<any>response_);
                } catch (e) {
                    return <Observable<GetLocationGroupForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetLocationGroupForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetLocationGroupForView(response: HttpResponseBase): Observable<GetLocationGroupForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLocationGroupForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationGroupForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLocationGroupForEdit(id: number | undefined): Observable<GetLocationGroupForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/LocationGroups/GetLocationGroupForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationGroupForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationGroupForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetLocationGroupForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetLocationGroupForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetLocationGroupForEdit(response: HttpResponseBase): Observable<GetLocationGroupForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLocationGroupForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationGroupForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditLocationGroupDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LocationGroups/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAndGetId(body: CreateOrEditLocationGroupDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/LocationGroups/CreateAndGetId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAndGetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAndGetId(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateAndGetId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LocationGroups/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param maxCapacityFilter (optional) 
     * @param minCapacityFilter (optional) 
     * @return Success
     */
    getLocationGroupsToExcel(filter: string | undefined, titleFilter: string | undefined, maxCapacityFilter: number | undefined, minCapacityFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/LocationGroups/GetLocationGroupsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (maxCapacityFilter === null)
            throw new Error("The parameter 'maxCapacityFilter' cannot be null.");
        else if (maxCapacityFilter !== undefined)
            url_ += "MaxCapacityFilter=" + encodeURIComponent("" + maxCapacityFilter) + "&"; 
        if (minCapacityFilter === null)
            throw new Error("The parameter 'minCapacityFilter' cannot be null.");
        else if (minCapacityFilter !== undefined)
            url_ += "MinCapacityFilter=" + encodeURIComponent("" + minCapacityFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationGroupsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationGroupsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetLocationGroupsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class LocationsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param codeFilter (optional) 
     * @param isPublicOrPrivateFilter (optional) 
     * @param ownerFilter (optional) 
     * @param ownerPhoneNoFilter (optional) 
     * @param guaranteedTimeDeliverFilter (optional) 
     * @param isUserRequestsToBePublicTheLocationFilter (optional) 
     * @param locationGroupTitleFilter (optional) 
     * @param locationTypeTitleFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, titleFilter: string | undefined, codeFilter: string | undefined, isPublicOrPrivateFilter: number | undefined, ownerFilter: string | undefined, ownerPhoneNoFilter: string | undefined, guaranteedTimeDeliverFilter: string | undefined, isUserRequestsToBePublicTheLocationFilter: number | undefined, locationGroupTitleFilter: string | undefined, locationTypeTitleFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetLocationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Locations/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (isPublicOrPrivateFilter === null)
            throw new Error("The parameter 'isPublicOrPrivateFilter' cannot be null.");
        else if (isPublicOrPrivateFilter !== undefined)
            url_ += "IsPublicOrPrivateFilter=" + encodeURIComponent("" + isPublicOrPrivateFilter) + "&"; 
        if (ownerFilter === null)
            throw new Error("The parameter 'ownerFilter' cannot be null.");
        else if (ownerFilter !== undefined)
            url_ += "OwnerFilter=" + encodeURIComponent("" + ownerFilter) + "&"; 
        if (ownerPhoneNoFilter === null)
            throw new Error("The parameter 'ownerPhoneNoFilter' cannot be null.");
        else if (ownerPhoneNoFilter !== undefined)
            url_ += "OwnerPhoneNoFilter=" + encodeURIComponent("" + ownerPhoneNoFilter) + "&"; 
        if (guaranteedTimeDeliverFilter === null)
            throw new Error("The parameter 'guaranteedTimeDeliverFilter' cannot be null.");
        else if (guaranteedTimeDeliverFilter !== undefined)
            url_ += "GuaranteedTimeDeliverFilter=" + encodeURIComponent("" + guaranteedTimeDeliverFilter) + "&"; 
        if (isUserRequestsToBePublicTheLocationFilter === null)
            throw new Error("The parameter 'isUserRequestsToBePublicTheLocationFilter' cannot be null.");
        else if (isUserRequestsToBePublicTheLocationFilter !== undefined)
            url_ += "IsUserRequestsToBePublicTheLocationFilter=" + encodeURIComponent("" + isUserRequestsToBePublicTheLocationFilter) + "&"; 
        if (locationGroupTitleFilter === null)
            throw new Error("The parameter 'locationGroupTitleFilter' cannot be null.");
        else if (locationGroupTitleFilter !== undefined)
            url_ += "LocationGroupTitleFilter=" + encodeURIComponent("" + locationGroupTitleFilter) + "&"; 
        if (locationTypeTitleFilter === null)
            throw new Error("The parameter 'locationTypeTitleFilter' cannot be null.");
        else if (locationTypeTitleFilter !== undefined)
            url_ += "LocationTypeTitleFilter=" + encodeURIComponent("" + locationTypeTitleFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetLocationForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetLocationForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetLocationForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetLocationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetLocationForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLocationForView(id: number | undefined): Observable<GetLocationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Locations/GetLocationForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationForView(<any>response_);
                } catch (e) {
                    return <Observable<GetLocationForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetLocationForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetLocationForView(response: HttpResponseBase): Observable<GetLocationForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLocationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLocationForEdit(id: number | undefined): Observable<GetLocationForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Locations/GetLocationForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetLocationForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetLocationForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetLocationForEdit(response: HttpResponseBase): Observable<GetLocationForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLocationForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationForEditOutput>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLocationAndAddressForEdit(id: number | undefined): Observable<GetLocationAndAddressForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Locations/GetLocationAndAddressForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationAndAddressForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationAndAddressForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetLocationAndAddressForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetLocationAndAddressForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetLocationAndAddressForEdit(response: HttpResponseBase): Observable<GetLocationAndAddressForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLocationAndAddressForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationAndAddressForEditOutput>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAddressFromLocationIdForView(id: number | undefined): Observable<GetAddressForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Locations/GetAddressFromLocationIdForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAddressFromLocationIdForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAddressFromLocationIdForView(<any>response_);
                } catch (e) {
                    return <Observable<GetAddressForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAddressForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAddressFromLocationIdForView(response: HttpResponseBase): Observable<GetAddressForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAddressForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAddressForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditLocationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Locations/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAndGetId(body: CreateOrEditLocationDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Locations/CreateAndGetId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAndGetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAndGetId(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateAndGetId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditLocationAndAddress(body: CreateOrEditLocationAndAddress | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Locations/CreateOrEditLocationAndAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditLocationAndAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditLocationAndAddress(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditLocationAndAddress(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param page (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getPublicLocationsForShop(filter: string | undefined, page: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetPublicLocationsForShopDto> {
        let url_ = this.baseUrl + "/api/services/app/Locations/GetPublicLocationsForShop?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPublicLocationsForShop(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublicLocationsForShop(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetPublicLocationsForShopDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetPublicLocationsForShopDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPublicLocationsForShop(response: HttpResponseBase): Observable<PagedResultDtoOfGetPublicLocationsForShopDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetPublicLocationsForShopDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetPublicLocationsForShopDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Locations/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param codeFilter (optional) 
     * @param isPublicOrPrivateFilter (optional) 
     * @param ownerFilter (optional) 
     * @param ownerPhoneNoFilter (optional) 
     * @param guaranteedTimeDeliverFilter (optional) 
     * @param isUserRequestsToBePublicTheLocationFilter (optional) 
     * @param locationGroupTitleFilter (optional) 
     * @param locationTypeTitleFilter (optional) 
     * @return Success
     */
    getLocationsToExcel(filter: string | undefined, titleFilter: string | undefined, codeFilter: string | undefined, isPublicOrPrivateFilter: number | undefined, ownerFilter: string | undefined, ownerPhoneNoFilter: string | undefined, guaranteedTimeDeliverFilter: string | undefined, isUserRequestsToBePublicTheLocationFilter: number | undefined, locationGroupTitleFilter: string | undefined, locationTypeTitleFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Locations/GetLocationsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (isPublicOrPrivateFilter === null)
            throw new Error("The parameter 'isPublicOrPrivateFilter' cannot be null.");
        else if (isPublicOrPrivateFilter !== undefined)
            url_ += "IsPublicOrPrivateFilter=" + encodeURIComponent("" + isPublicOrPrivateFilter) + "&"; 
        if (ownerFilter === null)
            throw new Error("The parameter 'ownerFilter' cannot be null.");
        else if (ownerFilter !== undefined)
            url_ += "OwnerFilter=" + encodeURIComponent("" + ownerFilter) + "&"; 
        if (ownerPhoneNoFilter === null)
            throw new Error("The parameter 'ownerPhoneNoFilter' cannot be null.");
        else if (ownerPhoneNoFilter !== undefined)
            url_ += "OwnerPhoneNoFilter=" + encodeURIComponent("" + ownerPhoneNoFilter) + "&"; 
        if (guaranteedTimeDeliverFilter === null)
            throw new Error("The parameter 'guaranteedTimeDeliverFilter' cannot be null.");
        else if (guaranteedTimeDeliverFilter !== undefined)
            url_ += "GuaranteedTimeDeliverFilter=" + encodeURIComponent("" + guaranteedTimeDeliverFilter) + "&"; 
        if (isUserRequestsToBePublicTheLocationFilter === null)
            throw new Error("The parameter 'isUserRequestsToBePublicTheLocationFilter' cannot be null.");
        else if (isUserRequestsToBePublicTheLocationFilter !== undefined)
            url_ += "IsUserRequestsToBePublicTheLocationFilter=" + encodeURIComponent("" + isUserRequestsToBePublicTheLocationFilter) + "&"; 
        if (locationGroupTitleFilter === null)
            throw new Error("The parameter 'locationGroupTitleFilter' cannot be null.");
        else if (locationGroupTitleFilter !== undefined)
            url_ += "LocationGroupTitleFilter=" + encodeURIComponent("" + locationGroupTitleFilter) + "&"; 
        if (locationTypeTitleFilter === null)
            throw new Error("The parameter 'locationTypeTitleFilter' cannot be null.");
        else if (locationTypeTitleFilter !== undefined)
            url_ += "LocationTypeTitleFilter=" + encodeURIComponent("" + locationTypeTitleFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetLocationsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllLocationGroupForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfLocationLocationGroupLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Locations/GetAllLocationGroupForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLocationGroupForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLocationGroupForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfLocationLocationGroupLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfLocationLocationGroupLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllLocationGroupForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfLocationLocationGroupLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLocationLocationGroupLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfLocationLocationGroupLookupTableDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllLocationTypeForTableDropdown(): Observable<LocationLocationTypeLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Locations/GetAllLocationTypeForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLocationTypeForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLocationTypeForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<LocationLocationTypeLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LocationLocationTypeLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllLocationTypeForTableDropdown(response: HttpResponseBase): Observable<LocationLocationTypeLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationLocationTypeLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationLocationTypeLookupTableDto[]>(<any>null);
    }

    /**
     * @param lat (optional) 
     * @param lng (optional) 
     * @return Success
     */
    getReverseGeocoding(lat: string | undefined, lng: string | undefined): Observable<ReverseGeocodingDto> {
        let url_ = this.baseUrl + "/api/services/app/Locations/GetReverseGeocoding?";
        if (lat === null)
            throw new Error("The parameter 'lat' cannot be null.");
        else if (lat !== undefined)
            url_ += "lat=" + encodeURIComponent("" + lat) + "&"; 
        if (lng === null)
            throw new Error("The parameter 'lng' cannot be null.");
        else if (lng !== undefined)
            url_ += "lng=" + encodeURIComponent("" + lng) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReverseGeocoding(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReverseGeocoding(<any>response_);
                } catch (e) {
                    return <Observable<ReverseGeocodingDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReverseGeocodingDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetReverseGeocoding(response: HttpResponseBase): Observable<ReverseGeocodingDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReverseGeocodingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReverseGeocodingDto>(<any>null);
    }

    /**
     * @param term (optional) 
     * @param lat (optional) 
     * @param lng (optional) 
     * @return Success
     */
    getSearchLocation(term: string | undefined, lat: string | undefined, lng: string | undefined): Observable<GetSearchLocationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Locations/GetSearchLocation?";
        if (term === null)
            throw new Error("The parameter 'term' cannot be null.");
        else if (term !== undefined)
            url_ += "term=" + encodeURIComponent("" + term) + "&"; 
        if (lat === null)
            throw new Error("The parameter 'lat' cannot be null.");
        else if (lat !== undefined)
            url_ += "lat=" + encodeURIComponent("" + lat) + "&"; 
        if (lng === null)
            throw new Error("The parameter 'lng' cannot be null.");
        else if (lng !== undefined)
            url_ += "lng=" + encodeURIComponent("" + lng) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSearchLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSearchLocation(<any>response_);
                } catch (e) {
                    return <Observable<GetSearchLocationDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSearchLocationDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetSearchLocation(response: HttpResponseBase): Observable<GetSearchLocationDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetSearchLocationDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSearchLocationDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    mergeAndSave(body: MergeAndSaveInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Locations/MergeAndSave";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMergeAndSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMergeAndSave(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processMergeAndSave(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class LocationTypesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, titleFilter: string | undefined, isActiveFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetLocationTypeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/LocationTypes/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (isActiveFilter === null)
            throw new Error("The parameter 'isActiveFilter' cannot be null.");
        else if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetLocationTypeForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetLocationTypeForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetLocationTypeForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetLocationTypeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetLocationTypeForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLocationTypeForView(id: number | undefined): Observable<GetLocationTypeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/LocationTypes/GetLocationTypeForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationTypeForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationTypeForView(<any>response_);
                } catch (e) {
                    return <Observable<GetLocationTypeForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetLocationTypeForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetLocationTypeForView(response: HttpResponseBase): Observable<GetLocationTypeForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLocationTypeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationTypeForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLocationTypeForEdit(id: number | undefined): Observable<GetLocationTypeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/LocationTypes/GetLocationTypeForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationTypeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationTypeForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetLocationTypeForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetLocationTypeForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetLocationTypeForEdit(response: HttpResponseBase): Observable<GetLocationTypeForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLocationTypeForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationTypeForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditLocationTypeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LocationTypes/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LocationTypes/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param isActiveFilter (optional) 
     * @return Success
     */
    getLocationTypesToExcel(filter: string | undefined, titleFilter: string | undefined, isActiveFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/LocationTypes/GetLocationTypesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (isActiveFilter === null)
            throw new Error("The parameter 'isActiveFilter' cannot be null.");
        else if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationTypesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationTypesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetLocationTypesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class MoneyBoxesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param typeFilter (optional) 
     * @param titleFilter (optional) 
     * @param planConstTitleFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, typeFilter: number | undefined, titleFilter: string | undefined, planConstTitleFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetMoneyBoxForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MoneyBoxes/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (typeFilter === null)
            throw new Error("The parameter 'typeFilter' cannot be null.");
        else if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (planConstTitleFilter === null)
            throw new Error("The parameter 'planConstTitleFilter' cannot be null.");
        else if (planConstTitleFilter !== undefined)
            url_ += "PlanConstTitleFilter=" + encodeURIComponent("" + planConstTitleFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetMoneyBoxForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetMoneyBoxForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetMoneyBoxForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetMoneyBoxForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetMoneyBoxForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getMoneyBoxForView(id: number | undefined): Observable<GetMoneyBoxForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MoneyBoxes/GetMoneyBoxForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMoneyBoxForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMoneyBoxForView(<any>response_);
                } catch (e) {
                    return <Observable<GetMoneyBoxForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMoneyBoxForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMoneyBoxForView(response: HttpResponseBase): Observable<GetMoneyBoxForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMoneyBoxForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMoneyBoxForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getMoneyBoxForEdit(id: number | undefined): Observable<GetMoneyBoxForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/MoneyBoxes/GetMoneyBoxForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMoneyBoxForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMoneyBoxForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetMoneyBoxForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMoneyBoxForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetMoneyBoxForEdit(response: HttpResponseBase): Observable<GetMoneyBoxForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMoneyBoxForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMoneyBoxForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditMoneyBoxDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MoneyBoxes/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MoneyBoxes/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param typeFilter (optional) 
     * @param titleFilter (optional) 
     * @param planConstTitleFilter (optional) 
     * @return Success
     */
    getMoneyBoxesToExcel(filter: string | undefined, typeFilter: number | undefined, titleFilter: string | undefined, planConstTitleFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MoneyBoxes/GetMoneyBoxesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (typeFilter === null)
            throw new Error("The parameter 'typeFilter' cannot be null.");
        else if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (planConstTitleFilter === null)
            throw new Error("The parameter 'planConstTitleFilter' cannot be null.");
        else if (planConstTitleFilter !== undefined)
            url_ += "PlanConstTitleFilter=" + encodeURIComponent("" + planConstTitleFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMoneyBoxesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMoneyBoxesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMoneyBoxesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllPlanConstForTableDropdown(): Observable<MoneyBoxPlanConstLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MoneyBoxes/GetAllPlanConstForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPlanConstForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPlanConstForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<MoneyBoxPlanConstLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MoneyBoxPlanConstLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPlanConstForTableDropdown(response: HttpResponseBase): Observable<MoneyBoxPlanConstLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MoneyBoxPlanConstLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MoneyBoxPlanConstLookupTableDto[]>(<any>null);
    }
}

@Injectable()
export class MoneyBoxEventsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxAmountFilter (optional) 
     * @param minAmountFilter (optional) 
     * @param lastStatusFilter (optional) 
     * @param planBillCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, maxAmountFilter: number | undefined, minAmountFilter: number | undefined, lastStatusFilter: number | undefined, planBillCodeFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetMoneyBoxEventForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MoneyBoxEvents/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxAmountFilter === null)
            throw new Error("The parameter 'maxAmountFilter' cannot be null.");
        else if (maxAmountFilter !== undefined)
            url_ += "MaxAmountFilter=" + encodeURIComponent("" + maxAmountFilter) + "&"; 
        if (minAmountFilter === null)
            throw new Error("The parameter 'minAmountFilter' cannot be null.");
        else if (minAmountFilter !== undefined)
            url_ += "MinAmountFilter=" + encodeURIComponent("" + minAmountFilter) + "&"; 
        if (lastStatusFilter === null)
            throw new Error("The parameter 'lastStatusFilter' cannot be null.");
        else if (lastStatusFilter !== undefined)
            url_ += "LastStatusFilter=" + encodeURIComponent("" + lastStatusFilter) + "&"; 
        if (planBillCodeFilter === null)
            throw new Error("The parameter 'planBillCodeFilter' cannot be null.");
        else if (planBillCodeFilter !== undefined)
            url_ += "PlanBillCodeFilter=" + encodeURIComponent("" + planBillCodeFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetMoneyBoxEventForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetMoneyBoxEventForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetMoneyBoxEventForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetMoneyBoxEventForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetMoneyBoxEventForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getMoneyBoxEventForView(id: number | undefined): Observable<GetMoneyBoxEventForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MoneyBoxEvents/GetMoneyBoxEventForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMoneyBoxEventForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMoneyBoxEventForView(<any>response_);
                } catch (e) {
                    return <Observable<GetMoneyBoxEventForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMoneyBoxEventForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMoneyBoxEventForView(response: HttpResponseBase): Observable<GetMoneyBoxEventForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMoneyBoxEventForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMoneyBoxEventForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getMoneyBoxEventForEdit(id: number | undefined): Observable<GetMoneyBoxEventForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/MoneyBoxEvents/GetMoneyBoxEventForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMoneyBoxEventForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMoneyBoxEventForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetMoneyBoxEventForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMoneyBoxEventForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetMoneyBoxEventForEdit(response: HttpResponseBase): Observable<GetMoneyBoxEventForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMoneyBoxEventForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMoneyBoxEventForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditMoneyBoxEventDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MoneyBoxEvents/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MoneyBoxEvents/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param maxAmountFilter (optional) 
     * @param minAmountFilter (optional) 
     * @param lastStatusFilter (optional) 
     * @param planBillCodeFilter (optional) 
     * @return Success
     */
    getMoneyBoxEventsToExcel(filter: string | undefined, maxAmountFilter: number | undefined, minAmountFilter: number | undefined, lastStatusFilter: number | undefined, planBillCodeFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MoneyBoxEvents/GetMoneyBoxEventsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxAmountFilter === null)
            throw new Error("The parameter 'maxAmountFilter' cannot be null.");
        else if (maxAmountFilter !== undefined)
            url_ += "MaxAmountFilter=" + encodeURIComponent("" + maxAmountFilter) + "&"; 
        if (minAmountFilter === null)
            throw new Error("The parameter 'minAmountFilter' cannot be null.");
        else if (minAmountFilter !== undefined)
            url_ += "MinAmountFilter=" + encodeURIComponent("" + minAmountFilter) + "&"; 
        if (lastStatusFilter === null)
            throw new Error("The parameter 'lastStatusFilter' cannot be null.");
        else if (lastStatusFilter !== undefined)
            url_ += "LastStatusFilter=" + encodeURIComponent("" + lastStatusFilter) + "&"; 
        if (planBillCodeFilter === null)
            throw new Error("The parameter 'planBillCodeFilter' cannot be null.");
        else if (planBillCodeFilter !== undefined)
            url_ += "PlanBillCodeFilter=" + encodeURIComponent("" + planBillCodeFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMoneyBoxEventsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMoneyBoxEventsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMoneyBoxEventsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllPlanBillForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfMoneyBoxEventPlanBillLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/MoneyBoxEvents/GetAllPlanBillForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPlanBillForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPlanBillForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfMoneyBoxEventPlanBillLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfMoneyBoxEventPlanBillLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPlanBillForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfMoneyBoxEventPlanBillLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMoneyBoxEventPlanBillLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfMoneyBoxEventPlanBillLookupTableDto>(<any>null);
    }
}

@Injectable()
export class NewslettersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param mobileNumberFilter (optional) 
     * @param contactFirstNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, mobileNumberFilter: string | undefined, contactFirstNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetNewsletterForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Newsletters/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (mobileNumberFilter === null)
            throw new Error("The parameter 'mobileNumberFilter' cannot be null.");
        else if (mobileNumberFilter !== undefined)
            url_ += "MobileNumberFilter=" + encodeURIComponent("" + mobileNumberFilter) + "&"; 
        if (contactFirstNameFilter === null)
            throw new Error("The parameter 'contactFirstNameFilter' cannot be null.");
        else if (contactFirstNameFilter !== undefined)
            url_ += "ContactFirstNameFilter=" + encodeURIComponent("" + contactFirstNameFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetNewsletterForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetNewsletterForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetNewsletterForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetNewsletterForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetNewsletterForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getNewsletterForView(id: number | undefined): Observable<GetNewsletterForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Newsletters/GetNewsletterForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewsletterForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewsletterForView(<any>response_);
                } catch (e) {
                    return <Observable<GetNewsletterForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetNewsletterForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetNewsletterForView(response: HttpResponseBase): Observable<GetNewsletterForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNewsletterForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNewsletterForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getNewsletterForEdit(id: number | undefined): Observable<GetNewsletterForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Newsletters/GetNewsletterForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewsletterForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewsletterForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetNewsletterForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetNewsletterForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetNewsletterForEdit(response: HttpResponseBase): Observable<GetNewsletterForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNewsletterForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNewsletterForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditNewsletterDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Newsletters/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Newsletters/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param mobileNumberFilter (optional) 
     * @param contactFirstNameFilter (optional) 
     * @return Success
     */
    getNewslettersToExcel(filter: string | undefined, mobileNumberFilter: string | undefined, contactFirstNameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Newsletters/GetNewslettersToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (mobileNumberFilter === null)
            throw new Error("The parameter 'mobileNumberFilter' cannot be null.");
        else if (mobileNumberFilter !== undefined)
            url_ += "MobileNumberFilter=" + encodeURIComponent("" + mobileNumberFilter) + "&"; 
        if (contactFirstNameFilter === null)
            throw new Error("The parameter 'contactFirstNameFilter' cannot be null.");
        else if (contactFirstNameFilter !== undefined)
            url_ += "ContactFirstNameFilter=" + encodeURIComponent("" + contactFirstNameFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewslettersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewslettersToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetNewslettersToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllContactForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfNewsletterContactLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Newsletters/GetAllContactForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllContactForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllContactForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfNewsletterContactLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfNewsletterContactLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllContactForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfNewsletterContactLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNewsletterContactLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfNewsletterContactLookupTableDto>(<any>null);
    }
}

@Injectable()
export class NoticesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxEntityRefFilter (optional) 
     * @param minEntityRefFilter (optional) 
     * @param entityFilter (optional) 
     * @param contactFirstNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, maxEntityRefFilter: number | undefined, minEntityRefFilter: number | undefined, entityFilter: number | undefined, contactFirstNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetNoticeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Notices/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxEntityRefFilter === null)
            throw new Error("The parameter 'maxEntityRefFilter' cannot be null.");
        else if (maxEntityRefFilter !== undefined)
            url_ += "MaxEntityRefFilter=" + encodeURIComponent("" + maxEntityRefFilter) + "&"; 
        if (minEntityRefFilter === null)
            throw new Error("The parameter 'minEntityRefFilter' cannot be null.");
        else if (minEntityRefFilter !== undefined)
            url_ += "MinEntityRefFilter=" + encodeURIComponent("" + minEntityRefFilter) + "&"; 
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (contactFirstNameFilter === null)
            throw new Error("The parameter 'contactFirstNameFilter' cannot be null.");
        else if (contactFirstNameFilter !== undefined)
            url_ += "ContactFirstNameFilter=" + encodeURIComponent("" + contactFirstNameFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetNoticeForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetNoticeForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetNoticeForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetNoticeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetNoticeForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getNoticeForView(id: number | undefined): Observable<GetNoticeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Notices/GetNoticeForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNoticeForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNoticeForView(<any>response_);
                } catch (e) {
                    return <Observable<GetNoticeForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetNoticeForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetNoticeForView(response: HttpResponseBase): Observable<GetNoticeForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNoticeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNoticeForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getNoticeForEdit(id: number | undefined): Observable<GetNoticeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notices/GetNoticeForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNoticeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNoticeForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetNoticeForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetNoticeForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetNoticeForEdit(response: HttpResponseBase): Observable<GetNoticeForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNoticeForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNoticeForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditNoticeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notices/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notices/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param maxEntityRefFilter (optional) 
     * @param minEntityRefFilter (optional) 
     * @param entityFilter (optional) 
     * @param contactFirstNameFilter (optional) 
     * @return Success
     */
    getNoticesToExcel(filter: string | undefined, maxEntityRefFilter: number | undefined, minEntityRefFilter: number | undefined, entityFilter: number | undefined, contactFirstNameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Notices/GetNoticesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxEntityRefFilter === null)
            throw new Error("The parameter 'maxEntityRefFilter' cannot be null.");
        else if (maxEntityRefFilter !== undefined)
            url_ += "MaxEntityRefFilter=" + encodeURIComponent("" + maxEntityRefFilter) + "&"; 
        if (minEntityRefFilter === null)
            throw new Error("The parameter 'minEntityRefFilter' cannot be null.");
        else if (minEntityRefFilter !== undefined)
            url_ += "MinEntityRefFilter=" + encodeURIComponent("" + minEntityRefFilter) + "&"; 
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (contactFirstNameFilter === null)
            throw new Error("The parameter 'contactFirstNameFilter' cannot be null.");
        else if (contactFirstNameFilter !== undefined)
            url_ += "ContactFirstNameFilter=" + encodeURIComponent("" + contactFirstNameFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNoticesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNoticesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetNoticesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllContactForTableDropdown(): Observable<NoticeContactLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Notices/GetAllContactForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllContactForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllContactForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<NoticeContactLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NoticeContactLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllContactForTableDropdown(response: HttpResponseBase): Observable<NoticeContactLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NoticeContactLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NoticeContactLookupTableDto[]>(<any>null);
    }
}

@Injectable()
export class NotificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param state (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getUserNotifications(state: UserNotificationState | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetNotificationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetUserNotifications?";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&"; 
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserNotifications(<any>response_);
                } catch (e) {
                    return <Observable<GetNotificationsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetNotificationsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserNotifications(response: HttpResponseBase): Observable<GetNotificationsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNotificationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNotificationsOutput>(<any>null);
    }

    /**
     * @return Success
     */
    setAllNotificationsAsRead(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetAllNotificationsAsRead";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAllNotificationsAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAllNotificationsAsRead(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetAllNotificationsAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setNotificationAsRead(body: EntityDtoOfGuid | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetNotificationAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetNotificationAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetNotificationAsRead(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetNotificationAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getNotificationSettings(): Observable<GetNotificationSettingsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationSettings(<any>response_);
                } catch (e) {
                    return <Observable<GetNotificationSettingsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetNotificationSettingsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetNotificationSettings(response: HttpResponseBase): Observable<GetNotificationSettingsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNotificationSettingsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNotificationSettingsOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateNotificationSettings(body: UpdateNotificationSettingsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/UpdateNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNotificationSettings(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateNotificationSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteNotification(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/DeleteNotification?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteNotification(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param state (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    deleteAllUserNotifications(state: UserNotificationState | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/DeleteAllUserNotifications?";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&"; 
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAllUserNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAllUserNotifications(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteAllUserNotifications(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class NotificationKeysServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param deviceIdFilter (optional) 
     * @param contactFirstNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, deviceIdFilter: string | undefined, contactFirstNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetNotificationKeyForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/NotificationKeys/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (deviceIdFilter === null)
            throw new Error("The parameter 'deviceIdFilter' cannot be null.");
        else if (deviceIdFilter !== undefined)
            url_ += "DeviceIdFilter=" + encodeURIComponent("" + deviceIdFilter) + "&"; 
        if (contactFirstNameFilter === null)
            throw new Error("The parameter 'contactFirstNameFilter' cannot be null.");
        else if (contactFirstNameFilter !== undefined)
            url_ += "ContactFirstNameFilter=" + encodeURIComponent("" + contactFirstNameFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetNotificationKeyForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetNotificationKeyForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetNotificationKeyForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetNotificationKeyForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetNotificationKeyForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getNotificationKeyForView(id: number | undefined): Observable<GetNotificationKeyForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/NotificationKeys/GetNotificationKeyForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotificationKeyForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationKeyForView(<any>response_);
                } catch (e) {
                    return <Observable<GetNotificationKeyForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetNotificationKeyForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetNotificationKeyForView(response: HttpResponseBase): Observable<GetNotificationKeyForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNotificationKeyForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNotificationKeyForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getNotificationKeyForEdit(id: number | undefined): Observable<GetNotificationKeyForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/NotificationKeys/GetNotificationKeyForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotificationKeyForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationKeyForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetNotificationKeyForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetNotificationKeyForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetNotificationKeyForEdit(response: HttpResponseBase): Observable<GetNotificationKeyForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNotificationKeyForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNotificationKeyForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditNotificationKeyDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/NotificationKeys/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/NotificationKeys/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param deviceIdFilter (optional) 
     * @param contactFirstNameFilter (optional) 
     * @return Success
     */
    getNotificationKeysToExcel(filter: string | undefined, deviceIdFilter: string | undefined, contactFirstNameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/NotificationKeys/GetNotificationKeysToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (deviceIdFilter === null)
            throw new Error("The parameter 'deviceIdFilter' cannot be null.");
        else if (deviceIdFilter !== undefined)
            url_ += "DeviceIdFilter=" + encodeURIComponent("" + deviceIdFilter) + "&"; 
        if (contactFirstNameFilter === null)
            throw new Error("The parameter 'contactFirstNameFilter' cannot be null.");
        else if (contactFirstNameFilter !== undefined)
            url_ += "ContactFirstNameFilter=" + encodeURIComponent("" + contactFirstNameFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotificationKeysToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationKeysToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetNotificationKeysToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllContactForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfNotificationKeyContactLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/NotificationKeys/GetAllContactForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllContactForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllContactForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfNotificationKeyContactLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfNotificationKeyContactLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllContactForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfNotificationKeyContactLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNotificationKeyContactLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfNotificationKeyContactLookupTableDto>(<any>null);
    }
}

@Injectable()
export class NotifyJobsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxEntityRefFilter (optional) 
     * @param minEntityRefFilter (optional) 
     * @param entityFilter (optional) 
     * @param maxJobIdFilter (optional) 
     * @param minJobIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, maxEntityRefFilter: number | undefined, minEntityRefFilter: number | undefined, entityFilter: number | undefined, maxJobIdFilter: number | undefined, minJobIdFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetNotifyJobForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/NotifyJobs/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxEntityRefFilter === null)
            throw new Error("The parameter 'maxEntityRefFilter' cannot be null.");
        else if (maxEntityRefFilter !== undefined)
            url_ += "MaxEntityRefFilter=" + encodeURIComponent("" + maxEntityRefFilter) + "&"; 
        if (minEntityRefFilter === null)
            throw new Error("The parameter 'minEntityRefFilter' cannot be null.");
        else if (minEntityRefFilter !== undefined)
            url_ += "MinEntityRefFilter=" + encodeURIComponent("" + minEntityRefFilter) + "&"; 
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (maxJobIdFilter === null)
            throw new Error("The parameter 'maxJobIdFilter' cannot be null.");
        else if (maxJobIdFilter !== undefined)
            url_ += "MaxJobIdFilter=" + encodeURIComponent("" + maxJobIdFilter) + "&"; 
        if (minJobIdFilter === null)
            throw new Error("The parameter 'minJobIdFilter' cannot be null.");
        else if (minJobIdFilter !== undefined)
            url_ += "MinJobIdFilter=" + encodeURIComponent("" + minJobIdFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetNotifyJobForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetNotifyJobForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetNotifyJobForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetNotifyJobForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetNotifyJobForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getNotifyJobForView(id: number | undefined): Observable<GetNotifyJobForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/NotifyJobs/GetNotifyJobForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotifyJobForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotifyJobForView(<any>response_);
                } catch (e) {
                    return <Observable<GetNotifyJobForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetNotifyJobForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetNotifyJobForView(response: HttpResponseBase): Observable<GetNotifyJobForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNotifyJobForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNotifyJobForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getNotifyJobForEdit(id: number | undefined): Observable<GetNotifyJobForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/NotifyJobs/GetNotifyJobForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotifyJobForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotifyJobForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetNotifyJobForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetNotifyJobForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetNotifyJobForEdit(response: HttpResponseBase): Observable<GetNotifyJobForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNotifyJobForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNotifyJobForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditNotifyJobDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/NotifyJobs/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/NotifyJobs/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param maxEntityRefFilter (optional) 
     * @param minEntityRefFilter (optional) 
     * @param entityFilter (optional) 
     * @param maxJobIdFilter (optional) 
     * @param minJobIdFilter (optional) 
     * @return Success
     */
    getNotifyJobsToExcel(filter: string | undefined, maxEntityRefFilter: number | undefined, minEntityRefFilter: number | undefined, entityFilter: number | undefined, maxJobIdFilter: number | undefined, minJobIdFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/NotifyJobs/GetNotifyJobsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxEntityRefFilter === null)
            throw new Error("The parameter 'maxEntityRefFilter' cannot be null.");
        else if (maxEntityRefFilter !== undefined)
            url_ += "MaxEntityRefFilter=" + encodeURIComponent("" + maxEntityRefFilter) + "&"; 
        if (minEntityRefFilter === null)
            throw new Error("The parameter 'minEntityRefFilter' cannot be null.");
        else if (minEntityRefFilter !== undefined)
            url_ += "MinEntityRefFilter=" + encodeURIComponent("" + minEntityRefFilter) + "&"; 
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (maxJobIdFilter === null)
            throw new Error("The parameter 'maxJobIdFilter' cannot be null.");
        else if (maxJobIdFilter !== undefined)
            url_ += "MaxJobIdFilter=" + encodeURIComponent("" + maxJobIdFilter) + "&"; 
        if (minJobIdFilter === null)
            throw new Error("The parameter 'minJobIdFilter' cannot be null.");
        else if (minJobIdFilter !== undefined)
            url_ += "MinJobIdFilter=" + encodeURIComponent("" + minJobIdFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotifyJobsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotifyJobsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetNotifyJobsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class OrganizationUnitServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getOrganizationUnits(): Observable<ListResultDtoOfOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnits";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnits(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfOrganizationUnitDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfOrganizationUnitDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrganizationUnits(response: HttpResponseBase): Observable<ListResultDtoOfOrganizationUnitDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfOrganizationUnitDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getOrganizationUnitUsers(id: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfOrganizationUnitUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitUsers?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnitUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnitUsers(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfOrganizationUnitUserListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfOrganizationUnitUserListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrganizationUnitUsers(response: HttpResponseBase): Observable<PagedResultDtoOfOrganizationUnitUserListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOrganizationUnitUserListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfOrganizationUnitUserListDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getOrganizationUnitRoles(id: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfOrganizationUnitRoleListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitRoles?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnitRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnitRoles(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfOrganizationUnitRoleListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfOrganizationUnitRoleListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrganizationUnitRoles(response: HttpResponseBase): Observable<PagedResultDtoOfOrganizationUnitRoleListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOrganizationUnitRoleListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfOrganizationUnitRoleListDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrganizationUnit(body: CreateOrganizationUnitInput | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/CreateOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrganizationUnit(<any>response_);
                } catch (e) {
                    return <Observable<OrganizationUnitDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrganizationUnitDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrganizationUnitDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateOrganizationUnit(body: UpdateOrganizationUnitInput | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/UpdateOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrganizationUnit(<any>response_);
                } catch (e) {
                    return <Observable<OrganizationUnitDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrganizationUnitDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrganizationUnitDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    moveOrganizationUnit(body: MoveOrganizationUnitInput | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/MoveOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveOrganizationUnit(<any>response_);
                } catch (e) {
                    return <Observable<OrganizationUnitDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrganizationUnitDto>><any>_observableThrow(response_);
        }));
    }

    protected processMoveOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrganizationUnitDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteOrganizationUnit(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/DeleteOrganizationUnit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOrganizationUnit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @param organizationUnitId (optional) 
     * @return Success
     */
    removeUserFromOrganizationUnit(userId: number | undefined, organizationUnitId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/RemoveUserFromOrganizationUnit?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUserFromOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUserFromOrganizationUnit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveUserFromOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param roleId (optional) 
     * @param organizationUnitId (optional) 
     * @return Success
     */
    removeRoleFromOrganizationUnit(roleId: number | undefined, organizationUnitId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/RemoveRoleFromOrganizationUnit?";
        if (roleId === null)
            throw new Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "RoleId=" + encodeURIComponent("" + roleId) + "&"; 
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveRoleFromOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveRoleFromOrganizationUnit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveRoleFromOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addUsersToOrganizationUnit(body: UsersToOrganizationUnitInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/AddUsersToOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUsersToOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUsersToOrganizationUnit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAddUsersToOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addRolesToOrganizationUnit(body: RolesToOrganizationUnitInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/AddRolesToOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddRolesToOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddRolesToOrganizationUnit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAddRolesToOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    findUsers(body: FindOrganizationUnitUsersInput | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/FindUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindUsers(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfNameValueDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfNameValueDto>><any>_observableThrow(response_);
        }));
    }

    protected processFindUsers(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfNameValueDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    findRoles(body: FindOrganizationUnitRolesInput | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/FindRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindRoles(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfNameValueDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfNameValueDto>><any>_observableThrow(response_);
        }));
    }

    protected processFindRoles(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfNameValueDto>(<any>null);
    }
}

@Injectable()
export class PaymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param upgradeEditionId (optional) 
     * @return Success
     */
    getPaymentInfo(upgradeEditionId: number | undefined): Observable<PaymentInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetPaymentInfo?";
        if (upgradeEditionId === null)
            throw new Error("The parameter 'upgradeEditionId' cannot be null.");
        else if (upgradeEditionId !== undefined)
            url_ += "UpgradeEditionId=" + encodeURIComponent("" + upgradeEditionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentInfo(<any>response_);
                } catch (e) {
                    return <Observable<PaymentInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaymentInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentInfo(response: HttpResponseBase): Observable<PaymentInfoDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentInfoDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPayment(body: CreatePaymentDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Payment/CreatePayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePayment(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreatePayment(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cancelPayment(body: CancelPaymentDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/CancelPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelPayment(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCancelPayment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaymentHistory(sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfSubscriptionPaymentListDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetPaymentHistory?";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentHistory(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfSubscriptionPaymentListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfSubscriptionPaymentListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentHistory(response: HttpResponseBase): Observable<PagedResultDtoOfSubscriptionPaymentListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSubscriptionPaymentListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfSubscriptionPaymentListDto>(<any>null);
    }

    /**
     * @param recurringPaymentsEnabled (optional) 
     * @return Success
     */
    getActiveGateways(recurringPaymentsEnabled: boolean | undefined): Observable<PaymentGatewayModel[]> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetActiveGateways?";
        if (recurringPaymentsEnabled === null)
            throw new Error("The parameter 'recurringPaymentsEnabled' cannot be null.");
        else if (recurringPaymentsEnabled !== undefined)
            url_ += "RecurringPaymentsEnabled=" + encodeURIComponent("" + recurringPaymentsEnabled) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveGateways(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveGateways(<any>response_);
                } catch (e) {
                    return <Observable<PaymentGatewayModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaymentGatewayModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetActiveGateways(response: HttpResponseBase): Observable<PaymentGatewayModel[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaymentGatewayModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentGatewayModel[]>(<any>null);
    }

    /**
     * @param paymentId (optional) 
     * @return Success
     */
    getPayment(paymentId: number | undefined): Observable<SubscriptionPaymentDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetPayment?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayment(<any>response_);
                } catch (e) {
                    return <Observable<SubscriptionPaymentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubscriptionPaymentDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPayment(response: HttpResponseBase): Observable<SubscriptionPaymentDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionPaymentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubscriptionPaymentDto>(<any>null);
    }

    /**
     * @return Success
     */
    getLastCompletedPayment(): Observable<SubscriptionPaymentDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetLastCompletedPayment";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastCompletedPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastCompletedPayment(<any>response_);
                } catch (e) {
                    return <Observable<SubscriptionPaymentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubscriptionPaymentDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetLastCompletedPayment(response: HttpResponseBase): Observable<SubscriptionPaymentDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionPaymentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubscriptionPaymentDto>(<any>null);
    }

    /**
     * @param paymentId (optional) 
     * @return Success
     */
    buyNowSucceed(paymentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/BuyNowSucceed?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuyNowSucceed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuyNowSucceed(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processBuyNowSucceed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param paymentId (optional) 
     * @return Success
     */
    newRegistrationSucceed(paymentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/NewRegistrationSucceed?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewRegistrationSucceed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewRegistrationSucceed(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processNewRegistrationSucceed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param paymentId (optional) 
     * @return Success
     */
    upgradeSucceed(paymentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/UpgradeSucceed?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpgradeSucceed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpgradeSucceed(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpgradeSucceed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param paymentId (optional) 
     * @return Success
     */
    extendSucceed(paymentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/ExtendSucceed?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtendSucceed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtendSucceed(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExtendSucceed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param paymentId (optional) 
     * @return Success
     */
    paymentFailed(paymentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/PaymentFailed?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaymentFailed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaymentFailed(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPaymentFailed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class PaymentsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param paymentTypeFilter (optional) 
     * @param panCardFilter (optional) 
     * @param maxPaymentDateTimeFilter (optional) 
     * @param minPaymentDateTimeFilter (optional) 
     * @param bankTrackingNOFilter (optional) 
     * @param bankSerialNOFilter (optional) 
     * @param maxPriceFilter (optional) 
     * @param minPriceFilter (optional) 
     * @param paymentStatusFilter (optional) 
     * @param contactMobileNumber (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, paymentTypeFilter: number | undefined, panCardFilter: string | undefined, maxPaymentDateTimeFilter: moment.Moment | undefined, minPaymentDateTimeFilter: moment.Moment | undefined, bankTrackingNOFilter: string | undefined, bankSerialNOFilter: string | undefined, maxPriceFilter: number | undefined, minPriceFilter: number | undefined, paymentStatusFilter: number | undefined, contactMobileNumber: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetPaymentForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Payments/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (paymentTypeFilter === null)
            throw new Error("The parameter 'paymentTypeFilter' cannot be null.");
        else if (paymentTypeFilter !== undefined)
            url_ += "PaymentTypeFilter=" + encodeURIComponent("" + paymentTypeFilter) + "&"; 
        if (panCardFilter === null)
            throw new Error("The parameter 'panCardFilter' cannot be null.");
        else if (panCardFilter !== undefined)
            url_ += "PanCardFilter=" + encodeURIComponent("" + panCardFilter) + "&"; 
        if (maxPaymentDateTimeFilter === null)
            throw new Error("The parameter 'maxPaymentDateTimeFilter' cannot be null.");
        else if (maxPaymentDateTimeFilter !== undefined)
            url_ += "MaxPaymentDateTimeFilter=" + encodeURIComponent(maxPaymentDateTimeFilter ? "" + maxPaymentDateTimeFilter.toJSON() : "") + "&"; 
        if (minPaymentDateTimeFilter === null)
            throw new Error("The parameter 'minPaymentDateTimeFilter' cannot be null.");
        else if (minPaymentDateTimeFilter !== undefined)
            url_ += "MinPaymentDateTimeFilter=" + encodeURIComponent(minPaymentDateTimeFilter ? "" + minPaymentDateTimeFilter.toJSON() : "") + "&"; 
        if (bankTrackingNOFilter === null)
            throw new Error("The parameter 'bankTrackingNOFilter' cannot be null.");
        else if (bankTrackingNOFilter !== undefined)
            url_ += "BankTrackingNOFilter=" + encodeURIComponent("" + bankTrackingNOFilter) + "&"; 
        if (bankSerialNOFilter === null)
            throw new Error("The parameter 'bankSerialNOFilter' cannot be null.");
        else if (bankSerialNOFilter !== undefined)
            url_ += "BankSerialNOFilter=" + encodeURIComponent("" + bankSerialNOFilter) + "&"; 
        if (maxPriceFilter === null)
            throw new Error("The parameter 'maxPriceFilter' cannot be null.");
        else if (maxPriceFilter !== undefined)
            url_ += "MaxPriceFilter=" + encodeURIComponent("" + maxPriceFilter) + "&"; 
        if (minPriceFilter === null)
            throw new Error("The parameter 'minPriceFilter' cannot be null.");
        else if (minPriceFilter !== undefined)
            url_ += "MinPriceFilter=" + encodeURIComponent("" + minPriceFilter) + "&"; 
        if (paymentStatusFilter === null)
            throw new Error("The parameter 'paymentStatusFilter' cannot be null.");
        else if (paymentStatusFilter !== undefined)
            url_ += "PaymentStatusFilter=" + encodeURIComponent("" + paymentStatusFilter) + "&"; 
        if (contactMobileNumber === null)
            throw new Error("The parameter 'contactMobileNumber' cannot be null.");
        else if (contactMobileNumber !== undefined)
            url_ += "ContactMobileNumber=" + encodeURIComponent("" + contactMobileNumber) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetPaymentForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetPaymentForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetPaymentForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetPaymentForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetPaymentForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPaymentForView(id: number | undefined): Observable<GetPaymentForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Payments/GetPaymentForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentForView(<any>response_);
                } catch (e) {
                    return <Observable<GetPaymentForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPaymentForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentForView(response: HttpResponseBase): Observable<GetPaymentForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPaymentForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPaymentForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPaymentForEdit(id: number | undefined): Observable<GetPaymentForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Payments/GetPaymentForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetPaymentForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPaymentForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentForEdit(response: HttpResponseBase): Observable<GetPaymentForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPaymentForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPaymentForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPaymentAndEditBill(body: PaymentAndBillInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payments/CreatePaymentAndEditBill";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePaymentAndEditBill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePaymentAndEditBill(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreatePaymentAndEditBill(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditPaymentDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payments/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAndGetId(body: CreateOrEditPaymentDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Payments/CreateAndGetId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAndGetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAndGetId(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateAndGetId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payments/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param paymentTypeFilter (optional) 
     * @param panCardFilter (optional) 
     * @param maxPaymentDateTimeFilter (optional) 
     * @param minPaymentDateTimeFilter (optional) 
     * @param bankTrackingNOFilter (optional) 
     * @param bankSerialNOFilter (optional) 
     * @param maxPriceFilter (optional) 
     * @param minPriceFilter (optional) 
     * @param paymentStatusFilter (optional) 
     * @param bankHashCodeFilter (optional) 
     * @param bankAccountAccountNumberFilter (optional) 
     * @return Success
     */
    getPaymentsToExcel(filter: string | undefined, paymentTypeFilter: number | undefined, panCardFilter: string | undefined, maxPaymentDateTimeFilter: moment.Moment | undefined, minPaymentDateTimeFilter: moment.Moment | undefined, bankTrackingNOFilter: string | undefined, bankSerialNOFilter: string | undefined, maxPriceFilter: number | undefined, minPriceFilter: number | undefined, paymentStatusFilter: number | undefined, bankHashCodeFilter: string | undefined, bankAccountAccountNumberFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Payments/GetPaymentsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (paymentTypeFilter === null)
            throw new Error("The parameter 'paymentTypeFilter' cannot be null.");
        else if (paymentTypeFilter !== undefined)
            url_ += "PaymentTypeFilter=" + encodeURIComponent("" + paymentTypeFilter) + "&"; 
        if (panCardFilter === null)
            throw new Error("The parameter 'panCardFilter' cannot be null.");
        else if (panCardFilter !== undefined)
            url_ += "PanCardFilter=" + encodeURIComponent("" + panCardFilter) + "&"; 
        if (maxPaymentDateTimeFilter === null)
            throw new Error("The parameter 'maxPaymentDateTimeFilter' cannot be null.");
        else if (maxPaymentDateTimeFilter !== undefined)
            url_ += "MaxPaymentDateTimeFilter=" + encodeURIComponent(maxPaymentDateTimeFilter ? "" + maxPaymentDateTimeFilter.toJSON() : "") + "&"; 
        if (minPaymentDateTimeFilter === null)
            throw new Error("The parameter 'minPaymentDateTimeFilter' cannot be null.");
        else if (minPaymentDateTimeFilter !== undefined)
            url_ += "MinPaymentDateTimeFilter=" + encodeURIComponent(minPaymentDateTimeFilter ? "" + minPaymentDateTimeFilter.toJSON() : "") + "&"; 
        if (bankTrackingNOFilter === null)
            throw new Error("The parameter 'bankTrackingNOFilter' cannot be null.");
        else if (bankTrackingNOFilter !== undefined)
            url_ += "BankTrackingNOFilter=" + encodeURIComponent("" + bankTrackingNOFilter) + "&"; 
        if (bankSerialNOFilter === null)
            throw new Error("The parameter 'bankSerialNOFilter' cannot be null.");
        else if (bankSerialNOFilter !== undefined)
            url_ += "BankSerialNOFilter=" + encodeURIComponent("" + bankSerialNOFilter) + "&"; 
        if (maxPriceFilter === null)
            throw new Error("The parameter 'maxPriceFilter' cannot be null.");
        else if (maxPriceFilter !== undefined)
            url_ += "MaxPriceFilter=" + encodeURIComponent("" + maxPriceFilter) + "&"; 
        if (minPriceFilter === null)
            throw new Error("The parameter 'minPriceFilter' cannot be null.");
        else if (minPriceFilter !== undefined)
            url_ += "MinPriceFilter=" + encodeURIComponent("" + minPriceFilter) + "&"; 
        if (paymentStatusFilter === null)
            throw new Error("The parameter 'paymentStatusFilter' cannot be null.");
        else if (paymentStatusFilter !== undefined)
            url_ += "PaymentStatusFilter=" + encodeURIComponent("" + paymentStatusFilter) + "&"; 
        if (bankHashCodeFilter === null)
            throw new Error("The parameter 'bankHashCodeFilter' cannot be null.");
        else if (bankHashCodeFilter !== undefined)
            url_ += "BankHashCodeFilter=" + encodeURIComponent("" + bankHashCodeFilter) + "&"; 
        if (bankAccountAccountNumberFilter === null)
            throw new Error("The parameter 'bankAccountAccountNumberFilter' cannot be null.");
        else if (bankAccountAccountNumberFilter !== undefined)
            url_ += "BankAccountAccountNumberFilter=" + encodeURIComponent("" + bankAccountAccountNumberFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param paymentTypeFilter (optional) 
     * @param pCToPosFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllBankAccountForLookupTable(filter: string | undefined, paymentTypeFilter: number | undefined, pCToPosFilter: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfPaymentBankAccountLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Payments/GetAllBankAccountForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (paymentTypeFilter === null)
            throw new Error("The parameter 'paymentTypeFilter' cannot be null.");
        else if (paymentTypeFilter !== undefined)
            url_ += "PaymentTypeFilter=" + encodeURIComponent("" + paymentTypeFilter) + "&"; 
        if (pCToPosFilter === null)
            throw new Error("The parameter 'pCToPosFilter' cannot be null.");
        else if (pCToPosFilter !== undefined)
            url_ += "PCToPosFilter=" + encodeURIComponent("" + pCToPosFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBankAccountForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBankAccountForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfPaymentBankAccountLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfPaymentBankAccountLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBankAccountForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfPaymentBankAccountLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPaymentBankAccountLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfPaymentBankAccountLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param paymentTypeFilter (optional) 
     * @param pCToPosFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllPosForLookupTable(filter: string | undefined, paymentTypeFilter: number | undefined, pCToPosFilter: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfPaymentPosLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Payments/getAllPosForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (paymentTypeFilter === null)
            throw new Error("The parameter 'paymentTypeFilter' cannot be null.");
        else if (paymentTypeFilter !== undefined)
            url_ += "PaymentTypeFilter=" + encodeURIComponent("" + paymentTypeFilter) + "&"; 
        if (pCToPosFilter === null)
            throw new Error("The parameter 'pCToPosFilter' cannot be null.");
        else if (pCToPosFilter !== undefined)
            url_ += "PCToPosFilter=" + encodeURIComponent("" + pCToPosFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPosForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPosForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfPaymentPosLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfPaymentPosLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPosForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfPaymentPosLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPaymentPosLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfPaymentPosLookupTableDto>(<any>null);
    }

    /**
     * @param pcPos (optional) 
     * @return Success
     */
    getPosForCurrentUser(pcPos: boolean | undefined): Observable<PaymentPosLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Payments/GetPosForCurrentUser?";
        if (pcPos === null)
            throw new Error("The parameter 'pcPos' cannot be null.");
        else if (pcPos !== undefined)
            url_ += "pcPos=" + encodeURIComponent("" + pcPos) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPosForCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPosForCurrentUser(<any>response_);
                } catch (e) {
                    return <Observable<PaymentPosLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaymentPosLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPosForCurrentUser(response: HttpResponseBase): Observable<PaymentPosLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentPosLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentPosLookupTableDto>(<any>null);
    }

    /**
     * @param postmanId (optional) 
     * @param pcPos (optional) 
     * @return Success
     */
    getPosForPostman(postmanId: number | undefined, pcPos: boolean | undefined): Observable<PaymentPosLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Payments/GetPosForPostman?";
        if (postmanId === null)
            throw new Error("The parameter 'postmanId' cannot be null.");
        else if (postmanId !== undefined)
            url_ += "postmanId=" + encodeURIComponent("" + postmanId) + "&"; 
        if (pcPos === null)
            throw new Error("The parameter 'pcPos' cannot be null.");
        else if (pcPos !== undefined)
            url_ += "pcPos=" + encodeURIComponent("" + pcPos) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPosForPostman(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPosForPostman(<any>response_);
                } catch (e) {
                    return <Observable<PaymentPosLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaymentPosLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPosForPostman(response: HttpResponseBase): Observable<PaymentPosLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentPosLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentPosLookupTableDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    pcToPos(body: PcToPosInput | undefined): Observable<PcToPosOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Payments/PcToPos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPcToPos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPcToPos(<any>response_);
                } catch (e) {
                    return <Observable<PcToPosOutputDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PcToPosOutputDto>><any>_observableThrow(response_);
        }));
    }

    protected processPcToPos(response: HttpResponseBase): Observable<PcToPosOutputDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PcToPosOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PcToPosOutputDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param paymentTypeFilter (optional) 
     * @param maxPaymentDateTimeFilter (optional) 
     * @param minPaymentDateTimeFilter (optional) 
     * @param maxPriceFilter (optional) 
     * @param minPriceFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllNotConnectedPayments(filter: string | undefined, paymentTypeFilter: number | undefined, maxPaymentDateTimeFilter: moment.Moment | undefined, minPaymentDateTimeFilter: moment.Moment | undefined, maxPriceFilter: number | undefined, minPriceFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetPaymentForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Payments/GetAllNotConnectedPayments?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (paymentTypeFilter === null)
            throw new Error("The parameter 'paymentTypeFilter' cannot be null.");
        else if (paymentTypeFilter !== undefined)
            url_ += "PaymentTypeFilter=" + encodeURIComponent("" + paymentTypeFilter) + "&"; 
        if (maxPaymentDateTimeFilter === null)
            throw new Error("The parameter 'maxPaymentDateTimeFilter' cannot be null.");
        else if (maxPaymentDateTimeFilter !== undefined)
            url_ += "MaxPaymentDateTimeFilter=" + encodeURIComponent(maxPaymentDateTimeFilter ? "" + maxPaymentDateTimeFilter.toJSON() : "") + "&"; 
        if (minPaymentDateTimeFilter === null)
            throw new Error("The parameter 'minPaymentDateTimeFilter' cannot be null.");
        else if (minPaymentDateTimeFilter !== undefined)
            url_ += "MinPaymentDateTimeFilter=" + encodeURIComponent(minPaymentDateTimeFilter ? "" + minPaymentDateTimeFilter.toJSON() : "") + "&"; 
        if (maxPriceFilter === null)
            throw new Error("The parameter 'maxPriceFilter' cannot be null.");
        else if (maxPriceFilter !== undefined)
            url_ += "MaxPriceFilter=" + encodeURIComponent("" + maxPriceFilter) + "&"; 
        if (minPriceFilter === null)
            throw new Error("The parameter 'minPriceFilter' cannot be null.");
        else if (minPriceFilter !== undefined)
            url_ += "MinPriceFilter=" + encodeURIComponent("" + minPriceFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllNotConnectedPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllNotConnectedPayments(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetPaymentForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetPaymentForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllNotConnectedPayments(response: HttpResponseBase): Observable<PagedResultDtoOfGetPaymentForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetPaymentForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetPaymentForViewDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param billId (optional) 
     * @param contactId (optional) 
     * @param maxIssueDateFilter (optional) 
     * @param minIssueDateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllNotConnectedBills(filter: string | undefined, billId: number | undefined, contactId: number | undefined, maxIssueDateFilter: moment.Moment | undefined, minIssueDateFilter: moment.Moment | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAllNotConnectedBillsDto> {
        let url_ = this.baseUrl + "/api/services/app/Payments/GetAllNotConnectedBills?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (billId === null)
            throw new Error("The parameter 'billId' cannot be null.");
        else if (billId !== undefined)
            url_ += "BillId=" + encodeURIComponent("" + billId) + "&"; 
        if (contactId === null)
            throw new Error("The parameter 'contactId' cannot be null.");
        else if (contactId !== undefined)
            url_ += "ContactId=" + encodeURIComponent("" + contactId) + "&"; 
        if (maxIssueDateFilter === null)
            throw new Error("The parameter 'maxIssueDateFilter' cannot be null.");
        else if (maxIssueDateFilter !== undefined)
            url_ += "MaxIssueDateFilter=" + encodeURIComponent(maxIssueDateFilter ? "" + maxIssueDateFilter.toJSON() : "") + "&"; 
        if (minIssueDateFilter === null)
            throw new Error("The parameter 'minIssueDateFilter' cannot be null.");
        else if (minIssueDateFilter !== undefined)
            url_ += "MinIssueDateFilter=" + encodeURIComponent(minIssueDateFilter ? "" + minIssueDateFilter.toJSON() : "") + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllNotConnectedBills(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllNotConnectedBills(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAllNotConnectedBillsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAllNotConnectedBillsDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllNotConnectedBills(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllNotConnectedBillsDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAllNotConnectedBillsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAllNotConnectedBillsDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    connectBillsToPayments(body: ConnectBillsToPaymentsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payments/ConnectBillsToPayments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConnectBillsToPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConnectBillsToPayments(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processConnectBillsToPayments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param paymentTypeFilter (optional) 
     * @param panCardFilter (optional) 
     * @param maxPaymentDateTimeFilter (optional) 
     * @param minPaymentDateTimeFilter (optional) 
     * @param bankTrackingNOFilter (optional) 
     * @param bankSerialNOFilter (optional) 
     * @param maxPriceFilter (optional) 
     * @param minPriceFilter (optional) 
     * @param paymentStatusFilter (optional) 
     * @param contactMobileNumber (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllReport(filter: string | undefined, paymentTypeFilter: number | undefined, panCardFilter: string | undefined, maxPaymentDateTimeFilter: moment.Moment | undefined, minPaymentDateTimeFilter: moment.Moment | undefined, bankTrackingNOFilter: string | undefined, bankSerialNOFilter: string | undefined, maxPriceFilter: number | undefined, minPriceFilter: number | undefined, paymentStatusFilter: number | undefined, contactMobileNumber: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<GetAllPaymentReport> {
        let url_ = this.baseUrl + "/api/services/app/Payments/GetAllReport?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (paymentTypeFilter === null)
            throw new Error("The parameter 'paymentTypeFilter' cannot be null.");
        else if (paymentTypeFilter !== undefined)
            url_ += "PaymentTypeFilter=" + encodeURIComponent("" + paymentTypeFilter) + "&"; 
        if (panCardFilter === null)
            throw new Error("The parameter 'panCardFilter' cannot be null.");
        else if (panCardFilter !== undefined)
            url_ += "PanCardFilter=" + encodeURIComponent("" + panCardFilter) + "&"; 
        if (maxPaymentDateTimeFilter === null)
            throw new Error("The parameter 'maxPaymentDateTimeFilter' cannot be null.");
        else if (maxPaymentDateTimeFilter !== undefined)
            url_ += "MaxPaymentDateTimeFilter=" + encodeURIComponent(maxPaymentDateTimeFilter ? "" + maxPaymentDateTimeFilter.toJSON() : "") + "&"; 
        if (minPaymentDateTimeFilter === null)
            throw new Error("The parameter 'minPaymentDateTimeFilter' cannot be null.");
        else if (minPaymentDateTimeFilter !== undefined)
            url_ += "MinPaymentDateTimeFilter=" + encodeURIComponent(minPaymentDateTimeFilter ? "" + minPaymentDateTimeFilter.toJSON() : "") + "&"; 
        if (bankTrackingNOFilter === null)
            throw new Error("The parameter 'bankTrackingNOFilter' cannot be null.");
        else if (bankTrackingNOFilter !== undefined)
            url_ += "BankTrackingNOFilter=" + encodeURIComponent("" + bankTrackingNOFilter) + "&"; 
        if (bankSerialNOFilter === null)
            throw new Error("The parameter 'bankSerialNOFilter' cannot be null.");
        else if (bankSerialNOFilter !== undefined)
            url_ += "BankSerialNOFilter=" + encodeURIComponent("" + bankSerialNOFilter) + "&"; 
        if (maxPriceFilter === null)
            throw new Error("The parameter 'maxPriceFilter' cannot be null.");
        else if (maxPriceFilter !== undefined)
            url_ += "MaxPriceFilter=" + encodeURIComponent("" + maxPriceFilter) + "&"; 
        if (minPriceFilter === null)
            throw new Error("The parameter 'minPriceFilter' cannot be null.");
        else if (minPriceFilter !== undefined)
            url_ += "MinPriceFilter=" + encodeURIComponent("" + minPriceFilter) + "&"; 
        if (paymentStatusFilter === null)
            throw new Error("The parameter 'paymentStatusFilter' cannot be null.");
        else if (paymentStatusFilter !== undefined)
            url_ += "PaymentStatusFilter=" + encodeURIComponent("" + paymentStatusFilter) + "&"; 
        if (contactMobileNumber === null)
            throw new Error("The parameter 'contactMobileNumber' cannot be null.");
        else if (contactMobileNumber !== undefined)
            url_ += "ContactMobileNumber=" + encodeURIComponent("" + contactMobileNumber) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllReport(<any>response_);
                } catch (e) {
                    return <Observable<GetAllPaymentReport>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAllPaymentReport>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllReport(response: HttpResponseBase): Observable<GetAllPaymentReport> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllPaymentReport.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAllPaymentReport>(<any>null);
    }
}

@Injectable()
export class PayPalPaymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param paymentId (optional) 
     * @param paypalOrderId (optional) 
     * @return Success
     */
    confirmPayment(paymentId: number | undefined, paypalOrderId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PayPalPayment/ConfirmPayment?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&"; 
        if (paypalOrderId === null)
            throw new Error("The parameter 'paypalOrderId' cannot be null.");
        else if (paypalOrderId !== undefined)
            url_ += "paypalOrderId=" + encodeURIComponent("" + paypalOrderId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmPayment(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processConfirmPayment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getConfiguration(): Observable<PayPalConfigurationDto> {
        let url_ = this.baseUrl + "/api/services/app/PayPalPayment/GetConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfiguration(<any>response_);
                } catch (e) {
                    return <Observable<PayPalConfigurationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PayPalConfigurationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetConfiguration(response: HttpResponseBase): Observable<PayPalConfigurationDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PayPalConfigurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PayPalConfigurationDto>(<any>null);
    }
}

@Injectable()
export class PermissionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<ListResultDtoOfFlatPermissionWithLevelDto> {
        let url_ = this.baseUrl + "/api/services/app/Permission/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfFlatPermissionWithLevelDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfFlatPermissionWithLevelDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<ListResultDtoOfFlatPermissionWithLevelDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfFlatPermissionWithLevelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfFlatPermissionWithLevelDto>(<any>null);
    }
}

@Injectable()
export class PersonInquiriesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param entityFilter (optional) 
     * @param maxEntityRefFilter (optional) 
     * @param minEntityRefFilter (optional) 
     * @param maxStartDateFilter (optional) 
     * @param minStartDateFilter (optional) 
     * @param inquiryDescriptionFilter (optional) 
     * @param maxFirstInquiryDateFilter (optional) 
     * @param minFirstInquiryDateFilter (optional) 
     * @param firstInquirerDescFilter (optional) 
     * @param maxSecondInquiryDateFilter (optional) 
     * @param minSecondInquiryDateFilter (optional) 
     * @param secondInquirerDescFilter (optional) 
     * @param managementDescriptionFilter (optional) 
     * @param relevantUnitDescriptionFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxCompletionDateFilter (optional) 
     * @param minCompletionDateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, codeFilter: string | undefined, entityFilter: number | undefined, maxEntityRefFilter: number | undefined, minEntityRefFilter: number | undefined, maxStartDateFilter: moment.Moment | undefined, minStartDateFilter: moment.Moment | undefined, inquiryDescriptionFilter: string | undefined, maxFirstInquiryDateFilter: moment.Moment | undefined, minFirstInquiryDateFilter: moment.Moment | undefined, firstInquirerDescFilter: string | undefined, maxSecondInquiryDateFilter: moment.Moment | undefined, minSecondInquiryDateFilter: moment.Moment | undefined, secondInquirerDescFilter: string | undefined, managementDescriptionFilter: string | undefined, relevantUnitDescriptionFilter: string | undefined, statusFilter: number | undefined, maxCompletionDateFilter: moment.Moment | undefined, minCompletionDateFilter: moment.Moment | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetPersonInquiryForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonInquiries/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (maxEntityRefFilter === null)
            throw new Error("The parameter 'maxEntityRefFilter' cannot be null.");
        else if (maxEntityRefFilter !== undefined)
            url_ += "MaxEntityRefFilter=" + encodeURIComponent("" + maxEntityRefFilter) + "&"; 
        if (minEntityRefFilter === null)
            throw new Error("The parameter 'minEntityRefFilter' cannot be null.");
        else if (minEntityRefFilter !== undefined)
            url_ += "MinEntityRefFilter=" + encodeURIComponent("" + minEntityRefFilter) + "&"; 
        if (maxStartDateFilter === null)
            throw new Error("The parameter 'maxStartDateFilter' cannot be null.");
        else if (maxStartDateFilter !== undefined)
            url_ += "MaxStartDateFilter=" + encodeURIComponent(maxStartDateFilter ? "" + maxStartDateFilter.toJSON() : "") + "&"; 
        if (minStartDateFilter === null)
            throw new Error("The parameter 'minStartDateFilter' cannot be null.");
        else if (minStartDateFilter !== undefined)
            url_ += "MinStartDateFilter=" + encodeURIComponent(minStartDateFilter ? "" + minStartDateFilter.toJSON() : "") + "&"; 
        if (inquiryDescriptionFilter === null)
            throw new Error("The parameter 'inquiryDescriptionFilter' cannot be null.");
        else if (inquiryDescriptionFilter !== undefined)
            url_ += "InquiryDescriptionFilter=" + encodeURIComponent("" + inquiryDescriptionFilter) + "&"; 
        if (maxFirstInquiryDateFilter === null)
            throw new Error("The parameter 'maxFirstInquiryDateFilter' cannot be null.");
        else if (maxFirstInquiryDateFilter !== undefined)
            url_ += "MaxFirstInquiryDateFilter=" + encodeURIComponent(maxFirstInquiryDateFilter ? "" + maxFirstInquiryDateFilter.toJSON() : "") + "&"; 
        if (minFirstInquiryDateFilter === null)
            throw new Error("The parameter 'minFirstInquiryDateFilter' cannot be null.");
        else if (minFirstInquiryDateFilter !== undefined)
            url_ += "MinFirstInquiryDateFilter=" + encodeURIComponent(minFirstInquiryDateFilter ? "" + minFirstInquiryDateFilter.toJSON() : "") + "&"; 
        if (firstInquirerDescFilter === null)
            throw new Error("The parameter 'firstInquirerDescFilter' cannot be null.");
        else if (firstInquirerDescFilter !== undefined)
            url_ += "FirstInquirerDescFilter=" + encodeURIComponent("" + firstInquirerDescFilter) + "&"; 
        if (maxSecondInquiryDateFilter === null)
            throw new Error("The parameter 'maxSecondInquiryDateFilter' cannot be null.");
        else if (maxSecondInquiryDateFilter !== undefined)
            url_ += "MaxSecondInquiryDateFilter=" + encodeURIComponent(maxSecondInquiryDateFilter ? "" + maxSecondInquiryDateFilter.toJSON() : "") + "&"; 
        if (minSecondInquiryDateFilter === null)
            throw new Error("The parameter 'minSecondInquiryDateFilter' cannot be null.");
        else if (minSecondInquiryDateFilter !== undefined)
            url_ += "MinSecondInquiryDateFilter=" + encodeURIComponent(minSecondInquiryDateFilter ? "" + minSecondInquiryDateFilter.toJSON() : "") + "&"; 
        if (secondInquirerDescFilter === null)
            throw new Error("The parameter 'secondInquirerDescFilter' cannot be null.");
        else if (secondInquirerDescFilter !== undefined)
            url_ += "SecondInquirerDescFilter=" + encodeURIComponent("" + secondInquirerDescFilter) + "&"; 
        if (managementDescriptionFilter === null)
            throw new Error("The parameter 'managementDescriptionFilter' cannot be null.");
        else if (managementDescriptionFilter !== undefined)
            url_ += "ManagementDescriptionFilter=" + encodeURIComponent("" + managementDescriptionFilter) + "&"; 
        if (relevantUnitDescriptionFilter === null)
            throw new Error("The parameter 'relevantUnitDescriptionFilter' cannot be null.");
        else if (relevantUnitDescriptionFilter !== undefined)
            url_ += "RelevantUnitDescriptionFilter=" + encodeURIComponent("" + relevantUnitDescriptionFilter) + "&"; 
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (maxCompletionDateFilter === null)
            throw new Error("The parameter 'maxCompletionDateFilter' cannot be null.");
        else if (maxCompletionDateFilter !== undefined)
            url_ += "MaxCompletionDateFilter=" + encodeURIComponent(maxCompletionDateFilter ? "" + maxCompletionDateFilter.toJSON() : "") + "&"; 
        if (minCompletionDateFilter === null)
            throw new Error("The parameter 'minCompletionDateFilter' cannot be null.");
        else if (minCompletionDateFilter !== undefined)
            url_ += "MinCompletionDateFilter=" + encodeURIComponent(minCompletionDateFilter ? "" + minCompletionDateFilter.toJSON() : "") + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetPersonInquiryForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetPersonInquiryForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetPersonInquiryForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetPersonInquiryForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetPersonInquiryForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPersonInquiryForView(id: number | undefined): Observable<GetPersonInquiryForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonInquiries/GetPersonInquiryForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonInquiryForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonInquiryForView(<any>response_);
                } catch (e) {
                    return <Observable<GetPersonInquiryForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPersonInquiryForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPersonInquiryForView(response: HttpResponseBase): Observable<GetPersonInquiryForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPersonInquiryForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPersonInquiryForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPersonInquiryForEdit(id: number | undefined): Observable<GetPersonInquiryForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/PersonInquiries/GetPersonInquiryForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonInquiryForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonInquiryForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetPersonInquiryForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPersonInquiryForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetPersonInquiryForEdit(response: HttpResponseBase): Observable<GetPersonInquiryForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPersonInquiryForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPersonInquiryForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditPersonInquiryDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PersonInquiries/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PersonInquiries/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param entityFilter (optional) 
     * @param maxEntityRefFilter (optional) 
     * @param minEntityRefFilter (optional) 
     * @param maxStartDateFilter (optional) 
     * @param minStartDateFilter (optional) 
     * @param inquiryDescriptionFilter (optional) 
     * @param maxFirstInquiryDateFilter (optional) 
     * @param minFirstInquiryDateFilter (optional) 
     * @param firstInquirerDescFilter (optional) 
     * @param maxSecondInquiryDateFilter (optional) 
     * @param minSecondInquiryDateFilter (optional) 
     * @param secondInquirerDescFilter (optional) 
     * @param managementDescriptionFilter (optional) 
     * @param relevantUnitDescriptionFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxCompletionDateFilter (optional) 
     * @param minCompletionDateFilter (optional) 
     * @return Success
     */
    getPersonInquiriesToExcel(filter: string | undefined, codeFilter: string | undefined, entityFilter: number | undefined, maxEntityRefFilter: number | undefined, minEntityRefFilter: number | undefined, maxStartDateFilter: moment.Moment | undefined, minStartDateFilter: moment.Moment | undefined, inquiryDescriptionFilter: string | undefined, maxFirstInquiryDateFilter: moment.Moment | undefined, minFirstInquiryDateFilter: moment.Moment | undefined, firstInquirerDescFilter: string | undefined, maxSecondInquiryDateFilter: moment.Moment | undefined, minSecondInquiryDateFilter: moment.Moment | undefined, secondInquirerDescFilter: string | undefined, managementDescriptionFilter: string | undefined, relevantUnitDescriptionFilter: string | undefined, statusFilter: number | undefined, maxCompletionDateFilter: moment.Moment | undefined, minCompletionDateFilter: moment.Moment | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonInquiries/GetPersonInquiriesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (maxEntityRefFilter === null)
            throw new Error("The parameter 'maxEntityRefFilter' cannot be null.");
        else if (maxEntityRefFilter !== undefined)
            url_ += "MaxEntityRefFilter=" + encodeURIComponent("" + maxEntityRefFilter) + "&"; 
        if (minEntityRefFilter === null)
            throw new Error("The parameter 'minEntityRefFilter' cannot be null.");
        else if (minEntityRefFilter !== undefined)
            url_ += "MinEntityRefFilter=" + encodeURIComponent("" + minEntityRefFilter) + "&"; 
        if (maxStartDateFilter === null)
            throw new Error("The parameter 'maxStartDateFilter' cannot be null.");
        else if (maxStartDateFilter !== undefined)
            url_ += "MaxStartDateFilter=" + encodeURIComponent(maxStartDateFilter ? "" + maxStartDateFilter.toJSON() : "") + "&"; 
        if (minStartDateFilter === null)
            throw new Error("The parameter 'minStartDateFilter' cannot be null.");
        else if (minStartDateFilter !== undefined)
            url_ += "MinStartDateFilter=" + encodeURIComponent(minStartDateFilter ? "" + minStartDateFilter.toJSON() : "") + "&"; 
        if (inquiryDescriptionFilter === null)
            throw new Error("The parameter 'inquiryDescriptionFilter' cannot be null.");
        else if (inquiryDescriptionFilter !== undefined)
            url_ += "InquiryDescriptionFilter=" + encodeURIComponent("" + inquiryDescriptionFilter) + "&"; 
        if (maxFirstInquiryDateFilter === null)
            throw new Error("The parameter 'maxFirstInquiryDateFilter' cannot be null.");
        else if (maxFirstInquiryDateFilter !== undefined)
            url_ += "MaxFirstInquiryDateFilter=" + encodeURIComponent(maxFirstInquiryDateFilter ? "" + maxFirstInquiryDateFilter.toJSON() : "") + "&"; 
        if (minFirstInquiryDateFilter === null)
            throw new Error("The parameter 'minFirstInquiryDateFilter' cannot be null.");
        else if (minFirstInquiryDateFilter !== undefined)
            url_ += "MinFirstInquiryDateFilter=" + encodeURIComponent(minFirstInquiryDateFilter ? "" + minFirstInquiryDateFilter.toJSON() : "") + "&"; 
        if (firstInquirerDescFilter === null)
            throw new Error("The parameter 'firstInquirerDescFilter' cannot be null.");
        else if (firstInquirerDescFilter !== undefined)
            url_ += "FirstInquirerDescFilter=" + encodeURIComponent("" + firstInquirerDescFilter) + "&"; 
        if (maxSecondInquiryDateFilter === null)
            throw new Error("The parameter 'maxSecondInquiryDateFilter' cannot be null.");
        else if (maxSecondInquiryDateFilter !== undefined)
            url_ += "MaxSecondInquiryDateFilter=" + encodeURIComponent(maxSecondInquiryDateFilter ? "" + maxSecondInquiryDateFilter.toJSON() : "") + "&"; 
        if (minSecondInquiryDateFilter === null)
            throw new Error("The parameter 'minSecondInquiryDateFilter' cannot be null.");
        else if (minSecondInquiryDateFilter !== undefined)
            url_ += "MinSecondInquiryDateFilter=" + encodeURIComponent(minSecondInquiryDateFilter ? "" + minSecondInquiryDateFilter.toJSON() : "") + "&"; 
        if (secondInquirerDescFilter === null)
            throw new Error("The parameter 'secondInquirerDescFilter' cannot be null.");
        else if (secondInquirerDescFilter !== undefined)
            url_ += "SecondInquirerDescFilter=" + encodeURIComponent("" + secondInquirerDescFilter) + "&"; 
        if (managementDescriptionFilter === null)
            throw new Error("The parameter 'managementDescriptionFilter' cannot be null.");
        else if (managementDescriptionFilter !== undefined)
            url_ += "ManagementDescriptionFilter=" + encodeURIComponent("" + managementDescriptionFilter) + "&"; 
        if (relevantUnitDescriptionFilter === null)
            throw new Error("The parameter 'relevantUnitDescriptionFilter' cannot be null.");
        else if (relevantUnitDescriptionFilter !== undefined)
            url_ += "RelevantUnitDescriptionFilter=" + encodeURIComponent("" + relevantUnitDescriptionFilter) + "&"; 
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (maxCompletionDateFilter === null)
            throw new Error("The parameter 'maxCompletionDateFilter' cannot be null.");
        else if (maxCompletionDateFilter !== undefined)
            url_ += "MaxCompletionDateFilter=" + encodeURIComponent(maxCompletionDateFilter ? "" + maxCompletionDateFilter.toJSON() : "") + "&"; 
        if (minCompletionDateFilter === null)
            throw new Error("The parameter 'minCompletionDateFilter' cannot be null.");
        else if (minCompletionDateFilter !== undefined)
            url_ += "MinCompletionDateFilter=" + encodeURIComponent(minCompletionDateFilter ? "" + minCompletionDateFilter.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonInquiriesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonInquiriesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPersonInquiriesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllFamilyForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfPersonInquiryFamilyLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonInquiries/GetAllFamilyForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFamilyForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFamilyForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfPersonInquiryFamilyLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfPersonInquiryFamilyLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllFamilyForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfPersonInquiryFamilyLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPersonInquiryFamilyLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfPersonInquiryFamilyLookupTableDto>(<any>null);
    }
}

@Injectable()
export class PlanBillsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxStartDateFilter (optional) 
     * @param minStartDateFilter (optional) 
     * @param maxEndDateFilter (optional) 
     * @param minEndDateFilter (optional) 
     * @param maxPriceFilter (optional) 
     * @param minPriceFilter (optional) 
     * @param entityFilter (optional) 
     * @param entityRefFilter (optional) 
     * @param contactInformationFilter (optional) 
     * @param planConstTitleFilter (optional) 
     * @param baseTimeIdFilter (optional) 
     * @param planConstIdFilter (optional) 
     * @param planTypeFilter (optional) 
     * @param statusFilter (optional) 
     * @param isConfirmFilter (optional) 
     * @param benefactorNameFilter (optional) 
     * @param isCreatedByMe (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, maxStartDateFilter: moment.Moment | undefined, minStartDateFilter: moment.Moment | undefined, maxEndDateFilter: moment.Moment | undefined, minEndDateFilter: moment.Moment | undefined, maxPriceFilter: number | undefined, minPriceFilter: number | undefined, entityFilter: number | undefined, entityRefFilter: number | undefined, contactInformationFilter: string | undefined, planConstTitleFilter: string | undefined, baseTimeIdFilter: number | undefined, planConstIdFilter: number | undefined, planTypeFilter: number | undefined, statusFilter: number | undefined, isConfirmFilter: number | undefined, benefactorNameFilter: string | undefined, isCreatedByMe: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetPlanBillForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PlanBills/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxStartDateFilter === null)
            throw new Error("The parameter 'maxStartDateFilter' cannot be null.");
        else if (maxStartDateFilter !== undefined)
            url_ += "MaxStartDateFilter=" + encodeURIComponent(maxStartDateFilter ? "" + maxStartDateFilter.toJSON() : "") + "&"; 
        if (minStartDateFilter === null)
            throw new Error("The parameter 'minStartDateFilter' cannot be null.");
        else if (minStartDateFilter !== undefined)
            url_ += "MinStartDateFilter=" + encodeURIComponent(minStartDateFilter ? "" + minStartDateFilter.toJSON() : "") + "&"; 
        if (maxEndDateFilter === null)
            throw new Error("The parameter 'maxEndDateFilter' cannot be null.");
        else if (maxEndDateFilter !== undefined)
            url_ += "MaxEndDateFilter=" + encodeURIComponent(maxEndDateFilter ? "" + maxEndDateFilter.toJSON() : "") + "&"; 
        if (minEndDateFilter === null)
            throw new Error("The parameter 'minEndDateFilter' cannot be null.");
        else if (minEndDateFilter !== undefined)
            url_ += "MinEndDateFilter=" + encodeURIComponent(minEndDateFilter ? "" + minEndDateFilter.toJSON() : "") + "&"; 
        if (maxPriceFilter === null)
            throw new Error("The parameter 'maxPriceFilter' cannot be null.");
        else if (maxPriceFilter !== undefined)
            url_ += "MaxPriceFilter=" + encodeURIComponent("" + maxPriceFilter) + "&"; 
        if (minPriceFilter === null)
            throw new Error("The parameter 'minPriceFilter' cannot be null.");
        else if (minPriceFilter !== undefined)
            url_ += "MinPriceFilter=" + encodeURIComponent("" + minPriceFilter) + "&"; 
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (entityRefFilter === null)
            throw new Error("The parameter 'entityRefFilter' cannot be null.");
        else if (entityRefFilter !== undefined)
            url_ += "EntityRefFilter=" + encodeURIComponent("" + entityRefFilter) + "&"; 
        if (contactInformationFilter === null)
            throw new Error("The parameter 'contactInformationFilter' cannot be null.");
        else if (contactInformationFilter !== undefined)
            url_ += "ContactInformationFilter=" + encodeURIComponent("" + contactInformationFilter) + "&"; 
        if (planConstTitleFilter === null)
            throw new Error("The parameter 'planConstTitleFilter' cannot be null.");
        else if (planConstTitleFilter !== undefined)
            url_ += "PlanConstTitleFilter=" + encodeURIComponent("" + planConstTitleFilter) + "&"; 
        if (baseTimeIdFilter === null)
            throw new Error("The parameter 'baseTimeIdFilter' cannot be null.");
        else if (baseTimeIdFilter !== undefined)
            url_ += "BaseTimeIdFilter=" + encodeURIComponent("" + baseTimeIdFilter) + "&"; 
        if (planConstIdFilter === null)
            throw new Error("The parameter 'planConstIdFilter' cannot be null.");
        else if (planConstIdFilter !== undefined)
            url_ += "PlanConstIdFilter=" + encodeURIComponent("" + planConstIdFilter) + "&"; 
        if (planTypeFilter === null)
            throw new Error("The parameter 'planTypeFilter' cannot be null.");
        else if (planTypeFilter !== undefined)
            url_ += "PlanTypeFilter=" + encodeURIComponent("" + planTypeFilter) + "&"; 
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (isConfirmFilter === null)
            throw new Error("The parameter 'isConfirmFilter' cannot be null.");
        else if (isConfirmFilter !== undefined)
            url_ += "IsConfirmFilter=" + encodeURIComponent("" + isConfirmFilter) + "&"; 
        if (benefactorNameFilter === null)
            throw new Error("The parameter 'benefactorNameFilter' cannot be null.");
        else if (benefactorNameFilter !== undefined)
            url_ += "BenefactorNameFilter=" + encodeURIComponent("" + benefactorNameFilter) + "&"; 
        if (isCreatedByMe === null)
            throw new Error("The parameter 'isCreatedByMe' cannot be null.");
        else if (isCreatedByMe !== undefined)
            url_ += "IsCreatedByMe=" + encodeURIComponent("" + isCreatedByMe) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetPlanBillForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetPlanBillForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetPlanBillForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetPlanBillForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetPlanBillForViewDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param contactId (optional) 
     * @param benefactorNameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getContactPlanBills(filter: string | undefined, contactId: number | undefined, benefactorNameFilter: string | undefined, descriptionFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetPlanBillForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PlanBills/GetContactPlanBills?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (contactId === null)
            throw new Error("The parameter 'contactId' cannot be null.");
        else if (contactId !== undefined)
            url_ += "ContactId=" + encodeURIComponent("" + contactId) + "&"; 
        if (benefactorNameFilter === null)
            throw new Error("The parameter 'benefactorNameFilter' cannot be null.");
        else if (benefactorNameFilter !== undefined)
            url_ += "BenefactorNameFilter=" + encodeURIComponent("" + benefactorNameFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactPlanBills(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactPlanBills(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetPlanBillForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetPlanBillForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetContactPlanBills(response: HttpResponseBase): Observable<PagedResultDtoOfGetPlanBillForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetPlanBillForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetPlanBillForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPlanBillForView(id: number | undefined): Observable<GetPlanBillForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PlanBills/GetPlanBillForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlanBillForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlanBillForView(<any>response_);
                } catch (e) {
                    return <Observable<GetPlanBillForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPlanBillForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPlanBillForView(response: HttpResponseBase): Observable<GetPlanBillForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPlanBillForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPlanBillForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPlanBillForEdit(id: number | undefined): Observable<GetPlanBillForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/PlanBills/GetPlanBillForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlanBillForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlanBillForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetPlanBillForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPlanBillForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetPlanBillForEdit(response: HttpResponseBase): Observable<GetPlanBillForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPlanBillForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPlanBillForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditPlanBillDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PlanBills/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditPlanBillAndAddress(body: CreateOrEditPlanBillAndAddressDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PlanBills/CreateOrEditPlanBillAndAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditPlanBillAndAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditPlanBillAndAddress(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditPlanBillAndAddress(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditPlanBillAndMoneyBoxEvent(body: CreateOrEditPlanBillAndMoneyBoxEventInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PlanBills/CreateOrEditPlanBillAndMoneyBoxEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditPlanBillAndMoneyBoxEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditPlanBillAndMoneyBoxEvent(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditPlanBillAndMoneyBoxEvent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAndGetId(body: CreateOrEditPlanBillDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PlanBills/CreateAndGetId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAndGetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAndGetId(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateAndGetId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAndGetIdAnonymous(body: CreateOrEditPlanBillDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PlanBills/CreateAndGetIdAnonymous";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAndGetIdAnonymous(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAndGetIdAnonymous(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateAndGetIdAnonymous(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PlanBills/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param maxStartDateFilter (optional) 
     * @param minStartDateFilter (optional) 
     * @param maxEndDateFilter (optional) 
     * @param minEndDateFilter (optional) 
     * @param maxPriceFilter (optional) 
     * @param minPriceFilter (optional) 
     * @param entityFilter (optional) 
     * @param entityRefFilter (optional) 
     * @param contactInformationFilter (optional) 
     * @param planConstTitleFilter (optional) 
     * @param baseTimeIdFilter (optional) 
     * @param planConstIdFilter (optional) 
     * @param planTypeFilter (optional) 
     * @param statusFilter (optional) 
     * @param isConfirmFilter (optional) 
     * @param benefactorNameFilter (optional) 
     * @return Success
     */
    getPlanBillsToExcel(filter: string | undefined, maxStartDateFilter: moment.Moment | undefined, minStartDateFilter: moment.Moment | undefined, maxEndDateFilter: moment.Moment | undefined, minEndDateFilter: moment.Moment | undefined, maxPriceFilter: number | undefined, minPriceFilter: number | undefined, entityFilter: number | undefined, entityRefFilter: number | undefined, contactInformationFilter: string | undefined, planConstTitleFilter: string | undefined, baseTimeIdFilter: number | undefined, planConstIdFilter: number | undefined, planTypeFilter: number | undefined, statusFilter: number | undefined, isConfirmFilter: number | undefined, benefactorNameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/PlanBills/GetPlanBillsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxStartDateFilter === null)
            throw new Error("The parameter 'maxStartDateFilter' cannot be null.");
        else if (maxStartDateFilter !== undefined)
            url_ += "MaxStartDateFilter=" + encodeURIComponent(maxStartDateFilter ? "" + maxStartDateFilter.toJSON() : "") + "&"; 
        if (minStartDateFilter === null)
            throw new Error("The parameter 'minStartDateFilter' cannot be null.");
        else if (minStartDateFilter !== undefined)
            url_ += "MinStartDateFilter=" + encodeURIComponent(minStartDateFilter ? "" + minStartDateFilter.toJSON() : "") + "&"; 
        if (maxEndDateFilter === null)
            throw new Error("The parameter 'maxEndDateFilter' cannot be null.");
        else if (maxEndDateFilter !== undefined)
            url_ += "MaxEndDateFilter=" + encodeURIComponent(maxEndDateFilter ? "" + maxEndDateFilter.toJSON() : "") + "&"; 
        if (minEndDateFilter === null)
            throw new Error("The parameter 'minEndDateFilter' cannot be null.");
        else if (minEndDateFilter !== undefined)
            url_ += "MinEndDateFilter=" + encodeURIComponent(minEndDateFilter ? "" + minEndDateFilter.toJSON() : "") + "&"; 
        if (maxPriceFilter === null)
            throw new Error("The parameter 'maxPriceFilter' cannot be null.");
        else if (maxPriceFilter !== undefined)
            url_ += "MaxPriceFilter=" + encodeURIComponent("" + maxPriceFilter) + "&"; 
        if (minPriceFilter === null)
            throw new Error("The parameter 'minPriceFilter' cannot be null.");
        else if (minPriceFilter !== undefined)
            url_ += "MinPriceFilter=" + encodeURIComponent("" + minPriceFilter) + "&"; 
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (entityRefFilter === null)
            throw new Error("The parameter 'entityRefFilter' cannot be null.");
        else if (entityRefFilter !== undefined)
            url_ += "EntityRefFilter=" + encodeURIComponent("" + entityRefFilter) + "&"; 
        if (contactInformationFilter === null)
            throw new Error("The parameter 'contactInformationFilter' cannot be null.");
        else if (contactInformationFilter !== undefined)
            url_ += "ContactInformationFilter=" + encodeURIComponent("" + contactInformationFilter) + "&"; 
        if (planConstTitleFilter === null)
            throw new Error("The parameter 'planConstTitleFilter' cannot be null.");
        else if (planConstTitleFilter !== undefined)
            url_ += "PlanConstTitleFilter=" + encodeURIComponent("" + planConstTitleFilter) + "&"; 
        if (baseTimeIdFilter === null)
            throw new Error("The parameter 'baseTimeIdFilter' cannot be null.");
        else if (baseTimeIdFilter !== undefined)
            url_ += "BaseTimeIdFilter=" + encodeURIComponent("" + baseTimeIdFilter) + "&"; 
        if (planConstIdFilter === null)
            throw new Error("The parameter 'planConstIdFilter' cannot be null.");
        else if (planConstIdFilter !== undefined)
            url_ += "PlanConstIdFilter=" + encodeURIComponent("" + planConstIdFilter) + "&"; 
        if (planTypeFilter === null)
            throw new Error("The parameter 'planTypeFilter' cannot be null.");
        else if (planTypeFilter !== undefined)
            url_ += "PlanTypeFilter=" + encodeURIComponent("" + planTypeFilter) + "&"; 
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (isConfirmFilter === null)
            throw new Error("The parameter 'isConfirmFilter' cannot be null.");
        else if (isConfirmFilter !== undefined)
            url_ += "IsConfirmFilter=" + encodeURIComponent("" + isConfirmFilter) + "&"; 
        if (benefactorNameFilter === null)
            throw new Error("The parameter 'benefactorNameFilter' cannot be null.");
        else if (benefactorNameFilter !== undefined)
            url_ += "BenefactorNameFilter=" + encodeURIComponent("" + benefactorNameFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlanBillsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlanBillsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPlanBillsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllContactForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfPlanBillContactLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/PlanBills/GetAllContactForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllContactForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllContactForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfPlanBillContactLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfPlanBillContactLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllContactForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfPlanBillContactLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPlanBillContactLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfPlanBillContactLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param contactIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllPlanConstForLookupTable(filter: string | undefined, planTypeFilter: Plans, contactIdFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfPlanBillPlanConstLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/PlanBills/GetAllPlanConstForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (planTypeFilter === undefined || planTypeFilter === null)
            throw new Error("The parameter 'planTypeFilter' must be defined and cannot be null.");
        else
            url_ += "PlanTypeFilter=" + encodeURIComponent("" + planTypeFilter) + "&"; 
        if (contactIdFilter === null)
            throw new Error("The parameter 'contactIdFilter' cannot be null.");
        else if (contactIdFilter !== undefined)
            url_ += "ContactIdFilter=" + encodeURIComponent("" + contactIdFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPlanConstForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPlanConstForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfPlanBillPlanConstLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfPlanBillPlanConstLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPlanConstForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfPlanBillPlanConstLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPlanBillPlanConstLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfPlanBillPlanConstLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllClientForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfPlanBillContactLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/PlanBills/GetAllClientForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllClientForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllClientForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfPlanBillContactLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfPlanBillContactLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllClientForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfPlanBillContactLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPlanBillContactLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfPlanBillContactLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllFamilyForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfPlanBillFamilyLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/PlanBills/GetAllFamilyForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFamilyForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFamilyForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfPlanBillFamilyLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfPlanBillFamilyLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllFamilyForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfPlanBillFamilyLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPlanBillFamilyLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfPlanBillFamilyLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllAddressForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfPlanBillAddressLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/PlanBills/GetAllAddressForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAddressForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAddressForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfPlanBillAddressLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfPlanBillAddressLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllAddressForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfPlanBillAddressLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPlanBillAddressLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfPlanBillAddressLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllDeceasedForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfPlanBillDeceasedLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/PlanBills/GetAllDeceasedForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDeceasedForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDeceasedForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfPlanBillDeceasedLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfPlanBillDeceasedLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllDeceasedForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfPlanBillDeceasedLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPlanBillDeceasedLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfPlanBillDeceasedLookupTableDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllBaseTimeForTableDropdown(): Observable<PlanBillBaseTimeLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PlanBills/GetAllBaseTimeForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBaseTimeForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBaseTimeForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<PlanBillBaseTimeLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PlanBillBaseTimeLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBaseTimeForTableDropdown(response: HttpResponseBase): Observable<PlanBillBaseTimeLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlanBillBaseTimeLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlanBillBaseTimeLookupTableDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllHealthStatusForTableDropdown(): Observable<PlanBillHealthStatusLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PlanBills/GetAllHealthStatusForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllHealthStatusForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllHealthStatusForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<PlanBillHealthStatusLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PlanBillHealthStatusLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllHealthStatusForTableDropdown(response: HttpResponseBase): Observable<PlanBillHealthStatusLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlanBillHealthStatusLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlanBillHealthStatusLookupTableDto[]>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param startDateFilter (optional) 
     * @param isExpiredFilter (optional) 
     * @param isDueDateFilter (optional) 
     * @param page (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllContactPlanBillsForShop(filter: string | undefined, startDateFilter: moment.Moment | undefined, isExpiredFilter: boolean | undefined, isDueDateFilter: boolean | undefined, page: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAllContactPlanBillsForShopDto> {
        let url_ = this.baseUrl + "/api/services/app/PlanBills/GetAllContactPlanBillsForShop?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (startDateFilter === null)
            throw new Error("The parameter 'startDateFilter' cannot be null.");
        else if (startDateFilter !== undefined)
            url_ += "StartDateFilter=" + encodeURIComponent(startDateFilter ? "" + startDateFilter.toJSON() : "") + "&"; 
        if (isExpiredFilter === null)
            throw new Error("The parameter 'isExpiredFilter' cannot be null.");
        else if (isExpiredFilter !== undefined)
            url_ += "IsExpiredFilter=" + encodeURIComponent("" + isExpiredFilter) + "&"; 
        if (isDueDateFilter === null)
            throw new Error("The parameter 'isDueDateFilter' cannot be null.");
        else if (isDueDateFilter !== undefined)
            url_ += "IsDueDateFilter=" + encodeURIComponent("" + isDueDateFilter) + "&"; 
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllContactPlanBillsForShop(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllContactPlanBillsForShop(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAllContactPlanBillsForShopDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAllContactPlanBillsForShopDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllContactPlanBillsForShop(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllContactPlanBillsForShopDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAllContactPlanBillsForShopDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAllContactPlanBillsForShopDto>(<any>null);
    }

    /**
     * @param lastDate (optional) 
     * @param durationInt (optional) 
     * @param calendarInt (optional) 
     * @param durationDate (optional) 
     * @return Success
     */
    calculateNextPayment(lastDate: moment.Moment | undefined, durationInt: number | undefined, calendarInt: number | undefined, durationDate: number | undefined): Observable<moment.Moment> {
        let url_ = this.baseUrl + "/api/services/app/PlanBills/CalculateNextPayment?";
        if (lastDate === null)
            throw new Error("The parameter 'lastDate' cannot be null.");
        else if (lastDate !== undefined)
            url_ += "lastDate=" + encodeURIComponent(lastDate ? "" + lastDate.toJSON() : "") + "&"; 
        if (durationInt === null)
            throw new Error("The parameter 'durationInt' cannot be null.");
        else if (durationInt !== undefined)
            url_ += "durationInt=" + encodeURIComponent("" + durationInt) + "&"; 
        if (calendarInt === null)
            throw new Error("The parameter 'calendarInt' cannot be null.");
        else if (calendarInt !== undefined)
            url_ += "calendarInt=" + encodeURIComponent("" + calendarInt) + "&"; 
        if (durationDate === null)
            throw new Error("The parameter 'durationDate' cannot be null.");
        else if (durationDate !== undefined)
            url_ += "durationDate=" + encodeURIComponent("" + durationDate) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateNextPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateNextPayment(<any>response_);
                } catch (e) {
                    return <Observable<moment.Moment>><any>_observableThrow(e);
                }
            } else
                return <Observable<moment.Moment>><any>_observableThrow(response_);
        }));
    }

    protected processCalculateNextPayment(response: HttpResponseBase): Observable<moment.Moment> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? moment(resultData200.toString()) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<moment.Moment>(<any>null);
    }

    /**
     * @param planBillcode (optional) 
     * @return Success
     */
    getPlanBillDetailsForShop(planBillcode: string | undefined): Observable<GetPlanBillDetailsForShopDto> {
        let url_ = this.baseUrl + "/api/services/app/PlanBills/GetPlanBillDetailsForShop?";
        if (planBillcode === null)
            throw new Error("The parameter 'planBillcode' cannot be null.");
        else if (planBillcode !== undefined)
            url_ += "planBillcode=" + encodeURIComponent("" + planBillcode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlanBillDetailsForShop(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlanBillDetailsForShop(<any>response_);
                } catch (e) {
                    return <Observable<GetPlanBillDetailsForShopDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPlanBillDetailsForShopDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPlanBillDetailsForShop(response: HttpResponseBase): Observable<GetPlanBillDetailsForShopDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPlanBillDetailsForShopDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPlanBillDetailsForShopDto>(<any>null);
    }

    /**
     * @return Success
     */
    getContactMoneyBoxPlanBill(): Observable<GetContactMoneyBoxPlanBillDto> {
        let url_ = this.baseUrl + "/api/services/app/PlanBills/GetContactMoneyBoxPlanBill";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactMoneyBoxPlanBill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactMoneyBoxPlanBill(<any>response_);
                } catch (e) {
                    return <Observable<GetContactMoneyBoxPlanBillDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetContactMoneyBoxPlanBillDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetContactMoneyBoxPlanBill(response: HttpResponseBase): Observable<GetContactMoneyBoxPlanBillDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetContactMoneyBoxPlanBillDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetContactMoneyBoxPlanBillDto>(<any>null);
    }

    /**
     * @param planBillId (optional) 
     * @return Success
     */
    getUnPayedPlanBillBills(planBillId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PlanBills/GetUnPayedPlanBillBills?";
        if (planBillId === null)
            throw new Error("The parameter 'planBillId' cannot be null.");
        else if (planBillId !== undefined)
            url_ += "planBillId=" + encodeURIComponent("" + planBillId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnPayedPlanBillBills(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnPayedPlanBillBills(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetUnPayedPlanBillBills(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    expirePlanBill(body: ExpirePlanBillInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PlanBills/ExpirePlanBill";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExpirePlanBill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExpirePlanBill(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExpirePlanBill(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cancelPlanBill(body: ExpirePlanBillInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PlanBills/CancelPlanBill";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelPlanBill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelPlanBill(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCancelPlanBill(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param count (optional) 
     * @param planBillCode (optional) 
     * @return Success
     */
    getEarlyPayments(count: number | undefined, planBillCode: string | undefined): Observable<moment.Moment[]> {
        let url_ = this.baseUrl + "/api/services/app/PlanBills/GetEarlyPayments?";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&"; 
        if (planBillCode === null)
            throw new Error("The parameter 'planBillCode' cannot be null.");
        else if (planBillCode !== undefined)
            url_ += "planBillCode=" + encodeURIComponent("" + planBillCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEarlyPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEarlyPayments(<any>response_);
                } catch (e) {
                    return <Observable<moment.Moment[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<moment.Moment[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetEarlyPayments(response: HttpResponseBase): Observable<moment.Moment[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(moment(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<moment.Moment[]>(<any>null);
    }

    /**
     * @param planBillId (optional) 
     * @return Success
     */
    getDelaiedPayments(planBillId: number | undefined): Observable<GetDelaiedPaymentsDto> {
        let url_ = this.baseUrl + "/api/services/app/PlanBills/GetDelaiedPayments?";
        if (planBillId === null)
            throw new Error("The parameter 'planBillId' cannot be null.");
        else if (planBillId !== undefined)
            url_ += "planBillId=" + encodeURIComponent("" + planBillId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDelaiedPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDelaiedPayments(<any>response_);
                } catch (e) {
                    return <Observable<GetDelaiedPaymentsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetDelaiedPaymentsDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetDelaiedPayments(response: HttpResponseBase): Observable<GetDelaiedPaymentsDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDelaiedPaymentsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDelaiedPaymentsDto>(<any>null);
    }

    /**
     * @return Success
     */
    checkDuePlanBillsAndRecordBill(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PlanBills/CheckDuePlanBillsAndRecordBill";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckDuePlanBillsAndRecordBill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckDuePlanBillsAndRecordBill(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCheckDuePlanBillsAndRecordBill(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approveMoneyBox(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PlanBills/ApproveMoneyBox";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveMoneyBox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveMoneyBox(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApproveMoneyBox(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class PlanCategoriesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param maxParentIdFilter (optional) 
     * @param minParentIdFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, titleFilter: string | undefined, maxParentIdFilter: number | undefined, minParentIdFilter: number | undefined, descriptionFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetPlanCategoryForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PlanCategories/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (maxParentIdFilter === null)
            throw new Error("The parameter 'maxParentIdFilter' cannot be null.");
        else if (maxParentIdFilter !== undefined)
            url_ += "MaxParentIdFilter=" + encodeURIComponent("" + maxParentIdFilter) + "&"; 
        if (minParentIdFilter === null)
            throw new Error("The parameter 'minParentIdFilter' cannot be null.");
        else if (minParentIdFilter !== undefined)
            url_ += "MinParentIdFilter=" + encodeURIComponent("" + minParentIdFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetPlanCategoryForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetPlanCategoryForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetPlanCategoryForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetPlanCategoryForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetPlanCategoryForViewDto>(<any>null);
    }

    /**
     * @return Success
     */
    ping(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PlanCategories/Ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPing(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPing(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPlanCategoryForView(id: number | undefined): Observable<GetPlanCategoryForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PlanCategories/GetPlanCategoryForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlanCategoryForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlanCategoryForView(<any>response_);
                } catch (e) {
                    return <Observable<GetPlanCategoryForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPlanCategoryForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPlanCategoryForView(response: HttpResponseBase): Observable<GetPlanCategoryForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPlanCategoryForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPlanCategoryForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPlanCategoryForEdit(id: number | undefined): Observable<GetPlanCategoryForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/PlanCategories/GetPlanCategoryForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlanCategoryForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlanCategoryForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetPlanCategoryForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPlanCategoryForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetPlanCategoryForEdit(response: HttpResponseBase): Observable<GetPlanCategoryForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPlanCategoryForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPlanCategoryForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditPlanCategoryDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PlanCategories/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PlanCategories/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteByChangeState(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PlanCategories/DeleteByChangeState?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteByChangeState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByChangeState(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteByChangeState(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param maxParentIdFilter (optional) 
     * @param minParentIdFilter (optional) 
     * @param descriptionFilter (optional) 
     * @return Success
     */
    getPlanCategoriesToExcel(filter: string | undefined, titleFilter: string | undefined, maxParentIdFilter: number | undefined, minParentIdFilter: number | undefined, descriptionFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/PlanCategories/GetPlanCategoriesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (maxParentIdFilter === null)
            throw new Error("The parameter 'maxParentIdFilter' cannot be null.");
        else if (maxParentIdFilter !== undefined)
            url_ += "MaxParentIdFilter=" + encodeURIComponent("" + maxParentIdFilter) + "&"; 
        if (minParentIdFilter === null)
            throw new Error("The parameter 'minParentIdFilter' cannot be null.");
        else if (minParentIdFilter !== undefined)
            url_ += "MinParentIdFilter=" + encodeURIComponent("" + minParentIdFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlanCategoriesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlanCategoriesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPlanCategoriesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    shopGetAll(): Observable<PagedResultDtoOfGetPlanCategoriesForSiteJson> {
        let url_ = this.baseUrl + "/api/services/app/PlanCategories/ShopGetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShopGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShopGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetPlanCategoriesForSiteJson>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetPlanCategoriesForSiteJson>><any>_observableThrow(response_);
        }));
    }

    protected processShopGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetPlanCategoriesForSiteJson> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetPlanCategoriesForSiteJson.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetPlanCategoriesForSiteJson>(<any>null);
    }

    /**
     * @return Success
     */
    getAllPlanCategoryForTableDropdown(): Observable<PlanCategoryPlanCategoryLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PlanCategories/GetAllPlanCategoryForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPlanCategoryForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPlanCategoryForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<PlanCategoryPlanCategoryLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PlanCategoryPlanCategoryLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPlanCategoryForTableDropdown(response: HttpResponseBase): Observable<PlanCategoryPlanCategoryLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlanCategoryPlanCategoryLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlanCategoryPlanCategoryLookupTableDto[]>(<any>null);
    }
}

@Injectable()
export class PlanConstsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param codeFilter (optional) 
     * @param isShowFilter (optional) 
     * @param stateFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param sourceNameFilter (optional) 
     * @param consumesRefFilter (optional) 
     * @param planLinkFilter (optional) 
     * @param maxStartDateFilter (optional) 
     * @param minStartDateFilter (optional) 
     * @param maxEndDateFilter (optional) 
     * @param minEndDateFilter (optional) 
     * @param planTypeFilter (optional) 
     * @param planCategoryTitleFilter (optional) 
     * @param tagsFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, titleFilter: string | undefined, codeFilter: string | undefined, isShowFilter: number | undefined, stateFilter: number | undefined, descriptionFilter: string | undefined, sourceNameFilter: string | undefined, consumesRefFilter: string | undefined, planLinkFilter: string | undefined, maxStartDateFilter: moment.Moment | undefined, minStartDateFilter: moment.Moment | undefined, maxEndDateFilter: moment.Moment | undefined, minEndDateFilter: moment.Moment | undefined, planTypeFilter: number | undefined, planCategoryTitleFilter: string | undefined, tagsFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetPlanConstForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PlanConsts/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (isShowFilter === null)
            throw new Error("The parameter 'isShowFilter' cannot be null.");
        else if (isShowFilter !== undefined)
            url_ += "IsShowFilter=" + encodeURIComponent("" + isShowFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (sourceNameFilter === null)
            throw new Error("The parameter 'sourceNameFilter' cannot be null.");
        else if (sourceNameFilter !== undefined)
            url_ += "SourceNameFilter=" + encodeURIComponent("" + sourceNameFilter) + "&"; 
        if (consumesRefFilter === null)
            throw new Error("The parameter 'consumesRefFilter' cannot be null.");
        else if (consumesRefFilter !== undefined)
            url_ += "ConsumesRefFilter=" + encodeURIComponent("" + consumesRefFilter) + "&"; 
        if (planLinkFilter === null)
            throw new Error("The parameter 'planLinkFilter' cannot be null.");
        else if (planLinkFilter !== undefined)
            url_ += "PlanLinkFilter=" + encodeURIComponent("" + planLinkFilter) + "&"; 
        if (maxStartDateFilter === null)
            throw new Error("The parameter 'maxStartDateFilter' cannot be null.");
        else if (maxStartDateFilter !== undefined)
            url_ += "MaxStartDateFilter=" + encodeURIComponent(maxStartDateFilter ? "" + maxStartDateFilter.toJSON() : "") + "&"; 
        if (minStartDateFilter === null)
            throw new Error("The parameter 'minStartDateFilter' cannot be null.");
        else if (minStartDateFilter !== undefined)
            url_ += "MinStartDateFilter=" + encodeURIComponent(minStartDateFilter ? "" + minStartDateFilter.toJSON() : "") + "&"; 
        if (maxEndDateFilter === null)
            throw new Error("The parameter 'maxEndDateFilter' cannot be null.");
        else if (maxEndDateFilter !== undefined)
            url_ += "MaxEndDateFilter=" + encodeURIComponent(maxEndDateFilter ? "" + maxEndDateFilter.toJSON() : "") + "&"; 
        if (minEndDateFilter === null)
            throw new Error("The parameter 'minEndDateFilter' cannot be null.");
        else if (minEndDateFilter !== undefined)
            url_ += "MinEndDateFilter=" + encodeURIComponent(minEndDateFilter ? "" + minEndDateFilter.toJSON() : "") + "&"; 
        if (planTypeFilter === null)
            throw new Error("The parameter 'planTypeFilter' cannot be null.");
        else if (planTypeFilter !== undefined)
            url_ += "PlanTypeFilter=" + encodeURIComponent("" + planTypeFilter) + "&"; 
        if (planCategoryTitleFilter === null)
            throw new Error("The parameter 'planCategoryTitleFilter' cannot be null.");
        else if (planCategoryTitleFilter !== undefined)
            url_ += "PlanCategoryTitleFilter=" + encodeURIComponent("" + planCategoryTitleFilter) + "&"; 
        if (tagsFilter === null)
            throw new Error("The parameter 'tagsFilter' cannot be null.");
        else if (tagsFilter !== undefined)
            url_ += "TagsFilter=" + encodeURIComponent("" + tagsFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetPlanConstForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetPlanConstForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetPlanConstForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetPlanConstForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetPlanConstForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPlanConstForView(id: number | undefined): Observable<GetPlanConstForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PlanConsts/GetPlanConstForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlanConstForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlanConstForView(<any>response_);
                } catch (e) {
                    return <Observable<GetPlanConstForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPlanConstForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPlanConstForView(response: HttpResponseBase): Observable<GetPlanConstForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPlanConstForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPlanConstForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param currencyId (optional) 
     * @return Success
     */
    getPlanConstAndPlans(id: number | undefined, currencyId: number | undefined): Observable<GetPlanConstAndPlansDto> {
        let url_ = this.baseUrl + "/api/services/app/PlanConsts/GetPlanConstAndPlans?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (currencyId === null)
            throw new Error("The parameter 'currencyId' cannot be null.");
        else if (currencyId !== undefined)
            url_ += "currencyId=" + encodeURIComponent("" + currencyId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlanConstAndPlans(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlanConstAndPlans(<any>response_);
                } catch (e) {
                    return <Observable<GetPlanConstAndPlansDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPlanConstAndPlansDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPlanConstAndPlans(response: HttpResponseBase): Observable<GetPlanConstAndPlansDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPlanConstAndPlansDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPlanConstAndPlansDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPlanConstForEdit(id: number | undefined): Observable<GetPlanConstForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/PlanConsts/GetPlanConstForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlanConstForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlanConstForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetPlanConstForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPlanConstForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetPlanConstForEdit(response: HttpResponseBase): Observable<GetPlanConstForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPlanConstForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPlanConstForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditPlanConstDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PlanConsts/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAndGetId(body: CreateOrEditPlanConstDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PlanConsts/CreateAndGetId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAndGetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAndGetId(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateAndGetId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditPlanConstAndBannerAndPlan(body: CreateOrEditPlanConstAndBannerAndPlansDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PlanConsts/CreateOrEditPlanConstAndBannerAndPlan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditPlanConstAndBannerAndPlan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditPlanConstAndBannerAndPlan(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditPlanConstAndBannerAndPlan(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param stateFilter (optional) 
     * @param planCategoryTitleFilter (optional) 
     * @param planTypeFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param tagsFilter (optional) 
     * @param isPrivateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllPlans(filter: string | undefined, titleFilter: string | undefined, stateFilter: number | undefined, planCategoryTitleFilter: string | undefined, planTypeFilter: Plans | undefined, descriptionFilter: string | undefined, tagsFilter: string | undefined, isPrivateFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetPlanForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PlanConsts/GetAllPlans?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (planCategoryTitleFilter === null)
            throw new Error("The parameter 'planCategoryTitleFilter' cannot be null.");
        else if (planCategoryTitleFilter !== undefined)
            url_ += "PlanCategoryTitleFilter=" + encodeURIComponent("" + planCategoryTitleFilter) + "&"; 
        if (planTypeFilter === null)
            throw new Error("The parameter 'planTypeFilter' cannot be null.");
        else if (planTypeFilter !== undefined)
            url_ += "PlanTypeFilter=" + encodeURIComponent("" + planTypeFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (tagsFilter === null)
            throw new Error("The parameter 'tagsFilter' cannot be null.");
        else if (tagsFilter !== undefined)
            url_ += "TagsFilter=" + encodeURIComponent("" + tagsFilter) + "&"; 
        if (isPrivateFilter === null)
            throw new Error("The parameter 'isPrivateFilter' cannot be null.");
        else if (isPrivateFilter !== undefined)
            url_ += "IsPrivateFilter=" + encodeURIComponent("" + isPrivateFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPlans(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPlans(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetPlanForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetPlanForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPlans(response: HttpResponseBase): Observable<PagedResultDtoOfGetPlanForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetPlanForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetPlanForViewDto>(<any>null);
    }

    /**
     * @param planType (optional) 
     * @param planConstId (optional) 
     * @return Success
     */
    getPlanConstAndPlanAndBannerForEdit(planType: Plans | undefined, planConstId: number | undefined): Observable<GetPlanConstAndBannerAndPlansDto> {
        let url_ = this.baseUrl + "/api/services/app/PlanConsts/GetPlanConstAndPlanAndBannerForEdit?";
        if (planType === null)
            throw new Error("The parameter 'planType' cannot be null.");
        else if (planType !== undefined)
            url_ += "planType=" + encodeURIComponent("" + planType) + "&"; 
        if (planConstId === null)
            throw new Error("The parameter 'planConstId' cannot be null.");
        else if (planConstId !== undefined)
            url_ += "planConstId=" + encodeURIComponent("" + planConstId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlanConstAndPlanAndBannerForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlanConstAndPlanAndBannerForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetPlanConstAndBannerAndPlansDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPlanConstAndBannerAndPlansDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPlanConstAndPlanAndBannerForEdit(response: HttpResponseBase): Observable<GetPlanConstAndBannerAndPlansDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPlanConstAndBannerAndPlansDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPlanConstAndBannerAndPlansDto>(<any>null);
    }

    /**
     * @return Success
     */
    createPlansCashForShop(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PlanConsts/CreatePlansCashForShop";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlansCashForShop(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlansCashForShop(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreatePlansCashForShop(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param planTypeFilter (optional) 
     * @param minPriceFilter (optional) 
     * @param maxPricefilter (optional) 
     * @param categoryFilter (optional) 
     * @param incloudCode (optional) 
     * @param page (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllPlansForShop(filter: string | undefined, planTypeFilter: string | undefined, minPriceFilter: number | undefined, maxPricefilter: number | undefined, categoryFilter: number | undefined, incloudCode: string | undefined, page: number | undefined, requestPage: RequestPage, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultPlanShopDto> {
        let url_ = this.baseUrl + "/api/services/app/PlanConsts/GetAllPlansForShop?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (planTypeFilter === null)
            throw new Error("The parameter 'planTypeFilter' cannot be null.");
        else if (planTypeFilter !== undefined)
            url_ += "PlanTypeFilter=" + encodeURIComponent("" + planTypeFilter) + "&"; 
        if (minPriceFilter === null)
            throw new Error("The parameter 'minPriceFilter' cannot be null.");
        else if (minPriceFilter !== undefined)
            url_ += "MinPriceFilter=" + encodeURIComponent("" + minPriceFilter) + "&"; 
        if (maxPricefilter === null)
            throw new Error("The parameter 'maxPricefilter' cannot be null.");
        else if (maxPricefilter !== undefined)
            url_ += "MaxPricefilter=" + encodeURIComponent("" + maxPricefilter) + "&"; 
        if (categoryFilter === null)
            throw new Error("The parameter 'categoryFilter' cannot be null.");
        else if (categoryFilter !== undefined)
            url_ += "CategoryFilter=" + encodeURIComponent("" + categoryFilter) + "&"; 
        if (incloudCode === null)
            throw new Error("The parameter 'incloudCode' cannot be null.");
        else if (incloudCode !== undefined)
            url_ += "IncloudCode=" + encodeURIComponent("" + incloudCode) + "&"; 
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (requestPage === undefined || requestPage === null)
            throw new Error("The parameter 'requestPage' must be defined and cannot be null.");
        else
            url_ += "RequestPage=" + encodeURIComponent("" + requestPage) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPlansForShop(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPlansForShop(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultPlanShopDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultPlanShopDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPlansForShop(response: HttpResponseBase): Observable<PagedResultPlanShopDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultPlanShopDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultPlanShopDto>(<any>null);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    getPlanDetailsForShop(code: string | undefined, planType: Plans): Observable<GetAllPlansForShopViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PlanConsts/GetPlanDetailsForShop?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        if (planType === undefined || planType === null)
            throw new Error("The parameter 'planType' must be defined and cannot be null.");
        else
            url_ += "planType=" + encodeURIComponent("" + planType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlanDetailsForShop(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlanDetailsForShop(<any>response_);
                } catch (e) {
                    return <Observable<GetAllPlansForShopViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAllPlansForShopViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPlanDetailsForShop(response: HttpResponseBase): Observable<GetAllPlansForShopViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllPlansForShopViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAllPlansForShopViewDto>(<any>null);
    }

    /**
     * @return Success
     */
    checkPlansPayment(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PlanConsts/CheckPlansPayment";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckPlansPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckPlansPayment(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCheckPlansPayment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PlanConsts/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param planConstId (optional) 
     * @return Success
     */
    deletePlanConstAndPlanAndBanner(planConstId: number | undefined, planType: Plans): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PlanConsts/DeletePlanConstAndPlanAndBanner?";
        if (planConstId === null)
            throw new Error("The parameter 'planConstId' cannot be null.");
        else if (planConstId !== undefined)
            url_ += "planConstId=" + encodeURIComponent("" + planConstId) + "&"; 
        if (planType === undefined || planType === null)
            throw new Error("The parameter 'planType' must be defined and cannot be null.");
        else
            url_ += "planType=" + encodeURIComponent("" + planType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePlanConstAndPlanAndBanner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePlanConstAndPlanAndBanner(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeletePlanConstAndPlanAndBanner(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param codeFilter (optional) 
     * @param isShowFilter (optional) 
     * @param stateFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param consumesRefFilter (optional) 
     * @param sourceNameFilter (optional) 
     * @param planLinkFilter (optional) 
     * @param maxStartDateFilter (optional) 
     * @param minStartDateFilter (optional) 
     * @param maxEndDateFilter (optional) 
     * @param minEndDateFilter (optional) 
     * @param planTypeFilter (optional) 
     * @param planCategoryTitleFilter (optional) 
     * @param tagsFilter (optional) 
     * @return Success
     */
    getPlanConstsToExcel(filter: string | undefined, titleFilter: string | undefined, codeFilter: string | undefined, isShowFilter: number | undefined, stateFilter: number | undefined, descriptionFilter: string | undefined, consumesRefFilter: string | undefined, sourceNameFilter: string | undefined, planLinkFilter: string | undefined, maxStartDateFilter: moment.Moment | undefined, minStartDateFilter: moment.Moment | undefined, maxEndDateFilter: moment.Moment | undefined, minEndDateFilter: moment.Moment | undefined, planTypeFilter: number | undefined, planCategoryTitleFilter: string | undefined, tagsFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/PlanConsts/GetPlanConstsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (isShowFilter === null)
            throw new Error("The parameter 'isShowFilter' cannot be null.");
        else if (isShowFilter !== undefined)
            url_ += "IsShowFilter=" + encodeURIComponent("" + isShowFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (consumesRefFilter === null)
            throw new Error("The parameter 'consumesRefFilter' cannot be null.");
        else if (consumesRefFilter !== undefined)
            url_ += "ConsumesRefFilter=" + encodeURIComponent("" + consumesRefFilter) + "&"; 
        if (sourceNameFilter === null)
            throw new Error("The parameter 'sourceNameFilter' cannot be null.");
        else if (sourceNameFilter !== undefined)
            url_ += "SourceNameFilter=" + encodeURIComponent("" + sourceNameFilter) + "&"; 
        if (planLinkFilter === null)
            throw new Error("The parameter 'planLinkFilter' cannot be null.");
        else if (planLinkFilter !== undefined)
            url_ += "PlanLinkFilter=" + encodeURIComponent("" + planLinkFilter) + "&"; 
        if (maxStartDateFilter === null)
            throw new Error("The parameter 'maxStartDateFilter' cannot be null.");
        else if (maxStartDateFilter !== undefined)
            url_ += "MaxStartDateFilter=" + encodeURIComponent(maxStartDateFilter ? "" + maxStartDateFilter.toJSON() : "") + "&"; 
        if (minStartDateFilter === null)
            throw new Error("The parameter 'minStartDateFilter' cannot be null.");
        else if (minStartDateFilter !== undefined)
            url_ += "MinStartDateFilter=" + encodeURIComponent(minStartDateFilter ? "" + minStartDateFilter.toJSON() : "") + "&"; 
        if (maxEndDateFilter === null)
            throw new Error("The parameter 'maxEndDateFilter' cannot be null.");
        else if (maxEndDateFilter !== undefined)
            url_ += "MaxEndDateFilter=" + encodeURIComponent(maxEndDateFilter ? "" + maxEndDateFilter.toJSON() : "") + "&"; 
        if (minEndDateFilter === null)
            throw new Error("The parameter 'minEndDateFilter' cannot be null.");
        else if (minEndDateFilter !== undefined)
            url_ += "MinEndDateFilter=" + encodeURIComponent(minEndDateFilter ? "" + minEndDateFilter.toJSON() : "") + "&"; 
        if (planTypeFilter === null)
            throw new Error("The parameter 'planTypeFilter' cannot be null.");
        else if (planTypeFilter !== undefined)
            url_ += "PlanTypeFilter=" + encodeURIComponent("" + planTypeFilter) + "&"; 
        if (planCategoryTitleFilter === null)
            throw new Error("The parameter 'planCategoryTitleFilter' cannot be null.");
        else if (planCategoryTitleFilter !== undefined)
            url_ += "PlanCategoryTitleFilter=" + encodeURIComponent("" + planCategoryTitleFilter) + "&"; 
        if (tagsFilter === null)
            throw new Error("The parameter 'tagsFilter' cannot be null.");
        else if (tagsFilter !== undefined)
            url_ += "TagsFilter=" + encodeURIComponent("" + tagsFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlanConstsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlanConstsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPlanConstsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllSourceForTableDropdown(): Observable<PlanConstSourceLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PlanConsts/GetAllSourceForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSourceForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSourceForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<PlanConstSourceLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PlanConstSourceLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSourceForTableDropdown(response: HttpResponseBase): Observable<PlanConstSourceLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlanConstSourceLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlanConstSourceLookupTableDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllPlanCategoryForTableDropdown(): Observable<PlanConstPlanCategoryLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PlanConsts/GetAllPlanCategoryForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPlanCategoryForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPlanCategoryForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<PlanConstPlanCategoryLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PlanConstPlanCategoryLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPlanCategoryForTableDropdown(response: HttpResponseBase): Observable<PlanConstPlanCategoryLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlanConstPlanCategoryLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlanConstPlanCategoryLookupTableDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllCurrencyForTableDropdown(): Observable<PlanConstCurrencyLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PlanConsts/GetAllCurrencyForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCurrencyForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCurrencyForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<PlanConstCurrencyLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PlanConstCurrencyLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCurrencyForTableDropdown(response: HttpResponseBase): Observable<PlanConstCurrencyLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlanConstCurrencyLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlanConstCurrencyLookupTableDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllConsumeForTableDropdown(): Observable<PlanConstConsumeLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PlanConsts/GetAllConsumeForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllConsumeForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllConsumeForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<PlanConstConsumeLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PlanConstConsumeLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllConsumeForTableDropdown(response: HttpResponseBase): Observable<PlanConstConsumeLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlanConstConsumeLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlanConstConsumeLookupTableDto[]>(<any>null);
    }

    /**
     * @param sourceId (optional) 
     * @return Success
     */
    getConsumesWithConditions(sourceId: number | undefined): Observable<PlanConstConsumeLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PlanConsts/GetConsumesWithConditions?";
        if (sourceId === null)
            throw new Error("The parameter 'sourceId' cannot be null.");
        else if (sourceId !== undefined)
            url_ += "sourceId=" + encodeURIComponent("" + sourceId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsumesWithConditions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsumesWithConditions(<any>response_);
                } catch (e) {
                    return <Observable<PlanConstConsumeLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PlanConstConsumeLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetConsumesWithConditions(response: HttpResponseBase): Observable<PlanConstConsumeLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlanConstConsumeLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlanConstConsumeLookupTableDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllCardTemplateForTableDropdown(): Observable<PlanConstCardTemplateLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PlanConsts/GetAllCardTemplateForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCardTemplateForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCardTemplateForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<PlanConstCardTemplateLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PlanConstCardTemplateLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCardTemplateForTableDropdown(response: HttpResponseBase): Observable<PlanConstCardTemplateLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlanConstCardTemplateLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlanConstCardTemplateLookupTableDto[]>(<any>null);
    }

    /**
     * @param firstNameFilter (optional) 
     * @param genderFilter (optional) 
     * @param minAgeFilter (optional) 
     * @param maxAgeFilter (optional) 
     * @param minBirthDate (optional) 
     * @param maxBirthDate (optional) 
     * @param healthStatusFilter (optional) 
     * @param isSadatFilter (optional) 
     * @param page (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllClientForShop(firstNameFilter: string | undefined, genderFilter: Gender | undefined, minAgeFilter: number | undefined, maxAgeFilter: number | undefined, minBirthDate: moment.Moment | undefined, maxBirthDate: moment.Moment | undefined, healthStatusFilter: string | undefined, isSadatFilter: boolean | undefined, page: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAllClientForShopDto> {
        let url_ = this.baseUrl + "/api/services/app/PlanConsts/GetAllClientForShop?";
        if (firstNameFilter === null)
            throw new Error("The parameter 'firstNameFilter' cannot be null.");
        else if (firstNameFilter !== undefined)
            url_ += "FirstNameFilter=" + encodeURIComponent("" + firstNameFilter) + "&"; 
        if (genderFilter === null)
            throw new Error("The parameter 'genderFilter' cannot be null.");
        else if (genderFilter !== undefined)
            url_ += "GenderFilter=" + encodeURIComponent("" + genderFilter) + "&"; 
        if (minAgeFilter === null)
            throw new Error("The parameter 'minAgeFilter' cannot be null.");
        else if (minAgeFilter !== undefined)
            url_ += "MinAgeFilter=" + encodeURIComponent("" + minAgeFilter) + "&"; 
        if (maxAgeFilter === null)
            throw new Error("The parameter 'maxAgeFilter' cannot be null.");
        else if (maxAgeFilter !== undefined)
            url_ += "MaxAgeFilter=" + encodeURIComponent("" + maxAgeFilter) + "&"; 
        if (minBirthDate === null)
            throw new Error("The parameter 'minBirthDate' cannot be null.");
        else if (minBirthDate !== undefined)
            url_ += "MinBirthDate=" + encodeURIComponent(minBirthDate ? "" + minBirthDate.toJSON() : "") + "&"; 
        if (maxBirthDate === null)
            throw new Error("The parameter 'maxBirthDate' cannot be null.");
        else if (maxBirthDate !== undefined)
            url_ += "MaxBirthDate=" + encodeURIComponent(maxBirthDate ? "" + maxBirthDate.toJSON() : "") + "&"; 
        if (healthStatusFilter === null)
            throw new Error("The parameter 'healthStatusFilter' cannot be null.");
        else if (healthStatusFilter !== undefined)
            url_ += "HealthStatusFilter=" + encodeURIComponent("" + healthStatusFilter) + "&"; 
        if (isSadatFilter === null)
            throw new Error("The parameter 'isSadatFilter' cannot be null.");
        else if (isSadatFilter !== undefined)
            url_ += "IsSadatFilter=" + encodeURIComponent("" + isSadatFilter) + "&"; 
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllClientForShop(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllClientForShop(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAllClientForShopDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAllClientForShopDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllClientForShop(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllClientForShopDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAllClientForShopDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAllClientForShopDto>(<any>null);
    }

    /**
     * @param firstNameFilter (optional) 
     * @param genderFilter (optional) 
     * @param minAgeFilter (optional) 
     * @param maxAgeFilter (optional) 
     * @param minBirthDate (optional) 
     * @param maxBirthDate (optional) 
     * @param healthStatusFilter (optional) 
     * @param isSadatFilter (optional) 
     * @param page (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllFamilyForShop(firstNameFilter: string | undefined, genderFilter: Gender | undefined, minAgeFilter: number | undefined, maxAgeFilter: number | undefined, minBirthDate: moment.Moment | undefined, maxBirthDate: moment.Moment | undefined, healthStatusFilter: string | undefined, isSadatFilter: boolean | undefined, page: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAllClientForShopDto> {
        let url_ = this.baseUrl + "/api/services/app/PlanConsts/GetAllFamilyForShop?";
        if (firstNameFilter === null)
            throw new Error("The parameter 'firstNameFilter' cannot be null.");
        else if (firstNameFilter !== undefined)
            url_ += "FirstNameFilter=" + encodeURIComponent("" + firstNameFilter) + "&"; 
        if (genderFilter === null)
            throw new Error("The parameter 'genderFilter' cannot be null.");
        else if (genderFilter !== undefined)
            url_ += "GenderFilter=" + encodeURIComponent("" + genderFilter) + "&"; 
        if (minAgeFilter === null)
            throw new Error("The parameter 'minAgeFilter' cannot be null.");
        else if (minAgeFilter !== undefined)
            url_ += "MinAgeFilter=" + encodeURIComponent("" + minAgeFilter) + "&"; 
        if (maxAgeFilter === null)
            throw new Error("The parameter 'maxAgeFilter' cannot be null.");
        else if (maxAgeFilter !== undefined)
            url_ += "MaxAgeFilter=" + encodeURIComponent("" + maxAgeFilter) + "&"; 
        if (minBirthDate === null)
            throw new Error("The parameter 'minBirthDate' cannot be null.");
        else if (minBirthDate !== undefined)
            url_ += "MinBirthDate=" + encodeURIComponent(minBirthDate ? "" + minBirthDate.toJSON() : "") + "&"; 
        if (maxBirthDate === null)
            throw new Error("The parameter 'maxBirthDate' cannot be null.");
        else if (maxBirthDate !== undefined)
            url_ += "MaxBirthDate=" + encodeURIComponent(maxBirthDate ? "" + maxBirthDate.toJSON() : "") + "&"; 
        if (healthStatusFilter === null)
            throw new Error("The parameter 'healthStatusFilter' cannot be null.");
        else if (healthStatusFilter !== undefined)
            url_ += "HealthStatusFilter=" + encodeURIComponent("" + healthStatusFilter) + "&"; 
        if (isSadatFilter === null)
            throw new Error("The parameter 'isSadatFilter' cannot be null.");
        else if (isSadatFilter !== undefined)
            url_ += "IsSadatFilter=" + encodeURIComponent("" + isSadatFilter) + "&"; 
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFamilyForShop(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFamilyForShop(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAllClientForShopDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAllClientForShopDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllFamilyForShop(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllClientForShopDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAllClientForShopDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAllClientForShopDto>(<any>null);
    }

    /**
     * @param billCode (optional) 
     * @return Success
     */
    checkExpiryPlan(billCode: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PlanConsts/CheckExpiryPlan?";
        if (billCode === null)
            throw new Error("The parameter 'billCode' cannot be null.");
        else if (billCode !== undefined)
            url_ += "billCode=" + encodeURIComponent("" + billCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckExpiryPlan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckExpiryPlan(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCheckExpiryPlan(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllPlanConsts(): Observable<PlanConst[]> {
        let url_ = this.baseUrl + "/api/services/app/PlanConsts/GetAllPlanConsts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPlanConsts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPlanConsts(<any>response_);
                } catch (e) {
                    return <Observable<PlanConst[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PlanConst[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPlanConsts(response: HttpResponseBase): Observable<PlanConst[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlanConst.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlanConst[]>(<any>null);
    }

    /**
     * @param planConstId (optional) 
     * @param startCeremonyDateTime (optional) 
     * @param latitude (optional) 
     * @param longitude (optional) 
     * @param ceremonyId (optional) 
     * @param bill_BillId (optional) 
     * @param bill_BillStatus (optional) 
     * @param bill_IssueDate (optional) 
     * @return Success
     */
    getFlowerCrownCapacity(planConstId: number | undefined, startCeremonyDateTime: moment.Moment | undefined, latitude: number | undefined, longitude: number | undefined, ceremonyId: number | undefined, bill_BillId: number | undefined, bill_BillStatus: BillStatus | undefined, bill_IssueDate: moment.Moment | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PlanConsts/GetFlowerCrownCapacity?";
        if (planConstId === null)
            throw new Error("The parameter 'planConstId' cannot be null.");
        else if (planConstId !== undefined)
            url_ += "PlanConstId=" + encodeURIComponent("" + planConstId) + "&"; 
        if (startCeremonyDateTime === null)
            throw new Error("The parameter 'startCeremonyDateTime' cannot be null.");
        else if (startCeremonyDateTime !== undefined)
            url_ += "StartCeremonyDateTime=" + encodeURIComponent(startCeremonyDateTime ? "" + startCeremonyDateTime.toJSON() : "") + "&"; 
        if (latitude === null)
            throw new Error("The parameter 'latitude' cannot be null.");
        else if (latitude !== undefined)
            url_ += "Latitude=" + encodeURIComponent("" + latitude) + "&"; 
        if (longitude === null)
            throw new Error("The parameter 'longitude' cannot be null.");
        else if (longitude !== undefined)
            url_ += "Longitude=" + encodeURIComponent("" + longitude) + "&"; 
        if (ceremonyId === null)
            throw new Error("The parameter 'ceremonyId' cannot be null.");
        else if (ceremonyId !== undefined)
            url_ += "CeremonyId=" + encodeURIComponent("" + ceremonyId) + "&"; 
        if (bill_BillId === null)
            throw new Error("The parameter 'bill_BillId' cannot be null.");
        else if (bill_BillId !== undefined)
            url_ += "Bill.BillId=" + encodeURIComponent("" + bill_BillId) + "&"; 
        if (bill_BillStatus === null)
            throw new Error("The parameter 'bill_BillStatus' cannot be null.");
        else if (bill_BillStatus !== undefined)
            url_ += "Bill.BillStatus=" + encodeURIComponent("" + bill_BillStatus) + "&"; 
        if (bill_IssueDate === null)
            throw new Error("The parameter 'bill_IssueDate' cannot be null.");
        else if (bill_IssueDate !== undefined)
            url_ += "Bill.IssueDate=" + encodeURIComponent(bill_IssueDate ? "" + bill_IssueDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFlowerCrownCapacity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFlowerCrownCapacity(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetFlowerCrownCapacity(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    calculateProductCapacity(body: GetFlowerCrownCapacityInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PlanConsts/CalculateProductCapacity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateProductCapacity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateProductCapacity(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCalculateProductCapacity(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param tagFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getCharityPlans(tagFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCharityPlansDto> {
        let url_ = this.baseUrl + "/api/services/app/PlanConsts/GetCharityPlans?";
        if (tagFilter === null)
            throw new Error("The parameter 'tagFilter' cannot be null.");
        else if (tagFilter !== undefined)
            url_ += "TagFilter=" + encodeURIComponent("" + tagFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCharityPlans(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCharityPlans(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCharityPlansDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCharityPlansDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCharityPlans(response: HttpResponseBase): Observable<PagedResultDtoOfGetCharityPlansDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCharityPlansDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCharityPlansDto>(<any>null);
    }
}

@Injectable()
export class PlanCurrenciesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxMinAmountFilter (optional) 
     * @param minMinAmountFilter (optional) 
     * @param maxMaxAmountFilter (optional) 
     * @param minMaxAmountFilter (optional) 
     * @param currencyNameFilter (optional) 
     * @param planConstTitleFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, maxMinAmountFilter: number | undefined, minMinAmountFilter: number | undefined, maxMaxAmountFilter: number | undefined, minMaxAmountFilter: number | undefined, currencyNameFilter: string | undefined, planConstTitleFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetPlanCurrencyForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PlanCurrencies/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxMinAmountFilter === null)
            throw new Error("The parameter 'maxMinAmountFilter' cannot be null.");
        else if (maxMinAmountFilter !== undefined)
            url_ += "MaxMinAmountFilter=" + encodeURIComponent("" + maxMinAmountFilter) + "&"; 
        if (minMinAmountFilter === null)
            throw new Error("The parameter 'minMinAmountFilter' cannot be null.");
        else if (minMinAmountFilter !== undefined)
            url_ += "MinMinAmountFilter=" + encodeURIComponent("" + minMinAmountFilter) + "&"; 
        if (maxMaxAmountFilter === null)
            throw new Error("The parameter 'maxMaxAmountFilter' cannot be null.");
        else if (maxMaxAmountFilter !== undefined)
            url_ += "MaxMaxAmountFilter=" + encodeURIComponent("" + maxMaxAmountFilter) + "&"; 
        if (minMaxAmountFilter === null)
            throw new Error("The parameter 'minMaxAmountFilter' cannot be null.");
        else if (minMaxAmountFilter !== undefined)
            url_ += "MinMaxAmountFilter=" + encodeURIComponent("" + minMaxAmountFilter) + "&"; 
        if (currencyNameFilter === null)
            throw new Error("The parameter 'currencyNameFilter' cannot be null.");
        else if (currencyNameFilter !== undefined)
            url_ += "CurrencyNameFilter=" + encodeURIComponent("" + currencyNameFilter) + "&"; 
        if (planConstTitleFilter === null)
            throw new Error("The parameter 'planConstTitleFilter' cannot be null.");
        else if (planConstTitleFilter !== undefined)
            url_ += "PlanConstTitleFilter=" + encodeURIComponent("" + planConstTitleFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetPlanCurrencyForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetPlanCurrencyForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetPlanCurrencyForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetPlanCurrencyForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetPlanCurrencyForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPlanCurrencyForView(id: number | undefined): Observable<GetPlanCurrencyForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PlanCurrencies/GetPlanCurrencyForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlanCurrencyForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlanCurrencyForView(<any>response_);
                } catch (e) {
                    return <Observable<GetPlanCurrencyForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPlanCurrencyForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPlanCurrencyForView(response: HttpResponseBase): Observable<GetPlanCurrencyForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPlanCurrencyForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPlanCurrencyForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPlanCurrencyForEdit(id: number | undefined): Observable<GetPlanCurrencyForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/PlanCurrencies/GetPlanCurrencyForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlanCurrencyForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlanCurrencyForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetPlanCurrencyForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPlanCurrencyForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetPlanCurrencyForEdit(response: HttpResponseBase): Observable<GetPlanCurrencyForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPlanCurrencyForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPlanCurrencyForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditPlanCurrencyDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PlanCurrencies/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PlanCurrencies/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param maxMinAmountFilter (optional) 
     * @param minMinAmountFilter (optional) 
     * @param maxMaxAmountFilter (optional) 
     * @param minMaxAmountFilter (optional) 
     * @param currencyNameFilter (optional) 
     * @param planConstTitleFilter (optional) 
     * @return Success
     */
    getPlanCurrenciesToExcel(filter: string | undefined, maxMinAmountFilter: number | undefined, minMinAmountFilter: number | undefined, maxMaxAmountFilter: number | undefined, minMaxAmountFilter: number | undefined, currencyNameFilter: string | undefined, planConstTitleFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/PlanCurrencies/GetPlanCurrenciesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxMinAmountFilter === null)
            throw new Error("The parameter 'maxMinAmountFilter' cannot be null.");
        else if (maxMinAmountFilter !== undefined)
            url_ += "MaxMinAmountFilter=" + encodeURIComponent("" + maxMinAmountFilter) + "&"; 
        if (minMinAmountFilter === null)
            throw new Error("The parameter 'minMinAmountFilter' cannot be null.");
        else if (minMinAmountFilter !== undefined)
            url_ += "MinMinAmountFilter=" + encodeURIComponent("" + minMinAmountFilter) + "&"; 
        if (maxMaxAmountFilter === null)
            throw new Error("The parameter 'maxMaxAmountFilter' cannot be null.");
        else if (maxMaxAmountFilter !== undefined)
            url_ += "MaxMaxAmountFilter=" + encodeURIComponent("" + maxMaxAmountFilter) + "&"; 
        if (minMaxAmountFilter === null)
            throw new Error("The parameter 'minMaxAmountFilter' cannot be null.");
        else if (minMaxAmountFilter !== undefined)
            url_ += "MinMaxAmountFilter=" + encodeURIComponent("" + minMaxAmountFilter) + "&"; 
        if (currencyNameFilter === null)
            throw new Error("The parameter 'currencyNameFilter' cannot be null.");
        else if (currencyNameFilter !== undefined)
            url_ += "CurrencyNameFilter=" + encodeURIComponent("" + currencyNameFilter) + "&"; 
        if (planConstTitleFilter === null)
            throw new Error("The parameter 'planConstTitleFilter' cannot be null.");
        else if (planConstTitleFilter !== undefined)
            url_ += "PlanConstTitleFilter=" + encodeURIComponent("" + planConstTitleFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlanCurrenciesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlanCurrenciesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPlanCurrenciesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllCurrencyForTableDropdown(): Observable<PlanCurrencyCurrencyLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PlanCurrencies/GetAllCurrencyForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCurrencyForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCurrencyForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<PlanCurrencyCurrencyLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PlanCurrencyCurrencyLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCurrencyForTableDropdown(response: HttpResponseBase): Observable<PlanCurrencyCurrencyLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlanCurrencyCurrencyLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlanCurrencyCurrencyLookupTableDto[]>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllPlanConstForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfPlanCurrencyPlanConstLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/PlanCurrencies/GetAllPlanConstForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPlanConstForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPlanConstForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfPlanCurrencyPlanConstLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfPlanCurrencyPlanConstLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPlanConstForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfPlanCurrencyPlanConstLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPlanCurrencyPlanConstLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfPlanCurrencyPlanConstLookupTableDto>(<any>null);
    }
}

@Injectable()
export class PointsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param stateFilter (optional) 
     * @param maxLongitudeFilter (optional) 
     * @param minLongitudeFilter (optional) 
     * @param maxLatitudeFilter (optional) 
     * @param minLatitudeFilter (optional) 
     * @param maxOrderFilter (optional) 
     * @param minOrderFilter (optional) 
     * @param maxEntityRefFilter (optional) 
     * @param minEntityRefFilter (optional) 
     * @param entityFilter (optional) 
     * @param typeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, stateFilter: number | undefined, maxLongitudeFilter: number | undefined, minLongitudeFilter: number | undefined, maxLatitudeFilter: number | undefined, minLatitudeFilter: number | undefined, maxOrderFilter: number | undefined, minOrderFilter: number | undefined, maxEntityRefFilter: number | undefined, minEntityRefFilter: number | undefined, entityFilter: number | undefined, typeFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetPointForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Points/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (maxLongitudeFilter === null)
            throw new Error("The parameter 'maxLongitudeFilter' cannot be null.");
        else if (maxLongitudeFilter !== undefined)
            url_ += "MaxLongitudeFilter=" + encodeURIComponent("" + maxLongitudeFilter) + "&"; 
        if (minLongitudeFilter === null)
            throw new Error("The parameter 'minLongitudeFilter' cannot be null.");
        else if (minLongitudeFilter !== undefined)
            url_ += "MinLongitudeFilter=" + encodeURIComponent("" + minLongitudeFilter) + "&"; 
        if (maxLatitudeFilter === null)
            throw new Error("The parameter 'maxLatitudeFilter' cannot be null.");
        else if (maxLatitudeFilter !== undefined)
            url_ += "MaxLatitudeFilter=" + encodeURIComponent("" + maxLatitudeFilter) + "&"; 
        if (minLatitudeFilter === null)
            throw new Error("The parameter 'minLatitudeFilter' cannot be null.");
        else if (minLatitudeFilter !== undefined)
            url_ += "MinLatitudeFilter=" + encodeURIComponent("" + minLatitudeFilter) + "&"; 
        if (maxOrderFilter === null)
            throw new Error("The parameter 'maxOrderFilter' cannot be null.");
        else if (maxOrderFilter !== undefined)
            url_ += "MaxOrderFilter=" + encodeURIComponent("" + maxOrderFilter) + "&"; 
        if (minOrderFilter === null)
            throw new Error("The parameter 'minOrderFilter' cannot be null.");
        else if (minOrderFilter !== undefined)
            url_ += "MinOrderFilter=" + encodeURIComponent("" + minOrderFilter) + "&"; 
        if (maxEntityRefFilter === null)
            throw new Error("The parameter 'maxEntityRefFilter' cannot be null.");
        else if (maxEntityRefFilter !== undefined)
            url_ += "MaxEntityRefFilter=" + encodeURIComponent("" + maxEntityRefFilter) + "&"; 
        if (minEntityRefFilter === null)
            throw new Error("The parameter 'minEntityRefFilter' cannot be null.");
        else if (minEntityRefFilter !== undefined)
            url_ += "MinEntityRefFilter=" + encodeURIComponent("" + minEntityRefFilter) + "&"; 
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (typeFilter === null)
            throw new Error("The parameter 'typeFilter' cannot be null.");
        else if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetPointForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetPointForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetPointForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetPointForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetPointForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPointForView(id: number | undefined): Observable<GetPointForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Points/GetPointForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPointForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPointForView(<any>response_);
                } catch (e) {
                    return <Observable<GetPointForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPointForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPointForView(response: HttpResponseBase): Observable<GetPointForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPointForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPointForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPointForEdit(id: number | undefined): Observable<GetPointForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Points/GetPointForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPointForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPointForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetPointForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPointForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetPointForEdit(response: HttpResponseBase): Observable<GetPointForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPointForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPointForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditPointDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Points/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Points/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param stateFilter (optional) 
     * @param maxLongitudeFilter (optional) 
     * @param minLongitudeFilter (optional) 
     * @param maxLatitudeFilter (optional) 
     * @param minLatitudeFilter (optional) 
     * @param maxOrderFilter (optional) 
     * @param minOrderFilter (optional) 
     * @param maxEntityRefFilter (optional) 
     * @param minEntityRefFilter (optional) 
     * @param entityFilter (optional) 
     * @param typeFilter (optional) 
     * @return Success
     */
    getPointsToExcel(filter: string | undefined, stateFilter: number | undefined, maxLongitudeFilter: number | undefined, minLongitudeFilter: number | undefined, maxLatitudeFilter: number | undefined, minLatitudeFilter: number | undefined, maxOrderFilter: number | undefined, minOrderFilter: number | undefined, maxEntityRefFilter: number | undefined, minEntityRefFilter: number | undefined, entityFilter: number | undefined, typeFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Points/GetPointsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (maxLongitudeFilter === null)
            throw new Error("The parameter 'maxLongitudeFilter' cannot be null.");
        else if (maxLongitudeFilter !== undefined)
            url_ += "MaxLongitudeFilter=" + encodeURIComponent("" + maxLongitudeFilter) + "&"; 
        if (minLongitudeFilter === null)
            throw new Error("The parameter 'minLongitudeFilter' cannot be null.");
        else if (minLongitudeFilter !== undefined)
            url_ += "MinLongitudeFilter=" + encodeURIComponent("" + minLongitudeFilter) + "&"; 
        if (maxLatitudeFilter === null)
            throw new Error("The parameter 'maxLatitudeFilter' cannot be null.");
        else if (maxLatitudeFilter !== undefined)
            url_ += "MaxLatitudeFilter=" + encodeURIComponent("" + maxLatitudeFilter) + "&"; 
        if (minLatitudeFilter === null)
            throw new Error("The parameter 'minLatitudeFilter' cannot be null.");
        else if (minLatitudeFilter !== undefined)
            url_ += "MinLatitudeFilter=" + encodeURIComponent("" + minLatitudeFilter) + "&"; 
        if (maxOrderFilter === null)
            throw new Error("The parameter 'maxOrderFilter' cannot be null.");
        else if (maxOrderFilter !== undefined)
            url_ += "MaxOrderFilter=" + encodeURIComponent("" + maxOrderFilter) + "&"; 
        if (minOrderFilter === null)
            throw new Error("The parameter 'minOrderFilter' cannot be null.");
        else if (minOrderFilter !== undefined)
            url_ += "MinOrderFilter=" + encodeURIComponent("" + minOrderFilter) + "&"; 
        if (maxEntityRefFilter === null)
            throw new Error("The parameter 'maxEntityRefFilter' cannot be null.");
        else if (maxEntityRefFilter !== undefined)
            url_ += "MaxEntityRefFilter=" + encodeURIComponent("" + maxEntityRefFilter) + "&"; 
        if (minEntityRefFilter === null)
            throw new Error("The parameter 'minEntityRefFilter' cannot be null.");
        else if (minEntityRefFilter !== undefined)
            url_ += "MinEntityRefFilter=" + encodeURIComponent("" + minEntityRefFilter) + "&"; 
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (typeFilter === null)
            throw new Error("The parameter 'typeFilter' cannot be null.");
        else if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPointsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPointsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPointsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param directionId (optional) 
     * @return Success
     */
    deleteByDirection(directionId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Points/DeleteByDirection?";
        if (directionId === null)
            throw new Error("The parameter 'directionId' cannot be null.");
        else if (directionId !== undefined)
            url_ += "directionId=" + encodeURIComponent("" + directionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteByDirection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByDirection(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteByDirection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class PosesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param deviceTypeFilter (optional) 
     * @param pSPFilter (optional) 
     * @param serialFilter (optional) 
     * @param acceptorNumberFilter (optional) 
     * @param acceptorPasswordFilter (optional) 
     * @param posIdentityFilter (optional) 
     * @param stateFilter (optional) 
     * @param maxPortFilter (optional) 
     * @param minPortFilter (optional) 
     * @param iPFilter (optional) 
     * @param bankAccountAccountNumberFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, deviceTypeFilter: number | undefined, pSPFilter: number | undefined, serialFilter: string | undefined, acceptorNumberFilter: string | undefined, acceptorPasswordFilter: string | undefined, posIdentityFilter: string | undefined, stateFilter: number | undefined, maxPortFilter: number | undefined, minPortFilter: number | undefined, iPFilter: string | undefined, bankAccountAccountNumberFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetPosForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Poses/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (deviceTypeFilter === null)
            throw new Error("The parameter 'deviceTypeFilter' cannot be null.");
        else if (deviceTypeFilter !== undefined)
            url_ += "DeviceTypeFilter=" + encodeURIComponent("" + deviceTypeFilter) + "&"; 
        if (pSPFilter === null)
            throw new Error("The parameter 'pSPFilter' cannot be null.");
        else if (pSPFilter !== undefined)
            url_ += "PSPFilter=" + encodeURIComponent("" + pSPFilter) + "&"; 
        if (serialFilter === null)
            throw new Error("The parameter 'serialFilter' cannot be null.");
        else if (serialFilter !== undefined)
            url_ += "SerialFilter=" + encodeURIComponent("" + serialFilter) + "&"; 
        if (acceptorNumberFilter === null)
            throw new Error("The parameter 'acceptorNumberFilter' cannot be null.");
        else if (acceptorNumberFilter !== undefined)
            url_ += "AcceptorNumberFilter=" + encodeURIComponent("" + acceptorNumberFilter) + "&"; 
        if (acceptorPasswordFilter === null)
            throw new Error("The parameter 'acceptorPasswordFilter' cannot be null.");
        else if (acceptorPasswordFilter !== undefined)
            url_ += "AcceptorPasswordFilter=" + encodeURIComponent("" + acceptorPasswordFilter) + "&"; 
        if (posIdentityFilter === null)
            throw new Error("The parameter 'posIdentityFilter' cannot be null.");
        else if (posIdentityFilter !== undefined)
            url_ += "PosIdentityFilter=" + encodeURIComponent("" + posIdentityFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (maxPortFilter === null)
            throw new Error("The parameter 'maxPortFilter' cannot be null.");
        else if (maxPortFilter !== undefined)
            url_ += "MaxPortFilter=" + encodeURIComponent("" + maxPortFilter) + "&"; 
        if (minPortFilter === null)
            throw new Error("The parameter 'minPortFilter' cannot be null.");
        else if (minPortFilter !== undefined)
            url_ += "MinPortFilter=" + encodeURIComponent("" + minPortFilter) + "&"; 
        if (iPFilter === null)
            throw new Error("The parameter 'iPFilter' cannot be null.");
        else if (iPFilter !== undefined)
            url_ += "IPFilter=" + encodeURIComponent("" + iPFilter) + "&"; 
        if (bankAccountAccountNumberFilter === null)
            throw new Error("The parameter 'bankAccountAccountNumberFilter' cannot be null.");
        else if (bankAccountAccountNumberFilter !== undefined)
            url_ += "BankAccountAccountNumberFilter=" + encodeURIComponent("" + bankAccountAccountNumberFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetPosForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetPosForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetPosForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetPosForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetPosForViewDto>(<any>null);
    }

    /**
     * @param inputString (optional) 
     * @return Success
     */
    getHashString(inputString: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Poses/GetHashString?";
        if (inputString === null)
            throw new Error("The parameter 'inputString' cannot be null.");
        else if (inputString !== undefined)
            url_ += "inputString=" + encodeURIComponent("" + inputString) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHashString(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHashString(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetHashString(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPosForView(id: number | undefined): Observable<GetPosForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Poses/GetPosForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPosForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPosForView(<any>response_);
                } catch (e) {
                    return <Observable<GetPosForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPosForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPosForView(response: HttpResponseBase): Observable<GetPosForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPosForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPosForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPosForEdit(id: number | undefined): Observable<GetPosForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Poses/GetPosForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPosForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPosForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetPosForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPosForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetPosForEdit(response: HttpResponseBase): Observable<GetPosForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPosForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPosForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditPosAndUsers(body: CreateOrEditPosAndUsersDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Poses/CreateOrEditPosAndUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditPosAndUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditPosAndUsers(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditPosAndUsers(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditPosDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Poses/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Poses/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param deviceTypeFilter (optional) 
     * @param pSPFilter (optional) 
     * @param serialFilter (optional) 
     * @param acceptorNumberFilter (optional) 
     * @param acceptorPasswordFilter (optional) 
     * @param posIdentityFilter (optional) 
     * @param stateFilter (optional) 
     * @param maxPortFilter (optional) 
     * @param minPortFilter (optional) 
     * @param iPFilter (optional) 
     * @param bankAccountAccountNumberFilter (optional) 
     * @return Success
     */
    getPosesToExcel(filter: string | undefined, deviceTypeFilter: number | undefined, pSPFilter: number | undefined, serialFilter: string | undefined, acceptorNumberFilter: string | undefined, acceptorPasswordFilter: string | undefined, posIdentityFilter: string | undefined, stateFilter: number | undefined, maxPortFilter: number | undefined, minPortFilter: number | undefined, iPFilter: string | undefined, bankAccountAccountNumberFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Poses/GetPosesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (deviceTypeFilter === null)
            throw new Error("The parameter 'deviceTypeFilter' cannot be null.");
        else if (deviceTypeFilter !== undefined)
            url_ += "DeviceTypeFilter=" + encodeURIComponent("" + deviceTypeFilter) + "&"; 
        if (pSPFilter === null)
            throw new Error("The parameter 'pSPFilter' cannot be null.");
        else if (pSPFilter !== undefined)
            url_ += "PSPFilter=" + encodeURIComponent("" + pSPFilter) + "&"; 
        if (serialFilter === null)
            throw new Error("The parameter 'serialFilter' cannot be null.");
        else if (serialFilter !== undefined)
            url_ += "SerialFilter=" + encodeURIComponent("" + serialFilter) + "&"; 
        if (acceptorNumberFilter === null)
            throw new Error("The parameter 'acceptorNumberFilter' cannot be null.");
        else if (acceptorNumberFilter !== undefined)
            url_ += "AcceptorNumberFilter=" + encodeURIComponent("" + acceptorNumberFilter) + "&"; 
        if (acceptorPasswordFilter === null)
            throw new Error("The parameter 'acceptorPasswordFilter' cannot be null.");
        else if (acceptorPasswordFilter !== undefined)
            url_ += "AcceptorPasswordFilter=" + encodeURIComponent("" + acceptorPasswordFilter) + "&"; 
        if (posIdentityFilter === null)
            throw new Error("The parameter 'posIdentityFilter' cannot be null.");
        else if (posIdentityFilter !== undefined)
            url_ += "PosIdentityFilter=" + encodeURIComponent("" + posIdentityFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (maxPortFilter === null)
            throw new Error("The parameter 'maxPortFilter' cannot be null.");
        else if (maxPortFilter !== undefined)
            url_ += "MaxPortFilter=" + encodeURIComponent("" + maxPortFilter) + "&"; 
        if (minPortFilter === null)
            throw new Error("The parameter 'minPortFilter' cannot be null.");
        else if (minPortFilter !== undefined)
            url_ += "MinPortFilter=" + encodeURIComponent("" + minPortFilter) + "&"; 
        if (iPFilter === null)
            throw new Error("The parameter 'iPFilter' cannot be null.");
        else if (iPFilter !== undefined)
            url_ += "IPFilter=" + encodeURIComponent("" + iPFilter) + "&"; 
        if (bankAccountAccountNumberFilter === null)
            throw new Error("The parameter 'bankAccountAccountNumberFilter' cannot be null.");
        else if (bankAccountAccountNumberFilter !== undefined)
            url_ += "BankAccountAccountNumberFilter=" + encodeURIComponent("" + bankAccountAccountNumberFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPosesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPosesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPosesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllBankAccountForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfPosBankAccountLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Poses/GetAllBankAccountForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBankAccountForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBankAccountForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfPosBankAccountLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfPosBankAccountLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBankAccountForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfPosBankAccountLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPosBankAccountLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfPosBankAccountLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param posId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllPosUserForLookupTable(filter: string | undefined, posId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfPosUserLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Poses/GetAllPosUserForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (posId === null)
            throw new Error("The parameter 'posId' cannot be null.");
        else if (posId !== undefined)
            url_ += "PosId=" + encodeURIComponent("" + posId) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPosUserForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPosUserForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfPosUserLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfPosUserLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPosUserForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfPosUserLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPosUserLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfPosUserLookupTableDto>(<any>null);
    }
}

@Injectable()
export class PostmanTasksServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param descriptionFilter (optional) 
     * @param typeFilter (optional) 
     * @param addressTitleFilter (optional) 
     * @param billCodeFilter (optional) 
     * @param postmanNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, descriptionFilter: string | undefined, typeFilter: number | undefined, addressTitleFilter: string | undefined, billCodeFilter: string | undefined, postmanNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetPostmanTaskForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PostmanTasks/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (typeFilter === null)
            throw new Error("The parameter 'typeFilter' cannot be null.");
        else if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&"; 
        if (addressTitleFilter === null)
            throw new Error("The parameter 'addressTitleFilter' cannot be null.");
        else if (addressTitleFilter !== undefined)
            url_ += "AddressTitleFilter=" + encodeURIComponent("" + addressTitleFilter) + "&"; 
        if (billCodeFilter === null)
            throw new Error("The parameter 'billCodeFilter' cannot be null.");
        else if (billCodeFilter !== undefined)
            url_ += "BillCodeFilter=" + encodeURIComponent("" + billCodeFilter) + "&"; 
        if (postmanNameFilter === null)
            throw new Error("The parameter 'postmanNameFilter' cannot be null.");
        else if (postmanNameFilter !== undefined)
            url_ += "PostmanNameFilter=" + encodeURIComponent("" + postmanNameFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetPostmanTaskForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetPostmanTaskForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetPostmanTaskForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetPostmanTaskForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetPostmanTaskForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPostmanTaskForView(id: number | undefined): Observable<GetPostmanTaskForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PostmanTasks/GetPostmanTaskForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPostmanTaskForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPostmanTaskForView(<any>response_);
                } catch (e) {
                    return <Observable<GetPostmanTaskForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPostmanTaskForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPostmanTaskForView(response: HttpResponseBase): Observable<GetPostmanTaskForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPostmanTaskForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPostmanTaskForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPostmanTaskForEdit(id: number | undefined): Observable<GetPostmanTaskForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/PostmanTasks/GetPostmanTaskForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPostmanTaskForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPostmanTaskForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetPostmanTaskForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPostmanTaskForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetPostmanTaskForEdit(response: HttpResponseBase): Observable<GetPostmanTaskForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPostmanTaskForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPostmanTaskForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditCustom(body: CreateOrEditPostmanTaskDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PostmanTasks/CreateOrEditCustom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditCustom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditCustom(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditCustom(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditPostmanTaskDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PostmanTasks/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PostmanTasks/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param descriptionFilter (optional) 
     * @param typeFilter (optional) 
     * @param addressTitleFilter (optional) 
     * @param billCodeFilter (optional) 
     * @param postmanNameFilter (optional) 
     * @return Success
     */
    getPostmanTasksToExcel(filter: string | undefined, descriptionFilter: string | undefined, typeFilter: number | undefined, addressTitleFilter: string | undefined, billCodeFilter: string | undefined, postmanNameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/PostmanTasks/GetPostmanTasksToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (typeFilter === null)
            throw new Error("The parameter 'typeFilter' cannot be null.");
        else if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&"; 
        if (addressTitleFilter === null)
            throw new Error("The parameter 'addressTitleFilter' cannot be null.");
        else if (addressTitleFilter !== undefined)
            url_ += "AddressTitleFilter=" + encodeURIComponent("" + addressTitleFilter) + "&"; 
        if (billCodeFilter === null)
            throw new Error("The parameter 'billCodeFilter' cannot be null.");
        else if (billCodeFilter !== undefined)
            url_ += "BillCodeFilter=" + encodeURIComponent("" + billCodeFilter) + "&"; 
        if (postmanNameFilter === null)
            throw new Error("The parameter 'postmanNameFilter' cannot be null.");
        else if (postmanNameFilter !== undefined)
            url_ += "PostmanNameFilter=" + encodeURIComponent("" + postmanNameFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPostmanTasksToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPostmanTasksToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPostmanTasksToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllAddressForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfPostmanTaskAddressLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/PostmanTasks/GetAllAddressForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAddressForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAddressForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfPostmanTaskAddressLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfPostmanTaskAddressLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllAddressForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfPostmanTaskAddressLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPostmanTaskAddressLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfPostmanTaskAddressLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllBillForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfPostmanTaskBillLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/PostmanTasks/GetAllBillForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBillForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBillForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfPostmanTaskBillLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfPostmanTaskBillLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBillForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfPostmanTaskBillLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPostmanTaskBillLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfPostmanTaskBillLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param positions (optional) 
     * @param allFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllAmbassadorForLookupTable(filter: string | undefined, positions: Position[] | undefined, allFilter: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfPostmanTaskContactLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/PostmanTasks/GetAllAmbassadorForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (positions === null)
            throw new Error("The parameter 'positions' cannot be null.");
        else if (positions !== undefined)
            positions && positions.forEach((item, index) => { 
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Positions[" + index + "]." + attr + "=" + encodeURIComponent("" + (<any>item)[attr]) + "&";
        			}
            });
        if (allFilter === null)
            throw new Error("The parameter 'allFilter' cannot be null.");
        else if (allFilter !== undefined)
            url_ += "AllFilter=" + encodeURIComponent("" + allFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAmbassadorForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAmbassadorForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfPostmanTaskContactLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfPostmanTaskContactLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllAmbassadorForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfPostmanTaskContactLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPostmanTaskContactLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfPostmanTaskContactLookupTableDto>(<any>null);
    }

    /**
     * @param today (optional) 
     * @param billCode (optional) 
     * @param filter (optional) 
     * @param statusFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllPostmanTask(today: boolean | undefined, billCode: string | undefined, filter: string | undefined, statusFilter: number[] | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetPostmanTasksDto> {
        let url_ = this.baseUrl + "/api/services/app/PostmanTasks/GetAllPostmanTask?";
        if (today === null)
            throw new Error("The parameter 'today' cannot be null.");
        else if (today !== undefined)
            url_ += "Today=" + encodeURIComponent("" + today) + "&"; 
        if (billCode === null)
            throw new Error("The parameter 'billCode' cannot be null.");
        else if (billCode !== undefined)
            url_ += "BillCode=" + encodeURIComponent("" + billCode) + "&"; 
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            statusFilter && statusFilter.forEach(item => { url_ += "StatusFilter=" + encodeURIComponent("" + item) + "&"; });
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPostmanTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPostmanTask(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetPostmanTasksDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetPostmanTasksDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPostmanTask(response: HttpResponseBase): Observable<PagedResultDtoOfGetPostmanTasksDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetPostmanTasksDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetPostmanTasksDto>(<any>null);
    }

    /**
     * @param today (optional) 
     * @param permission (optional) 
     * @param filter (optional) 
     * @param contactFilter (optional) 
     * @param postmanTypeFilter (optional) 
     * @param directionFilter (optional) 
     * @param postmanFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllPostmanTaskForAdmin(today: boolean | undefined, permission: string | undefined, filter: string | undefined, contactFilter: string | undefined, postmanTypeFilter: number | undefined, directionFilter: string | undefined, postmanFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetPostmanTasksDto> {
        let url_ = this.baseUrl + "/api/services/app/PostmanTasks/GetAllPostmanTaskForAdmin?";
        if (today === null)
            throw new Error("The parameter 'today' cannot be null.");
        else if (today !== undefined)
            url_ += "Today=" + encodeURIComponent("" + today) + "&"; 
        if (permission === null)
            throw new Error("The parameter 'permission' cannot be null.");
        else if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&"; 
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (contactFilter === null)
            throw new Error("The parameter 'contactFilter' cannot be null.");
        else if (contactFilter !== undefined)
            url_ += "ContactFilter=" + encodeURIComponent("" + contactFilter) + "&"; 
        if (postmanTypeFilter === null)
            throw new Error("The parameter 'postmanTypeFilter' cannot be null.");
        else if (postmanTypeFilter !== undefined)
            url_ += "PostmanTypeFilter=" + encodeURIComponent("" + postmanTypeFilter) + "&"; 
        if (directionFilter === null)
            throw new Error("The parameter 'directionFilter' cannot be null.");
        else if (directionFilter !== undefined)
            url_ += "DirectionFilter=" + encodeURIComponent("" + directionFilter) + "&"; 
        if (postmanFilter === null)
            throw new Error("The parameter 'postmanFilter' cannot be null.");
        else if (postmanFilter !== undefined)
            url_ += "PostmanFilter=" + encodeURIComponent("" + postmanFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPostmanTaskForAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPostmanTaskForAdmin(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetPostmanTasksDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetPostmanTasksDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPostmanTaskForAdmin(response: HttpResponseBase): Observable<PagedResultDtoOfGetPostmanTasksDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetPostmanTasksDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetPostmanTasksDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editBillPrice(body: EditBillPriceDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PostmanTasks/EditBillPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditBillPrice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditBillPrice(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processEditBillPrice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class PosUsersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param entityFilter (optional) 
     * @param maxEntityRefFilter (optional) 
     * @param minEntityRefFilter (optional) 
     * @param maxFromDateFilter (optional) 
     * @param minFromDateFilter (optional) 
     * @param maxToDateFilter (optional) 
     * @param minToDateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, entityFilter: number | undefined, maxEntityRefFilter: number | undefined, minEntityRefFilter: number | undefined, maxFromDateFilter: moment.Moment | undefined, minFromDateFilter: moment.Moment | undefined, maxToDateFilter: moment.Moment | undefined, minToDateFilter: moment.Moment | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetPosUserForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PosUsers/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (maxEntityRefFilter === null)
            throw new Error("The parameter 'maxEntityRefFilter' cannot be null.");
        else if (maxEntityRefFilter !== undefined)
            url_ += "MaxEntityRefFilter=" + encodeURIComponent("" + maxEntityRefFilter) + "&"; 
        if (minEntityRefFilter === null)
            throw new Error("The parameter 'minEntityRefFilter' cannot be null.");
        else if (minEntityRefFilter !== undefined)
            url_ += "MinEntityRefFilter=" + encodeURIComponent("" + minEntityRefFilter) + "&"; 
        if (maxFromDateFilter === null)
            throw new Error("The parameter 'maxFromDateFilter' cannot be null.");
        else if (maxFromDateFilter !== undefined)
            url_ += "MaxFromDateFilter=" + encodeURIComponent(maxFromDateFilter ? "" + maxFromDateFilter.toJSON() : "") + "&"; 
        if (minFromDateFilter === null)
            throw new Error("The parameter 'minFromDateFilter' cannot be null.");
        else if (minFromDateFilter !== undefined)
            url_ += "MinFromDateFilter=" + encodeURIComponent(minFromDateFilter ? "" + minFromDateFilter.toJSON() : "") + "&"; 
        if (maxToDateFilter === null)
            throw new Error("The parameter 'maxToDateFilter' cannot be null.");
        else if (maxToDateFilter !== undefined)
            url_ += "MaxToDateFilter=" + encodeURIComponent(maxToDateFilter ? "" + maxToDateFilter.toJSON() : "") + "&"; 
        if (minToDateFilter === null)
            throw new Error("The parameter 'minToDateFilter' cannot be null.");
        else if (minToDateFilter !== undefined)
            url_ += "MinToDateFilter=" + encodeURIComponent(minToDateFilter ? "" + minToDateFilter.toJSON() : "") + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetPosUserForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetPosUserForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetPosUserForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetPosUserForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetPosUserForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPosUserForView(id: number | undefined): Observable<GetPosUserForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PosUsers/GetPosUserForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPosUserForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPosUserForView(<any>response_);
                } catch (e) {
                    return <Observable<GetPosUserForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPosUserForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPosUserForView(response: HttpResponseBase): Observable<GetPosUserForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPosUserForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPosUserForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPosUserForEdit(id: number | undefined): Observable<GetPosUserForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/PosUsers/GetPosUserForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPosUserForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPosUserForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetPosUserForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPosUserForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetPosUserForEdit(response: HttpResponseBase): Observable<GetPosUserForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPosUserForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPosUserForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditPosUserDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PosUsers/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PosUsers/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param entityFilter (optional) 
     * @param maxEntityRefFilter (optional) 
     * @param minEntityRefFilter (optional) 
     * @param maxFromDateFilter (optional) 
     * @param minFromDateFilter (optional) 
     * @param maxToDateFilter (optional) 
     * @param minToDateFilter (optional) 
     * @return Success
     */
    getPosUsersToExcel(filter: string | undefined, entityFilter: number | undefined, maxEntityRefFilter: number | undefined, minEntityRefFilter: number | undefined, maxFromDateFilter: moment.Moment | undefined, minFromDateFilter: moment.Moment | undefined, maxToDateFilter: moment.Moment | undefined, minToDateFilter: moment.Moment | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/PosUsers/GetPosUsersToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (maxEntityRefFilter === null)
            throw new Error("The parameter 'maxEntityRefFilter' cannot be null.");
        else if (maxEntityRefFilter !== undefined)
            url_ += "MaxEntityRefFilter=" + encodeURIComponent("" + maxEntityRefFilter) + "&"; 
        if (minEntityRefFilter === null)
            throw new Error("The parameter 'minEntityRefFilter' cannot be null.");
        else if (minEntityRefFilter !== undefined)
            url_ += "MinEntityRefFilter=" + encodeURIComponent("" + minEntityRefFilter) + "&"; 
        if (maxFromDateFilter === null)
            throw new Error("The parameter 'maxFromDateFilter' cannot be null.");
        else if (maxFromDateFilter !== undefined)
            url_ += "MaxFromDateFilter=" + encodeURIComponent(maxFromDateFilter ? "" + maxFromDateFilter.toJSON() : "") + "&"; 
        if (minFromDateFilter === null)
            throw new Error("The parameter 'minFromDateFilter' cannot be null.");
        else if (minFromDateFilter !== undefined)
            url_ += "MinFromDateFilter=" + encodeURIComponent(minFromDateFilter ? "" + minFromDateFilter.toJSON() : "") + "&"; 
        if (maxToDateFilter === null)
            throw new Error("The parameter 'maxToDateFilter' cannot be null.");
        else if (maxToDateFilter !== undefined)
            url_ += "MaxToDateFilter=" + encodeURIComponent(maxToDateFilter ? "" + maxToDateFilter.toJSON() : "") + "&"; 
        if (minToDateFilter === null)
            throw new Error("The parameter 'minToDateFilter' cannot be null.");
        else if (minToDateFilter !== undefined)
            url_ += "MinToDateFilter=" + encodeURIComponent(minToDateFilter ? "" + minToDateFilter.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPosUsersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPosUsersToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPosUsersToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllContactForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfPosUserContactLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/PosUsers/GetAllContactForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllContactForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllContactForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfPosUserContactLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfPosUserContactLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllContactForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfPosUserContactLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPosUserContactLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfPosUserContactLookupTableDto>(<any>null);
    }
}

@Injectable()
export class ProfileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentUserProfileForEdit(): Observable<CurrentUserProfileEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetCurrentUserProfileForEdit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUserProfileForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUserProfileForEdit(<any>response_);
                } catch (e) {
                    return <Observable<CurrentUserProfileEditDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CurrentUserProfileEditDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCurrentUserProfileForEdit(response: HttpResponseBase): Observable<CurrentUserProfileEditDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrentUserProfileEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CurrentUserProfileEditDto>(<any>null);
    }

    /**
     * @return Success
     */
    disableGoogleAuthenticator(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/DisableGoogleAuthenticator";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableGoogleAuthenticator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableGoogleAuthenticator(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDisableGoogleAuthenticator(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    updateGoogleAuthenticatorKey(): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateGoogleAuthenticatorKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateGoogleAuthenticatorKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGoogleAuthenticatorKey(<any>response_);
                } catch (e) {
                    return <Observable<UpdateGoogleAuthenticatorKeyOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateGoogleAuthenticatorKeyOutput>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateGoogleAuthenticatorKey(response: HttpResponseBase): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateGoogleAuthenticatorKeyOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateGoogleAuthenticatorKeyOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendVerificationSms(body: SendVerificationSmsInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/SendVerificationSms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendVerificationSms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendVerificationSms(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendVerificationSms(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    verifySmsCode(body: VerifySmsCodeInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/VerifySmsCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifySmsCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifySmsCode(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processVerifySmsCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    prepareCollectedData(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/PrepareCollectedData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrepareCollectedData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrepareCollectedData(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPrepareCollectedData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCurrentUserProfile(body: CurrentUserProfileEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateCurrentUserProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCurrentUserProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCurrentUserProfile(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateCurrentUserProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProfilePicture(body: UpdateProfilePictureInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProfilePicture(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateProfilePicture(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getPasswordComplexitySetting(): Observable<GetPasswordComplexitySettingOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetPasswordComplexitySetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPasswordComplexitySetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPasswordComplexitySetting(<any>response_);
                } catch (e) {
                    return <Observable<GetPasswordComplexitySettingOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPasswordComplexitySettingOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetPasswordComplexitySetting(response: HttpResponseBase): Observable<GetPasswordComplexitySettingOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPasswordComplexitySettingOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPasswordComplexitySettingOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getProfilePicture(): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePicture(<any>response_);
                } catch (e) {
                    return <Observable<GetProfilePictureOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetProfilePictureOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetProfilePicture(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProfilePictureOutput>(<any>null);
    }

    /**
     * @param profilePictureId (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getFriendProfilePictureById(profilePictureId: string | undefined, userId: number | undefined, tenantId: number | undefined): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetFriendProfilePictureById?";
        if (profilePictureId === null)
            throw new Error("The parameter 'profilePictureId' cannot be null.");
        else if (profilePictureId !== undefined)
            url_ += "ProfilePictureId=" + encodeURIComponent("" + profilePictureId) + "&"; 
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFriendProfilePictureById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFriendProfilePictureById(<any>response_);
                } catch (e) {
                    return <Observable<GetProfilePictureOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetProfilePictureOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetFriendProfilePictureById(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProfilePictureOutput>(<any>null);
    }

    /**
     * @param profilePictureId (optional) 
     * @return Success
     */
    getProfilePictureById(profilePictureId: string | undefined): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePictureById?";
        if (profilePictureId === null)
            throw new Error("The parameter 'profilePictureId' cannot be null.");
        else if (profilePictureId !== undefined)
            url_ += "profilePictureId=" + encodeURIComponent("" + profilePictureId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfilePictureById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePictureById(<any>response_);
                } catch (e) {
                    return <Observable<GetProfilePictureOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetProfilePictureOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetProfilePictureById(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProfilePictureOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class RegulatVouchersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxRegulatedDateTimeFilter (optional) 
     * @param minRegulatedDateTimeFilter (optional) 
     * @param codeFilter (optional) 
     * @param maxSecondedDateTimeFilter (optional) 
     * @param minSecondedDateTimeFilter (optional) 
     * @param maxApprovedDateTimeFilter (optional) 
     * @param minApprovedDateTimeFilter (optional) 
     * @param userNameFilter (optional) 
     * @param userName2Filter (optional) 
     * @param userName3Filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, maxRegulatedDateTimeFilter: moment.Moment | undefined, minRegulatedDateTimeFilter: moment.Moment | undefined, codeFilter: string | undefined, maxSecondedDateTimeFilter: moment.Moment | undefined, minSecondedDateTimeFilter: moment.Moment | undefined, maxApprovedDateTimeFilter: moment.Moment | undefined, minApprovedDateTimeFilter: moment.Moment | undefined, userNameFilter: string | undefined, userName2Filter: string | undefined, userName3Filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetRegulatVoucherForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/RegulatVouchers/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxRegulatedDateTimeFilter === null)
            throw new Error("The parameter 'maxRegulatedDateTimeFilter' cannot be null.");
        else if (maxRegulatedDateTimeFilter !== undefined)
            url_ += "MaxRegulatedDateTimeFilter=" + encodeURIComponent(maxRegulatedDateTimeFilter ? "" + maxRegulatedDateTimeFilter.toJSON() : "") + "&"; 
        if (minRegulatedDateTimeFilter === null)
            throw new Error("The parameter 'minRegulatedDateTimeFilter' cannot be null.");
        else if (minRegulatedDateTimeFilter !== undefined)
            url_ += "MinRegulatedDateTimeFilter=" + encodeURIComponent(minRegulatedDateTimeFilter ? "" + minRegulatedDateTimeFilter.toJSON() : "") + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (maxSecondedDateTimeFilter === null)
            throw new Error("The parameter 'maxSecondedDateTimeFilter' cannot be null.");
        else if (maxSecondedDateTimeFilter !== undefined)
            url_ += "MaxSecondedDateTimeFilter=" + encodeURIComponent(maxSecondedDateTimeFilter ? "" + maxSecondedDateTimeFilter.toJSON() : "") + "&"; 
        if (minSecondedDateTimeFilter === null)
            throw new Error("The parameter 'minSecondedDateTimeFilter' cannot be null.");
        else if (minSecondedDateTimeFilter !== undefined)
            url_ += "MinSecondedDateTimeFilter=" + encodeURIComponent(minSecondedDateTimeFilter ? "" + minSecondedDateTimeFilter.toJSON() : "") + "&"; 
        if (maxApprovedDateTimeFilter === null)
            throw new Error("The parameter 'maxApprovedDateTimeFilter' cannot be null.");
        else if (maxApprovedDateTimeFilter !== undefined)
            url_ += "MaxApprovedDateTimeFilter=" + encodeURIComponent(maxApprovedDateTimeFilter ? "" + maxApprovedDateTimeFilter.toJSON() : "") + "&"; 
        if (minApprovedDateTimeFilter === null)
            throw new Error("The parameter 'minApprovedDateTimeFilter' cannot be null.");
        else if (minApprovedDateTimeFilter !== undefined)
            url_ += "MinApprovedDateTimeFilter=" + encodeURIComponent(minApprovedDateTimeFilter ? "" + minApprovedDateTimeFilter.toJSON() : "") + "&"; 
        if (userNameFilter === null)
            throw new Error("The parameter 'userNameFilter' cannot be null.");
        else if (userNameFilter !== undefined)
            url_ += "UserNameFilter=" + encodeURIComponent("" + userNameFilter) + "&"; 
        if (userName2Filter === null)
            throw new Error("The parameter 'userName2Filter' cannot be null.");
        else if (userName2Filter !== undefined)
            url_ += "UserName2Filter=" + encodeURIComponent("" + userName2Filter) + "&"; 
        if (userName3Filter === null)
            throw new Error("The parameter 'userName3Filter' cannot be null.");
        else if (userName3Filter !== undefined)
            url_ += "UserName3Filter=" + encodeURIComponent("" + userName3Filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetRegulatVoucherForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetRegulatVoucherForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetRegulatVoucherForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetRegulatVoucherForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetRegulatVoucherForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRegulatVoucherForView(id: number | undefined): Observable<GetRegulatVoucherForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/RegulatVouchers/GetRegulatVoucherForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegulatVoucherForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegulatVoucherForView(<any>response_);
                } catch (e) {
                    return <Observable<GetRegulatVoucherForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRegulatVoucherForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRegulatVoucherForView(response: HttpResponseBase): Observable<GetRegulatVoucherForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRegulatVoucherForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRegulatVoucherForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRegulatVoucherForEdit(id: number | undefined): Observable<GetRegulatVoucherForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/RegulatVouchers/GetRegulatVoucherForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegulatVoucherForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegulatVoucherForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetRegulatVoucherForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRegulatVoucherForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRegulatVoucherForEdit(response: HttpResponseBase): Observable<GetRegulatVoucherForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRegulatVoucherForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRegulatVoucherForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditRegulatVoucherDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RegulatVouchers/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAndGetId(body: CreateOrEditRegulatVoucherDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/RegulatVouchers/CreateAndGetId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAndGetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAndGetId(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateAndGetId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RegulatVouchers/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param maxRegulatedDateTimeFilter (optional) 
     * @param minRegulatedDateTimeFilter (optional) 
     * @param codeFilter (optional) 
     * @param maxSecondedDateTimeFilter (optional) 
     * @param minSecondedDateTimeFilter (optional) 
     * @param maxApprovedDateTimeFilter (optional) 
     * @param minApprovedDateTimeFilter (optional) 
     * @param userNameFilter (optional) 
     * @param userName2Filter (optional) 
     * @param userName3Filter (optional) 
     * @return Success
     */
    getRegulatVouchersToExcel(filter: string | undefined, maxRegulatedDateTimeFilter: moment.Moment | undefined, minRegulatedDateTimeFilter: moment.Moment | undefined, codeFilter: string | undefined, maxSecondedDateTimeFilter: moment.Moment | undefined, minSecondedDateTimeFilter: moment.Moment | undefined, maxApprovedDateTimeFilter: moment.Moment | undefined, minApprovedDateTimeFilter: moment.Moment | undefined, userNameFilter: string | undefined, userName2Filter: string | undefined, userName3Filter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/RegulatVouchers/GetRegulatVouchersToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxRegulatedDateTimeFilter === null)
            throw new Error("The parameter 'maxRegulatedDateTimeFilter' cannot be null.");
        else if (maxRegulatedDateTimeFilter !== undefined)
            url_ += "MaxRegulatedDateTimeFilter=" + encodeURIComponent(maxRegulatedDateTimeFilter ? "" + maxRegulatedDateTimeFilter.toJSON() : "") + "&"; 
        if (minRegulatedDateTimeFilter === null)
            throw new Error("The parameter 'minRegulatedDateTimeFilter' cannot be null.");
        else if (minRegulatedDateTimeFilter !== undefined)
            url_ += "MinRegulatedDateTimeFilter=" + encodeURIComponent(minRegulatedDateTimeFilter ? "" + minRegulatedDateTimeFilter.toJSON() : "") + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (maxSecondedDateTimeFilter === null)
            throw new Error("The parameter 'maxSecondedDateTimeFilter' cannot be null.");
        else if (maxSecondedDateTimeFilter !== undefined)
            url_ += "MaxSecondedDateTimeFilter=" + encodeURIComponent(maxSecondedDateTimeFilter ? "" + maxSecondedDateTimeFilter.toJSON() : "") + "&"; 
        if (minSecondedDateTimeFilter === null)
            throw new Error("The parameter 'minSecondedDateTimeFilter' cannot be null.");
        else if (minSecondedDateTimeFilter !== undefined)
            url_ += "MinSecondedDateTimeFilter=" + encodeURIComponent(minSecondedDateTimeFilter ? "" + minSecondedDateTimeFilter.toJSON() : "") + "&"; 
        if (maxApprovedDateTimeFilter === null)
            throw new Error("The parameter 'maxApprovedDateTimeFilter' cannot be null.");
        else if (maxApprovedDateTimeFilter !== undefined)
            url_ += "MaxApprovedDateTimeFilter=" + encodeURIComponent(maxApprovedDateTimeFilter ? "" + maxApprovedDateTimeFilter.toJSON() : "") + "&"; 
        if (minApprovedDateTimeFilter === null)
            throw new Error("The parameter 'minApprovedDateTimeFilter' cannot be null.");
        else if (minApprovedDateTimeFilter !== undefined)
            url_ += "MinApprovedDateTimeFilter=" + encodeURIComponent(minApprovedDateTimeFilter ? "" + minApprovedDateTimeFilter.toJSON() : "") + "&"; 
        if (userNameFilter === null)
            throw new Error("The parameter 'userNameFilter' cannot be null.");
        else if (userNameFilter !== undefined)
            url_ += "UserNameFilter=" + encodeURIComponent("" + userNameFilter) + "&"; 
        if (userName2Filter === null)
            throw new Error("The parameter 'userName2Filter' cannot be null.");
        else if (userName2Filter !== undefined)
            url_ += "UserName2Filter=" + encodeURIComponent("" + userName2Filter) + "&"; 
        if (userName3Filter === null)
            throw new Error("The parameter 'userName3Filter' cannot be null.");
        else if (userName3Filter !== undefined)
            url_ += "UserName3Filter=" + encodeURIComponent("" + userName3Filter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegulatVouchersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegulatVouchersToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRegulatVouchersToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllUserForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfRegulatVoucherUserLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/RegulatVouchers/GetAllUserForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUserForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfRegulatVoucherUserLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfRegulatVoucherUserLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllUserForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfRegulatVoucherUserLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfRegulatVoucherUserLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfRegulatVoucherUserLookupTableDto>(<any>null);
    }
}

@Injectable()
export class RespectPrefixesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param genderFilter (optional) 
     * @param stateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, titleFilter: string | undefined, genderFilter: number | undefined, stateFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetRespectPrefixForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/RespectPrefixes/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (genderFilter === null)
            throw new Error("The parameter 'genderFilter' cannot be null.");
        else if (genderFilter !== undefined)
            url_ += "GenderFilter=" + encodeURIComponent("" + genderFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetRespectPrefixForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetRespectPrefixForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetRespectPrefixForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetRespectPrefixForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetRespectPrefixForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRespectPrefixForView(id: number | undefined): Observable<GetRespectPrefixForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/RespectPrefixes/GetRespectPrefixForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRespectPrefixForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRespectPrefixForView(<any>response_);
                } catch (e) {
                    return <Observable<GetRespectPrefixForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRespectPrefixForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRespectPrefixForView(response: HttpResponseBase): Observable<GetRespectPrefixForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRespectPrefixForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRespectPrefixForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRespectPrefixForEdit(id: number | undefined): Observable<GetRespectPrefixForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/RespectPrefixes/GetRespectPrefixForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRespectPrefixForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRespectPrefixForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetRespectPrefixForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRespectPrefixForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRespectPrefixForEdit(response: HttpResponseBase): Observable<GetRespectPrefixForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRespectPrefixForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRespectPrefixForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditRespectPrefixDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RespectPrefixes/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RespectPrefixes/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param genderFilter (optional) 
     * @param stateFilter (optional) 
     * @return Success
     */
    getRespectPrefixesToExcel(filter: string | undefined, titleFilter: string | undefined, genderFilter: number | undefined, stateFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/RespectPrefixes/GetRespectPrefixesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (genderFilter === null)
            throw new Error("The parameter 'genderFilter' cannot be null.");
        else if (genderFilter !== undefined)
            url_ += "GenderFilter=" + encodeURIComponent("" + genderFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRespectPrefixesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRespectPrefixesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRespectPrefixesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param permissions (optional) 
     * @return Success
     */
    getRoles(permissions: string[] | undefined): Observable<ListResultDtoOfRoleListDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (permissions === null)
            throw new Error("The parameter 'permissions' cannot be null.");
        else if (permissions !== undefined)
            permissions && permissions.forEach(item => { url_ += "Permissions=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfRoleListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfRoleListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<ListResultDtoOfRoleListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfRoleListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfRoleListDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetRoleForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRoleForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRoleForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateRole(body: CreateOrUpdateRoleInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/CreateOrUpdateRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateRole(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdateRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteRole(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/DeleteRole?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRole(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class RouteFeesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param valuesFilter (optional) 
     * @param serviceTypeFilter (optional) 
     * @param directionNameFilter (optional) 
     * @param wageTitleFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, valuesFilter: string | undefined, serviceTypeFilter: string | undefined, directionNameFilter: string | undefined, wageTitleFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetRouteFeeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/RouteFees/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (valuesFilter === null)
            throw new Error("The parameter 'valuesFilter' cannot be null.");
        else if (valuesFilter !== undefined)
            url_ += "ValuesFilter=" + encodeURIComponent("" + valuesFilter) + "&"; 
        if (serviceTypeFilter === null)
            throw new Error("The parameter 'serviceTypeFilter' cannot be null.");
        else if (serviceTypeFilter !== undefined)
            url_ += "ServiceTypeFilter=" + encodeURIComponent("" + serviceTypeFilter) + "&"; 
        if (directionNameFilter === null)
            throw new Error("The parameter 'directionNameFilter' cannot be null.");
        else if (directionNameFilter !== undefined)
            url_ += "DirectionNameFilter=" + encodeURIComponent("" + directionNameFilter) + "&"; 
        if (wageTitleFilter === null)
            throw new Error("The parameter 'wageTitleFilter' cannot be null.");
        else if (wageTitleFilter !== undefined)
            url_ += "WageTitleFilter=" + encodeURIComponent("" + wageTitleFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetRouteFeeForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetRouteFeeForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetRouteFeeForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetRouteFeeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetRouteFeeForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRouteFeeForView(id: number | undefined): Observable<GetRouteFeeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/RouteFees/GetRouteFeeForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRouteFeeForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRouteFeeForView(<any>response_);
                } catch (e) {
                    return <Observable<GetRouteFeeForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRouteFeeForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRouteFeeForView(response: HttpResponseBase): Observable<GetRouteFeeForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRouteFeeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRouteFeeForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRouteFeeForEdit(id: number | undefined): Observable<GetRouteFeeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/RouteFees/GetRouteFeeForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRouteFeeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRouteFeeForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetRouteFeeForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRouteFeeForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRouteFeeForEdit(response: HttpResponseBase): Observable<GetRouteFeeForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRouteFeeForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRouteFeeForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditRouteFeeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RouteFees/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RouteFees/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param valuesFilter (optional) 
     * @param serviceTypeFilter (optional) 
     * @param directionNameFilter (optional) 
     * @param wageTitleFilter (optional) 
     * @return Success
     */
    getRouteFeesToExcel(filter: string | undefined, valuesFilter: string | undefined, serviceTypeFilter: string | undefined, directionNameFilter: string | undefined, wageTitleFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/RouteFees/GetRouteFeesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (valuesFilter === null)
            throw new Error("The parameter 'valuesFilter' cannot be null.");
        else if (valuesFilter !== undefined)
            url_ += "ValuesFilter=" + encodeURIComponent("" + valuesFilter) + "&"; 
        if (serviceTypeFilter === null)
            throw new Error("The parameter 'serviceTypeFilter' cannot be null.");
        else if (serviceTypeFilter !== undefined)
            url_ += "ServiceTypeFilter=" + encodeURIComponent("" + serviceTypeFilter) + "&"; 
        if (directionNameFilter === null)
            throw new Error("The parameter 'directionNameFilter' cannot be null.");
        else if (directionNameFilter !== undefined)
            url_ += "DirectionNameFilter=" + encodeURIComponent("" + directionNameFilter) + "&"; 
        if (wageTitleFilter === null)
            throw new Error("The parameter 'wageTitleFilter' cannot be null.");
        else if (wageTitleFilter !== undefined)
            url_ += "WageTitleFilter=" + encodeURIComponent("" + wageTitleFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRouteFeesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRouteFeesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRouteFeesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllDirectionForTableDropdown(): Observable<RouteFeeDirectionLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RouteFees/GetAllDirectionForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDirectionForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDirectionForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<RouteFeeDirectionLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RouteFeeDirectionLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllDirectionForTableDropdown(response: HttpResponseBase): Observable<RouteFeeDirectionLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RouteFeeDirectionLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RouteFeeDirectionLookupTableDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllWageForTableDropdown(): Observable<RouteFeeWageLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RouteFees/GetAllWageForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWageForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWageForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<RouteFeeWageLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RouteFeeWageLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllWageForTableDropdown(response: HttpResponseBase): Observable<RouteFeeWageLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RouteFeeWageLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RouteFeeWageLookupTableDto[]>(<any>null);
    }
}

@Injectable()
export class SacrificesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param isParticipatoryFilter (optional) 
     * @param maxMaxOrderFilter (optional) 
     * @param minMaxOrderFilter (optional) 
     * @param maxAncillaryCostsAmountFilter (optional) 
     * @param minAncillaryCostsAmountFilter (optional) 
     * @param planConstTitleFilter (optional) 
     * @param sacrificeTypeTitleFilter (optional) 
     * @param sacrificeTypeIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, isParticipatoryFilter: number | undefined, maxMaxOrderFilter: number | undefined, minMaxOrderFilter: number | undefined, maxAncillaryCostsAmountFilter: number | undefined, minAncillaryCostsAmountFilter: number | undefined, planConstTitleFilter: string | undefined, sacrificeTypeTitleFilter: string | undefined, sacrificeTypeIdFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetSacrificeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Sacrifices/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (isParticipatoryFilter === null)
            throw new Error("The parameter 'isParticipatoryFilter' cannot be null.");
        else if (isParticipatoryFilter !== undefined)
            url_ += "IsParticipatoryFilter=" + encodeURIComponent("" + isParticipatoryFilter) + "&"; 
        if (maxMaxOrderFilter === null)
            throw new Error("The parameter 'maxMaxOrderFilter' cannot be null.");
        else if (maxMaxOrderFilter !== undefined)
            url_ += "MaxMaxOrderFilter=" + encodeURIComponent("" + maxMaxOrderFilter) + "&"; 
        if (minMaxOrderFilter === null)
            throw new Error("The parameter 'minMaxOrderFilter' cannot be null.");
        else if (minMaxOrderFilter !== undefined)
            url_ += "MinMaxOrderFilter=" + encodeURIComponent("" + minMaxOrderFilter) + "&"; 
        if (maxAncillaryCostsAmountFilter === null)
            throw new Error("The parameter 'maxAncillaryCostsAmountFilter' cannot be null.");
        else if (maxAncillaryCostsAmountFilter !== undefined)
            url_ += "MaxAncillaryCostsAmountFilter=" + encodeURIComponent("" + maxAncillaryCostsAmountFilter) + "&"; 
        if (minAncillaryCostsAmountFilter === null)
            throw new Error("The parameter 'minAncillaryCostsAmountFilter' cannot be null.");
        else if (minAncillaryCostsAmountFilter !== undefined)
            url_ += "MinAncillaryCostsAmountFilter=" + encodeURIComponent("" + minAncillaryCostsAmountFilter) + "&"; 
        if (planConstTitleFilter === null)
            throw new Error("The parameter 'planConstTitleFilter' cannot be null.");
        else if (planConstTitleFilter !== undefined)
            url_ += "PlanConstTitleFilter=" + encodeURIComponent("" + planConstTitleFilter) + "&"; 
        if (sacrificeTypeTitleFilter === null)
            throw new Error("The parameter 'sacrificeTypeTitleFilter' cannot be null.");
        else if (sacrificeTypeTitleFilter !== undefined)
            url_ += "SacrificeTypeTitleFilter=" + encodeURIComponent("" + sacrificeTypeTitleFilter) + "&"; 
        if (sacrificeTypeIdFilter === null)
            throw new Error("The parameter 'sacrificeTypeIdFilter' cannot be null.");
        else if (sacrificeTypeIdFilter !== undefined)
            url_ += "SacrificeTypeIdFilter=" + encodeURIComponent("" + sacrificeTypeIdFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSacrificeForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSacrificeForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSacrificeForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetSacrificeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSacrificeForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSacrificeForView(id: number | undefined): Observable<GetSacrificeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Sacrifices/GetSacrificeForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSacrificeForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSacrificeForView(<any>response_);
                } catch (e) {
                    return <Observable<GetSacrificeForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSacrificeForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSacrificeForView(response: HttpResponseBase): Observable<GetSacrificeForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSacrificeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSacrificeForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSacrificeForEdit(id: number | undefined): Observable<GetSacrificeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Sacrifices/GetSacrificeForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSacrificeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSacrificeForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSacrificeForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSacrificeForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSacrificeForEdit(response: HttpResponseBase): Observable<GetSacrificeForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSacrificeForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSacrificeForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditSacrificeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Sacrifices/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Sacrifices/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param isParticipatoryFilter (optional) 
     * @param maxMaxOrderFilter (optional) 
     * @param minMaxOrderFilter (optional) 
     * @param maxAncillaryCostsAmountFilter (optional) 
     * @param minAncillaryCostsAmountFilter (optional) 
     * @param planConstTitleFilter (optional) 
     * @return Success
     */
    getSacrificesToExcel(filter: string | undefined, isParticipatoryFilter: number | undefined, maxMaxOrderFilter: number | undefined, minMaxOrderFilter: number | undefined, maxAncillaryCostsAmountFilter: number | undefined, minAncillaryCostsAmountFilter: number | undefined, planConstTitleFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Sacrifices/GetSacrificesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (isParticipatoryFilter === null)
            throw new Error("The parameter 'isParticipatoryFilter' cannot be null.");
        else if (isParticipatoryFilter !== undefined)
            url_ += "IsParticipatoryFilter=" + encodeURIComponent("" + isParticipatoryFilter) + "&"; 
        if (maxMaxOrderFilter === null)
            throw new Error("The parameter 'maxMaxOrderFilter' cannot be null.");
        else if (maxMaxOrderFilter !== undefined)
            url_ += "MaxMaxOrderFilter=" + encodeURIComponent("" + maxMaxOrderFilter) + "&"; 
        if (minMaxOrderFilter === null)
            throw new Error("The parameter 'minMaxOrderFilter' cannot be null.");
        else if (minMaxOrderFilter !== undefined)
            url_ += "MinMaxOrderFilter=" + encodeURIComponent("" + minMaxOrderFilter) + "&"; 
        if (maxAncillaryCostsAmountFilter === null)
            throw new Error("The parameter 'maxAncillaryCostsAmountFilter' cannot be null.");
        else if (maxAncillaryCostsAmountFilter !== undefined)
            url_ += "MaxAncillaryCostsAmountFilter=" + encodeURIComponent("" + maxAncillaryCostsAmountFilter) + "&"; 
        if (minAncillaryCostsAmountFilter === null)
            throw new Error("The parameter 'minAncillaryCostsAmountFilter' cannot be null.");
        else if (minAncillaryCostsAmountFilter !== undefined)
            url_ += "MinAncillaryCostsAmountFilter=" + encodeURIComponent("" + minAncillaryCostsAmountFilter) + "&"; 
        if (planConstTitleFilter === null)
            throw new Error("The parameter 'planConstTitleFilter' cannot be null.");
        else if (planConstTitleFilter !== undefined)
            url_ += "PlanConstTitleFilter=" + encodeURIComponent("" + planConstTitleFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSacrificesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSacrificesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSacrificesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllPlanConstForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSacrificePlanConstLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Sacrifices/GetAllPlanConstForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPlanConstForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPlanConstForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfSacrificePlanConstLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfSacrificePlanConstLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPlanConstForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSacrificePlanConstLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSacrificePlanConstLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfSacrificePlanConstLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllSacrificeTypeForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSacrificeSacrificeTypeLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Sacrifices/GetAllSacrificeTypeForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSacrificeTypeForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSacrificeTypeForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfSacrificeSacrificeTypeLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfSacrificeSacrificeTypeLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSacrificeTypeForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSacrificeSacrificeTypeLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSacrificeSacrificeTypeLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfSacrificeSacrificeTypeLookupTableDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllBaseTimeForTableDropdown(): Observable<SacrificeBaseTimeLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Sacrifices/GetAllBaseTimeForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBaseTimeForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBaseTimeForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<SacrificeBaseTimeLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SacrificeBaseTimeLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBaseTimeForTableDropdown(response: HttpResponseBase): Observable<SacrificeBaseTimeLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SacrificeBaseTimeLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SacrificeBaseTimeLookupTableDto[]>(<any>null);
    }
}

@Injectable()
export class SacrificeTypesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param maxDailyNumberPerPersonFilter (optional) 
     * @param minDailyNumberPerPersonFilter (optional) 
     * @param maxMaximumDailyNumberFilter (optional) 
     * @param minMaximumDailyNumberFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, titleFilter: string | undefined, maxDailyNumberPerPersonFilter: number | undefined, minDailyNumberPerPersonFilter: number | undefined, maxMaximumDailyNumberFilter: number | undefined, minMaximumDailyNumberFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetSacrificeTypeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SacrificeTypes/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (maxDailyNumberPerPersonFilter === null)
            throw new Error("The parameter 'maxDailyNumberPerPersonFilter' cannot be null.");
        else if (maxDailyNumberPerPersonFilter !== undefined)
            url_ += "MaxDailyNumberPerPersonFilter=" + encodeURIComponent("" + maxDailyNumberPerPersonFilter) + "&"; 
        if (minDailyNumberPerPersonFilter === null)
            throw new Error("The parameter 'minDailyNumberPerPersonFilter' cannot be null.");
        else if (minDailyNumberPerPersonFilter !== undefined)
            url_ += "MinDailyNumberPerPersonFilter=" + encodeURIComponent("" + minDailyNumberPerPersonFilter) + "&"; 
        if (maxMaximumDailyNumberFilter === null)
            throw new Error("The parameter 'maxMaximumDailyNumberFilter' cannot be null.");
        else if (maxMaximumDailyNumberFilter !== undefined)
            url_ += "MaxMaximumDailyNumberFilter=" + encodeURIComponent("" + maxMaximumDailyNumberFilter) + "&"; 
        if (minMaximumDailyNumberFilter === null)
            throw new Error("The parameter 'minMaximumDailyNumberFilter' cannot be null.");
        else if (minMaximumDailyNumberFilter !== undefined)
            url_ += "MinMaximumDailyNumberFilter=" + encodeURIComponent("" + minMaximumDailyNumberFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSacrificeTypeForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSacrificeTypeForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSacrificeTypeForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetSacrificeTypeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSacrificeTypeForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSacrificeTypeForView(id: number | undefined): Observable<GetSacrificeTypeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SacrificeTypes/GetSacrificeTypeForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSacrificeTypeForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSacrificeTypeForView(<any>response_);
                } catch (e) {
                    return <Observable<GetSacrificeTypeForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSacrificeTypeForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSacrificeTypeForView(response: HttpResponseBase): Observable<GetSacrificeTypeForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSacrificeTypeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSacrificeTypeForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSacrificeTypeForEdit(id: number | undefined): Observable<GetSacrificeTypeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SacrificeTypes/GetSacrificeTypeForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSacrificeTypeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSacrificeTypeForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSacrificeTypeForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSacrificeTypeForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSacrificeTypeForEdit(response: HttpResponseBase): Observable<GetSacrificeTypeForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSacrificeTypeForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSacrificeTypeForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditSacrificeTypeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SacrificeTypes/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SacrificeTypes/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param maxDailyNumberPerPersonFilter (optional) 
     * @param minDailyNumberPerPersonFilter (optional) 
     * @param maxMaximumDailyNumberFilter (optional) 
     * @param minMaximumDailyNumberFilter (optional) 
     * @return Success
     */
    getSacrificeTypesToExcel(filter: string | undefined, titleFilter: string | undefined, maxDailyNumberPerPersonFilter: number | undefined, minDailyNumberPerPersonFilter: number | undefined, maxMaximumDailyNumberFilter: number | undefined, minMaximumDailyNumberFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SacrificeTypes/GetSacrificeTypesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (maxDailyNumberPerPersonFilter === null)
            throw new Error("The parameter 'maxDailyNumberPerPersonFilter' cannot be null.");
        else if (maxDailyNumberPerPersonFilter !== undefined)
            url_ += "MaxDailyNumberPerPersonFilter=" + encodeURIComponent("" + maxDailyNumberPerPersonFilter) + "&"; 
        if (minDailyNumberPerPersonFilter === null)
            throw new Error("The parameter 'minDailyNumberPerPersonFilter' cannot be null.");
        else if (minDailyNumberPerPersonFilter !== undefined)
            url_ += "MinDailyNumberPerPersonFilter=" + encodeURIComponent("" + minDailyNumberPerPersonFilter) + "&"; 
        if (maxMaximumDailyNumberFilter === null)
            throw new Error("The parameter 'maxMaximumDailyNumberFilter' cannot be null.");
        else if (maxMaximumDailyNumberFilter !== undefined)
            url_ += "MaxMaximumDailyNumberFilter=" + encodeURIComponent("" + maxMaximumDailyNumberFilter) + "&"; 
        if (minMaximumDailyNumberFilter === null)
            throw new Error("The parameter 'minMaximumDailyNumberFilter' cannot be null.");
        else if (minMaximumDailyNumberFilter !== undefined)
            url_ += "MinMaximumDailyNumberFilter=" + encodeURIComponent("" + minMaximumDailyNumberFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSacrificeTypesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSacrificeTypesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSacrificeTypesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getSacrificeIcon(input: Livestocks): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SacrificeTypes/GetSacrificeIcon?";
        if (input === undefined || input === null)
            throw new Error("The parameter 'input' must be defined and cannot be null.");
        else
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSacrificeIcon(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSacrificeIcon(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetSacrificeIcon(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class SendMessagesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerSMS(body: RegisterConfigRequest | undefined): Observable<RegisterConfigResponse> {
        let url_ = this.baseUrl + "/api/services/app/SendMessages/RegisterSMS";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterSMS(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterSMS(<any>response_);
                } catch (e) {
                    return <Observable<RegisterConfigResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegisterConfigResponse>><any>_observableThrow(response_);
        }));
    }

    protected processRegisterSMS(response: HttpResponseBase): Observable<RegisterConfigResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterConfigResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisterConfigResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerEmailConfig(body: RegisterEmailRequest | undefined): Observable<RegisterEmailResponse> {
        let url_ = this.baseUrl + "/api/services/app/SendMessages/RegisterEmailConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterEmailConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterEmailConfig(<any>response_);
                } catch (e) {
                    return <Observable<RegisterEmailResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegisterEmailResponse>><any>_observableThrow(response_);
        }));
    }

    protected processRegisterEmailConfig(response: HttpResponseBase): Observable<RegisterEmailResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterEmailResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisterEmailResponse>(<any>null);
    }

    /**
     * @param tenantId (optional) 
     * @param body (optional) 
     * @return Success
     */
    sendSimpleSMS(tenantId: number | undefined, body: SendSimpleRequest | undefined): Observable<SendSimpleResponse> {
        let url_ = this.baseUrl + "/api/services/app/SendMessages/SendSimpleSMS?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendSimpleSMS(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendSimpleSMS(<any>response_);
                } catch (e) {
                    return <Observable<SendSimpleResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<SendSimpleResponse>><any>_observableThrow(response_);
        }));
    }

    protected processSendSimpleSMS(response: HttpResponseBase): Observable<SendSimpleResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendSimpleResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SendSimpleResponse>(<any>null);
    }

    /**
     * @param tenantId (optional) 
     * @param body (optional) 
     * @return Success
     */
    sendMessageByTemplate(tenantId: number | undefined, body: SendByTemplateRequest | undefined): Observable<SendByTemplateResponse> {
        let url_ = this.baseUrl + "/api/services/app/SendMessages/SendMessageByTemplate?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMessageByTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMessageByTemplate(<any>response_);
                } catch (e) {
                    return <Observable<SendByTemplateResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<SendByTemplateResponse>><any>_observableThrow(response_);
        }));
    }

    protected processSendMessageByTemplate(response: HttpResponseBase): Observable<SendByTemplateResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendByTemplateResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SendByTemplateResponse>(<any>null);
    }

    /**
     * @param numberFilter (optional) 
     * @param templateFilter (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllLogs(numberFilter: string | undefined, templateFilter: string | undefined, fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAllLogsDto> {
        let url_ = this.baseUrl + "/api/services/app/SendMessages/GetAllLogs?";
        if (numberFilter === null)
            throw new Error("The parameter 'numberFilter' cannot be null.");
        else if (numberFilter !== undefined)
            url_ += "NumberFilter=" + encodeURIComponent("" + numberFilter) + "&"; 
        if (templateFilter === null)
            throw new Error("The parameter 'templateFilter' cannot be null.");
        else if (templateFilter !== undefined)
            url_ += "TemplateFilter=" + encodeURIComponent("" + templateFilter) + "&"; 
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLogs(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAllLogsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAllLogsDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllLogs(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllLogsDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAllLogsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAllLogsDto>(<any>null);
    }

    /**
     * @param jobId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    deleteJob(jobId: number | undefined, tenantId: number | undefined): Observable<DeleteAndCancelResponse> {
        let url_ = this.baseUrl + "/api/services/app/SendMessages/DeleteJob?";
        if (jobId === null)
            throw new Error("The parameter 'jobId' cannot be null.");
        else if (jobId !== undefined)
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&"; 
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteJob(<any>response_);
                } catch (e) {
                    return <Observable<DeleteAndCancelResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<DeleteAndCancelResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteJob(response: HttpResponseBase): Observable<DeleteAndCancelResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteAndCancelResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteAndCancelResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendEmail(body: SendEmailRequest | undefined): Observable<SendEmailResponse> {
        let url_ = this.baseUrl + "/api/services/app/SendMessages/SendEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmail(<any>response_);
                } catch (e) {
                    return <Observable<SendEmailResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<SendEmailResponse>><any>_observableThrow(response_);
        }));
    }

    protected processSendEmail(response: HttpResponseBase): Observable<SendEmailResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendEmailResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SendEmailResponse>(<any>null);
    }

    /**
     * @param tokens (optional) 
     * @return Success
     */
    getEmailTemplate(tempName: SMSServices, tokens: EmailToken[] | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SendMessages/GetEmailTemplate?";
        if (tempName === undefined || tempName === null)
            throw new Error("The parameter 'tempName' must be defined and cannot be null.");
        else
            url_ += "tempName=" + encodeURIComponent("" + tempName) + "&"; 
        if (tokens === null)
            throw new Error("The parameter 'tokens' cannot be null.");
        else if (tokens !== undefined)
            tokens && tokens.forEach((item, index) => { 
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "tokens[" + index + "]." + attr + "=" + encodeURIComponent("" + (<any>item)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailTemplate(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetEmailTemplate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class ServiceConditionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param descriptionFilter (optional) 
     * @param conditionTitleFilter (optional) 
     * @param serviceTitleFilter (optional) 
     * @param serviceIdFilter (optional) 
     * @param conditionIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, descriptionFilter: string | undefined, conditionTitleFilter: string | undefined, serviceTitleFilter: string | undefined, serviceIdFilter: number | undefined, conditionIdFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetServiceConditionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceConditions/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (conditionTitleFilter === null)
            throw new Error("The parameter 'conditionTitleFilter' cannot be null.");
        else if (conditionTitleFilter !== undefined)
            url_ += "ConditionTitleFilter=" + encodeURIComponent("" + conditionTitleFilter) + "&"; 
        if (serviceTitleFilter === null)
            throw new Error("The parameter 'serviceTitleFilter' cannot be null.");
        else if (serviceTitleFilter !== undefined)
            url_ += "ServiceTitleFilter=" + encodeURIComponent("" + serviceTitleFilter) + "&"; 
        if (serviceIdFilter === null)
            throw new Error("The parameter 'serviceIdFilter' cannot be null.");
        else if (serviceIdFilter !== undefined)
            url_ += "ServiceIdFilter=" + encodeURIComponent("" + serviceIdFilter) + "&"; 
        if (conditionIdFilter === null)
            throw new Error("The parameter 'conditionIdFilter' cannot be null.");
        else if (conditionIdFilter !== undefined)
            url_ += "ConditionIdFilter=" + encodeURIComponent("" + conditionIdFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetServiceConditionForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetServiceConditionForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetServiceConditionForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetServiceConditionForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetServiceConditionForViewDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param serviceRef (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllConditionForService(filter: string | undefined, serviceRef: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetServiceConditionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceConditions/GetAllConditionForService?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (serviceRef === null)
            throw new Error("The parameter 'serviceRef' cannot be null.");
        else if (serviceRef !== undefined)
            url_ += "ServiceRef=" + encodeURIComponent("" + serviceRef) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllConditionForService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllConditionForService(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetServiceConditionForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetServiceConditionForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllConditionForService(response: HttpResponseBase): Observable<PagedResultDtoOfGetServiceConditionForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetServiceConditionForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetServiceConditionForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getServiceConditionForView(id: number | undefined): Observable<GetServiceConditionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceConditions/GetServiceConditionForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceConditionForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceConditionForView(<any>response_);
                } catch (e) {
                    return <Observable<GetServiceConditionForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetServiceConditionForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetServiceConditionForView(response: HttpResponseBase): Observable<GetServiceConditionForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetServiceConditionForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetServiceConditionForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getServiceConditionForEdit(id: number | undefined): Observable<GetServiceConditionForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ServiceConditions/GetServiceConditionForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceConditionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceConditionForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetServiceConditionForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetServiceConditionForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetServiceConditionForEdit(response: HttpResponseBase): Observable<GetServiceConditionForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetServiceConditionForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetServiceConditionForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditServiceConditionsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceConditions/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceConditions/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param serviceRefInput (optional) 
     * @return Success
     */
    deleteAllServiceConditionByServiceRef(serviceRefInput: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceConditions/DeleteAllServiceConditionByServiceRef?";
        if (serviceRefInput === null)
            throw new Error("The parameter 'serviceRefInput' cannot be null.");
        else if (serviceRefInput !== undefined)
            url_ += "serviceRefInput=" + encodeURIComponent("" + serviceRefInput) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAllServiceConditionByServiceRef(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAllServiceConditionByServiceRef(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteAllServiceConditionByServiceRef(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param descriptionFilter (optional) 
     * @param minFilter (optional) 
     * @param maxFilter (optional) 
     * @param isIncludeFilter (optional) 
     * @param conditionTitleFilter (optional) 
     * @param serviceTitleFilter (optional) 
     * @return Success
     */
    getServiceConditionsToExcel(filter: string | undefined, descriptionFilter: string | undefined, minFilter: string | undefined, maxFilter: string | undefined, isIncludeFilter: number | undefined, conditionTitleFilter: string | undefined, serviceTitleFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceConditions/GetServiceConditionsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (minFilter === null)
            throw new Error("The parameter 'minFilter' cannot be null.");
        else if (minFilter !== undefined)
            url_ += "MinFilter=" + encodeURIComponent("" + minFilter) + "&"; 
        if (maxFilter === null)
            throw new Error("The parameter 'maxFilter' cannot be null.");
        else if (maxFilter !== undefined)
            url_ += "MaxFilter=" + encodeURIComponent("" + maxFilter) + "&"; 
        if (isIncludeFilter === null)
            throw new Error("The parameter 'isIncludeFilter' cannot be null.");
        else if (isIncludeFilter !== undefined)
            url_ += "IsIncludeFilter=" + encodeURIComponent("" + isIncludeFilter) + "&"; 
        if (conditionTitleFilter === null)
            throw new Error("The parameter 'conditionTitleFilter' cannot be null.");
        else if (conditionTitleFilter !== undefined)
            url_ += "ConditionTitleFilter=" + encodeURIComponent("" + conditionTitleFilter) + "&"; 
        if (serviceTitleFilter === null)
            throw new Error("The parameter 'serviceTitleFilter' cannot be null.");
        else if (serviceTitleFilter !== undefined)
            url_ += "ServiceTitleFilter=" + encodeURIComponent("" + serviceTitleFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceConditionsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceConditionsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetServiceConditionsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param entityFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllConditionForLookupTable(filter: string | undefined, entityFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfServiceConditionConditionLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceConditions/GetAllConditionForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllConditionForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllConditionForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfServiceConditionConditionLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfServiceConditionConditionLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllConditionForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfServiceConditionConditionLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfServiceConditionConditionLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfServiceConditionConditionLookupTableDto>(<any>null);
    }

    /**
     * @param entityFilter (optional) 
     * @return Success
     */
    getAllConditionForTableDropdown(entityFilter: number | undefined): Observable<ServiceConditionConditionLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ServiceConditions/GetAllConditionForTableDropdown?";
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllConditionForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllConditionForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<ServiceConditionConditionLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ServiceConditionConditionLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllConditionForTableDropdown(response: HttpResponseBase): Observable<ServiceConditionConditionLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceConditionConditionLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceConditionConditionLookupTableDto[]>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param entityFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllServiceForLookupTable(filter: string | undefined, entityFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfServiceConditionServiceLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceConditions/GetAllServiceForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllServiceForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllServiceForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfServiceConditionServiceLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfServiceConditionServiceLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllServiceForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfServiceConditionServiceLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfServiceConditionServiceLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfServiceConditionServiceLookupTableDto>(<any>null);
    }
}

@Injectable()
export class ServicesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param codeFilter (optional) 
     * @param maxPriceFilter (optional) 
     * @param minPriceFilter (optional) 
     * @param accountingCodeFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param serviceAreaFilter (optional) 
     * @param serviceTypeFilter (optional) 
     * @param entityFilter (optional) 
     * @param branchNameFilter (optional) 
     * @param accountIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, titleFilter: string | undefined, codeFilter: string | undefined, maxPriceFilter: number | undefined, minPriceFilter: number | undefined, accountingCodeFilter: string | undefined, descriptionFilter: string | undefined, serviceAreaFilter: number | undefined, serviceTypeFilter: number | undefined, entityFilter: number | undefined, branchNameFilter: string | undefined, accountIdFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetServiceForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Services/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (maxPriceFilter === null)
            throw new Error("The parameter 'maxPriceFilter' cannot be null.");
        else if (maxPriceFilter !== undefined)
            url_ += "MaxPriceFilter=" + encodeURIComponent("" + maxPriceFilter) + "&"; 
        if (minPriceFilter === null)
            throw new Error("The parameter 'minPriceFilter' cannot be null.");
        else if (minPriceFilter !== undefined)
            url_ += "MinPriceFilter=" + encodeURIComponent("" + minPriceFilter) + "&"; 
        if (accountingCodeFilter === null)
            throw new Error("The parameter 'accountingCodeFilter' cannot be null.");
        else if (accountingCodeFilter !== undefined)
            url_ += "AccountingCodeFilter=" + encodeURIComponent("" + accountingCodeFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (serviceAreaFilter === null)
            throw new Error("The parameter 'serviceAreaFilter' cannot be null.");
        else if (serviceAreaFilter !== undefined)
            url_ += "ServiceAreaFilter=" + encodeURIComponent("" + serviceAreaFilter) + "&"; 
        if (serviceTypeFilter === null)
            throw new Error("The parameter 'serviceTypeFilter' cannot be null.");
        else if (serviceTypeFilter !== undefined)
            url_ += "ServiceTypeFilter=" + encodeURIComponent("" + serviceTypeFilter) + "&"; 
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (branchNameFilter === null)
            throw new Error("The parameter 'branchNameFilter' cannot be null.");
        else if (branchNameFilter !== undefined)
            url_ += "BranchNameFilter=" + encodeURIComponent("" + branchNameFilter) + "&"; 
        if (accountIdFilter === null)
            throw new Error("The parameter 'accountIdFilter' cannot be null.");
        else if (accountIdFilter !== undefined)
            url_ += "AccountIdFilter=" + encodeURIComponent("" + accountIdFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetServiceForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetServiceForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetServiceForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetServiceForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetServiceForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getServiceForView(id: number | undefined): Observable<GetServiceForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Services/GetServiceForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceForView(<any>response_);
                } catch (e) {
                    return <Observable<GetServiceForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetServiceForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetServiceForView(response: HttpResponseBase): Observable<GetServiceForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetServiceForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetServiceForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getServiceForEdit(id: number | undefined): Observable<GetServiceForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Services/GetServiceForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetServiceForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetServiceForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetServiceForEdit(response: HttpResponseBase): Observable<GetServiceForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetServiceForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetServiceForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditServiceDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Services/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditServiceAndServiceCondition(body: CreateOrEditServiceAndServiceConditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Services/CreateOrEditServiceAndServiceCondition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditServiceAndServiceCondition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditServiceAndServiceCondition(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditServiceAndServiceCondition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Services/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param codeFilter (optional) 
     * @param maxPriceFilter (optional) 
     * @param minPriceFilter (optional) 
     * @param accountingCodeFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param serviceAreaFilter (optional) 
     * @param serviceTypeFilter (optional) 
     * @param entityFilter (optional) 
     * @param branchNameFilter (optional) 
     * @return Success
     */
    getServicesToExcel(filter: string | undefined, titleFilter: string | undefined, codeFilter: string | undefined, maxPriceFilter: number | undefined, minPriceFilter: number | undefined, accountingCodeFilter: string | undefined, descriptionFilter: string | undefined, serviceAreaFilter: number | undefined, serviceTypeFilter: number | undefined, entityFilter: number | undefined, branchNameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Services/GetServicesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (maxPriceFilter === null)
            throw new Error("The parameter 'maxPriceFilter' cannot be null.");
        else if (maxPriceFilter !== undefined)
            url_ += "MaxPriceFilter=" + encodeURIComponent("" + maxPriceFilter) + "&"; 
        if (minPriceFilter === null)
            throw new Error("The parameter 'minPriceFilter' cannot be null.");
        else if (minPriceFilter !== undefined)
            url_ += "MinPriceFilter=" + encodeURIComponent("" + minPriceFilter) + "&"; 
        if (accountingCodeFilter === null)
            throw new Error("The parameter 'accountingCodeFilter' cannot be null.");
        else if (accountingCodeFilter !== undefined)
            url_ += "AccountingCodeFilter=" + encodeURIComponent("" + accountingCodeFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (serviceAreaFilter === null)
            throw new Error("The parameter 'serviceAreaFilter' cannot be null.");
        else if (serviceAreaFilter !== undefined)
            url_ += "ServiceAreaFilter=" + encodeURIComponent("" + serviceAreaFilter) + "&"; 
        if (serviceTypeFilter === null)
            throw new Error("The parameter 'serviceTypeFilter' cannot be null.");
        else if (serviceTypeFilter !== undefined)
            url_ += "ServiceTypeFilter=" + encodeURIComponent("" + serviceTypeFilter) + "&"; 
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (branchNameFilter === null)
            throw new Error("The parameter 'branchNameFilter' cannot be null.");
        else if (branchNameFilter !== undefined)
            url_ += "BranchNameFilter=" + encodeURIComponent("" + branchNameFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServicesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServicesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetServicesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllBranchForTableDropdown(): Observable<ServiceBranchLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Services/GetAllBranchForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBranchForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBranchForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<ServiceBranchLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ServiceBranchLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBranchForTableDropdown(response: HttpResponseBase): Observable<ServiceBranchLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceBranchLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceBranchLookupTableDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllRoleForTableDropdown(): Observable<ServiceRoleLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Services/GetAllRoleForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRoleForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRoleForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<ServiceRoleLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ServiceRoleLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllRoleForTableDropdown(response: HttpResponseBase): Observable<ServiceRoleLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceRoleLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceRoleLookupTableDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllBaseTimeForTableDropdown(): Observable<ServiceBaseTimeLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Services/GetAllBaseTimeForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBaseTimeForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBaseTimeForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<ServiceBaseTimeLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ServiceBaseTimeLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBaseTimeForTableDropdown(response: HttpResponseBase): Observable<ServiceBaseTimeLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceBaseTimeLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceBaseTimeLookupTableDto[]>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCommodityBasketForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfServiceCommodityBasketLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Services/GetAllCommodityBasketForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCommodityBasketForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCommodityBasketForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfServiceCommodityBasketLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfServiceCommodityBasketLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCommodityBasketForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfServiceCommodityBasketLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfServiceCommodityBasketLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfServiceCommodityBasketLookupTableDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllAccountForTableDropdown(): Observable<ServiceAccountLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Services/GetAllAccountForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAccountForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAccountForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<ServiceAccountLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ServiceAccountLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllAccountForTableDropdown(response: HttpResponseBase): Observable<ServiceAccountLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceAccountLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceAccountLookupTableDto[]>(<any>null);
    }
}

@Injectable()
export class ServiceVouchersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param entityFilter (optional) 
     * @param statusFilter (optional) 
     * @param serviceTitleFilter (optional) 
     * @param branchNameFilter (optional) 
     * @param planBillCodeFilter (optional) 
     * @param userPhoneNumberFilter (optional) 
     * @param userPhoneNumber2Filter (optional) 
     * @param userPhoneNumber3Filter (optional) 
     * @param serviceIdFilter (optional) 
     * @param personInquiryIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, codeFilter: string | undefined, entityFilter: number | undefined, statusFilter: number | undefined, serviceTitleFilter: string | undefined, branchNameFilter: string | undefined, planBillCodeFilter: string | undefined, userPhoneNumberFilter: string | undefined, userPhoneNumber2Filter: string | undefined, userPhoneNumber3Filter: string | undefined, serviceIdFilter: number | undefined, personInquiryIdFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetServiceVoucherForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVouchers/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (serviceTitleFilter === null)
            throw new Error("The parameter 'serviceTitleFilter' cannot be null.");
        else if (serviceTitleFilter !== undefined)
            url_ += "ServiceTitleFilter=" + encodeURIComponent("" + serviceTitleFilter) + "&"; 
        if (branchNameFilter === null)
            throw new Error("The parameter 'branchNameFilter' cannot be null.");
        else if (branchNameFilter !== undefined)
            url_ += "BranchNameFilter=" + encodeURIComponent("" + branchNameFilter) + "&"; 
        if (planBillCodeFilter === null)
            throw new Error("The parameter 'planBillCodeFilter' cannot be null.");
        else if (planBillCodeFilter !== undefined)
            url_ += "PlanBillCodeFilter=" + encodeURIComponent("" + planBillCodeFilter) + "&"; 
        if (userPhoneNumberFilter === null)
            throw new Error("The parameter 'userPhoneNumberFilter' cannot be null.");
        else if (userPhoneNumberFilter !== undefined)
            url_ += "UserPhoneNumberFilter=" + encodeURIComponent("" + userPhoneNumberFilter) + "&"; 
        if (userPhoneNumber2Filter === null)
            throw new Error("The parameter 'userPhoneNumber2Filter' cannot be null.");
        else if (userPhoneNumber2Filter !== undefined)
            url_ += "UserPhoneNumber2Filter=" + encodeURIComponent("" + userPhoneNumber2Filter) + "&"; 
        if (userPhoneNumber3Filter === null)
            throw new Error("The parameter 'userPhoneNumber3Filter' cannot be null.");
        else if (userPhoneNumber3Filter !== undefined)
            url_ += "UserPhoneNumber3Filter=" + encodeURIComponent("" + userPhoneNumber3Filter) + "&"; 
        if (serviceIdFilter === null)
            throw new Error("The parameter 'serviceIdFilter' cannot be null.");
        else if (serviceIdFilter !== undefined)
            url_ += "ServiceIdFilter=" + encodeURIComponent("" + serviceIdFilter) + "&"; 
        if (personInquiryIdFilter === null)
            throw new Error("The parameter 'personInquiryIdFilter' cannot be null.");
        else if (personInquiryIdFilter !== undefined)
            url_ += "PersonInquiryIdFilter=" + encodeURIComponent("" + personInquiryIdFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetServiceVoucherForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetServiceVoucherForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetServiceVoucherForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetServiceVoucherForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetServiceVoucherForViewDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param entityFilter (optional) 
     * @param statusFilter (optional) 
     * @param serviceTitleFilter (optional) 
     * @param branchNameFilter (optional) 
     * @param planBillCodeFilter (optional) 
     * @param userPhoneNumberFilter (optional) 
     * @param userPhoneNumber2Filter (optional) 
     * @param userPhoneNumber3Filter (optional) 
     * @param serviceIdFilter (optional) 
     * @param personInquiryIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllForSeconder(filter: string | undefined, codeFilter: string | undefined, entityFilter: number | undefined, statusFilter: number | undefined, serviceTitleFilter: string | undefined, branchNameFilter: string | undefined, planBillCodeFilter: string | undefined, userPhoneNumberFilter: string | undefined, userPhoneNumber2Filter: string | undefined, userPhoneNumber3Filter: string | undefined, serviceIdFilter: number | undefined, personInquiryIdFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetServiceVoucherForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVouchers/GetAllForSeconder?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (serviceTitleFilter === null)
            throw new Error("The parameter 'serviceTitleFilter' cannot be null.");
        else if (serviceTitleFilter !== undefined)
            url_ += "ServiceTitleFilter=" + encodeURIComponent("" + serviceTitleFilter) + "&"; 
        if (branchNameFilter === null)
            throw new Error("The parameter 'branchNameFilter' cannot be null.");
        else if (branchNameFilter !== undefined)
            url_ += "BranchNameFilter=" + encodeURIComponent("" + branchNameFilter) + "&"; 
        if (planBillCodeFilter === null)
            throw new Error("The parameter 'planBillCodeFilter' cannot be null.");
        else if (planBillCodeFilter !== undefined)
            url_ += "PlanBillCodeFilter=" + encodeURIComponent("" + planBillCodeFilter) + "&"; 
        if (userPhoneNumberFilter === null)
            throw new Error("The parameter 'userPhoneNumberFilter' cannot be null.");
        else if (userPhoneNumberFilter !== undefined)
            url_ += "UserPhoneNumberFilter=" + encodeURIComponent("" + userPhoneNumberFilter) + "&"; 
        if (userPhoneNumber2Filter === null)
            throw new Error("The parameter 'userPhoneNumber2Filter' cannot be null.");
        else if (userPhoneNumber2Filter !== undefined)
            url_ += "UserPhoneNumber2Filter=" + encodeURIComponent("" + userPhoneNumber2Filter) + "&"; 
        if (userPhoneNumber3Filter === null)
            throw new Error("The parameter 'userPhoneNumber3Filter' cannot be null.");
        else if (userPhoneNumber3Filter !== undefined)
            url_ += "UserPhoneNumber3Filter=" + encodeURIComponent("" + userPhoneNumber3Filter) + "&"; 
        if (serviceIdFilter === null)
            throw new Error("The parameter 'serviceIdFilter' cannot be null.");
        else if (serviceIdFilter !== undefined)
            url_ += "ServiceIdFilter=" + encodeURIComponent("" + serviceIdFilter) + "&"; 
        if (personInquiryIdFilter === null)
            throw new Error("The parameter 'personInquiryIdFilter' cannot be null.");
        else if (personInquiryIdFilter !== undefined)
            url_ += "PersonInquiryIdFilter=" + encodeURIComponent("" + personInquiryIdFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForSeconder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForSeconder(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetServiceVoucherForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetServiceVoucherForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllForSeconder(response: HttpResponseBase): Observable<PagedResultDtoOfGetServiceVoucherForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetServiceVoucherForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetServiceVoucherForViewDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param entityFilter (optional) 
     * @param statusFilter (optional) 
     * @param serviceTitleFilter (optional) 
     * @param branchNameFilter (optional) 
     * @param planBillCodeFilter (optional) 
     * @param userPhoneNumberFilter (optional) 
     * @param userPhoneNumber2Filter (optional) 
     * @param userPhoneNumber3Filter (optional) 
     * @param serviceIdFilter (optional) 
     * @param personInquiryIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllForApprover(filter: string | undefined, codeFilter: string | undefined, entityFilter: number | undefined, statusFilter: number | undefined, serviceTitleFilter: string | undefined, branchNameFilter: string | undefined, planBillCodeFilter: string | undefined, userPhoneNumberFilter: string | undefined, userPhoneNumber2Filter: string | undefined, userPhoneNumber3Filter: string | undefined, serviceIdFilter: number | undefined, personInquiryIdFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetServiceVoucherForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVouchers/GetAllForApprover?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (serviceTitleFilter === null)
            throw new Error("The parameter 'serviceTitleFilter' cannot be null.");
        else if (serviceTitleFilter !== undefined)
            url_ += "ServiceTitleFilter=" + encodeURIComponent("" + serviceTitleFilter) + "&"; 
        if (branchNameFilter === null)
            throw new Error("The parameter 'branchNameFilter' cannot be null.");
        else if (branchNameFilter !== undefined)
            url_ += "BranchNameFilter=" + encodeURIComponent("" + branchNameFilter) + "&"; 
        if (planBillCodeFilter === null)
            throw new Error("The parameter 'planBillCodeFilter' cannot be null.");
        else if (planBillCodeFilter !== undefined)
            url_ += "PlanBillCodeFilter=" + encodeURIComponent("" + planBillCodeFilter) + "&"; 
        if (userPhoneNumberFilter === null)
            throw new Error("The parameter 'userPhoneNumberFilter' cannot be null.");
        else if (userPhoneNumberFilter !== undefined)
            url_ += "UserPhoneNumberFilter=" + encodeURIComponent("" + userPhoneNumberFilter) + "&"; 
        if (userPhoneNumber2Filter === null)
            throw new Error("The parameter 'userPhoneNumber2Filter' cannot be null.");
        else if (userPhoneNumber2Filter !== undefined)
            url_ += "UserPhoneNumber2Filter=" + encodeURIComponent("" + userPhoneNumber2Filter) + "&"; 
        if (userPhoneNumber3Filter === null)
            throw new Error("The parameter 'userPhoneNumber3Filter' cannot be null.");
        else if (userPhoneNumber3Filter !== undefined)
            url_ += "UserPhoneNumber3Filter=" + encodeURIComponent("" + userPhoneNumber3Filter) + "&"; 
        if (serviceIdFilter === null)
            throw new Error("The parameter 'serviceIdFilter' cannot be null.");
        else if (serviceIdFilter !== undefined)
            url_ += "ServiceIdFilter=" + encodeURIComponent("" + serviceIdFilter) + "&"; 
        if (personInquiryIdFilter === null)
            throw new Error("The parameter 'personInquiryIdFilter' cannot be null.");
        else if (personInquiryIdFilter !== undefined)
            url_ += "PersonInquiryIdFilter=" + encodeURIComponent("" + personInquiryIdFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForApprover(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForApprover(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetServiceVoucherForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetServiceVoucherForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllForApprover(response: HttpResponseBase): Observable<PagedResultDtoOfGetServiceVoucherForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetServiceVoucherForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetServiceVoucherForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getServiceVoucherForView(id: number | undefined): Observable<GetServiceVoucherForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVouchers/GetServiceVoucherForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceVoucherForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceVoucherForView(<any>response_);
                } catch (e) {
                    return <Observable<GetServiceVoucherForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetServiceVoucherForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetServiceVoucherForView(response: HttpResponseBase): Observable<GetServiceVoucherForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetServiceVoucherForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetServiceVoucherForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getServiceVoucherForEdit(id: number | undefined): Observable<GetServiceVoucherForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVouchers/GetServiceVoucherForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceVoucherForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceVoucherForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetServiceVoucherForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetServiceVoucherForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetServiceVoucherForEdit(response: HttpResponseBase): Observable<GetServiceVoucherForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetServiceVoucherForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetServiceVoucherForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditServiceVoucherDto | undefined): Observable<CreateOrEditServiceVoucherResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVouchers/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditServiceVoucherResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditServiceVoucherResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<CreateOrEditServiceVoucherResponseDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditServiceVoucherResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditServiceVoucherResponseDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVouchers/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param entityFilter (optional) 
     * @param statusFilter (optional) 
     * @param serviceTitleFilter (optional) 
     * @param branchNameFilter (optional) 
     * @param planBillCodeFilter (optional) 
     * @param userPhoneNumberFilter (optional) 
     * @param userPhoneNumber2Filter (optional) 
     * @param userPhoneNumber3Filter (optional) 
     * @return Success
     */
    getServiceVouchersToExcel(filter: string | undefined, codeFilter: string | undefined, entityFilter: number | undefined, statusFilter: number | undefined, serviceTitleFilter: string | undefined, branchNameFilter: string | undefined, planBillCodeFilter: string | undefined, userPhoneNumberFilter: string | undefined, userPhoneNumber2Filter: string | undefined, userPhoneNumber3Filter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVouchers/GetServiceVouchersToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (serviceTitleFilter === null)
            throw new Error("The parameter 'serviceTitleFilter' cannot be null.");
        else if (serviceTitleFilter !== undefined)
            url_ += "ServiceTitleFilter=" + encodeURIComponent("" + serviceTitleFilter) + "&"; 
        if (branchNameFilter === null)
            throw new Error("The parameter 'branchNameFilter' cannot be null.");
        else if (branchNameFilter !== undefined)
            url_ += "BranchNameFilter=" + encodeURIComponent("" + branchNameFilter) + "&"; 
        if (planBillCodeFilter === null)
            throw new Error("The parameter 'planBillCodeFilter' cannot be null.");
        else if (planBillCodeFilter !== undefined)
            url_ += "PlanBillCodeFilter=" + encodeURIComponent("" + planBillCodeFilter) + "&"; 
        if (userPhoneNumberFilter === null)
            throw new Error("The parameter 'userPhoneNumberFilter' cannot be null.");
        else if (userPhoneNumberFilter !== undefined)
            url_ += "UserPhoneNumberFilter=" + encodeURIComponent("" + userPhoneNumberFilter) + "&"; 
        if (userPhoneNumber2Filter === null)
            throw new Error("The parameter 'userPhoneNumber2Filter' cannot be null.");
        else if (userPhoneNumber2Filter !== undefined)
            url_ += "UserPhoneNumber2Filter=" + encodeURIComponent("" + userPhoneNumber2Filter) + "&"; 
        if (userPhoneNumber3Filter === null)
            throw new Error("The parameter 'userPhoneNumber3Filter' cannot be null.");
        else if (userPhoneNumber3Filter !== undefined)
            url_ += "UserPhoneNumber3Filter=" + encodeURIComponent("" + userPhoneNumber3Filter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceVouchersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceVouchersToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetServiceVouchersToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param rolRefFilter (optional) 
     * @param entityFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllServiceForLookupTable(filter: string | undefined, rolRefFilter: number[] | undefined, entityFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfServiceVoucherServiceLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVouchers/GetAllServiceForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (rolRefFilter === null)
            throw new Error("The parameter 'rolRefFilter' cannot be null.");
        else if (rolRefFilter !== undefined)
            rolRefFilter && rolRefFilter.forEach(item => { url_ += "RolRefFilter=" + encodeURIComponent("" + item) + "&"; });
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllServiceForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllServiceForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfServiceVoucherServiceLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfServiceVoucherServiceLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllServiceForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfServiceVoucherServiceLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfServiceVoucherServiceLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfServiceVoucherServiceLookupTableDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllBranchForTableDropdown(): Observable<ServiceVoucherBranchLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVouchers/GetAllBranchForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBranchForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBranchForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<ServiceVoucherBranchLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ServiceVoucherBranchLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBranchForTableDropdown(response: HttpResponseBase): Observable<ServiceVoucherBranchLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceVoucherBranchLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceVoucherBranchLookupTableDto[]>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param rolRefFilter (optional) 
     * @param entityFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllPlanBillForLookupTable(filter: string | undefined, rolRefFilter: number[] | undefined, entityFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfServiceVoucherPlanBillLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVouchers/GetAllPlanBillForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (rolRefFilter === null)
            throw new Error("The parameter 'rolRefFilter' cannot be null.");
        else if (rolRefFilter !== undefined)
            rolRefFilter && rolRefFilter.forEach(item => { url_ += "RolRefFilter=" + encodeURIComponent("" + item) + "&"; });
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPlanBillForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPlanBillForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfServiceVoucherPlanBillLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfServiceVoucherPlanBillLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPlanBillForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfServiceVoucherPlanBillLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfServiceVoucherPlanBillLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfServiceVoucherPlanBillLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param rolRefFilter (optional) 
     * @param entityFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllUserForLookupTable(filter: string | undefined, rolRefFilter: number[] | undefined, entityFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfServiceVoucherUserLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVouchers/GetAllUserForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (rolRefFilter === null)
            throw new Error("The parameter 'rolRefFilter' cannot be null.");
        else if (rolRefFilter !== undefined)
            rolRefFilter && rolRefFilter.forEach(item => { url_ += "RolRefFilter=" + encodeURIComponent("" + item) + "&"; });
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUserForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfServiceVoucherUserLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfServiceVoucherUserLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllUserForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfServiceVoucherUserLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfServiceVoucherUserLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfServiceVoucherUserLookupTableDto>(<any>null);
    }

    /**
     * @param firstNameFilter (optional) 
     * @param genderFilter (optional) 
     * @param minAgeFilter (optional) 
     * @param maxAgeFilter (optional) 
     * @param minBirthDate (optional) 
     * @param maxBirthDate (optional) 
     * @param healthStatusFilter (optional) 
     * @param isSadatFilter (optional) 
     * @param serviceId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllAcceptableClientForLookupTable(firstNameFilter: string | undefined, genderFilter: Gender | undefined, minAgeFilter: number | undefined, maxAgeFilter: number | undefined, minBirthDate: moment.Moment | undefined, maxBirthDate: moment.Moment | undefined, healthStatusFilter: string | undefined, isSadatFilter: boolean | undefined, serviceId: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAllClientForShopDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVouchers/GetAllAcceptableClientForLookupTable?";
        if (firstNameFilter === null)
            throw new Error("The parameter 'firstNameFilter' cannot be null.");
        else if (firstNameFilter !== undefined)
            url_ += "FirstNameFilter=" + encodeURIComponent("" + firstNameFilter) + "&"; 
        if (genderFilter === null)
            throw new Error("The parameter 'genderFilter' cannot be null.");
        else if (genderFilter !== undefined)
            url_ += "GenderFilter=" + encodeURIComponent("" + genderFilter) + "&"; 
        if (minAgeFilter === null)
            throw new Error("The parameter 'minAgeFilter' cannot be null.");
        else if (minAgeFilter !== undefined)
            url_ += "MinAgeFilter=" + encodeURIComponent("" + minAgeFilter) + "&"; 
        if (maxAgeFilter === null)
            throw new Error("The parameter 'maxAgeFilter' cannot be null.");
        else if (maxAgeFilter !== undefined)
            url_ += "MaxAgeFilter=" + encodeURIComponent("" + maxAgeFilter) + "&"; 
        if (minBirthDate === null)
            throw new Error("The parameter 'minBirthDate' cannot be null.");
        else if (minBirthDate !== undefined)
            url_ += "MinBirthDate=" + encodeURIComponent(minBirthDate ? "" + minBirthDate.toJSON() : "") + "&"; 
        if (maxBirthDate === null)
            throw new Error("The parameter 'maxBirthDate' cannot be null.");
        else if (maxBirthDate !== undefined)
            url_ += "MaxBirthDate=" + encodeURIComponent(maxBirthDate ? "" + maxBirthDate.toJSON() : "") + "&"; 
        if (healthStatusFilter === null)
            throw new Error("The parameter 'healthStatusFilter' cannot be null.");
        else if (healthStatusFilter !== undefined)
            url_ += "HealthStatusFilter=" + encodeURIComponent("" + healthStatusFilter) + "&"; 
        if (isSadatFilter === null)
            throw new Error("The parameter 'isSadatFilter' cannot be null.");
        else if (isSadatFilter !== undefined)
            url_ += "IsSadatFilter=" + encodeURIComponent("" + isSadatFilter) + "&"; 
        if (serviceId === null)
            throw new Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&"; 
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAcceptableClientForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAcceptableClientForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAllClientForShopDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAllClientForShopDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllAcceptableClientForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllClientForShopDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAllClientForShopDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAllClientForShopDto>(<any>null);
    }

    /**
     * @param firstNameFilter (optional) 
     * @param genderFilter (optional) 
     * @param minAgeFilter (optional) 
     * @param maxAgeFilter (optional) 
     * @param minBirthDate (optional) 
     * @param maxBirthDate (optional) 
     * @param healthStatusFilter (optional) 
     * @param isSadatFilter (optional) 
     * @param page (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllClientForLookupTable(firstNameFilter: string | undefined, genderFilter: Gender | undefined, minAgeFilter: number | undefined, maxAgeFilter: number | undefined, minBirthDate: moment.Moment | undefined, maxBirthDate: moment.Moment | undefined, healthStatusFilter: string | undefined, isSadatFilter: boolean | undefined, page: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAllClientForShopDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVouchers/GetAllClientForLookupTable?";
        if (firstNameFilter === null)
            throw new Error("The parameter 'firstNameFilter' cannot be null.");
        else if (firstNameFilter !== undefined)
            url_ += "FirstNameFilter=" + encodeURIComponent("" + firstNameFilter) + "&"; 
        if (genderFilter === null)
            throw new Error("The parameter 'genderFilter' cannot be null.");
        else if (genderFilter !== undefined)
            url_ += "GenderFilter=" + encodeURIComponent("" + genderFilter) + "&"; 
        if (minAgeFilter === null)
            throw new Error("The parameter 'minAgeFilter' cannot be null.");
        else if (minAgeFilter !== undefined)
            url_ += "MinAgeFilter=" + encodeURIComponent("" + minAgeFilter) + "&"; 
        if (maxAgeFilter === null)
            throw new Error("The parameter 'maxAgeFilter' cannot be null.");
        else if (maxAgeFilter !== undefined)
            url_ += "MaxAgeFilter=" + encodeURIComponent("" + maxAgeFilter) + "&"; 
        if (minBirthDate === null)
            throw new Error("The parameter 'minBirthDate' cannot be null.");
        else if (minBirthDate !== undefined)
            url_ += "MinBirthDate=" + encodeURIComponent(minBirthDate ? "" + minBirthDate.toJSON() : "") + "&"; 
        if (maxBirthDate === null)
            throw new Error("The parameter 'maxBirthDate' cannot be null.");
        else if (maxBirthDate !== undefined)
            url_ += "MaxBirthDate=" + encodeURIComponent(maxBirthDate ? "" + maxBirthDate.toJSON() : "") + "&"; 
        if (healthStatusFilter === null)
            throw new Error("The parameter 'healthStatusFilter' cannot be null.");
        else if (healthStatusFilter !== undefined)
            url_ += "HealthStatusFilter=" + encodeURIComponent("" + healthStatusFilter) + "&"; 
        if (isSadatFilter === null)
            throw new Error("The parameter 'isSadatFilter' cannot be null.");
        else if (isSadatFilter !== undefined)
            url_ += "IsSadatFilter=" + encodeURIComponent("" + isSadatFilter) + "&"; 
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllClientForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllClientForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAllClientForShopDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAllClientForShopDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllClientForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllClientForShopDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAllClientForShopDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAllClientForShopDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param serviceId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllAcceptableFamilyForLookupTable(filter: string | undefined, serviceId: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfServiceVoucherFamilyLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVouchers/GetAllAcceptableFamilyForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (serviceId === null)
            throw new Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&"; 
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAcceptableFamilyForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAcceptableFamilyForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfServiceVoucherFamilyLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfServiceVoucherFamilyLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllAcceptableFamilyForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfServiceVoucherFamilyLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfServiceVoucherFamilyLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfServiceVoucherFamilyLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param rolRefFilter (optional) 
     * @param entityFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllFamilyForLookupTable(filter: string | undefined, rolRefFilter: number[] | undefined, entityFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfServiceVoucherFamilyLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVouchers/GetAllFamilyForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (rolRefFilter === null)
            throw new Error("The parameter 'rolRefFilter' cannot be null.");
        else if (rolRefFilter !== undefined)
            rolRefFilter && rolRefFilter.forEach(item => { url_ += "RolRefFilter=" + encodeURIComponent("" + item) + "&"; });
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFamilyForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFamilyForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfServiceVoucherFamilyLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfServiceVoucherFamilyLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllFamilyForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfServiceVoucherFamilyLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfServiceVoucherFamilyLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfServiceVoucherFamilyLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param rolRefFilter (optional) 
     * @param entityFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllPersonInquiryForLookupTable(filter: string | undefined, rolRefFilter: number[] | undefined, entityFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfServiceVoucherPersonInquiryLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVouchers/GetAllPersonInquiryForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (rolRefFilter === null)
            throw new Error("The parameter 'rolRefFilter' cannot be null.");
        else if (rolRefFilter !== undefined)
            rolRefFilter && rolRefFilter.forEach(item => { url_ += "RolRefFilter=" + encodeURIComponent("" + item) + "&"; });
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPersonInquiryForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPersonInquiryForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfServiceVoucherPersonInquiryLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfServiceVoucherPersonInquiryLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPersonInquiryForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfServiceVoucherPersonInquiryLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfServiceVoucherPersonInquiryLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfServiceVoucherPersonInquiryLookupTableDto>(<any>null);
    }

    /**
     * @return Success
     */
    checkServiceVoucher(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVouchers/CheckServiceVoucher";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckServiceVoucher(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckServiceVoucher(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCheckServiceVoucher(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param serviceRefsFilter (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param entityRefNameFilter (optional) 
     * @param entityFilter (optional) 
     * @param timeStampKey (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAutomaticCheckServices(serviceRefsFilter: number[] | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, entityRefNameFilter: string | undefined, entityFilter: number | undefined, timeStampKey: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<GetAutomaticCheckServiceViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVouchers/GetAutomaticCheckServices?";
        if (serviceRefsFilter === null)
            throw new Error("The parameter 'serviceRefsFilter' cannot be null.");
        else if (serviceRefsFilter !== undefined)
            serviceRefsFilter && serviceRefsFilter.forEach(item => { url_ += "ServiceRefsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (entityRefNameFilter === null)
            throw new Error("The parameter 'entityRefNameFilter' cannot be null.");
        else if (entityRefNameFilter !== undefined)
            url_ += "EntityRefNameFilter=" + encodeURIComponent("" + entityRefNameFilter) + "&"; 
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (timeStampKey === null)
            throw new Error("The parameter 'timeStampKey' cannot be null.");
        else if (timeStampKey !== undefined)
            url_ += "TimeStampKey=" + encodeURIComponent("" + timeStampKey) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAutomaticCheckServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAutomaticCheckServices(<any>response_);
                } catch (e) {
                    return <Observable<GetAutomaticCheckServiceViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAutomaticCheckServiceViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAutomaticCheckServices(response: HttpResponseBase): Observable<GetAutomaticCheckServiceViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAutomaticCheckServiceViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAutomaticCheckServiceViewDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createRegulateAndServiceVouchers(body: CreateRegulateAndServiceVouchersInputDto | undefined): Observable<CreateOrEditServiceVoucherResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVouchers/CreateRegulateAndServiceVouchers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRegulateAndServiceVouchers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRegulateAndServiceVouchers(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditServiceVoucherResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditServiceVoucherResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateRegulateAndServiceVouchers(response: HttpResponseBase): Observable<CreateOrEditServiceVoucherResponseDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditServiceVoucherResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditServiceVoucherResponseDto>(<any>null);
    }

    /**
     * @param key (optional) 
     * @return Success
     */
    clearServiceVouchersCash(key: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVouchers/ClearServiceVouchersCash?";
        if (key === null)
            throw new Error("The parameter 'key' cannot be null.");
        else if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearServiceVouchersCash(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearServiceVouchersCash(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processClearServiceVouchersCash(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getReviewServiceVouchers(): Observable<PagedResultDtoOfGetServiceVoucherForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVouchers/GetReviewServiceVouchers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewServiceVouchers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewServiceVouchers(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetServiceVoucherForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetServiceVoucherForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetReviewServiceVouchers(response: HttpResponseBase): Observable<PagedResultDtoOfGetServiceVoucherForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetServiceVoucherForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetServiceVoucherForViewDto>(<any>null);
    }

    /**
     * @return Success
     */
    checkExpiredServiceVoucher(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVouchers/CheckExpiredServiceVoucher";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckExpiredServiceVoucher(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckExpiredServiceVoucher(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCheckExpiredServiceVoucher(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    checkExpiredFamilyServiceVoucher(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVouchers/CheckExpiredFamilyServiceVoucher";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckExpiredFamilyServiceVoucher(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckExpiredFamilyServiceVoucher(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCheckExpiredFamilyServiceVoucher(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    checkExpiredClientServiceVoucher(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVouchers/CheckExpiredClientServiceVoucher";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckExpiredClientServiceVoucher(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckExpiredClientServiceVoucher(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCheckExpiredClientServiceVoucher(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    secondedServiceVoucher(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVouchers/SecondedServiceVoucher";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSecondedServiceVoucher(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSecondedServiceVoucher(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSecondedServiceVoucher(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approvedServiceVoucher(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVouchers/ApprovedServiceVoucher";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprovedServiceVoucher(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprovedServiceVoucher(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApprovedServiceVoucher(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    activateServiceVoucher(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVouchers/ActivateServiceVoucher";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateServiceVoucher(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateServiceVoucher(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processActivateServiceVoucher(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    serviceVoucherCancellationByAdmin(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVouchers/ServiceVoucherCancellationByAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceVoucherCancellationByAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceVoucherCancellationByAdmin(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processServiceVoucherCancellationByAdmin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param familyId (optional) 
     * @param filter (optional) 
     * @param statusFilter (optional) 
     * @param serviceTitleFilter (optional) 
     * @param branchNameFilter (optional) 
     * @param planBillCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getFamilyServiceVoucherReport(familyId: number | undefined, filter: string | undefined, statusFilter: number | undefined, serviceTitleFilter: string | undefined, branchNameFilter: string | undefined, planBillCodeFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetFamilyServiceVoucherReportDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVouchers/GetFamilyServiceVoucherReport?";
        if (familyId === null)
            throw new Error("The parameter 'familyId' cannot be null.");
        else if (familyId !== undefined)
            url_ += "FamilyId=" + encodeURIComponent("" + familyId) + "&"; 
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (serviceTitleFilter === null)
            throw new Error("The parameter 'serviceTitleFilter' cannot be null.");
        else if (serviceTitleFilter !== undefined)
            url_ += "ServiceTitleFilter=" + encodeURIComponent("" + serviceTitleFilter) + "&"; 
        if (branchNameFilter === null)
            throw new Error("The parameter 'branchNameFilter' cannot be null.");
        else if (branchNameFilter !== undefined)
            url_ += "BranchNameFilter=" + encodeURIComponent("" + branchNameFilter) + "&"; 
        if (planBillCodeFilter === null)
            throw new Error("The parameter 'planBillCodeFilter' cannot be null.");
        else if (planBillCodeFilter !== undefined)
            url_ += "PlanBillCodeFilter=" + encodeURIComponent("" + planBillCodeFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFamilyServiceVoucherReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFamilyServiceVoucherReport(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetFamilyServiceVoucherReportDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetFamilyServiceVoucherReportDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFamilyServiceVoucherReport(response: HttpResponseBase): Observable<PagedResultDtoOfGetFamilyServiceVoucherReportDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetFamilyServiceVoucherReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetFamilyServiceVoucherReportDto>(<any>null);
    }

    /**
     * @param entityRefFilter (optional) 
     * @return Success
     */
    getClientCreditService(entityFilter: Entities, entityRefFilter: number | undefined): Observable<GetClientCreditServiceDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVouchers/GetClientCreditService?";
        if (entityFilter === undefined || entityFilter === null)
            throw new Error("The parameter 'entityFilter' must be defined and cannot be null.");
        else
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (entityRefFilter === null)
            throw new Error("The parameter 'entityRefFilter' cannot be null.");
        else if (entityRefFilter !== undefined)
            url_ += "EntityRefFilter=" + encodeURIComponent("" + entityRefFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientCreditService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientCreditService(<any>response_);
                } catch (e) {
                    return <Observable<GetClientCreditServiceDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetClientCreditServiceDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetClientCreditService(response: HttpResponseBase): Observable<GetClientCreditServiceDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetClientCreditServiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetClientCreditServiceDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllServiceForTableDropdown(): Observable<ServiceVoucherServiceLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVouchers/GetAllServiceForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllServiceForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllServiceForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<ServiceVoucherServiceLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ServiceVoucherServiceLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllServiceForTableDropdown(response: HttpResponseBase): Observable<ServiceVoucherServiceLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceVoucherServiceLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceVoucherServiceLookupTableDto[]>(<any>null);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(<any>response_);
                } catch (e) {
                    return <Observable<GetCurrentLoginInformationsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCurrentLoginInformationsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCurrentLoginInformationsOutput>(<any>null);
    }

    /**
     * @return Success
     */
    updateUserSignInToken(): Observable<UpdateUserSignInTokenOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/UpdateUserSignInToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserSignInToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserSignInToken(<any>response_);
                } catch (e) {
                    return <Observable<UpdateUserSignInTokenOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateUserSignInTokenOutput>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateUserSignInToken(response: HttpResponseBase): Observable<UpdateUserSignInTokenOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateUserSignInTokenOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateUserSignInTokenOutput>(<any>null);
    }
}

@Injectable()
export class SlaughterAgentsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxFromHourFilter (optional) 
     * @param minFromHourFilter (optional) 
     * @param maxToHourFilter (optional) 
     * @param minToHourFilter (optional) 
     * @param statusFilter (optional) 
     * @param slaughterhouseNameFilter (optional) 
     * @param sacrificeTypesFilter (optional) 
     * @param contactFirstNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, maxFromHourFilter: string | undefined, minFromHourFilter: string | undefined, maxToHourFilter: string | undefined, minToHourFilter: string | undefined, statusFilter: number | undefined, slaughterhouseNameFilter: string | undefined, sacrificeTypesFilter: string | undefined, contactFirstNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetSlaughterAgentForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SlaughterAgents/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxFromHourFilter === null)
            throw new Error("The parameter 'maxFromHourFilter' cannot be null.");
        else if (maxFromHourFilter !== undefined)
            url_ += "MaxFromHourFilter=" + encodeURIComponent("" + maxFromHourFilter) + "&"; 
        if (minFromHourFilter === null)
            throw new Error("The parameter 'minFromHourFilter' cannot be null.");
        else if (minFromHourFilter !== undefined)
            url_ += "MinFromHourFilter=" + encodeURIComponent("" + minFromHourFilter) + "&"; 
        if (maxToHourFilter === null)
            throw new Error("The parameter 'maxToHourFilter' cannot be null.");
        else if (maxToHourFilter !== undefined)
            url_ += "MaxToHourFilter=" + encodeURIComponent("" + maxToHourFilter) + "&"; 
        if (minToHourFilter === null)
            throw new Error("The parameter 'minToHourFilter' cannot be null.");
        else if (minToHourFilter !== undefined)
            url_ += "MinToHourFilter=" + encodeURIComponent("" + minToHourFilter) + "&"; 
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (slaughterhouseNameFilter === null)
            throw new Error("The parameter 'slaughterhouseNameFilter' cannot be null.");
        else if (slaughterhouseNameFilter !== undefined)
            url_ += "SlaughterhouseNameFilter=" + encodeURIComponent("" + slaughterhouseNameFilter) + "&"; 
        if (sacrificeTypesFilter === null)
            throw new Error("The parameter 'sacrificeTypesFilter' cannot be null.");
        else if (sacrificeTypesFilter !== undefined)
            url_ += "SacrificeTypesFilter=" + encodeURIComponent("" + sacrificeTypesFilter) + "&"; 
        if (contactFirstNameFilter === null)
            throw new Error("The parameter 'contactFirstNameFilter' cannot be null.");
        else if (contactFirstNameFilter !== undefined)
            url_ += "ContactFirstNameFilter=" + encodeURIComponent("" + contactFirstNameFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSlaughterAgentForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSlaughterAgentForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSlaughterAgentForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetSlaughterAgentForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSlaughterAgentForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSlaughterAgentForView(id: number | undefined): Observable<GetSlaughterAgentForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SlaughterAgents/GetSlaughterAgentForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSlaughterAgentForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSlaughterAgentForView(<any>response_);
                } catch (e) {
                    return <Observable<GetSlaughterAgentForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSlaughterAgentForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSlaughterAgentForView(response: HttpResponseBase): Observable<GetSlaughterAgentForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSlaughterAgentForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSlaughterAgentForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSlaughterAgentForEdit(id: number | undefined): Observable<GetSlaughterAgentForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SlaughterAgents/GetSlaughterAgentForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSlaughterAgentForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSlaughterAgentForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSlaughterAgentForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSlaughterAgentForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSlaughterAgentForEdit(response: HttpResponseBase): Observable<GetSlaughterAgentForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSlaughterAgentForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSlaughterAgentForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditSlaughterAgentDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SlaughterAgents/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param sloughterAgentId (optional) 
     * @return Success
     */
    allowDelete(sloughterAgentId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SlaughterAgents/AllowDelete?";
        if (sloughterAgentId === null)
            throw new Error("The parameter 'sloughterAgentId' cannot be null.");
        else if (sloughterAgentId !== undefined)
            url_ += "sloughterAgentId=" + encodeURIComponent("" + sloughterAgentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAllowDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAllowDelete(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processAllowDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SlaughterAgents/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param maxFromHourFilter (optional) 
     * @param minFromHourFilter (optional) 
     * @param maxToHourFilter (optional) 
     * @param minToHourFilter (optional) 
     * @param statusFilter (optional) 
     * @param slaughterhouseNameFilter (optional) 
     * @param sacrificeTypesFilter (optional) 
     * @param contactFirstNameFilter (optional) 
     * @return Success
     */
    getSlaughterAgentsToExcel(filter: string | undefined, maxFromHourFilter: string | undefined, minFromHourFilter: string | undefined, maxToHourFilter: string | undefined, minToHourFilter: string | undefined, statusFilter: number | undefined, slaughterhouseNameFilter: string | undefined, sacrificeTypesFilter: string | undefined, contactFirstNameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SlaughterAgents/GetSlaughterAgentsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxFromHourFilter === null)
            throw new Error("The parameter 'maxFromHourFilter' cannot be null.");
        else if (maxFromHourFilter !== undefined)
            url_ += "MaxFromHourFilter=" + encodeURIComponent("" + maxFromHourFilter) + "&"; 
        if (minFromHourFilter === null)
            throw new Error("The parameter 'minFromHourFilter' cannot be null.");
        else if (minFromHourFilter !== undefined)
            url_ += "MinFromHourFilter=" + encodeURIComponent("" + minFromHourFilter) + "&"; 
        if (maxToHourFilter === null)
            throw new Error("The parameter 'maxToHourFilter' cannot be null.");
        else if (maxToHourFilter !== undefined)
            url_ += "MaxToHourFilter=" + encodeURIComponent("" + maxToHourFilter) + "&"; 
        if (minToHourFilter === null)
            throw new Error("The parameter 'minToHourFilter' cannot be null.");
        else if (minToHourFilter !== undefined)
            url_ += "MinToHourFilter=" + encodeURIComponent("" + minToHourFilter) + "&"; 
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (slaughterhouseNameFilter === null)
            throw new Error("The parameter 'slaughterhouseNameFilter' cannot be null.");
        else if (slaughterhouseNameFilter !== undefined)
            url_ += "SlaughterhouseNameFilter=" + encodeURIComponent("" + slaughterhouseNameFilter) + "&"; 
        if (sacrificeTypesFilter === null)
            throw new Error("The parameter 'sacrificeTypesFilter' cannot be null.");
        else if (sacrificeTypesFilter !== undefined)
            url_ += "SacrificeTypesFilter=" + encodeURIComponent("" + sacrificeTypesFilter) + "&"; 
        if (contactFirstNameFilter === null)
            throw new Error("The parameter 'contactFirstNameFilter' cannot be null.");
        else if (contactFirstNameFilter !== undefined)
            url_ += "ContactFirstNameFilter=" + encodeURIComponent("" + contactFirstNameFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSlaughterAgentsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSlaughterAgentsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSlaughterAgentsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllContactForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSlaughterAgentContactLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/SlaughterAgents/GetAllContactForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllContactForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllContactForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfSlaughterAgentContactLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfSlaughterAgentContactLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllContactForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSlaughterAgentContactLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSlaughterAgentContactLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfSlaughterAgentContactLookupTableDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllSacrificeTypeForTableDropdown(): Observable<SlaughterAgentSacrificeTypesLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SlaughterAgents/GetAllSacrificeTypeForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSacrificeTypeForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSacrificeTypeForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<SlaughterAgentSacrificeTypesLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SlaughterAgentSacrificeTypesLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSacrificeTypeForTableDropdown(response: HttpResponseBase): Observable<SlaughterAgentSacrificeTypesLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SlaughterAgentSacrificeTypesLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SlaughterAgentSacrificeTypesLookupTableDto[]>(<any>null);
    }
}

@Injectable()
export class SlaughteredsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxWeightFilter (optional) 
     * @param minWeightFilter (optional) 
     * @param maxUnitPriceFilter (optional) 
     * @param minUnitPriceFilter (optional) 
     * @param maxRatioFilter (optional) 
     * @param minRatioFilter (optional) 
     * @param billSlaughteredCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, maxWeightFilter: number | undefined, minWeightFilter: number | undefined, maxUnitPriceFilter: number | undefined, minUnitPriceFilter: number | undefined, maxRatioFilter: number | undefined, minRatioFilter: number | undefined, billSlaughteredCodeFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetSlaughteredForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Slaughtereds/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxWeightFilter === null)
            throw new Error("The parameter 'maxWeightFilter' cannot be null.");
        else if (maxWeightFilter !== undefined)
            url_ += "MaxWeightFilter=" + encodeURIComponent("" + maxWeightFilter) + "&"; 
        if (minWeightFilter === null)
            throw new Error("The parameter 'minWeightFilter' cannot be null.");
        else if (minWeightFilter !== undefined)
            url_ += "MinWeightFilter=" + encodeURIComponent("" + minWeightFilter) + "&"; 
        if (maxUnitPriceFilter === null)
            throw new Error("The parameter 'maxUnitPriceFilter' cannot be null.");
        else if (maxUnitPriceFilter !== undefined)
            url_ += "MaxUnitPriceFilter=" + encodeURIComponent("" + maxUnitPriceFilter) + "&"; 
        if (minUnitPriceFilter === null)
            throw new Error("The parameter 'minUnitPriceFilter' cannot be null.");
        else if (minUnitPriceFilter !== undefined)
            url_ += "MinUnitPriceFilter=" + encodeURIComponent("" + minUnitPriceFilter) + "&"; 
        if (maxRatioFilter === null)
            throw new Error("The parameter 'maxRatioFilter' cannot be null.");
        else if (maxRatioFilter !== undefined)
            url_ += "MaxRatioFilter=" + encodeURIComponent("" + maxRatioFilter) + "&"; 
        if (minRatioFilter === null)
            throw new Error("The parameter 'minRatioFilter' cannot be null.");
        else if (minRatioFilter !== undefined)
            url_ += "MinRatioFilter=" + encodeURIComponent("" + minRatioFilter) + "&"; 
        if (billSlaughteredCodeFilter === null)
            throw new Error("The parameter 'billSlaughteredCodeFilter' cannot be null.");
        else if (billSlaughteredCodeFilter !== undefined)
            url_ += "BillSlaughteredCodeFilter=" + encodeURIComponent("" + billSlaughteredCodeFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSlaughteredForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSlaughteredForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSlaughteredForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetSlaughteredForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSlaughteredForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSlaughteredForView(id: number | undefined): Observable<GetSlaughteredForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Slaughtereds/GetSlaughteredForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSlaughteredForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSlaughteredForView(<any>response_);
                } catch (e) {
                    return <Observable<GetSlaughteredForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSlaughteredForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSlaughteredForView(response: HttpResponseBase): Observable<GetSlaughteredForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSlaughteredForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSlaughteredForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSlaughteredForEdit(id: number | undefined): Observable<GetSlaughteredForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Slaughtereds/GetSlaughteredForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSlaughteredForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSlaughteredForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSlaughteredForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSlaughteredForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSlaughteredForEdit(response: HttpResponseBase): Observable<GetSlaughteredForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSlaughteredForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSlaughteredForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditSlaughteredDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Slaughtereds/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSlaughteredAndBillSlaughtered(body: CreateOrEditSlaughteredDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Slaughtereds/UpdateSlaughteredAndBillSlaughtered";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSlaughteredAndBillSlaughtered(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSlaughteredAndBillSlaughtered(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateSlaughteredAndBillSlaughtered(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSlaughtered(body: CreateOrEditSlaughteredDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Slaughtereds/UpdateSlaughtered";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSlaughtered(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSlaughtered(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateSlaughtered(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSlaughteredAndBill(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Slaughtereds/UpdateSlaughteredAndBill";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSlaughteredAndBill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSlaughteredAndBill(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateSlaughteredAndBill(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getLostBillsSlaughtered(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Slaughtereds/GetLostBillsSlaughtered";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLostBillsSlaughtered(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLostBillsSlaughtered(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetLostBillsSlaughtered(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateBillAndDeleteSlaughtered(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Slaughtereds/UpdateBillAndDeleteSlaughtered";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBillAndDeleteSlaughtered(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBillAndDeleteSlaughtered(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateBillAndDeleteSlaughtered(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createFollowUp(body: CreateOrEditFollowUpDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Slaughtereds/CreateFollowUp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFollowUp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFollowUp(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateFollowUp(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Slaughtereds/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param maxWeightFilter (optional) 
     * @param minWeightFilter (optional) 
     * @param maxUnitPriceFilter (optional) 
     * @param minUnitPriceFilter (optional) 
     * @param maxRatioFilter (optional) 
     * @param minRatioFilter (optional) 
     * @param billSlaughteredCodeFilter (optional) 
     * @return Success
     */
    getSlaughteredsToExcel(filter: string | undefined, maxWeightFilter: number | undefined, minWeightFilter: number | undefined, maxUnitPriceFilter: number | undefined, minUnitPriceFilter: number | undefined, maxRatioFilter: number | undefined, minRatioFilter: number | undefined, billSlaughteredCodeFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Slaughtereds/GetSlaughteredsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxWeightFilter === null)
            throw new Error("The parameter 'maxWeightFilter' cannot be null.");
        else if (maxWeightFilter !== undefined)
            url_ += "MaxWeightFilter=" + encodeURIComponent("" + maxWeightFilter) + "&"; 
        if (minWeightFilter === null)
            throw new Error("The parameter 'minWeightFilter' cannot be null.");
        else if (minWeightFilter !== undefined)
            url_ += "MinWeightFilter=" + encodeURIComponent("" + minWeightFilter) + "&"; 
        if (maxUnitPriceFilter === null)
            throw new Error("The parameter 'maxUnitPriceFilter' cannot be null.");
        else if (maxUnitPriceFilter !== undefined)
            url_ += "MaxUnitPriceFilter=" + encodeURIComponent("" + maxUnitPriceFilter) + "&"; 
        if (minUnitPriceFilter === null)
            throw new Error("The parameter 'minUnitPriceFilter' cannot be null.");
        else if (minUnitPriceFilter !== undefined)
            url_ += "MinUnitPriceFilter=" + encodeURIComponent("" + minUnitPriceFilter) + "&"; 
        if (maxRatioFilter === null)
            throw new Error("The parameter 'maxRatioFilter' cannot be null.");
        else if (maxRatioFilter !== undefined)
            url_ += "MaxRatioFilter=" + encodeURIComponent("" + maxRatioFilter) + "&"; 
        if (minRatioFilter === null)
            throw new Error("The parameter 'minRatioFilter' cannot be null.");
        else if (minRatioFilter !== undefined)
            url_ += "MinRatioFilter=" + encodeURIComponent("" + minRatioFilter) + "&"; 
        if (billSlaughteredCodeFilter === null)
            throw new Error("The parameter 'billSlaughteredCodeFilter' cannot be null.");
        else if (billSlaughteredCodeFilter !== undefined)
            url_ += "BillSlaughteredCodeFilter=" + encodeURIComponent("" + billSlaughteredCodeFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSlaughteredsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSlaughteredsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSlaughteredsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllContactForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSlaughteredContactLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Slaughtereds/GetAllContactForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllContactForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllContactForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfSlaughteredContactLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfSlaughteredContactLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllContactForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSlaughteredContactLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSlaughteredContactLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfSlaughteredContactLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllUserForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSlaughteredUserLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Slaughtereds/GetAllUserForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUserForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfSlaughteredUserLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfSlaughteredUserLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllUserForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSlaughteredUserLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSlaughteredUserLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfSlaughteredUserLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllBillSlaughteredForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSlaughteredBillSlaughteredLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Slaughtereds/GetAllBillSlaughteredForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBillSlaughteredForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBillSlaughteredForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfSlaughteredBillSlaughteredLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfSlaughteredBillSlaughteredLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBillSlaughteredForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSlaughteredBillSlaughteredLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSlaughteredBillSlaughteredLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfSlaughteredBillSlaughteredLookupTableDto>(<any>null);
    }
}

@Injectable()
export class SMSServiceConfigsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param sMSServicesFilter (optional) 
     * @param valueFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, sMSServicesFilter: number | undefined, valueFilter: string | undefined, isActiveFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetSMSServiceConfigForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SMSServiceConfigs/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sMSServicesFilter === null)
            throw new Error("The parameter 'sMSServicesFilter' cannot be null.");
        else if (sMSServicesFilter !== undefined)
            url_ += "SMSServicesFilter=" + encodeURIComponent("" + sMSServicesFilter) + "&"; 
        if (valueFilter === null)
            throw new Error("The parameter 'valueFilter' cannot be null.");
        else if (valueFilter !== undefined)
            url_ += "ValueFilter=" + encodeURIComponent("" + valueFilter) + "&"; 
        if (isActiveFilter === null)
            throw new Error("The parameter 'isActiveFilter' cannot be null.");
        else if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSMSServiceConfigForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSMSServiceConfigForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSMSServiceConfigForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetSMSServiceConfigForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSMSServiceConfigForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSMSServiceConfigForView(id: number | undefined): Observable<GetSMSServiceConfigForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SMSServiceConfigs/GetSMSServiceConfigForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSMSServiceConfigForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSMSServiceConfigForView(<any>response_);
                } catch (e) {
                    return <Observable<GetSMSServiceConfigForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSMSServiceConfigForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSMSServiceConfigForView(response: HttpResponseBase): Observable<GetSMSServiceConfigForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSMSServiceConfigForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSMSServiceConfigForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSMSServiceConfigForEdit(id: number | undefined): Observable<GetSMSServiceConfigForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SMSServiceConfigs/GetSMSServiceConfigForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSMSServiceConfigForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSMSServiceConfigForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSMSServiceConfigForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSMSServiceConfigForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSMSServiceConfigForEdit(response: HttpResponseBase): Observable<GetSMSServiceConfigForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSMSServiceConfigForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSMSServiceConfigForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditSMSServiceConfigDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SMSServiceConfigs/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SMSServiceConfigs/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sMSServicesFilter (optional) 
     * @param valueFilter (optional) 
     * @param isActiveFilter (optional) 
     * @return Success
     */
    getSMSServiceConfigsToExcel(filter: string | undefined, sMSServicesFilter: number | undefined, valueFilter: string | undefined, isActiveFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SMSServiceConfigs/GetSMSServiceConfigsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sMSServicesFilter === null)
            throw new Error("The parameter 'sMSServicesFilter' cannot be null.");
        else if (sMSServicesFilter !== undefined)
            url_ += "SMSServicesFilter=" + encodeURIComponent("" + sMSServicesFilter) + "&"; 
        if (valueFilter === null)
            throw new Error("The parameter 'valueFilter' cannot be null.");
        else if (valueFilter !== undefined)
            url_ += "ValueFilter=" + encodeURIComponent("" + valueFilter) + "&"; 
        if (isActiveFilter === null)
            throw new Error("The parameter 'isActiveFilter' cannot be null.");
        else if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSMSServiceConfigsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSMSServiceConfigsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSMSServiceConfigsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param numberFilter (optional) 
     * @param templateFilter (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllLogs(numberFilter: string | undefined, templateFilter: string | undefined, fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAllLogsDto> {
        let url_ = this.baseUrl + "/api/services/app/SMSServiceConfigs/GetAllLogs?";
        if (numberFilter === null)
            throw new Error("The parameter 'numberFilter' cannot be null.");
        else if (numberFilter !== undefined)
            url_ += "NumberFilter=" + encodeURIComponent("" + numberFilter) + "&"; 
        if (templateFilter === null)
            throw new Error("The parameter 'templateFilter' cannot be null.");
        else if (templateFilter !== undefined)
            url_ += "TemplateFilter=" + encodeURIComponent("" + templateFilter) + "&"; 
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&"; 
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLogs(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAllLogsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAllLogsDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllLogs(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllLogsDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAllLogsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAllLogsDto>(<any>null);
    }
}

@Injectable()
export class SourcesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param accountCodeFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param stateFilter (optional) 
     * @param isDefaultFilter (optional) 
     * @param shortcutKeyFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, nameFilter: string | undefined, accountCodeFilter: string | undefined, descriptionFilter: string | undefined, stateFilter: number | undefined, isDefaultFilter: number | undefined, shortcutKeyFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetSourceForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Sources/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&"; 
        if (accountCodeFilter === null)
            throw new Error("The parameter 'accountCodeFilter' cannot be null.");
        else if (accountCodeFilter !== undefined)
            url_ += "AccountCodeFilter=" + encodeURIComponent("" + accountCodeFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (isDefaultFilter === null)
            throw new Error("The parameter 'isDefaultFilter' cannot be null.");
        else if (isDefaultFilter !== undefined)
            url_ += "IsDefaultFilter=" + encodeURIComponent("" + isDefaultFilter) + "&"; 
        if (shortcutKeyFilter === null)
            throw new Error("The parameter 'shortcutKeyFilter' cannot be null.");
        else if (shortcutKeyFilter !== undefined)
            url_ += "ShortcutKeyFilter=" + encodeURIComponent("" + shortcutKeyFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSourceForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSourceForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSourceForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetSourceForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSourceForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSourceForView(id: number | undefined): Observable<GetSourceForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Sources/GetSourceForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSourceForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSourceForView(<any>response_);
                } catch (e) {
                    return <Observable<GetSourceForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSourceForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSourceForView(response: HttpResponseBase): Observable<GetSourceForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSourceForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSourceForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSourceForEdit(id: number | undefined): Observable<GetSourceForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Sources/GetSourceForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSourceForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSourceForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSourceForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSourceForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSourceForEdit(response: HttpResponseBase): Observable<GetSourceForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSourceForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSourceForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditSourceAndTags(body: CreateOrEditSourceAndTagsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Sources/CreateOrEditSourceAndTags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditSourceAndTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditSourceAndTags(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditSourceAndTags(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Sources/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param accountCodeFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param stateFilter (optional) 
     * @param shortcutKeyFilter (optional) 
     * @return Success
     */
    getSourcesToExcel(filter: string | undefined, nameFilter: string | undefined, accountCodeFilter: string | undefined, descriptionFilter: string | undefined, stateFilter: number | undefined, shortcutKeyFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Sources/GetSourcesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&"; 
        if (accountCodeFilter === null)
            throw new Error("The parameter 'accountCodeFilter' cannot be null.");
        else if (accountCodeFilter !== undefined)
            url_ += "AccountCodeFilter=" + encodeURIComponent("" + accountCodeFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (shortcutKeyFilter === null)
            throw new Error("The parameter 'shortcutKeyFilter' cannot be null.");
        else if (shortcutKeyFilter !== undefined)
            url_ += "ShortcutKeyFilter=" + encodeURIComponent("" + shortcutKeyFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSourcesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSourcesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSourcesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class StatesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param countryIdFilter (optional) 
     * @param isForShopCeremony (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, nameFilter: string | undefined, countryIdFilter: number | undefined, isForShopCeremony: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetStateForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/States/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&"; 
        if (countryIdFilter === null)
            throw new Error("The parameter 'countryIdFilter' cannot be null.");
        else if (countryIdFilter !== undefined)
            url_ += "CountryIdFilter=" + encodeURIComponent("" + countryIdFilter) + "&"; 
        if (isForShopCeremony === null)
            throw new Error("The parameter 'isForShopCeremony' cannot be null.");
        else if (isForShopCeremony !== undefined)
            url_ += "IsForShopCeremony=" + encodeURIComponent("" + isForShopCeremony) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetStateForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetStateForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetStateForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetStateForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetStateForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getStateForView(id: number | undefined): Observable<GetStateForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/States/GetStateForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStateForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStateForView(<any>response_);
                } catch (e) {
                    return <Observable<GetStateForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetStateForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetStateForView(response: HttpResponseBase): Observable<GetStateForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStateForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStateForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getStateForEdit(id: number | undefined): Observable<GetStateForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/States/GetStateForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStateForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStateForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetStateForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetStateForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetStateForEdit(response: HttpResponseBase): Observable<GetStateForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStateForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStateForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditStateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/States/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/States/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param countryIdFilter (optional) 
     * @return Success
     */
    getStatesToExcel(filter: string | undefined, nameFilter: string | undefined, countryIdFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/States/GetStatesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&"; 
        if (countryIdFilter === null)
            throw new Error("The parameter 'countryIdFilter' cannot be null.");
        else if (countryIdFilter !== undefined)
            url_ += "CountryIdFilter=" + encodeURIComponent("" + countryIdFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetStatesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllCountryForTableDropdown(): Observable<StateCountryLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/States/GetAllCountryForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCountryForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCountryForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<StateCountryLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<StateCountryLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCountryForTableDropdown(response: HttpResponseBase): Observable<StateCountryLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StateCountryLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StateCountryLookupTableDto[]>(<any>null);
    }
}

@Injectable()
export class StockHandlingDetailsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxNumberFilter (optional) 
     * @param minNumberFilter (optional) 
     * @param maxRealNumberFilter (optional) 
     * @param minRealNumberFilter (optional) 
     * @param stockHandlingTitleFilter (optional) 
     * @param commodityTitleFilter (optional) 
     * @param stockHandlingRefFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, maxNumberFilter: number | undefined, minNumberFilter: number | undefined, maxRealNumberFilter: number | undefined, minRealNumberFilter: number | undefined, stockHandlingTitleFilter: string | undefined, commodityTitleFilter: string | undefined, stockHandlingRefFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetStockHandlingDetailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/StockHandlingDetails/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxNumberFilter === null)
            throw new Error("The parameter 'maxNumberFilter' cannot be null.");
        else if (maxNumberFilter !== undefined)
            url_ += "MaxNumberFilter=" + encodeURIComponent("" + maxNumberFilter) + "&"; 
        if (minNumberFilter === null)
            throw new Error("The parameter 'minNumberFilter' cannot be null.");
        else if (minNumberFilter !== undefined)
            url_ += "MinNumberFilter=" + encodeURIComponent("" + minNumberFilter) + "&"; 
        if (maxRealNumberFilter === null)
            throw new Error("The parameter 'maxRealNumberFilter' cannot be null.");
        else if (maxRealNumberFilter !== undefined)
            url_ += "MaxRealNumberFilter=" + encodeURIComponent("" + maxRealNumberFilter) + "&"; 
        if (minRealNumberFilter === null)
            throw new Error("The parameter 'minRealNumberFilter' cannot be null.");
        else if (minRealNumberFilter !== undefined)
            url_ += "MinRealNumberFilter=" + encodeURIComponent("" + minRealNumberFilter) + "&"; 
        if (stockHandlingTitleFilter === null)
            throw new Error("The parameter 'stockHandlingTitleFilter' cannot be null.");
        else if (stockHandlingTitleFilter !== undefined)
            url_ += "StockHandlingTitleFilter=" + encodeURIComponent("" + stockHandlingTitleFilter) + "&"; 
        if (commodityTitleFilter === null)
            throw new Error("The parameter 'commodityTitleFilter' cannot be null.");
        else if (commodityTitleFilter !== undefined)
            url_ += "CommodityTitleFilter=" + encodeURIComponent("" + commodityTitleFilter) + "&"; 
        if (stockHandlingRefFilter === null)
            throw new Error("The parameter 'stockHandlingRefFilter' cannot be null.");
        else if (stockHandlingRefFilter !== undefined)
            url_ += "StockHandlingRefFilter=" + encodeURIComponent("" + stockHandlingRefFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetStockHandlingDetailForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetStockHandlingDetailForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetStockHandlingDetailForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetStockHandlingDetailForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetStockHandlingDetailForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getStockHandlingDetailForView(id: number | undefined): Observable<GetStockHandlingDetailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/StockHandlingDetails/GetStockHandlingDetailForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockHandlingDetailForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockHandlingDetailForView(<any>response_);
                } catch (e) {
                    return <Observable<GetStockHandlingDetailForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetStockHandlingDetailForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetStockHandlingDetailForView(response: HttpResponseBase): Observable<GetStockHandlingDetailForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStockHandlingDetailForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStockHandlingDetailForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getStockHandlingDetailForEdit(id: number | undefined): Observable<GetStockHandlingDetailForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/StockHandlingDetails/GetStockHandlingDetailForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockHandlingDetailForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockHandlingDetailForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetStockHandlingDetailForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetStockHandlingDetailForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetStockHandlingDetailForEdit(response: HttpResponseBase): Observable<GetStockHandlingDetailForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStockHandlingDetailForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStockHandlingDetailForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditStockHandlingDetailDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockHandlingDetails/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockHandlingDetails/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param maxNumberFilter (optional) 
     * @param minNumberFilter (optional) 
     * @param maxRealNumberFilter (optional) 
     * @param minRealNumberFilter (optional) 
     * @param stockHandlingTitleFilter (optional) 
     * @param commodityTitleFilter (optional) 
     * @return Success
     */
    getStockHandlingDetailsToExcel(filter: string | undefined, maxNumberFilter: number | undefined, minNumberFilter: number | undefined, maxRealNumberFilter: number | undefined, minRealNumberFilter: number | undefined, stockHandlingTitleFilter: string | undefined, commodityTitleFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/StockHandlingDetails/GetStockHandlingDetailsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxNumberFilter === null)
            throw new Error("The parameter 'maxNumberFilter' cannot be null.");
        else if (maxNumberFilter !== undefined)
            url_ += "MaxNumberFilter=" + encodeURIComponent("" + maxNumberFilter) + "&"; 
        if (minNumberFilter === null)
            throw new Error("The parameter 'minNumberFilter' cannot be null.");
        else if (minNumberFilter !== undefined)
            url_ += "MinNumberFilter=" + encodeURIComponent("" + minNumberFilter) + "&"; 
        if (maxRealNumberFilter === null)
            throw new Error("The parameter 'maxRealNumberFilter' cannot be null.");
        else if (maxRealNumberFilter !== undefined)
            url_ += "MaxRealNumberFilter=" + encodeURIComponent("" + maxRealNumberFilter) + "&"; 
        if (minRealNumberFilter === null)
            throw new Error("The parameter 'minRealNumberFilter' cannot be null.");
        else if (minRealNumberFilter !== undefined)
            url_ += "MinRealNumberFilter=" + encodeURIComponent("" + minRealNumberFilter) + "&"; 
        if (stockHandlingTitleFilter === null)
            throw new Error("The parameter 'stockHandlingTitleFilter' cannot be null.");
        else if (stockHandlingTitleFilter !== undefined)
            url_ += "StockHandlingTitleFilter=" + encodeURIComponent("" + stockHandlingTitleFilter) + "&"; 
        if (commodityTitleFilter === null)
            throw new Error("The parameter 'commodityTitleFilter' cannot be null.");
        else if (commodityTitleFilter !== undefined)
            url_ += "CommodityTitleFilter=" + encodeURIComponent("" + commodityTitleFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockHandlingDetailsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockHandlingDetailsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetStockHandlingDetailsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllStockHandlingForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfStockHandlingDetailStockHandlingLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/StockHandlingDetails/GetAllStockHandlingForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStockHandlingForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStockHandlingForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfStockHandlingDetailStockHandlingLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfStockHandlingDetailStockHandlingLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllStockHandlingForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfStockHandlingDetailStockHandlingLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfStockHandlingDetailStockHandlingLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfStockHandlingDetailStockHandlingLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCommodityForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfStockHandlingDetailCommodityLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/StockHandlingDetails/GetAllCommodityForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCommodityForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCommodityForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfStockHandlingDetailCommodityLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfStockHandlingDetailCommodityLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCommodityForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfStockHandlingDetailCommodityLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfStockHandlingDetailCommodityLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfStockHandlingDetailCommodityLookupTableDto>(<any>null);
    }
}

@Injectable()
export class StockHandlingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxStartDateFilter (optional) 
     * @param minStartDateFilter (optional) 
     * @param maxEndDateFilter (optional) 
     * @param minEndDateFilter (optional) 
     * @param statusFilter (optional) 
     * @param titleFilter (optional) 
     * @param contactFirstNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, maxStartDateFilter: moment.Moment | undefined, minStartDateFilter: moment.Moment | undefined, maxEndDateFilter: moment.Moment | undefined, minEndDateFilter: moment.Moment | undefined, statusFilter: number | undefined, titleFilter: string | undefined, contactFirstNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetStockHandlingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/StockHandlings/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxStartDateFilter === null)
            throw new Error("The parameter 'maxStartDateFilter' cannot be null.");
        else if (maxStartDateFilter !== undefined)
            url_ += "MaxStartDateFilter=" + encodeURIComponent(maxStartDateFilter ? "" + maxStartDateFilter.toJSON() : "") + "&"; 
        if (minStartDateFilter === null)
            throw new Error("The parameter 'minStartDateFilter' cannot be null.");
        else if (minStartDateFilter !== undefined)
            url_ += "MinStartDateFilter=" + encodeURIComponent(minStartDateFilter ? "" + minStartDateFilter.toJSON() : "") + "&"; 
        if (maxEndDateFilter === null)
            throw new Error("The parameter 'maxEndDateFilter' cannot be null.");
        else if (maxEndDateFilter !== undefined)
            url_ += "MaxEndDateFilter=" + encodeURIComponent(maxEndDateFilter ? "" + maxEndDateFilter.toJSON() : "") + "&"; 
        if (minEndDateFilter === null)
            throw new Error("The parameter 'minEndDateFilter' cannot be null.");
        else if (minEndDateFilter !== undefined)
            url_ += "MinEndDateFilter=" + encodeURIComponent(minEndDateFilter ? "" + minEndDateFilter.toJSON() : "") + "&"; 
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (contactFirstNameFilter === null)
            throw new Error("The parameter 'contactFirstNameFilter' cannot be null.");
        else if (contactFirstNameFilter !== undefined)
            url_ += "ContactFirstNameFilter=" + encodeURIComponent("" + contactFirstNameFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetStockHandlingForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetStockHandlingForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetStockHandlingForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetStockHandlingForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetStockHandlingForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getStockHandlingForView(id: number | undefined): Observable<GetStockHandlingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/StockHandlings/GetStockHandlingForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockHandlingForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockHandlingForView(<any>response_);
                } catch (e) {
                    return <Observable<GetStockHandlingForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetStockHandlingForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetStockHandlingForView(response: HttpResponseBase): Observable<GetStockHandlingForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStockHandlingForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStockHandlingForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getStockHandlingForEdit(id: number | undefined): Observable<GetStockHandlingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/StockHandlings/GetStockHandlingForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockHandlingForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockHandlingForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetStockHandlingForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetStockHandlingForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetStockHandlingForEdit(response: HttpResponseBase): Observable<GetStockHandlingForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStockHandlingForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStockHandlingForEditOutput>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getStockHandlingAndDetailsForEdit(id: number | undefined): Observable<GetStockHandlingAndDetailsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/StockHandlings/GetStockHandlingAndDetailsForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockHandlingAndDetailsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockHandlingAndDetailsForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetStockHandlingAndDetailsForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetStockHandlingAndDetailsForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetStockHandlingAndDetailsForEdit(response: HttpResponseBase): Observable<GetStockHandlingAndDetailsForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStockHandlingAndDetailsForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStockHandlingAndDetailsForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditStockHandlingDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockHandlings/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditStockHandlingAndDetails(body: CreateOrEditStockHandlingAndDetailsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockHandlings/CreateOrEditStockHandlingAndDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditStockHandlingAndDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditStockHandlingAndDetails(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditStockHandlingAndDetails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockHandlings/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param maxStartDateFilter (optional) 
     * @param minStartDateFilter (optional) 
     * @param maxEndDateFilter (optional) 
     * @param minEndDateFilter (optional) 
     * @param statusFilter (optional) 
     * @param titleFilter (optional) 
     * @param contactFirstNameFilter (optional) 
     * @return Success
     */
    getStockHandlingsToExcel(filter: string | undefined, maxStartDateFilter: moment.Moment | undefined, minStartDateFilter: moment.Moment | undefined, maxEndDateFilter: moment.Moment | undefined, minEndDateFilter: moment.Moment | undefined, statusFilter: number | undefined, titleFilter: string | undefined, contactFirstNameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/StockHandlings/GetStockHandlingsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxStartDateFilter === null)
            throw new Error("The parameter 'maxStartDateFilter' cannot be null.");
        else if (maxStartDateFilter !== undefined)
            url_ += "MaxStartDateFilter=" + encodeURIComponent(maxStartDateFilter ? "" + maxStartDateFilter.toJSON() : "") + "&"; 
        if (minStartDateFilter === null)
            throw new Error("The parameter 'minStartDateFilter' cannot be null.");
        else if (minStartDateFilter !== undefined)
            url_ += "MinStartDateFilter=" + encodeURIComponent(minStartDateFilter ? "" + minStartDateFilter.toJSON() : "") + "&"; 
        if (maxEndDateFilter === null)
            throw new Error("The parameter 'maxEndDateFilter' cannot be null.");
        else if (maxEndDateFilter !== undefined)
            url_ += "MaxEndDateFilter=" + encodeURIComponent(maxEndDateFilter ? "" + maxEndDateFilter.toJSON() : "") + "&"; 
        if (minEndDateFilter === null)
            throw new Error("The parameter 'minEndDateFilter' cannot be null.");
        else if (minEndDateFilter !== undefined)
            url_ += "MinEndDateFilter=" + encodeURIComponent(minEndDateFilter ? "" + minEndDateFilter.toJSON() : "") + "&"; 
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (contactFirstNameFilter === null)
            throw new Error("The parameter 'contactFirstNameFilter' cannot be null.");
        else if (contactFirstNameFilter !== undefined)
            url_ += "ContactFirstNameFilter=" + encodeURIComponent("" + contactFirstNameFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockHandlingsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockHandlingsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetStockHandlingsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllContactForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfStockHandlingContactLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/StockHandlings/GetAllContactForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllContactForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllContactForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfStockHandlingContactLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfStockHandlingContactLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllContactForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfStockHandlingContactLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfStockHandlingContactLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfStockHandlingContactLookupTableDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllFinancialYearForLookupTable(): Observable<StockHandlingFinancialYearLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StockHandlings/GetAllFinancialYearForLookupTable";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFinancialYearForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFinancialYearForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<StockHandlingFinancialYearLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<StockHandlingFinancialYearLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllFinancialYearForLookupTable(response: HttpResponseBase): Observable<StockHandlingFinancialYearLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockHandlingFinancialYearLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockHandlingFinancialYearLookupTableDto[]>(<any>null);
    }
}

@Injectable()
export class StockTransactionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param formCodeFilter (optional) 
     * @param maxFormDateFilter (optional) 
     * @param minFormDateFilter (optional) 
     * @param identityCodeFilter (optional) 
     * @param fileCodeFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param accountCodeFilter (optional) 
     * @param branchNameFilter (optional) 
     * @param contactFirstNameFilter (optional) 
     * @param contactFirstName2Filter (optional) 
     * @param contactFirstName3Filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, formCodeFilter: string | undefined, maxFormDateFilter: moment.Moment | undefined, minFormDateFilter: moment.Moment | undefined, identityCodeFilter: string | undefined, fileCodeFilter: string | undefined, descriptionFilter: string | undefined, accountCodeFilter: string | undefined, branchNameFilter: string | undefined, contactFirstNameFilter: string | undefined, contactFirstName2Filter: string | undefined, contactFirstName3Filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetStockTransactionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/StockTransactions/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (formCodeFilter === null)
            throw new Error("The parameter 'formCodeFilter' cannot be null.");
        else if (formCodeFilter !== undefined)
            url_ += "FormCodeFilter=" + encodeURIComponent("" + formCodeFilter) + "&"; 
        if (maxFormDateFilter === null)
            throw new Error("The parameter 'maxFormDateFilter' cannot be null.");
        else if (maxFormDateFilter !== undefined)
            url_ += "MaxFormDateFilter=" + encodeURIComponent(maxFormDateFilter ? "" + maxFormDateFilter.toJSON() : "") + "&"; 
        if (minFormDateFilter === null)
            throw new Error("The parameter 'minFormDateFilter' cannot be null.");
        else if (minFormDateFilter !== undefined)
            url_ += "MinFormDateFilter=" + encodeURIComponent(minFormDateFilter ? "" + minFormDateFilter.toJSON() : "") + "&"; 
        if (identityCodeFilter === null)
            throw new Error("The parameter 'identityCodeFilter' cannot be null.");
        else if (identityCodeFilter !== undefined)
            url_ += "IdentityCodeFilter=" + encodeURIComponent("" + identityCodeFilter) + "&"; 
        if (fileCodeFilter === null)
            throw new Error("The parameter 'fileCodeFilter' cannot be null.");
        else if (fileCodeFilter !== undefined)
            url_ += "FileCodeFilter=" + encodeURIComponent("" + fileCodeFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (accountCodeFilter === null)
            throw new Error("The parameter 'accountCodeFilter' cannot be null.");
        else if (accountCodeFilter !== undefined)
            url_ += "AccountCodeFilter=" + encodeURIComponent("" + accountCodeFilter) + "&"; 
        if (branchNameFilter === null)
            throw new Error("The parameter 'branchNameFilter' cannot be null.");
        else if (branchNameFilter !== undefined)
            url_ += "BranchNameFilter=" + encodeURIComponent("" + branchNameFilter) + "&"; 
        if (contactFirstNameFilter === null)
            throw new Error("The parameter 'contactFirstNameFilter' cannot be null.");
        else if (contactFirstNameFilter !== undefined)
            url_ += "ContactFirstNameFilter=" + encodeURIComponent("" + contactFirstNameFilter) + "&"; 
        if (contactFirstName2Filter === null)
            throw new Error("The parameter 'contactFirstName2Filter' cannot be null.");
        else if (contactFirstName2Filter !== undefined)
            url_ += "ContactFirstName2Filter=" + encodeURIComponent("" + contactFirstName2Filter) + "&"; 
        if (contactFirstName3Filter === null)
            throw new Error("The parameter 'contactFirstName3Filter' cannot be null.");
        else if (contactFirstName3Filter !== undefined)
            url_ += "ContactFirstName3Filter=" + encodeURIComponent("" + contactFirstName3Filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetStockTransactionForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetStockTransactionForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetStockTransactionForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetStockTransactionForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetStockTransactionForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getStockTransactionForView(id: number | undefined): Observable<GetStockTransactionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/StockTransactions/GetStockTransactionForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockTransactionForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockTransactionForView(<any>response_);
                } catch (e) {
                    return <Observable<GetStockTransactionForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetStockTransactionForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetStockTransactionForView(response: HttpResponseBase): Observable<GetStockTransactionForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStockTransactionForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStockTransactionForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getStockTransactionForEdit(id: number | undefined): Observable<GetStockTransactionForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/StockTransactions/GetStockTransactionForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockTransactionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockTransactionForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetStockTransactionForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetStockTransactionForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetStockTransactionForEdit(response: HttpResponseBase): Observable<GetStockTransactionForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStockTransactionForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStockTransactionForEditOutput>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getStockTransactionAndTransactionDetailsForEdit(id: number | undefined): Observable<GetStockTransactionAndTransactionDetailsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/StockTransactions/GetStockTransactionAndTransactionDetailsForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockTransactionAndTransactionDetailsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockTransactionAndTransactionDetailsForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetStockTransactionAndTransactionDetailsForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetStockTransactionAndTransactionDetailsForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetStockTransactionAndTransactionDetailsForEdit(response: HttpResponseBase): Observable<GetStockTransactionAndTransactionDetailsForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStockTransactionAndTransactionDetailsForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStockTransactionAndTransactionDetailsForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditStockTransactionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockTransactions/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditStockTransactionAndTransactionDetails(body: CreateOrEditStockTransactionAndTransactionDetailsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockTransactions/CreateOrEditStockTransactionAndTransactionDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditStockTransactionAndTransactionDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditStockTransactionAndTransactionDetails(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditStockTransactionAndTransactionDetails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditStockTransactionAndTransactionDetailsForClient(body: CreateOrEditStockTransactionAndTransactionDetailsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockTransactions/CreateOrEditStockTransactionAndTransactionDetailsForClient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditStockTransactionAndTransactionDetailsForClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditStockTransactionAndTransactionDetailsForClient(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditStockTransactionAndTransactionDetailsForClient(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StockTransactions/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param formCodeFilter (optional) 
     * @param maxFormDateFilter (optional) 
     * @param minFormDateFilter (optional) 
     * @param identityCodeFilter (optional) 
     * @param fileCodeFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param accountCodeFilter (optional) 
     * @param branchNameFilter (optional) 
     * @param contactFirstNameFilter (optional) 
     * @param contactFirstName2Filter (optional) 
     * @param contactFirstName3Filter (optional) 
     * @return Success
     */
    getStockTransactionsToExcel(filter: string | undefined, formCodeFilter: string | undefined, maxFormDateFilter: moment.Moment | undefined, minFormDateFilter: moment.Moment | undefined, identityCodeFilter: string | undefined, fileCodeFilter: string | undefined, descriptionFilter: string | undefined, accountCodeFilter: string | undefined, branchNameFilter: string | undefined, contactFirstNameFilter: string | undefined, contactFirstName2Filter: string | undefined, contactFirstName3Filter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/StockTransactions/GetStockTransactionsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (formCodeFilter === null)
            throw new Error("The parameter 'formCodeFilter' cannot be null.");
        else if (formCodeFilter !== undefined)
            url_ += "FormCodeFilter=" + encodeURIComponent("" + formCodeFilter) + "&"; 
        if (maxFormDateFilter === null)
            throw new Error("The parameter 'maxFormDateFilter' cannot be null.");
        else if (maxFormDateFilter !== undefined)
            url_ += "MaxFormDateFilter=" + encodeURIComponent(maxFormDateFilter ? "" + maxFormDateFilter.toJSON() : "") + "&"; 
        if (minFormDateFilter === null)
            throw new Error("The parameter 'minFormDateFilter' cannot be null.");
        else if (minFormDateFilter !== undefined)
            url_ += "MinFormDateFilter=" + encodeURIComponent(minFormDateFilter ? "" + minFormDateFilter.toJSON() : "") + "&"; 
        if (identityCodeFilter === null)
            throw new Error("The parameter 'identityCodeFilter' cannot be null.");
        else if (identityCodeFilter !== undefined)
            url_ += "IdentityCodeFilter=" + encodeURIComponent("" + identityCodeFilter) + "&"; 
        if (fileCodeFilter === null)
            throw new Error("The parameter 'fileCodeFilter' cannot be null.");
        else if (fileCodeFilter !== undefined)
            url_ += "FileCodeFilter=" + encodeURIComponent("" + fileCodeFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (accountCodeFilter === null)
            throw new Error("The parameter 'accountCodeFilter' cannot be null.");
        else if (accountCodeFilter !== undefined)
            url_ += "AccountCodeFilter=" + encodeURIComponent("" + accountCodeFilter) + "&"; 
        if (branchNameFilter === null)
            throw new Error("The parameter 'branchNameFilter' cannot be null.");
        else if (branchNameFilter !== undefined)
            url_ += "BranchNameFilter=" + encodeURIComponent("" + branchNameFilter) + "&"; 
        if (contactFirstNameFilter === null)
            throw new Error("The parameter 'contactFirstNameFilter' cannot be null.");
        else if (contactFirstNameFilter !== undefined)
            url_ += "ContactFirstNameFilter=" + encodeURIComponent("" + contactFirstNameFilter) + "&"; 
        if (contactFirstName2Filter === null)
            throw new Error("The parameter 'contactFirstName2Filter' cannot be null.");
        else if (contactFirstName2Filter !== undefined)
            url_ += "ContactFirstName2Filter=" + encodeURIComponent("" + contactFirstName2Filter) + "&"; 
        if (contactFirstName3Filter === null)
            throw new Error("The parameter 'contactFirstName3Filter' cannot be null.");
        else if (contactFirstName3Filter !== undefined)
            url_ += "ContactFirstName3Filter=" + encodeURIComponent("" + contactFirstName3Filter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockTransactionsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockTransactionsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetStockTransactionsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllBranchForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfStockTransactionBranchLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/StockTransactions/GetAllBranchForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBranchForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBranchForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfStockTransactionBranchLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfStockTransactionBranchLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBranchForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfStockTransactionBranchLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfStockTransactionBranchLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfStockTransactionBranchLookupTableDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllBranchForForTableDropdown(): Observable<StockTransactionBranchLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTransactions/GetAllBranchForForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBranchForForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBranchForForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<StockTransactionBranchLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<StockTransactionBranchLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBranchForForTableDropdown(response: HttpResponseBase): Observable<StockTransactionBranchLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockTransactionBranchLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockTransactionBranchLookupTableDto[]>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllContactForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfStockTransactionContactLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/StockTransactions/GetAllContactForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllContactForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllContactForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfStockTransactionContactLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfStockTransactionContactLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllContactForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfStockTransactionContactLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfStockTransactionContactLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfStockTransactionContactLookupTableDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllTransactionTypeForForTableDropdown(): Observable<StockTransactionTransactionTypeLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StockTransactions/GetAllTransactionTypeForForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTransactionTypeForForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTransactionTypeForForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<StockTransactionTransactionTypeLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<StockTransactionTransactionTypeLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllTransactionTypeForForTableDropdown(response: HttpResponseBase): Observable<StockTransactionTransactionTypeLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockTransactionTransactionTypeLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockTransactionTransactionTypeLookupTableDto[]>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllFamilyForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfStockTransactionFamilyLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/StockTransactions/GetAllFamilyForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFamilyForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFamilyForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfStockTransactionFamilyLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfStockTransactionFamilyLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllFamilyForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfStockTransactionFamilyLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfStockTransactionFamilyLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfStockTransactionFamilyLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param familyRefFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllMemberContactForLookupTable(filter: string | undefined, familyRefFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfStockTransactionMemberContactLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/StockTransactions/GetAllMemberContactForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (familyRefFilter === null)
            throw new Error("The parameter 'familyRefFilter' cannot be null.");
        else if (familyRefFilter !== undefined)
            url_ += "FamilyRefFilter=" + encodeURIComponent("" + familyRefFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMemberContactForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMemberContactForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfStockTransactionMemberContactLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfStockTransactionMemberContactLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllMemberContactForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfStockTransactionMemberContactLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfStockTransactionMemberContactLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfStockTransactionMemberContactLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param familyRefFilter (optional) 
     * @param formCodeFilter (optional) 
     * @param maxFormDateFilter (optional) 
     * @param minFormDateFilter (optional) 
     * @param identityCodeFilter (optional) 
     * @param fileCodeFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param accountCodeFilter (optional) 
     * @param branchNameFilter (optional) 
     * @param contactFirstNameFilter (optional) 
     * @param contactFirstName2Filter (optional) 
     * @param contactFirstName3Filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllFamilyStockTransactionsReport(filter: string | undefined, familyRefFilter: number | undefined, formCodeFilter: string | undefined, maxFormDateFilter: moment.Moment | undefined, minFormDateFilter: moment.Moment | undefined, identityCodeFilter: string | undefined, fileCodeFilter: string | undefined, descriptionFilter: string | undefined, accountCodeFilter: string | undefined, branchNameFilter: string | undefined, contactFirstNameFilter: string | undefined, contactFirstName2Filter: string | undefined, contactFirstName3Filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetStockTransactionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/StockTransactions/GetAllFamilyStockTransactionsReport?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (familyRefFilter === null)
            throw new Error("The parameter 'familyRefFilter' cannot be null.");
        else if (familyRefFilter !== undefined)
            url_ += "FamilyRefFilter=" + encodeURIComponent("" + familyRefFilter) + "&"; 
        if (formCodeFilter === null)
            throw new Error("The parameter 'formCodeFilter' cannot be null.");
        else if (formCodeFilter !== undefined)
            url_ += "FormCodeFilter=" + encodeURIComponent("" + formCodeFilter) + "&"; 
        if (maxFormDateFilter === null)
            throw new Error("The parameter 'maxFormDateFilter' cannot be null.");
        else if (maxFormDateFilter !== undefined)
            url_ += "MaxFormDateFilter=" + encodeURIComponent(maxFormDateFilter ? "" + maxFormDateFilter.toJSON() : "") + "&"; 
        if (minFormDateFilter === null)
            throw new Error("The parameter 'minFormDateFilter' cannot be null.");
        else if (minFormDateFilter !== undefined)
            url_ += "MinFormDateFilter=" + encodeURIComponent(minFormDateFilter ? "" + minFormDateFilter.toJSON() : "") + "&"; 
        if (identityCodeFilter === null)
            throw new Error("The parameter 'identityCodeFilter' cannot be null.");
        else if (identityCodeFilter !== undefined)
            url_ += "IdentityCodeFilter=" + encodeURIComponent("" + identityCodeFilter) + "&"; 
        if (fileCodeFilter === null)
            throw new Error("The parameter 'fileCodeFilter' cannot be null.");
        else if (fileCodeFilter !== undefined)
            url_ += "FileCodeFilter=" + encodeURIComponent("" + fileCodeFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (accountCodeFilter === null)
            throw new Error("The parameter 'accountCodeFilter' cannot be null.");
        else if (accountCodeFilter !== undefined)
            url_ += "AccountCodeFilter=" + encodeURIComponent("" + accountCodeFilter) + "&"; 
        if (branchNameFilter === null)
            throw new Error("The parameter 'branchNameFilter' cannot be null.");
        else if (branchNameFilter !== undefined)
            url_ += "BranchNameFilter=" + encodeURIComponent("" + branchNameFilter) + "&"; 
        if (contactFirstNameFilter === null)
            throw new Error("The parameter 'contactFirstNameFilter' cannot be null.");
        else if (contactFirstNameFilter !== undefined)
            url_ += "ContactFirstNameFilter=" + encodeURIComponent("" + contactFirstNameFilter) + "&"; 
        if (contactFirstName2Filter === null)
            throw new Error("The parameter 'contactFirstName2Filter' cannot be null.");
        else if (contactFirstName2Filter !== undefined)
            url_ += "ContactFirstName2Filter=" + encodeURIComponent("" + contactFirstName2Filter) + "&"; 
        if (contactFirstName3Filter === null)
            throw new Error("The parameter 'contactFirstName3Filter' cannot be null.");
        else if (contactFirstName3Filter !== undefined)
            url_ += "ContactFirstName3Filter=" + encodeURIComponent("" + contactFirstName3Filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFamilyStockTransactionsReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFamilyStockTransactionsReport(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetStockTransactionForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetStockTransactionForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllFamilyStockTransactionsReport(response: HttpResponseBase): Observable<PagedResultDtoOfGetStockTransactionForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetStockTransactionForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetStockTransactionForViewDto>(<any>null);
    }
}

@Injectable()
export class StripePaymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getConfiguration(): Observable<StripeConfigurationDto> {
        let url_ = this.baseUrl + "/api/services/app/StripePayment/GetConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfiguration(<any>response_);
                } catch (e) {
                    return <Observable<StripeConfigurationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StripeConfigurationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetConfiguration(response: HttpResponseBase): Observable<StripeConfigurationDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StripeConfigurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StripeConfigurationDto>(<any>null);
    }

    /**
     * @param stripeSessionId (optional) 
     * @return Success
     */
    getPayment(stripeSessionId: string | undefined): Observable<SubscriptionPaymentDto> {
        let url_ = this.baseUrl + "/api/services/app/StripePayment/GetPayment?";
        if (stripeSessionId === null)
            throw new Error("The parameter 'stripeSessionId' cannot be null.");
        else if (stripeSessionId !== undefined)
            url_ += "StripeSessionId=" + encodeURIComponent("" + stripeSessionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayment(<any>response_);
                } catch (e) {
                    return <Observable<SubscriptionPaymentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubscriptionPaymentDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPayment(response: HttpResponseBase): Observable<SubscriptionPaymentDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionPaymentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubscriptionPaymentDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPaymentSession(body: StripeCreatePaymentSessionInput | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/StripePayment/CreatePaymentSession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePaymentSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePaymentSession(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processCreatePaymentSession(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param paymentId (optional) 
     * @return Success
     */
    getPaymentResult(paymentId: number | undefined): Observable<StripePaymentResultOutput> {
        let url_ = this.baseUrl + "/api/services/app/StripePayment/GetPaymentResult?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "PaymentId=" + encodeURIComponent("" + paymentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentResult(<any>response_);
                } catch (e) {
                    return <Observable<StripePaymentResultOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<StripePaymentResultOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentResult(response: HttpResponseBase): Observable<StripePaymentResultOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StripePaymentResultOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StripePaymentResultOutput>(<any>null);
    }
}

@Injectable()
export class SubscriptionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    disableRecurringPayments(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/DisableRecurringPayments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableRecurringPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableRecurringPayments(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDisableRecurringPayments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    enableRecurringPayments(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/EnableRecurringPayments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnableRecurringPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnableRecurringPayments(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processEnableRecurringPayments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class SupportiveOrganizationsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, nameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetSupportiveOrganizationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SupportiveOrganizations/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSupportiveOrganizationForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSupportiveOrganizationForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSupportiveOrganizationForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetSupportiveOrganizationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSupportiveOrganizationForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSupportiveOrganizationForView(id: number | undefined): Observable<GetSupportiveOrganizationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SupportiveOrganizations/GetSupportiveOrganizationForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupportiveOrganizationForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupportiveOrganizationForView(<any>response_);
                } catch (e) {
                    return <Observable<GetSupportiveOrganizationForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSupportiveOrganizationForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSupportiveOrganizationForView(response: HttpResponseBase): Observable<GetSupportiveOrganizationForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSupportiveOrganizationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSupportiveOrganizationForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSupportiveOrganizationForEdit(id: number | undefined): Observable<GetSupportiveOrganizationForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SupportiveOrganizations/GetSupportiveOrganizationForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupportiveOrganizationForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupportiveOrganizationForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSupportiveOrganizationForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSupportiveOrganizationForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSupportiveOrganizationForEdit(response: HttpResponseBase): Observable<GetSupportiveOrganizationForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSupportiveOrganizationForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSupportiveOrganizationForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditSupportiveOrganizationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SupportiveOrganizations/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SupportiveOrganizations/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @return Success
     */
    getSupportiveOrganizationsToExcel(filter: string | undefined, nameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/SupportiveOrganizations/GetSupportiveOrganizationsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupportiveOrganizationsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupportiveOrganizationsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSupportiveOrganizationsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class TagsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param entityNameFilter (optional) 
     * @param entityRefFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, titleFilter: string | undefined, entityNameFilter: number | undefined, entityRefFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetTagForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Tags/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (entityNameFilter === null)
            throw new Error("The parameter 'entityNameFilter' cannot be null.");
        else if (entityNameFilter !== undefined)
            url_ += "EntityNameFilter=" + encodeURIComponent("" + entityNameFilter) + "&"; 
        if (entityRefFilter === null)
            throw new Error("The parameter 'entityRefFilter' cannot be null.");
        else if (entityRefFilter !== undefined)
            url_ += "EntityRefFilter=" + encodeURIComponent("" + entityRefFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTagForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTagForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTagForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTagForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTagForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTagForView(id: number | undefined): Observable<GetTagForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Tags/GetTagForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTagForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTagForView(<any>response_);
                } catch (e) {
                    return <Observable<GetTagForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTagForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTagForView(response: HttpResponseBase): Observable<GetTagForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTagForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTagForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTagForEdit(id: number | undefined): Observable<GetTagForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Tags/GetTagForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTagForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTagForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetTagForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTagForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetTagForEdit(response: HttpResponseBase): Observable<GetTagForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTagForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTagForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditTagDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tags/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tags/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param entityNameFilter (optional) 
     * @return Success
     */
    getTagsToExcel(filter: string | undefined, titleFilter: string | undefined, entityNameFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Tags/GetTagsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (entityNameFilter === null)
            throw new Error("The parameter 'entityNameFilter' cannot be null.");
        else if (entityNameFilter !== undefined)
            url_ += "EntityNameFilter=" + encodeURIComponent("" + entityNameFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTagsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTagsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTagsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class TemplateDatasServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param promotesFilter (optional) 
     * @param specialOffersFilter (optional) 
     * @param partnersFilter (optional) 
     * @param themTemplateCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, promotesFilter: string | undefined, specialOffersFilter: string | undefined, partnersFilter: string | undefined, themTemplateCodeFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetTemplateDataForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TemplateDatas/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (promotesFilter === null)
            throw new Error("The parameter 'promotesFilter' cannot be null.");
        else if (promotesFilter !== undefined)
            url_ += "PromotesFilter=" + encodeURIComponent("" + promotesFilter) + "&"; 
        if (specialOffersFilter === null)
            throw new Error("The parameter 'specialOffersFilter' cannot be null.");
        else if (specialOffersFilter !== undefined)
            url_ += "SpecialOffersFilter=" + encodeURIComponent("" + specialOffersFilter) + "&"; 
        if (partnersFilter === null)
            throw new Error("The parameter 'partnersFilter' cannot be null.");
        else if (partnersFilter !== undefined)
            url_ += "PartnersFilter=" + encodeURIComponent("" + partnersFilter) + "&"; 
        if (themTemplateCodeFilter === null)
            throw new Error("The parameter 'themTemplateCodeFilter' cannot be null.");
        else if (themTemplateCodeFilter !== undefined)
            url_ += "ThemTemplateCodeFilter=" + encodeURIComponent("" + themTemplateCodeFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTemplateDataForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTemplateDataForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTemplateDataForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTemplateDataForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTemplateDataForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTemplateDataForView(id: number | undefined): Observable<GetTemplateDataForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TemplateDatas/GetTemplateDataForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTemplateDataForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemplateDataForView(<any>response_);
                } catch (e) {
                    return <Observable<GetTemplateDataForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTemplateDataForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTemplateDataForView(response: HttpResponseBase): Observable<GetTemplateDataForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTemplateDataForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTemplateDataForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTemplateDataForEdit(id: number | undefined): Observable<GetTemplateDataForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TemplateDatas/GetTemplateDataForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTemplateDataForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemplateDataForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetTemplateDataForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTemplateDataForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetTemplateDataForEdit(response: HttpResponseBase): Observable<GetTemplateDataForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTemplateDataForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTemplateDataForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditTemplateDataDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TemplateDatas/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditTemplateDataInfo(body: CreateOrEditTemplateDataInfoAndBannerDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TemplateDatas/CreateOrEditTemplateDataInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditTemplateDataInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditTemplateDataInfo(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditTemplateDataInfo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param themeTemplateId (optional) 
     * @return Success
     */
    getTemplateDataInfoForView(themeTemplateId: number | undefined): Observable<GetTemplateDataInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TemplateDatas/GetTemplateDataInfoForView?";
        if (themeTemplateId === null)
            throw new Error("The parameter 'themeTemplateId' cannot be null.");
        else if (themeTemplateId !== undefined)
            url_ += "themeTemplateId=" + encodeURIComponent("" + themeTemplateId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTemplateDataInfoForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemplateDataInfoForView(<any>response_);
                } catch (e) {
                    return <Observable<GetTemplateDataInfoForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTemplateDataInfoForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTemplateDataInfoForView(response: HttpResponseBase): Observable<GetTemplateDataInfoForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTemplateDataInfoForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTemplateDataInfoForViewDto>(<any>null);
    }

    /**
     * @return Success
     */
    getTemplateDataForShop(): Observable<GetTemplateDataForShopDto> {
        let url_ = this.baseUrl + "/api/services/app/TemplateDatas/GetTemplateDataForShop";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTemplateDataForShop(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemplateDataForShop(<any>response_);
                } catch (e) {
                    return <Observable<GetTemplateDataForShopDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTemplateDataForShopDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTemplateDataForShop(response: HttpResponseBase): Observable<GetTemplateDataForShopDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTemplateDataForShopDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTemplateDataForShopDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TemplateDatas/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param promotesFilter (optional) 
     * @param specialOffersFilter (optional) 
     * @param partnersFilter (optional) 
     * @param themTemplateCodeFilter (optional) 
     * @return Success
     */
    getTemplateDatasToExcel(filter: string | undefined, promotesFilter: string | undefined, specialOffersFilter: string | undefined, partnersFilter: string | undefined, themTemplateCodeFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/TemplateDatas/GetTemplateDatasToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (promotesFilter === null)
            throw new Error("The parameter 'promotesFilter' cannot be null.");
        else if (promotesFilter !== undefined)
            url_ += "PromotesFilter=" + encodeURIComponent("" + promotesFilter) + "&"; 
        if (specialOffersFilter === null)
            throw new Error("The parameter 'specialOffersFilter' cannot be null.");
        else if (specialOffersFilter !== undefined)
            url_ += "SpecialOffersFilter=" + encodeURIComponent("" + specialOffersFilter) + "&"; 
        if (partnersFilter === null)
            throw new Error("The parameter 'partnersFilter' cannot be null.");
        else if (partnersFilter !== undefined)
            url_ += "PartnersFilter=" + encodeURIComponent("" + partnersFilter) + "&"; 
        if (themTemplateCodeFilter === null)
            throw new Error("The parameter 'themTemplateCodeFilter' cannot be null.");
        else if (themTemplateCodeFilter !== undefined)
            url_ += "ThemTemplateCodeFilter=" + encodeURIComponent("" + themTemplateCodeFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTemplateDatasToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemplateDatasToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTemplateDatasToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllThemTemplateForTableDropdown(): Observable<TemplateDataThemTemplateLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TemplateDatas/GetAllThemTemplateForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllThemTemplateForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllThemTemplateForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<TemplateDataThemTemplateLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TemplateDataThemTemplateLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllThemTemplateForTableDropdown(response: HttpResponseBase): Observable<TemplateDataThemTemplateLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateDataThemTemplateLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TemplateDataThemTemplateLookupTableDto[]>(<any>null);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param subscriptionEndDateStart (optional) 
     * @param subscriptionEndDateEnd (optional) 
     * @param creationDateStart (optional) 
     * @param creationDateEnd (optional) 
     * @param editionId (optional) 
     * @param editionIdSpecified (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getTenants(filter: string | undefined, subscriptionEndDateStart: moment.Moment | undefined, subscriptionEndDateEnd: moment.Moment | undefined, creationDateStart: moment.Moment | undefined, creationDateEnd: moment.Moment | undefined, editionId: number | undefined, editionIdSpecified: boolean | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfTenantListDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenants?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (subscriptionEndDateStart === null)
            throw new Error("The parameter 'subscriptionEndDateStart' cannot be null.");
        else if (subscriptionEndDateStart !== undefined)
            url_ += "SubscriptionEndDateStart=" + encodeURIComponent(subscriptionEndDateStart ? "" + subscriptionEndDateStart.toJSON() : "") + "&"; 
        if (subscriptionEndDateEnd === null)
            throw new Error("The parameter 'subscriptionEndDateEnd' cannot be null.");
        else if (subscriptionEndDateEnd !== undefined)
            url_ += "SubscriptionEndDateEnd=" + encodeURIComponent(subscriptionEndDateEnd ? "" + subscriptionEndDateEnd.toJSON() : "") + "&"; 
        if (creationDateStart === null)
            throw new Error("The parameter 'creationDateStart' cannot be null.");
        else if (creationDateStart !== undefined)
            url_ += "CreationDateStart=" + encodeURIComponent(creationDateStart ? "" + creationDateStart.toJSON() : "") + "&"; 
        if (creationDateEnd === null)
            throw new Error("The parameter 'creationDateEnd' cannot be null.");
        else if (creationDateEnd !== undefined)
            url_ += "CreationDateEnd=" + encodeURIComponent(creationDateEnd ? "" + creationDateEnd.toJSON() : "") + "&"; 
        if (editionId === null)
            throw new Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "EditionId=" + encodeURIComponent("" + editionId) + "&"; 
        if (editionIdSpecified === null)
            throw new Error("The parameter 'editionIdSpecified' cannot be null.");
        else if (editionIdSpecified !== undefined)
            url_ += "EditionIdSpecified=" + encodeURIComponent("" + editionIdSpecified) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenants(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfTenantListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfTenantListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTenants(response: HttpResponseBase): Observable<PagedResultDtoOfTenantListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTenantListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfTenantListDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTenant(body: CreateTenantInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/CreateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTenant(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTenantForEdit(id: number | undefined): Observable<TenantEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantForEdit(<any>response_);
                } catch (e) {
                    return <Observable<TenantEditDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantEditDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTenantForEdit(response: HttpResponseBase): Observable<TenantEditDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantEditDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTenantForView(id: number | undefined): Observable<TenantViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantForView(<any>response_);
                } catch (e) {
                    return <Observable<TenantViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTenantForView(response: HttpResponseBase): Observable<TenantViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantViewDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTenant(body: TenantEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTenant(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteTenant(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/DeleteTenant?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTenant(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTenantFeaturesForEdit(id: number | undefined): Observable<GetTenantFeaturesEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantFeaturesForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantFeaturesForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantFeaturesForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetTenantFeaturesEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTenantFeaturesEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetTenantFeaturesForEdit(response: HttpResponseBase): Observable<GetTenantFeaturesEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTenantFeaturesEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTenantFeaturesEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTenantFeatures(body: UpdateTenantFeaturesInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenantFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTenantFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTenantFeatures(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateTenantFeatures(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetTenantSpecificFeatures(body: EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/ResetTenantSpecificFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetTenantSpecificFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetTenantSpecificFeatures(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processResetTenantSpecificFeatures(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unlockTenantAdmin(body: EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UnlockTenantAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockTenantAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockTenantAdmin(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUnlockTenantAdmin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class TenantDashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getMemberActivity(): Observable<GetMemberActivityOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetMemberActivity";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberActivity(<any>response_);
                } catch (e) {
                    return <Observable<GetMemberActivityOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMemberActivityOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetMemberActivity(response: HttpResponseBase): Observable<GetMemberActivityOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMemberActivityOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMemberActivityOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getDashboardData(salesSummaryDatePeriod: SalesSummaryDatePeriod): Observable<GetDashboardDataOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetDashboardData?";
        if (salesSummaryDatePeriod === undefined || salesSummaryDatePeriod === null)
            throw new Error("The parameter 'salesSummaryDatePeriod' must be defined and cannot be null.");
        else
            url_ += "SalesSummaryDatePeriod=" + encodeURIComponent("" + salesSummaryDatePeriod) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardData(<any>response_);
                } catch (e) {
                    return <Observable<GetDashboardDataOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetDashboardDataOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetDashboardData(response: HttpResponseBase): Observable<GetDashboardDataOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDashboardDataOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDashboardDataOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getTopStats(): Observable<GetTopStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetTopStats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTopStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTopStats(<any>response_);
                } catch (e) {
                    return <Observable<GetTopStatsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTopStatsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetTopStats(response: HttpResponseBase): Observable<GetTopStatsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTopStatsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTopStatsOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getProfitShare(): Observable<GetProfitShareOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetProfitShare";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfitShare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfitShare(<any>response_);
                } catch (e) {
                    return <Observable<GetProfitShareOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetProfitShareOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetProfitShare(response: HttpResponseBase): Observable<GetProfitShareOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfitShareOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProfitShareOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getDailySales(): Observable<GetDailySalesOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetDailySales";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDailySales(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDailySales(<any>response_);
                } catch (e) {
                    return <Observable<GetDailySalesOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetDailySalesOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetDailySales(response: HttpResponseBase): Observable<GetDailySalesOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDailySalesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDailySalesOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getSalesSummary(salesSummaryDatePeriod: SalesSummaryDatePeriod): Observable<GetSalesSummaryOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetSalesSummary?";
        if (salesSummaryDatePeriod === undefined || salesSummaryDatePeriod === null)
            throw new Error("The parameter 'salesSummaryDatePeriod' must be defined and cannot be null.");
        else
            url_ += "SalesSummaryDatePeriod=" + encodeURIComponent("" + salesSummaryDatePeriod) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalesSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesSummary(<any>response_);
                } catch (e) {
                    return <Observable<GetSalesSummaryOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSalesSummaryOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSalesSummary(response: HttpResponseBase): Observable<GetSalesSummaryOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSalesSummaryOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSalesSummaryOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getRegionalStats(): Observable<GetRegionalStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetRegionalStats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegionalStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegionalStats(<any>response_);
                } catch (e) {
                    return <Observable<GetRegionalStatsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRegionalStatsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRegionalStats(response: HttpResponseBase): Observable<GetRegionalStatsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRegionalStatsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRegionalStatsOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getGeneralStats(): Observable<GetGeneralStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetGeneralStats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeneralStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralStats(<any>response_);
                } catch (e) {
                    return <Observable<GetGeneralStatsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGeneralStatsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGeneralStats(response: HttpResponseBase): Observable<GetGeneralStatsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeneralStatsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGeneralStatsOutput>(<any>null);
    }

    /**
     * @param isCach (optional) 
     * @return Success
     */
    getNumberOfBill(isCach: boolean | undefined): Observable<GetNumberOfBillOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetNumberOfBill?";
        if (isCach === null)
            throw new Error("The parameter 'isCach' cannot be null.");
        else if (isCach !== undefined)
            url_ += "isCach=" + encodeURIComponent("" + isCach) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNumberOfBill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumberOfBill(<any>response_);
                } catch (e) {
                    return <Observable<GetNumberOfBillOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetNumberOfBillOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetNumberOfBill(response: HttpResponseBase): Observable<GetNumberOfBillOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNumberOfBillOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNumberOfBillOutput>(<any>null);
    }

    /**
     * @param isCach (optional) 
     * @return Success
     */
    getNumberOfNotApproveBill(isCach: boolean | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetNumberOfNotApproveBill?";
        if (isCach === null)
            throw new Error("The parameter 'isCach' cannot be null.");
        else if (isCach !== undefined)
            url_ += "isCach=" + encodeURIComponent("" + isCach) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNumberOfNotApproveBill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumberOfNotApproveBill(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetNumberOfNotApproveBill(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param isCach (optional) 
     * @return Success
     */
    getNumberOfDeceasedNotApprove(isCach: boolean | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetNumberOfDeceasedNotApprove?";
        if (isCach === null)
            throw new Error("The parameter 'isCach' cannot be null.");
        else if (isCach !== undefined)
            url_ += "isCach=" + encodeURIComponent("" + isCach) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNumberOfDeceasedNotApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumberOfDeceasedNotApprove(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetNumberOfDeceasedNotApprove(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param isCach (optional) 
     * @return Success
     */
    getNumberOfDeceasedNotApproveImg(isCach: boolean | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetNumberOfDeceasedNotApproveImg?";
        if (isCach === null)
            throw new Error("The parameter 'isCach' cannot be null.");
        else if (isCach !== undefined)
            url_ += "isCach=" + encodeURIComponent("" + isCach) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNumberOfDeceasedNotApproveImg(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumberOfDeceasedNotApproveImg(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetNumberOfDeceasedNotApproveImg(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param isCach (optional) 
     * @return Success
     */
    getNumberOfCeremonyNotApprove(isCach: boolean | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetNumberOfCeremonyNotApprove?";
        if (isCach === null)
            throw new Error("The parameter 'isCach' cannot be null.");
        else if (isCach !== undefined)
            url_ += "isCach=" + encodeURIComponent("" + isCach) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNumberOfCeremonyNotApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumberOfCeremonyNotApprove(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetNumberOfCeremonyNotApprove(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param isCach (optional) 
     * @return Success
     */
    getNumberOfCondolenceMessageNotApprove(isCach: boolean | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetNumberOfCondolenceMessageNotApprove?";
        if (isCach === null)
            throw new Error("The parameter 'isCach' cannot be null.");
        else if (isCach !== undefined)
            url_ += "isCach=" + encodeURIComponent("" + isCach) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNumberOfCondolenceMessageNotApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumberOfCondolenceMessageNotApprove(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetNumberOfCondolenceMessageNotApprove(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param isCach (optional) 
     * @return Success
     */
    getNumberOfUser(isCach: boolean | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetNumberOfUser?";
        if (isCach === null)
            throw new Error("The parameter 'isCach' cannot be null.");
        else if (isCach !== undefined)
            url_ += "isCach=" + encodeURIComponent("" + isCach) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNumberOfUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumberOfUser(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetNumberOfUser(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param isCach (optional) 
     * @return Success
     */
    getNumberOfOnlineUser(isCach: boolean | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetNumberOfOnlineUser?";
        if (isCach === null)
            throw new Error("The parameter 'isCach' cannot be null.");
        else if (isCach !== undefined)
            url_ += "isCach=" + encodeURIComponent("" + isCach) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNumberOfOnlineUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumberOfOnlineUser(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetNumberOfOnlineUser(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param today (optional) 
     * @param isCach (optional) 
     * @return Success
     */
    getNumberOfPlans(today: boolean | undefined, isCach: boolean | undefined): Observable<GetNUmberOfPlansOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetNumberOfPlans?";
        if (today === null)
            throw new Error("The parameter 'today' cannot be null.");
        else if (today !== undefined)
            url_ += "today=" + encodeURIComponent("" + today) + "&"; 
        if (isCach === null)
            throw new Error("The parameter 'isCach' cannot be null.");
        else if (isCach !== undefined)
            url_ += "isCach=" + encodeURIComponent("" + isCach) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNumberOfPlans(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumberOfPlans(<any>response_);
                } catch (e) {
                    return <Observable<GetNUmberOfPlansOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetNUmberOfPlansOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetNumberOfPlans(response: HttpResponseBase): Observable<GetNUmberOfPlansOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNUmberOfPlansOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNUmberOfPlansOutput>(<any>null);
    }

    /**
     * @return Success
     */
    updateDashbordCach(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/UpdateDashbordCach";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDashbordCach(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDashbordCach(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateDashbordCach(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class TenantRegistrationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerTenant(body: RegisterTenantInput | undefined): Observable<RegisterTenantOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/RegisterTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterTenant(<any>response_);
                } catch (e) {
                    return <Observable<RegisterTenantOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegisterTenantOutput>><any>_observableThrow(response_);
        }));
    }

    protected processRegisterTenant(response: HttpResponseBase): Observable<RegisterTenantOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterTenantOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisterTenantOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getEditionsForSelect(): Observable<EditionsSelectOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEditionsForSelect";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionsForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionsForSelect(<any>response_);
                } catch (e) {
                    return <Observable<EditionsSelectOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<EditionsSelectOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetEditionsForSelect(response: HttpResponseBase): Observable<EditionsSelectOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditionsSelectOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EditionsSelectOutput>(<any>null);
    }

    /**
     * @param editionId (optional) 
     * @return Success
     */
    getEdition(editionId: number | undefined): Observable<EditionSelectDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEdition?";
        if (editionId === null)
            throw new Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEdition(<any>response_);
                } catch (e) {
                    return <Observable<EditionSelectDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<EditionSelectDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEdition(response: HttpResponseBase): Observable<EditionSelectDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditionSelectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EditionSelectDto>(<any>null);
    }
}

@Injectable()
export class TenantSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllSettings(): Observable<TenantSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSettings(<any>response_);
                } catch (e) {
                    return <Observable<TenantSettingsEditDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantSettingsEditDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSettings(response: HttpResponseBase): Observable<TenantSettingsEditDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantSettingsEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantSettingsEditDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAllSettings(body: TenantSettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllSettings(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateAllSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    clearLogo(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearLogo(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processClearLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    clearCustomCss(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearCustomCss";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearCustomCss(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearCustomCss(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processClearCustomCss(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    tenantSendTestEmail(body: TenantSendTestEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/TenantSendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTenantSendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTenantSendTestEmail(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processTenantSendTestEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendTestEmail(body: SendTestEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class TermMappingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param originalTermFilter (optional) 
     * @param mappedTermFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param fontNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, originalTermFilter: string | undefined, mappedTermFilter: string | undefined, isActiveFilter: number | undefined, fontNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetTermMappingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TermMappings/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (originalTermFilter === null)
            throw new Error("The parameter 'originalTermFilter' cannot be null.");
        else if (originalTermFilter !== undefined)
            url_ += "OriginalTermFilter=" + encodeURIComponent("" + originalTermFilter) + "&"; 
        if (mappedTermFilter === null)
            throw new Error("The parameter 'mappedTermFilter' cannot be null.");
        else if (mappedTermFilter !== undefined)
            url_ += "MappedTermFilter=" + encodeURIComponent("" + mappedTermFilter) + "&"; 
        if (isActiveFilter === null)
            throw new Error("The parameter 'isActiveFilter' cannot be null.");
        else if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&"; 
        if (fontNameFilter === null)
            throw new Error("The parameter 'fontNameFilter' cannot be null.");
        else if (fontNameFilter !== undefined)
            url_ += "FontNameFilter=" + encodeURIComponent("" + fontNameFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTermMappingForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTermMappingForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTermMappingForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTermMappingForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTermMappingForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTermMappingForView(id: number | undefined): Observable<GetTermMappingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TermMappings/GetTermMappingForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTermMappingForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTermMappingForView(<any>response_);
                } catch (e) {
                    return <Observable<GetTermMappingForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTermMappingForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTermMappingForView(response: HttpResponseBase): Observable<GetTermMappingForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTermMappingForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTermMappingForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTermMappingForEdit(id: number | undefined): Observable<GetTermMappingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TermMappings/GetTermMappingForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTermMappingForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTermMappingForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetTermMappingForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTermMappingForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetTermMappingForEdit(response: HttpResponseBase): Observable<GetTermMappingForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTermMappingForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTermMappingForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditTermMappingDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TermMappings/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TermMappings/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param originalTermFilter (optional) 
     * @param mappedTermFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param fontNameFilter (optional) 
     * @return Success
     */
    getTermMappingsToExcel(filter: string | undefined, originalTermFilter: string | undefined, mappedTermFilter: string | undefined, isActiveFilter: number | undefined, fontNameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/TermMappings/GetTermMappingsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (originalTermFilter === null)
            throw new Error("The parameter 'originalTermFilter' cannot be null.");
        else if (originalTermFilter !== undefined)
            url_ += "OriginalTermFilter=" + encodeURIComponent("" + originalTermFilter) + "&"; 
        if (mappedTermFilter === null)
            throw new Error("The parameter 'mappedTermFilter' cannot be null.");
        else if (mappedTermFilter !== undefined)
            url_ += "MappedTermFilter=" + encodeURIComponent("" + mappedTermFilter) + "&"; 
        if (isActiveFilter === null)
            throw new Error("The parameter 'isActiveFilter' cannot be null.");
        else if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&"; 
        if (fontNameFilter === null)
            throw new Error("The parameter 'fontNameFilter' cannot be null.");
        else if (fontNameFilter !== undefined)
            url_ += "FontNameFilter=" + encodeURIComponent("" + fontNameFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTermMappingsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTermMappingsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTermMappingsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class ThemTemplatesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param titleFilter (optional) 
     * @param imageFilter (optional) 
     * @param defaultFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, codeFilter: string | undefined, titleFilter: string | undefined, imageFilter: string | undefined, defaultFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetThemTemplateForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ThemTemplates/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (imageFilter === null)
            throw new Error("The parameter 'imageFilter' cannot be null.");
        else if (imageFilter !== undefined)
            url_ += "ImageFilter=" + encodeURIComponent("" + imageFilter) + "&"; 
        if (defaultFilter === null)
            throw new Error("The parameter 'defaultFilter' cannot be null.");
        else if (defaultFilter !== undefined)
            url_ += "DefaultFilter=" + encodeURIComponent("" + defaultFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetThemTemplateForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetThemTemplateForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetThemTemplateForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetThemTemplateForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetThemTemplateForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getThemTemplateForView(id: number | undefined): Observable<GetThemTemplateForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ThemTemplates/GetThemTemplateForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetThemTemplateForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetThemTemplateForView(<any>response_);
                } catch (e) {
                    return <Observable<GetThemTemplateForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetThemTemplateForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetThemTemplateForView(response: HttpResponseBase): Observable<GetThemTemplateForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetThemTemplateForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetThemTemplateForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getThemTemplateForEdit(id: number | undefined): Observable<GetThemTemplateForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ThemTemplates/GetThemTemplateForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetThemTemplateForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetThemTemplateForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetThemTemplateForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetThemTemplateForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetThemTemplateForEdit(response: HttpResponseBase): Observable<GetThemTemplateForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetThemTemplateForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetThemTemplateForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditThemTemplateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ThemTemplates/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ThemTemplates/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param titleFilter (optional) 
     * @param imageFilter (optional) 
     * @param defaultFilter (optional) 
     * @return Success
     */
    getThemTemplatesToExcel(filter: string | undefined, codeFilter: string | undefined, titleFilter: string | undefined, imageFilter: string | undefined, defaultFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ThemTemplates/GetThemTemplatesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (imageFilter === null)
            throw new Error("The parameter 'imageFilter' cannot be null.");
        else if (imageFilter !== undefined)
            url_ += "ImageFilter=" + encodeURIComponent("" + imageFilter) + "&"; 
        if (defaultFilter === null)
            throw new Error("The parameter 'defaultFilter' cannot be null.");
        else if (defaultFilter !== undefined)
            url_ += "DefaultFilter=" + encodeURIComponent("" + defaultFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetThemTemplatesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetThemTemplatesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetThemTemplatesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class TimingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getTimezones(defaultTimezoneScope: SettingScopes): Observable<ListResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetTimezones?";
        if (defaultTimezoneScope === undefined || defaultTimezoneScope === null)
            throw new Error("The parameter 'defaultTimezoneScope' must be defined and cannot be null.");
        else
            url_ += "DefaultTimezoneScope=" + encodeURIComponent("" + defaultTimezoneScope) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimezones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimezones(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfNameValueDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfNameValueDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTimezones(response: HttpResponseBase): Observable<ListResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfNameValueDto>(<any>null);
    }

    /**
     * @param selectedTimezoneId (optional) 
     * @return Success
     */
    getTimezoneComboboxItems(selectedTimezoneId: string | undefined): Observable<ComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetTimezoneComboboxItems?";
        if (selectedTimezoneId === null)
            throw new Error("The parameter 'selectedTimezoneId' cannot be null.");
        else if (selectedTimezoneId !== undefined)
            url_ += "SelectedTimezoneId=" + encodeURIComponent("" + selectedTimezoneId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimezoneComboboxItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimezoneComboboxItems(<any>response_);
                } catch (e) {
                    return <Observable<ComboboxItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ComboboxItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTimezoneComboboxItems(response: HttpResponseBase): Observable<ComboboxItemDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ComboboxItemDto[]>(<any>null);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param sendSMSForRegister (optional) 
     * @return Success
     */
    sendVerificationSmsCode(phoneNumber: string, sendSMSForRegister: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/SendVerificationSmsCode?";
        if (phoneNumber === undefined || phoneNumber === null)
            throw new Error("The parameter 'phoneNumber' must be defined and cannot be null.");
        else
            url_ += "PhoneNumber=" + encodeURIComponent("" + phoneNumber) + "&"; 
        if (sendSMSForRegister === null)
            throw new Error("The parameter 'sendSMSForRegister' cannot be null.");
        else if (sendSMSForRegister !== undefined)
            url_ += "SendSMSForRegister=" + encodeURIComponent("" + sendSMSForRegister) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendVerificationSmsCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendVerificationSmsCode(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendVerificationSmsCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param sendEmailForRegister (optional) 
     * @return Success
     */
    sendVerificationEmailCode(emailAddressTo: string, sendEmailForRegister: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/SendVerificationEmailCode?";
        if (emailAddressTo === undefined || emailAddressTo === null)
            throw new Error("The parameter 'emailAddressTo' must be defined and cannot be null.");
        else
            url_ += "EmailAddressTo=" + encodeURIComponent("" + emailAddressTo) + "&"; 
        if (sendEmailForRegister === null)
            throw new Error("The parameter 'sendEmailForRegister' cannot be null.");
        else if (sendEmailForRegister !== undefined)
            url_ += "SendEmailForRegister=" + encodeURIComponent("" + sendEmailForRegister) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendVerificationEmailCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendVerificationEmailCode(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendVerificationEmailCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    verifyMobileNumber(body: VerifyPhoneNumberInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/VerifyMobileNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyMobileNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyMobileNumber(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyMobileNumber(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    verifyEmail(body: VerifyEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/VerifyEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyEmail(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    verifyContactMobileNumber(body: VerifyPhoneNumberInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/VerifyContactMobileNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyContactMobileNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyContactMobileNumber(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyContactMobileNumber(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    verifyContactEmail(body: VerifyEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/VerifyContactEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyContactEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyContactEmail(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyContactEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    logInWithPassword(body: LogInWithPassInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/LogInWithPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogInWithPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogInWithPassword(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processLogInWithPassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param deviceId (optional) 
     * @return Success
     */
    logout(deviceId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/Logout?";
        if (deviceId === null)
            throw new Error("The parameter 'deviceId' cannot be null.");
        else if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogout(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPasswordBySendSMSCode(body: PasswordInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/ResetPasswordBySendSMSCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPasswordBySendSMSCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPasswordBySendSMSCode(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processResetPasswordBySendSMSCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    verifySmsCodeForRestPass(body: VerifyCodeForRestPassInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/VerifySmsCodeForRestPass";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifySmsCodeForRestPass(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifySmsCodeForRestPass(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processVerifySmsCodeForRestPass(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPasswordBySendEmailCode(body: ResetPasswordByEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/ResetPasswordBySendEmailCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPasswordBySendEmailCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPasswordBySendEmailCode(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processResetPasswordBySendEmailCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    verifyEmailCodeForRestPass(body: VerifyCodeForRestPassInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/VerifyEmailCodeForRestPass";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyEmailCodeForRestPass(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyEmailCodeForRestPass(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyEmailCodeForRestPass(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param impersonationToken (optional) 
     * @return Success
     */
    impersonatedAuthenticate(impersonationToken: string | undefined): Observable<ImpersonatedAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ImpersonatedAuthenticate?";
        if (impersonationToken === null)
            throw new Error("The parameter 'impersonationToken' cannot be null.");
        else if (impersonationToken !== undefined)
            url_ += "impersonationToken=" + encodeURIComponent("" + impersonationToken) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonatedAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonatedAuthenticate(<any>response_);
                } catch (e) {
                    return <Observable<ImpersonatedAuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ImpersonatedAuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processImpersonatedAuthenticate(response: HttpResponseBase): Observable<ImpersonatedAuthenticateResultModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonatedAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImpersonatedAuthenticateResultModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticate(body: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(<any>response_);
                } catch (e) {
                    return <Observable<AuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResultModel>(<any>null);
    }

    /**
     * @param refreshToken (optional) 
     * @return Success
     */
    refreshToken(refreshToken: string | undefined): Observable<RefreshTokenResult> {
        let url_ = this.baseUrl + "/api/TokenAuth/RefreshToken?";
        if (refreshToken === null)
            throw new Error("The parameter 'refreshToken' cannot be null.");
        else if (refreshToken !== undefined)
            url_ += "refreshToken=" + encodeURIComponent("" + refreshToken) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshToken(<any>response_);
                } catch (e) {
                    return <Observable<RefreshTokenResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<RefreshTokenResult>><any>_observableThrow(response_);
        }));
    }

    protected processRefreshToken(response: HttpResponseBase): Observable<RefreshTokenResult> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RefreshTokenResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RefreshTokenResult>(<any>null);
    }

    /**
     * @param deviceId (optional) 
     * @return Success
     */
    logOut(deviceId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/LogOut?";
        if (deviceId === null)
            throw new Error("The parameter 'deviceId' cannot be null.");
        else if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogOut(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processLogOut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendTwoFactorAuthCode(body: SendTwoFactorAuthCodeModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/SendTwoFactorAuthCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTwoFactorAuthCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTwoFactorAuthCode(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendTwoFactorAuthCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param switchAccountToken (optional) 
     * @return Success
     */
    linkedAccountAuthenticate(switchAccountToken: string | undefined): Observable<SwitchedAccountAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/LinkedAccountAuthenticate?";
        if (switchAccountToken === null)
            throw new Error("The parameter 'switchAccountToken' cannot be null.");
        else if (switchAccountToken !== undefined)
            url_ += "switchAccountToken=" + encodeURIComponent("" + switchAccountToken) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkedAccountAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkedAccountAuthenticate(<any>response_);
                } catch (e) {
                    return <Observable<SwitchedAccountAuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwitchedAccountAuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processLinkedAccountAuthenticate(response: HttpResponseBase): Observable<SwitchedAccountAuthenticateResultModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SwitchedAccountAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwitchedAccountAuthenticateResultModel>(<any>null);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalAuthenticationProviders(<any>response_);
                } catch (e) {
                    return <Observable<ExternalLoginProviderInfoModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExternalLoginProviderInfoModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalLoginProviderInfoModel[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    externalAuthenticate(body: ExternalAuthenticateModel | undefined): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAuthenticate(<any>response_);
                } catch (e) {
                    return <Observable<ExternalAuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExternalAuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalAuthenticateResultModel>(<any>null);
    }

    /**
     * @param message (optional) 
     * @param severity (optional) 
     * @return Success
     */
    testNotification(message: string | undefined, severity: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/TestNotification?";
        if (message === null)
            throw new Error("The parameter 'message' cannot be null.");
        else if (message !== undefined)
            url_ += "message=" + encodeURIComponent("" + message) + "&"; 
        if (severity === null)
            throw new Error("The parameter 'severity' cannot be null.");
        else if (severity !== undefined)
            url_ += "severity=" + encodeURIComponent("" + severity) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestNotification(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processTestNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class TransactionDetailsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param maxUnitPriceFilter (optional) 
     * @param minUnitPriceFilter (optional) 
     * @param maxAmountFilter (optional) 
     * @param minAmountFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param stockTransactionFormCodeFilter (optional) 
     * @param stockTransactionRefFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, codeFilter: string | undefined, maxUnitPriceFilter: number | undefined, minUnitPriceFilter: number | undefined, maxAmountFilter: number | undefined, minAmountFilter: number | undefined, descriptionFilter: string | undefined, stockTransactionFormCodeFilter: string | undefined, stockTransactionRefFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetTransactionDetailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TransactionDetails/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (maxUnitPriceFilter === null)
            throw new Error("The parameter 'maxUnitPriceFilter' cannot be null.");
        else if (maxUnitPriceFilter !== undefined)
            url_ += "MaxUnitPriceFilter=" + encodeURIComponent("" + maxUnitPriceFilter) + "&"; 
        if (minUnitPriceFilter === null)
            throw new Error("The parameter 'minUnitPriceFilter' cannot be null.");
        else if (minUnitPriceFilter !== undefined)
            url_ += "MinUnitPriceFilter=" + encodeURIComponent("" + minUnitPriceFilter) + "&"; 
        if (maxAmountFilter === null)
            throw new Error("The parameter 'maxAmountFilter' cannot be null.");
        else if (maxAmountFilter !== undefined)
            url_ += "MaxAmountFilter=" + encodeURIComponent("" + maxAmountFilter) + "&"; 
        if (minAmountFilter === null)
            throw new Error("The parameter 'minAmountFilter' cannot be null.");
        else if (minAmountFilter !== undefined)
            url_ += "MinAmountFilter=" + encodeURIComponent("" + minAmountFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (stockTransactionFormCodeFilter === null)
            throw new Error("The parameter 'stockTransactionFormCodeFilter' cannot be null.");
        else if (stockTransactionFormCodeFilter !== undefined)
            url_ += "StockTransactionFormCodeFilter=" + encodeURIComponent("" + stockTransactionFormCodeFilter) + "&"; 
        if (stockTransactionRefFilter === null)
            throw new Error("The parameter 'stockTransactionRefFilter' cannot be null.");
        else if (stockTransactionRefFilter !== undefined)
            url_ += "StockTransactionRefFilter=" + encodeURIComponent("" + stockTransactionRefFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTransactionDetailForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTransactionDetailForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTransactionDetailForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTransactionDetailForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTransactionDetailForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTransactionDetailForView(id: number | undefined): Observable<GetTransactionDetailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TransactionDetails/GetTransactionDetailForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransactionDetailForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionDetailForView(<any>response_);
                } catch (e) {
                    return <Observable<GetTransactionDetailForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTransactionDetailForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTransactionDetailForView(response: HttpResponseBase): Observable<GetTransactionDetailForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTransactionDetailForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTransactionDetailForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTransactionDetailForEdit(id: number | undefined): Observable<GetTransactionDetailForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TransactionDetails/GetTransactionDetailForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransactionDetailForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionDetailForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetTransactionDetailForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTransactionDetailForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetTransactionDetailForEdit(response: HttpResponseBase): Observable<GetTransactionDetailForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTransactionDetailForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTransactionDetailForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditTransactionDetailDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TransactionDetails/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TransactionDetails/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param maxUnitPriceFilter (optional) 
     * @param minUnitPriceFilter (optional) 
     * @param maxAmountFilter (optional) 
     * @param minAmountFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param stockTransactionFormCodeFilter (optional) 
     * @return Success
     */
    getTransactionDetailsToExcel(filter: string | undefined, codeFilter: string | undefined, maxUnitPriceFilter: number | undefined, minUnitPriceFilter: number | undefined, maxAmountFilter: number | undefined, minAmountFilter: number | undefined, descriptionFilter: string | undefined, stockTransactionFormCodeFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/TransactionDetails/GetTransactionDetailsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (maxUnitPriceFilter === null)
            throw new Error("The parameter 'maxUnitPriceFilter' cannot be null.");
        else if (maxUnitPriceFilter !== undefined)
            url_ += "MaxUnitPriceFilter=" + encodeURIComponent("" + maxUnitPriceFilter) + "&"; 
        if (minUnitPriceFilter === null)
            throw new Error("The parameter 'minUnitPriceFilter' cannot be null.");
        else if (minUnitPriceFilter !== undefined)
            url_ += "MinUnitPriceFilter=" + encodeURIComponent("" + minUnitPriceFilter) + "&"; 
        if (maxAmountFilter === null)
            throw new Error("The parameter 'maxAmountFilter' cannot be null.");
        else if (maxAmountFilter !== undefined)
            url_ += "MaxAmountFilter=" + encodeURIComponent("" + maxAmountFilter) + "&"; 
        if (minAmountFilter === null)
            throw new Error("The parameter 'minAmountFilter' cannot be null.");
        else if (minAmountFilter !== undefined)
            url_ += "MinAmountFilter=" + encodeURIComponent("" + minAmountFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (stockTransactionFormCodeFilter === null)
            throw new Error("The parameter 'stockTransactionFormCodeFilter' cannot be null.");
        else if (stockTransactionFormCodeFilter !== undefined)
            url_ += "StockTransactionFormCodeFilter=" + encodeURIComponent("" + stockTransactionFormCodeFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransactionDetailsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionDetailsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTransactionDetailsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllStockTransactionForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfTransactionDetailStockTransactionLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/TransactionDetails/GetAllStockTransactionForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStockTransactionForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStockTransactionForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfTransactionDetailStockTransactionLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfTransactionDetailStockTransactionLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllStockTransactionForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfTransactionDetailStockTransactionLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTransactionDetailStockTransactionLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfTransactionDetailStockTransactionLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCommodityForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfTransactionDetailCommodityLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/TransactionDetails/GetAllCommodityForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCommodityForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCommodityForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfTransactionDetailCommodityLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfTransactionDetailCommodityLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCommodityForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfTransactionDetailCommodityLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTransactionDetailCommodityLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfTransactionDetailCommodityLookupTableDto>(<any>null);
    }
}

@Injectable()
export class TransactionTypesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param isAffectedFilter (optional) 
     * @param isTemporaryFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, titleFilter: string | undefined, isAffectedFilter: number | undefined, isTemporaryFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetTransactionTypeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TransactionTypes/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (isAffectedFilter === null)
            throw new Error("The parameter 'isAffectedFilter' cannot be null.");
        else if (isAffectedFilter !== undefined)
            url_ += "IsAffectedFilter=" + encodeURIComponent("" + isAffectedFilter) + "&"; 
        if (isTemporaryFilter === null)
            throw new Error("The parameter 'isTemporaryFilter' cannot be null.");
        else if (isTemporaryFilter !== undefined)
            url_ += "IsTemporaryFilter=" + encodeURIComponent("" + isTemporaryFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTransactionTypeForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTransactionTypeForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTransactionTypeForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTransactionTypeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTransactionTypeForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTransactionTypeForView(id: number | undefined): Observable<GetTransactionTypeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TransactionTypes/GetTransactionTypeForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransactionTypeForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionTypeForView(<any>response_);
                } catch (e) {
                    return <Observable<GetTransactionTypeForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTransactionTypeForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTransactionTypeForView(response: HttpResponseBase): Observable<GetTransactionTypeForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTransactionTypeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTransactionTypeForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTransactionTypeForEdit(id: number | undefined): Observable<GetTransactionTypeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TransactionTypes/GetTransactionTypeForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransactionTypeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionTypeForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetTransactionTypeForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTransactionTypeForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetTransactionTypeForEdit(response: HttpResponseBase): Observable<GetTransactionTypeForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTransactionTypeForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTransactionTypeForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditTransactionTypeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TransactionTypes/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TransactionTypes/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param isAffectedFilter (optional) 
     * @param isTemporaryFilter (optional) 
     * @return Success
     */
    getTransactionTypesToExcel(filter: string | undefined, titleFilter: string | undefined, isAffectedFilter: number | undefined, isTemporaryFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/TransactionTypes/GetTransactionTypesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (isAffectedFilter === null)
            throw new Error("The parameter 'isAffectedFilter' cannot be null.");
        else if (isAffectedFilter !== undefined)
            url_ += "IsAffectedFilter=" + encodeURIComponent("" + isAffectedFilter) + "&"; 
        if (isTemporaryFilter === null)
            throw new Error("The parameter 'isTemporaryFilter' cannot be null.");
        else if (isTemporaryFilter !== undefined)
            url_ += "IsTemporaryFilter=" + encodeURIComponent("" + isTemporaryFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransactionTypesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionTypesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTransactionTypesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class UiCustomizationSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getUiManagementSettings(): Observable<ThemeSettingsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/GetUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUiManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUiManagementSettings(<any>response_);
                } catch (e) {
                    return <Observable<ThemeSettingsDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ThemeSettingsDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUiManagementSettings(response: HttpResponseBase): Observable<ThemeSettingsDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ThemeSettingsDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ThemeSettingsDto[]>(<any>null);
    }

    /**
     * @param themeName (optional) 
     * @return Success
     */
    changeThemeWithDefaultValues(themeName: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/ChangeThemeWithDefaultValues?";
        if (themeName === null)
            throw new Error("The parameter 'themeName' cannot be null.");
        else if (themeName !== undefined)
            url_ += "themeName=" + encodeURIComponent("" + themeName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeThemeWithDefaultValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeThemeWithDefaultValues(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeThemeWithDefaultValues(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUiManagementSettings(body: ThemeSettingsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUiManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUiManagementSettings(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateUiManagementSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDefaultUiManagementSettings(body: ThemeSettingsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateDefaultUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDefaultUiManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDefaultUiManagementSettings(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateDefaultUiManagementSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    useSystemDefaultSettings(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UseSystemDefaultSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUseSystemDefaultSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUseSystemDefaultSettings(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUseSystemDefaultSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class UniversitiesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param cityNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, titleFilter: string | undefined, cityNameFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetUniversityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Universities/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (cityNameFilter === null)
            throw new Error("The parameter 'cityNameFilter' cannot be null.");
        else if (cityNameFilter !== undefined)
            url_ += "CityNameFilter=" + encodeURIComponent("" + cityNameFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetUniversityForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetUniversityForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetUniversityForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetUniversityForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetUniversityForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUniversityForView(id: number | undefined): Observable<GetUniversityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Universities/GetUniversityForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUniversityForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUniversityForView(<any>response_);
                } catch (e) {
                    return <Observable<GetUniversityForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetUniversityForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUniversityForView(response: HttpResponseBase): Observable<GetUniversityForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUniversityForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUniversityForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUniversityForEdit(id: number | undefined): Observable<GetUniversityForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Universities/GetUniversityForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUniversityForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUniversityForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetUniversityForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetUniversityForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetUniversityForEdit(response: HttpResponseBase): Observable<GetUniversityForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUniversityForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUniversityForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditUniversityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Universities/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Universities/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param cityNameFilter (optional) 
     * @return Success
     */
    getUniversitiesToExcel(filter: string | undefined, titleFilter: string | undefined, cityNameFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Universities/GetUniversitiesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (cityNameFilter === null)
            throw new Error("The parameter 'cityNameFilter' cannot be null.");
        else if (cityNameFilter !== undefined)
            url_ += "CityNameFilter=" + encodeURIComponent("" + cityNameFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUniversitiesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUniversitiesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUniversitiesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllCityForTableDropdown(): Observable<UniversityCityLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Universities/GetAllCityForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCityForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCityForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<UniversityCityLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UniversityCityLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCityForTableDropdown(response: HttpResponseBase): Observable<UniversityCityLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UniversityCityLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UniversityCityLookupTableDto[]>(<any>null);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param permissions (optional) 
     * @param role (optional) 
     * @param onlyLockedUsers (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getUsers(filter: string | undefined, permissions: string[] | undefined, role: number | undefined, onlyLockedUsers: boolean | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsers?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (permissions === null)
            throw new Error("The parameter 'permissions' cannot be null.");
        else if (permissions !== undefined)
            permissions && permissions.forEach(item => { url_ += "Permissions=" + encodeURIComponent("" + item) + "&"; });
        if (role === null)
            throw new Error("The parameter 'role' cannot be null.");
        else if (role !== undefined)
            url_ += "Role=" + encodeURIComponent("" + role) + "&"; 
        if (onlyLockedUsers === null)
            throw new Error("The parameter 'onlyLockedUsers' cannot be null.");
        else if (onlyLockedUsers !== undefined)
            url_ += "OnlyLockedUsers=" + encodeURIComponent("" + onlyLockedUsers) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsers(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUsers(response: HttpResponseBase): Observable<PagedResultDtoOfUserListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserListDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param permissions (optional) 
     * @param role (optional) 
     * @param onlyLockedUsers (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getUsersToExcel(filter: string | undefined, permissions: string[] | undefined, role: number | undefined, onlyLockedUsers: boolean | undefined, sorting: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsersToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (permissions === null)
            throw new Error("The parameter 'permissions' cannot be null.");
        else if (permissions !== undefined)
            permissions && permissions.forEach(item => { url_ += "Permissions=" + encodeURIComponent("" + item) + "&"; });
        if (role === null)
            throw new Error("The parameter 'role' cannot be null.");
        else if (role !== undefined)
            url_ += "Role=" + encodeURIComponent("" + role) + "&"; 
        if (onlyLockedUsers === null)
            throw new Error("The parameter 'onlyLockedUsers' cannot be null.");
        else if (onlyLockedUsers !== undefined)
            url_ += "OnlyLockedUsers=" + encodeURIComponent("" + onlyLockedUsers) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUsersToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUserForEdit(id: number | undefined): Observable<GetUserForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetUserForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetUserForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserForEdit(response: HttpResponseBase): Observable<GetUserForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserForEditOutput>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUserPermissionsForEdit(id: number | undefined): Observable<GetUserPermissionsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserPermissionsForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPermissionsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPermissionsForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetUserPermissionsForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetUserPermissionsForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserPermissionsForEdit(response: HttpResponseBase): Observable<GetUserPermissionsForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserPermissionsForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserPermissionsForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetUserSpecificPermissions(body: EntityDtoOfInt64 | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetUserSpecificPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetUserSpecificPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetUserSpecificPermissions(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processResetUserSpecificPermissions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUserPermissions(body: UpdateUserPermissionsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateUserPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserPermissions(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateUserPermissions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateUser(body: CreateOrUpdateUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateOrUpdateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdateUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteUser(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/DeleteUser?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unlockUser(body: EntityDtoOfInt64 | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UnlockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUnlockUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class UserEntitiesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param stateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, titleFilter: string | undefined, descriptionFilter: string | undefined, stateFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetUserEntityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/UserEntities/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetUserEntityForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetUserEntityForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetUserEntityForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetUserEntityForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetUserEntityForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUserEntityForView(id: number | undefined): Observable<GetUserEntityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/UserEntities/GetUserEntityForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserEntityForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserEntityForView(<any>response_);
                } catch (e) {
                    return <Observable<GetUserEntityForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetUserEntityForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserEntityForView(response: HttpResponseBase): Observable<GetUserEntityForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserEntityForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserEntityForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUserEntityForEdit(id: number | undefined): Observable<GetUserEntityForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/UserEntities/GetUserEntityForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserEntityForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserEntityForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetUserEntityForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetUserEntityForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserEntityForEdit(response: HttpResponseBase): Observable<GetUserEntityForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserEntityForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserEntityForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditUserEntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserEntities/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserEntities/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param stateFilter (optional) 
     * @return Success
     */
    getUserEntitiesToExcel(filter: string | undefined, titleFilter: string | undefined, descriptionFilter: string | undefined, stateFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/UserEntities/GetUserEntitiesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserEntitiesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserEntitiesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserEntitiesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class UserEntityValuesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param valueFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param stateFilter (optional) 
     * @param userEntityTitleFilter (optional) 
     * @param userEntityIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, valueFilter: string | undefined, descriptionFilter: string | undefined, stateFilter: number | undefined, userEntityTitleFilter: string | undefined, userEntityIdFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetUserEntityValueForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/UserEntityValues/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (valueFilter === null)
            throw new Error("The parameter 'valueFilter' cannot be null.");
        else if (valueFilter !== undefined)
            url_ += "ValueFilter=" + encodeURIComponent("" + valueFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (userEntityTitleFilter === null)
            throw new Error("The parameter 'userEntityTitleFilter' cannot be null.");
        else if (userEntityTitleFilter !== undefined)
            url_ += "UserEntityTitleFilter=" + encodeURIComponent("" + userEntityTitleFilter) + "&"; 
        if (userEntityIdFilter === null)
            throw new Error("The parameter 'userEntityIdFilter' cannot be null.");
        else if (userEntityIdFilter !== undefined)
            url_ += "UserEntityIdFilter=" + encodeURIComponent("" + userEntityIdFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetUserEntityValueForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetUserEntityValueForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetUserEntityValueForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetUserEntityValueForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetUserEntityValueForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUserEntityValueForView(id: number | undefined): Observable<GetUserEntityValueForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/UserEntityValues/GetUserEntityValueForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserEntityValueForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserEntityValueForView(<any>response_);
                } catch (e) {
                    return <Observable<GetUserEntityValueForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetUserEntityValueForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserEntityValueForView(response: HttpResponseBase): Observable<GetUserEntityValueForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserEntityValueForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserEntityValueForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUserEntityValueForEdit(id: number | undefined): Observable<GetUserEntityValueForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/UserEntityValues/GetUserEntityValueForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserEntityValueForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserEntityValueForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetUserEntityValueForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetUserEntityValueForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserEntityValueForEdit(response: HttpResponseBase): Observable<GetUserEntityValueForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserEntityValueForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserEntityValueForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditUserEntityValueDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserEntityValues/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserEntityValues/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param valueFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param stateFilter (optional) 
     * @param userEntityTitleFilter (optional) 
     * @return Success
     */
    getUserEntityValuesToExcel(filter: string | undefined, valueFilter: string | undefined, descriptionFilter: string | undefined, stateFilter: number | undefined, userEntityTitleFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/UserEntityValues/GetUserEntityValuesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (valueFilter === null)
            throw new Error("The parameter 'valueFilter' cannot be null.");
        else if (valueFilter !== undefined)
            url_ += "ValueFilter=" + encodeURIComponent("" + valueFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (userEntityTitleFilter === null)
            throw new Error("The parameter 'userEntityTitleFilter' cannot be null.");
        else if (userEntityTitleFilter !== undefined)
            url_ += "UserEntityTitleFilter=" + encodeURIComponent("" + userEntityTitleFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserEntityValuesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserEntityValuesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserEntityValuesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllUserEntityForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfUserEntityValueUserEntityLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/UserEntityValues/GetAllUserEntityForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUserEntityForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserEntityForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserEntityValueUserEntityLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserEntityValueUserEntityLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllUserEntityForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfUserEntityValueUserEntityLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserEntityValueUserEntityLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserEntityValueUserEntityLookupTableDto>(<any>null);
    }
}

@Injectable()
export class UserLinkServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    linkToUser(body: LinkToUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/LinkToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkToUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processLinkToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getLinkedUsers(maxResultCount: number | undefined, skipCount: number | undefined, sorting: string | undefined): Observable<PagedResultDtoOfLinkedUserDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/GetLinkedUsers?";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLinkedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLinkedUsers(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfLinkedUserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfLinkedUserDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetLinkedUsers(response: HttpResponseBase): Observable<PagedResultDtoOfLinkedUserDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLinkedUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfLinkedUserDto>(<any>null);
    }

    /**
     * @return Success
     */
    getRecentlyUsedLinkedUsers(): Observable<ListResultDtoOfLinkedUserDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/GetRecentlyUsedLinkedUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentlyUsedLinkedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentlyUsedLinkedUsers(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfLinkedUserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfLinkedUserDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRecentlyUsedLinkedUsers(response: HttpResponseBase): Observable<ListResultDtoOfLinkedUserDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfLinkedUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfLinkedUserDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unlinkUser(body: UnlinkUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/UnlinkUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlinkUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlinkUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUnlinkUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class UserLoginServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getRecentUserLoginAttempts(): Observable<ListResultDtoOfUserLoginAttemptDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLogin/GetRecentUserLoginAttempts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentUserLoginAttempts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentUserLoginAttempts(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfUserLoginAttemptDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfUserLoginAttemptDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRecentUserLoginAttempts(response: HttpResponseBase): Observable<ListResultDtoOfUserLoginAttemptDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfUserLoginAttemptDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfUserLoginAttemptDto>(<any>null);
    }
}

@Injectable()
export class VisitCountsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxCountFilter (optional) 
     * @param minCountFilter (optional) 
     * @param maxEntityRefFilter (optional) 
     * @param minEntityRefFilter (optional) 
     * @param entityFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, maxCountFilter: number | undefined, minCountFilter: number | undefined, maxEntityRefFilter: number | undefined, minEntityRefFilter: number | undefined, entityFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetVisitCountForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/VisitCounts/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxCountFilter === null)
            throw new Error("The parameter 'maxCountFilter' cannot be null.");
        else if (maxCountFilter !== undefined)
            url_ += "MaxCountFilter=" + encodeURIComponent("" + maxCountFilter) + "&"; 
        if (minCountFilter === null)
            throw new Error("The parameter 'minCountFilter' cannot be null.");
        else if (minCountFilter !== undefined)
            url_ += "MinCountFilter=" + encodeURIComponent("" + minCountFilter) + "&"; 
        if (maxEntityRefFilter === null)
            throw new Error("The parameter 'maxEntityRefFilter' cannot be null.");
        else if (maxEntityRefFilter !== undefined)
            url_ += "MaxEntityRefFilter=" + encodeURIComponent("" + maxEntityRefFilter) + "&"; 
        if (minEntityRefFilter === null)
            throw new Error("The parameter 'minEntityRefFilter' cannot be null.");
        else if (minEntityRefFilter !== undefined)
            url_ += "MinEntityRefFilter=" + encodeURIComponent("" + minEntityRefFilter) + "&"; 
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetVisitCountForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetVisitCountForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetVisitCountForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetVisitCountForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetVisitCountForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getVisitCountForView(id: number | undefined): Observable<GetVisitCountForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/VisitCounts/GetVisitCountForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVisitCountForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVisitCountForView(<any>response_);
                } catch (e) {
                    return <Observable<GetVisitCountForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetVisitCountForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetVisitCountForView(response: HttpResponseBase): Observable<GetVisitCountForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetVisitCountForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetVisitCountForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getVisitCountForEdit(id: number | undefined): Observable<GetVisitCountForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/VisitCounts/GetVisitCountForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVisitCountForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVisitCountForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetVisitCountForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetVisitCountForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetVisitCountForEdit(response: HttpResponseBase): Observable<GetVisitCountForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetVisitCountForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetVisitCountForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditVisitCountDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VisitCounts/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VisitCounts/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param maxCountFilter (optional) 
     * @param minCountFilter (optional) 
     * @param maxEntityRefFilter (optional) 
     * @param minEntityRefFilter (optional) 
     * @param entityFilter (optional) 
     * @return Success
     */
    getVisitCountsToExcel(filter: string | undefined, maxCountFilter: number | undefined, minCountFilter: number | undefined, maxEntityRefFilter: number | undefined, minEntityRefFilter: number | undefined, entityFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/VisitCounts/GetVisitCountsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxCountFilter === null)
            throw new Error("The parameter 'maxCountFilter' cannot be null.");
        else if (maxCountFilter !== undefined)
            url_ += "MaxCountFilter=" + encodeURIComponent("" + maxCountFilter) + "&"; 
        if (minCountFilter === null)
            throw new Error("The parameter 'minCountFilter' cannot be null.");
        else if (minCountFilter !== undefined)
            url_ += "MinCountFilter=" + encodeURIComponent("" + minCountFilter) + "&"; 
        if (maxEntityRefFilter === null)
            throw new Error("The parameter 'maxEntityRefFilter' cannot be null.");
        else if (maxEntityRefFilter !== undefined)
            url_ += "MaxEntityRefFilter=" + encodeURIComponent("" + maxEntityRefFilter) + "&"; 
        if (minEntityRefFilter === null)
            throw new Error("The parameter 'minEntityRefFilter' cannot be null.");
        else if (minEntityRefFilter !== undefined)
            url_ += "MinEntityRefFilter=" + encodeURIComponent("" + minEntityRefFilter) + "&"; 
        if (entityFilter === null)
            throw new Error("The parameter 'entityFilter' cannot be null.");
        else if (entityFilter !== undefined)
            url_ += "EntityFilter=" + encodeURIComponent("" + entityFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVisitCountsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVisitCountsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetVisitCountsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class VoucherDetailsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param maxAmountFilter (optional) 
     * @param minAmountFilter (optional) 
     * @param maxDueDateFilter (optional) 
     * @param minDueDateFilter (optional) 
     * @param serviceVoucherCodeFilter (optional) 
     * @param serviceVoucherIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, codeFilter: string | undefined, maxAmountFilter: number | undefined, minAmountFilter: number | undefined, maxDueDateFilter: moment.Moment | undefined, minDueDateFilter: moment.Moment | undefined, serviceVoucherCodeFilter: string | undefined, serviceVoucherIdFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetVoucherDetailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/VoucherDetails/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (codeFilter === null)
            throw new Error("The parameter 'codeFilter' cannot be null.");
        else if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&"; 
        if (maxAmountFilter === null)
            throw new Error("The parameter 'maxAmountFilter' cannot be null.");
        else if (maxAmountFilter !== undefined)
            url_ += "MaxAmountFilter=" + encodeURIComponent("" + maxAmountFilter) + "&"; 
        if (minAmountFilter === null)
            throw new Error("The parameter 'minAmountFilter' cannot be null.");
        else if (minAmountFilter !== undefined)
            url_ += "MinAmountFilter=" + encodeURIComponent("" + minAmountFilter) + "&"; 
        if (maxDueDateFilter === null)
            throw new Error("The parameter 'maxDueDateFilter' cannot be null.");
        else if (maxDueDateFilter !== undefined)
            url_ += "MaxDueDateFilter=" + encodeURIComponent(maxDueDateFilter ? "" + maxDueDateFilter.toJSON() : "") + "&"; 
        if (minDueDateFilter === null)
            throw new Error("The parameter 'minDueDateFilter' cannot be null.");
        else if (minDueDateFilter !== undefined)
            url_ += "MinDueDateFilter=" + encodeURIComponent(minDueDateFilter ? "" + minDueDateFilter.toJSON() : "") + "&"; 
        if (serviceVoucherCodeFilter === null)
            throw new Error("The parameter 'serviceVoucherCodeFilter' cannot be null.");
        else if (serviceVoucherCodeFilter !== undefined)
            url_ += "ServiceVoucherCodeFilter=" + encodeURIComponent("" + serviceVoucherCodeFilter) + "&"; 
        if (serviceVoucherIdFilter === null)
            throw new Error("The parameter 'serviceVoucherIdFilter' cannot be null.");
        else if (serviceVoucherIdFilter !== undefined)
            url_ += "ServiceVoucherIdFilter=" + encodeURIComponent("" + serviceVoucherIdFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetVoucherDetailForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetVoucherDetailForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetVoucherDetailForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetVoucherDetailForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetVoucherDetailForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getVoucherDetailForView(id: number | undefined): Observable<GetVoucherDetailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/VoucherDetails/GetVoucherDetailForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVoucherDetailForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVoucherDetailForView(<any>response_);
                } catch (e) {
                    return <Observable<GetVoucherDetailForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetVoucherDetailForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetVoucherDetailForView(response: HttpResponseBase): Observable<GetVoucherDetailForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetVoucherDetailForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetVoucherDetailForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getVoucherDetailForEdit(id: number | undefined): Observable<GetVoucherDetailForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/VoucherDetails/GetVoucherDetailForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVoucherDetailForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVoucherDetailForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetVoucherDetailForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetVoucherDetailForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetVoucherDetailForEdit(response: HttpResponseBase): Observable<GetVoucherDetailForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetVoucherDetailForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetVoucherDetailForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditVoucherDetailDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VoucherDetails/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approve(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VoucherDetails/Approve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprove(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApprove(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VoucherDetails/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param vocherDetailIds (optional) 
     * @return Success
     */
    getVoucherDetailsToExcel(vocherDetailIds: number[] | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/VoucherDetails/GetVoucherDetailsToExcel?";
        if (vocherDetailIds === null)
            throw new Error("The parameter 'vocherDetailIds' cannot be null.");
        else if (vocherDetailIds !== undefined)
            vocherDetailIds && vocherDetailIds.forEach(item => { url_ += "vocherDetailIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVoucherDetailsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVoucherDetailsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetVoucherDetailsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllServiceVoucherForLookupTable(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfVoucherDetailServiceVoucherLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/VoucherDetails/GetAllServiceVoucherForLookupTable?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllServiceVoucherForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllServiceVoucherForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfVoucherDetailServiceVoucherLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfVoucherDetailServiceVoucherLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllServiceVoucherForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfVoucherDetailServiceVoucherLookupTableDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfVoucherDetailServiceVoucherLookupTableDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfVoucherDetailServiceVoucherLookupTableDto>(<any>null);
    }

    /**
     * @return Success
     */
    checkDueVoucherDetail(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VoucherDetails/CheckDueVoucherDetail";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckDueVoucherDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckDueVoucherDetail(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCheckDueVoucherDetail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param serviceVoucherCode (optional) 
     * @return Success
     */
    getDuedVoucherDetails(serviceVoucherCode: string | undefined): Observable<moment.Moment[]> {
        let url_ = this.baseUrl + "/api/services/app/VoucherDetails/GetDuedVoucherDetails?";
        if (serviceVoucherCode === null)
            throw new Error("The parameter 'serviceVoucherCode' cannot be null.");
        else if (serviceVoucherCode !== undefined)
            url_ += "serviceVoucherCode=" + encodeURIComponent("" + serviceVoucherCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDuedVoucherDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDuedVoucherDetails(<any>response_);
                } catch (e) {
                    return <Observable<moment.Moment[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<moment.Moment[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetDuedVoucherDetails(response: HttpResponseBase): Observable<moment.Moment[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(moment(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<moment.Moment[]>(<any>null);
    }
}

@Injectable()
export class WagesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param classNameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param maxCreatedFilter (optional) 
     * @param minCreatedFilter (optional) 
     * @param maxCreatedByFilter (optional) 
     * @param minCreatedByFilter (optional) 
     * @param maxModifiedFilter (optional) 
     * @param minModifiedFilter (optional) 
     * @param maxModifiedByFilter (optional) 
     * @param minModifiedByFilter (optional) 
     * @param stateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, titleFilter: string | undefined, classNameFilter: number | undefined, descriptionFilter: string | undefined, maxCreatedFilter: moment.Moment | undefined, minCreatedFilter: moment.Moment | undefined, maxCreatedByFilter: number | undefined, minCreatedByFilter: number | undefined, maxModifiedFilter: moment.Moment | undefined, minModifiedFilter: moment.Moment | undefined, maxModifiedByFilter: number | undefined, minModifiedByFilter: number | undefined, stateFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetWageForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Wages/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (classNameFilter === null)
            throw new Error("The parameter 'classNameFilter' cannot be null.");
        else if (classNameFilter !== undefined)
            url_ += "ClassNameFilter=" + encodeURIComponent("" + classNameFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (maxCreatedFilter === null)
            throw new Error("The parameter 'maxCreatedFilter' cannot be null.");
        else if (maxCreatedFilter !== undefined)
            url_ += "MaxCreatedFilter=" + encodeURIComponent(maxCreatedFilter ? "" + maxCreatedFilter.toJSON() : "") + "&"; 
        if (minCreatedFilter === null)
            throw new Error("The parameter 'minCreatedFilter' cannot be null.");
        else if (minCreatedFilter !== undefined)
            url_ += "MinCreatedFilter=" + encodeURIComponent(minCreatedFilter ? "" + minCreatedFilter.toJSON() : "") + "&"; 
        if (maxCreatedByFilter === null)
            throw new Error("The parameter 'maxCreatedByFilter' cannot be null.");
        else if (maxCreatedByFilter !== undefined)
            url_ += "MaxCreatedByFilter=" + encodeURIComponent("" + maxCreatedByFilter) + "&"; 
        if (minCreatedByFilter === null)
            throw new Error("The parameter 'minCreatedByFilter' cannot be null.");
        else if (minCreatedByFilter !== undefined)
            url_ += "MinCreatedByFilter=" + encodeURIComponent("" + minCreatedByFilter) + "&"; 
        if (maxModifiedFilter === null)
            throw new Error("The parameter 'maxModifiedFilter' cannot be null.");
        else if (maxModifiedFilter !== undefined)
            url_ += "MaxModifiedFilter=" + encodeURIComponent(maxModifiedFilter ? "" + maxModifiedFilter.toJSON() : "") + "&"; 
        if (minModifiedFilter === null)
            throw new Error("The parameter 'minModifiedFilter' cannot be null.");
        else if (minModifiedFilter !== undefined)
            url_ += "MinModifiedFilter=" + encodeURIComponent(minModifiedFilter ? "" + minModifiedFilter.toJSON() : "") + "&"; 
        if (maxModifiedByFilter === null)
            throw new Error("The parameter 'maxModifiedByFilter' cannot be null.");
        else if (maxModifiedByFilter !== undefined)
            url_ += "MaxModifiedByFilter=" + encodeURIComponent("" + maxModifiedByFilter) + "&"; 
        if (minModifiedByFilter === null)
            throw new Error("The parameter 'minModifiedByFilter' cannot be null.");
        else if (minModifiedByFilter !== undefined)
            url_ += "MinModifiedByFilter=" + encodeURIComponent("" + minModifiedByFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetWageForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetWageForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetWageForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetWageForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetWageForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getWageForView(id: number | undefined): Observable<GetWageForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Wages/GetWageForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWageForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWageForView(<any>response_);
                } catch (e) {
                    return <Observable<GetWageForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetWageForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetWageForView(response: HttpResponseBase): Observable<GetWageForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetWageForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetWageForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getWageForEdit(id: number | undefined): Observable<GetWageForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Wages/GetWageForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWageForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWageForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetWageForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetWageForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetWageForEdit(response: HttpResponseBase): Observable<GetWageForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetWageForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetWageForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditWageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Wages/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Wages/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param classNameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param maxCreatedFilter (optional) 
     * @param minCreatedFilter (optional) 
     * @param maxCreatedByFilter (optional) 
     * @param minCreatedByFilter (optional) 
     * @param maxModifiedFilter (optional) 
     * @param minModifiedFilter (optional) 
     * @param maxModifiedByFilter (optional) 
     * @param minModifiedByFilter (optional) 
     * @param stateFilter (optional) 
     * @return Success
     */
    getWagesToExcel(filter: string | undefined, titleFilter: string | undefined, classNameFilter: number | undefined, descriptionFilter: string | undefined, maxCreatedFilter: moment.Moment | undefined, minCreatedFilter: moment.Moment | undefined, maxCreatedByFilter: number | undefined, minCreatedByFilter: number | undefined, maxModifiedFilter: moment.Moment | undefined, minModifiedFilter: moment.Moment | undefined, maxModifiedByFilter: number | undefined, minModifiedByFilter: number | undefined, stateFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Wages/GetWagesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (titleFilter === null)
            throw new Error("The parameter 'titleFilter' cannot be null.");
        else if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&"; 
        if (classNameFilter === null)
            throw new Error("The parameter 'classNameFilter' cannot be null.");
        else if (classNameFilter !== undefined)
            url_ += "ClassNameFilter=" + encodeURIComponent("" + classNameFilter) + "&"; 
        if (descriptionFilter === null)
            throw new Error("The parameter 'descriptionFilter' cannot be null.");
        else if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&"; 
        if (maxCreatedFilter === null)
            throw new Error("The parameter 'maxCreatedFilter' cannot be null.");
        else if (maxCreatedFilter !== undefined)
            url_ += "MaxCreatedFilter=" + encodeURIComponent(maxCreatedFilter ? "" + maxCreatedFilter.toJSON() : "") + "&"; 
        if (minCreatedFilter === null)
            throw new Error("The parameter 'minCreatedFilter' cannot be null.");
        else if (minCreatedFilter !== undefined)
            url_ += "MinCreatedFilter=" + encodeURIComponent(minCreatedFilter ? "" + minCreatedFilter.toJSON() : "") + "&"; 
        if (maxCreatedByFilter === null)
            throw new Error("The parameter 'maxCreatedByFilter' cannot be null.");
        else if (maxCreatedByFilter !== undefined)
            url_ += "MaxCreatedByFilter=" + encodeURIComponent("" + maxCreatedByFilter) + "&"; 
        if (minCreatedByFilter === null)
            throw new Error("The parameter 'minCreatedByFilter' cannot be null.");
        else if (minCreatedByFilter !== undefined)
            url_ += "MinCreatedByFilter=" + encodeURIComponent("" + minCreatedByFilter) + "&"; 
        if (maxModifiedFilter === null)
            throw new Error("The parameter 'maxModifiedFilter' cannot be null.");
        else if (maxModifiedFilter !== undefined)
            url_ += "MaxModifiedFilter=" + encodeURIComponent(maxModifiedFilter ? "" + maxModifiedFilter.toJSON() : "") + "&"; 
        if (minModifiedFilter === null)
            throw new Error("The parameter 'minModifiedFilter' cannot be null.");
        else if (minModifiedFilter !== undefined)
            url_ += "MinModifiedFilter=" + encodeURIComponent(minModifiedFilter ? "" + minModifiedFilter.toJSON() : "") + "&"; 
        if (maxModifiedByFilter === null)
            throw new Error("The parameter 'maxModifiedByFilter' cannot be null.");
        else if (maxModifiedByFilter !== undefined)
            url_ += "MaxModifiedByFilter=" + encodeURIComponent("" + maxModifiedByFilter) + "&"; 
        if (minModifiedByFilter === null)
            throw new Error("The parameter 'minModifiedByFilter' cannot be null.");
        else if (minModifiedByFilter !== undefined)
            url_ += "MinModifiedByFilter=" + encodeURIComponent("" + minModifiedByFilter) + "&"; 
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWagesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWagesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetWagesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class WebLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getLatestWebLogs(): Observable<GetLatestWebLogsOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebLog/GetLatestWebLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestWebLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestWebLogs(<any>response_);
                } catch (e) {
                    return <Observable<GetLatestWebLogsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetLatestWebLogsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetLatestWebLogs(response: HttpResponseBase): Observable<GetLatestWebLogsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLatestWebLogsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLatestWebLogsOutput>(<any>null);
    }

    /**
     * @return Success
     */
    downloadWebLogs(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/WebLog/DownloadWebLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadWebLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadWebLogs(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processDownloadWebLogs(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class WizardStepsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param planTypeFilter (optional) 
     * @param stepsFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, planTypeFilter: number | undefined, stepsFilter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetWizardStepForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/WizardSteps/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (planTypeFilter === null)
            throw new Error("The parameter 'planTypeFilter' cannot be null.");
        else if (planTypeFilter !== undefined)
            url_ += "PlanTypeFilter=" + encodeURIComponent("" + planTypeFilter) + "&"; 
        if (stepsFilter === null)
            throw new Error("The parameter 'stepsFilter' cannot be null.");
        else if (stepsFilter !== undefined)
            url_ += "StepsFilter=" + encodeURIComponent("" + stepsFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetWizardStepForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetWizardStepForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetWizardStepForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetWizardStepForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetWizardStepForViewDto>(<any>null);
    }

    /**
     * @param code (optional) 
     * @param wizardPath (optional) 
     * @return Success
     */
    getWizardStepsForShop(planType: Plans, code: string | undefined, wizardPath: number | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/WizardSteps/GetWizardStepsForShop?";
        if (planType === undefined || planType === null)
            throw new Error("The parameter 'planType' must be defined and cannot be null.");
        else
            url_ += "planType=" + encodeURIComponent("" + planType) + "&"; 
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "Code=" + encodeURIComponent("" + code) + "&"; 
        if (wizardPath === null)
            throw new Error("The parameter 'wizardPath' cannot be null.");
        else if (wizardPath !== undefined)
            url_ += "wizardPath=" + encodeURIComponent("" + wizardPath) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWizardStepsForShop(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWizardStepsForShop(<any>response_);
                } catch (e) {
                    return <Observable<number[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<number[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetWizardStepsForShop(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getWizardStepForView(id: number | undefined): Observable<GetWizardStepForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/WizardSteps/GetWizardStepForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWizardStepForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWizardStepForView(<any>response_);
                } catch (e) {
                    return <Observable<GetWizardStepForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetWizardStepForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetWizardStepForView(response: HttpResponseBase): Observable<GetWizardStepForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetWizardStepForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetWizardStepForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getWizardStepForEdit(id: number | undefined): Observable<GetWizardStepForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/WizardSteps/GetWizardStepForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWizardStepForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWizardStepForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetWizardStepForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetWizardStepForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetWizardStepForEdit(response: HttpResponseBase): Observable<GetWizardStepForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetWizardStepForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetWizardStepForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditWizardStepDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WizardSteps/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditList(body: CreateOrEditWizardStepDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WizardSteps/CreateOrEditList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditList(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WizardSteps/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param planTypeFilter (optional) 
     * @param stepsFilter (optional) 
     * @return Success
     */
    getWizardStepsToExcel(filter: string | undefined, planTypeFilter: number | undefined, stepsFilter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/WizardSteps/GetWizardStepsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (planTypeFilter === null)
            throw new Error("The parameter 'planTypeFilter' cannot be null.");
        else if (planTypeFilter !== undefined)
            url_ += "PlanTypeFilter=" + encodeURIComponent("" + planTypeFilter) + "&"; 
        if (stepsFilter === null)
            throw new Error("The parameter 'stepsFilter' cannot be null.");
        else if (stepsFilter !== undefined)
            url_ += "StepsFilter=" + encodeURIComponent("" + stepsFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWizardStepsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWizardStepsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetWizardStepsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName!: string | undefined;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data; 
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string | undefined;
}

export enum TenantAvailabilityState {
    Available = 1,
    InActive = 2,
    NotFound = 3,
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state!: TenantAvailabilityState;
    tenantId!: number | undefined;
    serverRootAddress!: string | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.state = data["state"];
            this.tenantId = data["tenantId"];
            this.serverRootAddress = data["serverRootAddress"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        data["serverRootAddress"] = this.serverRootAddress;
        return data; 
    }
}

export interface IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;
    serverRootAddress: string | undefined;
}

export class ResolveTenantIdInput implements IResolveTenantIdInput {
    c!: string | undefined;

    constructor(data?: IResolveTenantIdInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.c = data["c"];
        }
    }

    static fromJS(data: any): ResolveTenantIdInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResolveTenantIdInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["c"] = this.c;
        return data; 
    }
}

export interface IResolveTenantIdInput {
    c: string | undefined;
}

export class RegisterInput implements IRegisterInput {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    password!: string | undefined;
    captchaResponse!: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.password = data["password"];
            this.captchaResponse = data["captchaResponse"];
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data; 
    }
}

export interface IRegisterInput {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    password: string | undefined;
    captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin!: boolean;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.canLogin = data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data; 
    }
}

export interface IRegisterOutput {
    canLogin: boolean;
}

export class SendPasswordResetCodeInput implements ISendPasswordResetCodeInput {
    emailAddress!: string | undefined;

    constructor(data?: ISendPasswordResetCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.emailAddress = data["emailAddress"];
        }
    }

    static fromJS(data: any): SendPasswordResetCodeInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendPasswordResetCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data; 
    }
}

export interface ISendPasswordResetCodeInput {
    emailAddress: string | undefined;
}

export class ResetPasswordInput implements IResetPasswordInput {
    userId!: number;
    resetCode!: string | undefined;
    password!: string | undefined;
    returnUrl!: string | undefined;
    singleSignIn!: string | undefined;
    c!: string | undefined;

    constructor(data?: IResetPasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.resetCode = data["resetCode"];
            this.password = data["password"];
            this.returnUrl = data["returnUrl"];
            this.singleSignIn = data["singleSignIn"];
            this.c = data["c"];
        }
    }

    static fromJS(data: any): ResetPasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["resetCode"] = this.resetCode;
        data["password"] = this.password;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        data["c"] = this.c;
        return data; 
    }
}

export interface IResetPasswordInput {
    userId: number;
    resetCode: string | undefined;
    password: string | undefined;
    returnUrl: string | undefined;
    singleSignIn: string | undefined;
    c: string | undefined;
}

export class ResetPasswordOutput implements IResetPasswordOutput {
    canLogin!: boolean;
    userName!: string | undefined;

    constructor(data?: IResetPasswordOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.canLogin = data["canLogin"];
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): ResetPasswordOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        data["userName"] = this.userName;
        return data; 
    }
}

export interface IResetPasswordOutput {
    canLogin: boolean;
    userName: string | undefined;
}

export class SendEmailActivationLinkInput implements ISendEmailActivationLinkInput {
    emailAddress!: string | undefined;

    constructor(data?: ISendEmailActivationLinkInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.emailAddress = data["emailAddress"];
        }
    }

    static fromJS(data: any): SendEmailActivationLinkInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendEmailActivationLinkInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data; 
    }
}

export interface ISendEmailActivationLinkInput {
    emailAddress: string | undefined;
}

export class ActivateEmailInput implements IActivateEmailInput {
    userId!: number;
    confirmationCode!: string | undefined;
    c!: string | undefined;

    constructor(data?: IActivateEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.confirmationCode = data["confirmationCode"];
            this.c = data["c"];
        }
    }

    static fromJS(data: any): ActivateEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new ActivateEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["confirmationCode"] = this.confirmationCode;
        data["c"] = this.c;
        return data; 
    }
}

export interface IActivateEmailInput {
    userId: number;
    confirmationCode: string | undefined;
    c: string | undefined;
}

export class ImpersonateInput implements IImpersonateInput {
    tenantId!: number | undefined;
    userId!: number;

    constructor(data?: IImpersonateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
        }
    }

    static fromJS(data: any): ImpersonateInput {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data; 
    }
}

export interface IImpersonateInput {
    tenantId: number | undefined;
    userId: number;
}

export class ImpersonateOutput implements IImpersonateOutput {
    impersonationToken!: string | undefined;
    tenancyName!: string | undefined;

    constructor(data?: IImpersonateOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.impersonationToken = data["impersonationToken"];
            this.tenancyName = data["tenancyName"];
        }
    }

    static fromJS(data: any): ImpersonateOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonateOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["impersonationToken"] = this.impersonationToken;
        data["tenancyName"] = this.tenancyName;
        return data; 
    }
}

export interface IImpersonateOutput {
    impersonationToken: string | undefined;
    tenancyName: string | undefined;
}

export class SwitchToLinkedAccountInput implements ISwitchToLinkedAccountInput {
    targetTenantId!: number | undefined;
    targetUserId!: number;

    constructor(data?: ISwitchToLinkedAccountInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetTenantId = data["targetTenantId"];
            this.targetUserId = data["targetUserId"];
        }
    }

    static fromJS(data: any): SwitchToLinkedAccountInput {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchToLinkedAccountInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetTenantId"] = this.targetTenantId;
        data["targetUserId"] = this.targetUserId;
        return data; 
    }
}

export interface ISwitchToLinkedAccountInput {
    targetTenantId: number | undefined;
    targetUserId: number;
}

export class SwitchToLinkedAccountOutput implements ISwitchToLinkedAccountOutput {
    switchAccountToken!: string | undefined;
    tenancyName!: string | undefined;

    constructor(data?: ISwitchToLinkedAccountOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.switchAccountToken = data["switchAccountToken"];
            this.tenancyName = data["tenancyName"];
        }
    }

    static fromJS(data: any): SwitchToLinkedAccountOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchToLinkedAccountOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["switchAccountToken"] = this.switchAccountToken;
        data["tenancyName"] = this.tenancyName;
        return data; 
    }
}

export interface ISwitchToLinkedAccountOutput {
    switchAccountToken: string | undefined;
    tenancyName: string | undefined;
}

export enum BankDiskTypes {
    Meli = 1,
    Melat = 2,
}

export enum AccountTypes {
    Rial = 1,
    Number = 2,
}

export class AccountDto implements IAccountDto {
    name!: string | undefined;
    description!: string | undefined;
    userName!: string | undefined;
    password!: string | undefined;
    isGlobal!: boolean;
    accessList!: string | undefined;
    bankDiskType!: BankDiskTypes;
    accountType!: AccountTypes;
    bankAccountType!: number | undefined;
    id!: number;

    constructor(data?: IAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.description = data["description"];
            this.userName = data["userName"];
            this.password = data["password"];
            this.isGlobal = data["isGlobal"];
            this.accessList = data["accessList"];
            this.bankDiskType = data["bankDiskType"];
            this.accountType = data["accountType"];
            this.bankAccountType = data["bankAccountType"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["isGlobal"] = this.isGlobal;
        data["accessList"] = this.accessList;
        data["bankDiskType"] = this.bankDiskType;
        data["accountType"] = this.accountType;
        data["bankAccountType"] = this.bankAccountType;
        data["id"] = this.id;
        return data; 
    }
}

export interface IAccountDto {
    name: string | undefined;
    description: string | undefined;
    userName: string | undefined;
    password: string | undefined;
    isGlobal: boolean;
    accessList: string | undefined;
    bankDiskType: BankDiskTypes;
    accountType: AccountTypes;
    bankAccountType: number | undefined;
    id: number;
}

export class GetAccountForViewDto implements IGetAccountForViewDto {
    account!: AccountDto;

    constructor(data?: IGetAccountForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.account = data["account"] ? AccountDto.fromJS(data["account"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAccountForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccountForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetAccountForViewDto {
    account: AccountDto;
}

export class PagedResultDtoOfGetAccountForViewDto implements IPagedResultDtoOfGetAccountForViewDto {
    totalCount!: number;
    items!: GetAccountForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAccountForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetAccountForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAccountForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAccountForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetAccountForViewDto {
    totalCount: number;
    items: GetAccountForViewDto[] | undefined;
}

export class CreateOrEditAccountDto implements ICreateOrEditAccountDto {
    name!: string | undefined;
    description!: string | undefined;
    userName!: string | undefined;
    password!: string | undefined;
    isGlobal!: boolean;
    accessList!: string | undefined;
    bankDiskType!: BankDiskTypes;
    accountType!: AccountTypes;
    bankAccountType!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.description = data["description"];
            this.userName = data["userName"];
            this.password = data["password"];
            this.isGlobal = data["isGlobal"];
            this.accessList = data["accessList"];
            this.bankDiskType = data["bankDiskType"];
            this.accountType = data["accountType"];
            this.bankAccountType = data["bankAccountType"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["isGlobal"] = this.isGlobal;
        data["accessList"] = this.accessList;
        data["bankDiskType"] = this.bankDiskType;
        data["accountType"] = this.accountType;
        data["bankAccountType"] = this.bankAccountType;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditAccountDto {
    name: string | undefined;
    description: string | undefined;
    userName: string | undefined;
    password: string | undefined;
    isGlobal: boolean;
    accessList: string | undefined;
    bankDiskType: BankDiskTypes;
    accountType: AccountTypes;
    bankAccountType: number | undefined;
    id: number | undefined;
}

export class GetAccountForEditOutput implements IGetAccountForEditOutput {
    account!: CreateOrEditAccountDto;

    constructor(data?: IGetAccountForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.account = data["account"] ? CreateOrEditAccountDto.fromJS(data["account"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAccountForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccountForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetAccountForEditOutput {
    account: CreateOrEditAccountDto;
}

export class FileDto implements IFileDto {
    fileName!: string | undefined;
    fileType!: string | undefined;
    fileToken!: string | undefined;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.fileType = data["fileType"];
            this.fileToken = data["fileToken"];
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data; 
    }
}

export interface IFileDto {
    fileName: string | undefined;
    fileType: string | undefined;
    fileToken: string | undefined;
}

export enum Entities {
    Default = 0,
    Direction = 1,
    UserEntity = 2,
    Source = 3,
    PlanConsts = 4,
    PlanCategory = 5,
    FlowerCrown = 6,
    Contact = 7,
    TemplateDatas = 8,
    Deceased = 9,
    Location = 10,
    Family = 11,
    GroupSubgroup = 12,
    Client = 13,
    Payment = 14,
    Branch = 15,
    MoneyBox = 16,
    LegalContact = 17,
    Area = 18,
    BranchDirection = 19,
    Consume = 20,
    Bill = 21,
    PlanBill = 22,
    Ceremony = 23,
    Attribute = 24,
    Sacrifice = 25,
}

export class AddressDto implements IAddressDto {
    title!: string | undefined;
    streetAlley!: string | undefined;
    houseNumber!: number | undefined;
    floor!: number | undefined;
    phoneNumber!: string | undefined;
    postalCode!: string | undefined;
    latitude!: number | undefined;
    longitude!: number | undefined;
    area!: number | undefined;
    default!: boolean;
    entityRef!: number;
    entity!: Entities;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    description!: string | undefined;
    stateId!: number;
    cityId!: number;
    countryId!: number;
    id!: number;

    constructor(data?: IAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.streetAlley = data["streetAlley"];
            this.houseNumber = data["houseNumber"];
            this.floor = data["floor"];
            this.phoneNumber = data["phoneNumber"];
            this.postalCode = data["postalCode"];
            this.latitude = data["latitude"];
            this.longitude = data["longitude"];
            this.area = data["area"];
            this.default = data["default"];
            this.entityRef = data["entityRef"];
            this.entity = data["entity"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.description = data["description"];
            this.stateId = data["stateId"];
            this.cityId = data["cityId"];
            this.countryId = data["countryId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["streetAlley"] = this.streetAlley;
        data["houseNumber"] = this.houseNumber;
        data["floor"] = this.floor;
        data["phoneNumber"] = this.phoneNumber;
        data["postalCode"] = this.postalCode;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["area"] = this.area;
        data["default"] = this.default;
        data["entityRef"] = this.entityRef;
        data["entity"] = this.entity;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["stateId"] = this.stateId;
        data["cityId"] = this.cityId;
        data["countryId"] = this.countryId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IAddressDto {
    title: string | undefined;
    streetAlley: string | undefined;
    houseNumber: number | undefined;
    floor: number | undefined;
    phoneNumber: string | undefined;
    postalCode: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    area: number | undefined;
    default: boolean;
    entityRef: number;
    entity: Entities;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    description: string | undefined;
    stateId: number;
    cityId: number;
    countryId: number;
    id: number;
}

export class GetAddressForViewDto implements IGetAddressForViewDto {
    address!: AddressDto;
    stateName!: string | undefined;
    cityName!: string | undefined;
    countryName!: string | undefined;
    editable!: boolean;

    constructor(data?: IGetAddressForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.address = data["address"] ? AddressDto.fromJS(data["address"]) : <any>undefined;
            this.stateName = data["stateName"];
            this.cityName = data["cityName"];
            this.countryName = data["countryName"];
            this.editable = data["editable"];
        }
    }

    static fromJS(data: any): GetAddressForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAddressForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["stateName"] = this.stateName;
        data["cityName"] = this.cityName;
        data["countryName"] = this.countryName;
        data["editable"] = this.editable;
        return data; 
    }
}

export interface IGetAddressForViewDto {
    address: AddressDto;
    stateName: string | undefined;
    cityName: string | undefined;
    countryName: string | undefined;
    editable: boolean;
}

export class PagedResultDtoOfGetAddressForViewDto implements IPagedResultDtoOfGetAddressForViewDto {
    totalCount!: number;
    items!: GetAddressForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAddressForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetAddressForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAddressForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAddressForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetAddressForViewDto {
    totalCount: number;
    items: GetAddressForViewDto[] | undefined;
}

export class CreateOrEditAddressDto implements ICreateOrEditAddressDto {
    title!: string | undefined;
    streetAlley!: string | undefined;
    houseNumber!: number | undefined;
    floor!: number | undefined;
    phoneNumber!: string | undefined;
    postalCode!: string | undefined;
    latitude!: number | undefined;
    longitude!: number | undefined;
    area!: number | undefined;
    default!: boolean;
    entityRef!: number;
    entity!: Entities;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    description!: string | undefined;
    stateId!: number;
    cityId!: number;
    countryId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.streetAlley = data["streetAlley"];
            this.houseNumber = data["houseNumber"];
            this.floor = data["floor"];
            this.phoneNumber = data["phoneNumber"];
            this.postalCode = data["postalCode"];
            this.latitude = data["latitude"];
            this.longitude = data["longitude"];
            this.area = data["area"];
            this.default = data["default"];
            this.entityRef = data["entityRef"];
            this.entity = data["entity"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.description = data["description"];
            this.stateId = data["stateId"];
            this.cityId = data["cityId"];
            this.countryId = data["countryId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["streetAlley"] = this.streetAlley;
        data["houseNumber"] = this.houseNumber;
        data["floor"] = this.floor;
        data["phoneNumber"] = this.phoneNumber;
        data["postalCode"] = this.postalCode;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["area"] = this.area;
        data["default"] = this.default;
        data["entityRef"] = this.entityRef;
        data["entity"] = this.entity;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["stateId"] = this.stateId;
        data["cityId"] = this.cityId;
        data["countryId"] = this.countryId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditAddressDto {
    title: string | undefined;
    streetAlley: string | undefined;
    houseNumber: number | undefined;
    floor: number | undefined;
    phoneNumber: string | undefined;
    postalCode: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    area: number | undefined;
    default: boolean;
    entityRef: number;
    entity: Entities;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    description: string | undefined;
    stateId: number;
    cityId: number;
    countryId: number;
    id: number | undefined;
}

export class GetAddressForEditOutput implements IGetAddressForEditOutput {
    address!: CreateOrEditAddressDto;
    stateName!: string | undefined;
    cityName!: string | undefined;
    countryName!: string | undefined;
    cityLatitude!: number | undefined;
    cityLongitude!: number | undefined;
    creatorUserId!: number | undefined;
    lastModifierUserId!: number | undefined;

    constructor(data?: IGetAddressForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.address = data["address"] ? CreateOrEditAddressDto.fromJS(data["address"]) : <any>undefined;
            this.stateName = data["stateName"];
            this.cityName = data["cityName"];
            this.countryName = data["countryName"];
            this.cityLatitude = data["cityLatitude"];
            this.cityLongitude = data["cityLongitude"];
            this.creatorUserId = data["creatorUserId"];
            this.lastModifierUserId = data["lastModifierUserId"];
        }
    }

    static fromJS(data: any): GetAddressForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAddressForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["stateName"] = this.stateName;
        data["cityName"] = this.cityName;
        data["countryName"] = this.countryName;
        data["cityLatitude"] = this.cityLatitude;
        data["cityLongitude"] = this.cityLongitude;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        return data; 
    }
}

export interface IGetAddressForEditOutput {
    address: CreateOrEditAddressDto;
    stateName: string | undefined;
    cityName: string | undefined;
    countryName: string | undefined;
    cityLatitude: number | undefined;
    cityLongitude: number | undefined;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
}

export class GetAddressForContactsDto implements IGetAddressForContactsDto {
    address!: AddressDto;
    creatorUserId!: number | undefined;
    lastModifierUserId!: number | undefined;
    stateName!: string | undefined;
    cityName!: string | undefined;
    countryName!: string | undefined;

    constructor(data?: IGetAddressForContactsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.address = data["address"] ? AddressDto.fromJS(data["address"]) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.lastModifierUserId = data["lastModifierUserId"];
            this.stateName = data["stateName"];
            this.cityName = data["cityName"];
            this.countryName = data["countryName"];
        }
    }

    static fromJS(data: any): GetAddressForContactsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAddressForContactsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["stateName"] = this.stateName;
        data["cityName"] = this.cityName;
        data["countryName"] = this.countryName;
        return data; 
    }
}

export interface IGetAddressForContactsDto {
    address: AddressDto;
    creatorUserId: number | undefined;
    lastModifierUserId: number | undefined;
    stateName: string | undefined;
    cityName: string | undefined;
    countryName: string | undefined;
}

export class AddressStateLookupTableDto implements IAddressStateLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IAddressStateLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): AddressStateLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressStateLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IAddressStateLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfAddressStateLookupTableDto implements IPagedResultDtoOfAddressStateLookupTableDto {
    totalCount!: number;
    items!: AddressStateLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAddressStateLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(AddressStateLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAddressStateLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAddressStateLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfAddressStateLookupTableDto {
    totalCount: number;
    items: AddressStateLookupTableDto[] | undefined;
}

export class AddressCityLookupTableDto implements IAddressCityLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IAddressCityLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): AddressCityLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressCityLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IAddressCityLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfAddressCityLookupTableDto implements IPagedResultDtoOfAddressCityLookupTableDto {
    totalCount!: number;
    items!: AddressCityLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAddressCityLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(AddressCityLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAddressCityLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAddressCityLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfAddressCityLookupTableDto {
    totalCount: number;
    items: AddressCityLookupTableDto[] | undefined;
}

export class AddressCountryLookupTableDto implements IAddressCountryLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IAddressCountryLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): AddressCountryLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressCountryLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IAddressCountryLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfAddressCountryLookupTableDto implements IPagedResultDtoOfAddressCountryLookupTableDto {
    totalCount!: number;
    items!: AddressCountryLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAddressCountryLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(AddressCountryLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAddressCountryLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAddressCountryLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfAddressCountryLookupTableDto {
    totalCount: number;
    items: AddressCountryLookupTableDto[] | undefined;
}

export enum Plans {
    Default = 0,
    Charity = 1,
    FlowerCrown = 2,
    Sacrifice = 3,
    MoneyBox = 4,
    SendPostman = 5,
    ForDeceased = 6,
    Clip = 7,
}

export class GetAddressInfoDto implements IGetAddressInfoDto {
    latitude!: number | undefined;
    longitude!: number | undefined;

    constructor(data?: IGetAddressInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.latitude = data["latitude"];
            this.longitude = data["longitude"];
        }
    }

    static fromJS(data: any): GetAddressInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAddressInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data; 
    }
}

export interface IGetAddressInfoDto {
    latitude: number | undefined;
    longitude: number | undefined;
}

export class AmbassadorDto implements IAmbassadorDto {
    service!: Plans;
    contactId!: number;
    directionId!: number;
    id!: number;

    constructor(data?: IAmbassadorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.service = data["service"];
            this.contactId = data["contactId"];
            this.directionId = data["directionId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AmbassadorDto {
        data = typeof data === 'object' ? data : {};
        let result = new AmbassadorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["service"] = this.service;
        data["contactId"] = this.contactId;
        data["directionId"] = this.directionId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IAmbassadorDto {
    service: Plans;
    contactId: number;
    directionId: number;
    id: number;
}

export class GetAmbassadorForViewDto implements IGetAmbassadorForViewDto {
    ambassador!: AmbassadorDto;
    directionName!: string | undefined;

    constructor(data?: IGetAmbassadorForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ambassador = data["ambassador"] ? AmbassadorDto.fromJS(data["ambassador"]) : <any>undefined;
            this.directionName = data["directionName"];
        }
    }

    static fromJS(data: any): GetAmbassadorForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAmbassadorForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ambassador"] = this.ambassador ? this.ambassador.toJSON() : <any>undefined;
        data["directionName"] = this.directionName;
        return data; 
    }
}

export interface IGetAmbassadorForViewDto {
    ambassador: AmbassadorDto;
    directionName: string | undefined;
}

export class PagedResultDtoOfGetAmbassadorForViewDto implements IPagedResultDtoOfGetAmbassadorForViewDto {
    totalCount!: number;
    items!: GetAmbassadorForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAmbassadorForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetAmbassadorForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAmbassadorForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAmbassadorForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetAmbassadorForViewDto {
    totalCount: number;
    items: GetAmbassadorForViewDto[] | undefined;
}

export class CreateOrEditAmbassadorDto implements ICreateOrEditAmbassadorDto {
    service!: Plans;
    contactId!: number;
    directionId!: number;
    id!: number;

    constructor(data?: ICreateOrEditAmbassadorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.service = data["service"];
            this.contactId = data["contactId"];
            this.directionId = data["directionId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditAmbassadorDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAmbassadorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["service"] = this.service;
        data["contactId"] = this.contactId;
        data["directionId"] = this.directionId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditAmbassadorDto {
    service: Plans;
    contactId: number;
    directionId: number;
    id: number;
}

export class GetAmbassadorForEditOutput implements IGetAmbassadorForEditOutput {
    ambassador!: CreateOrEditAmbassadorDto;
    directionName!: string | undefined;

    constructor(data?: IGetAmbassadorForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ambassador = data["ambassador"] ? CreateOrEditAmbassadorDto.fromJS(data["ambassador"]) : <any>undefined;
            this.directionName = data["directionName"];
        }
    }

    static fromJS(data: any): GetAmbassadorForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAmbassadorForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ambassador"] = this.ambassador ? this.ambassador.toJSON() : <any>undefined;
        data["directionName"] = this.directionName;
        return data; 
    }
}

export interface IGetAmbassadorForEditOutput {
    ambassador: CreateOrEditAmbassadorDto;
    directionName: string | undefined;
}

export class AmbassadorDirectionLookupTableDto implements IAmbassadorDirectionLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IAmbassadorDirectionLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): AmbassadorDirectionLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new AmbassadorDirectionLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IAmbassadorDirectionLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfAmbassadorDirectionLookupTableDto implements IPagedResultDtoOfAmbassadorDirectionLookupTableDto {
    totalCount!: number;
    items!: AmbassadorDirectionLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAmbassadorDirectionLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(AmbassadorDirectionLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAmbassadorDirectionLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAmbassadorDirectionLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfAmbassadorDirectionLookupTableDto {
    totalCount: number;
    items: AmbassadorDirectionLookupTableDto[] | undefined;
}

export class PagedResultDtoOfGetAmbassadorForEditOutput implements IPagedResultDtoOfGetAmbassadorForEditOutput {
    totalCount!: number;
    items!: GetAmbassadorForEditOutput[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAmbassadorForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetAmbassadorForEditOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAmbassadorForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAmbassadorForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetAmbassadorForEditOutput {
    totalCount: number;
    items: GetAmbassadorForEditOutput[] | undefined;
}

export class AreaDto implements IAreaDto {
    name!: string | undefined;
    state!: boolean;
    description!: string | undefined;
    cityId!: number;
    id!: number;

    constructor(data?: IAreaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.state = data["state"];
            this.description = data["description"];
            this.cityId = data["cityId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AreaDto {
        data = typeof data === 'object' ? data : {};
        let result = new AreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["state"] = this.state;
        data["description"] = this.description;
        data["cityId"] = this.cityId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IAreaDto {
    name: string | undefined;
    state: boolean;
    description: string | undefined;
    cityId: number;
    id: number;
}

export class GetAreaForViewDto implements IGetAreaForViewDto {
    area!: AreaDto;
    cityName!: string | undefined;

    constructor(data?: IGetAreaForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.area = data["area"] ? AreaDto.fromJS(data["area"]) : <any>undefined;
            this.cityName = data["cityName"];
        }
    }

    static fromJS(data: any): GetAreaForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAreaForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["area"] = this.area ? this.area.toJSON() : <any>undefined;
        data["cityName"] = this.cityName;
        return data; 
    }
}

export interface IGetAreaForViewDto {
    area: AreaDto;
    cityName: string | undefined;
}

export class PagedResultDtoOfGetAreaForViewDto implements IPagedResultDtoOfGetAreaForViewDto {
    totalCount!: number;
    items!: GetAreaForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAreaForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetAreaForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAreaForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAreaForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetAreaForViewDto {
    totalCount: number;
    items: GetAreaForViewDto[] | undefined;
}

export class CreateOrEditAreaDto implements ICreateOrEditAreaDto {
    name!: string | undefined;
    state!: boolean;
    description!: string | undefined;
    cityId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditAreaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.state = data["state"];
            this.description = data["description"];
            this.cityId = data["cityId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditAreaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["state"] = this.state;
        data["description"] = this.description;
        data["cityId"] = this.cityId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditAreaDto {
    name: string | undefined;
    state: boolean;
    description: string | undefined;
    cityId: number;
    id: number | undefined;
}

export class GetAreaForEditOutput implements IGetAreaForEditOutput {
    area!: CreateOrEditAreaDto;
    cityName!: string | undefined;

    constructor(data?: IGetAreaForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.area = data["area"] ? CreateOrEditAreaDto.fromJS(data["area"]) : <any>undefined;
            this.cityName = data["cityName"];
        }
    }

    static fromJS(data: any): GetAreaForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAreaForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["area"] = this.area ? this.area.toJSON() : <any>undefined;
        data["cityName"] = this.cityName;
        return data; 
    }
}

export interface IGetAreaForEditOutput {
    area: CreateOrEditAreaDto;
    cityName: string | undefined;
}

export class AreaCityLookupTableDto implements IAreaCityLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IAreaCityLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): AreaCityLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new AreaCityLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IAreaCityLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export enum DataType {
    Default = 0,
    Integer = 1,
    DateTime = 2,
    String = 3,
    Boolean = 4,
    File = 5,
    Entity = 6,
    Price = 7,
    Enum = 8,
    Age = 9,
    BirthDay = 10,
}

export class AttributeDto implements IAttributeDto {
    title!: string | undefined;
    minValue!: number | undefined;
    maxValue!: number | undefined;
    description!: string | undefined;
    state!: boolean | undefined;
    dataType!: DataType;
    required!: boolean;
    isUnique!: boolean;
    tags!: string | undefined;
    entity!: Entities;
    entityRef!: number | undefined;
    userEntityId!: number | undefined;
    id!: number;

    constructor(data?: IAttributeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.minValue = data["minValue"];
            this.maxValue = data["maxValue"];
            this.description = data["description"];
            this.state = data["state"];
            this.dataType = data["dataType"];
            this.required = data["required"];
            this.isUnique = data["isUnique"];
            this.tags = data["tags"];
            this.entity = data["entity"];
            this.entityRef = data["entityRef"];
            this.userEntityId = data["userEntityId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AttributeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttributeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        data["description"] = this.description;
        data["state"] = this.state;
        data["dataType"] = this.dataType;
        data["required"] = this.required;
        data["isUnique"] = this.isUnique;
        data["tags"] = this.tags;
        data["entity"] = this.entity;
        data["entityRef"] = this.entityRef;
        data["userEntityId"] = this.userEntityId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IAttributeDto {
    title: string | undefined;
    minValue: number | undefined;
    maxValue: number | undefined;
    description: string | undefined;
    state: boolean | undefined;
    dataType: DataType;
    required: boolean;
    isUnique: boolean;
    tags: string | undefined;
    entity: Entities;
    entityRef: number | undefined;
    userEntityId: number | undefined;
    id: number;
}

export class GetAttributeForViewDto implements IGetAttributeForViewDto {
    attribute!: AttributeDto;
    userEntityTitle!: string | undefined;

    constructor(data?: IGetAttributeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.attribute = data["attribute"] ? AttributeDto.fromJS(data["attribute"]) : <any>undefined;
            this.userEntityTitle = data["userEntityTitle"];
        }
    }

    static fromJS(data: any): GetAttributeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAttributeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attribute"] = this.attribute ? this.attribute.toJSON() : <any>undefined;
        data["userEntityTitle"] = this.userEntityTitle;
        return data; 
    }
}

export interface IGetAttributeForViewDto {
    attribute: AttributeDto;
    userEntityTitle: string | undefined;
}

export class PagedResultDtoOfGetAttributeForViewDto implements IPagedResultDtoOfGetAttributeForViewDto {
    totalCount!: number;
    items!: GetAttributeForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAttributeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetAttributeForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAttributeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAttributeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetAttributeForViewDto {
    totalCount: number;
    items: GetAttributeForViewDto[] | undefined;
}

export class CreateOrEditAttributeDto implements ICreateOrEditAttributeDto {
    title!: string | undefined;
    minValue!: number | undefined;
    maxValue!: number | undefined;
    description!: string | undefined;
    state!: boolean;
    dataType!: DataType;
    required!: boolean;
    isUnique!: boolean;
    tags!: string | undefined;
    entity!: Entities;
    entityRef!: number | undefined;
    userEntityId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditAttributeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.minValue = data["minValue"];
            this.maxValue = data["maxValue"];
            this.description = data["description"];
            this.state = data["state"];
            this.dataType = data["dataType"];
            this.required = data["required"];
            this.isUnique = data["isUnique"];
            this.tags = data["tags"];
            this.entity = data["entity"];
            this.entityRef = data["entityRef"];
            this.userEntityId = data["userEntityId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditAttributeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAttributeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        data["description"] = this.description;
        data["state"] = this.state;
        data["dataType"] = this.dataType;
        data["required"] = this.required;
        data["isUnique"] = this.isUnique;
        data["tags"] = this.tags;
        data["entity"] = this.entity;
        data["entityRef"] = this.entityRef;
        data["userEntityId"] = this.userEntityId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditAttributeDto {
    title: string | undefined;
    minValue: number | undefined;
    maxValue: number | undefined;
    description: string | undefined;
    state: boolean;
    dataType: DataType;
    required: boolean;
    isUnique: boolean;
    tags: string | undefined;
    entity: Entities;
    entityRef: number | undefined;
    userEntityId: number | undefined;
    id: number | undefined;
}

export class GetAttributeForEditOutput implements IGetAttributeForEditOutput {
    attribute!: CreateOrEditAttributeDto;
    userEntityTitle!: string | undefined;

    constructor(data?: IGetAttributeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.attribute = data["attribute"] ? CreateOrEditAttributeDto.fromJS(data["attribute"]) : <any>undefined;
            this.userEntityTitle = data["userEntityTitle"];
        }
    }

    static fromJS(data: any): GetAttributeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAttributeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attribute"] = this.attribute ? this.attribute.toJSON() : <any>undefined;
        data["userEntityTitle"] = this.userEntityTitle;
        return data; 
    }
}

export interface IGetAttributeForEditOutput {
    attribute: CreateOrEditAttributeDto;
    userEntityTitle: string | undefined;
}

export class AttributeUserEntityLookupTableDto implements IAttributeUserEntityLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IAttributeUserEntityLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): AttributeUserEntityLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttributeUserEntityLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IAttributeUserEntityLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfAttributeUserEntityLookupTableDto implements IPagedResultDtoOfAttributeUserEntityLookupTableDto {
    totalCount!: number;
    items!: AttributeUserEntityLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAttributeUserEntityLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(AttributeUserEntityLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAttributeUserEntityLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAttributeUserEntityLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfAttributeUserEntityLookupTableDto {
    totalCount: number;
    items: AttributeUserEntityLookupTableDto[] | undefined;
}

export class UserEntityValueDto implements IUserEntityValueDto {
    value!: string | undefined;
    description!: string | undefined;
    created!: moment.Moment;
    modified!: moment.Moment | undefined;
    createdBy!: number;
    modifiedBy!: number | undefined;
    state!: boolean | undefined;
    userEntityId!: number;
    id!: number;

    constructor(data?: IUserEntityValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"];
            this.description = data["description"];
            this.created = data["created"] ? moment(data["created"].toString()) : <any>undefined;
            this.modified = data["modified"] ? moment(data["modified"].toString()) : <any>undefined;
            this.createdBy = data["createdBy"];
            this.modifiedBy = data["modifiedBy"];
            this.state = data["state"];
            this.userEntityId = data["userEntityId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserEntityValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserEntityValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["description"] = this.description;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["modifiedBy"] = this.modifiedBy;
        data["state"] = this.state;
        data["userEntityId"] = this.userEntityId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserEntityValueDto {
    value: string | undefined;
    description: string | undefined;
    created: moment.Moment;
    modified: moment.Moment | undefined;
    createdBy: number;
    modifiedBy: number | undefined;
    state: boolean | undefined;
    userEntityId: number;
    id: number;
}

export class AttributeValueDto implements IAttributeValueDto {
    value!: string | undefined;
    state!: boolean;
    description!: string | undefined;
    entity!: Entities;
    entityRef!: number;
    attributeId!: number;
    id!: number;

    constructor(data?: IAttributeValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"];
            this.state = data["state"];
            this.description = data["description"];
            this.entity = data["entity"];
            this.entityRef = data["entityRef"];
            this.attributeId = data["attributeId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AttributeValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttributeValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["state"] = this.state;
        data["description"] = this.description;
        data["entity"] = this.entity;
        data["entityRef"] = this.entityRef;
        data["attributeId"] = this.attributeId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IAttributeValueDto {
    value: string | undefined;
    state: boolean;
    description: string | undefined;
    entity: Entities;
    entityRef: number;
    attributeId: number;
    id: number;
}

export class GetAttributeForFamilyDto implements IGetAttributeForFamilyDto {
    attribute!: AttributeDto;
    userEntityTitle!: string | undefined;
    userEntityValue!: UserEntityValueDto[] | undefined;
    value!: AttributeValueDto;

    constructor(data?: IGetAttributeForFamilyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.attribute = data["attribute"] ? AttributeDto.fromJS(data["attribute"]) : <any>undefined;
            this.userEntityTitle = data["userEntityTitle"];
            if (Array.isArray(data["userEntityValue"])) {
                this.userEntityValue = [] as any;
                for (let item of data["userEntityValue"])
                    this.userEntityValue!.push(UserEntityValueDto.fromJS(item));
            }
            this.value = data["value"] ? AttributeValueDto.fromJS(data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAttributeForFamilyDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAttributeForFamilyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attribute"] = this.attribute ? this.attribute.toJSON() : <any>undefined;
        data["userEntityTitle"] = this.userEntityTitle;
        if (Array.isArray(this.userEntityValue)) {
            data["userEntityValue"] = [];
            for (let item of this.userEntityValue)
                data["userEntityValue"].push(item.toJSON());
        }
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetAttributeForFamilyDto {
    attribute: AttributeDto;
    userEntityTitle: string | undefined;
    userEntityValue: UserEntityValueDto[] | undefined;
    value: AttributeValueDto;
}

export class PagedResultDtoOfGetAttributeForFamilyDto implements IPagedResultDtoOfGetAttributeForFamilyDto {
    totalCount!: number;
    items!: GetAttributeForFamilyDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAttributeForFamilyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetAttributeForFamilyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAttributeForFamilyDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAttributeForFamilyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetAttributeForFamilyDto {
    totalCount: number;
    items: GetAttributeForFamilyDto[] | undefined;
}

export class SourceAttribute implements ISourceAttribute {
    title!: string | undefined;
    value!: string | undefined;

    constructor(data?: ISourceAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): SourceAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new SourceAttribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["value"] = this.value;
        return data; 
    }
}

export interface ISourceAttribute {
    title: string | undefined;
    value: string | undefined;
}

export class GetAttributeValueForViewDto implements IGetAttributeValueForViewDto {
    attributeValue!: AttributeValueDto;
    attributeTitle!: string | undefined;

    constructor(data?: IGetAttributeValueForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.attributeValue = data["attributeValue"] ? AttributeValueDto.fromJS(data["attributeValue"]) : <any>undefined;
            this.attributeTitle = data["attributeTitle"];
        }
    }

    static fromJS(data: any): GetAttributeValueForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAttributeValueForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributeValue"] = this.attributeValue ? this.attributeValue.toJSON() : <any>undefined;
        data["attributeTitle"] = this.attributeTitle;
        return data; 
    }
}

export interface IGetAttributeValueForViewDto {
    attributeValue: AttributeValueDto;
    attributeTitle: string | undefined;
}

export class PagedResultDtoOfGetAttributeValueForViewDto implements IPagedResultDtoOfGetAttributeValueForViewDto {
    totalCount!: number;
    items!: GetAttributeValueForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAttributeValueForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetAttributeValueForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAttributeValueForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAttributeValueForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetAttributeValueForViewDto {
    totalCount: number;
    items: GetAttributeValueForViewDto[] | undefined;
}

export class CreateOrEditAttributeValueDto implements ICreateOrEditAttributeValueDto {
    value!: string | undefined;
    state!: boolean;
    description!: string | undefined;
    entity!: Entities;
    entityRef!: number;
    attributeId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditAttributeValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"];
            this.state = data["state"];
            this.description = data["description"];
            this.entity = data["entity"];
            this.entityRef = data["entityRef"];
            this.attributeId = data["attributeId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditAttributeValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAttributeValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["state"] = this.state;
        data["description"] = this.description;
        data["entity"] = this.entity;
        data["entityRef"] = this.entityRef;
        data["attributeId"] = this.attributeId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditAttributeValueDto {
    value: string | undefined;
    state: boolean;
    description: string | undefined;
    entity: Entities;
    entityRef: number;
    attributeId: number;
    id: number | undefined;
}

export class GetAttributeValueForEditOutput implements IGetAttributeValueForEditOutput {
    attributeValue!: CreateOrEditAttributeValueDto;
    attributeTitle!: string | undefined;

    constructor(data?: IGetAttributeValueForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.attributeValue = data["attributeValue"] ? CreateOrEditAttributeValueDto.fromJS(data["attributeValue"]) : <any>undefined;
            this.attributeTitle = data["attributeTitle"];
        }
    }

    static fromJS(data: any): GetAttributeValueForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAttributeValueForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributeValue"] = this.attributeValue ? this.attributeValue.toJSON() : <any>undefined;
        data["attributeTitle"] = this.attributeTitle;
        return data; 
    }
}

export interface IGetAttributeValueForEditOutput {
    attributeValue: CreateOrEditAttributeValueDto;
    attributeTitle: string | undefined;
}

export class AttributeValueAttributeLookupTableDto implements IAttributeValueAttributeLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    type!: DataType;
    minValue!: number | undefined;
    maxValue!: number | undefined;
    required!: boolean;
    isUnique!: boolean;

    constructor(data?: IAttributeValueAttributeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.type = data["type"];
            this.minValue = data["minValue"];
            this.maxValue = data["maxValue"];
            this.required = data["required"];
            this.isUnique = data["isUnique"];
        }
    }

    static fromJS(data: any): AttributeValueAttributeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttributeValueAttributeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["type"] = this.type;
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        data["required"] = this.required;
        data["isUnique"] = this.isUnique;
        return data; 
    }
}

export interface IAttributeValueAttributeLookupTableDto {
    id: number;
    displayName: string | undefined;
    type: DataType;
    minValue: number | undefined;
    maxValue: number | undefined;
    required: boolean;
    isUnique: boolean;
}

export class PagedResultDtoOfAttributeValueAttributeLookupTableDto implements IPagedResultDtoOfAttributeValueAttributeLookupTableDto {
    totalCount!: number;
    items!: AttributeValueAttributeLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAttributeValueAttributeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(AttributeValueAttributeLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAttributeValueAttributeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAttributeValueAttributeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfAttributeValueAttributeLookupTableDto {
    totalCount: number;
    items: AttributeValueAttributeLookupTableDto[] | undefined;
}

export class AttributeValueUserentityLookupTableDto implements IAttributeValueUserentityLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    propertyType!: DataType;

    constructor(data?: IAttributeValueUserentityLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.propertyType = data["propertyType"];
        }
    }

    static fromJS(data: any): AttributeValueUserentityLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttributeValueUserentityLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["propertyType"] = this.propertyType;
        return data; 
    }
}

export interface IAttributeValueUserentityLookupTableDto {
    id: number;
    displayName: string | undefined;
    propertyType: DataType;
}

export class AuditLogListDto implements IAuditLogListDto {
    userId!: number | undefined;
    userName!: string | undefined;
    impersonatorTenantId!: number | undefined;
    impersonatorUserId!: number | undefined;
    serviceName!: string | undefined;
    methodName!: string | undefined;
    parameters!: string | undefined;
    executionTime!: moment.Moment;
    executionDuration!: number;
    clientIpAddress!: string | undefined;
    clientName!: string | undefined;
    browserInfo!: string | undefined;
    exception!: string | undefined;
    customData!: string | undefined;
    id!: number;

    constructor(data?: IAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.userName = data["userName"];
            this.impersonatorTenantId = data["impersonatorTenantId"];
            this.impersonatorUserId = data["impersonatorUserId"];
            this.serviceName = data["serviceName"];
            this.methodName = data["methodName"];
            this.parameters = data["parameters"];
            this.executionTime = data["executionTime"] ? moment(data["executionTime"].toString()) : <any>undefined;
            this.executionDuration = data["executionDuration"];
            this.clientIpAddress = data["clientIpAddress"];
            this.clientName = data["clientName"];
            this.browserInfo = data["browserInfo"];
            this.exception = data["exception"];
            this.customData = data["customData"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AuditLogListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["impersonatorTenantId"] = this.impersonatorTenantId;
        data["impersonatorUserId"] = this.impersonatorUserId;
        data["serviceName"] = this.serviceName;
        data["methodName"] = this.methodName;
        data["parameters"] = this.parameters;
        data["executionTime"] = this.executionTime ? this.executionTime.toISOString() : <any>undefined;
        data["executionDuration"] = this.executionDuration;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["exception"] = this.exception;
        data["customData"] = this.customData;
        data["id"] = this.id;
        return data; 
    }
}

export interface IAuditLogListDto {
    userId: number | undefined;
    userName: string | undefined;
    impersonatorTenantId: number | undefined;
    impersonatorUserId: number | undefined;
    serviceName: string | undefined;
    methodName: string | undefined;
    parameters: string | undefined;
    executionTime: moment.Moment;
    executionDuration: number;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    exception: string | undefined;
    customData: string | undefined;
    id: number;
}

export class PagedResultDtoOfAuditLogListDto implements IPagedResultDtoOfAuditLogListDto {
    totalCount!: number;
    items!: AuditLogListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(AuditLogListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAuditLogListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfAuditLogListDto {
    totalCount: number;
    items: AuditLogListDto[] | undefined;
}

export class NameValueDto implements INameValueDto {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): NameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }
}

export interface INameValueDto {
    name: string | undefined;
    value: string | undefined;
}

export enum EntityChangeType {
    Created = 0,
    Updated = 1,
    Deleted = 2,
}

export class EntityChangeListDto implements IEntityChangeListDto {
    userId!: number | undefined;
    userName!: string | undefined;
    changeTime!: moment.Moment;
    entityTypeFullName!: string | undefined;
    changeType!: EntityChangeType;
    readonly changeTypeName!: string | undefined;
    entityChangeSetId!: number;
    id!: number;

    constructor(data?: IEntityChangeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.userName = data["userName"];
            this.changeTime = data["changeTime"] ? moment(data["changeTime"].toString()) : <any>undefined;
            this.entityTypeFullName = data["entityTypeFullName"];
            this.changeType = data["changeType"];
            (<any>this).changeTypeName = data["changeTypeName"];
            this.entityChangeSetId = data["entityChangeSetId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityChangeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityChangeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["changeTime"] = this.changeTime ? this.changeTime.toISOString() : <any>undefined;
        data["entityTypeFullName"] = this.entityTypeFullName;
        data["changeType"] = this.changeType;
        data["changeTypeName"] = this.changeTypeName;
        data["entityChangeSetId"] = this.entityChangeSetId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEntityChangeListDto {
    userId: number | undefined;
    userName: string | undefined;
    changeTime: moment.Moment;
    entityTypeFullName: string | undefined;
    changeType: EntityChangeType;
    changeTypeName: string | undefined;
    entityChangeSetId: number;
    id: number;
}

export class PagedResultDtoOfEntityChangeListDto implements IPagedResultDtoOfEntityChangeListDto {
    totalCount!: number;
    items!: EntityChangeListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfEntityChangeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(EntityChangeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEntityChangeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfEntityChangeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfEntityChangeListDto {
    totalCount: number;
    items: EntityChangeListDto[] | undefined;
}

export class EntityPropertyChangeDto implements IEntityPropertyChangeDto {
    entityChangeId!: number;
    newValue!: string | undefined;
    originalValue!: string | undefined;
    propertyName!: string | undefined;
    propertyTypeFullName!: string | undefined;
    tenantId!: number | undefined;
    id!: number;

    constructor(data?: IEntityPropertyChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityChangeId = data["entityChangeId"];
            this.newValue = data["newValue"];
            this.originalValue = data["originalValue"];
            this.propertyName = data["propertyName"];
            this.propertyTypeFullName = data["propertyTypeFullName"];
            this.tenantId = data["tenantId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityPropertyChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityPropertyChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityChangeId"] = this.entityChangeId;
        data["newValue"] = this.newValue;
        data["originalValue"] = this.originalValue;
        data["propertyName"] = this.propertyName;
        data["propertyTypeFullName"] = this.propertyTypeFullName;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEntityPropertyChangeDto {
    entityChangeId: number;
    newValue: string | undefined;
    originalValue: string | undefined;
    propertyName: string | undefined;
    propertyTypeFullName: string | undefined;
    tenantId: number | undefined;
    id: number;
}

export enum IPGType {
    Default = 0,
    Mellat = 1,
    Melli = 2,
    Tejarat = 3,
    Maskan = 4,
}

export enum BankAccountState {
    Default = 0,
    Active = 1,
    Deactive = 2,
}

export enum PaymentType {
    Default = 0,
    IPG = 1,
    CardToCard = 2,
    BankPaymentReceipt = 3,
    Cash = 4,
    POS = 5,
    ItemReceipt = 6,
    VirtualCredit = 7,
    PayToPostman = 8,
    Check = 9,
    Discount = 10,
    RefusalToPay = 11,
}

export class BankAccountDto implements IBankAccountDto {
    branchName!: string | undefined;
    branchId!: string | undefined;
    accountNumber!: string | undefined;
    shabaNumber!: string | undefined;
    accountTitle!: string | undefined;
    depositID!: string | undefined;
    default!: boolean;
    contactId!: number | undefined;
    bankId!: number;
    terminalId!: number | undefined;
    userName!: string | undefined;
    userPassword!: string | undefined;
    ipgTypeId!: IPGType;
    state!: BankAccountState;
    paymentType!: PaymentType;
    logo!: string | undefined;
    isShow!: boolean;
    currencyRef!: number | undefined;
    id!: number;

    constructor(data?: IBankAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.branchName = data["branchName"];
            this.branchId = data["branchId"];
            this.accountNumber = data["accountNumber"];
            this.shabaNumber = data["shabaNumber"];
            this.accountTitle = data["accountTitle"];
            this.depositID = data["depositID"];
            this.default = data["default"];
            this.contactId = data["contactId"];
            this.bankId = data["bankId"];
            this.terminalId = data["terminalId"];
            this.userName = data["userName"];
            this.userPassword = data["userPassword"];
            this.ipgTypeId = data["ipgTypeId"];
            this.state = data["state"];
            this.paymentType = data["paymentType"];
            this.logo = data["logo"];
            this.isShow = data["isShow"];
            this.currencyRef = data["currencyRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): BankAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchName"] = this.branchName;
        data["branchId"] = this.branchId;
        data["accountNumber"] = this.accountNumber;
        data["shabaNumber"] = this.shabaNumber;
        data["accountTitle"] = this.accountTitle;
        data["depositID"] = this.depositID;
        data["default"] = this.default;
        data["contactId"] = this.contactId;
        data["bankId"] = this.bankId;
        data["terminalId"] = this.terminalId;
        data["userName"] = this.userName;
        data["userPassword"] = this.userPassword;
        data["ipgTypeId"] = this.ipgTypeId;
        data["state"] = this.state;
        data["paymentType"] = this.paymentType;
        data["logo"] = this.logo;
        data["isShow"] = this.isShow;
        data["currencyRef"] = this.currencyRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface IBankAccountDto {
    branchName: string | undefined;
    branchId: string | undefined;
    accountNumber: string | undefined;
    shabaNumber: string | undefined;
    accountTitle: string | undefined;
    depositID: string | undefined;
    default: boolean;
    contactId: number | undefined;
    bankId: number;
    terminalId: number | undefined;
    userName: string | undefined;
    userPassword: string | undefined;
    ipgTypeId: IPGType;
    state: BankAccountState;
    paymentType: PaymentType;
    logo: string | undefined;
    isShow: boolean;
    currencyRef: number | undefined;
    id: number;
}

export class GetBankAccountForViewDto implements IGetBankAccountForViewDto {
    bankAccount!: BankAccountDto;
    bankName!: string | undefined;
    currencyName!: string | undefined;

    constructor(data?: IGetBankAccountForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bankAccount = data["bankAccount"] ? BankAccountDto.fromJS(data["bankAccount"]) : <any>undefined;
            this.bankName = data["bankName"];
            this.currencyName = data["currencyName"];
        }
    }

    static fromJS(data: any): GetBankAccountForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBankAccountForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankAccount"] = this.bankAccount ? this.bankAccount.toJSON() : <any>undefined;
        data["bankName"] = this.bankName;
        data["currencyName"] = this.currencyName;
        return data; 
    }
}

export interface IGetBankAccountForViewDto {
    bankAccount: BankAccountDto;
    bankName: string | undefined;
    currencyName: string | undefined;
}

export class PagedResultDtoOfGetBankAccountForViewDto implements IPagedResultDtoOfGetBankAccountForViewDto {
    totalCount!: number;
    items!: GetBankAccountForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetBankAccountForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetBankAccountForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetBankAccountForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetBankAccountForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetBankAccountForViewDto {
    totalCount: number;
    items: GetBankAccountForViewDto[] | undefined;
}

export class CreateOrEditBankAccountDto implements ICreateOrEditBankAccountDto {
    branchName!: string | undefined;
    branchId!: string | undefined;
    accountNumber!: string | undefined;
    shabaNumber!: string | undefined;
    accountTitle!: string | undefined;
    depositID!: string | undefined;
    default!: boolean;
    contactId!: number | undefined;
    bankId!: number;
    terminalId!: number | undefined;
    userName!: string | undefined;
    userPassword!: string | undefined;
    ipgTypeId!: IPGType;
    state!: BankAccountState;
    paymentType!: PaymentType;
    logo!: string | undefined;
    isShow!: boolean;
    currencyRef!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditBankAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.branchName = data["branchName"];
            this.branchId = data["branchId"];
            this.accountNumber = data["accountNumber"];
            this.shabaNumber = data["shabaNumber"];
            this.accountTitle = data["accountTitle"];
            this.depositID = data["depositID"];
            this.default = data["default"];
            this.contactId = data["contactId"];
            this.bankId = data["bankId"];
            this.terminalId = data["terminalId"];
            this.userName = data["userName"];
            this.userPassword = data["userPassword"];
            this.ipgTypeId = data["ipgTypeId"];
            this.state = data["state"];
            this.paymentType = data["paymentType"];
            this.logo = data["logo"];
            this.isShow = data["isShow"];
            this.currencyRef = data["currencyRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditBankAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditBankAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchName"] = this.branchName;
        data["branchId"] = this.branchId;
        data["accountNumber"] = this.accountNumber;
        data["shabaNumber"] = this.shabaNumber;
        data["accountTitle"] = this.accountTitle;
        data["depositID"] = this.depositID;
        data["default"] = this.default;
        data["contactId"] = this.contactId;
        data["bankId"] = this.bankId;
        data["terminalId"] = this.terminalId;
        data["userName"] = this.userName;
        data["userPassword"] = this.userPassword;
        data["ipgTypeId"] = this.ipgTypeId;
        data["state"] = this.state;
        data["paymentType"] = this.paymentType;
        data["logo"] = this.logo;
        data["isShow"] = this.isShow;
        data["currencyRef"] = this.currencyRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditBankAccountDto {
    branchName: string | undefined;
    branchId: string | undefined;
    accountNumber: string | undefined;
    shabaNumber: string | undefined;
    accountTitle: string | undefined;
    depositID: string | undefined;
    default: boolean;
    contactId: number | undefined;
    bankId: number;
    terminalId: number | undefined;
    userName: string | undefined;
    userPassword: string | undefined;
    ipgTypeId: IPGType;
    state: BankAccountState;
    paymentType: PaymentType;
    logo: string | undefined;
    isShow: boolean;
    currencyRef: number | undefined;
    id: number | undefined;
}

export class GetBankAccountForEditOutput implements IGetBankAccountForEditOutput {
    bankAccount!: CreateOrEditBankAccountDto;
    bankName!: string | undefined;
    currencyName!: string | undefined;

    constructor(data?: IGetBankAccountForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bankAccount = data["bankAccount"] ? CreateOrEditBankAccountDto.fromJS(data["bankAccount"]) : <any>undefined;
            this.bankName = data["bankName"];
            this.currencyName = data["currencyName"];
        }
    }

    static fromJS(data: any): GetBankAccountForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetBankAccountForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankAccount"] = this.bankAccount ? this.bankAccount.toJSON() : <any>undefined;
        data["bankName"] = this.bankName;
        data["currencyName"] = this.currencyName;
        return data; 
    }
}

export interface IGetBankAccountForEditOutput {
    bankAccount: CreateOrEditBankAccountDto;
    bankName: string | undefined;
    currencyName: string | undefined;
}

export class BankAccountBankLookupTableDto implements IBankAccountBankLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IBankAccountBankLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): BankAccountBankLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountBankLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IBankAccountBankLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfBankAccountBankLookupTableDto implements IPagedResultDtoOfBankAccountBankLookupTableDto {
    totalCount!: number;
    items!: BankAccountBankLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfBankAccountBankLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(BankAccountBankLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfBankAccountBankLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfBankAccountBankLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfBankAccountBankLookupTableDto {
    totalCount: number;
    items: BankAccountBankLookupTableDto[] | undefined;
}

export class BanckAccountCurrencyLookupTableDto implements IBanckAccountCurrencyLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IBanckAccountCurrencyLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): BanckAccountCurrencyLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new BanckAccountCurrencyLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IBanckAccountCurrencyLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class BankDto implements IBankDto {
    name!: string | undefined;
    state!: boolean;
    id!: number;

    constructor(data?: IBankDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.state = data["state"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): BankDto {
        data = typeof data === 'object' ? data : {};
        let result = new BankDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["state"] = this.state;
        data["id"] = this.id;
        return data; 
    }
}

export interface IBankDto {
    name: string | undefined;
    state: boolean;
    id: number;
}

export class GetBankForViewDto implements IGetBankForViewDto {
    bank!: BankDto;

    constructor(data?: IGetBankForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bank = data["bank"] ? BankDto.fromJS(data["bank"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBankForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBankForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bank"] = this.bank ? this.bank.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetBankForViewDto {
    bank: BankDto;
}

export class PagedResultDtoOfGetBankForViewDto implements IPagedResultDtoOfGetBankForViewDto {
    totalCount!: number;
    items!: GetBankForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetBankForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetBankForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetBankForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetBankForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetBankForViewDto {
    totalCount: number;
    items: GetBankForViewDto[] | undefined;
}

export class CreateOrEditBankDto implements ICreateOrEditBankDto {
    name!: string | undefined;
    state!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditBankDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.state = data["state"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditBankDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditBankDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["state"] = this.state;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditBankDto {
    name: string | undefined;
    state: boolean;
    id: number | undefined;
}

export class GetBankForEditOutput implements IGetBankForEditOutput {
    bank!: CreateOrEditBankDto;

    constructor(data?: IGetBankForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bank = data["bank"] ? CreateOrEditBankDto.fromJS(data["bank"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBankForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetBankForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bank"] = this.bank ? this.bank.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetBankForEditOutput {
    bank: CreateOrEditBankDto;
}

export enum BannerTypes {
    Default = 0,
    Event = 1,
    Deceased = 2,
}

export class BannerDto implements IBannerDto {
    entityRef!: number;
    entity!: Entities;
    title!: string | undefined;
    fileName!: string | undefined;
    fileType!: string | undefined;
    filePath!: string | undefined;
    thumbPath!: string | undefined;
    order!: number;
    time!: number | undefined;
    isApproved!: boolean;
    link!: string | undefined;
    bannerType!: BannerTypes;
    id!: number;

    constructor(data?: IBannerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityRef = data["entityRef"];
            this.entity = data["entity"];
            this.title = data["title"];
            this.fileName = data["fileName"];
            this.fileType = data["fileType"];
            this.filePath = data["filePath"];
            this.thumbPath = data["thumbPath"];
            this.order = data["order"];
            this.time = data["time"];
            this.isApproved = data["isApproved"];
            this.link = data["link"];
            this.bannerType = data["bannerType"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): BannerDto {
        data = typeof data === 'object' ? data : {};
        let result = new BannerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityRef"] = this.entityRef;
        data["entity"] = this.entity;
        data["title"] = this.title;
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["filePath"] = this.filePath;
        data["thumbPath"] = this.thumbPath;
        data["order"] = this.order;
        data["time"] = this.time;
        data["isApproved"] = this.isApproved;
        data["link"] = this.link;
        data["bannerType"] = this.bannerType;
        data["id"] = this.id;
        return data; 
    }
}

export interface IBannerDto {
    entityRef: number;
    entity: Entities;
    title: string | undefined;
    fileName: string | undefined;
    fileType: string | undefined;
    filePath: string | undefined;
    thumbPath: string | undefined;
    order: number;
    time: number | undefined;
    isApproved: boolean;
    link: string | undefined;
    bannerType: BannerTypes;
    id: number;
}

export class GetBannerForViewDto implements IGetBannerForViewDto {
    banner!: BannerDto;

    constructor(data?: IGetBannerForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.banner = data["banner"] ? BannerDto.fromJS(data["banner"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBannerForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBannerForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["banner"] = this.banner ? this.banner.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetBannerForViewDto {
    banner: BannerDto;
}

export class PagedResultDtoOfGetBannerForViewDto implements IPagedResultDtoOfGetBannerForViewDto {
    totalCount!: number;
    items!: GetBannerForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetBannerForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetBannerForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetBannerForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetBannerForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetBannerForViewDto {
    totalCount: number;
    items: GetBannerForViewDto[] | undefined;
}

export class CreateOrEditBannerDto implements ICreateOrEditBannerDto {
    entityRef!: number;
    entity!: Entities;
    title!: string | undefined;
    fileName!: string | undefined;
    fileType!: string | undefined;
    filePath!: string | undefined;
    thumbPath!: string | undefined;
    order!: number;
    time!: number | undefined;
    isApproved!: boolean;
    link!: string | undefined;
    bannerType!: BannerTypes;
    id!: number | undefined;

    constructor(data?: ICreateOrEditBannerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityRef = data["entityRef"];
            this.entity = data["entity"];
            this.title = data["title"];
            this.fileName = data["fileName"];
            this.fileType = data["fileType"];
            this.filePath = data["filePath"];
            this.thumbPath = data["thumbPath"];
            this.order = data["order"];
            this.time = data["time"];
            this.isApproved = data["isApproved"];
            this.link = data["link"];
            this.bannerType = data["bannerType"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditBannerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditBannerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityRef"] = this.entityRef;
        data["entity"] = this.entity;
        data["title"] = this.title;
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["filePath"] = this.filePath;
        data["thumbPath"] = this.thumbPath;
        data["order"] = this.order;
        data["time"] = this.time;
        data["isApproved"] = this.isApproved;
        data["link"] = this.link;
        data["bannerType"] = this.bannerType;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditBannerDto {
    entityRef: number;
    entity: Entities;
    title: string | undefined;
    fileName: string | undefined;
    fileType: string | undefined;
    filePath: string | undefined;
    thumbPath: string | undefined;
    order: number;
    time: number | undefined;
    isApproved: boolean;
    link: string | undefined;
    bannerType: BannerTypes;
    id: number | undefined;
}

export class GetBannerForEditOutput implements IGetBannerForEditOutput {
    banner!: CreateOrEditBannerDto;

    constructor(data?: IGetBannerForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.banner = data["banner"] ? CreateOrEditBannerDto.fromJS(data["banner"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBannerForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetBannerForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["banner"] = this.banner ? this.banner.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetBannerForEditOutput {
    banner: CreateOrEditBannerDto;
}

export enum Calendar {
    Default = 0,
    Solar = 1,
    Gregorian = 2,
    Lunar = 3,
    Null = 4,
}

export enum BaseTimeTypes {
    Default = 0,
    Daily = 1,
    EveryOtherDay = 2,
    Weekly = 3,
    Monthly = 4,
    EveryTwoMonths = 5,
    EveryTreeMonths = 6,
    EverySixMonths = 7,
    Yearly = 8,
    EveryFourMonths = 9,
    EveryFiveMonths = 10,
}

export class BaseTimeDto implements IBaseTimeDto {
    name!: string | undefined;
    calendar!: Calendar;
    duration!: BaseTimeTypes;
    referralAndPaymentToPostMan!: boolean;
    description!: string | undefined;
    state!: boolean;
    id!: number;

    constructor(data?: IBaseTimeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.calendar = data["calendar"];
            this.duration = data["duration"];
            this.referralAndPaymentToPostMan = data["referralAndPaymentToPostMan"];
            this.description = data["description"];
            this.state = data["state"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): BaseTimeDto {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTimeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["calendar"] = this.calendar;
        data["duration"] = this.duration;
        data["referralAndPaymentToPostMan"] = this.referralAndPaymentToPostMan;
        data["description"] = this.description;
        data["state"] = this.state;
        data["id"] = this.id;
        return data; 
    }
}

export interface IBaseTimeDto {
    name: string | undefined;
    calendar: Calendar;
    duration: BaseTimeTypes;
    referralAndPaymentToPostMan: boolean;
    description: string | undefined;
    state: boolean;
    id: number;
}

export class GetBaseTimeForViewDto implements IGetBaseTimeForViewDto {
    baseTime!: BaseTimeDto;

    constructor(data?: IGetBaseTimeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.baseTime = data["baseTime"] ? BaseTimeDto.fromJS(data["baseTime"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBaseTimeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBaseTimeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseTime"] = this.baseTime ? this.baseTime.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetBaseTimeForViewDto {
    baseTime: BaseTimeDto;
}

export class PagedResultDtoOfGetBaseTimeForViewDto implements IPagedResultDtoOfGetBaseTimeForViewDto {
    totalCount!: number;
    items!: GetBaseTimeForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetBaseTimeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetBaseTimeForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetBaseTimeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetBaseTimeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetBaseTimeForViewDto {
    totalCount: number;
    items: GetBaseTimeForViewDto[] | undefined;
}

export class CreateOrEditBaseTimeDto implements ICreateOrEditBaseTimeDto {
    name!: string | undefined;
    calendar!: Calendar;
    duration!: BaseTimeTypes;
    referralAndPaymentToPostMan!: boolean;
    description!: string | undefined;
    state!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditBaseTimeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.calendar = data["calendar"];
            this.duration = data["duration"];
            this.referralAndPaymentToPostMan = data["referralAndPaymentToPostMan"];
            this.description = data["description"];
            this.state = data["state"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditBaseTimeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditBaseTimeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["calendar"] = this.calendar;
        data["duration"] = this.duration;
        data["referralAndPaymentToPostMan"] = this.referralAndPaymentToPostMan;
        data["description"] = this.description;
        data["state"] = this.state;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditBaseTimeDto {
    name: string | undefined;
    calendar: Calendar;
    duration: BaseTimeTypes;
    referralAndPaymentToPostMan: boolean;
    description: string | undefined;
    state: boolean;
    id: number | undefined;
}

export class GetBaseTimeForEditOutput implements IGetBaseTimeForEditOutput {
    baseTime!: CreateOrEditBaseTimeDto;

    constructor(data?: IGetBaseTimeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.baseTime = data["baseTime"] ? CreateOrEditBaseTimeDto.fromJS(data["baseTime"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBaseTimeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetBaseTimeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseTime"] = this.baseTime ? this.baseTime.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetBaseTimeForEditOutput {
    baseTime: CreateOrEditBaseTimeDto;
}

export enum BillPaymentTypes {
    Default = 0,
    Client = 1,
    Server = 2,
}

export class BillPaymentDto implements IBillPaymentDto {
    type!: BillPaymentTypes;
    paymentId!: number;
    billId!: number;
    id!: number;

    constructor(data?: IBillPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["type"];
            this.paymentId = data["paymentId"];
            this.billId = data["billId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): BillPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["paymentId"] = this.paymentId;
        data["billId"] = this.billId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IBillPaymentDto {
    type: BillPaymentTypes;
    paymentId: number;
    billId: number;
    id: number;
}

export class GetBillPaymentForViewDto implements IGetBillPaymentForViewDto {
    billPayment!: BillPaymentDto;
    paymentBankTrackingNO!: string | undefined;
    billIssueTracking!: string | undefined;

    constructor(data?: IGetBillPaymentForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.billPayment = data["billPayment"] ? BillPaymentDto.fromJS(data["billPayment"]) : <any>undefined;
            this.paymentBankTrackingNO = data["paymentBankTrackingNO"];
            this.billIssueTracking = data["billIssueTracking"];
        }
    }

    static fromJS(data: any): GetBillPaymentForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBillPaymentForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billPayment"] = this.billPayment ? this.billPayment.toJSON() : <any>undefined;
        data["paymentBankTrackingNO"] = this.paymentBankTrackingNO;
        data["billIssueTracking"] = this.billIssueTracking;
        return data; 
    }
}

export interface IGetBillPaymentForViewDto {
    billPayment: BillPaymentDto;
    paymentBankTrackingNO: string | undefined;
    billIssueTracking: string | undefined;
}

export class PagedResultDtoOfGetBillPaymentForViewDto implements IPagedResultDtoOfGetBillPaymentForViewDto {
    totalCount!: number;
    items!: GetBillPaymentForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetBillPaymentForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetBillPaymentForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetBillPaymentForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetBillPaymentForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetBillPaymentForViewDto {
    totalCount: number;
    items: GetBillPaymentForViewDto[] | undefined;
}

export class CreateOrEditBillPaymentDto implements ICreateOrEditBillPaymentDto {
    type!: BillPaymentTypes;
    paymentId!: number;
    billId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditBillPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["type"];
            this.paymentId = data["paymentId"];
            this.billId = data["billId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditBillPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditBillPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["paymentId"] = this.paymentId;
        data["billId"] = this.billId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditBillPaymentDto {
    type: BillPaymentTypes;
    paymentId: number;
    billId: number;
    id: number | undefined;
}

export class GetBillPaymentForEditOutput implements IGetBillPaymentForEditOutput {
    billPayment!: CreateOrEditBillPaymentDto;
    paymentBankTrackingNO!: string | undefined;
    billIssueTracking!: string | undefined;

    constructor(data?: IGetBillPaymentForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.billPayment = data["billPayment"] ? CreateOrEditBillPaymentDto.fromJS(data["billPayment"]) : <any>undefined;
            this.paymentBankTrackingNO = data["paymentBankTrackingNO"];
            this.billIssueTracking = data["billIssueTracking"];
        }
    }

    static fromJS(data: any): GetBillPaymentForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetBillPaymentForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billPayment"] = this.billPayment ? this.billPayment.toJSON() : <any>undefined;
        data["paymentBankTrackingNO"] = this.paymentBankTrackingNO;
        data["billIssueTracking"] = this.billIssueTracking;
        return data; 
    }
}

export interface IGetBillPaymentForEditOutput {
    billPayment: CreateOrEditBillPaymentDto;
    paymentBankTrackingNO: string | undefined;
    billIssueTracking: string | undefined;
}

export class BillPaymentPaymentLookupTableDto implements IBillPaymentPaymentLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IBillPaymentPaymentLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): BillPaymentPaymentLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillPaymentPaymentLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IBillPaymentPaymentLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfBillPaymentPaymentLookupTableDto implements IPagedResultDtoOfBillPaymentPaymentLookupTableDto {
    totalCount!: number;
    items!: BillPaymentPaymentLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfBillPaymentPaymentLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(BillPaymentPaymentLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfBillPaymentPaymentLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfBillPaymentPaymentLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfBillPaymentPaymentLookupTableDto {
    totalCount: number;
    items: BillPaymentPaymentLookupTableDto[] | undefined;
}

export class BillPaymentBillLookupTableDto implements IBillPaymentBillLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IBillPaymentBillLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): BillPaymentBillLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillPaymentBillLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IBillPaymentBillLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfBillPaymentBillLookupTableDto implements IPagedResultDtoOfBillPaymentBillLookupTableDto {
    totalCount!: number;
    items!: BillPaymentBillLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfBillPaymentBillLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(BillPaymentBillLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfBillPaymentBillLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfBillPaymentBillLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfBillPaymentBillLookupTableDto {
    totalCount: number;
    items: BillPaymentBillLookupTableDto[] | undefined;
}

export enum PaymentStatus {
    Default = 0,
    Success = 1,
    Cancel = 2,
    Failed = 3,
    OnPayment = 4,
    OnApprove = 5,
    NotApprove = 6,
    VirtualCredit = 7,
    OnAccountingApprove = 8,
    WaitingForReturnMoney = 9,
    ReturnedMoney = 10,
    SentLink = 11,
}

export enum BillStatus {
    Default = 0,
    Expired = 1,
    Paid = 2,
    WaitingForPayment = 3,
    OnPayment = 4,
    OnApprove = 5,
    Cancel = 6,
    LabelPrinting = 7,
    TransferToCalligraphyOrPrinting = 8,
    CalligraphyOrPosterPrinting = 9,
    DeliveryToFlowerRoom = 10,
    PosterPlacement = 11,
    Sending = 12,
    InCeremony = 13,
    PickUp = 14,
    ReturnToFlowerRoom = 15,
    AssignedToPostman = 16,
    AcceptedByPostman = 17,
    OnTheWay = 18,
    Failed = 19,
    Succeedent = 20,
    SendToSlaughter = 21,
    Slaughter = 22,
    ReturnSlaughter = 23,
    WaitingForSend = 24,
    VirtualPayment = 25,
    NotApprovedByAccounting = 26,
    OnApproveAndDeliveryToContact = 27,
    DeliveryToContact = 28,
    InCeremonyAndCompletion = 29,
    ReturnToPaid = 30,
    Lost = 31,
}

export enum Consumers {
    Default = 0,
    Ceremony = 1,
    Deceased = 2,
    Other = 3,
    MoneyBox = 4,
    Sacrifice = 5,
    SacrificeDifrence = 6,
    Client = 7,
    Family = 8,
    SacrificeForDeceased = 9,
}

export enum DeliveryTypes {
    Default = 0,
    Physical = 1,
    NonPhysical = 2,
    Both = 3,
}

export class BillDto implements IBillDto {
    code!: string | undefined;
    issueDate!: moment.Moment;
    price!: number;
    count!: number | undefined;
    description!: string | undefined;
    dueDate!: moment.Moment | undefined;
    status!: BillStatus;
    extraEntity!: Consumers;
    extraEntityRef!: number | undefined;
    contactId!: number;
    currencyId!: number | undefined;
    planConstId!: number;
    planBillId!: number | undefined;
    deliveryType!: DeliveryTypes;
    descriptionOne!: string | undefined;
    descriptionTwo!: string | undefined;
    announceTheDifference!: boolean;
    billSlaughteredRef!: number | undefined;
    cardTemplateRef!: number | undefined;
    branchRef!: number | undefined;
    survivorMobileNo!: string | undefined;
    planType!: Plans;
    id!: number;

    constructor(data?: IBillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.issueDate = data["issueDate"] ? moment(data["issueDate"].toString()) : <any>undefined;
            this.price = data["price"];
            this.count = data["count"];
            this.description = data["description"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.status = data["status"];
            this.extraEntity = data["extraEntity"];
            this.extraEntityRef = data["extraEntityRef"];
            this.contactId = data["contactId"];
            this.currencyId = data["currencyId"];
            this.planConstId = data["planConstId"];
            this.planBillId = data["planBillId"];
            this.deliveryType = data["deliveryType"];
            this.descriptionOne = data["descriptionOne"];
            this.descriptionTwo = data["descriptionTwo"];
            this.announceTheDifference = data["announceTheDifference"];
            this.billSlaughteredRef = data["billSlaughteredRef"];
            this.cardTemplateRef = data["cardTemplateRef"];
            this.branchRef = data["branchRef"];
            this.survivorMobileNo = data["survivorMobileNo"];
            this.planType = data["planType"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): BillDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["price"] = this.price;
        data["count"] = this.count;
        data["description"] = this.description;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["extraEntity"] = this.extraEntity;
        data["extraEntityRef"] = this.extraEntityRef;
        data["contactId"] = this.contactId;
        data["currencyId"] = this.currencyId;
        data["planConstId"] = this.planConstId;
        data["planBillId"] = this.planBillId;
        data["deliveryType"] = this.deliveryType;
        data["descriptionOne"] = this.descriptionOne;
        data["descriptionTwo"] = this.descriptionTwo;
        data["announceTheDifference"] = this.announceTheDifference;
        data["billSlaughteredRef"] = this.billSlaughteredRef;
        data["cardTemplateRef"] = this.cardTemplateRef;
        data["branchRef"] = this.branchRef;
        data["survivorMobileNo"] = this.survivorMobileNo;
        data["planType"] = this.planType;
        data["id"] = this.id;
        return data; 
    }
}

export interface IBillDto {
    code: string | undefined;
    issueDate: moment.Moment;
    price: number;
    count: number | undefined;
    description: string | undefined;
    dueDate: moment.Moment | undefined;
    status: BillStatus;
    extraEntity: Consumers;
    extraEntityRef: number | undefined;
    contactId: number;
    currencyId: number | undefined;
    planConstId: number;
    planBillId: number | undefined;
    deliveryType: DeliveryTypes;
    descriptionOne: string | undefined;
    descriptionTwo: string | undefined;
    announceTheDifference: boolean;
    billSlaughteredRef: number | undefined;
    cardTemplateRef: number | undefined;
    branchRef: number | undefined;
    survivorMobileNo: string | undefined;
    planType: Plans;
    id: number;
}

export enum PlanBillStatus {
    Default = 0,
    Active = 1,
    Ended = 2,
    Cancellation = 3,
    Inactive = 4,
    Requested = 5,
}

export class PlanBillDto implements IPlanBillDto {
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    amount!: number | undefined;
    count!: number | undefined;
    entity!: Entities;
    entityRef!: number | undefined;
    durationDate!: number | undefined;
    code!: string | undefined;
    isDeliveredByPost!: boolean;
    iscollectByPost!: boolean;
    isConfirm!: boolean;
    description!: string | undefined;
    donotApprovedDescription!: string | undefined;
    status!: PlanBillStatus;
    isSendSmsOn!: boolean;
    addressRef!: number | undefined;
    contactId!: number;
    planConstId!: number;
    baseTimeRef!: number | undefined;
    id!: number;

    constructor(data?: IPlanBillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.amount = data["amount"];
            this.count = data["count"];
            this.entity = data["entity"];
            this.entityRef = data["entityRef"];
            this.durationDate = data["durationDate"];
            this.code = data["code"];
            this.isDeliveredByPost = data["isDeliveredByPost"];
            this.iscollectByPost = data["iscollectByPost"];
            this.isConfirm = data["isConfirm"];
            this.description = data["description"];
            this.donotApprovedDescription = data["donotApprovedDescription"];
            this.status = data["status"];
            this.isSendSmsOn = data["isSendSmsOn"];
            this.addressRef = data["addressRef"];
            this.contactId = data["contactId"];
            this.planConstId = data["planConstId"];
            this.baseTimeRef = data["baseTimeRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PlanBillDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlanBillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["count"] = this.count;
        data["entity"] = this.entity;
        data["entityRef"] = this.entityRef;
        data["durationDate"] = this.durationDate;
        data["code"] = this.code;
        data["isDeliveredByPost"] = this.isDeliveredByPost;
        data["iscollectByPost"] = this.iscollectByPost;
        data["isConfirm"] = this.isConfirm;
        data["description"] = this.description;
        data["donotApprovedDescription"] = this.donotApprovedDescription;
        data["status"] = this.status;
        data["isSendSmsOn"] = this.isSendSmsOn;
        data["addressRef"] = this.addressRef;
        data["contactId"] = this.contactId;
        data["planConstId"] = this.planConstId;
        data["baseTimeRef"] = this.baseTimeRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPlanBillDto {
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    amount: number | undefined;
    count: number | undefined;
    entity: Entities;
    entityRef: number | undefined;
    durationDate: number | undefined;
    code: string | undefined;
    isDeliveredByPost: boolean;
    iscollectByPost: boolean;
    isConfirm: boolean;
    description: string | undefined;
    donotApprovedDescription: string | undefined;
    status: PlanBillStatus;
    isSendSmsOn: boolean;
    addressRef: number | undefined;
    contactId: number;
    planConstId: number;
    baseTimeRef: number | undefined;
    id: number;
}

export class BillCardTemplateValueDto implements IBillCardTemplateValueDto {
    displayTitle!: string | undefined;
    value!: string | undefined;

    constructor(data?: IBillCardTemplateValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.displayTitle = data["displayTitle"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): BillCardTemplateValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillCardTemplateValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayTitle"] = this.displayTitle;
        data["value"] = this.value;
        return data; 
    }
}

export interface IBillCardTemplateValueDto {
    displayTitle: string | undefined;
    value: string | undefined;
}

export class GetBillForViewDto implements IGetBillForViewDto {
    bill!: BillDto;
    planBill!: PlanBillDto;
    contactFirstName!: string | undefined;
    benefactorName!: string | undefined;
    currencyName!: string | undefined;
    planConstTitle!: string | undefined;
    deceasedName!: string | undefined;
    ceremonyTitle!: string | undefined;
    billSlaughteredCode!: string | undefined;
    averageSlaughteredWeight!: number | undefined;
    paymentCreatorUser!: string | undefined;
    billCreatorUser!: string | undefined;
    postmanName!: string | undefined;
    cardTemplateTitle!: string | undefined;
    flowerCardTemplates!: BillCardTemplateValueDto[] | undefined;
    branchName!: string | undefined;
    isCash!: boolean;
    hasPrice!: boolean;
    lat!: number | undefined;
    long!: number | undefined;
    direction!: string[] | undefined;
    area!: string[] | undefined;
    approvedPaymentUser!: string | undefined;
    hasPostmanPayment!: boolean;
    remainingPrice!: number;
    paidPrice!: number | undefined;
    billsIdForRemaining!: number[] | undefined;
    tenantId!: number | undefined;
    previousUnPayedPlanBills!: number[] | undefined;

    constructor(data?: IGetBillForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bill = data["bill"] ? BillDto.fromJS(data["bill"]) : <any>undefined;
            this.planBill = data["planBill"] ? PlanBillDto.fromJS(data["planBill"]) : <any>undefined;
            this.contactFirstName = data["contactFirstName"];
            this.benefactorName = data["benefactorName"];
            this.currencyName = data["currencyName"];
            this.planConstTitle = data["planConstTitle"];
            this.deceasedName = data["deceasedName"];
            this.ceremonyTitle = data["ceremonyTitle"];
            this.billSlaughteredCode = data["billSlaughteredCode"];
            this.averageSlaughteredWeight = data["averageSlaughteredWeight"];
            this.paymentCreatorUser = data["paymentCreatorUser"];
            this.billCreatorUser = data["billCreatorUser"];
            this.postmanName = data["postmanName"];
            this.cardTemplateTitle = data["cardTemplateTitle"];
            if (Array.isArray(data["flowerCardTemplates"])) {
                this.flowerCardTemplates = [] as any;
                for (let item of data["flowerCardTemplates"])
                    this.flowerCardTemplates!.push(BillCardTemplateValueDto.fromJS(item));
            }
            this.branchName = data["branchName"];
            this.isCash = data["isCash"];
            this.hasPrice = data["hasPrice"];
            this.lat = data["lat"];
            this.long = data["long"];
            if (Array.isArray(data["direction"])) {
                this.direction = [] as any;
                for (let item of data["direction"])
                    this.direction!.push(item);
            }
            if (Array.isArray(data["area"])) {
                this.area = [] as any;
                for (let item of data["area"])
                    this.area!.push(item);
            }
            this.approvedPaymentUser = data["approvedPaymentUser"];
            this.hasPostmanPayment = data["hasPostmanPayment"];
            this.remainingPrice = data["remainingPrice"];
            this.paidPrice = data["paidPrice"];
            if (Array.isArray(data["billsIdForRemaining"])) {
                this.billsIdForRemaining = [] as any;
                for (let item of data["billsIdForRemaining"])
                    this.billsIdForRemaining!.push(item);
            }
            this.tenantId = data["tenantId"];
            if (Array.isArray(data["previousUnPayedPlanBills"])) {
                this.previousUnPayedPlanBills = [] as any;
                for (let item of data["previousUnPayedPlanBills"])
                    this.previousUnPayedPlanBills!.push(item);
            }
        }
    }

    static fromJS(data: any): GetBillForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBillForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bill"] = this.bill ? this.bill.toJSON() : <any>undefined;
        data["planBill"] = this.planBill ? this.planBill.toJSON() : <any>undefined;
        data["contactFirstName"] = this.contactFirstName;
        data["benefactorName"] = this.benefactorName;
        data["currencyName"] = this.currencyName;
        data["planConstTitle"] = this.planConstTitle;
        data["deceasedName"] = this.deceasedName;
        data["ceremonyTitle"] = this.ceremonyTitle;
        data["billSlaughteredCode"] = this.billSlaughteredCode;
        data["averageSlaughteredWeight"] = this.averageSlaughteredWeight;
        data["paymentCreatorUser"] = this.paymentCreatorUser;
        data["billCreatorUser"] = this.billCreatorUser;
        data["postmanName"] = this.postmanName;
        data["cardTemplateTitle"] = this.cardTemplateTitle;
        if (Array.isArray(this.flowerCardTemplates)) {
            data["flowerCardTemplates"] = [];
            for (let item of this.flowerCardTemplates)
                data["flowerCardTemplates"].push(item.toJSON());
        }
        data["branchName"] = this.branchName;
        data["isCash"] = this.isCash;
        data["hasPrice"] = this.hasPrice;
        data["lat"] = this.lat;
        data["long"] = this.long;
        if (Array.isArray(this.direction)) {
            data["direction"] = [];
            for (let item of this.direction)
                data["direction"].push(item);
        }
        if (Array.isArray(this.area)) {
            data["area"] = [];
            for (let item of this.area)
                data["area"].push(item);
        }
        data["approvedPaymentUser"] = this.approvedPaymentUser;
        data["hasPostmanPayment"] = this.hasPostmanPayment;
        data["remainingPrice"] = this.remainingPrice;
        data["paidPrice"] = this.paidPrice;
        if (Array.isArray(this.billsIdForRemaining)) {
            data["billsIdForRemaining"] = [];
            for (let item of this.billsIdForRemaining)
                data["billsIdForRemaining"].push(item);
        }
        data["tenantId"] = this.tenantId;
        if (Array.isArray(this.previousUnPayedPlanBills)) {
            data["previousUnPayedPlanBills"] = [];
            for (let item of this.previousUnPayedPlanBills)
                data["previousUnPayedPlanBills"].push(item);
        }
        return data; 
    }
}

export interface IGetBillForViewDto {
    bill: BillDto;
    planBill: PlanBillDto;
    contactFirstName: string | undefined;
    benefactorName: string | undefined;
    currencyName: string | undefined;
    planConstTitle: string | undefined;
    deceasedName: string | undefined;
    ceremonyTitle: string | undefined;
    billSlaughteredCode: string | undefined;
    averageSlaughteredWeight: number | undefined;
    paymentCreatorUser: string | undefined;
    billCreatorUser: string | undefined;
    postmanName: string | undefined;
    cardTemplateTitle: string | undefined;
    flowerCardTemplates: BillCardTemplateValueDto[] | undefined;
    branchName: string | undefined;
    isCash: boolean;
    hasPrice: boolean;
    lat: number | undefined;
    long: number | undefined;
    direction: string[] | undefined;
    area: string[] | undefined;
    approvedPaymentUser: string | undefined;
    hasPostmanPayment: boolean;
    remainingPrice: number;
    paidPrice: number | undefined;
    billsIdForRemaining: number[] | undefined;
    tenantId: number | undefined;
    previousUnPayedPlanBills: number[] | undefined;
}

export class PaymentBillDto implements IPaymentBillDto {
    paymentType!: PaymentType;
    panCard!: string | undefined;
    paymentDateTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    bankTrackingNO!: string | undefined;
    accountingTrackingNO!: string | undefined;
    bankSerialNO!: string | undefined;
    priceAmount!: number;
    paymentStatus!: PaymentStatus;
    bankHashCode!: string | undefined;
    bankAccountId!: number | undefined;
    bankName!: string | undefined;
    accountNumber!: string | undefined;
    documentPath!: string | undefined;
    description!: string | undefined;
    bankBranch!: string | undefined;
    dueDate!: moment.Moment | undefined;
    billsAmount!: number;
    billsCode!: string[] | undefined;
    billsPriceAmount!: string | undefined;
    bills!: GetBillForViewDto[] | undefined;
    creatorUser!: string | undefined;
    lastModifierUser!: string | undefined;
    id!: number;

    constructor(data?: IPaymentBillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paymentType = data["paymentType"];
            this.panCard = data["panCard"];
            this.paymentDateTime = data["paymentDateTime"] ? moment(data["paymentDateTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.bankTrackingNO = data["bankTrackingNO"];
            this.accountingTrackingNO = data["accountingTrackingNO"];
            this.bankSerialNO = data["bankSerialNO"];
            this.priceAmount = data["priceAmount"];
            this.paymentStatus = data["paymentStatus"];
            this.bankHashCode = data["bankHashCode"];
            this.bankAccountId = data["bankAccountId"];
            this.bankName = data["bankName"];
            this.accountNumber = data["accountNumber"];
            this.documentPath = data["documentPath"];
            this.description = data["description"];
            this.bankBranch = data["bankBranch"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.billsAmount = data["billsAmount"];
            if (Array.isArray(data["billsCode"])) {
                this.billsCode = [] as any;
                for (let item of data["billsCode"])
                    this.billsCode!.push(item);
            }
            this.billsPriceAmount = data["billsPriceAmount"];
            if (Array.isArray(data["bills"])) {
                this.bills = [] as any;
                for (let item of data["bills"])
                    this.bills!.push(GetBillForViewDto.fromJS(item));
            }
            this.creatorUser = data["creatorUser"];
            this.lastModifierUser = data["lastModifierUser"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PaymentBillDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentBillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentType"] = this.paymentType;
        data["panCard"] = this.panCard;
        data["paymentDateTime"] = this.paymentDateTime ? this.paymentDateTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["bankTrackingNO"] = this.bankTrackingNO;
        data["accountingTrackingNO"] = this.accountingTrackingNO;
        data["bankSerialNO"] = this.bankSerialNO;
        data["priceAmount"] = this.priceAmount;
        data["paymentStatus"] = this.paymentStatus;
        data["bankHashCode"] = this.bankHashCode;
        data["bankAccountId"] = this.bankAccountId;
        data["bankName"] = this.bankName;
        data["accountNumber"] = this.accountNumber;
        data["documentPath"] = this.documentPath;
        data["description"] = this.description;
        data["bankBranch"] = this.bankBranch;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["billsAmount"] = this.billsAmount;
        if (Array.isArray(this.billsCode)) {
            data["billsCode"] = [];
            for (let item of this.billsCode)
                data["billsCode"].push(item);
        }
        data["billsPriceAmount"] = this.billsPriceAmount;
        if (Array.isArray(this.bills)) {
            data["bills"] = [];
            for (let item of this.bills)
                data["bills"].push(item.toJSON());
        }
        data["creatorUser"] = this.creatorUser;
        data["lastModifierUser"] = this.lastModifierUser;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPaymentBillDto {
    paymentType: PaymentType;
    panCard: string | undefined;
    paymentDateTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    bankTrackingNO: string | undefined;
    accountingTrackingNO: string | undefined;
    bankSerialNO: string | undefined;
    priceAmount: number;
    paymentStatus: PaymentStatus;
    bankHashCode: string | undefined;
    bankAccountId: number | undefined;
    bankName: string | undefined;
    accountNumber: string | undefined;
    documentPath: string | undefined;
    description: string | undefined;
    bankBranch: string | undefined;
    dueDate: moment.Moment | undefined;
    billsAmount: number;
    billsCode: string[] | undefined;
    billsPriceAmount: string | undefined;
    bills: GetBillForViewDto[] | undefined;
    creatorUser: string | undefined;
    lastModifierUser: string | undefined;
    id: number;
}

export class GetPaymentBillOutput implements IGetPaymentBillOutput {
    payments!: PaymentBillDto[] | undefined;

    constructor(data?: IGetPaymentBillOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["payments"])) {
                this.payments = [] as any;
                for (let item of data["payments"])
                    this.payments!.push(PaymentBillDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPaymentBillOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentBillOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetPaymentBillOutput {
    payments: PaymentBillDto[] | undefined;
}

export class ApprovePayOutput implements IApprovePayOutput {
    message!: string | undefined;
    success!: boolean;

    constructor(data?: IApprovePayOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ApprovePayOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovePayOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["success"] = this.success;
        return data; 
    }
}

export interface IApprovePayOutput {
    message: string | undefined;
    success: boolean;
}

export class NotApprovedPayInput implements INotApprovedPayInput {
    payId!: number;
    description!: string | undefined;

    constructor(data?: INotApprovedPayInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.payId = data["payId"];
            this.description = data["description"];
        }
    }

    static fromJS(data: any): NotApprovedPayInput {
        data = typeof data === 'object' ? data : {};
        let result = new NotApprovedPayInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payId"] = this.payId;
        data["description"] = this.description;
        return data; 
    }
}

export interface INotApprovedPayInput {
    payId: number;
    description: string | undefined;
}

export class CustomBillAndPriceDto implements ICustomBillAndPriceDto {
    id!: number;
    price!: number;

    constructor(data?: ICustomBillAndPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.price = data["price"];
        }
    }

    static fromJS(data: any): CustomBillAndPriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomBillAndPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["price"] = this.price;
        return data; 
    }
}

export interface ICustomBillAndPriceDto {
    id: number;
    price: number;
}

export class AddressForPaymentDto implements IAddressForPaymentDto {
    title!: string | undefined;
    streetAlley!: string | undefined;
    houseNumber!: number | undefined;
    floor!: number | undefined;
    phoneNumber!: string | undefined;
    postalCode!: string | undefined;
    latitude!: number | undefined;
    longitude!: number | undefined;
    area!: number | undefined;
    entityRef!: number | undefined;
    entity!: Entities;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    description!: string | undefined;
    stateId!: number | undefined;
    cityId!: number | undefined;
    countryId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IAddressForPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.streetAlley = data["streetAlley"];
            this.houseNumber = data["houseNumber"];
            this.floor = data["floor"];
            this.phoneNumber = data["phoneNumber"];
            this.postalCode = data["postalCode"];
            this.latitude = data["latitude"];
            this.longitude = data["longitude"];
            this.area = data["area"];
            this.entityRef = data["entityRef"];
            this.entity = data["entity"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.description = data["description"];
            this.stateId = data["stateId"];
            this.cityId = data["cityId"];
            this.countryId = data["countryId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AddressForPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressForPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["streetAlley"] = this.streetAlley;
        data["houseNumber"] = this.houseNumber;
        data["floor"] = this.floor;
        data["phoneNumber"] = this.phoneNumber;
        data["postalCode"] = this.postalCode;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["area"] = this.area;
        data["entityRef"] = this.entityRef;
        data["entity"] = this.entity;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["stateId"] = this.stateId;
        data["cityId"] = this.cityId;
        data["countryId"] = this.countryId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IAddressForPaymentDto {
    title: string | undefined;
    streetAlley: string | undefined;
    houseNumber: number | undefined;
    floor: number | undefined;
    phoneNumber: string | undefined;
    postalCode: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    area: number | undefined;
    entityRef: number | undefined;
    entity: Entities;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    description: string | undefined;
    stateId: number | undefined;
    cityId: number | undefined;
    countryId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditPaymentForAdminDto implements ICreateOrEditPaymentForAdminDto {
    paymentType!: PaymentType;
    panCard!: string | undefined;
    paymentDateTime!: moment.Moment | undefined;
    stringPaymentDateTime!: string | undefined;
    bankTrackingNO!: string | undefined;
    bankSerialNO!: string | undefined;
    priceAmount!: number;
    paymentStatus!: PaymentStatus;
    bankHashCode!: string | undefined;
    description!: string | undefined;
    bankBranch!: string | undefined;
    dueDate!: moment.Moment | undefined;
    stringDueDate!: string | undefined;
    accountingTrackingNO!: string | undefined;
    bankAccountId!: number | undefined;
    posRef!: number | undefined;
    address!: AddressForPaymentDto;
    pcToPosSuccessful!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditPaymentForAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paymentType = data["paymentType"];
            this.panCard = data["panCard"];
            this.paymentDateTime = data["paymentDateTime"] ? moment(data["paymentDateTime"].toString()) : <any>undefined;
            this.stringPaymentDateTime = data["stringPaymentDateTime"];
            this.bankTrackingNO = data["bankTrackingNO"];
            this.bankSerialNO = data["bankSerialNO"];
            this.priceAmount = data["priceAmount"];
            this.paymentStatus = data["paymentStatus"];
            this.bankHashCode = data["bankHashCode"];
            this.description = data["description"];
            this.bankBranch = data["bankBranch"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.stringDueDate = data["stringDueDate"];
            this.accountingTrackingNO = data["accountingTrackingNO"];
            this.bankAccountId = data["bankAccountId"];
            this.posRef = data["posRef"];
            this.address = data["address"] ? AddressForPaymentDto.fromJS(data["address"]) : <any>undefined;
            this.pcToPosSuccessful = data["pcToPosSuccessful"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditPaymentForAdminDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPaymentForAdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentType"] = this.paymentType;
        data["panCard"] = this.panCard;
        data["paymentDateTime"] = this.paymentDateTime ? this.paymentDateTime.toISOString() : <any>undefined;
        data["stringPaymentDateTime"] = this.stringPaymentDateTime;
        data["bankTrackingNO"] = this.bankTrackingNO;
        data["bankSerialNO"] = this.bankSerialNO;
        data["priceAmount"] = this.priceAmount;
        data["paymentStatus"] = this.paymentStatus;
        data["bankHashCode"] = this.bankHashCode;
        data["description"] = this.description;
        data["bankBranch"] = this.bankBranch;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["stringDueDate"] = this.stringDueDate;
        data["accountingTrackingNO"] = this.accountingTrackingNO;
        data["bankAccountId"] = this.bankAccountId;
        data["posRef"] = this.posRef;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["pcToPosSuccessful"] = this.pcToPosSuccessful;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditPaymentForAdminDto {
    paymentType: PaymentType;
    panCard: string | undefined;
    paymentDateTime: moment.Moment | undefined;
    stringPaymentDateTime: string | undefined;
    bankTrackingNO: string | undefined;
    bankSerialNO: string | undefined;
    priceAmount: number;
    paymentStatus: PaymentStatus;
    bankHashCode: string | undefined;
    description: string | undefined;
    bankBranch: string | undefined;
    dueDate: moment.Moment | undefined;
    stringDueDate: string | undefined;
    accountingTrackingNO: string | undefined;
    bankAccountId: number | undefined;
    posRef: number | undefined;
    address: AddressForPaymentDto;
    pcToPosSuccessful: boolean;
    id: number | undefined;
}

export class CreatePaymentByAdminInput implements ICreatePaymentByAdminInput {
    bills!: CustomBillAndPriceDto[] | undefined;
    payments!: CreateOrEditPaymentForAdminDto[] | undefined;
    isDuplicate!: boolean;
    isDeliveryToContact!: boolean;

    constructor(data?: ICreatePaymentByAdminInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["bills"])) {
                this.bills = [] as any;
                for (let item of data["bills"])
                    this.bills!.push(CustomBillAndPriceDto.fromJS(item));
            }
            if (Array.isArray(data["payments"])) {
                this.payments = [] as any;
                for (let item of data["payments"])
                    this.payments!.push(CreateOrEditPaymentForAdminDto.fromJS(item));
            }
            this.isDuplicate = data["isDuplicate"];
            this.isDeliveryToContact = data["isDeliveryToContact"];
        }
    }

    static fromJS(data: any): CreatePaymentByAdminInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePaymentByAdminInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bills)) {
            data["bills"] = [];
            for (let item of this.bills)
                data["bills"].push(item.toJSON());
        }
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        data["isDuplicate"] = this.isDuplicate;
        data["isDeliveryToContact"] = this.isDeliveryToContact;
        return data; 
    }
}

export interface ICreatePaymentByAdminInput {
    bills: CustomBillAndPriceDto[] | undefined;
    payments: CreateOrEditPaymentForAdminDto[] | undefined;
    isDuplicate: boolean;
    isDeliveryToContact: boolean;
}

export class CreatePaymentByAdminOutput implements ICreatePaymentByAdminOutput {
    message!: string | undefined;
    success!: boolean;

    constructor(data?: ICreatePaymentByAdminOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): CreatePaymentByAdminOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePaymentByAdminOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["success"] = this.success;
        return data; 
    }
}

export interface ICreatePaymentByAdminOutput {
    message: string | undefined;
    success: boolean;
}

export class PaymentsDetail implements IPaymentsDetail {
    payId!: number;
    accountingTrackingNO!: string | undefined;

    constructor(data?: IPaymentsDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.payId = data["payId"];
            this.accountingTrackingNO = data["accountingTrackingNO"];
        }
    }

    static fromJS(data: any): PaymentsDetail {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentsDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payId"] = this.payId;
        data["accountingTrackingNO"] = this.accountingTrackingNO;
        return data; 
    }
}

export interface IPaymentsDetail {
    payId: number;
    accountingTrackingNO: string | undefined;
}

export class ApproveByAccountingInput implements IApproveByAccountingInput {
    payments!: PaymentsDetail[] | undefined;
    description!: string | undefined;

    constructor(data?: IApproveByAccountingInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["payments"])) {
                this.payments = [] as any;
                for (let item of data["payments"])
                    this.payments!.push(PaymentsDetail.fromJS(item));
            }
            this.description = data["description"];
        }
    }

    static fromJS(data: any): ApproveByAccountingInput {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveByAccountingInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        data["description"] = this.description;
        return data; 
    }
}

export interface IApproveByAccountingInput {
    payments: PaymentsDetail[] | undefined;
    description: string | undefined;
}

export class PaymentDto implements IPaymentDto {
    paymentType!: PaymentType;
    panCard!: string | undefined;
    paymentDateTime!: moment.Moment | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserName!: string | undefined;
    bankTrackingNO!: string | undefined;
    bankSerialNO!: string | undefined;
    priceAmount!: number;
    paymentStatus!: PaymentStatus;
    bankHashCode!: string | undefined;
    description!: string | undefined;
    bankBranch!: string | undefined;
    dueDate!: moment.Moment | undefined;
    accountingTrackingNO!: string | undefined;
    bankAccountId!: number | undefined;
    addressId!: number | undefined;
    posRef!: number | undefined;
    posIdentity!: string | undefined;
    id!: number;

    constructor(data?: IPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paymentType = data["paymentType"];
            this.panCard = data["panCard"];
            this.paymentDateTime = data["paymentDateTime"] ? moment(data["paymentDateTime"].toString()) : <any>undefined;
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserName = data["creatorUserName"];
            this.bankTrackingNO = data["bankTrackingNO"];
            this.bankSerialNO = data["bankSerialNO"];
            this.priceAmount = data["priceAmount"];
            this.paymentStatus = data["paymentStatus"];
            this.bankHashCode = data["bankHashCode"];
            this.description = data["description"];
            this.bankBranch = data["bankBranch"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.accountingTrackingNO = data["accountingTrackingNO"];
            this.bankAccountId = data["bankAccountId"];
            this.addressId = data["addressId"];
            this.posRef = data["posRef"];
            this.posIdentity = data["posIdentity"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentType"] = this.paymentType;
        data["panCard"] = this.panCard;
        data["paymentDateTime"] = this.paymentDateTime ? this.paymentDateTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserName"] = this.creatorUserName;
        data["bankTrackingNO"] = this.bankTrackingNO;
        data["bankSerialNO"] = this.bankSerialNO;
        data["priceAmount"] = this.priceAmount;
        data["paymentStatus"] = this.paymentStatus;
        data["bankHashCode"] = this.bankHashCode;
        data["description"] = this.description;
        data["bankBranch"] = this.bankBranch;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["accountingTrackingNO"] = this.accountingTrackingNO;
        data["bankAccountId"] = this.bankAccountId;
        data["addressId"] = this.addressId;
        data["posRef"] = this.posRef;
        data["posIdentity"] = this.posIdentity;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPaymentDto {
    paymentType: PaymentType;
    panCard: string | undefined;
    paymentDateTime: moment.Moment | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserName: string | undefined;
    bankTrackingNO: string | undefined;
    bankSerialNO: string | undefined;
    priceAmount: number;
    paymentStatus: PaymentStatus;
    bankHashCode: string | undefined;
    description: string | undefined;
    bankBranch: string | undefined;
    dueDate: moment.Moment | undefined;
    accountingTrackingNO: string | undefined;
    bankAccountId: number | undefined;
    addressId: number | undefined;
    posRef: number | undefined;
    posIdentity: string | undefined;
    id: number;
}

export class GetPaymentForViewDto implements IGetPaymentForViewDto {
    payment!: PaymentDto;
    bankAccountAccountNumber!: string | undefined;
    check!: boolean;
    paymentCreatorUser!: string | undefined;

    constructor(data?: IGetPaymentForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.payment = data["payment"] ? PaymentDto.fromJS(data["payment"]) : <any>undefined;
            this.bankAccountAccountNumber = data["bankAccountAccountNumber"];
            this.check = data["check"];
            this.paymentCreatorUser = data["paymentCreatorUser"];
        }
    }

    static fromJS(data: any): GetPaymentForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        data["bankAccountAccountNumber"] = this.bankAccountAccountNumber;
        data["check"] = this.check;
        data["paymentCreatorUser"] = this.paymentCreatorUser;
        return data; 
    }
}

export interface IGetPaymentForViewDto {
    payment: PaymentDto;
    bankAccountAccountNumber: string | undefined;
    check: boolean;
    paymentCreatorUser: string | undefined;
}

export class GetCancelationBillsDto implements IGetCancelationBillsDto {
    payment!: GetPaymentForViewDto;
    bill!: BillDto;
    billPaymentId!: number;
    shabaNumber!: string | undefined;
    contactName!: string | undefined;
    planConstTitle!: string | undefined;

    constructor(data?: IGetCancelationBillsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.payment = data["payment"] ? GetPaymentForViewDto.fromJS(data["payment"]) : <any>undefined;
            this.bill = data["bill"] ? BillDto.fromJS(data["bill"]) : <any>undefined;
            this.billPaymentId = data["billPaymentId"];
            this.shabaNumber = data["shabaNumber"];
            this.contactName = data["contactName"];
            this.planConstTitle = data["planConstTitle"];
        }
    }

    static fromJS(data: any): GetCancelationBillsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCancelationBillsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        data["bill"] = this.bill ? this.bill.toJSON() : <any>undefined;
        data["billPaymentId"] = this.billPaymentId;
        data["shabaNumber"] = this.shabaNumber;
        data["contactName"] = this.contactName;
        data["planConstTitle"] = this.planConstTitle;
        return data; 
    }
}

export interface IGetCancelationBillsDto {
    payment: GetPaymentForViewDto;
    bill: BillDto;
    billPaymentId: number;
    shabaNumber: string | undefined;
    contactName: string | undefined;
    planConstTitle: string | undefined;
}

export class PagedResultDtoOfGetCancelationBillsDto implements IPagedResultDtoOfGetCancelationBillsDto {
    totalCount!: number;
    items!: GetCancelationBillsDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCancelationBillsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetCancelationBillsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCancelationBillsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCancelationBillsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetCancelationBillsDto {
    totalCount: number;
    items: GetCancelationBillsDto[] | undefined;
}

export class BillForUserReport implements IBillForUserReport {
    code!: string | undefined;
    planConstTitle!: string | undefined;
    billStatus!: BillStatus;
    price!: number;

    constructor(data?: IBillForUserReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.planConstTitle = data["planConstTitle"];
            this.billStatus = data["billStatus"];
            this.price = data["price"];
        }
    }

    static fromJS(data: any): BillForUserReport {
        data = typeof data === 'object' ? data : {};
        let result = new BillForUserReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["planConstTitle"] = this.planConstTitle;
        data["billStatus"] = this.billStatus;
        data["price"] = this.price;
        return data; 
    }
}

export interface IBillForUserReport {
    code: string | undefined;
    planConstTitle: string | undefined;
    billStatus: BillStatus;
    price: number;
}

export class PaymentReport implements IPaymentReport {
    bill!: BillForUserReport[] | undefined;
    paymentType!: PaymentType;
    paymentStatus!: PaymentStatus;
    creationTime!: moment.Moment | undefined;
    creationUser!: string | undefined;
    paymentDateTime!: moment.Moment | undefined;
    paymentModifyDate!: moment.Moment | undefined;
    paymentModifierUser!: string | undefined;
    priceAmount!: number;
    description!: string | undefined;
    bankAccountId!: number | undefined;
    bank!: string | undefined;
    pos!: string | undefined;
    bankBranch!: string | undefined;
    panCard!: string | undefined;
    bankTrackingNO!: string | undefined;
    bankSerialNO!: string | undefined;

    constructor(data?: IPaymentReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["bill"])) {
                this.bill = [] as any;
                for (let item of data["bill"])
                    this.bill!.push(BillForUserReport.fromJS(item));
            }
            this.paymentType = data["paymentType"];
            this.paymentStatus = data["paymentStatus"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creationUser = data["creationUser"];
            this.paymentDateTime = data["paymentDateTime"] ? moment(data["paymentDateTime"].toString()) : <any>undefined;
            this.paymentModifyDate = data["paymentModifyDate"] ? moment(data["paymentModifyDate"].toString()) : <any>undefined;
            this.paymentModifierUser = data["paymentModifierUser"];
            this.priceAmount = data["priceAmount"];
            this.description = data["description"];
            this.bankAccountId = data["bankAccountId"];
            this.bank = data["bank"];
            this.pos = data["pos"];
            this.bankBranch = data["bankBranch"];
            this.panCard = data["panCard"];
            this.bankTrackingNO = data["bankTrackingNO"];
            this.bankSerialNO = data["bankSerialNO"];
        }
    }

    static fromJS(data: any): PaymentReport {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bill)) {
            data["bill"] = [];
            for (let item of this.bill)
                data["bill"].push(item.toJSON());
        }
        data["paymentType"] = this.paymentType;
        data["paymentStatus"] = this.paymentStatus;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creationUser"] = this.creationUser;
        data["paymentDateTime"] = this.paymentDateTime ? this.paymentDateTime.toISOString() : <any>undefined;
        data["paymentModifyDate"] = this.paymentModifyDate ? this.paymentModifyDate.toISOString() : <any>undefined;
        data["paymentModifierUser"] = this.paymentModifierUser;
        data["priceAmount"] = this.priceAmount;
        data["description"] = this.description;
        data["bankAccountId"] = this.bankAccountId;
        data["bank"] = this.bank;
        data["pos"] = this.pos;
        data["bankBranch"] = this.bankBranch;
        data["panCard"] = this.panCard;
        data["bankTrackingNO"] = this.bankTrackingNO;
        data["bankSerialNO"] = this.bankSerialNO;
        return data; 
    }
}

export interface IPaymentReport {
    bill: BillForUserReport[] | undefined;
    paymentType: PaymentType;
    paymentStatus: PaymentStatus;
    creationTime: moment.Moment | undefined;
    creationUser: string | undefined;
    paymentDateTime: moment.Moment | undefined;
    paymentModifyDate: moment.Moment | undefined;
    paymentModifierUser: string | undefined;
    priceAmount: number;
    description: string | undefined;
    bankAccountId: number | undefined;
    bank: string | undefined;
    pos: string | undefined;
    bankBranch: string | undefined;
    panCard: string | undefined;
    bankTrackingNO: string | undefined;
    bankSerialNO: string | undefined;
}

export class PaymentReportBankDetails implements IPaymentReportBankDetails {
    bankName!: string | undefined;
    bankAccountId!: number | undefined;
    priceAmount!: number;
    paymentType!: PaymentType;
    paymentStatus!: PaymentStatus;
    paymentDateTime!: moment.Moment | undefined;

    constructor(data?: IPaymentReportBankDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bankName = data["bankName"];
            this.bankAccountId = data["bankAccountId"];
            this.priceAmount = data["priceAmount"];
            this.paymentType = data["paymentType"];
            this.paymentStatus = data["paymentStatus"];
            this.paymentDateTime = data["paymentDateTime"] ? moment(data["paymentDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PaymentReportBankDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentReportBankDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankName"] = this.bankName;
        data["bankAccountId"] = this.bankAccountId;
        data["priceAmount"] = this.priceAmount;
        data["paymentType"] = this.paymentType;
        data["paymentStatus"] = this.paymentStatus;
        data["paymentDateTime"] = this.paymentDateTime ? this.paymentDateTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IPaymentReportBankDetails {
    bankName: string | undefined;
    bankAccountId: number | undefined;
    priceAmount: number;
    paymentType: PaymentType;
    paymentStatus: PaymentStatus;
    paymentDateTime: moment.Moment | undefined;
}

export class GetUserReportOutputDto implements IGetUserReportOutputDto {
    creatorPaymentsIpg!: PaymentReport[] | undefined;
    creatorPaymentsCard!: PaymentReport[] | undefined;
    creatorPaymentsBankReceipt!: PaymentReport[] | undefined;
    creatorPaymentsCash!: PaymentReport[] | undefined;
    creatorPaymentsPos!: PaymentReport[] | undefined;
    creatorPaymentsCheck!: PaymentReport[] | undefined;
    creatorPaymentsPayToPostman!: PaymentReport[] | undefined;
    creatorPaymentsVirtualCredit!: PaymentReport[] | undefined;
    creatorPaymentsDiscount!: PaymentReport[] | undefined;
    creatorPaymentsBankDetails!: PaymentReportBankDetails[] | undefined;
    approverPaymentsCard!: PaymentReport[] | undefined;
    approverPaymentsBankReceipt!: PaymentReport[] | undefined;
    approverPaymentsCash!: PaymentReport[] | undefined;
    approverPaymentsPos!: PaymentReport[] | undefined;
    approverPaymentsCheck!: PaymentReport[] | undefined;
    approverPaymentsDiscount!: PaymentReport[] | undefined;
    approverPaymentsBankDetails!: PaymentReportBankDetails[] | undefined;
    paymentsBankDetails!: PaymentReportBankDetails[] | undefined;
    verifiedPaymentsIpg!: PaymentReport[] | undefined;
    verifiedPaymentsCard!: PaymentReport[] | undefined;
    verifiedPaymentsBankReceipt!: PaymentReport[] | undefined;
    verifiedPaymentsCash!: PaymentReport[] | undefined;
    verifiedPaymentsPos!: PaymentReport[] | undefined;
    verifiedPaymentsCheck!: PaymentReport[] | undefined;
    verifiedPaymentsDiscount!: PaymentReport[] | undefined;
    verifiedPaymentsBankDetails!: PaymentReportBankDetails[] | undefined;

    constructor(data?: IGetUserReportOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["creatorPaymentsIpg"])) {
                this.creatorPaymentsIpg = [] as any;
                for (let item of data["creatorPaymentsIpg"])
                    this.creatorPaymentsIpg!.push(PaymentReport.fromJS(item));
            }
            if (Array.isArray(data["creatorPaymentsCard"])) {
                this.creatorPaymentsCard = [] as any;
                for (let item of data["creatorPaymentsCard"])
                    this.creatorPaymentsCard!.push(PaymentReport.fromJS(item));
            }
            if (Array.isArray(data["creatorPaymentsBankReceipt"])) {
                this.creatorPaymentsBankReceipt = [] as any;
                for (let item of data["creatorPaymentsBankReceipt"])
                    this.creatorPaymentsBankReceipt!.push(PaymentReport.fromJS(item));
            }
            if (Array.isArray(data["creatorPaymentsCash"])) {
                this.creatorPaymentsCash = [] as any;
                for (let item of data["creatorPaymentsCash"])
                    this.creatorPaymentsCash!.push(PaymentReport.fromJS(item));
            }
            if (Array.isArray(data["creatorPaymentsPos"])) {
                this.creatorPaymentsPos = [] as any;
                for (let item of data["creatorPaymentsPos"])
                    this.creatorPaymentsPos!.push(PaymentReport.fromJS(item));
            }
            if (Array.isArray(data["creatorPaymentsCheck"])) {
                this.creatorPaymentsCheck = [] as any;
                for (let item of data["creatorPaymentsCheck"])
                    this.creatorPaymentsCheck!.push(PaymentReport.fromJS(item));
            }
            if (Array.isArray(data["creatorPaymentsPayToPostman"])) {
                this.creatorPaymentsPayToPostman = [] as any;
                for (let item of data["creatorPaymentsPayToPostman"])
                    this.creatorPaymentsPayToPostman!.push(PaymentReport.fromJS(item));
            }
            if (Array.isArray(data["creatorPaymentsVirtualCredit"])) {
                this.creatorPaymentsVirtualCredit = [] as any;
                for (let item of data["creatorPaymentsVirtualCredit"])
                    this.creatorPaymentsVirtualCredit!.push(PaymentReport.fromJS(item));
            }
            if (Array.isArray(data["creatorPaymentsDiscount"])) {
                this.creatorPaymentsDiscount = [] as any;
                for (let item of data["creatorPaymentsDiscount"])
                    this.creatorPaymentsDiscount!.push(PaymentReport.fromJS(item));
            }
            if (Array.isArray(data["creatorPaymentsBankDetails"])) {
                this.creatorPaymentsBankDetails = [] as any;
                for (let item of data["creatorPaymentsBankDetails"])
                    this.creatorPaymentsBankDetails!.push(PaymentReportBankDetails.fromJS(item));
            }
            if (Array.isArray(data["approverPaymentsCard"])) {
                this.approverPaymentsCard = [] as any;
                for (let item of data["approverPaymentsCard"])
                    this.approverPaymentsCard!.push(PaymentReport.fromJS(item));
            }
            if (Array.isArray(data["approverPaymentsBankReceipt"])) {
                this.approverPaymentsBankReceipt = [] as any;
                for (let item of data["approverPaymentsBankReceipt"])
                    this.approverPaymentsBankReceipt!.push(PaymentReport.fromJS(item));
            }
            if (Array.isArray(data["approverPaymentsCash"])) {
                this.approverPaymentsCash = [] as any;
                for (let item of data["approverPaymentsCash"])
                    this.approverPaymentsCash!.push(PaymentReport.fromJS(item));
            }
            if (Array.isArray(data["approverPaymentsPos"])) {
                this.approverPaymentsPos = [] as any;
                for (let item of data["approverPaymentsPos"])
                    this.approverPaymentsPos!.push(PaymentReport.fromJS(item));
            }
            if (Array.isArray(data["approverPaymentsCheck"])) {
                this.approverPaymentsCheck = [] as any;
                for (let item of data["approverPaymentsCheck"])
                    this.approverPaymentsCheck!.push(PaymentReport.fromJS(item));
            }
            if (Array.isArray(data["approverPaymentsDiscount"])) {
                this.approverPaymentsDiscount = [] as any;
                for (let item of data["approverPaymentsDiscount"])
                    this.approverPaymentsDiscount!.push(PaymentReport.fromJS(item));
            }
            if (Array.isArray(data["approverPaymentsBankDetails"])) {
                this.approverPaymentsBankDetails = [] as any;
                for (let item of data["approverPaymentsBankDetails"])
                    this.approverPaymentsBankDetails!.push(PaymentReportBankDetails.fromJS(item));
            }
            if (Array.isArray(data["paymentsBankDetails"])) {
                this.paymentsBankDetails = [] as any;
                for (let item of data["paymentsBankDetails"])
                    this.paymentsBankDetails!.push(PaymentReportBankDetails.fromJS(item));
            }
            if (Array.isArray(data["verifiedPaymentsIpg"])) {
                this.verifiedPaymentsIpg = [] as any;
                for (let item of data["verifiedPaymentsIpg"])
                    this.verifiedPaymentsIpg!.push(PaymentReport.fromJS(item));
            }
            if (Array.isArray(data["verifiedPaymentsCard"])) {
                this.verifiedPaymentsCard = [] as any;
                for (let item of data["verifiedPaymentsCard"])
                    this.verifiedPaymentsCard!.push(PaymentReport.fromJS(item));
            }
            if (Array.isArray(data["verifiedPaymentsBankReceipt"])) {
                this.verifiedPaymentsBankReceipt = [] as any;
                for (let item of data["verifiedPaymentsBankReceipt"])
                    this.verifiedPaymentsBankReceipt!.push(PaymentReport.fromJS(item));
            }
            if (Array.isArray(data["verifiedPaymentsCash"])) {
                this.verifiedPaymentsCash = [] as any;
                for (let item of data["verifiedPaymentsCash"])
                    this.verifiedPaymentsCash!.push(PaymentReport.fromJS(item));
            }
            if (Array.isArray(data["verifiedPaymentsPos"])) {
                this.verifiedPaymentsPos = [] as any;
                for (let item of data["verifiedPaymentsPos"])
                    this.verifiedPaymentsPos!.push(PaymentReport.fromJS(item));
            }
            if (Array.isArray(data["verifiedPaymentsCheck"])) {
                this.verifiedPaymentsCheck = [] as any;
                for (let item of data["verifiedPaymentsCheck"])
                    this.verifiedPaymentsCheck!.push(PaymentReport.fromJS(item));
            }
            if (Array.isArray(data["verifiedPaymentsDiscount"])) {
                this.verifiedPaymentsDiscount = [] as any;
                for (let item of data["verifiedPaymentsDiscount"])
                    this.verifiedPaymentsDiscount!.push(PaymentReport.fromJS(item));
            }
            if (Array.isArray(data["verifiedPaymentsBankDetails"])) {
                this.verifiedPaymentsBankDetails = [] as any;
                for (let item of data["verifiedPaymentsBankDetails"])
                    this.verifiedPaymentsBankDetails!.push(PaymentReportBankDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserReportOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserReportOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.creatorPaymentsIpg)) {
            data["creatorPaymentsIpg"] = [];
            for (let item of this.creatorPaymentsIpg)
                data["creatorPaymentsIpg"].push(item.toJSON());
        }
        if (Array.isArray(this.creatorPaymentsCard)) {
            data["creatorPaymentsCard"] = [];
            for (let item of this.creatorPaymentsCard)
                data["creatorPaymentsCard"].push(item.toJSON());
        }
        if (Array.isArray(this.creatorPaymentsBankReceipt)) {
            data["creatorPaymentsBankReceipt"] = [];
            for (let item of this.creatorPaymentsBankReceipt)
                data["creatorPaymentsBankReceipt"].push(item.toJSON());
        }
        if (Array.isArray(this.creatorPaymentsCash)) {
            data["creatorPaymentsCash"] = [];
            for (let item of this.creatorPaymentsCash)
                data["creatorPaymentsCash"].push(item.toJSON());
        }
        if (Array.isArray(this.creatorPaymentsPos)) {
            data["creatorPaymentsPos"] = [];
            for (let item of this.creatorPaymentsPos)
                data["creatorPaymentsPos"].push(item.toJSON());
        }
        if (Array.isArray(this.creatorPaymentsCheck)) {
            data["creatorPaymentsCheck"] = [];
            for (let item of this.creatorPaymentsCheck)
                data["creatorPaymentsCheck"].push(item.toJSON());
        }
        if (Array.isArray(this.creatorPaymentsPayToPostman)) {
            data["creatorPaymentsPayToPostman"] = [];
            for (let item of this.creatorPaymentsPayToPostman)
                data["creatorPaymentsPayToPostman"].push(item.toJSON());
        }
        if (Array.isArray(this.creatorPaymentsVirtualCredit)) {
            data["creatorPaymentsVirtualCredit"] = [];
            for (let item of this.creatorPaymentsVirtualCredit)
                data["creatorPaymentsVirtualCredit"].push(item.toJSON());
        }
        if (Array.isArray(this.creatorPaymentsDiscount)) {
            data["creatorPaymentsDiscount"] = [];
            for (let item of this.creatorPaymentsDiscount)
                data["creatorPaymentsDiscount"].push(item.toJSON());
        }
        if (Array.isArray(this.creatorPaymentsBankDetails)) {
            data["creatorPaymentsBankDetails"] = [];
            for (let item of this.creatorPaymentsBankDetails)
                data["creatorPaymentsBankDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.approverPaymentsCard)) {
            data["approverPaymentsCard"] = [];
            for (let item of this.approverPaymentsCard)
                data["approverPaymentsCard"].push(item.toJSON());
        }
        if (Array.isArray(this.approverPaymentsBankReceipt)) {
            data["approverPaymentsBankReceipt"] = [];
            for (let item of this.approverPaymentsBankReceipt)
                data["approverPaymentsBankReceipt"].push(item.toJSON());
        }
        if (Array.isArray(this.approverPaymentsCash)) {
            data["approverPaymentsCash"] = [];
            for (let item of this.approverPaymentsCash)
                data["approverPaymentsCash"].push(item.toJSON());
        }
        if (Array.isArray(this.approverPaymentsPos)) {
            data["approverPaymentsPos"] = [];
            for (let item of this.approverPaymentsPos)
                data["approverPaymentsPos"].push(item.toJSON());
        }
        if (Array.isArray(this.approverPaymentsCheck)) {
            data["approverPaymentsCheck"] = [];
            for (let item of this.approverPaymentsCheck)
                data["approverPaymentsCheck"].push(item.toJSON());
        }
        if (Array.isArray(this.approverPaymentsDiscount)) {
            data["approverPaymentsDiscount"] = [];
            for (let item of this.approverPaymentsDiscount)
                data["approverPaymentsDiscount"].push(item.toJSON());
        }
        if (Array.isArray(this.approverPaymentsBankDetails)) {
            data["approverPaymentsBankDetails"] = [];
            for (let item of this.approverPaymentsBankDetails)
                data["approverPaymentsBankDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.paymentsBankDetails)) {
            data["paymentsBankDetails"] = [];
            for (let item of this.paymentsBankDetails)
                data["paymentsBankDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.verifiedPaymentsIpg)) {
            data["verifiedPaymentsIpg"] = [];
            for (let item of this.verifiedPaymentsIpg)
                data["verifiedPaymentsIpg"].push(item.toJSON());
        }
        if (Array.isArray(this.verifiedPaymentsCard)) {
            data["verifiedPaymentsCard"] = [];
            for (let item of this.verifiedPaymentsCard)
                data["verifiedPaymentsCard"].push(item.toJSON());
        }
        if (Array.isArray(this.verifiedPaymentsBankReceipt)) {
            data["verifiedPaymentsBankReceipt"] = [];
            for (let item of this.verifiedPaymentsBankReceipt)
                data["verifiedPaymentsBankReceipt"].push(item.toJSON());
        }
        if (Array.isArray(this.verifiedPaymentsCash)) {
            data["verifiedPaymentsCash"] = [];
            for (let item of this.verifiedPaymentsCash)
                data["verifiedPaymentsCash"].push(item.toJSON());
        }
        if (Array.isArray(this.verifiedPaymentsPos)) {
            data["verifiedPaymentsPos"] = [];
            for (let item of this.verifiedPaymentsPos)
                data["verifiedPaymentsPos"].push(item.toJSON());
        }
        if (Array.isArray(this.verifiedPaymentsCheck)) {
            data["verifiedPaymentsCheck"] = [];
            for (let item of this.verifiedPaymentsCheck)
                data["verifiedPaymentsCheck"].push(item.toJSON());
        }
        if (Array.isArray(this.verifiedPaymentsDiscount)) {
            data["verifiedPaymentsDiscount"] = [];
            for (let item of this.verifiedPaymentsDiscount)
                data["verifiedPaymentsDiscount"].push(item.toJSON());
        }
        if (Array.isArray(this.verifiedPaymentsBankDetails)) {
            data["verifiedPaymentsBankDetails"] = [];
            for (let item of this.verifiedPaymentsBankDetails)
                data["verifiedPaymentsBankDetails"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetUserReportOutputDto {
    creatorPaymentsIpg: PaymentReport[] | undefined;
    creatorPaymentsCard: PaymentReport[] | undefined;
    creatorPaymentsBankReceipt: PaymentReport[] | undefined;
    creatorPaymentsCash: PaymentReport[] | undefined;
    creatorPaymentsPos: PaymentReport[] | undefined;
    creatorPaymentsCheck: PaymentReport[] | undefined;
    creatorPaymentsPayToPostman: PaymentReport[] | undefined;
    creatorPaymentsVirtualCredit: PaymentReport[] | undefined;
    creatorPaymentsDiscount: PaymentReport[] | undefined;
    creatorPaymentsBankDetails: PaymentReportBankDetails[] | undefined;
    approverPaymentsCard: PaymentReport[] | undefined;
    approverPaymentsBankReceipt: PaymentReport[] | undefined;
    approverPaymentsCash: PaymentReport[] | undefined;
    approverPaymentsPos: PaymentReport[] | undefined;
    approverPaymentsCheck: PaymentReport[] | undefined;
    approverPaymentsDiscount: PaymentReport[] | undefined;
    approverPaymentsBankDetails: PaymentReportBankDetails[] | undefined;
    paymentsBankDetails: PaymentReportBankDetails[] | undefined;
    verifiedPaymentsIpg: PaymentReport[] | undefined;
    verifiedPaymentsCard: PaymentReport[] | undefined;
    verifiedPaymentsBankReceipt: PaymentReport[] | undefined;
    verifiedPaymentsCash: PaymentReport[] | undefined;
    verifiedPaymentsPos: PaymentReport[] | undefined;
    verifiedPaymentsCheck: PaymentReport[] | undefined;
    verifiedPaymentsDiscount: PaymentReport[] | undefined;
    verifiedPaymentsBankDetails: PaymentReportBankDetails[] | undefined;
}

export class RefusalToPaymentInput implements IRefusalToPaymentInput {
    billId!: number;
    description!: string | undefined;

    constructor(data?: IRefusalToPaymentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.billId = data["billId"];
            this.description = data["description"];
        }
    }

    static fromJS(data: any): RefusalToPaymentInput {
        data = typeof data === 'object' ? data : {};
        let result = new RefusalToPaymentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billId"] = this.billId;
        data["description"] = this.description;
        return data; 
    }
}

export interface IRefusalToPaymentInput {
    billId: number;
    description: string | undefined;
}

export class ClaimWalletChargeInput implements IClaimWalletChargeInput {
    billId!: number;
    planConstCode!: string | undefined;
    planConstId!: number;
    price!: number;
    count!: number | undefined;
    contactMobileNumber!: string | undefined;
    contactEmail!: string | undefined;
    contactIntroducer!: string | undefined;
    callContact!: boolean | undefined;

    constructor(data?: IClaimWalletChargeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.billId = data["billId"];
            this.planConstCode = data["planConstCode"];
            this.planConstId = data["planConstId"];
            this.price = data["price"];
            this.count = data["count"];
            this.contactMobileNumber = data["contactMobileNumber"];
            this.contactEmail = data["contactEmail"];
            this.contactIntroducer = data["contactIntroducer"];
            this.callContact = data["callContact"];
        }
    }

    static fromJS(data: any): ClaimWalletChargeInput {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimWalletChargeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billId"] = this.billId;
        data["planConstCode"] = this.planConstCode;
        data["planConstId"] = this.planConstId;
        data["price"] = this.price;
        data["count"] = this.count;
        data["contactMobileNumber"] = this.contactMobileNumber;
        data["contactEmail"] = this.contactEmail;
        data["contactIntroducer"] = this.contactIntroducer;
        data["callContact"] = this.callContact;
        return data; 
    }
}

export interface IClaimWalletChargeInput {
    billId: number;
    planConstCode: string | undefined;
    planConstId: number;
    price: number;
    count: number | undefined;
    contactMobileNumber: string | undefined;
    contactEmail: string | undefined;
    contactIntroducer: string | undefined;
    callContact: boolean | undefined;
}

export class ClaimWalletChargeResponseDto implements IClaimWalletChargeResponseDto {
    responseCode!: number;

    constructor(data?: IClaimWalletChargeResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.responseCode = data["responseCode"];
        }
    }

    static fromJS(data: any): ClaimWalletChargeResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimWalletChargeResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode;
        return data; 
    }
}

export interface IClaimWalletChargeResponseDto {
    responseCode: number;
}

export class CreatePaymentForKioskInput implements ICreatePaymentForKioskInput {
    billId!: number;
    panCard!: string | undefined;
    paymentDateTime!: moment.Moment | undefined;
    bankTrackingNO!: string | undefined;
    bankSerialNO!: string | undefined;
    priceAmount!: number;
    posRef!: number | undefined;
    paymentStatus!: PaymentStatus;

    constructor(data?: ICreatePaymentForKioskInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.billId = data["billId"];
            this.panCard = data["panCard"];
            this.paymentDateTime = data["paymentDateTime"] ? moment(data["paymentDateTime"].toString()) : <any>undefined;
            this.bankTrackingNO = data["bankTrackingNO"];
            this.bankSerialNO = data["bankSerialNO"];
            this.priceAmount = data["priceAmount"];
            this.posRef = data["posRef"];
            this.paymentStatus = data["paymentStatus"];
        }
    }

    static fromJS(data: any): CreatePaymentForKioskInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePaymentForKioskInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billId"] = this.billId;
        data["panCard"] = this.panCard;
        data["paymentDateTime"] = this.paymentDateTime ? this.paymentDateTime.toISOString() : <any>undefined;
        data["bankTrackingNO"] = this.bankTrackingNO;
        data["bankSerialNO"] = this.bankSerialNO;
        data["priceAmount"] = this.priceAmount;
        data["posRef"] = this.posRef;
        data["paymentStatus"] = this.paymentStatus;
        return data; 
    }
}

export interface ICreatePaymentForKioskInput {
    billId: number;
    panCard: string | undefined;
    paymentDateTime: moment.Moment | undefined;
    bankTrackingNO: string | undefined;
    bankSerialNO: string | undefined;
    priceAmount: number;
    posRef: number | undefined;
    paymentStatus: PaymentStatus;
}

export class BillReportDto implements IBillReportDto {
    currencyId!: number;
    branchRef!: number | undefined;
    count!: number | undefined;
    firstName!: string | undefined;
    issueDate!: moment.Moment;
    billCreatorUser!: string | undefined;
    status!: BillStatus;
    billCode!: string | undefined;
    price!: number;
    description!: string | undefined;
    extraEntity!: Consumers;
    planConstTitle!: string | undefined;
    planBillCode!: string | undefined;
    benefactorName!: string | undefined;
    approveFullName!: string | undefined;
    lat!: number | undefined;
    long!: number | undefined;
    dueDate!: moment.Moment | undefined;
    extraEntityRef!: number | undefined;
    deliveryType!: DeliveryTypes;
    contactId!: number;
    descriptionOne!: string | undefined;
    descriptionTwo!: string | undefined;
    announceTheDifference!: boolean;
    cardTemplateRef!: number | undefined;
    ceremonyTitle!: string | undefined;
    deceasedTitle!: string | undefined;
    currencyName!: string | undefined;
    cardTemplateTile!: string | undefined;
    planBillId!: number | undefined;
    planConstId!: number | undefined;
    planType!: Plans;
    lastName!: string | undefined;
    mobileNumber1!: string | undefined;
    billId!: number;
    planConstCode!: string | undefined;
    sourceAttributes!: string | undefined;
    sourceAttributesValue!: string | undefined;
    paymentCreatorUser!: string | undefined;
    paymentCreatDate!: moment.Moment | undefined;
    paymentApprovedDate!: moment.Moment | undefined;
    paymentType!: string | undefined;
    bankSerialNO!: string | undefined;
    branchCode!: string | undefined;
    bankPayment!: string | undefined;
    paymentAmount!: number | undefined;
    paymentBankTrackingNO!: string | undefined;
    paymentAccountingTrackingNO!: string | undefined;
    panCard!: string | undefined;
    paymentDateTime!: moment.Moment | undefined;
    posSerial!: string | undefined;
    depositId!: string | undefined;
    paymentDescription!: string | undefined;
    bankAccountNumber!: string | undefined;
    paymentId!: number | undefined;
    id!: number;

    constructor(data?: IBillReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currencyId = data["currencyId"];
            this.branchRef = data["branchRef"];
            this.count = data["count"];
            this.firstName = data["firstName"];
            this.issueDate = data["issueDate"] ? moment(data["issueDate"].toString()) : <any>undefined;
            this.billCreatorUser = data["billCreatorUser"];
            this.status = data["status"];
            this.billCode = data["billCode"];
            this.price = data["price"];
            this.description = data["description"];
            this.extraEntity = data["extraEntity"];
            this.planConstTitle = data["planConstTitle"];
            this.planBillCode = data["planBillCode"];
            this.benefactorName = data["benefactorName"];
            this.approveFullName = data["approveFullName"];
            this.lat = data["lat"];
            this.long = data["long"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.extraEntityRef = data["extraEntityRef"];
            this.deliveryType = data["deliveryType"];
            this.contactId = data["contactId"];
            this.descriptionOne = data["descriptionOne"];
            this.descriptionTwo = data["descriptionTwo"];
            this.announceTheDifference = data["announceTheDifference"];
            this.cardTemplateRef = data["cardTemplateRef"];
            this.ceremonyTitle = data["ceremonyTitle"];
            this.deceasedTitle = data["deceasedTitle"];
            this.currencyName = data["currencyName"];
            this.cardTemplateTile = data["cardTemplateTile"];
            this.planBillId = data["planBillId"];
            this.planConstId = data["planConstId"];
            this.planType = data["planType"];
            this.lastName = data["lastName"];
            this.mobileNumber1 = data["mobileNumber1"];
            this.billId = data["billId"];
            this.planConstCode = data["planConstCode"];
            this.sourceAttributes = data["sourceAttributes"];
            this.sourceAttributesValue = data["sourceAttributesValue"];
            this.paymentCreatorUser = data["paymentCreatorUser"];
            this.paymentCreatDate = data["paymentCreatDate"] ? moment(data["paymentCreatDate"].toString()) : <any>undefined;
            this.paymentApprovedDate = data["paymentApprovedDate"] ? moment(data["paymentApprovedDate"].toString()) : <any>undefined;
            this.paymentType = data["paymentType"];
            this.bankSerialNO = data["bankSerialNO"];
            this.branchCode = data["branchCode"];
            this.bankPayment = data["bankPayment"];
            this.paymentAmount = data["paymentAmount"];
            this.paymentBankTrackingNO = data["paymentBankTrackingNO"];
            this.paymentAccountingTrackingNO = data["paymentAccountingTrackingNO"];
            this.panCard = data["panCard"];
            this.paymentDateTime = data["paymentDateTime"] ? moment(data["paymentDateTime"].toString()) : <any>undefined;
            this.posSerial = data["posSerial"];
            this.depositId = data["depositId"];
            this.paymentDescription = data["paymentDescription"];
            this.bankAccountNumber = data["bankAccountNumber"];
            this.paymentId = data["paymentId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): BillReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyId"] = this.currencyId;
        data["branchRef"] = this.branchRef;
        data["count"] = this.count;
        data["firstName"] = this.firstName;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["billCreatorUser"] = this.billCreatorUser;
        data["status"] = this.status;
        data["billCode"] = this.billCode;
        data["price"] = this.price;
        data["description"] = this.description;
        data["extraEntity"] = this.extraEntity;
        data["planConstTitle"] = this.planConstTitle;
        data["planBillCode"] = this.planBillCode;
        data["benefactorName"] = this.benefactorName;
        data["approveFullName"] = this.approveFullName;
        data["lat"] = this.lat;
        data["long"] = this.long;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["extraEntityRef"] = this.extraEntityRef;
        data["deliveryType"] = this.deliveryType;
        data["contactId"] = this.contactId;
        data["descriptionOne"] = this.descriptionOne;
        data["descriptionTwo"] = this.descriptionTwo;
        data["announceTheDifference"] = this.announceTheDifference;
        data["cardTemplateRef"] = this.cardTemplateRef;
        data["ceremonyTitle"] = this.ceremonyTitle;
        data["deceasedTitle"] = this.deceasedTitle;
        data["currencyName"] = this.currencyName;
        data["cardTemplateTile"] = this.cardTemplateTile;
        data["planBillId"] = this.planBillId;
        data["planConstId"] = this.planConstId;
        data["planType"] = this.planType;
        data["lastName"] = this.lastName;
        data["mobileNumber1"] = this.mobileNumber1;
        data["billId"] = this.billId;
        data["planConstCode"] = this.planConstCode;
        data["sourceAttributes"] = this.sourceAttributes;
        data["sourceAttributesValue"] = this.sourceAttributesValue;
        data["paymentCreatorUser"] = this.paymentCreatorUser;
        data["paymentCreatDate"] = this.paymentCreatDate ? this.paymentCreatDate.toISOString() : <any>undefined;
        data["paymentApprovedDate"] = this.paymentApprovedDate ? this.paymentApprovedDate.toISOString() : <any>undefined;
        data["paymentType"] = this.paymentType;
        data["bankSerialNO"] = this.bankSerialNO;
        data["branchCode"] = this.branchCode;
        data["bankPayment"] = this.bankPayment;
        data["paymentAmount"] = this.paymentAmount;
        data["paymentBankTrackingNO"] = this.paymentBankTrackingNO;
        data["paymentAccountingTrackingNO"] = this.paymentAccountingTrackingNO;
        data["panCard"] = this.panCard;
        data["paymentDateTime"] = this.paymentDateTime ? this.paymentDateTime.toISOString() : <any>undefined;
        data["posSerial"] = this.posSerial;
        data["depositId"] = this.depositId;
        data["paymentDescription"] = this.paymentDescription;
        data["bankAccountNumber"] = this.bankAccountNumber;
        data["paymentId"] = this.paymentId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IBillReportDto {
    currencyId: number;
    branchRef: number | undefined;
    count: number | undefined;
    firstName: string | undefined;
    issueDate: moment.Moment;
    billCreatorUser: string | undefined;
    status: BillStatus;
    billCode: string | undefined;
    price: number;
    description: string | undefined;
    extraEntity: Consumers;
    planConstTitle: string | undefined;
    planBillCode: string | undefined;
    benefactorName: string | undefined;
    approveFullName: string | undefined;
    lat: number | undefined;
    long: number | undefined;
    dueDate: moment.Moment | undefined;
    extraEntityRef: number | undefined;
    deliveryType: DeliveryTypes;
    contactId: number;
    descriptionOne: string | undefined;
    descriptionTwo: string | undefined;
    announceTheDifference: boolean;
    cardTemplateRef: number | undefined;
    ceremonyTitle: string | undefined;
    deceasedTitle: string | undefined;
    currencyName: string | undefined;
    cardTemplateTile: string | undefined;
    planBillId: number | undefined;
    planConstId: number | undefined;
    planType: Plans;
    lastName: string | undefined;
    mobileNumber1: string | undefined;
    billId: number;
    planConstCode: string | undefined;
    sourceAttributes: string | undefined;
    sourceAttributesValue: string | undefined;
    paymentCreatorUser: string | undefined;
    paymentCreatDate: moment.Moment | undefined;
    paymentApprovedDate: moment.Moment | undefined;
    paymentType: string | undefined;
    bankSerialNO: string | undefined;
    branchCode: string | undefined;
    bankPayment: string | undefined;
    paymentAmount: number | undefined;
    paymentBankTrackingNO: string | undefined;
    paymentAccountingTrackingNO: string | undefined;
    panCard: string | undefined;
    paymentDateTime: moment.Moment | undefined;
    posSerial: string | undefined;
    depositId: string | undefined;
    paymentDescription: string | undefined;
    bankAccountNumber: string | undefined;
    paymentId: number | undefined;
    id: number;
}

export class GetBillReportForViewDto implements IGetBillReportForViewDto {
    billReport!: BillReportDto;

    constructor(data?: IGetBillReportForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.billReport = data["billReport"] ? BillReportDto.fromJS(data["billReport"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBillReportForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBillReportForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billReport"] = this.billReport ? this.billReport.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetBillReportForViewDto {
    billReport: BillReportDto;
}

export class PagedResultDtoOfGetBillReportForViewDto implements IPagedResultDtoOfGetBillReportForViewDto {
    totalCount!: number;
    items!: GetBillReportForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetBillReportForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetBillReportForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetBillReportForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetBillReportForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetBillReportForViewDto {
    totalCount: number;
    items: GetBillReportForViewDto[] | undefined;
}

export class CreateOrEditBillReportDto implements ICreateOrEditBillReportDto {
    currencyId!: number;
    branchRef!: number | undefined;
    count!: number | undefined;
    firstName!: string | undefined;
    issueDate!: moment.Moment;
    billCreatorUser!: string | undefined;
    status!: BillStatus;
    billCode!: string | undefined;
    price!: number;
    description!: string | undefined;
    extraEntity!: Consumers;
    planConstTitle!: string | undefined;
    planBillCode!: string | undefined;
    benefactorName!: string | undefined;
    approveFullName!: string | undefined;
    lat!: number | undefined;
    long!: number | undefined;
    dueDate!: moment.Moment | undefined;
    extraEntityRef!: number | undefined;
    deliveryType!: DeliveryTypes;
    contactId!: number;
    descriptionOne!: string | undefined;
    descriptionTwo!: string | undefined;
    announceTheDifference!: boolean;
    cardTemplateRef!: number | undefined;
    ceremonyTitle!: string | undefined;
    deceasedTitle!: string | undefined;
    currencyName!: string | undefined;
    cardTemplateTile!: string | undefined;
    planBillId!: number | undefined;
    planConstId!: number | undefined;
    planType!: Plans;
    lastName!: string | undefined;
    mobileNumber1!: string | undefined;
    billId!: number;
    planConstCode!: string | undefined;
    sourceAttributes!: string | undefined;
    sourceAttributesValue!: string | undefined;
    paymentCreatorUser!: string | undefined;
    paymentCreatDate!: moment.Moment | undefined;
    paymentApprovedDate!: moment.Moment | undefined;
    paymentType!: string | undefined;
    bankSerialNO!: string | undefined;
    branchCode!: string | undefined;
    bankPayment!: string | undefined;
    paymentAmount!: number | undefined;
    paymentBankTrackingNO!: string | undefined;
    paymentAccountingTrackingNO!: string | undefined;
    panCard!: string | undefined;
    paymentDateTime!: moment.Moment | undefined;
    posSerial!: string | undefined;
    depositId!: string | undefined;
    paymentDescription!: string | undefined;
    bankAccountNumber!: string | undefined;
    paymentId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditBillReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currencyId = data["currencyId"];
            this.branchRef = data["branchRef"];
            this.count = data["count"];
            this.firstName = data["firstName"];
            this.issueDate = data["issueDate"] ? moment(data["issueDate"].toString()) : <any>undefined;
            this.billCreatorUser = data["billCreatorUser"];
            this.status = data["status"];
            this.billCode = data["billCode"];
            this.price = data["price"];
            this.description = data["description"];
            this.extraEntity = data["extraEntity"];
            this.planConstTitle = data["planConstTitle"];
            this.planBillCode = data["planBillCode"];
            this.benefactorName = data["benefactorName"];
            this.approveFullName = data["approveFullName"];
            this.lat = data["lat"];
            this.long = data["long"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.extraEntityRef = data["extraEntityRef"];
            this.deliveryType = data["deliveryType"];
            this.contactId = data["contactId"];
            this.descriptionOne = data["descriptionOne"];
            this.descriptionTwo = data["descriptionTwo"];
            this.announceTheDifference = data["announceTheDifference"];
            this.cardTemplateRef = data["cardTemplateRef"];
            this.ceremonyTitle = data["ceremonyTitle"];
            this.deceasedTitle = data["deceasedTitle"];
            this.currencyName = data["currencyName"];
            this.cardTemplateTile = data["cardTemplateTile"];
            this.planBillId = data["planBillId"];
            this.planConstId = data["planConstId"];
            this.planType = data["planType"];
            this.lastName = data["lastName"];
            this.mobileNumber1 = data["mobileNumber1"];
            this.billId = data["billId"];
            this.planConstCode = data["planConstCode"];
            this.sourceAttributes = data["sourceAttributes"];
            this.sourceAttributesValue = data["sourceAttributesValue"];
            this.paymentCreatorUser = data["paymentCreatorUser"];
            this.paymentCreatDate = data["paymentCreatDate"] ? moment(data["paymentCreatDate"].toString()) : <any>undefined;
            this.paymentApprovedDate = data["paymentApprovedDate"] ? moment(data["paymentApprovedDate"].toString()) : <any>undefined;
            this.paymentType = data["paymentType"];
            this.bankSerialNO = data["bankSerialNO"];
            this.branchCode = data["branchCode"];
            this.bankPayment = data["bankPayment"];
            this.paymentAmount = data["paymentAmount"];
            this.paymentBankTrackingNO = data["paymentBankTrackingNO"];
            this.paymentAccountingTrackingNO = data["paymentAccountingTrackingNO"];
            this.panCard = data["panCard"];
            this.paymentDateTime = data["paymentDateTime"] ? moment(data["paymentDateTime"].toString()) : <any>undefined;
            this.posSerial = data["posSerial"];
            this.depositId = data["depositId"];
            this.paymentDescription = data["paymentDescription"];
            this.bankAccountNumber = data["bankAccountNumber"];
            this.paymentId = data["paymentId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditBillReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditBillReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyId"] = this.currencyId;
        data["branchRef"] = this.branchRef;
        data["count"] = this.count;
        data["firstName"] = this.firstName;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["billCreatorUser"] = this.billCreatorUser;
        data["status"] = this.status;
        data["billCode"] = this.billCode;
        data["price"] = this.price;
        data["description"] = this.description;
        data["extraEntity"] = this.extraEntity;
        data["planConstTitle"] = this.planConstTitle;
        data["planBillCode"] = this.planBillCode;
        data["benefactorName"] = this.benefactorName;
        data["approveFullName"] = this.approveFullName;
        data["lat"] = this.lat;
        data["long"] = this.long;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["extraEntityRef"] = this.extraEntityRef;
        data["deliveryType"] = this.deliveryType;
        data["contactId"] = this.contactId;
        data["descriptionOne"] = this.descriptionOne;
        data["descriptionTwo"] = this.descriptionTwo;
        data["announceTheDifference"] = this.announceTheDifference;
        data["cardTemplateRef"] = this.cardTemplateRef;
        data["ceremonyTitle"] = this.ceremonyTitle;
        data["deceasedTitle"] = this.deceasedTitle;
        data["currencyName"] = this.currencyName;
        data["cardTemplateTile"] = this.cardTemplateTile;
        data["planBillId"] = this.planBillId;
        data["planConstId"] = this.planConstId;
        data["planType"] = this.planType;
        data["lastName"] = this.lastName;
        data["mobileNumber1"] = this.mobileNumber1;
        data["billId"] = this.billId;
        data["planConstCode"] = this.planConstCode;
        data["sourceAttributes"] = this.sourceAttributes;
        data["sourceAttributesValue"] = this.sourceAttributesValue;
        data["paymentCreatorUser"] = this.paymentCreatorUser;
        data["paymentCreatDate"] = this.paymentCreatDate ? this.paymentCreatDate.toISOString() : <any>undefined;
        data["paymentApprovedDate"] = this.paymentApprovedDate ? this.paymentApprovedDate.toISOString() : <any>undefined;
        data["paymentType"] = this.paymentType;
        data["bankSerialNO"] = this.bankSerialNO;
        data["branchCode"] = this.branchCode;
        data["bankPayment"] = this.bankPayment;
        data["paymentAmount"] = this.paymentAmount;
        data["paymentBankTrackingNO"] = this.paymentBankTrackingNO;
        data["paymentAccountingTrackingNO"] = this.paymentAccountingTrackingNO;
        data["panCard"] = this.panCard;
        data["paymentDateTime"] = this.paymentDateTime ? this.paymentDateTime.toISOString() : <any>undefined;
        data["posSerial"] = this.posSerial;
        data["depositId"] = this.depositId;
        data["paymentDescription"] = this.paymentDescription;
        data["bankAccountNumber"] = this.bankAccountNumber;
        data["paymentId"] = this.paymentId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditBillReportDto {
    currencyId: number;
    branchRef: number | undefined;
    count: number | undefined;
    firstName: string | undefined;
    issueDate: moment.Moment;
    billCreatorUser: string | undefined;
    status: BillStatus;
    billCode: string | undefined;
    price: number;
    description: string | undefined;
    extraEntity: Consumers;
    planConstTitle: string | undefined;
    planBillCode: string | undefined;
    benefactorName: string | undefined;
    approveFullName: string | undefined;
    lat: number | undefined;
    long: number | undefined;
    dueDate: moment.Moment | undefined;
    extraEntityRef: number | undefined;
    deliveryType: DeliveryTypes;
    contactId: number;
    descriptionOne: string | undefined;
    descriptionTwo: string | undefined;
    announceTheDifference: boolean;
    cardTemplateRef: number | undefined;
    ceremonyTitle: string | undefined;
    deceasedTitle: string | undefined;
    currencyName: string | undefined;
    cardTemplateTile: string | undefined;
    planBillId: number | undefined;
    planConstId: number | undefined;
    planType: Plans;
    lastName: string | undefined;
    mobileNumber1: string | undefined;
    billId: number;
    planConstCode: string | undefined;
    sourceAttributes: string | undefined;
    sourceAttributesValue: string | undefined;
    paymentCreatorUser: string | undefined;
    paymentCreatDate: moment.Moment | undefined;
    paymentApprovedDate: moment.Moment | undefined;
    paymentType: string | undefined;
    bankSerialNO: string | undefined;
    branchCode: string | undefined;
    bankPayment: string | undefined;
    paymentAmount: number | undefined;
    paymentBankTrackingNO: string | undefined;
    paymentAccountingTrackingNO: string | undefined;
    panCard: string | undefined;
    paymentDateTime: moment.Moment | undefined;
    posSerial: string | undefined;
    depositId: string | undefined;
    paymentDescription: string | undefined;
    bankAccountNumber: string | undefined;
    paymentId: number | undefined;
    id: number | undefined;
}

export class GetBillReportForEditOutput implements IGetBillReportForEditOutput {
    billReport!: CreateOrEditBillReportDto;

    constructor(data?: IGetBillReportForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.billReport = data["billReport"] ? CreateOrEditBillReportDto.fromJS(data["billReport"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBillReportForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetBillReportForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billReport"] = this.billReport ? this.billReport.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetBillReportForEditOutput {
    billReport: CreateOrEditBillReportDto;
}

export class PagedResultDtoOfGetBillForViewDto implements IPagedResultDtoOfGetBillForViewDto {
    totalCount!: number;
    items!: GetBillForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetBillForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetBillForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetBillForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetBillForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetBillForViewDto {
    totalCount: number;
    items: GetBillForViewDto[] | undefined;
}

export class GetPaymentForEkramDto implements IGetPaymentForEkramDto {
    paymentCreatorUser!: string | undefined;
    paymentCreatDate!: moment.Moment | undefined;
    paymentType!: PaymentType;
    paymentStatus!: PaymentStatus;
    paymentDate!: moment.Moment | undefined;
    paymentTime!: moment.Moment | undefined;
    approvedPaymentUser!: string | undefined;
    price!: number | undefined;

    constructor(data?: IGetPaymentForEkramDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paymentCreatorUser = data["paymentCreatorUser"];
            this.paymentCreatDate = data["paymentCreatDate"] ? moment(data["paymentCreatDate"].toString()) : <any>undefined;
            this.paymentType = data["paymentType"];
            this.paymentStatus = data["paymentStatus"];
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.paymentTime = data["paymentTime"] ? moment(data["paymentTime"].toString()) : <any>undefined;
            this.approvedPaymentUser = data["approvedPaymentUser"];
            this.price = data["price"];
        }
    }

    static fromJS(data: any): GetPaymentForEkramDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentForEkramDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentCreatorUser"] = this.paymentCreatorUser;
        data["paymentCreatDate"] = this.paymentCreatDate ? this.paymentCreatDate.toISOString() : <any>undefined;
        data["paymentType"] = this.paymentType;
        data["paymentStatus"] = this.paymentStatus;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["paymentTime"] = this.paymentTime ? this.paymentTime.toISOString() : <any>undefined;
        data["approvedPaymentUser"] = this.approvedPaymentUser;
        data["price"] = this.price;
        return data; 
    }
}

export interface IGetPaymentForEkramDto {
    paymentCreatorUser: string | undefined;
    paymentCreatDate: moment.Moment | undefined;
    paymentType: PaymentType;
    paymentStatus: PaymentStatus;
    paymentDate: moment.Moment | undefined;
    paymentTime: moment.Moment | undefined;
    approvedPaymentUser: string | undefined;
    price: number | undefined;
}

export class GetEkramBillForViewDto implements IGetEkramBillForViewDto {
    id!: number;
    contactFirstName!: string | undefined;
    benefactorName!: string | undefined;
    deceasedName!: string | undefined;
    identityCode!: string | undefined;
    mobileNumber1!: string | undefined;
    billCode!: string | undefined;
    billId!: number;
    issueDate!: moment.Moment | undefined;
    extraEntity!: Consumers;
    planConstTitle!: string | undefined;
    planConstCode!: string | undefined;
    sourceTitle!: string | undefined;
    sourceId!: number | undefined;
    sourceAccountCode!: string | undefined;
    consumes!: string | undefined;
    consumesAccountCode!: string | undefined;
    planBillCode!: string | undefined;
    planBillId!: number | undefined;
    sourceAttributes!: SourceAttribute[] | undefined;
    totalPrice!: number | undefined;
    paymentCreatorUser!: string | undefined;
    paymentCreatDate!: moment.Moment | undefined;
    paymentType!: PaymentType;
    paymentDate!: moment.Moment | undefined;
    paymentTime!: moment.Moment | undefined;
    approvedPaymentUser!: string | undefined;
    price!: number | undefined;
    status!: BillStatus;
    billDescription!: string | undefined;
    payments!: GetPaymentForEkramDto[] | undefined;

    constructor(data?: IGetEkramBillForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.contactFirstName = data["contactFirstName"];
            this.benefactorName = data["benefactorName"];
            this.deceasedName = data["deceasedName"];
            this.identityCode = data["identityCode"];
            this.mobileNumber1 = data["mobileNumber1"];
            this.billCode = data["billCode"];
            this.billId = data["billId"];
            this.issueDate = data["issueDate"] ? moment(data["issueDate"].toString()) : <any>undefined;
            this.extraEntity = data["extraEntity"];
            this.planConstTitle = data["planConstTitle"];
            this.planConstCode = data["planConstCode"];
            this.sourceTitle = data["sourceTitle"];
            this.sourceId = data["sourceId"];
            this.sourceAccountCode = data["sourceAccountCode"];
            this.consumes = data["consumes"];
            this.consumesAccountCode = data["consumesAccountCode"];
            this.planBillCode = data["planBillCode"];
            this.planBillId = data["planBillId"];
            if (Array.isArray(data["sourceAttributes"])) {
                this.sourceAttributes = [] as any;
                for (let item of data["sourceAttributes"])
                    this.sourceAttributes!.push(SourceAttribute.fromJS(item));
            }
            this.totalPrice = data["totalPrice"];
            this.paymentCreatorUser = data["paymentCreatorUser"];
            this.paymentCreatDate = data["paymentCreatDate"] ? moment(data["paymentCreatDate"].toString()) : <any>undefined;
            this.paymentType = data["paymentType"];
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.paymentTime = data["paymentTime"] ? moment(data["paymentTime"].toString()) : <any>undefined;
            this.approvedPaymentUser = data["approvedPaymentUser"];
            this.price = data["price"];
            this.status = data["status"];
            this.billDescription = data["billDescription"];
            if (Array.isArray(data["payments"])) {
                this.payments = [] as any;
                for (let item of data["payments"])
                    this.payments!.push(GetPaymentForEkramDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEkramBillForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEkramBillForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contactFirstName"] = this.contactFirstName;
        data["benefactorName"] = this.benefactorName;
        data["deceasedName"] = this.deceasedName;
        data["identityCode"] = this.identityCode;
        data["mobileNumber1"] = this.mobileNumber1;
        data["billCode"] = this.billCode;
        data["billId"] = this.billId;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["extraEntity"] = this.extraEntity;
        data["planConstTitle"] = this.planConstTitle;
        data["planConstCode"] = this.planConstCode;
        data["sourceTitle"] = this.sourceTitle;
        data["sourceId"] = this.sourceId;
        data["sourceAccountCode"] = this.sourceAccountCode;
        data["consumes"] = this.consumes;
        data["consumesAccountCode"] = this.consumesAccountCode;
        data["planBillCode"] = this.planBillCode;
        data["planBillId"] = this.planBillId;
        if (Array.isArray(this.sourceAttributes)) {
            data["sourceAttributes"] = [];
            for (let item of this.sourceAttributes)
                data["sourceAttributes"].push(item.toJSON());
        }
        data["totalPrice"] = this.totalPrice;
        data["paymentCreatorUser"] = this.paymentCreatorUser;
        data["paymentCreatDate"] = this.paymentCreatDate ? this.paymentCreatDate.toISOString() : <any>undefined;
        data["paymentType"] = this.paymentType;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["paymentTime"] = this.paymentTime ? this.paymentTime.toISOString() : <any>undefined;
        data["approvedPaymentUser"] = this.approvedPaymentUser;
        data["price"] = this.price;
        data["status"] = this.status;
        data["billDescription"] = this.billDescription;
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetEkramBillForViewDto {
    id: number;
    contactFirstName: string | undefined;
    benefactorName: string | undefined;
    deceasedName: string | undefined;
    identityCode: string | undefined;
    mobileNumber1: string | undefined;
    billCode: string | undefined;
    billId: number;
    issueDate: moment.Moment | undefined;
    extraEntity: Consumers;
    planConstTitle: string | undefined;
    planConstCode: string | undefined;
    sourceTitle: string | undefined;
    sourceId: number | undefined;
    sourceAccountCode: string | undefined;
    consumes: string | undefined;
    consumesAccountCode: string | undefined;
    planBillCode: string | undefined;
    planBillId: number | undefined;
    sourceAttributes: SourceAttribute[] | undefined;
    totalPrice: number | undefined;
    paymentCreatorUser: string | undefined;
    paymentCreatDate: moment.Moment | undefined;
    paymentType: PaymentType;
    paymentDate: moment.Moment | undefined;
    paymentTime: moment.Moment | undefined;
    approvedPaymentUser: string | undefined;
    price: number | undefined;
    status: BillStatus;
    billDescription: string | undefined;
    payments: GetPaymentForEkramDto[] | undefined;
}

export class PagedResultDtoOfGetEkramBillForViewDto implements IPagedResultDtoOfGetEkramBillForViewDto {
    totalCount!: number;
    items!: GetEkramBillForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetEkramBillForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetEkramBillForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetEkramBillForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetEkramBillForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetEkramBillForViewDto {
    totalCount: number;
    items: GetEkramBillForViewDto[] | undefined;
}

export class CustomAccountingBillDto implements ICustomAccountingBillDto {
    code!: string | undefined;
    status!: BillStatus;
    price!: number;
    id!: number;

    constructor(data?: ICustomAccountingBillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.status = data["status"];
            this.price = data["price"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CustomAccountingBillDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAccountingBillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["status"] = this.status;
        data["price"] = this.price;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICustomAccountingBillDto {
    code: string | undefined;
    status: BillStatus;
    price: number;
    id: number;
}

export class GetBillAndPaymentForAccountingOutputDto implements IGetBillAndPaymentForAccountingOutputDto {
    bills!: CustomAccountingBillDto[] | undefined;
    payment!: PaymentDto;
    cashierName!: string | undefined;
    postmanName!: string | undefined;
    currencyName!: string | undefined;

    constructor(data?: IGetBillAndPaymentForAccountingOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["bills"])) {
                this.bills = [] as any;
                for (let item of data["bills"])
                    this.bills!.push(CustomAccountingBillDto.fromJS(item));
            }
            this.payment = data["payment"] ? PaymentDto.fromJS(data["payment"]) : <any>undefined;
            this.cashierName = data["cashierName"];
            this.postmanName = data["postmanName"];
            this.currencyName = data["currencyName"];
        }
    }

    static fromJS(data: any): GetBillAndPaymentForAccountingOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBillAndPaymentForAccountingOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bills)) {
            data["bills"] = [];
            for (let item of this.bills)
                data["bills"].push(item.toJSON());
        }
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        data["cashierName"] = this.cashierName;
        data["postmanName"] = this.postmanName;
        data["currencyName"] = this.currencyName;
        return data; 
    }
}

export interface IGetBillAndPaymentForAccountingOutputDto {
    bills: CustomAccountingBillDto[] | undefined;
    payment: PaymentDto;
    cashierName: string | undefined;
    postmanName: string | undefined;
    currencyName: string | undefined;
}

export class PagedResultDtoOfGetBillAndPaymentForAccountingOutputDto implements IPagedResultDtoOfGetBillAndPaymentForAccountingOutputDto {
    totalCount!: number;
    items!: GetBillAndPaymentForAccountingOutputDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetBillAndPaymentForAccountingOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetBillAndPaymentForAccountingOutputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetBillAndPaymentForAccountingOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetBillAndPaymentForAccountingOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetBillAndPaymentForAccountingOutputDto {
    totalCount: number;
    items: GetBillAndPaymentForAccountingOutputDto[] | undefined;
}

export enum DefaultTitles {
    Default = 0,
    DeceasedName = 1,
    ContactName = 2,
    IssueDate = 3,
    SubscriptionCode = 4,
    Address = 5,
    PhoneNumber = 6,
    PlanConst = 7,
    SurvivorName = 8,
    Price = 9,
    CreatorUser = 10,
    PriceInWords = 11,
    BaseTime = 12,
    BillBarcode = 13,
    BillNumber = 14,
    PrintDate = 16,
    PaymentType = 17,
    PrinterUser = 18,
    PrintTime = 19,
    LocationName = 20,
    CeremonyDate = 21,
    CeremonyTime = 22,
    AddressLocation = 23,
    QRCode = 24,
    Description = 25,
    FromContactName = 26,
    FromSurvivorName = 27,
    DeceasedImage = 28,
    ClipPath = 29,
    DescriptionOne = 31,
    DescriptionTwo = 32,
    DueDate = 33,
    NetPaid = 34,
    String = 35,
    CurrencyName = 36,
    ToCondolenceDeceasedName = 37,
    DeceasedQR = 38,
}

export class GetPropertiesForBillDto implements IGetPropertiesForBillDto {
    cardTemplatePropertyRef!: number;
    displayTitle!: string | undefined;
    charactersLimite!: number;
    defaultTitle!: DefaultTitles;
    value!: string | undefined;
    entity!: Entities;
    entityRef!: number | undefined;
    cardTemplateValueRef!: number | undefined;
    x!: number | undefined;
    y!: number | undefined;
    fontName!: string | undefined;
    fontSize!: string | undefined;
    hidden!: boolean;
    touched!: boolean;
    isRequired!: boolean;
    isCenterAlign!: boolean;
    isFontChanging!: boolean;
    maxWidth!: number | undefined;
    lineHeight!: number | undefined;

    constructor(data?: IGetPropertiesForBillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cardTemplatePropertyRef = data["cardTemplatePropertyRef"];
            this.displayTitle = data["displayTitle"];
            this.charactersLimite = data["charactersLimite"];
            this.defaultTitle = data["defaultTitle"];
            this.value = data["value"];
            this.entity = data["entity"];
            this.entityRef = data["entityRef"];
            this.cardTemplateValueRef = data["cardTemplateValueRef"];
            this.x = data["x"];
            this.y = data["y"];
            this.fontName = data["fontName"];
            this.fontSize = data["fontSize"];
            this.hidden = data["hidden"];
            this.touched = data["touched"];
            this.isRequired = data["isRequired"];
            this.isCenterAlign = data["isCenterAlign"];
            this.isFontChanging = data["isFontChanging"];
            this.maxWidth = data["maxWidth"];
            this.lineHeight = data["lineHeight"];
        }
    }

    static fromJS(data: any): GetPropertiesForBillDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPropertiesForBillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardTemplatePropertyRef"] = this.cardTemplatePropertyRef;
        data["displayTitle"] = this.displayTitle;
        data["charactersLimite"] = this.charactersLimite;
        data["defaultTitle"] = this.defaultTitle;
        data["value"] = this.value;
        data["entity"] = this.entity;
        data["entityRef"] = this.entityRef;
        data["cardTemplateValueRef"] = this.cardTemplateValueRef;
        data["x"] = this.x;
        data["y"] = this.y;
        data["fontName"] = this.fontName;
        data["fontSize"] = this.fontSize;
        data["hidden"] = this.hidden;
        data["touched"] = this.touched;
        data["isRequired"] = this.isRequired;
        data["isCenterAlign"] = this.isCenterAlign;
        data["isFontChanging"] = this.isFontChanging;
        data["maxWidth"] = this.maxWidth;
        data["lineHeight"] = this.lineHeight;
        return data; 
    }
}

export interface IGetPropertiesForBillDto {
    cardTemplatePropertyRef: number;
    displayTitle: string | undefined;
    charactersLimite: number;
    defaultTitle: DefaultTitles;
    value: string | undefined;
    entity: Entities;
    entityRef: number | undefined;
    cardTemplateValueRef: number | undefined;
    x: number | undefined;
    y: number | undefined;
    fontName: string | undefined;
    fontSize: string | undefined;
    hidden: boolean;
    touched: boolean;
    isRequired: boolean;
    isCenterAlign: boolean;
    isFontChanging: boolean;
    maxWidth: number | undefined;
    lineHeight: number | undefined;
}

export class CreateOrEditBillDto implements ICreateOrEditBillDto {
    tenantId!: number | undefined;
    code!: string | undefined;
    issueDate!: moment.Moment | undefined;
    price!: number;
    secondPrice!: number | undefined;
    thirdPrice!: number | undefined;
    count!: number | undefined;
    description!: string | undefined;
    dueDate!: moment.Moment | undefined;
    status!: BillStatus;
    extraEntity!: Consumers;
    extraEntityRef!: number | undefined;
    deliveryType!: DeliveryTypes;
    survivorMobileNo!: string | undefined;
    contactId!: number | undefined;
    currencyId!: number | undefined;
    planConstId!: number | undefined;
    planBillId!: number | undefined;
    paymentId!: number | undefined;
    deacesedId!: number | undefined;
    descriptionOne!: string | undefined;
    descriptionTwo!: string | undefined;
    announceTheDifference!: boolean;
    benefactorName!: string | undefined;
    cardTemplateRef!: number | undefined;
    billSlaughteredRef!: number | undefined;
    branchRef!: number | undefined;
    isSendSmsOn!: boolean;
    isAprovedPay!: boolean;
    planType!: Plans;
    billCardTemplateProperties!: GetPropertiesForBillDto[] | undefined;
    flowerCardTemplateProperties!: GetPropertiesForBillDto[] | undefined;
    deleteFlowerCardTemplateProperties!: number[] | undefined;
    attributeValues!: CreateOrEditAttributeValueDto[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditBillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.code = data["code"];
            this.issueDate = data["issueDate"] ? moment(data["issueDate"].toString()) : <any>undefined;
            this.price = data["price"];
            this.secondPrice = data["secondPrice"];
            this.thirdPrice = data["thirdPrice"];
            this.count = data["count"];
            this.description = data["description"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.status = data["status"];
            this.extraEntity = data["extraEntity"];
            this.extraEntityRef = data["extraEntityRef"];
            this.deliveryType = data["deliveryType"];
            this.survivorMobileNo = data["survivorMobileNo"];
            this.contactId = data["contactId"];
            this.currencyId = data["currencyId"];
            this.planConstId = data["planConstId"];
            this.planBillId = data["planBillId"];
            this.paymentId = data["paymentId"];
            this.deacesedId = data["deacesedId"];
            this.descriptionOne = data["descriptionOne"];
            this.descriptionTwo = data["descriptionTwo"];
            this.announceTheDifference = data["announceTheDifference"];
            this.benefactorName = data["benefactorName"];
            this.cardTemplateRef = data["cardTemplateRef"];
            this.billSlaughteredRef = data["billSlaughteredRef"];
            this.branchRef = data["branchRef"];
            this.isSendSmsOn = data["isSendSmsOn"];
            this.isAprovedPay = data["isAprovedPay"];
            this.planType = data["planType"];
            if (Array.isArray(data["billCardTemplateProperties"])) {
                this.billCardTemplateProperties = [] as any;
                for (let item of data["billCardTemplateProperties"])
                    this.billCardTemplateProperties!.push(GetPropertiesForBillDto.fromJS(item));
            }
            if (Array.isArray(data["flowerCardTemplateProperties"])) {
                this.flowerCardTemplateProperties = [] as any;
                for (let item of data["flowerCardTemplateProperties"])
                    this.flowerCardTemplateProperties!.push(GetPropertiesForBillDto.fromJS(item));
            }
            if (Array.isArray(data["deleteFlowerCardTemplateProperties"])) {
                this.deleteFlowerCardTemplateProperties = [] as any;
                for (let item of data["deleteFlowerCardTemplateProperties"])
                    this.deleteFlowerCardTemplateProperties!.push(item);
            }
            if (Array.isArray(data["attributeValues"])) {
                this.attributeValues = [] as any;
                for (let item of data["attributeValues"])
                    this.attributeValues!.push(CreateOrEditAttributeValueDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditBillDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditBillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["code"] = this.code;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["price"] = this.price;
        data["secondPrice"] = this.secondPrice;
        data["thirdPrice"] = this.thirdPrice;
        data["count"] = this.count;
        data["description"] = this.description;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["extraEntity"] = this.extraEntity;
        data["extraEntityRef"] = this.extraEntityRef;
        data["deliveryType"] = this.deliveryType;
        data["survivorMobileNo"] = this.survivorMobileNo;
        data["contactId"] = this.contactId;
        data["currencyId"] = this.currencyId;
        data["planConstId"] = this.planConstId;
        data["planBillId"] = this.planBillId;
        data["paymentId"] = this.paymentId;
        data["deacesedId"] = this.deacesedId;
        data["descriptionOne"] = this.descriptionOne;
        data["descriptionTwo"] = this.descriptionTwo;
        data["announceTheDifference"] = this.announceTheDifference;
        data["benefactorName"] = this.benefactorName;
        data["cardTemplateRef"] = this.cardTemplateRef;
        data["billSlaughteredRef"] = this.billSlaughteredRef;
        data["branchRef"] = this.branchRef;
        data["isSendSmsOn"] = this.isSendSmsOn;
        data["isAprovedPay"] = this.isAprovedPay;
        data["planType"] = this.planType;
        if (Array.isArray(this.billCardTemplateProperties)) {
            data["billCardTemplateProperties"] = [];
            for (let item of this.billCardTemplateProperties)
                data["billCardTemplateProperties"].push(item.toJSON());
        }
        if (Array.isArray(this.flowerCardTemplateProperties)) {
            data["flowerCardTemplateProperties"] = [];
            for (let item of this.flowerCardTemplateProperties)
                data["flowerCardTemplateProperties"].push(item.toJSON());
        }
        if (Array.isArray(this.deleteFlowerCardTemplateProperties)) {
            data["deleteFlowerCardTemplateProperties"] = [];
            for (let item of this.deleteFlowerCardTemplateProperties)
                data["deleteFlowerCardTemplateProperties"].push(item);
        }
        if (Array.isArray(this.attributeValues)) {
            data["attributeValues"] = [];
            for (let item of this.attributeValues)
                data["attributeValues"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditBillDto {
    tenantId: number | undefined;
    code: string | undefined;
    issueDate: moment.Moment | undefined;
    price: number;
    secondPrice: number | undefined;
    thirdPrice: number | undefined;
    count: number | undefined;
    description: string | undefined;
    dueDate: moment.Moment | undefined;
    status: BillStatus;
    extraEntity: Consumers;
    extraEntityRef: number | undefined;
    deliveryType: DeliveryTypes;
    survivorMobileNo: string | undefined;
    contactId: number | undefined;
    currencyId: number | undefined;
    planConstId: number | undefined;
    planBillId: number | undefined;
    paymentId: number | undefined;
    deacesedId: number | undefined;
    descriptionOne: string | undefined;
    descriptionTwo: string | undefined;
    announceTheDifference: boolean;
    benefactorName: string | undefined;
    cardTemplateRef: number | undefined;
    billSlaughteredRef: number | undefined;
    branchRef: number | undefined;
    isSendSmsOn: boolean;
    isAprovedPay: boolean;
    planType: Plans;
    billCardTemplateProperties: GetPropertiesForBillDto[] | undefined;
    flowerCardTemplateProperties: GetPropertiesForBillDto[] | undefined;
    deleteFlowerCardTemplateProperties: number[] | undefined;
    attributeValues: CreateOrEditAttributeValueDto[] | undefined;
    id: number | undefined;
}

export class CreateOrEditPlanBillDto implements ICreateOrEditPlanBillDto {
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    amount!: number | undefined;
    count!: number | undefined;
    entity!: Entities;
    entityRef!: number | undefined;
    durationDate!: number | undefined;
    code!: string | undefined;
    isDeliveredByPost!: boolean | undefined;
    iscollectByPost!: boolean | undefined;
    isConfirm!: boolean | undefined;
    donotApprovedDescription!: string | undefined;
    status!: PlanBillStatus;
    description!: string | undefined;
    isSendSmsOn!: boolean;
    addressRef!: number | undefined;
    contactId!: number | undefined;
    planConstId!: number | undefined;
    baseTimeRef!: number | undefined;
    benefactorName!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditPlanBillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.amount = data["amount"];
            this.count = data["count"];
            this.entity = data["entity"];
            this.entityRef = data["entityRef"];
            this.durationDate = data["durationDate"];
            this.code = data["code"];
            this.isDeliveredByPost = data["isDeliveredByPost"];
            this.iscollectByPost = data["iscollectByPost"];
            this.isConfirm = data["isConfirm"];
            this.donotApprovedDescription = data["donotApprovedDescription"];
            this.status = data["status"];
            this.description = data["description"];
            this.isSendSmsOn = data["isSendSmsOn"];
            this.addressRef = data["addressRef"];
            this.contactId = data["contactId"];
            this.planConstId = data["planConstId"];
            this.baseTimeRef = data["baseTimeRef"];
            this.benefactorName = data["benefactorName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditPlanBillDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPlanBillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["count"] = this.count;
        data["entity"] = this.entity;
        data["entityRef"] = this.entityRef;
        data["durationDate"] = this.durationDate;
        data["code"] = this.code;
        data["isDeliveredByPost"] = this.isDeliveredByPost;
        data["iscollectByPost"] = this.iscollectByPost;
        data["isConfirm"] = this.isConfirm;
        data["donotApprovedDescription"] = this.donotApprovedDescription;
        data["status"] = this.status;
        data["description"] = this.description;
        data["isSendSmsOn"] = this.isSendSmsOn;
        data["addressRef"] = this.addressRef;
        data["contactId"] = this.contactId;
        data["planConstId"] = this.planConstId;
        data["baseTimeRef"] = this.baseTimeRef;
        data["benefactorName"] = this.benefactorName;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditPlanBillDto {
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    amount: number | undefined;
    count: number | undefined;
    entity: Entities;
    entityRef: number | undefined;
    durationDate: number | undefined;
    code: string | undefined;
    isDeliveredByPost: boolean | undefined;
    iscollectByPost: boolean | undefined;
    isConfirm: boolean | undefined;
    donotApprovedDescription: string | undefined;
    status: PlanBillStatus;
    description: string | undefined;
    isSendSmsOn: boolean;
    addressRef: number | undefined;
    contactId: number | undefined;
    planConstId: number | undefined;
    baseTimeRef: number | undefined;
    benefactorName: string | undefined;
    id: number | undefined;
}

export enum SelectClient {
    Default = 0,
    SelectByContact = 1,
    SelectByAssociation = 2,
    SelectByBoth = 3,
}

export class BaseTimeInfo implements IBaseTimeInfo {
    id!: number;
    name!: string | undefined;
    duratione!: number | undefined;
    referralAndPaymentToPostMan!: boolean;

    constructor(data?: IBaseTimeInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.duratione = data["duratione"];
            this.referralAndPaymentToPostMan = data["referralAndPaymentToPostMan"];
        }
    }

    static fromJS(data: any): BaseTimeInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTimeInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["duratione"] = this.duratione;
        data["referralAndPaymentToPostMan"] = this.referralAndPaymentToPostMan;
        return data; 
    }
}

export interface IBaseTimeInfo {
    id: number;
    name: string | undefined;
    duratione: number | undefined;
    referralAndPaymentToPostMan: boolean;
}

export class BillCardTemplateLookupTableDto implements IBillCardTemplateLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    isDefault!: boolean;
    imagePath!: string | undefined;
    height!: number | undefined;
    width!: number | undefined;

    constructor(data?: IBillCardTemplateLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.isDefault = data["isDefault"];
            this.imagePath = data["imagePath"];
            this.height = data["height"];
            this.width = data["width"];
        }
    }

    static fromJS(data: any): BillCardTemplateLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillCardTemplateLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["isDefault"] = this.isDefault;
        data["imagePath"] = this.imagePath;
        data["height"] = this.height;
        data["width"] = this.width;
        return data; 
    }
}

export interface IBillCardTemplateLookupTableDto {
    id: number;
    displayName: string | undefined;
    isDefault: boolean;
    imagePath: string | undefined;
    height: number | undefined;
    width: number | undefined;
}

export class GetBillForEditOutput implements IGetBillForEditOutput {
    bill!: CreateOrEditBillDto;
    planBill!: CreateOrEditPlanBillDto;
    contactFirstName!: string | undefined;
    clientFirstName!: string | undefined;
    familyName!: string | undefined;
    currencyName!: string | undefined;
    deacesedName!: string | undefined;
    ceremonyTitle!: string | undefined;
    planConstTitle!: string | undefined;
    sourceId!: number | undefined;
    selectClient!: SelectClient;
    planType!: Plans;
    deliveryType!: DeliveryTypes;
    billSlaughteredCode!: string | undefined;
    isDescriptionRequired!: boolean;
    isParticipatory!: boolean;
    minAmount!: number | undefined;
    maxAmount!: number | undefined;
    baseTimes!: BaseTimeInfo[] | undefined;
    flowerCardTemplates!: BillCardTemplateLookupTableDto[] | undefined;
    flowerCardTemplateProperties!: GetPropertiesForBillDto[] | undefined;
    billCardTemplateProperties!: GetPropertiesForBillDto[] | undefined;
    isContinuous!: boolean;
    cardTemplateTitle!: string | undefined;
    branchName!: string | undefined;

    constructor(data?: IGetBillForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bill = data["bill"] ? CreateOrEditBillDto.fromJS(data["bill"]) : <any>undefined;
            this.planBill = data["planBill"] ? CreateOrEditPlanBillDto.fromJS(data["planBill"]) : <any>undefined;
            this.contactFirstName = data["contactFirstName"];
            this.clientFirstName = data["clientFirstName"];
            this.familyName = data["familyName"];
            this.currencyName = data["currencyName"];
            this.deacesedName = data["deacesedName"];
            this.ceremonyTitle = data["ceremonyTitle"];
            this.planConstTitle = data["planConstTitle"];
            this.sourceId = data["sourceId"];
            this.selectClient = data["selectClient"];
            this.planType = data["planType"];
            this.deliveryType = data["deliveryType"];
            this.billSlaughteredCode = data["billSlaughteredCode"];
            this.isDescriptionRequired = data["isDescriptionRequired"];
            this.isParticipatory = data["isParticipatory"];
            this.minAmount = data["minAmount"];
            this.maxAmount = data["maxAmount"];
            if (Array.isArray(data["baseTimes"])) {
                this.baseTimes = [] as any;
                for (let item of data["baseTimes"])
                    this.baseTimes!.push(BaseTimeInfo.fromJS(item));
            }
            if (Array.isArray(data["flowerCardTemplates"])) {
                this.flowerCardTemplates = [] as any;
                for (let item of data["flowerCardTemplates"])
                    this.flowerCardTemplates!.push(BillCardTemplateLookupTableDto.fromJS(item));
            }
            if (Array.isArray(data["flowerCardTemplateProperties"])) {
                this.flowerCardTemplateProperties = [] as any;
                for (let item of data["flowerCardTemplateProperties"])
                    this.flowerCardTemplateProperties!.push(GetPropertiesForBillDto.fromJS(item));
            }
            if (Array.isArray(data["billCardTemplateProperties"])) {
                this.billCardTemplateProperties = [] as any;
                for (let item of data["billCardTemplateProperties"])
                    this.billCardTemplateProperties!.push(GetPropertiesForBillDto.fromJS(item));
            }
            this.isContinuous = data["isContinuous"];
            this.cardTemplateTitle = data["cardTemplateTitle"];
            this.branchName = data["branchName"];
        }
    }

    static fromJS(data: any): GetBillForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetBillForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bill"] = this.bill ? this.bill.toJSON() : <any>undefined;
        data["planBill"] = this.planBill ? this.planBill.toJSON() : <any>undefined;
        data["contactFirstName"] = this.contactFirstName;
        data["clientFirstName"] = this.clientFirstName;
        data["familyName"] = this.familyName;
        data["currencyName"] = this.currencyName;
        data["deacesedName"] = this.deacesedName;
        data["ceremonyTitle"] = this.ceremonyTitle;
        data["planConstTitle"] = this.planConstTitle;
        data["sourceId"] = this.sourceId;
        data["selectClient"] = this.selectClient;
        data["planType"] = this.planType;
        data["deliveryType"] = this.deliveryType;
        data["billSlaughteredCode"] = this.billSlaughteredCode;
        data["isDescriptionRequired"] = this.isDescriptionRequired;
        data["isParticipatory"] = this.isParticipatory;
        data["minAmount"] = this.minAmount;
        data["maxAmount"] = this.maxAmount;
        if (Array.isArray(this.baseTimes)) {
            data["baseTimes"] = [];
            for (let item of this.baseTimes)
                data["baseTimes"].push(item.toJSON());
        }
        if (Array.isArray(this.flowerCardTemplates)) {
            data["flowerCardTemplates"] = [];
            for (let item of this.flowerCardTemplates)
                data["flowerCardTemplates"].push(item.toJSON());
        }
        if (Array.isArray(this.flowerCardTemplateProperties)) {
            data["flowerCardTemplateProperties"] = [];
            for (let item of this.flowerCardTemplateProperties)
                data["flowerCardTemplateProperties"].push(item.toJSON());
        }
        if (Array.isArray(this.billCardTemplateProperties)) {
            data["billCardTemplateProperties"] = [];
            for (let item of this.billCardTemplateProperties)
                data["billCardTemplateProperties"].push(item.toJSON());
        }
        data["isContinuous"] = this.isContinuous;
        data["cardTemplateTitle"] = this.cardTemplateTitle;
        data["branchName"] = this.branchName;
        return data; 
    }
}

export interface IGetBillForEditOutput {
    bill: CreateOrEditBillDto;
    planBill: CreateOrEditPlanBillDto;
    contactFirstName: string | undefined;
    clientFirstName: string | undefined;
    familyName: string | undefined;
    currencyName: string | undefined;
    deacesedName: string | undefined;
    ceremonyTitle: string | undefined;
    planConstTitle: string | undefined;
    sourceId: number | undefined;
    selectClient: SelectClient;
    planType: Plans;
    deliveryType: DeliveryTypes;
    billSlaughteredCode: string | undefined;
    isDescriptionRequired: boolean;
    isParticipatory: boolean;
    minAmount: number | undefined;
    maxAmount: number | undefined;
    baseTimes: BaseTimeInfo[] | undefined;
    flowerCardTemplates: BillCardTemplateLookupTableDto[] | undefined;
    flowerCardTemplateProperties: GetPropertiesForBillDto[] | undefined;
    billCardTemplateProperties: GetPropertiesForBillDto[] | undefined;
    isContinuous: boolean;
    cardTemplateTitle: string | undefined;
    branchName: string | undefined;
}

export enum Gender {
    Default = 0,
    Male = 1,
    Female = 2,
    NotSelected = 3,
}

export class GetAllCeremoniesForShopDto implements IGetAllCeremoniesForShopDto {
    ceremonyId!: number;
    deceasedId!: number;
    ceremonyCode!: string | undefined;
    title!: string | undefined;
    deceasedFullName!: string | undefined;
    deceasedCode!: string | undefined;
    ceremonyDate!: moment.Moment;
    image!: string | undefined;
    location!: string | undefined;
    locationId!: number | undefined;
    locationDescription!: string | undefined;
    latitude!: number | undefined;
    longitude!: number | undefined;
    eventTypeTitle!: string | undefined;
    eventTypeId!: number | undefined;
    createdBy!: string | undefined;
    isGuaranteedTimeDeliver!: boolean;

    constructor(data?: IGetAllCeremoniesForShopDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ceremonyId = data["ceremonyId"];
            this.deceasedId = data["deceasedId"];
            this.ceremonyCode = data["ceremonyCode"];
            this.title = data["title"];
            this.deceasedFullName = data["deceasedFullName"];
            this.deceasedCode = data["deceasedCode"];
            this.ceremonyDate = data["ceremonyDate"] ? moment(data["ceremonyDate"].toString()) : <any>undefined;
            this.image = data["image"];
            this.location = data["location"];
            this.locationId = data["locationId"];
            this.locationDescription = data["locationDescription"];
            this.latitude = data["latitude"];
            this.longitude = data["longitude"];
            this.eventTypeTitle = data["eventTypeTitle"];
            this.eventTypeId = data["eventTypeId"];
            this.createdBy = data["createdBy"];
            this.isGuaranteedTimeDeliver = data["isGuaranteedTimeDeliver"];
        }
    }

    static fromJS(data: any): GetAllCeremoniesForShopDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllCeremoniesForShopDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ceremonyId"] = this.ceremonyId;
        data["deceasedId"] = this.deceasedId;
        data["ceremonyCode"] = this.ceremonyCode;
        data["title"] = this.title;
        data["deceasedFullName"] = this.deceasedFullName;
        data["deceasedCode"] = this.deceasedCode;
        data["ceremonyDate"] = this.ceremonyDate ? this.ceremonyDate.toISOString() : <any>undefined;
        data["image"] = this.image;
        data["location"] = this.location;
        data["locationId"] = this.locationId;
        data["locationDescription"] = this.locationDescription;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["eventTypeTitle"] = this.eventTypeTitle;
        data["eventTypeId"] = this.eventTypeId;
        data["createdBy"] = this.createdBy;
        data["isGuaranteedTimeDeliver"] = this.isGuaranteedTimeDeliver;
        return data; 
    }
}

export interface IGetAllCeremoniesForShopDto {
    ceremonyId: number;
    deceasedId: number;
    ceremonyCode: string | undefined;
    title: string | undefined;
    deceasedFullName: string | undefined;
    deceasedCode: string | undefined;
    ceremonyDate: moment.Moment;
    image: string | undefined;
    location: string | undefined;
    locationId: number | undefined;
    locationDescription: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    eventTypeTitle: string | undefined;
    eventTypeId: number | undefined;
    createdBy: string | undefined;
    isGuaranteedTimeDeliver: boolean;
}

export class FileUploadModel implements IFileUploadModel {
    name!: string | undefined;
    type!: string | undefined;
    path!: string | undefined;
    size!: number | undefined;
    thumbPath!: string | undefined;
    id!: number | undefined;

    constructor(data?: IFileUploadModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.type = data["type"];
            this.path = data["path"];
            this.size = data["size"];
            this.thumbPath = data["thumbPath"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): FileUploadModel {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        data["path"] = this.path;
        data["size"] = this.size;
        data["thumbPath"] = this.thumbPath;
        data["id"] = this.id;
        return data; 
    }
}

export interface IFileUploadModel {
    name: string | undefined;
    type: string | undefined;
    path: string | undefined;
    size: number | undefined;
    thumbPath: string | undefined;
    id: number | undefined;
}

export class DeceasedForBillDto implements IDeceasedForBillDto {
    deceasedId!: number | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    gender!: Gender;
    deathDate!: moment.Moment | undefined;
    survivorName!: string | undefined;
    survivorPhoneNo!: string | undefined;
    description!: string | undefined;
    imagePath!: string | undefined;
    isDuplicate!: boolean;
    deceasedCeremonies!: GetAllCeremoniesForShopDto[] | undefined;
    gallery!: FileUploadModel[] | undefined;

    constructor(data?: IDeceasedForBillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deceasedId = data["deceasedId"];
            this.firstName = data["firstName"];
            this.lastName = data["lastName"];
            this.gender = data["gender"];
            this.deathDate = data["deathDate"] ? moment(data["deathDate"].toString()) : <any>undefined;
            this.survivorName = data["survivorName"];
            this.survivorPhoneNo = data["survivorPhoneNo"];
            this.description = data["description"];
            this.imagePath = data["imagePath"];
            this.isDuplicate = data["isDuplicate"];
            if (Array.isArray(data["deceasedCeremonies"])) {
                this.deceasedCeremonies = [] as any;
                for (let item of data["deceasedCeremonies"])
                    this.deceasedCeremonies!.push(GetAllCeremoniesForShopDto.fromJS(item));
            }
            if (Array.isArray(data["gallery"])) {
                this.gallery = [] as any;
                for (let item of data["gallery"])
                    this.gallery!.push(FileUploadModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeceasedForBillDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeceasedForBillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deceasedId"] = this.deceasedId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["gender"] = this.gender;
        data["deathDate"] = this.deathDate ? this.deathDate.toISOString() : <any>undefined;
        data["survivorName"] = this.survivorName;
        data["survivorPhoneNo"] = this.survivorPhoneNo;
        data["description"] = this.description;
        data["imagePath"] = this.imagePath;
        data["isDuplicate"] = this.isDuplicate;
        if (Array.isArray(this.deceasedCeremonies)) {
            data["deceasedCeremonies"] = [];
            for (let item of this.deceasedCeremonies)
                data["deceasedCeremonies"].push(item.toJSON());
        }
        if (Array.isArray(this.gallery)) {
            data["gallery"] = [];
            for (let item of this.gallery)
                data["gallery"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDeceasedForBillDto {
    deceasedId: number | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    gender: Gender;
    deathDate: moment.Moment | undefined;
    survivorName: string | undefined;
    survivorPhoneNo: string | undefined;
    description: string | undefined;
    imagePath: string | undefined;
    isDuplicate: boolean;
    deceasedCeremonies: GetAllCeremoniesForShopDto[] | undefined;
    gallery: FileUploadModel[] | undefined;
}

export class AddressForBillDto implements IAddressForBillDto {
    title!: string | undefined;
    streetAlley!: string | undefined;
    floor!: number | undefined;
    phoneNumber!: string | undefined;
    postalCode!: string | undefined;
    area!: number | undefined;
    description!: string | undefined;
    stateId!: number | undefined;
    cityId!: number | undefined;
    countryId!: number | undefined;
    latitude!: number | undefined;
    longitude!: number | undefined;
    addressDesc!: string | undefined;

    constructor(data?: IAddressForBillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.streetAlley = data["streetAlley"];
            this.floor = data["floor"];
            this.phoneNumber = data["phoneNumber"];
            this.postalCode = data["postalCode"];
            this.area = data["area"];
            this.description = data["description"];
            this.stateId = data["stateId"];
            this.cityId = data["cityId"];
            this.countryId = data["countryId"];
            this.latitude = data["latitude"];
            this.longitude = data["longitude"];
            this.addressDesc = data["addressDesc"];
        }
    }

    static fromJS(data: any): AddressForBillDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressForBillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["streetAlley"] = this.streetAlley;
        data["floor"] = this.floor;
        data["phoneNumber"] = this.phoneNumber;
        data["postalCode"] = this.postalCode;
        data["area"] = this.area;
        data["description"] = this.description;
        data["stateId"] = this.stateId;
        data["cityId"] = this.cityId;
        data["countryId"] = this.countryId;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["addressDesc"] = this.addressDesc;
        return data; 
    }
}

export interface IAddressForBillDto {
    title: string | undefined;
    streetAlley: string | undefined;
    floor: number | undefined;
    phoneNumber: string | undefined;
    postalCode: string | undefined;
    area: number | undefined;
    description: string | undefined;
    stateId: number | undefined;
    cityId: number | undefined;
    countryId: number | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    addressDesc: string | undefined;
}

export class LocationForBillDto implements ILocationForBillDto {
    locationId!: number | undefined;
    title!: string | undefined;
    type!: boolean | undefined;
    capacity!: number | undefined;
    owner!: string | undefined;
    ownerPhoneNo!: string | undefined;
    locationTypeId!: number | undefined;
    guaranteedTimeDeliver!: number | undefined;
    address!: AddressForBillDto;
    isDuplicate!: boolean;

    constructor(data?: ILocationForBillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.locationId = data["locationId"];
            this.title = data["title"];
            this.type = data["type"];
            this.capacity = data["capacity"];
            this.owner = data["owner"];
            this.ownerPhoneNo = data["ownerPhoneNo"];
            this.locationTypeId = data["locationTypeId"];
            this.guaranteedTimeDeliver = data["guaranteedTimeDeliver"];
            this.address = data["address"] ? AddressForBillDto.fromJS(data["address"]) : <any>undefined;
            this.isDuplicate = data["isDuplicate"];
        }
    }

    static fromJS(data: any): LocationForBillDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationForBillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationId"] = this.locationId;
        data["title"] = this.title;
        data["type"] = this.type;
        data["capacity"] = this.capacity;
        data["owner"] = this.owner;
        data["ownerPhoneNo"] = this.ownerPhoneNo;
        data["locationTypeId"] = this.locationTypeId;
        data["guaranteedTimeDeliver"] = this.guaranteedTimeDeliver;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["isDuplicate"] = this.isDuplicate;
        return data; 
    }
}

export interface ILocationForBillDto {
    locationId: number | undefined;
    title: string | undefined;
    type: boolean | undefined;
    capacity: number | undefined;
    owner: string | undefined;
    ownerPhoneNo: string | undefined;
    locationTypeId: number | undefined;
    guaranteedTimeDeliver: number | undefined;
    address: AddressForBillDto;
    isDuplicate: boolean;
}

export class CeremonyForBillDto implements ICeremonyForBillDto {
    ceremonyId!: number | undefined;
    eventTypeId!: number | undefined;
    title!: string | undefined;
    startTime!: moment.Moment;
    endTime!: moment.Moment | undefined;
    ceremonyOwnerName!: string | undefined;
    ceremonyOwnerPhoneNo!: string | undefined;
    location!: LocationForBillDto;

    constructor(data?: ICeremonyForBillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ceremonyId = data["ceremonyId"];
            this.eventTypeId = data["eventTypeId"];
            this.title = data["title"];
            this.startTime = data["startTime"] ? moment(data["startTime"].toString()) : <any>undefined;
            this.endTime = data["endTime"] ? moment(data["endTime"].toString()) : <any>undefined;
            this.ceremonyOwnerName = data["ceremonyOwnerName"];
            this.ceremonyOwnerPhoneNo = data["ceremonyOwnerPhoneNo"];
            this.location = data["location"] ? LocationForBillDto.fromJS(data["location"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CeremonyForBillDto {
        data = typeof data === 'object' ? data : {};
        let result = new CeremonyForBillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ceremonyId"] = this.ceremonyId;
        data["eventTypeId"] = this.eventTypeId;
        data["title"] = this.title;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["ceremonyOwnerName"] = this.ceremonyOwnerName;
        data["ceremonyOwnerPhoneNo"] = this.ceremonyOwnerPhoneNo;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICeremonyForBillDto {
    ceremonyId: number | undefined;
    eventTypeId: number | undefined;
    title: string | undefined;
    startTime: moment.Moment;
    endTime: moment.Moment | undefined;
    ceremonyOwnerName: string | undefined;
    ceremonyOwnerPhoneNo: string | undefined;
    location: LocationForBillDto;
}

export class CustomBillDto implements ICustomBillDto {
    billId!: number | undefined;
    price!: number | undefined;
    deliveryType!: DeliveryTypes;
    survivorMobileNo!: string | undefined;
    description!: string | undefined;
    contactId!: number | undefined;
    currencyId!: number | undefined;
    planConstId!: number | undefined;
    cardTemplateRef!: number | undefined;

    constructor(data?: ICustomBillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.billId = data["billId"];
            this.price = data["price"];
            this.deliveryType = data["deliveryType"];
            this.survivorMobileNo = data["survivorMobileNo"];
            this.description = data["description"];
            this.contactId = data["contactId"];
            this.currencyId = data["currencyId"];
            this.planConstId = data["planConstId"];
            this.cardTemplateRef = data["cardTemplateRef"];
        }
    }

    static fromJS(data: any): CustomBillDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomBillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billId"] = this.billId;
        data["price"] = this.price;
        data["deliveryType"] = this.deliveryType;
        data["survivorMobileNo"] = this.survivorMobileNo;
        data["description"] = this.description;
        data["contactId"] = this.contactId;
        data["currencyId"] = this.currencyId;
        data["planConstId"] = this.planConstId;
        data["cardTemplateRef"] = this.cardTemplateRef;
        return data; 
    }
}

export interface ICustomBillDto {
    billId: number | undefined;
    price: number | undefined;
    deliveryType: DeliveryTypes;
    survivorMobileNo: string | undefined;
    description: string | undefined;
    contactId: number | undefined;
    currencyId: number | undefined;
    planConstId: number | undefined;
    cardTemplateRef: number | undefined;
}

export class CreateOrEditBillAndDependentFormsDto implements ICreateOrEditBillAndDependentFormsDto {
    deceased!: DeceasedForBillDto;
    ceremony!: CeremonyForBillDto;
    bill!: CustomBillDto;
    flowerCardTemplateProperties!: GetPropertiesForBillDto[] | undefined;
    sendNotice!: boolean;
    title!: string | undefined;
    maxPrice!: number | undefined;
    minPrice!: number | undefined;
    planBanner!: string | undefined;
    planType!: Plans;
    isDuplicate!: boolean;

    constructor(data?: ICreateOrEditBillAndDependentFormsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deceased = data["deceased"] ? DeceasedForBillDto.fromJS(data["deceased"]) : <any>undefined;
            this.ceremony = data["ceremony"] ? CeremonyForBillDto.fromJS(data["ceremony"]) : <any>undefined;
            this.bill = data["bill"] ? CustomBillDto.fromJS(data["bill"]) : <any>undefined;
            if (Array.isArray(data["flowerCardTemplateProperties"])) {
                this.flowerCardTemplateProperties = [] as any;
                for (let item of data["flowerCardTemplateProperties"])
                    this.flowerCardTemplateProperties!.push(GetPropertiesForBillDto.fromJS(item));
            }
            this.sendNotice = data["sendNotice"];
            this.title = data["title"];
            this.maxPrice = data["maxPrice"];
            this.minPrice = data["minPrice"];
            this.planBanner = data["planBanner"];
            this.planType = data["planType"];
            this.isDuplicate = data["isDuplicate"];
        }
    }

    static fromJS(data: any): CreateOrEditBillAndDependentFormsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditBillAndDependentFormsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deceased"] = this.deceased ? this.deceased.toJSON() : <any>undefined;
        data["ceremony"] = this.ceremony ? this.ceremony.toJSON() : <any>undefined;
        data["bill"] = this.bill ? this.bill.toJSON() : <any>undefined;
        if (Array.isArray(this.flowerCardTemplateProperties)) {
            data["flowerCardTemplateProperties"] = [];
            for (let item of this.flowerCardTemplateProperties)
                data["flowerCardTemplateProperties"].push(item.toJSON());
        }
        data["sendNotice"] = this.sendNotice;
        data["title"] = this.title;
        data["maxPrice"] = this.maxPrice;
        data["minPrice"] = this.minPrice;
        data["planBanner"] = this.planBanner;
        data["planType"] = this.planType;
        data["isDuplicate"] = this.isDuplicate;
        return data; 
    }
}

export interface ICreateOrEditBillAndDependentFormsDto {
    deceased: DeceasedForBillDto;
    ceremony: CeremonyForBillDto;
    bill: CustomBillDto;
    flowerCardTemplateProperties: GetPropertiesForBillDto[] | undefined;
    sendNotice: boolean;
    title: string | undefined;
    maxPrice: number | undefined;
    minPrice: number | undefined;
    planBanner: string | undefined;
    planType: Plans;
    isDuplicate: boolean;
}

export class GetPublicLocationsForShopDto implements IGetPublicLocationsForShopDto {
    title!: string | undefined;
    address!: string | undefined;
    locationId!: number;
    state!: string | undefined;
    city!: string | undefined;
    streetAlley!: string | undefined;
    addressId!: number | undefined;
    addressTitle!: string | undefined;
    guaranteedTimeDeliver!: number | undefined;
    latitude!: number | undefined;
    longitude!: number | undefined;

    constructor(data?: IGetPublicLocationsForShopDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.address = data["address"];
            this.locationId = data["locationId"];
            this.state = data["state"];
            this.city = data["city"];
            this.streetAlley = data["streetAlley"];
            this.addressId = data["addressId"];
            this.addressTitle = data["addressTitle"];
            this.guaranteedTimeDeliver = data["guaranteedTimeDeliver"];
            this.latitude = data["latitude"];
            this.longitude = data["longitude"];
        }
    }

    static fromJS(data: any): GetPublicLocationsForShopDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublicLocationsForShopDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["address"] = this.address;
        data["locationId"] = this.locationId;
        data["state"] = this.state;
        data["city"] = this.city;
        data["streetAlley"] = this.streetAlley;
        data["addressId"] = this.addressId;
        data["addressTitle"] = this.addressTitle;
        data["guaranteedTimeDeliver"] = this.guaranteedTimeDeliver;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data; 
    }
}

export interface IGetPublicLocationsForShopDto {
    title: string | undefined;
    address: string | undefined;
    locationId: number;
    state: string | undefined;
    city: string | undefined;
    streetAlley: string | undefined;
    addressId: number | undefined;
    addressTitle: string | undefined;
    guaranteedTimeDeliver: number | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
}

export class PagedResultDtoOfGetPublicLocationsForShopDto implements IPagedResultDtoOfGetPublicLocationsForShopDto {
    totalCount!: number;
    items!: GetPublicLocationsForShopDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetPublicLocationsForShopDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetPublicLocationsForShopDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetPublicLocationsForShopDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetPublicLocationsForShopDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetPublicLocationsForShopDto {
    totalCount: number;
    items: GetPublicLocationsForShopDto[] | undefined;
}

export class GetAllDeceasedForShopDto implements IGetAllDeceasedForShopDto {
    deceasedId!: number;
    deceasedCode!: string | undefined;
    deceasedFullName!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    survivorName!: string | undefined;
    survivorPhoneNo!: string | undefined;
    respectPrefixTitle!: string | undefined;
    isApproved!: boolean | undefined;
    imagePath!: string | undefined;
    deathDate!: moment.Moment | undefined;
    creationTime!: moment.Moment | undefined;
    gender!: Gender;
    deceasedCeremonies!: GetAllCeremoniesForShopDto[] | undefined;
    gallery!: FileUploadModel[] | undefined;

    constructor(data?: IGetAllDeceasedForShopDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deceasedId = data["deceasedId"];
            this.deceasedCode = data["deceasedCode"];
            this.deceasedFullName = data["deceasedFullName"];
            this.firstName = data["firstName"];
            this.lastName = data["lastName"];
            this.survivorName = data["survivorName"];
            this.survivorPhoneNo = data["survivorPhoneNo"];
            this.respectPrefixTitle = data["respectPrefixTitle"];
            this.isApproved = data["isApproved"];
            this.imagePath = data["imagePath"];
            this.deathDate = data["deathDate"] ? moment(data["deathDate"].toString()) : <any>undefined;
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.gender = data["gender"];
            if (Array.isArray(data["deceasedCeremonies"])) {
                this.deceasedCeremonies = [] as any;
                for (let item of data["deceasedCeremonies"])
                    this.deceasedCeremonies!.push(GetAllCeremoniesForShopDto.fromJS(item));
            }
            if (Array.isArray(data["gallery"])) {
                this.gallery = [] as any;
                for (let item of data["gallery"])
                    this.gallery!.push(FileUploadModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllDeceasedForShopDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllDeceasedForShopDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deceasedId"] = this.deceasedId;
        data["deceasedCode"] = this.deceasedCode;
        data["deceasedFullName"] = this.deceasedFullName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["survivorName"] = this.survivorName;
        data["survivorPhoneNo"] = this.survivorPhoneNo;
        data["respectPrefixTitle"] = this.respectPrefixTitle;
        data["isApproved"] = this.isApproved;
        data["imagePath"] = this.imagePath;
        data["deathDate"] = this.deathDate ? this.deathDate.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["gender"] = this.gender;
        if (Array.isArray(this.deceasedCeremonies)) {
            data["deceasedCeremonies"] = [];
            for (let item of this.deceasedCeremonies)
                data["deceasedCeremonies"].push(item.toJSON());
        }
        if (Array.isArray(this.gallery)) {
            data["gallery"] = [];
            for (let item of this.gallery)
                data["gallery"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetAllDeceasedForShopDto {
    deceasedId: number;
    deceasedCode: string | undefined;
    deceasedFullName: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    survivorName: string | undefined;
    survivorPhoneNo: string | undefined;
    respectPrefixTitle: string | undefined;
    isApproved: boolean | undefined;
    imagePath: string | undefined;
    deathDate: moment.Moment | undefined;
    creationTime: moment.Moment | undefined;
    gender: Gender;
    deceasedCeremonies: GetAllCeremoniesForShopDto[] | undefined;
    gallery: FileUploadModel[] | undefined;
}

export class PagedResultDtoOfGetAllDeceasedForShopDto implements IPagedResultDtoOfGetAllDeceasedForShopDto {
    totalCount!: number;
    items!: GetAllDeceasedForShopDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAllDeceasedForShopDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetAllDeceasedForShopDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAllDeceasedForShopDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAllDeceasedForShopDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetAllDeceasedForShopDto {
    totalCount: number;
    items: GetAllDeceasedForShopDto[] | undefined;
}

export class ActionResult implements IActionResult {

    constructor(data?: IActionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
    }

    static fromJS(data: any): ActionResult {
        data = typeof data === 'object' ? data : {};
        let result = new ActionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }
}

export interface IActionResult {
}

export class CreateOrEditBillAndDependentFormsOutputDto implements ICreateOrEditBillAndDependentFormsOutputDto {
    locations!: PagedResultDtoOfGetPublicLocationsForShopDto;
    deceaseds!: PagedResultDtoOfGetAllDeceasedForShopDto;
    result!: ActionResult;

    constructor(data?: ICreateOrEditBillAndDependentFormsOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.locations = data["locations"] ? PagedResultDtoOfGetPublicLocationsForShopDto.fromJS(data["locations"]) : <any>undefined;
            this.deceaseds = data["deceaseds"] ? PagedResultDtoOfGetAllDeceasedForShopDto.fromJS(data["deceaseds"]) : <any>undefined;
            this.result = data["result"] ? ActionResult.fromJS(data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrEditBillAndDependentFormsOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditBillAndDependentFormsOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locations"] = this.locations ? this.locations.toJSON() : <any>undefined;
        data["deceaseds"] = this.deceaseds ? this.deceaseds.toJSON() : <any>undefined;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICreateOrEditBillAndDependentFormsOutputDto {
    locations: PagedResultDtoOfGetPublicLocationsForShopDto;
    deceaseds: PagedResultDtoOfGetAllDeceasedForShopDto;
    result: ActionResult;
}

export class ConsumeRef implements IConsumeRef {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IConsumeRef) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): ConsumeRef {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumeRef();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IConsumeRef {
    id: number;
    displayName: string | undefined;
}

export class CreateOrEditPlanConstAndCharityForShop implements ICreateOrEditPlanConstAndCharityForShop {
    title!: string | undefined;
    consumesRef!: ConsumeRef[] | undefined;
    sourceId!: number | undefined;
    isCash!: boolean;
    isContinuous!: boolean;
    selectClient!: SelectClient;
    planConstId!: number | undefined;
    minPrice!: number | undefined;
    maxPrice!: number | undefined;
    baseTimes!: BaseTimeInfo[] | undefined;
    sourceAttributes!: GetAttributeForFamilyDto[] | undefined;

    constructor(data?: ICreateOrEditPlanConstAndCharityForShop) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            if (Array.isArray(data["consumesRef"])) {
                this.consumesRef = [] as any;
                for (let item of data["consumesRef"])
                    this.consumesRef!.push(ConsumeRef.fromJS(item));
            }
            this.sourceId = data["sourceId"];
            this.isCash = data["isCash"];
            this.isContinuous = data["isContinuous"];
            this.selectClient = data["selectClient"];
            this.planConstId = data["planConstId"];
            this.minPrice = data["minPrice"];
            this.maxPrice = data["maxPrice"];
            if (Array.isArray(data["baseTimes"])) {
                this.baseTimes = [] as any;
                for (let item of data["baseTimes"])
                    this.baseTimes!.push(BaseTimeInfo.fromJS(item));
            }
            if (Array.isArray(data["sourceAttributes"])) {
                this.sourceAttributes = [] as any;
                for (let item of data["sourceAttributes"])
                    this.sourceAttributes!.push(GetAttributeForFamilyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrEditPlanConstAndCharityForShop {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPlanConstAndCharityForShop();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        if (Array.isArray(this.consumesRef)) {
            data["consumesRef"] = [];
            for (let item of this.consumesRef)
                data["consumesRef"].push(item.toJSON());
        }
        data["sourceId"] = this.sourceId;
        data["isCash"] = this.isCash;
        data["isContinuous"] = this.isContinuous;
        data["selectClient"] = this.selectClient;
        data["planConstId"] = this.planConstId;
        data["minPrice"] = this.minPrice;
        data["maxPrice"] = this.maxPrice;
        if (Array.isArray(this.baseTimes)) {
            data["baseTimes"] = [];
            for (let item of this.baseTimes)
                data["baseTimes"].push(item.toJSON());
        }
        if (Array.isArray(this.sourceAttributes)) {
            data["sourceAttributes"] = [];
            for (let item of this.sourceAttributes)
                data["sourceAttributes"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateOrEditPlanConstAndCharityForShop {
    title: string | undefined;
    consumesRef: ConsumeRef[] | undefined;
    sourceId: number | undefined;
    isCash: boolean;
    isContinuous: boolean;
    selectClient: SelectClient;
    planConstId: number | undefined;
    minPrice: number | undefined;
    maxPrice: number | undefined;
    baseTimes: BaseTimeInfo[] | undefined;
    sourceAttributes: GetAttributeForFamilyDto[] | undefined;
}

export class CreateOrEditPlanBillForShopDto implements ICreateOrEditPlanBillForShopDto {
    planBillId!: number | undefined;
    amount!: number | undefined;
    entity!: Entities;
    entityRef!: number | undefined;
    description!: string | undefined;
    startDate!: moment.Moment | undefined;
    benefactorName!: string | undefined;
    durationDate!: number | undefined;
    baseTimeId!: number | undefined;
    age!: number | undefined;
    fullName!: string | undefined;
    gender!: Gender;
    isSadat!: boolean | undefined;
    birthDay!: moment.Moment | undefined;
    sourceAttr!: GetAttributeForFamilyDto[] | undefined;

    constructor(data?: ICreateOrEditPlanBillForShopDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.planBillId = data["planBillId"];
            this.amount = data["amount"];
            this.entity = data["entity"];
            this.entityRef = data["entityRef"];
            this.description = data["description"];
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.benefactorName = data["benefactorName"];
            this.durationDate = data["durationDate"];
            this.baseTimeId = data["baseTimeId"];
            this.age = data["age"];
            this.fullName = data["fullName"];
            this.gender = data["gender"];
            this.isSadat = data["isSadat"];
            this.birthDay = data["birthDay"] ? moment(data["birthDay"].toString()) : <any>undefined;
            if (Array.isArray(data["sourceAttr"])) {
                this.sourceAttr = [] as any;
                for (let item of data["sourceAttr"])
                    this.sourceAttr!.push(GetAttributeForFamilyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrEditPlanBillForShopDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPlanBillForShopDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planBillId"] = this.planBillId;
        data["amount"] = this.amount;
        data["entity"] = this.entity;
        data["entityRef"] = this.entityRef;
        data["description"] = this.description;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["benefactorName"] = this.benefactorName;
        data["durationDate"] = this.durationDate;
        data["baseTimeId"] = this.baseTimeId;
        data["age"] = this.age;
        data["fullName"] = this.fullName;
        data["gender"] = this.gender;
        data["isSadat"] = this.isSadat;
        data["birthDay"] = this.birthDay ? this.birthDay.toISOString() : <any>undefined;
        if (Array.isArray(this.sourceAttr)) {
            data["sourceAttr"] = [];
            for (let item of this.sourceAttr)
                data["sourceAttr"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateOrEditPlanBillForShopDto {
    planBillId: number | undefined;
    amount: number | undefined;
    entity: Entities;
    entityRef: number | undefined;
    description: string | undefined;
    startDate: moment.Moment | undefined;
    benefactorName: string | undefined;
    durationDate: number | undefined;
    baseTimeId: number | undefined;
    age: number | undefined;
    fullName: string | undefined;
    gender: Gender;
    isSadat: boolean | undefined;
    birthDay: moment.Moment | undefined;
    sourceAttr: GetAttributeForFamilyDto[] | undefined;
}

export class CreateOrEditBillAndDependentCharityFormsDto implements ICreateOrEditBillAndDependentCharityFormsDto {
    contactId!: number | undefined;
    charity!: CreateOrEditPlanConstAndCharityForShop;
    orphans!: CreateOrEditPlanBillForShopDto[] | undefined;

    constructor(data?: ICreateOrEditBillAndDependentCharityFormsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contactId = data["contactId"];
            this.charity = data["charity"] ? CreateOrEditPlanConstAndCharityForShop.fromJS(data["charity"]) : <any>undefined;
            if (Array.isArray(data["orphans"])) {
                this.orphans = [] as any;
                for (let item of data["orphans"])
                    this.orphans!.push(CreateOrEditPlanBillForShopDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrEditBillAndDependentCharityFormsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditBillAndDependentCharityFormsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["charity"] = this.charity ? this.charity.toJSON() : <any>undefined;
        if (Array.isArray(this.orphans)) {
            data["orphans"] = [];
            for (let item of this.orphans)
                data["orphans"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateOrEditBillAndDependentCharityFormsDto {
    contactId: number | undefined;
    charity: CreateOrEditPlanConstAndCharityForShop;
    orphans: CreateOrEditPlanBillForShopDto[] | undefined;
}

export class CreateOrEditBillsFromPlanBillDto implements ICreateOrEditBillsFromPlanBillDto {
    planBillId!: number;
    contactId!: number | undefined;
    billCount!: number;
    branchRef!: number | undefined;

    constructor(data?: ICreateOrEditBillsFromPlanBillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.planBillId = data["planBillId"];
            this.contactId = data["contactId"];
            this.billCount = data["billCount"];
            this.branchRef = data["branchRef"];
        }
    }

    static fromJS(data: any): CreateOrEditBillsFromPlanBillDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditBillsFromPlanBillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planBillId"] = this.planBillId;
        data["contactId"] = this.contactId;
        data["billCount"] = this.billCount;
        data["branchRef"] = this.branchRef;
        return data; 
    }
}

export interface ICreateOrEditBillsFromPlanBillDto {
    planBillId: number;
    contactId: number | undefined;
    billCount: number;
    branchRef: number | undefined;
}

export class BillsFromPlanBillOutputDto implements IBillsFromPlanBillOutputDto {
    bill!: BillDto;
    contactFirstName!: string | undefined;
    currencyName!: string | undefined;

    constructor(data?: IBillsFromPlanBillOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bill = data["bill"] ? BillDto.fromJS(data["bill"]) : <any>undefined;
            this.contactFirstName = data["contactFirstName"];
            this.currencyName = data["currencyName"];
        }
    }

    static fromJS(data: any): BillsFromPlanBillOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillsFromPlanBillOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bill"] = this.bill ? this.bill.toJSON() : <any>undefined;
        data["contactFirstName"] = this.contactFirstName;
        data["currencyName"] = this.currencyName;
        return data; 
    }
}

export interface IBillsFromPlanBillOutputDto {
    bill: BillDto;
    contactFirstName: string | undefined;
    currencyName: string | undefined;
}

export class CreateOrEditBillAndPlanBillDto implements ICreateOrEditBillAndPlanBillDto {
    bill!: CreateOrEditBillDto;
    planBill!: CreateOrEditPlanBillDto;
    payRequest!: boolean;

    constructor(data?: ICreateOrEditBillAndPlanBillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bill = data["bill"] ? CreateOrEditBillDto.fromJS(data["bill"]) : <any>undefined;
            this.planBill = data["planBill"] ? CreateOrEditPlanBillDto.fromJS(data["planBill"]) : <any>undefined;
            this.payRequest = data["payRequest"];
        }
    }

    static fromJS(data: any): CreateOrEditBillAndPlanBillDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditBillAndPlanBillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bill"] = this.bill ? this.bill.toJSON() : <any>undefined;
        data["planBill"] = this.planBill ? this.planBill.toJSON() : <any>undefined;
        data["payRequest"] = this.payRequest;
        return data; 
    }
}

export interface ICreateOrEditBillAndPlanBillDto {
    bill: CreateOrEditBillDto;
    planBill: CreateOrEditPlanBillDto;
    payRequest: boolean;
}

export class BillAndPlanBillDto implements IBillAndPlanBillDto {
    billId!: number | undefined;
    price!: number | undefined;
    benefactorName!: string | undefined;
    survivorMobile!: string | undefined;
    planConstId!: number | undefined;
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    durationDate!: number | undefined;
    baseTimeRef!: number | undefined;

    constructor(data?: IBillAndPlanBillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.billId = data["billId"];
            this.price = data["price"];
            this.benefactorName = data["benefactorName"];
            this.survivorMobile = data["survivorMobile"];
            this.planConstId = data["planConstId"];
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.durationDate = data["durationDate"];
            this.baseTimeRef = data["baseTimeRef"];
        }
    }

    static fromJS(data: any): BillAndPlanBillDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillAndPlanBillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billId"] = this.billId;
        data["price"] = this.price;
        data["benefactorName"] = this.benefactorName;
        data["survivorMobile"] = this.survivorMobile;
        data["planConstId"] = this.planConstId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["durationDate"] = this.durationDate;
        data["baseTimeRef"] = this.baseTimeRef;
        return data; 
    }
}

export interface IBillAndPlanBillDto {
    billId: number | undefined;
    price: number | undefined;
    benefactorName: string | undefined;
    survivorMobile: string | undefined;
    planConstId: number | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    durationDate: number | undefined;
    baseTimeRef: number | undefined;
}

export class CreateOrEditBillAndDeceasedInput implements ICreateOrEditBillAndDeceasedInput {
    bill!: BillAndPlanBillDto;
    deceased!: DeceasedForBillDto;

    constructor(data?: ICreateOrEditBillAndDeceasedInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bill = data["bill"] ? BillAndPlanBillDto.fromJS(data["bill"]) : <any>undefined;
            this.deceased = data["deceased"] ? DeceasedForBillDto.fromJS(data["deceased"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrEditBillAndDeceasedInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditBillAndDeceasedInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bill"] = this.bill ? this.bill.toJSON() : <any>undefined;
        data["deceased"] = this.deceased ? this.deceased.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICreateOrEditBillAndDeceasedInput {
    bill: BillAndPlanBillDto;
    deceased: DeceasedForBillDto;
}

export class CreateOrEditBillsForSacrificeDto implements ICreateOrEditBillsForSacrificeDto {
    price!: number;
    count!: number | undefined;
    description!: string | undefined;
    planConstId!: number;
    descriptionOne!: string | undefined;
    descriptionTwo!: string | undefined;
    announceTheDifference!: boolean;
    isDuplicate!: boolean;
    extraEntityRef!: number | undefined;

    constructor(data?: ICreateOrEditBillsForSacrificeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.price = data["price"];
            this.count = data["count"];
            this.description = data["description"];
            this.planConstId = data["planConstId"];
            this.descriptionOne = data["descriptionOne"];
            this.descriptionTwo = data["descriptionTwo"];
            this.announceTheDifference = data["announceTheDifference"];
            this.isDuplicate = data["isDuplicate"];
            this.extraEntityRef = data["extraEntityRef"];
        }
    }

    static fromJS(data: any): CreateOrEditBillsForSacrificeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditBillsForSacrificeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["price"] = this.price;
        data["count"] = this.count;
        data["description"] = this.description;
        data["planConstId"] = this.planConstId;
        data["descriptionOne"] = this.descriptionOne;
        data["descriptionTwo"] = this.descriptionTwo;
        data["announceTheDifference"] = this.announceTheDifference;
        data["isDuplicate"] = this.isDuplicate;
        data["extraEntityRef"] = this.extraEntityRef;
        return data; 
    }
}

export interface ICreateOrEditBillsForSacrificeDto {
    price: number;
    count: number | undefined;
    description: string | undefined;
    planConstId: number;
    descriptionOne: string | undefined;
    descriptionTwo: string | undefined;
    announceTheDifference: boolean;
    isDuplicate: boolean;
    extraEntityRef: number | undefined;
}

export enum BillTypes {
    Default = 0,
    Basket = 1,
    Order = 2,
}

export enum PropertyTypes {
    Default = 0,
    String = 1,
    Number = 2,
    Boolean = 3,
}

export class Property implements IProperty {
    name!: string | undefined;
    value!: string | undefined;
    key!: string | undefined;
    type!: PropertyTypes;
    suffix!: string | undefined;

    constructor(data?: IProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
            this.key = data["key"];
            this.type = data["type"];
            this.suffix = data["suffix"];
        }
    }

    static fromJS(data: any): Property {
        data = typeof data === 'object' ? data : {};
        let result = new Property();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        data["key"] = this.key;
        data["type"] = this.type;
        data["suffix"] = this.suffix;
        return data; 
    }
}

export interface IProperty {
    name: string | undefined;
    value: string | undefined;
    key: string | undefined;
    type: PropertyTypes;
    suffix: string | undefined;
}

export class GetContactBillsForShopDto implements IGetContactBillsForShopDto {
    planConstId!: number;
    extraEntityRef!: number | undefined;
    extraEntity!: Consumers;
    isShowPlanConst!: boolean;
    sourceId!: number | undefined;
    planCode!: string | undefined;
    title!: string | undefined;
    price!: number;
    secondPrice!: number | undefined;
    thirdPrice!: number | undefined;
    imagePath!: string | undefined;
    code!: string | undefined;
    id!: number;
    billCurrencyId!: number | undefined;
    planBillRef!: number | undefined;
    status!: BillStatus;
    paymentDate!: moment.Moment | undefined;
    paymentType!: string | undefined;
    issueDate!: moment.Moment | undefined;
    dueDate!: moment.Moment | undefined;
    deliveryType!: DeliveryTypes;
    survivorMobileNo!: string | undefined;
    planType!: Plans;
    count!: number;
    bankIssueTracking!: string | undefined;
    isCash!: boolean;
    properties!: Property[] | undefined;
    postman!: boolean;
    cardTemplateRef!: number | undefined;
    deceasedId!: number | undefined;
    reorderForOther!: boolean;
    reorderForOtherCeremony!: boolean;
    notApprovedPay!: PaymentDto;
    description!: string | undefined;
    paidPrice!: number | undefined;
    billsIdForRemaining!: number[] | undefined;
    benefactorName!: string | undefined;

    constructor(data?: IGetContactBillsForShopDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.planConstId = data["planConstId"];
            this.extraEntityRef = data["extraEntityRef"];
            this.extraEntity = data["extraEntity"];
            this.isShowPlanConst = data["isShowPlanConst"];
            this.sourceId = data["sourceId"];
            this.planCode = data["planCode"];
            this.title = data["title"];
            this.price = data["price"];
            this.secondPrice = data["secondPrice"];
            this.thirdPrice = data["thirdPrice"];
            this.imagePath = data["imagePath"];
            this.code = data["code"];
            this.id = data["id"];
            this.billCurrencyId = data["billCurrencyId"];
            this.planBillRef = data["planBillRef"];
            this.status = data["status"];
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.paymentType = data["paymentType"];
            this.issueDate = data["issueDate"] ? moment(data["issueDate"].toString()) : <any>undefined;
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.deliveryType = data["deliveryType"];
            this.survivorMobileNo = data["survivorMobileNo"];
            this.planType = data["planType"];
            this.count = data["count"];
            this.bankIssueTracking = data["bankIssueTracking"];
            this.isCash = data["isCash"];
            if (Array.isArray(data["properties"])) {
                this.properties = [] as any;
                for (let item of data["properties"])
                    this.properties!.push(Property.fromJS(item));
            }
            this.postman = data["postman"];
            this.cardTemplateRef = data["cardTemplateRef"];
            this.deceasedId = data["deceasedId"];
            this.reorderForOther = data["reorderForOther"];
            this.reorderForOtherCeremony = data["reorderForOtherCeremony"];
            this.notApprovedPay = data["notApprovedPay"] ? PaymentDto.fromJS(data["notApprovedPay"]) : <any>undefined;
            this.description = data["description"];
            this.paidPrice = data["paidPrice"];
            if (Array.isArray(data["billsIdForRemaining"])) {
                this.billsIdForRemaining = [] as any;
                for (let item of data["billsIdForRemaining"])
                    this.billsIdForRemaining!.push(item);
            }
            this.benefactorName = data["benefactorName"];
        }
    }

    static fromJS(data: any): GetContactBillsForShopDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetContactBillsForShopDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planConstId"] = this.planConstId;
        data["extraEntityRef"] = this.extraEntityRef;
        data["extraEntity"] = this.extraEntity;
        data["isShowPlanConst"] = this.isShowPlanConst;
        data["sourceId"] = this.sourceId;
        data["planCode"] = this.planCode;
        data["title"] = this.title;
        data["price"] = this.price;
        data["secondPrice"] = this.secondPrice;
        data["thirdPrice"] = this.thirdPrice;
        data["imagePath"] = this.imagePath;
        data["code"] = this.code;
        data["id"] = this.id;
        data["billCurrencyId"] = this.billCurrencyId;
        data["planBillRef"] = this.planBillRef;
        data["status"] = this.status;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["paymentType"] = this.paymentType;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["deliveryType"] = this.deliveryType;
        data["survivorMobileNo"] = this.survivorMobileNo;
        data["planType"] = this.planType;
        data["count"] = this.count;
        data["bankIssueTracking"] = this.bankIssueTracking;
        data["isCash"] = this.isCash;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item.toJSON());
        }
        data["postman"] = this.postman;
        data["cardTemplateRef"] = this.cardTemplateRef;
        data["deceasedId"] = this.deceasedId;
        data["reorderForOther"] = this.reorderForOther;
        data["reorderForOtherCeremony"] = this.reorderForOtherCeremony;
        data["notApprovedPay"] = this.notApprovedPay ? this.notApprovedPay.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["paidPrice"] = this.paidPrice;
        if (Array.isArray(this.billsIdForRemaining)) {
            data["billsIdForRemaining"] = [];
            for (let item of this.billsIdForRemaining)
                data["billsIdForRemaining"].push(item);
        }
        data["benefactorName"] = this.benefactorName;
        return data; 
    }
}

export interface IGetContactBillsForShopDto {
    planConstId: number;
    extraEntityRef: number | undefined;
    extraEntity: Consumers;
    isShowPlanConst: boolean;
    sourceId: number | undefined;
    planCode: string | undefined;
    title: string | undefined;
    price: number;
    secondPrice: number | undefined;
    thirdPrice: number | undefined;
    imagePath: string | undefined;
    code: string | undefined;
    id: number;
    billCurrencyId: number | undefined;
    planBillRef: number | undefined;
    status: BillStatus;
    paymentDate: moment.Moment | undefined;
    paymentType: string | undefined;
    issueDate: moment.Moment | undefined;
    dueDate: moment.Moment | undefined;
    deliveryType: DeliveryTypes;
    survivorMobileNo: string | undefined;
    planType: Plans;
    count: number;
    bankIssueTracking: string | undefined;
    isCash: boolean;
    properties: Property[] | undefined;
    postman: boolean;
    cardTemplateRef: number | undefined;
    deceasedId: number | undefined;
    reorderForOther: boolean;
    reorderForOtherCeremony: boolean;
    notApprovedPay: PaymentDto;
    description: string | undefined;
    paidPrice: number | undefined;
    billsIdForRemaining: number[] | undefined;
    benefactorName: string | undefined;
}

export class PagedResultDtoOfGetContactBillsForShopDto implements IPagedResultDtoOfGetContactBillsForShopDto {
    totalCount!: number;
    items!: GetContactBillsForShopDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetContactBillsForShopDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetContactBillsForShopDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetContactBillsForShopDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetContactBillsForShopDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetContactBillsForShopDto {
    totalCount: number;
    items: GetContactBillsForShopDto[] | undefined;
}

export class Client implements IClient {
    entity!: Entities;
    fullName!: string | undefined;
    baseTimeId!: number | undefined;
    baseTimeName!: string | undefined;
    gender!: Gender;

    constructor(data?: IClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entity = data["entity"];
            this.fullName = data["fullName"];
            this.baseTimeId = data["baseTimeId"];
            this.baseTimeName = data["baseTimeName"];
            this.gender = data["gender"];
        }
    }

    static fromJS(data: any): Client {
        data = typeof data === 'object' ? data : {};
        let result = new Client();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entity"] = this.entity;
        data["fullName"] = this.fullName;
        data["baseTimeId"] = this.baseTimeId;
        data["baseTimeName"] = this.baseTimeName;
        data["gender"] = this.gender;
        return data; 
    }
}

export interface IClient {
    entity: Entities;
    fullName: string | undefined;
    baseTimeId: number | undefined;
    baseTimeName: string | undefined;
    gender: Gender;
}

export enum TypesOfSolace {
    Default = 0,
    FlowerCrown = 1,
    Banner = 2,
    Stand = 3,
    Tablet = 4,
    Frame = 5,
    Bill = 6,
    Clip = 7,
    Payment = 8,
    TemporaryReceipt = 9,
}

export class GetBillAndDependentFormsOutput implements IGetBillAndDependentFormsOutput {
    deceased!: DeceasedForBillDto;
    ceremony!: CeremonyForBillDto;
    bill!: CustomBillDto;
    sendNotice!: boolean;
    title!: string | undefined;
    maxPrice!: number | undefined;
    minPrice!: number | undefined;
    planBanner!: string | undefined;
    planType!: Plans;
    payments!: PaymentBillDto[] | undefined;
    client!: Client;
    flowerCardTemplateProperties!: GetPropertiesForBillDto[] | undefined;
    typesOfSolace!: TypesOfSolace;

    constructor(data?: IGetBillAndDependentFormsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deceased = data["deceased"] ? DeceasedForBillDto.fromJS(data["deceased"]) : <any>undefined;
            this.ceremony = data["ceremony"] ? CeremonyForBillDto.fromJS(data["ceremony"]) : <any>undefined;
            this.bill = data["bill"] ? CustomBillDto.fromJS(data["bill"]) : <any>undefined;
            this.sendNotice = data["sendNotice"];
            this.title = data["title"];
            this.maxPrice = data["maxPrice"];
            this.minPrice = data["minPrice"];
            this.planBanner = data["planBanner"];
            this.planType = data["planType"];
            if (Array.isArray(data["payments"])) {
                this.payments = [] as any;
                for (let item of data["payments"])
                    this.payments!.push(PaymentBillDto.fromJS(item));
            }
            this.client = data["client"] ? Client.fromJS(data["client"]) : <any>undefined;
            if (Array.isArray(data["flowerCardTemplateProperties"])) {
                this.flowerCardTemplateProperties = [] as any;
                for (let item of data["flowerCardTemplateProperties"])
                    this.flowerCardTemplateProperties!.push(GetPropertiesForBillDto.fromJS(item));
            }
            this.typesOfSolace = data["typesOfSolace"];
        }
    }

    static fromJS(data: any): GetBillAndDependentFormsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetBillAndDependentFormsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deceased"] = this.deceased ? this.deceased.toJSON() : <any>undefined;
        data["ceremony"] = this.ceremony ? this.ceremony.toJSON() : <any>undefined;
        data["bill"] = this.bill ? this.bill.toJSON() : <any>undefined;
        data["sendNotice"] = this.sendNotice;
        data["title"] = this.title;
        data["maxPrice"] = this.maxPrice;
        data["minPrice"] = this.minPrice;
        data["planBanner"] = this.planBanner;
        data["planType"] = this.planType;
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        if (Array.isArray(this.flowerCardTemplateProperties)) {
            data["flowerCardTemplateProperties"] = [];
            for (let item of this.flowerCardTemplateProperties)
                data["flowerCardTemplateProperties"].push(item.toJSON());
        }
        data["typesOfSolace"] = this.typesOfSolace;
        return data; 
    }
}

export interface IGetBillAndDependentFormsOutput {
    deceased: DeceasedForBillDto;
    ceremony: CeremonyForBillDto;
    bill: CustomBillDto;
    sendNotice: boolean;
    title: string | undefined;
    maxPrice: number | undefined;
    minPrice: number | undefined;
    planBanner: string | undefined;
    planType: Plans;
    payments: PaymentBillDto[] | undefined;
    client: Client;
    flowerCardTemplateProperties: GetPropertiesForBillDto[] | undefined;
    typesOfSolace: TypesOfSolace;
}

export class BillContactLookupTableDto implements IBillContactLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    mobileNumber!: string | undefined;
    email!: string | undefined;
    mobileNumber2!: string | undefined;
    address!: string | undefined;
    virtualCredit!: string | undefined;
    respectPrefixTitle!: string | undefined;
    currencyId!: number | undefined;
    userId!: number | undefined;
    isBadPayer!: boolean;

    constructor(data?: IBillContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.mobileNumber = data["mobileNumber"];
            this.email = data["email"];
            this.mobileNumber2 = data["mobileNumber2"];
            this.address = data["address"];
            this.virtualCredit = data["virtualCredit"];
            this.respectPrefixTitle = data["respectPrefixTitle"];
            this.currencyId = data["currencyId"];
            this.userId = data["userId"];
            this.isBadPayer = data["isBadPayer"];
        }
    }

    static fromJS(data: any): BillContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["mobileNumber"] = this.mobileNumber;
        data["email"] = this.email;
        data["mobileNumber2"] = this.mobileNumber2;
        data["address"] = this.address;
        data["virtualCredit"] = this.virtualCredit;
        data["respectPrefixTitle"] = this.respectPrefixTitle;
        data["currencyId"] = this.currencyId;
        data["userId"] = this.userId;
        data["isBadPayer"] = this.isBadPayer;
        return data; 
    }
}

export interface IBillContactLookupTableDto {
    id: number;
    displayName: string | undefined;
    mobileNumber: string | undefined;
    email: string | undefined;
    mobileNumber2: string | undefined;
    address: string | undefined;
    virtualCredit: string | undefined;
    respectPrefixTitle: string | undefined;
    currencyId: number | undefined;
    userId: number | undefined;
    isBadPayer: boolean;
}

export class PagedResultDtoOfBillContactLookupTableDto implements IPagedResultDtoOfBillContactLookupTableDto {
    totalCount!: number;
    items!: BillContactLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfBillContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(BillContactLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfBillContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfBillContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfBillContactLookupTableDto {
    totalCount: number;
    items: BillContactLookupTableDto[] | undefined;
}

export class BillCurrencyLookupTableDto implements IBillCurrencyLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IBillCurrencyLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): BillCurrencyLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillCurrencyLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IBillCurrencyLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class BillDeceasedLookupTableDto implements IBillDeceasedLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    survivorName!: string | undefined;
    survivorMobileNum!: string | undefined;
    deceasedName!: string | undefined;
    isToday!: boolean;
    gender!: Gender;

    constructor(data?: IBillDeceasedLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.survivorName = data["survivorName"];
            this.survivorMobileNum = data["survivorMobileNum"];
            this.deceasedName = data["deceasedName"];
            this.isToday = data["isToday"];
            this.gender = data["gender"];
        }
    }

    static fromJS(data: any): BillDeceasedLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillDeceasedLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["survivorName"] = this.survivorName;
        data["survivorMobileNum"] = this.survivorMobileNum;
        data["deceasedName"] = this.deceasedName;
        data["isToday"] = this.isToday;
        data["gender"] = this.gender;
        return data; 
    }
}

export interface IBillDeceasedLookupTableDto {
    id: number;
    displayName: string | undefined;
    survivorName: string | undefined;
    survivorMobileNum: string | undefined;
    deceasedName: string | undefined;
    isToday: boolean;
    gender: Gender;
}

export class PagedResultDtoOfBillDeceasedLookupTableDto implements IPagedResultDtoOfBillDeceasedLookupTableDto {
    totalCount!: number;
    items!: BillDeceasedLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfBillDeceasedLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(BillDeceasedLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfBillDeceasedLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfBillDeceasedLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfBillDeceasedLookupTableDto {
    totalCount: number;
    items: BillDeceasedLookupTableDto[] | undefined;
}

export class BillBranchLookupTableDto implements IBillBranchLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IBillBranchLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): BillBranchLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillBranchLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IBillBranchLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class BillCeremonyLookupTableDto implements IBillCeremonyLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    survivorName!: string | undefined;
    survivorMobileNum!: string | undefined;
    deceasedName!: string | undefined;
    location!: string | undefined;
    startTime!: moment.Moment | undefined;
    pased!: boolean;
    absoluteValue!: number | undefined;
    creatorUserName!: string | undefined;
    isToday!: boolean;
    gender!: Gender;

    constructor(data?: IBillCeremonyLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.survivorName = data["survivorName"];
            this.survivorMobileNum = data["survivorMobileNum"];
            this.deceasedName = data["deceasedName"];
            this.location = data["location"];
            this.startTime = data["startTime"] ? moment(data["startTime"].toString()) : <any>undefined;
            this.pased = data["pased"];
            this.absoluteValue = data["absoluteValue"];
            this.creatorUserName = data["creatorUserName"];
            this.isToday = data["isToday"];
            this.gender = data["gender"];
        }
    }

    static fromJS(data: any): BillCeremonyLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillCeremonyLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["survivorName"] = this.survivorName;
        data["survivorMobileNum"] = this.survivorMobileNum;
        data["deceasedName"] = this.deceasedName;
        data["location"] = this.location;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["pased"] = this.pased;
        data["absoluteValue"] = this.absoluteValue;
        data["creatorUserName"] = this.creatorUserName;
        data["isToday"] = this.isToday;
        data["gender"] = this.gender;
        return data; 
    }
}

export interface IBillCeremonyLookupTableDto {
    id: number;
    displayName: string | undefined;
    survivorName: string | undefined;
    survivorMobileNum: string | undefined;
    deceasedName: string | undefined;
    location: string | undefined;
    startTime: moment.Moment | undefined;
    pased: boolean;
    absoluteValue: number | undefined;
    creatorUserName: string | undefined;
    isToday: boolean;
    gender: Gender;
}

export class PagedResultDtoOfBillCeremonyLookupTableDto implements IPagedResultDtoOfBillCeremonyLookupTableDto {
    totalCount!: number;
    items!: BillCeremonyLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfBillCeremonyLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(BillCeremonyLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfBillCeremonyLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfBillCeremonyLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfBillCeremonyLookupTableDto {
    totalCount: number;
    items: BillCeremonyLookupTableDto[] | undefined;
}

export class BillPlanConstLookupTableDto implements IBillPlanConstLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    baseTime!: BaseTimeInfo[] | undefined;
    isContinuous!: boolean;
    isPublic!: boolean;
    sourceId!: number | undefined;
    price!: number | undefined;
    type!: TypesOfSolace;
    order!: number | undefined;

    constructor(data?: IBillPlanConstLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            if (Array.isArray(data["baseTime"])) {
                this.baseTime = [] as any;
                for (let item of data["baseTime"])
                    this.baseTime!.push(BaseTimeInfo.fromJS(item));
            }
            this.isContinuous = data["isContinuous"];
            this.isPublic = data["isPublic"];
            this.sourceId = data["sourceId"];
            this.price = data["price"];
            this.type = data["type"];
            this.order = data["order"];
        }
    }

    static fromJS(data: any): BillPlanConstLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillPlanConstLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        if (Array.isArray(this.baseTime)) {
            data["baseTime"] = [];
            for (let item of this.baseTime)
                data["baseTime"].push(item.toJSON());
        }
        data["isContinuous"] = this.isContinuous;
        data["isPublic"] = this.isPublic;
        data["sourceId"] = this.sourceId;
        data["price"] = this.price;
        data["type"] = this.type;
        data["order"] = this.order;
        return data; 
    }
}

export interface IBillPlanConstLookupTableDto {
    id: number;
    displayName: string | undefined;
    baseTime: BaseTimeInfo[] | undefined;
    isContinuous: boolean;
    isPublic: boolean;
    sourceId: number | undefined;
    price: number | undefined;
    type: TypesOfSolace;
    order: number | undefined;
}

export class PagedResultDtoOfBillPlanConstLookupTableDto implements IPagedResultDtoOfBillPlanConstLookupTableDto {
    totalCount!: number;
    items!: BillPlanConstLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfBillPlanConstLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(BillPlanConstLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfBillPlanConstLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfBillPlanConstLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfBillPlanConstLookupTableDto {
    totalCount: number;
    items: BillPlanConstLookupTableDto[] | undefined;
}

export class PlanConstDto implements IPlanConstDto {
    title!: string | undefined;
    code!: string | undefined;
    isShow!: boolean;
    state!: boolean;
    description!: string | undefined;
    planLink!: string | undefined;
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    planType!: Plans;
    deliveryType!: DeliveryTypes;
    hasPostmanPayment!: boolean;
    tags!: string | undefined;
    showInNewest!: boolean;
    showInPopular!: boolean;
    default!: boolean;
    planCategoryId!: number | undefined;
    order!: number | undefined;
    consumesRef!: string | undefined;
    sourceId!: number | undefined;
    cardTemplateRef!: number | undefined;
    id!: number;

    constructor(data?: IPlanConstDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.code = data["code"];
            this.isShow = data["isShow"];
            this.state = data["state"];
            this.description = data["description"];
            this.planLink = data["planLink"];
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.planType = data["planType"];
            this.deliveryType = data["deliveryType"];
            this.hasPostmanPayment = data["hasPostmanPayment"];
            this.tags = data["tags"];
            this.showInNewest = data["showInNewest"];
            this.showInPopular = data["showInPopular"];
            this.default = data["default"];
            this.planCategoryId = data["planCategoryId"];
            this.order = data["order"];
            this.consumesRef = data["consumesRef"];
            this.sourceId = data["sourceId"];
            this.cardTemplateRef = data["cardTemplateRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PlanConstDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlanConstDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["code"] = this.code;
        data["isShow"] = this.isShow;
        data["state"] = this.state;
        data["description"] = this.description;
        data["planLink"] = this.planLink;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["planType"] = this.planType;
        data["deliveryType"] = this.deliveryType;
        data["hasPostmanPayment"] = this.hasPostmanPayment;
        data["tags"] = this.tags;
        data["showInNewest"] = this.showInNewest;
        data["showInPopular"] = this.showInPopular;
        data["default"] = this.default;
        data["planCategoryId"] = this.planCategoryId;
        data["order"] = this.order;
        data["consumesRef"] = this.consumesRef;
        data["sourceId"] = this.sourceId;
        data["cardTemplateRef"] = this.cardTemplateRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPlanConstDto {
    title: string | undefined;
    code: string | undefined;
    isShow: boolean;
    state: boolean;
    description: string | undefined;
    planLink: string | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    planType: Plans;
    deliveryType: DeliveryTypes;
    hasPostmanPayment: boolean;
    tags: string | undefined;
    showInNewest: boolean;
    showInPopular: boolean;
    default: boolean;
    planCategoryId: number | undefined;
    order: number | undefined;
    consumesRef: string | undefined;
    sourceId: number | undefined;
    cardTemplateRef: number | undefined;
    id: number;
}

export enum CharityTypes {
    Default = 0,
    ForDeceased = 1,
    Charity = 2,
}

export class CharityPlanDto implements ICharityPlanDto {
    targetNumber!: number | undefined;
    targetAmount!: number | undefined;
    isCash!: boolean;
    isContinuous!: boolean;
    hasOnlinePayment!: boolean;
    hasAttendancePayment!: boolean;
    isPublic!: boolean;
    state!: boolean;
    type!: CharityTypes;
    selectClient!: SelectClient;
    planConstId!: number;
    benefactorGroupSubgroupRef!: number | undefined;
    baseTimesRef!: string | undefined;
    contactRef!: number | undefined;
    id!: number;

    constructor(data?: ICharityPlanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetNumber = data["targetNumber"];
            this.targetAmount = data["targetAmount"];
            this.isCash = data["isCash"];
            this.isContinuous = data["isContinuous"];
            this.hasOnlinePayment = data["hasOnlinePayment"];
            this.hasAttendancePayment = data["hasAttendancePayment"];
            this.isPublic = data["isPublic"];
            this.state = data["state"];
            this.type = data["type"];
            this.selectClient = data["selectClient"];
            this.planConstId = data["planConstId"];
            this.benefactorGroupSubgroupRef = data["benefactorGroupSubgroupRef"];
            this.baseTimesRef = data["baseTimesRef"];
            this.contactRef = data["contactRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CharityPlanDto {
        data = typeof data === 'object' ? data : {};
        let result = new CharityPlanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetNumber"] = this.targetNumber;
        data["targetAmount"] = this.targetAmount;
        data["isCash"] = this.isCash;
        data["isContinuous"] = this.isContinuous;
        data["hasOnlinePayment"] = this.hasOnlinePayment;
        data["hasAttendancePayment"] = this.hasAttendancePayment;
        data["isPublic"] = this.isPublic;
        data["state"] = this.state;
        data["type"] = this.type;
        data["selectClient"] = this.selectClient;
        data["planConstId"] = this.planConstId;
        data["benefactorGroupSubgroupRef"] = this.benefactorGroupSubgroupRef;
        data["baseTimesRef"] = this.baseTimesRef;
        data["contactRef"] = this.contactRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICharityPlanDto {
    targetNumber: number | undefined;
    targetAmount: number | undefined;
    isCash: boolean;
    isContinuous: boolean;
    hasOnlinePayment: boolean;
    hasAttendancePayment: boolean;
    isPublic: boolean;
    state: boolean;
    type: CharityTypes;
    selectClient: SelectClient;
    planConstId: number;
    benefactorGroupSubgroupRef: number | undefined;
    baseTimesRef: string | undefined;
    contactRef: number | undefined;
    id: number;
}

export class FlowerCrownDto implements IFlowerCrownDto {
    width!: number | undefined;
    length!: number | undefined;
    thickness!: number | undefined;
    weight!: number | undefined;
    color!: string | undefined;
    isReversible!: boolean;
    planConstId!: number;
    type!: TypesOfSolace;
    secondPrice!: number | undefined;
    thirdPrice!: number | undefined;
    id!: number;

    constructor(data?: IFlowerCrownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.width = data["width"];
            this.length = data["length"];
            this.thickness = data["thickness"];
            this.weight = data["weight"];
            this.color = data["color"];
            this.isReversible = data["isReversible"];
            this.planConstId = data["planConstId"];
            this.type = data["type"];
            this.secondPrice = data["secondPrice"];
            this.thirdPrice = data["thirdPrice"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): FlowerCrownDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlowerCrownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["width"] = this.width;
        data["length"] = this.length;
        data["thickness"] = this.thickness;
        data["weight"] = this.weight;
        data["color"] = this.color;
        data["isReversible"] = this.isReversible;
        data["planConstId"] = this.planConstId;
        data["type"] = this.type;
        data["secondPrice"] = this.secondPrice;
        data["thirdPrice"] = this.thirdPrice;
        data["id"] = this.id;
        return data; 
    }
}

export interface IFlowerCrownDto {
    width: number | undefined;
    length: number | undefined;
    thickness: number | undefined;
    weight: number | undefined;
    color: string | undefined;
    isReversible: boolean;
    planConstId: number;
    type: TypesOfSolace;
    secondPrice: number | undefined;
    thirdPrice: number | undefined;
    id: number;
}

export class SacrificeDto implements ISacrificeDto {
    isParticipatory!: boolean;
    maxOrder!: number | undefined;
    targetAmount!: number | undefined;
    ancillaryCostsAmount!: number | undefined;
    isContinuous!: boolean;
    baseTimesRef!: string | undefined;
    planConstId!: number;
    sacrificeTypeRef!: number;
    maximumAnnouncementDate!: number | undefined;
    type!: CharityTypes;
    id!: number;

    constructor(data?: ISacrificeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isParticipatory = data["isParticipatory"];
            this.maxOrder = data["maxOrder"];
            this.targetAmount = data["targetAmount"];
            this.ancillaryCostsAmount = data["ancillaryCostsAmount"];
            this.isContinuous = data["isContinuous"];
            this.baseTimesRef = data["baseTimesRef"];
            this.planConstId = data["planConstId"];
            this.sacrificeTypeRef = data["sacrificeTypeRef"];
            this.maximumAnnouncementDate = data["maximumAnnouncementDate"];
            this.type = data["type"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SacrificeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SacrificeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isParticipatory"] = this.isParticipatory;
        data["maxOrder"] = this.maxOrder;
        data["targetAmount"] = this.targetAmount;
        data["ancillaryCostsAmount"] = this.ancillaryCostsAmount;
        data["isContinuous"] = this.isContinuous;
        data["baseTimesRef"] = this.baseTimesRef;
        data["planConstId"] = this.planConstId;
        data["sacrificeTypeRef"] = this.sacrificeTypeRef;
        data["maximumAnnouncementDate"] = this.maximumAnnouncementDate;
        data["type"] = this.type;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISacrificeDto {
    isParticipatory: boolean;
    maxOrder: number | undefined;
    targetAmount: number | undefined;
    ancillaryCostsAmount: number | undefined;
    isContinuous: boolean;
    baseTimesRef: string | undefined;
    planConstId: number;
    sacrificeTypeRef: number;
    maximumAnnouncementDate: number | undefined;
    type: CharityTypes;
    id: number;
}

export enum MoneyBoxType {
    Default = 0,
    Permanent = 1,
    Disposable = 2,
    Virtual = 3,
}

export class MoneyBoxDto implements IMoneyBoxDto {
    type!: MoneyBoxType;
    title!: string | undefined;
    planConstId!: number;
    id!: number;

    constructor(data?: IMoneyBoxDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["type"];
            this.title = data["title"];
            this.planConstId = data["planConstId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MoneyBoxDto {
        data = typeof data === 'object' ? data : {};
        let result = new MoneyBoxDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["planConstId"] = this.planConstId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMoneyBoxDto {
    type: MoneyBoxType;
    title: string | undefined;
    planConstId: number;
    id: number;
}

export class ContactInfoDto implements IContactInfoDto {
    fullName!: string | undefined;
    address!: string | undefined;
    contactCode!: string | undefined;
    phone!: string | undefined;

    constructor(data?: IContactInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fullName = data["fullName"];
            this.address = data["address"];
            this.contactCode = data["contactCode"];
            this.phone = data["phone"];
        }
    }

    static fromJS(data: any): ContactInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["address"] = this.address;
        data["contactCode"] = this.contactCode;
        data["phone"] = this.phone;
        return data; 
    }
}

export interface IContactInfoDto {
    fullName: string | undefined;
    address: string | undefined;
    contactCode: string | undefined;
    phone: string | undefined;
}

export class GetPlanForBillViewOutput implements IGetPlanForBillViewOutput {
    extraEntity!: string | undefined;
    paymentDate!: moment.Moment | undefined;
    billDescreption1!: string | undefined;
    billDescreption2!: string | undefined;
    averageSlaughteredWeight!: number | undefined;
    planBillCode!: string | undefined;
    clientName!: string | undefined;
    planConst!: PlanConstDto;
    banner!: BannerDto;
    charity!: CharityPlanDto;
    flowerCrown!: FlowerCrownDto;
    sacrifice!: SacrificeDto;
    moneyBox!: MoneyBoxDto;
    conact!: ContactInfoDto;
    branchName!: string | undefined;
    sacrificeDifference!: string | undefined;
    mainSacrifice!: string | undefined;

    constructor(data?: IGetPlanForBillViewOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.extraEntity = data["extraEntity"];
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.billDescreption1 = data["billDescreption1"];
            this.billDescreption2 = data["billDescreption2"];
            this.averageSlaughteredWeight = data["averageSlaughteredWeight"];
            this.planBillCode = data["planBillCode"];
            this.clientName = data["clientName"];
            this.planConst = data["planConst"] ? PlanConstDto.fromJS(data["planConst"]) : <any>undefined;
            this.banner = data["banner"] ? BannerDto.fromJS(data["banner"]) : <any>undefined;
            this.charity = data["charity"] ? CharityPlanDto.fromJS(data["charity"]) : <any>undefined;
            this.flowerCrown = data["flowerCrown"] ? FlowerCrownDto.fromJS(data["flowerCrown"]) : <any>undefined;
            this.sacrifice = data["sacrifice"] ? SacrificeDto.fromJS(data["sacrifice"]) : <any>undefined;
            this.moneyBox = data["moneyBox"] ? MoneyBoxDto.fromJS(data["moneyBox"]) : <any>undefined;
            this.conact = data["conact"] ? ContactInfoDto.fromJS(data["conact"]) : <any>undefined;
            this.branchName = data["branchName"];
            this.sacrificeDifference = data["sacrificeDifference"];
            this.mainSacrifice = data["mainSacrifice"];
        }
    }

    static fromJS(data: any): GetPlanForBillViewOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlanForBillViewOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extraEntity"] = this.extraEntity;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["billDescreption1"] = this.billDescreption1;
        data["billDescreption2"] = this.billDescreption2;
        data["averageSlaughteredWeight"] = this.averageSlaughteredWeight;
        data["planBillCode"] = this.planBillCode;
        data["clientName"] = this.clientName;
        data["planConst"] = this.planConst ? this.planConst.toJSON() : <any>undefined;
        data["banner"] = this.banner ? this.banner.toJSON() : <any>undefined;
        data["charity"] = this.charity ? this.charity.toJSON() : <any>undefined;
        data["flowerCrown"] = this.flowerCrown ? this.flowerCrown.toJSON() : <any>undefined;
        data["sacrifice"] = this.sacrifice ? this.sacrifice.toJSON() : <any>undefined;
        data["moneyBox"] = this.moneyBox ? this.moneyBox.toJSON() : <any>undefined;
        data["conact"] = this.conact ? this.conact.toJSON() : <any>undefined;
        data["branchName"] = this.branchName;
        data["sacrificeDifference"] = this.sacrificeDifference;
        data["mainSacrifice"] = this.mainSacrifice;
        return data; 
    }
}

export interface IGetPlanForBillViewOutput {
    extraEntity: string | undefined;
    paymentDate: moment.Moment | undefined;
    billDescreption1: string | undefined;
    billDescreption2: string | undefined;
    averageSlaughteredWeight: number | undefined;
    planBillCode: string | undefined;
    clientName: string | undefined;
    planConst: PlanConstDto;
    banner: BannerDto;
    charity: CharityPlanDto;
    flowerCrown: FlowerCrownDto;
    sacrifice: SacrificeDto;
    moneyBox: MoneyBoxDto;
    conact: ContactInfoDto;
    branchName: string | undefined;
    sacrificeDifference: string | undefined;
    mainSacrifice: string | undefined;
}

export class BillStatusType implements IBillStatusType {
    id!: number;
    name!: string | undefined;
    isShow!: boolean;
    permission!: string | undefined;

    constructor(data?: IBillStatusType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.isShow = data["isShow"];
            this.permission = data["permission"];
        }
    }

    static fromJS(data: any): BillStatusType {
        data = typeof data === 'object' ? data : {};
        let result = new BillStatusType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isShow"] = this.isShow;
        data["permission"] = this.permission;
        return data; 
    }
}

export interface IBillStatusType {
    id: number;
    name: string | undefined;
    isShow: boolean;
    permission: string | undefined;
}

export class CreateOrEditPaymentDto implements ICreateOrEditPaymentDto {
    paymentType!: PaymentType;
    panCard!: string | undefined;
    paymentDateTime!: moment.Moment | undefined;
    bankTrackingNO!: string | undefined;
    bankSerialNO!: string | undefined;
    priceAmount!: number;
    paymentStatus!: PaymentStatus;
    bankHashCode!: string | undefined;
    description!: string | undefined;
    bankBranch!: string | undefined;
    dueDate!: moment.Moment | undefined;
    accountingTrackingNO!: string | undefined;
    bankAccountId!: number | undefined;
    addressId!: number | undefined;
    posRef!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paymentType = data["paymentType"];
            this.panCard = data["panCard"];
            this.paymentDateTime = data["paymentDateTime"] ? moment(data["paymentDateTime"].toString()) : <any>undefined;
            this.bankTrackingNO = data["bankTrackingNO"];
            this.bankSerialNO = data["bankSerialNO"];
            this.priceAmount = data["priceAmount"];
            this.paymentStatus = data["paymentStatus"];
            this.bankHashCode = data["bankHashCode"];
            this.description = data["description"];
            this.bankBranch = data["bankBranch"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.accountingTrackingNO = data["accountingTrackingNO"];
            this.bankAccountId = data["bankAccountId"];
            this.addressId = data["addressId"];
            this.posRef = data["posRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentType"] = this.paymentType;
        data["panCard"] = this.panCard;
        data["paymentDateTime"] = this.paymentDateTime ? this.paymentDateTime.toISOString() : <any>undefined;
        data["bankTrackingNO"] = this.bankTrackingNO;
        data["bankSerialNO"] = this.bankSerialNO;
        data["priceAmount"] = this.priceAmount;
        data["paymentStatus"] = this.paymentStatus;
        data["bankHashCode"] = this.bankHashCode;
        data["description"] = this.description;
        data["bankBranch"] = this.bankBranch;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["accountingTrackingNO"] = this.accountingTrackingNO;
        data["bankAccountId"] = this.bankAccountId;
        data["addressId"] = this.addressId;
        data["posRef"] = this.posRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditPaymentDto {
    paymentType: PaymentType;
    panCard: string | undefined;
    paymentDateTime: moment.Moment | undefined;
    bankTrackingNO: string | undefined;
    bankSerialNO: string | undefined;
    priceAmount: number;
    paymentStatus: PaymentStatus;
    bankHashCode: string | undefined;
    description: string | undefined;
    bankBranch: string | undefined;
    dueDate: moment.Moment | undefined;
    accountingTrackingNO: string | undefined;
    bankAccountId: number | undefined;
    addressId: number | undefined;
    posRef: number | undefined;
    id: number | undefined;
}

export class VirtualCreditPayment implements IVirtualCreditPayment {
    paymentDateTime!: moment.Moment;
    bankSerialNO!: string | undefined;
    priceAmount!: number;
    creatorUser!: string | undefined;

    constructor(data?: IVirtualCreditPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paymentDateTime = data["paymentDateTime"] ? moment(data["paymentDateTime"].toString()) : <any>undefined;
            this.bankSerialNO = data["bankSerialNO"];
            this.priceAmount = data["priceAmount"];
            this.creatorUser = data["creatorUser"];
        }
    }

    static fromJS(data: any): VirtualCreditPayment {
        data = typeof data === 'object' ? data : {};
        let result = new VirtualCreditPayment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentDateTime"] = this.paymentDateTime ? this.paymentDateTime.toISOString() : <any>undefined;
        data["bankSerialNO"] = this.bankSerialNO;
        data["priceAmount"] = this.priceAmount;
        data["creatorUser"] = this.creatorUser;
        return data; 
    }
}

export interface IVirtualCreditPayment {
    paymentDateTime: moment.Moment;
    bankSerialNO: string | undefined;
    priceAmount: number;
    creatorUser: string | undefined;
}

export class GetVirtualCreditsReportDto implements IGetVirtualCreditsReportDto {
    virtualCreditPayment!: VirtualCreditPayment;
    payments!: PaymentBillDto[] | undefined;
    bills!: GetBillForViewDto[] | undefined;

    constructor(data?: IGetVirtualCreditsReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.virtualCreditPayment = data["virtualCreditPayment"] ? VirtualCreditPayment.fromJS(data["virtualCreditPayment"]) : <any>undefined;
            if (Array.isArray(data["payments"])) {
                this.payments = [] as any;
                for (let item of data["payments"])
                    this.payments!.push(PaymentBillDto.fromJS(item));
            }
            if (Array.isArray(data["bills"])) {
                this.bills = [] as any;
                for (let item of data["bills"])
                    this.bills!.push(GetBillForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetVirtualCreditsReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetVirtualCreditsReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["virtualCreditPayment"] = this.virtualCreditPayment ? this.virtualCreditPayment.toJSON() : <any>undefined;
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        if (Array.isArray(this.bills)) {
            data["bills"] = [];
            for (let item of this.bills)
                data["bills"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetVirtualCreditsReportDto {
    virtualCreditPayment: VirtualCreditPayment;
    payments: PaymentBillDto[] | undefined;
    bills: GetBillForViewDto[] | undefined;
}

export class PagedResultDtoOfGetVirtualCreditsReportDto implements IPagedResultDtoOfGetVirtualCreditsReportDto {
    totalCount!: number;
    items!: GetVirtualCreditsReportDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetVirtualCreditsReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetVirtualCreditsReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetVirtualCreditsReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetVirtualCreditsReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetVirtualCreditsReportDto {
    totalCount: number;
    items: GetVirtualCreditsReportDto[] | undefined;
}

export class VirtualCreditContactOutputDto implements IVirtualCreditContactOutputDto {
    id!: number;
    displayName!: string | undefined;
    virtualCreditAmount!: string | undefined;
    remainingVirtualCredit!: string | undefined;
    usedVirtualCredit!: string | undefined;
    payments!: PaymentReportBankDetails[] | undefined;
    sumPayments!: string | undefined;
    virtualCreditPayments!: VirtualCreditPayment[] | undefined;
    sumVirtualCreditPayments!: string | undefined;

    constructor(data?: IVirtualCreditContactOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.virtualCreditAmount = data["virtualCreditAmount"];
            this.remainingVirtualCredit = data["remainingVirtualCredit"];
            this.usedVirtualCredit = data["usedVirtualCredit"];
            if (Array.isArray(data["payments"])) {
                this.payments = [] as any;
                for (let item of data["payments"])
                    this.payments!.push(PaymentReportBankDetails.fromJS(item));
            }
            this.sumPayments = data["sumPayments"];
            if (Array.isArray(data["virtualCreditPayments"])) {
                this.virtualCreditPayments = [] as any;
                for (let item of data["virtualCreditPayments"])
                    this.virtualCreditPayments!.push(VirtualCreditPayment.fromJS(item));
            }
            this.sumVirtualCreditPayments = data["sumVirtualCreditPayments"];
        }
    }

    static fromJS(data: any): VirtualCreditContactOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new VirtualCreditContactOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["virtualCreditAmount"] = this.virtualCreditAmount;
        data["remainingVirtualCredit"] = this.remainingVirtualCredit;
        data["usedVirtualCredit"] = this.usedVirtualCredit;
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        data["sumPayments"] = this.sumPayments;
        if (Array.isArray(this.virtualCreditPayments)) {
            data["virtualCreditPayments"] = [];
            for (let item of this.virtualCreditPayments)
                data["virtualCreditPayments"].push(item.toJSON());
        }
        data["sumVirtualCreditPayments"] = this.sumVirtualCreditPayments;
        return data; 
    }
}

export interface IVirtualCreditContactOutputDto {
    id: number;
    displayName: string | undefined;
    virtualCreditAmount: string | undefined;
    remainingVirtualCredit: string | undefined;
    usedVirtualCredit: string | undefined;
    payments: PaymentReportBankDetails[] | undefined;
    sumPayments: string | undefined;
    virtualCreditPayments: VirtualCreditPayment[] | undefined;
    sumVirtualCreditPayments: string | undefined;
}

export class PagedResultDtoOfVirtualCreditContactOutputDto implements IPagedResultDtoOfVirtualCreditContactOutputDto {
    totalCount!: number;
    items!: VirtualCreditContactOutputDto[] | undefined;

    constructor(data?: IPagedResultDtoOfVirtualCreditContactOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(VirtualCreditContactOutputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfVirtualCreditContactOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfVirtualCreditContactOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfVirtualCreditContactOutputDto {
    totalCount: number;
    items: VirtualCreditContactOutputDto[] | undefined;
}

export class GetBillForEditFromReportOutput implements IGetBillForEditFromReportOutput {
    bill!: CreateOrEditBillDto;
    contactFirstName!: string | undefined;
    planConstTitle!: string | undefined;
    billCardTemplateProperties!: GetPropertiesForBillDto[] | undefined;
    billCardTemplateTitle!: string | undefined;

    constructor(data?: IGetBillForEditFromReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bill = data["bill"] ? CreateOrEditBillDto.fromJS(data["bill"]) : <any>undefined;
            this.contactFirstName = data["contactFirstName"];
            this.planConstTitle = data["planConstTitle"];
            if (Array.isArray(data["billCardTemplateProperties"])) {
                this.billCardTemplateProperties = [] as any;
                for (let item of data["billCardTemplateProperties"])
                    this.billCardTemplateProperties!.push(GetPropertiesForBillDto.fromJS(item));
            }
            this.billCardTemplateTitle = data["billCardTemplateTitle"];
        }
    }

    static fromJS(data: any): GetBillForEditFromReportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetBillForEditFromReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bill"] = this.bill ? this.bill.toJSON() : <any>undefined;
        data["contactFirstName"] = this.contactFirstName;
        data["planConstTitle"] = this.planConstTitle;
        if (Array.isArray(this.billCardTemplateProperties)) {
            data["billCardTemplateProperties"] = [];
            for (let item of this.billCardTemplateProperties)
                data["billCardTemplateProperties"].push(item.toJSON());
        }
        data["billCardTemplateTitle"] = this.billCardTemplateTitle;
        return data; 
    }
}

export interface IGetBillForEditFromReportOutput {
    bill: CreateOrEditBillDto;
    contactFirstName: string | undefined;
    planConstTitle: string | undefined;
    billCardTemplateProperties: GetPropertiesForBillDto[] | undefined;
    billCardTemplateTitle: string | undefined;
}

export class CreateOrEditBillFromReportDto implements ICreateOrEditBillFromReportDto {
    bill!: CreateOrEditBillDto;
    billCardTemplateProperties!: GetPropertiesForBillDto[] | undefined;

    constructor(data?: ICreateOrEditBillFromReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bill = data["bill"] ? CreateOrEditBillDto.fromJS(data["bill"]) : <any>undefined;
            if (Array.isArray(data["billCardTemplateProperties"])) {
                this.billCardTemplateProperties = [] as any;
                for (let item of data["billCardTemplateProperties"])
                    this.billCardTemplateProperties!.push(GetPropertiesForBillDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrEditBillFromReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditBillFromReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bill"] = this.bill ? this.bill.toJSON() : <any>undefined;
        if (Array.isArray(this.billCardTemplateProperties)) {
            data["billCardTemplateProperties"] = [];
            for (let item of this.billCardTemplateProperties)
                data["billCardTemplateProperties"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateOrEditBillFromReportDto {
    bill: CreateOrEditBillDto;
    billCardTemplateProperties: GetPropertiesForBillDto[] | undefined;
}

export class CreateOrEditCharityBillForKioskInput implements ICreateOrEditCharityBillForKioskInput {
    firstName!: string | undefined;
    lastName!: string | undefined;
    mobile!: string | undefined;
    planConstId!: number;
    price!: number;
    description!: string | undefined;

    constructor(data?: ICreateOrEditCharityBillForKioskInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.firstName = data["firstName"];
            this.lastName = data["lastName"];
            this.mobile = data["mobile"];
            this.planConstId = data["planConstId"];
            this.price = data["price"];
            this.description = data["description"];
        }
    }

    static fromJS(data: any): CreateOrEditCharityBillForKioskInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCharityBillForKioskInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["mobile"] = this.mobile;
        data["planConstId"] = this.planConstId;
        data["price"] = this.price;
        data["description"] = this.description;
        return data; 
    }
}

export interface ICreateOrEditCharityBillForKioskInput {
    firstName: string | undefined;
    lastName: string | undefined;
    mobile: string | undefined;
    planConstId: number;
    price: number;
    description: string | undefined;
}

export class BillSlaughteredDto implements IBillSlaughteredDto {
    averageWeight!: number | undefined;
    count!: number | undefined;
    averagePrice!: number | undefined;
    averageRatio!: number | undefined;
    code!: string | undefined;
    slaughterAgentRef!: number | undefined;
    id!: number;

    constructor(data?: IBillSlaughteredDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.averageWeight = data["averageWeight"];
            this.count = data["count"];
            this.averagePrice = data["averagePrice"];
            this.averageRatio = data["averageRatio"];
            this.code = data["code"];
            this.slaughterAgentRef = data["slaughterAgentRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): BillSlaughteredDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillSlaughteredDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["averageWeight"] = this.averageWeight;
        data["count"] = this.count;
        data["averagePrice"] = this.averagePrice;
        data["averageRatio"] = this.averageRatio;
        data["code"] = this.code;
        data["slaughterAgentRef"] = this.slaughterAgentRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface IBillSlaughteredDto {
    averageWeight: number | undefined;
    count: number | undefined;
    averagePrice: number | undefined;
    averageRatio: number | undefined;
    code: string | undefined;
    slaughterAgentRef: number | undefined;
    id: number;
}

export class GetBillSlaughteredForViewDto implements IGetBillSlaughteredForViewDto {
    billSlaughtered!: BillSlaughteredDto;
    slaughterAgentSlaughterhouseName!: string | undefined;

    constructor(data?: IGetBillSlaughteredForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.billSlaughtered = data["billSlaughtered"] ? BillSlaughteredDto.fromJS(data["billSlaughtered"]) : <any>undefined;
            this.slaughterAgentSlaughterhouseName = data["slaughterAgentSlaughterhouseName"];
        }
    }

    static fromJS(data: any): GetBillSlaughteredForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBillSlaughteredForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billSlaughtered"] = this.billSlaughtered ? this.billSlaughtered.toJSON() : <any>undefined;
        data["slaughterAgentSlaughterhouseName"] = this.slaughterAgentSlaughterhouseName;
        return data; 
    }
}

export interface IGetBillSlaughteredForViewDto {
    billSlaughtered: BillSlaughteredDto;
    slaughterAgentSlaughterhouseName: string | undefined;
}

export class PagedResultDtoOfGetBillSlaughteredForViewDto implements IPagedResultDtoOfGetBillSlaughteredForViewDto {
    totalCount!: number;
    items!: GetBillSlaughteredForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetBillSlaughteredForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetBillSlaughteredForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetBillSlaughteredForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetBillSlaughteredForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetBillSlaughteredForViewDto {
    totalCount: number;
    items: GetBillSlaughteredForViewDto[] | undefined;
}

export class CreateOrEditBillSlaughteredDto implements ICreateOrEditBillSlaughteredDto {
    averageWeight!: number | undefined;
    count!: number | undefined;
    averagePrice!: number | undefined;
    averageRatio!: number | undefined;
    code!: string | undefined;
    slaughterAgentRef!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditBillSlaughteredDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.averageWeight = data["averageWeight"];
            this.count = data["count"];
            this.averagePrice = data["averagePrice"];
            this.averageRatio = data["averageRatio"];
            this.code = data["code"];
            this.slaughterAgentRef = data["slaughterAgentRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditBillSlaughteredDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditBillSlaughteredDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["averageWeight"] = this.averageWeight;
        data["count"] = this.count;
        data["averagePrice"] = this.averagePrice;
        data["averageRatio"] = this.averageRatio;
        data["code"] = this.code;
        data["slaughterAgentRef"] = this.slaughterAgentRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditBillSlaughteredDto {
    averageWeight: number | undefined;
    count: number | undefined;
    averagePrice: number | undefined;
    averageRatio: number | undefined;
    code: string | undefined;
    slaughterAgentRef: number | undefined;
    id: number | undefined;
}

export class GetBillSlaughteredForEditOutput implements IGetBillSlaughteredForEditOutput {
    billSlaughtered!: CreateOrEditBillSlaughteredDto;
    slaughterAgentSlaughterhouseName!: string | undefined;

    constructor(data?: IGetBillSlaughteredForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.billSlaughtered = data["billSlaughtered"] ? CreateOrEditBillSlaughteredDto.fromJS(data["billSlaughtered"]) : <any>undefined;
            this.slaughterAgentSlaughterhouseName = data["slaughterAgentSlaughterhouseName"];
        }
    }

    static fromJS(data: any): GetBillSlaughteredForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetBillSlaughteredForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billSlaughtered"] = this.billSlaughtered ? this.billSlaughtered.toJSON() : <any>undefined;
        data["slaughterAgentSlaughterhouseName"] = this.slaughterAgentSlaughterhouseName;
        return data; 
    }
}

export interface IGetBillSlaughteredForEditOutput {
    billSlaughtered: CreateOrEditBillSlaughteredDto;
    slaughterAgentSlaughterhouseName: string | undefined;
}

export class BillSlaughteredSlaughterAgentLookupTableDto implements IBillSlaughteredSlaughterAgentLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IBillSlaughteredSlaughterAgentLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): BillSlaughteredSlaughterAgentLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillSlaughteredSlaughterAgentLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IBillSlaughteredSlaughterAgentLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfBillSlaughteredSlaughterAgentLookupTableDto implements IPagedResultDtoOfBillSlaughteredSlaughterAgentLookupTableDto {
    totalCount!: number;
    items!: BillSlaughteredSlaughterAgentLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfBillSlaughteredSlaughterAgentLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(BillSlaughteredSlaughterAgentLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfBillSlaughteredSlaughterAgentLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfBillSlaughteredSlaughterAgentLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfBillSlaughteredSlaughterAgentLookupTableDto {
    totalCount: number;
    items: BillSlaughteredSlaughterAgentLookupTableDto[] | undefined;
}

export class BillTokenDto implements IBillTokenDto {
    token!: string | undefined;
    billRef!: number;
    id!: number;

    constructor(data?: IBillTokenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.token = data["token"];
            this.billRef = data["billRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): BillTokenDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillTokenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["billRef"] = this.billRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface IBillTokenDto {
    token: string | undefined;
    billRef: number;
    id: number;
}

export class GetBillTokenForViewDto implements IGetBillTokenForViewDto {
    billToken!: BillTokenDto;
    billCode!: string | undefined;

    constructor(data?: IGetBillTokenForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.billToken = data["billToken"] ? BillTokenDto.fromJS(data["billToken"]) : <any>undefined;
            this.billCode = data["billCode"];
        }
    }

    static fromJS(data: any): GetBillTokenForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBillTokenForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billToken"] = this.billToken ? this.billToken.toJSON() : <any>undefined;
        data["billCode"] = this.billCode;
        return data; 
    }
}

export interface IGetBillTokenForViewDto {
    billToken: BillTokenDto;
    billCode: string | undefined;
}

export class PagedResultDtoOfGetBillTokenForViewDto implements IPagedResultDtoOfGetBillTokenForViewDto {
    totalCount!: number;
    items!: GetBillTokenForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetBillTokenForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetBillTokenForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetBillTokenForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetBillTokenForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetBillTokenForViewDto {
    totalCount: number;
    items: GetBillTokenForViewDto[] | undefined;
}

export class CreateOrEditBillTokenDto implements ICreateOrEditBillTokenDto {
    token!: string | undefined;
    billRef!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditBillTokenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.token = data["token"];
            this.billRef = data["billRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditBillTokenDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditBillTokenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["billRef"] = this.billRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditBillTokenDto {
    token: string | undefined;
    billRef: number;
    id: number | undefined;
}

export class GetBillTokenForEditOutput implements IGetBillTokenForEditOutput {
    billToken!: CreateOrEditBillTokenDto;
    billCode!: string | undefined;

    constructor(data?: IGetBillTokenForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.billToken = data["billToken"] ? CreateOrEditBillTokenDto.fromJS(data["billToken"]) : <any>undefined;
            this.billCode = data["billCode"];
        }
    }

    static fromJS(data: any): GetBillTokenForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetBillTokenForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billToken"] = this.billToken ? this.billToken.toJSON() : <any>undefined;
        data["billCode"] = this.billCode;
        return data; 
    }
}

export interface IGetBillTokenForEditOutput {
    billToken: CreateOrEditBillTokenDto;
    billCode: string | undefined;
}

export class BillTokenBillLookupTableDto implements IBillTokenBillLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IBillTokenBillLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): BillTokenBillLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillTokenBillLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IBillTokenBillLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfBillTokenBillLookupTableDto implements IPagedResultDtoOfBillTokenBillLookupTableDto {
    totalCount!: number;
    items!: BillTokenBillLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfBillTokenBillLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(BillTokenBillLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfBillTokenBillLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfBillTokenBillLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfBillTokenBillLookupTableDto {
    totalCount: number;
    items: BillTokenBillLookupTableDto[] | undefined;
}

export class BillDetailsByTokenDto implements IBillDetailsByTokenDto {
    id!: number;
    code!: string | undefined;
    price!: number;
    count!: number;
    description!: string | undefined;
    currencyId!: number | undefined;
    issueDate!: moment.Moment | undefined;
    planConstTitle!: string | undefined;
    planType!: Plans;
    benefactorName!: string | undefined;

    constructor(data?: IBillDetailsByTokenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.code = data["code"];
            this.price = data["price"];
            this.count = data["count"];
            this.description = data["description"];
            this.currencyId = data["currencyId"];
            this.issueDate = data["issueDate"] ? moment(data["issueDate"].toString()) : <any>undefined;
            this.planConstTitle = data["planConstTitle"];
            this.planType = data["planType"];
            this.benefactorName = data["benefactorName"];
        }
    }

    static fromJS(data: any): BillDetailsByTokenDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillDetailsByTokenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["price"] = this.price;
        data["count"] = this.count;
        data["description"] = this.description;
        data["currencyId"] = this.currencyId;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["planConstTitle"] = this.planConstTitle;
        data["planType"] = this.planType;
        data["benefactorName"] = this.benefactorName;
        return data; 
    }
}

export interface IBillDetailsByTokenDto {
    id: number;
    code: string | undefined;
    price: number;
    count: number;
    description: string | undefined;
    currencyId: number | undefined;
    issueDate: moment.Moment | undefined;
    planConstTitle: string | undefined;
    planType: Plans;
    benefactorName: string | undefined;
}

export class GetBillsByTokenOutputDto implements IGetBillsByTokenOutputDto {
    bills!: BillDetailsByTokenDto[] | undefined;
    totalPrice!: number;
    paidPrice!: number;

    constructor(data?: IGetBillsByTokenOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["bills"])) {
                this.bills = [] as any;
                for (let item of data["bills"])
                    this.bills!.push(BillDetailsByTokenDto.fromJS(item));
            }
            this.totalPrice = data["totalPrice"];
            this.paidPrice = data["paidPrice"];
        }
    }

    static fromJS(data: any): GetBillsByTokenOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBillsByTokenOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bills)) {
            data["bills"] = [];
            for (let item of this.bills)
                data["bills"].push(item.toJSON());
        }
        data["totalPrice"] = this.totalPrice;
        data["paidPrice"] = this.paidPrice;
        return data; 
    }
}

export interface IGetBillsByTokenOutputDto {
    bills: BillDetailsByTokenDto[] | undefined;
    totalPrice: number;
    paidPrice: number;
}

export class BranchCommodityDto implements IBranchCommodityDto {
    inventory!: number | undefined;
    branchRef!: number;
    commodityRef!: number;
    id!: number;

    constructor(data?: IBranchCommodityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.inventory = data["inventory"];
            this.branchRef = data["branchRef"];
            this.commodityRef = data["commodityRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): BranchCommodityDto {
        data = typeof data === 'object' ? data : {};
        let result = new BranchCommodityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inventory"] = this.inventory;
        data["branchRef"] = this.branchRef;
        data["commodityRef"] = this.commodityRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface IBranchCommodityDto {
    inventory: number | undefined;
    branchRef: number;
    commodityRef: number;
    id: number;
}

export class GetBranchCommodityForViewDto implements IGetBranchCommodityForViewDto {
    branchCommodity!: BranchCommodityDto;
    branchName!: string | undefined;
    commodityTitle!: string | undefined;

    constructor(data?: IGetBranchCommodityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.branchCommodity = data["branchCommodity"] ? BranchCommodityDto.fromJS(data["branchCommodity"]) : <any>undefined;
            this.branchName = data["branchName"];
            this.commodityTitle = data["commodityTitle"];
        }
    }

    static fromJS(data: any): GetBranchCommodityForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBranchCommodityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchCommodity"] = this.branchCommodity ? this.branchCommodity.toJSON() : <any>undefined;
        data["branchName"] = this.branchName;
        data["commodityTitle"] = this.commodityTitle;
        return data; 
    }
}

export interface IGetBranchCommodityForViewDto {
    branchCommodity: BranchCommodityDto;
    branchName: string | undefined;
    commodityTitle: string | undefined;
}

export class PagedResultDtoOfGetBranchCommodityForViewDto implements IPagedResultDtoOfGetBranchCommodityForViewDto {
    totalCount!: number;
    items!: GetBranchCommodityForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetBranchCommodityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetBranchCommodityForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetBranchCommodityForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetBranchCommodityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetBranchCommodityForViewDto {
    totalCount: number;
    items: GetBranchCommodityForViewDto[] | undefined;
}

export class CreateOrEditBranchCommodityDto implements ICreateOrEditBranchCommodityDto {
    inventory!: number | undefined;
    branchRef!: number;
    commodityRef!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditBranchCommodityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.inventory = data["inventory"];
            this.branchRef = data["branchRef"];
            this.commodityRef = data["commodityRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditBranchCommodityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditBranchCommodityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inventory"] = this.inventory;
        data["branchRef"] = this.branchRef;
        data["commodityRef"] = this.commodityRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditBranchCommodityDto {
    inventory: number | undefined;
    branchRef: number;
    commodityRef: number;
    id: number | undefined;
}

export class GetBranchCommodityForEditOutput implements IGetBranchCommodityForEditOutput {
    branchCommodity!: CreateOrEditBranchCommodityDto;
    branchName!: string | undefined;
    commodityTitle!: string | undefined;

    constructor(data?: IGetBranchCommodityForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.branchCommodity = data["branchCommodity"] ? CreateOrEditBranchCommodityDto.fromJS(data["branchCommodity"]) : <any>undefined;
            this.branchName = data["branchName"];
            this.commodityTitle = data["commodityTitle"];
        }
    }

    static fromJS(data: any): GetBranchCommodityForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetBranchCommodityForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchCommodity"] = this.branchCommodity ? this.branchCommodity.toJSON() : <any>undefined;
        data["branchName"] = this.branchName;
        data["commodityTitle"] = this.commodityTitle;
        return data; 
    }
}

export interface IGetBranchCommodityForEditOutput {
    branchCommodity: CreateOrEditBranchCommodityDto;
    branchName: string | undefined;
    commodityTitle: string | undefined;
}

export class BranchCommodityBranchLookupTableDto implements IBranchCommodityBranchLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IBranchCommodityBranchLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): BranchCommodityBranchLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new BranchCommodityBranchLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IBranchCommodityBranchLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class BranchCommodityCommodityLookupTableDto implements IBranchCommodityCommodityLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IBranchCommodityCommodityLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): BranchCommodityCommodityLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new BranchCommodityCommodityLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IBranchCommodityCommodityLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfBranchCommodityCommodityLookupTableDto implements IPagedResultDtoOfBranchCommodityCommodityLookupTableDto {
    totalCount!: number;
    items!: BranchCommodityCommodityLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfBranchCommodityCommodityLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(BranchCommodityCommodityLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfBranchCommodityCommodityLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfBranchCommodityCommodityLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfBranchCommodityCommodityLookupTableDto {
    totalCount: number;
    items: BranchCommodityCommodityLookupTableDto[] | undefined;
}

export class BranchDirectionDto implements IBranchDirectionDto {
    servise!: Plans;
    branchRef!: number | undefined;
    directionRef!: number | undefined;
    id!: number;

    constructor(data?: IBranchDirectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.servise = data["servise"];
            this.branchRef = data["branchRef"];
            this.directionRef = data["directionRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): BranchDirectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new BranchDirectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servise"] = this.servise;
        data["branchRef"] = this.branchRef;
        data["directionRef"] = this.directionRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface IBranchDirectionDto {
    servise: Plans;
    branchRef: number | undefined;
    directionRef: number | undefined;
    id: number;
}

export class GetBranchDirectionForViewDto implements IGetBranchDirectionForViewDto {
    branchDirection!: BranchDirectionDto;
    branchName!: string | undefined;
    directionName!: string | undefined;

    constructor(data?: IGetBranchDirectionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.branchDirection = data["branchDirection"] ? BranchDirectionDto.fromJS(data["branchDirection"]) : <any>undefined;
            this.branchName = data["branchName"];
            this.directionName = data["directionName"];
        }
    }

    static fromJS(data: any): GetBranchDirectionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBranchDirectionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchDirection"] = this.branchDirection ? this.branchDirection.toJSON() : <any>undefined;
        data["branchName"] = this.branchName;
        data["directionName"] = this.directionName;
        return data; 
    }
}

export interface IGetBranchDirectionForViewDto {
    branchDirection: BranchDirectionDto;
    branchName: string | undefined;
    directionName: string | undefined;
}

export class PagedResultDtoOfGetBranchDirectionForViewDto implements IPagedResultDtoOfGetBranchDirectionForViewDto {
    totalCount!: number;
    items!: GetBranchDirectionForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetBranchDirectionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetBranchDirectionForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetBranchDirectionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetBranchDirectionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetBranchDirectionForViewDto {
    totalCount: number;
    items: GetBranchDirectionForViewDto[] | undefined;
}

export class GetBranchLatLng implements IGetBranchLatLng {
    latitude!: number;
    longitude!: number;

    constructor(data?: IGetBranchLatLng) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.latitude = data["latitude"];
            this.longitude = data["longitude"];
        }
    }

    static fromJS(data: any): GetBranchLatLng {
        data = typeof data === 'object' ? data : {};
        let result = new GetBranchLatLng();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data; 
    }
}

export interface IGetBranchLatLng {
    latitude: number;
    longitude: number;
}

export class CreateOrEditBranchDirectionDto implements ICreateOrEditBranchDirectionDto {
    servise!: Plans;
    branchRef!: number | undefined;
    directionRef!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditBranchDirectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.servise = data["servise"];
            this.branchRef = data["branchRef"];
            this.directionRef = data["directionRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditBranchDirectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditBranchDirectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servise"] = this.servise;
        data["branchRef"] = this.branchRef;
        data["directionRef"] = this.directionRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditBranchDirectionDto {
    servise: Plans;
    branchRef: number | undefined;
    directionRef: number | undefined;
    id: number | undefined;
}

export class GetBranchDirectionForEditOutput implements IGetBranchDirectionForEditOutput {
    branchDirection!: CreateOrEditBranchDirectionDto;
    branchName!: string | undefined;
    directionName!: string | undefined;

    constructor(data?: IGetBranchDirectionForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.branchDirection = data["branchDirection"] ? CreateOrEditBranchDirectionDto.fromJS(data["branchDirection"]) : <any>undefined;
            this.branchName = data["branchName"];
            this.directionName = data["directionName"];
        }
    }

    static fromJS(data: any): GetBranchDirectionForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetBranchDirectionForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchDirection"] = this.branchDirection ? this.branchDirection.toJSON() : <any>undefined;
        data["branchName"] = this.branchName;
        data["directionName"] = this.directionName;
        return data; 
    }
}

export interface IGetBranchDirectionForEditOutput {
    branchDirection: CreateOrEditBranchDirectionDto;
    branchName: string | undefined;
    directionName: string | undefined;
}

export class DirectionDto implements IDirectionDto {
    name!: string | undefined;
    state!: boolean;
    description!: string | undefined;
    areaId!: number | undefined;
    id!: number;

    constructor(data?: IDirectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.state = data["state"];
            this.description = data["description"];
            this.areaId = data["areaId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DirectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new DirectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["state"] = this.state;
        data["description"] = this.description;
        data["areaId"] = this.areaId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDirectionDto {
    name: string | undefined;
    state: boolean;
    description: string | undefined;
    areaId: number | undefined;
    id: number;
}

export enum PointsType {
    Default = 0,
    Line = 1,
    Polygon = 2,
    Circle = 3,
}

export class PointDto implements IPointDto {
    state!: boolean;
    longitude!: number;
    latitude!: number;
    order!: number;
    entityRef!: number;
    entity!: Entities;
    type!: PointsType;
    id!: number;

    constructor(data?: IPointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.state = data["state"];
            this.longitude = data["longitude"];
            this.latitude = data["latitude"];
            this.order = data["order"];
            this.entityRef = data["entityRef"];
            this.entity = data["entity"];
            this.type = data["type"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PointDto {
        data = typeof data === 'object' ? data : {};
        let result = new PointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["order"] = this.order;
        data["entityRef"] = this.entityRef;
        data["entity"] = this.entity;
        data["type"] = this.type;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPointDto {
    state: boolean;
    longitude: number;
    latitude: number;
    order: number;
    entityRef: number;
    entity: Entities;
    type: PointsType;
    id: number;
}

export class GetDirectionAndPointsForViewDto implements IGetDirectionAndPointsForViewDto {
    direction!: DirectionDto;
    points!: PointDto[] | undefined;

    constructor(data?: IGetDirectionAndPointsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.direction = data["direction"] ? DirectionDto.fromJS(data["direction"]) : <any>undefined;
            if (Array.isArray(data["points"])) {
                this.points = [] as any;
                for (let item of data["points"])
                    this.points!.push(PointDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDirectionAndPointsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDirectionAndPointsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["direction"] = this.direction ? this.direction.toJSON() : <any>undefined;
        if (Array.isArray(this.points)) {
            data["points"] = [];
            for (let item of this.points)
                data["points"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetDirectionAndPointsForViewDto {
    direction: DirectionDto;
    points: PointDto[] | undefined;
}

export class GetBranchDirectionAndPointsForEditOutput implements IGetBranchDirectionAndPointsForEditOutput {
    servise!: Plans;
    branchRef!: number;
    directionsAndPoints!: GetDirectionAndPointsForViewDto[] | undefined;
    directionsRef!: number[] | undefined;

    constructor(data?: IGetBranchDirectionAndPointsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.servise = data["servise"];
            this.branchRef = data["branchRef"];
            if (Array.isArray(data["directionsAndPoints"])) {
                this.directionsAndPoints = [] as any;
                for (let item of data["directionsAndPoints"])
                    this.directionsAndPoints!.push(GetDirectionAndPointsForViewDto.fromJS(item));
            }
            if (Array.isArray(data["directionsRef"])) {
                this.directionsRef = [] as any;
                for (let item of data["directionsRef"])
                    this.directionsRef!.push(item);
            }
        }
    }

    static fromJS(data: any): GetBranchDirectionAndPointsForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetBranchDirectionAndPointsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servise"] = this.servise;
        data["branchRef"] = this.branchRef;
        if (Array.isArray(this.directionsAndPoints)) {
            data["directionsAndPoints"] = [];
            for (let item of this.directionsAndPoints)
                data["directionsAndPoints"].push(item.toJSON());
        }
        if (Array.isArray(this.directionsRef)) {
            data["directionsRef"] = [];
            for (let item of this.directionsRef)
                data["directionsRef"].push(item);
        }
        return data; 
    }
}

export interface IGetBranchDirectionAndPointsForEditOutput {
    servise: Plans;
    branchRef: number;
    directionsAndPoints: GetDirectionAndPointsForViewDto[] | undefined;
    directionsRef: number[] | undefined;
}

export class BranchDirectionBranchLookupTableDto implements IBranchDirectionBranchLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IBranchDirectionBranchLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): BranchDirectionBranchLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new BranchDirectionBranchLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IBranchDirectionBranchLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfBranchDirectionBranchLookupTableDto implements IPagedResultDtoOfBranchDirectionBranchLookupTableDto {
    totalCount!: number;
    items!: BranchDirectionBranchLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfBranchDirectionBranchLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(BranchDirectionBranchLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfBranchDirectionBranchLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfBranchDirectionBranchLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfBranchDirectionBranchLookupTableDto {
    totalCount: number;
    items: BranchDirectionBranchLookupTableDto[] | undefined;
}

export class BranchDirectionDirectionLookupTableDto implements IBranchDirectionDirectionLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IBranchDirectionDirectionLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): BranchDirectionDirectionLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new BranchDirectionDirectionLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IBranchDirectionDirectionLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfBranchDirectionDirectionLookupTableDto implements IPagedResultDtoOfBranchDirectionDirectionLookupTableDto {
    totalCount!: number;
    items!: BranchDirectionDirectionLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfBranchDirectionDirectionLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(BranchDirectionDirectionLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfBranchDirectionDirectionLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfBranchDirectionDirectionLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfBranchDirectionDirectionLookupTableDto {
    totalCount: number;
    items: BranchDirectionDirectionLookupTableDto[] | undefined;
}

export class BranchDto implements IBranchDto {
    name!: string | undefined;
    phone!: string | undefined;
    state!: boolean;
    accountancyId!: string | undefined;
    degree!: string | undefined;
    capacity!: number | undefined;
    description!: string | undefined;
    contactId!: number;
    addressId!: number | undefined;
    branchId!: number | undefined;
    id!: number;

    constructor(data?: IBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.phone = data["phone"];
            this.state = data["state"];
            this.accountancyId = data["accountancyId"];
            this.degree = data["degree"];
            this.capacity = data["capacity"];
            this.description = data["description"];
            this.contactId = data["contactId"];
            this.addressId = data["addressId"];
            this.branchId = data["branchId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): BranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new BranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["state"] = this.state;
        data["accountancyId"] = this.accountancyId;
        data["degree"] = this.degree;
        data["capacity"] = this.capacity;
        data["description"] = this.description;
        data["contactId"] = this.contactId;
        data["addressId"] = this.addressId;
        data["branchId"] = this.branchId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IBranchDto {
    name: string | undefined;
    phone: string | undefined;
    state: boolean;
    accountancyId: string | undefined;
    degree: string | undefined;
    capacity: number | undefined;
    description: string | undefined;
    contactId: number;
    addressId: number | undefined;
    branchId: number | undefined;
    id: number;
}

export class GetBranchForViewDto implements IGetBranchForViewDto {
    branch!: BranchDto;
    contactFirstName!: string | undefined;
    addressTitle!: string | undefined;
    branchName!: string | undefined;

    constructor(data?: IGetBranchForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.branch = data["branch"] ? BranchDto.fromJS(data["branch"]) : <any>undefined;
            this.contactFirstName = data["contactFirstName"];
            this.addressTitle = data["addressTitle"];
            this.branchName = data["branchName"];
        }
    }

    static fromJS(data: any): GetBranchForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBranchForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["contactFirstName"] = this.contactFirstName;
        data["addressTitle"] = this.addressTitle;
        data["branchName"] = this.branchName;
        return data; 
    }
}

export interface IGetBranchForViewDto {
    branch: BranchDto;
    contactFirstName: string | undefined;
    addressTitle: string | undefined;
    branchName: string | undefined;
}

export class PagedResultDtoOfGetBranchForViewDto implements IPagedResultDtoOfGetBranchForViewDto {
    totalCount!: number;
    items!: GetBranchForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetBranchForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetBranchForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetBranchForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetBranchForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetBranchForViewDto {
    totalCount: number;
    items: GetBranchForViewDto[] | undefined;
}

export class CreateOrEditBranchDto implements ICreateOrEditBranchDto {
    name!: string | undefined;
    phone!: string | undefined;
    state!: boolean;
    accountancyId!: string | undefined;
    degree!: string | undefined;
    capacity!: number | undefined;
    description!: string | undefined;
    contactId!: number;
    branchId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.phone = data["phone"];
            this.state = data["state"];
            this.accountancyId = data["accountancyId"];
            this.degree = data["degree"];
            this.capacity = data["capacity"];
            this.description = data["description"];
            this.contactId = data["contactId"];
            this.branchId = data["branchId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditBranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditBranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["state"] = this.state;
        data["accountancyId"] = this.accountancyId;
        data["degree"] = this.degree;
        data["capacity"] = this.capacity;
        data["description"] = this.description;
        data["contactId"] = this.contactId;
        data["branchId"] = this.branchId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditBranchDto {
    name: string | undefined;
    phone: string | undefined;
    state: boolean;
    accountancyId: string | undefined;
    degree: string | undefined;
    capacity: number | undefined;
    description: string | undefined;
    contactId: number;
    branchId: number | undefined;
    id: number | undefined;
}

export class GetBranchForEditOutput implements IGetBranchForEditOutput {
    branch!: CreateOrEditBranchDto;
    contactFirstName!: string | undefined;
    branchName!: string | undefined;

    constructor(data?: IGetBranchForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.branch = data["branch"] ? CreateOrEditBranchDto.fromJS(data["branch"]) : <any>undefined;
            this.contactFirstName = data["contactFirstName"];
            this.branchName = data["branchName"];
        }
    }

    static fromJS(data: any): GetBranchForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetBranchForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["contactFirstName"] = this.contactFirstName;
        data["branchName"] = this.branchName;
        return data; 
    }
}

export interface IGetBranchForEditOutput {
    branch: CreateOrEditBranchDto;
    contactFirstName: string | undefined;
    branchName: string | undefined;
}

export class CreateOrEditDirectionDto implements ICreateOrEditDirectionDto {
    name!: string | undefined;
    state!: boolean;
    description!: string | undefined;
    areaId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditDirectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.state = data["state"];
            this.description = data["description"];
            this.areaId = data["areaId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditDirectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditDirectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["state"] = this.state;
        data["description"] = this.description;
        data["areaId"] = this.areaId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditDirectionDto {
    name: string | undefined;
    state: boolean;
    description: string | undefined;
    areaId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditPointDto implements ICreateOrEditPointDto {
    state!: boolean;
    longitude!: number;
    latitude!: number;
    order!: number;
    entityRef!: number;
    entity!: Entities;
    type!: PointsType;
    id!: number | undefined;

    constructor(data?: ICreateOrEditPointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.state = data["state"];
            this.longitude = data["longitude"];
            this.latitude = data["latitude"];
            this.order = data["order"];
            this.entityRef = data["entityRef"];
            this.entity = data["entity"];
            this.type = data["type"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditPointDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["order"] = this.order;
        data["entityRef"] = this.entityRef;
        data["entity"] = this.entity;
        data["type"] = this.type;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditPointDto {
    state: boolean;
    longitude: number;
    latitude: number;
    order: number;
    entityRef: number;
    entity: Entities;
    type: PointsType;
    id: number | undefined;
}

export class CreateDirectionAndPointsDto implements ICreateDirectionAndPointsDto {
    direction!: CreateOrEditDirectionDto;
    points!: CreateOrEditPointDto[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateDirectionAndPointsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.direction = data["direction"] ? CreateOrEditDirectionDto.fromJS(data["direction"]) : <any>undefined;
            if (Array.isArray(data["points"])) {
                this.points = [] as any;
                for (let item of data["points"])
                    this.points!.push(CreateOrEditPointDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateDirectionAndPointsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDirectionAndPointsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["direction"] = this.direction ? this.direction.toJSON() : <any>undefined;
        if (Array.isArray(this.points)) {
            data["points"] = [];
            for (let item of this.points)
                data["points"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateDirectionAndPointsDto {
    direction: CreateOrEditDirectionDto;
    points: CreateOrEditPointDto[] | undefined;
    id: number | undefined;
}

export class GetBrachAndAddressForEditOutput implements IGetBrachAndAddressForEditOutput {
    directionAndPoints!: CreateDirectionAndPointsDto;
    branch!: GetBranchForEditOutput;
    address!: GetAddressForEditOutput;

    constructor(data?: IGetBrachAndAddressForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.directionAndPoints = data["directionAndPoints"] ? CreateDirectionAndPointsDto.fromJS(data["directionAndPoints"]) : <any>undefined;
            this.branch = data["branch"] ? GetBranchForEditOutput.fromJS(data["branch"]) : <any>undefined;
            this.address = data["address"] ? GetAddressForEditOutput.fromJS(data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBrachAndAddressForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetBrachAndAddressForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["directionAndPoints"] = this.directionAndPoints ? this.directionAndPoints.toJSON() : <any>undefined;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetBrachAndAddressForEditOutput {
    directionAndPoints: CreateDirectionAndPointsDto;
    branch: GetBranchForEditOutput;
    address: GetAddressForEditOutput;
}

export class CreateOrEditBranchAndAddressDto implements ICreateOrEditBranchAndAddressDto {
    branch!: CreateOrEditBranchDto;
    address!: CreateOrEditAddressDto;

    constructor(data?: ICreateOrEditBranchAndAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.branch = data["branch"] ? CreateOrEditBranchDto.fromJS(data["branch"]) : <any>undefined;
            this.address = data["address"] ? CreateOrEditAddressDto.fromJS(data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrEditBranchAndAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditBranchAndAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICreateOrEditBranchAndAddressDto {
    branch: CreateOrEditBranchDto;
    address: CreateOrEditAddressDto;
}

export class BranchContactLookupTableDto implements IBranchContactLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IBranchContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): BranchContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new BranchContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IBranchContactLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfBranchContactLookupTableDto implements IPagedResultDtoOfBranchContactLookupTableDto {
    totalCount!: number;
    items!: BranchContactLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfBranchContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(BranchContactLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfBranchContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfBranchContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfBranchContactLookupTableDto {
    totalCount: number;
    items: BranchContactLookupTableDto[] | undefined;
}

export class BranchAddressLookupTableDto implements IBranchAddressLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IBranchAddressLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): BranchAddressLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new BranchAddressLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IBranchAddressLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfBranchAddressLookupTableDto implements IPagedResultDtoOfBranchAddressLookupTableDto {
    totalCount!: number;
    items!: BranchAddressLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfBranchAddressLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(BranchAddressLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfBranchAddressLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfBranchAddressLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfBranchAddressLookupTableDto {
    totalCount: number;
    items: BranchAddressLookupTableDto[] | undefined;
}

export class BranchDirectionLookupTableDto implements IBranchDirectionLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IBranchDirectionLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): BranchDirectionLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new BranchDirectionLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IBranchDirectionLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfBranchDirectionLookupTableDto implements IPagedResultDtoOfBranchDirectionLookupTableDto {
    totalCount!: number;
    items!: BranchDirectionLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfBranchDirectionLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(BranchDirectionLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfBranchDirectionLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfBranchDirectionLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfBranchDirectionLookupTableDto {
    totalCount: number;
    items: BranchDirectionLookupTableDto[] | undefined;
}

export class BranchBranchLookupTableDto implements IBranchBranchLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IBranchBranchLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): BranchBranchLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new BranchBranchLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IBranchBranchLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfBranchBranchLookupTableDto implements IPagedResultDtoOfBranchBranchLookupTableDto {
    totalCount!: number;
    items!: BranchBranchLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfBranchBranchLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(BranchBranchLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfBranchBranchLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfBranchBranchLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfBranchBranchLookupTableDto {
    totalCount: number;
    items: BranchBranchLookupTableDto[] | undefined;
}

export class CacheDto implements ICacheDto {
    name!: string | undefined;

    constructor(data?: ICacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
        }
    }

    static fromJS(data: any): CacheDto {
        data = typeof data === 'object' ? data : {};
        let result = new CacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data; 
    }
}

export interface ICacheDto {
    name: string | undefined;
}

export class ListResultDtoOfCacheDto implements IListResultDtoOfCacheDto {
    items!: CacheDto[] | undefined;

    constructor(data?: IListResultDtoOfCacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(CacheDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCacheDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfCacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfCacheDto {
    items: CacheDto[] | undefined;
}

export class EntityDtoOfString implements IEntityDtoOfString {
    id!: string | undefined;

    constructor(data?: IEntityDtoOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfString {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IEntityDtoOfString {
    id: string | undefined;
}

export class CardTemplatePropertyDto implements ICardTemplatePropertyDto {
    displayTitle!: string | undefined;
    x!: number | undefined;
    y!: number | undefined;
    fontName!: string | undefined;
    fontSize!: string | undefined;
    charactersLimite!: number;
    defaultTitle!: DefaultTitles;
    isRequired!: boolean;
    isShow!: boolean;
    isCenterAlign!: boolean;
    isFontChanging!: boolean;
    cardTemplateRef!: number;
    maxWidth!: number | undefined;
    id!: number;

    constructor(data?: ICardTemplatePropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.displayTitle = data["displayTitle"];
            this.x = data["x"];
            this.y = data["y"];
            this.fontName = data["fontName"];
            this.fontSize = data["fontSize"];
            this.charactersLimite = data["charactersLimite"];
            this.defaultTitle = data["defaultTitle"];
            this.isRequired = data["isRequired"];
            this.isShow = data["isShow"];
            this.isCenterAlign = data["isCenterAlign"];
            this.isFontChanging = data["isFontChanging"];
            this.cardTemplateRef = data["cardTemplateRef"];
            this.maxWidth = data["maxWidth"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CardTemplatePropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CardTemplatePropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayTitle"] = this.displayTitle;
        data["x"] = this.x;
        data["y"] = this.y;
        data["fontName"] = this.fontName;
        data["fontSize"] = this.fontSize;
        data["charactersLimite"] = this.charactersLimite;
        data["defaultTitle"] = this.defaultTitle;
        data["isRequired"] = this.isRequired;
        data["isShow"] = this.isShow;
        data["isCenterAlign"] = this.isCenterAlign;
        data["isFontChanging"] = this.isFontChanging;
        data["cardTemplateRef"] = this.cardTemplateRef;
        data["maxWidth"] = this.maxWidth;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICardTemplatePropertyDto {
    displayTitle: string | undefined;
    x: number | undefined;
    y: number | undefined;
    fontName: string | undefined;
    fontSize: string | undefined;
    charactersLimite: number;
    defaultTitle: DefaultTitles;
    isRequired: boolean;
    isShow: boolean;
    isCenterAlign: boolean;
    isFontChanging: boolean;
    cardTemplateRef: number;
    maxWidth: number | undefined;
    id: number;
}

export class GetCardTemplatePropertyForViewDto implements IGetCardTemplatePropertyForViewDto {
    cardTemplateProperty!: CardTemplatePropertyDto;
    cardTemplateTitle!: string | undefined;

    constructor(data?: IGetCardTemplatePropertyForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cardTemplateProperty = data["cardTemplateProperty"] ? CardTemplatePropertyDto.fromJS(data["cardTemplateProperty"]) : <any>undefined;
            this.cardTemplateTitle = data["cardTemplateTitle"];
        }
    }

    static fromJS(data: any): GetCardTemplatePropertyForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCardTemplatePropertyForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardTemplateProperty"] = this.cardTemplateProperty ? this.cardTemplateProperty.toJSON() : <any>undefined;
        data["cardTemplateTitle"] = this.cardTemplateTitle;
        return data; 
    }
}

export interface IGetCardTemplatePropertyForViewDto {
    cardTemplateProperty: CardTemplatePropertyDto;
    cardTemplateTitle: string | undefined;
}

export class PagedResultDtoOfGetCardTemplatePropertyForViewDto implements IPagedResultDtoOfGetCardTemplatePropertyForViewDto {
    totalCount!: number;
    items!: GetCardTemplatePropertyForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCardTemplatePropertyForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetCardTemplatePropertyForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCardTemplatePropertyForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCardTemplatePropertyForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetCardTemplatePropertyForViewDto {
    totalCount: number;
    items: GetCardTemplatePropertyForViewDto[] | undefined;
}

export class CreateOrEditCardTemplatePropertyDto implements ICreateOrEditCardTemplatePropertyDto {
    displayTitle!: string | undefined;
    x!: number | undefined;
    y!: number | undefined;
    fontName!: string | undefined;
    fontSize!: string | undefined;
    charactersLimite!: number;
    defaultTitle!: DefaultTitles;
    isRequired!: boolean;
    isShow!: boolean;
    isCenterAlign!: boolean;
    isFontChanging!: boolean;
    cardTemplateRef!: number;
    maxWidth!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCardTemplatePropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.displayTitle = data["displayTitle"];
            this.x = data["x"];
            this.y = data["y"];
            this.fontName = data["fontName"];
            this.fontSize = data["fontSize"];
            this.charactersLimite = data["charactersLimite"];
            this.defaultTitle = data["defaultTitle"];
            this.isRequired = data["isRequired"];
            this.isShow = data["isShow"];
            this.isCenterAlign = data["isCenterAlign"];
            this.isFontChanging = data["isFontChanging"];
            this.cardTemplateRef = data["cardTemplateRef"];
            this.maxWidth = data["maxWidth"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCardTemplatePropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCardTemplatePropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayTitle"] = this.displayTitle;
        data["x"] = this.x;
        data["y"] = this.y;
        data["fontName"] = this.fontName;
        data["fontSize"] = this.fontSize;
        data["charactersLimite"] = this.charactersLimite;
        data["defaultTitle"] = this.defaultTitle;
        data["isRequired"] = this.isRequired;
        data["isShow"] = this.isShow;
        data["isCenterAlign"] = this.isCenterAlign;
        data["isFontChanging"] = this.isFontChanging;
        data["cardTemplateRef"] = this.cardTemplateRef;
        data["maxWidth"] = this.maxWidth;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditCardTemplatePropertyDto {
    displayTitle: string | undefined;
    x: number | undefined;
    y: number | undefined;
    fontName: string | undefined;
    fontSize: string | undefined;
    charactersLimite: number;
    defaultTitle: DefaultTitles;
    isRequired: boolean;
    isShow: boolean;
    isCenterAlign: boolean;
    isFontChanging: boolean;
    cardTemplateRef: number;
    maxWidth: number | undefined;
    id: number | undefined;
}

export class GetCardTemplatePropertyForEditOutput implements IGetCardTemplatePropertyForEditOutput {
    cardTemplateProperty!: CreateOrEditCardTemplatePropertyDto;
    cardTemplateTitle!: string | undefined;

    constructor(data?: IGetCardTemplatePropertyForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cardTemplateProperty = data["cardTemplateProperty"] ? CreateOrEditCardTemplatePropertyDto.fromJS(data["cardTemplateProperty"]) : <any>undefined;
            this.cardTemplateTitle = data["cardTemplateTitle"];
        }
    }

    static fromJS(data: any): GetCardTemplatePropertyForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCardTemplatePropertyForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardTemplateProperty"] = this.cardTemplateProperty ? this.cardTemplateProperty.toJSON() : <any>undefined;
        data["cardTemplateTitle"] = this.cardTemplateTitle;
        return data; 
    }
}

export interface IGetCardTemplatePropertyForEditOutput {
    cardTemplateProperty: CreateOrEditCardTemplatePropertyDto;
    cardTemplateTitle: string | undefined;
}

export class CardTemplatePropertyCardTemplateLookupTableDto implements ICardTemplatePropertyCardTemplateLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ICardTemplatePropertyCardTemplateLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): CardTemplatePropertyCardTemplateLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CardTemplatePropertyCardTemplateLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ICardTemplatePropertyCardTemplateLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfCardTemplatePropertyCardTemplateLookupTableDto implements IPagedResultDtoOfCardTemplatePropertyCardTemplateLookupTableDto {
    totalCount!: number;
    items!: CardTemplatePropertyCardTemplateLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCardTemplatePropertyCardTemplateLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(CardTemplatePropertyCardTemplateLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCardTemplatePropertyCardTemplateLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCardTemplatePropertyCardTemplateLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfCardTemplatePropertyCardTemplateLookupTableDto {
    totalCount: number;
    items: CardTemplatePropertyCardTemplateLookupTableDto[] | undefined;
}

export class CardTemplatePreviewDto implements ICardTemplatePreviewDto {
    path!: string | undefined;
    width!: number | undefined;
    height!: number | undefined;
    properties!: CardTemplatePropertyDto[] | undefined;

    constructor(data?: ICardTemplatePreviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.path = data["path"];
            this.width = data["width"];
            this.height = data["height"];
            if (Array.isArray(data["properties"])) {
                this.properties = [] as any;
                for (let item of data["properties"])
                    this.properties!.push(CardTemplatePropertyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CardTemplatePreviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new CardTemplatePreviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["path"] = this.path;
        data["width"] = this.width;
        data["height"] = this.height;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICardTemplatePreviewDto {
    path: string | undefined;
    width: number | undefined;
    height: number | undefined;
    properties: CardTemplatePropertyDto[] | undefined;
}

export class GenerateCardTemplatePreviewDto implements IGenerateCardTemplatePreviewDto {
    path!: string | undefined;
    width!: number | undefined;
    height!: number | undefined;
    properties!: GetPropertiesForBillDto[] | undefined;

    constructor(data?: IGenerateCardTemplatePreviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.path = data["path"];
            this.width = data["width"];
            this.height = data["height"];
            if (Array.isArray(data["properties"])) {
                this.properties = [] as any;
                for (let item of data["properties"])
                    this.properties!.push(GetPropertiesForBillDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GenerateCardTemplatePreviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateCardTemplatePreviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["path"] = this.path;
        data["width"] = this.width;
        data["height"] = this.height;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGenerateCardTemplatePreviewDto {
    path: string | undefined;
    width: number | undefined;
    height: number | undefined;
    properties: GetPropertiesForBillDto[] | undefined;
}

export class CardTemplateDto implements ICardTemplateDto {
    title!: string | undefined;
    isActive!: boolean;
    description!: string | undefined;
    imagePath!: string | undefined;
    width!: number | undefined;
    length!: number | undefined;
    type!: TypesOfSolace;
    isDefault!: boolean;
    singlePagePrinting!: boolean;
    advertisement!: string | undefined;
    id!: number;

    constructor(data?: ICardTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.isActive = data["isActive"];
            this.description = data["description"];
            this.imagePath = data["imagePath"];
            this.width = data["width"];
            this.length = data["length"];
            this.type = data["type"];
            this.isDefault = data["isDefault"];
            this.singlePagePrinting = data["singlePagePrinting"];
            this.advertisement = data["advertisement"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CardTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CardTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["isActive"] = this.isActive;
        data["description"] = this.description;
        data["imagePath"] = this.imagePath;
        data["width"] = this.width;
        data["length"] = this.length;
        data["type"] = this.type;
        data["isDefault"] = this.isDefault;
        data["singlePagePrinting"] = this.singlePagePrinting;
        data["advertisement"] = this.advertisement;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICardTemplateDto {
    title: string | undefined;
    isActive: boolean;
    description: string | undefined;
    imagePath: string | undefined;
    width: number | undefined;
    length: number | undefined;
    type: TypesOfSolace;
    isDefault: boolean;
    singlePagePrinting: boolean;
    advertisement: string | undefined;
    id: number;
}

export class GetCardTemplateForViewDto implements IGetCardTemplateForViewDto {
    cardTemplate!: CardTemplateDto;

    constructor(data?: IGetCardTemplateForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cardTemplate = data["cardTemplate"] ? CardTemplateDto.fromJS(data["cardTemplate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCardTemplateForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCardTemplateForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardTemplate"] = this.cardTemplate ? this.cardTemplate.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetCardTemplateForViewDto {
    cardTemplate: CardTemplateDto;
}

export class PagedResultDtoOfGetCardTemplateForViewDto implements IPagedResultDtoOfGetCardTemplateForViewDto {
    totalCount!: number;
    items!: GetCardTemplateForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCardTemplateForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetCardTemplateForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCardTemplateForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCardTemplateForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetCardTemplateForViewDto {
    totalCount: number;
    items: GetCardTemplateForViewDto[] | undefined;
}

export class CreateOrEditCardTemplateDto implements ICreateOrEditCardTemplateDto {
    title!: string | undefined;
    isActive!: boolean;
    description!: string | undefined;
    imagePath!: string | undefined;
    deleteEditPath!: string | undefined;
    width!: number | undefined;
    length!: number | undefined;
    type!: TypesOfSolace;
    isDefault!: boolean;
    singlePagePrinting!: boolean;
    advertisement!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCardTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.isActive = data["isActive"];
            this.description = data["description"];
            this.imagePath = data["imagePath"];
            this.deleteEditPath = data["deleteEditPath"];
            this.width = data["width"];
            this.length = data["length"];
            this.type = data["type"];
            this.isDefault = data["isDefault"];
            this.singlePagePrinting = data["singlePagePrinting"];
            this.advertisement = data["advertisement"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCardTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCardTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["isActive"] = this.isActive;
        data["description"] = this.description;
        data["imagePath"] = this.imagePath;
        data["deleteEditPath"] = this.deleteEditPath;
        data["width"] = this.width;
        data["length"] = this.length;
        data["type"] = this.type;
        data["isDefault"] = this.isDefault;
        data["singlePagePrinting"] = this.singlePagePrinting;
        data["advertisement"] = this.advertisement;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditCardTemplateDto {
    title: string | undefined;
    isActive: boolean;
    description: string | undefined;
    imagePath: string | undefined;
    deleteEditPath: string | undefined;
    width: number | undefined;
    length: number | undefined;
    type: TypesOfSolace;
    isDefault: boolean;
    singlePagePrinting: boolean;
    advertisement: string | undefined;
    id: number | undefined;
}

export class GetCardTemplateForEditOutput implements IGetCardTemplateForEditOutput {
    cardTemplate!: CreateOrEditCardTemplateDto;

    constructor(data?: IGetCardTemplateForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cardTemplate = data["cardTemplate"] ? CreateOrEditCardTemplateDto.fromJS(data["cardTemplate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCardTemplateForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCardTemplateForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardTemplate"] = this.cardTemplate ? this.cardTemplate.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetCardTemplateForEditOutput {
    cardTemplate: CreateOrEditCardTemplateDto;
}

export class GetCardTemplateAndPropertiesForEditOutput implements IGetCardTemplateAndPropertiesForEditOutput {
    cardTemplate!: CreateOrEditCardTemplateDto;
    cardTemplateProperties!: PagedResultDtoOfGetCardTemplatePropertyForViewDto;

    constructor(data?: IGetCardTemplateAndPropertiesForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cardTemplate = data["cardTemplate"] ? CreateOrEditCardTemplateDto.fromJS(data["cardTemplate"]) : <any>undefined;
            this.cardTemplateProperties = data["cardTemplateProperties"] ? PagedResultDtoOfGetCardTemplatePropertyForViewDto.fromJS(data["cardTemplateProperties"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCardTemplateAndPropertiesForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCardTemplateAndPropertiesForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardTemplate"] = this.cardTemplate ? this.cardTemplate.toJSON() : <any>undefined;
        data["cardTemplateProperties"] = this.cardTemplateProperties ? this.cardTemplateProperties.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetCardTemplateAndPropertiesForEditOutput {
    cardTemplate: CreateOrEditCardTemplateDto;
    cardTemplateProperties: PagedResultDtoOfGetCardTemplatePropertyForViewDto;
}

export class CreateOrEditCardTemplateAndProperties implements ICreateOrEditCardTemplateAndProperties {
    cardTemplate!: CreateOrEditCardTemplateDto;
    cardTemplateProperties!: CreateOrEditCardTemplatePropertyDto[] | undefined;

    constructor(data?: ICreateOrEditCardTemplateAndProperties) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cardTemplate = data["cardTemplate"] ? CreateOrEditCardTemplateDto.fromJS(data["cardTemplate"]) : <any>undefined;
            if (Array.isArray(data["cardTemplateProperties"])) {
                this.cardTemplateProperties = [] as any;
                for (let item of data["cardTemplateProperties"])
                    this.cardTemplateProperties!.push(CreateOrEditCardTemplatePropertyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrEditCardTemplateAndProperties {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCardTemplateAndProperties();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardTemplate"] = this.cardTemplate ? this.cardTemplate.toJSON() : <any>undefined;
        if (Array.isArray(this.cardTemplateProperties)) {
            data["cardTemplateProperties"] = [];
            for (let item of this.cardTemplateProperties)
                data["cardTemplateProperties"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateOrEditCardTemplateAndProperties {
    cardTemplate: CreateOrEditCardTemplateDto;
    cardTemplateProperties: CreateOrEditCardTemplatePropertyDto[] | undefined;
}

export class GetCardTemplateAndPropertiesAndValuesDto implements IGetCardTemplateAndPropertiesAndValuesDto {
    cardTemplateRef!: number;
    imagePath!: string | undefined;
    path!: string | undefined;
    width!: number | undefined;
    length!: number | undefined;
    singlePagePrinting!: boolean;
    properties!: GetPropertiesForBillDto[] | undefined;

    constructor(data?: IGetCardTemplateAndPropertiesAndValuesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cardTemplateRef = data["cardTemplateRef"];
            this.imagePath = data["imagePath"];
            this.path = data["path"];
            this.width = data["width"];
            this.length = data["length"];
            this.singlePagePrinting = data["singlePagePrinting"];
            if (Array.isArray(data["properties"])) {
                this.properties = [] as any;
                for (let item of data["properties"])
                    this.properties!.push(GetPropertiesForBillDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCardTemplateAndPropertiesAndValuesDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCardTemplateAndPropertiesAndValuesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardTemplateRef"] = this.cardTemplateRef;
        data["imagePath"] = this.imagePath;
        data["path"] = this.path;
        data["width"] = this.width;
        data["length"] = this.length;
        data["singlePagePrinting"] = this.singlePagePrinting;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetCardTemplateAndPropertiesAndValuesDto {
    cardTemplateRef: number;
    imagePath: string | undefined;
    path: string | undefined;
    width: number | undefined;
    length: number | undefined;
    singlePagePrinting: boolean;
    properties: GetPropertiesForBillDto[] | undefined;
}

export class TermMapping implements ITermMapping {
    tenantId!: number;
    originalTerm!: string | undefined;
    mappedTerm!: string | undefined;
    isActive!: boolean;
    fontName!: string | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ITermMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.originalTerm = data["originalTerm"];
            this.mappedTerm = data["mappedTerm"];
            this.isActive = data["isActive"];
            this.fontName = data["fontName"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TermMapping {
        data = typeof data === 'object' ? data : {};
        let result = new TermMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["originalTerm"] = this.originalTerm;
        data["mappedTerm"] = this.mappedTerm;
        data["isActive"] = this.isActive;
        data["fontName"] = this.fontName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITermMapping {
    tenantId: number;
    originalTerm: string | undefined;
    mappedTerm: string | undefined;
    isActive: boolean;
    fontName: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class CardTemplateValueDto implements ICardTemplateValueDto {
    value!: string | undefined;
    cardTemplatePropertyRef!: number;
    entity!: Entities;
    entityRef!: number;
    id!: number;

    constructor(data?: ICardTemplateValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"];
            this.cardTemplatePropertyRef = data["cardTemplatePropertyRef"];
            this.entity = data["entity"];
            this.entityRef = data["entityRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CardTemplateValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new CardTemplateValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["cardTemplatePropertyRef"] = this.cardTemplatePropertyRef;
        data["entity"] = this.entity;
        data["entityRef"] = this.entityRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICardTemplateValueDto {
    value: string | undefined;
    cardTemplatePropertyRef: number;
    entity: Entities;
    entityRef: number;
    id: number;
}

export class GetCardTemplateValueForViewDto implements IGetCardTemplateValueForViewDto {
    cardTemplateValue!: CardTemplateValueDto;
    cardTemplatePropertyDisplayTitle!: string | undefined;
    entityCode!: string | undefined;

    constructor(data?: IGetCardTemplateValueForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cardTemplateValue = data["cardTemplateValue"] ? CardTemplateValueDto.fromJS(data["cardTemplateValue"]) : <any>undefined;
            this.cardTemplatePropertyDisplayTitle = data["cardTemplatePropertyDisplayTitle"];
            this.entityCode = data["entityCode"];
        }
    }

    static fromJS(data: any): GetCardTemplateValueForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCardTemplateValueForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardTemplateValue"] = this.cardTemplateValue ? this.cardTemplateValue.toJSON() : <any>undefined;
        data["cardTemplatePropertyDisplayTitle"] = this.cardTemplatePropertyDisplayTitle;
        data["entityCode"] = this.entityCode;
        return data; 
    }
}

export interface IGetCardTemplateValueForViewDto {
    cardTemplateValue: CardTemplateValueDto;
    cardTemplatePropertyDisplayTitle: string | undefined;
    entityCode: string | undefined;
}

export class PagedResultDtoOfGetCardTemplateValueForViewDto implements IPagedResultDtoOfGetCardTemplateValueForViewDto {
    totalCount!: number;
    items!: GetCardTemplateValueForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCardTemplateValueForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetCardTemplateValueForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCardTemplateValueForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCardTemplateValueForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetCardTemplateValueForViewDto {
    totalCount: number;
    items: GetCardTemplateValueForViewDto[] | undefined;
}

export class CreateOrEditCardTemplateValueDto implements ICreateOrEditCardTemplateValueDto {
    value!: string | undefined;
    cardTemplatePropertyRef!: number;
    entity!: Entities;
    entityRef!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCardTemplateValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"];
            this.cardTemplatePropertyRef = data["cardTemplatePropertyRef"];
            this.entity = data["entity"];
            this.entityRef = data["entityRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCardTemplateValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCardTemplateValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["cardTemplatePropertyRef"] = this.cardTemplatePropertyRef;
        data["entity"] = this.entity;
        data["entityRef"] = this.entityRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditCardTemplateValueDto {
    value: string | undefined;
    cardTemplatePropertyRef: number;
    entity: Entities;
    entityRef: number | undefined;
    id: number | undefined;
}

export class GetCardTemplateValueForEditOutput implements IGetCardTemplateValueForEditOutput {
    cardTemplateValue!: CreateOrEditCardTemplateValueDto;
    cardTemplatePropertyDisplayTitle!: string | undefined;
    entityCode!: string | undefined;

    constructor(data?: IGetCardTemplateValueForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cardTemplateValue = data["cardTemplateValue"] ? CreateOrEditCardTemplateValueDto.fromJS(data["cardTemplateValue"]) : <any>undefined;
            this.cardTemplatePropertyDisplayTitle = data["cardTemplatePropertyDisplayTitle"];
            this.entityCode = data["entityCode"];
        }
    }

    static fromJS(data: any): GetCardTemplateValueForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCardTemplateValueForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardTemplateValue"] = this.cardTemplateValue ? this.cardTemplateValue.toJSON() : <any>undefined;
        data["cardTemplatePropertyDisplayTitle"] = this.cardTemplatePropertyDisplayTitle;
        data["entityCode"] = this.entityCode;
        return data; 
    }
}

export interface IGetCardTemplateValueForEditOutput {
    cardTemplateValue: CreateOrEditCardTemplateValueDto;
    cardTemplatePropertyDisplayTitle: string | undefined;
    entityCode: string | undefined;
}

export class CardTemplateValueCardTemplatePropertyLookupTableDto implements ICardTemplateValueCardTemplatePropertyLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ICardTemplateValueCardTemplatePropertyLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): CardTemplateValueCardTemplatePropertyLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CardTemplateValueCardTemplatePropertyLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ICardTemplateValueCardTemplatePropertyLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfCardTemplateValueCardTemplatePropertyLookupTableDto implements IPagedResultDtoOfCardTemplateValueCardTemplatePropertyLookupTableDto {
    totalCount!: number;
    items!: CardTemplateValueCardTemplatePropertyLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCardTemplateValueCardTemplatePropertyLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(CardTemplateValueCardTemplatePropertyLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCardTemplateValueCardTemplatePropertyLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCardTemplateValueCardTemplatePropertyLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfCardTemplateValueCardTemplatePropertyLookupTableDto {
    totalCount: number;
    items: CardTemplateValueCardTemplatePropertyLookupTableDto[] | undefined;
}

export class CardTemplateValueBillLookupTableDto implements ICardTemplateValueBillLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ICardTemplateValueBillLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): CardTemplateValueBillLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CardTemplateValueBillLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ICardTemplateValueBillLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfCardTemplateValueBillLookupTableDto implements IPagedResultDtoOfCardTemplateValueBillLookupTableDto {
    totalCount!: number;
    items!: CardTemplateValueBillLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCardTemplateValueBillLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(CardTemplateValueBillLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCardTemplateValueBillLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCardTemplateValueBillLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfCardTemplateValueBillLookupTableDto {
    totalCount: number;
    items: CardTemplateValueBillLookupTableDto[] | undefined;
}

export enum CashOutTypes {
    Creditor = 1,
    Debtor = 2,
}

export class CashOutDto implements ICashOutDto {
    amount!: number | undefined;
    description!: string | undefined;
    type!: CashOutTypes;
    transactionRef!: number | undefined;
    transactionTime!: moment.Moment;
    contactRef!: number;
    id!: number;

    constructor(data?: ICashOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.amount = data["amount"];
            this.description = data["description"];
            this.type = data["type"];
            this.transactionRef = data["transactionRef"];
            this.transactionTime = data["transactionTime"] ? moment(data["transactionTime"].toString()) : <any>undefined;
            this.contactRef = data["contactRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CashOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new CashOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["description"] = this.description;
        data["type"] = this.type;
        data["transactionRef"] = this.transactionRef;
        data["transactionTime"] = this.transactionTime ? this.transactionTime.toISOString() : <any>undefined;
        data["contactRef"] = this.contactRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICashOutDto {
    amount: number | undefined;
    description: string | undefined;
    type: CashOutTypes;
    transactionRef: number | undefined;
    transactionTime: moment.Moment;
    contactRef: number;
    id: number;
}

export class GetCashOutForViewDto implements IGetCashOutForViewDto {
    cashOut!: CashOutDto;
    contactFirstName!: string | undefined;

    constructor(data?: IGetCashOutForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cashOut = data["cashOut"] ? CashOutDto.fromJS(data["cashOut"]) : <any>undefined;
            this.contactFirstName = data["contactFirstName"];
        }
    }

    static fromJS(data: any): GetCashOutForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCashOutForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cashOut"] = this.cashOut ? this.cashOut.toJSON() : <any>undefined;
        data["contactFirstName"] = this.contactFirstName;
        return data; 
    }
}

export interface IGetCashOutForViewDto {
    cashOut: CashOutDto;
    contactFirstName: string | undefined;
}

export class PagedResultDtoOfGetCashOutForViewDto implements IPagedResultDtoOfGetCashOutForViewDto {
    totalCount!: number;
    items!: GetCashOutForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCashOutForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetCashOutForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCashOutForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCashOutForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetCashOutForViewDto {
    totalCount: number;
    items: GetCashOutForViewDto[] | undefined;
}

export class CreateOrEditCashOutDto implements ICreateOrEditCashOutDto {
    amount!: number | undefined;
    description!: string | undefined;
    type!: CashOutTypes;
    transactionRef!: number | undefined;
    transactionTime!: moment.Moment;
    contactRef!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCashOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.amount = data["amount"];
            this.description = data["description"];
            this.type = data["type"];
            this.transactionRef = data["transactionRef"];
            this.transactionTime = data["transactionTime"] ? moment(data["transactionTime"].toString()) : <any>undefined;
            this.contactRef = data["contactRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCashOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCashOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["description"] = this.description;
        data["type"] = this.type;
        data["transactionRef"] = this.transactionRef;
        data["transactionTime"] = this.transactionTime ? this.transactionTime.toISOString() : <any>undefined;
        data["contactRef"] = this.contactRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditCashOutDto {
    amount: number | undefined;
    description: string | undefined;
    type: CashOutTypes;
    transactionRef: number | undefined;
    transactionTime: moment.Moment;
    contactRef: number;
    id: number | undefined;
}

export class GetCashOutForEditOutput implements IGetCashOutForEditOutput {
    cashOut!: CreateOrEditCashOutDto;
    contactFirstName!: string | undefined;

    constructor(data?: IGetCashOutForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cashOut = data["cashOut"] ? CreateOrEditCashOutDto.fromJS(data["cashOut"]) : <any>undefined;
            this.contactFirstName = data["contactFirstName"];
        }
    }

    static fromJS(data: any): GetCashOutForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCashOutForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cashOut"] = this.cashOut ? this.cashOut.toJSON() : <any>undefined;
        data["contactFirstName"] = this.contactFirstName;
        return data; 
    }
}

export interface IGetCashOutForEditOutput {
    cashOut: CreateOrEditCashOutDto;
    contactFirstName: string | undefined;
}

export class CashOutContactLookupTableDto implements ICashOutContactLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ICashOutContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): CashOutContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CashOutContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ICashOutContactLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfCashOutContactLookupTableDto implements IPagedResultDtoOfCashOutContactLookupTableDto {
    totalCount!: number;
    items!: CashOutContactLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCashOutContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(CashOutContactLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCashOutContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCashOutContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfCashOutContactLookupTableDto {
    totalCount: number;
    items: CashOutContactLookupTableDto[] | undefined;
}

export class TransactionUseBonusInput implements ITransactionUseBonusInput {
    contactId!: number | undefined;
    amount!: number;
    walletCode!: string | undefined;

    constructor(data?: ITransactionUseBonusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contactId = data["contactId"];
            this.amount = data["amount"];
            this.walletCode = data["walletCode"];
        }
    }

    static fromJS(data: any): TransactionUseBonusInput {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionUseBonusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["amount"] = this.amount;
        data["walletCode"] = this.walletCode;
        return data; 
    }
}

export interface ITransactionUseBonusInput {
    contactId: number | undefined;
    amount: number;
    walletCode: string | undefined;
}

export class CeremonyDto implements ICeremonyDto {
    startTime!: moment.Moment | undefined;
    returnDate!: moment.Moment | undefined;
    ceremonyOwnerName!: string | undefined;
    ceremonyOwnerPhoneNo!: string | undefined;
    state!: boolean;
    isApproved!: boolean;
    code!: string | undefined;
    title!: string | undefined;
    deceasedId!: number;
    locationId!: number;
    eventTypeId!: number;
    id!: number;

    constructor(data?: ICeremonyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.startTime = data["startTime"] ? moment(data["startTime"].toString()) : <any>undefined;
            this.returnDate = data["returnDate"] ? moment(data["returnDate"].toString()) : <any>undefined;
            this.ceremonyOwnerName = data["ceremonyOwnerName"];
            this.ceremonyOwnerPhoneNo = data["ceremonyOwnerPhoneNo"];
            this.state = data["state"];
            this.isApproved = data["isApproved"];
            this.code = data["code"];
            this.title = data["title"];
            this.deceasedId = data["deceasedId"];
            this.locationId = data["locationId"];
            this.eventTypeId = data["eventTypeId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CeremonyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CeremonyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["returnDate"] = this.returnDate ? this.returnDate.toISOString() : <any>undefined;
        data["ceremonyOwnerName"] = this.ceremonyOwnerName;
        data["ceremonyOwnerPhoneNo"] = this.ceremonyOwnerPhoneNo;
        data["state"] = this.state;
        data["isApproved"] = this.isApproved;
        data["code"] = this.code;
        data["title"] = this.title;
        data["deceasedId"] = this.deceasedId;
        data["locationId"] = this.locationId;
        data["eventTypeId"] = this.eventTypeId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICeremonyDto {
    startTime: moment.Moment | undefined;
    returnDate: moment.Moment | undefined;
    ceremonyOwnerName: string | undefined;
    ceremonyOwnerPhoneNo: string | undefined;
    state: boolean;
    isApproved: boolean;
    code: string | undefined;
    title: string | undefined;
    deceasedId: number;
    locationId: number;
    eventTypeId: number;
    id: number;
}

export class GetCeremonyForViewDto implements IGetCeremonyForViewDto {
    ceremony!: CeremonyDto;
    deceasedFirstName!: string | undefined;
    locationTitle!: string | undefined;
    eventTypeTitle!: string | undefined;
    locationAddress!: string | undefined;
    creatorUserName!: string | undefined;
    survivorName!: string | undefined;
    survivorMobileNum!: string | undefined;
    gender!: Gender;

    constructor(data?: IGetCeremonyForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ceremony = data["ceremony"] ? CeremonyDto.fromJS(data["ceremony"]) : <any>undefined;
            this.deceasedFirstName = data["deceasedFirstName"];
            this.locationTitle = data["locationTitle"];
            this.eventTypeTitle = data["eventTypeTitle"];
            this.locationAddress = data["locationAddress"];
            this.creatorUserName = data["creatorUserName"];
            this.survivorName = data["survivorName"];
            this.survivorMobileNum = data["survivorMobileNum"];
            this.gender = data["gender"];
        }
    }

    static fromJS(data: any): GetCeremonyForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCeremonyForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ceremony"] = this.ceremony ? this.ceremony.toJSON() : <any>undefined;
        data["deceasedFirstName"] = this.deceasedFirstName;
        data["locationTitle"] = this.locationTitle;
        data["eventTypeTitle"] = this.eventTypeTitle;
        data["locationAddress"] = this.locationAddress;
        data["creatorUserName"] = this.creatorUserName;
        data["survivorName"] = this.survivorName;
        data["survivorMobileNum"] = this.survivorMobileNum;
        data["gender"] = this.gender;
        return data; 
    }
}

export interface IGetCeremonyForViewDto {
    ceremony: CeremonyDto;
    deceasedFirstName: string | undefined;
    locationTitle: string | undefined;
    eventTypeTitle: string | undefined;
    locationAddress: string | undefined;
    creatorUserName: string | undefined;
    survivorName: string | undefined;
    survivorMobileNum: string | undefined;
    gender: Gender;
}

export class PagedResultDtoOfGetCeremonyForViewDto implements IPagedResultDtoOfGetCeremonyForViewDto {
    totalCount!: number;
    items!: GetCeremonyForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCeremonyForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetCeremonyForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCeremonyForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCeremonyForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetCeremonyForViewDto {
    totalCount: number;
    items: GetCeremonyForViewDto[] | undefined;
}

export class CreateOrEditCeremonyDto implements ICreateOrEditCeremonyDto {
    startTime!: moment.Moment;
    returnDate!: moment.Moment | undefined;
    ceremonyOwnerName!: string | undefined;
    ceremonyOwnerPhoneNo!: string | undefined;
    state!: boolean;
    isApproved!: boolean;
    code!: string | undefined;
    title!: string | undefined;
    deceasedId!: number | undefined;
    locationId!: number;
    eventTypeId!: number;
    isDuplicate!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCeremonyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.startTime = data["startTime"] ? moment(data["startTime"].toString()) : <any>undefined;
            this.returnDate = data["returnDate"] ? moment(data["returnDate"].toString()) : <any>undefined;
            this.ceremonyOwnerName = data["ceremonyOwnerName"];
            this.ceremonyOwnerPhoneNo = data["ceremonyOwnerPhoneNo"];
            this.state = data["state"];
            this.isApproved = data["isApproved"];
            this.code = data["code"];
            this.title = data["title"];
            this.deceasedId = data["deceasedId"];
            this.locationId = data["locationId"];
            this.eventTypeId = data["eventTypeId"];
            this.isDuplicate = data["isDuplicate"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCeremonyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCeremonyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["returnDate"] = this.returnDate ? this.returnDate.toISOString() : <any>undefined;
        data["ceremonyOwnerName"] = this.ceremonyOwnerName;
        data["ceremonyOwnerPhoneNo"] = this.ceremonyOwnerPhoneNo;
        data["state"] = this.state;
        data["isApproved"] = this.isApproved;
        data["code"] = this.code;
        data["title"] = this.title;
        data["deceasedId"] = this.deceasedId;
        data["locationId"] = this.locationId;
        data["eventTypeId"] = this.eventTypeId;
        data["isDuplicate"] = this.isDuplicate;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditCeremonyDto {
    startTime: moment.Moment;
    returnDate: moment.Moment | undefined;
    ceremonyOwnerName: string | undefined;
    ceremonyOwnerPhoneNo: string | undefined;
    state: boolean;
    isApproved: boolean;
    code: string | undefined;
    title: string | undefined;
    deceasedId: number | undefined;
    locationId: number;
    eventTypeId: number;
    isDuplicate: boolean;
    id: number | undefined;
}

export class GetCeremonyForEditOutput implements IGetCeremonyForEditOutput {
    ceremony!: CreateOrEditCeremonyDto;
    deceasedFirstName!: string | undefined;
    locationTitle!: string | undefined;
    eventTypeTitle!: string | undefined;

    constructor(data?: IGetCeremonyForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ceremony = data["ceremony"] ? CreateOrEditCeremonyDto.fromJS(data["ceremony"]) : <any>undefined;
            this.deceasedFirstName = data["deceasedFirstName"];
            this.locationTitle = data["locationTitle"];
            this.eventTypeTitle = data["eventTypeTitle"];
        }
    }

    static fromJS(data: any): GetCeremonyForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCeremonyForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ceremony"] = this.ceremony ? this.ceremony.toJSON() : <any>undefined;
        data["deceasedFirstName"] = this.deceasedFirstName;
        data["locationTitle"] = this.locationTitle;
        data["eventTypeTitle"] = this.eventTypeTitle;
        return data; 
    }
}

export interface IGetCeremonyForEditOutput {
    ceremony: CreateOrEditCeremonyDto;
    deceasedFirstName: string | undefined;
    locationTitle: string | undefined;
    eventTypeTitle: string | undefined;
}

export class CreateOrEditCeremonyOutput implements ICreateOrEditCeremonyOutput {
    id!: number | undefined;
    message!: string | undefined;
    success!: boolean;

    constructor(data?: ICreateOrEditCeremonyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.message = data["message"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): CreateOrEditCeremonyOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCeremonyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["message"] = this.message;
        data["success"] = this.success;
        return data; 
    }
}

export interface ICreateOrEditCeremonyOutput {
    id: number | undefined;
    message: string | undefined;
    success: boolean;
}

export class PagedResultDtoOfGetAllCeremoniesForShopDto implements IPagedResultDtoOfGetAllCeremoniesForShopDto {
    totalCount!: number;
    items!: GetAllCeremoniesForShopDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAllCeremoniesForShopDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetAllCeremoniesForShopDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAllCeremoniesForShopDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAllCeremoniesForShopDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetAllCeremoniesForShopDto {
    totalCount: number;
    items: GetAllCeremoniesForShopDto[] | undefined;
}

export class CeremonyDeceasedLookupTableDto implements ICeremonyDeceasedLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    survivorName!: string | undefined;
    survivorPhoneNo!: string | undefined;
    today!: boolean;
    gender!: Gender;

    constructor(data?: ICeremonyDeceasedLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.survivorName = data["survivorName"];
            this.survivorPhoneNo = data["survivorPhoneNo"];
            this.today = data["today"];
            this.gender = data["gender"];
        }
    }

    static fromJS(data: any): CeremonyDeceasedLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CeremonyDeceasedLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["survivorName"] = this.survivorName;
        data["survivorPhoneNo"] = this.survivorPhoneNo;
        data["today"] = this.today;
        data["gender"] = this.gender;
        return data; 
    }
}

export interface ICeremonyDeceasedLookupTableDto {
    id: number;
    displayName: string | undefined;
    survivorName: string | undefined;
    survivorPhoneNo: string | undefined;
    today: boolean;
    gender: Gender;
}

export class PagedResultDtoOfCeremonyDeceasedLookupTableDto implements IPagedResultDtoOfCeremonyDeceasedLookupTableDto {
    totalCount!: number;
    items!: CeremonyDeceasedLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCeremonyDeceasedLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(CeremonyDeceasedLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCeremonyDeceasedLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCeremonyDeceasedLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfCeremonyDeceasedLookupTableDto {
    totalCount: number;
    items: CeremonyDeceasedLookupTableDto[] | undefined;
}

export class CeremonyLocationLookupTableDto implements ICeremonyLocationLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    address!: string | undefined;
    isPublicOrPrivate!: boolean;

    constructor(data?: ICeremonyLocationLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.address = data["address"];
            this.isPublicOrPrivate = data["isPublicOrPrivate"];
        }
    }

    static fromJS(data: any): CeremonyLocationLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CeremonyLocationLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["address"] = this.address;
        data["isPublicOrPrivate"] = this.isPublicOrPrivate;
        return data; 
    }
}

export interface ICeremonyLocationLookupTableDto {
    id: number;
    displayName: string | undefined;
    address: string | undefined;
    isPublicOrPrivate: boolean;
}

export class PagedResultDtoOfCeremonyLocationLookupTableDto implements IPagedResultDtoOfCeremonyLocationLookupTableDto {
    totalCount!: number;
    items!: CeremonyLocationLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCeremonyLocationLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(CeremonyLocationLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCeremonyLocationLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCeremonyLocationLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfCeremonyLocationLookupTableDto {
    totalCount: number;
    items: CeremonyLocationLookupTableDto[] | undefined;
}

export class CeremonyEventTypeLookupTableDto implements ICeremonyEventTypeLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    isEndDateRequired!: boolean;

    constructor(data?: ICeremonyEventTypeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.isEndDateRequired = data["isEndDateRequired"];
        }
    }

    static fromJS(data: any): CeremonyEventTypeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CeremonyEventTypeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["isEndDateRequired"] = this.isEndDateRequired;
        return data; 
    }
}

export interface ICeremonyEventTypeLookupTableDto {
    id: number;
    displayName: string | undefined;
    isEndDateRequired: boolean;
}

export class RespectPrefix implements IRespectPrefix {
    tenantId!: number | undefined;
    title!: string | undefined;
    gender!: Gender;
    state!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IRespectPrefix) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.title = data["title"];
            this.gender = data["gender"];
            this.state = data["state"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RespectPrefix {
        data = typeof data === 'object' ? data : {};
        let result = new RespectPrefix();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["title"] = this.title;
        data["gender"] = this.gender;
        data["state"] = this.state;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRespectPrefix {
    tenantId: number | undefined;
    title: string | undefined;
    gender: Gender;
    state: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class Deceased implements IDeceased {
    tenantId!: number | undefined;
    gender!: Gender;
    firstName!: string | undefined;
    lastName!: string | undefined;
    survivorName!: string | undefined;
    survivorPhoneNo!: string | undefined;
    description!: string | undefined;
    imagePath!: string | undefined;
    deathDate!: moment.Moment | undefined;
    code!: string | undefined;
    isApproved!: boolean;
    state!: boolean;
    isShow!: boolean;
    respectPrefixRef!: number | undefined;
    respectPrefixRefFk!: RespectPrefix;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IDeceased) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.gender = data["gender"];
            this.firstName = data["firstName"];
            this.lastName = data["lastName"];
            this.survivorName = data["survivorName"];
            this.survivorPhoneNo = data["survivorPhoneNo"];
            this.description = data["description"];
            this.imagePath = data["imagePath"];
            this.deathDate = data["deathDate"] ? moment(data["deathDate"].toString()) : <any>undefined;
            this.code = data["code"];
            this.isApproved = data["isApproved"];
            this.state = data["state"];
            this.isShow = data["isShow"];
            this.respectPrefixRef = data["respectPrefixRef"];
            this.respectPrefixRefFk = data["respectPrefixRefFk"] ? RespectPrefix.fromJS(data["respectPrefixRefFk"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Deceased {
        data = typeof data === 'object' ? data : {};
        let result = new Deceased();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["gender"] = this.gender;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["survivorName"] = this.survivorName;
        data["survivorPhoneNo"] = this.survivorPhoneNo;
        data["description"] = this.description;
        data["imagePath"] = this.imagePath;
        data["deathDate"] = this.deathDate ? this.deathDate.toISOString() : <any>undefined;
        data["code"] = this.code;
        data["isApproved"] = this.isApproved;
        data["state"] = this.state;
        data["isShow"] = this.isShow;
        data["respectPrefixRef"] = this.respectPrefixRef;
        data["respectPrefixRefFk"] = this.respectPrefixRefFk ? this.respectPrefixRefFk.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDeceased {
    tenantId: number | undefined;
    gender: Gender;
    firstName: string | undefined;
    lastName: string | undefined;
    survivorName: string | undefined;
    survivorPhoneNo: string | undefined;
    description: string | undefined;
    imagePath: string | undefined;
    deathDate: moment.Moment | undefined;
    code: string | undefined;
    isApproved: boolean;
    state: boolean;
    isShow: boolean;
    respectPrefixRef: number | undefined;
    respectPrefixRefFk: RespectPrefix;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class LocationGroup implements ILocationGroup {
    tenantId!: number | undefined;
    title!: string | undefined;
    capacity!: number;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ILocationGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.title = data["title"];
            this.capacity = data["capacity"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): LocationGroup {
        data = typeof data === 'object' ? data : {};
        let result = new LocationGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["title"] = this.title;
        data["capacity"] = this.capacity;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ILocationGroup {
    tenantId: number | undefined;
    title: string | undefined;
    capacity: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class LocationType implements ILocationType {
    tenantId!: number | undefined;
    title!: string | undefined;
    isActive!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ILocationType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.title = data["title"];
            this.isActive = data["isActive"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): LocationType {
        data = typeof data === 'object' ? data : {};
        let result = new LocationType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["title"] = this.title;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ILocationType {
    tenantId: number | undefined;
    title: string | undefined;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class Location implements ILocation {
    tenantId!: number | undefined;
    title!: string | undefined;
    code!: string | undefined;
    isPublicOrPrivate!: boolean;
    owner!: string | undefined;
    ownerPhoneNo!: string | undefined;
    guaranteedTimeDeliver!: number | undefined;
    isUserRequestsToBePublicTheLocation!: boolean;
    locationGroupId!: number | undefined;
    locationGroupFk!: LocationGroup;
    locationTypeId!: number | undefined;
    locationTypeFk!: LocationType;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ILocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.title = data["title"];
            this.code = data["code"];
            this.isPublicOrPrivate = data["isPublicOrPrivate"];
            this.owner = data["owner"];
            this.ownerPhoneNo = data["ownerPhoneNo"];
            this.guaranteedTimeDeliver = data["guaranteedTimeDeliver"];
            this.isUserRequestsToBePublicTheLocation = data["isUserRequestsToBePublicTheLocation"];
            this.locationGroupId = data["locationGroupId"];
            this.locationGroupFk = data["locationGroupFk"] ? LocationGroup.fromJS(data["locationGroupFk"]) : <any>undefined;
            this.locationTypeId = data["locationTypeId"];
            this.locationTypeFk = data["locationTypeFk"] ? LocationType.fromJS(data["locationTypeFk"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Location {
        data = typeof data === 'object' ? data : {};
        let result = new Location();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["title"] = this.title;
        data["code"] = this.code;
        data["isPublicOrPrivate"] = this.isPublicOrPrivate;
        data["owner"] = this.owner;
        data["ownerPhoneNo"] = this.ownerPhoneNo;
        data["guaranteedTimeDeliver"] = this.guaranteedTimeDeliver;
        data["isUserRequestsToBePublicTheLocation"] = this.isUserRequestsToBePublicTheLocation;
        data["locationGroupId"] = this.locationGroupId;
        data["locationGroupFk"] = this.locationGroupFk ? this.locationGroupFk.toJSON() : <any>undefined;
        data["locationTypeId"] = this.locationTypeId;
        data["locationTypeFk"] = this.locationTypeFk ? this.locationTypeFk.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ILocation {
    tenantId: number | undefined;
    title: string | undefined;
    code: string | undefined;
    isPublicOrPrivate: boolean;
    owner: string | undefined;
    ownerPhoneNo: string | undefined;
    guaranteedTimeDeliver: number | undefined;
    isUserRequestsToBePublicTheLocation: boolean;
    locationGroupId: number | undefined;
    locationGroupFk: LocationGroup;
    locationTypeId: number | undefined;
    locationTypeFk: LocationType;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class EventType implements IEventType {
    tenantId!: number | undefined;
    title!: string | undefined;
    isEndDateRequired!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IEventType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.title = data["title"];
            this.isEndDateRequired = data["isEndDateRequired"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventType {
        data = typeof data === 'object' ? data : {};
        let result = new EventType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["title"] = this.title;
        data["isEndDateRequired"] = this.isEndDateRequired;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventType {
    tenantId: number | undefined;
    title: string | undefined;
    isEndDateRequired: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class Ceremony implements ICeremony {
    tenantId!: number | undefined;
    startTime!: moment.Moment;
    returnDate!: moment.Moment | undefined;
    ceremonyOwnerName!: string | undefined;
    ceremonyOwnerPhoneNo!: string | undefined;
    state!: boolean;
    isApproved!: boolean;
    code!: string | undefined;
    title!: string | undefined;
    deceasedId!: number;
    deceasedFk!: Deceased;
    locationId!: number;
    locationFk!: Location;
    eventTypeId!: number;
    eventTypeFk!: EventType;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ICeremony) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.startTime = data["startTime"] ? moment(data["startTime"].toString()) : <any>undefined;
            this.returnDate = data["returnDate"] ? moment(data["returnDate"].toString()) : <any>undefined;
            this.ceremonyOwnerName = data["ceremonyOwnerName"];
            this.ceremonyOwnerPhoneNo = data["ceremonyOwnerPhoneNo"];
            this.state = data["state"];
            this.isApproved = data["isApproved"];
            this.code = data["code"];
            this.title = data["title"];
            this.deceasedId = data["deceasedId"];
            this.deceasedFk = data["deceasedFk"] ? Deceased.fromJS(data["deceasedFk"]) : <any>undefined;
            this.locationId = data["locationId"];
            this.locationFk = data["locationFk"] ? Location.fromJS(data["locationFk"]) : <any>undefined;
            this.eventTypeId = data["eventTypeId"];
            this.eventTypeFk = data["eventTypeFk"] ? EventType.fromJS(data["eventTypeFk"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Ceremony {
        data = typeof data === 'object' ? data : {};
        let result = new Ceremony();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["returnDate"] = this.returnDate ? this.returnDate.toISOString() : <any>undefined;
        data["ceremonyOwnerName"] = this.ceremonyOwnerName;
        data["ceremonyOwnerPhoneNo"] = this.ceremonyOwnerPhoneNo;
        data["state"] = this.state;
        data["isApproved"] = this.isApproved;
        data["code"] = this.code;
        data["title"] = this.title;
        data["deceasedId"] = this.deceasedId;
        data["deceasedFk"] = this.deceasedFk ? this.deceasedFk.toJSON() : <any>undefined;
        data["locationId"] = this.locationId;
        data["locationFk"] = this.locationFk ? this.locationFk.toJSON() : <any>undefined;
        data["eventTypeId"] = this.eventTypeId;
        data["eventTypeFk"] = this.eventTypeFk ? this.eventTypeFk.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICeremony {
    tenantId: number | undefined;
    startTime: moment.Moment;
    returnDate: moment.Moment | undefined;
    ceremonyOwnerName: string | undefined;
    ceremonyOwnerPhoneNo: string | undefined;
    state: boolean;
    isApproved: boolean;
    code: string | undefined;
    title: string | undefined;
    deceasedId: number;
    deceasedFk: Deceased;
    locationId: number;
    locationFk: Location;
    eventTypeId: number;
    eventTypeFk: EventType;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class GetDailyFlowerReportOutputDto implements IGetDailyFlowerReportOutputDto {
    ceremonyTitle!: string | undefined;
    startCeremony!: string | undefined;
    locationAddress!: string | undefined;
    extraEntity!: string[] | undefined;
    flowerCrownCount!: number;
    flowerCrownSumPrice!: number;

    constructor(data?: IGetDailyFlowerReportOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ceremonyTitle = data["ceremonyTitle"];
            this.startCeremony = data["startCeremony"];
            this.locationAddress = data["locationAddress"];
            if (Array.isArray(data["extraEntity"])) {
                this.extraEntity = [] as any;
                for (let item of data["extraEntity"])
                    this.extraEntity!.push(item);
            }
            this.flowerCrownCount = data["flowerCrownCount"];
            this.flowerCrownSumPrice = data["flowerCrownSumPrice"];
        }
    }

    static fromJS(data: any): GetDailyFlowerReportOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDailyFlowerReportOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ceremonyTitle"] = this.ceremonyTitle;
        data["startCeremony"] = this.startCeremony;
        data["locationAddress"] = this.locationAddress;
        if (Array.isArray(this.extraEntity)) {
            data["extraEntity"] = [];
            for (let item of this.extraEntity)
                data["extraEntity"].push(item);
        }
        data["flowerCrownCount"] = this.flowerCrownCount;
        data["flowerCrownSumPrice"] = this.flowerCrownSumPrice;
        return data; 
    }
}

export interface IGetDailyFlowerReportOutputDto {
    ceremonyTitle: string | undefined;
    startCeremony: string | undefined;
    locationAddress: string | undefined;
    extraEntity: string[] | undefined;
    flowerCrownCount: number;
    flowerCrownSumPrice: number;
}

export class PagedResultDtoOfGetDailyFlowerReportOutputDto implements IPagedResultDtoOfGetDailyFlowerReportOutputDto {
    totalCount!: number;
    items!: GetDailyFlowerReportOutputDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetDailyFlowerReportOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetDailyFlowerReportOutputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetDailyFlowerReportOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetDailyFlowerReportOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetDailyFlowerReportOutputDto {
    totalCount: number;
    items: GetDailyFlowerReportOutputDto[] | undefined;
}

export class CeremonyReportPlanConstLookupTableDto implements ICeremonyReportPlanConstLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ICeremonyReportPlanConstLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): CeremonyReportPlanConstLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CeremonyReportPlanConstLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ICeremonyReportPlanConstLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfCeremonyReportPlanConstLookupTableDto implements IPagedResultDtoOfCeremonyReportPlanConstLookupTableDto {
    totalCount!: number;
    items!: CeremonyReportPlanConstLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCeremonyReportPlanConstLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(CeremonyReportPlanConstLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCeremonyReportPlanConstLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCeremonyReportPlanConstLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfCeremonyReportPlanConstLookupTableDto {
    totalCount: number;
    items: CeremonyReportPlanConstLookupTableDto[] | undefined;
}

export class MergeCeremonyAndSaveInput implements IMergeCeremonyAndSaveInput {
    firstCeremonyId!: number;
    secondCeremonyId!: number;

    constructor(data?: IMergeCeremonyAndSaveInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.firstCeremonyId = data["firstCeremonyId"];
            this.secondCeremonyId = data["secondCeremonyId"];
        }
    }

    static fromJS(data: any): MergeCeremonyAndSaveInput {
        data = typeof data === 'object' ? data : {};
        let result = new MergeCeremonyAndSaveInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstCeremonyId"] = this.firstCeremonyId;
        data["secondCeremonyId"] = this.secondCeremonyId;
        return data; 
    }
}

export interface IMergeCeremonyAndSaveInput {
    firstCeremonyId: number;
    secondCeremonyId: number;
}

export class GetCharityPlanForViewDto implements IGetCharityPlanForViewDto {
    charityPlan!: CharityPlanDto;
    planConstTitle!: string | undefined;
    benefactorGroupSubgroupTitle!: string | undefined;
    contactFirstName!: string | undefined;

    constructor(data?: IGetCharityPlanForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.charityPlan = data["charityPlan"] ? CharityPlanDto.fromJS(data["charityPlan"]) : <any>undefined;
            this.planConstTitle = data["planConstTitle"];
            this.benefactorGroupSubgroupTitle = data["benefactorGroupSubgroupTitle"];
            this.contactFirstName = data["contactFirstName"];
        }
    }

    static fromJS(data: any): GetCharityPlanForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCharityPlanForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["charityPlan"] = this.charityPlan ? this.charityPlan.toJSON() : <any>undefined;
        data["planConstTitle"] = this.planConstTitle;
        data["benefactorGroupSubgroupTitle"] = this.benefactorGroupSubgroupTitle;
        data["contactFirstName"] = this.contactFirstName;
        return data; 
    }
}

export interface IGetCharityPlanForViewDto {
    charityPlan: CharityPlanDto;
    planConstTitle: string | undefined;
    benefactorGroupSubgroupTitle: string | undefined;
    contactFirstName: string | undefined;
}

export class PagedResultDtoOfGetCharityPlanForViewDto implements IPagedResultDtoOfGetCharityPlanForViewDto {
    totalCount!: number;
    items!: GetCharityPlanForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCharityPlanForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetCharityPlanForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCharityPlanForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCharityPlanForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetCharityPlanForViewDto {
    totalCount: number;
    items: GetCharityPlanForViewDto[] | undefined;
}

export class CreateOrEditCharityPlanDto implements ICreateOrEditCharityPlanDto {
    targetNumber!: number | undefined;
    targetAmount!: number | undefined;
    isCash!: boolean;
    isContinuous!: boolean;
    hasOnlinePayment!: boolean;
    hasAttendancePayment!: boolean;
    isPublic!: boolean;
    state!: boolean;
    durationDate!: number | undefined;
    type!: CharityTypes;
    selectClient!: SelectClient;
    planConstId!: number;
    benefactorGroupSubgroupRef!: number | undefined;
    baseTimesRef!: string | undefined;
    contactRef!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCharityPlanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetNumber = data["targetNumber"];
            this.targetAmount = data["targetAmount"];
            this.isCash = data["isCash"];
            this.isContinuous = data["isContinuous"];
            this.hasOnlinePayment = data["hasOnlinePayment"];
            this.hasAttendancePayment = data["hasAttendancePayment"];
            this.isPublic = data["isPublic"];
            this.state = data["state"];
            this.durationDate = data["durationDate"];
            this.type = data["type"];
            this.selectClient = data["selectClient"];
            this.planConstId = data["planConstId"];
            this.benefactorGroupSubgroupRef = data["benefactorGroupSubgroupRef"];
            this.baseTimesRef = data["baseTimesRef"];
            this.contactRef = data["contactRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCharityPlanDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCharityPlanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetNumber"] = this.targetNumber;
        data["targetAmount"] = this.targetAmount;
        data["isCash"] = this.isCash;
        data["isContinuous"] = this.isContinuous;
        data["hasOnlinePayment"] = this.hasOnlinePayment;
        data["hasAttendancePayment"] = this.hasAttendancePayment;
        data["isPublic"] = this.isPublic;
        data["state"] = this.state;
        data["durationDate"] = this.durationDate;
        data["type"] = this.type;
        data["selectClient"] = this.selectClient;
        data["planConstId"] = this.planConstId;
        data["benefactorGroupSubgroupRef"] = this.benefactorGroupSubgroupRef;
        data["baseTimesRef"] = this.baseTimesRef;
        data["contactRef"] = this.contactRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditCharityPlanDto {
    targetNumber: number | undefined;
    targetAmount: number | undefined;
    isCash: boolean;
    isContinuous: boolean;
    hasOnlinePayment: boolean;
    hasAttendancePayment: boolean;
    isPublic: boolean;
    state: boolean;
    durationDate: number | undefined;
    type: CharityTypes;
    selectClient: SelectClient;
    planConstId: number;
    benefactorGroupSubgroupRef: number | undefined;
    baseTimesRef: string | undefined;
    contactRef: number | undefined;
    id: number | undefined;
}

export class GetCharityPlanForEditOutput implements IGetCharityPlanForEditOutput {
    charityPlan!: CreateOrEditCharityPlanDto;
    planConstTitle!: string | undefined;
    benefactorGroupSubgroupTitle!: string | undefined;
    contactFirstName!: string | undefined;

    constructor(data?: IGetCharityPlanForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.charityPlan = data["charityPlan"] ? CreateOrEditCharityPlanDto.fromJS(data["charityPlan"]) : <any>undefined;
            this.planConstTitle = data["planConstTitle"];
            this.benefactorGroupSubgroupTitle = data["benefactorGroupSubgroupTitle"];
            this.contactFirstName = data["contactFirstName"];
        }
    }

    static fromJS(data: any): GetCharityPlanForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCharityPlanForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["charityPlan"] = this.charityPlan ? this.charityPlan.toJSON() : <any>undefined;
        data["planConstTitle"] = this.planConstTitle;
        data["benefactorGroupSubgroupTitle"] = this.benefactorGroupSubgroupTitle;
        data["contactFirstName"] = this.contactFirstName;
        return data; 
    }
}

export interface IGetCharityPlanForEditOutput {
    charityPlan: CreateOrEditCharityPlanDto;
    planConstTitle: string | undefined;
    benefactorGroupSubgroupTitle: string | undefined;
    contactFirstName: string | undefined;
}

export class CharityPlanGroupSubgroupLookupTableDto implements ICharityPlanGroupSubgroupLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ICharityPlanGroupSubgroupLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): CharityPlanGroupSubgroupLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CharityPlanGroupSubgroupLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ICharityPlanGroupSubgroupLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfCharityPlanGroupSubgroupLookupTableDto implements IPagedResultDtoOfCharityPlanGroupSubgroupLookupTableDto {
    totalCount!: number;
    items!: CharityPlanGroupSubgroupLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCharityPlanGroupSubgroupLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(CharityPlanGroupSubgroupLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCharityPlanGroupSubgroupLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCharityPlanGroupSubgroupLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfCharityPlanGroupSubgroupLookupTableDto {
    totalCount: number;
    items: CharityPlanGroupSubgroupLookupTableDto[] | undefined;
}

export class CharityPlanBaseTimeLookupTableDto implements ICharityPlanBaseTimeLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ICharityPlanBaseTimeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): CharityPlanBaseTimeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CharityPlanBaseTimeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ICharityPlanBaseTimeLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class CharityPlanContactLookupTableDto implements ICharityPlanContactLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ICharityPlanContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): CharityPlanContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CharityPlanContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ICharityPlanContactLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class CharityPlanFamilyLookupTableDto implements ICharityPlanFamilyLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ICharityPlanFamilyLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): CharityPlanFamilyLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CharityPlanFamilyLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ICharityPlanFamilyLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class CharityPlanPlanConstLookupTableDto implements ICharityPlanPlanConstLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ICharityPlanPlanConstLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): CharityPlanPlanConstLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CharityPlanPlanConstLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ICharityPlanPlanConstLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export enum FriendshipState {
    Accepted = 1,
    Blocked = 2,
}

export class FriendDto implements IFriendDto {
    friendUserId!: number;
    friendTenantId!: number | undefined;
    friendUserName!: string | undefined;
    friendTenancyName!: string | undefined;
    friendProfilePictureId!: string | undefined;
    unreadMessageCount!: number;
    isOnline!: boolean;
    state!: FriendshipState;

    constructor(data?: IFriendDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.friendUserId = data["friendUserId"];
            this.friendTenantId = data["friendTenantId"];
            this.friendUserName = data["friendUserName"];
            this.friendTenancyName = data["friendTenancyName"];
            this.friendProfilePictureId = data["friendProfilePictureId"];
            this.unreadMessageCount = data["unreadMessageCount"];
            this.isOnline = data["isOnline"];
            this.state = data["state"];
        }
    }

    static fromJS(data: any): FriendDto {
        data = typeof data === 'object' ? data : {};
        let result = new FriendDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["friendUserId"] = this.friendUserId;
        data["friendTenantId"] = this.friendTenantId;
        data["friendUserName"] = this.friendUserName;
        data["friendTenancyName"] = this.friendTenancyName;
        data["friendProfilePictureId"] = this.friendProfilePictureId;
        data["unreadMessageCount"] = this.unreadMessageCount;
        data["isOnline"] = this.isOnline;
        data["state"] = this.state;
        return data; 
    }
}

export interface IFriendDto {
    friendUserId: number;
    friendTenantId: number | undefined;
    friendUserName: string | undefined;
    friendTenancyName: string | undefined;
    friendProfilePictureId: string | undefined;
    unreadMessageCount: number;
    isOnline: boolean;
    state: FriendshipState;
}

export class GetUserChatFriendsWithSettingsOutput implements IGetUserChatFriendsWithSettingsOutput {
    serverTime!: moment.Moment;
    friends!: FriendDto[] | undefined;

    constructor(data?: IGetUserChatFriendsWithSettingsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serverTime = data["serverTime"] ? moment(data["serverTime"].toString()) : <any>undefined;
            if (Array.isArray(data["friends"])) {
                this.friends = [] as any;
                for (let item of data["friends"])
                    this.friends!.push(FriendDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserChatFriendsWithSettingsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserChatFriendsWithSettingsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serverTime"] = this.serverTime ? this.serverTime.toISOString() : <any>undefined;
        if (Array.isArray(this.friends)) {
            data["friends"] = [];
            for (let item of this.friends)
                data["friends"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetUserChatFriendsWithSettingsOutput {
    serverTime: moment.Moment;
    friends: FriendDto[] | undefined;
}

export enum ChatSide {
    Sender = 1,
    Receiver = 2,
}

export enum ChatMessageReadState {
    Unread = 1,
    Read = 2,
}

export class ChatMessageDto implements IChatMessageDto {
    userId!: number;
    tenantId!: number | undefined;
    targetUserId!: number;
    targetTenantId!: number | undefined;
    side!: ChatSide;
    readState!: ChatMessageReadState;
    receiverReadState!: ChatMessageReadState;
    message!: string | undefined;
    creationTime!: moment.Moment;
    sharedMessageId!: string | undefined;
    id!: number;

    constructor(data?: IChatMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
            this.targetUserId = data["targetUserId"];
            this.targetTenantId = data["targetTenantId"];
            this.side = data["side"];
            this.readState = data["readState"];
            this.receiverReadState = data["receiverReadState"];
            this.message = data["message"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.sharedMessageId = data["sharedMessageId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ChatMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChatMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["targetUserId"] = this.targetUserId;
        data["targetTenantId"] = this.targetTenantId;
        data["side"] = this.side;
        data["readState"] = this.readState;
        data["receiverReadState"] = this.receiverReadState;
        data["message"] = this.message;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["sharedMessageId"] = this.sharedMessageId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IChatMessageDto {
    userId: number;
    tenantId: number | undefined;
    targetUserId: number;
    targetTenantId: number | undefined;
    side: ChatSide;
    readState: ChatMessageReadState;
    receiverReadState: ChatMessageReadState;
    message: string | undefined;
    creationTime: moment.Moment;
    sharedMessageId: string | undefined;
    id: number;
}

export class ListResultDtoOfChatMessageDto implements IListResultDtoOfChatMessageDto {
    items!: ChatMessageDto[] | undefined;

    constructor(data?: IListResultDtoOfChatMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(ChatMessageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfChatMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfChatMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfChatMessageDto {
    items: ChatMessageDto[] | undefined;
}

export class MarkAllUnreadMessagesOfUserAsReadInput implements IMarkAllUnreadMessagesOfUserAsReadInput {
    tenantId!: number | undefined;
    userId!: number;

    constructor(data?: IMarkAllUnreadMessagesOfUserAsReadInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
        }
    }

    static fromJS(data: any): MarkAllUnreadMessagesOfUserAsReadInput {
        data = typeof data === 'object' ? data : {};
        let result = new MarkAllUnreadMessagesOfUserAsReadInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data; 
    }
}

export interface IMarkAllUnreadMessagesOfUserAsReadInput {
    tenantId: number | undefined;
    userId: number;
}

export class CityDto implements ICityDto {
    name!: string | undefined;
    prefix!: string | undefined;
    longitude!: number;
    latitude!: number;
    state!: boolean | undefined;
    description!: string | undefined;
    socialSecurityCode!: string | undefined;
    taxCode!: string | undefined;
    stateId!: number;
    id!: number;

    constructor(data?: ICityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.prefix = data["prefix"];
            this.longitude = data["longitude"];
            this.latitude = data["latitude"];
            this.state = data["state"];
            this.description = data["description"];
            this.socialSecurityCode = data["socialSecurityCode"];
            this.taxCode = data["taxCode"];
            this.stateId = data["stateId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["prefix"] = this.prefix;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["state"] = this.state;
        data["description"] = this.description;
        data["socialSecurityCode"] = this.socialSecurityCode;
        data["taxCode"] = this.taxCode;
        data["stateId"] = this.stateId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICityDto {
    name: string | undefined;
    prefix: string | undefined;
    longitude: number;
    latitude: number;
    state: boolean | undefined;
    description: string | undefined;
    socialSecurityCode: string | undefined;
    taxCode: string | undefined;
    stateId: number;
    id: number;
}

export class GetCityForViewDto implements IGetCityForViewDto {
    city!: CityDto;
    stateName!: string | undefined;

    constructor(data?: IGetCityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.city = data["city"] ? CityDto.fromJS(data["city"]) : <any>undefined;
            this.stateName = data["stateName"];
        }
    }

    static fromJS(data: any): GetCityForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["city"] = this.city ? this.city.toJSON() : <any>undefined;
        data["stateName"] = this.stateName;
        return data; 
    }
}

export interface IGetCityForViewDto {
    city: CityDto;
    stateName: string | undefined;
}

export class PagedResultDtoOfGetCityForViewDto implements IPagedResultDtoOfGetCityForViewDto {
    totalCount!: number;
    items!: GetCityForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetCityForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCityForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetCityForViewDto {
    totalCount: number;
    items: GetCityForViewDto[] | undefined;
}

export class CreateOrEditCityDto implements ICreateOrEditCityDto {
    name!: string | undefined;
    prefix!: string | undefined;
    longitude!: number;
    latitude!: number;
    state!: boolean | undefined;
    description!: string | undefined;
    socialSecurityCode!: string | undefined;
    taxCode!: string | undefined;
    stateId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.prefix = data["prefix"];
            this.longitude = data["longitude"];
            this.latitude = data["latitude"];
            this.state = data["state"];
            this.description = data["description"];
            this.socialSecurityCode = data["socialSecurityCode"];
            this.taxCode = data["taxCode"];
            this.stateId = data["stateId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["prefix"] = this.prefix;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["state"] = this.state;
        data["description"] = this.description;
        data["socialSecurityCode"] = this.socialSecurityCode;
        data["taxCode"] = this.taxCode;
        data["stateId"] = this.stateId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditCityDto {
    name: string | undefined;
    prefix: string | undefined;
    longitude: number;
    latitude: number;
    state: boolean | undefined;
    description: string | undefined;
    socialSecurityCode: string | undefined;
    taxCode: string | undefined;
    stateId: number;
    id: number | undefined;
}

export class GetCityForEditOutput implements IGetCityForEditOutput {
    city!: CreateOrEditCityDto;
    stateName!: string | undefined;

    constructor(data?: IGetCityForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.city = data["city"] ? CreateOrEditCityDto.fromJS(data["city"]) : <any>undefined;
            this.stateName = data["stateName"];
        }
    }

    static fromJS(data: any): GetCityForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCityForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["city"] = this.city ? this.city.toJSON() : <any>undefined;
        data["stateName"] = this.stateName;
        return data; 
    }
}

export interface IGetCityForEditOutput {
    city: CreateOrEditCityDto;
    stateName: string | undefined;
}

export class CityStateLookupTableDto implements ICityStateLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ICityStateLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): CityStateLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CityStateLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ICityStateLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class CommentDto implements ICommentDto {
    comments!: string | undefined;
    isApproved!: boolean;
    isUnknown!: boolean;
    rate!: number | undefined;
    entity!: Entities;
    entityRef!: number;
    contactId!: number;
    replyToId!: number | undefined;
    id!: number;

    constructor(data?: ICommentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.comments = data["comments"];
            this.isApproved = data["isApproved"];
            this.isUnknown = data["isUnknown"];
            this.rate = data["rate"];
            this.entity = data["entity"];
            this.entityRef = data["entityRef"];
            this.contactId = data["contactId"];
            this.replyToId = data["replyToId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CommentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comments"] = this.comments;
        data["isApproved"] = this.isApproved;
        data["isUnknown"] = this.isUnknown;
        data["rate"] = this.rate;
        data["entity"] = this.entity;
        data["entityRef"] = this.entityRef;
        data["contactId"] = this.contactId;
        data["replyToId"] = this.replyToId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICommentDto {
    comments: string | undefined;
    isApproved: boolean;
    isUnknown: boolean;
    rate: number | undefined;
    entity: Entities;
    entityRef: number;
    contactId: number;
    replyToId: number | undefined;
    id: number;
}

export class GetCommentForViewDto implements IGetCommentForViewDto {
    comment!: CommentDto;
    contactFirstName!: string | undefined;
    commentComments!: string | undefined;
    entityRefTitle!: string | undefined;

    constructor(data?: IGetCommentForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.comment = data["comment"] ? CommentDto.fromJS(data["comment"]) : <any>undefined;
            this.contactFirstName = data["contactFirstName"];
            this.commentComments = data["commentComments"];
            this.entityRefTitle = data["entityRefTitle"];
        }
    }

    static fromJS(data: any): GetCommentForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCommentForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment ? this.comment.toJSON() : <any>undefined;
        data["contactFirstName"] = this.contactFirstName;
        data["commentComments"] = this.commentComments;
        data["entityRefTitle"] = this.entityRefTitle;
        return data; 
    }
}

export interface IGetCommentForViewDto {
    comment: CommentDto;
    contactFirstName: string | undefined;
    commentComments: string | undefined;
    entityRefTitle: string | undefined;
}

export class PagedResultDtoOfGetCommentForViewDto implements IPagedResultDtoOfGetCommentForViewDto {
    totalCount!: number;
    items!: GetCommentForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCommentForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetCommentForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCommentForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCommentForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetCommentForViewDto {
    totalCount: number;
    items: GetCommentForViewDto[] | undefined;
}

export class CreateOrEditCommentDto implements ICreateOrEditCommentDto {
    comments!: string | undefined;
    isApproved!: boolean;
    isUnknown!: boolean;
    rate!: number | undefined;
    entity!: Entities;
    entityRef!: number;
    contactId!: number;
    replyToId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCommentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.comments = data["comments"];
            this.isApproved = data["isApproved"];
            this.isUnknown = data["isUnknown"];
            this.rate = data["rate"];
            this.entity = data["entity"];
            this.entityRef = data["entityRef"];
            this.contactId = data["contactId"];
            this.replyToId = data["replyToId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCommentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCommentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comments"] = this.comments;
        data["isApproved"] = this.isApproved;
        data["isUnknown"] = this.isUnknown;
        data["rate"] = this.rate;
        data["entity"] = this.entity;
        data["entityRef"] = this.entityRef;
        data["contactId"] = this.contactId;
        data["replyToId"] = this.replyToId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditCommentDto {
    comments: string | undefined;
    isApproved: boolean;
    isUnknown: boolean;
    rate: number | undefined;
    entity: Entities;
    entityRef: number;
    contactId: number;
    replyToId: number | undefined;
    id: number | undefined;
}

export class GetCommentForEditOutput implements IGetCommentForEditOutput {
    comment!: CreateOrEditCommentDto;
    contactFirstName!: string | undefined;
    commentComments!: string | undefined;

    constructor(data?: IGetCommentForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.comment = data["comment"] ? CreateOrEditCommentDto.fromJS(data["comment"]) : <any>undefined;
            this.contactFirstName = data["contactFirstName"];
            this.commentComments = data["commentComments"];
        }
    }

    static fromJS(data: any): GetCommentForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCommentForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment ? this.comment.toJSON() : <any>undefined;
        data["contactFirstName"] = this.contactFirstName;
        data["commentComments"] = this.commentComments;
        return data; 
    }
}

export interface IGetCommentForEditOutput {
    comment: CreateOrEditCommentDto;
    contactFirstName: string | undefined;
    commentComments: string | undefined;
}

export class CreateCommentForShopDto implements ICreateCommentForShopDto {
    comments!: string | undefined;
    isUnknown!: boolean;
    rate!: number | undefined;
    entity!: Entities;
    entityRef!: number;
    id!: number | undefined;

    constructor(data?: ICreateCommentForShopDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.comments = data["comments"];
            this.isUnknown = data["isUnknown"];
            this.rate = data["rate"];
            this.entity = data["entity"];
            this.entityRef = data["entityRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateCommentForShopDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCommentForShopDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comments"] = this.comments;
        data["isUnknown"] = this.isUnknown;
        data["rate"] = this.rate;
        data["entity"] = this.entity;
        data["entityRef"] = this.entityRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateCommentForShopDto {
    comments: string | undefined;
    isUnknown: boolean;
    rate: number | undefined;
    entity: Entities;
    entityRef: number;
    id: number | undefined;
}

export class CommentContactLookupTableDto implements ICommentContactLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ICommentContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): CommentContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommentContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ICommentContactLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfCommentContactLookupTableDto implements IPagedResultDtoOfCommentContactLookupTableDto {
    totalCount!: number;
    items!: CommentContactLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCommentContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(CommentContactLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCommentContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCommentContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfCommentContactLookupTableDto {
    totalCount: number;
    items: CommentContactLookupTableDto[] | undefined;
}

export class CommentCommentLookupTableDto implements ICommentCommentLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ICommentCommentLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): CommentCommentLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommentCommentLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ICommentCommentLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfCommentCommentLookupTableDto implements IPagedResultDtoOfCommentCommentLookupTableDto {
    totalCount!: number;
    items!: CommentCommentLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCommentCommentLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(CommentCommentLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCommentCommentLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCommentCommentLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfCommentCommentLookupTableDto {
    totalCount: number;
    items: CommentCommentLookupTableDto[] | undefined;
}

export class CommodityDto implements ICommodityDto {
    code!: string | undefined;
    title!: string | undefined;
    barcode!: string | undefined;
    price!: number | undefined;
    commodityGroupRef!: number;
    inventory!: number | undefined;
    id!: number;

    constructor(data?: ICommodityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.title = data["title"];
            this.barcode = data["barcode"];
            this.price = data["price"];
            this.commodityGroupRef = data["commodityGroupRef"];
            this.inventory = data["inventory"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CommodityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommodityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["title"] = this.title;
        data["barcode"] = this.barcode;
        data["price"] = this.price;
        data["commodityGroupRef"] = this.commodityGroupRef;
        data["inventory"] = this.inventory;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICommodityDto {
    code: string | undefined;
    title: string | undefined;
    barcode: string | undefined;
    price: number | undefined;
    commodityGroupRef: number;
    inventory: number | undefined;
    id: number;
}

export class GetCommodityForViewDto implements IGetCommodityForViewDto {
    commodity!: CommodityDto;
    commodityGroupTitle!: string | undefined;

    constructor(data?: IGetCommodityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.commodity = data["commodity"] ? CommodityDto.fromJS(data["commodity"]) : <any>undefined;
            this.commodityGroupTitle = data["commodityGroupTitle"];
        }
    }

    static fromJS(data: any): GetCommodityForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCommodityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commodity"] = this.commodity ? this.commodity.toJSON() : <any>undefined;
        data["commodityGroupTitle"] = this.commodityGroupTitle;
        return data; 
    }
}

export interface IGetCommodityForViewDto {
    commodity: CommodityDto;
    commodityGroupTitle: string | undefined;
}

export class PagedResultDtoOfGetCommodityForViewDto implements IPagedResultDtoOfGetCommodityForViewDto {
    totalCount!: number;
    items!: GetCommodityForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCommodityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetCommodityForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCommodityForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCommodityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetCommodityForViewDto {
    totalCount: number;
    items: GetCommodityForViewDto[] | undefined;
}

export enum Units {
    Meter = 1,
    Kilogram = 2,
    Device = 3,
    Numbers = 4,
    Pack = 5,
}

export class GetCommoditiesDto implements IGetCommoditiesDto {
    totalAmount!: number | undefined;
    receivedAmount!: number | undefined;
    commodityGroupCode!: string | undefined;
    commodityGroupTitle!: string | undefined;
    commodityGroupId!: number;
    commodityGroupUnit!: Units;
    commodities!: CommodityDto[] | undefined;

    constructor(data?: IGetCommoditiesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalAmount = data["totalAmount"];
            this.receivedAmount = data["receivedAmount"];
            this.commodityGroupCode = data["commodityGroupCode"];
            this.commodityGroupTitle = data["commodityGroupTitle"];
            this.commodityGroupId = data["commodityGroupId"];
            this.commodityGroupUnit = data["commodityGroupUnit"];
            if (Array.isArray(data["commodities"])) {
                this.commodities = [] as any;
                for (let item of data["commodities"])
                    this.commodities!.push(CommodityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCommoditiesDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCommoditiesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalAmount"] = this.totalAmount;
        data["receivedAmount"] = this.receivedAmount;
        data["commodityGroupCode"] = this.commodityGroupCode;
        data["commodityGroupTitle"] = this.commodityGroupTitle;
        data["commodityGroupId"] = this.commodityGroupId;
        data["commodityGroupUnit"] = this.commodityGroupUnit;
        if (Array.isArray(this.commodities)) {
            data["commodities"] = [];
            for (let item of this.commodities)
                data["commodities"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetCommoditiesDto {
    totalAmount: number | undefined;
    receivedAmount: number | undefined;
    commodityGroupCode: string | undefined;
    commodityGroupTitle: string | undefined;
    commodityGroupId: number;
    commodityGroupUnit: Units;
    commodities: CommodityDto[] | undefined;
}

export class PagedResultDtoOfGetCommoditiesDto implements IPagedResultDtoOfGetCommoditiesDto {
    totalCount!: number;
    items!: GetCommoditiesDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCommoditiesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetCommoditiesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCommoditiesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCommoditiesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetCommoditiesDto {
    totalCount: number;
    items: GetCommoditiesDto[] | undefined;
}

export class CreateOrEditCommodityDto implements ICreateOrEditCommodityDto {
    code!: string | undefined;
    title!: string | undefined;
    barcode!: string | undefined;
    price!: number | undefined;
    commodityGroupRef!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCommodityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.title = data["title"];
            this.barcode = data["barcode"];
            this.price = data["price"];
            this.commodityGroupRef = data["commodityGroupRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCommodityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCommodityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["title"] = this.title;
        data["barcode"] = this.barcode;
        data["price"] = this.price;
        data["commodityGroupRef"] = this.commodityGroupRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditCommodityDto {
    code: string | undefined;
    title: string | undefined;
    barcode: string | undefined;
    price: number | undefined;
    commodityGroupRef: number;
    id: number | undefined;
}

export class GetCommodityForEditOutput implements IGetCommodityForEditOutput {
    commodity!: CreateOrEditCommodityDto;
    commodityGroupTitle!: string | undefined;

    constructor(data?: IGetCommodityForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.commodity = data["commodity"] ? CreateOrEditCommodityDto.fromJS(data["commodity"]) : <any>undefined;
            this.commodityGroupTitle = data["commodityGroupTitle"];
        }
    }

    static fromJS(data: any): GetCommodityForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCommodityForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commodity"] = this.commodity ? this.commodity.toJSON() : <any>undefined;
        data["commodityGroupTitle"] = this.commodityGroupTitle;
        return data; 
    }
}

export interface IGetCommodityForEditOutput {
    commodity: CreateOrEditCommodityDto;
    commodityGroupTitle: string | undefined;
}

export class CommodityCommodityGroupLookupTableDto implements ICommodityCommodityGroupLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ICommodityCommodityGroupLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): CommodityCommodityGroupLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommodityCommodityGroupLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ICommodityCommodityGroupLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfCommodityCommodityGroupLookupTableDto implements IPagedResultDtoOfCommodityCommodityGroupLookupTableDto {
    totalCount!: number;
    items!: CommodityCommodityGroupLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCommodityCommodityGroupLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(CommodityCommodityGroupLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCommodityCommodityGroupLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCommodityCommodityGroupLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfCommodityCommodityGroupLookupTableDto {
    totalCount: number;
    items: CommodityCommodityGroupLookupTableDto[] | undefined;
}

export class AllBranchLookupTableDto implements IAllBranchLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IAllBranchLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): AllBranchLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new AllBranchLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IAllBranchLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class CommodityBasketDetailDto implements ICommodityBasketDetailDto {
    amount!: number | undefined;
    commodityBasketRef!: number | undefined;
    commodityGroupRef!: number;
    id!: number;

    constructor(data?: ICommodityBasketDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.amount = data["amount"];
            this.commodityBasketRef = data["commodityBasketRef"];
            this.commodityGroupRef = data["commodityGroupRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CommodityBasketDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommodityBasketDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["commodityBasketRef"] = this.commodityBasketRef;
        data["commodityGroupRef"] = this.commodityGroupRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICommodityBasketDetailDto {
    amount: number | undefined;
    commodityBasketRef: number | undefined;
    commodityGroupRef: number;
    id: number;
}

export class GetCommodityBasketDetailForViewDto implements IGetCommodityBasketDetailForViewDto {
    commodityBasketDetail!: CommodityBasketDetailDto;
    commodityBasketTitle!: string | undefined;
    commodityGroupTitle!: string | undefined;

    constructor(data?: IGetCommodityBasketDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.commodityBasketDetail = data["commodityBasketDetail"] ? CommodityBasketDetailDto.fromJS(data["commodityBasketDetail"]) : <any>undefined;
            this.commodityBasketTitle = data["commodityBasketTitle"];
            this.commodityGroupTitle = data["commodityGroupTitle"];
        }
    }

    static fromJS(data: any): GetCommodityBasketDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCommodityBasketDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commodityBasketDetail"] = this.commodityBasketDetail ? this.commodityBasketDetail.toJSON() : <any>undefined;
        data["commodityBasketTitle"] = this.commodityBasketTitle;
        data["commodityGroupTitle"] = this.commodityGroupTitle;
        return data; 
    }
}

export interface IGetCommodityBasketDetailForViewDto {
    commodityBasketDetail: CommodityBasketDetailDto;
    commodityBasketTitle: string | undefined;
    commodityGroupTitle: string | undefined;
}

export class PagedResultDtoOfGetCommodityBasketDetailForViewDto implements IPagedResultDtoOfGetCommodityBasketDetailForViewDto {
    totalCount!: number;
    items!: GetCommodityBasketDetailForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCommodityBasketDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetCommodityBasketDetailForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCommodityBasketDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCommodityBasketDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetCommodityBasketDetailForViewDto {
    totalCount: number;
    items: GetCommodityBasketDetailForViewDto[] | undefined;
}

export class CreateOrEditCommodityBasketDetailDto implements ICreateOrEditCommodityBasketDetailDto {
    amount!: number | undefined;
    commodityBasketRef!: number | undefined;
    commodityGroupRef!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCommodityBasketDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.amount = data["amount"];
            this.commodityBasketRef = data["commodityBasketRef"];
            this.commodityGroupRef = data["commodityGroupRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCommodityBasketDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCommodityBasketDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["commodityBasketRef"] = this.commodityBasketRef;
        data["commodityGroupRef"] = this.commodityGroupRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditCommodityBasketDetailDto {
    amount: number | undefined;
    commodityBasketRef: number | undefined;
    commodityGroupRef: number;
    id: number | undefined;
}

export class GetCommodityBasketDetailForEditOutput implements IGetCommodityBasketDetailForEditOutput {
    commodityBasketDetail!: CreateOrEditCommodityBasketDetailDto;
    commodityBasketTitle!: string | undefined;
    commodityGroupTitle!: string | undefined;

    constructor(data?: IGetCommodityBasketDetailForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.commodityBasketDetail = data["commodityBasketDetail"] ? CreateOrEditCommodityBasketDetailDto.fromJS(data["commodityBasketDetail"]) : <any>undefined;
            this.commodityBasketTitle = data["commodityBasketTitle"];
            this.commodityGroupTitle = data["commodityGroupTitle"];
        }
    }

    static fromJS(data: any): GetCommodityBasketDetailForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCommodityBasketDetailForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commodityBasketDetail"] = this.commodityBasketDetail ? this.commodityBasketDetail.toJSON() : <any>undefined;
        data["commodityBasketTitle"] = this.commodityBasketTitle;
        data["commodityGroupTitle"] = this.commodityGroupTitle;
        return data; 
    }
}

export interface IGetCommodityBasketDetailForEditOutput {
    commodityBasketDetail: CreateOrEditCommodityBasketDetailDto;
    commodityBasketTitle: string | undefined;
    commodityGroupTitle: string | undefined;
}

export class CommodityBasketDetailCommodityBasketLookupTableDto implements ICommodityBasketDetailCommodityBasketLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ICommodityBasketDetailCommodityBasketLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): CommodityBasketDetailCommodityBasketLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommodityBasketDetailCommodityBasketLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ICommodityBasketDetailCommodityBasketLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfCommodityBasketDetailCommodityBasketLookupTableDto implements IPagedResultDtoOfCommodityBasketDetailCommodityBasketLookupTableDto {
    totalCount!: number;
    items!: CommodityBasketDetailCommodityBasketLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCommodityBasketDetailCommodityBasketLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(CommodityBasketDetailCommodityBasketLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCommodityBasketDetailCommodityBasketLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCommodityBasketDetailCommodityBasketLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfCommodityBasketDetailCommodityBasketLookupTableDto {
    totalCount: number;
    items: CommodityBasketDetailCommodityBasketLookupTableDto[] | undefined;
}

export class CommodityBasketDetailCommodityLookupTableDto implements ICommodityBasketDetailCommodityLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ICommodityBasketDetailCommodityLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): CommodityBasketDetailCommodityLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommodityBasketDetailCommodityLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ICommodityBasketDetailCommodityLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfCommodityBasketDetailCommodityLookupTableDto implements IPagedResultDtoOfCommodityBasketDetailCommodityLookupTableDto {
    totalCount!: number;
    items!: CommodityBasketDetailCommodityLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCommodityBasketDetailCommodityLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(CommodityBasketDetailCommodityLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCommodityBasketDetailCommodityLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCommodityBasketDetailCommodityLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfCommodityBasketDetailCommodityLookupTableDto {
    totalCount: number;
    items: CommodityBasketDetailCommodityLookupTableDto[] | undefined;
}

export class CommodityBasketDetailCommodityGroupLookupTableDto implements ICommodityBasketDetailCommodityGroupLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ICommodityBasketDetailCommodityGroupLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): CommodityBasketDetailCommodityGroupLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommodityBasketDetailCommodityGroupLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ICommodityBasketDetailCommodityGroupLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfCommodityBasketDetailCommodityGroupLookupTableDto implements IPagedResultDtoOfCommodityBasketDetailCommodityGroupLookupTableDto {
    totalCount!: number;
    items!: CommodityBasketDetailCommodityGroupLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCommodityBasketDetailCommodityGroupLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(CommodityBasketDetailCommodityGroupLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCommodityBasketDetailCommodityGroupLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCommodityBasketDetailCommodityGroupLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfCommodityBasketDetailCommodityGroupLookupTableDto {
    totalCount: number;
    items: CommodityBasketDetailCommodityGroupLookupTableDto[] | undefined;
}

export class CommodityBasketDto implements ICommodityBasketDto {
    title!: string | undefined;
    code!: string | undefined;
    description!: string | undefined;
    defaultValue!: string | undefined;
    id!: number;

    constructor(data?: ICommodityBasketDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.code = data["code"];
            this.description = data["description"];
            this.defaultValue = data["defaultValue"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CommodityBasketDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommodityBasketDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["code"] = this.code;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICommodityBasketDto {
    title: string | undefined;
    code: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    id: number;
}

export class GetCommodityBasketForViewDto implements IGetCommodityBasketForViewDto {
    commodityBasket!: CommodityBasketDto;

    constructor(data?: IGetCommodityBasketForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.commodityBasket = data["commodityBasket"] ? CommodityBasketDto.fromJS(data["commodityBasket"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCommodityBasketForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCommodityBasketForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commodityBasket"] = this.commodityBasket ? this.commodityBasket.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetCommodityBasketForViewDto {
    commodityBasket: CommodityBasketDto;
}

export class PagedResultDtoOfGetCommodityBasketForViewDto implements IPagedResultDtoOfGetCommodityBasketForViewDto {
    totalCount!: number;
    items!: GetCommodityBasketForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCommodityBasketForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetCommodityBasketForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCommodityBasketForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCommodityBasketForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetCommodityBasketForViewDto {
    totalCount: number;
    items: GetCommodityBasketForViewDto[] | undefined;
}

export class CreateOrEditCommodityBasketDto implements ICreateOrEditCommodityBasketDto {
    title!: string | undefined;
    code!: string | undefined;
    description!: string | undefined;
    defaultValue!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCommodityBasketDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.code = data["code"];
            this.description = data["description"];
            this.defaultValue = data["defaultValue"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCommodityBasketDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCommodityBasketDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["code"] = this.code;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditCommodityBasketDto {
    title: string | undefined;
    code: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    id: number | undefined;
}

export class GetCommodityBasketForEditOutput implements IGetCommodityBasketForEditOutput {
    commodityBasket!: CreateOrEditCommodityBasketDto;

    constructor(data?: IGetCommodityBasketForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.commodityBasket = data["commodityBasket"] ? CreateOrEditCommodityBasketDto.fromJS(data["commodityBasket"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCommodityBasketForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCommodityBasketForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commodityBasket"] = this.commodityBasket ? this.commodityBasket.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetCommodityBasketForEditOutput {
    commodityBasket: CreateOrEditCommodityBasketDto;
}

export class CreateOrEditCommodityBasketAndDetailsDto implements ICreateOrEditCommodityBasketAndDetailsDto {
    commodityBasket!: CreateOrEditCommodityBasketDto;
    commodityBasketDetails!: CreateOrEditCommodityBasketDetailDto[] | undefined;

    constructor(data?: ICreateOrEditCommodityBasketAndDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.commodityBasket = data["commodityBasket"] ? CreateOrEditCommodityBasketDto.fromJS(data["commodityBasket"]) : <any>undefined;
            if (Array.isArray(data["commodityBasketDetails"])) {
                this.commodityBasketDetails = [] as any;
                for (let item of data["commodityBasketDetails"])
                    this.commodityBasketDetails!.push(CreateOrEditCommodityBasketDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrEditCommodityBasketAndDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCommodityBasketAndDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commodityBasket"] = this.commodityBasket ? this.commodityBasket.toJSON() : <any>undefined;
        if (Array.isArray(this.commodityBasketDetails)) {
            data["commodityBasketDetails"] = [];
            for (let item of this.commodityBasketDetails)
                data["commodityBasketDetails"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateOrEditCommodityBasketAndDetailsDto {
    commodityBasket: CreateOrEditCommodityBasketDto;
    commodityBasketDetails: CreateOrEditCommodityBasketDetailDto[] | undefined;
}

export class CommodityGroupDto implements ICommodityGroupDto {
    title!: string | undefined;
    code!: string | undefined;
    unit!: Units;
    id!: number;

    constructor(data?: ICommodityGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.code = data["code"];
            this.unit = data["unit"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CommodityGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommodityGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["code"] = this.code;
        data["unit"] = this.unit;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICommodityGroupDto {
    title: string | undefined;
    code: string | undefined;
    unit: Units;
    id: number;
}

export class GetCommodityGroupForViewDto implements IGetCommodityGroupForViewDto {
    commodityGroup!: CommodityGroupDto;

    constructor(data?: IGetCommodityGroupForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.commodityGroup = data["commodityGroup"] ? CommodityGroupDto.fromJS(data["commodityGroup"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCommodityGroupForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCommodityGroupForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commodityGroup"] = this.commodityGroup ? this.commodityGroup.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetCommodityGroupForViewDto {
    commodityGroup: CommodityGroupDto;
}

export class PagedResultDtoOfGetCommodityGroupForViewDto implements IPagedResultDtoOfGetCommodityGroupForViewDto {
    totalCount!: number;
    items!: GetCommodityGroupForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCommodityGroupForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetCommodityGroupForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCommodityGroupForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCommodityGroupForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetCommodityGroupForViewDto {
    totalCount: number;
    items: GetCommodityGroupForViewDto[] | undefined;
}

export class CreateOrEditCommodityGroupDto implements ICreateOrEditCommodityGroupDto {
    title!: string | undefined;
    code!: string | undefined;
    unit!: Units;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCommodityGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.code = data["code"];
            this.unit = data["unit"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCommodityGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCommodityGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["code"] = this.code;
        data["unit"] = this.unit;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditCommodityGroupDto {
    title: string | undefined;
    code: string | undefined;
    unit: Units;
    id: number | undefined;
}

export class GetCommodityGroupForEditOutput implements IGetCommodityGroupForEditOutput {
    commodityGroup!: CreateOrEditCommodityGroupDto;

    constructor(data?: IGetCommodityGroupForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.commodityGroup = data["commodityGroup"] ? CreateOrEditCommodityGroupDto.fromJS(data["commodityGroup"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCommodityGroupForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCommodityGroupForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commodityGroup"] = this.commodityGroup ? this.commodityGroup.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetCommodityGroupForEditOutput {
    commodityGroup: CreateOrEditCommodityGroupDto;
}

export class SubscribableEditionComboboxItemDto implements ISubscribableEditionComboboxItemDto {
    isFree!: boolean | undefined;
    value!: string | undefined;
    displayText!: string | undefined;
    isSelected!: boolean;

    constructor(data?: ISubscribableEditionComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isFree = data["isFree"];
            this.value = data["value"];
            this.displayText = data["displayText"];
            this.isSelected = data["isSelected"];
        }
    }

    static fromJS(data: any): SubscribableEditionComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFree"] = this.isFree;
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data; 
    }
}

export interface ISubscribableEditionComboboxItemDto {
    isFree: boolean | undefined;
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean;
}

export class ListResultDtoOfSubscribableEditionComboboxItemDto implements IListResultDtoOfSubscribableEditionComboboxItemDto {
    items!: SubscribableEditionComboboxItemDto[] | undefined;

    constructor(data?: IListResultDtoOfSubscribableEditionComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(SubscribableEditionComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfSubscribableEditionComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfSubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfSubscribableEditionComboboxItemDto {
    items: SubscribableEditionComboboxItemDto[] | undefined;
}

export class FindUsersInput implements IFindUsersInput {
    tenantId!: number | undefined;
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | undefined;

    constructor(data?: IFindUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.maxResultCount = data["maxResultCount"];
            this.skipCount = data["skipCount"];
            this.filter = data["filter"];
        }
    }

    static fromJS(data: any): FindUsersInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data; 
    }
}

export interface IFindUsersInput {
    tenantId: number | undefined;
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
}

export class PagedResultDtoOfNameValueDto implements IPagedResultDtoOfNameValueDto {
    totalCount!: number;
    items!: NameValueDto[] | undefined;

    constructor(data?: IPagedResultDtoOfNameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfNameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfNameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfNameValueDto {
    totalCount: number;
    items: NameValueDto[] | undefined;
}

export class GetDefaultEditionNameOutput implements IGetDefaultEditionNameOutput {
    name!: string | undefined;

    constructor(data?: IGetDefaultEditionNameOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GetDefaultEditionNameOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDefaultEditionNameOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data; 
    }
}

export interface IGetDefaultEditionNameOutput {
    name: string | undefined;
}

export class ConditionDto implements IConditionDto {
    title!: string | undefined;
    code!: string | undefined;
    fileCode!: string | undefined;
    description!: string | undefined;
    entity!: Entities;
    property!: string | undefined;
    dataType!: DataType;
    id!: number;

    constructor(data?: IConditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.code = data["code"];
            this.fileCode = data["fileCode"];
            this.description = data["description"];
            this.entity = data["entity"];
            this.property = data["property"];
            this.dataType = data["dataType"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ConditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["code"] = this.code;
        data["fileCode"] = this.fileCode;
        data["description"] = this.description;
        data["entity"] = this.entity;
        data["property"] = this.property;
        data["dataType"] = this.dataType;
        data["id"] = this.id;
        return data; 
    }
}

export interface IConditionDto {
    title: string | undefined;
    code: string | undefined;
    fileCode: string | undefined;
    description: string | undefined;
    entity: Entities;
    property: string | undefined;
    dataType: DataType;
    id: number;
}

export class GetConditionForViewDto implements IGetConditionForViewDto {
    condition!: ConditionDto;

    constructor(data?: IGetConditionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.condition = data["condition"] ? ConditionDto.fromJS(data["condition"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetConditionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetConditionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["condition"] = this.condition ? this.condition.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetConditionForViewDto {
    condition: ConditionDto;
}

export class PagedResultDtoOfGetConditionForViewDto implements IPagedResultDtoOfGetConditionForViewDto {
    totalCount!: number;
    items!: GetConditionForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetConditionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetConditionForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetConditionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetConditionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetConditionForViewDto {
    totalCount: number;
    items: GetConditionForViewDto[] | undefined;
}

export class CreateOrEditConditionDto implements ICreateOrEditConditionDto {
    title!: string | undefined;
    code!: string | undefined;
    fileCode!: string | undefined;
    description!: string | undefined;
    entity!: Entities;
    property!: string | undefined;
    dataType!: DataType;
    id!: number | undefined;

    constructor(data?: ICreateOrEditConditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.code = data["code"];
            this.fileCode = data["fileCode"];
            this.description = data["description"];
            this.entity = data["entity"];
            this.property = data["property"];
            this.dataType = data["dataType"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditConditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditConditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["code"] = this.code;
        data["fileCode"] = this.fileCode;
        data["description"] = this.description;
        data["entity"] = this.entity;
        data["property"] = this.property;
        data["dataType"] = this.dataType;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditConditionDto {
    title: string | undefined;
    code: string | undefined;
    fileCode: string | undefined;
    description: string | undefined;
    entity: Entities;
    property: string | undefined;
    dataType: DataType;
    id: number | undefined;
}

export class GetConditionForEditOutput implements IGetConditionForEditOutput {
    condition!: CreateOrEditConditionDto;

    constructor(data?: IGetConditionForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.condition = data["condition"] ? CreateOrEditConditionDto.fromJS(data["condition"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetConditionForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetConditionForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["condition"] = this.condition ? this.condition.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetConditionForEditOutput {
    condition: CreateOrEditConditionDto;
}

export class GetEntityPropertiesDto implements IGetEntityPropertiesDto {
    propertyName!: string | undefined;
    propertyType!: DataType;

    constructor(data?: IGetEntityPropertiesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.propertyName = data["propertyName"];
            this.propertyType = data["propertyType"];
        }
    }

    static fromJS(data: any): GetEntityPropertiesDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEntityPropertiesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName;
        data["propertyType"] = this.propertyType;
        return data; 
    }
}

export interface IGetEntityPropertiesDto {
    propertyName: string | undefined;
    propertyType: DataType;
}

export class ConditionAttributeLookupTableDto implements IConditionAttributeLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    propertyType!: DataType;

    constructor(data?: IConditionAttributeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.propertyType = data["propertyType"];
        }
    }

    static fromJS(data: any): ConditionAttributeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConditionAttributeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["propertyType"] = this.propertyType;
        return data; 
    }
}

export interface IConditionAttributeLookupTableDto {
    id: number;
    displayName: string | undefined;
    propertyType: DataType;
}

export class CondolenceMessageDto implements ICondolenceMessageDto {
    message!: string | undefined;
    isApproved!: boolean;
    isDefault!: boolean;
    contactId!: number;
    deceasedId!: number;
    replyToId!: number | undefined;
    id!: number;

    constructor(data?: ICondolenceMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"];
            this.isApproved = data["isApproved"];
            this.isDefault = data["isDefault"];
            this.contactId = data["contactId"];
            this.deceasedId = data["deceasedId"];
            this.replyToId = data["replyToId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CondolenceMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CondolenceMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["isApproved"] = this.isApproved;
        data["isDefault"] = this.isDefault;
        data["contactId"] = this.contactId;
        data["deceasedId"] = this.deceasedId;
        data["replyToId"] = this.replyToId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICondolenceMessageDto {
    message: string | undefined;
    isApproved: boolean;
    isDefault: boolean;
    contactId: number;
    deceasedId: number;
    replyToId: number | undefined;
    id: number;
}

export class GetCondolenceMessageForViewDto implements IGetCondolenceMessageForViewDto {
    condolenceMessage!: CondolenceMessageDto;
    contactFirstName!: string | undefined;
    deceasedFirstName!: string | undefined;
    condolenceMessageMessage!: string | undefined;

    constructor(data?: IGetCondolenceMessageForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.condolenceMessage = data["condolenceMessage"] ? CondolenceMessageDto.fromJS(data["condolenceMessage"]) : <any>undefined;
            this.contactFirstName = data["contactFirstName"];
            this.deceasedFirstName = data["deceasedFirstName"];
            this.condolenceMessageMessage = data["condolenceMessageMessage"];
        }
    }

    static fromJS(data: any): GetCondolenceMessageForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCondolenceMessageForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["condolenceMessage"] = this.condolenceMessage ? this.condolenceMessage.toJSON() : <any>undefined;
        data["contactFirstName"] = this.contactFirstName;
        data["deceasedFirstName"] = this.deceasedFirstName;
        data["condolenceMessageMessage"] = this.condolenceMessageMessage;
        return data; 
    }
}

export interface IGetCondolenceMessageForViewDto {
    condolenceMessage: CondolenceMessageDto;
    contactFirstName: string | undefined;
    deceasedFirstName: string | undefined;
    condolenceMessageMessage: string | undefined;
}

export class PagedResultDtoOfGetCondolenceMessageForViewDto implements IPagedResultDtoOfGetCondolenceMessageForViewDto {
    totalCount!: number;
    items!: GetCondolenceMessageForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCondolenceMessageForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetCondolenceMessageForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCondolenceMessageForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCondolenceMessageForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetCondolenceMessageForViewDto {
    totalCount: number;
    items: GetCondolenceMessageForViewDto[] | undefined;
}

export class CreateOrEditCondolenceMessageDto implements ICreateOrEditCondolenceMessageDto {
    message!: string | undefined;
    isApproved!: boolean;
    isDefault!: boolean;
    contactId!: number | undefined;
    deceasedId!: number;
    replyToId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCondolenceMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"];
            this.isApproved = data["isApproved"];
            this.isDefault = data["isDefault"];
            this.contactId = data["contactId"];
            this.deceasedId = data["deceasedId"];
            this.replyToId = data["replyToId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCondolenceMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCondolenceMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["isApproved"] = this.isApproved;
        data["isDefault"] = this.isDefault;
        data["contactId"] = this.contactId;
        data["deceasedId"] = this.deceasedId;
        data["replyToId"] = this.replyToId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditCondolenceMessageDto {
    message: string | undefined;
    isApproved: boolean;
    isDefault: boolean;
    contactId: number | undefined;
    deceasedId: number;
    replyToId: number | undefined;
    id: number | undefined;
}

export class GetCondolenceMessageForEditOutput implements IGetCondolenceMessageForEditOutput {
    condolenceMessage!: CreateOrEditCondolenceMessageDto;
    contactFirstName!: string | undefined;
    deceasedFirstName!: string | undefined;
    condolenceMessageMessage!: string | undefined;

    constructor(data?: IGetCondolenceMessageForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.condolenceMessage = data["condolenceMessage"] ? CreateOrEditCondolenceMessageDto.fromJS(data["condolenceMessage"]) : <any>undefined;
            this.contactFirstName = data["contactFirstName"];
            this.deceasedFirstName = data["deceasedFirstName"];
            this.condolenceMessageMessage = data["condolenceMessageMessage"];
        }
    }

    static fromJS(data: any): GetCondolenceMessageForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCondolenceMessageForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["condolenceMessage"] = this.condolenceMessage ? this.condolenceMessage.toJSON() : <any>undefined;
        data["contactFirstName"] = this.contactFirstName;
        data["deceasedFirstName"] = this.deceasedFirstName;
        data["condolenceMessageMessage"] = this.condolenceMessageMessage;
        return data; 
    }
}

export interface IGetCondolenceMessageForEditOutput {
    condolenceMessage: CreateOrEditCondolenceMessageDto;
    contactFirstName: string | undefined;
    deceasedFirstName: string | undefined;
    condolenceMessageMessage: string | undefined;
}

export class GetCondolenceMessageForShopDto implements IGetCondolenceMessageForShopDto {
    id!: number;
    name!: string | undefined;
    date!: moment.Moment;
    image!: string | undefined;
    message!: string | undefined;

    constructor(data?: IGetCondolenceMessageForShopDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.image = data["image"];
            this.message = data["message"];
        }
    }

    static fromJS(data: any): GetCondolenceMessageForShopDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCondolenceMessageForShopDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["image"] = this.image;
        data["message"] = this.message;
        return data; 
    }
}

export interface IGetCondolenceMessageForShopDto {
    id: number;
    name: string | undefined;
    date: moment.Moment;
    image: string | undefined;
    message: string | undefined;
}

export class PagedResultDtoOfGetCondolenceMessageForShopDto implements IPagedResultDtoOfGetCondolenceMessageForShopDto {
    totalCount!: number;
    items!: GetCondolenceMessageForShopDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCondolenceMessageForShopDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetCondolenceMessageForShopDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCondolenceMessageForShopDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCondolenceMessageForShopDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetCondolenceMessageForShopDto {
    totalCount: number;
    items: GetCondolenceMessageForShopDto[] | undefined;
}

export class CondolenceMessageContactLookupTableDto implements ICondolenceMessageContactLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ICondolenceMessageContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): CondolenceMessageContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CondolenceMessageContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ICondolenceMessageContactLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfCondolenceMessageContactLookupTableDto implements IPagedResultDtoOfCondolenceMessageContactLookupTableDto {
    totalCount!: number;
    items!: CondolenceMessageContactLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCondolenceMessageContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(CondolenceMessageContactLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCondolenceMessageContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCondolenceMessageContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfCondolenceMessageContactLookupTableDto {
    totalCount: number;
    items: CondolenceMessageContactLookupTableDto[] | undefined;
}

export class CondolenceMessageDeceasedLookupTableDto implements ICondolenceMessageDeceasedLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ICondolenceMessageDeceasedLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): CondolenceMessageDeceasedLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CondolenceMessageDeceasedLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ICondolenceMessageDeceasedLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfCondolenceMessageDeceasedLookupTableDto implements IPagedResultDtoOfCondolenceMessageDeceasedLookupTableDto {
    totalCount!: number;
    items!: CondolenceMessageDeceasedLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCondolenceMessageDeceasedLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(CondolenceMessageDeceasedLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCondolenceMessageDeceasedLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCondolenceMessageDeceasedLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfCondolenceMessageDeceasedLookupTableDto {
    totalCount: number;
    items: CondolenceMessageDeceasedLookupTableDto[] | undefined;
}

export class CondolenceMessageCondolenceMessageLookupTableDto implements ICondolenceMessageCondolenceMessageLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ICondolenceMessageCondolenceMessageLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): CondolenceMessageCondolenceMessageLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CondolenceMessageCondolenceMessageLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ICondolenceMessageCondolenceMessageLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfCondolenceMessageCondolenceMessageLookupTableDto implements IPagedResultDtoOfCondolenceMessageCondolenceMessageLookupTableDto {
    totalCount!: number;
    items!: CondolenceMessageCondolenceMessageLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCondolenceMessageCondolenceMessageLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(CondolenceMessageCondolenceMessageLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCondolenceMessageCondolenceMessageLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCondolenceMessageCondolenceMessageLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfCondolenceMessageCondolenceMessageLookupTableDto {
    totalCount: number;
    items: CondolenceMessageCondolenceMessageLookupTableDto[] | undefined;
}

export enum BelongTo {
    Default = 0,
    Family = 1,
    Orphan = 2,
    Supervisor = 3,
}

export class ConsumeDto implements IConsumeDto {
    name!: string | undefined;
    accountCode!: string | undefined;
    minAllowedOnePersonInYear!: number | undefined;
    maxAllowedOnePersonInYear!: number | undefined;
    minAge!: number | undefined;
    maxAge!: number | undefined;
    state!: boolean | undefined;
    description!: string | undefined;
    genderCondition!: Gender;
    seyed!: boolean | undefined;
    belong!: BelongTo;
    id!: number;

    constructor(data?: IConsumeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.accountCode = data["accountCode"];
            this.minAllowedOnePersonInYear = data["minAllowedOnePersonInYear"];
            this.maxAllowedOnePersonInYear = data["maxAllowedOnePersonInYear"];
            this.minAge = data["minAge"];
            this.maxAge = data["maxAge"];
            this.state = data["state"];
            this.description = data["description"];
            this.genderCondition = data["genderCondition"];
            this.seyed = data["seyed"];
            this.belong = data["belong"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ConsumeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["accountCode"] = this.accountCode;
        data["minAllowedOnePersonInYear"] = this.minAllowedOnePersonInYear;
        data["maxAllowedOnePersonInYear"] = this.maxAllowedOnePersonInYear;
        data["minAge"] = this.minAge;
        data["maxAge"] = this.maxAge;
        data["state"] = this.state;
        data["description"] = this.description;
        data["genderCondition"] = this.genderCondition;
        data["seyed"] = this.seyed;
        data["belong"] = this.belong;
        data["id"] = this.id;
        return data; 
    }
}

export interface IConsumeDto {
    name: string | undefined;
    accountCode: string | undefined;
    minAllowedOnePersonInYear: number | undefined;
    maxAllowedOnePersonInYear: number | undefined;
    minAge: number | undefined;
    maxAge: number | undefined;
    state: boolean | undefined;
    description: string | undefined;
    genderCondition: Gender;
    seyed: boolean | undefined;
    belong: BelongTo;
    id: number;
}

export class GetConsumeForViewDto implements IGetConsumeForViewDto {
    consume!: ConsumeDto;

    constructor(data?: IGetConsumeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.consume = data["consume"] ? ConsumeDto.fromJS(data["consume"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetConsumeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetConsumeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consume"] = this.consume ? this.consume.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetConsumeForViewDto {
    consume: ConsumeDto;
}

export class PagedResultDtoOfGetConsumeForViewDto implements IPagedResultDtoOfGetConsumeForViewDto {
    totalCount!: number;
    items!: GetConsumeForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetConsumeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetConsumeForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetConsumeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetConsumeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetConsumeForViewDto {
    totalCount: number;
    items: GetConsumeForViewDto[] | undefined;
}

export class CreateOrEditConsumeDto implements ICreateOrEditConsumeDto {
    name!: string | undefined;
    accountCode!: string | undefined;
    minAllowedOnePersonInYear!: number | undefined;
    maxAllowedOnePersonInYear!: number | undefined;
    minAge!: number | undefined;
    maxAge!: number | undefined;
    state!: boolean;
    description!: string | undefined;
    genderCondition!: Gender;
    seyed!: boolean | undefined;
    belong!: BelongTo;
    id!: number | undefined;

    constructor(data?: ICreateOrEditConsumeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.accountCode = data["accountCode"];
            this.minAllowedOnePersonInYear = data["minAllowedOnePersonInYear"];
            this.maxAllowedOnePersonInYear = data["maxAllowedOnePersonInYear"];
            this.minAge = data["minAge"];
            this.maxAge = data["maxAge"];
            this.state = data["state"];
            this.description = data["description"];
            this.genderCondition = data["genderCondition"];
            this.seyed = data["seyed"];
            this.belong = data["belong"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditConsumeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditConsumeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["accountCode"] = this.accountCode;
        data["minAllowedOnePersonInYear"] = this.minAllowedOnePersonInYear;
        data["maxAllowedOnePersonInYear"] = this.maxAllowedOnePersonInYear;
        data["minAge"] = this.minAge;
        data["maxAge"] = this.maxAge;
        data["state"] = this.state;
        data["description"] = this.description;
        data["genderCondition"] = this.genderCondition;
        data["seyed"] = this.seyed;
        data["belong"] = this.belong;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditConsumeDto {
    name: string | undefined;
    accountCode: string | undefined;
    minAllowedOnePersonInYear: number | undefined;
    maxAllowedOnePersonInYear: number | undefined;
    minAge: number | undefined;
    maxAge: number | undefined;
    state: boolean;
    description: string | undefined;
    genderCondition: Gender;
    seyed: boolean | undefined;
    belong: BelongTo;
    id: number | undefined;
}

export class CreateOrEditTagDto implements ICreateOrEditTagDto {
    title!: string | undefined;
    entity!: Entities;
    entityRef!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.entity = data["entity"];
            this.entityRef = data["entityRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["entity"] = this.entity;
        data["entityRef"] = this.entityRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditTagDto {
    title: string | undefined;
    entity: Entities;
    entityRef: number;
    id: number | undefined;
}

export class GetConsumeForEditOutput implements IGetConsumeForEditOutput {
    consume!: CreateOrEditConsumeDto;
    tags!: CreateOrEditTagDto[] | undefined;

    constructor(data?: IGetConsumeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.consume = data["consume"] ? CreateOrEditConsumeDto.fromJS(data["consume"]) : <any>undefined;
            if (Array.isArray(data["tags"])) {
                this.tags = [] as any;
                for (let item of data["tags"])
                    this.tags!.push(CreateOrEditTagDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetConsumeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetConsumeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consume"] = this.consume ? this.consume.toJSON() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetConsumeForEditOutput {
    consume: CreateOrEditConsumeDto;
    tags: CreateOrEditTagDto[] | undefined;
}

export class CreateOrEditConsumeAndTagsDto implements ICreateOrEditConsumeAndTagsDto {
    consume!: CreateOrEditConsumeDto;
    tags!: CreateOrEditTagDto[] | undefined;

    constructor(data?: ICreateOrEditConsumeAndTagsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.consume = data["consume"] ? CreateOrEditConsumeDto.fromJS(data["consume"]) : <any>undefined;
            if (Array.isArray(data["tags"])) {
                this.tags = [] as any;
                for (let item of data["tags"])
                    this.tags!.push(CreateOrEditTagDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrEditConsumeAndTagsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditConsumeAndTagsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consume"] = this.consume ? this.consume.toJSON() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateOrEditConsumeAndTagsDto {
    consume: CreateOrEditConsumeDto;
    tags: CreateOrEditTagDto[] | undefined;
}

export class ConsumesAndSourceDto implements IConsumesAndSourceDto {
    isCanUse!: boolean;
    description!: string | undefined;
    state!: boolean;
    sourceId!: number;
    consumeId!: string | undefined;
    id!: number;

    constructor(data?: IConsumesAndSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isCanUse = data["isCanUse"];
            this.description = data["description"];
            this.state = data["state"];
            this.sourceId = data["sourceId"];
            this.consumeId = data["consumeId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ConsumesAndSourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumesAndSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCanUse"] = this.isCanUse;
        data["description"] = this.description;
        data["state"] = this.state;
        data["sourceId"] = this.sourceId;
        data["consumeId"] = this.consumeId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IConsumesAndSourceDto {
    isCanUse: boolean;
    description: string | undefined;
    state: boolean;
    sourceId: number;
    consumeId: string | undefined;
    id: number;
}

export class GetConsumesAndSourceForViewDto implements IGetConsumesAndSourceForViewDto {
    consumesAndSource!: ConsumesAndSourceDto;
    sourceName!: string | undefined;
    consumeName!: string | undefined;

    constructor(data?: IGetConsumesAndSourceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.consumesAndSource = data["consumesAndSource"] ? ConsumesAndSourceDto.fromJS(data["consumesAndSource"]) : <any>undefined;
            this.sourceName = data["sourceName"];
            this.consumeName = data["consumeName"];
        }
    }

    static fromJS(data: any): GetConsumesAndSourceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetConsumesAndSourceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumesAndSource"] = this.consumesAndSource ? this.consumesAndSource.toJSON() : <any>undefined;
        data["sourceName"] = this.sourceName;
        data["consumeName"] = this.consumeName;
        return data; 
    }
}

export interface IGetConsumesAndSourceForViewDto {
    consumesAndSource: ConsumesAndSourceDto;
    sourceName: string | undefined;
    consumeName: string | undefined;
}

export class PagedResultDtoOfGetConsumesAndSourceForViewDto implements IPagedResultDtoOfGetConsumesAndSourceForViewDto {
    totalCount!: number;
    items!: GetConsumesAndSourceForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetConsumesAndSourceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetConsumesAndSourceForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetConsumesAndSourceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetConsumesAndSourceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetConsumesAndSourceForViewDto {
    totalCount: number;
    items: GetConsumesAndSourceForViewDto[] | undefined;
}

export class CreateOrEditConsumesAndSourceDto implements ICreateOrEditConsumesAndSourceDto {
    isCanUse!: boolean;
    description!: string | undefined;
    state!: boolean;
    sourceId!: number;
    consumeId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditConsumesAndSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isCanUse = data["isCanUse"];
            this.description = data["description"];
            this.state = data["state"];
            this.sourceId = data["sourceId"];
            this.consumeId = data["consumeId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditConsumesAndSourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditConsumesAndSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCanUse"] = this.isCanUse;
        data["description"] = this.description;
        data["state"] = this.state;
        data["sourceId"] = this.sourceId;
        data["consumeId"] = this.consumeId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditConsumesAndSourceDto {
    isCanUse: boolean;
    description: string | undefined;
    state: boolean;
    sourceId: number;
    consumeId: number;
    id: number | undefined;
}

export class GetConsumesAndSourceForEditOutput implements IGetConsumesAndSourceForEditOutput {
    consumesAndSource!: CreateOrEditConsumesAndSourceDto;
    sourceName!: string | undefined;
    consumeName!: string | undefined;

    constructor(data?: IGetConsumesAndSourceForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.consumesAndSource = data["consumesAndSource"] ? CreateOrEditConsumesAndSourceDto.fromJS(data["consumesAndSource"]) : <any>undefined;
            this.sourceName = data["sourceName"];
            this.consumeName = data["consumeName"];
        }
    }

    static fromJS(data: any): GetConsumesAndSourceForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetConsumesAndSourceForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumesAndSource"] = this.consumesAndSource ? this.consumesAndSource.toJSON() : <any>undefined;
        data["sourceName"] = this.sourceName;
        data["consumeName"] = this.consumeName;
        return data; 
    }
}

export interface IGetConsumesAndSourceForEditOutput {
    consumesAndSource: CreateOrEditConsumesAndSourceDto;
    sourceName: string | undefined;
    consumeName: string | undefined;
}

export class ConsumesAndSourceSourceLookupTableDto implements IConsumesAndSourceSourceLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IConsumesAndSourceSourceLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): ConsumesAndSourceSourceLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumesAndSourceSourceLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IConsumesAndSourceSourceLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfConsumesAndSourceSourceLookupTableDto implements IPagedResultDtoOfConsumesAndSourceSourceLookupTableDto {
    totalCount!: number;
    items!: ConsumesAndSourceSourceLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfConsumesAndSourceSourceLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(ConsumesAndSourceSourceLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfConsumesAndSourceSourceLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfConsumesAndSourceSourceLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfConsumesAndSourceSourceLookupTableDto {
    totalCount: number;
    items: ConsumesAndSourceSourceLookupTableDto[] | undefined;
}

export class ConsumesAndSourceConsumeLookupTableDto implements IConsumesAndSourceConsumeLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    checked!: boolean;

    constructor(data?: IConsumesAndSourceConsumeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.checked = data["checked"];
        }
    }

    static fromJS(data: any): ConsumesAndSourceConsumeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumesAndSourceConsumeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["checked"] = this.checked;
        return data; 
    }
}

export interface IConsumesAndSourceConsumeLookupTableDto {
    id: number;
    displayName: string | undefined;
    checked: boolean;
}

export class PagedResultDtoOfConsumesAndSourceConsumeLookupTableDto implements IPagedResultDtoOfConsumesAndSourceConsumeLookupTableDto {
    totalCount!: number;
    items!: ConsumesAndSourceConsumeLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfConsumesAndSourceConsumeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(ConsumesAndSourceConsumeLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfConsumesAndSourceConsumeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfConsumesAndSourceConsumeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfConsumesAndSourceConsumeLookupTableDto {
    totalCount: number;
    items: ConsumesAndSourceConsumeLookupTableDto[] | undefined;
}

export class GetConsumesAndSourceGroupBySourceForEditOutput implements IGetConsumesAndSourceGroupBySourceForEditOutput {
    consumesAndSource!: ConsumesAndSourceDto;
    sourceName!: string | undefined;
    consumes!: ConsumesAndSourceConsumeLookupTableDto[] | undefined;
    deleteConsumesId!: number[] | undefined;

    constructor(data?: IGetConsumesAndSourceGroupBySourceForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.consumesAndSource = data["consumesAndSource"] ? ConsumesAndSourceDto.fromJS(data["consumesAndSource"]) : <any>undefined;
            this.sourceName = data["sourceName"];
            if (Array.isArray(data["consumes"])) {
                this.consumes = [] as any;
                for (let item of data["consumes"])
                    this.consumes!.push(ConsumesAndSourceConsumeLookupTableDto.fromJS(item));
            }
            if (Array.isArray(data["deleteConsumesId"])) {
                this.deleteConsumesId = [] as any;
                for (let item of data["deleteConsumesId"])
                    this.deleteConsumesId!.push(item);
            }
        }
    }

    static fromJS(data: any): GetConsumesAndSourceGroupBySourceForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetConsumesAndSourceGroupBySourceForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumesAndSource"] = this.consumesAndSource ? this.consumesAndSource.toJSON() : <any>undefined;
        data["sourceName"] = this.sourceName;
        if (Array.isArray(this.consumes)) {
            data["consumes"] = [];
            for (let item of this.consumes)
                data["consumes"].push(item.toJSON());
        }
        if (Array.isArray(this.deleteConsumesId)) {
            data["deleteConsumesId"] = [];
            for (let item of this.deleteConsumesId)
                data["deleteConsumesId"].push(item);
        }
        return data; 
    }
}

export interface IGetConsumesAndSourceGroupBySourceForEditOutput {
    consumesAndSource: ConsumesAndSourceDto;
    sourceName: string | undefined;
    consumes: ConsumesAndSourceConsumeLookupTableDto[] | undefined;
    deleteConsumesId: number[] | undefined;
}

export enum IntroduceType {
    MoarefiDostan = 1,
    Internet = 2,
    TablighateMohiti = 3,
    Jarayed = 4,
    Bazaryab = 5,
}

export enum RespectPostfixConsts {
    GhadeseraSharif = 1,
    Modazellah = 2,
    ZayedEzah = 3,
    KaramAllaheVajhe = 4,
    HefzaAllahe = 5,
    YadollaheTaali = 6,
}

export enum RelationshipStatus {
    Single = 1,
    Married = 2,
    Widowed = 3,
    Divorced = 4,
}

export enum IdentityType {
    MelliCode = 1,
    Passport = 2,
    ForeignNationalsId = 3,
}

export enum AccessLevels {
    Default = 0,
    Basic = 1,
    Professional = 2,
}

export class ContactDto implements IContactDto {
    firstName!: string | undefined;
    lastName!: string | undefined;
    mobileNumber1!: string | undefined;
    mobileNumber2!: string | undefined;
    fatherName!: string | undefined;
    identityCode!: string | undefined;
    birthDate!: moment.Moment | undefined;
    isSadat!: boolean;
    fax!: string | undefined;
    email!: string | undefined;
    otherJob!: string | undefined;
    introducerRelation!: string | undefined;
    description!: string | undefined;
    profilePicture!: string | undefined;
    identificationCode!: string | undefined;
    isStaff!: boolean;
    isClient!: boolean;
    isMobileNumberValidated!: boolean;
    isLegalContact!: boolean;
    introduceType!: IntroduceType;
    creationTime!: string | undefined;
    postfix!: RespectPostfixConsts;
    newsletterSubscription!: boolean;
    pushNotificationSubscription!: boolean;
    relationshipStatus!: RelationshipStatus;
    gender!: Gender;
    pocketTitle!: string | undefined;
    groupSubgroups!: string | undefined;
    introducer!: string | undefined;
    identityType!: IdentityType;
    virtualCredit!: string | undefined;
    rate!: number | undefined;
    accessLevel!: AccessLevels;
    isBadPayer!: boolean;
    jobId!: number | undefined;
    educationDegreeId!: number | undefined;
    universityId!: number | undefined;
    educationFieldId!: number | undefined;
    nationality!: number | undefined;
    healthStatusId!: number | undefined;
    currencyId!: number | undefined;
    respectPrefixId!: number | undefined;
    address!: string | undefined;
    respectPrefixTitle!: string | undefined;
    introductionCode!: string | undefined;
    baleId!: number | undefined;
    id!: number;

    constructor(data?: IContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.firstName = data["firstName"];
            this.lastName = data["lastName"];
            this.mobileNumber1 = data["mobileNumber1"];
            this.mobileNumber2 = data["mobileNumber2"];
            this.fatherName = data["fatherName"];
            this.identityCode = data["identityCode"];
            this.birthDate = data["birthDate"] ? moment(data["birthDate"].toString()) : <any>undefined;
            this.isSadat = data["isSadat"];
            this.fax = data["fax"];
            this.email = data["email"];
            this.otherJob = data["otherJob"];
            this.introducerRelation = data["introducerRelation"];
            this.description = data["description"];
            this.profilePicture = data["profilePicture"];
            this.identificationCode = data["identificationCode"];
            this.isStaff = data["isStaff"];
            this.isClient = data["isClient"];
            this.isMobileNumberValidated = data["isMobileNumberValidated"];
            this.isLegalContact = data["isLegalContact"];
            this.introduceType = data["introduceType"];
            this.creationTime = data["creationTime"];
            this.postfix = data["postfix"];
            this.newsletterSubscription = data["newsletterSubscription"];
            this.pushNotificationSubscription = data["pushNotificationSubscription"];
            this.relationshipStatus = data["relationshipStatus"];
            this.gender = data["gender"];
            this.pocketTitle = data["pocketTitle"];
            this.groupSubgroups = data["groupSubgroups"];
            this.introducer = data["introducer"];
            this.identityType = data["identityType"];
            this.virtualCredit = data["virtualCredit"];
            this.rate = data["rate"];
            this.accessLevel = data["accessLevel"];
            this.isBadPayer = data["isBadPayer"];
            this.jobId = data["jobId"];
            this.educationDegreeId = data["educationDegreeId"];
            this.universityId = data["universityId"];
            this.educationFieldId = data["educationFieldId"];
            this.nationality = data["nationality"];
            this.healthStatusId = data["healthStatusId"];
            this.currencyId = data["currencyId"];
            this.respectPrefixId = data["respectPrefixId"];
            this.address = data["address"];
            this.respectPrefixTitle = data["respectPrefixTitle"];
            this.introductionCode = data["introductionCode"];
            this.baleId = data["baleId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["mobileNumber1"] = this.mobileNumber1;
        data["mobileNumber2"] = this.mobileNumber2;
        data["fatherName"] = this.fatherName;
        data["identityCode"] = this.identityCode;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["isSadat"] = this.isSadat;
        data["fax"] = this.fax;
        data["email"] = this.email;
        data["otherJob"] = this.otherJob;
        data["introducerRelation"] = this.introducerRelation;
        data["description"] = this.description;
        data["profilePicture"] = this.profilePicture;
        data["identificationCode"] = this.identificationCode;
        data["isStaff"] = this.isStaff;
        data["isClient"] = this.isClient;
        data["isMobileNumberValidated"] = this.isMobileNumberValidated;
        data["isLegalContact"] = this.isLegalContact;
        data["introduceType"] = this.introduceType;
        data["creationTime"] = this.creationTime;
        data["postfix"] = this.postfix;
        data["newsletterSubscription"] = this.newsletterSubscription;
        data["pushNotificationSubscription"] = this.pushNotificationSubscription;
        data["relationshipStatus"] = this.relationshipStatus;
        data["gender"] = this.gender;
        data["pocketTitle"] = this.pocketTitle;
        data["groupSubgroups"] = this.groupSubgroups;
        data["introducer"] = this.introducer;
        data["identityType"] = this.identityType;
        data["virtualCredit"] = this.virtualCredit;
        data["rate"] = this.rate;
        data["accessLevel"] = this.accessLevel;
        data["isBadPayer"] = this.isBadPayer;
        data["jobId"] = this.jobId;
        data["educationDegreeId"] = this.educationDegreeId;
        data["universityId"] = this.universityId;
        data["educationFieldId"] = this.educationFieldId;
        data["nationality"] = this.nationality;
        data["healthStatusId"] = this.healthStatusId;
        data["currencyId"] = this.currencyId;
        data["respectPrefixId"] = this.respectPrefixId;
        data["address"] = this.address;
        data["respectPrefixTitle"] = this.respectPrefixTitle;
        data["introductionCode"] = this.introductionCode;
        data["baleId"] = this.baleId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IContactDto {
    firstName: string | undefined;
    lastName: string | undefined;
    mobileNumber1: string | undefined;
    mobileNumber2: string | undefined;
    fatherName: string | undefined;
    identityCode: string | undefined;
    birthDate: moment.Moment | undefined;
    isSadat: boolean;
    fax: string | undefined;
    email: string | undefined;
    otherJob: string | undefined;
    introducerRelation: string | undefined;
    description: string | undefined;
    profilePicture: string | undefined;
    identificationCode: string | undefined;
    isStaff: boolean;
    isClient: boolean;
    isMobileNumberValidated: boolean;
    isLegalContact: boolean;
    introduceType: IntroduceType;
    creationTime: string | undefined;
    postfix: RespectPostfixConsts;
    newsletterSubscription: boolean;
    pushNotificationSubscription: boolean;
    relationshipStatus: RelationshipStatus;
    gender: Gender;
    pocketTitle: string | undefined;
    groupSubgroups: string | undefined;
    introducer: string | undefined;
    identityType: IdentityType;
    virtualCredit: string | undefined;
    rate: number | undefined;
    accessLevel: AccessLevels;
    isBadPayer: boolean;
    jobId: number | undefined;
    educationDegreeId: number | undefined;
    universityId: number | undefined;
    educationFieldId: number | undefined;
    nationality: number | undefined;
    healthStatusId: number | undefined;
    currencyId: number | undefined;
    respectPrefixId: number | undefined;
    address: string | undefined;
    respectPrefixTitle: string | undefined;
    introductionCode: string | undefined;
    baleId: number | undefined;
    id: number;
}

export class GetUserWalletInfoDetailResponseDto implements IGetUserWalletInfoDetailResponseDto {
    accountNumber!: number;
    title!: string | undefined;
    clientType!: number | undefined;
    availableBalance!: number;
    actualBalance!: number;
    maxRemainAmountPerson!: number;
    maxDailyTRSAmountPerson!: number;
    maxDailyTRSAmountBusiness!: number;
    maxRemainAmountBusiness!: number;
    userIDMRef!: string | undefined;

    constructor(data?: IGetUserWalletInfoDetailResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accountNumber = data["accountNumber"];
            this.title = data["title"];
            this.clientType = data["clientType"];
            this.availableBalance = data["availableBalance"];
            this.actualBalance = data["actualBalance"];
            this.maxRemainAmountPerson = data["maxRemainAmountPerson"];
            this.maxDailyTRSAmountPerson = data["maxDailyTRSAmountPerson"];
            this.maxDailyTRSAmountBusiness = data["maxDailyTRSAmountBusiness"];
            this.maxRemainAmountBusiness = data["maxRemainAmountBusiness"];
            this.userIDMRef = data["userIDMRef"];
        }
    }

    static fromJS(data: any): GetUserWalletInfoDetailResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserWalletInfoDetailResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber;
        data["title"] = this.title;
        data["clientType"] = this.clientType;
        data["availableBalance"] = this.availableBalance;
        data["actualBalance"] = this.actualBalance;
        data["maxRemainAmountPerson"] = this.maxRemainAmountPerson;
        data["maxDailyTRSAmountPerson"] = this.maxDailyTRSAmountPerson;
        data["maxDailyTRSAmountBusiness"] = this.maxDailyTRSAmountBusiness;
        data["maxRemainAmountBusiness"] = this.maxRemainAmountBusiness;
        data["userIDMRef"] = this.userIDMRef;
        return data; 
    }
}

export interface IGetUserWalletInfoDetailResponseDto {
    accountNumber: number;
    title: string | undefined;
    clientType: number | undefined;
    availableBalance: number;
    actualBalance: number;
    maxRemainAmountPerson: number;
    maxDailyTRSAmountPerson: number;
    maxDailyTRSAmountBusiness: number;
    maxRemainAmountBusiness: number;
    userIDMRef: string | undefined;
}

export class GetUserWalletInfoResponseDto implements IGetUserWalletInfoResponseDto {
    details!: GetUserWalletInfoDetailResponseDto[] | undefined;
    isContactsBirthdate!: boolean;
    isContactsLoyalty!: boolean;

    constructor(data?: IGetUserWalletInfoResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["details"])) {
                this.details = [] as any;
                for (let item of data["details"])
                    this.details!.push(GetUserWalletInfoDetailResponseDto.fromJS(item));
            }
            this.isContactsBirthdate = data["isContactsBirthdate"];
            this.isContactsLoyalty = data["isContactsLoyalty"];
        }
    }

    static fromJS(data: any): GetUserWalletInfoResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserWalletInfoResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["isContactsBirthdate"] = this.isContactsBirthdate;
        data["isContactsLoyalty"] = this.isContactsLoyalty;
        return data; 
    }
}

export interface IGetUserWalletInfoResponseDto {
    details: GetUserWalletInfoDetailResponseDto[] | undefined;
    isContactsBirthdate: boolean;
    isContactsLoyalty: boolean;
}

export class GetContactForViewDto implements IGetContactForViewDto {
    contact!: ContactDto;
    jobTitle!: string | undefined;
    educationDegreeTitle!: string | undefined;
    universityTitle!: string | undefined;
    educationFieldName!: string | undefined;
    countryName!: string | undefined;
    healthStatusTitle!: string | undefined;
    currencyName!: string | undefined;
    respectPrefixTitle!: string | undefined;
    isAmbassador!: boolean;
    userWalletInfo!: GetUserWalletInfoResponseDto[] | undefined;

    constructor(data?: IGetContactForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contact = data["contact"] ? ContactDto.fromJS(data["contact"]) : <any>undefined;
            this.jobTitle = data["jobTitle"];
            this.educationDegreeTitle = data["educationDegreeTitle"];
            this.universityTitle = data["universityTitle"];
            this.educationFieldName = data["educationFieldName"];
            this.countryName = data["countryName"];
            this.healthStatusTitle = data["healthStatusTitle"];
            this.currencyName = data["currencyName"];
            this.respectPrefixTitle = data["respectPrefixTitle"];
            this.isAmbassador = data["isAmbassador"];
            if (Array.isArray(data["userWalletInfo"])) {
                this.userWalletInfo = [] as any;
                for (let item of data["userWalletInfo"])
                    this.userWalletInfo!.push(GetUserWalletInfoResponseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetContactForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetContactForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["jobTitle"] = this.jobTitle;
        data["educationDegreeTitle"] = this.educationDegreeTitle;
        data["universityTitle"] = this.universityTitle;
        data["educationFieldName"] = this.educationFieldName;
        data["countryName"] = this.countryName;
        data["healthStatusTitle"] = this.healthStatusTitle;
        data["currencyName"] = this.currencyName;
        data["respectPrefixTitle"] = this.respectPrefixTitle;
        data["isAmbassador"] = this.isAmbassador;
        if (Array.isArray(this.userWalletInfo)) {
            data["userWalletInfo"] = [];
            for (let item of this.userWalletInfo)
                data["userWalletInfo"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetContactForViewDto {
    contact: ContactDto;
    jobTitle: string | undefined;
    educationDegreeTitle: string | undefined;
    universityTitle: string | undefined;
    educationFieldName: string | undefined;
    countryName: string | undefined;
    healthStatusTitle: string | undefined;
    currencyName: string | undefined;
    respectPrefixTitle: string | undefined;
    isAmbassador: boolean;
    userWalletInfo: GetUserWalletInfoResponseDto[] | undefined;
}

export class PagedResultDtoOfGetContactForViewDto implements IPagedResultDtoOfGetContactForViewDto {
    totalCount!: number;
    items!: GetContactForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetContactForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetContactForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetContactForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetContactForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetContactForViewDto {
    totalCount: number;
    items: GetContactForViewDto[] | undefined;
}

export class EditableContactDto implements IEditableContactDto {
    firstName!: boolean;
    lastName!: boolean;
    mobileNumber1!: boolean;
    mobileNumber2!: boolean;
    fatherName!: boolean;
    identityCode!: boolean;
    birthDate!: boolean;
    isSadat!: boolean;
    fax!: boolean;
    email!: boolean;
    otherJob!: boolean;
    introducerRelation!: boolean;
    description!: boolean;
    profilePicture!: boolean;
    identificationCode!: boolean;
    isStaff!: boolean;
    isClient!: boolean;
    isMobileNumberValidated!: boolean;
    introduceType!: boolean;
    menPrefix!: boolean;
    womenPrefix!: boolean;
    menPostfix!: boolean;
    womenPostfix!: boolean;
    bothPrefix!: boolean;
    bothPostfix!: boolean;
    gender!: boolean;
    pocketTitle!: boolean;
    groupSubgroups!: boolean;
    introducer!: boolean;
    identityType!: boolean;
    virtualCredit!: boolean;
    jobId!: boolean;
    educationDegreeId!: boolean;
    universityId!: boolean;
    educationFieldId!: boolean;
    nationality!: boolean;
    document!: boolean;
    newsletterSubscription!: boolean;
    pushNotificationSubscription!: boolean;
    shabaNumber!: boolean;
    bankId!: boolean;
    isBadPayer!: boolean;

    constructor(data?: IEditableContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.firstName = data["firstName"];
            this.lastName = data["lastName"];
            this.mobileNumber1 = data["mobileNumber1"];
            this.mobileNumber2 = data["mobileNumber2"];
            this.fatherName = data["fatherName"];
            this.identityCode = data["identityCode"];
            this.birthDate = data["birthDate"];
            this.isSadat = data["isSadat"];
            this.fax = data["fax"];
            this.email = data["email"];
            this.otherJob = data["otherJob"];
            this.introducerRelation = data["introducerRelation"];
            this.description = data["description"];
            this.profilePicture = data["profilePicture"];
            this.identificationCode = data["identificationCode"];
            this.isStaff = data["isStaff"];
            this.isClient = data["isClient"];
            this.isMobileNumberValidated = data["isMobileNumberValidated"];
            this.introduceType = data["introduceType"];
            this.menPrefix = data["menPrefix"];
            this.womenPrefix = data["womenPrefix"];
            this.menPostfix = data["menPostfix"];
            this.womenPostfix = data["womenPostfix"];
            this.bothPrefix = data["bothPrefix"];
            this.bothPostfix = data["bothPostfix"];
            this.gender = data["gender"];
            this.pocketTitle = data["pocketTitle"];
            this.groupSubgroups = data["groupSubgroups"];
            this.introducer = data["introducer"];
            this.identityType = data["identityType"];
            this.virtualCredit = data["virtualCredit"];
            this.jobId = data["jobId"];
            this.educationDegreeId = data["educationDegreeId"];
            this.universityId = data["universityId"];
            this.educationFieldId = data["educationFieldId"];
            this.nationality = data["nationality"];
            this.document = data["document"];
            this.newsletterSubscription = data["newsletterSubscription"];
            this.pushNotificationSubscription = data["pushNotificationSubscription"];
            this.shabaNumber = data["shabaNumber"];
            this.bankId = data["bankId"];
            this.isBadPayer = data["isBadPayer"];
        }
    }

    static fromJS(data: any): EditableContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditableContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["mobileNumber1"] = this.mobileNumber1;
        data["mobileNumber2"] = this.mobileNumber2;
        data["fatherName"] = this.fatherName;
        data["identityCode"] = this.identityCode;
        data["birthDate"] = this.birthDate;
        data["isSadat"] = this.isSadat;
        data["fax"] = this.fax;
        data["email"] = this.email;
        data["otherJob"] = this.otherJob;
        data["introducerRelation"] = this.introducerRelation;
        data["description"] = this.description;
        data["profilePicture"] = this.profilePicture;
        data["identificationCode"] = this.identificationCode;
        data["isStaff"] = this.isStaff;
        data["isClient"] = this.isClient;
        data["isMobileNumberValidated"] = this.isMobileNumberValidated;
        data["introduceType"] = this.introduceType;
        data["menPrefix"] = this.menPrefix;
        data["womenPrefix"] = this.womenPrefix;
        data["menPostfix"] = this.menPostfix;
        data["womenPostfix"] = this.womenPostfix;
        data["bothPrefix"] = this.bothPrefix;
        data["bothPostfix"] = this.bothPostfix;
        data["gender"] = this.gender;
        data["pocketTitle"] = this.pocketTitle;
        data["groupSubgroups"] = this.groupSubgroups;
        data["introducer"] = this.introducer;
        data["identityType"] = this.identityType;
        data["virtualCredit"] = this.virtualCredit;
        data["jobId"] = this.jobId;
        data["educationDegreeId"] = this.educationDegreeId;
        data["universityId"] = this.universityId;
        data["educationFieldId"] = this.educationFieldId;
        data["nationality"] = this.nationality;
        data["document"] = this.document;
        data["newsletterSubscription"] = this.newsletterSubscription;
        data["pushNotificationSubscription"] = this.pushNotificationSubscription;
        data["shabaNumber"] = this.shabaNumber;
        data["bankId"] = this.bankId;
        data["isBadPayer"] = this.isBadPayer;
        return data; 
    }
}

export interface IEditableContactDto {
    firstName: boolean;
    lastName: boolean;
    mobileNumber1: boolean;
    mobileNumber2: boolean;
    fatherName: boolean;
    identityCode: boolean;
    birthDate: boolean;
    isSadat: boolean;
    fax: boolean;
    email: boolean;
    otherJob: boolean;
    introducerRelation: boolean;
    description: boolean;
    profilePicture: boolean;
    identificationCode: boolean;
    isStaff: boolean;
    isClient: boolean;
    isMobileNumberValidated: boolean;
    introduceType: boolean;
    menPrefix: boolean;
    womenPrefix: boolean;
    menPostfix: boolean;
    womenPostfix: boolean;
    bothPrefix: boolean;
    bothPostfix: boolean;
    gender: boolean;
    pocketTitle: boolean;
    groupSubgroups: boolean;
    introducer: boolean;
    identityType: boolean;
    virtualCredit: boolean;
    jobId: boolean;
    educationDegreeId: boolean;
    universityId: boolean;
    educationFieldId: boolean;
    nationality: boolean;
    document: boolean;
    newsletterSubscription: boolean;
    pushNotificationSubscription: boolean;
    shabaNumber: boolean;
    bankId: boolean;
    isBadPayer: boolean;
}

export enum DocumentTypes {
    NotSelected = 0,
    Shenasname1 = 1,
    KartMelli = 2,
    NameNamayandegi = 3,
    PayanKhedmatCard = 4,
    MadrakTahsili = 5,
    TozihatShenasname = 6,
    EzdevajShenasname = 7,
}

export enum DocumentStatus {
    Default = 0,
    AwaitingReview = 1,
    Approved = 2,
    NotApproved = 3,
}

export class DocumentDto implements IDocumentDto {
    documentTitle!: string | undefined;
    entityRef!: number;
    entity!: Entities;
    entityDocType!: DocumentTypes;
    filePath!: string | undefined;
    fileName!: string | undefined;
    fileType!: string | undefined;
    status!: DocumentStatus;
    hasExpireDate!: boolean;
    expireDate!: moment.Moment | undefined;
    stringExpireDate!: string | undefined;
    code!: string | undefined;
    issueDate!: moment.Moment | undefined;
    isEqualToOriginal!: boolean;
    description!: string | undefined;
    id!: number;

    constructor(data?: IDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.documentTitle = data["documentTitle"];
            this.entityRef = data["entityRef"];
            this.entity = data["entity"];
            this.entityDocType = data["entityDocType"];
            this.filePath = data["filePath"];
            this.fileName = data["fileName"];
            this.fileType = data["fileType"];
            this.status = data["status"];
            this.hasExpireDate = data["hasExpireDate"];
            this.expireDate = data["expireDate"] ? moment(data["expireDate"].toString()) : <any>undefined;
            this.stringExpireDate = data["stringExpireDate"];
            this.code = data["code"];
            this.issueDate = data["issueDate"] ? moment(data["issueDate"].toString()) : <any>undefined;
            this.isEqualToOriginal = data["isEqualToOriginal"];
            this.description = data["description"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentTitle"] = this.documentTitle;
        data["entityRef"] = this.entityRef;
        data["entity"] = this.entity;
        data["entityDocType"] = this.entityDocType;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["status"] = this.status;
        data["hasExpireDate"] = this.hasExpireDate;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["stringExpireDate"] = this.stringExpireDate;
        data["code"] = this.code;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["isEqualToOriginal"] = this.isEqualToOriginal;
        data["description"] = this.description;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDocumentDto {
    documentTitle: string | undefined;
    entityRef: number;
    entity: Entities;
    entityDocType: DocumentTypes;
    filePath: string | undefined;
    fileName: string | undefined;
    fileType: string | undefined;
    status: DocumentStatus;
    hasExpireDate: boolean;
    expireDate: moment.Moment | undefined;
    stringExpireDate: string | undefined;
    code: string | undefined;
    issueDate: moment.Moment | undefined;
    isEqualToOriginal: boolean;
    description: string | undefined;
    id: number;
}

export class FaildResult implements IFaildResult {
    errorMessage!: string | undefined;

    constructor(data?: IFaildResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.errorMessage = data["errorMessage"];
        }
    }

    static fromJS(data: any): FaildResult {
        data = typeof data === 'object' ? data : {};
        let result = new FaildResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        return data; 
    }
}

export interface IFaildResult {
    errorMessage: string | undefined;
}

export class GetContactAndAddressesForViewDto implements IGetContactAndAddressesForViewDto {
    contact!: ContactDto;
    shabaNumber!: string | undefined;
    bankId!: number | undefined;
    editableCantact!: EditableContactDto;
    addresses!: GetAddressForViewDto[] | undefined;
    documents!: DocumentDto[] | undefined;
    error!: FaildResult;

    constructor(data?: IGetContactAndAddressesForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contact = data["contact"] ? ContactDto.fromJS(data["contact"]) : <any>undefined;
            this.shabaNumber = data["shabaNumber"];
            this.bankId = data["bankId"];
            this.editableCantact = data["editableCantact"] ? EditableContactDto.fromJS(data["editableCantact"]) : <any>undefined;
            if (Array.isArray(data["addresses"])) {
                this.addresses = [] as any;
                for (let item of data["addresses"])
                    this.addresses!.push(GetAddressForViewDto.fromJS(item));
            }
            if (Array.isArray(data["documents"])) {
                this.documents = [] as any;
                for (let item of data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.error = data["error"] ? FaildResult.fromJS(data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetContactAndAddressesForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetContactAndAddressesForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["shabaNumber"] = this.shabaNumber;
        data["bankId"] = this.bankId;
        data["editableCantact"] = this.editableCantact ? this.editableCantact.toJSON() : <any>undefined;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetContactAndAddressesForViewDto {
    contact: ContactDto;
    shabaNumber: string | undefined;
    bankId: number | undefined;
    editableCantact: EditableContactDto;
    addresses: GetAddressForViewDto[] | undefined;
    documents: DocumentDto[] | undefined;
    error: FaildResult;
}

export class CreateOrEditContactDto implements ICreateOrEditContactDto {
    firstName!: string | undefined;
    lastName!: string | undefined;
    mobileNumber1!: string | undefined;
    mobileNumber2!: string | undefined;
    fatherName!: string | undefined;
    identityCode!: string | undefined;
    birthDate!: moment.Moment | undefined;
    isSadat!: boolean;
    fax!: string | undefined;
    email!: string | undefined;
    otherJob!: string | undefined;
    introducerRelation!: string | undefined;
    description!: string | undefined;
    profilePicture!: string | undefined;
    identificationCode!: string | undefined;
    isStaff!: boolean;
    isMobileNumberValidated!: boolean;
    isClient!: boolean;
    isLegalContact!: boolean;
    introduceType!: IntroduceType;
    postfix!: RespectPostfixConsts;
    relationshipStatus!: RelationshipStatus;
    gender!: Gender;
    pocketTitle!: string | undefined;
    groupSubgroups!: string | undefined;
    isBadPayer!: boolean;
    introducer!: string | undefined;
    identityType!: IdentityType;
    virtualCredit!: string | undefined;
    rate!: number | undefined;
    accessLevel!: AccessLevels;
    jobId!: number | undefined;
    educationDegreeId!: number | undefined;
    universityId!: number | undefined;
    educationFieldId!: number | undefined;
    nationality!: number | undefined;
    healthStatusId!: number | undefined;
    currencyId!: number | undefined;
    respectPrefixId!: number | undefined;
    newsletterSubscription!: boolean;
    pushNotificationSubscription!: boolean;
    address!: string | undefined;
    respectPrefixTitle!: string | undefined;
    baleId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.firstName = data["firstName"];
            this.lastName = data["lastName"];
            this.mobileNumber1 = data["mobileNumber1"];
            this.mobileNumber2 = data["mobileNumber2"];
            this.fatherName = data["fatherName"];
            this.identityCode = data["identityCode"];
            this.birthDate = data["birthDate"] ? moment(data["birthDate"].toString()) : <any>undefined;
            this.isSadat = data["isSadat"];
            this.fax = data["fax"];
            this.email = data["email"];
            this.otherJob = data["otherJob"];
            this.introducerRelation = data["introducerRelation"];
            this.description = data["description"];
            this.profilePicture = data["profilePicture"];
            this.identificationCode = data["identificationCode"];
            this.isStaff = data["isStaff"];
            this.isMobileNumberValidated = data["isMobileNumberValidated"];
            this.isClient = data["isClient"];
            this.isLegalContact = data["isLegalContact"];
            this.introduceType = data["introduceType"];
            this.postfix = data["postfix"];
            this.relationshipStatus = data["relationshipStatus"];
            this.gender = data["gender"];
            this.pocketTitle = data["pocketTitle"];
            this.groupSubgroups = data["groupSubgroups"];
            this.isBadPayer = data["isBadPayer"];
            this.introducer = data["introducer"];
            this.identityType = data["identityType"];
            this.virtualCredit = data["virtualCredit"];
            this.rate = data["rate"];
            this.accessLevel = data["accessLevel"];
            this.jobId = data["jobId"];
            this.educationDegreeId = data["educationDegreeId"];
            this.universityId = data["universityId"];
            this.educationFieldId = data["educationFieldId"];
            this.nationality = data["nationality"];
            this.healthStatusId = data["healthStatusId"];
            this.currencyId = data["currencyId"];
            this.respectPrefixId = data["respectPrefixId"];
            this.newsletterSubscription = data["newsletterSubscription"];
            this.pushNotificationSubscription = data["pushNotificationSubscription"];
            this.address = data["address"];
            this.respectPrefixTitle = data["respectPrefixTitle"];
            this.baleId = data["baleId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["mobileNumber1"] = this.mobileNumber1;
        data["mobileNumber2"] = this.mobileNumber2;
        data["fatherName"] = this.fatherName;
        data["identityCode"] = this.identityCode;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["isSadat"] = this.isSadat;
        data["fax"] = this.fax;
        data["email"] = this.email;
        data["otherJob"] = this.otherJob;
        data["introducerRelation"] = this.introducerRelation;
        data["description"] = this.description;
        data["profilePicture"] = this.profilePicture;
        data["identificationCode"] = this.identificationCode;
        data["isStaff"] = this.isStaff;
        data["isMobileNumberValidated"] = this.isMobileNumberValidated;
        data["isClient"] = this.isClient;
        data["isLegalContact"] = this.isLegalContact;
        data["introduceType"] = this.introduceType;
        data["postfix"] = this.postfix;
        data["relationshipStatus"] = this.relationshipStatus;
        data["gender"] = this.gender;
        data["pocketTitle"] = this.pocketTitle;
        data["groupSubgroups"] = this.groupSubgroups;
        data["isBadPayer"] = this.isBadPayer;
        data["introducer"] = this.introducer;
        data["identityType"] = this.identityType;
        data["virtualCredit"] = this.virtualCredit;
        data["rate"] = this.rate;
        data["accessLevel"] = this.accessLevel;
        data["jobId"] = this.jobId;
        data["educationDegreeId"] = this.educationDegreeId;
        data["universityId"] = this.universityId;
        data["educationFieldId"] = this.educationFieldId;
        data["nationality"] = this.nationality;
        data["healthStatusId"] = this.healthStatusId;
        data["currencyId"] = this.currencyId;
        data["respectPrefixId"] = this.respectPrefixId;
        data["newsletterSubscription"] = this.newsletterSubscription;
        data["pushNotificationSubscription"] = this.pushNotificationSubscription;
        data["address"] = this.address;
        data["respectPrefixTitle"] = this.respectPrefixTitle;
        data["baleId"] = this.baleId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditContactDto {
    firstName: string | undefined;
    lastName: string | undefined;
    mobileNumber1: string | undefined;
    mobileNumber2: string | undefined;
    fatherName: string | undefined;
    identityCode: string | undefined;
    birthDate: moment.Moment | undefined;
    isSadat: boolean;
    fax: string | undefined;
    email: string | undefined;
    otherJob: string | undefined;
    introducerRelation: string | undefined;
    description: string | undefined;
    profilePicture: string | undefined;
    identificationCode: string | undefined;
    isStaff: boolean;
    isMobileNumberValidated: boolean;
    isClient: boolean;
    isLegalContact: boolean;
    introduceType: IntroduceType;
    postfix: RespectPostfixConsts;
    relationshipStatus: RelationshipStatus;
    gender: Gender;
    pocketTitle: string | undefined;
    groupSubgroups: string | undefined;
    isBadPayer: boolean;
    introducer: string | undefined;
    identityType: IdentityType;
    virtualCredit: string | undefined;
    rate: number | undefined;
    accessLevel: AccessLevels;
    jobId: number | undefined;
    educationDegreeId: number | undefined;
    universityId: number | undefined;
    educationFieldId: number | undefined;
    nationality: number | undefined;
    healthStatusId: number | undefined;
    currencyId: number | undefined;
    respectPrefixId: number | undefined;
    newsletterSubscription: boolean;
    pushNotificationSubscription: boolean;
    address: string | undefined;
    respectPrefixTitle: string | undefined;
    baleId: number | undefined;
    id: number | undefined;
}

export class FileUploadOutput implements IFileUploadOutput {
    fileName!: string | undefined;
    fileType!: string | undefined;
    fileToken!: string | undefined;
    filePath!: string | undefined;
    docType!: DocumentTypes;
    hasExpireDate!: boolean;
    expireDate!: moment.Moment | undefined;
    code!: string | undefined;
    issueDate!: moment.Moment | undefined;
    isEqualToOriginal!: boolean;
    description!: string | undefined;

    constructor(data?: IFileUploadOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.fileType = data["fileType"];
            this.fileToken = data["fileToken"];
            this.filePath = data["filePath"];
            this.docType = data["docType"];
            this.hasExpireDate = data["hasExpireDate"];
            this.expireDate = data["expireDate"] ? moment(data["expireDate"].toString()) : <any>undefined;
            this.code = data["code"];
            this.issueDate = data["issueDate"] ? moment(data["issueDate"].toString()) : <any>undefined;
            this.isEqualToOriginal = data["isEqualToOriginal"];
            this.description = data["description"];
        }
    }

    static fromJS(data: any): FileUploadOutput {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        data["filePath"] = this.filePath;
        data["docType"] = this.docType;
        data["hasExpireDate"] = this.hasExpireDate;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["code"] = this.code;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["isEqualToOriginal"] = this.isEqualToOriginal;
        data["description"] = this.description;
        return data; 
    }
}

export interface IFileUploadOutput {
    fileName: string | undefined;
    fileType: string | undefined;
    fileToken: string | undefined;
    filePath: string | undefined;
    docType: DocumentTypes;
    hasExpireDate: boolean;
    expireDate: moment.Moment | undefined;
    code: string | undefined;
    issueDate: moment.Moment | undefined;
    isEqualToOriginal: boolean;
    description: string | undefined;
}

export class EditProfileContactDto implements IEditProfileContactDto {
    contact!: CreateOrEditContactDto;
    shabaNumber!: string | undefined;
    bankId!: number | undefined;
    documents!: FileUploadOutput[] | undefined;

    constructor(data?: IEditProfileContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contact = data["contact"] ? CreateOrEditContactDto.fromJS(data["contact"]) : <any>undefined;
            this.shabaNumber = data["shabaNumber"];
            this.bankId = data["bankId"];
            if (Array.isArray(data["documents"])) {
                this.documents = [] as any;
                for (let item of data["documents"])
                    this.documents!.push(FileUploadOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditProfileContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditProfileContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["shabaNumber"] = this.shabaNumber;
        data["bankId"] = this.bankId;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IEditProfileContactDto {
    contact: CreateOrEditContactDto;
    shabaNumber: string | undefined;
    bankId: number | undefined;
    documents: FileUploadOutput[] | undefined;
}

export class EmployeeDto implements IEmployeeDto {
    shenasnameNumber!: string | undefined;
    personnelNumber!: string | undefined;
    maritalStatus!: boolean;
    numberOfChildren!: number;
    trafficNumber!: string | undefined;
    receiptAgent!: boolean;
    contactId!: number;
    birthPlace!: number;
    shenasnameIssueCity!: number;
    id!: number;

    constructor(data?: IEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.shenasnameNumber = data["shenasnameNumber"];
            this.personnelNumber = data["personnelNumber"];
            this.maritalStatus = data["maritalStatus"];
            this.numberOfChildren = data["numberOfChildren"];
            this.trafficNumber = data["trafficNumber"];
            this.receiptAgent = data["receiptAgent"];
            this.contactId = data["contactId"];
            this.birthPlace = data["birthPlace"];
            this.shenasnameIssueCity = data["shenasnameIssueCity"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shenasnameNumber"] = this.shenasnameNumber;
        data["personnelNumber"] = this.personnelNumber;
        data["maritalStatus"] = this.maritalStatus;
        data["numberOfChildren"] = this.numberOfChildren;
        data["trafficNumber"] = this.trafficNumber;
        data["receiptAgent"] = this.receiptAgent;
        data["contactId"] = this.contactId;
        data["birthPlace"] = this.birthPlace;
        data["shenasnameIssueCity"] = this.shenasnameIssueCity;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEmployeeDto {
    shenasnameNumber: string | undefined;
    personnelNumber: string | undefined;
    maritalStatus: boolean;
    numberOfChildren: number;
    trafficNumber: string | undefined;
    receiptAgent: boolean;
    contactId: number;
    birthPlace: number;
    shenasnameIssueCity: number;
    id: number;
}

export class GetEmployeeForViewDto implements IGetEmployeeForViewDto {
    employee!: EmployeeDto;
    cityName!: string | undefined;
    cityName2!: string | undefined;

    constructor(data?: IGetEmployeeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.employee = data["employee"] ? EmployeeDto.fromJS(data["employee"]) : <any>undefined;
            this.cityName = data["cityName"];
            this.cityName2 = data["cityName2"];
        }
    }

    static fromJS(data: any): GetEmployeeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["cityName"] = this.cityName;
        data["cityName2"] = this.cityName2;
        return data; 
    }
}

export interface IGetEmployeeForViewDto {
    employee: EmployeeDto;
    cityName: string | undefined;
    cityName2: string | undefined;
}

export class LegalContactDto implements ILegalContactDto {
    name!: string | undefined;
    identityCode!: string | undefined;
    economicCode!: string | undefined;
    registrationNumber!: string | undefined;
    phone!: string | undefined;
    manager!: string | undefined;
    postalCode!: string | undefined;
    activityField!: string | undefined;
    state!: boolean;
    contactRef!: number;
    id!: number;

    constructor(data?: ILegalContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.identityCode = data["identityCode"];
            this.economicCode = data["economicCode"];
            this.registrationNumber = data["registrationNumber"];
            this.phone = data["phone"];
            this.manager = data["manager"];
            this.postalCode = data["postalCode"];
            this.activityField = data["activityField"];
            this.state = data["state"];
            this.contactRef = data["contactRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): LegalContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new LegalContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["identityCode"] = this.identityCode;
        data["economicCode"] = this.economicCode;
        data["registrationNumber"] = this.registrationNumber;
        data["phone"] = this.phone;
        data["manager"] = this.manager;
        data["postalCode"] = this.postalCode;
        data["activityField"] = this.activityField;
        data["state"] = this.state;
        data["contactRef"] = this.contactRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ILegalContactDto {
    name: string | undefined;
    identityCode: string | undefined;
    economicCode: string | undefined;
    registrationNumber: string | undefined;
    phone: string | undefined;
    manager: string | undefined;
    postalCode: string | undefined;
    activityField: string | undefined;
    state: boolean;
    contactRef: number;
    id: number;
}

export class GetLegalContactForViewDto implements IGetLegalContactForViewDto {
    legalContact!: LegalContactDto;
    contactFirstName!: string | undefined;
    addressTitle!: string | undefined;

    constructor(data?: IGetLegalContactForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.legalContact = data["legalContact"] ? LegalContactDto.fromJS(data["legalContact"]) : <any>undefined;
            this.contactFirstName = data["contactFirstName"];
            this.addressTitle = data["addressTitle"];
        }
    }

    static fromJS(data: any): GetLegalContactForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetLegalContactForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalContact"] = this.legalContact ? this.legalContact.toJSON() : <any>undefined;
        data["contactFirstName"] = this.contactFirstName;
        data["addressTitle"] = this.addressTitle;
        return data; 
    }
}

export interface IGetLegalContactForViewDto {
    legalContact: LegalContactDto;
    contactFirstName: string | undefined;
    addressTitle: string | undefined;
}

export enum DeathCause {
    AcuteHeartComplication = 1,
    Stroke = 2,
    Wave = 3,
    Accident = 4,
    Casualty = 5,
    AcuteCardiacAnarctus = 6,
    Addiction = 7,
    AlcoholPoisoning = 8,
    Alzheimer = 9,
    Fall = 10,
    Appendix = 11,
    Arrhythmia = 12,
    Asthma = 13,
    Beat = 14,
    BehavioralDisorders = 15,
    BleedingDueHitting = 16,
    BloodPressure = 17,
    BrainTumor = 18,
    Burn = 19,
    Cancer = 20,
    CardiovascularDiseases = 21,
    CerebralHemorrhage = 22,
    Choking = 23,
    ComplicationsCausedByHeartAttack = 24,
    Concussion = 25,
    CongenitalAnomalies = 26,
    Corona = 27,
    CutTheHeart = 28,
    CyrusHebdi = 29,
    Diabetes = 30,
    Disease = 31,
    DiseasesOfHematopoieticAndImmune = 32,
    DiseasesOfTheDigestive = 33,
    DiseasesRelatedToBloodPressure = 34,
    Drowned = 35,
    DrugAbuse = 36,
    DrugPoisoning = 37,
    Impact = 38,
    DynamiteExplosion = 39,
    Earthquake = 40,
    HeartFailure = 41,
    Electrocution = 42,
    Epilepsy = 43,
    Execution = 44,
    ExtensiveFracturesOfOrgans = 45,
    Fire = 46,
    GastrointestinalBleeding = 47,
    Hanging = 48,
    HeartAttack = 49,
    HeartRhythmDisorderAndVasoconstriction = 50,
    HeartTrouble = 51,
    Hepatitis = 52,
    Hypoxia = 53,
    InfectiousDisease = 54,
    Injection = 55,
    InsufficiencyFollowingBurns = 56,
    InternalBleeding = 57,
    InternalInfection = 58,
    KidneyDisease = 59,
    KidneyFailure = 60,
    LiverDiscomfort = 61,
    LiverDisease = 62,
    LungDisease = 63,
    LungProblem = 64,
    Lymphoma = 65,
    MarrowPieces = 66,
    Martyr = 67,
    MentalIllness = 68,
    GotLost = 69,
    MultiplePhysicalInjuries = 70,
    Murder = 71,
    NaturalDeath = 72,
    NervousDisease = 73,
    OldAge = 74,
    Parkinson = 75,
    Pneumonia = 76,
    Poisoning = 77,
    PoorlyDefinedSymptomsAndConditions = 78,
    PulmonaryInfection = 79,
    RespiratoryFailure = 80,
    RespiratoryDiseases = 81,
    RicePillPoisoning = 82,
    AcutePeritonitisShock = 83,
    BleedingShock = 84,
    Shot = 85,
    DrugUseSideEffects = 86,
    SkeletalAndMuscularDiseases = 87,
    TtomachDisease = 88,
    Suicide = 89,
    WellCollapse = 90,
    EndocrineDisease = 91,
    TrafficAccidents = 92,
    Tuberculosis = 93,
    Tumor = 94,
    UnintentionalAccidents = 95,
    Unknown = 96,
    UnstableAngina = 97,
    UrinaryGenitalSystemDisease = 98,
    VascularDiseases = 99,
    VertebralFractures = 100,
    WellExplosion = 101,
}

export enum InsuranceType {
    Iranian = 1,
    BonyadShahid = 2,
    Behzisty = 3,
    Behzisty_Ejtema = 4,
    Behzisty_Khadamat = 5,
    Behzisty_Salamat = 6,
    Salamat = 7,
    Keshavarzi = 8,
    TaminEjtemaei = 9,
    Janbazan_Salamat = 10,
    KhadamatDarmani = 11,
    Roosta = 12,
    Komiteh_Khadamat = 13,
    Komiteh_Salamat = 14,
    Komiteh_Ejtemaei = 15,
    KomitehEmdad = 16,
    NiroohayeMosalah = 17,
}

export enum FamilyRelationType {
    Father = 1,
    Mother = 2,
    Son = 3,
    Daughter = 4,
    UnkelM = 5,
    AuntM = 6,
    GrandMother = 7,
    GrandFather = 8,
    Other = 9,
    UnkelF = 10,
    AuntF = 11,
}

export class FamilyMemberDto implements IFamilyMemberDto {
    notIsAlive!: boolean;
    deathCause!: DeathCause;
    deathCauseExplanation!: string | undefined;
    deathDate!: moment.Moment | undefined;
    insuranceType!: InsuranceType;
    familyMemberRelation!: FamilyRelationType;
    beginDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    contactId!: number | undefined;
    otherRelation!: string | undefined;
    isLivingWithClient!: boolean;
    isActive!: boolean;
    deathCertificateSerial!: string | undefined;
    familyId!: number;
    familyMembersRoleIds!: string | undefined;
    id!: number;

    constructor(data?: IFamilyMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.notIsAlive = data["notIsAlive"];
            this.deathCause = data["deathCause"];
            this.deathCauseExplanation = data["deathCauseExplanation"];
            this.deathDate = data["deathDate"] ? moment(data["deathDate"].toString()) : <any>undefined;
            this.insuranceType = data["insuranceType"];
            this.familyMemberRelation = data["familyMemberRelation"];
            this.beginDate = data["beginDate"] ? moment(data["beginDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.contactId = data["contactId"];
            this.otherRelation = data["otherRelation"];
            this.isLivingWithClient = data["isLivingWithClient"];
            this.isActive = data["isActive"];
            this.deathCertificateSerial = data["deathCertificateSerial"];
            this.familyId = data["familyId"];
            this.familyMembersRoleIds = data["familyMembersRoleIds"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): FamilyMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new FamilyMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notIsAlive"] = this.notIsAlive;
        data["deathCause"] = this.deathCause;
        data["deathCauseExplanation"] = this.deathCauseExplanation;
        data["deathDate"] = this.deathDate ? this.deathDate.toISOString() : <any>undefined;
        data["insuranceType"] = this.insuranceType;
        data["familyMemberRelation"] = this.familyMemberRelation;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["contactId"] = this.contactId;
        data["otherRelation"] = this.otherRelation;
        data["isLivingWithClient"] = this.isLivingWithClient;
        data["isActive"] = this.isActive;
        data["deathCertificateSerial"] = this.deathCertificateSerial;
        data["familyId"] = this.familyId;
        data["familyMembersRoleIds"] = this.familyMembersRoleIds;
        data["id"] = this.id;
        return data; 
    }
}

export interface IFamilyMemberDto {
    notIsAlive: boolean;
    deathCause: DeathCause;
    deathCauseExplanation: string | undefined;
    deathDate: moment.Moment | undefined;
    insuranceType: InsuranceType;
    familyMemberRelation: FamilyRelationType;
    beginDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    contactId: number | undefined;
    otherRelation: string | undefined;
    isLivingWithClient: boolean;
    isActive: boolean;
    deathCertificateSerial: string | undefined;
    familyId: number;
    familyMembersRoleIds: string | undefined;
    id: number;
}

export class GetFamilyMemberForViewDto implements IGetFamilyMemberForViewDto {
    familyMember!: FamilyMemberDto;
    familyName!: string | undefined;
    familyFileNumber!: string | undefined;
    familyMembersRoleTitle!: string | undefined;
    contactFirstName!: string | undefined;
    contactIdentityCode!: string | undefined;
    contactMobileNumber!: string | undefined;
    jobTitle!: string | undefined;
    educationDegreeTitle!: string | undefined;

    constructor(data?: IGetFamilyMemberForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.familyMember = data["familyMember"] ? FamilyMemberDto.fromJS(data["familyMember"]) : <any>undefined;
            this.familyName = data["familyName"];
            this.familyFileNumber = data["familyFileNumber"];
            this.familyMembersRoleTitle = data["familyMembersRoleTitle"];
            this.contactFirstName = data["contactFirstName"];
            this.contactIdentityCode = data["contactIdentityCode"];
            this.contactMobileNumber = data["contactMobileNumber"];
            this.jobTitle = data["jobTitle"];
            this.educationDegreeTitle = data["educationDegreeTitle"];
        }
    }

    static fromJS(data: any): GetFamilyMemberForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFamilyMemberForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["familyMember"] = this.familyMember ? this.familyMember.toJSON() : <any>undefined;
        data["familyName"] = this.familyName;
        data["familyFileNumber"] = this.familyFileNumber;
        data["familyMembersRoleTitle"] = this.familyMembersRoleTitle;
        data["contactFirstName"] = this.contactFirstName;
        data["contactIdentityCode"] = this.contactIdentityCode;
        data["contactMobileNumber"] = this.contactMobileNumber;
        data["jobTitle"] = this.jobTitle;
        data["educationDegreeTitle"] = this.educationDegreeTitle;
        return data; 
    }
}

export interface IGetFamilyMemberForViewDto {
    familyMember: FamilyMemberDto;
    familyName: string | undefined;
    familyFileNumber: string | undefined;
    familyMembersRoleTitle: string | undefined;
    contactFirstName: string | undefined;
    contactIdentityCode: string | undefined;
    contactMobileNumber: string | undefined;
    jobTitle: string | undefined;
    educationDegreeTitle: string | undefined;
}

export class GetContactAndDependentFormForViewDto implements IGetContactAndDependentFormForViewDto {
    contact!: ContactDto;
    jobTitle!: string | undefined;
    educationDegreeTitle!: string | undefined;
    universityTitle!: string | undefined;
    educationFieldName!: string | undefined;
    countryName!: string | undefined;
    healthStatusTitle!: string | undefined;
    currencyName!: string | undefined;
    respectPrefixTitle!: string | undefined;
    groupSubgroupsName!: string | undefined;
    rolesName!: string | undefined;
    employee!: GetEmployeeForViewDto;
    legalContact!: GetLegalContactForViewDto;
    addresses!: GetAddressForViewDto[] | undefined;
    ambassadors!: GetAmbassadorForViewDto[] | undefined;
    bankAccounts!: GetBankAccountForViewDto[] | undefined;
    familyMembers!: GetFamilyMemberForViewDto[] | undefined;

    constructor(data?: IGetContactAndDependentFormForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contact = data["contact"] ? ContactDto.fromJS(data["contact"]) : <any>undefined;
            this.jobTitle = data["jobTitle"];
            this.educationDegreeTitle = data["educationDegreeTitle"];
            this.universityTitle = data["universityTitle"];
            this.educationFieldName = data["educationFieldName"];
            this.countryName = data["countryName"];
            this.healthStatusTitle = data["healthStatusTitle"];
            this.currencyName = data["currencyName"];
            this.respectPrefixTitle = data["respectPrefixTitle"];
            this.groupSubgroupsName = data["groupSubgroupsName"];
            this.rolesName = data["rolesName"];
            this.employee = data["employee"] ? GetEmployeeForViewDto.fromJS(data["employee"]) : <any>undefined;
            this.legalContact = data["legalContact"] ? GetLegalContactForViewDto.fromJS(data["legalContact"]) : <any>undefined;
            if (Array.isArray(data["addresses"])) {
                this.addresses = [] as any;
                for (let item of data["addresses"])
                    this.addresses!.push(GetAddressForViewDto.fromJS(item));
            }
            if (Array.isArray(data["ambassadors"])) {
                this.ambassadors = [] as any;
                for (let item of data["ambassadors"])
                    this.ambassadors!.push(GetAmbassadorForViewDto.fromJS(item));
            }
            if (Array.isArray(data["bankAccounts"])) {
                this.bankAccounts = [] as any;
                for (let item of data["bankAccounts"])
                    this.bankAccounts!.push(GetBankAccountForViewDto.fromJS(item));
            }
            if (Array.isArray(data["familyMembers"])) {
                this.familyMembers = [] as any;
                for (let item of data["familyMembers"])
                    this.familyMembers!.push(GetFamilyMemberForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetContactAndDependentFormForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetContactAndDependentFormForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["jobTitle"] = this.jobTitle;
        data["educationDegreeTitle"] = this.educationDegreeTitle;
        data["universityTitle"] = this.universityTitle;
        data["educationFieldName"] = this.educationFieldName;
        data["countryName"] = this.countryName;
        data["healthStatusTitle"] = this.healthStatusTitle;
        data["currencyName"] = this.currencyName;
        data["respectPrefixTitle"] = this.respectPrefixTitle;
        data["groupSubgroupsName"] = this.groupSubgroupsName;
        data["rolesName"] = this.rolesName;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["legalContact"] = this.legalContact ? this.legalContact.toJSON() : <any>undefined;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        if (Array.isArray(this.ambassadors)) {
            data["ambassadors"] = [];
            for (let item of this.ambassadors)
                data["ambassadors"].push(item.toJSON());
        }
        if (Array.isArray(this.bankAccounts)) {
            data["bankAccounts"] = [];
            for (let item of this.bankAccounts)
                data["bankAccounts"].push(item.toJSON());
        }
        if (Array.isArray(this.familyMembers)) {
            data["familyMembers"] = [];
            for (let item of this.familyMembers)
                data["familyMembers"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetContactAndDependentFormForViewDto {
    contact: ContactDto;
    jobTitle: string | undefined;
    educationDegreeTitle: string | undefined;
    universityTitle: string | undefined;
    educationFieldName: string | undefined;
    countryName: string | undefined;
    healthStatusTitle: string | undefined;
    currencyName: string | undefined;
    respectPrefixTitle: string | undefined;
    groupSubgroupsName: string | undefined;
    rolesName: string | undefined;
    employee: GetEmployeeForViewDto;
    legalContact: GetLegalContactForViewDto;
    addresses: GetAddressForViewDto[] | undefined;
    ambassadors: GetAmbassadorForViewDto[] | undefined;
    bankAccounts: GetBankAccountForViewDto[] | undefined;
    familyMembers: GetFamilyMemberForViewDto[] | undefined;
}

export class ContactSubscriptionsDto implements IContactSubscriptionsDto {
    newsletterSubscription!: boolean;
    pushNotificationSubscription!: boolean;

    constructor(data?: IContactSubscriptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.newsletterSubscription = data["newsletterSubscription"];
            this.pushNotificationSubscription = data["pushNotificationSubscription"];
        }
    }

    static fromJS(data: any): ContactSubscriptionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactSubscriptionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newsletterSubscription"] = this.newsletterSubscription;
        data["pushNotificationSubscription"] = this.pushNotificationSubscription;
        return data; 
    }
}

export interface IContactSubscriptionsDto {
    newsletterSubscription: boolean;
    pushNotificationSubscription: boolean;
}

export class GetContactForEditOutput implements IGetContactForEditOutput {
    contact!: ContactDto;
    jobTitle!: string | undefined;
    educationDegreeTitle!: string | undefined;
    universityTitle!: string | undefined;
    educationFieldName!: string | undefined;
    countryName!: string | undefined;
    healthStatusTitle!: string | undefined;
    currencyName!: string | undefined;
    respectPrefixTitle!: string | undefined;

    constructor(data?: IGetContactForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contact = data["contact"] ? ContactDto.fromJS(data["contact"]) : <any>undefined;
            this.jobTitle = data["jobTitle"];
            this.educationDegreeTitle = data["educationDegreeTitle"];
            this.universityTitle = data["universityTitle"];
            this.educationFieldName = data["educationFieldName"];
            this.countryName = data["countryName"];
            this.healthStatusTitle = data["healthStatusTitle"];
            this.currencyName = data["currencyName"];
            this.respectPrefixTitle = data["respectPrefixTitle"];
        }
    }

    static fromJS(data: any): GetContactForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetContactForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["jobTitle"] = this.jobTitle;
        data["educationDegreeTitle"] = this.educationDegreeTitle;
        data["universityTitle"] = this.universityTitle;
        data["educationFieldName"] = this.educationFieldName;
        data["countryName"] = this.countryName;
        data["healthStatusTitle"] = this.healthStatusTitle;
        data["currencyName"] = this.currencyName;
        data["respectPrefixTitle"] = this.respectPrefixTitle;
        return data; 
    }
}

export interface IGetContactForEditOutput {
    contact: ContactDto;
    jobTitle: string | undefined;
    educationDegreeTitle: string | undefined;
    universityTitle: string | undefined;
    educationFieldName: string | undefined;
    countryName: string | undefined;
    healthStatusTitle: string | undefined;
    currencyName: string | undefined;
    respectPrefixTitle: string | undefined;
}

export class UserContactDto implements IUserContactDto {
    userName!: string | undefined;
    password!: string | undefined;
    isActive!: boolean;
    shouldChangePasswordOnNextLogin!: boolean;
    isTwoFactorEnabled!: boolean;
    isLockoutEnabled!: boolean;
    sendActivationEmail!: boolean;
    sendSMSToContact!: boolean;

    constructor(data?: IUserContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userName = data["userName"];
            this.password = data["password"];
            this.isActive = data["isActive"];
            this.shouldChangePasswordOnNextLogin = data["shouldChangePasswordOnNextLogin"];
            this.isTwoFactorEnabled = data["isTwoFactorEnabled"];
            this.isLockoutEnabled = data["isLockoutEnabled"];
            this.sendActivationEmail = data["sendActivationEmail"];
            this.sendSMSToContact = data["sendSMSToContact"];
        }
    }

    static fromJS(data: any): UserContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["isActive"] = this.isActive;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["sendSMSToContact"] = this.sendSMSToContact;
        return data; 
    }
}

export interface IUserContactDto {
    userName: string | undefined;
    password: string | undefined;
    isActive: boolean;
    shouldChangePasswordOnNextLogin: boolean;
    isTwoFactorEnabled: boolean;
    isLockoutEnabled: boolean;
    sendActivationEmail: boolean;
    sendSMSToContact: boolean;
}

export class UserRole implements IUserRole {
    tenantId!: number | undefined;
    userId!: number;
    roleId!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.roleId = data["roleId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserRole {
    tenantId: number | undefined;
    userId: number;
    roleId: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class CreateOrEditEmployeeForContactDto implements ICreateOrEditEmployeeForContactDto {
    shenasnameNumber!: string | undefined;
    personnelNumber!: string | undefined;
    maritalStatus!: boolean;
    numberOfChildren!: number;
    trafficNumber!: string | undefined;
    receiptAgent!: boolean;
    contactId!: number;
    birthPlace!: number;
    shenasnameIssueCity!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditEmployeeForContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.shenasnameNumber = data["shenasnameNumber"];
            this.personnelNumber = data["personnelNumber"];
            this.maritalStatus = data["maritalStatus"];
            this.numberOfChildren = data["numberOfChildren"];
            this.trafficNumber = data["trafficNumber"];
            this.receiptAgent = data["receiptAgent"];
            this.contactId = data["contactId"];
            this.birthPlace = data["birthPlace"];
            this.shenasnameIssueCity = data["shenasnameIssueCity"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditEmployeeForContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditEmployeeForContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shenasnameNumber"] = this.shenasnameNumber;
        data["personnelNumber"] = this.personnelNumber;
        data["maritalStatus"] = this.maritalStatus;
        data["numberOfChildren"] = this.numberOfChildren;
        data["trafficNumber"] = this.trafficNumber;
        data["receiptAgent"] = this.receiptAgent;
        data["contactId"] = this.contactId;
        data["birthPlace"] = this.birthPlace;
        data["shenasnameIssueCity"] = this.shenasnameIssueCity;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditEmployeeForContactDto {
    shenasnameNumber: string | undefined;
    personnelNumber: string | undefined;
    maritalStatus: boolean;
    numberOfChildren: number;
    trafficNumber: string | undefined;
    receiptAgent: boolean;
    contactId: number;
    birthPlace: number;
    shenasnameIssueCity: number;
    id: number | undefined;
}

export class CreateOrEditLegalContactForContactDto implements ICreateOrEditLegalContactForContactDto {
    name!: string | undefined;
    identityCode!: string | undefined;
    economicCode!: string | undefined;
    registrationNumber!: string | undefined;
    phone!: string | undefined;
    manager!: string | undefined;
    postalCode!: string | undefined;
    activityField!: string | undefined;
    state!: boolean;
    contactRef!: number;
    addressRef!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditLegalContactForContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.identityCode = data["identityCode"];
            this.economicCode = data["economicCode"];
            this.registrationNumber = data["registrationNumber"];
            this.phone = data["phone"];
            this.manager = data["manager"];
            this.postalCode = data["postalCode"];
            this.activityField = data["activityField"];
            this.state = data["state"];
            this.contactRef = data["contactRef"];
            this.addressRef = data["addressRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditLegalContactForContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditLegalContactForContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["identityCode"] = this.identityCode;
        data["economicCode"] = this.economicCode;
        data["registrationNumber"] = this.registrationNumber;
        data["phone"] = this.phone;
        data["manager"] = this.manager;
        data["postalCode"] = this.postalCode;
        data["activityField"] = this.activityField;
        data["state"] = this.state;
        data["contactRef"] = this.contactRef;
        data["addressRef"] = this.addressRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditLegalContactForContactDto {
    name: string | undefined;
    identityCode: string | undefined;
    economicCode: string | undefined;
    registrationNumber: string | undefined;
    phone: string | undefined;
    manager: string | undefined;
    postalCode: string | undefined;
    activityField: string | undefined;
    state: boolean;
    contactRef: number;
    addressRef: number | undefined;
    id: number | undefined;
}

export class CreateOrEditFamilyMemberDto implements ICreateOrEditFamilyMemberDto {
    notIsAlive!: boolean;
    deathCause!: DeathCause;
    deathCauseExplanation!: string | undefined;
    deathDate!: moment.Moment | undefined;
    insuranceType!: InsuranceType;
    familyMemberRelation!: FamilyRelationType;
    beginDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    contactId!: number | undefined;
    otherRelation!: string | undefined;
    isLivingWithClient!: boolean;
    isActive!: boolean;
    deathCertificateSerial!: string | undefined;
    familyId!: number | undefined;
    familyMembersRoleIds!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditFamilyMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.notIsAlive = data["notIsAlive"];
            this.deathCause = data["deathCause"];
            this.deathCauseExplanation = data["deathCauseExplanation"];
            this.deathDate = data["deathDate"] ? moment(data["deathDate"].toString()) : <any>undefined;
            this.insuranceType = data["insuranceType"];
            this.familyMemberRelation = data["familyMemberRelation"];
            this.beginDate = data["beginDate"] ? moment(data["beginDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.contactId = data["contactId"];
            this.otherRelation = data["otherRelation"];
            this.isLivingWithClient = data["isLivingWithClient"];
            this.isActive = data["isActive"];
            this.deathCertificateSerial = data["deathCertificateSerial"];
            this.familyId = data["familyId"];
            this.familyMembersRoleIds = data["familyMembersRoleIds"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditFamilyMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditFamilyMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notIsAlive"] = this.notIsAlive;
        data["deathCause"] = this.deathCause;
        data["deathCauseExplanation"] = this.deathCauseExplanation;
        data["deathDate"] = this.deathDate ? this.deathDate.toISOString() : <any>undefined;
        data["insuranceType"] = this.insuranceType;
        data["familyMemberRelation"] = this.familyMemberRelation;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["contactId"] = this.contactId;
        data["otherRelation"] = this.otherRelation;
        data["isLivingWithClient"] = this.isLivingWithClient;
        data["isActive"] = this.isActive;
        data["deathCertificateSerial"] = this.deathCertificateSerial;
        data["familyId"] = this.familyId;
        data["familyMembersRoleIds"] = this.familyMembersRoleIds;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditFamilyMemberDto {
    notIsAlive: boolean;
    deathCause: DeathCause;
    deathCauseExplanation: string | undefined;
    deathDate: moment.Moment | undefined;
    insuranceType: InsuranceType;
    familyMemberRelation: FamilyRelationType;
    beginDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    contactId: number | undefined;
    otherRelation: string | undefined;
    isLivingWithClient: boolean;
    isActive: boolean;
    deathCertificateSerial: string | undefined;
    familyId: number | undefined;
    familyMembersRoleIds: string | undefined;
    id: number | undefined;
}

export class CreateOrEditDocumentDto implements ICreateOrEditDocumentDto {
    documentTitle!: string | undefined;
    entityRef!: number;
    entity!: Entities;
    entityDocType!: DocumentTypes;
    filePath!: string | undefined;
    fileName!: string | undefined;
    fileType!: string | undefined;
    status!: DocumentStatus;
    hasExpireDate!: boolean;
    expireDate!: moment.Moment | undefined;
    stringExpireDate!: string | undefined;
    code!: string | undefined;
    issueDate!: moment.Moment | undefined;
    isEqualToOriginal!: boolean;
    description!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.documentTitle = data["documentTitle"];
            this.entityRef = data["entityRef"];
            this.entity = data["entity"];
            this.entityDocType = data["entityDocType"];
            this.filePath = data["filePath"];
            this.fileName = data["fileName"];
            this.fileType = data["fileType"];
            this.status = data["status"];
            this.hasExpireDate = data["hasExpireDate"];
            this.expireDate = data["expireDate"] ? moment(data["expireDate"].toString()) : <any>undefined;
            this.stringExpireDate = data["stringExpireDate"];
            this.code = data["code"];
            this.issueDate = data["issueDate"] ? moment(data["issueDate"].toString()) : <any>undefined;
            this.isEqualToOriginal = data["isEqualToOriginal"];
            this.description = data["description"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentTitle"] = this.documentTitle;
        data["entityRef"] = this.entityRef;
        data["entity"] = this.entity;
        data["entityDocType"] = this.entityDocType;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["status"] = this.status;
        data["hasExpireDate"] = this.hasExpireDate;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["stringExpireDate"] = this.stringExpireDate;
        data["code"] = this.code;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["isEqualToOriginal"] = this.isEqualToOriginal;
        data["description"] = this.description;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditDocumentDto {
    documentTitle: string | undefined;
    entityRef: number;
    entity: Entities;
    entityDocType: DocumentTypes;
    filePath: string | undefined;
    fileName: string | undefined;
    fileType: string | undefined;
    status: DocumentStatus;
    hasExpireDate: boolean;
    expireDate: moment.Moment | undefined;
    stringExpireDate: string | undefined;
    code: string | undefined;
    issueDate: moment.Moment | undefined;
    isEqualToOriginal: boolean;
    description: string | undefined;
    id: number | undefined;
}

export class CreateOrEditContactAndDependentFormsDto implements ICreateOrEditContactAndDependentFormsDto {
    contact!: CreateOrEditContactDto;
    user!: UserContactDto;
    roles!: UserRole[] | undefined;
    employee!: CreateOrEditEmployeeForContactDto;
    legalContact!: CreateOrEditLegalContactForContactDto;
    legalAddress!: CreateOrEditAddressDto;
    familyMembers!: CreateOrEditFamilyMemberDto[] | undefined;
    attributeValues!: CreateOrEditAttributeValueDto[] | undefined;
    ambassador!: CreateOrEditAmbassadorDto[] | undefined;
    bankAccount!: CreateOrEditBankAccountDto[] | undefined;
    deleteBankAccountIds!: number[] | undefined;
    addresses!: CreateOrEditAddressDto[] | undefined;
    documents!: CreateOrEditDocumentDto[] | undefined;

    constructor(data?: ICreateOrEditContactAndDependentFormsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.contact = new CreateOrEditContactDto();
        }
    }

    init(data?: any) {
        if (data) {
            this.contact = data["contact"] ? CreateOrEditContactDto.fromJS(data["contact"]) : new CreateOrEditContactDto();
            this.user = data["user"] ? UserContactDto.fromJS(data["user"]) : <any>undefined;
            if (Array.isArray(data["roles"])) {
                this.roles = [] as any;
                for (let item of data["roles"])
                    this.roles!.push(UserRole.fromJS(item));
            }
            this.employee = data["employee"] ? CreateOrEditEmployeeForContactDto.fromJS(data["employee"]) : <any>undefined;
            this.legalContact = data["legalContact"] ? CreateOrEditLegalContactForContactDto.fromJS(data["legalContact"]) : <any>undefined;
            this.legalAddress = data["legalAddress"] ? CreateOrEditAddressDto.fromJS(data["legalAddress"]) : <any>undefined;
            if (Array.isArray(data["familyMembers"])) {
                this.familyMembers = [] as any;
                for (let item of data["familyMembers"])
                    this.familyMembers!.push(CreateOrEditFamilyMemberDto.fromJS(item));
            }
            if (Array.isArray(data["attributeValues"])) {
                this.attributeValues = [] as any;
                for (let item of data["attributeValues"])
                    this.attributeValues!.push(CreateOrEditAttributeValueDto.fromJS(item));
            }
            if (Array.isArray(data["ambassador"])) {
                this.ambassador = [] as any;
                for (let item of data["ambassador"])
                    this.ambassador!.push(CreateOrEditAmbassadorDto.fromJS(item));
            }
            if (Array.isArray(data["bankAccount"])) {
                this.bankAccount = [] as any;
                for (let item of data["bankAccount"])
                    this.bankAccount!.push(CreateOrEditBankAccountDto.fromJS(item));
            }
            if (Array.isArray(data["deleteBankAccountIds"])) {
                this.deleteBankAccountIds = [] as any;
                for (let item of data["deleteBankAccountIds"])
                    this.deleteBankAccountIds!.push(item);
            }
            if (Array.isArray(data["addresses"])) {
                this.addresses = [] as any;
                for (let item of data["addresses"])
                    this.addresses!.push(CreateOrEditAddressDto.fromJS(item));
            }
            if (Array.isArray(data["documents"])) {
                this.documents = [] as any;
                for (let item of data["documents"])
                    this.documents!.push(CreateOrEditDocumentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrEditContactAndDependentFormsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditContactAndDependentFormsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["legalContact"] = this.legalContact ? this.legalContact.toJSON() : <any>undefined;
        data["legalAddress"] = this.legalAddress ? this.legalAddress.toJSON() : <any>undefined;
        if (Array.isArray(this.familyMembers)) {
            data["familyMembers"] = [];
            for (let item of this.familyMembers)
                data["familyMembers"].push(item.toJSON());
        }
        if (Array.isArray(this.attributeValues)) {
            data["attributeValues"] = [];
            for (let item of this.attributeValues)
                data["attributeValues"].push(item.toJSON());
        }
        if (Array.isArray(this.ambassador)) {
            data["ambassador"] = [];
            for (let item of this.ambassador)
                data["ambassador"].push(item.toJSON());
        }
        if (Array.isArray(this.bankAccount)) {
            data["bankAccount"] = [];
            for (let item of this.bankAccount)
                data["bankAccount"].push(item.toJSON());
        }
        if (Array.isArray(this.deleteBankAccountIds)) {
            data["deleteBankAccountIds"] = [];
            for (let item of this.deleteBankAccountIds)
                data["deleteBankAccountIds"].push(item);
        }
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateOrEditContactAndDependentFormsDto {
    contact: CreateOrEditContactDto;
    user: UserContactDto;
    roles: UserRole[] | undefined;
    employee: CreateOrEditEmployeeForContactDto;
    legalContact: CreateOrEditLegalContactForContactDto;
    legalAddress: CreateOrEditAddressDto;
    familyMembers: CreateOrEditFamilyMemberDto[] | undefined;
    attributeValues: CreateOrEditAttributeValueDto[] | undefined;
    ambassador: CreateOrEditAmbassadorDto[] | undefined;
    bankAccount: CreateOrEditBankAccountDto[] | undefined;
    deleteBankAccountIds: number[] | undefined;
    addresses: CreateOrEditAddressDto[] | undefined;
    documents: CreateOrEditDocumentDto[] | undefined;
}

export class CreateOrEditContactOutputDto implements ICreateOrEditContactOutputDto {
    smsResult!: string | undefined;
    contactId!: number;

    constructor(data?: ICreateOrEditContactOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.smsResult = data["smsResult"];
            this.contactId = data["contactId"];
        }
    }

    static fromJS(data: any): CreateOrEditContactOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditContactOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["smsResult"] = this.smsResult;
        data["contactId"] = this.contactId;
        return data; 
    }
}

export interface ICreateOrEditContactOutputDto {
    smsResult: string | undefined;
    contactId: number;
}

export class ContactJobLookupTableDto implements IContactJobLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IContactJobLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): ContactJobLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactJobLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IContactJobLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfContactJobLookupTableDto implements IPagedResultDtoOfContactJobLookupTableDto {
    totalCount!: number;
    items!: ContactJobLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfContactJobLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(ContactJobLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfContactJobLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfContactJobLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfContactJobLookupTableDto {
    totalCount: number;
    items: ContactJobLookupTableDto[] | undefined;
}

export class ContactEducationDegreeLookupTableDto implements IContactEducationDegreeLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IContactEducationDegreeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): ContactEducationDegreeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactEducationDegreeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IContactEducationDegreeLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfContactEducationDegreeLookupTableDto implements IPagedResultDtoOfContactEducationDegreeLookupTableDto {
    totalCount!: number;
    items!: ContactEducationDegreeLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfContactEducationDegreeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(ContactEducationDegreeLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfContactEducationDegreeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfContactEducationDegreeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfContactEducationDegreeLookupTableDto {
    totalCount: number;
    items: ContactEducationDegreeLookupTableDto[] | undefined;
}

export class ContactUniversityLookupTableDto implements IContactUniversityLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IContactUniversityLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): ContactUniversityLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactUniversityLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IContactUniversityLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfContactUniversityLookupTableDto implements IPagedResultDtoOfContactUniversityLookupTableDto {
    totalCount!: number;
    items!: ContactUniversityLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfContactUniversityLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(ContactUniversityLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfContactUniversityLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfContactUniversityLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfContactUniversityLookupTableDto {
    totalCount: number;
    items: ContactUniversityLookupTableDto[] | undefined;
}

export class ContactEducationFieldLookupTableDto implements IContactEducationFieldLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IContactEducationFieldLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): ContactEducationFieldLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactEducationFieldLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IContactEducationFieldLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfContactEducationFieldLookupTableDto implements IPagedResultDtoOfContactEducationFieldLookupTableDto {
    totalCount!: number;
    items!: ContactEducationFieldLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfContactEducationFieldLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(ContactEducationFieldLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfContactEducationFieldLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfContactEducationFieldLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfContactEducationFieldLookupTableDto {
    totalCount: number;
    items: ContactEducationFieldLookupTableDto[] | undefined;
}

export class ContactCountryLookupTableDto implements IContactCountryLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IContactCountryLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): ContactCountryLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactCountryLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IContactCountryLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfContactCountryLookupTableDto implements IPagedResultDtoOfContactCountryLookupTableDto {
    totalCount!: number;
    items!: ContactCountryLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfContactCountryLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(ContactCountryLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfContactCountryLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfContactCountryLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfContactCountryLookupTableDto {
    totalCount: number;
    items: ContactCountryLookupTableDto[] | undefined;
}

export class RoleClaim implements IRoleClaim {
    tenantId!: number | undefined;
    roleId!: number;
    claimType!: string | undefined;
    claimValue!: string | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IRoleClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.roleId = data["roleId"];
            this.claimType = data["claimType"];
            this.claimValue = data["claimValue"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RoleClaim {
        data = typeof data === 'object' ? data : {};
        let result = new RoleClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["roleId"] = this.roleId;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRoleClaim {
    tenantId: number | undefined;
    roleId: number;
    claimType: string | undefined;
    claimValue: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class UserOrganizationUnit implements IUserOrganizationUnit {
    tenantId!: number | undefined;
    userId!: number;
    organizationUnitId!: number;
    isDeleted!: boolean;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IUserOrganizationUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.organizationUnitId = data["organizationUnitId"];
            this.isDeleted = data["isDeleted"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserOrganizationUnit {
        data = typeof data === 'object' ? data : {};
        let result = new UserOrganizationUnit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["organizationUnitId"] = this.organizationUnitId;
        data["isDeleted"] = this.isDeleted;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserOrganizationUnit {
    tenantId: number | undefined;
    userId: number;
    organizationUnitId: number;
    isDeleted: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class UserToken implements IUserToken {
    tenantId!: number | undefined;
    userId!: number;
    loginProvider!: string | undefined;
    name!: string | undefined;
    value!: string | undefined;
    expireDate!: moment.Moment | undefined;
    id!: number;

    constructor(data?: IUserToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.loginProvider = data["loginProvider"];
            this.name = data["name"];
            this.value = data["value"];
            this.expireDate = data["expireDate"] ? moment(data["expireDate"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserToken {
        data = typeof data === 'object' ? data : {};
        let result = new UserToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["name"] = this.name;
        data["value"] = this.value;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserToken {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: moment.Moment | undefined;
    id: number;
}

export class UserLogin implements IUserLogin {
    tenantId!: number | undefined;
    userId!: number;
    loginProvider!: string | undefined;
    providerKey!: string | undefined;
    id!: number;

    constructor(data?: IUserLogin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.loginProvider = data["loginProvider"];
            this.providerKey = data["providerKey"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserLogin {
        data = typeof data === 'object' ? data : {};
        let result = new UserLogin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["providerKey"] = this.providerKey;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserLogin {
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    providerKey: string | undefined;
    id: number;
}

export class UserClaim implements IUserClaim {
    tenantId!: number | undefined;
    userId!: number;
    claimType!: string | undefined;
    claimValue!: string | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IUserClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.claimType = data["claimType"];
            this.claimValue = data["claimValue"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserClaim {
        data = typeof data === 'object' ? data : {};
        let result = new UserClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserClaim {
    tenantId: number | undefined;
    userId: number;
    claimType: string | undefined;
    claimValue: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class UserPermissionSetting implements IUserPermissionSetting {
    userId!: number;
    tenantId!: number | undefined;
    name!: string | undefined;
    isGranted!: boolean;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IUserPermissionSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
            this.name = data["name"];
            this.isGranted = data["isGranted"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserPermissionSetting {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isGranted"] = this.isGranted;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserPermissionSetting {
    userId: number;
    tenantId: number | undefined;
    name: string | undefined;
    isGranted: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class Setting implements ISetting {
    tenantId!: number | undefined;
    userId!: number | undefined;
    name!: string | undefined;
    value!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ISetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.name = data["name"];
            this.value = data["value"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Setting {
        data = typeof data === 'object' ? data : {};
        let result = new Setting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["value"] = this.value;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISetting {
    tenantId: number | undefined;
    userId: number | undefined;
    name: string | undefined;
    value: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class User implements IUser {
    contactRef!: number | undefined;
    profilePictureId!: string | undefined;
    shouldChangePasswordOnNextLogin!: boolean;
    signInTokenExpireTimeUtc!: moment.Moment | undefined;
    signInToken!: string | undefined;
    googleAuthenticatorKey!: string | undefined;
    organizationUnits!: UserOrganizationUnit[] | undefined;
    normalizedUserName!: string | undefined;
    normalizedEmailAddress!: string | undefined;
    concurrencyStamp!: string | undefined;
    tokens!: UserToken[] | undefined;
    deleterUser!: User;
    creatorUser!: User;
    lastModifierUser!: User;
    authenticationSource!: string | undefined;
    userName!: string | undefined;
    tenantId!: number | undefined;
    emailAddress!: string | undefined;
    name!: string | undefined;
    surname!: string | undefined;
    readonly fullName!: string | undefined;
    password!: string | undefined;
    emailConfirmationCode!: string | undefined;
    passwordResetCode!: string | undefined;
    lockoutEndDateUtc!: moment.Moment | undefined;
    accessFailedCount!: number;
    isLockoutEnabled!: boolean;
    phoneNumber!: string | undefined;
    isPhoneNumberConfirmed!: boolean;
    securityStamp!: string | undefined;
    isTwoFactorEnabled!: boolean;
    logins!: UserLogin[] | undefined;
    roles!: UserRole[] | undefined;
    claims!: UserClaim[] | undefined;
    permissions!: UserPermissionSetting[] | undefined;
    settings!: Setting[] | undefined;
    isEmailConfirmed!: boolean;
    isActive!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contactRef = data["contactRef"];
            this.profilePictureId = data["profilePictureId"];
            this.shouldChangePasswordOnNextLogin = data["shouldChangePasswordOnNextLogin"];
            this.signInTokenExpireTimeUtc = data["signInTokenExpireTimeUtc"] ? moment(data["signInTokenExpireTimeUtc"].toString()) : <any>undefined;
            this.signInToken = data["signInToken"];
            this.googleAuthenticatorKey = data["googleAuthenticatorKey"];
            if (Array.isArray(data["organizationUnits"])) {
                this.organizationUnits = [] as any;
                for (let item of data["organizationUnits"])
                    this.organizationUnits!.push(UserOrganizationUnit.fromJS(item));
            }
            this.normalizedUserName = data["normalizedUserName"];
            this.normalizedEmailAddress = data["normalizedEmailAddress"];
            this.concurrencyStamp = data["concurrencyStamp"];
            if (Array.isArray(data["tokens"])) {
                this.tokens = [] as any;
                for (let item of data["tokens"])
                    this.tokens!.push(UserToken.fromJS(item));
            }
            this.deleterUser = data["deleterUser"] ? User.fromJS(data["deleterUser"]) : <any>undefined;
            this.creatorUser = data["creatorUser"] ? User.fromJS(data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = data["lastModifierUser"] ? User.fromJS(data["lastModifierUser"]) : <any>undefined;
            this.authenticationSource = data["authenticationSource"];
            this.userName = data["userName"];
            this.tenantId = data["tenantId"];
            this.emailAddress = data["emailAddress"];
            this.name = data["name"];
            this.surname = data["surname"];
            (<any>this).fullName = data["fullName"];
            this.password = data["password"];
            this.emailConfirmationCode = data["emailConfirmationCode"];
            this.passwordResetCode = data["passwordResetCode"];
            this.lockoutEndDateUtc = data["lockoutEndDateUtc"] ? moment(data["lockoutEndDateUtc"].toString()) : <any>undefined;
            this.accessFailedCount = data["accessFailedCount"];
            this.isLockoutEnabled = data["isLockoutEnabled"];
            this.phoneNumber = data["phoneNumber"];
            this.isPhoneNumberConfirmed = data["isPhoneNumberConfirmed"];
            this.securityStamp = data["securityStamp"];
            this.isTwoFactorEnabled = data["isTwoFactorEnabled"];
            if (Array.isArray(data["logins"])) {
                this.logins = [] as any;
                for (let item of data["logins"])
                    this.logins!.push(UserLogin.fromJS(item));
            }
            if (Array.isArray(data["roles"])) {
                this.roles = [] as any;
                for (let item of data["roles"])
                    this.roles!.push(UserRole.fromJS(item));
            }
            if (Array.isArray(data["claims"])) {
                this.claims = [] as any;
                for (let item of data["claims"])
                    this.claims!.push(UserClaim.fromJS(item));
            }
            if (Array.isArray(data["permissions"])) {
                this.permissions = [] as any;
                for (let item of data["permissions"])
                    this.permissions!.push(UserPermissionSetting.fromJS(item));
            }
            if (Array.isArray(data["settings"])) {
                this.settings = [] as any;
                for (let item of data["settings"])
                    this.settings!.push(Setting.fromJS(item));
            }
            this.isEmailConfirmed = data["isEmailConfirmed"];
            this.isActive = data["isActive"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactRef"] = this.contactRef;
        data["profilePictureId"] = this.profilePictureId;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["signInTokenExpireTimeUtc"] = this.signInTokenExpireTimeUtc ? this.signInTokenExpireTimeUtc.toISOString() : <any>undefined;
        data["signInToken"] = this.signInToken;
        data["googleAuthenticatorKey"] = this.googleAuthenticatorKey;
        if (Array.isArray(this.organizationUnits)) {
            data["organizationUnits"] = [];
            for (let item of this.organizationUnits)
                data["organizationUnits"].push(item.toJSON());
        }
        data["normalizedUserName"] = this.normalizedUserName;
        data["normalizedEmailAddress"] = this.normalizedEmailAddress;
        data["concurrencyStamp"] = this.concurrencyStamp;
        if (Array.isArray(this.tokens)) {
            data["tokens"] = [];
            for (let item of this.tokens)
                data["tokens"].push(item.toJSON());
        }
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["authenticationSource"] = this.authenticationSource;
        data["userName"] = this.userName;
        data["tenantId"] = this.tenantId;
        data["emailAddress"] = this.emailAddress;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["password"] = this.password;
        data["emailConfirmationCode"] = this.emailConfirmationCode;
        data["passwordResetCode"] = this.passwordResetCode;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toISOString() : <any>undefined;
        data["accessFailedCount"] = this.accessFailedCount;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["securityStamp"] = this.securityStamp;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        if (Array.isArray(this.logins)) {
            data["logins"] = [];
            for (let item of this.logins)
                data["logins"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.settings)) {
            data["settings"] = [];
            for (let item of this.settings)
                data["settings"].push(item.toJSON());
        }
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUser {
    contactRef: number | undefined;
    profilePictureId: string | undefined;
    shouldChangePasswordOnNextLogin: boolean;
    signInTokenExpireTimeUtc: moment.Moment | undefined;
    signInToken: string | undefined;
    googleAuthenticatorKey: string | undefined;
    organizationUnits: UserOrganizationUnit[] | undefined;
    normalizedUserName: string | undefined;
    normalizedEmailAddress: string | undefined;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    authenticationSource: string | undefined;
    userName: string | undefined;
    tenantId: number | undefined;
    emailAddress: string | undefined;
    name: string | undefined;
    surname: string | undefined;
    fullName: string | undefined;
    password: string | undefined;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: moment.Moment | undefined;
    accessFailedCount: number;
    isLockoutEnabled: boolean;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class RolePermissionSetting implements IRolePermissionSetting {
    roleId!: number;
    tenantId!: number | undefined;
    name!: string | undefined;
    isGranted!: boolean;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IRolePermissionSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.roleId = data["roleId"];
            this.tenantId = data["tenantId"];
            this.name = data["name"];
            this.isGranted = data["isGranted"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RolePermissionSetting {
        data = typeof data === 'object' ? data : {};
        let result = new RolePermissionSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isGranted"] = this.isGranted;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRolePermissionSetting {
    roleId: number;
    tenantId: number | undefined;
    name: string | undefined;
    isGranted: boolean;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class Role implements IRole {
    normalizedName!: string | undefined;
    claims!: RoleClaim[] | undefined;
    concurrencyStamp!: string | undefined;
    deleterUser!: User;
    creatorUser!: User;
    lastModifierUser!: User;
    tenantId!: number | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    isStatic!: boolean;
    isDefault!: boolean;
    permissions!: RolePermissionSetting[] | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.normalizedName = data["normalizedName"];
            if (Array.isArray(data["claims"])) {
                this.claims = [] as any;
                for (let item of data["claims"])
                    this.claims!.push(RoleClaim.fromJS(item));
            }
            this.concurrencyStamp = data["concurrencyStamp"];
            this.deleterUser = data["deleterUser"] ? User.fromJS(data["deleterUser"]) : <any>undefined;
            this.creatorUser = data["creatorUser"] ? User.fromJS(data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = data["lastModifierUser"] ? User.fromJS(data["lastModifierUser"]) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.isStatic = data["isStatic"];
            this.isDefault = data["isDefault"];
            if (Array.isArray(data["permissions"])) {
                this.permissions = [] as any;
                for (let item of data["permissions"])
                    this.permissions!.push(RolePermissionSetting.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Role {
        data = typeof data === 'object' ? data : {};
        let result = new Role();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["normalizedName"] = this.normalizedName;
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRole {
    normalizedName: string | undefined;
    claims: RoleClaim[] | undefined;
    concurrencyStamp: string | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    tenantId: number | undefined;
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    permissions: RolePermissionSetting[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class RoleListDto implements IRoleListDto {
    name!: string | undefined;
    displayName!: string | undefined;
    isStatic!: boolean;
    isDefault!: boolean;
    creationTime!: moment.Moment;
    id!: number;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.isStatic = data["isStatic"];
            this.isDefault = data["isDefault"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRoleListDto {
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;
    id: number;
}

export class ListResultDtoOfRoleListDto implements IListResultDtoOfRoleListDto {
    items!: RoleListDto[] | undefined;

    constructor(data?: IListResultDtoOfRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfRoleListDto {
    items: RoleListDto[] | undefined;
}

export class ContactRespectPrefixLookupTableDto implements IContactRespectPrefixLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IContactRespectPrefixLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): ContactRespectPrefixLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactRespectPrefixLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IContactRespectPrefixLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfContactRespectPrefixLookupTableDto implements IPagedResultDtoOfContactRespectPrefixLookupTableDto {
    totalCount!: number;
    items!: ContactRespectPrefixLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfContactRespectPrefixLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(ContactRespectPrefixLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfContactRespectPrefixLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfContactRespectPrefixLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfContactRespectPrefixLookupTableDto {
    totalCount: number;
    items: ContactRespectPrefixLookupTableDto[] | undefined;
}

export class GetValidationIntroducerOutput implements IGetValidationIntroducerOutput {
    name!: string | undefined;
    surname!: string | undefined;

    constructor(data?: IGetValidationIntroducerOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
        }
    }

    static fromJS(data: any): GetValidationIntroducerOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetValidationIntroducerOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        return data; 
    }
}

export interface IGetValidationIntroducerOutput {
    name: string | undefined;
    surname: string | undefined;
}

export class ContactGroupSubgroupLookupTableDto implements IContactGroupSubgroupLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IContactGroupSubgroupLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): ContactGroupSubgroupLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactGroupSubgroupLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IContactGroupSubgroupLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export enum WalletTypes {
    Money = 0,
    Score = 1,
}

export class RegisterUserWalletResponseDto implements IRegisterUserWalletResponseDto {
    status!: number;
    message!: string | undefined;
    accountNumber!: number | undefined;

    constructor(data?: IRegisterUserWalletResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.status = data["status"];
            this.message = data["message"];
            this.accountNumber = data["accountNumber"];
        }
    }

    static fromJS(data: any): RegisterUserWalletResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterUserWalletResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["accountNumber"] = this.accountNumber;
        return data; 
    }
}

export interface IRegisterUserWalletResponseDto {
    status: number;
    message: string | undefined;
    accountNumber: number | undefined;
}

export class GetAllSettlesForViewDto implements IGetAllSettlesForViewDto {
    transactionId!: number;
    trsTypRef!: number;
    trsTypFaTitle!: string | undefined;
    applicationCode!: string | undefined;
    amount!: number;
    creationTime!: moment.Moment;
    description!: string | undefined;

    constructor(data?: IGetAllSettlesForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transactionId = data["transactionId"];
            this.trsTypRef = data["trsTypRef"];
            this.trsTypFaTitle = data["trsTypFaTitle"];
            this.applicationCode = data["applicationCode"];
            this.amount = data["amount"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.description = data["description"];
        }
    }

    static fromJS(data: any): GetAllSettlesForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSettlesForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["trsTypRef"] = this.trsTypRef;
        data["trsTypFaTitle"] = this.trsTypFaTitle;
        data["applicationCode"] = this.applicationCode;
        data["amount"] = this.amount;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["description"] = this.description;
        return data; 
    }
}

export interface IGetAllSettlesForViewDto {
    transactionId: number;
    trsTypRef: number;
    trsTypFaTitle: string | undefined;
    applicationCode: string | undefined;
    amount: number;
    creationTime: moment.Moment;
    description: string | undefined;
}

export class PagedResultDtoOfGetAllSettlesForViewDto implements IPagedResultDtoOfGetAllSettlesForViewDto {
    totalCount!: number;
    items!: GetAllSettlesForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAllSettlesForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetAllSettlesForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAllSettlesForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAllSettlesForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetAllSettlesForViewDto {
    totalCount: number;
    items: GetAllSettlesForViewDto[] | undefined;
}

export class ReassignContactBillsInputDto implements IReassignContactBillsInputDto {
    currentContactId!: number;
    nextContactId!: number;

    constructor(data?: IReassignContactBillsInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentContactId = data["currentContactId"];
            this.nextContactId = data["nextContactId"];
        }
    }

    static fromJS(data: any): ReassignContactBillsInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReassignContactBillsInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentContactId"] = this.currentContactId;
        data["nextContactId"] = this.nextContactId;
        return data; 
    }
}

export interface IReassignContactBillsInputDto {
    currentContactId: number;
    nextContactId: number;
}

export class CreateContactForAppsDto implements ICreateContactForAppsDto {
    contact!: CreateOrEditContactDto;
    roles!: UserRole[] | undefined;

    constructor(data?: ICreateContactForAppsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.contact = new CreateOrEditContactDto();
        }
    }

    init(data?: any) {
        if (data) {
            this.contact = data["contact"] ? CreateOrEditContactDto.fromJS(data["contact"]) : new CreateOrEditContactDto();
            if (Array.isArray(data["roles"])) {
                this.roles = [] as any;
                for (let item of data["roles"])
                    this.roles!.push(UserRole.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateContactForAppsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateContactForAppsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateContactForAppsDto {
    contact: CreateOrEditContactDto;
    roles: UserRole[] | undefined;
}

export class ContactWalletDto implements IContactWalletDto {
    walletCode!: string | undefined;
    accountId!: number;
    contactRef!: number;
    id!: number;

    constructor(data?: IContactWalletDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.walletCode = data["walletCode"];
            this.accountId = data["accountId"];
            this.contactRef = data["contactRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ContactWalletDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactWalletDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["walletCode"] = this.walletCode;
        data["accountId"] = this.accountId;
        data["contactRef"] = this.contactRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface IContactWalletDto {
    walletCode: string | undefined;
    accountId: number;
    contactRef: number;
    id: number;
}

export class GetContactWalletForViewDto implements IGetContactWalletForViewDto {
    contactWallet!: ContactWalletDto;
    contactFirstName!: string | undefined;

    constructor(data?: IGetContactWalletForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contactWallet = data["contactWallet"] ? ContactWalletDto.fromJS(data["contactWallet"]) : <any>undefined;
            this.contactFirstName = data["contactFirstName"];
        }
    }

    static fromJS(data: any): GetContactWalletForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetContactWalletForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactWallet"] = this.contactWallet ? this.contactWallet.toJSON() : <any>undefined;
        data["contactFirstName"] = this.contactFirstName;
        return data; 
    }
}

export interface IGetContactWalletForViewDto {
    contactWallet: ContactWalletDto;
    contactFirstName: string | undefined;
}

export class PagedResultDtoOfGetContactWalletForViewDto implements IPagedResultDtoOfGetContactWalletForViewDto {
    totalCount!: number;
    items!: GetContactWalletForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetContactWalletForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetContactWalletForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetContactWalletForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetContactWalletForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetContactWalletForViewDto {
    totalCount: number;
    items: GetContactWalletForViewDto[] | undefined;
}

export class CreateOrEditContactWalletDto implements ICreateOrEditContactWalletDto {
    walletCode!: string | undefined;
    accountId!: number;
    contactRef!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditContactWalletDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.walletCode = data["walletCode"];
            this.accountId = data["accountId"];
            this.contactRef = data["contactRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditContactWalletDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditContactWalletDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["walletCode"] = this.walletCode;
        data["accountId"] = this.accountId;
        data["contactRef"] = this.contactRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditContactWalletDto {
    walletCode: string | undefined;
    accountId: number;
    contactRef: number;
    id: number | undefined;
}

export class GetContactWalletForEditOutput implements IGetContactWalletForEditOutput {
    contactWallet!: CreateOrEditContactWalletDto;
    contactFirstName!: string | undefined;

    constructor(data?: IGetContactWalletForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contactWallet = data["contactWallet"] ? CreateOrEditContactWalletDto.fromJS(data["contactWallet"]) : <any>undefined;
            this.contactFirstName = data["contactFirstName"];
        }
    }

    static fromJS(data: any): GetContactWalletForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetContactWalletForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactWallet"] = this.contactWallet ? this.contactWallet.toJSON() : <any>undefined;
        data["contactFirstName"] = this.contactFirstName;
        return data; 
    }
}

export interface IGetContactWalletForEditOutput {
    contactWallet: CreateOrEditContactWalletDto;
    contactFirstName: string | undefined;
}

export class ContactWalletContactLookupTableDto implements IContactWalletContactLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IContactWalletContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): ContactWalletContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactWalletContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IContactWalletContactLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfContactWalletContactLookupTableDto implements IPagedResultDtoOfContactWalletContactLookupTableDto {
    totalCount!: number;
    items!: ContactWalletContactLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfContactWalletContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(ContactWalletContactLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfContactWalletContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfContactWalletContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfContactWalletContactLookupTableDto {
    totalCount: number;
    items: ContactWalletContactLookupTableDto[] | undefined;
}

export class CountryDto implements ICountryDto {
    name!: string | undefined;
    prefix!: string | undefined;
    state!: boolean | undefined;
    description!: string | undefined;
    currencyId!: number | undefined;
    socialSecurityCode!: string | undefined;
    taxCode!: string | undefined;
    applicationLanguageId!: number | undefined;
    id!: number;

    constructor(data?: ICountryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.prefix = data["prefix"];
            this.state = data["state"];
            this.description = data["description"];
            this.currencyId = data["currencyId"];
            this.socialSecurityCode = data["socialSecurityCode"];
            this.taxCode = data["taxCode"];
            this.applicationLanguageId = data["applicationLanguageId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CountryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["prefix"] = this.prefix;
        data["state"] = this.state;
        data["description"] = this.description;
        data["currencyId"] = this.currencyId;
        data["socialSecurityCode"] = this.socialSecurityCode;
        data["taxCode"] = this.taxCode;
        data["applicationLanguageId"] = this.applicationLanguageId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICountryDto {
    name: string | undefined;
    prefix: string | undefined;
    state: boolean | undefined;
    description: string | undefined;
    currencyId: number | undefined;
    socialSecurityCode: string | undefined;
    taxCode: string | undefined;
    applicationLanguageId: number | undefined;
    id: number;
}

export class GetCountryForViewDto implements IGetCountryForViewDto {
    country!: CountryDto;
    applicationLanguageName!: string | undefined;
    currencyName!: string | undefined;

    constructor(data?: IGetCountryForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.country = data["country"] ? CountryDto.fromJS(data["country"]) : <any>undefined;
            this.applicationLanguageName = data["applicationLanguageName"];
            this.currencyName = data["currencyName"];
        }
    }

    static fromJS(data: any): GetCountryForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCountryForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["applicationLanguageName"] = this.applicationLanguageName;
        data["currencyName"] = this.currencyName;
        return data; 
    }
}

export interface IGetCountryForViewDto {
    country: CountryDto;
    applicationLanguageName: string | undefined;
    currencyName: string | undefined;
}

export class PagedResultDtoOfGetCountryForViewDto implements IPagedResultDtoOfGetCountryForViewDto {
    totalCount!: number;
    items!: GetCountryForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCountryForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetCountryForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCountryForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCountryForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetCountryForViewDto {
    totalCount: number;
    items: GetCountryForViewDto[] | undefined;
}

export class CreateOrEditCountryDto implements ICreateOrEditCountryDto {
    name!: string | undefined;
    prefix!: string | undefined;
    state!: boolean | undefined;
    description!: string | undefined;
    socialSecurityCode!: string | undefined;
    taxCode!: string | undefined;
    applicationLanguageId!: number | undefined;
    currencyId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCountryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.prefix = data["prefix"];
            this.state = data["state"];
            this.description = data["description"];
            this.socialSecurityCode = data["socialSecurityCode"];
            this.taxCode = data["taxCode"];
            this.applicationLanguageId = data["applicationLanguageId"];
            this.currencyId = data["currencyId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCountryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCountryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["prefix"] = this.prefix;
        data["state"] = this.state;
        data["description"] = this.description;
        data["socialSecurityCode"] = this.socialSecurityCode;
        data["taxCode"] = this.taxCode;
        data["applicationLanguageId"] = this.applicationLanguageId;
        data["currencyId"] = this.currencyId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditCountryDto {
    name: string | undefined;
    prefix: string | undefined;
    state: boolean | undefined;
    description: string | undefined;
    socialSecurityCode: string | undefined;
    taxCode: string | undefined;
    applicationLanguageId: number | undefined;
    currencyId: number | undefined;
    id: number | undefined;
}

export class GetCountryForEditOutput implements IGetCountryForEditOutput {
    country!: CreateOrEditCountryDto;
    applicationLanguageName!: string | undefined;
    currencyName!: string | undefined;

    constructor(data?: IGetCountryForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.country = data["country"] ? CreateOrEditCountryDto.fromJS(data["country"]) : <any>undefined;
            this.applicationLanguageName = data["applicationLanguageName"];
            this.currencyName = data["currencyName"];
        }
    }

    static fromJS(data: any): GetCountryForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCountryForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["applicationLanguageName"] = this.applicationLanguageName;
        data["currencyName"] = this.currencyName;
        return data; 
    }
}

export interface IGetCountryForEditOutput {
    country: CreateOrEditCountryDto;
    applicationLanguageName: string | undefined;
    currencyName: string | undefined;
}

export class ViewResult implements IViewResult {
    messages!: string[] | undefined;
    status!: boolean;

    constructor(data?: IViewResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["messages"])) {
                this.messages = [] as any;
                for (let item of data["messages"])
                    this.messages!.push(item);
            }
            this.status = data["status"];
        }
    }

    static fromJS(data: any): ViewResult {
        data = typeof data === 'object' ? data : {};
        let result = new ViewResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["status"] = this.status;
        return data; 
    }
}

export interface IViewResult {
    messages: string[] | undefined;
    status: boolean;
}

export class CountryApplicationLanguageLookupTableDto implements ICountryApplicationLanguageLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ICountryApplicationLanguageLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): CountryApplicationLanguageLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryApplicationLanguageLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ICountryApplicationLanguageLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class CountryCurrencyLookupTableDto implements ICountryCurrencyLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ICountryCurrencyLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): CountryCurrencyLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryCurrencyLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ICountryCurrencyLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class CurrencyDto implements ICurrencyDto {
    name!: string | undefined;
    rate!: number;
    description!: string | undefined;
    state!: boolean | undefined;
    createdBy!: number;
    modifiedBy!: number | undefined;
    created!: moment.Moment;
    modified!: moment.Moment | undefined;
    id!: number;

    constructor(data?: ICurrencyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.rate = data["rate"];
            this.description = data["description"];
            this.state = data["state"];
            this.createdBy = data["createdBy"];
            this.modifiedBy = data["modifiedBy"];
            this.created = data["created"] ? moment(data["created"].toString()) : <any>undefined;
            this.modified = data["modified"] ? moment(data["modified"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CurrencyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["rate"] = this.rate;
        data["description"] = this.description;
        data["state"] = this.state;
        data["createdBy"] = this.createdBy;
        data["modifiedBy"] = this.modifiedBy;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICurrencyDto {
    name: string | undefined;
    rate: number;
    description: string | undefined;
    state: boolean | undefined;
    createdBy: number;
    modifiedBy: number | undefined;
    created: moment.Moment;
    modified: moment.Moment | undefined;
    id: number;
}

export class GetCurrencyForViewDto implements IGetCurrencyForViewDto {
    currency!: CurrencyDto;

    constructor(data?: IGetCurrencyForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currency = data["currency"] ? CurrencyDto.fromJS(data["currency"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrencyForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrencyForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currency"] = this.currency ? this.currency.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetCurrencyForViewDto {
    currency: CurrencyDto;
}

export class PagedResultDtoOfGetCurrencyForViewDto implements IPagedResultDtoOfGetCurrencyForViewDto {
    totalCount!: number;
    items!: GetCurrencyForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCurrencyForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetCurrencyForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCurrencyForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCurrencyForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetCurrencyForViewDto {
    totalCount: number;
    items: GetCurrencyForViewDto[] | undefined;
}

export class CreateOrEditCurrencyDto implements ICreateOrEditCurrencyDto {
    name!: string | undefined;
    rate!: number;
    description!: string | undefined;
    state!: boolean | undefined;
    createdBy!: number;
    modifiedBy!: number | undefined;
    created!: moment.Moment;
    modified!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCurrencyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.rate = data["rate"];
            this.description = data["description"];
            this.state = data["state"];
            this.createdBy = data["createdBy"];
            this.modifiedBy = data["modifiedBy"];
            this.created = data["created"] ? moment(data["created"].toString()) : <any>undefined;
            this.modified = data["modified"] ? moment(data["modified"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCurrencyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCurrencyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["rate"] = this.rate;
        data["description"] = this.description;
        data["state"] = this.state;
        data["createdBy"] = this.createdBy;
        data["modifiedBy"] = this.modifiedBy;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditCurrencyDto {
    name: string | undefined;
    rate: number;
    description: string | undefined;
    state: boolean | undefined;
    createdBy: number;
    modifiedBy: number | undefined;
    created: moment.Moment;
    modified: moment.Moment | undefined;
    id: number | undefined;
}

export class GetCurrencyForEditOutput implements IGetCurrencyForEditOutput {
    currency!: CreateOrEditCurrencyDto;

    constructor(data?: IGetCurrencyForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currency = data["currency"] ? CreateOrEditCurrencyDto.fromJS(data["currency"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrencyForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrencyForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currency"] = this.currency ? this.currency.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetCurrencyForEditOutput {
    currency: CreateOrEditCurrencyDto;
}

export class Widget implements IWidget {
    widgetId!: string | undefined;
    height!: number;
    width!: number;
    positionX!: number;
    positionY!: number;

    constructor(data?: IWidget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.widgetId = data["widgetId"];
            this.height = data["height"];
            this.width = data["width"];
            this.positionX = data["positionX"];
            this.positionY = data["positionY"];
        }
    }

    static fromJS(data: any): Widget {
        data = typeof data === 'object' ? data : {};
        let result = new Widget();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["widgetId"] = this.widgetId;
        data["height"] = this.height;
        data["width"] = this.width;
        data["positionX"] = this.positionX;
        data["positionY"] = this.positionY;
        return data; 
    }
}

export interface IWidget {
    widgetId: string | undefined;
    height: number;
    width: number;
    positionX: number;
    positionY: number;
}

export class Page implements IPage {
    id!: string | undefined;
    name!: string | undefined;
    widgets!: Widget[] | undefined;

    constructor(data?: IPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            if (Array.isArray(data["widgets"])) {
                this.widgets = [] as any;
                for (let item of data["widgets"])
                    this.widgets!.push(Widget.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Page {
        data = typeof data === 'object' ? data : {};
        let result = new Page();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.widgets)) {
            data["widgets"] = [];
            for (let item of this.widgets)
                data["widgets"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPage {
    id: string | undefined;
    name: string | undefined;
    widgets: Widget[] | undefined;
}

export class Dashboard implements IDashboard {
    dashboardName!: string | undefined;
    pages!: Page[] | undefined;

    constructor(data?: IDashboard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dashboardName = data["dashboardName"];
            if (Array.isArray(data["pages"])) {
                this.pages = [] as any;
                for (let item of data["pages"])
                    this.pages!.push(Page.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Dashboard {
        data = typeof data === 'object' ? data : {};
        let result = new Dashboard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardName"] = this.dashboardName;
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDashboard {
    dashboardName: string | undefined;
    pages: Page[] | undefined;
}

export class SavePageInput implements ISavePageInput {
    dashboardName!: string | undefined;
    application!: string | undefined;
    pages!: Page[] | undefined;

    constructor(data?: ISavePageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dashboardName = data["dashboardName"];
            this.application = data["application"];
            if (Array.isArray(data["pages"])) {
                this.pages = [] as any;
                for (let item of data["pages"])
                    this.pages!.push(Page.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SavePageInput {
        data = typeof data === 'object' ? data : {};
        let result = new SavePageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardName"] = this.dashboardName;
        data["application"] = this.application;
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISavePageInput {
    dashboardName: string | undefined;
    application: string | undefined;
    pages: Page[] | undefined;
}

export class RenamePageInput implements IRenamePageInput {
    dashboardName!: string | undefined;
    id!: string | undefined;
    name!: string | undefined;
    application!: string | undefined;

    constructor(data?: IRenamePageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dashboardName = data["dashboardName"];
            this.id = data["id"];
            this.name = data["name"];
            this.application = data["application"];
        }
    }

    static fromJS(data: any): RenamePageInput {
        data = typeof data === 'object' ? data : {};
        let result = new RenamePageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardName"] = this.dashboardName;
        data["id"] = this.id;
        data["name"] = this.name;
        data["application"] = this.application;
        return data; 
    }
}

export interface IRenamePageInput {
    dashboardName: string | undefined;
    id: string | undefined;
    name: string | undefined;
    application: string | undefined;
}

export class AddNewPageInput implements IAddNewPageInput {
    dashboardName!: string | undefined;
    name!: string | undefined;
    application!: string | undefined;

    constructor(data?: IAddNewPageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dashboardName = data["dashboardName"];
            this.name = data["name"];
            this.application = data["application"];
        }
    }

    static fromJS(data: any): AddNewPageInput {
        data = typeof data === 'object' ? data : {};
        let result = new AddNewPageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardName"] = this.dashboardName;
        data["name"] = this.name;
        data["application"] = this.application;
        return data; 
    }
}

export interface IAddNewPageInput {
    dashboardName: string | undefined;
    name: string | undefined;
    application: string | undefined;
}

export class AddNewPageOutput implements IAddNewPageOutput {
    pageId!: string | undefined;

    constructor(data?: IAddNewPageOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pageId = data["pageId"];
        }
    }

    static fromJS(data: any): AddNewPageOutput {
        data = typeof data === 'object' ? data : {};
        let result = new AddNewPageOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageId"] = this.pageId;
        return data; 
    }
}

export interface IAddNewPageOutput {
    pageId: string | undefined;
}

export class AddWidgetInput implements IAddWidgetInput {
    widgetId!: string | undefined;
    pageId!: string | undefined;
    dashboardName!: string | undefined;
    width!: number;
    height!: number;
    application!: string | undefined;

    constructor(data?: IAddWidgetInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.widgetId = data["widgetId"];
            this.pageId = data["pageId"];
            this.dashboardName = data["dashboardName"];
            this.width = data["width"];
            this.height = data["height"];
            this.application = data["application"];
        }
    }

    static fromJS(data: any): AddWidgetInput {
        data = typeof data === 'object' ? data : {};
        let result = new AddWidgetInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["widgetId"] = this.widgetId;
        data["pageId"] = this.pageId;
        data["dashboardName"] = this.dashboardName;
        data["width"] = this.width;
        data["height"] = this.height;
        data["application"] = this.application;
        return data; 
    }
}

export interface IAddWidgetInput {
    widgetId: string | undefined;
    pageId: string | undefined;
    dashboardName: string | undefined;
    width: number;
    height: number;
    application: string | undefined;
}

export class WidgetFilterOutput implements IWidgetFilterOutput {
    readonly id!: string | undefined;
    readonly name!: string | undefined;

    constructor(data?: IWidgetFilterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            (<any>this).id = data["id"];
            (<any>this).name = data["name"];
        }
    }

    static fromJS(data: any): WidgetFilterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetFilterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IWidgetFilterOutput {
    id: string | undefined;
    name: string | undefined;
}

export class WidgetOutput implements IWidgetOutput {
    readonly id!: string | undefined;
    readonly name!: string | undefined;
    readonly description!: string | undefined;
    filters!: WidgetFilterOutput[] | undefined;

    constructor(data?: IWidgetOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            (<any>this).id = data["id"];
            (<any>this).name = data["name"];
            (<any>this).description = data["description"];
            if (Array.isArray(data["filters"])) {
                this.filters = [] as any;
                for (let item of data["filters"])
                    this.filters!.push(WidgetFilterOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WidgetOutput {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IWidgetOutput {
    id: string | undefined;
    name: string | undefined;
    description: string | undefined;
    filters: WidgetFilterOutput[] | undefined;
}

export class DashboardOutput implements IDashboardOutput {
    name!: string | undefined;
    widgets!: WidgetOutput[] | undefined;

    constructor(data?: IDashboardOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            if (Array.isArray(data["widgets"])) {
                this.widgets = [] as any;
                for (let item of data["widgets"])
                    this.widgets!.push(WidgetOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DashboardOutput {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.widgets)) {
            data["widgets"] = [];
            for (let item of this.widgets)
                data["widgets"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDashboardOutput {
    name: string | undefined;
    widgets: WidgetOutput[] | undefined;
}

export class DeceasedDto implements IDeceasedDto {
    gender!: Gender;
    firstName!: string | undefined;
    lastName!: string | undefined;
    survivorName!: string | undefined;
    survivorPhoneNo!: string | undefined;
    description!: string | undefined;
    imagePath!: string | undefined;
    deathDate!: moment.Moment | undefined;
    creationTime!: moment.Moment | undefined;
    code!: string | undefined;
    isApproved!: boolean;
    state!: boolean;
    isShow!: boolean;
    respectPrefixRef!: number | undefined;
    id!: number;

    constructor(data?: IDeceasedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gender = data["gender"];
            this.firstName = data["firstName"];
            this.lastName = data["lastName"];
            this.survivorName = data["survivorName"];
            this.survivorPhoneNo = data["survivorPhoneNo"];
            this.description = data["description"];
            this.imagePath = data["imagePath"];
            this.deathDate = data["deathDate"] ? moment(data["deathDate"].toString()) : <any>undefined;
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.code = data["code"];
            this.isApproved = data["isApproved"];
            this.state = data["state"];
            this.isShow = data["isShow"];
            this.respectPrefixRef = data["respectPrefixRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DeceasedDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeceasedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gender"] = this.gender;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["survivorName"] = this.survivorName;
        data["survivorPhoneNo"] = this.survivorPhoneNo;
        data["description"] = this.description;
        data["imagePath"] = this.imagePath;
        data["deathDate"] = this.deathDate ? this.deathDate.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["code"] = this.code;
        data["isApproved"] = this.isApproved;
        data["state"] = this.state;
        data["isShow"] = this.isShow;
        data["respectPrefixRef"] = this.respectPrefixRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDeceasedDto {
    gender: Gender;
    firstName: string | undefined;
    lastName: string | undefined;
    survivorName: string | undefined;
    survivorPhoneNo: string | undefined;
    description: string | undefined;
    imagePath: string | undefined;
    deathDate: moment.Moment | undefined;
    creationTime: moment.Moment | undefined;
    code: string | undefined;
    isApproved: boolean;
    state: boolean;
    isShow: boolean;
    respectPrefixRef: number | undefined;
    id: number;
}

export class GetDeceasedForViewDto implements IGetDeceasedForViewDto {
    deceased!: DeceasedDto;
    respectPrefixTitle!: string | undefined;
    creatorUserName!: string | undefined;

    constructor(data?: IGetDeceasedForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deceased = data["deceased"] ? DeceasedDto.fromJS(data["deceased"]) : <any>undefined;
            this.respectPrefixTitle = data["respectPrefixTitle"];
            this.creatorUserName = data["creatorUserName"];
        }
    }

    static fromJS(data: any): GetDeceasedForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeceasedForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deceased"] = this.deceased ? this.deceased.toJSON() : <any>undefined;
        data["respectPrefixTitle"] = this.respectPrefixTitle;
        data["creatorUserName"] = this.creatorUserName;
        return data; 
    }
}

export interface IGetDeceasedForViewDto {
    deceased: DeceasedDto;
    respectPrefixTitle: string | undefined;
    creatorUserName: string | undefined;
}

export class PagedResultDtoOfGetDeceasedForViewDto implements IPagedResultDtoOfGetDeceasedForViewDto {
    totalCount!: number;
    items!: GetDeceasedForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetDeceasedForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetDeceasedForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetDeceasedForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetDeceasedForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetDeceasedForViewDto {
    totalCount: number;
    items: GetDeceasedForViewDto[] | undefined;
}

export class CreateOrEditDeceasedDto implements ICreateOrEditDeceasedDto {
    gender!: Gender;
    firstName!: string | undefined;
    lastName!: string | undefined;
    survivorName!: string | undefined;
    survivorPhoneNo!: string | undefined;
    description!: string | undefined;
    imagePath!: string | undefined;
    deathDate!: moment.Moment | undefined;
    code!: string | undefined;
    isApproved!: boolean;
    state!: boolean;
    isShow!: boolean;
    respectPrefixRef!: number | undefined;
    isDuplicate!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditDeceasedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gender = data["gender"];
            this.firstName = data["firstName"];
            this.lastName = data["lastName"];
            this.survivorName = data["survivorName"];
            this.survivorPhoneNo = data["survivorPhoneNo"];
            this.description = data["description"];
            this.imagePath = data["imagePath"];
            this.deathDate = data["deathDate"] ? moment(data["deathDate"].toString()) : <any>undefined;
            this.code = data["code"];
            this.isApproved = data["isApproved"];
            this.state = data["state"];
            this.isShow = data["isShow"];
            this.respectPrefixRef = data["respectPrefixRef"];
            this.isDuplicate = data["isDuplicate"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditDeceasedDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditDeceasedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gender"] = this.gender;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["survivorName"] = this.survivorName;
        data["survivorPhoneNo"] = this.survivorPhoneNo;
        data["description"] = this.description;
        data["imagePath"] = this.imagePath;
        data["deathDate"] = this.deathDate ? this.deathDate.toISOString() : <any>undefined;
        data["code"] = this.code;
        data["isApproved"] = this.isApproved;
        data["state"] = this.state;
        data["isShow"] = this.isShow;
        data["respectPrefixRef"] = this.respectPrefixRef;
        data["isDuplicate"] = this.isDuplicate;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditDeceasedDto {
    gender: Gender;
    firstName: string | undefined;
    lastName: string | undefined;
    survivorName: string | undefined;
    survivorPhoneNo: string | undefined;
    description: string | undefined;
    imagePath: string | undefined;
    deathDate: moment.Moment | undefined;
    code: string | undefined;
    isApproved: boolean;
    state: boolean;
    isShow: boolean;
    respectPrefixRef: number | undefined;
    isDuplicate: boolean;
    id: number | undefined;
}

export class GetDeceasedForEditOutput implements IGetDeceasedForEditOutput {
    deceased!: CreateOrEditDeceasedDto;
    respectPrefixTitle!: string | undefined;

    constructor(data?: IGetDeceasedForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deceased = data["deceased"] ? CreateOrEditDeceasedDto.fromJS(data["deceased"]) : <any>undefined;
            this.respectPrefixTitle = data["respectPrefixTitle"];
        }
    }

    static fromJS(data: any): GetDeceasedForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeceasedForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deceased"] = this.deceased ? this.deceased.toJSON() : <any>undefined;
        data["respectPrefixTitle"] = this.respectPrefixTitle;
        return data; 
    }
}

export interface IGetDeceasedForEditOutput {
    deceased: CreateOrEditDeceasedDto;
    respectPrefixTitle: string | undefined;
}

export class PagedResultDtoOfCreateOrEditBannerDto implements IPagedResultDtoOfCreateOrEditBannerDto {
    totalCount!: number;
    items!: CreateOrEditBannerDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCreateOrEditBannerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(CreateOrEditBannerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCreateOrEditBannerDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCreateOrEditBannerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfCreateOrEditBannerDto {
    totalCount: number;
    items: CreateOrEditBannerDto[] | undefined;
}

export class GetDeceasedAndBannersForEditOutput implements IGetDeceasedAndBannersForEditOutput {
    deceased!: CreateOrEditDeceasedDto;
    respectPrefixTitle!: string | undefined;
    banners!: PagedResultDtoOfCreateOrEditBannerDto;

    constructor(data?: IGetDeceasedAndBannersForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deceased = data["deceased"] ? CreateOrEditDeceasedDto.fromJS(data["deceased"]) : <any>undefined;
            this.respectPrefixTitle = data["respectPrefixTitle"];
            this.banners = data["banners"] ? PagedResultDtoOfCreateOrEditBannerDto.fromJS(data["banners"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDeceasedAndBannersForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeceasedAndBannersForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deceased"] = this.deceased ? this.deceased.toJSON() : <any>undefined;
        data["respectPrefixTitle"] = this.respectPrefixTitle;
        data["banners"] = this.banners ? this.banners.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetDeceasedAndBannersForEditOutput {
    deceased: CreateOrEditDeceasedDto;
    respectPrefixTitle: string | undefined;
    banners: PagedResultDtoOfCreateOrEditBannerDto;
}

export class CreateOrEditDeceasedOutput implements ICreateOrEditDeceasedOutput {
    id!: number | undefined;
    message!: string | undefined;
    success!: boolean;

    constructor(data?: ICreateOrEditDeceasedOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.message = data["message"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): CreateOrEditDeceasedOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditDeceasedOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["message"] = this.message;
        data["success"] = this.success;
        return data; 
    }
}

export interface ICreateOrEditDeceasedOutput {
    id: number | undefined;
    message: string | undefined;
    success: boolean;
}

export class CreateOrEditDeceasedAndBannerDto implements ICreateOrEditDeceasedAndBannerDto {
    banners!: CreateOrEditBannerDto[] | undefined;
    deceased!: CreateOrEditDeceasedDto;

    constructor(data?: ICreateOrEditDeceasedAndBannerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["banners"])) {
                this.banners = [] as any;
                for (let item of data["banners"])
                    this.banners!.push(CreateOrEditBannerDto.fromJS(item));
            }
            this.deceased = data["deceased"] ? CreateOrEditDeceasedDto.fromJS(data["deceased"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrEditDeceasedAndBannerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditDeceasedAndBannerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.banners)) {
            data["banners"] = [];
            for (let item of this.banners)
                data["banners"].push(item.toJSON());
        }
        data["deceased"] = this.deceased ? this.deceased.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICreateOrEditDeceasedAndBannerDto {
    banners: CreateOrEditBannerDto[] | undefined;
    deceased: CreateOrEditDeceasedDto;
}

export class GetClipsForShop implements IGetClipsForShop {
    title!: string | undefined;
    filePath!: string | undefined;
    thumbPath!: string | undefined;
    viewCount!: number | undefined;
    creatorName!: string | undefined;
    created!: moment.Moment | undefined;

    constructor(data?: IGetClipsForShop) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.filePath = data["filePath"];
            this.thumbPath = data["thumbPath"];
            this.viewCount = data["viewCount"];
            this.creatorName = data["creatorName"];
            this.created = data["created"] ? moment(data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetClipsForShop {
        data = typeof data === 'object' ? data : {};
        let result = new GetClipsForShop();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["filePath"] = this.filePath;
        data["thumbPath"] = this.thumbPath;
        data["viewCount"] = this.viewCount;
        data["creatorName"] = this.creatorName;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGetClipsForShop {
    title: string | undefined;
    filePath: string | undefined;
    thumbPath: string | undefined;
    viewCount: number | undefined;
    creatorName: string | undefined;
    created: moment.Moment | undefined;
}

export class GetDeceasedForShopDto implements IGetDeceasedForShopDto {
    deceased!: DeceasedDto;
    respectPrefixTitle!: string | undefined;
    visitCount!: number;
    pictureGallery!: string[] | undefined;
    clips!: GetClipsForShop[] | undefined;
    video!: string | undefined;

    constructor(data?: IGetDeceasedForShopDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deceased = data["deceased"] ? DeceasedDto.fromJS(data["deceased"]) : <any>undefined;
            this.respectPrefixTitle = data["respectPrefixTitle"];
            this.visitCount = data["visitCount"];
            if (Array.isArray(data["pictureGallery"])) {
                this.pictureGallery = [] as any;
                for (let item of data["pictureGallery"])
                    this.pictureGallery!.push(item);
            }
            if (Array.isArray(data["clips"])) {
                this.clips = [] as any;
                for (let item of data["clips"])
                    this.clips!.push(GetClipsForShop.fromJS(item));
            }
            this.video = data["video"];
        }
    }

    static fromJS(data: any): GetDeceasedForShopDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeceasedForShopDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deceased"] = this.deceased ? this.deceased.toJSON() : <any>undefined;
        data["respectPrefixTitle"] = this.respectPrefixTitle;
        data["visitCount"] = this.visitCount;
        if (Array.isArray(this.pictureGallery)) {
            data["pictureGallery"] = [];
            for (let item of this.pictureGallery)
                data["pictureGallery"].push(item);
        }
        if (Array.isArray(this.clips)) {
            data["clips"] = [];
            for (let item of this.clips)
                data["clips"].push(item.toJSON());
        }
        data["video"] = this.video;
        return data; 
    }
}

export interface IGetDeceasedForShopDto {
    deceased: DeceasedDto;
    respectPrefixTitle: string | undefined;
    visitCount: number;
    pictureGallery: string[] | undefined;
    clips: GetClipsForShop[] | undefined;
    video: string | undefined;
}

export class GetDeceasedAndCeremonyForShopDto implements IGetDeceasedAndCeremonyForShopDto {
    deceased!: DeceasedDto;
    respectPrefixTitle!: string | undefined;
    ceremonies!: GetAllCeremoniesForShopDto[] | undefined;

    constructor(data?: IGetDeceasedAndCeremonyForShopDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deceased = data["deceased"] ? DeceasedDto.fromJS(data["deceased"]) : <any>undefined;
            this.respectPrefixTitle = data["respectPrefixTitle"];
            if (Array.isArray(data["ceremonies"])) {
                this.ceremonies = [] as any;
                for (let item of data["ceremonies"])
                    this.ceremonies!.push(GetAllCeremoniesForShopDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDeceasedAndCeremonyForShopDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeceasedAndCeremonyForShopDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deceased"] = this.deceased ? this.deceased.toJSON() : <any>undefined;
        data["respectPrefixTitle"] = this.respectPrefixTitle;
        if (Array.isArray(this.ceremonies)) {
            data["ceremonies"] = [];
            for (let item of this.ceremonies)
                data["ceremonies"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetDeceasedAndCeremonyForShopDto {
    deceased: DeceasedDto;
    respectPrefixTitle: string | undefined;
    ceremonies: GetAllCeremoniesForShopDto[] | undefined;
}

export class KheyratDetails implements IKheyratDetails {
    name!: string | undefined;
    date!: moment.Moment;
    price!: number;

    constructor(data?: IKheyratDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.price = data["price"];
        }
    }

    static fromJS(data: any): KheyratDetails {
        data = typeof data === 'object' ? data : {};
        let result = new KheyratDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["price"] = this.price;
        return data; 
    }
}

export interface IKheyratDetails {
    name: string | undefined;
    date: moment.Moment;
    price: number;
}

export class Kheyrat implements IKheyrat {
    totalPrice!: number;
    details!: KheyratDetails[] | undefined;

    constructor(data?: IKheyrat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalPrice = data["totalPrice"];
            if (Array.isArray(data["details"])) {
                this.details = [] as any;
                for (let item of data["details"])
                    this.details!.push(KheyratDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Kheyrat {
        data = typeof data === 'object' ? data : {};
        let result = new Kheyrat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalPrice"] = this.totalPrice;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IKheyrat {
    totalPrice: number;
    details: KheyratDetails[] | undefined;
}

export class DeceasedRespectPrefixLookupTableDto implements IDeceasedRespectPrefixLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IDeceasedRespectPrefixLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): DeceasedRespectPrefixLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeceasedRespectPrefixLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IDeceasedRespectPrefixLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfDeceasedRespectPrefixLookupTableDto implements IPagedResultDtoOfDeceasedRespectPrefixLookupTableDto {
    totalCount!: number;
    items!: DeceasedRespectPrefixLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfDeceasedRespectPrefixLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(DeceasedRespectPrefixLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfDeceasedRespectPrefixLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfDeceasedRespectPrefixLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfDeceasedRespectPrefixLookupTableDto {
    totalCount: number;
    items: DeceasedRespectPrefixLookupTableDto[] | undefined;
}

export class GetInquiryDeceasedDto implements IGetInquiryDeceasedDto {
    firstName!: string | undefined;
    lastName!: string | undefined;
    ghete!: string | undefined;
    block!: string | undefined;
    row!: string | undefined;
    number!: string | undefined;
    description!: string | undefined;
    deathDate!: moment.Moment | undefined;
    location!: string | undefined;
    action!: string | undefined;
    age!: string | undefined;
    fatherName!: string | undefined;

    constructor(data?: IGetInquiryDeceasedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.firstName = data["firstName"];
            this.lastName = data["lastName"];
            this.ghete = data["ghete"];
            this.block = data["block"];
            this.row = data["row"];
            this.number = data["number"];
            this.description = data["description"];
            this.deathDate = data["deathDate"] ? moment(data["deathDate"].toString()) : <any>undefined;
            this.location = data["location"];
            this.action = data["action"];
            this.age = data["age"];
            this.fatherName = data["fatherName"];
        }
    }

    static fromJS(data: any): GetInquiryDeceasedDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetInquiryDeceasedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["ghete"] = this.ghete;
        data["block"] = this.block;
        data["row"] = this.row;
        data["number"] = this.number;
        data["description"] = this.description;
        data["deathDate"] = this.deathDate ? this.deathDate.toISOString() : <any>undefined;
        data["location"] = this.location;
        data["action"] = this.action;
        data["age"] = this.age;
        data["fatherName"] = this.fatherName;
        return data; 
    }
}

export interface IGetInquiryDeceasedDto {
    firstName: string | undefined;
    lastName: string | undefined;
    ghete: string | undefined;
    block: string | undefined;
    row: string | undefined;
    number: string | undefined;
    description: string | undefined;
    deathDate: moment.Moment | undefined;
    location: string | undefined;
    action: string | undefined;
    age: string | undefined;
    fatherName: string | undefined;
}

export class PagedResultDtoOfGetInquiryDeceasedDto implements IPagedResultDtoOfGetInquiryDeceasedDto {
    totalCount!: number;
    items!: GetInquiryDeceasedDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetInquiryDeceasedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetInquiryDeceasedDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetInquiryDeceasedDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetInquiryDeceasedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetInquiryDeceasedDto {
    totalCount: number;
    items: GetInquiryDeceasedDto[] | undefined;
}

export class GetFlowerCrownsForDeceasedDto implements IGetFlowerCrownsForDeceasedDto {
    benefactorName!: string | undefined;
    flowerCrownImagePath!: string | undefined;
    flowerCrownName!: string | undefined;
    price!: string | undefined;
    ceremony!: string | undefined;
    billCode!: string | undefined;
    type!: string | undefined;

    constructor(data?: IGetFlowerCrownsForDeceasedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.benefactorName = data["benefactorName"];
            this.flowerCrownImagePath = data["flowerCrownImagePath"];
            this.flowerCrownName = data["flowerCrownName"];
            this.price = data["price"];
            this.ceremony = data["ceremony"];
            this.billCode = data["billCode"];
            this.type = data["type"];
        }
    }

    static fromJS(data: any): GetFlowerCrownsForDeceasedDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFlowerCrownsForDeceasedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["benefactorName"] = this.benefactorName;
        data["flowerCrownImagePath"] = this.flowerCrownImagePath;
        data["flowerCrownName"] = this.flowerCrownName;
        data["price"] = this.price;
        data["ceremony"] = this.ceremony;
        data["billCode"] = this.billCode;
        data["type"] = this.type;
        return data; 
    }
}

export interface IGetFlowerCrownsForDeceasedDto {
    benefactorName: string | undefined;
    flowerCrownImagePath: string | undefined;
    flowerCrownName: string | undefined;
    price: string | undefined;
    ceremony: string | undefined;
    billCode: string | undefined;
    type: string | undefined;
}

export class PagedResultDtoOfGetFlowerCrownsForDeceasedDto implements IPagedResultDtoOfGetFlowerCrownsForDeceasedDto {
    totalCount!: number;
    items!: GetFlowerCrownsForDeceasedDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetFlowerCrownsForDeceasedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetFlowerCrownsForDeceasedDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetFlowerCrownsForDeceasedDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetFlowerCrownsForDeceasedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetFlowerCrownsForDeceasedDto {
    totalCount: number;
    items: GetFlowerCrownsForDeceasedDto[] | undefined;
}

export class GetDeceasedFlowerCrownsAndClipsDto implements IGetDeceasedFlowerCrownsAndClipsDto {
    deceasedFlowerCrowns!: PagedResultDtoOfGetFlowerCrownsForDeceasedDto;
    clips!: GetClipsForShop[] | undefined;

    constructor(data?: IGetDeceasedFlowerCrownsAndClipsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deceasedFlowerCrowns = data["deceasedFlowerCrowns"] ? PagedResultDtoOfGetFlowerCrownsForDeceasedDto.fromJS(data["deceasedFlowerCrowns"]) : <any>undefined;
            if (Array.isArray(data["clips"])) {
                this.clips = [] as any;
                for (let item of data["clips"])
                    this.clips!.push(GetClipsForShop.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDeceasedFlowerCrownsAndClipsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeceasedFlowerCrownsAndClipsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deceasedFlowerCrowns"] = this.deceasedFlowerCrowns ? this.deceasedFlowerCrowns.toJSON() : <any>undefined;
        if (Array.isArray(this.clips)) {
            data["clips"] = [];
            for (let item of this.clips)
                data["clips"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetDeceasedFlowerCrownsAndClipsDto {
    deceasedFlowerCrowns: PagedResultDtoOfGetFlowerCrownsForDeceasedDto;
    clips: GetClipsForShop[] | undefined;
}

export class GetFlowerCrownDetailForDeceasedDto implements IGetFlowerCrownDetailForDeceasedDto {
    ceremony!: string | undefined;
    deceased!: string | undefined;
    deceasedCode!: string | undefined;
    planConstTitle!: string | undefined;
    banner!: string[] | undefined;
    cardTempId!: number | undefined;
    cardTempImg!: string | undefined;
    cardTempWidth!: number | undefined;
    cardTempLength!: number | undefined;
    flowerCrown!: string | undefined;
    properties!: Property[] | undefined;

    constructor(data?: IGetFlowerCrownDetailForDeceasedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ceremony = data["ceremony"];
            this.deceased = data["deceased"];
            this.deceasedCode = data["deceasedCode"];
            this.planConstTitle = data["planConstTitle"];
            if (Array.isArray(data["banner"])) {
                this.banner = [] as any;
                for (let item of data["banner"])
                    this.banner!.push(item);
            }
            this.cardTempId = data["cardTempId"];
            this.cardTempImg = data["cardTempImg"];
            this.cardTempWidth = data["cardTempWidth"];
            this.cardTempLength = data["cardTempLength"];
            this.flowerCrown = data["flowerCrown"];
            if (Array.isArray(data["properties"])) {
                this.properties = [] as any;
                for (let item of data["properties"])
                    this.properties!.push(Property.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFlowerCrownDetailForDeceasedDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFlowerCrownDetailForDeceasedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ceremony"] = this.ceremony;
        data["deceased"] = this.deceased;
        data["deceasedCode"] = this.deceasedCode;
        data["planConstTitle"] = this.planConstTitle;
        if (Array.isArray(this.banner)) {
            data["banner"] = [];
            for (let item of this.banner)
                data["banner"].push(item);
        }
        data["cardTempId"] = this.cardTempId;
        data["cardTempImg"] = this.cardTempImg;
        data["cardTempWidth"] = this.cardTempWidth;
        data["cardTempLength"] = this.cardTempLength;
        data["flowerCrown"] = this.flowerCrown;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetFlowerCrownDetailForDeceasedDto {
    ceremony: string | undefined;
    deceased: string | undefined;
    deceasedCode: string | undefined;
    planConstTitle: string | undefined;
    banner: string[] | undefined;
    cardTempId: number | undefined;
    cardTempImg: string | undefined;
    cardTempWidth: number | undefined;
    cardTempLength: number | undefined;
    flowerCrown: string | undefined;
    properties: Property[] | undefined;
}

export class GetDeceasedFromBeheshteZahraOutput implements IGetDeceasedFromBeheshteZahraOutput {
    row!: string | undefined;
    name!: string | undefined;
    lastName!: string | undefined;
    fatherName!: string | undefined;
    birthday!: string | undefined;
    deadDate!: string | undefined;
    address!: string | undefined;

    constructor(data?: IGetDeceasedFromBeheshteZahraOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.row = data["row"];
            this.name = data["name"];
            this.lastName = data["lastName"];
            this.fatherName = data["fatherName"];
            this.birthday = data["birthday"];
            this.deadDate = data["deadDate"];
            this.address = data["address"];
        }
    }

    static fromJS(data: any): GetDeceasedFromBeheshteZahraOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeceasedFromBeheshteZahraOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["row"] = this.row;
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["fatherName"] = this.fatherName;
        data["birthday"] = this.birthday;
        data["deadDate"] = this.deadDate;
        data["address"] = this.address;
        return data; 
    }
}

export interface IGetDeceasedFromBeheshteZahraOutput {
    row: string | undefined;
    name: string | undefined;
    lastName: string | undefined;
    fatherName: string | undefined;
    birthday: string | undefined;
    deadDate: string | undefined;
    address: string | undefined;
}

export class PagedResultDtoOfGetDeceasedFromBeheshteZahraOutput implements IPagedResultDtoOfGetDeceasedFromBeheshteZahraOutput {
    totalCount!: number;
    items!: GetDeceasedFromBeheshteZahraOutput[] | undefined;

    constructor(data?: IPagedResultDtoOfGetDeceasedFromBeheshteZahraOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetDeceasedFromBeheshteZahraOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetDeceasedFromBeheshteZahraOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetDeceasedFromBeheshteZahraOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetDeceasedFromBeheshteZahraOutput {
    totalCount: number;
    items: GetDeceasedFromBeheshteZahraOutput[] | undefined;
}

export class MergeDeceasedAndSaveInput implements IMergeDeceasedAndSaveInput {
    firstDeceasedId!: number;
    secondDeceasedId!: number;

    constructor(data?: IMergeDeceasedAndSaveInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.firstDeceasedId = data["firstDeceasedId"];
            this.secondDeceasedId = data["secondDeceasedId"];
        }
    }

    static fromJS(data: any): MergeDeceasedAndSaveInput {
        data = typeof data === 'object' ? data : {};
        let result = new MergeDeceasedAndSaveInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstDeceasedId"] = this.firstDeceasedId;
        data["secondDeceasedId"] = this.secondDeceasedId;
        return data; 
    }
}

export interface IMergeDeceasedAndSaveInput {
    firstDeceasedId: number;
    secondDeceasedId: number;
}

export class DateToStringOutput implements IDateToStringOutput {
    dateString!: string | undefined;

    constructor(data?: IDateToStringOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dateString = data["dateString"];
        }
    }

    static fromJS(data: any): DateToStringOutput {
        data = typeof data === 'object' ? data : {};
        let result = new DateToStringOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateString"] = this.dateString;
        return data; 
    }
}

export interface IDateToStringOutput {
    dateString: string | undefined;
}

export class NameValueOfString implements INameValueOfString {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValueOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): NameValueOfString {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }
}

export interface INameValueOfString {
    name: string | undefined;
    value: string | undefined;
}

export class StringOutput implements IStringOutput {
    output!: string | undefined;

    constructor(data?: IStringOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.output = data["output"];
        }
    }

    static fromJS(data: any): StringOutput {
        data = typeof data === 'object' ? data : {};
        let result = new StringOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["output"] = this.output;
        return data; 
    }
}

export interface IStringOutput {
    output: string | undefined;
}

export class GetDirectionForViewDto implements IGetDirectionForViewDto {
    direction!: DirectionDto;
    areaName!: string | undefined;

    constructor(data?: IGetDirectionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.direction = data["direction"] ? DirectionDto.fromJS(data["direction"]) : <any>undefined;
            this.areaName = data["areaName"];
        }
    }

    static fromJS(data: any): GetDirectionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDirectionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["direction"] = this.direction ? this.direction.toJSON() : <any>undefined;
        data["areaName"] = this.areaName;
        return data; 
    }
}

export interface IGetDirectionForViewDto {
    direction: DirectionDto;
    areaName: string | undefined;
}

export class PagedResultDtoOfGetDirectionForViewDto implements IPagedResultDtoOfGetDirectionForViewDto {
    totalCount!: number;
    items!: GetDirectionForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetDirectionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetDirectionForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetDirectionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetDirectionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetDirectionForViewDto {
    totalCount: number;
    items: GetDirectionForViewDto[] | undefined;
}

export class GetDirectionForEditOutput implements IGetDirectionForEditOutput {
    direction!: CreateOrEditDirectionDto;
    areaName!: string | undefined;

    constructor(data?: IGetDirectionForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.direction = data["direction"] ? CreateOrEditDirectionDto.fromJS(data["direction"]) : <any>undefined;
            this.areaName = data["areaName"];
        }
    }

    static fromJS(data: any): GetDirectionForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDirectionForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["direction"] = this.direction ? this.direction.toJSON() : <any>undefined;
        data["areaName"] = this.areaName;
        return data; 
    }
}

export interface IGetDirectionForEditOutput {
    direction: CreateOrEditDirectionDto;
    areaName: string | undefined;
}

export class DirectionAreaLookupTableDto implements IDirectionAreaLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IDirectionAreaLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): DirectionAreaLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new DirectionAreaLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IDirectionAreaLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class GetDirectionByCityIdForViewDto implements IGetDirectionByCityIdForViewDto {
    areaName!: string | undefined;
    directionAndPoints!: GetDirectionAndPointsForViewDto[] | undefined;

    constructor(data?: IGetDirectionByCityIdForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.areaName = data["areaName"];
            if (Array.isArray(data["directionAndPoints"])) {
                this.directionAndPoints = [] as any;
                for (let item of data["directionAndPoints"])
                    this.directionAndPoints!.push(GetDirectionAndPointsForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDirectionByCityIdForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDirectionByCityIdForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaName"] = this.areaName;
        if (Array.isArray(this.directionAndPoints)) {
            data["directionAndPoints"] = [];
            for (let item of this.directionAndPoints)
                data["directionAndPoints"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetDirectionByCityIdForViewDto {
    areaName: string | undefined;
    directionAndPoints: GetDirectionAndPointsForViewDto[] | undefined;
}

export class GetDocumentForViewDto implements IGetDocumentForViewDto {
    document!: DocumentDto;

    constructor(data?: IGetDocumentForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.document = data["document"] ? DocumentDto.fromJS(data["document"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDocumentForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetDocumentForViewDto {
    document: DocumentDto;
}

export class PagedResultDtoOfGetDocumentForViewDto implements IPagedResultDtoOfGetDocumentForViewDto {
    totalCount!: number;
    items!: GetDocumentForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetDocumentForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetDocumentForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetDocumentForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetDocumentForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetDocumentForViewDto {
    totalCount: number;
    items: GetDocumentForViewDto[] | undefined;
}

export class GetDocumentForEditOutput implements IGetDocumentForEditOutput {
    document!: CreateOrEditDocumentDto;

    constructor(data?: IGetDocumentForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.document = data["document"] ? CreateOrEditDocumentDto.fromJS(data["document"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDocumentForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetDocumentForEditOutput {
    document: CreateOrEditDocumentDto;
}

export class EditionListDto implements IEditionListDto {
    name!: string | undefined;
    displayName!: string | undefined;
    dailyPrice!: number | undefined;
    weeklyPrice!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    waitingDayAfterExpire!: number | undefined;
    trialDayCount!: number | undefined;
    expiringEditionDisplayName!: string | undefined;
    id!: number;

    constructor(data?: IEditionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.dailyPrice = data["dailyPrice"];
            this.weeklyPrice = data["weeklyPrice"];
            this.monthlyPrice = data["monthlyPrice"];
            this.annualPrice = data["annualPrice"];
            this.waitingDayAfterExpire = data["waitingDayAfterExpire"];
            this.trialDayCount = data["trialDayCount"];
            this.expiringEditionDisplayName = data["expiringEditionDisplayName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EditionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["dailyPrice"] = this.dailyPrice;
        data["weeklyPrice"] = this.weeklyPrice;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["trialDayCount"] = this.trialDayCount;
        data["expiringEditionDisplayName"] = this.expiringEditionDisplayName;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEditionListDto {
    name: string | undefined;
    displayName: string | undefined;
    dailyPrice: number | undefined;
    weeklyPrice: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    waitingDayAfterExpire: number | undefined;
    trialDayCount: number | undefined;
    expiringEditionDisplayName: string | undefined;
    id: number;
}

export class ListResultDtoOfEditionListDto implements IListResultDtoOfEditionListDto {
    items!: EditionListDto[] | undefined;

    constructor(data?: IListResultDtoOfEditionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(EditionListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEditionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfEditionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfEditionListDto {
    items: EditionListDto[] | undefined;
}

export class EditionEditDto implements IEditionEditDto {
    id!: number | undefined;
    displayName!: string | undefined;
    expiringEditionId!: number | undefined;

    constructor(data?: IEditionEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.expiringEditionId = data["expiringEditionId"];
        }
    }

    static fromJS(data: any): EditionEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["expiringEditionId"] = this.expiringEditionId;
        return data; 
    }
}

export interface IEditionEditDto {
    id: number | undefined;
    displayName: string | undefined;
    expiringEditionId: number | undefined;
}

export class IValueValidator implements IIValueValidator {
    readonly name!: string | undefined;
    readonly attributes!: { [key: string]: any; } | undefined;

    constructor(data?: IIValueValidator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            (<any>this).name = data["name"];
            if (data["attributes"]) {
                (<any>this).attributes = {} as any;
                for (let key in data["attributes"]) {
                    if (data["attributes"].hasOwnProperty(key))
                        (<any>this).attributes![key] = data["attributes"][key];
                }
            }
        }
    }

    static fromJS(data: any): IValueValidator {
        data = typeof data === 'object' ? data : {};
        let result = new IValueValidator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    data["attributes"][key] = this.attributes[key];
            }
        }
        return data; 
    }
}

export interface IIValueValidator {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
}

export class LocalizableComboboxItemDto implements ILocalizableComboboxItemDto {
    value!: string | undefined;
    displayText!: string | undefined;

    constructor(data?: ILocalizableComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"];
            this.displayText = data["displayText"];
        }
    }

    static fromJS(data: any): LocalizableComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizableComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        return data; 
    }
}

export interface ILocalizableComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
}

export class LocalizableComboboxItemSourceDto implements ILocalizableComboboxItemSourceDto {
    items!: LocalizableComboboxItemDto[] | undefined;

    constructor(data?: ILocalizableComboboxItemSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(LocalizableComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocalizableComboboxItemSourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizableComboboxItemSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ILocalizableComboboxItemSourceDto {
    items: LocalizableComboboxItemDto[] | undefined;
}

export class FeatureInputTypeDto implements IFeatureInputTypeDto {
    name!: string | undefined;
    attributes!: { [key: string]: any; } | undefined;
    validator!: IValueValidator;
    itemSource!: LocalizableComboboxItemSourceDto;

    constructor(data?: IFeatureInputTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            if (data["attributes"]) {
                this.attributes = {} as any;
                for (let key in data["attributes"]) {
                    if (data["attributes"].hasOwnProperty(key))
                        this.attributes![key] = data["attributes"][key];
                }
            }
            this.validator = data["validator"] ? IValueValidator.fromJS(data["validator"]) : <any>undefined;
            this.itemSource = data["itemSource"] ? LocalizableComboboxItemSourceDto.fromJS(data["itemSource"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FeatureInputTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureInputTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    data["attributes"][key] = this.attributes[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        data["itemSource"] = this.itemSource ? this.itemSource.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IFeatureInputTypeDto {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
    validator: IValueValidator;
    itemSource: LocalizableComboboxItemSourceDto;
}

export class FlatFeatureDto implements IFlatFeatureDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    defaultValue!: string | undefined;
    inputType!: FeatureInputTypeDto;

    constructor(data?: IFlatFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.defaultValue = data["defaultValue"];
            this.inputType = data["inputType"] ? FeatureInputTypeDto.fromJS(data["inputType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FlatFeatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatFeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IFlatFeatureDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    inputType: FeatureInputTypeDto;
}

export class GetEditionEditOutput implements IGetEditionEditOutput {
    edition!: EditionEditDto;
    featureValues!: NameValueDto[] | undefined;
    features!: FlatFeatureDto[] | undefined;

    constructor(data?: IGetEditionEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.edition = data["edition"] ? EditionEditDto.fromJS(data["edition"]) : <any>undefined;
            if (Array.isArray(data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
            if (Array.isArray(data["features"])) {
                this.features = [] as any;
                for (let item of data["features"])
                    this.features!.push(FlatFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEditionEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEditionEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetEditionEditOutput {
    edition: EditionEditDto;
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;
}

export class EditionCreateDto implements IEditionCreateDto {
    id!: number | undefined;
    displayName!: string | undefined;
    dailyPrice!: number | undefined;
    weeklyPrice!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    trialDayCount!: number | undefined;
    waitingDayAfterExpire!: number | undefined;
    expiringEditionId!: number | undefined;

    constructor(data?: IEditionCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.dailyPrice = data["dailyPrice"];
            this.weeklyPrice = data["weeklyPrice"];
            this.monthlyPrice = data["monthlyPrice"];
            this.annualPrice = data["annualPrice"];
            this.trialDayCount = data["trialDayCount"];
            this.waitingDayAfterExpire = data["waitingDayAfterExpire"];
            this.expiringEditionId = data["expiringEditionId"];
        }
    }

    static fromJS(data: any): EditionCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["dailyPrice"] = this.dailyPrice;
        data["weeklyPrice"] = this.weeklyPrice;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["expiringEditionId"] = this.expiringEditionId;
        return data; 
    }
}

export interface IEditionCreateDto {
    id: number | undefined;
    displayName: string | undefined;
    dailyPrice: number | undefined;
    weeklyPrice: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    trialDayCount: number | undefined;
    waitingDayAfterExpire: number | undefined;
    expiringEditionId: number | undefined;
}

export class CreateEditionDto implements ICreateEditionDto {
    edition!: EditionCreateDto;
    featureValues!: NameValueDto[] | undefined;

    constructor(data?: ICreateEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.edition = new EditionCreateDto();
        }
    }

    init(data?: any) {
        if (data) {
            this.edition = data["edition"] ? EditionCreateDto.fromJS(data["edition"]) : new EditionCreateDto();
            if (Array.isArray(data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateEditionDto {
    edition: EditionCreateDto;
    featureValues: NameValueDto[] | undefined;
}

export class UpdateEditionDto implements IUpdateEditionDto {
    edition!: EditionEditDto;
    featureValues!: NameValueDto[] | undefined;

    constructor(data?: IUpdateEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.edition = new EditionEditDto();
        }
    }

    init(data?: any) {
        if (data) {
            this.edition = data["edition"] ? EditionEditDto.fromJS(data["edition"]) : new EditionEditDto();
            if (Array.isArray(data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateEditionDto {
    edition: EditionEditDto;
    featureValues: NameValueDto[] | undefined;
}

export class MoveTenantsToAnotherEditionDto implements IMoveTenantsToAnotherEditionDto {
    sourceEditionId!: number;
    targetEditionId!: number;

    constructor(data?: IMoveTenantsToAnotherEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sourceEditionId = data["sourceEditionId"];
            this.targetEditionId = data["targetEditionId"];
        }
    }

    static fromJS(data: any): MoveTenantsToAnotherEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MoveTenantsToAnotherEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceEditionId"] = this.sourceEditionId;
        data["targetEditionId"] = this.targetEditionId;
        return data; 
    }
}

export interface IMoveTenantsToAnotherEditionDto {
    sourceEditionId: number;
    targetEditionId: number;
}

export class EducationDegreeDto implements IEducationDegreeDto {
    title!: string | undefined;
    socialSecurityCode!: string | undefined;
    taxCode!: string | undefined;
    state!: boolean;
    id!: number;

    constructor(data?: IEducationDegreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.socialSecurityCode = data["socialSecurityCode"];
            this.taxCode = data["taxCode"];
            this.state = data["state"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EducationDegreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EducationDegreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["socialSecurityCode"] = this.socialSecurityCode;
        data["taxCode"] = this.taxCode;
        data["state"] = this.state;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEducationDegreeDto {
    title: string | undefined;
    socialSecurityCode: string | undefined;
    taxCode: string | undefined;
    state: boolean;
    id: number;
}

export class GetEducationDegreeForViewDto implements IGetEducationDegreeForViewDto {
    educationDegree!: EducationDegreeDto;

    constructor(data?: IGetEducationDegreeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.educationDegree = data["educationDegree"] ? EducationDegreeDto.fromJS(data["educationDegree"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEducationDegreeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEducationDegreeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["educationDegree"] = this.educationDegree ? this.educationDegree.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetEducationDegreeForViewDto {
    educationDegree: EducationDegreeDto;
}

export class PagedResultDtoOfGetEducationDegreeForViewDto implements IPagedResultDtoOfGetEducationDegreeForViewDto {
    totalCount!: number;
    items!: GetEducationDegreeForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetEducationDegreeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetEducationDegreeForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetEducationDegreeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetEducationDegreeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetEducationDegreeForViewDto {
    totalCount: number;
    items: GetEducationDegreeForViewDto[] | undefined;
}

export class CreateOrEditEducationDegreeDto implements ICreateOrEditEducationDegreeDto {
    title!: string | undefined;
    socialSecurityCode!: string | undefined;
    taxCode!: string | undefined;
    state!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditEducationDegreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.socialSecurityCode = data["socialSecurityCode"];
            this.taxCode = data["taxCode"];
            this.state = data["state"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditEducationDegreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditEducationDegreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["socialSecurityCode"] = this.socialSecurityCode;
        data["taxCode"] = this.taxCode;
        data["state"] = this.state;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditEducationDegreeDto {
    title: string | undefined;
    socialSecurityCode: string | undefined;
    taxCode: string | undefined;
    state: boolean;
    id: number | undefined;
}

export class GetEducationDegreeForEditOutput implements IGetEducationDegreeForEditOutput {
    educationDegree!: CreateOrEditEducationDegreeDto;

    constructor(data?: IGetEducationDegreeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.educationDegree = data["educationDegree"] ? CreateOrEditEducationDegreeDto.fromJS(data["educationDegree"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEducationDegreeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEducationDegreeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["educationDegree"] = this.educationDegree ? this.educationDegree.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetEducationDegreeForEditOutput {
    educationDegree: CreateOrEditEducationDegreeDto;
}

export class EducationFieldDto implements IEducationFieldDto {
    name!: string | undefined;
    socialSecurityCode!: string | undefined;
    taxCode!: string | undefined;
    state!: boolean;
    id!: number;

    constructor(data?: IEducationFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.socialSecurityCode = data["socialSecurityCode"];
            this.taxCode = data["taxCode"];
            this.state = data["state"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EducationFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new EducationFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["socialSecurityCode"] = this.socialSecurityCode;
        data["taxCode"] = this.taxCode;
        data["state"] = this.state;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEducationFieldDto {
    name: string | undefined;
    socialSecurityCode: string | undefined;
    taxCode: string | undefined;
    state: boolean;
    id: number;
}

export class GetEducationFieldForViewDto implements IGetEducationFieldForViewDto {
    educationField!: EducationFieldDto;

    constructor(data?: IGetEducationFieldForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.educationField = data["educationField"] ? EducationFieldDto.fromJS(data["educationField"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEducationFieldForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEducationFieldForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["educationField"] = this.educationField ? this.educationField.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetEducationFieldForViewDto {
    educationField: EducationFieldDto;
}

export class PagedResultDtoOfGetEducationFieldForViewDto implements IPagedResultDtoOfGetEducationFieldForViewDto {
    totalCount!: number;
    items!: GetEducationFieldForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetEducationFieldForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetEducationFieldForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetEducationFieldForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetEducationFieldForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetEducationFieldForViewDto {
    totalCount: number;
    items: GetEducationFieldForViewDto[] | undefined;
}

export class CreateOrEditEducationFieldDto implements ICreateOrEditEducationFieldDto {
    name!: string | undefined;
    socialSecurityCode!: string | undefined;
    taxCode!: string | undefined;
    state!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditEducationFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.socialSecurityCode = data["socialSecurityCode"];
            this.taxCode = data["taxCode"];
            this.state = data["state"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditEducationFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditEducationFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["socialSecurityCode"] = this.socialSecurityCode;
        data["taxCode"] = this.taxCode;
        data["state"] = this.state;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditEducationFieldDto {
    name: string | undefined;
    socialSecurityCode: string | undefined;
    taxCode: string | undefined;
    state: boolean;
    id: number | undefined;
}

export class GetEducationFieldForEditOutput implements IGetEducationFieldForEditOutput {
    educationField!: CreateOrEditEducationFieldDto;

    constructor(data?: IGetEducationFieldForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.educationField = data["educationField"] ? CreateOrEditEducationFieldDto.fromJS(data["educationField"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEducationFieldForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEducationFieldForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["educationField"] = this.educationField ? this.educationField.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetEducationFieldForEditOutput {
    educationField: CreateOrEditEducationFieldDto;
}

export class PagedResultDtoOfGetEmployeeForViewDto implements IPagedResultDtoOfGetEmployeeForViewDto {
    totalCount!: number;
    items!: GetEmployeeForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetEmployeeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetEmployeeForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetEmployeeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetEmployeeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetEmployeeForViewDto {
    totalCount: number;
    items: GetEmployeeForViewDto[] | undefined;
}

export class CreateOrEditEmployeeDto implements ICreateOrEditEmployeeDto {
    shenasnameNumber!: string | undefined;
    personnelNumber!: string | undefined;
    maritalStatus!: boolean;
    numberOfChildren!: number;
    trafficNumber!: string | undefined;
    receiptAgent!: boolean;
    contactId!: number;
    birthPlace!: number;
    shenasnameIssueCity!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.shenasnameNumber = data["shenasnameNumber"];
            this.personnelNumber = data["personnelNumber"];
            this.maritalStatus = data["maritalStatus"];
            this.numberOfChildren = data["numberOfChildren"];
            this.trafficNumber = data["trafficNumber"];
            this.receiptAgent = data["receiptAgent"];
            this.contactId = data["contactId"];
            this.birthPlace = data["birthPlace"];
            this.shenasnameIssueCity = data["shenasnameIssueCity"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditEmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditEmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shenasnameNumber"] = this.shenasnameNumber;
        data["personnelNumber"] = this.personnelNumber;
        data["maritalStatus"] = this.maritalStatus;
        data["numberOfChildren"] = this.numberOfChildren;
        data["trafficNumber"] = this.trafficNumber;
        data["receiptAgent"] = this.receiptAgent;
        data["contactId"] = this.contactId;
        data["birthPlace"] = this.birthPlace;
        data["shenasnameIssueCity"] = this.shenasnameIssueCity;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditEmployeeDto {
    shenasnameNumber: string | undefined;
    personnelNumber: string | undefined;
    maritalStatus: boolean;
    numberOfChildren: number;
    trafficNumber: string | undefined;
    receiptAgent: boolean;
    contactId: number;
    birthPlace: number;
    shenasnameIssueCity: number;
    id: number | undefined;
}

export class GetEmployeeForEditOutput implements IGetEmployeeForEditOutput {
    employee!: CreateOrEditEmployeeDto;
    cityName!: string | undefined;
    cityName2!: string | undefined;

    constructor(data?: IGetEmployeeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.employee = data["employee"] ? CreateOrEditEmployeeDto.fromJS(data["employee"]) : <any>undefined;
            this.cityName = data["cityName"];
            this.cityName2 = data["cityName2"];
        }
    }

    static fromJS(data: any): GetEmployeeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["cityName"] = this.cityName;
        data["cityName2"] = this.cityName2;
        return data; 
    }
}

export interface IGetEmployeeForEditOutput {
    employee: CreateOrEditEmployeeDto;
    cityName: string | undefined;
    cityName2: string | undefined;
}

export class EmployeeCityLookupTableDto implements IEmployeeCityLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IEmployeeCityLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): EmployeeCityLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeCityLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IEmployeeCityLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfEmployeeCityLookupTableDto implements IPagedResultDtoOfEmployeeCityLookupTableDto {
    totalCount!: number;
    items!: EmployeeCityLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfEmployeeCityLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(EmployeeCityLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEmployeeCityLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfEmployeeCityLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfEmployeeCityLookupTableDto {
    totalCount: number;
    items: EmployeeCityLookupTableDto[] | undefined;
}

export class EmployeeStateLookupTableDto implements IEmployeeStateLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IEmployeeStateLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): EmployeeStateLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeStateLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IEmployeeStateLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfEmployeeStateLookupTableDto implements IPagedResultDtoOfEmployeeStateLookupTableDto {
    totalCount!: number;
    items!: EmployeeStateLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfEmployeeStateLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(EmployeeStateLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEmployeeStateLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfEmployeeStateLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfEmployeeStateLookupTableDto {
    totalCount: number;
    items: EmployeeStateLookupTableDto[] | undefined;
}

export class EventTypeDto implements IEventTypeDto {
    title!: string | undefined;
    isEndDateRequired!: boolean;
    id!: number;

    constructor(data?: IEventTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.isEndDateRequired = data["isEndDateRequired"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["isEndDateRequired"] = this.isEndDateRequired;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventTypeDto {
    title: string | undefined;
    isEndDateRequired: boolean;
    id: number;
}

export class GetEventTypeForViewDto implements IGetEventTypeForViewDto {
    eventType!: EventTypeDto;

    constructor(data?: IGetEventTypeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eventType = data["eventType"] ? EventTypeDto.fromJS(data["eventType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEventTypeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEventTypeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventType"] = this.eventType ? this.eventType.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetEventTypeForViewDto {
    eventType: EventTypeDto;
}

export class PagedResultDtoOfGetEventTypeForViewDto implements IPagedResultDtoOfGetEventTypeForViewDto {
    totalCount!: number;
    items!: GetEventTypeForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetEventTypeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetEventTypeForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetEventTypeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetEventTypeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetEventTypeForViewDto {
    totalCount: number;
    items: GetEventTypeForViewDto[] | undefined;
}

export class CreateOrEditEventTypeDto implements ICreateOrEditEventTypeDto {
    title!: string | undefined;
    isEndDateRequired!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditEventTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.isEndDateRequired = data["isEndDateRequired"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditEventTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditEventTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["isEndDateRequired"] = this.isEndDateRequired;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditEventTypeDto {
    title: string | undefined;
    isEndDateRequired: boolean;
    id: number | undefined;
}

export class GetEventTypeForEditOutput implements IGetEventTypeForEditOutput {
    eventType!: CreateOrEditEventTypeDto;

    constructor(data?: IGetEventTypeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eventType = data["eventType"] ? CreateOrEditEventTypeDto.fromJS(data["eventType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEventTypeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEventTypeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventType"] = this.eventType ? this.eventType.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetEventTypeForEditOutput {
    eventType: CreateOrEditEventTypeDto;
}

export class FamiliarityDto implements IFamiliarityDto {
    title!: string | undefined;
    state!: boolean;
    created!: moment.Moment;
    modified!: moment.Moment | undefined;
    createdBy!: number;
    modifiedBy!: number | undefined;
    id!: number;

    constructor(data?: IFamiliarityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.state = data["state"];
            this.created = data["created"] ? moment(data["created"].toString()) : <any>undefined;
            this.modified = data["modified"] ? moment(data["modified"].toString()) : <any>undefined;
            this.createdBy = data["createdBy"];
            this.modifiedBy = data["modifiedBy"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): FamiliarityDto {
        data = typeof data === 'object' ? data : {};
        let result = new FamiliarityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["state"] = this.state;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        return data; 
    }
}

export interface IFamiliarityDto {
    title: string | undefined;
    state: boolean;
    created: moment.Moment;
    modified: moment.Moment | undefined;
    createdBy: number;
    modifiedBy: number | undefined;
    id: number;
}

export class GetFamiliarityForViewDto implements IGetFamiliarityForViewDto {
    familiarity!: FamiliarityDto;

    constructor(data?: IGetFamiliarityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.familiarity = data["familiarity"] ? FamiliarityDto.fromJS(data["familiarity"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetFamiliarityForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFamiliarityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["familiarity"] = this.familiarity ? this.familiarity.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetFamiliarityForViewDto {
    familiarity: FamiliarityDto;
}

export class PagedResultDtoOfGetFamiliarityForViewDto implements IPagedResultDtoOfGetFamiliarityForViewDto {
    totalCount!: number;
    items!: GetFamiliarityForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetFamiliarityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetFamiliarityForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetFamiliarityForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetFamiliarityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetFamiliarityForViewDto {
    totalCount: number;
    items: GetFamiliarityForViewDto[] | undefined;
}

export class CreateOrEditFamiliarityDto implements ICreateOrEditFamiliarityDto {
    title!: string | undefined;
    state!: boolean;
    created!: moment.Moment;
    modified!: moment.Moment | undefined;
    createdBy!: number;
    modifiedBy!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditFamiliarityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.state = data["state"];
            this.created = data["created"] ? moment(data["created"].toString()) : <any>undefined;
            this.modified = data["modified"] ? moment(data["modified"].toString()) : <any>undefined;
            this.createdBy = data["createdBy"];
            this.modifiedBy = data["modifiedBy"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditFamiliarityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditFamiliarityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["state"] = this.state;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditFamiliarityDto {
    title: string | undefined;
    state: boolean;
    created: moment.Moment;
    modified: moment.Moment | undefined;
    createdBy: number;
    modifiedBy: number | undefined;
    id: number | undefined;
}

export class GetFamiliarityForEditOutput implements IGetFamiliarityForEditOutput {
    familiarity!: CreateOrEditFamiliarityDto;

    constructor(data?: IGetFamiliarityForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.familiarity = data["familiarity"] ? CreateOrEditFamiliarityDto.fromJS(data["familiarity"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetFamiliarityForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetFamiliarityForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["familiarity"] = this.familiarity ? this.familiarity.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetFamiliarityForEditOutput {
    familiarity: CreateOrEditFamiliarityDto;
}

export enum FamilyStatus {
    Unknown = 0,
    Active = 1,
    SemiActive = 2,
    Inactive = 3,
    Deleted = 4,
}

export enum ResidenceType {
    Ownership = 1,
    Rent = 2,
    FathersHouse = 3,
    BrothersHouse = 4,
    GrandfathersHouse = 5,
    FreeOnEmploymentCondition = 6,
    FathersGrandfathersHouse = 7,
    MothersGrandfathersHouse = 8,
    Rehabilitation = 9,
    LeaseOnConditionOfOwnership = 10,
    HomeOfTheLateWifesGrandfather = 11,
    AuntMsHouse = 12,
    UncleMsHouse = 13,
    StepfathersHouse = 14,
    EndowmentHouse = 15,
    BenefactorsHouse = 16,
    AssociationHouse = 17,
    Nomads = 18,
    Other = 19,
    AuntFsHouse = 20,
    UncleFsHouse = 21,
    Unknown = 22,
    Relative = 23,
    GrandmothersHouse = 24,
    SistersHouse = 25,
    MothersAntsHouse = 26,
}

export class FamilyDto implements IFamilyDto {
    name!: string | undefined;
    previousFamilyName!: string | undefined;
    degree!: number | undefined;
    fileNumber!: string | undefined;
    areaNumber!: string | undefined;
    agentDescription!: string | undefined;
    connectorDescription!: string | undefined;
    requirementCoefficient!: number | undefined;
    status!: FamilyStatus;
    isSendSmsOn!: boolean;
    groupSubgroups!: string | undefined;
    registerDate!: moment.Moment;
    inactiveDate!: moment.Moment | undefined;
    isOrphans!: boolean;
    residenceType!: ResidenceType;
    otherResidenceType!: string | undefined;
    code!: string | undefined;
    description!: string | undefined;
    isSadat!: boolean;
    incomeAmount!: number | undefined;
    outcomeAmount!: number | undefined;
    activeClientsCount!: number | undefined;
    familyTypeRef!: number | undefined;
    branchRef!: number;
    bankAccountRef!: number | undefined;
    agentRef!: number | undefined;
    connectorRef!: number | undefined;
    id!: number;

    constructor(data?: IFamilyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.previousFamilyName = data["previousFamilyName"];
            this.degree = data["degree"];
            this.fileNumber = data["fileNumber"];
            this.areaNumber = data["areaNumber"];
            this.agentDescription = data["agentDescription"];
            this.connectorDescription = data["connectorDescription"];
            this.requirementCoefficient = data["requirementCoefficient"];
            this.status = data["status"];
            this.isSendSmsOn = data["isSendSmsOn"];
            this.groupSubgroups = data["groupSubgroups"];
            this.registerDate = data["registerDate"] ? moment(data["registerDate"].toString()) : <any>undefined;
            this.inactiveDate = data["inactiveDate"] ? moment(data["inactiveDate"].toString()) : <any>undefined;
            this.isOrphans = data["isOrphans"];
            this.residenceType = data["residenceType"];
            this.otherResidenceType = data["otherResidenceType"];
            this.code = data["code"];
            this.description = data["description"];
            this.isSadat = data["isSadat"];
            this.incomeAmount = data["incomeAmount"];
            this.outcomeAmount = data["outcomeAmount"];
            this.activeClientsCount = data["activeClientsCount"];
            this.familyTypeRef = data["familyTypeRef"];
            this.branchRef = data["branchRef"];
            this.bankAccountRef = data["bankAccountRef"];
            this.agentRef = data["agentRef"];
            this.connectorRef = data["connectorRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): FamilyDto {
        data = typeof data === 'object' ? data : {};
        let result = new FamilyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["previousFamilyName"] = this.previousFamilyName;
        data["degree"] = this.degree;
        data["fileNumber"] = this.fileNumber;
        data["areaNumber"] = this.areaNumber;
        data["agentDescription"] = this.agentDescription;
        data["connectorDescription"] = this.connectorDescription;
        data["requirementCoefficient"] = this.requirementCoefficient;
        data["status"] = this.status;
        data["isSendSmsOn"] = this.isSendSmsOn;
        data["groupSubgroups"] = this.groupSubgroups;
        data["registerDate"] = this.registerDate ? this.registerDate.toISOString() : <any>undefined;
        data["inactiveDate"] = this.inactiveDate ? this.inactiveDate.toISOString() : <any>undefined;
        data["isOrphans"] = this.isOrphans;
        data["residenceType"] = this.residenceType;
        data["otherResidenceType"] = this.otherResidenceType;
        data["code"] = this.code;
        data["description"] = this.description;
        data["isSadat"] = this.isSadat;
        data["incomeAmount"] = this.incomeAmount;
        data["outcomeAmount"] = this.outcomeAmount;
        data["activeClientsCount"] = this.activeClientsCount;
        data["familyTypeRef"] = this.familyTypeRef;
        data["branchRef"] = this.branchRef;
        data["bankAccountRef"] = this.bankAccountRef;
        data["agentRef"] = this.agentRef;
        data["connectorRef"] = this.connectorRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface IFamilyDto {
    name: string | undefined;
    previousFamilyName: string | undefined;
    degree: number | undefined;
    fileNumber: string | undefined;
    areaNumber: string | undefined;
    agentDescription: string | undefined;
    connectorDescription: string | undefined;
    requirementCoefficient: number | undefined;
    status: FamilyStatus;
    isSendSmsOn: boolean;
    groupSubgroups: string | undefined;
    registerDate: moment.Moment;
    inactiveDate: moment.Moment | undefined;
    isOrphans: boolean;
    residenceType: ResidenceType;
    otherResidenceType: string | undefined;
    code: string | undefined;
    description: string | undefined;
    isSadat: boolean;
    incomeAmount: number | undefined;
    outcomeAmount: number | undefined;
    activeClientsCount: number | undefined;
    familyTypeRef: number | undefined;
    branchRef: number;
    bankAccountRef: number | undefined;
    agentRef: number | undefined;
    connectorRef: number | undefined;
    id: number;
}

export class GetFamilyForViewDto implements IGetFamilyForViewDto {
    family!: FamilyDto;
    familyTypeTitle!: string | undefined;
    branchName!: string | undefined;
    bankAccountShabaNumber!: string | undefined;
    groupSubgroupsName!: string | undefined;
    agentName!: string | undefined;
    connectorName!: string | undefined;
    membersCount!: number | undefined;
    activeMembersCount!: number | undefined;
    primaryMemberName!: string | undefined;
    totalAmount!: number | undefined;
    totalIncome!: number | undefined;
    totalOutcome!: number | undefined;
    effectiveAmount!: number | undefined;

    constructor(data?: IGetFamilyForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.family = data["family"] ? FamilyDto.fromJS(data["family"]) : <any>undefined;
            this.familyTypeTitle = data["familyTypeTitle"];
            this.branchName = data["branchName"];
            this.bankAccountShabaNumber = data["bankAccountShabaNumber"];
            this.groupSubgroupsName = data["groupSubgroupsName"];
            this.agentName = data["agentName"];
            this.connectorName = data["connectorName"];
            this.membersCount = data["membersCount"];
            this.activeMembersCount = data["activeMembersCount"];
            this.primaryMemberName = data["primaryMemberName"];
            this.totalAmount = data["totalAmount"];
            this.totalIncome = data["totalIncome"];
            this.totalOutcome = data["totalOutcome"];
            this.effectiveAmount = data["effectiveAmount"];
        }
    }

    static fromJS(data: any): GetFamilyForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFamilyForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["family"] = this.family ? this.family.toJSON() : <any>undefined;
        data["familyTypeTitle"] = this.familyTypeTitle;
        data["branchName"] = this.branchName;
        data["bankAccountShabaNumber"] = this.bankAccountShabaNumber;
        data["groupSubgroupsName"] = this.groupSubgroupsName;
        data["agentName"] = this.agentName;
        data["connectorName"] = this.connectorName;
        data["membersCount"] = this.membersCount;
        data["activeMembersCount"] = this.activeMembersCount;
        data["primaryMemberName"] = this.primaryMemberName;
        data["totalAmount"] = this.totalAmount;
        data["totalIncome"] = this.totalIncome;
        data["totalOutcome"] = this.totalOutcome;
        data["effectiveAmount"] = this.effectiveAmount;
        return data; 
    }
}

export interface IGetFamilyForViewDto {
    family: FamilyDto;
    familyTypeTitle: string | undefined;
    branchName: string | undefined;
    bankAccountShabaNumber: string | undefined;
    groupSubgroupsName: string | undefined;
    agentName: string | undefined;
    connectorName: string | undefined;
    membersCount: number | undefined;
    activeMembersCount: number | undefined;
    primaryMemberName: string | undefined;
    totalAmount: number | undefined;
    totalIncome: number | undefined;
    totalOutcome: number | undefined;
    effectiveAmount: number | undefined;
}

export class PagedResultDtoOfGetFamilyForViewDto implements IPagedResultDtoOfGetFamilyForViewDto {
    totalCount!: number;
    items!: GetFamilyForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetFamilyForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetFamilyForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetFamilyForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetFamilyForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetFamilyForViewDto {
    totalCount: number;
    items: GetFamilyForViewDto[] | undefined;
}

export class CreateOrEditFamilyDto implements ICreateOrEditFamilyDto {
    name!: string | undefined;
    previousFamilyName!: string | undefined;
    degree!: number | undefined;
    fileNumber!: string | undefined;
    areaNumber!: string | undefined;
    agentDescription!: string | undefined;
    connectorDescription!: string | undefined;
    requirementCoefficient!: number | undefined;
    status!: FamilyStatus;
    isSendSmsOn!: boolean;
    groupSubgroups!: string | undefined;
    registerDate!: moment.Moment | undefined;
    inactiveDate!: moment.Moment | undefined;
    isOrphans!: boolean;
    residenceType!: ResidenceType;
    otherResidenceType!: string | undefined;
    code!: string | undefined;
    description!: string | undefined;
    isSadat!: boolean;
    incomeAmount!: number | undefined;
    outcomeAmount!: number | undefined;
    activeClientsCount!: number | undefined;
    familyTypeRef!: number | undefined;
    branchRef!: number;
    bankAccountRef!: number | undefined;
    agentRef!: number | undefined;
    connectorRef!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditFamilyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.previousFamilyName = data["previousFamilyName"];
            this.degree = data["degree"];
            this.fileNumber = data["fileNumber"];
            this.areaNumber = data["areaNumber"];
            this.agentDescription = data["agentDescription"];
            this.connectorDescription = data["connectorDescription"];
            this.requirementCoefficient = data["requirementCoefficient"];
            this.status = data["status"];
            this.isSendSmsOn = data["isSendSmsOn"];
            this.groupSubgroups = data["groupSubgroups"];
            this.registerDate = data["registerDate"] ? moment(data["registerDate"].toString()) : <any>undefined;
            this.inactiveDate = data["inactiveDate"] ? moment(data["inactiveDate"].toString()) : <any>undefined;
            this.isOrphans = data["isOrphans"];
            this.residenceType = data["residenceType"];
            this.otherResidenceType = data["otherResidenceType"];
            this.code = data["code"];
            this.description = data["description"];
            this.isSadat = data["isSadat"];
            this.incomeAmount = data["incomeAmount"];
            this.outcomeAmount = data["outcomeAmount"];
            this.activeClientsCount = data["activeClientsCount"];
            this.familyTypeRef = data["familyTypeRef"];
            this.branchRef = data["branchRef"];
            this.bankAccountRef = data["bankAccountRef"];
            this.agentRef = data["agentRef"];
            this.connectorRef = data["connectorRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditFamilyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditFamilyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["previousFamilyName"] = this.previousFamilyName;
        data["degree"] = this.degree;
        data["fileNumber"] = this.fileNumber;
        data["areaNumber"] = this.areaNumber;
        data["agentDescription"] = this.agentDescription;
        data["connectorDescription"] = this.connectorDescription;
        data["requirementCoefficient"] = this.requirementCoefficient;
        data["status"] = this.status;
        data["isSendSmsOn"] = this.isSendSmsOn;
        data["groupSubgroups"] = this.groupSubgroups;
        data["registerDate"] = this.registerDate ? this.registerDate.toISOString() : <any>undefined;
        data["inactiveDate"] = this.inactiveDate ? this.inactiveDate.toISOString() : <any>undefined;
        data["isOrphans"] = this.isOrphans;
        data["residenceType"] = this.residenceType;
        data["otherResidenceType"] = this.otherResidenceType;
        data["code"] = this.code;
        data["description"] = this.description;
        data["isSadat"] = this.isSadat;
        data["incomeAmount"] = this.incomeAmount;
        data["outcomeAmount"] = this.outcomeAmount;
        data["activeClientsCount"] = this.activeClientsCount;
        data["familyTypeRef"] = this.familyTypeRef;
        data["branchRef"] = this.branchRef;
        data["bankAccountRef"] = this.bankAccountRef;
        data["agentRef"] = this.agentRef;
        data["connectorRef"] = this.connectorRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditFamilyDto {
    name: string | undefined;
    previousFamilyName: string | undefined;
    degree: number | undefined;
    fileNumber: string | undefined;
    areaNumber: string | undefined;
    agentDescription: string | undefined;
    connectorDescription: string | undefined;
    requirementCoefficient: number | undefined;
    status: FamilyStatus;
    isSendSmsOn: boolean;
    groupSubgroups: string | undefined;
    registerDate: moment.Moment | undefined;
    inactiveDate: moment.Moment | undefined;
    isOrphans: boolean;
    residenceType: ResidenceType;
    otherResidenceType: string | undefined;
    code: string | undefined;
    description: string | undefined;
    isSadat: boolean;
    incomeAmount: number | undefined;
    outcomeAmount: number | undefined;
    activeClientsCount: number | undefined;
    familyTypeRef: number | undefined;
    branchRef: number;
    bankAccountRef: number | undefined;
    agentRef: number | undefined;
    connectorRef: number | undefined;
    id: number | undefined;
}

export class GetFamilyForEditOutput implements IGetFamilyForEditOutput {
    family!: CreateOrEditFamilyDto;
    familyTypeTitle!: string | undefined;
    branchName!: string | undefined;
    bankAccountShabaNumber!: string | undefined;
    groupSubgroupsName!: string | undefined;
    agentName!: string | undefined;
    connectorName!: string | undefined;

    constructor(data?: IGetFamilyForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.family = data["family"] ? CreateOrEditFamilyDto.fromJS(data["family"]) : <any>undefined;
            this.familyTypeTitle = data["familyTypeTitle"];
            this.branchName = data["branchName"];
            this.bankAccountShabaNumber = data["bankAccountShabaNumber"];
            this.groupSubgroupsName = data["groupSubgroupsName"];
            this.agentName = data["agentName"];
            this.connectorName = data["connectorName"];
        }
    }

    static fromJS(data: any): GetFamilyForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetFamilyForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["family"] = this.family ? this.family.toJSON() : <any>undefined;
        data["familyTypeTitle"] = this.familyTypeTitle;
        data["branchName"] = this.branchName;
        data["bankAccountShabaNumber"] = this.bankAccountShabaNumber;
        data["groupSubgroupsName"] = this.groupSubgroupsName;
        data["agentName"] = this.agentName;
        data["connectorName"] = this.connectorName;
        return data; 
    }
}

export interface IGetFamilyForEditOutput {
    family: CreateOrEditFamilyDto;
    familyTypeTitle: string | undefined;
    branchName: string | undefined;
    bankAccountShabaNumber: string | undefined;
    groupSubgroupsName: string | undefined;
    agentName: string | undefined;
    connectorName: string | undefined;
}

export class PagedResultDtoOfGetFamilyMemberForViewDto implements IPagedResultDtoOfGetFamilyMemberForViewDto {
    totalCount!: number;
    items!: GetFamilyMemberForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetFamilyMemberForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetFamilyMemberForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetFamilyMemberForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetFamilyMemberForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetFamilyMemberForViewDto {
    totalCount: number;
    items: GetFamilyMemberForViewDto[] | undefined;
}

export class TagDto implements ITagDto {
    title!: string | undefined;
    entity!: Entities;
    entityRef!: number;
    id!: number;

    constructor(data?: ITagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.entity = data["entity"];
            this.entityRef = data["entityRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TagDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["entity"] = this.entity;
        data["entityRef"] = this.entityRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITagDto {
    title: string | undefined;
    entity: Entities;
    entityRef: number;
    id: number;
}

export class GetTagForViewDto implements IGetTagForViewDto {
    tag!: TagDto;

    constructor(data?: IGetTagForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tag = data["tag"] ? TagDto.fromJS(data["tag"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTagForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTagForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag ? this.tag.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetTagForViewDto {
    tag: TagDto;
}

export class PagedResultDtoOfGetTagForViewDto implements IPagedResultDtoOfGetTagForViewDto {
    totalCount!: number;
    items!: GetTagForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTagForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetTagForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTagForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTagForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetTagForViewDto {
    totalCount: number;
    items: GetTagForViewDto[] | undefined;
}

export class FamilySupportOrganizationDto implements IFamilySupportOrganizationDto {
    state!: boolean;
    fileCode!: string | undefined;
    familyRef!: number;
    supportiveOrganizationRef!: number;
    id!: number;

    constructor(data?: IFamilySupportOrganizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.state = data["state"];
            this.fileCode = data["fileCode"];
            this.familyRef = data["familyRef"];
            this.supportiveOrganizationRef = data["supportiveOrganizationRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): FamilySupportOrganizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new FamilySupportOrganizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["fileCode"] = this.fileCode;
        data["familyRef"] = this.familyRef;
        data["supportiveOrganizationRef"] = this.supportiveOrganizationRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface IFamilySupportOrganizationDto {
    state: boolean;
    fileCode: string | undefined;
    familyRef: number;
    supportiveOrganizationRef: number;
    id: number;
}

export class GetFamilySupportOrganizationForViewDto implements IGetFamilySupportOrganizationForViewDto {
    familySupportOrganization!: FamilySupportOrganizationDto;
    familyName!: string | undefined;
    supportiveOrganizationName!: string | undefined;

    constructor(data?: IGetFamilySupportOrganizationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.familySupportOrganization = data["familySupportOrganization"] ? FamilySupportOrganizationDto.fromJS(data["familySupportOrganization"]) : <any>undefined;
            this.familyName = data["familyName"];
            this.supportiveOrganizationName = data["supportiveOrganizationName"];
        }
    }

    static fromJS(data: any): GetFamilySupportOrganizationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFamilySupportOrganizationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["familySupportOrganization"] = this.familySupportOrganization ? this.familySupportOrganization.toJSON() : <any>undefined;
        data["familyName"] = this.familyName;
        data["supportiveOrganizationName"] = this.supportiveOrganizationName;
        return data; 
    }
}

export interface IGetFamilySupportOrganizationForViewDto {
    familySupportOrganization: FamilySupportOrganizationDto;
    familyName: string | undefined;
    supportiveOrganizationName: string | undefined;
}

export class PagedResultDtoOfGetFamilySupportOrganizationForViewDto implements IPagedResultDtoOfGetFamilySupportOrganizationForViewDto {
    totalCount!: number;
    items!: GetFamilySupportOrganizationForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetFamilySupportOrganizationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetFamilySupportOrganizationForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetFamilySupportOrganizationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetFamilySupportOrganizationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetFamilySupportOrganizationForViewDto {
    totalCount: number;
    items: GetFamilySupportOrganizationForViewDto[] | undefined;
}

export class FamilySupportiveOrganizationsLookupTableDto implements IFamilySupportiveOrganizationsLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IFamilySupportiveOrganizationsLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): FamilySupportiveOrganizationsLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new FamilySupportiveOrganizationsLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IFamilySupportiveOrganizationsLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class FamilyIncomeOutcomeDto implements IFamilyIncomeOutcomeDto {
    amount!: number | undefined;
    startDate!: moment.Moment | undefined;
    stringStartDate!: string | undefined;
    endDate!: moment.Moment | undefined;
    stringEndDate!: string | undefined;
    description!: string | undefined;
    familyRef!: number | undefined;
    incomeOutcomeRef!: number;
    id!: number;

    constructor(data?: IFamilyIncomeOutcomeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.amount = data["amount"];
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.stringStartDate = data["stringStartDate"];
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.stringEndDate = data["stringEndDate"];
            this.description = data["description"];
            this.familyRef = data["familyRef"];
            this.incomeOutcomeRef = data["incomeOutcomeRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): FamilyIncomeOutcomeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FamilyIncomeOutcomeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["stringStartDate"] = this.stringStartDate;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["stringEndDate"] = this.stringEndDate;
        data["description"] = this.description;
        data["familyRef"] = this.familyRef;
        data["incomeOutcomeRef"] = this.incomeOutcomeRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface IFamilyIncomeOutcomeDto {
    amount: number | undefined;
    startDate: moment.Moment | undefined;
    stringStartDate: string | undefined;
    endDate: moment.Moment | undefined;
    stringEndDate: string | undefined;
    description: string | undefined;
    familyRef: number | undefined;
    incomeOutcomeRef: number;
    id: number;
}

export class GetFamilyIncomeOutcomeForViewDto implements IGetFamilyIncomeOutcomeForViewDto {
    familyIncomeOutcome!: FamilyIncomeOutcomeDto;
    familyCode!: string | undefined;
    incomeOutcomeCode!: string | undefined;
    isEffective!: boolean;
    effect!: boolean;

    constructor(data?: IGetFamilyIncomeOutcomeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.familyIncomeOutcome = data["familyIncomeOutcome"] ? FamilyIncomeOutcomeDto.fromJS(data["familyIncomeOutcome"]) : <any>undefined;
            this.familyCode = data["familyCode"];
            this.incomeOutcomeCode = data["incomeOutcomeCode"];
            this.isEffective = data["isEffective"];
            this.effect = data["effect"];
        }
    }

    static fromJS(data: any): GetFamilyIncomeOutcomeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFamilyIncomeOutcomeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["familyIncomeOutcome"] = this.familyIncomeOutcome ? this.familyIncomeOutcome.toJSON() : <any>undefined;
        data["familyCode"] = this.familyCode;
        data["incomeOutcomeCode"] = this.incomeOutcomeCode;
        data["isEffective"] = this.isEffective;
        data["effect"] = this.effect;
        return data; 
    }
}

export interface IGetFamilyIncomeOutcomeForViewDto {
    familyIncomeOutcome: FamilyIncomeOutcomeDto;
    familyCode: string | undefined;
    incomeOutcomeCode: string | undefined;
    isEffective: boolean;
    effect: boolean;
}

export class PagedResultDtoOfGetFamilyIncomeOutcomeForViewDto implements IPagedResultDtoOfGetFamilyIncomeOutcomeForViewDto {
    totalCount!: number;
    items!: GetFamilyIncomeOutcomeForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetFamilyIncomeOutcomeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetFamilyIncomeOutcomeForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetFamilyIncomeOutcomeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetFamilyIncomeOutcomeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetFamilyIncomeOutcomeForViewDto {
    totalCount: number;
    items: GetFamilyIncomeOutcomeForViewDto[] | undefined;
}

export class GetFamilyAndDependenciesForEditOutput implements IGetFamilyAndDependenciesForEditOutput {
    family!: GetFamilyForEditOutput;
    familyMembers!: PagedResultDtoOfGetFamilyMemberForViewDto;
    addresses!: PagedResultDtoOfGetAddressForViewDto;
    documents!: PagedResultDtoOfGetDocumentForViewDto;
    tags!: PagedResultDtoOfGetTagForViewDto;
    familySupportOrganizations!: PagedResultDtoOfGetFamilySupportOrganizationForViewDto;
    familySupportOrganizationList!: FamilySupportiveOrganizationsLookupTableDto[] | undefined;
    familyIncomeOutcomes!: PagedResultDtoOfGetFamilyIncomeOutcomeForViewDto;

    constructor(data?: IGetFamilyAndDependenciesForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.family = data["family"] ? GetFamilyForEditOutput.fromJS(data["family"]) : <any>undefined;
            this.familyMembers = data["familyMembers"] ? PagedResultDtoOfGetFamilyMemberForViewDto.fromJS(data["familyMembers"]) : <any>undefined;
            this.addresses = data["addresses"] ? PagedResultDtoOfGetAddressForViewDto.fromJS(data["addresses"]) : <any>undefined;
            this.documents = data["documents"] ? PagedResultDtoOfGetDocumentForViewDto.fromJS(data["documents"]) : <any>undefined;
            this.tags = data["tags"] ? PagedResultDtoOfGetTagForViewDto.fromJS(data["tags"]) : <any>undefined;
            this.familySupportOrganizations = data["familySupportOrganizations"] ? PagedResultDtoOfGetFamilySupportOrganizationForViewDto.fromJS(data["familySupportOrganizations"]) : <any>undefined;
            if (Array.isArray(data["familySupportOrganizationList"])) {
                this.familySupportOrganizationList = [] as any;
                for (let item of data["familySupportOrganizationList"])
                    this.familySupportOrganizationList!.push(FamilySupportiveOrganizationsLookupTableDto.fromJS(item));
            }
            this.familyIncomeOutcomes = data["familyIncomeOutcomes"] ? PagedResultDtoOfGetFamilyIncomeOutcomeForViewDto.fromJS(data["familyIncomeOutcomes"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetFamilyAndDependenciesForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetFamilyAndDependenciesForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["family"] = this.family ? this.family.toJSON() : <any>undefined;
        data["familyMembers"] = this.familyMembers ? this.familyMembers.toJSON() : <any>undefined;
        data["addresses"] = this.addresses ? this.addresses.toJSON() : <any>undefined;
        data["documents"] = this.documents ? this.documents.toJSON() : <any>undefined;
        data["tags"] = this.tags ? this.tags.toJSON() : <any>undefined;
        data["familySupportOrganizations"] = this.familySupportOrganizations ? this.familySupportOrganizations.toJSON() : <any>undefined;
        if (Array.isArray(this.familySupportOrganizationList)) {
            data["familySupportOrganizationList"] = [];
            for (let item of this.familySupportOrganizationList)
                data["familySupportOrganizationList"].push(item.toJSON());
        }
        data["familyIncomeOutcomes"] = this.familyIncomeOutcomes ? this.familyIncomeOutcomes.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetFamilyAndDependenciesForEditOutput {
    family: GetFamilyForEditOutput;
    familyMembers: PagedResultDtoOfGetFamilyMemberForViewDto;
    addresses: PagedResultDtoOfGetAddressForViewDto;
    documents: PagedResultDtoOfGetDocumentForViewDto;
    tags: PagedResultDtoOfGetTagForViewDto;
    familySupportOrganizations: PagedResultDtoOfGetFamilySupportOrganizationForViewDto;
    familySupportOrganizationList: FamilySupportiveOrganizationsLookupTableDto[] | undefined;
    familyIncomeOutcomes: PagedResultDtoOfGetFamilyIncomeOutcomeForViewDto;
}

export class DeleteModel implements IDeleteModel {
    id!: number | undefined;
    path!: string | undefined;

    constructor(data?: IDeleteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.path = data["path"];
        }
    }

    static fromJS(data: any): DeleteModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["path"] = this.path;
        return data; 
    }
}

export interface IDeleteModel {
    id: number | undefined;
    path: string | undefined;
}

export class CreateOrEditFamilyIncomeOutcomeDto implements ICreateOrEditFamilyIncomeOutcomeDto {
    amount!: number | undefined;
    startDate!: moment.Moment | undefined;
    stringStartDate!: string | undefined;
    endDate!: moment.Moment | undefined;
    stringEndDate!: string | undefined;
    description!: string | undefined;
    familyRef!: number | undefined;
    incomeOutcomeRef!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditFamilyIncomeOutcomeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.amount = data["amount"];
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.stringStartDate = data["stringStartDate"];
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.stringEndDate = data["stringEndDate"];
            this.description = data["description"];
            this.familyRef = data["familyRef"];
            this.incomeOutcomeRef = data["incomeOutcomeRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditFamilyIncomeOutcomeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditFamilyIncomeOutcomeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["stringStartDate"] = this.stringStartDate;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["stringEndDate"] = this.stringEndDate;
        data["description"] = this.description;
        data["familyRef"] = this.familyRef;
        data["incomeOutcomeRef"] = this.incomeOutcomeRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditFamilyIncomeOutcomeDto {
    amount: number | undefined;
    startDate: moment.Moment | undefined;
    stringStartDate: string | undefined;
    endDate: moment.Moment | undefined;
    stringEndDate: string | undefined;
    description: string | undefined;
    familyRef: number | undefined;
    incomeOutcomeRef: number;
    id: number | undefined;
}

export class CreateOrEditFamilyAndDependenciesDto implements ICreateOrEditFamilyAndDependenciesDto {
    family!: CreateOrEditFamilyDto;
    familyMembers!: CreateOrEditFamilyMemberDto[] | undefined;
    familySupportOrganizationList!: FamilySupportiveOrganizationsLookupTableDto[] | undefined;
    addresses!: CreateOrEditAddressDto[] | undefined;
    documents!: CreateOrEditDocumentDto[] | undefined;
    deleteDocuments!: DeleteModel[] | undefined;
    tags!: CreateOrEditTagDto[] | undefined;
    attributeValues!: CreateOrEditAttributeValueDto[] | undefined;
    familyIncomeOutcomes!: CreateOrEditFamilyIncomeOutcomeDto[] | undefined;

    constructor(data?: ICreateOrEditFamilyAndDependenciesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.family = data["family"] ? CreateOrEditFamilyDto.fromJS(data["family"]) : <any>undefined;
            if (Array.isArray(data["familyMembers"])) {
                this.familyMembers = [] as any;
                for (let item of data["familyMembers"])
                    this.familyMembers!.push(CreateOrEditFamilyMemberDto.fromJS(item));
            }
            if (Array.isArray(data["familySupportOrganizationList"])) {
                this.familySupportOrganizationList = [] as any;
                for (let item of data["familySupportOrganizationList"])
                    this.familySupportOrganizationList!.push(FamilySupportiveOrganizationsLookupTableDto.fromJS(item));
            }
            if (Array.isArray(data["addresses"])) {
                this.addresses = [] as any;
                for (let item of data["addresses"])
                    this.addresses!.push(CreateOrEditAddressDto.fromJS(item));
            }
            if (Array.isArray(data["documents"])) {
                this.documents = [] as any;
                for (let item of data["documents"])
                    this.documents!.push(CreateOrEditDocumentDto.fromJS(item));
            }
            if (Array.isArray(data["deleteDocuments"])) {
                this.deleteDocuments = [] as any;
                for (let item of data["deleteDocuments"])
                    this.deleteDocuments!.push(DeleteModel.fromJS(item));
            }
            if (Array.isArray(data["tags"])) {
                this.tags = [] as any;
                for (let item of data["tags"])
                    this.tags!.push(CreateOrEditTagDto.fromJS(item));
            }
            if (Array.isArray(data["attributeValues"])) {
                this.attributeValues = [] as any;
                for (let item of data["attributeValues"])
                    this.attributeValues!.push(CreateOrEditAttributeValueDto.fromJS(item));
            }
            if (Array.isArray(data["familyIncomeOutcomes"])) {
                this.familyIncomeOutcomes = [] as any;
                for (let item of data["familyIncomeOutcomes"])
                    this.familyIncomeOutcomes!.push(CreateOrEditFamilyIncomeOutcomeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrEditFamilyAndDependenciesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditFamilyAndDependenciesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["family"] = this.family ? this.family.toJSON() : <any>undefined;
        if (Array.isArray(this.familyMembers)) {
            data["familyMembers"] = [];
            for (let item of this.familyMembers)
                data["familyMembers"].push(item.toJSON());
        }
        if (Array.isArray(this.familySupportOrganizationList)) {
            data["familySupportOrganizationList"] = [];
            for (let item of this.familySupportOrganizationList)
                data["familySupportOrganizationList"].push(item.toJSON());
        }
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        if (Array.isArray(this.deleteDocuments)) {
            data["deleteDocuments"] = [];
            for (let item of this.deleteDocuments)
                data["deleteDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        if (Array.isArray(this.attributeValues)) {
            data["attributeValues"] = [];
            for (let item of this.attributeValues)
                data["attributeValues"].push(item.toJSON());
        }
        if (Array.isArray(this.familyIncomeOutcomes)) {
            data["familyIncomeOutcomes"] = [];
            for (let item of this.familyIncomeOutcomes)
                data["familyIncomeOutcomes"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateOrEditFamilyAndDependenciesDto {
    family: CreateOrEditFamilyDto;
    familyMembers: CreateOrEditFamilyMemberDto[] | undefined;
    familySupportOrganizationList: FamilySupportiveOrganizationsLookupTableDto[] | undefined;
    addresses: CreateOrEditAddressDto[] | undefined;
    documents: CreateOrEditDocumentDto[] | undefined;
    deleteDocuments: DeleteModel[] | undefined;
    tags: CreateOrEditTagDto[] | undefined;
    attributeValues: CreateOrEditAttributeValueDto[] | undefined;
    familyIncomeOutcomes: CreateOrEditFamilyIncomeOutcomeDto[] | undefined;
}

export class FamilyFamilyTypesLookupTableDto implements IFamilyFamilyTypesLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IFamilyFamilyTypesLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): FamilyFamilyTypesLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new FamilyFamilyTypesLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IFamilyFamilyTypesLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class FamilyBranchesLookupTableDto implements IFamilyBranchesLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IFamilyBranchesLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): FamilyBranchesLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new FamilyBranchesLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IFamilyBranchesLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class FamilyBankAccountsLookupTableDto implements IFamilyBankAccountsLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IFamilyBankAccountsLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): FamilyBankAccountsLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new FamilyBankAccountsLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IFamilyBankAccountsLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class FamilyGroupSubgroupLookupTableDto implements IFamilyGroupSubgroupLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IFamilyGroupSubgroupLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): FamilyGroupSubgroupLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new FamilyGroupSubgroupLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IFamilyGroupSubgroupLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class FamilyContactLookupTableDto implements IFamilyContactLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    identityCode!: string | undefined;

    constructor(data?: IFamilyContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.identityCode = data["identityCode"];
        }
    }

    static fromJS(data: any): FamilyContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new FamilyContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["identityCode"] = this.identityCode;
        return data; 
    }
}

export interface IFamilyContactLookupTableDto {
    id: number;
    displayName: string | undefined;
    identityCode: string | undefined;
}

export class PagedResultDtoOfFamilyContactLookupTableDto implements IPagedResultDtoOfFamilyContactLookupTableDto {
    totalCount!: number;
    items!: FamilyContactLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfFamilyContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(FamilyContactLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfFamilyContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfFamilyContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfFamilyContactLookupTableDto {
    totalCount: number;
    items: FamilyContactLookupTableDto[] | undefined;
}

export class GetFamilyIncomeOutcomeForEditOutput implements IGetFamilyIncomeOutcomeForEditOutput {
    familyIncomeOutcome!: CreateOrEditFamilyIncomeOutcomeDto;
    familyCode!: string | undefined;
    incomeOutcomeCode!: string | undefined;

    constructor(data?: IGetFamilyIncomeOutcomeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.familyIncomeOutcome = data["familyIncomeOutcome"] ? CreateOrEditFamilyIncomeOutcomeDto.fromJS(data["familyIncomeOutcome"]) : <any>undefined;
            this.familyCode = data["familyCode"];
            this.incomeOutcomeCode = data["incomeOutcomeCode"];
        }
    }

    static fromJS(data: any): GetFamilyIncomeOutcomeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetFamilyIncomeOutcomeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["familyIncomeOutcome"] = this.familyIncomeOutcome ? this.familyIncomeOutcome.toJSON() : <any>undefined;
        data["familyCode"] = this.familyCode;
        data["incomeOutcomeCode"] = this.incomeOutcomeCode;
        return data; 
    }
}

export interface IGetFamilyIncomeOutcomeForEditOutput {
    familyIncomeOutcome: CreateOrEditFamilyIncomeOutcomeDto;
    familyCode: string | undefined;
    incomeOutcomeCode: string | undefined;
}

export class FamilyIncomeOutcomeFamilyLookupTableDto implements IFamilyIncomeOutcomeFamilyLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IFamilyIncomeOutcomeFamilyLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): FamilyIncomeOutcomeFamilyLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new FamilyIncomeOutcomeFamilyLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IFamilyIncomeOutcomeFamilyLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfFamilyIncomeOutcomeFamilyLookupTableDto implements IPagedResultDtoOfFamilyIncomeOutcomeFamilyLookupTableDto {
    totalCount!: number;
    items!: FamilyIncomeOutcomeFamilyLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfFamilyIncomeOutcomeFamilyLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(FamilyIncomeOutcomeFamilyLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfFamilyIncomeOutcomeFamilyLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfFamilyIncomeOutcomeFamilyLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfFamilyIncomeOutcomeFamilyLookupTableDto {
    totalCount: number;
    items: FamilyIncomeOutcomeFamilyLookupTableDto[] | undefined;
}

export class FamilyIncomeOutcomeIncomeOutcomeLookupTableDto implements IFamilyIncomeOutcomeIncomeOutcomeLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    isEffective!: boolean;
    effect!: boolean;

    constructor(data?: IFamilyIncomeOutcomeIncomeOutcomeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.isEffective = data["isEffective"];
            this.effect = data["effect"];
        }
    }

    static fromJS(data: any): FamilyIncomeOutcomeIncomeOutcomeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new FamilyIncomeOutcomeIncomeOutcomeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["isEffective"] = this.isEffective;
        data["effect"] = this.effect;
        return data; 
    }
}

export interface IFamilyIncomeOutcomeIncomeOutcomeLookupTableDto {
    id: number;
    displayName: string | undefined;
    isEffective: boolean;
    effect: boolean;
}

export class PagedResultDtoOfFamilyIncomeOutcomeIncomeOutcomeLookupTableDto implements IPagedResultDtoOfFamilyIncomeOutcomeIncomeOutcomeLookupTableDto {
    totalCount!: number;
    items!: FamilyIncomeOutcomeIncomeOutcomeLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfFamilyIncomeOutcomeIncomeOutcomeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(FamilyIncomeOutcomeIncomeOutcomeLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfFamilyIncomeOutcomeIncomeOutcomeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfFamilyIncomeOutcomeIncomeOutcomeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfFamilyIncomeOutcomeIncomeOutcomeLookupTableDto {
    totalCount: number;
    items: FamilyIncomeOutcomeIncomeOutcomeLookupTableDto[] | undefined;
}

export class GetFamilyMemberForEditOutput implements IGetFamilyMemberForEditOutput {
    familyMember!: CreateOrEditFamilyMemberDto;
    familyName!: string | undefined;
    familyFileNumber!: string | undefined;
    familyMembersRoleTitle!: string | undefined;
    contactFirstName!: string | undefined;
    contactIdentityCode!: string | undefined;
    contactMobileNumber!: string | undefined;
    jobTitle!: string | undefined;
    educationDegreeTitle!: string | undefined;
    isRolePrimery!: boolean;

    constructor(data?: IGetFamilyMemberForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.familyMember = data["familyMember"] ? CreateOrEditFamilyMemberDto.fromJS(data["familyMember"]) : <any>undefined;
            this.familyName = data["familyName"];
            this.familyFileNumber = data["familyFileNumber"];
            this.familyMembersRoleTitle = data["familyMembersRoleTitle"];
            this.contactFirstName = data["contactFirstName"];
            this.contactIdentityCode = data["contactIdentityCode"];
            this.contactMobileNumber = data["contactMobileNumber"];
            this.jobTitle = data["jobTitle"];
            this.educationDegreeTitle = data["educationDegreeTitle"];
            this.isRolePrimery = data["isRolePrimery"];
        }
    }

    static fromJS(data: any): GetFamilyMemberForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetFamilyMemberForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["familyMember"] = this.familyMember ? this.familyMember.toJSON() : <any>undefined;
        data["familyName"] = this.familyName;
        data["familyFileNumber"] = this.familyFileNumber;
        data["familyMembersRoleTitle"] = this.familyMembersRoleTitle;
        data["contactFirstName"] = this.contactFirstName;
        data["contactIdentityCode"] = this.contactIdentityCode;
        data["contactMobileNumber"] = this.contactMobileNumber;
        data["jobTitle"] = this.jobTitle;
        data["educationDegreeTitle"] = this.educationDegreeTitle;
        data["isRolePrimery"] = this.isRolePrimery;
        return data; 
    }
}

export interface IGetFamilyMemberForEditOutput {
    familyMember: CreateOrEditFamilyMemberDto;
    familyName: string | undefined;
    familyFileNumber: string | undefined;
    familyMembersRoleTitle: string | undefined;
    contactFirstName: string | undefined;
    contactIdentityCode: string | undefined;
    contactMobileNumber: string | undefined;
    jobTitle: string | undefined;
    educationDegreeTitle: string | undefined;
    isRolePrimery: boolean;
}

export class FamilyMemberFamilyLookupTableDto implements IFamilyMemberFamilyLookupTableDto {
    id!: number;
    name!: string | undefined;
    supportiveOrganizations!: string | undefined;
    residenceType!: ResidenceType;
    otherResidenceType!: string | undefined;

    constructor(data?: IFamilyMemberFamilyLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.supportiveOrganizations = data["supportiveOrganizations"];
            this.residenceType = data["residenceType"];
            this.otherResidenceType = data["otherResidenceType"];
        }
    }

    static fromJS(data: any): FamilyMemberFamilyLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new FamilyMemberFamilyLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["supportiveOrganizations"] = this.supportiveOrganizations;
        data["residenceType"] = this.residenceType;
        data["otherResidenceType"] = this.otherResidenceType;
        return data; 
    }
}

export interface IFamilyMemberFamilyLookupTableDto {
    id: number;
    name: string | undefined;
    supportiveOrganizations: string | undefined;
    residenceType: ResidenceType;
    otherResidenceType: string | undefined;
}

export class PagedResultDtoOfFamilyMemberFamilyLookupTableDto implements IPagedResultDtoOfFamilyMemberFamilyLookupTableDto {
    totalCount!: number;
    items!: FamilyMemberFamilyLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfFamilyMemberFamilyLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(FamilyMemberFamilyLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfFamilyMemberFamilyLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfFamilyMemberFamilyLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfFamilyMemberFamilyLookupTableDto {
    totalCount: number;
    items: FamilyMemberFamilyLookupTableDto[] | undefined;
}

export class FamilyMemberFamilyMembersRoleLookupTableDto implements IFamilyMemberFamilyMembersRoleLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    isPrimery!: boolean;

    constructor(data?: IFamilyMemberFamilyMembersRoleLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.isPrimery = data["isPrimery"];
        }
    }

    static fromJS(data: any): FamilyMemberFamilyMembersRoleLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new FamilyMemberFamilyMembersRoleLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["isPrimery"] = this.isPrimery;
        return data; 
    }
}

export interface IFamilyMemberFamilyMembersRoleLookupTableDto {
    id: number;
    displayName: string | undefined;
    isPrimery: boolean;
}

export class PagedResultDtoOfFamilyMemberFamilyMembersRoleLookupTableDto implements IPagedResultDtoOfFamilyMemberFamilyMembersRoleLookupTableDto {
    totalCount!: number;
    items!: FamilyMemberFamilyMembersRoleLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfFamilyMemberFamilyMembersRoleLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(FamilyMemberFamilyMembersRoleLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfFamilyMemberFamilyMembersRoleLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfFamilyMemberFamilyMembersRoleLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfFamilyMemberFamilyMembersRoleLookupTableDto {
    totalCount: number;
    items: FamilyMemberFamilyMembersRoleLookupTableDto[] | undefined;
}

export class GetFamilyMemberFamilyForContactDto implements IGetFamilyMemberFamilyForContactDto {
    familyMember!: GetFamilyMemberForEditOutput;
    family!: CreateOrEditFamilyDto;

    constructor(data?: IGetFamilyMemberFamilyForContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.familyMember = data["familyMember"] ? GetFamilyMemberForEditOutput.fromJS(data["familyMember"]) : <any>undefined;
            this.family = data["family"] ? CreateOrEditFamilyDto.fromJS(data["family"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetFamilyMemberFamilyForContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFamilyMemberFamilyForContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["familyMember"] = this.familyMember ? this.familyMember.toJSON() : <any>undefined;
        data["family"] = this.family ? this.family.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetFamilyMemberFamilyForContactDto {
    familyMember: GetFamilyMemberForEditOutput;
    family: CreateOrEditFamilyDto;
}

export class PagedResultDtoOfGetFamilyMemberFamilyForContactDto implements IPagedResultDtoOfGetFamilyMemberFamilyForContactDto {
    totalCount!: number;
    items!: GetFamilyMemberFamilyForContactDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetFamilyMemberFamilyForContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetFamilyMemberFamilyForContactDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetFamilyMemberFamilyForContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetFamilyMemberFamilyForContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetFamilyMemberFamilyForContactDto {
    totalCount: number;
    items: GetFamilyMemberFamilyForContactDto[] | undefined;
}

export class FamilyMemberContactLookupTableDto implements IFamilyMemberContactLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    fatherName!: string | undefined;
    mobileNumber!: string | undefined;
    identityCode!: string | undefined;
    birthDate!: moment.Moment | undefined;
    familyFileNumber!: string | undefined;

    constructor(data?: IFamilyMemberContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.fatherName = data["fatherName"];
            this.mobileNumber = data["mobileNumber"];
            this.identityCode = data["identityCode"];
            this.birthDate = data["birthDate"] ? moment(data["birthDate"].toString()) : <any>undefined;
            this.familyFileNumber = data["familyFileNumber"];
        }
    }

    static fromJS(data: any): FamilyMemberContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new FamilyMemberContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["fatherName"] = this.fatherName;
        data["mobileNumber"] = this.mobileNumber;
        data["identityCode"] = this.identityCode;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["familyFileNumber"] = this.familyFileNumber;
        return data; 
    }
}

export interface IFamilyMemberContactLookupTableDto {
    id: number;
    displayName: string | undefined;
    fatherName: string | undefined;
    mobileNumber: string | undefined;
    identityCode: string | undefined;
    birthDate: moment.Moment | undefined;
    familyFileNumber: string | undefined;
}

export class PagedResultDtoOfFamilyMemberContactLookupTableDto implements IPagedResultDtoOfFamilyMemberContactLookupTableDto {
    totalCount!: number;
    items!: FamilyMemberContactLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfFamilyMemberContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(FamilyMemberContactLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfFamilyMemberContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfFamilyMemberContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfFamilyMemberContactLookupTableDto {
    totalCount: number;
    items: FamilyMemberContactLookupTableDto[] | undefined;
}

export class FamilyMembersRoleDto implements IFamilyMembersRoleDto {
    title!: string | undefined;
    isPrimary!: boolean;
    id!: number;

    constructor(data?: IFamilyMembersRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.isPrimary = data["isPrimary"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): FamilyMembersRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new FamilyMembersRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["isPrimary"] = this.isPrimary;
        data["id"] = this.id;
        return data; 
    }
}

export interface IFamilyMembersRoleDto {
    title: string | undefined;
    isPrimary: boolean;
    id: number;
}

export class GetFamilyMembersRoleForViewDto implements IGetFamilyMembersRoleForViewDto {
    familyMembersRole!: FamilyMembersRoleDto;

    constructor(data?: IGetFamilyMembersRoleForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.familyMembersRole = data["familyMembersRole"] ? FamilyMembersRoleDto.fromJS(data["familyMembersRole"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetFamilyMembersRoleForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFamilyMembersRoleForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["familyMembersRole"] = this.familyMembersRole ? this.familyMembersRole.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetFamilyMembersRoleForViewDto {
    familyMembersRole: FamilyMembersRoleDto;
}

export class PagedResultDtoOfGetFamilyMembersRoleForViewDto implements IPagedResultDtoOfGetFamilyMembersRoleForViewDto {
    totalCount!: number;
    items!: GetFamilyMembersRoleForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetFamilyMembersRoleForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetFamilyMembersRoleForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetFamilyMembersRoleForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetFamilyMembersRoleForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetFamilyMembersRoleForViewDto {
    totalCount: number;
    items: GetFamilyMembersRoleForViewDto[] | undefined;
}

export class CreateOrEditFamilyMembersRoleDto implements ICreateOrEditFamilyMembersRoleDto {
    title!: string | undefined;
    isPrimary!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditFamilyMembersRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.isPrimary = data["isPrimary"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditFamilyMembersRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditFamilyMembersRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["isPrimary"] = this.isPrimary;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditFamilyMembersRoleDto {
    title: string | undefined;
    isPrimary: boolean;
    id: number | undefined;
}

export class GetFamilyMembersRoleForEditOutput implements IGetFamilyMembersRoleForEditOutput {
    familyMembersRole!: CreateOrEditFamilyMembersRoleDto;

    constructor(data?: IGetFamilyMembersRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.familyMembersRole = data["familyMembersRole"] ? CreateOrEditFamilyMembersRoleDto.fromJS(data["familyMembersRole"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetFamilyMembersRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetFamilyMembersRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["familyMembersRole"] = this.familyMembersRole ? this.familyMembersRole.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetFamilyMembersRoleForEditOutput {
    familyMembersRole: CreateOrEditFamilyMembersRoleDto;
}

export class CreateOrEditFamilySupportOrganizationDto implements ICreateOrEditFamilySupportOrganizationDto {
    state!: boolean;
    fileCode!: string | undefined;
    familyRef!: number;
    supportiveOrganizationRef!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditFamilySupportOrganizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.state = data["state"];
            this.fileCode = data["fileCode"];
            this.familyRef = data["familyRef"];
            this.supportiveOrganizationRef = data["supportiveOrganizationRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditFamilySupportOrganizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditFamilySupportOrganizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["fileCode"] = this.fileCode;
        data["familyRef"] = this.familyRef;
        data["supportiveOrganizationRef"] = this.supportiveOrganizationRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditFamilySupportOrganizationDto {
    state: boolean;
    fileCode: string | undefined;
    familyRef: number;
    supportiveOrganizationRef: number;
    id: number | undefined;
}

export class GetFamilySupportOrganizationForEditOutput implements IGetFamilySupportOrganizationForEditOutput {
    familySupportOrganization!: CreateOrEditFamilySupportOrganizationDto;
    familyName!: string | undefined;
    supportiveOrganizationName!: string | undefined;

    constructor(data?: IGetFamilySupportOrganizationForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.familySupportOrganization = data["familySupportOrganization"] ? CreateOrEditFamilySupportOrganizationDto.fromJS(data["familySupportOrganization"]) : <any>undefined;
            this.familyName = data["familyName"];
            this.supportiveOrganizationName = data["supportiveOrganizationName"];
        }
    }

    static fromJS(data: any): GetFamilySupportOrganizationForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetFamilySupportOrganizationForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["familySupportOrganization"] = this.familySupportOrganization ? this.familySupportOrganization.toJSON() : <any>undefined;
        data["familyName"] = this.familyName;
        data["supportiveOrganizationName"] = this.supportiveOrganizationName;
        return data; 
    }
}

export interface IGetFamilySupportOrganizationForEditOutput {
    familySupportOrganization: CreateOrEditFamilySupportOrganizationDto;
    familyName: string | undefined;
    supportiveOrganizationName: string | undefined;
}

export class FamilySupportOrganizationFamilyLookupTableDto implements IFamilySupportOrganizationFamilyLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IFamilySupportOrganizationFamilyLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): FamilySupportOrganizationFamilyLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new FamilySupportOrganizationFamilyLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IFamilySupportOrganizationFamilyLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfFamilySupportOrganizationFamilyLookupTableDto implements IPagedResultDtoOfFamilySupportOrganizationFamilyLookupTableDto {
    totalCount!: number;
    items!: FamilySupportOrganizationFamilyLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfFamilySupportOrganizationFamilyLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(FamilySupportOrganizationFamilyLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfFamilySupportOrganizationFamilyLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfFamilySupportOrganizationFamilyLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfFamilySupportOrganizationFamilyLookupTableDto {
    totalCount: number;
    items: FamilySupportOrganizationFamilyLookupTableDto[] | undefined;
}

export class FamilySupportOrganizationSupportiveOrganizationLookupTableDto implements IFamilySupportOrganizationSupportiveOrganizationLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IFamilySupportOrganizationSupportiveOrganizationLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): FamilySupportOrganizationSupportiveOrganizationLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new FamilySupportOrganizationSupportiveOrganizationLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IFamilySupportOrganizationSupportiveOrganizationLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfFamilySupportOrganizationSupportiveOrganizationLookupTableDto implements IPagedResultDtoOfFamilySupportOrganizationSupportiveOrganizationLookupTableDto {
    totalCount!: number;
    items!: FamilySupportOrganizationSupportiveOrganizationLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfFamilySupportOrganizationSupportiveOrganizationLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(FamilySupportOrganizationSupportiveOrganizationLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfFamilySupportOrganizationSupportiveOrganizationLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfFamilySupportOrganizationSupportiveOrganizationLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfFamilySupportOrganizationSupportiveOrganizationLookupTableDto {
    totalCount: number;
    items: FamilySupportOrganizationSupportiveOrganizationLookupTableDto[] | undefined;
}

export class FamilyTypeDto implements IFamilyTypeDto {
    title!: string | undefined;
    code!: number;
    description!: string | undefined;
    id!: number;

    constructor(data?: IFamilyTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.code = data["code"];
            this.description = data["description"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): FamilyTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FamilyTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["code"] = this.code;
        data["description"] = this.description;
        data["id"] = this.id;
        return data; 
    }
}

export interface IFamilyTypeDto {
    title: string | undefined;
    code: number;
    description: string | undefined;
    id: number;
}

export class GetFamilyTypeForViewDto implements IGetFamilyTypeForViewDto {
    familyType!: FamilyTypeDto;

    constructor(data?: IGetFamilyTypeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.familyType = data["familyType"] ? FamilyTypeDto.fromJS(data["familyType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetFamilyTypeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFamilyTypeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["familyType"] = this.familyType ? this.familyType.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetFamilyTypeForViewDto {
    familyType: FamilyTypeDto;
}

export class PagedResultDtoOfGetFamilyTypeForViewDto implements IPagedResultDtoOfGetFamilyTypeForViewDto {
    totalCount!: number;
    items!: GetFamilyTypeForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetFamilyTypeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetFamilyTypeForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetFamilyTypeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetFamilyTypeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetFamilyTypeForViewDto {
    totalCount: number;
    items: GetFamilyTypeForViewDto[] | undefined;
}

export class CreateOrEditFamilyTypeDto implements ICreateOrEditFamilyTypeDto {
    title!: string | undefined;
    code!: number;
    description!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditFamilyTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.code = data["code"];
            this.description = data["description"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditFamilyTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditFamilyTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["code"] = this.code;
        data["description"] = this.description;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditFamilyTypeDto {
    title: string | undefined;
    code: number;
    description: string | undefined;
    id: number | undefined;
}

export class GetFamilyTypeForEditOutput implements IGetFamilyTypeForEditOutput {
    familyType!: CreateOrEditFamilyTypeDto;

    constructor(data?: IGetFamilyTypeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.familyType = data["familyType"] ? CreateOrEditFamilyTypeDto.fromJS(data["familyType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetFamilyTypeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetFamilyTypeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["familyType"] = this.familyType ? this.familyType.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetFamilyTypeForEditOutput {
    familyType: CreateOrEditFamilyTypeDto;
}

export enum FinancialYearStatus {
    Active = 1,
    Ended = 2,
}

export class FinancialYearDto implements IFinancialYearDto {
    titleCode!: string | undefined;
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    status!: FinancialYearStatus;
    id!: number;

    constructor(data?: IFinancialYearDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.titleCode = data["titleCode"];
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): FinancialYearDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialYearDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleCode"] = this.titleCode;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["id"] = this.id;
        return data; 
    }
}

export interface IFinancialYearDto {
    titleCode: string | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    status: FinancialYearStatus;
    id: number;
}

export class GetFinancialYearForViewDto implements IGetFinancialYearForViewDto {
    financialYear!: FinancialYearDto;

    constructor(data?: IGetFinancialYearForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.financialYear = data["financialYear"] ? FinancialYearDto.fromJS(data["financialYear"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetFinancialYearForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFinancialYearForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financialYear"] = this.financialYear ? this.financialYear.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetFinancialYearForViewDto {
    financialYear: FinancialYearDto;
}

export class PagedResultDtoOfGetFinancialYearForViewDto implements IPagedResultDtoOfGetFinancialYearForViewDto {
    totalCount!: number;
    items!: GetFinancialYearForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetFinancialYearForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetFinancialYearForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetFinancialYearForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetFinancialYearForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetFinancialYearForViewDto {
    totalCount: number;
    items: GetFinancialYearForViewDto[] | undefined;
}

export class CreateOrEditFinancialYearDto implements ICreateOrEditFinancialYearDto {
    titleCode!: string | undefined;
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    status!: FinancialYearStatus;
    id!: number | undefined;

    constructor(data?: ICreateOrEditFinancialYearDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.titleCode = data["titleCode"];
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditFinancialYearDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditFinancialYearDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleCode"] = this.titleCode;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditFinancialYearDto {
    titleCode: string | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    status: FinancialYearStatus;
    id: number | undefined;
}

export class GetFinancialYearForEditOutput implements IGetFinancialYearForEditOutput {
    financialYear!: CreateOrEditFinancialYearDto;

    constructor(data?: IGetFinancialYearForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.financialYear = data["financialYear"] ? CreateOrEditFinancialYearDto.fromJS(data["financialYear"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetFinancialYearForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetFinancialYearForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financialYear"] = this.financialYear ? this.financialYear.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetFinancialYearForEditOutput {
    financialYear: CreateOrEditFinancialYearDto;
}

export class FlowerCrownBranchDto implements IFlowerCrownBranchDto {
    stock!: number;
    isGenerallyUsed!: boolean;
    branchRef!: number;
    flowerCrownRef!: number;
    id!: number;

    constructor(data?: IFlowerCrownBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.stock = data["stock"];
            this.isGenerallyUsed = data["isGenerallyUsed"];
            this.branchRef = data["branchRef"];
            this.flowerCrownRef = data["flowerCrownRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): FlowerCrownBranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlowerCrownBranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stock"] = this.stock;
        data["isGenerallyUsed"] = this.isGenerallyUsed;
        data["branchRef"] = this.branchRef;
        data["flowerCrownRef"] = this.flowerCrownRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface IFlowerCrownBranchDto {
    stock: number;
    isGenerallyUsed: boolean;
    branchRef: number;
    flowerCrownRef: number;
    id: number;
}

export class GetFlowerCrownBranchForViewDto implements IGetFlowerCrownBranchForViewDto {
    flowerCrownBranch!: FlowerCrownBranchDto;
    branchName!: string | undefined;
    flowerCrownColor!: string | undefined;

    constructor(data?: IGetFlowerCrownBranchForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.flowerCrownBranch = data["flowerCrownBranch"] ? FlowerCrownBranchDto.fromJS(data["flowerCrownBranch"]) : <any>undefined;
            this.branchName = data["branchName"];
            this.flowerCrownColor = data["flowerCrownColor"];
        }
    }

    static fromJS(data: any): GetFlowerCrownBranchForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFlowerCrownBranchForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flowerCrownBranch"] = this.flowerCrownBranch ? this.flowerCrownBranch.toJSON() : <any>undefined;
        data["branchName"] = this.branchName;
        data["flowerCrownColor"] = this.flowerCrownColor;
        return data; 
    }
}

export interface IGetFlowerCrownBranchForViewDto {
    flowerCrownBranch: FlowerCrownBranchDto;
    branchName: string | undefined;
    flowerCrownColor: string | undefined;
}

export class PagedResultDtoOfGetFlowerCrownBranchForViewDto implements IPagedResultDtoOfGetFlowerCrownBranchForViewDto {
    totalCount!: number;
    items!: GetFlowerCrownBranchForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetFlowerCrownBranchForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetFlowerCrownBranchForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetFlowerCrownBranchForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetFlowerCrownBranchForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetFlowerCrownBranchForViewDto {
    totalCount: number;
    items: GetFlowerCrownBranchForViewDto[] | undefined;
}

export class CreateOrEditFlowerCrownBranchDto implements ICreateOrEditFlowerCrownBranchDto {
    stock!: number;
    isGenerallyUsed!: boolean;
    branchRef!: number;
    flowerCrownRef!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditFlowerCrownBranchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.stock = data["stock"];
            this.isGenerallyUsed = data["isGenerallyUsed"];
            this.branchRef = data["branchRef"];
            this.flowerCrownRef = data["flowerCrownRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditFlowerCrownBranchDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditFlowerCrownBranchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stock"] = this.stock;
        data["isGenerallyUsed"] = this.isGenerallyUsed;
        data["branchRef"] = this.branchRef;
        data["flowerCrownRef"] = this.flowerCrownRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditFlowerCrownBranchDto {
    stock: number;
    isGenerallyUsed: boolean;
    branchRef: number;
    flowerCrownRef: number | undefined;
    id: number | undefined;
}

export class GetFlowerCrownBranchForEditOutput implements IGetFlowerCrownBranchForEditOutput {
    flowerCrownBranch!: CreateOrEditFlowerCrownBranchDto;
    branchName!: string | undefined;
    flowerCrownColor!: string | undefined;

    constructor(data?: IGetFlowerCrownBranchForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.flowerCrownBranch = data["flowerCrownBranch"] ? CreateOrEditFlowerCrownBranchDto.fromJS(data["flowerCrownBranch"]) : <any>undefined;
            this.branchName = data["branchName"];
            this.flowerCrownColor = data["flowerCrownColor"];
        }
    }

    static fromJS(data: any): GetFlowerCrownBranchForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetFlowerCrownBranchForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flowerCrownBranch"] = this.flowerCrownBranch ? this.flowerCrownBranch.toJSON() : <any>undefined;
        data["branchName"] = this.branchName;
        data["flowerCrownColor"] = this.flowerCrownColor;
        return data; 
    }
}

export interface IGetFlowerCrownBranchForEditOutput {
    flowerCrownBranch: CreateOrEditFlowerCrownBranchDto;
    branchName: string | undefined;
    flowerCrownColor: string | undefined;
}

export class FlowerCrownBranchBranchLookupTableDto implements IFlowerCrownBranchBranchLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IFlowerCrownBranchBranchLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): FlowerCrownBranchBranchLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlowerCrownBranchBranchLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IFlowerCrownBranchBranchLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class FlowerCrownBranchFlowerCrownLookupTableDto implements IFlowerCrownBranchFlowerCrownLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IFlowerCrownBranchFlowerCrownLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): FlowerCrownBranchFlowerCrownLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlowerCrownBranchFlowerCrownLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IFlowerCrownBranchFlowerCrownLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfFlowerCrownBranchFlowerCrownLookupTableDto implements IPagedResultDtoOfFlowerCrownBranchFlowerCrownLookupTableDto {
    totalCount!: number;
    items!: FlowerCrownBranchFlowerCrownLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfFlowerCrownBranchFlowerCrownLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(FlowerCrownBranchFlowerCrownLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfFlowerCrownBranchFlowerCrownLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfFlowerCrownBranchFlowerCrownLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfFlowerCrownBranchFlowerCrownLookupTableDto {
    totalCount: number;
    items: FlowerCrownBranchFlowerCrownLookupTableDto[] | undefined;
}

export class GetFlowerCrownForViewDto implements IGetFlowerCrownForViewDto {
    flowerCrown!: FlowerCrownDto;
    planConstTitle!: string | undefined;

    constructor(data?: IGetFlowerCrownForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.flowerCrown = data["flowerCrown"] ? FlowerCrownDto.fromJS(data["flowerCrown"]) : <any>undefined;
            this.planConstTitle = data["planConstTitle"];
        }
    }

    static fromJS(data: any): GetFlowerCrownForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFlowerCrownForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flowerCrown"] = this.flowerCrown ? this.flowerCrown.toJSON() : <any>undefined;
        data["planConstTitle"] = this.planConstTitle;
        return data; 
    }
}

export interface IGetFlowerCrownForViewDto {
    flowerCrown: FlowerCrownDto;
    planConstTitle: string | undefined;
}

export class PagedResultDtoOfGetFlowerCrownForViewDto implements IPagedResultDtoOfGetFlowerCrownForViewDto {
    totalCount!: number;
    items!: GetFlowerCrownForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetFlowerCrownForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetFlowerCrownForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetFlowerCrownForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetFlowerCrownForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetFlowerCrownForViewDto {
    totalCount: number;
    items: GetFlowerCrownForViewDto[] | undefined;
}

export class CreateOrEditFlowerCrownDto implements ICreateOrEditFlowerCrownDto {
    width!: number | undefined;
    length!: number | undefined;
    thickness!: number | undefined;
    weight!: number | undefined;
    color!: string | undefined;
    isReversible!: boolean;
    planConstId!: number;
    type!: TypesOfSolace;
    secondPrice!: number | undefined;
    thirdPrice!: number | undefined;
    flowerCrownBranchs!: GetFlowerCrownBranchForEditOutput[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditFlowerCrownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.width = data["width"];
            this.length = data["length"];
            this.thickness = data["thickness"];
            this.weight = data["weight"];
            this.color = data["color"];
            this.isReversible = data["isReversible"];
            this.planConstId = data["planConstId"];
            this.type = data["type"];
            this.secondPrice = data["secondPrice"];
            this.thirdPrice = data["thirdPrice"];
            if (Array.isArray(data["flowerCrownBranchs"])) {
                this.flowerCrownBranchs = [] as any;
                for (let item of data["flowerCrownBranchs"])
                    this.flowerCrownBranchs!.push(GetFlowerCrownBranchForEditOutput.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditFlowerCrownDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditFlowerCrownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["width"] = this.width;
        data["length"] = this.length;
        data["thickness"] = this.thickness;
        data["weight"] = this.weight;
        data["color"] = this.color;
        data["isReversible"] = this.isReversible;
        data["planConstId"] = this.planConstId;
        data["type"] = this.type;
        data["secondPrice"] = this.secondPrice;
        data["thirdPrice"] = this.thirdPrice;
        if (Array.isArray(this.flowerCrownBranchs)) {
            data["flowerCrownBranchs"] = [];
            for (let item of this.flowerCrownBranchs)
                data["flowerCrownBranchs"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditFlowerCrownDto {
    width: number | undefined;
    length: number | undefined;
    thickness: number | undefined;
    weight: number | undefined;
    color: string | undefined;
    isReversible: boolean;
    planConstId: number;
    type: TypesOfSolace;
    secondPrice: number | undefined;
    thirdPrice: number | undefined;
    flowerCrownBranchs: GetFlowerCrownBranchForEditOutput[] | undefined;
    id: number | undefined;
}

export class GetFlowerCrownForEditOutput implements IGetFlowerCrownForEditOutput {
    flowerCrown!: CreateOrEditFlowerCrownDto;
    planConstTitle!: string | undefined;

    constructor(data?: IGetFlowerCrownForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.flowerCrown = data["flowerCrown"] ? CreateOrEditFlowerCrownDto.fromJS(data["flowerCrown"]) : <any>undefined;
            this.planConstTitle = data["planConstTitle"];
        }
    }

    static fromJS(data: any): GetFlowerCrownForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetFlowerCrownForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flowerCrown"] = this.flowerCrown ? this.flowerCrown.toJSON() : <any>undefined;
        data["planConstTitle"] = this.planConstTitle;
        return data; 
    }
}

export interface IGetFlowerCrownForEditOutput {
    flowerCrown: CreateOrEditFlowerCrownDto;
    planConstTitle: string | undefined;
}

export class FlowerCrownPlanConstLookupTableDto implements IFlowerCrownPlanConstLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IFlowerCrownPlanConstLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): FlowerCrownPlanConstLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlowerCrownPlanConstLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IFlowerCrownPlanConstLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfFlowerCrownPlanConstLookupTableDto implements IPagedResultDtoOfFlowerCrownPlanConstLookupTableDto {
    totalCount!: number;
    items!: FlowerCrownPlanConstLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfFlowerCrownPlanConstLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(FlowerCrownPlanConstLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfFlowerCrownPlanConstLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfFlowerCrownPlanConstLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfFlowerCrownPlanConstLookupTableDto {
    totalCount: number;
    items: FlowerCrownPlanConstLookupTableDto[] | undefined;
}

export class FollowUpDto implements IFollowUpDto {
    type!: BillStatus;
    description!: string | undefined;
    image!: string | undefined;
    billRef!: number;
    id!: number;

    constructor(data?: IFollowUpDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["type"];
            this.description = data["description"];
            this.image = data["image"];
            this.billRef = data["billRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): FollowUpDto {
        data = typeof data === 'object' ? data : {};
        let result = new FollowUpDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["description"] = this.description;
        data["image"] = this.image;
        data["billRef"] = this.billRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface IFollowUpDto {
    type: BillStatus;
    description: string | undefined;
    image: string | undefined;
    billRef: number;
    id: number;
}

export class GetFollowUpForViewDto implements IGetFollowUpForViewDto {
    followUp!: FollowUpDto;
    billCode!: string | undefined;

    constructor(data?: IGetFollowUpForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.followUp = data["followUp"] ? FollowUpDto.fromJS(data["followUp"]) : <any>undefined;
            this.billCode = data["billCode"];
        }
    }

    static fromJS(data: any): GetFollowUpForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFollowUpForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["followUp"] = this.followUp ? this.followUp.toJSON() : <any>undefined;
        data["billCode"] = this.billCode;
        return data; 
    }
}

export interface IGetFollowUpForViewDto {
    followUp: FollowUpDto;
    billCode: string | undefined;
}

export class PagedResultDtoOfGetFollowUpForViewDto implements IPagedResultDtoOfGetFollowUpForViewDto {
    totalCount!: number;
    items!: GetFollowUpForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetFollowUpForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetFollowUpForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetFollowUpForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetFollowUpForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetFollowUpForViewDto {
    totalCount: number;
    items: GetFollowUpForViewDto[] | undefined;
}

export class CreateOrEditFollowUpDto implements ICreateOrEditFollowUpDto {
    tenantId!: number | undefined;
    description!: string | undefined;
    image!: string | undefined;
    type!: BillStatus;
    billRef!: number;
    currentStatus!: BillStatus;
    id!: number | undefined;

    constructor(data?: ICreateOrEditFollowUpDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.description = data["description"];
            this.image = data["image"];
            this.type = data["type"];
            this.billRef = data["billRef"];
            this.currentStatus = data["currentStatus"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditFollowUpDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditFollowUpDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["description"] = this.description;
        data["image"] = this.image;
        data["type"] = this.type;
        data["billRef"] = this.billRef;
        data["currentStatus"] = this.currentStatus;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditFollowUpDto {
    tenantId: number | undefined;
    description: string | undefined;
    image: string | undefined;
    type: BillStatus;
    billRef: number;
    currentStatus: BillStatus;
    id: number | undefined;
}

export class GetFollowUpForEditOutput implements IGetFollowUpForEditOutput {
    followUp!: CreateOrEditFollowUpDto;
    billCode!: string | undefined;

    constructor(data?: IGetFollowUpForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.followUp = data["followUp"] ? CreateOrEditFollowUpDto.fromJS(data["followUp"]) : <any>undefined;
            this.billCode = data["billCode"];
        }
    }

    static fromJS(data: any): GetFollowUpForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetFollowUpForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["followUp"] = this.followUp ? this.followUp.toJSON() : <any>undefined;
        data["billCode"] = this.billCode;
        return data; 
    }
}

export interface IGetFollowUpForEditOutput {
    followUp: CreateOrEditFollowUpDto;
    billCode: string | undefined;
}

export class CreateOrEditFollowUpForSacrificeDto implements ICreateOrEditFollowUpForSacrificeDto {
    slaughterRef!: number | undefined;
    permission!: string | undefined;
    billCodes!: string[] | undefined;
    count!: number | undefined;
    isParticipatory!: boolean;

    constructor(data?: ICreateOrEditFollowUpForSacrificeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.slaughterRef = data["slaughterRef"];
            this.permission = data["permission"];
            if (Array.isArray(data["billCodes"])) {
                this.billCodes = [] as any;
                for (let item of data["billCodes"])
                    this.billCodes!.push(item);
            }
            this.count = data["count"];
            this.isParticipatory = data["isParticipatory"];
        }
    }

    static fromJS(data: any): CreateOrEditFollowUpForSacrificeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditFollowUpForSacrificeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["slaughterRef"] = this.slaughterRef;
        data["permission"] = this.permission;
        if (Array.isArray(this.billCodes)) {
            data["billCodes"] = [];
            for (let item of this.billCodes)
                data["billCodes"].push(item);
        }
        data["count"] = this.count;
        data["isParticipatory"] = this.isParticipatory;
        return data; 
    }
}

export interface ICreateOrEditFollowUpForSacrificeDto {
    slaughterRef: number | undefined;
    permission: string | undefined;
    billCodes: string[] | undefined;
    count: number | undefined;
    isParticipatory: boolean;
}

export class FollowUpBillLookupTableDto implements IFollowUpBillLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IFollowUpBillLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): FollowUpBillLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new FollowUpBillLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IFollowUpBillLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfFollowUpBillLookupTableDto implements IPagedResultDtoOfFollowUpBillLookupTableDto {
    totalCount!: number;
    items!: FollowUpBillLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfFollowUpBillLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(FollowUpBillLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfFollowUpBillLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfFollowUpBillLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfFollowUpBillLookupTableDto {
    totalCount: number;
    items: FollowUpBillLookupTableDto[] | undefined;
}

export class GetBillFollowUpDto implements IGetBillFollowUpDto {
    date!: moment.Moment | undefined;
    functorName!: string | undefined;
    type!: BillStatus;
    status!: boolean;
    imagePath!: string | undefined;

    constructor(data?: IGetBillFollowUpDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.functorName = data["functorName"];
            this.type = data["type"];
            this.status = data["status"];
            this.imagePath = data["imagePath"];
        }
    }

    static fromJS(data: any): GetBillFollowUpDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBillFollowUpDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["functorName"] = this.functorName;
        data["type"] = this.type;
        data["status"] = this.status;
        data["imagePath"] = this.imagePath;
        return data; 
    }
}

export interface IGetBillFollowUpDto {
    date: moment.Moment | undefined;
    functorName: string | undefined;
    type: BillStatus;
    status: boolean;
    imagePath: string | undefined;
}

export class GetFollowUpsCountDto implements IGetFollowUpsCountDto {
    calligrafyCount!: number;
    stockCount!: number;
    transportCount!: number;
    paidCount!: number;
    transferCount!: number;
    posterPrintingCount!: number;
    deliveryToFlowerRoomCount!: number;
    posterPlacementCount!: number;
    sendingCount!: number;
    inCeremonyCount!: number;
    pickUpCount!: number;
    lostCount!: number;

    constructor(data?: IGetFollowUpsCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.calligrafyCount = data["calligrafyCount"];
            this.stockCount = data["stockCount"];
            this.transportCount = data["transportCount"];
            this.paidCount = data["paidCount"];
            this.transferCount = data["transferCount"];
            this.posterPrintingCount = data["posterPrintingCount"];
            this.deliveryToFlowerRoomCount = data["deliveryToFlowerRoomCount"];
            this.posterPlacementCount = data["posterPlacementCount"];
            this.sendingCount = data["sendingCount"];
            this.inCeremonyCount = data["inCeremonyCount"];
            this.pickUpCount = data["pickUpCount"];
            this.lostCount = data["lostCount"];
        }
    }

    static fromJS(data: any): GetFollowUpsCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFollowUpsCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calligrafyCount"] = this.calligrafyCount;
        data["stockCount"] = this.stockCount;
        data["transportCount"] = this.transportCount;
        data["paidCount"] = this.paidCount;
        data["transferCount"] = this.transferCount;
        data["posterPrintingCount"] = this.posterPrintingCount;
        data["deliveryToFlowerRoomCount"] = this.deliveryToFlowerRoomCount;
        data["posterPlacementCount"] = this.posterPlacementCount;
        data["sendingCount"] = this.sendingCount;
        data["inCeremonyCount"] = this.inCeremonyCount;
        data["pickUpCount"] = this.pickUpCount;
        data["lostCount"] = this.lostCount;
        return data; 
    }
}

export interface IGetFollowUpsCountDto {
    calligrafyCount: number;
    stockCount: number;
    transportCount: number;
    paidCount: number;
    transferCount: number;
    posterPrintingCount: number;
    deliveryToFlowerRoomCount: number;
    posterPlacementCount: number;
    sendingCount: number;
    inCeremonyCount: number;
    pickUpCount: number;
    lostCount: number;
}

export class FlowerCrownInfo implements IFlowerCrownInfo {
    width!: number | undefined;
    length!: number | undefined;
    thickness!: number | undefined;
    weight!: number | undefined;
    color!: string | undefined;
    isReversible!: boolean;
    flowerCrownType!: TypesOfSolace;

    constructor(data?: IFlowerCrownInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.width = data["width"];
            this.length = data["length"];
            this.thickness = data["thickness"];
            this.weight = data["weight"];
            this.color = data["color"];
            this.isReversible = data["isReversible"];
            this.flowerCrownType = data["flowerCrownType"];
        }
    }

    static fromJS(data: any): FlowerCrownInfo {
        data = typeof data === 'object' ? data : {};
        let result = new FlowerCrownInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["width"] = this.width;
        data["length"] = this.length;
        data["thickness"] = this.thickness;
        data["weight"] = this.weight;
        data["color"] = this.color;
        data["isReversible"] = this.isReversible;
        data["flowerCrownType"] = this.flowerCrownType;
        return data; 
    }
}

export interface IFlowerCrownInfo {
    width: number | undefined;
    length: number | undefined;
    thickness: number | undefined;
    weight: number | undefined;
    color: string | undefined;
    isReversible: boolean;
    flowerCrownType: TypesOfSolace;
}

export class GetAllFollowUpsForStaffDto implements IGetAllFollowUpsForStaffDto {
    billCode!: string | undefined;
    billId!: number;
    planConstTitle!: string | undefined;
    planConstCode!: string | undefined;
    benefactorName!: string | undefined;
    deceasedFullName!: string | undefined;
    survivorName!: string | undefined;
    ceremonyTitle!: string | undefined;
    startCeremony!: moment.Moment | undefined;
    startCeremonyDay!: string | undefined;
    type!: BillStatus;
    flowerCrown!: FlowerCrownInfo;
    location!: string | undefined;
    latitude!: number | undefined;
    longitude!: number | undefined;
    bannerPath!: string | undefined;
    description!: string | undefined;
    imageInCeremony!: string | undefined;
    branches!: string[] | undefined;
    branchName!: string | undefined;
    creatorName!: string | undefined;
    flowerCardTemplate!: BillCardTemplateLookupTableDto;
    flowerCardTemplateProperties!: GetPropertiesForBillDto[] | undefined;

    constructor(data?: IGetAllFollowUpsForStaffDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.billCode = data["billCode"];
            this.billId = data["billId"];
            this.planConstTitle = data["planConstTitle"];
            this.planConstCode = data["planConstCode"];
            this.benefactorName = data["benefactorName"];
            this.deceasedFullName = data["deceasedFullName"];
            this.survivorName = data["survivorName"];
            this.ceremonyTitle = data["ceremonyTitle"];
            this.startCeremony = data["startCeremony"] ? moment(data["startCeremony"].toString()) : <any>undefined;
            this.startCeremonyDay = data["startCeremonyDay"];
            this.type = data["type"];
            this.flowerCrown = data["flowerCrown"] ? FlowerCrownInfo.fromJS(data["flowerCrown"]) : <any>undefined;
            this.location = data["location"];
            this.latitude = data["latitude"];
            this.longitude = data["longitude"];
            this.bannerPath = data["bannerPath"];
            this.description = data["description"];
            this.imageInCeremony = data["imageInCeremony"];
            if (Array.isArray(data["branches"])) {
                this.branches = [] as any;
                for (let item of data["branches"])
                    this.branches!.push(item);
            }
            this.branchName = data["branchName"];
            this.creatorName = data["creatorName"];
            this.flowerCardTemplate = data["flowerCardTemplate"] ? BillCardTemplateLookupTableDto.fromJS(data["flowerCardTemplate"]) : <any>undefined;
            if (Array.isArray(data["flowerCardTemplateProperties"])) {
                this.flowerCardTemplateProperties = [] as any;
                for (let item of data["flowerCardTemplateProperties"])
                    this.flowerCardTemplateProperties!.push(GetPropertiesForBillDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllFollowUpsForStaffDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllFollowUpsForStaffDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billCode"] = this.billCode;
        data["billId"] = this.billId;
        data["planConstTitle"] = this.planConstTitle;
        data["planConstCode"] = this.planConstCode;
        data["benefactorName"] = this.benefactorName;
        data["deceasedFullName"] = this.deceasedFullName;
        data["survivorName"] = this.survivorName;
        data["ceremonyTitle"] = this.ceremonyTitle;
        data["startCeremony"] = this.startCeremony ? this.startCeremony.toISOString() : <any>undefined;
        data["startCeremonyDay"] = this.startCeremonyDay;
        data["type"] = this.type;
        data["flowerCrown"] = this.flowerCrown ? this.flowerCrown.toJSON() : <any>undefined;
        data["location"] = this.location;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["bannerPath"] = this.bannerPath;
        data["description"] = this.description;
        data["imageInCeremony"] = this.imageInCeremony;
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item);
        }
        data["branchName"] = this.branchName;
        data["creatorName"] = this.creatorName;
        data["flowerCardTemplate"] = this.flowerCardTemplate ? this.flowerCardTemplate.toJSON() : <any>undefined;
        if (Array.isArray(this.flowerCardTemplateProperties)) {
            data["flowerCardTemplateProperties"] = [];
            for (let item of this.flowerCardTemplateProperties)
                data["flowerCardTemplateProperties"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetAllFollowUpsForStaffDto {
    billCode: string | undefined;
    billId: number;
    planConstTitle: string | undefined;
    planConstCode: string | undefined;
    benefactorName: string | undefined;
    deceasedFullName: string | undefined;
    survivorName: string | undefined;
    ceremonyTitle: string | undefined;
    startCeremony: moment.Moment | undefined;
    startCeremonyDay: string | undefined;
    type: BillStatus;
    flowerCrown: FlowerCrownInfo;
    location: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    bannerPath: string | undefined;
    description: string | undefined;
    imageInCeremony: string | undefined;
    branches: string[] | undefined;
    branchName: string | undefined;
    creatorName: string | undefined;
    flowerCardTemplate: BillCardTemplateLookupTableDto;
    flowerCardTemplateProperties: GetPropertiesForBillDto[] | undefined;
}

export class PagedResultDtoOfGetAllFollowUpsForStaffDto implements IPagedResultDtoOfGetAllFollowUpsForStaffDto {
    totalCount!: number;
    items!: GetAllFollowUpsForStaffDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAllFollowUpsForStaffDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetAllFollowUpsForStaffDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAllFollowUpsForStaffDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAllFollowUpsForStaffDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetAllFollowUpsForStaffDto {
    totalCount: number;
    items: GetAllFollowUpsForStaffDto[] | undefined;
}

export enum MethodNameForCache {
    Get = 1,
    Insert = 2,
    Update = 3,
    Delete = 4,
}

export enum Livestocks {
    Default = 0,
    Camel = 1,
    Sheep = 2,
    Lamb = 3,
    Chicken = 4,
    Cow = 5,
    Calf = 6,
}

export class GetAllSacrificeFollowUpsDto implements IGetAllSacrificeFollowUpsDto {
    billCode!: string | undefined;
    billRef!: number | undefined;
    slaughteredRef!: number | undefined;
    billSlaughteredRef!: number | undefined;
    planConstTitle!: string | undefined;
    planConstRef!: number;
    status!: BillStatus;
    benefactorName!: string | undefined;
    currencyName!: string | undefined;
    price!: number | undefined;
    count!: number | undefined;
    sacrificeTypeTitle!: string | undefined;
    sacrificeIcon!: string | undefined;
    sacrificeTypeRef!: number;
    livestock!: Livestocks;
    descriptionOne!: string | undefined;
    descriptionTwo!: string | undefined;
    description!: string | undefined;
    isParticipatory!: boolean;
    slaughterAgentTitle!: string | undefined;
    slaughterAgentRef!: number | undefined;
    weight!: number | undefined;
    unitPrice!: number | undefined;
    ratio!: number | undefined;
    billRefs!: number[] | undefined;
    paymentDate!: moment.Moment | undefined;
    sendToSlaughterDate!: moment.Moment | undefined;
    announceTheDifference!: boolean;
    branchName!: string | undefined;
    creatorName!: string | undefined;

    constructor(data?: IGetAllSacrificeFollowUpsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.billCode = data["billCode"];
            this.billRef = data["billRef"];
            this.slaughteredRef = data["slaughteredRef"];
            this.billSlaughteredRef = data["billSlaughteredRef"];
            this.planConstTitle = data["planConstTitle"];
            this.planConstRef = data["planConstRef"];
            this.status = data["status"];
            this.benefactorName = data["benefactorName"];
            this.currencyName = data["currencyName"];
            this.price = data["price"];
            this.count = data["count"];
            this.sacrificeTypeTitle = data["sacrificeTypeTitle"];
            this.sacrificeIcon = data["sacrificeIcon"];
            this.sacrificeTypeRef = data["sacrificeTypeRef"];
            this.livestock = data["livestock"];
            this.descriptionOne = data["descriptionOne"];
            this.descriptionTwo = data["descriptionTwo"];
            this.description = data["description"];
            this.isParticipatory = data["isParticipatory"];
            this.slaughterAgentTitle = data["slaughterAgentTitle"];
            this.slaughterAgentRef = data["slaughterAgentRef"];
            this.weight = data["weight"];
            this.unitPrice = data["unitPrice"];
            this.ratio = data["ratio"];
            if (Array.isArray(data["billRefs"])) {
                this.billRefs = [] as any;
                for (let item of data["billRefs"])
                    this.billRefs!.push(item);
            }
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.sendToSlaughterDate = data["sendToSlaughterDate"] ? moment(data["sendToSlaughterDate"].toString()) : <any>undefined;
            this.announceTheDifference = data["announceTheDifference"];
            this.branchName = data["branchName"];
            this.creatorName = data["creatorName"];
        }
    }

    static fromJS(data: any): GetAllSacrificeFollowUpsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSacrificeFollowUpsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billCode"] = this.billCode;
        data["billRef"] = this.billRef;
        data["slaughteredRef"] = this.slaughteredRef;
        data["billSlaughteredRef"] = this.billSlaughteredRef;
        data["planConstTitle"] = this.planConstTitle;
        data["planConstRef"] = this.planConstRef;
        data["status"] = this.status;
        data["benefactorName"] = this.benefactorName;
        data["currencyName"] = this.currencyName;
        data["price"] = this.price;
        data["count"] = this.count;
        data["sacrificeTypeTitle"] = this.sacrificeTypeTitle;
        data["sacrificeIcon"] = this.sacrificeIcon;
        data["sacrificeTypeRef"] = this.sacrificeTypeRef;
        data["livestock"] = this.livestock;
        data["descriptionOne"] = this.descriptionOne;
        data["descriptionTwo"] = this.descriptionTwo;
        data["description"] = this.description;
        data["isParticipatory"] = this.isParticipatory;
        data["slaughterAgentTitle"] = this.slaughterAgentTitle;
        data["slaughterAgentRef"] = this.slaughterAgentRef;
        data["weight"] = this.weight;
        data["unitPrice"] = this.unitPrice;
        data["ratio"] = this.ratio;
        if (Array.isArray(this.billRefs)) {
            data["billRefs"] = [];
            for (let item of this.billRefs)
                data["billRefs"].push(item);
        }
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["sendToSlaughterDate"] = this.sendToSlaughterDate ? this.sendToSlaughterDate.toISOString() : <any>undefined;
        data["announceTheDifference"] = this.announceTheDifference;
        data["branchName"] = this.branchName;
        data["creatorName"] = this.creatorName;
        return data; 
    }
}

export interface IGetAllSacrificeFollowUpsDto {
    billCode: string | undefined;
    billRef: number | undefined;
    slaughteredRef: number | undefined;
    billSlaughteredRef: number | undefined;
    planConstTitle: string | undefined;
    planConstRef: number;
    status: BillStatus;
    benefactorName: string | undefined;
    currencyName: string | undefined;
    price: number | undefined;
    count: number | undefined;
    sacrificeTypeTitle: string | undefined;
    sacrificeIcon: string | undefined;
    sacrificeTypeRef: number;
    livestock: Livestocks;
    descriptionOne: string | undefined;
    descriptionTwo: string | undefined;
    description: string | undefined;
    isParticipatory: boolean;
    slaughterAgentTitle: string | undefined;
    slaughterAgentRef: number | undefined;
    weight: number | undefined;
    unitPrice: number | undefined;
    ratio: number | undefined;
    billRefs: number[] | undefined;
    paymentDate: moment.Moment | undefined;
    sendToSlaughterDate: moment.Moment | undefined;
    announceTheDifference: boolean;
    branchName: string | undefined;
    creatorName: string | undefined;
}

export class PagedResultDtoOfGetAllSacrificeFollowUpsDto implements IPagedResultDtoOfGetAllSacrificeFollowUpsDto {
    totalCount!: number;
    items!: GetAllSacrificeFollowUpsDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAllSacrificeFollowUpsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetAllSacrificeFollowUpsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAllSacrificeFollowUpsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAllSacrificeFollowUpsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetAllSacrificeFollowUpsDto {
    totalCount: number;
    items: GetAllSacrificeFollowUpsDto[] | undefined;
}

export class FollowUpSlaughterAgentLookupTableDto implements IFollowUpSlaughterAgentLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    sacrificeType!: string | undefined;
    sacrificeTypes!: number[] | undefined;

    constructor(data?: IFollowUpSlaughterAgentLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.sacrificeType = data["sacrificeType"];
            if (Array.isArray(data["sacrificeTypes"])) {
                this.sacrificeTypes = [] as any;
                for (let item of data["sacrificeTypes"])
                    this.sacrificeTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): FollowUpSlaughterAgentLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new FollowUpSlaughterAgentLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["sacrificeType"] = this.sacrificeType;
        if (Array.isArray(this.sacrificeTypes)) {
            data["sacrificeTypes"] = [];
            for (let item of this.sacrificeTypes)
                data["sacrificeTypes"].push(item);
        }
        return data; 
    }
}

export interface IFollowUpSlaughterAgentLookupTableDto {
    id: number;
    displayName: string | undefined;
    sacrificeType: string | undefined;
    sacrificeTypes: number[] | undefined;
}

export class FollowUpSacrificeTypeLookupTableDto implements IFollowUpSacrificeTypeLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IFollowUpSacrificeTypeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): FollowUpSacrificeTypeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new FollowUpSacrificeTypeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IFollowUpSacrificeTypeLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class BranchLookupTableDto implements IBranchLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IBranchLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): BranchLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new BranchLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IBranchLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PlanConstLookupTableDto implements IPlanConstLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IPlanConstLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): PlanConstLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlanConstLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IPlanConstLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class EditCardTemlateFromActionDto implements IEditCardTemlateFromActionDto {
    billId!: number;
    cartTemlateId!: number;
    flowerCardTemplateProperties!: GetPropertiesForBillDto[] | undefined;
    deleteFlowerCardTemplateProperties!: number[] | undefined;

    constructor(data?: IEditCardTemlateFromActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.billId = data["billId"];
            this.cartTemlateId = data["cartTemlateId"];
            if (Array.isArray(data["flowerCardTemplateProperties"])) {
                this.flowerCardTemplateProperties = [] as any;
                for (let item of data["flowerCardTemplateProperties"])
                    this.flowerCardTemplateProperties!.push(GetPropertiesForBillDto.fromJS(item));
            }
            if (Array.isArray(data["deleteFlowerCardTemplateProperties"])) {
                this.deleteFlowerCardTemplateProperties = [] as any;
                for (let item of data["deleteFlowerCardTemplateProperties"])
                    this.deleteFlowerCardTemplateProperties!.push(item);
            }
        }
    }

    static fromJS(data: any): EditCardTemlateFromActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditCardTemlateFromActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billId"] = this.billId;
        data["cartTemlateId"] = this.cartTemlateId;
        if (Array.isArray(this.flowerCardTemplateProperties)) {
            data["flowerCardTemplateProperties"] = [];
            for (let item of this.flowerCardTemplateProperties)
                data["flowerCardTemplateProperties"].push(item.toJSON());
        }
        if (Array.isArray(this.deleteFlowerCardTemplateProperties)) {
            data["deleteFlowerCardTemplateProperties"] = [];
            for (let item of this.deleteFlowerCardTemplateProperties)
                data["deleteFlowerCardTemplateProperties"].push(item);
        }
        return data; 
    }
}

export interface IEditCardTemlateFromActionDto {
    billId: number;
    cartTemlateId: number;
    flowerCardTemplateProperties: GetPropertiesForBillDto[] | undefined;
    deleteFlowerCardTemplateProperties: number[] | undefined;
}

export class GetBillForFollowUpDto implements IGetBillForFollowUpDto {
    code!: string | undefined;
    tenantId!: number | undefined;
    benefactorName!: string | undefined;
    issueDate!: moment.Moment;
    price!: number;
    count!: number | undefined;
    description!: string | undefined;
    status!: BillStatus;
    contactId!: number;
    currencyId!: number | undefined;
    planConstId!: number;
    planConstCode!: string | undefined;
    cardTemplateRef!: number | undefined;
    branchRef!: number | undefined;
    branchTitle!: string | undefined;
    survivorMobileNo!: string | undefined;
    planConstTitle!: string | undefined;
    planType!: Plans;
    lastModifierUserId!: number | undefined;
    creatorUserId!: number | undefined;
    deliveryType!: DeliveryTypes;
    extraEntity!: Consumers;
    extraEntityRef!: number | undefined;
    id!: number;

    constructor(data?: IGetBillForFollowUpDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.tenantId = data["tenantId"];
            this.benefactorName = data["benefactorName"];
            this.issueDate = data["issueDate"] ? moment(data["issueDate"].toString()) : <any>undefined;
            this.price = data["price"];
            this.count = data["count"];
            this.description = data["description"];
            this.status = data["status"];
            this.contactId = data["contactId"];
            this.currencyId = data["currencyId"];
            this.planConstId = data["planConstId"];
            this.planConstCode = data["planConstCode"];
            this.cardTemplateRef = data["cardTemplateRef"];
            this.branchRef = data["branchRef"];
            this.branchTitle = data["branchTitle"];
            this.survivorMobileNo = data["survivorMobileNo"];
            this.planConstTitle = data["planConstTitle"];
            this.planType = data["planType"];
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creatorUserId = data["creatorUserId"];
            this.deliveryType = data["deliveryType"];
            this.extraEntity = data["extraEntity"];
            this.extraEntityRef = data["extraEntityRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GetBillForFollowUpDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBillForFollowUpDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["tenantId"] = this.tenantId;
        data["benefactorName"] = this.benefactorName;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["price"] = this.price;
        data["count"] = this.count;
        data["description"] = this.description;
        data["status"] = this.status;
        data["contactId"] = this.contactId;
        data["currencyId"] = this.currencyId;
        data["planConstId"] = this.planConstId;
        data["planConstCode"] = this.planConstCode;
        data["cardTemplateRef"] = this.cardTemplateRef;
        data["branchRef"] = this.branchRef;
        data["branchTitle"] = this.branchTitle;
        data["survivorMobileNo"] = this.survivorMobileNo;
        data["planConstTitle"] = this.planConstTitle;
        data["planType"] = this.planType;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creatorUserId"] = this.creatorUserId;
        data["deliveryType"] = this.deliveryType;
        data["extraEntity"] = this.extraEntity;
        data["extraEntityRef"] = this.extraEntityRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface IGetBillForFollowUpDto {
    code: string | undefined;
    tenantId: number | undefined;
    benefactorName: string | undefined;
    issueDate: moment.Moment;
    price: number;
    count: number | undefined;
    description: string | undefined;
    status: BillStatus;
    contactId: number;
    currencyId: number | undefined;
    planConstId: number;
    planConstCode: string | undefined;
    cardTemplateRef: number | undefined;
    branchRef: number | undefined;
    branchTitle: string | undefined;
    survivorMobileNo: string | undefined;
    planConstTitle: string | undefined;
    planType: Plans;
    lastModifierUserId: number | undefined;
    creatorUserId: number | undefined;
    deliveryType: DeliveryTypes;
    extraEntity: Consumers;
    extraEntityRef: number | undefined;
    id: number;
}

export class GetFollowUpForCachDto implements IGetFollowUpForCachDto {
    description!: string | undefined;
    creatorUserId!: number | undefined;
    image!: string | undefined;
    type!: BillStatus;
    billRef!: number;
    billStatus!: BillStatus;
    creationTime!: moment.Moment | undefined;
    id!: number;

    constructor(data?: IGetFollowUpForCachDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.creatorUserId = data["creatorUserId"];
            this.image = data["image"];
            this.type = data["type"];
            this.billRef = data["billRef"];
            this.billStatus = data["billStatus"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GetFollowUpForCachDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFollowUpForCachDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["creatorUserId"] = this.creatorUserId;
        data["image"] = this.image;
        data["type"] = this.type;
        data["billRef"] = this.billRef;
        data["billStatus"] = this.billStatus;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IGetFollowUpForCachDto {
    description: string | undefined;
    creatorUserId: number | undefined;
    image: string | undefined;
    type: BillStatus;
    billRef: number;
    billStatus: BillStatus;
    creationTime: moment.Moment | undefined;
    id: number;
}

export class GetDeliveryToContactReportDto implements IGetDeliveryToContactReportDto {
    bill!: GetBillForFollowUpDto;
    followUp!: GetFollowUpForCachDto;

    constructor(data?: IGetDeliveryToContactReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bill = data["bill"] ? GetBillForFollowUpDto.fromJS(data["bill"]) : <any>undefined;
            this.followUp = data["followUp"] ? GetFollowUpForCachDto.fromJS(data["followUp"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDeliveryToContactReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeliveryToContactReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bill"] = this.bill ? this.bill.toJSON() : <any>undefined;
        data["followUp"] = this.followUp ? this.followUp.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetDeliveryToContactReportDto {
    bill: GetBillForFollowUpDto;
    followUp: GetFollowUpForCachDto;
}

export class PagedResultDtoOfGetDeliveryToContactReportDto implements IPagedResultDtoOfGetDeliveryToContactReportDto {
    totalCount!: number;
    items!: GetDeliveryToContactReportDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetDeliveryToContactReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetDeliveryToContactReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetDeliveryToContactReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetDeliveryToContactReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetDeliveryToContactReportDto {
    totalCount: number;
    items: GetDeliveryToContactReportDto[] | undefined;
}

export class CreateFriendshipRequestInput implements ICreateFriendshipRequestInput {
    userId!: number;
    tenantId!: number | undefined;

    constructor(data?: ICreateFriendshipRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): CreateFriendshipRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFriendshipRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface ICreateFriendshipRequestInput {
    userId: number;
    tenantId: number | undefined;
}

export class CreateFriendshipRequestByUserNameInput implements ICreateFriendshipRequestByUserNameInput {
    tenancyName!: string | undefined;
    userName!: string | undefined;

    constructor(data?: ICreateFriendshipRequestByUserNameInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): CreateFriendshipRequestByUserNameInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFriendshipRequestByUserNameInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userName"] = this.userName;
        return data; 
    }
}

export interface ICreateFriendshipRequestByUserNameInput {
    tenancyName: string | undefined;
    userName: string | undefined;
}

export class BlockUserInput implements IBlockUserInput {
    userId!: number;
    tenantId!: number | undefined;

    constructor(data?: IBlockUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): BlockUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new BlockUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IBlockUserInput {
    userId: number;
    tenantId: number | undefined;
}

export class UnblockUserInput implements IUnblockUserInput {
    userId!: number;
    tenantId!: number | undefined;

    constructor(data?: IUnblockUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): UnblockUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new UnblockUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IUnblockUserInput {
    userId: number;
    tenantId: number | undefined;
}

export class AcceptFriendshipRequestInput implements IAcceptFriendshipRequestInput {
    userId!: number;
    tenantId!: number | undefined;

    constructor(data?: IAcceptFriendshipRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): AcceptFriendshipRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptFriendshipRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IAcceptFriendshipRequestInput {
    userId: number;
    tenantId: number | undefined;
}

export class GeneralSettingDto implements IGeneralSettingDto {
    logo!: string | undefined;
    siteTitle!: string | undefined;
    favicon!: string | undefined;
    description!: string | undefined;
    addresses!: string | undefined;
    phones!: string | undefined;
    emails!: string | undefined;
    apps!: string | undefined;
    socialMedia!: string | undefined;
    rulesAndPrivacy!: string | undefined;
    pushNotification!: boolean;
    constFlowerCrownId!: number | undefined;
    constMoneyBoxId!: number | undefined;
    constCharityPlanId!: number | undefined;
    constCharityAlmsPlanId!: number | undefined;
    operatorPhoneNo!: string | undefined;
    scoreWalletCode!: string | undefined;
    moneyWalletCode!: string | undefined;
    minTaaminPension!: number | undefined;
    themTemplateId!: number | undefined;
    currencyRef!: number | undefined;
    branchRef!: number | undefined;
    thirdPartyApps!: string | undefined;
    id!: number;

    constructor(data?: IGeneralSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.logo = data["logo"];
            this.siteTitle = data["siteTitle"];
            this.favicon = data["favicon"];
            this.description = data["description"];
            this.addresses = data["addresses"];
            this.phones = data["phones"];
            this.emails = data["emails"];
            this.apps = data["apps"];
            this.socialMedia = data["socialMedia"];
            this.rulesAndPrivacy = data["rulesAndPrivacy"];
            this.pushNotification = data["pushNotification"];
            this.constFlowerCrownId = data["constFlowerCrownId"];
            this.constMoneyBoxId = data["constMoneyBoxId"];
            this.constCharityPlanId = data["constCharityPlanId"];
            this.constCharityAlmsPlanId = data["constCharityAlmsPlanId"];
            this.operatorPhoneNo = data["operatorPhoneNo"];
            this.scoreWalletCode = data["scoreWalletCode"];
            this.moneyWalletCode = data["moneyWalletCode"];
            this.minTaaminPension = data["minTaaminPension"];
            this.themTemplateId = data["themTemplateId"];
            this.currencyRef = data["currencyRef"];
            this.branchRef = data["branchRef"];
            this.thirdPartyApps = data["thirdPartyApps"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GeneralSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logo"] = this.logo;
        data["siteTitle"] = this.siteTitle;
        data["favicon"] = this.favicon;
        data["description"] = this.description;
        data["addresses"] = this.addresses;
        data["phones"] = this.phones;
        data["emails"] = this.emails;
        data["apps"] = this.apps;
        data["socialMedia"] = this.socialMedia;
        data["rulesAndPrivacy"] = this.rulesAndPrivacy;
        data["pushNotification"] = this.pushNotification;
        data["constFlowerCrownId"] = this.constFlowerCrownId;
        data["constMoneyBoxId"] = this.constMoneyBoxId;
        data["constCharityPlanId"] = this.constCharityPlanId;
        data["constCharityAlmsPlanId"] = this.constCharityAlmsPlanId;
        data["operatorPhoneNo"] = this.operatorPhoneNo;
        data["scoreWalletCode"] = this.scoreWalletCode;
        data["moneyWalletCode"] = this.moneyWalletCode;
        data["minTaaminPension"] = this.minTaaminPension;
        data["themTemplateId"] = this.themTemplateId;
        data["currencyRef"] = this.currencyRef;
        data["branchRef"] = this.branchRef;
        data["thirdPartyApps"] = this.thirdPartyApps;
        data["id"] = this.id;
        return data; 
    }
}

export interface IGeneralSettingDto {
    logo: string | undefined;
    siteTitle: string | undefined;
    favicon: string | undefined;
    description: string | undefined;
    addresses: string | undefined;
    phones: string | undefined;
    emails: string | undefined;
    apps: string | undefined;
    socialMedia: string | undefined;
    rulesAndPrivacy: string | undefined;
    pushNotification: boolean;
    constFlowerCrownId: number | undefined;
    constMoneyBoxId: number | undefined;
    constCharityPlanId: number | undefined;
    constCharityAlmsPlanId: number | undefined;
    operatorPhoneNo: string | undefined;
    scoreWalletCode: string | undefined;
    moneyWalletCode: string | undefined;
    minTaaminPension: number | undefined;
    themTemplateId: number | undefined;
    currencyRef: number | undefined;
    branchRef: number | undefined;
    thirdPartyApps: string | undefined;
    id: number;
}

export class GetGeneralSettingForViewDto implements IGetGeneralSettingForViewDto {
    generalSetting!: GeneralSettingDto;
    themTemplateCode!: string | undefined;
    currencyName!: string | undefined;
    constFlowerCrownName!: string | undefined;
    constMoneyBoxName!: string | undefined;
    constCharityPlanName!: string | undefined;
    constCharityAlmsPlanName!: string | undefined;
    branchName!: string | undefined;

    constructor(data?: IGetGeneralSettingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.generalSetting = data["generalSetting"] ? GeneralSettingDto.fromJS(data["generalSetting"]) : <any>undefined;
            this.themTemplateCode = data["themTemplateCode"];
            this.currencyName = data["currencyName"];
            this.constFlowerCrownName = data["constFlowerCrownName"];
            this.constMoneyBoxName = data["constMoneyBoxName"];
            this.constCharityPlanName = data["constCharityPlanName"];
            this.constCharityAlmsPlanName = data["constCharityAlmsPlanName"];
            this.branchName = data["branchName"];
        }
    }

    static fromJS(data: any): GetGeneralSettingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeneralSettingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generalSetting"] = this.generalSetting ? this.generalSetting.toJSON() : <any>undefined;
        data["themTemplateCode"] = this.themTemplateCode;
        data["currencyName"] = this.currencyName;
        data["constFlowerCrownName"] = this.constFlowerCrownName;
        data["constMoneyBoxName"] = this.constMoneyBoxName;
        data["constCharityPlanName"] = this.constCharityPlanName;
        data["constCharityAlmsPlanName"] = this.constCharityAlmsPlanName;
        data["branchName"] = this.branchName;
        return data; 
    }
}

export interface IGetGeneralSettingForViewDto {
    generalSetting: GeneralSettingDto;
    themTemplateCode: string | undefined;
    currencyName: string | undefined;
    constFlowerCrownName: string | undefined;
    constMoneyBoxName: string | undefined;
    constCharityPlanName: string | undefined;
    constCharityAlmsPlanName: string | undefined;
    branchName: string | undefined;
}

export class PagedResultDtoOfGetGeneralSettingForViewDto implements IPagedResultDtoOfGetGeneralSettingForViewDto {
    totalCount!: number;
    items!: GetGeneralSettingForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetGeneralSettingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetGeneralSettingForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetGeneralSettingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetGeneralSettingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetGeneralSettingForViewDto {
    totalCount: number;
    items: GetGeneralSettingForViewDto[] | undefined;
}

export class CreateOrEditGeneralSettingDto implements ICreateOrEditGeneralSettingDto {
    logo!: string | undefined;
    siteTitle!: string | undefined;
    favicon!: string | undefined;
    description!: string | undefined;
    addresses!: string | undefined;
    phones!: string | undefined;
    emails!: string | undefined;
    apps!: string | undefined;
    socialMedia!: string | undefined;
    rulesAndPrivacy!: string | undefined;
    pushNotification!: boolean;
    constFlowerCrownId!: number | undefined;
    constMoneyBoxId!: number | undefined;
    constCharityPlanId!: number | undefined;
    constCharityAlmsPlanId!: number | undefined;
    scoreWalletCode!: string | undefined;
    moneyWalletCode!: string | undefined;
    operatorPhoneNo!: string | undefined;
    minTaaminPension!: number | undefined;
    themTemplateId!: number | undefined;
    currencyRef!: number | undefined;
    branchRef!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditGeneralSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.logo = data["logo"];
            this.siteTitle = data["siteTitle"];
            this.favicon = data["favicon"];
            this.description = data["description"];
            this.addresses = data["addresses"];
            this.phones = data["phones"];
            this.emails = data["emails"];
            this.apps = data["apps"];
            this.socialMedia = data["socialMedia"];
            this.rulesAndPrivacy = data["rulesAndPrivacy"];
            this.pushNotification = data["pushNotification"];
            this.constFlowerCrownId = data["constFlowerCrownId"];
            this.constMoneyBoxId = data["constMoneyBoxId"];
            this.constCharityPlanId = data["constCharityPlanId"];
            this.constCharityAlmsPlanId = data["constCharityAlmsPlanId"];
            this.scoreWalletCode = data["scoreWalletCode"];
            this.moneyWalletCode = data["moneyWalletCode"];
            this.operatorPhoneNo = data["operatorPhoneNo"];
            this.minTaaminPension = data["minTaaminPension"];
            this.themTemplateId = data["themTemplateId"];
            this.currencyRef = data["currencyRef"];
            this.branchRef = data["branchRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditGeneralSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditGeneralSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logo"] = this.logo;
        data["siteTitle"] = this.siteTitle;
        data["favicon"] = this.favicon;
        data["description"] = this.description;
        data["addresses"] = this.addresses;
        data["phones"] = this.phones;
        data["emails"] = this.emails;
        data["apps"] = this.apps;
        data["socialMedia"] = this.socialMedia;
        data["rulesAndPrivacy"] = this.rulesAndPrivacy;
        data["pushNotification"] = this.pushNotification;
        data["constFlowerCrownId"] = this.constFlowerCrownId;
        data["constMoneyBoxId"] = this.constMoneyBoxId;
        data["constCharityPlanId"] = this.constCharityPlanId;
        data["constCharityAlmsPlanId"] = this.constCharityAlmsPlanId;
        data["scoreWalletCode"] = this.scoreWalletCode;
        data["moneyWalletCode"] = this.moneyWalletCode;
        data["operatorPhoneNo"] = this.operatorPhoneNo;
        data["minTaaminPension"] = this.minTaaminPension;
        data["themTemplateId"] = this.themTemplateId;
        data["currencyRef"] = this.currencyRef;
        data["branchRef"] = this.branchRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditGeneralSettingDto {
    logo: string | undefined;
    siteTitle: string | undefined;
    favicon: string | undefined;
    description: string | undefined;
    addresses: string | undefined;
    phones: string | undefined;
    emails: string | undefined;
    apps: string | undefined;
    socialMedia: string | undefined;
    rulesAndPrivacy: string | undefined;
    pushNotification: boolean;
    constFlowerCrownId: number | undefined;
    constMoneyBoxId: number | undefined;
    constCharityPlanId: number | undefined;
    constCharityAlmsPlanId: number | undefined;
    scoreWalletCode: string | undefined;
    moneyWalletCode: string | undefined;
    operatorPhoneNo: string | undefined;
    minTaaminPension: number | undefined;
    themTemplateId: number | undefined;
    currencyRef: number | undefined;
    branchRef: number | undefined;
    id: number | undefined;
}

export class GetGeneralSettingForEditOutput implements IGetGeneralSettingForEditOutput {
    generalSetting!: CreateOrEditGeneralSettingDto;
    themTemplateCode!: string | undefined;
    currencyName!: string | undefined;
    constFlowerCrownName!: string | undefined;
    constMoneyBoxName!: string | undefined;
    constCharityPlanName!: string | undefined;
    constCharityAlmsPlanName!: string | undefined;
    branchName!: string | undefined;

    constructor(data?: IGetGeneralSettingForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.generalSetting = data["generalSetting"] ? CreateOrEditGeneralSettingDto.fromJS(data["generalSetting"]) : <any>undefined;
            this.themTemplateCode = data["themTemplateCode"];
            this.currencyName = data["currencyName"];
            this.constFlowerCrownName = data["constFlowerCrownName"];
            this.constMoneyBoxName = data["constMoneyBoxName"];
            this.constCharityPlanName = data["constCharityPlanName"];
            this.constCharityAlmsPlanName = data["constCharityAlmsPlanName"];
            this.branchName = data["branchName"];
        }
    }

    static fromJS(data: any): GetGeneralSettingForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeneralSettingForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generalSetting"] = this.generalSetting ? this.generalSetting.toJSON() : <any>undefined;
        data["themTemplateCode"] = this.themTemplateCode;
        data["currencyName"] = this.currencyName;
        data["constFlowerCrownName"] = this.constFlowerCrownName;
        data["constMoneyBoxName"] = this.constMoneyBoxName;
        data["constCharityPlanName"] = this.constCharityPlanName;
        data["constCharityAlmsPlanName"] = this.constCharityAlmsPlanName;
        data["branchName"] = this.branchName;
        return data; 
    }
}

export interface IGetGeneralSettingForEditOutput {
    generalSetting: CreateOrEditGeneralSettingDto;
    themTemplateCode: string | undefined;
    currencyName: string | undefined;
    constFlowerCrownName: string | undefined;
    constMoneyBoxName: string | undefined;
    constCharityPlanName: string | undefined;
    constCharityAlmsPlanName: string | undefined;
    branchName: string | undefined;
}

export class ValuesDto implements IValuesDto {
    name!: string | undefined;
    url!: string | undefined;

    constructor(data?: IValuesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.url = data["url"];
        }
    }

    static fromJS(data: any): ValuesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValuesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["url"] = this.url;
        return data; 
    }
}

export interface IValuesDto {
    name: string | undefined;
    url: string | undefined;
}

export enum PathToWizard {
    Default = 0,
    DetailsPage = 1,
    DeceasedPage = 2,
}

export class CreateOrEditWizardStepDto implements ICreateOrEditWizardStepDto {
    planType!: Plans;
    steps!: string | undefined;
    wizardPath!: PathToWizard;
    id!: number | undefined;

    constructor(data?: ICreateOrEditWizardStepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.planType = data["planType"];
            this.steps = data["steps"];
            this.wizardPath = data["wizardPath"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditWizardStepDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditWizardStepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planType"] = this.planType;
        data["steps"] = this.steps;
        data["wizardPath"] = this.wizardPath;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditWizardStepDto {
    planType: Plans;
    steps: string | undefined;
    wizardPath: PathToWizard;
    id: number | undefined;
}

export enum AppSettingUserTypes {
    User = 0,
    Agent = 1,
}

export class CreateOrEditApplicationSettingDto implements ICreateOrEditApplicationSettingDto {
    ratio!: number;
    userType!: AppSettingUserTypes;

    constructor(data?: ICreateOrEditApplicationSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ratio = data["ratio"];
            this.userType = data["userType"];
        }
    }

    static fromJS(data: any): CreateOrEditApplicationSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditApplicationSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ratio"] = this.ratio;
        data["userType"] = this.userType;
        return data; 
    }
}

export interface ICreateOrEditApplicationSettingDto {
    ratio: number;
    userType: AppSettingUserTypes;
}

export class CreateOrEditApplicationServiceDto implements ICreateOrEditApplicationServiceDto {
    code!: string | undefined;
    serviceName!: string | undefined;
    title!: string | undefined;
    fixedScore!: number | undefined;
    variableScore!: number | undefined;
    maxScore!: number | undefined;
    expireDuration!: number | undefined;
    accountNumber!: number;

    constructor(data?: ICreateOrEditApplicationServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.serviceName = data["serviceName"];
            this.title = data["title"];
            this.fixedScore = data["fixedScore"];
            this.variableScore = data["variableScore"];
            this.maxScore = data["maxScore"];
            this.expireDuration = data["expireDuration"];
            this.accountNumber = data["accountNumber"];
        }
    }

    static fromJS(data: any): CreateOrEditApplicationServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditApplicationServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["serviceName"] = this.serviceName;
        data["title"] = this.title;
        data["fixedScore"] = this.fixedScore;
        data["variableScore"] = this.variableScore;
        data["maxScore"] = this.maxScore;
        data["expireDuration"] = this.expireDuration;
        data["accountNumber"] = this.accountNumber;
        return data; 
    }
}

export interface ICreateOrEditApplicationServiceDto {
    code: string | undefined;
    serviceName: string | undefined;
    title: string | undefined;
    fixedScore: number | undefined;
    variableScore: number | undefined;
    maxScore: number | undefined;
    expireDuration: number | undefined;
    accountNumber: number;
}

export class CreateOrEditApplicationServiceUsedDto implements ICreateOrEditApplicationServiceUsedDto {
    code!: string | undefined;
    serviceName!: string | undefined;
    title!: string | undefined;
    accountNumber!: number;

    constructor(data?: ICreateOrEditApplicationServiceUsedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.serviceName = data["serviceName"];
            this.title = data["title"];
            this.accountNumber = data["accountNumber"];
        }
    }

    static fromJS(data: any): CreateOrEditApplicationServiceUsedDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditApplicationServiceUsedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["serviceName"] = this.serviceName;
        data["title"] = this.title;
        data["accountNumber"] = this.accountNumber;
        return data; 
    }
}

export interface ICreateOrEditApplicationServiceUsedDto {
    code: string | undefined;
    serviceName: string | undefined;
    title: string | undefined;
    accountNumber: number;
}

export class ThirdPartyAppDto implements IThirdPartyAppDto {
    id!: number;
    title!: string | undefined;
    callBackUrl!: string | undefined;
    isEnabled!: boolean;

    constructor(data?: IThirdPartyAppDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.title = data["title"];
            this.callBackUrl = data["callBackUrl"];
            this.isEnabled = data["isEnabled"];
        }
    }

    static fromJS(data: any): ThirdPartyAppDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThirdPartyAppDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["callBackUrl"] = this.callBackUrl;
        data["isEnabled"] = this.isEnabled;
        return data; 
    }
}

export interface IThirdPartyAppDto {
    id: number;
    title: string | undefined;
    callBackUrl: string | undefined;
    isEnabled: boolean;
}

export class GetGeneralSettingByObjectForEditOutput implements IGetGeneralSettingByObjectForEditOutput {
    generalSetting!: CreateOrEditGeneralSettingDto;
    social!: ValuesDto[] | undefined;
    apps!: ValuesDto[] | undefined;
    wizardSteps!: CreateOrEditWizardStepDto[] | undefined;
    applicationSettings!: CreateOrEditApplicationSettingDto[] | undefined;
    walletApplicationServices!: CreateOrEditApplicationServiceDto[] | undefined;
    walletApplicationServicesUsed!: CreateOrEditApplicationServiceUsedDto[] | undefined;
    thirdPartyApps!: ThirdPartyAppDto[] | undefined;
    themTemplateCode!: string | undefined;
    currencyName!: string | undefined;
    constFlowerCrownName!: string | undefined;
    constMoneyBoxName!: string | undefined;
    constCharityPlanName!: string | undefined;
    constCharityAlmsPlanName!: string | undefined;
    branchName!: string | undefined;

    constructor(data?: IGetGeneralSettingByObjectForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.generalSetting = data["generalSetting"] ? CreateOrEditGeneralSettingDto.fromJS(data["generalSetting"]) : <any>undefined;
            if (Array.isArray(data["social"])) {
                this.social = [] as any;
                for (let item of data["social"])
                    this.social!.push(ValuesDto.fromJS(item));
            }
            if (Array.isArray(data["apps"])) {
                this.apps = [] as any;
                for (let item of data["apps"])
                    this.apps!.push(ValuesDto.fromJS(item));
            }
            if (Array.isArray(data["wizardSteps"])) {
                this.wizardSteps = [] as any;
                for (let item of data["wizardSteps"])
                    this.wizardSteps!.push(CreateOrEditWizardStepDto.fromJS(item));
            }
            if (Array.isArray(data["applicationSettings"])) {
                this.applicationSettings = [] as any;
                for (let item of data["applicationSettings"])
                    this.applicationSettings!.push(CreateOrEditApplicationSettingDto.fromJS(item));
            }
            if (Array.isArray(data["walletApplicationServices"])) {
                this.walletApplicationServices = [] as any;
                for (let item of data["walletApplicationServices"])
                    this.walletApplicationServices!.push(CreateOrEditApplicationServiceDto.fromJS(item));
            }
            if (Array.isArray(data["walletApplicationServicesUsed"])) {
                this.walletApplicationServicesUsed = [] as any;
                for (let item of data["walletApplicationServicesUsed"])
                    this.walletApplicationServicesUsed!.push(CreateOrEditApplicationServiceUsedDto.fromJS(item));
            }
            if (Array.isArray(data["thirdPartyApps"])) {
                this.thirdPartyApps = [] as any;
                for (let item of data["thirdPartyApps"])
                    this.thirdPartyApps!.push(ThirdPartyAppDto.fromJS(item));
            }
            this.themTemplateCode = data["themTemplateCode"];
            this.currencyName = data["currencyName"];
            this.constFlowerCrownName = data["constFlowerCrownName"];
            this.constMoneyBoxName = data["constMoneyBoxName"];
            this.constCharityPlanName = data["constCharityPlanName"];
            this.constCharityAlmsPlanName = data["constCharityAlmsPlanName"];
            this.branchName = data["branchName"];
        }
    }

    static fromJS(data: any): GetGeneralSettingByObjectForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeneralSettingByObjectForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generalSetting"] = this.generalSetting ? this.generalSetting.toJSON() : <any>undefined;
        if (Array.isArray(this.social)) {
            data["social"] = [];
            for (let item of this.social)
                data["social"].push(item.toJSON());
        }
        if (Array.isArray(this.apps)) {
            data["apps"] = [];
            for (let item of this.apps)
                data["apps"].push(item.toJSON());
        }
        if (Array.isArray(this.wizardSteps)) {
            data["wizardSteps"] = [];
            for (let item of this.wizardSteps)
                data["wizardSteps"].push(item.toJSON());
        }
        if (Array.isArray(this.applicationSettings)) {
            data["applicationSettings"] = [];
            for (let item of this.applicationSettings)
                data["applicationSettings"].push(item.toJSON());
        }
        if (Array.isArray(this.walletApplicationServices)) {
            data["walletApplicationServices"] = [];
            for (let item of this.walletApplicationServices)
                data["walletApplicationServices"].push(item.toJSON());
        }
        if (Array.isArray(this.walletApplicationServicesUsed)) {
            data["walletApplicationServicesUsed"] = [];
            for (let item of this.walletApplicationServicesUsed)
                data["walletApplicationServicesUsed"].push(item.toJSON());
        }
        if (Array.isArray(this.thirdPartyApps)) {
            data["thirdPartyApps"] = [];
            for (let item of this.thirdPartyApps)
                data["thirdPartyApps"].push(item.toJSON());
        }
        data["themTemplateCode"] = this.themTemplateCode;
        data["currencyName"] = this.currencyName;
        data["constFlowerCrownName"] = this.constFlowerCrownName;
        data["constMoneyBoxName"] = this.constMoneyBoxName;
        data["constCharityPlanName"] = this.constCharityPlanName;
        data["constCharityAlmsPlanName"] = this.constCharityAlmsPlanName;
        data["branchName"] = this.branchName;
        return data; 
    }
}

export interface IGetGeneralSettingByObjectForEditOutput {
    generalSetting: CreateOrEditGeneralSettingDto;
    social: ValuesDto[] | undefined;
    apps: ValuesDto[] | undefined;
    wizardSteps: CreateOrEditWizardStepDto[] | undefined;
    applicationSettings: CreateOrEditApplicationSettingDto[] | undefined;
    walletApplicationServices: CreateOrEditApplicationServiceDto[] | undefined;
    walletApplicationServicesUsed: CreateOrEditApplicationServiceUsedDto[] | undefined;
    thirdPartyApps: ThirdPartyAppDto[] | undefined;
    themTemplateCode: string | undefined;
    currencyName: string | undefined;
    constFlowerCrownName: string | undefined;
    constMoneyBoxName: string | undefined;
    constCharityPlanName: string | undefined;
    constCharityAlmsPlanName: string | undefined;
    branchName: string | undefined;
}

export class CreateOrEditGeneralSettingByObjectDto implements ICreateOrEditGeneralSettingByObjectDto {
    generalSettingsDto!: CreateOrEditGeneralSettingDto;
    social!: ValuesDto[] | undefined;
    apps!: ValuesDto[] | undefined;
    wizardSteps!: CreateOrEditWizardStepDto[] | undefined;
    walletApplicationSettings!: CreateOrEditApplicationSettingDto[] | undefined;
    walletApplicationServices!: CreateOrEditApplicationServiceDto[] | undefined;
    walletApplicationServicesUsed!: CreateOrEditApplicationServiceUsedDto[] | undefined;
    thirdPartyApps!: ThirdPartyAppDto[] | undefined;

    constructor(data?: ICreateOrEditGeneralSettingByObjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.generalSettingsDto = data["generalSettingsDto"] ? CreateOrEditGeneralSettingDto.fromJS(data["generalSettingsDto"]) : <any>undefined;
            if (Array.isArray(data["social"])) {
                this.social = [] as any;
                for (let item of data["social"])
                    this.social!.push(ValuesDto.fromJS(item));
            }
            if (Array.isArray(data["apps"])) {
                this.apps = [] as any;
                for (let item of data["apps"])
                    this.apps!.push(ValuesDto.fromJS(item));
            }
            if (Array.isArray(data["wizardSteps"])) {
                this.wizardSteps = [] as any;
                for (let item of data["wizardSteps"])
                    this.wizardSteps!.push(CreateOrEditWizardStepDto.fromJS(item));
            }
            if (Array.isArray(data["walletApplicationSettings"])) {
                this.walletApplicationSettings = [] as any;
                for (let item of data["walletApplicationSettings"])
                    this.walletApplicationSettings!.push(CreateOrEditApplicationSettingDto.fromJS(item));
            }
            if (Array.isArray(data["walletApplicationServices"])) {
                this.walletApplicationServices = [] as any;
                for (let item of data["walletApplicationServices"])
                    this.walletApplicationServices!.push(CreateOrEditApplicationServiceDto.fromJS(item));
            }
            if (Array.isArray(data["walletApplicationServicesUsed"])) {
                this.walletApplicationServicesUsed = [] as any;
                for (let item of data["walletApplicationServicesUsed"])
                    this.walletApplicationServicesUsed!.push(CreateOrEditApplicationServiceUsedDto.fromJS(item));
            }
            if (Array.isArray(data["thirdPartyApps"])) {
                this.thirdPartyApps = [] as any;
                for (let item of data["thirdPartyApps"])
                    this.thirdPartyApps!.push(ThirdPartyAppDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrEditGeneralSettingByObjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditGeneralSettingByObjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generalSettingsDto"] = this.generalSettingsDto ? this.generalSettingsDto.toJSON() : <any>undefined;
        if (Array.isArray(this.social)) {
            data["social"] = [];
            for (let item of this.social)
                data["social"].push(item.toJSON());
        }
        if (Array.isArray(this.apps)) {
            data["apps"] = [];
            for (let item of this.apps)
                data["apps"].push(item.toJSON());
        }
        if (Array.isArray(this.wizardSteps)) {
            data["wizardSteps"] = [];
            for (let item of this.wizardSteps)
                data["wizardSteps"].push(item.toJSON());
        }
        if (Array.isArray(this.walletApplicationSettings)) {
            data["walletApplicationSettings"] = [];
            for (let item of this.walletApplicationSettings)
                data["walletApplicationSettings"].push(item.toJSON());
        }
        if (Array.isArray(this.walletApplicationServices)) {
            data["walletApplicationServices"] = [];
            for (let item of this.walletApplicationServices)
                data["walletApplicationServices"].push(item.toJSON());
        }
        if (Array.isArray(this.walletApplicationServicesUsed)) {
            data["walletApplicationServicesUsed"] = [];
            for (let item of this.walletApplicationServicesUsed)
                data["walletApplicationServicesUsed"].push(item.toJSON());
        }
        if (Array.isArray(this.thirdPartyApps)) {
            data["thirdPartyApps"] = [];
            for (let item of this.thirdPartyApps)
                data["thirdPartyApps"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateOrEditGeneralSettingByObjectDto {
    generalSettingsDto: CreateOrEditGeneralSettingDto;
    social: ValuesDto[] | undefined;
    apps: ValuesDto[] | undefined;
    wizardSteps: CreateOrEditWizardStepDto[] | undefined;
    walletApplicationSettings: CreateOrEditApplicationSettingDto[] | undefined;
    walletApplicationServices: CreateOrEditApplicationServiceDto[] | undefined;
    walletApplicationServicesUsed: CreateOrEditApplicationServiceUsedDto[] | undefined;
    thirdPartyApps: ThirdPartyAppDto[] | undefined;
}

export class DeceasedPlan implements IDeceasedPlan {
    planId!: number;
    planType!: Plans;
    planCode!: string | undefined;

    constructor(data?: IDeceasedPlan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.planId = data["planId"];
            this.planType = data["planType"];
            this.planCode = data["planCode"];
        }
    }

    static fromJS(data: any): DeceasedPlan {
        data = typeof data === 'object' ? data : {};
        let result = new DeceasedPlan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planId"] = this.planId;
        data["planType"] = this.planType;
        data["planCode"] = this.planCode;
        return data; 
    }
}

export interface IDeceasedPlan {
    planId: number;
    planType: Plans;
    planCode: string | undefined;
}

export class ShopCurrency implements IShopCurrency {
    name!: string | undefined;
    id!: number | undefined;

    constructor(data?: IShopCurrency) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ShopCurrency {
        data = typeof data === 'object' ? data : {};
        let result = new ShopCurrency();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }
}

export interface IShopCurrency {
    name: string | undefined;
    id: number | undefined;
}

export class GetGeneralSettingsForShopDto implements IGetGeneralSettingsForShopDto {
    logo!: string | undefined;
    title!: string | undefined;
    favicon!: string | undefined;
    description!: string | undefined;
    deceasedPlan!: DeceasedPlan;
    charityPlan!: DeceasedPlan;
    charityAlmsPlan!: DeceasedPlan;
    addresses!: string[] | undefined;
    phones!: string[] | undefined;
    emails!: string[] | undefined;
    rluesAndPrivacy!: string | undefined;
    currency!: ShopCurrency;
    social!: ValuesDto[] | undefined;
    apps!: ValuesDto[] | undefined;
    templateCode!: string | undefined;
    pushNotification!: boolean;

    constructor(data?: IGetGeneralSettingsForShopDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.logo = data["logo"];
            this.title = data["title"];
            this.favicon = data["favicon"];
            this.description = data["description"];
            this.deceasedPlan = data["deceasedPlan"] ? DeceasedPlan.fromJS(data["deceasedPlan"]) : <any>undefined;
            this.charityPlan = data["charityPlan"] ? DeceasedPlan.fromJS(data["charityPlan"]) : <any>undefined;
            this.charityAlmsPlan = data["charityAlmsPlan"] ? DeceasedPlan.fromJS(data["charityAlmsPlan"]) : <any>undefined;
            if (Array.isArray(data["addresses"])) {
                this.addresses = [] as any;
                for (let item of data["addresses"])
                    this.addresses!.push(item);
            }
            if (Array.isArray(data["phones"])) {
                this.phones = [] as any;
                for (let item of data["phones"])
                    this.phones!.push(item);
            }
            if (Array.isArray(data["emails"])) {
                this.emails = [] as any;
                for (let item of data["emails"])
                    this.emails!.push(item);
            }
            this.rluesAndPrivacy = data["rluesAndPrivacy"];
            this.currency = data["currency"] ? ShopCurrency.fromJS(data["currency"]) : <any>undefined;
            if (Array.isArray(data["social"])) {
                this.social = [] as any;
                for (let item of data["social"])
                    this.social!.push(ValuesDto.fromJS(item));
            }
            if (Array.isArray(data["apps"])) {
                this.apps = [] as any;
                for (let item of data["apps"])
                    this.apps!.push(ValuesDto.fromJS(item));
            }
            this.templateCode = data["templateCode"];
            this.pushNotification = data["pushNotification"];
        }
    }

    static fromJS(data: any): GetGeneralSettingsForShopDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeneralSettingsForShopDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logo"] = this.logo;
        data["title"] = this.title;
        data["favicon"] = this.favicon;
        data["description"] = this.description;
        data["deceasedPlan"] = this.deceasedPlan ? this.deceasedPlan.toJSON() : <any>undefined;
        data["charityPlan"] = this.charityPlan ? this.charityPlan.toJSON() : <any>undefined;
        data["charityAlmsPlan"] = this.charityAlmsPlan ? this.charityAlmsPlan.toJSON() : <any>undefined;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item);
        }
        if (Array.isArray(this.phones)) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item);
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        data["rluesAndPrivacy"] = this.rluesAndPrivacy;
        data["currency"] = this.currency ? this.currency.toJSON() : <any>undefined;
        if (Array.isArray(this.social)) {
            data["social"] = [];
            for (let item of this.social)
                data["social"].push(item.toJSON());
        }
        if (Array.isArray(this.apps)) {
            data["apps"] = [];
            for (let item of this.apps)
                data["apps"].push(item.toJSON());
        }
        data["templateCode"] = this.templateCode;
        data["pushNotification"] = this.pushNotification;
        return data; 
    }
}

export interface IGetGeneralSettingsForShopDto {
    logo: string | undefined;
    title: string | undefined;
    favicon: string | undefined;
    description: string | undefined;
    deceasedPlan: DeceasedPlan;
    charityPlan: DeceasedPlan;
    charityAlmsPlan: DeceasedPlan;
    addresses: string[] | undefined;
    phones: string[] | undefined;
    emails: string[] | undefined;
    rluesAndPrivacy: string | undefined;
    currency: ShopCurrency;
    social: ValuesDto[] | undefined;
    apps: ValuesDto[] | undefined;
    templateCode: string | undefined;
    pushNotification: boolean;
}

export class GeneralSettingThemTemplateLookupTableDto implements IGeneralSettingThemTemplateLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IGeneralSettingThemTemplateLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): GeneralSettingThemTemplateLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralSettingThemTemplateLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IGeneralSettingThemTemplateLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class GeneralSettingCurrencyLookupTableDto implements IGeneralSettingCurrencyLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IGeneralSettingCurrencyLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): GeneralSettingCurrencyLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralSettingCurrencyLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IGeneralSettingCurrencyLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class GeneralSettingBranchLookupTableDto implements IGeneralSettingBranchLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IGeneralSettingBranchLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): GeneralSettingBranchLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralSettingBranchLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IGeneralSettingBranchLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class GetProviderAccountsRequestDto implements IGetProviderAccountsRequestDto {

    constructor(data?: IGetProviderAccountsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
    }

    static fromJS(data: any): GetProviderAccountsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetProviderAccountsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }
}

export interface IGetProviderAccountsRequestDto {
}

export class GetProviderAccountsResponseDto implements IGetProviderAccountsResponseDto {
    id!: number;
    providerName!: string | undefined;

    constructor(data?: IGetProviderAccountsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.providerName = data["providerName"];
        }
    }

    static fromJS(data: any): GetProviderAccountsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetProviderAccountsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["providerName"] = this.providerName;
        return data; 
    }
}

export interface IGetProviderAccountsResponseDto {
    id: number;
    providerName: string | undefined;
}

export class GetApplicationServiceTypesResponseDto implements IGetApplicationServiceTypesResponseDto {
    displayName!: string | undefined;
    code!: string | undefined;

    constructor(data?: IGetApplicationServiceTypesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.displayName = data["displayName"];
            this.code = data["code"];
        }
    }

    static fromJS(data: any): GetApplicationServiceTypesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetApplicationServiceTypesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["code"] = this.code;
        return data; 
    }
}

export interface IGetApplicationServiceTypesResponseDto {
    displayName: string | undefined;
    code: string | undefined;
}

export class PagedResultDtoOfGetApplicationServiceTypesResponseDto implements IPagedResultDtoOfGetApplicationServiceTypesResponseDto {
    totalCount!: number;
    items!: GetApplicationServiceTypesResponseDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetApplicationServiceTypesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetApplicationServiceTypesResponseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetApplicationServiceTypesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetApplicationServiceTypesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetApplicationServiceTypesResponseDto {
    totalCount: number;
    items: GetApplicationServiceTypesResponseDto[] | undefined;
}

export class GroupSubgroupDto implements IGroupSubgroupDto {
    title!: string | undefined;
    entity!: Entities;
    accessList!: string | undefined;
    code!: string | undefined;
    parentRef!: number | undefined;
    id!: number;

    constructor(data?: IGroupSubgroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.entity = data["entity"];
            this.accessList = data["accessList"];
            this.code = data["code"];
            this.parentRef = data["parentRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GroupSubgroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupSubgroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["entity"] = this.entity;
        data["accessList"] = this.accessList;
        data["code"] = this.code;
        data["parentRef"] = this.parentRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface IGroupSubgroupDto {
    title: string | undefined;
    entity: Entities;
    accessList: string | undefined;
    code: string | undefined;
    parentRef: number | undefined;
    id: number;
}

export class GetGroupSubgroupForViewDto implements IGetGroupSubgroupForViewDto {
    groupSubgroup!: GroupSubgroupDto;
    groupSubgroupTitle!: string | undefined;

    constructor(data?: IGetGroupSubgroupForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.groupSubgroup = data["groupSubgroup"] ? GroupSubgroupDto.fromJS(data["groupSubgroup"]) : <any>undefined;
            this.groupSubgroupTitle = data["groupSubgroupTitle"];
        }
    }

    static fromJS(data: any): GetGroupSubgroupForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGroupSubgroupForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupSubgroup"] = this.groupSubgroup ? this.groupSubgroup.toJSON() : <any>undefined;
        data["groupSubgroupTitle"] = this.groupSubgroupTitle;
        return data; 
    }
}

export interface IGetGroupSubgroupForViewDto {
    groupSubgroup: GroupSubgroupDto;
    groupSubgroupTitle: string | undefined;
}

export class PagedResultDtoOfGetGroupSubgroupForViewDto implements IPagedResultDtoOfGetGroupSubgroupForViewDto {
    totalCount!: number;
    items!: GetGroupSubgroupForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetGroupSubgroupForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetGroupSubgroupForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetGroupSubgroupForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetGroupSubgroupForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetGroupSubgroupForViewDto {
    totalCount: number;
    items: GetGroupSubgroupForViewDto[] | undefined;
}

export class CreateOrEditGroupSubgroupDto implements ICreateOrEditGroupSubgroupDto {
    title!: string | undefined;
    entity!: Entities;
    accessList!: string | undefined;
    code!: string | undefined;
    parentRef!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditGroupSubgroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.entity = data["entity"];
            this.accessList = data["accessList"];
            this.code = data["code"];
            this.parentRef = data["parentRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditGroupSubgroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditGroupSubgroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["entity"] = this.entity;
        data["accessList"] = this.accessList;
        data["code"] = this.code;
        data["parentRef"] = this.parentRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditGroupSubgroupDto {
    title: string | undefined;
    entity: Entities;
    accessList: string | undefined;
    code: string | undefined;
    parentRef: number | undefined;
    id: number | undefined;
}

export class GetGroupSubgroupForEditOutput implements IGetGroupSubgroupForEditOutput {
    groupSubgroup!: CreateOrEditGroupSubgroupDto;
    groupSubgroupTitle!: string | undefined;

    constructor(data?: IGetGroupSubgroupForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.groupSubgroup = data["groupSubgroup"] ? CreateOrEditGroupSubgroupDto.fromJS(data["groupSubgroup"]) : <any>undefined;
            this.groupSubgroupTitle = data["groupSubgroupTitle"];
        }
    }

    static fromJS(data: any): GetGroupSubgroupForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGroupSubgroupForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupSubgroup"] = this.groupSubgroup ? this.groupSubgroup.toJSON() : <any>undefined;
        data["groupSubgroupTitle"] = this.groupSubgroupTitle;
        return data; 
    }
}

export interface IGetGroupSubgroupForEditOutput {
    groupSubgroup: CreateOrEditGroupSubgroupDto;
    groupSubgroupTitle: string | undefined;
}

export class GroupSubgroupGroupSubgroupLookupTableDto implements IGroupSubgroupGroupSubgroupLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IGroupSubgroupGroupSubgroupLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): GroupSubgroupGroupSubgroupLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupSubgroupGroupSubgroupLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IGroupSubgroupGroupSubgroupLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfGroupSubgroupGroupSubgroupLookupTableDto implements IPagedResultDtoOfGroupSubgroupGroupSubgroupLookupTableDto {
    totalCount!: number;
    items!: GroupSubgroupGroupSubgroupLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGroupSubgroupGroupSubgroupLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GroupSubgroupGroupSubgroupLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGroupSubgroupGroupSubgroupLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGroupSubgroupGroupSubgroupLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGroupSubgroupGroupSubgroupLookupTableDto {
    totalCount: number;
    items: GroupSubgroupGroupSubgroupLookupTableDto[] | undefined;
}

export class HealthStatusDto implements IHealthStatusDto {
    title!: string | undefined;
    description!: string | undefined;
    state!: boolean;
    id!: number;

    constructor(data?: IHealthStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.description = data["description"];
            this.state = data["state"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): HealthStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["state"] = this.state;
        data["id"] = this.id;
        return data; 
    }
}

export interface IHealthStatusDto {
    title: string | undefined;
    description: string | undefined;
    state: boolean;
    id: number;
}

export class GetHealthStatusForViewDto implements IGetHealthStatusForViewDto {
    healthStatus!: HealthStatusDto;

    constructor(data?: IGetHealthStatusForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.healthStatus = data["healthStatus"] ? HealthStatusDto.fromJS(data["healthStatus"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetHealthStatusForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetHealthStatusForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthStatus"] = this.healthStatus ? this.healthStatus.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetHealthStatusForViewDto {
    healthStatus: HealthStatusDto;
}

export class PagedResultDtoOfGetHealthStatusForViewDto implements IPagedResultDtoOfGetHealthStatusForViewDto {
    totalCount!: number;
    items!: GetHealthStatusForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetHealthStatusForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetHealthStatusForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetHealthStatusForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetHealthStatusForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetHealthStatusForViewDto {
    totalCount: number;
    items: GetHealthStatusForViewDto[] | undefined;
}

export class CreateOrEditHealthStatusDto implements ICreateOrEditHealthStatusDto {
    title!: string | undefined;
    description!: string | undefined;
    state!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditHealthStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.description = data["description"];
            this.state = data["state"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditHealthStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditHealthStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["state"] = this.state;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditHealthStatusDto {
    title: string | undefined;
    description: string | undefined;
    state: boolean;
    id: number | undefined;
}

export class GetHealthStatusForEditOutput implements IGetHealthStatusForEditOutput {
    healthStatus!: CreateOrEditHealthStatusDto;

    constructor(data?: IGetHealthStatusForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.healthStatus = data["healthStatus"] ? CreateOrEditHealthStatusDto.fromJS(data["healthStatus"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetHealthStatusForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetHealthStatusForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthStatus"] = this.healthStatus ? this.healthStatus.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetHealthStatusForEditOutput {
    healthStatus: CreateOrEditHealthStatusDto;
}

export class TopStatsData implements ITopStatsData {
    newTenantsCount!: number;
    newSubscriptionAmount!: number;
    dashboardPlaceholder1!: number;
    dashboardPlaceholder2!: number;

    constructor(data?: ITopStatsData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.newTenantsCount = data["newTenantsCount"];
            this.newSubscriptionAmount = data["newSubscriptionAmount"];
            this.dashboardPlaceholder1 = data["dashboardPlaceholder1"];
            this.dashboardPlaceholder2 = data["dashboardPlaceholder2"];
        }
    }

    static fromJS(data: any): TopStatsData {
        data = typeof data === 'object' ? data : {};
        let result = new TopStatsData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newTenantsCount"] = this.newTenantsCount;
        data["newSubscriptionAmount"] = this.newSubscriptionAmount;
        data["dashboardPlaceholder1"] = this.dashboardPlaceholder1;
        data["dashboardPlaceholder2"] = this.dashboardPlaceholder2;
        return data; 
    }
}

export interface ITopStatsData {
    newTenantsCount: number;
    newSubscriptionAmount: number;
    dashboardPlaceholder1: number;
    dashboardPlaceholder2: number;
}

export class RecentTenant implements IRecentTenant {
    id!: number;
    name!: string | undefined;
    creationTime!: moment.Moment;

    constructor(data?: IRecentTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RecentTenant {
        data = typeof data === 'object' ? data : {};
        let result = new RecentTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IRecentTenant {
    id: number;
    name: string | undefined;
    creationTime: moment.Moment;
}

export class GetRecentTenantsOutput implements IGetRecentTenantsOutput {
    recentTenants!: RecentTenant[] | undefined;
    recentTenantsDayCount!: number;
    maxRecentTenantsShownCount!: number;
    tenantCreationStartDate!: moment.Moment;

    constructor(data?: IGetRecentTenantsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["recentTenants"])) {
                this.recentTenants = [] as any;
                for (let item of data["recentTenants"])
                    this.recentTenants!.push(RecentTenant.fromJS(item));
            }
            this.recentTenantsDayCount = data["recentTenantsDayCount"];
            this.maxRecentTenantsShownCount = data["maxRecentTenantsShownCount"];
            this.tenantCreationStartDate = data["tenantCreationStartDate"] ? moment(data["tenantCreationStartDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRecentTenantsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecentTenantsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.recentTenants)) {
            data["recentTenants"] = [];
            for (let item of this.recentTenants)
                data["recentTenants"].push(item.toJSON());
        }
        data["recentTenantsDayCount"] = this.recentTenantsDayCount;
        data["maxRecentTenantsShownCount"] = this.maxRecentTenantsShownCount;
        data["tenantCreationStartDate"] = this.tenantCreationStartDate ? this.tenantCreationStartDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGetRecentTenantsOutput {
    recentTenants: RecentTenant[] | undefined;
    recentTenantsDayCount: number;
    maxRecentTenantsShownCount: number;
    tenantCreationStartDate: moment.Moment;
}

export class ExpiringTenant implements IExpiringTenant {
    tenantName!: string | undefined;
    remainingDayCount!: number;

    constructor(data?: IExpiringTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantName = data["tenantName"];
            this.remainingDayCount = data["remainingDayCount"];
        }
    }

    static fromJS(data: any): ExpiringTenant {
        data = typeof data === 'object' ? data : {};
        let result = new ExpiringTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["remainingDayCount"] = this.remainingDayCount;
        return data; 
    }
}

export interface IExpiringTenant {
    tenantName: string | undefined;
    remainingDayCount: number;
}

export class GetExpiringTenantsOutput implements IGetExpiringTenantsOutput {
    expiringTenants!: ExpiringTenant[] | undefined;
    subscriptionEndAlertDayCount!: number;
    maxExpiringTenantsShownCount!: number;
    subscriptionEndDateStart!: moment.Moment;
    subscriptionEndDateEnd!: moment.Moment;

    constructor(data?: IGetExpiringTenantsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["expiringTenants"])) {
                this.expiringTenants = [] as any;
                for (let item of data["expiringTenants"])
                    this.expiringTenants!.push(ExpiringTenant.fromJS(item));
            }
            this.subscriptionEndAlertDayCount = data["subscriptionEndAlertDayCount"];
            this.maxExpiringTenantsShownCount = data["maxExpiringTenantsShownCount"];
            this.subscriptionEndDateStart = data["subscriptionEndDateStart"] ? moment(data["subscriptionEndDateStart"].toString()) : <any>undefined;
            this.subscriptionEndDateEnd = data["subscriptionEndDateEnd"] ? moment(data["subscriptionEndDateEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetExpiringTenantsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetExpiringTenantsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.expiringTenants)) {
            data["expiringTenants"] = [];
            for (let item of this.expiringTenants)
                data["expiringTenants"].push(item.toJSON());
        }
        data["subscriptionEndAlertDayCount"] = this.subscriptionEndAlertDayCount;
        data["maxExpiringTenantsShownCount"] = this.maxExpiringTenantsShownCount;
        data["subscriptionEndDateStart"] = this.subscriptionEndDateStart ? this.subscriptionEndDateStart.toISOString() : <any>undefined;
        data["subscriptionEndDateEnd"] = this.subscriptionEndDateEnd ? this.subscriptionEndDateEnd.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGetExpiringTenantsOutput {
    expiringTenants: ExpiringTenant[] | undefined;
    subscriptionEndAlertDayCount: number;
    maxExpiringTenantsShownCount: number;
    subscriptionEndDateStart: moment.Moment;
    subscriptionEndDateEnd: moment.Moment;
}

export enum ChartDateInterval {
    Daily = 1,
    Weekly = 2,
    Monthly = 3,
}

export class IncomeStastistic implements IIncomeStastistic {
    label!: string | undefined;
    date!: moment.Moment;
    amount!: number;

    constructor(data?: IIncomeStastistic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.label = data["label"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.amount = data["amount"];
        }
    }

    static fromJS(data: any): IncomeStastistic {
        data = typeof data === 'object' ? data : {};
        let result = new IncomeStastistic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        return data; 
    }
}

export interface IIncomeStastistic {
    label: string | undefined;
    date: moment.Moment;
    amount: number;
}

export class GetIncomeStatisticsDataOutput implements IGetIncomeStatisticsDataOutput {
    incomeStatistics!: IncomeStastistic[] | undefined;

    constructor(data?: IGetIncomeStatisticsDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["incomeStatistics"])) {
                this.incomeStatistics = [] as any;
                for (let item of data["incomeStatistics"])
                    this.incomeStatistics!.push(IncomeStastistic.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetIncomeStatisticsDataOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetIncomeStatisticsDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.incomeStatistics)) {
            data["incomeStatistics"] = [];
            for (let item of this.incomeStatistics)
                data["incomeStatistics"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetIncomeStatisticsDataOutput {
    incomeStatistics: IncomeStastistic[] | undefined;
}

export class TenantEdition implements ITenantEdition {
    label!: string | undefined;
    value!: number;

    constructor(data?: ITenantEdition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.label = data["label"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): TenantEdition {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEdition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        return data; 
    }
}

export interface ITenantEdition {
    label: string | undefined;
    value: number;
}

export class GetEditionTenantStatisticsOutput implements IGetEditionTenantStatisticsOutput {
    editionStatistics!: TenantEdition[] | undefined;

    constructor(data?: IGetEditionTenantStatisticsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["editionStatistics"])) {
                this.editionStatistics = [] as any;
                for (let item of data["editionStatistics"])
                    this.editionStatistics!.push(TenantEdition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEditionTenantStatisticsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEditionTenantStatisticsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.editionStatistics)) {
            data["editionStatistics"] = [];
            for (let item of this.editionStatistics)
                data["editionStatistics"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetEditionTenantStatisticsOutput {
    editionStatistics: TenantEdition[] | undefined;
}

export class GetTenantPlanInfoDto implements IGetTenantPlanInfoDto {
    serviceCount!: number;
    flowerCrownCount!: number;

    constructor(data?: IGetTenantPlanInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serviceCount = data["serviceCount"];
            this.flowerCrownCount = data["flowerCrownCount"];
        }
    }

    static fromJS(data: any): GetTenantPlanInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTenantPlanInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceCount"] = this.serviceCount;
        data["flowerCrownCount"] = this.flowerCrownCount;
        return data; 
    }
}

export interface IGetTenantPlanInfoDto {
    serviceCount: number;
    flowerCrownCount: number;
}

export class GeneralSettingsEditDto implements IGeneralSettingsEditDto {
    timezone!: string | undefined;
    timezoneForComparison!: string | undefined;

    constructor(data?: IGeneralSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.timezone = data["timezone"];
            this.timezoneForComparison = data["timezoneForComparison"];
        }
    }

    static fromJS(data: any): GeneralSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timezone"] = this.timezone;
        data["timezoneForComparison"] = this.timezoneForComparison;
        return data; 
    }
}

export interface IGeneralSettingsEditDto {
    timezone: string | undefined;
    timezoneForComparison: string | undefined;
}

export class SessionTimeOutSettingsEditDto implements ISessionTimeOutSettingsEditDto {
    isEnabled!: boolean;
    timeOutSecond!: number;
    showTimeOutNotificationSecond!: number;

    constructor(data?: ISessionTimeOutSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isEnabled = data["isEnabled"];
            this.timeOutSecond = data["timeOutSecond"];
            this.showTimeOutNotificationSecond = data["showTimeOutNotificationSecond"];
        }
    }

    static fromJS(data: any): SessionTimeOutSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SessionTimeOutSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["timeOutSecond"] = this.timeOutSecond;
        data["showTimeOutNotificationSecond"] = this.showTimeOutNotificationSecond;
        return data; 
    }
}

export interface ISessionTimeOutSettingsEditDto {
    isEnabled: boolean;
    timeOutSecond: number;
    showTimeOutNotificationSecond: number;
}

export class HostUserManagementSettingsEditDto implements IHostUserManagementSettingsEditDto {
    isEmailConfirmationRequiredForLogin!: boolean;
    smsVerificationEnabled!: boolean;
    isCookieConsentEnabled!: boolean;
    isQuickThemeSelectEnabled!: boolean;
    useCaptchaOnLogin!: boolean;
    sessionTimeOutSettings!: SessionTimeOutSettingsEditDto;

    constructor(data?: IHostUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isEmailConfirmationRequiredForLogin = data["isEmailConfirmationRequiredForLogin"];
            this.smsVerificationEnabled = data["smsVerificationEnabled"];
            this.isCookieConsentEnabled = data["isCookieConsentEnabled"];
            this.isQuickThemeSelectEnabled = data["isQuickThemeSelectEnabled"];
            this.useCaptchaOnLogin = data["useCaptchaOnLogin"];
            this.sessionTimeOutSettings = data["sessionTimeOutSettings"] ? SessionTimeOutSettingsEditDto.fromJS(data["sessionTimeOutSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HostUserManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostUserManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["smsVerificationEnabled"] = this.smsVerificationEnabled;
        data["isCookieConsentEnabled"] = this.isCookieConsentEnabled;
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        data["useCaptchaOnLogin"] = this.useCaptchaOnLogin;
        data["sessionTimeOutSettings"] = this.sessionTimeOutSettings ? this.sessionTimeOutSettings.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IHostUserManagementSettingsEditDto {
    isEmailConfirmationRequiredForLogin: boolean;
    smsVerificationEnabled: boolean;
    isCookieConsentEnabled: boolean;
    isQuickThemeSelectEnabled: boolean;
    useCaptchaOnLogin: boolean;
    sessionTimeOutSettings: SessionTimeOutSettingsEditDto;
}

export class EmailSettingsEditDto implements IEmailSettingsEditDto {
    defaultFromAddress!: string | undefined;
    defaultFromDisplayName!: string | undefined;
    smtpHost!: string | undefined;
    smtpPort!: number;
    smtpUserName!: string | undefined;
    smtpPassword!: string | undefined;
    smtpDomain!: string | undefined;
    smtpEnableSsl!: boolean;
    smtpUseDefaultCredentials!: boolean;

    constructor(data?: IEmailSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.defaultFromAddress = data["defaultFromAddress"];
            this.defaultFromDisplayName = data["defaultFromDisplayName"];
            this.smtpHost = data["smtpHost"];
            this.smtpPort = data["smtpPort"];
            this.smtpUserName = data["smtpUserName"];
            this.smtpPassword = data["smtpPassword"];
            this.smtpDomain = data["smtpDomain"];
            this.smtpEnableSsl = data["smtpEnableSsl"];
            this.smtpUseDefaultCredentials = data["smtpUseDefaultCredentials"];
        }
    }

    static fromJS(data: any): EmailSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultFromAddress"] = this.defaultFromAddress;
        data["defaultFromDisplayName"] = this.defaultFromDisplayName;
        data["smtpHost"] = this.smtpHost;
        data["smtpPort"] = this.smtpPort;
        data["smtpUserName"] = this.smtpUserName;
        data["smtpPassword"] = this.smtpPassword;
        data["smtpDomain"] = this.smtpDomain;
        data["smtpEnableSsl"] = this.smtpEnableSsl;
        data["smtpUseDefaultCredentials"] = this.smtpUseDefaultCredentials;
        return data; 
    }
}

export interface IEmailSettingsEditDto {
    defaultFromAddress: string | undefined;
    defaultFromDisplayName: string | undefined;
    smtpHost: string | undefined;
    smtpPort: number;
    smtpUserName: string | undefined;
    smtpPassword: string | undefined;
    smtpDomain: string | undefined;
    smtpEnableSsl: boolean;
    smtpUseDefaultCredentials: boolean;
}

export class TenantManagementSettingsEditDto implements ITenantManagementSettingsEditDto {
    allowSelfRegistration!: boolean;
    isNewRegisteredTenantActiveByDefault!: boolean;
    useCaptchaOnRegistration!: boolean;
    defaultEditionId!: number | undefined;

    constructor(data?: ITenantManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allowSelfRegistration = data["allowSelfRegistration"];
            this.isNewRegisteredTenantActiveByDefault = data["isNewRegisteredTenantActiveByDefault"];
            this.useCaptchaOnRegistration = data["useCaptchaOnRegistration"];
            this.defaultEditionId = data["defaultEditionId"];
        }
    }

    static fromJS(data: any): TenantManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredTenantActiveByDefault"] = this.isNewRegisteredTenantActiveByDefault;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        data["defaultEditionId"] = this.defaultEditionId;
        return data; 
    }
}

export interface ITenantManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredTenantActiveByDefault: boolean;
    useCaptchaOnRegistration: boolean;
    defaultEditionId: number | undefined;
}

export class PasswordComplexitySetting implements IPasswordComplexitySetting {
    requireDigit!: boolean;
    requireLowercase!: boolean;
    requireNonAlphanumeric!: boolean;
    requireUppercase!: boolean;
    requiredLength!: number;

    constructor(data?: IPasswordComplexitySetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.requireDigit = data["requireDigit"];
            this.requireLowercase = data["requireLowercase"];
            this.requireNonAlphanumeric = data["requireNonAlphanumeric"];
            this.requireUppercase = data["requireUppercase"];
            this.requiredLength = data["requiredLength"];
        }
    }

    static fromJS(data: any): PasswordComplexitySetting {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordComplexitySetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requireDigit"] = this.requireDigit;
        data["requireLowercase"] = this.requireLowercase;
        data["requireNonAlphanumeric"] = this.requireNonAlphanumeric;
        data["requireUppercase"] = this.requireUppercase;
        data["requiredLength"] = this.requiredLength;
        return data; 
    }
}

export interface IPasswordComplexitySetting {
    requireDigit: boolean;
    requireLowercase: boolean;
    requireNonAlphanumeric: boolean;
    requireUppercase: boolean;
    requiredLength: number;
}

export class UserLockOutSettingsEditDto implements IUserLockOutSettingsEditDto {
    isEnabled!: boolean;
    maxFailedAccessAttemptsBeforeLockout!: number;
    defaultAccountLockoutSeconds!: number;

    constructor(data?: IUserLockOutSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isEnabled = data["isEnabled"];
            this.maxFailedAccessAttemptsBeforeLockout = data["maxFailedAccessAttemptsBeforeLockout"];
            this.defaultAccountLockoutSeconds = data["defaultAccountLockoutSeconds"];
        }
    }

    static fromJS(data: any): UserLockOutSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLockOutSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["maxFailedAccessAttemptsBeforeLockout"] = this.maxFailedAccessAttemptsBeforeLockout;
        data["defaultAccountLockoutSeconds"] = this.defaultAccountLockoutSeconds;
        return data; 
    }
}

export interface IUserLockOutSettingsEditDto {
    isEnabled: boolean;
    maxFailedAccessAttemptsBeforeLockout: number;
    defaultAccountLockoutSeconds: number;
}

export class TwoFactorLoginSettingsEditDto implements ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication!: boolean;
    isEnabled!: boolean;
    isEmailProviderEnabled!: boolean;
    isSmsProviderEnabled!: boolean;
    isRememberBrowserEnabled!: boolean;
    isGoogleAuthenticatorEnabled!: boolean;

    constructor(data?: ITwoFactorLoginSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isEnabledForApplication = data["isEnabledForApplication"];
            this.isEnabled = data["isEnabled"];
            this.isEmailProviderEnabled = data["isEmailProviderEnabled"];
            this.isSmsProviderEnabled = data["isSmsProviderEnabled"];
            this.isRememberBrowserEnabled = data["isRememberBrowserEnabled"];
            this.isGoogleAuthenticatorEnabled = data["isGoogleAuthenticatorEnabled"];
        }
    }

    static fromJS(data: any): TwoFactorLoginSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TwoFactorLoginSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabledForApplication"] = this.isEnabledForApplication;
        data["isEnabled"] = this.isEnabled;
        data["isEmailProviderEnabled"] = this.isEmailProviderEnabled;
        data["isSmsProviderEnabled"] = this.isSmsProviderEnabled;
        data["isRememberBrowserEnabled"] = this.isRememberBrowserEnabled;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data; 
    }
}

export interface ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication: boolean;
    isEnabled: boolean;
    isEmailProviderEnabled: boolean;
    isSmsProviderEnabled: boolean;
    isRememberBrowserEnabled: boolean;
    isGoogleAuthenticatorEnabled: boolean;
}

export class SecuritySettingsEditDto implements ISecuritySettingsEditDto {
    allowOneConcurrentLoginPerUser!: boolean;
    useDefaultPasswordComplexitySettings!: boolean;
    passwordComplexity!: PasswordComplexitySetting;
    defaultPasswordComplexity!: PasswordComplexitySetting;
    userLockOut!: UserLockOutSettingsEditDto;
    twoFactorLogin!: TwoFactorLoginSettingsEditDto;

    constructor(data?: ISecuritySettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allowOneConcurrentLoginPerUser = data["allowOneConcurrentLoginPerUser"];
            this.useDefaultPasswordComplexitySettings = data["useDefaultPasswordComplexitySettings"];
            this.passwordComplexity = data["passwordComplexity"] ? PasswordComplexitySetting.fromJS(data["passwordComplexity"]) : <any>undefined;
            this.defaultPasswordComplexity = data["defaultPasswordComplexity"] ? PasswordComplexitySetting.fromJS(data["defaultPasswordComplexity"]) : <any>undefined;
            this.userLockOut = data["userLockOut"] ? UserLockOutSettingsEditDto.fromJS(data["userLockOut"]) : <any>undefined;
            this.twoFactorLogin = data["twoFactorLogin"] ? TwoFactorLoginSettingsEditDto.fromJS(data["twoFactorLogin"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SecuritySettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecuritySettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowOneConcurrentLoginPerUser"] = this.allowOneConcurrentLoginPerUser;
        data["useDefaultPasswordComplexitySettings"] = this.useDefaultPasswordComplexitySettings;
        data["passwordComplexity"] = this.passwordComplexity ? this.passwordComplexity.toJSON() : <any>undefined;
        data["defaultPasswordComplexity"] = this.defaultPasswordComplexity ? this.defaultPasswordComplexity.toJSON() : <any>undefined;
        data["userLockOut"] = this.userLockOut ? this.userLockOut.toJSON() : <any>undefined;
        data["twoFactorLogin"] = this.twoFactorLogin ? this.twoFactorLogin.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ISecuritySettingsEditDto {
    allowOneConcurrentLoginPerUser: boolean;
    useDefaultPasswordComplexitySettings: boolean;
    passwordComplexity: PasswordComplexitySetting;
    defaultPasswordComplexity: PasswordComplexitySetting;
    userLockOut: UserLockOutSettingsEditDto;
    twoFactorLogin: TwoFactorLoginSettingsEditDto;
}

export class HostBillingSettingsEditDto implements IHostBillingSettingsEditDto {
    legalName!: string | undefined;
    address!: string | undefined;

    constructor(data?: IHostBillingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.legalName = data["legalName"];
            this.address = data["address"];
        }
    }

    static fromJS(data: any): HostBillingSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostBillingSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        return data; 
    }
}

export interface IHostBillingSettingsEditDto {
    legalName: string | undefined;
    address: string | undefined;
}

export class OtherSettingsEditDto implements IOtherSettingsEditDto {
    isQuickThemeSelectEnabled!: boolean;

    constructor(data?: IOtherSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isQuickThemeSelectEnabled = data["isQuickThemeSelectEnabled"];
        }
    }

    static fromJS(data: any): OtherSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OtherSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        return data; 
    }
}

export interface IOtherSettingsEditDto {
    isQuickThemeSelectEnabled: boolean;
}

export class HostSettingsEditDto implements IHostSettingsEditDto {
    general!: GeneralSettingsEditDto;
    userManagement!: HostUserManagementSettingsEditDto;
    email!: EmailSettingsEditDto;
    tenantManagement!: TenantManagementSettingsEditDto;
    security!: SecuritySettingsEditDto;
    billing!: HostBillingSettingsEditDto;
    otherSettings!: OtherSettingsEditDto;

    constructor(data?: IHostSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.general = new GeneralSettingsEditDto();
            this.userManagement = new HostUserManagementSettingsEditDto();
            this.email = new EmailSettingsEditDto();
            this.tenantManagement = new TenantManagementSettingsEditDto();
            this.security = new SecuritySettingsEditDto();
        }
    }

    init(data?: any) {
        if (data) {
            this.general = data["general"] ? GeneralSettingsEditDto.fromJS(data["general"]) : new GeneralSettingsEditDto();
            this.userManagement = data["userManagement"] ? HostUserManagementSettingsEditDto.fromJS(data["userManagement"]) : new HostUserManagementSettingsEditDto();
            this.email = data["email"] ? EmailSettingsEditDto.fromJS(data["email"]) : new EmailSettingsEditDto();
            this.tenantManagement = data["tenantManagement"] ? TenantManagementSettingsEditDto.fromJS(data["tenantManagement"]) : new TenantManagementSettingsEditDto();
            this.security = data["security"] ? SecuritySettingsEditDto.fromJS(data["security"]) : new SecuritySettingsEditDto();
            this.billing = data["billing"] ? HostBillingSettingsEditDto.fromJS(data["billing"]) : <any>undefined;
            this.otherSettings = data["otherSettings"] ? OtherSettingsEditDto.fromJS(data["otherSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HostSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["tenantManagement"] = this.tenantManagement ? this.tenantManagement.toJSON() : <any>undefined;
        data["security"] = this.security ? this.security.toJSON() : <any>undefined;
        data["billing"] = this.billing ? this.billing.toJSON() : <any>undefined;
        data["otherSettings"] = this.otherSettings ? this.otherSettings.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IHostSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: HostUserManagementSettingsEditDto;
    email: EmailSettingsEditDto;
    tenantManagement: TenantManagementSettingsEditDto;
    security: SecuritySettingsEditDto;
    billing: HostBillingSettingsEditDto;
    otherSettings: OtherSettingsEditDto;
}

export class SendTestEmailInput implements ISendTestEmailInput {
    emailAddress!: string | undefined;

    constructor(data?: ISendTestEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.emailAddress = data["emailAddress"];
        }
    }

    static fromJS(data: any): SendTestEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendTestEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data; 
    }
}

export interface ISendTestEmailInput {
    emailAddress: string | undefined;
}

export class IncomeOutcomeDto implements IIncomeOutcomeDto {
    code!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    isEffective!: boolean;
    effect!: boolean;
    id!: number;

    constructor(data?: IIncomeOutcomeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.isEffective = data["isEffective"];
            this.effect = data["effect"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): IncomeOutcomeDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncomeOutcomeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isEffective"] = this.isEffective;
        data["effect"] = this.effect;
        data["id"] = this.id;
        return data; 
    }
}

export interface IIncomeOutcomeDto {
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    isEffective: boolean;
    effect: boolean;
    id: number;
}

export class GetIncomeOutcomeForViewDto implements IGetIncomeOutcomeForViewDto {
    incomeOutcome!: IncomeOutcomeDto;
    isEditable!: boolean;

    constructor(data?: IGetIncomeOutcomeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.incomeOutcome = data["incomeOutcome"] ? IncomeOutcomeDto.fromJS(data["incomeOutcome"]) : <any>undefined;
            this.isEditable = data["isEditable"];
        }
    }

    static fromJS(data: any): GetIncomeOutcomeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetIncomeOutcomeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incomeOutcome"] = this.incomeOutcome ? this.incomeOutcome.toJSON() : <any>undefined;
        data["isEditable"] = this.isEditable;
        return data; 
    }
}

export interface IGetIncomeOutcomeForViewDto {
    incomeOutcome: IncomeOutcomeDto;
    isEditable: boolean;
}

export class PagedResultDtoOfGetIncomeOutcomeForViewDto implements IPagedResultDtoOfGetIncomeOutcomeForViewDto {
    totalCount!: number;
    items!: GetIncomeOutcomeForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetIncomeOutcomeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetIncomeOutcomeForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetIncomeOutcomeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetIncomeOutcomeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetIncomeOutcomeForViewDto {
    totalCount: number;
    items: GetIncomeOutcomeForViewDto[] | undefined;
}

export class CreateOrEditIncomeOutcomeDto implements ICreateOrEditIncomeOutcomeDto {
    code!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    isEffective!: boolean;
    effect!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditIncomeOutcomeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.isEffective = data["isEffective"];
            this.effect = data["effect"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditIncomeOutcomeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditIncomeOutcomeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isEffective"] = this.isEffective;
        data["effect"] = this.effect;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditIncomeOutcomeDto {
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    isEffective: boolean;
    effect: boolean;
    id: number | undefined;
}

export class GetIncomeOutcomeForEditOutput implements IGetIncomeOutcomeForEditOutput {
    incomeOutcome!: CreateOrEditIncomeOutcomeDto;

    constructor(data?: IGetIncomeOutcomeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.incomeOutcome = data["incomeOutcome"] ? CreateOrEditIncomeOutcomeDto.fromJS(data["incomeOutcome"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetIncomeOutcomeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetIncomeOutcomeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incomeOutcome"] = this.incomeOutcome ? this.incomeOutcome.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetIncomeOutcomeForEditOutput {
    incomeOutcome: CreateOrEditIncomeOutcomeDto;
}

export class InstallDto implements IInstallDto {
    connectionString!: string | undefined;
    adminPassword!: string | undefined;
    webSiteUrl!: string | undefined;
    serverUrl!: string | undefined;
    defaultLanguage!: string | undefined;
    smtpSettings!: EmailSettingsEditDto;
    billInfo!: HostBillingSettingsEditDto;

    constructor(data?: IInstallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.connectionString = data["connectionString"];
            this.adminPassword = data["adminPassword"];
            this.webSiteUrl = data["webSiteUrl"];
            this.serverUrl = data["serverUrl"];
            this.defaultLanguage = data["defaultLanguage"];
            this.smtpSettings = data["smtpSettings"] ? EmailSettingsEditDto.fromJS(data["smtpSettings"]) : <any>undefined;
            this.billInfo = data["billInfo"] ? HostBillingSettingsEditDto.fromJS(data["billInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InstallDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectionString"] = this.connectionString;
        data["adminPassword"] = this.adminPassword;
        data["webSiteUrl"] = this.webSiteUrl;
        data["serverUrl"] = this.serverUrl;
        data["defaultLanguage"] = this.defaultLanguage;
        data["smtpSettings"] = this.smtpSettings ? this.smtpSettings.toJSON() : <any>undefined;
        data["billInfo"] = this.billInfo ? this.billInfo.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IInstallDto {
    connectionString: string | undefined;
    adminPassword: string | undefined;
    webSiteUrl: string | undefined;
    serverUrl: string | undefined;
    defaultLanguage: string | undefined;
    smtpSettings: EmailSettingsEditDto;
    billInfo: HostBillingSettingsEditDto;
}

export class NameValue implements INameValue {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): NameValue {
        data = typeof data === 'object' ? data : {};
        let result = new NameValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }
}

export interface INameValue {
    name: string | undefined;
    value: string | undefined;
}

export class AppSettingsJsonDto implements IAppSettingsJsonDto {
    webSiteUrl!: string | undefined;
    serverSiteUrl!: string | undefined;
    languages!: NameValue[] | undefined;

    constructor(data?: IAppSettingsJsonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.webSiteUrl = data["webSiteUrl"];
            this.serverSiteUrl = data["serverSiteUrl"];
            if (Array.isArray(data["languages"])) {
                this.languages = [] as any;
                for (let item of data["languages"])
                    this.languages!.push(NameValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppSettingsJsonDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppSettingsJsonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webSiteUrl"] = this.webSiteUrl;
        data["serverSiteUrl"] = this.serverSiteUrl;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAppSettingsJsonDto {
    webSiteUrl: string | undefined;
    serverSiteUrl: string | undefined;
    languages: NameValue[] | undefined;
}

export class CheckDatabaseOutput implements ICheckDatabaseOutput {
    isDatabaseExist!: boolean;

    constructor(data?: ICheckDatabaseOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isDatabaseExist = data["isDatabaseExist"];
        }
    }

    static fromJS(data: any): CheckDatabaseOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CheckDatabaseOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDatabaseExist"] = this.isDatabaseExist;
        return data; 
    }
}

export interface ICheckDatabaseOutput {
    isDatabaseExist: boolean;
}

export class IntroductionMethodDto implements IIntroductionMethodDto {
    title!: string | undefined;
    state!: boolean;
    created!: moment.Moment;
    createdBy!: number;
    modified!: moment.Moment | undefined;
    modifiedBy!: number | undefined;
    id!: number;

    constructor(data?: IIntroductionMethodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.state = data["state"];
            this.created = data["created"] ? moment(data["created"].toString()) : <any>undefined;
            this.createdBy = data["createdBy"];
            this.modified = data["modified"] ? moment(data["modified"].toString()) : <any>undefined;
            this.modifiedBy = data["modifiedBy"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): IntroductionMethodDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntroductionMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["state"] = this.state;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        return data; 
    }
}

export interface IIntroductionMethodDto {
    title: string | undefined;
    state: boolean;
    created: moment.Moment;
    createdBy: number;
    modified: moment.Moment | undefined;
    modifiedBy: number | undefined;
    id: number;
}

export class GetIntroductionMethodForViewDto implements IGetIntroductionMethodForViewDto {
    introductionMethod!: IntroductionMethodDto;

    constructor(data?: IGetIntroductionMethodForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.introductionMethod = data["introductionMethod"] ? IntroductionMethodDto.fromJS(data["introductionMethod"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetIntroductionMethodForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetIntroductionMethodForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["introductionMethod"] = this.introductionMethod ? this.introductionMethod.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetIntroductionMethodForViewDto {
    introductionMethod: IntroductionMethodDto;
}

export class PagedResultDtoOfGetIntroductionMethodForViewDto implements IPagedResultDtoOfGetIntroductionMethodForViewDto {
    totalCount!: number;
    items!: GetIntroductionMethodForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetIntroductionMethodForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetIntroductionMethodForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetIntroductionMethodForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetIntroductionMethodForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetIntroductionMethodForViewDto {
    totalCount: number;
    items: GetIntroductionMethodForViewDto[] | undefined;
}

export class CreateOrEditIntroductionMethodDto implements ICreateOrEditIntroductionMethodDto {
    title!: string | undefined;
    state!: boolean;
    created!: moment.Moment;
    createdBy!: number;
    modified!: moment.Moment | undefined;
    modifiedBy!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditIntroductionMethodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.state = data["state"];
            this.created = data["created"] ? moment(data["created"].toString()) : <any>undefined;
            this.createdBy = data["createdBy"];
            this.modified = data["modified"] ? moment(data["modified"].toString()) : <any>undefined;
            this.modifiedBy = data["modifiedBy"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditIntroductionMethodDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditIntroductionMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["state"] = this.state;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditIntroductionMethodDto {
    title: string | undefined;
    state: boolean;
    created: moment.Moment;
    createdBy: number;
    modified: moment.Moment | undefined;
    modifiedBy: number | undefined;
    id: number | undefined;
}

export class GetIntroductionMethodForEditOutput implements IGetIntroductionMethodForEditOutput {
    introductionMethod!: CreateOrEditIntroductionMethodDto;

    constructor(data?: IGetIntroductionMethodForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.introductionMethod = data["introductionMethod"] ? CreateOrEditIntroductionMethodDto.fromJS(data["introductionMethod"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetIntroductionMethodForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetIntroductionMethodForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["introductionMethod"] = this.introductionMethod ? this.introductionMethod.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetIntroductionMethodForEditOutput {
    introductionMethod: CreateOrEditIntroductionMethodDto;
}

export class InvoiceDto implements IInvoiceDto {
    amount!: number;
    editionDisplayName!: string | undefined;
    invoiceNo!: string | undefined;
    invoiceDate!: moment.Moment;
    tenantLegalName!: string | undefined;
    tenantAddress!: string[] | undefined;
    tenantTaxNo!: string | undefined;
    hostLegalName!: string | undefined;
    hostAddress!: string[] | undefined;

    constructor(data?: IInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.amount = data["amount"];
            this.editionDisplayName = data["editionDisplayName"];
            this.invoiceNo = data["invoiceNo"];
            this.invoiceDate = data["invoiceDate"] ? moment(data["invoiceDate"].toString()) : <any>undefined;
            this.tenantLegalName = data["tenantLegalName"];
            if (Array.isArray(data["tenantAddress"])) {
                this.tenantAddress = [] as any;
                for (let item of data["tenantAddress"])
                    this.tenantAddress!.push(item);
            }
            this.tenantTaxNo = data["tenantTaxNo"];
            this.hostLegalName = data["hostLegalName"];
            if (Array.isArray(data["hostAddress"])) {
                this.hostAddress = [] as any;
                for (let item of data["hostAddress"])
                    this.hostAddress!.push(item);
            }
        }
    }

    static fromJS(data: any): InvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["editionDisplayName"] = this.editionDisplayName;
        data["invoiceNo"] = this.invoiceNo;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
        data["tenantLegalName"] = this.tenantLegalName;
        if (Array.isArray(this.tenantAddress)) {
            data["tenantAddress"] = [];
            for (let item of this.tenantAddress)
                data["tenantAddress"].push(item);
        }
        data["tenantTaxNo"] = this.tenantTaxNo;
        data["hostLegalName"] = this.hostLegalName;
        if (Array.isArray(this.hostAddress)) {
            data["hostAddress"] = [];
            for (let item of this.hostAddress)
                data["hostAddress"].push(item);
        }
        return data; 
    }
}

export interface IInvoiceDto {
    amount: number;
    editionDisplayName: string | undefined;
    invoiceNo: string | undefined;
    invoiceDate: moment.Moment;
    tenantLegalName: string | undefined;
    tenantAddress: string[] | undefined;
    tenantTaxNo: string | undefined;
    hostLegalName: string | undefined;
    hostAddress: string[] | undefined;
}

export class CreateInvoiceDto implements ICreateInvoiceDto {
    subscriptionPaymentId!: number;

    constructor(data?: ICreateInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.subscriptionPaymentId = data["subscriptionPaymentId"];
        }
    }

    static fromJS(data: any): CreateInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionPaymentId"] = this.subscriptionPaymentId;
        return data; 
    }
}

export interface ICreateInvoiceDto {
    subscriptionPaymentId: number;
}

export class JobDto implements IJobDto {
    title!: string | undefined;
    socialSecurityCode!: string | undefined;
    taxCode!: string | undefined;
    state!: boolean;
    id!: number;

    constructor(data?: IJobDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.socialSecurityCode = data["socialSecurityCode"];
            this.taxCode = data["taxCode"];
            this.state = data["state"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): JobDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["socialSecurityCode"] = this.socialSecurityCode;
        data["taxCode"] = this.taxCode;
        data["state"] = this.state;
        data["id"] = this.id;
        return data; 
    }
}

export interface IJobDto {
    title: string | undefined;
    socialSecurityCode: string | undefined;
    taxCode: string | undefined;
    state: boolean;
    id: number;
}

export class GetJobForViewDto implements IGetJobForViewDto {
    job!: JobDto;

    constructor(data?: IGetJobForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.job = data["job"] ? JobDto.fromJS(data["job"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetJobForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetJobForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["job"] = this.job ? this.job.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetJobForViewDto {
    job: JobDto;
}

export class PagedResultDtoOfGetJobForViewDto implements IPagedResultDtoOfGetJobForViewDto {
    totalCount!: number;
    items!: GetJobForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetJobForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetJobForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetJobForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetJobForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetJobForViewDto {
    totalCount: number;
    items: GetJobForViewDto[] | undefined;
}

export class CreateOrEditJobDto implements ICreateOrEditJobDto {
    title!: string | undefined;
    socialSecurityCode!: string | undefined;
    taxCode!: string | undefined;
    state!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditJobDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.socialSecurityCode = data["socialSecurityCode"];
            this.taxCode = data["taxCode"];
            this.state = data["state"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditJobDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditJobDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["socialSecurityCode"] = this.socialSecurityCode;
        data["taxCode"] = this.taxCode;
        data["state"] = this.state;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditJobDto {
    title: string | undefined;
    socialSecurityCode: string | undefined;
    taxCode: string | undefined;
    state: boolean;
    id: number | undefined;
}

export class GetJobForEditOutput implements IGetJobForEditOutput {
    job!: CreateOrEditJobDto;

    constructor(data?: IGetJobForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.job = data["job"] ? CreateOrEditJobDto.fromJS(data["job"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetJobForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetJobForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["job"] = this.job ? this.job.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetJobForEditOutput {
    job: CreateOrEditJobDto;
}

export class ApplicationLanguageListDto implements IApplicationLanguageListDto {
    tenantId!: number | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    icon!: string | undefined;
    isDisabled!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IApplicationLanguageListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.icon = data["icon"];
            this.isDisabled = data["isDisabled"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ApplicationLanguageListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLanguageListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["icon"] = this.icon;
        data["isDisabled"] = this.isDisabled;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IApplicationLanguageListDto {
    tenantId: number | undefined;
    name: string | undefined;
    displayName: string | undefined;
    icon: string | undefined;
    isDisabled: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class GetLanguagesOutput implements IGetLanguagesOutput {
    defaultLanguageName!: string | undefined;
    items!: ApplicationLanguageListDto[] | undefined;

    constructor(data?: IGetLanguagesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.defaultLanguageName = data["defaultLanguageName"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(ApplicationLanguageListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguagesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLanguagesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultLanguageName"] = this.defaultLanguageName;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetLanguagesOutput {
    defaultLanguageName: string | undefined;
    items: ApplicationLanguageListDto[] | undefined;
}

export class ApplicationLanguageEditDto implements IApplicationLanguageEditDto {
    id!: number | undefined;
    name!: string | undefined;
    icon!: string | undefined;
    isEnabled!: boolean;

    constructor(data?: IApplicationLanguageEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.icon = data["icon"];
            this.isEnabled = data["isEnabled"];
        }
    }

    static fromJS(data: any): ApplicationLanguageEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLanguageEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["isEnabled"] = this.isEnabled;
        return data; 
    }
}

export interface IApplicationLanguageEditDto {
    id: number | undefined;
    name: string | undefined;
    icon: string | undefined;
    isEnabled: boolean;
}

export class ComboboxItemDto implements IComboboxItemDto {
    value!: string | undefined;
    displayText!: string | undefined;
    isSelected!: boolean;

    constructor(data?: IComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"];
            this.displayText = data["displayText"];
            this.isSelected = data["isSelected"];
        }
    }

    static fromJS(data: any): ComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data; 
    }
}

export interface IComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean;
}

export class GetLanguageForEditOutput implements IGetLanguageForEditOutput {
    language!: ApplicationLanguageEditDto;
    languageNames!: ComboboxItemDto[] | undefined;
    flags!: ComboboxItemDto[] | undefined;

    constructor(data?: IGetLanguageForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.language = data["language"] ? ApplicationLanguageEditDto.fromJS(data["language"]) : <any>undefined;
            if (Array.isArray(data["languageNames"])) {
                this.languageNames = [] as any;
                for (let item of data["languageNames"])
                    this.languageNames!.push(ComboboxItemDto.fromJS(item));
            }
            if (Array.isArray(data["flags"])) {
                this.flags = [] as any;
                for (let item of data["flags"])
                    this.flags!.push(ComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguageForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLanguageForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        if (Array.isArray(this.languageNames)) {
            data["languageNames"] = [];
            for (let item of this.languageNames)
                data["languageNames"].push(item.toJSON());
        }
        if (Array.isArray(this.flags)) {
            data["flags"] = [];
            for (let item of this.flags)
                data["flags"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetLanguageForEditOutput {
    language: ApplicationLanguageEditDto;
    languageNames: ComboboxItemDto[] | undefined;
    flags: ComboboxItemDto[] | undefined;
}

export class CreateOrUpdateLanguageInput implements ICreateOrUpdateLanguageInput {
    language!: ApplicationLanguageEditDto;

    constructor(data?: ICreateOrUpdateLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.language = new ApplicationLanguageEditDto();
        }
    }

    init(data?: any) {
        if (data) {
            this.language = data["language"] ? ApplicationLanguageEditDto.fromJS(data["language"]) : new ApplicationLanguageEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateLanguageInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLanguageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICreateOrUpdateLanguageInput {
    language: ApplicationLanguageEditDto;
}

export class SetDefaultLanguageInput implements ISetDefaultLanguageInput {
    name!: string | undefined;

    constructor(data?: ISetDefaultLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
        }
    }

    static fromJS(data: any): SetDefaultLanguageInput {
        data = typeof data === 'object' ? data : {};
        let result = new SetDefaultLanguageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data; 
    }
}

export interface ISetDefaultLanguageInput {
    name: string | undefined;
}

export class LanguageTextListDto implements ILanguageTextListDto {
    key!: string | undefined;
    baseValue!: string | undefined;
    targetValue!: string | undefined;

    constructor(data?: ILanguageTextListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.key = data["key"];
            this.baseValue = data["baseValue"];
            this.targetValue = data["targetValue"];
        }
    }

    static fromJS(data: any): LanguageTextListDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageTextListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["baseValue"] = this.baseValue;
        data["targetValue"] = this.targetValue;
        return data; 
    }
}

export interface ILanguageTextListDto {
    key: string | undefined;
    baseValue: string | undefined;
    targetValue: string | undefined;
}

export class PagedResultDtoOfLanguageTextListDto implements IPagedResultDtoOfLanguageTextListDto {
    totalCount!: number;
    items!: LanguageTextListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLanguageTextListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(LanguageTextListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLanguageTextListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLanguageTextListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfLanguageTextListDto {
    totalCount: number;
    items: LanguageTextListDto[] | undefined;
}

export class UpdateLanguageTextInput implements IUpdateLanguageTextInput {
    languageName!: string | undefined;
    sourceName!: string | undefined;
    key!: string | undefined;
    value!: string | undefined;

    constructor(data?: IUpdateLanguageTextInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.languageName = data["languageName"];
            this.sourceName = data["sourceName"];
            this.key = data["key"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): UpdateLanguageTextInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLanguageTextInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        data["sourceName"] = this.sourceName;
        data["key"] = this.key;
        data["value"] = this.value;
        return data; 
    }
}

export interface IUpdateLanguageTextInput {
    languageName: string | undefined;
    sourceName: string | undefined;
    key: string | undefined;
    value: string | undefined;
}

export class PagedResultDtoOfGetLegalContactForViewDto implements IPagedResultDtoOfGetLegalContactForViewDto {
    totalCount!: number;
    items!: GetLegalContactForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetLegalContactForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetLegalContactForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetLegalContactForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetLegalContactForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetLegalContactForViewDto {
    totalCount: number;
    items: GetLegalContactForViewDto[] | undefined;
}

export class CreateOrEditLegalContactDto implements ICreateOrEditLegalContactDto {
    name!: string | undefined;
    identityCode!: string | undefined;
    economicCode!: string | undefined;
    registrationNumber!: string | undefined;
    phone!: string | undefined;
    manager!: string | undefined;
    postalCode!: string | undefined;
    activityField!: string | undefined;
    state!: boolean;
    contactRef!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditLegalContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.identityCode = data["identityCode"];
            this.economicCode = data["economicCode"];
            this.registrationNumber = data["registrationNumber"];
            this.phone = data["phone"];
            this.manager = data["manager"];
            this.postalCode = data["postalCode"];
            this.activityField = data["activityField"];
            this.state = data["state"];
            this.contactRef = data["contactRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditLegalContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditLegalContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["identityCode"] = this.identityCode;
        data["economicCode"] = this.economicCode;
        data["registrationNumber"] = this.registrationNumber;
        data["phone"] = this.phone;
        data["manager"] = this.manager;
        data["postalCode"] = this.postalCode;
        data["activityField"] = this.activityField;
        data["state"] = this.state;
        data["contactRef"] = this.contactRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditLegalContactDto {
    name: string | undefined;
    identityCode: string | undefined;
    economicCode: string | undefined;
    registrationNumber: string | undefined;
    phone: string | undefined;
    manager: string | undefined;
    postalCode: string | undefined;
    activityField: string | undefined;
    state: boolean;
    contactRef: number;
    id: number | undefined;
}

export class GetLegalContactForEditOutput implements IGetLegalContactForEditOutput {
    legalContact!: CreateOrEditLegalContactDto;
    contactFirstName!: string | undefined;
    addressTitle!: string | undefined;

    constructor(data?: IGetLegalContactForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.legalContact = data["legalContact"] ? CreateOrEditLegalContactDto.fromJS(data["legalContact"]) : <any>undefined;
            this.contactFirstName = data["contactFirstName"];
            this.addressTitle = data["addressTitle"];
        }
    }

    static fromJS(data: any): GetLegalContactForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLegalContactForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalContact"] = this.legalContact ? this.legalContact.toJSON() : <any>undefined;
        data["contactFirstName"] = this.contactFirstName;
        data["addressTitle"] = this.addressTitle;
        return data; 
    }
}

export interface IGetLegalContactForEditOutput {
    legalContact: CreateOrEditLegalContactDto;
    contactFirstName: string | undefined;
    addressTitle: string | undefined;
}

export class LegalContactContactLookupTableDto implements ILegalContactContactLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ILegalContactContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): LegalContactContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new LegalContactContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ILegalContactContactLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfLegalContactContactLookupTableDto implements IPagedResultDtoOfLegalContactContactLookupTableDto {
    totalCount!: number;
    items!: LegalContactContactLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLegalContactContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(LegalContactContactLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLegalContactContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLegalContactContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfLegalContactContactLookupTableDto {
    totalCount: number;
    items: LegalContactContactLookupTableDto[] | undefined;
}

export class LegalContactAddressLookupTableDto implements ILegalContactAddressLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ILegalContactAddressLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): LegalContactAddressLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new LegalContactAddressLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ILegalContactAddressLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfLegalContactAddressLookupTableDto implements IPagedResultDtoOfLegalContactAddressLookupTableDto {
    totalCount!: number;
    items!: LegalContactAddressLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLegalContactAddressLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(LegalContactAddressLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLegalContactAddressLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLegalContactAddressLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfLegalContactAddressLookupTableDto {
    totalCount: number;
    items: LegalContactAddressLookupTableDto[] | undefined;
}

export class LocationGroupDto implements ILocationGroupDto {
    title!: string | undefined;
    capacity!: number;
    id!: number;

    constructor(data?: ILocationGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.capacity = data["capacity"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): LocationGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["capacity"] = this.capacity;
        data["id"] = this.id;
        return data; 
    }
}

export interface ILocationGroupDto {
    title: string | undefined;
    capacity: number;
    id: number;
}

export class GetLocationGroupForViewDto implements IGetLocationGroupForViewDto {
    locationGroup!: LocationGroupDto;

    constructor(data?: IGetLocationGroupForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.locationGroup = data["locationGroup"] ? LocationGroupDto.fromJS(data["locationGroup"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetLocationGroupForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetLocationGroupForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationGroup"] = this.locationGroup ? this.locationGroup.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetLocationGroupForViewDto {
    locationGroup: LocationGroupDto;
}

export class PagedResultDtoOfGetLocationGroupForViewDto implements IPagedResultDtoOfGetLocationGroupForViewDto {
    totalCount!: number;
    items!: GetLocationGroupForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetLocationGroupForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetLocationGroupForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetLocationGroupForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetLocationGroupForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetLocationGroupForViewDto {
    totalCount: number;
    items: GetLocationGroupForViewDto[] | undefined;
}

export class CreateOrEditLocationGroupDto implements ICreateOrEditLocationGroupDto {
    title!: string | undefined;
    capacity!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditLocationGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.capacity = data["capacity"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditLocationGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditLocationGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["capacity"] = this.capacity;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditLocationGroupDto {
    title: string | undefined;
    capacity: number;
    id: number | undefined;
}

export class GetLocationGroupForEditOutput implements IGetLocationGroupForEditOutput {
    locationGroup!: CreateOrEditLocationGroupDto;

    constructor(data?: IGetLocationGroupForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.locationGroup = data["locationGroup"] ? CreateOrEditLocationGroupDto.fromJS(data["locationGroup"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetLocationGroupForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLocationGroupForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationGroup"] = this.locationGroup ? this.locationGroup.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetLocationGroupForEditOutput {
    locationGroup: CreateOrEditLocationGroupDto;
}

export class LocationDto implements ILocationDto {
    title!: string | undefined;
    code!: string | undefined;
    isPublicOrPrivate!: boolean;
    owner!: string | undefined;
    ownerPhoneNo!: string | undefined;
    guaranteedTimeDeliver!: number | undefined;
    isUserRequestsToBePublicTheLocation!: boolean;
    locationGroupId!: number | undefined;
    locationTypeId!: number | undefined;
    id!: number;

    constructor(data?: ILocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.code = data["code"];
            this.isPublicOrPrivate = data["isPublicOrPrivate"];
            this.owner = data["owner"];
            this.ownerPhoneNo = data["ownerPhoneNo"];
            this.guaranteedTimeDeliver = data["guaranteedTimeDeliver"];
            this.isUserRequestsToBePublicTheLocation = data["isUserRequestsToBePublicTheLocation"];
            this.locationGroupId = data["locationGroupId"];
            this.locationTypeId = data["locationTypeId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): LocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["code"] = this.code;
        data["isPublicOrPrivate"] = this.isPublicOrPrivate;
        data["owner"] = this.owner;
        data["ownerPhoneNo"] = this.ownerPhoneNo;
        data["guaranteedTimeDeliver"] = this.guaranteedTimeDeliver;
        data["isUserRequestsToBePublicTheLocation"] = this.isUserRequestsToBePublicTheLocation;
        data["locationGroupId"] = this.locationGroupId;
        data["locationTypeId"] = this.locationTypeId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ILocationDto {
    title: string | undefined;
    code: string | undefined;
    isPublicOrPrivate: boolean;
    owner: string | undefined;
    ownerPhoneNo: string | undefined;
    guaranteedTimeDeliver: number | undefined;
    isUserRequestsToBePublicTheLocation: boolean;
    locationGroupId: number | undefined;
    locationTypeId: number | undefined;
    id: number;
}

export class GetLocationForViewDto implements IGetLocationForViewDto {
    location!: LocationDto;
    locationGroupTitle!: string | undefined;
    locationTypeTitle!: string | undefined;
    address!: string | undefined;
    creatorUserName!: string | undefined;

    constructor(data?: IGetLocationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.location = data["location"] ? LocationDto.fromJS(data["location"]) : <any>undefined;
            this.locationGroupTitle = data["locationGroupTitle"];
            this.locationTypeTitle = data["locationTypeTitle"];
            this.address = data["address"];
            this.creatorUserName = data["creatorUserName"];
        }
    }

    static fromJS(data: any): GetLocationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetLocationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["locationGroupTitle"] = this.locationGroupTitle;
        data["locationTypeTitle"] = this.locationTypeTitle;
        data["address"] = this.address;
        data["creatorUserName"] = this.creatorUserName;
        return data; 
    }
}

export interface IGetLocationForViewDto {
    location: LocationDto;
    locationGroupTitle: string | undefined;
    locationTypeTitle: string | undefined;
    address: string | undefined;
    creatorUserName: string | undefined;
}

export class PagedResultDtoOfGetLocationForViewDto implements IPagedResultDtoOfGetLocationForViewDto {
    totalCount!: number;
    items!: GetLocationForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetLocationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetLocationForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetLocationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetLocationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetLocationForViewDto {
    totalCount: number;
    items: GetLocationForViewDto[] | undefined;
}

export class CreateOrEditLocationDto implements ICreateOrEditLocationDto {
    title!: string | undefined;
    code!: string | undefined;
    isPublicOrPrivate!: boolean;
    owner!: string | undefined;
    ownerPhoneNo!: string | undefined;
    guaranteedTimeDeliver!: number | undefined;
    isUserRequestsToBePublicTheLocation!: boolean;
    locationGroupId!: number | undefined;
    locationTypeId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.code = data["code"];
            this.isPublicOrPrivate = data["isPublicOrPrivate"];
            this.owner = data["owner"];
            this.ownerPhoneNo = data["ownerPhoneNo"];
            this.guaranteedTimeDeliver = data["guaranteedTimeDeliver"];
            this.isUserRequestsToBePublicTheLocation = data["isUserRequestsToBePublicTheLocation"];
            this.locationGroupId = data["locationGroupId"];
            this.locationTypeId = data["locationTypeId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["code"] = this.code;
        data["isPublicOrPrivate"] = this.isPublicOrPrivate;
        data["owner"] = this.owner;
        data["ownerPhoneNo"] = this.ownerPhoneNo;
        data["guaranteedTimeDeliver"] = this.guaranteedTimeDeliver;
        data["isUserRequestsToBePublicTheLocation"] = this.isUserRequestsToBePublicTheLocation;
        data["locationGroupId"] = this.locationGroupId;
        data["locationTypeId"] = this.locationTypeId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditLocationDto {
    title: string | undefined;
    code: string | undefined;
    isPublicOrPrivate: boolean;
    owner: string | undefined;
    ownerPhoneNo: string | undefined;
    guaranteedTimeDeliver: number | undefined;
    isUserRequestsToBePublicTheLocation: boolean;
    locationGroupId: number | undefined;
    locationTypeId: number | undefined;
    id: number | undefined;
}

export class GetLocationForEditOutput implements IGetLocationForEditOutput {
    location!: CreateOrEditLocationDto;
    locationGroupTitle!: string | undefined;
    locationTypeTitle!: string | undefined;

    constructor(data?: IGetLocationForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.location = data["location"] ? CreateOrEditLocationDto.fromJS(data["location"]) : <any>undefined;
            this.locationGroupTitle = data["locationGroupTitle"];
            this.locationTypeTitle = data["locationTypeTitle"];
        }
    }

    static fromJS(data: any): GetLocationForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLocationForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["locationGroupTitle"] = this.locationGroupTitle;
        data["locationTypeTitle"] = this.locationTypeTitle;
        return data; 
    }
}

export interface IGetLocationForEditOutput {
    location: CreateOrEditLocationDto;
    locationGroupTitle: string | undefined;
    locationTypeTitle: string | undefined;
}

export class GetLocationAndAddressForEditOutput implements IGetLocationAndAddressForEditOutput {
    location!: GetLocationForEditOutput;
    address!: GetAddressForEditOutput;

    constructor(data?: IGetLocationAndAddressForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.location = data["location"] ? GetLocationForEditOutput.fromJS(data["location"]) : <any>undefined;
            this.address = data["address"] ? GetAddressForEditOutput.fromJS(data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetLocationAndAddressForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLocationAndAddressForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetLocationAndAddressForEditOutput {
    location: GetLocationForEditOutput;
    address: GetAddressForEditOutput;
}

export class CreateOrEditLocationAndAddress implements ICreateOrEditLocationAndAddress {
    location!: CreateOrEditLocationDto;
    createLocationGroup!: boolean;
    address!: CreateOrEditAddressDto;

    constructor(data?: ICreateOrEditLocationAndAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.location = data["location"] ? CreateOrEditLocationDto.fromJS(data["location"]) : <any>undefined;
            this.createLocationGroup = data["createLocationGroup"];
            this.address = data["address"] ? CreateOrEditAddressDto.fromJS(data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrEditLocationAndAddress {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditLocationAndAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["createLocationGroup"] = this.createLocationGroup;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICreateOrEditLocationAndAddress {
    location: CreateOrEditLocationDto;
    createLocationGroup: boolean;
    address: CreateOrEditAddressDto;
}

export class LocationLocationGroupLookupTableDto implements ILocationLocationGroupLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ILocationLocationGroupLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): LocationLocationGroupLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationLocationGroupLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ILocationLocationGroupLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfLocationLocationGroupLookupTableDto implements IPagedResultDtoOfLocationLocationGroupLookupTableDto {
    totalCount!: number;
    items!: LocationLocationGroupLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLocationLocationGroupLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(LocationLocationGroupLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLocationLocationGroupLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLocationLocationGroupLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfLocationLocationGroupLookupTableDto {
    totalCount: number;
    items: LocationLocationGroupLookupTableDto[] | undefined;
}

export class LocationLocationTypeLookupTableDto implements ILocationLocationTypeLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ILocationLocationTypeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): LocationLocationTypeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationLocationTypeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ILocationLocationTypeLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class AddressData implements IAddressData {
    address!: string | undefined;
    country_Id!: number | undefined;
    state_Id!: number | undefined;
    city_Id!: number | undefined;
    countryName!: string | undefined;
    stateName!: string | undefined;
    cityName!: string | undefined;
    municipality_Zone!: number | undefined;

    constructor(data?: IAddressData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.address = data["address"];
            this.country_Id = data["country_Id"];
            this.state_Id = data["state_Id"];
            this.city_Id = data["city_Id"];
            this.countryName = data["countryName"];
            this.stateName = data["stateName"];
            this.cityName = data["cityName"];
            this.municipality_Zone = data["municipality_Zone"];
        }
    }

    static fromJS(data: any): AddressData {
        data = typeof data === 'object' ? data : {};
        let result = new AddressData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["country_Id"] = this.country_Id;
        data["state_Id"] = this.state_Id;
        data["city_Id"] = this.city_Id;
        data["countryName"] = this.countryName;
        data["stateName"] = this.stateName;
        data["cityName"] = this.cityName;
        data["municipality_Zone"] = this.municipality_Zone;
        return data; 
    }
}

export interface IAddressData {
    address: string | undefined;
    country_Id: number | undefined;
    state_Id: number | undefined;
    city_Id: number | undefined;
    countryName: string | undefined;
    stateName: string | undefined;
    cityName: string | undefined;
    municipality_Zone: number | undefined;
}

export class ReverseGeocodingDto implements IReverseGeocodingDto {
    status!: boolean;
    data!: AddressData;

    constructor(data?: IReverseGeocodingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.status = data["status"];
            this.data = data["data"] ? AddressData.fromJS(data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReverseGeocodingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReverseGeocodingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IReverseGeocodingDto {
    status: boolean;
    data: AddressData;
}

export class GetSearchLocationDto implements IGetSearchLocationDto {
    title!: string | undefined;
    address!: string | undefined;
    latitude!: number;
    longitude!: number;

    constructor(data?: IGetSearchLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.address = data["address"];
            this.latitude = data["latitude"];
            this.longitude = data["longitude"];
        }
    }

    static fromJS(data: any): GetSearchLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSearchLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["address"] = this.address;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data; 
    }
}

export interface IGetSearchLocationDto {
    title: string | undefined;
    address: string | undefined;
    latitude: number;
    longitude: number;
}

export class MergeAndSaveInput implements IMergeAndSaveInput {
    firstLocationId!: number;
    secondLocationId!: number;

    constructor(data?: IMergeAndSaveInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.firstLocationId = data["firstLocationId"];
            this.secondLocationId = data["secondLocationId"];
        }
    }

    static fromJS(data: any): MergeAndSaveInput {
        data = typeof data === 'object' ? data : {};
        let result = new MergeAndSaveInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstLocationId"] = this.firstLocationId;
        data["secondLocationId"] = this.secondLocationId;
        return data; 
    }
}

export interface IMergeAndSaveInput {
    firstLocationId: number;
    secondLocationId: number;
}

export class LocationTypeDto implements ILocationTypeDto {
    title!: string | undefined;
    isActive!: boolean;
    id!: number;

    constructor(data?: ILocationTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): LocationTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data; 
    }
}

export interface ILocationTypeDto {
    title: string | undefined;
    isActive: boolean;
    id: number;
}

export class GetLocationTypeForViewDto implements IGetLocationTypeForViewDto {
    locationType!: LocationTypeDto;

    constructor(data?: IGetLocationTypeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.locationType = data["locationType"] ? LocationTypeDto.fromJS(data["locationType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetLocationTypeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetLocationTypeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationType"] = this.locationType ? this.locationType.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetLocationTypeForViewDto {
    locationType: LocationTypeDto;
}

export class PagedResultDtoOfGetLocationTypeForViewDto implements IPagedResultDtoOfGetLocationTypeForViewDto {
    totalCount!: number;
    items!: GetLocationTypeForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetLocationTypeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetLocationTypeForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetLocationTypeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetLocationTypeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetLocationTypeForViewDto {
    totalCount: number;
    items: GetLocationTypeForViewDto[] | undefined;
}

export class CreateOrEditLocationTypeDto implements ICreateOrEditLocationTypeDto {
    title!: string | undefined;
    isActive!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditLocationTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditLocationTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditLocationTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditLocationTypeDto {
    title: string | undefined;
    isActive: boolean;
    id: number | undefined;
}

export class GetLocationTypeForEditOutput implements IGetLocationTypeForEditOutput {
    locationType!: CreateOrEditLocationTypeDto;

    constructor(data?: IGetLocationTypeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.locationType = data["locationType"] ? CreateOrEditLocationTypeDto.fromJS(data["locationType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetLocationTypeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLocationTypeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationType"] = this.locationType ? this.locationType.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetLocationTypeForEditOutput {
    locationType: CreateOrEditLocationTypeDto;
}

export class GetMoneyBoxForViewDto implements IGetMoneyBoxForViewDto {
    moneyBox!: MoneyBoxDto;
    planConstTitle!: string | undefined;

    constructor(data?: IGetMoneyBoxForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.moneyBox = data["moneyBox"] ? MoneyBoxDto.fromJS(data["moneyBox"]) : <any>undefined;
            this.planConstTitle = data["planConstTitle"];
        }
    }

    static fromJS(data: any): GetMoneyBoxForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMoneyBoxForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moneyBox"] = this.moneyBox ? this.moneyBox.toJSON() : <any>undefined;
        data["planConstTitle"] = this.planConstTitle;
        return data; 
    }
}

export interface IGetMoneyBoxForViewDto {
    moneyBox: MoneyBoxDto;
    planConstTitle: string | undefined;
}

export class PagedResultDtoOfGetMoneyBoxForViewDto implements IPagedResultDtoOfGetMoneyBoxForViewDto {
    totalCount!: number;
    items!: GetMoneyBoxForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetMoneyBoxForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetMoneyBoxForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetMoneyBoxForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetMoneyBoxForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetMoneyBoxForViewDto {
    totalCount: number;
    items: GetMoneyBoxForViewDto[] | undefined;
}

export class CreateOrEditMoneyBoxDto implements ICreateOrEditMoneyBoxDto {
    type!: MoneyBoxType;
    title!: string | undefined;
    planConstId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditMoneyBoxDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["type"];
            this.title = data["title"];
            this.planConstId = data["planConstId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditMoneyBoxDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditMoneyBoxDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["planConstId"] = this.planConstId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditMoneyBoxDto {
    type: MoneyBoxType;
    title: string | undefined;
    planConstId: number;
    id: number | undefined;
}

export class GetMoneyBoxForEditOutput implements IGetMoneyBoxForEditOutput {
    moneyBox!: CreateOrEditMoneyBoxDto;
    planConstTitle!: string | undefined;

    constructor(data?: IGetMoneyBoxForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.moneyBox = data["moneyBox"] ? CreateOrEditMoneyBoxDto.fromJS(data["moneyBox"]) : <any>undefined;
            this.planConstTitle = data["planConstTitle"];
        }
    }

    static fromJS(data: any): GetMoneyBoxForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMoneyBoxForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moneyBox"] = this.moneyBox ? this.moneyBox.toJSON() : <any>undefined;
        data["planConstTitle"] = this.planConstTitle;
        return data; 
    }
}

export interface IGetMoneyBoxForEditOutput {
    moneyBox: CreateOrEditMoneyBoxDto;
    planConstTitle: string | undefined;
}

export class MoneyBoxPlanConstLookupTableDto implements IMoneyBoxPlanConstLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IMoneyBoxPlanConstLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): MoneyBoxPlanConstLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new MoneyBoxPlanConstLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IMoneyBoxPlanConstLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export enum ActionTypes {
    Default = 0,
    Delivery = 1,
    Discharge = 2,
    Collect = 3,
    Cancel = 4,
}

export class MoneyBoxEventDto implements IMoneyBoxEventDto {
    amount!: number | undefined;
    lastStatus!: ActionTypes;
    planBillRef!: number;
    billRef!: number | undefined;
    id!: number;

    constructor(data?: IMoneyBoxEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.amount = data["amount"];
            this.lastStatus = data["lastStatus"];
            this.planBillRef = data["planBillRef"];
            this.billRef = data["billRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MoneyBoxEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new MoneyBoxEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["lastStatus"] = this.lastStatus;
        data["planBillRef"] = this.planBillRef;
        data["billRef"] = this.billRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMoneyBoxEventDto {
    amount: number | undefined;
    lastStatus: ActionTypes;
    planBillRef: number;
    billRef: number | undefined;
    id: number;
}

export class GetMoneyBoxEventForViewDto implements IGetMoneyBoxEventForViewDto {
    moneyBoxEvent!: MoneyBoxEventDto;
    planBillCode!: string | undefined;
    billCode!: string | undefined;

    constructor(data?: IGetMoneyBoxEventForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.moneyBoxEvent = data["moneyBoxEvent"] ? MoneyBoxEventDto.fromJS(data["moneyBoxEvent"]) : <any>undefined;
            this.planBillCode = data["planBillCode"];
            this.billCode = data["billCode"];
        }
    }

    static fromJS(data: any): GetMoneyBoxEventForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMoneyBoxEventForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moneyBoxEvent"] = this.moneyBoxEvent ? this.moneyBoxEvent.toJSON() : <any>undefined;
        data["planBillCode"] = this.planBillCode;
        data["billCode"] = this.billCode;
        return data; 
    }
}

export interface IGetMoneyBoxEventForViewDto {
    moneyBoxEvent: MoneyBoxEventDto;
    planBillCode: string | undefined;
    billCode: string | undefined;
}

export class PagedResultDtoOfGetMoneyBoxEventForViewDto implements IPagedResultDtoOfGetMoneyBoxEventForViewDto {
    totalCount!: number;
    items!: GetMoneyBoxEventForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetMoneyBoxEventForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetMoneyBoxEventForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetMoneyBoxEventForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetMoneyBoxEventForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetMoneyBoxEventForViewDto {
    totalCount: number;
    items: GetMoneyBoxEventForViewDto[] | undefined;
}

export class CreateOrEditMoneyBoxEventDto implements ICreateOrEditMoneyBoxEventDto {
    amount!: number | undefined;
    lastStatus!: ActionTypes;
    planBillRef!: number | undefined;
    billRef!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditMoneyBoxEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.amount = data["amount"];
            this.lastStatus = data["lastStatus"];
            this.planBillRef = data["planBillRef"];
            this.billRef = data["billRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditMoneyBoxEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditMoneyBoxEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["lastStatus"] = this.lastStatus;
        data["planBillRef"] = this.planBillRef;
        data["billRef"] = this.billRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditMoneyBoxEventDto {
    amount: number | undefined;
    lastStatus: ActionTypes;
    planBillRef: number | undefined;
    billRef: number | undefined;
    id: number | undefined;
}

export class GetMoneyBoxEventForEditOutput implements IGetMoneyBoxEventForEditOutput {
    moneyBoxEvent!: CreateOrEditMoneyBoxEventDto;
    planBillCode!: string | undefined;
    billCode!: string | undefined;

    constructor(data?: IGetMoneyBoxEventForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.moneyBoxEvent = data["moneyBoxEvent"] ? CreateOrEditMoneyBoxEventDto.fromJS(data["moneyBoxEvent"]) : <any>undefined;
            this.planBillCode = data["planBillCode"];
            this.billCode = data["billCode"];
        }
    }

    static fromJS(data: any): GetMoneyBoxEventForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMoneyBoxEventForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moneyBoxEvent"] = this.moneyBoxEvent ? this.moneyBoxEvent.toJSON() : <any>undefined;
        data["planBillCode"] = this.planBillCode;
        data["billCode"] = this.billCode;
        return data; 
    }
}

export interface IGetMoneyBoxEventForEditOutput {
    moneyBoxEvent: CreateOrEditMoneyBoxEventDto;
    planBillCode: string | undefined;
    billCode: string | undefined;
}

export class MoneyBoxEventPlanBillLookupTableDto implements IMoneyBoxEventPlanBillLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IMoneyBoxEventPlanBillLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): MoneyBoxEventPlanBillLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new MoneyBoxEventPlanBillLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IMoneyBoxEventPlanBillLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfMoneyBoxEventPlanBillLookupTableDto implements IPagedResultDtoOfMoneyBoxEventPlanBillLookupTableDto {
    totalCount!: number;
    items!: MoneyBoxEventPlanBillLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfMoneyBoxEventPlanBillLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(MoneyBoxEventPlanBillLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMoneyBoxEventPlanBillLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMoneyBoxEventPlanBillLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfMoneyBoxEventPlanBillLookupTableDto {
    totalCount: number;
    items: MoneyBoxEventPlanBillLookupTableDto[] | undefined;
}

export class NewsletterDto implements INewsletterDto {
    mobileNumber!: string | undefined;
    contactRef!: number | undefined;
    id!: number;

    constructor(data?: INewsletterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.mobileNumber = data["mobileNumber"];
            this.contactRef = data["contactRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): NewsletterDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewsletterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mobileNumber"] = this.mobileNumber;
        data["contactRef"] = this.contactRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface INewsletterDto {
    mobileNumber: string | undefined;
    contactRef: number | undefined;
    id: number;
}

export class GetNewsletterForViewDto implements IGetNewsletterForViewDto {
    newsletter!: NewsletterDto;
    contactFirstName!: string | undefined;

    constructor(data?: IGetNewsletterForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.newsletter = data["newsletter"] ? NewsletterDto.fromJS(data["newsletter"]) : <any>undefined;
            this.contactFirstName = data["contactFirstName"];
        }
    }

    static fromJS(data: any): GetNewsletterForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetNewsletterForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newsletter"] = this.newsletter ? this.newsletter.toJSON() : <any>undefined;
        data["contactFirstName"] = this.contactFirstName;
        return data; 
    }
}

export interface IGetNewsletterForViewDto {
    newsletter: NewsletterDto;
    contactFirstName: string | undefined;
}

export class PagedResultDtoOfGetNewsletterForViewDto implements IPagedResultDtoOfGetNewsletterForViewDto {
    totalCount!: number;
    items!: GetNewsletterForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetNewsletterForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetNewsletterForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetNewsletterForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetNewsletterForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetNewsletterForViewDto {
    totalCount: number;
    items: GetNewsletterForViewDto[] | undefined;
}

export class CreateOrEditNewsletterDto implements ICreateOrEditNewsletterDto {
    mobileNumber!: string | undefined;
    contactRef!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditNewsletterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.mobileNumber = data["mobileNumber"];
            this.contactRef = data["contactRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditNewsletterDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditNewsletterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mobileNumber"] = this.mobileNumber;
        data["contactRef"] = this.contactRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditNewsletterDto {
    mobileNumber: string | undefined;
    contactRef: number | undefined;
    id: number | undefined;
}

export class GetNewsletterForEditOutput implements IGetNewsletterForEditOutput {
    newsletter!: CreateOrEditNewsletterDto;
    contactFirstName!: string | undefined;

    constructor(data?: IGetNewsletterForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.newsletter = data["newsletter"] ? CreateOrEditNewsletterDto.fromJS(data["newsletter"]) : <any>undefined;
            this.contactFirstName = data["contactFirstName"];
        }
    }

    static fromJS(data: any): GetNewsletterForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNewsletterForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newsletter"] = this.newsletter ? this.newsletter.toJSON() : <any>undefined;
        data["contactFirstName"] = this.contactFirstName;
        return data; 
    }
}

export interface IGetNewsletterForEditOutput {
    newsletter: CreateOrEditNewsletterDto;
    contactFirstName: string | undefined;
}

export class NewsletterContactLookupTableDto implements INewsletterContactLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: INewsletterContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): NewsletterContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewsletterContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface INewsletterContactLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfNewsletterContactLookupTableDto implements IPagedResultDtoOfNewsletterContactLookupTableDto {
    totalCount!: number;
    items!: NewsletterContactLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfNewsletterContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(NewsletterContactLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfNewsletterContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfNewsletterContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfNewsletterContactLookupTableDto {
    totalCount: number;
    items: NewsletterContactLookupTableDto[] | undefined;
}

export enum Subject {
    Default = 0,
    Bill = 1,
}

export class NoticeDto implements INoticeDto {
    entityRef!: number;
    entity!: Subject;
    contactId!: number;
    id!: number;

    constructor(data?: INoticeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityRef = data["entityRef"];
            this.entity = data["entity"];
            this.contactId = data["contactId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): NoticeDto {
        data = typeof data === 'object' ? data : {};
        let result = new NoticeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityRef"] = this.entityRef;
        data["entity"] = this.entity;
        data["contactId"] = this.contactId;
        data["id"] = this.id;
        return data; 
    }
}

export interface INoticeDto {
    entityRef: number;
    entity: Subject;
    contactId: number;
    id: number;
}

export class GetNoticeForViewDto implements IGetNoticeForViewDto {
    notice!: NoticeDto;
    contactFirstName!: string | undefined;

    constructor(data?: IGetNoticeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.notice = data["notice"] ? NoticeDto.fromJS(data["notice"]) : <any>undefined;
            this.contactFirstName = data["contactFirstName"];
        }
    }

    static fromJS(data: any): GetNoticeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetNoticeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notice"] = this.notice ? this.notice.toJSON() : <any>undefined;
        data["contactFirstName"] = this.contactFirstName;
        return data; 
    }
}

export interface IGetNoticeForViewDto {
    notice: NoticeDto;
    contactFirstName: string | undefined;
}

export class PagedResultDtoOfGetNoticeForViewDto implements IPagedResultDtoOfGetNoticeForViewDto {
    totalCount!: number;
    items!: GetNoticeForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetNoticeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetNoticeForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetNoticeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetNoticeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetNoticeForViewDto {
    totalCount: number;
    items: GetNoticeForViewDto[] | undefined;
}

export class CreateOrEditNoticeDto implements ICreateOrEditNoticeDto {
    entityRef!: number;
    entity!: Subject;
    contactId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditNoticeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityRef = data["entityRef"];
            this.entity = data["entity"];
            this.contactId = data["contactId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditNoticeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditNoticeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityRef"] = this.entityRef;
        data["entity"] = this.entity;
        data["contactId"] = this.contactId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditNoticeDto {
    entityRef: number;
    entity: Subject;
    contactId: number;
    id: number | undefined;
}

export class GetNoticeForEditOutput implements IGetNoticeForEditOutput {
    notice!: CreateOrEditNoticeDto;
    contactFirstName!: string | undefined;

    constructor(data?: IGetNoticeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.notice = data["notice"] ? CreateOrEditNoticeDto.fromJS(data["notice"]) : <any>undefined;
            this.contactFirstName = data["contactFirstName"];
        }
    }

    static fromJS(data: any): GetNoticeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNoticeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notice"] = this.notice ? this.notice.toJSON() : <any>undefined;
        data["contactFirstName"] = this.contactFirstName;
        return data; 
    }
}

export interface IGetNoticeForEditOutput {
    notice: CreateOrEditNoticeDto;
    contactFirstName: string | undefined;
}

export class NoticeContactLookupTableDto implements INoticeContactLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: INoticeContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): NoticeContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new NoticeContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface INoticeContactLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export enum UserNotificationState {
    Unread = 0,
    Read = 1,
}

export class NotificationData implements INotificationData {
    readonly type!: string | undefined;
    properties!: { [key: string]: any; } | undefined;

    constructor(data?: INotificationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            (<any>this).type = data["type"];
            if (data["properties"]) {
                this.properties = {} as any;
                for (let key in data["properties"]) {
                    if (data["properties"].hasOwnProperty(key))
                        this.properties![key] = data["properties"][key];
                }
            }
        }
    }

    static fromJS(data: any): NotificationData {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    data["properties"][key] = this.properties[key];
            }
        }
        return data; 
    }
}

export interface INotificationData {
    type: string | undefined;
    properties: { [key: string]: any; } | undefined;
}

export enum NotificationSeverity {
    Info = 0,
    Success = 1,
    Warn = 2,
    Error = 3,
    Fatal = 4,
}

export class TenantNotification implements ITenantNotification {
    tenantId!: number | undefined;
    notificationName!: string | undefined;
    data!: NotificationData;
    entityType!: string | undefined;
    entityTypeName!: string | undefined;
    entityId!: any | undefined;
    severity!: NotificationSeverity;
    creationTime!: moment.Moment;
    id!: string;

    constructor(data?: ITenantNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.notificationName = data["notificationName"];
            this.data = data["data"] ? NotificationData.fromJS(data["data"]) : <any>undefined;
            this.entityType = data["entityType"];
            this.entityTypeName = data["entityTypeName"];
            this.entityId = data["entityId"];
            this.severity = data["severity"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenantNotification {
        data = typeof data === 'object' ? data : {};
        let result = new TenantNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["notificationName"] = this.notificationName;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["entityType"] = this.entityType;
        data["entityTypeName"] = this.entityTypeName;
        data["entityId"] = this.entityId;
        data["severity"] = this.severity;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenantNotification {
    tenantId: number | undefined;
    notificationName: string | undefined;
    data: NotificationData;
    entityType: string | undefined;
    entityTypeName: string | undefined;
    entityId: any | undefined;
    severity: NotificationSeverity;
    creationTime: moment.Moment;
    id: string;
}

export class UserNotification implements IUserNotification {
    tenantId!: number | undefined;
    userId!: number;
    state!: UserNotificationState;
    notification!: TenantNotification;
    id!: string;

    constructor(data?: IUserNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.state = data["state"];
            this.notification = data["notification"] ? TenantNotification.fromJS(data["notification"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserNotification {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["state"] = this.state;
        data["notification"] = this.notification ? this.notification.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserNotification {
    tenantId: number | undefined;
    userId: number;
    state: UserNotificationState;
    notification: TenantNotification;
    id: string;
}

export class GetNotificationsOutput implements IGetNotificationsOutput {
    unreadCount!: number;
    totalCount!: number;
    items!: UserNotification[] | undefined;

    constructor(data?: IGetNotificationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unreadCount = data["unreadCount"];
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(UserNotification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unreadCount"] = this.unreadCount;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetNotificationsOutput {
    unreadCount: number;
    totalCount: number;
    items: UserNotification[] | undefined;
}

export class EntityDtoOfGuid implements IEntityDtoOfGuid {
    id!: string;

    constructor(data?: IEntityDtoOfGuid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfGuid {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfGuid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IEntityDtoOfGuid {
    id: string;
}

export class NotificationSubscriptionWithDisplayNameDto implements INotificationSubscriptionWithDisplayNameDto {
    displayName!: string | undefined;
    description!: string | undefined;
    name!: string | undefined;
    isSubscribed!: boolean;

    constructor(data?: INotificationSubscriptionWithDisplayNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.name = data["name"];
            this.isSubscribed = data["isSubscribed"];
        }
    }

    static fromJS(data: any): NotificationSubscriptionWithDisplayNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSubscriptionWithDisplayNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data; 
    }
}

export interface INotificationSubscriptionWithDisplayNameDto {
    displayName: string | undefined;
    description: string | undefined;
    name: string | undefined;
    isSubscribed: boolean;
}

export class GetNotificationSettingsOutput implements IGetNotificationSettingsOutput {
    receiveNotifications!: boolean;
    notifications!: NotificationSubscriptionWithDisplayNameDto[] | undefined;

    constructor(data?: IGetNotificationSettingsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.receiveNotifications = data["receiveNotifications"];
            if (Array.isArray(data["notifications"])) {
                this.notifications = [] as any;
                for (let item of data["notifications"])
                    this.notifications!.push(NotificationSubscriptionWithDisplayNameDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationSettingsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationSettingsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetNotificationSettingsOutput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionWithDisplayNameDto[] | undefined;
}

export class NotificationSubscriptionDto implements INotificationSubscriptionDto {
    name!: string | undefined;
    isSubscribed!: boolean;

    constructor(data?: INotificationSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.isSubscribed = data["isSubscribed"];
        }
    }

    static fromJS(data: any): NotificationSubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data; 
    }
}

export interface INotificationSubscriptionDto {
    name: string | undefined;
    isSubscribed: boolean;
}

export class UpdateNotificationSettingsInput implements IUpdateNotificationSettingsInput {
    receiveNotifications!: boolean;
    notifications!: NotificationSubscriptionDto[] | undefined;

    constructor(data?: IUpdateNotificationSettingsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.receiveNotifications = data["receiveNotifications"];
            if (Array.isArray(data["notifications"])) {
                this.notifications = [] as any;
                for (let item of data["notifications"])
                    this.notifications!.push(NotificationSubscriptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateNotificationSettingsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNotificationSettingsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateNotificationSettingsInput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionDto[] | undefined;
}

export class NotificationKeyDto implements INotificationKeyDto {
    deviceId!: string | undefined;
    contactRef!: number | undefined;
    id!: number;

    constructor(data?: INotificationKeyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceId = data["deviceId"];
            this.contactRef = data["contactRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): NotificationKeyDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationKeyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["contactRef"] = this.contactRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface INotificationKeyDto {
    deviceId: string | undefined;
    contactRef: number | undefined;
    id: number;
}

export class GetNotificationKeyForViewDto implements IGetNotificationKeyForViewDto {
    notificationKey!: NotificationKeyDto;
    contactFirstName!: string | undefined;

    constructor(data?: IGetNotificationKeyForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.notificationKey = data["notificationKey"] ? NotificationKeyDto.fromJS(data["notificationKey"]) : <any>undefined;
            this.contactFirstName = data["contactFirstName"];
        }
    }

    static fromJS(data: any): GetNotificationKeyForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationKeyForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationKey"] = this.notificationKey ? this.notificationKey.toJSON() : <any>undefined;
        data["contactFirstName"] = this.contactFirstName;
        return data; 
    }
}

export interface IGetNotificationKeyForViewDto {
    notificationKey: NotificationKeyDto;
    contactFirstName: string | undefined;
}

export class PagedResultDtoOfGetNotificationKeyForViewDto implements IPagedResultDtoOfGetNotificationKeyForViewDto {
    totalCount!: number;
    items!: GetNotificationKeyForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetNotificationKeyForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetNotificationKeyForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetNotificationKeyForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetNotificationKeyForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetNotificationKeyForViewDto {
    totalCount: number;
    items: GetNotificationKeyForViewDto[] | undefined;
}

export class CreateOrEditNotificationKeyDto implements ICreateOrEditNotificationKeyDto {
    deviceId!: string | undefined;
    contactRef!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditNotificationKeyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceId = data["deviceId"];
            this.contactRef = data["contactRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditNotificationKeyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditNotificationKeyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["contactRef"] = this.contactRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditNotificationKeyDto {
    deviceId: string | undefined;
    contactRef: number | undefined;
    id: number | undefined;
}

export class GetNotificationKeyForEditOutput implements IGetNotificationKeyForEditOutput {
    notificationKey!: CreateOrEditNotificationKeyDto;
    contactFirstName!: string | undefined;

    constructor(data?: IGetNotificationKeyForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.notificationKey = data["notificationKey"] ? CreateOrEditNotificationKeyDto.fromJS(data["notificationKey"]) : <any>undefined;
            this.contactFirstName = data["contactFirstName"];
        }
    }

    static fromJS(data: any): GetNotificationKeyForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationKeyForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationKey"] = this.notificationKey ? this.notificationKey.toJSON() : <any>undefined;
        data["contactFirstName"] = this.contactFirstName;
        return data; 
    }
}

export interface IGetNotificationKeyForEditOutput {
    notificationKey: CreateOrEditNotificationKeyDto;
    contactFirstName: string | undefined;
}

export class NotificationKeyContactLookupTableDto implements INotificationKeyContactLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: INotificationKeyContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): NotificationKeyContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationKeyContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface INotificationKeyContactLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfNotificationKeyContactLookupTableDto implements IPagedResultDtoOfNotificationKeyContactLookupTableDto {
    totalCount!: number;
    items!: NotificationKeyContactLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfNotificationKeyContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(NotificationKeyContactLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfNotificationKeyContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfNotificationKeyContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfNotificationKeyContactLookupTableDto {
    totalCount: number;
    items: NotificationKeyContactLookupTableDto[] | undefined;
}

export class NotifyJobDto implements INotifyJobDto {
    entityRef!: number;
    entity!: Entities;
    jobId!: number;
    isDelete!: boolean;
    exeptionDescription!: string | undefined;
    id!: number;

    constructor(data?: INotifyJobDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityRef = data["entityRef"];
            this.entity = data["entity"];
            this.jobId = data["jobId"];
            this.isDelete = data["isDelete"];
            this.exeptionDescription = data["exeptionDescription"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): NotifyJobDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotifyJobDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityRef"] = this.entityRef;
        data["entity"] = this.entity;
        data["jobId"] = this.jobId;
        data["isDelete"] = this.isDelete;
        data["exeptionDescription"] = this.exeptionDescription;
        data["id"] = this.id;
        return data; 
    }
}

export interface INotifyJobDto {
    entityRef: number;
    entity: Entities;
    jobId: number;
    isDelete: boolean;
    exeptionDescription: string | undefined;
    id: number;
}

export class GetNotifyJobForViewDto implements IGetNotifyJobForViewDto {
    notifyJob!: NotifyJobDto;

    constructor(data?: IGetNotifyJobForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.notifyJob = data["notifyJob"] ? NotifyJobDto.fromJS(data["notifyJob"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetNotifyJobForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotifyJobForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notifyJob"] = this.notifyJob ? this.notifyJob.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetNotifyJobForViewDto {
    notifyJob: NotifyJobDto;
}

export class PagedResultDtoOfGetNotifyJobForViewDto implements IPagedResultDtoOfGetNotifyJobForViewDto {
    totalCount!: number;
    items!: GetNotifyJobForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetNotifyJobForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetNotifyJobForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetNotifyJobForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetNotifyJobForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetNotifyJobForViewDto {
    totalCount: number;
    items: GetNotifyJobForViewDto[] | undefined;
}

export class CreateOrEditNotifyJobDto implements ICreateOrEditNotifyJobDto {
    entityRef!: number;
    entity!: Entities;
    jobId!: number;
    isDelete!: boolean;
    exeptionDescription!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditNotifyJobDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityRef = data["entityRef"];
            this.entity = data["entity"];
            this.jobId = data["jobId"];
            this.isDelete = data["isDelete"];
            this.exeptionDescription = data["exeptionDescription"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditNotifyJobDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditNotifyJobDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityRef"] = this.entityRef;
        data["entity"] = this.entity;
        data["jobId"] = this.jobId;
        data["isDelete"] = this.isDelete;
        data["exeptionDescription"] = this.exeptionDescription;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditNotifyJobDto {
    entityRef: number;
    entity: Entities;
    jobId: number;
    isDelete: boolean;
    exeptionDescription: string | undefined;
    id: number | undefined;
}

export class GetNotifyJobForEditOutput implements IGetNotifyJobForEditOutput {
    notifyJob!: CreateOrEditNotifyJobDto;

    constructor(data?: IGetNotifyJobForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.notifyJob = data["notifyJob"] ? CreateOrEditNotifyJobDto.fromJS(data["notifyJob"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetNotifyJobForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotifyJobForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notifyJob"] = this.notifyJob ? this.notifyJob.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetNotifyJobForEditOutput {
    notifyJob: CreateOrEditNotifyJobDto;
}

export class OrganizationUnitDto implements IOrganizationUnitDto {
    parentId!: number | undefined;
    code!: string | undefined;
    displayName!: string | undefined;
    memberCount!: number;
    roleCount!: number;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentId = data["parentId"];
            this.code = data["code"];
            this.displayName = data["displayName"];
            this.memberCount = data["memberCount"];
            this.roleCount = data["roleCount"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["memberCount"] = this.memberCount;
        data["roleCount"] = this.roleCount;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IOrganizationUnitDto {
    parentId: number | undefined;
    code: string | undefined;
    displayName: string | undefined;
    memberCount: number;
    roleCount: number;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ListResultDtoOfOrganizationUnitDto implements IListResultDtoOfOrganizationUnitDto {
    items!: OrganizationUnitDto[] | undefined;

    constructor(data?: IListResultDtoOfOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(OrganizationUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfOrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfOrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfOrganizationUnitDto {
    items: OrganizationUnitDto[] | undefined;
}

export class OrganizationUnitUserListDto implements IOrganizationUnitUserListDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    profilePictureId!: string | undefined;
    addedTime!: moment.Moment;
    id!: number;

    constructor(data?: IOrganizationUnitUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.profilePictureId = data["profilePictureId"];
            this.addedTime = data["addedTime"] ? moment(data["addedTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["addedTime"] = this.addedTime ? this.addedTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IOrganizationUnitUserListDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    addedTime: moment.Moment;
    id: number;
}

export class PagedResultDtoOfOrganizationUnitUserListDto implements IPagedResultDtoOfOrganizationUnitUserListDto {
    totalCount!: number;
    items!: OrganizationUnitUserListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOrganizationUnitUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(OrganizationUnitUserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrganizationUnitUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrganizationUnitUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfOrganizationUnitUserListDto {
    totalCount: number;
    items: OrganizationUnitUserListDto[] | undefined;
}

export class OrganizationUnitRoleListDto implements IOrganizationUnitRoleListDto {
    displayName!: string | undefined;
    name!: string | undefined;
    addedTime!: moment.Moment;
    id!: number;

    constructor(data?: IOrganizationUnitRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.displayName = data["displayName"];
            this.name = data["name"];
            this.addedTime = data["addedTime"] ? moment(data["addedTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["name"] = this.name;
        data["addedTime"] = this.addedTime ? this.addedTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IOrganizationUnitRoleListDto {
    displayName: string | undefined;
    name: string | undefined;
    addedTime: moment.Moment;
    id: number;
}

export class PagedResultDtoOfOrganizationUnitRoleListDto implements IPagedResultDtoOfOrganizationUnitRoleListDto {
    totalCount!: number;
    items!: OrganizationUnitRoleListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOrganizationUnitRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(OrganizationUnitRoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrganizationUnitRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrganizationUnitRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfOrganizationUnitRoleListDto {
    totalCount: number;
    items: OrganizationUnitRoleListDto[] | undefined;
}

export class CreateOrganizationUnitInput implements ICreateOrganizationUnitInput {
    parentId!: number | undefined;
    displayName!: string | undefined;

    constructor(data?: ICreateOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentId = data["parentId"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): CreateOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ICreateOrganizationUnitInput {
    parentId: number | undefined;
    displayName: string | undefined;
}

export class UpdateOrganizationUnitInput implements IUpdateOrganizationUnitInput {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IUpdateOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): UpdateOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IUpdateOrganizationUnitInput {
    id: number;
    displayName: string | undefined;
}

export class MoveOrganizationUnitInput implements IMoveOrganizationUnitInput {
    id!: number;
    newParentId!: number | undefined;

    constructor(data?: IMoveOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.newParentId = data["newParentId"];
        }
    }

    static fromJS(data: any): MoveOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new MoveOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newParentId"] = this.newParentId;
        return data; 
    }
}

export interface IMoveOrganizationUnitInput {
    id: number;
    newParentId: number | undefined;
}

export class UsersToOrganizationUnitInput implements IUsersToOrganizationUnitInput {
    userIds!: number[] | undefined;
    organizationUnitId!: number;

    constructor(data?: IUsersToOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["userIds"])) {
                this.userIds = [] as any;
                for (let item of data["userIds"])
                    this.userIds!.push(item);
            }
            this.organizationUnitId = data["organizationUnitId"];
        }
    }

    static fromJS(data: any): UsersToOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new UsersToOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["organizationUnitId"] = this.organizationUnitId;
        return data; 
    }
}

export interface IUsersToOrganizationUnitInput {
    userIds: number[] | undefined;
    organizationUnitId: number;
}

export class RolesToOrganizationUnitInput implements IRolesToOrganizationUnitInput {
    roleIds!: number[] | undefined;
    organizationUnitId!: number;

    constructor(data?: IRolesToOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of data["roleIds"])
                    this.roleIds!.push(item);
            }
            this.organizationUnitId = data["organizationUnitId"];
        }
    }

    static fromJS(data: any): RolesToOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new RolesToOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        data["organizationUnitId"] = this.organizationUnitId;
        return data; 
    }
}

export interface IRolesToOrganizationUnitInput {
    roleIds: number[] | undefined;
    organizationUnitId: number;
}

export class FindOrganizationUnitUsersInput implements IFindOrganizationUnitUsersInput {
    organizationUnitId!: number;
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | undefined;

    constructor(data?: IFindOrganizationUnitUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.organizationUnitId = data["organizationUnitId"];
            this.maxResultCount = data["maxResultCount"];
            this.skipCount = data["skipCount"];
            this.filter = data["filter"];
        }
    }

    static fromJS(data: any): FindOrganizationUnitUsersInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindOrganizationUnitUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitId"] = this.organizationUnitId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data; 
    }
}

export interface IFindOrganizationUnitUsersInput {
    organizationUnitId: number;
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
}

export class FindOrganizationUnitRolesInput implements IFindOrganizationUnitRolesInput {
    organizationUnitId!: number;
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | undefined;

    constructor(data?: IFindOrganizationUnitRolesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.organizationUnitId = data["organizationUnitId"];
            this.maxResultCount = data["maxResultCount"];
            this.skipCount = data["skipCount"];
            this.filter = data["filter"];
        }
    }

    static fromJS(data: any): FindOrganizationUnitRolesInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindOrganizationUnitRolesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitId"] = this.organizationUnitId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data; 
    }
}

export interface IFindOrganizationUnitRolesInput {
    organizationUnitId: number;
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
}

export class EditionSelectDto implements IEditionSelectDto {
    id!: number;
    name!: string | undefined;
    displayName!: string | undefined;
    expiringEditionId!: number | undefined;
    dailyPrice!: number | undefined;
    weeklyPrice!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    trialDayCount!: number | undefined;
    waitingDayAfterExpire!: number | undefined;
    isFree!: boolean;
    additionalData!: AdditionalData | undefined;

    constructor(data?: IEditionSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.expiringEditionId = data["expiringEditionId"];
            this.dailyPrice = data["dailyPrice"];
            this.weeklyPrice = data["weeklyPrice"];
            this.monthlyPrice = data["monthlyPrice"];
            this.annualPrice = data["annualPrice"];
            this.trialDayCount = data["trialDayCount"];
            this.waitingDayAfterExpire = data["waitingDayAfterExpire"];
            this.isFree = data["isFree"];
            this.additionalData = data["additionalData"] ? AdditionalData.fromJS(data["additionalData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EditionSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["expiringEditionId"] = this.expiringEditionId;
        data["dailyPrice"] = this.dailyPrice;
        data["weeklyPrice"] = this.weeklyPrice;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["isFree"] = this.isFree;
        data["additionalData"] = this.additionalData ? this.additionalData.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IEditionSelectDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    expiringEditionId: number | undefined;
    dailyPrice: number | undefined;
    weeklyPrice: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    trialDayCount: number | undefined;
    waitingDayAfterExpire: number | undefined;
    isFree: boolean;
    additionalData: AdditionalData | undefined;
}

export class PaymentInfoDto implements IPaymentInfoDto {
    edition!: EditionSelectDto;
    additionalPrice!: number;

    constructor(data?: IPaymentInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.edition = data["edition"] ? EditionSelectDto.fromJS(data["edition"]) : <any>undefined;
            this.additionalPrice = data["additionalPrice"];
        }
    }

    static fromJS(data: any): PaymentInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        data["additionalPrice"] = this.additionalPrice;
        return data; 
    }
}

export interface IPaymentInfoDto {
    edition: EditionSelectDto;
    additionalPrice: number;
}

export enum EditionPaymentType {
    NewRegistration = 0,
    BuyNow = 1,
    Upgrade = 2,
    Extend = 3,
}

export enum PaymentPeriodType {
    Daily = 1,
    Weekly = 7,
    Monthly = 30,
    Annual = 365,
}

export enum SubscriptionPaymentGatewayType {
    Paypal = 1,
    Stripe = 2,
}

export class CreatePaymentDto implements ICreatePaymentDto {
    editionId!: number;
    editionPaymentType!: EditionPaymentType;
    paymentPeriodType!: PaymentPeriodType;
    subscriptionPaymentGatewayType!: SubscriptionPaymentGatewayType;
    recurringPaymentEnabled!: boolean;
    successUrl!: string | undefined;
    errorUrl!: string | undefined;

    constructor(data?: ICreatePaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.editionId = data["editionId"];
            this.editionPaymentType = data["editionPaymentType"];
            this.paymentPeriodType = data["paymentPeriodType"];
            this.subscriptionPaymentGatewayType = data["subscriptionPaymentGatewayType"];
            this.recurringPaymentEnabled = data["recurringPaymentEnabled"];
            this.successUrl = data["successUrl"];
            this.errorUrl = data["errorUrl"];
        }
    }

    static fromJS(data: any): CreatePaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["editionId"] = this.editionId;
        data["editionPaymentType"] = this.editionPaymentType;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["subscriptionPaymentGatewayType"] = this.subscriptionPaymentGatewayType;
        data["recurringPaymentEnabled"] = this.recurringPaymentEnabled;
        data["successUrl"] = this.successUrl;
        data["errorUrl"] = this.errorUrl;
        return data; 
    }
}

export interface ICreatePaymentDto {
    editionId: number;
    editionPaymentType: EditionPaymentType;
    paymentPeriodType: PaymentPeriodType;
    subscriptionPaymentGatewayType: SubscriptionPaymentGatewayType;
    recurringPaymentEnabled: boolean;
    successUrl: string | undefined;
    errorUrl: string | undefined;
}

export class CancelPaymentDto implements ICancelPaymentDto {
    paymentId!: string | undefined;
    gateway!: SubscriptionPaymentGatewayType;

    constructor(data?: ICancelPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paymentId = data["paymentId"];
            this.gateway = data["gateway"];
        }
    }

    static fromJS(data: any): CancelPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CancelPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["gateway"] = this.gateway;
        return data; 
    }
}

export interface ICancelPaymentDto {
    paymentId: string | undefined;
    gateway: SubscriptionPaymentGatewayType;
}

export class SubscriptionPaymentListDto implements ISubscriptionPaymentListDto {
    gateway!: string | undefined;
    amount!: number;
    editionId!: number;
    dayCount!: number;
    paymentPeriodType!: string | undefined;
    externalPaymentId!: string | undefined;
    payerId!: string | undefined;
    status!: string | undefined;
    editionDisplayName!: string | undefined;
    tenantId!: number;
    invoiceNo!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ISubscriptionPaymentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gateway = data["gateway"];
            this.amount = data["amount"];
            this.editionId = data["editionId"];
            this.dayCount = data["dayCount"];
            this.paymentPeriodType = data["paymentPeriodType"];
            this.externalPaymentId = data["externalPaymentId"];
            this.payerId = data["payerId"];
            this.status = data["status"];
            this.editionDisplayName = data["editionDisplayName"];
            this.tenantId = data["tenantId"];
            this.invoiceNo = data["invoiceNo"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SubscriptionPaymentListDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionPaymentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gateway"] = this.gateway;
        data["amount"] = this.amount;
        data["editionId"] = this.editionId;
        data["dayCount"] = this.dayCount;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["externalPaymentId"] = this.externalPaymentId;
        data["payerId"] = this.payerId;
        data["status"] = this.status;
        data["editionDisplayName"] = this.editionDisplayName;
        data["tenantId"] = this.tenantId;
        data["invoiceNo"] = this.invoiceNo;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISubscriptionPaymentListDto {
    gateway: string | undefined;
    amount: number;
    editionId: number;
    dayCount: number;
    paymentPeriodType: string | undefined;
    externalPaymentId: string | undefined;
    payerId: string | undefined;
    status: string | undefined;
    editionDisplayName: string | undefined;
    tenantId: number;
    invoiceNo: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class PagedResultDtoOfSubscriptionPaymentListDto implements IPagedResultDtoOfSubscriptionPaymentListDto {
    totalCount!: number;
    items!: SubscriptionPaymentListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSubscriptionPaymentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(SubscriptionPaymentListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSubscriptionPaymentListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSubscriptionPaymentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfSubscriptionPaymentListDto {
    totalCount: number;
    items: SubscriptionPaymentListDto[] | undefined;
}

export class PaymentGatewayModel implements IPaymentGatewayModel {
    gatewayType!: SubscriptionPaymentGatewayType;
    supportsRecurringPayments!: boolean;

    constructor(data?: IPaymentGatewayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gatewayType = data["gatewayType"];
            this.supportsRecurringPayments = data["supportsRecurringPayments"];
        }
    }

    static fromJS(data: any): PaymentGatewayModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentGatewayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatewayType"] = this.gatewayType;
        data["supportsRecurringPayments"] = this.supportsRecurringPayments;
        return data; 
    }
}

export interface IPaymentGatewayModel {
    gatewayType: SubscriptionPaymentGatewayType;
    supportsRecurringPayments: boolean;
}

export enum SubscriptionPaymentStatus {
    NotPaid = 1,
    Paid = 2,
    Failed = 3,
    Cancelled = 4,
    Completed = 5,
}

export class SubscriptionPaymentDto implements ISubscriptionPaymentDto {
    description!: string | undefined;
    gateway!: SubscriptionPaymentGatewayType;
    amount!: number;
    editionId!: number;
    tenantId!: number;
    dayCount!: number;
    paymentPeriodType!: PaymentPeriodType;
    paymentId!: string | undefined;
    payerId!: string | undefined;
    editionDisplayName!: string | undefined;
    invoiceNo!: number;
    status!: SubscriptionPaymentStatus;
    isRecurring!: boolean;
    externalPaymentId!: string | undefined;
    successUrl!: string | undefined;
    errorUrl!: string | undefined;
    editionPaymentType!: EditionPaymentType;
    id!: number;

    constructor(data?: ISubscriptionPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.gateway = data["gateway"];
            this.amount = data["amount"];
            this.editionId = data["editionId"];
            this.tenantId = data["tenantId"];
            this.dayCount = data["dayCount"];
            this.paymentPeriodType = data["paymentPeriodType"];
            this.paymentId = data["paymentId"];
            this.payerId = data["payerId"];
            this.editionDisplayName = data["editionDisplayName"];
            this.invoiceNo = data["invoiceNo"];
            this.status = data["status"];
            this.isRecurring = data["isRecurring"];
            this.externalPaymentId = data["externalPaymentId"];
            this.successUrl = data["successUrl"];
            this.errorUrl = data["errorUrl"];
            this.editionPaymentType = data["editionPaymentType"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SubscriptionPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["gateway"] = this.gateway;
        data["amount"] = this.amount;
        data["editionId"] = this.editionId;
        data["tenantId"] = this.tenantId;
        data["dayCount"] = this.dayCount;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["paymentId"] = this.paymentId;
        data["payerId"] = this.payerId;
        data["editionDisplayName"] = this.editionDisplayName;
        data["invoiceNo"] = this.invoiceNo;
        data["status"] = this.status;
        data["isRecurring"] = this.isRecurring;
        data["externalPaymentId"] = this.externalPaymentId;
        data["successUrl"] = this.successUrl;
        data["errorUrl"] = this.errorUrl;
        data["editionPaymentType"] = this.editionPaymentType;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISubscriptionPaymentDto {
    description: string | undefined;
    gateway: SubscriptionPaymentGatewayType;
    amount: number;
    editionId: number;
    tenantId: number;
    dayCount: number;
    paymentPeriodType: PaymentPeriodType;
    paymentId: string | undefined;
    payerId: string | undefined;
    editionDisplayName: string | undefined;
    invoiceNo: number;
    status: SubscriptionPaymentStatus;
    isRecurring: boolean;
    externalPaymentId: string | undefined;
    successUrl: string | undefined;
    errorUrl: string | undefined;
    editionPaymentType: EditionPaymentType;
    id: number;
}

export class PagedResultDtoOfGetPaymentForViewDto implements IPagedResultDtoOfGetPaymentForViewDto {
    totalCount!: number;
    items!: GetPaymentForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetPaymentForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetPaymentForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetPaymentForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetPaymentForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetPaymentForViewDto {
    totalCount: number;
    items: GetPaymentForViewDto[] | undefined;
}

export class GetPaymentForEditOutput implements IGetPaymentForEditOutput {
    payment!: CreateOrEditPaymentDto;
    bankAccountAccountNumber!: string | undefined;

    constructor(data?: IGetPaymentForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.payment = data["payment"] ? CreateOrEditPaymentDto.fromJS(data["payment"]) : <any>undefined;
            this.bankAccountAccountNumber = data["bankAccountAccountNumber"];
        }
    }

    static fromJS(data: any): GetPaymentForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        data["bankAccountAccountNumber"] = this.bankAccountAccountNumber;
        return data; 
    }
}

export interface IGetPaymentForEditOutput {
    payment: CreateOrEditPaymentDto;
    bankAccountAccountNumber: string | undefined;
}

export class DocumentModel implements IDocumentModel {
    name!: string | undefined;
    type!: string | undefined;
    path!: string | undefined;
    size!: number;

    constructor(data?: IDocumentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.type = data["type"];
            this.path = data["path"];
            this.size = data["size"];
        }
    }

    static fromJS(data: any): DocumentModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        data["path"] = this.path;
        data["size"] = this.size;
        return data; 
    }
}

export interface IDocumentModel {
    name: string | undefined;
    type: string | undefined;
    path: string | undefined;
    size: number;
}

export class PaymentAndBillInput implements IPaymentAndBillInput {
    payment!: PaymentDto;
    scanDocument!: DocumentModel;
    billsId!: number[] | undefined;
    address!: AddressForPaymentDto;

    constructor(data?: IPaymentAndBillInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.payment = data["payment"] ? PaymentDto.fromJS(data["payment"]) : <any>undefined;
            this.scanDocument = data["scanDocument"] ? DocumentModel.fromJS(data["scanDocument"]) : <any>undefined;
            if (Array.isArray(data["billsId"])) {
                this.billsId = [] as any;
                for (let item of data["billsId"])
                    this.billsId!.push(item);
            }
            this.address = data["address"] ? AddressForPaymentDto.fromJS(data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PaymentAndBillInput {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentAndBillInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        data["scanDocument"] = this.scanDocument ? this.scanDocument.toJSON() : <any>undefined;
        if (Array.isArray(this.billsId)) {
            data["billsId"] = [];
            for (let item of this.billsId)
                data["billsId"].push(item);
        }
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IPaymentAndBillInput {
    payment: PaymentDto;
    scanDocument: DocumentModel;
    billsId: number[] | undefined;
    address: AddressForPaymentDto;
}

export class PaymentBankAccountLookupTableDto implements IPaymentBankAccountLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    logo!: string | undefined;

    constructor(data?: IPaymentBankAccountLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.logo = data["logo"];
        }
    }

    static fromJS(data: any): PaymentBankAccountLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentBankAccountLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["logo"] = this.logo;
        return data; 
    }
}

export interface IPaymentBankAccountLookupTableDto {
    id: number;
    displayName: string | undefined;
    logo: string | undefined;
}

export class PagedResultDtoOfPaymentBankAccountLookupTableDto implements IPagedResultDtoOfPaymentBankAccountLookupTableDto {
    totalCount!: number;
    items!: PaymentBankAccountLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPaymentBankAccountLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(PaymentBankAccountLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPaymentBankAccountLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPaymentBankAccountLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfPaymentBankAccountLookupTableDto {
    totalCount: number;
    items: PaymentBankAccountLookupTableDto[] | undefined;
}

export enum PSP {
    Default = 0,
    BehPardakht = 1,
    SEP = 2,
}

export class PaymentPosLookupTableDto implements IPaymentPosLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    pcToPos!: boolean;
    port!: string | undefined;
    ip!: string | undefined;
    systemIP!: string | undefined;
    logo!: string | undefined;
    bankName!: string | undefined;
    serial!: string | undefined;
    acceptorNumber!: string | undefined;
    psp!: PSP;
    accountNumber!: string | undefined;
    posIdentity!: string | undefined;

    constructor(data?: IPaymentPosLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.pcToPos = data["pcToPos"];
            this.port = data["port"];
            this.ip = data["ip"];
            this.systemIP = data["systemIP"];
            this.logo = data["logo"];
            this.bankName = data["bankName"];
            this.serial = data["serial"];
            this.acceptorNumber = data["acceptorNumber"];
            this.psp = data["psp"];
            this.accountNumber = data["accountNumber"];
            this.posIdentity = data["posIdentity"];
        }
    }

    static fromJS(data: any): PaymentPosLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentPosLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["pcToPos"] = this.pcToPos;
        data["port"] = this.port;
        data["ip"] = this.ip;
        data["systemIP"] = this.systemIP;
        data["logo"] = this.logo;
        data["bankName"] = this.bankName;
        data["serial"] = this.serial;
        data["acceptorNumber"] = this.acceptorNumber;
        data["psp"] = this.psp;
        data["accountNumber"] = this.accountNumber;
        data["posIdentity"] = this.posIdentity;
        return data; 
    }
}

export interface IPaymentPosLookupTableDto {
    id: number;
    displayName: string | undefined;
    pcToPos: boolean;
    port: string | undefined;
    ip: string | undefined;
    systemIP: string | undefined;
    logo: string | undefined;
    bankName: string | undefined;
    serial: string | undefined;
    acceptorNumber: string | undefined;
    psp: PSP;
    accountNumber: string | undefined;
    posIdentity: string | undefined;
}

export class PagedResultDtoOfPaymentPosLookupTableDto implements IPagedResultDtoOfPaymentPosLookupTableDto {
    totalCount!: number;
    items!: PaymentPosLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPaymentPosLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(PaymentPosLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPaymentPosLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPaymentPosLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfPaymentPosLookupTableDto {
    totalCount: number;
    items: PaymentPosLookupTableDto[] | undefined;
}

export class PcToPosInput implements IPcToPosInput {
    posId!: number;
    amount!: string | undefined;

    constructor(data?: IPcToPosInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.posId = data["posId"];
            this.amount = data["amount"];
        }
    }

    static fromJS(data: any): PcToPosInput {
        data = typeof data === 'object' ? data : {};
        let result = new PcToPosInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["posId"] = this.posId;
        data["amount"] = this.amount;
        return data; 
    }
}

export interface IPcToPosInput {
    posId: number;
    amount: string | undefined;
}

export class PcToPosOutputDto implements IPcToPosOutputDto {
    serrialNo!: string | undefined;
    trackingNo!: string | undefined;
    pan!: string | undefined;
    date!: string | undefined;
    time!: string | undefined;

    constructor(data?: IPcToPosOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serrialNo = data["serrialNo"];
            this.trackingNo = data["trackingNo"];
            this.pan = data["pan"];
            this.date = data["date"];
            this.time = data["time"];
        }
    }

    static fromJS(data: any): PcToPosOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PcToPosOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serrialNo"] = this.serrialNo;
        data["trackingNo"] = this.trackingNo;
        data["pan"] = this.pan;
        data["date"] = this.date;
        data["time"] = this.time;
        return data; 
    }
}

export interface IPcToPosOutputDto {
    serrialNo: string | undefined;
    trackingNo: string | undefined;
    pan: string | undefined;
    date: string | undefined;
    time: string | undefined;
}

export class GetAllNotConnectedBillsDto implements IGetAllNotConnectedBillsDto {
    bill!: BillDto;
    benefactorName!: string | undefined;
    currencyName!: string | undefined;
    planConstTitle!: string | undefined;
    hasPrice!: boolean;
    check!: boolean;

    constructor(data?: IGetAllNotConnectedBillsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bill = data["bill"] ? BillDto.fromJS(data["bill"]) : <any>undefined;
            this.benefactorName = data["benefactorName"];
            this.currencyName = data["currencyName"];
            this.planConstTitle = data["planConstTitle"];
            this.hasPrice = data["hasPrice"];
            this.check = data["check"];
        }
    }

    static fromJS(data: any): GetAllNotConnectedBillsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllNotConnectedBillsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bill"] = this.bill ? this.bill.toJSON() : <any>undefined;
        data["benefactorName"] = this.benefactorName;
        data["currencyName"] = this.currencyName;
        data["planConstTitle"] = this.planConstTitle;
        data["hasPrice"] = this.hasPrice;
        data["check"] = this.check;
        return data; 
    }
}

export interface IGetAllNotConnectedBillsDto {
    bill: BillDto;
    benefactorName: string | undefined;
    currencyName: string | undefined;
    planConstTitle: string | undefined;
    hasPrice: boolean;
    check: boolean;
}

export class PagedResultDtoOfGetAllNotConnectedBillsDto implements IPagedResultDtoOfGetAllNotConnectedBillsDto {
    totalCount!: number;
    items!: GetAllNotConnectedBillsDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAllNotConnectedBillsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetAllNotConnectedBillsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAllNotConnectedBillsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAllNotConnectedBillsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetAllNotConnectedBillsDto {
    totalCount: number;
    items: GetAllNotConnectedBillsDto[] | undefined;
}

export class ConnectBillsToPaymentsInput implements IConnectBillsToPaymentsInput {
    bills!: number[] | undefined;
    payments!: number[] | undefined;

    constructor(data?: IConnectBillsToPaymentsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["bills"])) {
                this.bills = [] as any;
                for (let item of data["bills"])
                    this.bills!.push(item);
            }
            if (Array.isArray(data["payments"])) {
                this.payments = [] as any;
                for (let item of data["payments"])
                    this.payments!.push(item);
            }
        }
    }

    static fromJS(data: any): ConnectBillsToPaymentsInput {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectBillsToPaymentsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bills)) {
            data["bills"] = [];
            for (let item of this.bills)
                data["bills"].push(item);
        }
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item);
        }
        return data; 
    }
}

export interface IConnectBillsToPaymentsInput {
    bills: number[] | undefined;
    payments: number[] | undefined;
}

export class GetPaymentBillsViewDto implements IGetPaymentBillsViewDto {
    id!: number;
    code!: string | undefined;
    issueDate!: moment.Moment;
    price!: number;
    count!: number | undefined;
    description!: string | undefined;
    dueDate!: moment.Moment | undefined;
    status!: BillStatus;
    extraEntity!: Consumers;
    extraEntityRef!: number | undefined;
    benefactorName!: string | undefined;
    currencyName!: string | undefined;
    planConstTitle!: string | undefined;
    planType!: Plans;

    constructor(data?: IGetPaymentBillsViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.code = data["code"];
            this.issueDate = data["issueDate"] ? moment(data["issueDate"].toString()) : <any>undefined;
            this.price = data["price"];
            this.count = data["count"];
            this.description = data["description"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.status = data["status"];
            this.extraEntity = data["extraEntity"];
            this.extraEntityRef = data["extraEntityRef"];
            this.benefactorName = data["benefactorName"];
            this.currencyName = data["currencyName"];
            this.planConstTitle = data["planConstTitle"];
            this.planType = data["planType"];
        }
    }

    static fromJS(data: any): GetPaymentBillsViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentBillsViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["price"] = this.price;
        data["count"] = this.count;
        data["description"] = this.description;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["extraEntity"] = this.extraEntity;
        data["extraEntityRef"] = this.extraEntityRef;
        data["benefactorName"] = this.benefactorName;
        data["currencyName"] = this.currencyName;
        data["planConstTitle"] = this.planConstTitle;
        data["planType"] = this.planType;
        return data; 
    }
}

export interface IGetPaymentBillsViewDto {
    id: number;
    code: string | undefined;
    issueDate: moment.Moment;
    price: number;
    count: number | undefined;
    description: string | undefined;
    dueDate: moment.Moment | undefined;
    status: BillStatus;
    extraEntity: Consumers;
    extraEntityRef: number | undefined;
    benefactorName: string | undefined;
    currencyName: string | undefined;
    planConstTitle: string | undefined;
    planType: Plans;
}

export class GetAllPaymentReportDto implements IGetAllPaymentReportDto {
    bills!: GetPaymentBillsViewDto[] | undefined;
    contactFirstName!: string | undefined;
    payment!: PaymentDto;
    bankAccountAccountNumber!: string | undefined;
    check!: boolean;
    paymentCreatorUser!: string | undefined;

    constructor(data?: IGetAllPaymentReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["bills"])) {
                this.bills = [] as any;
                for (let item of data["bills"])
                    this.bills!.push(GetPaymentBillsViewDto.fromJS(item));
            }
            this.contactFirstName = data["contactFirstName"];
            this.payment = data["payment"] ? PaymentDto.fromJS(data["payment"]) : <any>undefined;
            this.bankAccountAccountNumber = data["bankAccountAccountNumber"];
            this.check = data["check"];
            this.paymentCreatorUser = data["paymentCreatorUser"];
        }
    }

    static fromJS(data: any): GetAllPaymentReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllPaymentReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bills)) {
            data["bills"] = [];
            for (let item of this.bills)
                data["bills"].push(item.toJSON());
        }
        data["contactFirstName"] = this.contactFirstName;
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        data["bankAccountAccountNumber"] = this.bankAccountAccountNumber;
        data["check"] = this.check;
        data["paymentCreatorUser"] = this.paymentCreatorUser;
        return data; 
    }
}

export interface IGetAllPaymentReportDto {
    bills: GetPaymentBillsViewDto[] | undefined;
    contactFirstName: string | undefined;
    payment: PaymentDto;
    bankAccountAccountNumber: string | undefined;
    check: boolean;
    paymentCreatorUser: string | undefined;
}

export class PagedResultDtoOfGetAllPaymentReportDto implements IPagedResultDtoOfGetAllPaymentReportDto {
    totalCount!: number;
    items!: GetAllPaymentReportDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAllPaymentReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetAllPaymentReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAllPaymentReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAllPaymentReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetAllPaymentReportDto {
    totalCount: number;
    items: GetAllPaymentReportDto[] | undefined;
}

export class GetAllPaymentReport implements IGetAllPaymentReport {
    totalPrice!: number | undefined;
    list!: PagedResultDtoOfGetAllPaymentReportDto;

    constructor(data?: IGetAllPaymentReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalPrice = data["totalPrice"];
            this.list = data["list"] ? PagedResultDtoOfGetAllPaymentReportDto.fromJS(data["list"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAllPaymentReport {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllPaymentReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalPrice"] = this.totalPrice;
        data["list"] = this.list ? this.list.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetAllPaymentReport {
    totalPrice: number | undefined;
    list: PagedResultDtoOfGetAllPaymentReportDto;
}

export class PayPalConfigurationDto implements IPayPalConfigurationDto {
    clientId!: string | undefined;
    demoUsername!: string | undefined;
    demoPassword!: string | undefined;

    constructor(data?: IPayPalConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.clientId = data["clientId"];
            this.demoUsername = data["demoUsername"];
            this.demoPassword = data["demoPassword"];
        }
    }

    static fromJS(data: any): PayPalConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PayPalConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["demoUsername"] = this.demoUsername;
        data["demoPassword"] = this.demoPassword;
        return data; 
    }
}

export interface IPayPalConfigurationDto {
    clientId: string | undefined;
    demoUsername: string | undefined;
    demoPassword: string | undefined;
}

export class FlatPermissionWithLevelDto implements IFlatPermissionWithLevelDto {
    level!: number;
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    isGrantedByDefault!: boolean;

    constructor(data?: IFlatPermissionWithLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.level = data["level"];
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.isGrantedByDefault = data["isGrantedByDefault"];
        }
    }

    static fromJS(data: any): FlatPermissionWithLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionWithLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level;
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data; 
    }
}

export interface IFlatPermissionWithLevelDto {
    level: number;
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean;
}

export class ListResultDtoOfFlatPermissionWithLevelDto implements IListResultDtoOfFlatPermissionWithLevelDto {
    items!: FlatPermissionWithLevelDto[] | undefined;

    constructor(data?: IListResultDtoOfFlatPermissionWithLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(FlatPermissionWithLevelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfFlatPermissionWithLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfFlatPermissionWithLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfFlatPermissionWithLevelDto {
    items: FlatPermissionWithLevelDto[] | undefined;
}

export class PersonInquiryDto implements IPersonInquiryDto {
    code!: string | undefined;
    entity!: Entities;
    entityRef!: number;
    entityRefName!: string | undefined;
    startDate!: moment.Moment | undefined;
    inquiryDescription!: string | undefined;
    firstInquiryDate!: moment.Moment | undefined;
    firstInquirerDesc!: string | undefined;
    secondInquiryDate!: moment.Moment | undefined;
    secondInquirerDesc!: string | undefined;
    managementDescription!: string | undefined;
    relevantUnitDescription!: string | undefined;
    status!: PlanBillStatus;
    completionDate!: moment.Moment | undefined;
    id!: number;

    constructor(data?: IPersonInquiryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.entity = data["entity"];
            this.entityRef = data["entityRef"];
            this.entityRefName = data["entityRefName"];
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.inquiryDescription = data["inquiryDescription"];
            this.firstInquiryDate = data["firstInquiryDate"] ? moment(data["firstInquiryDate"].toString()) : <any>undefined;
            this.firstInquirerDesc = data["firstInquirerDesc"];
            this.secondInquiryDate = data["secondInquiryDate"] ? moment(data["secondInquiryDate"].toString()) : <any>undefined;
            this.secondInquirerDesc = data["secondInquirerDesc"];
            this.managementDescription = data["managementDescription"];
            this.relevantUnitDescription = data["relevantUnitDescription"];
            this.status = data["status"];
            this.completionDate = data["completionDate"] ? moment(data["completionDate"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PersonInquiryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonInquiryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["entity"] = this.entity;
        data["entityRef"] = this.entityRef;
        data["entityRefName"] = this.entityRefName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["inquiryDescription"] = this.inquiryDescription;
        data["firstInquiryDate"] = this.firstInquiryDate ? this.firstInquiryDate.toISOString() : <any>undefined;
        data["firstInquirerDesc"] = this.firstInquirerDesc;
        data["secondInquiryDate"] = this.secondInquiryDate ? this.secondInquiryDate.toISOString() : <any>undefined;
        data["secondInquirerDesc"] = this.secondInquirerDesc;
        data["managementDescription"] = this.managementDescription;
        data["relevantUnitDescription"] = this.relevantUnitDescription;
        data["status"] = this.status;
        data["completionDate"] = this.completionDate ? this.completionDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPersonInquiryDto {
    code: string | undefined;
    entity: Entities;
    entityRef: number;
    entityRefName: string | undefined;
    startDate: moment.Moment | undefined;
    inquiryDescription: string | undefined;
    firstInquiryDate: moment.Moment | undefined;
    firstInquirerDesc: string | undefined;
    secondInquiryDate: moment.Moment | undefined;
    secondInquirerDesc: string | undefined;
    managementDescription: string | undefined;
    relevantUnitDescription: string | undefined;
    status: PlanBillStatus;
    completionDate: moment.Moment | undefined;
    id: number;
}

export class GetPersonInquiryForViewDto implements IGetPersonInquiryForViewDto {
    personInquiry!: PersonInquiryDto;
    clientName!: string | undefined;
    familyName!: string | undefined;

    constructor(data?: IGetPersonInquiryForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.personInquiry = data["personInquiry"] ? PersonInquiryDto.fromJS(data["personInquiry"]) : <any>undefined;
            this.clientName = data["clientName"];
            this.familyName = data["familyName"];
        }
    }

    static fromJS(data: any): GetPersonInquiryForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPersonInquiryForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personInquiry"] = this.personInquiry ? this.personInquiry.toJSON() : <any>undefined;
        data["clientName"] = this.clientName;
        data["familyName"] = this.familyName;
        return data; 
    }
}

export interface IGetPersonInquiryForViewDto {
    personInquiry: PersonInquiryDto;
    clientName: string | undefined;
    familyName: string | undefined;
}

export class PagedResultDtoOfGetPersonInquiryForViewDto implements IPagedResultDtoOfGetPersonInquiryForViewDto {
    totalCount!: number;
    items!: GetPersonInquiryForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetPersonInquiryForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetPersonInquiryForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetPersonInquiryForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetPersonInquiryForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetPersonInquiryForViewDto {
    totalCount: number;
    items: GetPersonInquiryForViewDto[] | undefined;
}

export class CreateOrEditPersonInquiryDto implements ICreateOrEditPersonInquiryDto {
    code!: string | undefined;
    entity!: Entities;
    entityRef!: number;
    entityRefName!: string | undefined;
    startDate!: moment.Moment | undefined;
    inquiryDescription!: string | undefined;
    firstInquiryDate!: moment.Moment | undefined;
    firstInquirerDesc!: string | undefined;
    secondInquiryDate!: moment.Moment | undefined;
    secondInquirerDesc!: string | undefined;
    managementDescription!: string | undefined;
    relevantUnitDescription!: string | undefined;
    status!: PlanBillStatus;
    completionDate!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditPersonInquiryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.entity = data["entity"];
            this.entityRef = data["entityRef"];
            this.entityRefName = data["entityRefName"];
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.inquiryDescription = data["inquiryDescription"];
            this.firstInquiryDate = data["firstInquiryDate"] ? moment(data["firstInquiryDate"].toString()) : <any>undefined;
            this.firstInquirerDesc = data["firstInquirerDesc"];
            this.secondInquiryDate = data["secondInquiryDate"] ? moment(data["secondInquiryDate"].toString()) : <any>undefined;
            this.secondInquirerDesc = data["secondInquirerDesc"];
            this.managementDescription = data["managementDescription"];
            this.relevantUnitDescription = data["relevantUnitDescription"];
            this.status = data["status"];
            this.completionDate = data["completionDate"] ? moment(data["completionDate"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditPersonInquiryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPersonInquiryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["entity"] = this.entity;
        data["entityRef"] = this.entityRef;
        data["entityRefName"] = this.entityRefName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["inquiryDescription"] = this.inquiryDescription;
        data["firstInquiryDate"] = this.firstInquiryDate ? this.firstInquiryDate.toISOString() : <any>undefined;
        data["firstInquirerDesc"] = this.firstInquirerDesc;
        data["secondInquiryDate"] = this.secondInquiryDate ? this.secondInquiryDate.toISOString() : <any>undefined;
        data["secondInquirerDesc"] = this.secondInquirerDesc;
        data["managementDescription"] = this.managementDescription;
        data["relevantUnitDescription"] = this.relevantUnitDescription;
        data["status"] = this.status;
        data["completionDate"] = this.completionDate ? this.completionDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditPersonInquiryDto {
    code: string | undefined;
    entity: Entities;
    entityRef: number;
    entityRefName: string | undefined;
    startDate: moment.Moment | undefined;
    inquiryDescription: string | undefined;
    firstInquiryDate: moment.Moment | undefined;
    firstInquirerDesc: string | undefined;
    secondInquiryDate: moment.Moment | undefined;
    secondInquirerDesc: string | undefined;
    managementDescription: string | undefined;
    relevantUnitDescription: string | undefined;
    status: PlanBillStatus;
    completionDate: moment.Moment | undefined;
    id: number | undefined;
}

export class GetPersonInquiryForEditOutput implements IGetPersonInquiryForEditOutput {
    personInquiry!: CreateOrEditPersonInquiryDto;
    clientName!: string | undefined;
    familyName!: string | undefined;

    constructor(data?: IGetPersonInquiryForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.personInquiry = data["personInquiry"] ? CreateOrEditPersonInquiryDto.fromJS(data["personInquiry"]) : <any>undefined;
            this.clientName = data["clientName"];
            this.familyName = data["familyName"];
        }
    }

    static fromJS(data: any): GetPersonInquiryForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPersonInquiryForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personInquiry"] = this.personInquiry ? this.personInquiry.toJSON() : <any>undefined;
        data["clientName"] = this.clientName;
        data["familyName"] = this.familyName;
        return data; 
    }
}

export interface IGetPersonInquiryForEditOutput {
    personInquiry: CreateOrEditPersonInquiryDto;
    clientName: string | undefined;
    familyName: string | undefined;
}

export class PersonInquiryFamilyLookupTableDto implements IPersonInquiryFamilyLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    fileNumber!: string | undefined;

    constructor(data?: IPersonInquiryFamilyLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.fileNumber = data["fileNumber"];
        }
    }

    static fromJS(data: any): PersonInquiryFamilyLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonInquiryFamilyLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["fileNumber"] = this.fileNumber;
        return data; 
    }
}

export interface IPersonInquiryFamilyLookupTableDto {
    id: number;
    displayName: string | undefined;
    fileNumber: string | undefined;
}

export class PagedResultDtoOfPersonInquiryFamilyLookupTableDto implements IPagedResultDtoOfPersonInquiryFamilyLookupTableDto {
    totalCount!: number;
    items!: PersonInquiryFamilyLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPersonInquiryFamilyLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(PersonInquiryFamilyLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPersonInquiryFamilyLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPersonInquiryFamilyLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfPersonInquiryFamilyLookupTableDto {
    totalCount: number;
    items: PersonInquiryFamilyLookupTableDto[] | undefined;
}

export class GetPlanBillForViewDto implements IGetPlanBillForViewDto {
    planBill!: PlanBillDto;
    clientName!: string | undefined;
    familyName!: string | undefined;
    contactFirstName!: string | undefined;
    benefactorName!: string | undefined;
    planConstTitle!: string | undefined;
    baseTimeName!: string | undefined;
    addressTitle!: string | undefined;
    entityRefName!: string | undefined;
    isContinuous!: boolean;
    attributes!: string | undefined;
    creatorUserName!: string | undefined;
    lastModifierUserName!: string | undefined;
    billCardTemplateProperties!: GetPropertiesForBillDto[] | undefined;

    constructor(data?: IGetPlanBillForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.planBill = data["planBill"] ? PlanBillDto.fromJS(data["planBill"]) : <any>undefined;
            this.clientName = data["clientName"];
            this.familyName = data["familyName"];
            this.contactFirstName = data["contactFirstName"];
            this.benefactorName = data["benefactorName"];
            this.planConstTitle = data["planConstTitle"];
            this.baseTimeName = data["baseTimeName"];
            this.addressTitle = data["addressTitle"];
            this.entityRefName = data["entityRefName"];
            this.isContinuous = data["isContinuous"];
            this.attributes = data["attributes"];
            this.creatorUserName = data["creatorUserName"];
            this.lastModifierUserName = data["lastModifierUserName"];
            if (Array.isArray(data["billCardTemplateProperties"])) {
                this.billCardTemplateProperties = [] as any;
                for (let item of data["billCardTemplateProperties"])
                    this.billCardTemplateProperties!.push(GetPropertiesForBillDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPlanBillForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlanBillForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planBill"] = this.planBill ? this.planBill.toJSON() : <any>undefined;
        data["clientName"] = this.clientName;
        data["familyName"] = this.familyName;
        data["contactFirstName"] = this.contactFirstName;
        data["benefactorName"] = this.benefactorName;
        data["planConstTitle"] = this.planConstTitle;
        data["baseTimeName"] = this.baseTimeName;
        data["addressTitle"] = this.addressTitle;
        data["entityRefName"] = this.entityRefName;
        data["isContinuous"] = this.isContinuous;
        data["attributes"] = this.attributes;
        data["creatorUserName"] = this.creatorUserName;
        data["lastModifierUserName"] = this.lastModifierUserName;
        if (Array.isArray(this.billCardTemplateProperties)) {
            data["billCardTemplateProperties"] = [];
            for (let item of this.billCardTemplateProperties)
                data["billCardTemplateProperties"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetPlanBillForViewDto {
    planBill: PlanBillDto;
    clientName: string | undefined;
    familyName: string | undefined;
    contactFirstName: string | undefined;
    benefactorName: string | undefined;
    planConstTitle: string | undefined;
    baseTimeName: string | undefined;
    addressTitle: string | undefined;
    entityRefName: string | undefined;
    isContinuous: boolean;
    attributes: string | undefined;
    creatorUserName: string | undefined;
    lastModifierUserName: string | undefined;
    billCardTemplateProperties: GetPropertiesForBillDto[] | undefined;
}

export class PagedResultDtoOfGetPlanBillForViewDto implements IPagedResultDtoOfGetPlanBillForViewDto {
    totalCount!: number;
    items!: GetPlanBillForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetPlanBillForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetPlanBillForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetPlanBillForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetPlanBillForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetPlanBillForViewDto {
    totalCount: number;
    items: GetPlanBillForViewDto[] | undefined;
}

export class GetPlanBillForEditOutput implements IGetPlanBillForEditOutput {
    planBill!: CreateOrEditPlanBillDto;
    clientName!: string | undefined;
    familyName!: string | undefined;
    contactFirstName!: string | undefined;
    deacesedName!: string | undefined;
    planConstTitle!: string | undefined;
    planType!: Plans;
    baseTimeName!: string | undefined;
    sourceId!: number | undefined;
    addressTitle!: string | undefined;
    selectClient!: SelectClient;
    isParticipatory!: boolean;
    charityType!: CharityTypes;
    baseTimes!: BaseTimeInfo[] | undefined;
    lastPaymentDate!: moment.Moment | undefined;
    isStartDateEditable!: boolean;
    billCardTemplateProperties!: GetPropertiesForBillDto[] | undefined;

    constructor(data?: IGetPlanBillForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.isParticipatory = true;
        }
    }

    init(data?: any) {
        if (data) {
            this.planBill = data["planBill"] ? CreateOrEditPlanBillDto.fromJS(data["planBill"]) : <any>undefined;
            this.clientName = data["clientName"];
            this.familyName = data["familyName"];
            this.contactFirstName = data["contactFirstName"];
            this.deacesedName = data["deacesedName"];
            this.planConstTitle = data["planConstTitle"];
            this.planType = data["planType"];
            this.baseTimeName = data["baseTimeName"];
            this.sourceId = data["sourceId"];
            this.addressTitle = data["addressTitle"];
            this.selectClient = data["selectClient"];
            this.isParticipatory = data["isParticipatory"] !== undefined ? data["isParticipatory"] : true;
            this.charityType = data["charityType"];
            if (Array.isArray(data["baseTimes"])) {
                this.baseTimes = [] as any;
                for (let item of data["baseTimes"])
                    this.baseTimes!.push(BaseTimeInfo.fromJS(item));
            }
            this.lastPaymentDate = data["lastPaymentDate"] ? moment(data["lastPaymentDate"].toString()) : <any>undefined;
            this.isStartDateEditable = data["isStartDateEditable"];
            if (Array.isArray(data["billCardTemplateProperties"])) {
                this.billCardTemplateProperties = [] as any;
                for (let item of data["billCardTemplateProperties"])
                    this.billCardTemplateProperties!.push(GetPropertiesForBillDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPlanBillForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlanBillForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planBill"] = this.planBill ? this.planBill.toJSON() : <any>undefined;
        data["clientName"] = this.clientName;
        data["familyName"] = this.familyName;
        data["contactFirstName"] = this.contactFirstName;
        data["deacesedName"] = this.deacesedName;
        data["planConstTitle"] = this.planConstTitle;
        data["planType"] = this.planType;
        data["baseTimeName"] = this.baseTimeName;
        data["sourceId"] = this.sourceId;
        data["addressTitle"] = this.addressTitle;
        data["selectClient"] = this.selectClient;
        data["isParticipatory"] = this.isParticipatory;
        data["charityType"] = this.charityType;
        if (Array.isArray(this.baseTimes)) {
            data["baseTimes"] = [];
            for (let item of this.baseTimes)
                data["baseTimes"].push(item.toJSON());
        }
        data["lastPaymentDate"] = this.lastPaymentDate ? this.lastPaymentDate.toISOString() : <any>undefined;
        data["isStartDateEditable"] = this.isStartDateEditable;
        if (Array.isArray(this.billCardTemplateProperties)) {
            data["billCardTemplateProperties"] = [];
            for (let item of this.billCardTemplateProperties)
                data["billCardTemplateProperties"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetPlanBillForEditOutput {
    planBill: CreateOrEditPlanBillDto;
    clientName: string | undefined;
    familyName: string | undefined;
    contactFirstName: string | undefined;
    deacesedName: string | undefined;
    planConstTitle: string | undefined;
    planType: Plans;
    baseTimeName: string | undefined;
    sourceId: number | undefined;
    addressTitle: string | undefined;
    selectClient: SelectClient;
    isParticipatory: boolean;
    charityType: CharityTypes;
    baseTimes: BaseTimeInfo[] | undefined;
    lastPaymentDate: moment.Moment | undefined;
    isStartDateEditable: boolean;
    billCardTemplateProperties: GetPropertiesForBillDto[] | undefined;
}

export class CreateOrEditPlanBillAndAddressDto implements ICreateOrEditPlanBillAndAddressDto {
    planBill!: CreateOrEditPlanBillDto;
    address!: CreateOrEditAddressDto;
    branchRef!: number | undefined;
    billCardTemplateProperties!: GetPropertiesForBillDto[] | undefined;
    attributeValues!: CreateOrEditAttributeValueDto[] | undefined;

    constructor(data?: ICreateOrEditPlanBillAndAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.planBill = data["planBill"] ? CreateOrEditPlanBillDto.fromJS(data["planBill"]) : <any>undefined;
            this.address = data["address"] ? CreateOrEditAddressDto.fromJS(data["address"]) : <any>undefined;
            this.branchRef = data["branchRef"];
            if (Array.isArray(data["billCardTemplateProperties"])) {
                this.billCardTemplateProperties = [] as any;
                for (let item of data["billCardTemplateProperties"])
                    this.billCardTemplateProperties!.push(GetPropertiesForBillDto.fromJS(item));
            }
            if (Array.isArray(data["attributeValues"])) {
                this.attributeValues = [] as any;
                for (let item of data["attributeValues"])
                    this.attributeValues!.push(CreateOrEditAttributeValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrEditPlanBillAndAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPlanBillAndAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planBill"] = this.planBill ? this.planBill.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["branchRef"] = this.branchRef;
        if (Array.isArray(this.billCardTemplateProperties)) {
            data["billCardTemplateProperties"] = [];
            for (let item of this.billCardTemplateProperties)
                data["billCardTemplateProperties"].push(item.toJSON());
        }
        if (Array.isArray(this.attributeValues)) {
            data["attributeValues"] = [];
            for (let item of this.attributeValues)
                data["attributeValues"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateOrEditPlanBillAndAddressDto {
    planBill: CreateOrEditPlanBillDto;
    address: CreateOrEditAddressDto;
    branchRef: number | undefined;
    billCardTemplateProperties: GetPropertiesForBillDto[] | undefined;
    attributeValues: CreateOrEditAttributeValueDto[] | undefined;
}

export class CreateOrEditPlanBillAndMoneyBoxEventInput implements ICreateOrEditPlanBillAndMoneyBoxEventInput {
    amount!: number | undefined;
    baseTimeRef!: number | undefined;

    constructor(data?: ICreateOrEditPlanBillAndMoneyBoxEventInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.amount = data["amount"];
            this.baseTimeRef = data["baseTimeRef"];
        }
    }

    static fromJS(data: any): CreateOrEditPlanBillAndMoneyBoxEventInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPlanBillAndMoneyBoxEventInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["baseTimeRef"] = this.baseTimeRef;
        return data; 
    }
}

export interface ICreateOrEditPlanBillAndMoneyBoxEventInput {
    amount: number | undefined;
    baseTimeRef: number | undefined;
}

export class PlanBillContactLookupTableDto implements IPlanBillContactLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    mobileNumber!: string | undefined;
    address!: string | undefined;
    addresses!: GetAddressForEditOutput[] | undefined;
    isBadPayer!: boolean;

    constructor(data?: IPlanBillContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.mobileNumber = data["mobileNumber"];
            this.address = data["address"];
            if (Array.isArray(data["addresses"])) {
                this.addresses = [] as any;
                for (let item of data["addresses"])
                    this.addresses!.push(GetAddressForEditOutput.fromJS(item));
            }
            this.isBadPayer = data["isBadPayer"];
        }
    }

    static fromJS(data: any): PlanBillContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlanBillContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["mobileNumber"] = this.mobileNumber;
        data["address"] = this.address;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        data["isBadPayer"] = this.isBadPayer;
        return data; 
    }
}

export interface IPlanBillContactLookupTableDto {
    id: number;
    displayName: string | undefined;
    mobileNumber: string | undefined;
    address: string | undefined;
    addresses: GetAddressForEditOutput[] | undefined;
    isBadPayer: boolean;
}

export class PagedResultDtoOfPlanBillContactLookupTableDto implements IPagedResultDtoOfPlanBillContactLookupTableDto {
    totalCount!: number;
    items!: PlanBillContactLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPlanBillContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(PlanBillContactLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPlanBillContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPlanBillContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfPlanBillContactLookupTableDto {
    totalCount: number;
    items: PlanBillContactLookupTableDto[] | undefined;
}

export class PlanBillPlanConstLookupTableDto implements IPlanBillPlanConstLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    selectClient!: SelectClient;
    charityType!: CharityTypes;
    baseTime!: BaseTimeInfo[] | undefined;
    isPublic!: boolean;
    sourceId!: number | undefined;

    constructor(data?: IPlanBillPlanConstLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.selectClient = data["selectClient"];
            this.charityType = data["charityType"];
            if (Array.isArray(data["baseTime"])) {
                this.baseTime = [] as any;
                for (let item of data["baseTime"])
                    this.baseTime!.push(BaseTimeInfo.fromJS(item));
            }
            this.isPublic = data["isPublic"];
            this.sourceId = data["sourceId"];
        }
    }

    static fromJS(data: any): PlanBillPlanConstLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlanBillPlanConstLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["selectClient"] = this.selectClient;
        data["charityType"] = this.charityType;
        if (Array.isArray(this.baseTime)) {
            data["baseTime"] = [];
            for (let item of this.baseTime)
                data["baseTime"].push(item.toJSON());
        }
        data["isPublic"] = this.isPublic;
        data["sourceId"] = this.sourceId;
        return data; 
    }
}

export interface IPlanBillPlanConstLookupTableDto {
    id: number;
    displayName: string | undefined;
    selectClient: SelectClient;
    charityType: CharityTypes;
    baseTime: BaseTimeInfo[] | undefined;
    isPublic: boolean;
    sourceId: number | undefined;
}

export class PagedResultDtoOfPlanBillPlanConstLookupTableDto implements IPagedResultDtoOfPlanBillPlanConstLookupTableDto {
    totalCount!: number;
    items!: PlanBillPlanConstLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPlanBillPlanConstLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(PlanBillPlanConstLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPlanBillPlanConstLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPlanBillPlanConstLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfPlanBillPlanConstLookupTableDto {
    totalCount: number;
    items: PlanBillPlanConstLookupTableDto[] | undefined;
}

export class PlanBillFamilyLookupTableDto implements IPlanBillFamilyLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IPlanBillFamilyLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): PlanBillFamilyLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlanBillFamilyLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IPlanBillFamilyLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfPlanBillFamilyLookupTableDto implements IPagedResultDtoOfPlanBillFamilyLookupTableDto {
    totalCount!: number;
    items!: PlanBillFamilyLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPlanBillFamilyLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(PlanBillFamilyLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPlanBillFamilyLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPlanBillFamilyLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfPlanBillFamilyLookupTableDto {
    totalCount: number;
    items: PlanBillFamilyLookupTableDto[] | undefined;
}

export class PlanBillAddressLookupTableDto implements IPlanBillAddressLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IPlanBillAddressLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): PlanBillAddressLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlanBillAddressLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IPlanBillAddressLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfPlanBillAddressLookupTableDto implements IPagedResultDtoOfPlanBillAddressLookupTableDto {
    totalCount!: number;
    items!: PlanBillAddressLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPlanBillAddressLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(PlanBillAddressLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPlanBillAddressLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPlanBillAddressLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfPlanBillAddressLookupTableDto {
    totalCount: number;
    items: PlanBillAddressLookupTableDto[] | undefined;
}

export class PlanBillDeceasedLookupTableDto implements IPlanBillDeceasedLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    deceasedName!: string | undefined;
    gender!: Gender;

    constructor(data?: IPlanBillDeceasedLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.deceasedName = data["deceasedName"];
            this.gender = data["gender"];
        }
    }

    static fromJS(data: any): PlanBillDeceasedLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlanBillDeceasedLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["deceasedName"] = this.deceasedName;
        data["gender"] = this.gender;
        return data; 
    }
}

export interface IPlanBillDeceasedLookupTableDto {
    id: number;
    displayName: string | undefined;
    deceasedName: string | undefined;
    gender: Gender;
}

export class PagedResultDtoOfPlanBillDeceasedLookupTableDto implements IPagedResultDtoOfPlanBillDeceasedLookupTableDto {
    totalCount!: number;
    items!: PlanBillDeceasedLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPlanBillDeceasedLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(PlanBillDeceasedLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPlanBillDeceasedLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPlanBillDeceasedLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfPlanBillDeceasedLookupTableDto {
    totalCount: number;
    items: PlanBillDeceasedLookupTableDto[] | undefined;
}

export class PlanBillBaseTimeLookupTableDto implements IPlanBillBaseTimeLookupTableDto {
    id!: number;
    name!: string | undefined;
    duratione!: number | undefined;
    referralAndPaymentToPostMan!: boolean;

    constructor(data?: IPlanBillBaseTimeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.duratione = data["duratione"];
            this.referralAndPaymentToPostMan = data["referralAndPaymentToPostMan"];
        }
    }

    static fromJS(data: any): PlanBillBaseTimeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlanBillBaseTimeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["duratione"] = this.duratione;
        data["referralAndPaymentToPostMan"] = this.referralAndPaymentToPostMan;
        return data; 
    }
}

export interface IPlanBillBaseTimeLookupTableDto {
    id: number;
    name: string | undefined;
    duratione: number | undefined;
    referralAndPaymentToPostMan: boolean;
}

export class PlanBillHealthStatusLookupTableDto implements IPlanBillHealthStatusLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IPlanBillHealthStatusLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): PlanBillHealthStatusLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlanBillHealthStatusLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IPlanBillHealthStatusLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class GetAllContactPlanBillsForShopDto implements IGetAllContactPlanBillsForShopDto {
    id!: number;
    title!: string | undefined;
    startDate!: moment.Moment | undefined;
    amount!: number | undefined;
    count!: number | undefined;
    code!: string | undefined;
    clientName!: string | undefined;
    baseTimeTitle!: string | undefined;
    lastPaymentDate!: moment.Moment | undefined;
    nextPaymentDate!: moment.Moment | undefined;
    nonPaymentCount!: number;
    paymentCount!: number;
    onApprovePaymentCount!: number;
    isExpired!: boolean;
    isCash!: boolean;

    constructor(data?: IGetAllContactPlanBillsForShopDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.title = data["title"];
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.amount = data["amount"];
            this.count = data["count"];
            this.code = data["code"];
            this.clientName = data["clientName"];
            this.baseTimeTitle = data["baseTimeTitle"];
            this.lastPaymentDate = data["lastPaymentDate"] ? moment(data["lastPaymentDate"].toString()) : <any>undefined;
            this.nextPaymentDate = data["nextPaymentDate"] ? moment(data["nextPaymentDate"].toString()) : <any>undefined;
            this.nonPaymentCount = data["nonPaymentCount"];
            this.paymentCount = data["paymentCount"];
            this.onApprovePaymentCount = data["onApprovePaymentCount"];
            this.isExpired = data["isExpired"];
            this.isCash = data["isCash"];
        }
    }

    static fromJS(data: any): GetAllContactPlanBillsForShopDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllContactPlanBillsForShopDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["count"] = this.count;
        data["code"] = this.code;
        data["clientName"] = this.clientName;
        data["baseTimeTitle"] = this.baseTimeTitle;
        data["lastPaymentDate"] = this.lastPaymentDate ? this.lastPaymentDate.toISOString() : <any>undefined;
        data["nextPaymentDate"] = this.nextPaymentDate ? this.nextPaymentDate.toISOString() : <any>undefined;
        data["nonPaymentCount"] = this.nonPaymentCount;
        data["paymentCount"] = this.paymentCount;
        data["onApprovePaymentCount"] = this.onApprovePaymentCount;
        data["isExpired"] = this.isExpired;
        data["isCash"] = this.isCash;
        return data; 
    }
}

export interface IGetAllContactPlanBillsForShopDto {
    id: number;
    title: string | undefined;
    startDate: moment.Moment | undefined;
    amount: number | undefined;
    count: number | undefined;
    code: string | undefined;
    clientName: string | undefined;
    baseTimeTitle: string | undefined;
    lastPaymentDate: moment.Moment | undefined;
    nextPaymentDate: moment.Moment | undefined;
    nonPaymentCount: number;
    paymentCount: number;
    onApprovePaymentCount: number;
    isExpired: boolean;
    isCash: boolean;
}

export class PagedResultDtoOfGetAllContactPlanBillsForShopDto implements IPagedResultDtoOfGetAllContactPlanBillsForShopDto {
    totalCount!: number;
    items!: GetAllContactPlanBillsForShopDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAllContactPlanBillsForShopDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetAllContactPlanBillsForShopDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAllContactPlanBillsForShopDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAllContactPlanBillsForShopDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetAllContactPlanBillsForShopDto {
    totalCount: number;
    items: GetAllContactPlanBillsForShopDto[] | undefined;
}

export class PlanBillDetails implements IPlanBillDetails {
    planBillId!: number;
    title!: string | undefined;
    amount!: number | undefined;
    count!: number | undefined;
    durationDate!: number | undefined;
    planBillCode!: string | undefined;
    clientName!: string | undefined;
    educationDegree!: string | undefined;
    healthStatus!: string | undefined;
    isSadat!: boolean;
    isCash!: boolean;
    isExpired!: boolean;
    birthDate!: moment.Moment | undefined;
    age!: number | undefined;
    gender!: Gender;
    baseTimeName!: string | undefined;
    referralAndPaymentToPostMan!: boolean;

    constructor(data?: IPlanBillDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.planBillId = data["planBillId"];
            this.title = data["title"];
            this.amount = data["amount"];
            this.count = data["count"];
            this.durationDate = data["durationDate"];
            this.planBillCode = data["planBillCode"];
            this.clientName = data["clientName"];
            this.educationDegree = data["educationDegree"];
            this.healthStatus = data["healthStatus"];
            this.isSadat = data["isSadat"];
            this.isCash = data["isCash"];
            this.isExpired = data["isExpired"];
            this.birthDate = data["birthDate"] ? moment(data["birthDate"].toString()) : <any>undefined;
            this.age = data["age"];
            this.gender = data["gender"];
            this.baseTimeName = data["baseTimeName"];
            this.referralAndPaymentToPostMan = data["referralAndPaymentToPostMan"];
        }
    }

    static fromJS(data: any): PlanBillDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PlanBillDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planBillId"] = this.planBillId;
        data["title"] = this.title;
        data["amount"] = this.amount;
        data["count"] = this.count;
        data["durationDate"] = this.durationDate;
        data["planBillCode"] = this.planBillCode;
        data["clientName"] = this.clientName;
        data["educationDegree"] = this.educationDegree;
        data["healthStatus"] = this.healthStatus;
        data["isSadat"] = this.isSadat;
        data["isCash"] = this.isCash;
        data["isExpired"] = this.isExpired;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["age"] = this.age;
        data["gender"] = this.gender;
        data["baseTimeName"] = this.baseTimeName;
        data["referralAndPaymentToPostMan"] = this.referralAndPaymentToPostMan;
        return data; 
    }
}

export interface IPlanBillDetails {
    planBillId: number;
    title: string | undefined;
    amount: number | undefined;
    count: number | undefined;
    durationDate: number | undefined;
    planBillCode: string | undefined;
    clientName: string | undefined;
    educationDegree: string | undefined;
    healthStatus: string | undefined;
    isSadat: boolean;
    isCash: boolean;
    isExpired: boolean;
    birthDate: moment.Moment | undefined;
    age: number | undefined;
    gender: Gender;
    baseTimeName: string | undefined;
    referralAndPaymentToPostMan: boolean;
}

export class PlanBillPayments implements IPlanBillPayments {
    billId!: number;
    billCode!: string | undefined;
    billStatus!: BillStatus;
    dueDate!: moment.Moment;
    issueDate!: moment.Moment;
    paymentDate!: moment.Moment | undefined;
    bankTrackingNO!: string | undefined;
    paymentType!: PaymentType;

    constructor(data?: IPlanBillPayments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.billId = data["billId"];
            this.billCode = data["billCode"];
            this.billStatus = data["billStatus"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.issueDate = data["issueDate"] ? moment(data["issueDate"].toString()) : <any>undefined;
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.bankTrackingNO = data["bankTrackingNO"];
            this.paymentType = data["paymentType"];
        }
    }

    static fromJS(data: any): PlanBillPayments {
        data = typeof data === 'object' ? data : {};
        let result = new PlanBillPayments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billId"] = this.billId;
        data["billCode"] = this.billCode;
        data["billStatus"] = this.billStatus;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["bankTrackingNO"] = this.bankTrackingNO;
        data["paymentType"] = this.paymentType;
        return data; 
    }
}

export interface IPlanBillPayments {
    billId: number;
    billCode: string | undefined;
    billStatus: BillStatus;
    dueDate: moment.Moment;
    issueDate: moment.Moment;
    paymentDate: moment.Moment | undefined;
    bankTrackingNO: string | undefined;
    paymentType: PaymentType;
}

export class GetPlanBillDetailsForShopDto implements IGetPlanBillDetailsForShopDto {
    details!: PlanBillDetails;
    billPayments!: PlanBillPayments[] | undefined;

    constructor(data?: IGetPlanBillDetailsForShopDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.details = data["details"] ? PlanBillDetails.fromJS(data["details"]) : <any>undefined;
            if (Array.isArray(data["billPayments"])) {
                this.billPayments = [] as any;
                for (let item of data["billPayments"])
                    this.billPayments!.push(PlanBillPayments.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPlanBillDetailsForShopDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlanBillDetailsForShopDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["details"] = this.details ? this.details.toJSON() : <any>undefined;
        if (Array.isArray(this.billPayments)) {
            data["billPayments"] = [];
            for (let item of this.billPayments)
                data["billPayments"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetPlanBillDetailsForShopDto {
    details: PlanBillDetails;
    billPayments: PlanBillPayments[] | undefined;
}

export class GetContactMoneyBoxPlanBillDto implements IGetContactMoneyBoxPlanBillDto {
    planBillId!: number;
    code!: string | undefined;
    baseTimeRef!: number | undefined;
    totalCount!: number;
    status!: boolean;
    repetitiveOne!: number | undefined;
    repetitiveTwo!: number | undefined;

    constructor(data?: IGetContactMoneyBoxPlanBillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.planBillId = data["planBillId"];
            this.code = data["code"];
            this.baseTimeRef = data["baseTimeRef"];
            this.totalCount = data["totalCount"];
            this.status = data["status"];
            this.repetitiveOne = data["repetitiveOne"];
            this.repetitiveTwo = data["repetitiveTwo"];
        }
    }

    static fromJS(data: any): GetContactMoneyBoxPlanBillDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetContactMoneyBoxPlanBillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planBillId"] = this.planBillId;
        data["code"] = this.code;
        data["baseTimeRef"] = this.baseTimeRef;
        data["totalCount"] = this.totalCount;
        data["status"] = this.status;
        data["repetitiveOne"] = this.repetitiveOne;
        data["repetitiveTwo"] = this.repetitiveTwo;
        return data; 
    }
}

export interface IGetContactMoneyBoxPlanBillDto {
    planBillId: number;
    code: string | undefined;
    baseTimeRef: number | undefined;
    totalCount: number;
    status: boolean;
    repetitiveOne: number | undefined;
    repetitiveTwo: number | undefined;
}

export class ExpirePlanBillInput implements IExpirePlanBillInput {
    planBillCode!: string | undefined;
    planBillId!: number | undefined;

    constructor(data?: IExpirePlanBillInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.planBillCode = data["planBillCode"];
            this.planBillId = data["planBillId"];
        }
    }

    static fromJS(data: any): ExpirePlanBillInput {
        data = typeof data === 'object' ? data : {};
        let result = new ExpirePlanBillInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planBillCode"] = this.planBillCode;
        data["planBillId"] = this.planBillId;
        return data; 
    }
}

export interface IExpirePlanBillInput {
    planBillCode: string | undefined;
    planBillId: number | undefined;
}

export class GetDelaiedPaymentsDto implements IGetDelaiedPaymentsDto {
    currencyId!: number | undefined;
    dateTimes!: moment.Moment[] | undefined;

    constructor(data?: IGetDelaiedPaymentsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currencyId = data["currencyId"];
            if (Array.isArray(data["dateTimes"])) {
                this.dateTimes = [] as any;
                for (let item of data["dateTimes"])
                    this.dateTimes!.push(moment(item));
            }
        }
    }

    static fromJS(data: any): GetDelaiedPaymentsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDelaiedPaymentsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyId"] = this.currencyId;
        if (Array.isArray(this.dateTimes)) {
            data["dateTimes"] = [];
            for (let item of this.dateTimes)
                data["dateTimes"].push(item.toISOString());
        }
        return data; 
    }
}

export interface IGetDelaiedPaymentsDto {
    currencyId: number | undefined;
    dateTimes: moment.Moment[] | undefined;
}

export class PlanCategoryDto implements IPlanCategoryDto {
    title!: string | undefined;
    state!: boolean | undefined;
    icon!: string | undefined;
    parentId!: number | undefined;
    description!: string | undefined;
    created!: moment.Moment;
    modified!: moment.Moment | undefined;
    createdBy!: number;
    modifiedBy!: number | undefined;
    filePath!: string | undefined;
    thumbPath!: string | undefined;
    isPromote!: boolean;
    order!: number | undefined;
    id!: number;

    constructor(data?: IPlanCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.state = data["state"];
            this.icon = data["icon"];
            this.parentId = data["parentId"];
            this.description = data["description"];
            this.created = data["created"] ? moment(data["created"].toString()) : <any>undefined;
            this.modified = data["modified"] ? moment(data["modified"].toString()) : <any>undefined;
            this.createdBy = data["createdBy"];
            this.modifiedBy = data["modifiedBy"];
            this.filePath = data["filePath"];
            this.thumbPath = data["thumbPath"];
            this.isPromote = data["isPromote"];
            this.order = data["order"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PlanCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlanCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["state"] = this.state;
        data["icon"] = this.icon;
        data["parentId"] = this.parentId;
        data["description"] = this.description;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["modifiedBy"] = this.modifiedBy;
        data["filePath"] = this.filePath;
        data["thumbPath"] = this.thumbPath;
        data["isPromote"] = this.isPromote;
        data["order"] = this.order;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPlanCategoryDto {
    title: string | undefined;
    state: boolean | undefined;
    icon: string | undefined;
    parentId: number | undefined;
    description: string | undefined;
    created: moment.Moment;
    modified: moment.Moment | undefined;
    createdBy: number;
    modifiedBy: number | undefined;
    filePath: string | undefined;
    thumbPath: string | undefined;
    isPromote: boolean;
    order: number | undefined;
    id: number;
}

export class GetPlanCategoryForViewDto implements IGetPlanCategoryForViewDto {
    planCategory!: PlanCategoryDto;
    tagTitle!: string | undefined;
    parentTitle!: string | undefined;

    constructor(data?: IGetPlanCategoryForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.planCategory = data["planCategory"] ? PlanCategoryDto.fromJS(data["planCategory"]) : <any>undefined;
            this.tagTitle = data["tagTitle"];
            this.parentTitle = data["parentTitle"];
        }
    }

    static fromJS(data: any): GetPlanCategoryForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlanCategoryForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planCategory"] = this.planCategory ? this.planCategory.toJSON() : <any>undefined;
        data["tagTitle"] = this.tagTitle;
        data["parentTitle"] = this.parentTitle;
        return data; 
    }
}

export interface IGetPlanCategoryForViewDto {
    planCategory: PlanCategoryDto;
    tagTitle: string | undefined;
    parentTitle: string | undefined;
}

export class PagedResultDtoOfGetPlanCategoryForViewDto implements IPagedResultDtoOfGetPlanCategoryForViewDto {
    totalCount!: number;
    items!: GetPlanCategoryForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetPlanCategoryForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetPlanCategoryForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetPlanCategoryForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetPlanCategoryForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetPlanCategoryForViewDto {
    totalCount: number;
    items: GetPlanCategoryForViewDto[] | undefined;
}

export class CreateOrEditPlanCategoryDto implements ICreateOrEditPlanCategoryDto {
    title!: string | undefined;
    state!: boolean | undefined;
    icon!: string | undefined;
    parentId!: number | undefined;
    description!: string | undefined;
    created!: moment.Moment;
    modified!: moment.Moment | undefined;
    createdBy!: number;
    modifiedBy!: number | undefined;
    filePath!: string | undefined;
    thumbPath!: string | undefined;
    isPromote!: boolean;
    order!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditPlanCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.state = data["state"];
            this.icon = data["icon"];
            this.parentId = data["parentId"];
            this.description = data["description"];
            this.created = data["created"] ? moment(data["created"].toString()) : <any>undefined;
            this.modified = data["modified"] ? moment(data["modified"].toString()) : <any>undefined;
            this.createdBy = data["createdBy"];
            this.modifiedBy = data["modifiedBy"];
            this.filePath = data["filePath"];
            this.thumbPath = data["thumbPath"];
            this.isPromote = data["isPromote"];
            this.order = data["order"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditPlanCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPlanCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["state"] = this.state;
        data["icon"] = this.icon;
        data["parentId"] = this.parentId;
        data["description"] = this.description;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["modifiedBy"] = this.modifiedBy;
        data["filePath"] = this.filePath;
        data["thumbPath"] = this.thumbPath;
        data["isPromote"] = this.isPromote;
        data["order"] = this.order;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditPlanCategoryDto {
    title: string | undefined;
    state: boolean | undefined;
    icon: string | undefined;
    parentId: number | undefined;
    description: string | undefined;
    created: moment.Moment;
    modified: moment.Moment | undefined;
    createdBy: number;
    modifiedBy: number | undefined;
    filePath: string | undefined;
    thumbPath: string | undefined;
    isPromote: boolean;
    order: number | undefined;
    id: number | undefined;
}

export class GetPlanCategoryForEditOutput implements IGetPlanCategoryForEditOutput {
    planCategory!: CreateOrEditPlanCategoryDto;
    tagTitle!: string | undefined;

    constructor(data?: IGetPlanCategoryForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.planCategory = data["planCategory"] ? CreateOrEditPlanCategoryDto.fromJS(data["planCategory"]) : <any>undefined;
            this.tagTitle = data["tagTitle"];
        }
    }

    static fromJS(data: any): GetPlanCategoryForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlanCategoryForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planCategory"] = this.planCategory ? this.planCategory.toJSON() : <any>undefined;
        data["tagTitle"] = this.tagTitle;
        return data; 
    }
}

export interface IGetPlanCategoryForEditOutput {
    planCategory: CreateOrEditPlanCategoryDto;
    tagTitle: string | undefined;
}

export class GetPlanCategoriesForSiteJson implements IGetPlanCategoriesForSiteJson {
    id!: number;
    title!: string | undefined;
    icon!: string | undefined;
    filePath!: string | undefined;
    thumbPath!: string | undefined;
    isPromote!: boolean;
    order!: number | undefined;
    children!: GetPlanCategoriesForSiteJson[] | undefined;

    constructor(data?: IGetPlanCategoriesForSiteJson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.title = data["title"];
            this.icon = data["icon"];
            this.filePath = data["filePath"];
            this.thumbPath = data["thumbPath"];
            this.isPromote = data["isPromote"];
            this.order = data["order"];
            if (Array.isArray(data["children"])) {
                this.children = [] as any;
                for (let item of data["children"])
                    this.children!.push(GetPlanCategoriesForSiteJson.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPlanCategoriesForSiteJson {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlanCategoriesForSiteJson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["icon"] = this.icon;
        data["filePath"] = this.filePath;
        data["thumbPath"] = this.thumbPath;
        data["isPromote"] = this.isPromote;
        data["order"] = this.order;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetPlanCategoriesForSiteJson {
    id: number;
    title: string | undefined;
    icon: string | undefined;
    filePath: string | undefined;
    thumbPath: string | undefined;
    isPromote: boolean;
    order: number | undefined;
    children: GetPlanCategoriesForSiteJson[] | undefined;
}

export class PagedResultDtoOfGetPlanCategoriesForSiteJson implements IPagedResultDtoOfGetPlanCategoriesForSiteJson {
    totalCount!: number;
    items!: GetPlanCategoriesForSiteJson[] | undefined;

    constructor(data?: IPagedResultDtoOfGetPlanCategoriesForSiteJson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetPlanCategoriesForSiteJson.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetPlanCategoriesForSiteJson {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetPlanCategoriesForSiteJson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetPlanCategoriesForSiteJson {
    totalCount: number;
    items: GetPlanCategoriesForSiteJson[] | undefined;
}

export class PlanCategoryPlanCategoryLookupTableDto implements IPlanCategoryPlanCategoryLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IPlanCategoryPlanCategoryLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): PlanCategoryPlanCategoryLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlanCategoryPlanCategoryLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IPlanCategoryPlanCategoryLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class GetPlanConstForViewDto implements IGetPlanConstForViewDto {
    planConst!: PlanConstDto;
    planCategoryTitle!: string | undefined;
    sourceName!: string | undefined;
    cardTemplateTitle!: string | undefined;

    constructor(data?: IGetPlanConstForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.planConst = data["planConst"] ? PlanConstDto.fromJS(data["planConst"]) : <any>undefined;
            this.planCategoryTitle = data["planCategoryTitle"];
            this.sourceName = data["sourceName"];
            this.cardTemplateTitle = data["cardTemplateTitle"];
        }
    }

    static fromJS(data: any): GetPlanConstForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlanConstForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planConst"] = this.planConst ? this.planConst.toJSON() : <any>undefined;
        data["planCategoryTitle"] = this.planCategoryTitle;
        data["sourceName"] = this.sourceName;
        data["cardTemplateTitle"] = this.cardTemplateTitle;
        return data; 
    }
}

export interface IGetPlanConstForViewDto {
    planConst: PlanConstDto;
    planCategoryTitle: string | undefined;
    sourceName: string | undefined;
    cardTemplateTitle: string | undefined;
}

export class PagedResultDtoOfGetPlanConstForViewDto implements IPagedResultDtoOfGetPlanConstForViewDto {
    totalCount!: number;
    items!: GetPlanConstForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetPlanConstForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetPlanConstForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetPlanConstForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetPlanConstForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetPlanConstForViewDto {
    totalCount: number;
    items: GetPlanConstForViewDto[] | undefined;
}

export class PlanCurrencyDto implements IPlanCurrencyDto {
    minAmount!: number | undefined;
    maxAmount!: number | undefined;
    currencyRef!: number;
    planConstRef!: number;
    id!: number;

    constructor(data?: IPlanCurrencyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.minAmount = data["minAmount"];
            this.maxAmount = data["maxAmount"];
            this.currencyRef = data["currencyRef"];
            this.planConstRef = data["planConstRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PlanCurrencyDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlanCurrencyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minAmount"] = this.minAmount;
        data["maxAmount"] = this.maxAmount;
        data["currencyRef"] = this.currencyRef;
        data["planConstRef"] = this.planConstRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPlanCurrencyDto {
    minAmount: number | undefined;
    maxAmount: number | undefined;
    currencyRef: number;
    planConstRef: number;
    id: number;
}

export class GetPlanCurrencyForViewDto implements IGetPlanCurrencyForViewDto {
    planCurrency!: PlanCurrencyDto;
    currencyName!: string | undefined;
    planConstTitle!: string | undefined;

    constructor(data?: IGetPlanCurrencyForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.planCurrency = data["planCurrency"] ? PlanCurrencyDto.fromJS(data["planCurrency"]) : <any>undefined;
            this.currencyName = data["currencyName"];
            this.planConstTitle = data["planConstTitle"];
        }
    }

    static fromJS(data: any): GetPlanCurrencyForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlanCurrencyForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planCurrency"] = this.planCurrency ? this.planCurrency.toJSON() : <any>undefined;
        data["currencyName"] = this.currencyName;
        data["planConstTitle"] = this.planConstTitle;
        return data; 
    }
}

export interface IGetPlanCurrencyForViewDto {
    planCurrency: PlanCurrencyDto;
    currencyName: string | undefined;
    planConstTitle: string | undefined;
}

export class GetPlanConstAndPlansDto implements IGetPlanConstAndPlansDto {
    planConst!: PlanConstDto;
    isCash!: boolean;
    isParticipatory!: boolean;
    isDescriptionRequired!: boolean;
    selectClient!: SelectClient;
    charityType!: CharityTypes;
    flowerCrownType!: TypesOfSolace;
    billCardTemplateProperties!: GetPropertiesForBillDto[] | undefined;
    billCardTemplateTitle!: string | undefined;
    minAmount!: number | undefined;
    maxAmount!: number | undefined;
    currencyId!: number | undefined;
    planCurrencies!: GetPlanCurrencyForViewDto[] | undefined;

    constructor(data?: IGetPlanConstAndPlansDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.planConst = data["planConst"] ? PlanConstDto.fromJS(data["planConst"]) : <any>undefined;
            this.isCash = data["isCash"];
            this.isParticipatory = data["isParticipatory"];
            this.isDescriptionRequired = data["isDescriptionRequired"];
            this.selectClient = data["selectClient"];
            this.charityType = data["charityType"];
            this.flowerCrownType = data["flowerCrownType"];
            if (Array.isArray(data["billCardTemplateProperties"])) {
                this.billCardTemplateProperties = [] as any;
                for (let item of data["billCardTemplateProperties"])
                    this.billCardTemplateProperties!.push(GetPropertiesForBillDto.fromJS(item));
            }
            this.billCardTemplateTitle = data["billCardTemplateTitle"];
            this.minAmount = data["minAmount"];
            this.maxAmount = data["maxAmount"];
            this.currencyId = data["currencyId"];
            if (Array.isArray(data["planCurrencies"])) {
                this.planCurrencies = [] as any;
                for (let item of data["planCurrencies"])
                    this.planCurrencies!.push(GetPlanCurrencyForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPlanConstAndPlansDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlanConstAndPlansDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planConst"] = this.planConst ? this.planConst.toJSON() : <any>undefined;
        data["isCash"] = this.isCash;
        data["isParticipatory"] = this.isParticipatory;
        data["isDescriptionRequired"] = this.isDescriptionRequired;
        data["selectClient"] = this.selectClient;
        data["charityType"] = this.charityType;
        data["flowerCrownType"] = this.flowerCrownType;
        if (Array.isArray(this.billCardTemplateProperties)) {
            data["billCardTemplateProperties"] = [];
            for (let item of this.billCardTemplateProperties)
                data["billCardTemplateProperties"].push(item.toJSON());
        }
        data["billCardTemplateTitle"] = this.billCardTemplateTitle;
        data["minAmount"] = this.minAmount;
        data["maxAmount"] = this.maxAmount;
        data["currencyId"] = this.currencyId;
        if (Array.isArray(this.planCurrencies)) {
            data["planCurrencies"] = [];
            for (let item of this.planCurrencies)
                data["planCurrencies"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetPlanConstAndPlansDto {
    planConst: PlanConstDto;
    isCash: boolean;
    isParticipatory: boolean;
    isDescriptionRequired: boolean;
    selectClient: SelectClient;
    charityType: CharityTypes;
    flowerCrownType: TypesOfSolace;
    billCardTemplateProperties: GetPropertiesForBillDto[] | undefined;
    billCardTemplateTitle: string | undefined;
    minAmount: number | undefined;
    maxAmount: number | undefined;
    currencyId: number | undefined;
    planCurrencies: GetPlanCurrencyForViewDto[] | undefined;
}

export class CreateOrEditPlanConstDto implements ICreateOrEditPlanConstDto {
    title!: string | undefined;
    code!: string | undefined;
    isShow!: boolean;
    state!: boolean;
    description!: string | undefined;
    planLink!: string | undefined;
    startDate!: moment.Moment | undefined;
    consumesRef!: string | undefined;
    endDate!: moment.Moment | undefined;
    planType!: Plans;
    planCategoryId!: number | undefined;
    hasPostmanPayment!: boolean;
    deliveryType!: DeliveryTypes;
    showInNewest!: boolean;
    showInPopular!: boolean;
    default!: boolean;
    sourceId!: number | undefined;
    tags!: string | undefined;
    cardTemplateRef!: number | undefined;
    order!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditPlanConstDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.code = data["code"];
            this.isShow = data["isShow"];
            this.state = data["state"];
            this.description = data["description"];
            this.planLink = data["planLink"];
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.consumesRef = data["consumesRef"];
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.planType = data["planType"];
            this.planCategoryId = data["planCategoryId"];
            this.hasPostmanPayment = data["hasPostmanPayment"];
            this.deliveryType = data["deliveryType"];
            this.showInNewest = data["showInNewest"];
            this.showInPopular = data["showInPopular"];
            this.default = data["default"];
            this.sourceId = data["sourceId"];
            this.tags = data["tags"];
            this.cardTemplateRef = data["cardTemplateRef"];
            this.order = data["order"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditPlanConstDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPlanConstDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["code"] = this.code;
        data["isShow"] = this.isShow;
        data["state"] = this.state;
        data["description"] = this.description;
        data["planLink"] = this.planLink;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["consumesRef"] = this.consumesRef;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["planType"] = this.planType;
        data["planCategoryId"] = this.planCategoryId;
        data["hasPostmanPayment"] = this.hasPostmanPayment;
        data["deliveryType"] = this.deliveryType;
        data["showInNewest"] = this.showInNewest;
        data["showInPopular"] = this.showInPopular;
        data["default"] = this.default;
        data["sourceId"] = this.sourceId;
        data["tags"] = this.tags;
        data["cardTemplateRef"] = this.cardTemplateRef;
        data["order"] = this.order;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditPlanConstDto {
    title: string | undefined;
    code: string | undefined;
    isShow: boolean;
    state: boolean;
    description: string | undefined;
    planLink: string | undefined;
    startDate: moment.Moment | undefined;
    consumesRef: string | undefined;
    endDate: moment.Moment | undefined;
    planType: Plans;
    planCategoryId: number | undefined;
    hasPostmanPayment: boolean;
    deliveryType: DeliveryTypes;
    showInNewest: boolean;
    showInPopular: boolean;
    default: boolean;
    sourceId: number | undefined;
    tags: string | undefined;
    cardTemplateRef: number | undefined;
    order: number | undefined;
    id: number | undefined;
}

export class GetPlanConstForEditOutput implements IGetPlanConstForEditOutput {
    planConst!: CreateOrEditPlanConstDto;
    planCategoryTitle!: string | undefined;
    sourceName!: string | undefined;
    cardTemplateTitle!: string | undefined;

    constructor(data?: IGetPlanConstForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.planConst = data["planConst"] ? CreateOrEditPlanConstDto.fromJS(data["planConst"]) : <any>undefined;
            this.planCategoryTitle = data["planCategoryTitle"];
            this.sourceName = data["sourceName"];
            this.cardTemplateTitle = data["cardTemplateTitle"];
        }
    }

    static fromJS(data: any): GetPlanConstForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlanConstForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planConst"] = this.planConst ? this.planConst.toJSON() : <any>undefined;
        data["planCategoryTitle"] = this.planCategoryTitle;
        data["sourceName"] = this.sourceName;
        data["cardTemplateTitle"] = this.cardTemplateTitle;
        return data; 
    }
}

export interface IGetPlanConstForEditOutput {
    planConst: CreateOrEditPlanConstDto;
    planCategoryTitle: string | undefined;
    sourceName: string | undefined;
    cardTemplateTitle: string | undefined;
}

export class CreateOrEditSacrificeDto implements ICreateOrEditSacrificeDto {
    isParticipatory!: boolean;
    maxOrder!: number | undefined;
    targetAmount!: number | undefined;
    ancillaryCostsAmount!: number | undefined;
    isContinuous!: boolean;
    baseTimesRef!: string | undefined;
    planConstId!: number;
    sacrificeTypeRef!: number;
    maximumAnnouncementDate!: number | undefined;
    type!: CharityTypes;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSacrificeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isParticipatory = data["isParticipatory"];
            this.maxOrder = data["maxOrder"];
            this.targetAmount = data["targetAmount"];
            this.ancillaryCostsAmount = data["ancillaryCostsAmount"];
            this.isContinuous = data["isContinuous"];
            this.baseTimesRef = data["baseTimesRef"];
            this.planConstId = data["planConstId"];
            this.sacrificeTypeRef = data["sacrificeTypeRef"];
            this.maximumAnnouncementDate = data["maximumAnnouncementDate"];
            this.type = data["type"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSacrificeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSacrificeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isParticipatory"] = this.isParticipatory;
        data["maxOrder"] = this.maxOrder;
        data["targetAmount"] = this.targetAmount;
        data["ancillaryCostsAmount"] = this.ancillaryCostsAmount;
        data["isContinuous"] = this.isContinuous;
        data["baseTimesRef"] = this.baseTimesRef;
        data["planConstId"] = this.planConstId;
        data["sacrificeTypeRef"] = this.sacrificeTypeRef;
        data["maximumAnnouncementDate"] = this.maximumAnnouncementDate;
        data["type"] = this.type;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditSacrificeDto {
    isParticipatory: boolean;
    maxOrder: number | undefined;
    targetAmount: number | undefined;
    ancillaryCostsAmount: number | undefined;
    isContinuous: boolean;
    baseTimesRef: string | undefined;
    planConstId: number;
    sacrificeTypeRef: number;
    maximumAnnouncementDate: number | undefined;
    type: CharityTypes;
    id: number | undefined;
}

export class CreateOrEditPlanCurrencyDto implements ICreateOrEditPlanCurrencyDto {
    minAmount!: number | undefined;
    maxAmount!: number | undefined;
    currencyRef!: number;
    planConstRef!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditPlanCurrencyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.minAmount = data["minAmount"];
            this.maxAmount = data["maxAmount"];
            this.currencyRef = data["currencyRef"];
            this.planConstRef = data["planConstRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditPlanCurrencyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPlanCurrencyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minAmount"] = this.minAmount;
        data["maxAmount"] = this.maxAmount;
        data["currencyRef"] = this.currencyRef;
        data["planConstRef"] = this.planConstRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditPlanCurrencyDto {
    minAmount: number | undefined;
    maxAmount: number | undefined;
    currencyRef: number;
    planConstRef: number;
    id: number | undefined;
}

export class CreateOrEditPlanConstAndBannerAndPlansDto implements ICreateOrEditPlanConstAndBannerAndPlansDto {
    planConst!: CreateOrEditPlanConstDto;
    banners!: CreateOrEditBannerDto[] | undefined;
    charity!: CreateOrEditCharityPlanDto;
    flowerCrown!: CreateOrEditFlowerCrownDto;
    sacrifice!: CreateOrEditSacrificeDto;
    moneyBox!: CreateOrEditMoneyBoxDto;
    planCurrencies!: CreateOrEditPlanCurrencyDto[] | undefined;
    walletApplicationServices!: CreateOrEditApplicationServiceDto[] | undefined;

    constructor(data?: ICreateOrEditPlanConstAndBannerAndPlansDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.planConst = data["planConst"] ? CreateOrEditPlanConstDto.fromJS(data["planConst"]) : <any>undefined;
            if (Array.isArray(data["banners"])) {
                this.banners = [] as any;
                for (let item of data["banners"])
                    this.banners!.push(CreateOrEditBannerDto.fromJS(item));
            }
            this.charity = data["charity"] ? CreateOrEditCharityPlanDto.fromJS(data["charity"]) : <any>undefined;
            this.flowerCrown = data["flowerCrown"] ? CreateOrEditFlowerCrownDto.fromJS(data["flowerCrown"]) : <any>undefined;
            this.sacrifice = data["sacrifice"] ? CreateOrEditSacrificeDto.fromJS(data["sacrifice"]) : <any>undefined;
            this.moneyBox = data["moneyBox"] ? CreateOrEditMoneyBoxDto.fromJS(data["moneyBox"]) : <any>undefined;
            if (Array.isArray(data["planCurrencies"])) {
                this.planCurrencies = [] as any;
                for (let item of data["planCurrencies"])
                    this.planCurrencies!.push(CreateOrEditPlanCurrencyDto.fromJS(item));
            }
            if (Array.isArray(data["walletApplicationServices"])) {
                this.walletApplicationServices = [] as any;
                for (let item of data["walletApplicationServices"])
                    this.walletApplicationServices!.push(CreateOrEditApplicationServiceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrEditPlanConstAndBannerAndPlansDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPlanConstAndBannerAndPlansDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planConst"] = this.planConst ? this.planConst.toJSON() : <any>undefined;
        if (Array.isArray(this.banners)) {
            data["banners"] = [];
            for (let item of this.banners)
                data["banners"].push(item.toJSON());
        }
        data["charity"] = this.charity ? this.charity.toJSON() : <any>undefined;
        data["flowerCrown"] = this.flowerCrown ? this.flowerCrown.toJSON() : <any>undefined;
        data["sacrifice"] = this.sacrifice ? this.sacrifice.toJSON() : <any>undefined;
        data["moneyBox"] = this.moneyBox ? this.moneyBox.toJSON() : <any>undefined;
        if (Array.isArray(this.planCurrencies)) {
            data["planCurrencies"] = [];
            for (let item of this.planCurrencies)
                data["planCurrencies"].push(item.toJSON());
        }
        if (Array.isArray(this.walletApplicationServices)) {
            data["walletApplicationServices"] = [];
            for (let item of this.walletApplicationServices)
                data["walletApplicationServices"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateOrEditPlanConstAndBannerAndPlansDto {
    planConst: CreateOrEditPlanConstDto;
    banners: CreateOrEditBannerDto[] | undefined;
    charity: CreateOrEditCharityPlanDto;
    flowerCrown: CreateOrEditFlowerCrownDto;
    sacrifice: CreateOrEditSacrificeDto;
    moneyBox: CreateOrEditMoneyBoxDto;
    planCurrencies: CreateOrEditPlanCurrencyDto[] | undefined;
    walletApplicationServices: CreateOrEditApplicationServiceDto[] | undefined;
}

export class GetPlanForViewDto implements IGetPlanForViewDto {
    title!: string | undefined;
    planConstCode!: string | undefined;
    planConstId!: number;
    planCategoryTitle!: string | undefined;
    planType!: Plans;
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    state!: boolean;
    description!: string | undefined;
    default!: boolean;
    order!: number | undefined;

    constructor(data?: IGetPlanForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.planConstCode = data["planConstCode"];
            this.planConstId = data["planConstId"];
            this.planCategoryTitle = data["planCategoryTitle"];
            this.planType = data["planType"];
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.state = data["state"];
            this.description = data["description"];
            this.default = data["default"];
            this.order = data["order"];
        }
    }

    static fromJS(data: any): GetPlanForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlanForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["planConstCode"] = this.planConstCode;
        data["planConstId"] = this.planConstId;
        data["planCategoryTitle"] = this.planCategoryTitle;
        data["planType"] = this.planType;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["state"] = this.state;
        data["description"] = this.description;
        data["default"] = this.default;
        data["order"] = this.order;
        return data; 
    }
}

export interface IGetPlanForViewDto {
    title: string | undefined;
    planConstCode: string | undefined;
    planConstId: number;
    planCategoryTitle: string | undefined;
    planType: Plans;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    state: boolean;
    description: string | undefined;
    default: boolean;
    order: number | undefined;
}

export class PagedResultDtoOfGetPlanForViewDto implements IPagedResultDtoOfGetPlanForViewDto {
    totalCount!: number;
    items!: GetPlanForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetPlanForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetPlanForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetPlanForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetPlanForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetPlanForViewDto {
    totalCount: number;
    items: GetPlanForViewDto[] | undefined;
}

export class GetSacrificeForEditOutput implements IGetSacrificeForEditOutput {
    sacrifice!: CreateOrEditSacrificeDto;
    planConstTitle!: string | undefined;
    sacrificeTypeTitle!: string | undefined;

    constructor(data?: IGetSacrificeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sacrifice = data["sacrifice"] ? CreateOrEditSacrificeDto.fromJS(data["sacrifice"]) : <any>undefined;
            this.planConstTitle = data["planConstTitle"];
            this.sacrificeTypeTitle = data["sacrificeTypeTitle"];
        }
    }

    static fromJS(data: any): GetSacrificeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSacrificeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sacrifice"] = this.sacrifice ? this.sacrifice.toJSON() : <any>undefined;
        data["planConstTitle"] = this.planConstTitle;
        data["sacrificeTypeTitle"] = this.sacrificeTypeTitle;
        return data; 
    }
}

export interface IGetSacrificeForEditOutput {
    sacrifice: CreateOrEditSacrificeDto;
    planConstTitle: string | undefined;
    sacrificeTypeTitle: string | undefined;
}

export class GetPlanConstAndBannerAndPlansDto implements IGetPlanConstAndBannerAndPlansDto {
    planConst!: GetPlanConstForEditOutput;
    banners!: PagedResultDtoOfCreateOrEditBannerDto;
    charity!: GetCharityPlanForEditOutput;
    flowerCrown!: GetFlowerCrownForEditOutput;
    sacrifice!: GetSacrificeForEditOutput;
    moneyBox!: GetMoneyBoxForEditOutput;
    planCurrencies!: GetPlanCurrencyForViewDto[] | undefined;
    walletApplicationServices!: CreateOrEditApplicationServiceDto[] | undefined;

    constructor(data?: IGetPlanConstAndBannerAndPlansDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.planConst = data["planConst"] ? GetPlanConstForEditOutput.fromJS(data["planConst"]) : <any>undefined;
            this.banners = data["banners"] ? PagedResultDtoOfCreateOrEditBannerDto.fromJS(data["banners"]) : <any>undefined;
            this.charity = data["charity"] ? GetCharityPlanForEditOutput.fromJS(data["charity"]) : <any>undefined;
            this.flowerCrown = data["flowerCrown"] ? GetFlowerCrownForEditOutput.fromJS(data["flowerCrown"]) : <any>undefined;
            this.sacrifice = data["sacrifice"] ? GetSacrificeForEditOutput.fromJS(data["sacrifice"]) : <any>undefined;
            this.moneyBox = data["moneyBox"] ? GetMoneyBoxForEditOutput.fromJS(data["moneyBox"]) : <any>undefined;
            if (Array.isArray(data["planCurrencies"])) {
                this.planCurrencies = [] as any;
                for (let item of data["planCurrencies"])
                    this.planCurrencies!.push(GetPlanCurrencyForViewDto.fromJS(item));
            }
            if (Array.isArray(data["walletApplicationServices"])) {
                this.walletApplicationServices = [] as any;
                for (let item of data["walletApplicationServices"])
                    this.walletApplicationServices!.push(CreateOrEditApplicationServiceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPlanConstAndBannerAndPlansDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlanConstAndBannerAndPlansDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planConst"] = this.planConst ? this.planConst.toJSON() : <any>undefined;
        data["banners"] = this.banners ? this.banners.toJSON() : <any>undefined;
        data["charity"] = this.charity ? this.charity.toJSON() : <any>undefined;
        data["flowerCrown"] = this.flowerCrown ? this.flowerCrown.toJSON() : <any>undefined;
        data["sacrifice"] = this.sacrifice ? this.sacrifice.toJSON() : <any>undefined;
        data["moneyBox"] = this.moneyBox ? this.moneyBox.toJSON() : <any>undefined;
        if (Array.isArray(this.planCurrencies)) {
            data["planCurrencies"] = [];
            for (let item of this.planCurrencies)
                data["planCurrencies"].push(item.toJSON());
        }
        if (Array.isArray(this.walletApplicationServices)) {
            data["walletApplicationServices"] = [];
            for (let item of this.walletApplicationServices)
                data["walletApplicationServices"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetPlanConstAndBannerAndPlansDto {
    planConst: GetPlanConstForEditOutput;
    banners: PagedResultDtoOfCreateOrEditBannerDto;
    charity: GetCharityPlanForEditOutput;
    flowerCrown: GetFlowerCrownForEditOutput;
    sacrifice: GetSacrificeForEditOutput;
    moneyBox: GetMoneyBoxForEditOutput;
    planCurrencies: GetPlanCurrencyForViewDto[] | undefined;
    walletApplicationServices: CreateOrEditApplicationServiceDto[] | undefined;
}

export enum RequestPage {
    Default = 0,
    Main = 1,
    Search = 2,
}

export class Info implements IInfo {
    id!: number | undefined;
    title!: string | undefined;
    parentId!: number | undefined;
    icon!: string | undefined;

    constructor(data?: IInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.title = data["title"];
            this.parentId = data["parentId"];
            this.icon = data["icon"];
        }
    }

    static fromJS(data: any): Info {
        data = typeof data === 'object' ? data : {};
        let result = new Info();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["parentId"] = this.parentId;
        data["icon"] = this.icon;
        return data; 
    }
}

export interface IInfo {
    id: number | undefined;
    title: string | undefined;
    parentId: number | undefined;
    icon: string | undefined;
}

export class BaseTimeType implements IBaseTimeType {
    name!: string | undefined;
    id!: number;
    duration!: BaseTimeTypes;
    referralAndPaymentToPostMan!: boolean;
    sendPaperReceipt!: boolean;

    constructor(data?: IBaseTimeType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.id = data["id"];
            this.duration = data["duration"];
            this.referralAndPaymentToPostMan = data["referralAndPaymentToPostMan"];
            this.sendPaperReceipt = data["sendPaperReceipt"];
        }
    }

    static fromJS(data: any): BaseTimeType {
        data = typeof data === 'object' ? data : {};
        let result = new BaseTimeType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        data["duration"] = this.duration;
        data["referralAndPaymentToPostMan"] = this.referralAndPaymentToPostMan;
        data["sendPaperReceipt"] = this.sendPaperReceipt;
        return data; 
    }
}

export interface IBaseTimeType {
    name: string | undefined;
    id: number;
    duration: BaseTimeTypes;
    referralAndPaymentToPostMan: boolean;
    sendPaperReceipt: boolean;
}

export class Image implements IImage {
    filePath!: string | undefined;
    thumbPath!: string | undefined;
    order!: number;
    time!: number | undefined;

    constructor(data?: IImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filePath = data["filePath"];
            this.thumbPath = data["thumbPath"];
            this.order = data["order"];
            this.time = data["time"];
        }
    }

    static fromJS(data: any): Image {
        data = typeof data === 'object' ? data : {};
        let result = new Image();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filePath"] = this.filePath;
        data["thumbPath"] = this.thumbPath;
        data["order"] = this.order;
        data["time"] = this.time;
        return data; 
    }
}

export interface IImage {
    filePath: string | undefined;
    thumbPath: string | undefined;
    order: number;
    time: number | undefined;
}

export class GetAllPlansForShopViewDto implements IGetAllPlansForShopViewDto {
    planId!: number | undefined;
    planConstId!: number;
    title!: string | undefined;
    category!: Info;
    code!: string | undefined;
    currencyName!: string | undefined;
    currencyId!: number | undefined;
    description!: string | undefined;
    planType!: Plans;
    typesOfSolace!: TypesOfSolace;
    charityType!: CharityTypes;
    deliveryType!: DeliveryTypes;
    tags!: string[] | undefined;
    minPrice!: number | undefined;
    maxPrice!: number | undefined;
    amount!: number | undefined;
    video!: string | undefined;
    source!: string | undefined;
    sourceId!: number | undefined;
    consumes!: string | undefined;
    isCash!: boolean;
    isContinuous!: boolean;
    isParticipatory!: boolean;
    isDescriptionRequired!: boolean;
    hasPostmanPayment!: boolean;
    maxOrder!: number | undefined;
    inStock!: string | undefined;
    isVirtualMoneyBox!: boolean;
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    baseTime!: BaseTimeType[] | undefined;
    selectClient!: SelectClient;
    banners!: Image[] | undefined;
    properties!: Property[] | undefined;
    related!: GetAllPlansForShopViewDto[] | undefined;
    targetAmount!: number | undefined;
    remainingAmount!: number | undefined;
    participationAmount!: number | undefined;
    participationNumber!: number | undefined;
    lastModified!: moment.Moment | undefined;
    isShow!: boolean;
    order!: number | undefined;

    constructor(data?: IGetAllPlansForShopViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.planId = data["planId"];
            this.planConstId = data["planConstId"];
            this.title = data["title"];
            this.category = data["category"] ? Info.fromJS(data["category"]) : <any>undefined;
            this.code = data["code"];
            this.currencyName = data["currencyName"];
            this.currencyId = data["currencyId"];
            this.description = data["description"];
            this.planType = data["planType"];
            this.typesOfSolace = data["typesOfSolace"];
            this.charityType = data["charityType"];
            this.deliveryType = data["deliveryType"];
            if (Array.isArray(data["tags"])) {
                this.tags = [] as any;
                for (let item of data["tags"])
                    this.tags!.push(item);
            }
            this.minPrice = data["minPrice"];
            this.maxPrice = data["maxPrice"];
            this.amount = data["amount"];
            this.video = data["video"];
            this.source = data["source"];
            this.sourceId = data["sourceId"];
            this.consumes = data["consumes"];
            this.isCash = data["isCash"];
            this.isContinuous = data["isContinuous"];
            this.isParticipatory = data["isParticipatory"];
            this.isDescriptionRequired = data["isDescriptionRequired"];
            this.hasPostmanPayment = data["hasPostmanPayment"];
            this.maxOrder = data["maxOrder"];
            this.inStock = data["inStock"];
            this.isVirtualMoneyBox = data["isVirtualMoneyBox"];
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(data["baseTime"])) {
                this.baseTime = [] as any;
                for (let item of data["baseTime"])
                    this.baseTime!.push(BaseTimeType.fromJS(item));
            }
            this.selectClient = data["selectClient"];
            if (Array.isArray(data["banners"])) {
                this.banners = [] as any;
                for (let item of data["banners"])
                    this.banners!.push(Image.fromJS(item));
            }
            if (Array.isArray(data["properties"])) {
                this.properties = [] as any;
                for (let item of data["properties"])
                    this.properties!.push(Property.fromJS(item));
            }
            if (Array.isArray(data["related"])) {
                this.related = [] as any;
                for (let item of data["related"])
                    this.related!.push(GetAllPlansForShopViewDto.fromJS(item));
            }
            this.targetAmount = data["targetAmount"];
            this.remainingAmount = data["remainingAmount"];
            this.participationAmount = data["participationAmount"];
            this.participationNumber = data["participationNumber"];
            this.lastModified = data["lastModified"] ? moment(data["lastModified"].toString()) : <any>undefined;
            this.isShow = data["isShow"];
            this.order = data["order"];
        }
    }

    static fromJS(data: any): GetAllPlansForShopViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllPlansForShopViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planId"] = this.planId;
        data["planConstId"] = this.planConstId;
        data["title"] = this.title;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        data["code"] = this.code;
        data["currencyName"] = this.currencyName;
        data["currencyId"] = this.currencyId;
        data["description"] = this.description;
        data["planType"] = this.planType;
        data["typesOfSolace"] = this.typesOfSolace;
        data["charityType"] = this.charityType;
        data["deliveryType"] = this.deliveryType;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["minPrice"] = this.minPrice;
        data["maxPrice"] = this.maxPrice;
        data["amount"] = this.amount;
        data["video"] = this.video;
        data["source"] = this.source;
        data["sourceId"] = this.sourceId;
        data["consumes"] = this.consumes;
        data["isCash"] = this.isCash;
        data["isContinuous"] = this.isContinuous;
        data["isParticipatory"] = this.isParticipatory;
        data["isDescriptionRequired"] = this.isDescriptionRequired;
        data["hasPostmanPayment"] = this.hasPostmanPayment;
        data["maxOrder"] = this.maxOrder;
        data["inStock"] = this.inStock;
        data["isVirtualMoneyBox"] = this.isVirtualMoneyBox;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.baseTime)) {
            data["baseTime"] = [];
            for (let item of this.baseTime)
                data["baseTime"].push(item.toJSON());
        }
        data["selectClient"] = this.selectClient;
        if (Array.isArray(this.banners)) {
            data["banners"] = [];
            for (let item of this.banners)
                data["banners"].push(item.toJSON());
        }
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item.toJSON());
        }
        if (Array.isArray(this.related)) {
            data["related"] = [];
            for (let item of this.related)
                data["related"].push(item.toJSON());
        }
        data["targetAmount"] = this.targetAmount;
        data["remainingAmount"] = this.remainingAmount;
        data["participationAmount"] = this.participationAmount;
        data["participationNumber"] = this.participationNumber;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["isShow"] = this.isShow;
        data["order"] = this.order;
        return data; 
    }
}

export interface IGetAllPlansForShopViewDto {
    planId: number | undefined;
    planConstId: number;
    title: string | undefined;
    category: Info;
    code: string | undefined;
    currencyName: string | undefined;
    currencyId: number | undefined;
    description: string | undefined;
    planType: Plans;
    typesOfSolace: TypesOfSolace;
    charityType: CharityTypes;
    deliveryType: DeliveryTypes;
    tags: string[] | undefined;
    minPrice: number | undefined;
    maxPrice: number | undefined;
    amount: number | undefined;
    video: string | undefined;
    source: string | undefined;
    sourceId: number | undefined;
    consumes: string | undefined;
    isCash: boolean;
    isContinuous: boolean;
    isParticipatory: boolean;
    isDescriptionRequired: boolean;
    hasPostmanPayment: boolean;
    maxOrder: number | undefined;
    inStock: string | undefined;
    isVirtualMoneyBox: boolean;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    baseTime: BaseTimeType[] | undefined;
    selectClient: SelectClient;
    banners: Image[] | undefined;
    properties: Property[] | undefined;
    related: GetAllPlansForShopViewDto[] | undefined;
    targetAmount: number | undefined;
    remainingAmount: number | undefined;
    participationAmount: number | undefined;
    participationNumber: number | undefined;
    lastModified: moment.Moment | undefined;
    isShow: boolean;
    order: number | undefined;
}

export class Category implements ICategory {
    name!: string | undefined;
    id!: number;

    constructor(data?: ICategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Category {
        data = typeof data === 'object' ? data : {};
        let result = new Category();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICategory {
    name: string | undefined;
    id: number;
}

export class PagedResultPlanShopDto implements IPagedResultPlanShopDto {
    items!: GetAllPlansForShopViewDto[] | undefined;
    breadCrumbs!: Category[] | undefined;
    totalCount!: number;
    minPrice!: number;
    maxPrice!: number;

    constructor(data?: IPagedResultPlanShopDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetAllPlansForShopViewDto.fromJS(item));
            }
            if (Array.isArray(data["breadCrumbs"])) {
                this.breadCrumbs = [] as any;
                for (let item of data["breadCrumbs"])
                    this.breadCrumbs!.push(Category.fromJS(item));
            }
            this.totalCount = data["totalCount"];
            this.minPrice = data["minPrice"];
            this.maxPrice = data["maxPrice"];
        }
    }

    static fromJS(data: any): PagedResultPlanShopDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultPlanShopDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        if (Array.isArray(this.breadCrumbs)) {
            data["breadCrumbs"] = [];
            for (let item of this.breadCrumbs)
                data["breadCrumbs"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["minPrice"] = this.minPrice;
        data["maxPrice"] = this.maxPrice;
        return data; 
    }
}

export interface IPagedResultPlanShopDto {
    items: GetAllPlansForShopViewDto[] | undefined;
    breadCrumbs: Category[] | undefined;
    totalCount: number;
    minPrice: number;
    maxPrice: number;
}

export class PlanConstSourceLookupTableDto implements IPlanConstSourceLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    isDefault!: boolean;

    constructor(data?: IPlanConstSourceLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.isDefault = data["isDefault"];
        }
    }

    static fromJS(data: any): PlanConstSourceLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlanConstSourceLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["isDefault"] = this.isDefault;
        return data; 
    }
}

export interface IPlanConstSourceLookupTableDto {
    id: number;
    displayName: string | undefined;
    isDefault: boolean;
}

export class PlanConstPlanCategoryLookupTableDto implements IPlanConstPlanCategoryLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IPlanConstPlanCategoryLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): PlanConstPlanCategoryLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlanConstPlanCategoryLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IPlanConstPlanCategoryLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PlanConstCurrencyLookupTableDto implements IPlanConstCurrencyLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IPlanConstCurrencyLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): PlanConstCurrencyLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlanConstCurrencyLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IPlanConstCurrencyLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PlanConstConsumeLookupTableDto implements IPlanConstConsumeLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IPlanConstConsumeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): PlanConstConsumeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlanConstConsumeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IPlanConstConsumeLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PlanConstCardTemplateLookupTableDto implements IPlanConstCardTemplateLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    isDefault!: boolean;

    constructor(data?: IPlanConstCardTemplateLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.isDefault = data["isDefault"];
        }
    }

    static fromJS(data: any): PlanConstCardTemplateLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlanConstCardTemplateLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["isDefault"] = this.isDefault;
        return data; 
    }
}

export interface IPlanConstCardTemplateLookupTableDto {
    id: number;
    displayName: string | undefined;
    isDefault: boolean;
}

export class GetAllClientForShopDto implements IGetAllClientForShopDto {
    fullName!: string | undefined;
    entityRef!: number;
    entity!: Entities;
    birthDay!: moment.Moment | undefined;
    age!: number | undefined;
    imagePath!: string | undefined;
    identityCode!: string | undefined;
    code!: string | undefined;
    gender!: Gender;
    educationDegree!: string | undefined;
    healthStatus!: string | undefined;
    registerDate!: string | undefined;
    insuranceType!: InsuranceType;
    relationWithSupervisor!: string | undefined;
    residenceType!: ResidenceType;
    city!: string | undefined;
    area!: string | undefined;
    familyNumber!: number | undefined;
    isSadat!: boolean;
    isMotherAlive!: boolean;
    properties!: Property[] | undefined;

    constructor(data?: IGetAllClientForShopDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fullName = data["fullName"];
            this.entityRef = data["entityRef"];
            this.entity = data["entity"];
            this.birthDay = data["birthDay"] ? moment(data["birthDay"].toString()) : <any>undefined;
            this.age = data["age"];
            this.imagePath = data["imagePath"];
            this.identityCode = data["identityCode"];
            this.code = data["code"];
            this.gender = data["gender"];
            this.educationDegree = data["educationDegree"];
            this.healthStatus = data["healthStatus"];
            this.registerDate = data["registerDate"];
            this.insuranceType = data["insuranceType"];
            this.relationWithSupervisor = data["relationWithSupervisor"];
            this.residenceType = data["residenceType"];
            this.city = data["city"];
            this.area = data["area"];
            this.familyNumber = data["familyNumber"];
            this.isSadat = data["isSadat"];
            this.isMotherAlive = data["isMotherAlive"];
            if (Array.isArray(data["properties"])) {
                this.properties = [] as any;
                for (let item of data["properties"])
                    this.properties!.push(Property.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllClientForShopDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllClientForShopDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["entityRef"] = this.entityRef;
        data["entity"] = this.entity;
        data["birthDay"] = this.birthDay ? this.birthDay.toISOString() : <any>undefined;
        data["age"] = this.age;
        data["imagePath"] = this.imagePath;
        data["identityCode"] = this.identityCode;
        data["code"] = this.code;
        data["gender"] = this.gender;
        data["educationDegree"] = this.educationDegree;
        data["healthStatus"] = this.healthStatus;
        data["registerDate"] = this.registerDate;
        data["insuranceType"] = this.insuranceType;
        data["relationWithSupervisor"] = this.relationWithSupervisor;
        data["residenceType"] = this.residenceType;
        data["city"] = this.city;
        data["area"] = this.area;
        data["familyNumber"] = this.familyNumber;
        data["isSadat"] = this.isSadat;
        data["isMotherAlive"] = this.isMotherAlive;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetAllClientForShopDto {
    fullName: string | undefined;
    entityRef: number;
    entity: Entities;
    birthDay: moment.Moment | undefined;
    age: number | undefined;
    imagePath: string | undefined;
    identityCode: string | undefined;
    code: string | undefined;
    gender: Gender;
    educationDegree: string | undefined;
    healthStatus: string | undefined;
    registerDate: string | undefined;
    insuranceType: InsuranceType;
    relationWithSupervisor: string | undefined;
    residenceType: ResidenceType;
    city: string | undefined;
    area: string | undefined;
    familyNumber: number | undefined;
    isSadat: boolean;
    isMotherAlive: boolean;
    properties: Property[] | undefined;
}

export class PagedResultDtoOfGetAllClientForShopDto implements IPagedResultDtoOfGetAllClientForShopDto {
    totalCount!: number;
    items!: GetAllClientForShopDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAllClientForShopDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetAllClientForShopDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAllClientForShopDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAllClientForShopDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetAllClientForShopDto {
    totalCount: number;
    items: GetAllClientForShopDto[] | undefined;
}

export class PlanCategory implements IPlanCategory {
    tenantId!: number | undefined;
    title!: string | undefined;
    state!: boolean | undefined;
    icon!: string | undefined;
    parentId!: number | undefined;
    description!: string | undefined;
    created!: moment.Moment;
    modified!: moment.Moment | undefined;
    createdBy!: number;
    modifiedBy!: number | undefined;
    filePath!: string | undefined;
    thumbPath!: string | undefined;
    isPromote!: boolean;
    order!: number | undefined;
    id!: number;

    constructor(data?: IPlanCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.title = data["title"];
            this.state = data["state"];
            this.icon = data["icon"];
            this.parentId = data["parentId"];
            this.description = data["description"];
            this.created = data["created"] ? moment(data["created"].toString()) : <any>undefined;
            this.modified = data["modified"] ? moment(data["modified"].toString()) : <any>undefined;
            this.createdBy = data["createdBy"];
            this.modifiedBy = data["modifiedBy"];
            this.filePath = data["filePath"];
            this.thumbPath = data["thumbPath"];
            this.isPromote = data["isPromote"];
            this.order = data["order"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PlanCategory {
        data = typeof data === 'object' ? data : {};
        let result = new PlanCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["title"] = this.title;
        data["state"] = this.state;
        data["icon"] = this.icon;
        data["parentId"] = this.parentId;
        data["description"] = this.description;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["modifiedBy"] = this.modifiedBy;
        data["filePath"] = this.filePath;
        data["thumbPath"] = this.thumbPath;
        data["isPromote"] = this.isPromote;
        data["order"] = this.order;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPlanCategory {
    tenantId: number | undefined;
    title: string | undefined;
    state: boolean | undefined;
    icon: string | undefined;
    parentId: number | undefined;
    description: string | undefined;
    created: moment.Moment;
    modified: moment.Moment | undefined;
    createdBy: number;
    modifiedBy: number | undefined;
    filePath: string | undefined;
    thumbPath: string | undefined;
    isPromote: boolean;
    order: number | undefined;
    id: number;
}

export class Source implements ISource {
    tenantId!: number | undefined;
    name!: string | undefined;
    accountCode!: string | undefined;
    description!: string | undefined;
    state!: boolean;
    isDefault!: boolean;
    shortcutKey!: string | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ISource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.name = data["name"];
            this.accountCode = data["accountCode"];
            this.description = data["description"];
            this.state = data["state"];
            this.isDefault = data["isDefault"];
            this.shortcutKey = data["shortcutKey"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Source {
        data = typeof data === 'object' ? data : {};
        let result = new Source();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["accountCode"] = this.accountCode;
        data["description"] = this.description;
        data["state"] = this.state;
        data["isDefault"] = this.isDefault;
        data["shortcutKey"] = this.shortcutKey;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISource {
    tenantId: number | undefined;
    name: string | undefined;
    accountCode: string | undefined;
    description: string | undefined;
    state: boolean;
    isDefault: boolean;
    shortcutKey: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class CardTemplate implements ICardTemplate {
    tenantId!: number;
    title!: string | undefined;
    isActive!: boolean;
    description!: string | undefined;
    imagePath!: string | undefined;
    width!: number | undefined;
    length!: number | undefined;
    type!: TypesOfSolace;
    isDefault!: boolean;
    singlePagePrinting!: boolean;
    advertisement!: string | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ICardTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.title = data["title"];
            this.isActive = data["isActive"];
            this.description = data["description"];
            this.imagePath = data["imagePath"];
            this.width = data["width"];
            this.length = data["length"];
            this.type = data["type"];
            this.isDefault = data["isDefault"];
            this.singlePagePrinting = data["singlePagePrinting"];
            this.advertisement = data["advertisement"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CardTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new CardTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["title"] = this.title;
        data["isActive"] = this.isActive;
        data["description"] = this.description;
        data["imagePath"] = this.imagePath;
        data["width"] = this.width;
        data["length"] = this.length;
        data["type"] = this.type;
        data["isDefault"] = this.isDefault;
        data["singlePagePrinting"] = this.singlePagePrinting;
        data["advertisement"] = this.advertisement;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICardTemplate {
    tenantId: number;
    title: string | undefined;
    isActive: boolean;
    description: string | undefined;
    imagePath: string | undefined;
    width: number | undefined;
    length: number | undefined;
    type: TypesOfSolace;
    isDefault: boolean;
    singlePagePrinting: boolean;
    advertisement: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class PlanConst implements IPlanConst {
    tenantId!: number | undefined;
    title!: string | undefined;
    code!: string | undefined;
    isShow!: boolean;
    state!: boolean;
    description!: string | undefined;
    planLink!: string | undefined;
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    planType!: Plans;
    deliveryType!: DeliveryTypes;
    showInNewest!: boolean;
    showInPopular!: boolean;
    default!: boolean;
    order!: number | undefined;
    tags!: string | undefined;
    hasPostmanPayment!: boolean;
    consumesRef!: string | undefined;
    planCategoryId!: number | undefined;
    planCategoryFk!: PlanCategory;
    sourceId!: number | undefined;
    sourceFk!: Source;
    cardTemplateRef!: number | undefined;
    cardTemplateRefFk!: CardTemplate;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IPlanConst) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.title = data["title"];
            this.code = data["code"];
            this.isShow = data["isShow"];
            this.state = data["state"];
            this.description = data["description"];
            this.planLink = data["planLink"];
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.planType = data["planType"];
            this.deliveryType = data["deliveryType"];
            this.showInNewest = data["showInNewest"];
            this.showInPopular = data["showInPopular"];
            this.default = data["default"];
            this.order = data["order"];
            this.tags = data["tags"];
            this.hasPostmanPayment = data["hasPostmanPayment"];
            this.consumesRef = data["consumesRef"];
            this.planCategoryId = data["planCategoryId"];
            this.planCategoryFk = data["planCategoryFk"] ? PlanCategory.fromJS(data["planCategoryFk"]) : <any>undefined;
            this.sourceId = data["sourceId"];
            this.sourceFk = data["sourceFk"] ? Source.fromJS(data["sourceFk"]) : <any>undefined;
            this.cardTemplateRef = data["cardTemplateRef"];
            this.cardTemplateRefFk = data["cardTemplateRefFk"] ? CardTemplate.fromJS(data["cardTemplateRefFk"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PlanConst {
        data = typeof data === 'object' ? data : {};
        let result = new PlanConst();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["title"] = this.title;
        data["code"] = this.code;
        data["isShow"] = this.isShow;
        data["state"] = this.state;
        data["description"] = this.description;
        data["planLink"] = this.planLink;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["planType"] = this.planType;
        data["deliveryType"] = this.deliveryType;
        data["showInNewest"] = this.showInNewest;
        data["showInPopular"] = this.showInPopular;
        data["default"] = this.default;
        data["order"] = this.order;
        data["tags"] = this.tags;
        data["hasPostmanPayment"] = this.hasPostmanPayment;
        data["consumesRef"] = this.consumesRef;
        data["planCategoryId"] = this.planCategoryId;
        data["planCategoryFk"] = this.planCategoryFk ? this.planCategoryFk.toJSON() : <any>undefined;
        data["sourceId"] = this.sourceId;
        data["sourceFk"] = this.sourceFk ? this.sourceFk.toJSON() : <any>undefined;
        data["cardTemplateRef"] = this.cardTemplateRef;
        data["cardTemplateRefFk"] = this.cardTemplateRefFk ? this.cardTemplateRefFk.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPlanConst {
    tenantId: number | undefined;
    title: string | undefined;
    code: string | undefined;
    isShow: boolean;
    state: boolean;
    description: string | undefined;
    planLink: string | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    planType: Plans;
    deliveryType: DeliveryTypes;
    showInNewest: boolean;
    showInPopular: boolean;
    default: boolean;
    order: number | undefined;
    tags: string | undefined;
    hasPostmanPayment: boolean;
    consumesRef: string | undefined;
    planCategoryId: number | undefined;
    planCategoryFk: PlanCategory;
    sourceId: number | undefined;
    sourceFk: Source;
    cardTemplateRef: number | undefined;
    cardTemplateRefFk: CardTemplate;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class BillInfo implements IBillInfo {
    billId!: number | undefined;
    billStatus!: BillStatus;
    issueDate!: moment.Moment | undefined;

    constructor(data?: IBillInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.billId = data["billId"];
            this.billStatus = data["billStatus"];
            this.issueDate = data["issueDate"] ? moment(data["issueDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BillInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BillInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billId"] = this.billId;
        data["billStatus"] = this.billStatus;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IBillInfo {
    billId: number | undefined;
    billStatus: BillStatus;
    issueDate: moment.Moment | undefined;
}

export class GetFlowerCrownCapacityInput implements IGetFlowerCrownCapacityInput {
    planConstId!: number;
    startCeremonyDateTime!: moment.Moment | undefined;
    latitude!: number | undefined;
    longitude!: number | undefined;
    ceremonyId!: number | undefined;
    bill!: BillInfo;

    constructor(data?: IGetFlowerCrownCapacityInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.planConstId = data["planConstId"];
            this.startCeremonyDateTime = data["startCeremonyDateTime"] ? moment(data["startCeremonyDateTime"].toString()) : <any>undefined;
            this.latitude = data["latitude"];
            this.longitude = data["longitude"];
            this.ceremonyId = data["ceremonyId"];
            this.bill = data["bill"] ? BillInfo.fromJS(data["bill"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetFlowerCrownCapacityInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetFlowerCrownCapacityInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planConstId"] = this.planConstId;
        data["startCeremonyDateTime"] = this.startCeremonyDateTime ? this.startCeremonyDateTime.toISOString() : <any>undefined;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["ceremonyId"] = this.ceremonyId;
        data["bill"] = this.bill ? this.bill.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetFlowerCrownCapacityInput {
    planConstId: number;
    startCeremonyDateTime: moment.Moment | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    ceremonyId: number | undefined;
    bill: BillInfo;
}

export class GetCharityPlanCategory implements IGetCharityPlanCategory {
    id!: number | undefined;
    title!: string | undefined;
    icon!: string | undefined;

    constructor(data?: IGetCharityPlanCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.title = data["title"];
            this.icon = data["icon"];
        }
    }

    static fromJS(data: any): GetCharityPlanCategory {
        data = typeof data === 'object' ? data : {};
        let result = new GetCharityPlanCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["icon"] = this.icon;
        return data; 
    }
}

export interface IGetCharityPlanCategory {
    id: number | undefined;
    title: string | undefined;
    icon: string | undefined;
}

export class GetCharityPlan implements IGetCharityPlan {
    id!: number | undefined;
    title!: string | undefined;
    description!: string | undefined;
    code!: string | undefined;
    tags!: string[] | undefined;
    minPrice!: number | undefined;
    maxPrice!: number | undefined;
    amount!: number | undefined;
    banners!: Image[] | undefined;
    planType!: Plans;

    constructor(data?: IGetCharityPlan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.title = data["title"];
            this.description = data["description"];
            this.code = data["code"];
            if (Array.isArray(data["tags"])) {
                this.tags = [] as any;
                for (let item of data["tags"])
                    this.tags!.push(item);
            }
            this.minPrice = data["minPrice"];
            this.maxPrice = data["maxPrice"];
            this.amount = data["amount"];
            if (Array.isArray(data["banners"])) {
                this.banners = [] as any;
                for (let item of data["banners"])
                    this.banners!.push(Image.fromJS(item));
            }
            this.planType = data["planType"];
        }
    }

    static fromJS(data: any): GetCharityPlan {
        data = typeof data === 'object' ? data : {};
        let result = new GetCharityPlan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["code"] = this.code;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["minPrice"] = this.minPrice;
        data["maxPrice"] = this.maxPrice;
        data["amount"] = this.amount;
        if (Array.isArray(this.banners)) {
            data["banners"] = [];
            for (let item of this.banners)
                data["banners"].push(item.toJSON());
        }
        data["planType"] = this.planType;
        return data; 
    }
}

export interface IGetCharityPlan {
    id: number | undefined;
    title: string | undefined;
    description: string | undefined;
    code: string | undefined;
    tags: string[] | undefined;
    minPrice: number | undefined;
    maxPrice: number | undefined;
    amount: number | undefined;
    banners: Image[] | undefined;
    planType: Plans;
}

export class GetCharityPlansDto implements IGetCharityPlansDto {
    planCategory!: GetCharityPlanCategory;
    plan!: GetCharityPlan;

    constructor(data?: IGetCharityPlansDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.planCategory = data["planCategory"] ? GetCharityPlanCategory.fromJS(data["planCategory"]) : <any>undefined;
            this.plan = data["plan"] ? GetCharityPlan.fromJS(data["plan"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCharityPlansDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCharityPlansDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planCategory"] = this.planCategory ? this.planCategory.toJSON() : <any>undefined;
        data["plan"] = this.plan ? this.plan.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetCharityPlansDto {
    planCategory: GetCharityPlanCategory;
    plan: GetCharityPlan;
}

export class PagedResultDtoOfGetCharityPlansDto implements IPagedResultDtoOfGetCharityPlansDto {
    totalCount!: number;
    items!: GetCharityPlansDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCharityPlansDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetCharityPlansDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCharityPlansDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCharityPlansDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetCharityPlansDto {
    totalCount: number;
    items: GetCharityPlansDto[] | undefined;
}

export class PagedResultDtoOfGetPlanCurrencyForViewDto implements IPagedResultDtoOfGetPlanCurrencyForViewDto {
    totalCount!: number;
    items!: GetPlanCurrencyForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetPlanCurrencyForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetPlanCurrencyForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetPlanCurrencyForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetPlanCurrencyForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetPlanCurrencyForViewDto {
    totalCount: number;
    items: GetPlanCurrencyForViewDto[] | undefined;
}

export class GetPlanCurrencyForEditOutput implements IGetPlanCurrencyForEditOutput {
    planCurrency!: CreateOrEditPlanCurrencyDto;
    currencyName!: string | undefined;
    planConstTitle!: string | undefined;

    constructor(data?: IGetPlanCurrencyForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.planCurrency = data["planCurrency"] ? CreateOrEditPlanCurrencyDto.fromJS(data["planCurrency"]) : <any>undefined;
            this.currencyName = data["currencyName"];
            this.planConstTitle = data["planConstTitle"];
        }
    }

    static fromJS(data: any): GetPlanCurrencyForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlanCurrencyForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planCurrency"] = this.planCurrency ? this.planCurrency.toJSON() : <any>undefined;
        data["currencyName"] = this.currencyName;
        data["planConstTitle"] = this.planConstTitle;
        return data; 
    }
}

export interface IGetPlanCurrencyForEditOutput {
    planCurrency: CreateOrEditPlanCurrencyDto;
    currencyName: string | undefined;
    planConstTitle: string | undefined;
}

export class PlanCurrencyCurrencyLookupTableDto implements IPlanCurrencyCurrencyLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IPlanCurrencyCurrencyLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): PlanCurrencyCurrencyLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlanCurrencyCurrencyLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IPlanCurrencyCurrencyLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PlanCurrencyPlanConstLookupTableDto implements IPlanCurrencyPlanConstLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IPlanCurrencyPlanConstLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): PlanCurrencyPlanConstLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlanCurrencyPlanConstLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IPlanCurrencyPlanConstLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfPlanCurrencyPlanConstLookupTableDto implements IPagedResultDtoOfPlanCurrencyPlanConstLookupTableDto {
    totalCount!: number;
    items!: PlanCurrencyPlanConstLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPlanCurrencyPlanConstLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(PlanCurrencyPlanConstLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPlanCurrencyPlanConstLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPlanCurrencyPlanConstLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfPlanCurrencyPlanConstLookupTableDto {
    totalCount: number;
    items: PlanCurrencyPlanConstLookupTableDto[] | undefined;
}

export class GetPointForViewDto implements IGetPointForViewDto {
    point!: PointDto;

    constructor(data?: IGetPointForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.point = data["point"] ? PointDto.fromJS(data["point"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPointForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPointForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["point"] = this.point ? this.point.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetPointForViewDto {
    point: PointDto;
}

export class PagedResultDtoOfGetPointForViewDto implements IPagedResultDtoOfGetPointForViewDto {
    totalCount!: number;
    items!: GetPointForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetPointForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetPointForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetPointForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetPointForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetPointForViewDto {
    totalCount: number;
    items: GetPointForViewDto[] | undefined;
}

export class GetPointForEditOutput implements IGetPointForEditOutput {
    point!: CreateOrEditPointDto;

    constructor(data?: IGetPointForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.point = data["point"] ? CreateOrEditPointDto.fromJS(data["point"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPointForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPointForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["point"] = this.point ? this.point.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetPointForEditOutput {
    point: CreateOrEditPointDto;
}

export enum DeviceType {
    Default = 0,
    WirelessPos = 1,
    WiredPos = 2,
}

export class PosDto implements IPosDto {
    deviceType!: DeviceType;
    psp!: PSP;
    serial!: string | undefined;
    acceptorNumber!: string | undefined;
    acceptorPassword!: string | undefined;
    posIdentity!: string | undefined;
    state!: boolean;
    pcToPos!: boolean;
    port!: number | undefined;
    ip!: string | undefined;
    systemIP!: string | undefined;
    bankAccountRef!: number;
    id!: number;

    constructor(data?: IPosDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceType = data["deviceType"];
            this.psp = data["psp"];
            this.serial = data["serial"];
            this.acceptorNumber = data["acceptorNumber"];
            this.acceptorPassword = data["acceptorPassword"];
            this.posIdentity = data["posIdentity"];
            this.state = data["state"];
            this.pcToPos = data["pcToPos"];
            this.port = data["port"];
            this.ip = data["ip"];
            this.systemIP = data["systemIP"];
            this.bankAccountRef = data["bankAccountRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PosDto {
        data = typeof data === 'object' ? data : {};
        let result = new PosDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceType"] = this.deviceType;
        data["psp"] = this.psp;
        data["serial"] = this.serial;
        data["acceptorNumber"] = this.acceptorNumber;
        data["acceptorPassword"] = this.acceptorPassword;
        data["posIdentity"] = this.posIdentity;
        data["state"] = this.state;
        data["pcToPos"] = this.pcToPos;
        data["port"] = this.port;
        data["ip"] = this.ip;
        data["systemIP"] = this.systemIP;
        data["bankAccountRef"] = this.bankAccountRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPosDto {
    deviceType: DeviceType;
    psp: PSP;
    serial: string | undefined;
    acceptorNumber: string | undefined;
    acceptorPassword: string | undefined;
    posIdentity: string | undefined;
    state: boolean;
    pcToPos: boolean;
    port: number | undefined;
    ip: string | undefined;
    systemIP: string | undefined;
    bankAccountRef: number;
    id: number;
}

export class GetPosForViewDto implements IGetPosForViewDto {
    pos!: PosDto;
    bankAccountAccountNumber!: string | undefined;

    constructor(data?: IGetPosForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pos = data["pos"] ? PosDto.fromJS(data["pos"]) : <any>undefined;
            this.bankAccountAccountNumber = data["bankAccountAccountNumber"];
        }
    }

    static fromJS(data: any): GetPosForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPosForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pos"] = this.pos ? this.pos.toJSON() : <any>undefined;
        data["bankAccountAccountNumber"] = this.bankAccountAccountNumber;
        return data; 
    }
}

export interface IGetPosForViewDto {
    pos: PosDto;
    bankAccountAccountNumber: string | undefined;
}

export class PagedResultDtoOfGetPosForViewDto implements IPagedResultDtoOfGetPosForViewDto {
    totalCount!: number;
    items!: GetPosForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetPosForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetPosForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetPosForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetPosForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetPosForViewDto {
    totalCount: number;
    items: GetPosForViewDto[] | undefined;
}

export class CreateOrEditPosDto implements ICreateOrEditPosDto {
    deviceType!: DeviceType;
    psp!: PSP;
    serial!: string | undefined;
    acceptorNumber!: string | undefined;
    acceptorPassword!: string | undefined;
    posIdentity!: string | undefined;
    state!: boolean;
    pcToPos!: boolean;
    port!: number | undefined;
    ip!: string | undefined;
    systemIP!: string | undefined;
    bankAccountRef!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditPosDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceType = data["deviceType"];
            this.psp = data["psp"];
            this.serial = data["serial"];
            this.acceptorNumber = data["acceptorNumber"];
            this.acceptorPassword = data["acceptorPassword"];
            this.posIdentity = data["posIdentity"];
            this.state = data["state"];
            this.pcToPos = data["pcToPos"];
            this.port = data["port"];
            this.ip = data["ip"];
            this.systemIP = data["systemIP"];
            this.bankAccountRef = data["bankAccountRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditPosDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPosDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceType"] = this.deviceType;
        data["psp"] = this.psp;
        data["serial"] = this.serial;
        data["acceptorNumber"] = this.acceptorNumber;
        data["acceptorPassword"] = this.acceptorPassword;
        data["posIdentity"] = this.posIdentity;
        data["state"] = this.state;
        data["pcToPos"] = this.pcToPos;
        data["port"] = this.port;
        data["ip"] = this.ip;
        data["systemIP"] = this.systemIP;
        data["bankAccountRef"] = this.bankAccountRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditPosDto {
    deviceType: DeviceType;
    psp: PSP;
    serial: string | undefined;
    acceptorNumber: string | undefined;
    acceptorPassword: string | undefined;
    posIdentity: string | undefined;
    state: boolean;
    pcToPos: boolean;
    port: number | undefined;
    ip: string | undefined;
    systemIP: string | undefined;
    bankAccountRef: number;
    id: number | undefined;
}

export class GetPosForEditOutput implements IGetPosForEditOutput {
    pos!: CreateOrEditPosDto;
    bankAccountAccountNumber!: string | undefined;

    constructor(data?: IGetPosForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pos = data["pos"] ? CreateOrEditPosDto.fromJS(data["pos"]) : <any>undefined;
            this.bankAccountAccountNumber = data["bankAccountAccountNumber"];
        }
    }

    static fromJS(data: any): GetPosForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPosForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pos"] = this.pos ? this.pos.toJSON() : <any>undefined;
        data["bankAccountAccountNumber"] = this.bankAccountAccountNumber;
        return data; 
    }
}

export interface IGetPosForEditOutput {
    pos: CreateOrEditPosDto;
    bankAccountAccountNumber: string | undefined;
}

export class CreateOrEditPosUserDto implements ICreateOrEditPosUserDto {
    entity!: Entities;
    entityRef!: number;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    posRef!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditPosUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entity = data["entity"];
            this.entityRef = data["entityRef"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.posRef = data["posRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditPosUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPosUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entity"] = this.entity;
        data["entityRef"] = this.entityRef;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["posRef"] = this.posRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditPosUserDto {
    entity: Entities;
    entityRef: number;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    posRef: number | undefined;
    id: number | undefined;
}

export class CreateOrEditPosAndUsersDto implements ICreateOrEditPosAndUsersDto {
    pos!: CreateOrEditPosDto;
    posUsers!: CreateOrEditPosUserDto[] | undefined;

    constructor(data?: ICreateOrEditPosAndUsersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pos = data["pos"] ? CreateOrEditPosDto.fromJS(data["pos"]) : <any>undefined;
            if (Array.isArray(data["posUsers"])) {
                this.posUsers = [] as any;
                for (let item of data["posUsers"])
                    this.posUsers!.push(CreateOrEditPosUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrEditPosAndUsersDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPosAndUsersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pos"] = this.pos ? this.pos.toJSON() : <any>undefined;
        if (Array.isArray(this.posUsers)) {
            data["posUsers"] = [];
            for (let item of this.posUsers)
                data["posUsers"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateOrEditPosAndUsersDto {
    pos: CreateOrEditPosDto;
    posUsers: CreateOrEditPosUserDto[] | undefined;
}

export class PosBankAccountLookupTableDto implements IPosBankAccountLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IPosBankAccountLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): PosBankAccountLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PosBankAccountLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IPosBankAccountLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfPosBankAccountLookupTableDto implements IPagedResultDtoOfPosBankAccountLookupTableDto {
    totalCount!: number;
    items!: PosBankAccountLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPosBankAccountLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(PosBankAccountLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPosBankAccountLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPosBankAccountLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfPosBankAccountLookupTableDto {
    totalCount: number;
    items: PosBankAccountLookupTableDto[] | undefined;
}

export class PosUserLookupTableDto implements IPosUserLookupTableDto {
    id!: number;
    entity!: Entities;
    entityRef!: number;
    displayName!: string | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    posRef!: number | undefined;

    constructor(data?: IPosUserLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.entity = data["entity"];
            this.entityRef = data["entityRef"];
            this.displayName = data["displayName"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.posRef = data["posRef"];
        }
    }

    static fromJS(data: any): PosUserLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PosUserLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entity"] = this.entity;
        data["entityRef"] = this.entityRef;
        data["displayName"] = this.displayName;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["posRef"] = this.posRef;
        return data; 
    }
}

export interface IPosUserLookupTableDto {
    id: number;
    entity: Entities;
    entityRef: number;
    displayName: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    posRef: number | undefined;
}

export class PagedResultDtoOfPosUserLookupTableDto implements IPagedResultDtoOfPosUserLookupTableDto {
    totalCount!: number;
    items!: PosUserLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPosUserLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(PosUserLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPosUserLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPosUserLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfPosUserLookupTableDto {
    totalCount: number;
    items: PosUserLookupTableDto[] | undefined;
}

export enum PostmanStatus {
    Default = 0,
    Deliverer = 1,
    Receiver = 2,
}

export class PostmanTaskDto implements IPostmanTaskDto {
    description!: string | undefined;
    type!: BillStatus;
    postmanStatus!: PostmanStatus;
    addressId!: number;
    billId!: number;
    postmanId!: number | undefined;
    id!: number;

    constructor(data?: IPostmanTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.type = data["type"];
            this.postmanStatus = data["postmanStatus"];
            this.addressId = data["addressId"];
            this.billId = data["billId"];
            this.postmanId = data["postmanId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PostmanTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new PostmanTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["type"] = this.type;
        data["postmanStatus"] = this.postmanStatus;
        data["addressId"] = this.addressId;
        data["billId"] = this.billId;
        data["postmanId"] = this.postmanId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPostmanTaskDto {
    description: string | undefined;
    type: BillStatus;
    postmanStatus: PostmanStatus;
    addressId: number;
    billId: number;
    postmanId: number | undefined;
    id: number;
}

export class GetPostmanTaskForViewDto implements IGetPostmanTaskForViewDto {
    postmanTask!: PostmanTaskDto;
    addressTitle!: string | undefined;
    billCode!: string | undefined;
    postmanName!: string | undefined;

    constructor(data?: IGetPostmanTaskForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.postmanTask = data["postmanTask"] ? PostmanTaskDto.fromJS(data["postmanTask"]) : <any>undefined;
            this.addressTitle = data["addressTitle"];
            this.billCode = data["billCode"];
            this.postmanName = data["postmanName"];
        }
    }

    static fromJS(data: any): GetPostmanTaskForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPostmanTaskForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postmanTask"] = this.postmanTask ? this.postmanTask.toJSON() : <any>undefined;
        data["addressTitle"] = this.addressTitle;
        data["billCode"] = this.billCode;
        data["postmanName"] = this.postmanName;
        return data; 
    }
}

export interface IGetPostmanTaskForViewDto {
    postmanTask: PostmanTaskDto;
    addressTitle: string | undefined;
    billCode: string | undefined;
    postmanName: string | undefined;
}

export class PagedResultDtoOfGetPostmanTaskForViewDto implements IPagedResultDtoOfGetPostmanTaskForViewDto {
    totalCount!: number;
    items!: GetPostmanTaskForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetPostmanTaskForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetPostmanTaskForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetPostmanTaskForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetPostmanTaskForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetPostmanTaskForViewDto {
    totalCount: number;
    items: GetPostmanTaskForViewDto[] | undefined;
}

export class CreateOrEditPostmanTaskDto implements ICreateOrEditPostmanTaskDto {
    tenantId!: number | undefined;
    description!: string | undefined;
    type!: BillStatus;
    addressId!: number;
    billId!: number;
    postmanId!: number | undefined;
    price!: string | undefined;
    postmanStatus!: PostmanStatus;
    payments!: CreateOrEditPaymentDto[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditPostmanTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.description = data["description"];
            this.type = data["type"];
            this.addressId = data["addressId"];
            this.billId = data["billId"];
            this.postmanId = data["postmanId"];
            this.price = data["price"];
            this.postmanStatus = data["postmanStatus"];
            if (Array.isArray(data["payments"])) {
                this.payments = [] as any;
                for (let item of data["payments"])
                    this.payments!.push(CreateOrEditPaymentDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditPostmanTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPostmanTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["description"] = this.description;
        data["type"] = this.type;
        data["addressId"] = this.addressId;
        data["billId"] = this.billId;
        data["postmanId"] = this.postmanId;
        data["price"] = this.price;
        data["postmanStatus"] = this.postmanStatus;
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditPostmanTaskDto {
    tenantId: number | undefined;
    description: string | undefined;
    type: BillStatus;
    addressId: number;
    billId: number;
    postmanId: number | undefined;
    price: string | undefined;
    postmanStatus: PostmanStatus;
    payments: CreateOrEditPaymentDto[] | undefined;
    id: number | undefined;
}

export class GetPostmanTaskForEditOutput implements IGetPostmanTaskForEditOutput {
    postmanTask!: CreateOrEditPostmanTaskDto;
    addressTitle!: string | undefined;
    billCode!: string | undefined;
    postmanName!: string | undefined;

    constructor(data?: IGetPostmanTaskForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.postmanTask = data["postmanTask"] ? CreateOrEditPostmanTaskDto.fromJS(data["postmanTask"]) : <any>undefined;
            this.addressTitle = data["addressTitle"];
            this.billCode = data["billCode"];
            this.postmanName = data["postmanName"];
        }
    }

    static fromJS(data: any): GetPostmanTaskForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPostmanTaskForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postmanTask"] = this.postmanTask ? this.postmanTask.toJSON() : <any>undefined;
        data["addressTitle"] = this.addressTitle;
        data["billCode"] = this.billCode;
        data["postmanName"] = this.postmanName;
        return data; 
    }
}

export interface IGetPostmanTaskForEditOutput {
    postmanTask: CreateOrEditPostmanTaskDto;
    addressTitle: string | undefined;
    billCode: string | undefined;
    postmanName: string | undefined;
}

export class PostmanTaskAddressLookupTableDto implements IPostmanTaskAddressLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IPostmanTaskAddressLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): PostmanTaskAddressLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PostmanTaskAddressLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IPostmanTaskAddressLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfPostmanTaskAddressLookupTableDto implements IPagedResultDtoOfPostmanTaskAddressLookupTableDto {
    totalCount!: number;
    items!: PostmanTaskAddressLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPostmanTaskAddressLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(PostmanTaskAddressLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPostmanTaskAddressLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPostmanTaskAddressLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfPostmanTaskAddressLookupTableDto {
    totalCount: number;
    items: PostmanTaskAddressLookupTableDto[] | undefined;
}

export class PostmanTaskBillLookupTableDto implements IPostmanTaskBillLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IPostmanTaskBillLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): PostmanTaskBillLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PostmanTaskBillLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IPostmanTaskBillLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfPostmanTaskBillLookupTableDto implements IPagedResultDtoOfPostmanTaskBillLookupTableDto {
    totalCount!: number;
    items!: PostmanTaskBillLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPostmanTaskBillLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(PostmanTaskBillLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPostmanTaskBillLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPostmanTaskBillLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfPostmanTaskBillLookupTableDto {
    totalCount: number;
    items: PostmanTaskBillLookupTableDto[] | undefined;
}

export class Position implements IPosition {
    longitude!: number;
    latitude!: number;

    constructor(data?: IPosition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.longitude = data["longitude"];
            this.latitude = data["latitude"];
        }
    }

    static fromJS(data: any): Position {
        data = typeof data === 'object' ? data : {};
        let result = new Position();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        return data; 
    }
}

export interface IPosition {
    longitude: number;
    latitude: number;
}

export class PostmanTaskContactLookupTableDto implements IPostmanTaskContactLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    direction!: string | undefined;
    service!: string | undefined;
    assignedTasks!: number;
    tasks!: number;

    constructor(data?: IPostmanTaskContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.direction = data["direction"];
            this.service = data["service"];
            this.assignedTasks = data["assignedTasks"];
            this.tasks = data["tasks"];
        }
    }

    static fromJS(data: any): PostmanTaskContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PostmanTaskContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["direction"] = this.direction;
        data["service"] = this.service;
        data["assignedTasks"] = this.assignedTasks;
        data["tasks"] = this.tasks;
        return data; 
    }
}

export interface IPostmanTaskContactLookupTableDto {
    id: number;
    displayName: string | undefined;
    direction: string | undefined;
    service: string | undefined;
    assignedTasks: number;
    tasks: number;
}

export class PagedResultDtoOfPostmanTaskContactLookupTableDto implements IPagedResultDtoOfPostmanTaskContactLookupTableDto {
    totalCount!: number;
    items!: PostmanTaskContactLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPostmanTaskContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(PostmanTaskContactLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPostmanTaskContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPostmanTaskContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfPostmanTaskContactLookupTableDto {
    totalCount: number;
    items: PostmanTaskContactLookupTableDto[] | undefined;
}

export class GetPostmanTasksDto implements IGetPostmanTasksDto {
    description!: string | undefined;
    type!: BillStatus;
    addressId!: number;
    billId!: number;
    planBillId!: number | undefined;
    postmanId!: number | undefined;
    postmanContactId!: number | undefined;
    addressTitle!: string | undefined;
    direction!: string | undefined;
    billCode!: string | undefined;
    postmanName!: string | undefined;
    planConstTitle!: string | undefined;
    issueDate!: moment.Moment;
    contactName!: string | undefined;
    contactId!: number;
    billPrice!: string | undefined;
    latitude!: number | undefined;
    longitude!: number | undefined;
    postmanStatus!: PostmanStatus;
    currencyName!: string | undefined;

    constructor(data?: IGetPostmanTasksDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.type = data["type"];
            this.addressId = data["addressId"];
            this.billId = data["billId"];
            this.planBillId = data["planBillId"];
            this.postmanId = data["postmanId"];
            this.postmanContactId = data["postmanContactId"];
            this.addressTitle = data["addressTitle"];
            this.direction = data["direction"];
            this.billCode = data["billCode"];
            this.postmanName = data["postmanName"];
            this.planConstTitle = data["planConstTitle"];
            this.issueDate = data["issueDate"] ? moment(data["issueDate"].toString()) : <any>undefined;
            this.contactName = data["contactName"];
            this.contactId = data["contactId"];
            this.billPrice = data["billPrice"];
            this.latitude = data["latitude"];
            this.longitude = data["longitude"];
            this.postmanStatus = data["postmanStatus"];
            this.currencyName = data["currencyName"];
        }
    }

    static fromJS(data: any): GetPostmanTasksDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPostmanTasksDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["type"] = this.type;
        data["addressId"] = this.addressId;
        data["billId"] = this.billId;
        data["planBillId"] = this.planBillId;
        data["postmanId"] = this.postmanId;
        data["postmanContactId"] = this.postmanContactId;
        data["addressTitle"] = this.addressTitle;
        data["direction"] = this.direction;
        data["billCode"] = this.billCode;
        data["postmanName"] = this.postmanName;
        data["planConstTitle"] = this.planConstTitle;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["contactName"] = this.contactName;
        data["contactId"] = this.contactId;
        data["billPrice"] = this.billPrice;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["postmanStatus"] = this.postmanStatus;
        data["currencyName"] = this.currencyName;
        return data; 
    }
}

export interface IGetPostmanTasksDto {
    description: string | undefined;
    type: BillStatus;
    addressId: number;
    billId: number;
    planBillId: number | undefined;
    postmanId: number | undefined;
    postmanContactId: number | undefined;
    addressTitle: string | undefined;
    direction: string | undefined;
    billCode: string | undefined;
    postmanName: string | undefined;
    planConstTitle: string | undefined;
    issueDate: moment.Moment;
    contactName: string | undefined;
    contactId: number;
    billPrice: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    postmanStatus: PostmanStatus;
    currencyName: string | undefined;
}

export class PagedResultDtoOfGetPostmanTasksDto implements IPagedResultDtoOfGetPostmanTasksDto {
    totalCount!: number;
    items!: GetPostmanTasksDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetPostmanTasksDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetPostmanTasksDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetPostmanTasksDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetPostmanTasksDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetPostmanTasksDto {
    totalCount: number;
    items: GetPostmanTasksDto[] | undefined;
}

export class EditBillPriceDto implements IEditBillPriceDto {
    id!: number;
    price!: number;

    constructor(data?: IEditBillPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.price = data["price"];
        }
    }

    static fromJS(data: any): EditBillPriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditBillPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["price"] = this.price;
        return data; 
    }
}

export interface IEditBillPriceDto {
    id: number;
    price: number;
}

export class PosUserDto implements IPosUserDto {
    entity!: Entities;
    entityRef!: number;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    posRef!: number | undefined;
    id!: number;

    constructor(data?: IPosUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entity = data["entity"];
            this.entityRef = data["entityRef"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.posRef = data["posRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PosUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PosUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entity"] = this.entity;
        data["entityRef"] = this.entityRef;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["posRef"] = this.posRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPosUserDto {
    entity: Entities;
    entityRef: number;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    posRef: number | undefined;
    id: number;
}

export class GetPosUserForViewDto implements IGetPosUserForViewDto {
    posUser!: PosUserDto;

    constructor(data?: IGetPosUserForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.posUser = data["posUser"] ? PosUserDto.fromJS(data["posUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPosUserForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPosUserForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["posUser"] = this.posUser ? this.posUser.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetPosUserForViewDto {
    posUser: PosUserDto;
}

export class PagedResultDtoOfGetPosUserForViewDto implements IPagedResultDtoOfGetPosUserForViewDto {
    totalCount!: number;
    items!: GetPosUserForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetPosUserForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetPosUserForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetPosUserForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetPosUserForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetPosUserForViewDto {
    totalCount: number;
    items: GetPosUserForViewDto[] | undefined;
}

export class GetPosUserForEditOutput implements IGetPosUserForEditOutput {
    posUser!: CreateOrEditPosUserDto;

    constructor(data?: IGetPosUserForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.posUser = data["posUser"] ? CreateOrEditPosUserDto.fromJS(data["posUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPosUserForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPosUserForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["posUser"] = this.posUser ? this.posUser.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetPosUserForEditOutput {
    posUser: CreateOrEditPosUserDto;
}

export class PosUserContactLookupTableDto implements IPosUserContactLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IPosUserContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): PosUserContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PosUserContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IPosUserContactLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfPosUserContactLookupTableDto implements IPagedResultDtoOfPosUserContactLookupTableDto {
    totalCount!: number;
    items!: PosUserContactLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPosUserContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(PosUserContactLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPosUserContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPosUserContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfPosUserContactLookupTableDto {
    totalCount: number;
    items: PosUserContactLookupTableDto[] | undefined;
}

export class CurrentUserProfileEditDto implements ICurrentUserProfileEditDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    phoneNumber!: string | undefined;
    isPhoneNumberConfirmed!: boolean;
    timezone!: string | undefined;
    qrCodeSetupImageUrl!: string | undefined;
    isGoogleAuthenticatorEnabled!: boolean;

    constructor(data?: ICurrentUserProfileEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.phoneNumber = data["phoneNumber"];
            this.isPhoneNumberConfirmed = data["isPhoneNumberConfirmed"];
            this.timezone = data["timezone"];
            this.qrCodeSetupImageUrl = data["qrCodeSetupImageUrl"];
            this.isGoogleAuthenticatorEnabled = data["isGoogleAuthenticatorEnabled"];
        }
    }

    static fromJS(data: any): CurrentUserProfileEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentUserProfileEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["timezone"] = this.timezone;
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data; 
    }
}

export interface ICurrentUserProfileEditDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    timezone: string | undefined;
    qrCodeSetupImageUrl: string | undefined;
    isGoogleAuthenticatorEnabled: boolean;
}

export class UpdateGoogleAuthenticatorKeyOutput implements IUpdateGoogleAuthenticatorKeyOutput {
    qrCodeSetupImageUrl!: string | undefined;

    constructor(data?: IUpdateGoogleAuthenticatorKeyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.qrCodeSetupImageUrl = data["qrCodeSetupImageUrl"];
        }
    }

    static fromJS(data: any): UpdateGoogleAuthenticatorKeyOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGoogleAuthenticatorKeyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        return data; 
    }
}

export interface IUpdateGoogleAuthenticatorKeyOutput {
    qrCodeSetupImageUrl: string | undefined;
}

export class SendVerificationSmsInputDto implements ISendVerificationSmsInputDto {
    phoneNumber!: string | undefined;

    constructor(data?: ISendVerificationSmsInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.phoneNumber = data["phoneNumber"];
        }
    }

    static fromJS(data: any): SendVerificationSmsInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendVerificationSmsInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        return data; 
    }
}

export interface ISendVerificationSmsInputDto {
    phoneNumber: string | undefined;
}

export class VerifySmsCodeInputDto implements IVerifySmsCodeInputDto {
    code!: string | undefined;
    phoneNumber!: string | undefined;

    constructor(data?: IVerifySmsCodeInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.phoneNumber = data["phoneNumber"];
        }
    }

    static fromJS(data: any): VerifySmsCodeInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerifySmsCodeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["phoneNumber"] = this.phoneNumber;
        return data; 
    }
}

export interface IVerifySmsCodeInputDto {
    code: string | undefined;
    phoneNumber: string | undefined;
}

export class ChangePasswordInput implements IChangePasswordInput {
    currentPassword!: string | undefined;
    newPassword!: string | undefined;

    constructor(data?: IChangePasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPassword = data["currentPassword"];
            this.newPassword = data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data; 
    }
}

export interface IChangePasswordInput {
    currentPassword: string | undefined;
    newPassword: string | undefined;
}

export class UpdateProfilePictureInput implements IUpdateProfilePictureInput {
    fileToken!: string | undefined;
    x!: number;
    y!: number;
    width!: number;
    height!: number;

    constructor(data?: IUpdateProfilePictureInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileToken = data["fileToken"];
            this.x = data["x"];
            this.y = data["y"];
            this.width = data["width"];
            this.height = data["height"];
        }
    }

    static fromJS(data: any): UpdateProfilePictureInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfilePictureInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileToken"] = this.fileToken;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data; 
    }
}

export interface IUpdateProfilePictureInput {
    fileToken: string | undefined;
    x: number;
    y: number;
    width: number;
    height: number;
}

export class GetPasswordComplexitySettingOutput implements IGetPasswordComplexitySettingOutput {
    setting!: PasswordComplexitySetting;

    constructor(data?: IGetPasswordComplexitySettingOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.setting = data["setting"] ? PasswordComplexitySetting.fromJS(data["setting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPasswordComplexitySettingOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPasswordComplexitySettingOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["setting"] = this.setting ? this.setting.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetPasswordComplexitySettingOutput {
    setting: PasswordComplexitySetting;
}

export class GetProfilePictureOutput implements IGetProfilePictureOutput {
    profilePicture!: string | undefined;

    constructor(data?: IGetProfilePictureOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.profilePicture = data["profilePicture"];
        }
    }

    static fromJS(data: any): GetProfilePictureOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfilePictureOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePicture"] = this.profilePicture;
        return data; 
    }
}

export interface IGetProfilePictureOutput {
    profilePicture: string | undefined;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName!: string | undefined;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.languageName = data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data; 
    }
}

export interface IChangeUserLanguageDto {
    languageName: string | undefined;
}

export class RegulatVoucherDto implements IRegulatVoucherDto {
    regulatedDateTime!: moment.Moment;
    code!: string | undefined;
    secondedDateTime!: moment.Moment | undefined;
    approvedDateTime!: moment.Moment | undefined;
    regulatorRef!: number | undefined;
    seconderRef!: number | undefined;
    approverRef!: number | undefined;
    id!: number;

    constructor(data?: IRegulatVoucherDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.regulatedDateTime = data["regulatedDateTime"] ? moment(data["regulatedDateTime"].toString()) : <any>undefined;
            this.code = data["code"];
            this.secondedDateTime = data["secondedDateTime"] ? moment(data["secondedDateTime"].toString()) : <any>undefined;
            this.approvedDateTime = data["approvedDateTime"] ? moment(data["approvedDateTime"].toString()) : <any>undefined;
            this.regulatorRef = data["regulatorRef"];
            this.seconderRef = data["seconderRef"];
            this.approverRef = data["approverRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RegulatVoucherDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegulatVoucherDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regulatedDateTime"] = this.regulatedDateTime ? this.regulatedDateTime.toISOString() : <any>undefined;
        data["code"] = this.code;
        data["secondedDateTime"] = this.secondedDateTime ? this.secondedDateTime.toISOString() : <any>undefined;
        data["approvedDateTime"] = this.approvedDateTime ? this.approvedDateTime.toISOString() : <any>undefined;
        data["regulatorRef"] = this.regulatorRef;
        data["seconderRef"] = this.seconderRef;
        data["approverRef"] = this.approverRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRegulatVoucherDto {
    regulatedDateTime: moment.Moment;
    code: string | undefined;
    secondedDateTime: moment.Moment | undefined;
    approvedDateTime: moment.Moment | undefined;
    regulatorRef: number | undefined;
    seconderRef: number | undefined;
    approverRef: number | undefined;
    id: number;
}

export class GetRegulatVoucherForViewDto implements IGetRegulatVoucherForViewDto {
    regulatVoucher!: RegulatVoucherDto;
    userName!: string | undefined;
    userName2!: string | undefined;
    userName3!: string | undefined;

    constructor(data?: IGetRegulatVoucherForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.regulatVoucher = data["regulatVoucher"] ? RegulatVoucherDto.fromJS(data["regulatVoucher"]) : <any>undefined;
            this.userName = data["userName"];
            this.userName2 = data["userName2"];
            this.userName3 = data["userName3"];
        }
    }

    static fromJS(data: any): GetRegulatVoucherForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegulatVoucherForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regulatVoucher"] = this.regulatVoucher ? this.regulatVoucher.toJSON() : <any>undefined;
        data["userName"] = this.userName;
        data["userName2"] = this.userName2;
        data["userName3"] = this.userName3;
        return data; 
    }
}

export interface IGetRegulatVoucherForViewDto {
    regulatVoucher: RegulatVoucherDto;
    userName: string | undefined;
    userName2: string | undefined;
    userName3: string | undefined;
}

export class PagedResultDtoOfGetRegulatVoucherForViewDto implements IPagedResultDtoOfGetRegulatVoucherForViewDto {
    totalCount!: number;
    items!: GetRegulatVoucherForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetRegulatVoucherForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetRegulatVoucherForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetRegulatVoucherForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetRegulatVoucherForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetRegulatVoucherForViewDto {
    totalCount: number;
    items: GetRegulatVoucherForViewDto[] | undefined;
}

export class CreateOrEditRegulatVoucherDto implements ICreateOrEditRegulatVoucherDto {
    regulatedDateTime!: moment.Moment;
    code!: string | undefined;
    secondedDateTime!: moment.Moment | undefined;
    approvedDateTime!: moment.Moment | undefined;
    regulatorRef!: number | undefined;
    seconderRef!: number | undefined;
    approverRef!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditRegulatVoucherDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.regulatedDateTime = data["regulatedDateTime"] ? moment(data["regulatedDateTime"].toString()) : <any>undefined;
            this.code = data["code"];
            this.secondedDateTime = data["secondedDateTime"] ? moment(data["secondedDateTime"].toString()) : <any>undefined;
            this.approvedDateTime = data["approvedDateTime"] ? moment(data["approvedDateTime"].toString()) : <any>undefined;
            this.regulatorRef = data["regulatorRef"];
            this.seconderRef = data["seconderRef"];
            this.approverRef = data["approverRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditRegulatVoucherDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditRegulatVoucherDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regulatedDateTime"] = this.regulatedDateTime ? this.regulatedDateTime.toISOString() : <any>undefined;
        data["code"] = this.code;
        data["secondedDateTime"] = this.secondedDateTime ? this.secondedDateTime.toISOString() : <any>undefined;
        data["approvedDateTime"] = this.approvedDateTime ? this.approvedDateTime.toISOString() : <any>undefined;
        data["regulatorRef"] = this.regulatorRef;
        data["seconderRef"] = this.seconderRef;
        data["approverRef"] = this.approverRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditRegulatVoucherDto {
    regulatedDateTime: moment.Moment;
    code: string | undefined;
    secondedDateTime: moment.Moment | undefined;
    approvedDateTime: moment.Moment | undefined;
    regulatorRef: number | undefined;
    seconderRef: number | undefined;
    approverRef: number | undefined;
    id: number | undefined;
}

export class GetRegulatVoucherForEditOutput implements IGetRegulatVoucherForEditOutput {
    regulatVoucher!: CreateOrEditRegulatVoucherDto;
    userName!: string | undefined;
    userName2!: string | undefined;
    userName3!: string | undefined;

    constructor(data?: IGetRegulatVoucherForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.regulatVoucher = data["regulatVoucher"] ? CreateOrEditRegulatVoucherDto.fromJS(data["regulatVoucher"]) : <any>undefined;
            this.userName = data["userName"];
            this.userName2 = data["userName2"];
            this.userName3 = data["userName3"];
        }
    }

    static fromJS(data: any): GetRegulatVoucherForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegulatVoucherForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regulatVoucher"] = this.regulatVoucher ? this.regulatVoucher.toJSON() : <any>undefined;
        data["userName"] = this.userName;
        data["userName2"] = this.userName2;
        data["userName3"] = this.userName3;
        return data; 
    }
}

export interface IGetRegulatVoucherForEditOutput {
    regulatVoucher: CreateOrEditRegulatVoucherDto;
    userName: string | undefined;
    userName2: string | undefined;
    userName3: string | undefined;
}

export class RegulatVoucherUserLookupTableDto implements IRegulatVoucherUserLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IRegulatVoucherUserLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): RegulatVoucherUserLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegulatVoucherUserLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IRegulatVoucherUserLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfRegulatVoucherUserLookupTableDto implements IPagedResultDtoOfRegulatVoucherUserLookupTableDto {
    totalCount!: number;
    items!: RegulatVoucherUserLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfRegulatVoucherUserLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(RegulatVoucherUserLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfRegulatVoucherUserLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRegulatVoucherUserLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfRegulatVoucherUserLookupTableDto {
    totalCount: number;
    items: RegulatVoucherUserLookupTableDto[] | undefined;
}

export class RespectPrefixDto implements IRespectPrefixDto {
    title!: string | undefined;
    gender!: Gender;
    state!: boolean;
    id!: number;

    constructor(data?: IRespectPrefixDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.gender = data["gender"];
            this.state = data["state"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RespectPrefixDto {
        data = typeof data === 'object' ? data : {};
        let result = new RespectPrefixDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["gender"] = this.gender;
        data["state"] = this.state;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRespectPrefixDto {
    title: string | undefined;
    gender: Gender;
    state: boolean;
    id: number;
}

export class GetRespectPrefixForViewDto implements IGetRespectPrefixForViewDto {
    respectPrefix!: RespectPrefixDto;

    constructor(data?: IGetRespectPrefixForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.respectPrefix = data["respectPrefix"] ? RespectPrefixDto.fromJS(data["respectPrefix"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRespectPrefixForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetRespectPrefixForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["respectPrefix"] = this.respectPrefix ? this.respectPrefix.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetRespectPrefixForViewDto {
    respectPrefix: RespectPrefixDto;
}

export class PagedResultDtoOfGetRespectPrefixForViewDto implements IPagedResultDtoOfGetRespectPrefixForViewDto {
    totalCount!: number;
    items!: GetRespectPrefixForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetRespectPrefixForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetRespectPrefixForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetRespectPrefixForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetRespectPrefixForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetRespectPrefixForViewDto {
    totalCount: number;
    items: GetRespectPrefixForViewDto[] | undefined;
}

export class CreateOrEditRespectPrefixDto implements ICreateOrEditRespectPrefixDto {
    title!: string | undefined;
    gender!: Gender;
    state!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditRespectPrefixDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.gender = data["gender"];
            this.state = data["state"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditRespectPrefixDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditRespectPrefixDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["gender"] = this.gender;
        data["state"] = this.state;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditRespectPrefixDto {
    title: string | undefined;
    gender: Gender;
    state: boolean;
    id: number | undefined;
}

export class GetRespectPrefixForEditOutput implements IGetRespectPrefixForEditOutput {
    respectPrefix!: CreateOrEditRespectPrefixDto;

    constructor(data?: IGetRespectPrefixForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.respectPrefix = data["respectPrefix"] ? CreateOrEditRespectPrefixDto.fromJS(data["respectPrefix"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRespectPrefixForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRespectPrefixForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["respectPrefix"] = this.respectPrefix ? this.respectPrefix.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetRespectPrefixForEditOutput {
    respectPrefix: CreateOrEditRespectPrefixDto;
}

export class RoleEditDto implements IRoleEditDto {
    id!: number | undefined;
    displayName!: string | undefined;
    isDefault!: boolean;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.isDefault = data["isDefault"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["isDefault"] = this.isDefault;
        return data; 
    }
}

export interface IRoleEditDto {
    id: number | undefined;
    displayName: string | undefined;
    isDefault: boolean;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    isGrantedByDefault!: boolean;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.isGrantedByDefault = data["isGrantedByDefault"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data; 
    }
}

export interface IFlatPermissionDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role!: RoleEditDto;
    permissions!: FlatPermissionDto[] | undefined;
    grantedPermissionNames!: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.role = data["role"] ? RoleEditDto.fromJS(data["role"]) : <any>undefined;
            if (Array.isArray(data["permissions"])) {
                this.permissions = [] as any;
                for (let item of data["permissions"])
                    this.permissions!.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data; 
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class CreateOrUpdateRoleInput implements ICreateOrUpdateRoleInput {
    role!: RoleEditDto;
    grantedPermissionNames!: string[] | undefined;

    constructor(data?: ICreateOrUpdateRoleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.role = new RoleEditDto();
        }
    }

    init(data?: any) {
        if (data) {
            this.role = data["role"] ? RoleEditDto.fromJS(data["role"]) : new RoleEditDto();
            if (Array.isArray(data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateRoleInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateRoleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data; 
    }
}

export interface ICreateOrUpdateRoleInput {
    role: RoleEditDto;
    grantedPermissionNames: string[] | undefined;
}

export class RouteFeeDto implements IRouteFeeDto {
    values!: string | undefined;
    serviceType!: string | undefined;
    directionId!: number;
    wageId!: number;
    id!: number;

    constructor(data?: IRouteFeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.values = data["values"];
            this.serviceType = data["serviceType"];
            this.directionId = data["directionId"];
            this.wageId = data["wageId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RouteFeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new RouteFeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["values"] = this.values;
        data["serviceType"] = this.serviceType;
        data["directionId"] = this.directionId;
        data["wageId"] = this.wageId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRouteFeeDto {
    values: string | undefined;
    serviceType: string | undefined;
    directionId: number;
    wageId: number;
    id: number;
}

export class GetRouteFeeForViewDto implements IGetRouteFeeForViewDto {
    routeFee!: RouteFeeDto;
    directionName!: string | undefined;
    wageTitle!: string | undefined;

    constructor(data?: IGetRouteFeeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.routeFee = data["routeFee"] ? RouteFeeDto.fromJS(data["routeFee"]) : <any>undefined;
            this.directionName = data["directionName"];
            this.wageTitle = data["wageTitle"];
        }
    }

    static fromJS(data: any): GetRouteFeeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetRouteFeeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["routeFee"] = this.routeFee ? this.routeFee.toJSON() : <any>undefined;
        data["directionName"] = this.directionName;
        data["wageTitle"] = this.wageTitle;
        return data; 
    }
}

export interface IGetRouteFeeForViewDto {
    routeFee: RouteFeeDto;
    directionName: string | undefined;
    wageTitle: string | undefined;
}

export class PagedResultDtoOfGetRouteFeeForViewDto implements IPagedResultDtoOfGetRouteFeeForViewDto {
    totalCount!: number;
    items!: GetRouteFeeForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetRouteFeeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetRouteFeeForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetRouteFeeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetRouteFeeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetRouteFeeForViewDto {
    totalCount: number;
    items: GetRouteFeeForViewDto[] | undefined;
}

export class CreateOrEditRouteFeeDto implements ICreateOrEditRouteFeeDto {
    values!: string | undefined;
    serviceType!: string | undefined;
    directionId!: number;
    wageId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditRouteFeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.values = data["values"];
            this.serviceType = data["serviceType"];
            this.directionId = data["directionId"];
            this.wageId = data["wageId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditRouteFeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditRouteFeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["values"] = this.values;
        data["serviceType"] = this.serviceType;
        data["directionId"] = this.directionId;
        data["wageId"] = this.wageId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditRouteFeeDto {
    values: string | undefined;
    serviceType: string | undefined;
    directionId: number;
    wageId: number;
    id: number | undefined;
}

export class GetRouteFeeForEditOutput implements IGetRouteFeeForEditOutput {
    routeFee!: CreateOrEditRouteFeeDto;
    directionName!: string | undefined;
    wageTitle!: string | undefined;

    constructor(data?: IGetRouteFeeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.routeFee = data["routeFee"] ? CreateOrEditRouteFeeDto.fromJS(data["routeFee"]) : <any>undefined;
            this.directionName = data["directionName"];
            this.wageTitle = data["wageTitle"];
        }
    }

    static fromJS(data: any): GetRouteFeeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRouteFeeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["routeFee"] = this.routeFee ? this.routeFee.toJSON() : <any>undefined;
        data["directionName"] = this.directionName;
        data["wageTitle"] = this.wageTitle;
        return data; 
    }
}

export interface IGetRouteFeeForEditOutput {
    routeFee: CreateOrEditRouteFeeDto;
    directionName: string | undefined;
    wageTitle: string | undefined;
}

export class RouteFeeDirectionLookupTableDto implements IRouteFeeDirectionLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IRouteFeeDirectionLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): RouteFeeDirectionLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new RouteFeeDirectionLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IRouteFeeDirectionLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class RouteFeeWageLookupTableDto implements IRouteFeeWageLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IRouteFeeWageLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): RouteFeeWageLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new RouteFeeWageLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IRouteFeeWageLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class GetSacrificeForViewDto implements IGetSacrificeForViewDto {
    sacrifice!: SacrificeDto;
    planConstTitle!: string | undefined;
    sacrificeTypeTitle!: string | undefined;

    constructor(data?: IGetSacrificeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sacrifice = data["sacrifice"] ? SacrificeDto.fromJS(data["sacrifice"]) : <any>undefined;
            this.planConstTitle = data["planConstTitle"];
            this.sacrificeTypeTitle = data["sacrificeTypeTitle"];
        }
    }

    static fromJS(data: any): GetSacrificeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSacrificeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sacrifice"] = this.sacrifice ? this.sacrifice.toJSON() : <any>undefined;
        data["planConstTitle"] = this.planConstTitle;
        data["sacrificeTypeTitle"] = this.sacrificeTypeTitle;
        return data; 
    }
}

export interface IGetSacrificeForViewDto {
    sacrifice: SacrificeDto;
    planConstTitle: string | undefined;
    sacrificeTypeTitle: string | undefined;
}

export class PagedResultDtoOfGetSacrificeForViewDto implements IPagedResultDtoOfGetSacrificeForViewDto {
    totalCount!: number;
    items!: GetSacrificeForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSacrificeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetSacrificeForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSacrificeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSacrificeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetSacrificeForViewDto {
    totalCount: number;
    items: GetSacrificeForViewDto[] | undefined;
}

export class SacrificePlanConstLookupTableDto implements ISacrificePlanConstLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISacrificePlanConstLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): SacrificePlanConstLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SacrificePlanConstLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ISacrificePlanConstLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfSacrificePlanConstLookupTableDto implements IPagedResultDtoOfSacrificePlanConstLookupTableDto {
    totalCount!: number;
    items!: SacrificePlanConstLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSacrificePlanConstLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(SacrificePlanConstLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSacrificePlanConstLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSacrificePlanConstLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfSacrificePlanConstLookupTableDto {
    totalCount: number;
    items: SacrificePlanConstLookupTableDto[] | undefined;
}

export class SacrificeSacrificeTypeLookupTableDto implements ISacrificeSacrificeTypeLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISacrificeSacrificeTypeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): SacrificeSacrificeTypeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SacrificeSacrificeTypeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ISacrificeSacrificeTypeLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfSacrificeSacrificeTypeLookupTableDto implements IPagedResultDtoOfSacrificeSacrificeTypeLookupTableDto {
    totalCount!: number;
    items!: SacrificeSacrificeTypeLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSacrificeSacrificeTypeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(SacrificeSacrificeTypeLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSacrificeSacrificeTypeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSacrificeSacrificeTypeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfSacrificeSacrificeTypeLookupTableDto {
    totalCount: number;
    items: SacrificeSacrificeTypeLookupTableDto[] | undefined;
}

export class SacrificeBaseTimeLookupTableDto implements ISacrificeBaseTimeLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISacrificeBaseTimeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): SacrificeBaseTimeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SacrificeBaseTimeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ISacrificeBaseTimeLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SacrificeTypeDto implements ISacrificeTypeDto {
    title!: string | undefined;
    dailyNumberPerPerson!: number | undefined;
    maximumDailyNumber!: number | undefined;
    livestock!: Livestocks;
    isDescriptionRequired!: boolean;
    id!: number;

    constructor(data?: ISacrificeTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.dailyNumberPerPerson = data["dailyNumberPerPerson"];
            this.maximumDailyNumber = data["maximumDailyNumber"];
            this.livestock = data["livestock"];
            this.isDescriptionRequired = data["isDescriptionRequired"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SacrificeTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SacrificeTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["dailyNumberPerPerson"] = this.dailyNumberPerPerson;
        data["maximumDailyNumber"] = this.maximumDailyNumber;
        data["livestock"] = this.livestock;
        data["isDescriptionRequired"] = this.isDescriptionRequired;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISacrificeTypeDto {
    title: string | undefined;
    dailyNumberPerPerson: number | undefined;
    maximumDailyNumber: number | undefined;
    livestock: Livestocks;
    isDescriptionRequired: boolean;
    id: number;
}

export class GetSacrificeTypeForViewDto implements IGetSacrificeTypeForViewDto {
    sacrificeType!: SacrificeTypeDto;

    constructor(data?: IGetSacrificeTypeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sacrificeType = data["sacrificeType"] ? SacrificeTypeDto.fromJS(data["sacrificeType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSacrificeTypeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSacrificeTypeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sacrificeType"] = this.sacrificeType ? this.sacrificeType.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetSacrificeTypeForViewDto {
    sacrificeType: SacrificeTypeDto;
}

export class PagedResultDtoOfGetSacrificeTypeForViewDto implements IPagedResultDtoOfGetSacrificeTypeForViewDto {
    totalCount!: number;
    items!: GetSacrificeTypeForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSacrificeTypeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetSacrificeTypeForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSacrificeTypeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSacrificeTypeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetSacrificeTypeForViewDto {
    totalCount: number;
    items: GetSacrificeTypeForViewDto[] | undefined;
}

export class CreateOrEditSacrificeTypeDto implements ICreateOrEditSacrificeTypeDto {
    title!: string | undefined;
    dailyNumberPerPerson!: number | undefined;
    maximumDailyNumber!: number | undefined;
    livestock!: Livestocks;
    isDescriptionRequired!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSacrificeTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.dailyNumberPerPerson = data["dailyNumberPerPerson"];
            this.maximumDailyNumber = data["maximumDailyNumber"];
            this.livestock = data["livestock"];
            this.isDescriptionRequired = data["isDescriptionRequired"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSacrificeTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSacrificeTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["dailyNumberPerPerson"] = this.dailyNumberPerPerson;
        data["maximumDailyNumber"] = this.maximumDailyNumber;
        data["livestock"] = this.livestock;
        data["isDescriptionRequired"] = this.isDescriptionRequired;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditSacrificeTypeDto {
    title: string | undefined;
    dailyNumberPerPerson: number | undefined;
    maximumDailyNumber: number | undefined;
    livestock: Livestocks;
    isDescriptionRequired: boolean;
    id: number | undefined;
}

export class GetSacrificeTypeForEditOutput implements IGetSacrificeTypeForEditOutput {
    sacrificeType!: CreateOrEditSacrificeTypeDto;

    constructor(data?: IGetSacrificeTypeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sacrificeType = data["sacrificeType"] ? CreateOrEditSacrificeTypeDto.fromJS(data["sacrificeType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSacrificeTypeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSacrificeTypeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sacrificeType"] = this.sacrificeType ? this.sacrificeType.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetSacrificeTypeForEditOutput {
    sacrificeType: CreateOrEditSacrificeTypeDto;
}

export enum SMSProviderType {
    UnknownValue = 0,
    KavehNegar = 1,
}

export class RegisterConfigRequest implements IRegisterConfigRequest {
    apiKey!: string | undefined;
    provider!: SMSProviderType;
    senderMobileNumber!: string | undefined;

    constructor(data?: IRegisterConfigRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.apiKey = data["apiKey"];
            this.provider = data["provider"];
            this.senderMobileNumber = data["senderMobileNumber"];
        }
    }

    static fromJS(data: any): RegisterConfigRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterConfigRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiKey"] = this.apiKey;
        data["provider"] = this.provider;
        data["senderMobileNumber"] = this.senderMobileNumber;
        return data; 
    }
}

export interface IRegisterConfigRequest {
    apiKey: string | undefined;
    provider: SMSProviderType;
    senderMobileNumber: string | undefined;
}

export class RegisterConfigResponse implements IRegisterConfigResponse {
    result!: number;
    resultDesc!: string | undefined;

    constructor(data?: IRegisterConfigResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.result = data["result"];
            this.resultDesc = data["resultDesc"];
        }
    }

    static fromJS(data: any): RegisterConfigResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterConfigResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["resultDesc"] = this.resultDesc;
        return data; 
    }
}

export interface IRegisterConfigResponse {
    result: number;
    resultDesc: string | undefined;
}

export class RegisterEmailRequest implements IRegisterEmailRequest {
    username!: string | undefined;
    password!: string | undefined;
    host!: string | undefined;
    port!: number;
    emailFrom!: string | undefined;

    constructor(data?: IRegisterEmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.username = data["username"];
            this.password = data["password"];
            this.host = data["host"];
            this.port = data["port"];
            this.emailFrom = data["emailFrom"];
        }
    }

    static fromJS(data: any): RegisterEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        data["host"] = this.host;
        data["port"] = this.port;
        data["emailFrom"] = this.emailFrom;
        return data; 
    }
}

export interface IRegisterEmailRequest {
    username: string | undefined;
    password: string | undefined;
    host: string | undefined;
    port: number;
    emailFrom: string | undefined;
}

export class RegisterEmailResponse implements IRegisterEmailResponse {
    result!: number;
    resultDesc!: string | undefined;

    constructor(data?: IRegisterEmailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.result = data["result"];
            this.resultDesc = data["resultDesc"];
        }
    }

    static fromJS(data: any): RegisterEmailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterEmailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["resultDesc"] = this.resultDesc;
        return data; 
    }
}

export interface IRegisterEmailResponse {
    result: number;
    resultDesc: string | undefined;
}

export class Timestamp implements ITimestamp {
    seconds!: number;
    nanos!: number;

    constructor(data?: ITimestamp) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.seconds = data["seconds"];
            this.nanos = data["nanos"];
        }
    }

    static fromJS(data: any): Timestamp {
        data = typeof data === 'object' ? data : {};
        let result = new Timestamp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seconds"] = this.seconds;
        data["nanos"] = this.nanos;
        return data; 
    }
}

export interface ITimestamp {
    seconds: number;
    nanos: number;
}

export class SendSimpleRequest implements ISendSimpleRequest {
    sendTime!: Timestamp;
    mobileNumber!: string | undefined;
    text!: string | undefined;
    senderMobileNumber!: string | undefined;
    readonly hasSenderMobileNumber!: boolean;

    constructor(data?: ISendSimpleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sendTime = data["sendTime"] ? Timestamp.fromJS(data["sendTime"]) : <any>undefined;
            this.mobileNumber = data["mobileNumber"];
            this.text = data["text"];
            this.senderMobileNumber = data["senderMobileNumber"];
            (<any>this).hasSenderMobileNumber = data["hasSenderMobileNumber"];
        }
    }

    static fromJS(data: any): SendSimpleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendSimpleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sendTime"] = this.sendTime ? this.sendTime.toJSON() : <any>undefined;
        data["mobileNumber"] = this.mobileNumber;
        data["text"] = this.text;
        data["senderMobileNumber"] = this.senderMobileNumber;
        data["hasSenderMobileNumber"] = this.hasSenderMobileNumber;
        return data; 
    }
}

export interface ISendSimpleRequest {
    sendTime: Timestamp;
    mobileNumber: string | undefined;
    text: string | undefined;
    senderMobileNumber: string | undefined;
    hasSenderMobileNumber: boolean;
}

export class SendSimpleResponse implements ISendSimpleResponse {
    result!: number;
    resultDesc!: string | undefined;
    jobId!: string | undefined;
    readonly hasJobId!: boolean;

    constructor(data?: ISendSimpleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.result = data["result"];
            this.resultDesc = data["resultDesc"];
            this.jobId = data["jobId"];
            (<any>this).hasJobId = data["hasJobId"];
        }
    }

    static fromJS(data: any): SendSimpleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendSimpleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["resultDesc"] = this.resultDesc;
        data["jobId"] = this.jobId;
        data["hasJobId"] = this.hasJobId;
        return data; 
    }
}

export interface ISendSimpleResponse {
    result: number;
    resultDesc: string | undefined;
    jobId: string | undefined;
    hasJobId: boolean;
}

export class Token implements IToken {
    key!: string | undefined;
    value!: string | undefined;

    constructor(data?: IToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.key = data["key"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): Token {
        data = typeof data === 'object' ? data : {};
        let result = new Token();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data; 
    }
}

export interface IToken {
    key: string | undefined;
    value: string | undefined;
}

export class SendByTemplateRequest implements ISendByTemplateRequest {
    sendTime!: Timestamp;
    mobileNumber!: string | undefined;
    template!: string | undefined;
    readonly tokens!: Token[] | undefined;

    constructor(data?: ISendByTemplateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sendTime = data["sendTime"] ? Timestamp.fromJS(data["sendTime"]) : <any>undefined;
            this.mobileNumber = data["mobileNumber"];
            this.template = data["template"];
            if (Array.isArray(data["tokens"])) {
                (<any>this).tokens = [] as any;
                for (let item of data["tokens"])
                    (<any>this).tokens!.push(Token.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SendByTemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendByTemplateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sendTime"] = this.sendTime ? this.sendTime.toJSON() : <any>undefined;
        data["mobileNumber"] = this.mobileNumber;
        data["template"] = this.template;
        if (Array.isArray(this.tokens)) {
            data["tokens"] = [];
            for (let item of this.tokens)
                data["tokens"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISendByTemplateRequest {
    sendTime: Timestamp;
    mobileNumber: string | undefined;
    template: string | undefined;
    tokens: Token[] | undefined;
}

export class SendByTemplateResponse implements ISendByTemplateResponse {
    result!: number;
    resultDesc!: string | undefined;
    jobId!: string | undefined;
    readonly hasJobId!: boolean;

    constructor(data?: ISendByTemplateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.result = data["result"];
            this.resultDesc = data["resultDesc"];
            this.jobId = data["jobId"];
            (<any>this).hasJobId = data["hasJobId"];
        }
    }

    static fromJS(data: any): SendByTemplateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendByTemplateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["resultDesc"] = this.resultDesc;
        data["jobId"] = this.jobId;
        data["hasJobId"] = this.hasJobId;
        return data; 
    }
}

export interface ISendByTemplateResponse {
    result: number;
    resultDesc: string | undefined;
    jobId: string | undefined;
    hasJobId: boolean;
}

export class GetAllLogsDto implements IGetAllLogsDto {
    number!: string | undefined;
    message!: string | undefined;
    sender!: string | undefined;
    type!: string | undefined;
    creationTime!: moment.Moment | undefined;
    template!: string | undefined;

    constructor(data?: IGetAllLogsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.number = data["number"];
            this.message = data["message"];
            this.sender = data["sender"];
            this.type = data["type"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.template = data["template"];
        }
    }

    static fromJS(data: any): GetAllLogsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllLogsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["message"] = this.message;
        data["sender"] = this.sender;
        data["type"] = this.type;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["template"] = this.template;
        return data; 
    }
}

export interface IGetAllLogsDto {
    number: string | undefined;
    message: string | undefined;
    sender: string | undefined;
    type: string | undefined;
    creationTime: moment.Moment | undefined;
    template: string | undefined;
}

export class PagedResultDtoOfGetAllLogsDto implements IPagedResultDtoOfGetAllLogsDto {
    totalCount!: number;
    items!: GetAllLogsDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAllLogsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetAllLogsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAllLogsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAllLogsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetAllLogsDto {
    totalCount: number;
    items: GetAllLogsDto[] | undefined;
}

export class DeleteAndCancelResponse implements IDeleteAndCancelResponse {
    result!: number;
    resultDesc!: string | undefined;

    constructor(data?: IDeleteAndCancelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.result = data["result"];
            this.resultDesc = data["resultDesc"];
        }
    }

    static fromJS(data: any): DeleteAndCancelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteAndCancelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["resultDesc"] = this.resultDesc;
        return data; 
    }
}

export interface IDeleteAndCancelResponse {
    result: number;
    resultDesc: string | undefined;
}

export class SendEmailRequest implements ISendEmailRequest {
    sendTime!: Timestamp;
    emailFrom!: string | undefined;
    readonly emailTo!: string[] | undefined;
    subject!: string | undefined;
    body!: string | undefined;
    isBodyHtml!: boolean;

    constructor(data?: ISendEmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sendTime = data["sendTime"] ? Timestamp.fromJS(data["sendTime"]) : <any>undefined;
            this.emailFrom = data["emailFrom"];
            if (Array.isArray(data["emailTo"])) {
                (<any>this).emailTo = [] as any;
                for (let item of data["emailTo"])
                    (<any>this).emailTo!.push(item);
            }
            this.subject = data["subject"];
            this.body = data["body"];
            this.isBodyHtml = data["isBodyHtml"];
        }
    }

    static fromJS(data: any): SendEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sendTime"] = this.sendTime ? this.sendTime.toJSON() : <any>undefined;
        data["emailFrom"] = this.emailFrom;
        if (Array.isArray(this.emailTo)) {
            data["emailTo"] = [];
            for (let item of this.emailTo)
                data["emailTo"].push(item);
        }
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["isBodyHtml"] = this.isBodyHtml;
        return data; 
    }
}

export interface ISendEmailRequest {
    sendTime: Timestamp;
    emailFrom: string | undefined;
    emailTo: string[] | undefined;
    subject: string | undefined;
    body: string | undefined;
    isBodyHtml: boolean;
}

export class SendEmailResponse implements ISendEmailResponse {
    result!: number;
    resultDesc!: string | undefined;
    jobId!: string | undefined;
    readonly hasJobId!: boolean;

    constructor(data?: ISendEmailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.result = data["result"];
            this.resultDesc = data["resultDesc"];
            this.jobId = data["jobId"];
            (<any>this).hasJobId = data["hasJobId"];
        }
    }

    static fromJS(data: any): SendEmailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendEmailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["resultDesc"] = this.resultDesc;
        data["jobId"] = this.jobId;
        data["hasJobId"] = this.hasJobId;
        return data; 
    }
}

export interface ISendEmailResponse {
    result: number;
    resultDesc: string | undefined;
    jobId: string | undefined;
    hasJobId: boolean;
}

export enum SMSServices {
    Login_1 = 1,
    Reminder_2 = 2,
    UserPass_2 = 3,
    UnApprovedPayment_1 = 4,
    ApprovedPayment_1 = 5,
    PlanBillReminder_1 = 6,
    VirtualTasliat = 7,
    SaleDelayAlert = 8,
    VirtualMoneyBoxTemplate = 9,
    BillRecept = 10,
    ZebhRemind = 11,
    ZebhCreate = 12,
    Cart = 13,
    PaymentLink = 14,
}

export enum TokenName {
    BenefactorName = 1,
    DeceasedName = 2,
    ShortLink = 3,
    BankTrackingNo = 4,
    Price = 5,
    BillCodes = 6,
    CurrencyName = 7,
    Code = 8,
    UserName = 9,
    Password = 10,
    PlanBillCode = 11,
    Blank = 12,
}

export class EmailToken implements IEmailToken {
    name!: TokenName;
    value!: string | undefined;

    constructor(data?: IEmailToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): EmailToken {
        data = typeof data === 'object' ? data : {};
        let result = new EmailToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }
}

export interface IEmailToken {
    name: TokenName;
    value: string | undefined;
}

export class ServiceConditionDto implements IServiceConditionDto {
    description!: string | undefined;
    min!: string | undefined;
    max!: string | undefined;
    isInclude!: boolean;
    conditionRef!: number;
    serviceRef!: number;
    id!: number;

    constructor(data?: IServiceConditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.min = data["min"];
            this.max = data["max"];
            this.isInclude = data["isInclude"];
            this.conditionRef = data["conditionRef"];
            this.serviceRef = data["serviceRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ServiceConditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceConditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["min"] = this.min;
        data["max"] = this.max;
        data["isInclude"] = this.isInclude;
        data["conditionRef"] = this.conditionRef;
        data["serviceRef"] = this.serviceRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface IServiceConditionDto {
    description: string | undefined;
    min: string | undefined;
    max: string | undefined;
    isInclude: boolean;
    conditionRef: number;
    serviceRef: number;
    id: number;
}

export class GetServiceConditionForViewDto implements IGetServiceConditionForViewDto {
    serviceCondition!: ServiceConditionDto;
    conditionTitle!: string | undefined;
    serviceTitle!: string | undefined;
    dataType!: DataType;
    entity!: Entities;
    enumTypeName!: string | undefined;

    constructor(data?: IGetServiceConditionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serviceCondition = data["serviceCondition"] ? ServiceConditionDto.fromJS(data["serviceCondition"]) : <any>undefined;
            this.conditionTitle = data["conditionTitle"];
            this.serviceTitle = data["serviceTitle"];
            this.dataType = data["dataType"];
            this.entity = data["entity"];
            this.enumTypeName = data["enumTypeName"];
        }
    }

    static fromJS(data: any): GetServiceConditionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceConditionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceCondition"] = this.serviceCondition ? this.serviceCondition.toJSON() : <any>undefined;
        data["conditionTitle"] = this.conditionTitle;
        data["serviceTitle"] = this.serviceTitle;
        data["dataType"] = this.dataType;
        data["entity"] = this.entity;
        data["enumTypeName"] = this.enumTypeName;
        return data; 
    }
}

export interface IGetServiceConditionForViewDto {
    serviceCondition: ServiceConditionDto;
    conditionTitle: string | undefined;
    serviceTitle: string | undefined;
    dataType: DataType;
    entity: Entities;
    enumTypeName: string | undefined;
}

export class PagedResultDtoOfGetServiceConditionForViewDto implements IPagedResultDtoOfGetServiceConditionForViewDto {
    totalCount!: number;
    items!: GetServiceConditionForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetServiceConditionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetServiceConditionForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetServiceConditionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetServiceConditionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetServiceConditionForViewDto {
    totalCount: number;
    items: GetServiceConditionForViewDto[] | undefined;
}

export class CreateOrEditServiceConditionDto implements ICreateOrEditServiceConditionDto {
    description!: string | undefined;
    min!: string | undefined;
    max!: string | undefined;
    isInclude!: boolean;
    conditionRef!: number;
    serviceRef!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditServiceConditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.min = data["min"];
            this.max = data["max"];
            this.isInclude = data["isInclude"];
            this.conditionRef = data["conditionRef"];
            this.serviceRef = data["serviceRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditServiceConditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditServiceConditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["min"] = this.min;
        data["max"] = this.max;
        data["isInclude"] = this.isInclude;
        data["conditionRef"] = this.conditionRef;
        data["serviceRef"] = this.serviceRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditServiceConditionDto {
    description: string | undefined;
    min: string | undefined;
    max: string | undefined;
    isInclude: boolean;
    conditionRef: number;
    serviceRef: number;
    id: number | undefined;
}

export class GetServiceConditionForEditOutput implements IGetServiceConditionForEditOutput {
    serviceCondition!: CreateOrEditServiceConditionDto;
    conditionTitle!: string | undefined;
    serviceTitle!: string | undefined;
    dataType!: DataType;

    constructor(data?: IGetServiceConditionForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serviceCondition = data["serviceCondition"] ? CreateOrEditServiceConditionDto.fromJS(data["serviceCondition"]) : <any>undefined;
            this.conditionTitle = data["conditionTitle"];
            this.serviceTitle = data["serviceTitle"];
            this.dataType = data["dataType"];
        }
    }

    static fromJS(data: any): GetServiceConditionForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceConditionForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceCondition"] = this.serviceCondition ? this.serviceCondition.toJSON() : <any>undefined;
        data["conditionTitle"] = this.conditionTitle;
        data["serviceTitle"] = this.serviceTitle;
        data["dataType"] = this.dataType;
        return data; 
    }
}

export interface IGetServiceConditionForEditOutput {
    serviceCondition: CreateOrEditServiceConditionDto;
    conditionTitle: string | undefined;
    serviceTitle: string | undefined;
    dataType: DataType;
}

export class CreateOrEditServiceConditionsDto implements ICreateOrEditServiceConditionsDto {
    serviceConditions!: CreateOrEditServiceConditionDto[] | undefined;

    constructor(data?: ICreateOrEditServiceConditionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["serviceConditions"])) {
                this.serviceConditions = [] as any;
                for (let item of data["serviceConditions"])
                    this.serviceConditions!.push(CreateOrEditServiceConditionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrEditServiceConditionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditServiceConditionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.serviceConditions)) {
            data["serviceConditions"] = [];
            for (let item of this.serviceConditions)
                data["serviceConditions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateOrEditServiceConditionsDto {
    serviceConditions: CreateOrEditServiceConditionDto[] | undefined;
}

export class ServiceConditionConditionLookupTableDto implements IServiceConditionConditionLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    dataType!: DataType;
    entity!: Entities;
    attributeRef!: number | undefined;
    enumTypeName!: string | undefined;

    constructor(data?: IServiceConditionConditionLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.dataType = data["dataType"];
            this.entity = data["entity"];
            this.attributeRef = data["attributeRef"];
            this.enumTypeName = data["enumTypeName"];
        }
    }

    static fromJS(data: any): ServiceConditionConditionLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceConditionConditionLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["dataType"] = this.dataType;
        data["entity"] = this.entity;
        data["attributeRef"] = this.attributeRef;
        data["enumTypeName"] = this.enumTypeName;
        return data; 
    }
}

export interface IServiceConditionConditionLookupTableDto {
    id: number;
    displayName: string | undefined;
    dataType: DataType;
    entity: Entities;
    attributeRef: number | undefined;
    enumTypeName: string | undefined;
}

export class PagedResultDtoOfServiceConditionConditionLookupTableDto implements IPagedResultDtoOfServiceConditionConditionLookupTableDto {
    totalCount!: number;
    items!: ServiceConditionConditionLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfServiceConditionConditionLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(ServiceConditionConditionLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfServiceConditionConditionLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfServiceConditionConditionLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfServiceConditionConditionLookupTableDto {
    totalCount: number;
    items: ServiceConditionConditionLookupTableDto[] | undefined;
}

export class ServiceConditionServiceLookupTableDto implements IServiceConditionServiceLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    entity!: Entities;

    constructor(data?: IServiceConditionServiceLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.entity = data["entity"];
        }
    }

    static fromJS(data: any): ServiceConditionServiceLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceConditionServiceLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["entity"] = this.entity;
        return data; 
    }
}

export interface IServiceConditionServiceLookupTableDto {
    id: number;
    displayName: string | undefined;
    entity: Entities;
}

export class PagedResultDtoOfServiceConditionServiceLookupTableDto implements IPagedResultDtoOfServiceConditionServiceLookupTableDto {
    totalCount!: number;
    items!: ServiceConditionServiceLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfServiceConditionServiceLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(ServiceConditionServiceLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfServiceConditionServiceLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfServiceConditionServiceLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfServiceConditionServiceLookupTableDto {
    totalCount: number;
    items: ServiceConditionServiceLookupTableDto[] | undefined;
}

export enum ServiceAreas {
    Default = 0,
    Food = 1,
    Cloths = 2,
    House = 3,
    Healthcare = 4,
    Employment = 5,
    Marriage = 6,
    CulturalAffairs = 7,
    AcademicAffairs = 8,
    Counseling = 9,
    Other = 10,
}

export enum ServiceTypes {
    Default = 0,
    Cash = 1,
    Service = 2,
    Commodity = 3,
    Other = 4,
    Credit = 5,
    MellatCredit = 6,
}

export enum ServiceCalculationTypes {
    Constant = 1,
    RequirementCoefficientFormula = 2,
    Range = 3,
}

export enum ServicePluralities {
    Once = 1,
    Twice = 2,
    Multiple = 3,
}

export class ServiceDto implements IServiceDto {
    title!: string | undefined;
    code!: string | undefined;
    price!: number | undefined;
    maxPrice!: number | undefined;
    accountingCode!: string | undefined;
    minFamilyTypeCode!: number | undefined;
    maxFamilyTypeCode!: number | undefined;
    isDeliveryToSupervisor!: boolean;
    isDeliveryToClient!: boolean;
    isTakeTurn!: boolean;
    isSendSmsOn!: boolean;
    isConvertToCash!: boolean;
    description!: string | undefined;
    icon!: string | undefined;
    serviceArea!: ServiceAreas;
    serviceType!: ServiceTypes;
    calculationType!: ServiceCalculationTypes;
    familyStatus!: string | undefined;
    groupSubgroups!: string | undefined;
    entity!: Entities;
    durationDate!: number | undefined;
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    servicePlurality!: ServicePluralities;
    branchRefs!: string | undefined;
    regulatorRoleRefs!: string | undefined;
    seconderRoleRefs!: string | undefined;
    approverRoleRefs!: string | undefined;
    baseTimeRef!: number | undefined;
    firstCommodityBasketRef!: number | undefined;
    secondCommodityBasketRef!: number | undefined;
    thirdCommodityBasketRef!: number | undefined;
    accountRef!: number | undefined;
    id!: number;

    constructor(data?: IServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.code = data["code"];
            this.price = data["price"];
            this.maxPrice = data["maxPrice"];
            this.accountingCode = data["accountingCode"];
            this.minFamilyTypeCode = data["minFamilyTypeCode"];
            this.maxFamilyTypeCode = data["maxFamilyTypeCode"];
            this.isDeliveryToSupervisor = data["isDeliveryToSupervisor"];
            this.isDeliveryToClient = data["isDeliveryToClient"];
            this.isTakeTurn = data["isTakeTurn"];
            this.isSendSmsOn = data["isSendSmsOn"];
            this.isConvertToCash = data["isConvertToCash"];
            this.description = data["description"];
            this.icon = data["icon"];
            this.serviceArea = data["serviceArea"];
            this.serviceType = data["serviceType"];
            this.calculationType = data["calculationType"];
            this.familyStatus = data["familyStatus"];
            this.groupSubgroups = data["groupSubgroups"];
            this.entity = data["entity"];
            this.durationDate = data["durationDate"];
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.servicePlurality = data["servicePlurality"];
            this.branchRefs = data["branchRefs"];
            this.regulatorRoleRefs = data["regulatorRoleRefs"];
            this.seconderRoleRefs = data["seconderRoleRefs"];
            this.approverRoleRefs = data["approverRoleRefs"];
            this.baseTimeRef = data["baseTimeRef"];
            this.firstCommodityBasketRef = data["firstCommodityBasketRef"];
            this.secondCommodityBasketRef = data["secondCommodityBasketRef"];
            this.thirdCommodityBasketRef = data["thirdCommodityBasketRef"];
            this.accountRef = data["accountRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["code"] = this.code;
        data["price"] = this.price;
        data["maxPrice"] = this.maxPrice;
        data["accountingCode"] = this.accountingCode;
        data["minFamilyTypeCode"] = this.minFamilyTypeCode;
        data["maxFamilyTypeCode"] = this.maxFamilyTypeCode;
        data["isDeliveryToSupervisor"] = this.isDeliveryToSupervisor;
        data["isDeliveryToClient"] = this.isDeliveryToClient;
        data["isTakeTurn"] = this.isTakeTurn;
        data["isSendSmsOn"] = this.isSendSmsOn;
        data["isConvertToCash"] = this.isConvertToCash;
        data["description"] = this.description;
        data["icon"] = this.icon;
        data["serviceArea"] = this.serviceArea;
        data["serviceType"] = this.serviceType;
        data["calculationType"] = this.calculationType;
        data["familyStatus"] = this.familyStatus;
        data["groupSubgroups"] = this.groupSubgroups;
        data["entity"] = this.entity;
        data["durationDate"] = this.durationDate;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["servicePlurality"] = this.servicePlurality;
        data["branchRefs"] = this.branchRefs;
        data["regulatorRoleRefs"] = this.regulatorRoleRefs;
        data["seconderRoleRefs"] = this.seconderRoleRefs;
        data["approverRoleRefs"] = this.approverRoleRefs;
        data["baseTimeRef"] = this.baseTimeRef;
        data["firstCommodityBasketRef"] = this.firstCommodityBasketRef;
        data["secondCommodityBasketRef"] = this.secondCommodityBasketRef;
        data["thirdCommodityBasketRef"] = this.thirdCommodityBasketRef;
        data["accountRef"] = this.accountRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface IServiceDto {
    title: string | undefined;
    code: string | undefined;
    price: number | undefined;
    maxPrice: number | undefined;
    accountingCode: string | undefined;
    minFamilyTypeCode: number | undefined;
    maxFamilyTypeCode: number | undefined;
    isDeliveryToSupervisor: boolean;
    isDeliveryToClient: boolean;
    isTakeTurn: boolean;
    isSendSmsOn: boolean;
    isConvertToCash: boolean;
    description: string | undefined;
    icon: string | undefined;
    serviceArea: ServiceAreas;
    serviceType: ServiceTypes;
    calculationType: ServiceCalculationTypes;
    familyStatus: string | undefined;
    groupSubgroups: string | undefined;
    entity: Entities;
    durationDate: number | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    servicePlurality: ServicePluralities;
    branchRefs: string | undefined;
    regulatorRoleRefs: string | undefined;
    seconderRoleRefs: string | undefined;
    approverRoleRefs: string | undefined;
    baseTimeRef: number | undefined;
    firstCommodityBasketRef: number | undefined;
    secondCommodityBasketRef: number | undefined;
    thirdCommodityBasketRef: number | undefined;
    accountRef: number | undefined;
    id: number;
}

export class GetServiceForViewDto implements IGetServiceForViewDto {
    service!: ServiceDto;
    branchName!: string | undefined;
    regulatorRoleName!: string | undefined;
    seconderRoleName!: string | undefined;
    approverRoleName!: string | undefined;
    baseTimeName!: string | undefined;
    firstCommodityBasketTitle!: string | undefined;
    secondCommodityBasketTitle!: string | undefined;
    thirdCommodityBasketTitle!: string | undefined;
    accountName!: string | undefined;
    groupSubgroupsName!: string | undefined;

    constructor(data?: IGetServiceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.service = data["service"] ? ServiceDto.fromJS(data["service"]) : <any>undefined;
            this.branchName = data["branchName"];
            this.regulatorRoleName = data["regulatorRoleName"];
            this.seconderRoleName = data["seconderRoleName"];
            this.approverRoleName = data["approverRoleName"];
            this.baseTimeName = data["baseTimeName"];
            this.firstCommodityBasketTitle = data["firstCommodityBasketTitle"];
            this.secondCommodityBasketTitle = data["secondCommodityBasketTitle"];
            this.thirdCommodityBasketTitle = data["thirdCommodityBasketTitle"];
            this.accountName = data["accountName"];
            this.groupSubgroupsName = data["groupSubgroupsName"];
        }
    }

    static fromJS(data: any): GetServiceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["service"] = this.service ? this.service.toJSON() : <any>undefined;
        data["branchName"] = this.branchName;
        data["regulatorRoleName"] = this.regulatorRoleName;
        data["seconderRoleName"] = this.seconderRoleName;
        data["approverRoleName"] = this.approverRoleName;
        data["baseTimeName"] = this.baseTimeName;
        data["firstCommodityBasketTitle"] = this.firstCommodityBasketTitle;
        data["secondCommodityBasketTitle"] = this.secondCommodityBasketTitle;
        data["thirdCommodityBasketTitle"] = this.thirdCommodityBasketTitle;
        data["accountName"] = this.accountName;
        data["groupSubgroupsName"] = this.groupSubgroupsName;
        return data; 
    }
}

export interface IGetServiceForViewDto {
    service: ServiceDto;
    branchName: string | undefined;
    regulatorRoleName: string | undefined;
    seconderRoleName: string | undefined;
    approverRoleName: string | undefined;
    baseTimeName: string | undefined;
    firstCommodityBasketTitle: string | undefined;
    secondCommodityBasketTitle: string | undefined;
    thirdCommodityBasketTitle: string | undefined;
    accountName: string | undefined;
    groupSubgroupsName: string | undefined;
}

export class PagedResultDtoOfGetServiceForViewDto implements IPagedResultDtoOfGetServiceForViewDto {
    totalCount!: number;
    items!: GetServiceForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetServiceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetServiceForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetServiceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetServiceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetServiceForViewDto {
    totalCount: number;
    items: GetServiceForViewDto[] | undefined;
}

export class CreateOrEditServiceDto implements ICreateOrEditServiceDto {
    title!: string | undefined;
    code!: string | undefined;
    price!: number | undefined;
    maxPrice!: number | undefined;
    accountingCode!: string | undefined;
    minFamilyTypeCode!: number | undefined;
    maxFamilyTypeCode!: number | undefined;
    isDeliveryToSupervisor!: boolean;
    isDeliveryToClient!: boolean;
    isTakeTurn!: boolean;
    isSendSmsOn!: boolean;
    isConvertToCash!: boolean;
    description!: string | undefined;
    icon!: string | undefined;
    serviceArea!: ServiceAreas;
    serviceType!: ServiceTypes;
    calculationType!: ServiceCalculationTypes;
    familyStatus!: string | undefined;
    groupSubgroups!: string | undefined;
    entity!: Entities;
    durationDate!: number | undefined;
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    servicePlurality!: ServicePluralities;
    branchRefs!: string | undefined;
    regulatorRoleRefs!: string | undefined;
    seconderRoleRefs!: string | undefined;
    approverRoleRefs!: string | undefined;
    baseTimeRef!: number | undefined;
    firstCommodityBasketRef!: number | undefined;
    secondCommodityBasketRef!: number | undefined;
    thirdCommodityBasketRef!: number | undefined;
    accountRef!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.code = data["code"];
            this.price = data["price"];
            this.maxPrice = data["maxPrice"];
            this.accountingCode = data["accountingCode"];
            this.minFamilyTypeCode = data["minFamilyTypeCode"];
            this.maxFamilyTypeCode = data["maxFamilyTypeCode"];
            this.isDeliveryToSupervisor = data["isDeliveryToSupervisor"];
            this.isDeliveryToClient = data["isDeliveryToClient"];
            this.isTakeTurn = data["isTakeTurn"];
            this.isSendSmsOn = data["isSendSmsOn"];
            this.isConvertToCash = data["isConvertToCash"];
            this.description = data["description"];
            this.icon = data["icon"];
            this.serviceArea = data["serviceArea"];
            this.serviceType = data["serviceType"];
            this.calculationType = data["calculationType"];
            this.familyStatus = data["familyStatus"];
            this.groupSubgroups = data["groupSubgroups"];
            this.entity = data["entity"];
            this.durationDate = data["durationDate"];
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.servicePlurality = data["servicePlurality"];
            this.branchRefs = data["branchRefs"];
            this.regulatorRoleRefs = data["regulatorRoleRefs"];
            this.seconderRoleRefs = data["seconderRoleRefs"];
            this.approverRoleRefs = data["approverRoleRefs"];
            this.baseTimeRef = data["baseTimeRef"];
            this.firstCommodityBasketRef = data["firstCommodityBasketRef"];
            this.secondCommodityBasketRef = data["secondCommodityBasketRef"];
            this.thirdCommodityBasketRef = data["thirdCommodityBasketRef"];
            this.accountRef = data["accountRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["code"] = this.code;
        data["price"] = this.price;
        data["maxPrice"] = this.maxPrice;
        data["accountingCode"] = this.accountingCode;
        data["minFamilyTypeCode"] = this.minFamilyTypeCode;
        data["maxFamilyTypeCode"] = this.maxFamilyTypeCode;
        data["isDeliveryToSupervisor"] = this.isDeliveryToSupervisor;
        data["isDeliveryToClient"] = this.isDeliveryToClient;
        data["isTakeTurn"] = this.isTakeTurn;
        data["isSendSmsOn"] = this.isSendSmsOn;
        data["isConvertToCash"] = this.isConvertToCash;
        data["description"] = this.description;
        data["icon"] = this.icon;
        data["serviceArea"] = this.serviceArea;
        data["serviceType"] = this.serviceType;
        data["calculationType"] = this.calculationType;
        data["familyStatus"] = this.familyStatus;
        data["groupSubgroups"] = this.groupSubgroups;
        data["entity"] = this.entity;
        data["durationDate"] = this.durationDate;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["servicePlurality"] = this.servicePlurality;
        data["branchRefs"] = this.branchRefs;
        data["regulatorRoleRefs"] = this.regulatorRoleRefs;
        data["seconderRoleRefs"] = this.seconderRoleRefs;
        data["approverRoleRefs"] = this.approverRoleRefs;
        data["baseTimeRef"] = this.baseTimeRef;
        data["firstCommodityBasketRef"] = this.firstCommodityBasketRef;
        data["secondCommodityBasketRef"] = this.secondCommodityBasketRef;
        data["thirdCommodityBasketRef"] = this.thirdCommodityBasketRef;
        data["accountRef"] = this.accountRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditServiceDto {
    title: string | undefined;
    code: string | undefined;
    price: number | undefined;
    maxPrice: number | undefined;
    accountingCode: string | undefined;
    minFamilyTypeCode: number | undefined;
    maxFamilyTypeCode: number | undefined;
    isDeliveryToSupervisor: boolean;
    isDeliveryToClient: boolean;
    isTakeTurn: boolean;
    isSendSmsOn: boolean;
    isConvertToCash: boolean;
    description: string | undefined;
    icon: string | undefined;
    serviceArea: ServiceAreas;
    serviceType: ServiceTypes;
    calculationType: ServiceCalculationTypes;
    familyStatus: string | undefined;
    groupSubgroups: string | undefined;
    entity: Entities;
    durationDate: number | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    servicePlurality: ServicePluralities;
    branchRefs: string | undefined;
    regulatorRoleRefs: string | undefined;
    seconderRoleRefs: string | undefined;
    approverRoleRefs: string | undefined;
    baseTimeRef: number | undefined;
    firstCommodityBasketRef: number | undefined;
    secondCommodityBasketRef: number | undefined;
    thirdCommodityBasketRef: number | undefined;
    accountRef: number | undefined;
    id: number | undefined;
}

export class GetServiceForEditOutput implements IGetServiceForEditOutput {
    service!: CreateOrEditServiceDto;
    branchName!: string | undefined;
    regulatorRoleName!: string | undefined;
    seconderRoleName!: string | undefined;
    approverRoleName!: string | undefined;
    baseTimeName!: string | undefined;
    firstCommodityBasketTitle!: string | undefined;
    secondCommodityBasketTitle!: string | undefined;
    thirdCommodityBasketTitle!: string | undefined;
    firstCommodityBasketDescription!: string | undefined;
    secondCommodityBasketDescription!: string | undefined;
    thirdCommodityBasketDescription!: string | undefined;
    accountName!: string | undefined;
    groupSubgroupsName!: string | undefined;

    constructor(data?: IGetServiceForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.service = data["service"] ? CreateOrEditServiceDto.fromJS(data["service"]) : <any>undefined;
            this.branchName = data["branchName"];
            this.regulatorRoleName = data["regulatorRoleName"];
            this.seconderRoleName = data["seconderRoleName"];
            this.approverRoleName = data["approverRoleName"];
            this.baseTimeName = data["baseTimeName"];
            this.firstCommodityBasketTitle = data["firstCommodityBasketTitle"];
            this.secondCommodityBasketTitle = data["secondCommodityBasketTitle"];
            this.thirdCommodityBasketTitle = data["thirdCommodityBasketTitle"];
            this.firstCommodityBasketDescription = data["firstCommodityBasketDescription"];
            this.secondCommodityBasketDescription = data["secondCommodityBasketDescription"];
            this.thirdCommodityBasketDescription = data["thirdCommodityBasketDescription"];
            this.accountName = data["accountName"];
            this.groupSubgroupsName = data["groupSubgroupsName"];
        }
    }

    static fromJS(data: any): GetServiceForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["service"] = this.service ? this.service.toJSON() : <any>undefined;
        data["branchName"] = this.branchName;
        data["regulatorRoleName"] = this.regulatorRoleName;
        data["seconderRoleName"] = this.seconderRoleName;
        data["approverRoleName"] = this.approverRoleName;
        data["baseTimeName"] = this.baseTimeName;
        data["firstCommodityBasketTitle"] = this.firstCommodityBasketTitle;
        data["secondCommodityBasketTitle"] = this.secondCommodityBasketTitle;
        data["thirdCommodityBasketTitle"] = this.thirdCommodityBasketTitle;
        data["firstCommodityBasketDescription"] = this.firstCommodityBasketDescription;
        data["secondCommodityBasketDescription"] = this.secondCommodityBasketDescription;
        data["thirdCommodityBasketDescription"] = this.thirdCommodityBasketDescription;
        data["accountName"] = this.accountName;
        data["groupSubgroupsName"] = this.groupSubgroupsName;
        return data; 
    }
}

export interface IGetServiceForEditOutput {
    service: CreateOrEditServiceDto;
    branchName: string | undefined;
    regulatorRoleName: string | undefined;
    seconderRoleName: string | undefined;
    approverRoleName: string | undefined;
    baseTimeName: string | undefined;
    firstCommodityBasketTitle: string | undefined;
    secondCommodityBasketTitle: string | undefined;
    thirdCommodityBasketTitle: string | undefined;
    firstCommodityBasketDescription: string | undefined;
    secondCommodityBasketDescription: string | undefined;
    thirdCommodityBasketDescription: string | undefined;
    accountName: string | undefined;
    groupSubgroupsName: string | undefined;
}

export class CreateOrEditServiceAndServiceConditionDto implements ICreateOrEditServiceAndServiceConditionDto {
    service!: CreateOrEditServiceDto;
    serviceConditions!: CreateOrEditServiceConditionDto[] | undefined;

    constructor(data?: ICreateOrEditServiceAndServiceConditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.service = data["service"] ? CreateOrEditServiceDto.fromJS(data["service"]) : <any>undefined;
            if (Array.isArray(data["serviceConditions"])) {
                this.serviceConditions = [] as any;
                for (let item of data["serviceConditions"])
                    this.serviceConditions!.push(CreateOrEditServiceConditionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrEditServiceAndServiceConditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditServiceAndServiceConditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["service"] = this.service ? this.service.toJSON() : <any>undefined;
        if (Array.isArray(this.serviceConditions)) {
            data["serviceConditions"] = [];
            for (let item of this.serviceConditions)
                data["serviceConditions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateOrEditServiceAndServiceConditionDto {
    service: CreateOrEditServiceDto;
    serviceConditions: CreateOrEditServiceConditionDto[] | undefined;
}

export class ServiceBranchLookupTableDto implements IServiceBranchLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IServiceBranchLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): ServiceBranchLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceBranchLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IServiceBranchLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class ServiceRoleLookupTableDto implements IServiceRoleLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IServiceRoleLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): ServiceRoleLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRoleLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IServiceRoleLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class ServiceBaseTimeLookupTableDto implements IServiceBaseTimeLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    duratione!: number | undefined;

    constructor(data?: IServiceBaseTimeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.duratione = data["duratione"];
        }
    }

    static fromJS(data: any): ServiceBaseTimeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceBaseTimeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["duratione"] = this.duratione;
        return data; 
    }
}

export interface IServiceBaseTimeLookupTableDto {
    id: number;
    displayName: string | undefined;
    duratione: number | undefined;
}

export class ServiceCommodityBasketLookupTableDto implements IServiceCommodityBasketLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    description!: string | undefined;

    constructor(data?: IServiceCommodityBasketLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.description = data["description"];
        }
    }

    static fromJS(data: any): ServiceCommodityBasketLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCommodityBasketLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data; 
    }
}

export interface IServiceCommodityBasketLookupTableDto {
    id: number;
    displayName: string | undefined;
    description: string | undefined;
}

export class PagedResultDtoOfServiceCommodityBasketLookupTableDto implements IPagedResultDtoOfServiceCommodityBasketLookupTableDto {
    totalCount!: number;
    items!: ServiceCommodityBasketLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfServiceCommodityBasketLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(ServiceCommodityBasketLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfServiceCommodityBasketLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfServiceCommodityBasketLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfServiceCommodityBasketLookupTableDto {
    totalCount: number;
    items: ServiceCommodityBasketLookupTableDto[] | undefined;
}

export class ServiceAccountLookupTableDto implements IServiceAccountLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IServiceAccountLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): ServiceAccountLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceAccountLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IServiceAccountLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class ServiceVoucherDto implements IServiceVoucherDto {
    code!: string | undefined;
    entity!: Entities;
    entityRef!: number;
    entityRefName!: string | undefined;
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    status!: PlanBillStatus;
    maxCashValue!: number | undefined;
    cartCode!: string | undefined;
    regulatDateTime!: moment.Moment | undefined;
    secondedDateTime!: moment.Moment | undefined;
    approvedDateTime!: moment.Moment | undefined;
    servicesDescription!: string | undefined;
    relevantUnitDescription!: string | undefined;
    requestCode!: string | undefined;
    managementDescription!: string | undefined;
    isRequestedFromClient!: boolean;
    researchCode!: string | undefined;
    serviceRef!: number;
    branchRef!: number | undefined;
    planBillRef!: number | undefined;
    approverRef!: number | undefined;
    seconderRef!: number | undefined;
    regulatorRef!: number | undefined;
    personInquiryRef!: number | undefined;
    id!: number;

    constructor(data?: IServiceVoucherDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.entity = data["entity"];
            this.entityRef = data["entityRef"];
            this.entityRefName = data["entityRefName"];
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.status = data["status"];
            this.maxCashValue = data["maxCashValue"];
            this.cartCode = data["cartCode"];
            this.regulatDateTime = data["regulatDateTime"] ? moment(data["regulatDateTime"].toString()) : <any>undefined;
            this.secondedDateTime = data["secondedDateTime"] ? moment(data["secondedDateTime"].toString()) : <any>undefined;
            this.approvedDateTime = data["approvedDateTime"] ? moment(data["approvedDateTime"].toString()) : <any>undefined;
            this.servicesDescription = data["servicesDescription"];
            this.relevantUnitDescription = data["relevantUnitDescription"];
            this.requestCode = data["requestCode"];
            this.managementDescription = data["managementDescription"];
            this.isRequestedFromClient = data["isRequestedFromClient"];
            this.researchCode = data["researchCode"];
            this.serviceRef = data["serviceRef"];
            this.branchRef = data["branchRef"];
            this.planBillRef = data["planBillRef"];
            this.approverRef = data["approverRef"];
            this.seconderRef = data["seconderRef"];
            this.regulatorRef = data["regulatorRef"];
            this.personInquiryRef = data["personInquiryRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ServiceVoucherDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceVoucherDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["entity"] = this.entity;
        data["entityRef"] = this.entityRef;
        data["entityRefName"] = this.entityRefName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["maxCashValue"] = this.maxCashValue;
        data["cartCode"] = this.cartCode;
        data["regulatDateTime"] = this.regulatDateTime ? this.regulatDateTime.toISOString() : <any>undefined;
        data["secondedDateTime"] = this.secondedDateTime ? this.secondedDateTime.toISOString() : <any>undefined;
        data["approvedDateTime"] = this.approvedDateTime ? this.approvedDateTime.toISOString() : <any>undefined;
        data["servicesDescription"] = this.servicesDescription;
        data["relevantUnitDescription"] = this.relevantUnitDescription;
        data["requestCode"] = this.requestCode;
        data["managementDescription"] = this.managementDescription;
        data["isRequestedFromClient"] = this.isRequestedFromClient;
        data["researchCode"] = this.researchCode;
        data["serviceRef"] = this.serviceRef;
        data["branchRef"] = this.branchRef;
        data["planBillRef"] = this.planBillRef;
        data["approverRef"] = this.approverRef;
        data["seconderRef"] = this.seconderRef;
        data["regulatorRef"] = this.regulatorRef;
        data["personInquiryRef"] = this.personInquiryRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface IServiceVoucherDto {
    code: string | undefined;
    entity: Entities;
    entityRef: number;
    entityRefName: string | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    status: PlanBillStatus;
    maxCashValue: number | undefined;
    cartCode: string | undefined;
    regulatDateTime: moment.Moment | undefined;
    secondedDateTime: moment.Moment | undefined;
    approvedDateTime: moment.Moment | undefined;
    servicesDescription: string | undefined;
    relevantUnitDescription: string | undefined;
    requestCode: string | undefined;
    managementDescription: string | undefined;
    isRequestedFromClient: boolean;
    researchCode: string | undefined;
    serviceRef: number;
    branchRef: number | undefined;
    planBillRef: number | undefined;
    approverRef: number | undefined;
    seconderRef: number | undefined;
    regulatorRef: number | undefined;
    personInquiryRef: number | undefined;
    id: number;
}

export class GetServiceVoucherForViewDto implements IGetServiceVoucherForViewDto {
    serviceVoucher!: ServiceVoucherDto;
    serviceTitle!: string | undefined;
    branchName!: string | undefined;
    planBillCode!: string | undefined;
    approverPhoneNumber!: string | undefined;
    seconderPhoneNumber!: string | undefined;
    regulatorPhoneNumber!: string | undefined;
    clientName!: string | undefined;
    familyName!: string | undefined;
    personInquiryCode!: string | undefined;
    checked!: boolean;
    isGrantedRegulatorPermission!: boolean;
    isGrantedSeconderPermission!: boolean;
    isGrantedApproverPermission!: boolean;
    isGrantedTotalApproverPermission!: boolean;

    constructor(data?: IGetServiceVoucherForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serviceVoucher = data["serviceVoucher"] ? ServiceVoucherDto.fromJS(data["serviceVoucher"]) : <any>undefined;
            this.serviceTitle = data["serviceTitle"];
            this.branchName = data["branchName"];
            this.planBillCode = data["planBillCode"];
            this.approverPhoneNumber = data["approverPhoneNumber"];
            this.seconderPhoneNumber = data["seconderPhoneNumber"];
            this.regulatorPhoneNumber = data["regulatorPhoneNumber"];
            this.clientName = data["clientName"];
            this.familyName = data["familyName"];
            this.personInquiryCode = data["personInquiryCode"];
            this.checked = data["checked"];
            this.isGrantedRegulatorPermission = data["isGrantedRegulatorPermission"];
            this.isGrantedSeconderPermission = data["isGrantedSeconderPermission"];
            this.isGrantedApproverPermission = data["isGrantedApproverPermission"];
            this.isGrantedTotalApproverPermission = data["isGrantedTotalApproverPermission"];
        }
    }

    static fromJS(data: any): GetServiceVoucherForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceVoucherForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceVoucher"] = this.serviceVoucher ? this.serviceVoucher.toJSON() : <any>undefined;
        data["serviceTitle"] = this.serviceTitle;
        data["branchName"] = this.branchName;
        data["planBillCode"] = this.planBillCode;
        data["approverPhoneNumber"] = this.approverPhoneNumber;
        data["seconderPhoneNumber"] = this.seconderPhoneNumber;
        data["regulatorPhoneNumber"] = this.regulatorPhoneNumber;
        data["clientName"] = this.clientName;
        data["familyName"] = this.familyName;
        data["personInquiryCode"] = this.personInquiryCode;
        data["checked"] = this.checked;
        data["isGrantedRegulatorPermission"] = this.isGrantedRegulatorPermission;
        data["isGrantedSeconderPermission"] = this.isGrantedSeconderPermission;
        data["isGrantedApproverPermission"] = this.isGrantedApproverPermission;
        data["isGrantedTotalApproverPermission"] = this.isGrantedTotalApproverPermission;
        return data; 
    }
}

export interface IGetServiceVoucherForViewDto {
    serviceVoucher: ServiceVoucherDto;
    serviceTitle: string | undefined;
    branchName: string | undefined;
    planBillCode: string | undefined;
    approverPhoneNumber: string | undefined;
    seconderPhoneNumber: string | undefined;
    regulatorPhoneNumber: string | undefined;
    clientName: string | undefined;
    familyName: string | undefined;
    personInquiryCode: string | undefined;
    checked: boolean;
    isGrantedRegulatorPermission: boolean;
    isGrantedSeconderPermission: boolean;
    isGrantedApproverPermission: boolean;
    isGrantedTotalApproverPermission: boolean;
}

export class PagedResultDtoOfGetServiceVoucherForViewDto implements IPagedResultDtoOfGetServiceVoucherForViewDto {
    totalCount!: number;
    items!: GetServiceVoucherForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetServiceVoucherForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetServiceVoucherForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetServiceVoucherForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetServiceVoucherForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetServiceVoucherForViewDto {
    totalCount: number;
    items: GetServiceVoucherForViewDto[] | undefined;
}

export class CreateOrEditServiceVoucherDto implements ICreateOrEditServiceVoucherDto {
    code!: string | undefined;
    entity!: Entities;
    entityRef!: number;
    entityRefName!: string | undefined;
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    status!: PlanBillStatus;
    maxCashValue!: number | undefined;
    cartCode!: string | undefined;
    secondedDateTime!: moment.Moment | undefined;
    approvedDateTime!: moment.Moment | undefined;
    servicesDescription!: string | undefined;
    relevantUnitDescription!: string | undefined;
    requestCode!: string | undefined;
    managementDescription!: string | undefined;
    researchCode!: string | undefined;
    isRequestedFromClient!: boolean;
    serviceRef!: number;
    branchRef!: number | undefined;
    planBillRef!: number | undefined;
    approverRef!: number | undefined;
    seconderRef!: number | undefined;
    personInquiryRef!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditServiceVoucherDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.entity = data["entity"];
            this.entityRef = data["entityRef"];
            this.entityRefName = data["entityRefName"];
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.status = data["status"];
            this.maxCashValue = data["maxCashValue"];
            this.cartCode = data["cartCode"];
            this.secondedDateTime = data["secondedDateTime"] ? moment(data["secondedDateTime"].toString()) : <any>undefined;
            this.approvedDateTime = data["approvedDateTime"] ? moment(data["approvedDateTime"].toString()) : <any>undefined;
            this.servicesDescription = data["servicesDescription"];
            this.relevantUnitDescription = data["relevantUnitDescription"];
            this.requestCode = data["requestCode"];
            this.managementDescription = data["managementDescription"];
            this.researchCode = data["researchCode"];
            this.isRequestedFromClient = data["isRequestedFromClient"];
            this.serviceRef = data["serviceRef"];
            this.branchRef = data["branchRef"];
            this.planBillRef = data["planBillRef"];
            this.approverRef = data["approverRef"];
            this.seconderRef = data["seconderRef"];
            this.personInquiryRef = data["personInquiryRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditServiceVoucherDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditServiceVoucherDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["entity"] = this.entity;
        data["entityRef"] = this.entityRef;
        data["entityRefName"] = this.entityRefName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["maxCashValue"] = this.maxCashValue;
        data["cartCode"] = this.cartCode;
        data["secondedDateTime"] = this.secondedDateTime ? this.secondedDateTime.toISOString() : <any>undefined;
        data["approvedDateTime"] = this.approvedDateTime ? this.approvedDateTime.toISOString() : <any>undefined;
        data["servicesDescription"] = this.servicesDescription;
        data["relevantUnitDescription"] = this.relevantUnitDescription;
        data["requestCode"] = this.requestCode;
        data["managementDescription"] = this.managementDescription;
        data["researchCode"] = this.researchCode;
        data["isRequestedFromClient"] = this.isRequestedFromClient;
        data["serviceRef"] = this.serviceRef;
        data["branchRef"] = this.branchRef;
        data["planBillRef"] = this.planBillRef;
        data["approverRef"] = this.approverRef;
        data["seconderRef"] = this.seconderRef;
        data["personInquiryRef"] = this.personInquiryRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditServiceVoucherDto {
    code: string | undefined;
    entity: Entities;
    entityRef: number;
    entityRefName: string | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    status: PlanBillStatus;
    maxCashValue: number | undefined;
    cartCode: string | undefined;
    secondedDateTime: moment.Moment | undefined;
    approvedDateTime: moment.Moment | undefined;
    servicesDescription: string | undefined;
    relevantUnitDescription: string | undefined;
    requestCode: string | undefined;
    managementDescription: string | undefined;
    researchCode: string | undefined;
    isRequestedFromClient: boolean;
    serviceRef: number;
    branchRef: number | undefined;
    planBillRef: number | undefined;
    approverRef: number | undefined;
    seconderRef: number | undefined;
    personInquiryRef: number | undefined;
    id: number | undefined;
}

export class GetServiceVoucherForEditOutput implements IGetServiceVoucherForEditOutput {
    serviceVoucher!: CreateOrEditServiceVoucherDto;
    serviceTitle!: string | undefined;
    branchName!: string | undefined;
    planBillCode!: string | undefined;
    approverPhoneNumber!: string | undefined;
    seconderPhoneNumber!: string | undefined;
    regulatorPhoneNumber!: string | undefined;
    clientName!: string | undefined;
    familyName!: string | undefined;
    personInquiryCode!: string | undefined;
    approverRoleRefs!: number[] | undefined;
    seconderRoleRefs!: number[] | undefined;
    regulatorRoleRefs!: number[] | undefined;
    branchRefs!: number[] | undefined;
    isContinues!: boolean;

    constructor(data?: IGetServiceVoucherForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serviceVoucher = data["serviceVoucher"] ? CreateOrEditServiceVoucherDto.fromJS(data["serviceVoucher"]) : <any>undefined;
            this.serviceTitle = data["serviceTitle"];
            this.branchName = data["branchName"];
            this.planBillCode = data["planBillCode"];
            this.approverPhoneNumber = data["approverPhoneNumber"];
            this.seconderPhoneNumber = data["seconderPhoneNumber"];
            this.regulatorPhoneNumber = data["regulatorPhoneNumber"];
            this.clientName = data["clientName"];
            this.familyName = data["familyName"];
            this.personInquiryCode = data["personInquiryCode"];
            if (Array.isArray(data["approverRoleRefs"])) {
                this.approverRoleRefs = [] as any;
                for (let item of data["approverRoleRefs"])
                    this.approverRoleRefs!.push(item);
            }
            if (Array.isArray(data["seconderRoleRefs"])) {
                this.seconderRoleRefs = [] as any;
                for (let item of data["seconderRoleRefs"])
                    this.seconderRoleRefs!.push(item);
            }
            if (Array.isArray(data["regulatorRoleRefs"])) {
                this.regulatorRoleRefs = [] as any;
                for (let item of data["regulatorRoleRefs"])
                    this.regulatorRoleRefs!.push(item);
            }
            if (Array.isArray(data["branchRefs"])) {
                this.branchRefs = [] as any;
                for (let item of data["branchRefs"])
                    this.branchRefs!.push(item);
            }
            this.isContinues = data["isContinues"];
        }
    }

    static fromJS(data: any): GetServiceVoucherForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceVoucherForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceVoucher"] = this.serviceVoucher ? this.serviceVoucher.toJSON() : <any>undefined;
        data["serviceTitle"] = this.serviceTitle;
        data["branchName"] = this.branchName;
        data["planBillCode"] = this.planBillCode;
        data["approverPhoneNumber"] = this.approverPhoneNumber;
        data["seconderPhoneNumber"] = this.seconderPhoneNumber;
        data["regulatorPhoneNumber"] = this.regulatorPhoneNumber;
        data["clientName"] = this.clientName;
        data["familyName"] = this.familyName;
        data["personInquiryCode"] = this.personInquiryCode;
        if (Array.isArray(this.approverRoleRefs)) {
            data["approverRoleRefs"] = [];
            for (let item of this.approverRoleRefs)
                data["approverRoleRefs"].push(item);
        }
        if (Array.isArray(this.seconderRoleRefs)) {
            data["seconderRoleRefs"] = [];
            for (let item of this.seconderRoleRefs)
                data["seconderRoleRefs"].push(item);
        }
        if (Array.isArray(this.regulatorRoleRefs)) {
            data["regulatorRoleRefs"] = [];
            for (let item of this.regulatorRoleRefs)
                data["regulatorRoleRefs"].push(item);
        }
        if (Array.isArray(this.branchRefs)) {
            data["branchRefs"] = [];
            for (let item of this.branchRefs)
                data["branchRefs"].push(item);
        }
        data["isContinues"] = this.isContinues;
        return data; 
    }
}

export interface IGetServiceVoucherForEditOutput {
    serviceVoucher: CreateOrEditServiceVoucherDto;
    serviceTitle: string | undefined;
    branchName: string | undefined;
    planBillCode: string | undefined;
    approverPhoneNumber: string | undefined;
    seconderPhoneNumber: string | undefined;
    regulatorPhoneNumber: string | undefined;
    clientName: string | undefined;
    familyName: string | undefined;
    personInquiryCode: string | undefined;
    approverRoleRefs: number[] | undefined;
    seconderRoleRefs: number[] | undefined;
    regulatorRoleRefs: number[] | undefined;
    branchRefs: number[] | undefined;
    isContinues: boolean;
}

export class CreateOrEditServiceVoucherResponseDto implements ICreateOrEditServiceVoucherResponseDto {
    isSuccess!: boolean;
    message!: string | undefined;

    constructor(data?: ICreateOrEditServiceVoucherResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isSuccess = data["isSuccess"];
            this.message = data["message"];
        }
    }

    static fromJS(data: any): CreateOrEditServiceVoucherResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditServiceVoucherResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["message"] = this.message;
        return data; 
    }
}

export interface ICreateOrEditServiceVoucherResponseDto {
    isSuccess: boolean;
    message: string | undefined;
}

export class ServiceVoucherServiceLookupTableDto implements IServiceVoucherServiceLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    branchIds!: number[] | undefined;
    regulatorRoleRefs!: number[] | undefined;
    seconderRoleRefs!: number[] | undefined;
    approverRoleRefs!: number[] | undefined;
    entity!: Entities;
    isContinues!: boolean;
    price!: number | undefined;
    maxPrice!: number | undefined;
    calculationType!: ServiceCalculationTypes;

    constructor(data?: IServiceVoucherServiceLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            if (Array.isArray(data["branchIds"])) {
                this.branchIds = [] as any;
                for (let item of data["branchIds"])
                    this.branchIds!.push(item);
            }
            if (Array.isArray(data["regulatorRoleRefs"])) {
                this.regulatorRoleRefs = [] as any;
                for (let item of data["regulatorRoleRefs"])
                    this.regulatorRoleRefs!.push(item);
            }
            if (Array.isArray(data["seconderRoleRefs"])) {
                this.seconderRoleRefs = [] as any;
                for (let item of data["seconderRoleRefs"])
                    this.seconderRoleRefs!.push(item);
            }
            if (Array.isArray(data["approverRoleRefs"])) {
                this.approverRoleRefs = [] as any;
                for (let item of data["approverRoleRefs"])
                    this.approverRoleRefs!.push(item);
            }
            this.entity = data["entity"];
            this.isContinues = data["isContinues"];
            this.price = data["price"];
            this.maxPrice = data["maxPrice"];
            this.calculationType = data["calculationType"];
        }
    }

    static fromJS(data: any): ServiceVoucherServiceLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceVoucherServiceLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        if (Array.isArray(this.branchIds)) {
            data["branchIds"] = [];
            for (let item of this.branchIds)
                data["branchIds"].push(item);
        }
        if (Array.isArray(this.regulatorRoleRefs)) {
            data["regulatorRoleRefs"] = [];
            for (let item of this.regulatorRoleRefs)
                data["regulatorRoleRefs"].push(item);
        }
        if (Array.isArray(this.seconderRoleRefs)) {
            data["seconderRoleRefs"] = [];
            for (let item of this.seconderRoleRefs)
                data["seconderRoleRefs"].push(item);
        }
        if (Array.isArray(this.approverRoleRefs)) {
            data["approverRoleRefs"] = [];
            for (let item of this.approverRoleRefs)
                data["approverRoleRefs"].push(item);
        }
        data["entity"] = this.entity;
        data["isContinues"] = this.isContinues;
        data["price"] = this.price;
        data["maxPrice"] = this.maxPrice;
        data["calculationType"] = this.calculationType;
        return data; 
    }
}

export interface IServiceVoucherServiceLookupTableDto {
    id: number;
    displayName: string | undefined;
    branchIds: number[] | undefined;
    regulatorRoleRefs: number[] | undefined;
    seconderRoleRefs: number[] | undefined;
    approverRoleRefs: number[] | undefined;
    entity: Entities;
    isContinues: boolean;
    price: number | undefined;
    maxPrice: number | undefined;
    calculationType: ServiceCalculationTypes;
}

export class PagedResultDtoOfServiceVoucherServiceLookupTableDto implements IPagedResultDtoOfServiceVoucherServiceLookupTableDto {
    totalCount!: number;
    items!: ServiceVoucherServiceLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfServiceVoucherServiceLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(ServiceVoucherServiceLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfServiceVoucherServiceLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfServiceVoucherServiceLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfServiceVoucherServiceLookupTableDto {
    totalCount: number;
    items: ServiceVoucherServiceLookupTableDto[] | undefined;
}

export class ServiceVoucherBranchLookupTableDto implements IServiceVoucherBranchLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IServiceVoucherBranchLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): ServiceVoucherBranchLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceVoucherBranchLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IServiceVoucherBranchLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class ServiceVoucherPlanBillLookupTableDto implements IServiceVoucherPlanBillLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    contact!: string | undefined;
    attributes!: string | undefined;

    constructor(data?: IServiceVoucherPlanBillLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.contact = data["contact"];
            this.attributes = data["attributes"];
        }
    }

    static fromJS(data: any): ServiceVoucherPlanBillLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceVoucherPlanBillLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["contact"] = this.contact;
        data["attributes"] = this.attributes;
        return data; 
    }
}

export interface IServiceVoucherPlanBillLookupTableDto {
    id: number;
    displayName: string | undefined;
    contact: string | undefined;
    attributes: string | undefined;
}

export class PagedResultDtoOfServiceVoucherPlanBillLookupTableDto implements IPagedResultDtoOfServiceVoucherPlanBillLookupTableDto {
    totalCount!: number;
    items!: ServiceVoucherPlanBillLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfServiceVoucherPlanBillLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(ServiceVoucherPlanBillLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfServiceVoucherPlanBillLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfServiceVoucherPlanBillLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfServiceVoucherPlanBillLookupTableDto {
    totalCount: number;
    items: ServiceVoucherPlanBillLookupTableDto[] | undefined;
}

export class ServiceVoucherUserLookupTableDto implements IServiceVoucherUserLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IServiceVoucherUserLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): ServiceVoucherUserLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceVoucherUserLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IServiceVoucherUserLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfServiceVoucherUserLookupTableDto implements IPagedResultDtoOfServiceVoucherUserLookupTableDto {
    totalCount!: number;
    items!: ServiceVoucherUserLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfServiceVoucherUserLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(ServiceVoucherUserLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfServiceVoucherUserLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfServiceVoucherUserLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfServiceVoucherUserLookupTableDto {
    totalCount: number;
    items: ServiceVoucherUserLookupTableDto[] | undefined;
}

export class ServiceVoucherFamilyLookupTableDto implements IServiceVoucherFamilyLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    description!: string | undefined;
    code!: string | undefined;
    fileNumber!: string | undefined;
    connectorRef!: number | undefined;

    constructor(data?: IServiceVoucherFamilyLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.code = data["code"];
            this.fileNumber = data["fileNumber"];
            this.connectorRef = data["connectorRef"];
        }
    }

    static fromJS(data: any): ServiceVoucherFamilyLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceVoucherFamilyLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["code"] = this.code;
        data["fileNumber"] = this.fileNumber;
        data["connectorRef"] = this.connectorRef;
        return data; 
    }
}

export interface IServiceVoucherFamilyLookupTableDto {
    id: number;
    displayName: string | undefined;
    description: string | undefined;
    code: string | undefined;
    fileNumber: string | undefined;
    connectorRef: number | undefined;
}

export class PagedResultDtoOfServiceVoucherFamilyLookupTableDto implements IPagedResultDtoOfServiceVoucherFamilyLookupTableDto {
    totalCount!: number;
    items!: ServiceVoucherFamilyLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfServiceVoucherFamilyLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(ServiceVoucherFamilyLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfServiceVoucherFamilyLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfServiceVoucherFamilyLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfServiceVoucherFamilyLookupTableDto {
    totalCount: number;
    items: ServiceVoucherFamilyLookupTableDto[] | undefined;
}

export class ServiceVoucherPersonInquiryLookupTableDto implements IServiceVoucherPersonInquiryLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    entity!: Entities;
    entityRef!: string | undefined;

    constructor(data?: IServiceVoucherPersonInquiryLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.entity = data["entity"];
            this.entityRef = data["entityRef"];
        }
    }

    static fromJS(data: any): ServiceVoucherPersonInquiryLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceVoucherPersonInquiryLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["entity"] = this.entity;
        data["entityRef"] = this.entityRef;
        return data; 
    }
}

export interface IServiceVoucherPersonInquiryLookupTableDto {
    id: number;
    displayName: string | undefined;
    entity: Entities;
    entityRef: string | undefined;
}

export class PagedResultDtoOfServiceVoucherPersonInquiryLookupTableDto implements IPagedResultDtoOfServiceVoucherPersonInquiryLookupTableDto {
    totalCount!: number;
    items!: ServiceVoucherPersonInquiryLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfServiceVoucherPersonInquiryLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(ServiceVoucherPersonInquiryLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfServiceVoucherPersonInquiryLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfServiceVoucherPersonInquiryLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfServiceVoucherPersonInquiryLookupTableDto {
    totalCount: number;
    items: ServiceVoucherPersonInquiryLookupTableDto[] | undefined;
}

export class AutomaticCheckServiceVoucherDto implements IAutomaticCheckServiceVoucherDto {
    entity!: Entities;
    entityRef!: number;
    familyName!: string | undefined;
    clientName!: string | undefined;
    startDate!: moment.Moment;
    endDate!: moment.Moment;
    status!: PlanBillStatus;
    maxCashValue!: number | undefined;
    cartCode!: string | undefined;
    servicesDescription!: string | undefined;
    relevantUnitDescription!: string | undefined;
    requestCode!: string | undefined;
    managementDescription!: string | undefined;
    isRequestedFromClient!: boolean;
    serviceRef!: number;
    serviceTitle!: string | undefined;
    branchRef!: number | undefined;
    branchName!: string | undefined;
    check!: boolean;

    constructor(data?: IAutomaticCheckServiceVoucherDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entity = data["entity"];
            this.entityRef = data["entityRef"];
            this.familyName = data["familyName"];
            this.clientName = data["clientName"];
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.status = data["status"];
            this.maxCashValue = data["maxCashValue"];
            this.cartCode = data["cartCode"];
            this.servicesDescription = data["servicesDescription"];
            this.relevantUnitDescription = data["relevantUnitDescription"];
            this.requestCode = data["requestCode"];
            this.managementDescription = data["managementDescription"];
            this.isRequestedFromClient = data["isRequestedFromClient"];
            this.serviceRef = data["serviceRef"];
            this.serviceTitle = data["serviceTitle"];
            this.branchRef = data["branchRef"];
            this.branchName = data["branchName"];
            this.check = data["check"];
        }
    }

    static fromJS(data: any): AutomaticCheckServiceVoucherDto {
        data = typeof data === 'object' ? data : {};
        let result = new AutomaticCheckServiceVoucherDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entity"] = this.entity;
        data["entityRef"] = this.entityRef;
        data["familyName"] = this.familyName;
        data["clientName"] = this.clientName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["maxCashValue"] = this.maxCashValue;
        data["cartCode"] = this.cartCode;
        data["servicesDescription"] = this.servicesDescription;
        data["relevantUnitDescription"] = this.relevantUnitDescription;
        data["requestCode"] = this.requestCode;
        data["managementDescription"] = this.managementDescription;
        data["isRequestedFromClient"] = this.isRequestedFromClient;
        data["serviceRef"] = this.serviceRef;
        data["serviceTitle"] = this.serviceTitle;
        data["branchRef"] = this.branchRef;
        data["branchName"] = this.branchName;
        data["check"] = this.check;
        return data; 
    }
}

export interface IAutomaticCheckServiceVoucherDto {
    entity: Entities;
    entityRef: number;
    familyName: string | undefined;
    clientName: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    status: PlanBillStatus;
    maxCashValue: number | undefined;
    cartCode: string | undefined;
    servicesDescription: string | undefined;
    relevantUnitDescription: string | undefined;
    requestCode: string | undefined;
    managementDescription: string | undefined;
    isRequestedFromClient: boolean;
    serviceRef: number;
    serviceTitle: string | undefined;
    branchRef: number | undefined;
    branchName: string | undefined;
    check: boolean;
}

export class PagedResultDtoOfAutomaticCheckServiceVoucherDto implements IPagedResultDtoOfAutomaticCheckServiceVoucherDto {
    totalCount!: number;
    items!: AutomaticCheckServiceVoucherDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAutomaticCheckServiceVoucherDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(AutomaticCheckServiceVoucherDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAutomaticCheckServiceVoucherDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAutomaticCheckServiceVoucherDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfAutomaticCheckServiceVoucherDto {
    totalCount: number;
    items: AutomaticCheckServiceVoucherDto[] | undefined;
}

export class GetAutomaticCheckServiceViewDto implements IGetAutomaticCheckServiceViewDto {
    timeSpanKey!: string | undefined;
    serviceVouchers!: PagedResultDtoOfAutomaticCheckServiceVoucherDto;

    constructor(data?: IGetAutomaticCheckServiceViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.timeSpanKey = data["timeSpanKey"];
            this.serviceVouchers = data["serviceVouchers"] ? PagedResultDtoOfAutomaticCheckServiceVoucherDto.fromJS(data["serviceVouchers"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAutomaticCheckServiceViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAutomaticCheckServiceViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeSpanKey"] = this.timeSpanKey;
        data["serviceVouchers"] = this.serviceVouchers ? this.serviceVouchers.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetAutomaticCheckServiceViewDto {
    timeSpanKey: string | undefined;
    serviceVouchers: PagedResultDtoOfAutomaticCheckServiceVoucherDto;
}

export class CreateRegulateAndServiceVouchersInputDto implements ICreateRegulateAndServiceVouchersInputDto {
    timeSpanKey!: string | undefined;
    serviceVouchers!: AutomaticCheckServiceVoucherDto[] | undefined;

    constructor(data?: ICreateRegulateAndServiceVouchersInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.timeSpanKey = data["timeSpanKey"];
            if (Array.isArray(data["serviceVouchers"])) {
                this.serviceVouchers = [] as any;
                for (let item of data["serviceVouchers"])
                    this.serviceVouchers!.push(AutomaticCheckServiceVoucherDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateRegulateAndServiceVouchersInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRegulateAndServiceVouchersInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeSpanKey"] = this.timeSpanKey;
        if (Array.isArray(this.serviceVouchers)) {
            data["serviceVouchers"] = [];
            for (let item of this.serviceVouchers)
                data["serviceVouchers"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateRegulateAndServiceVouchersInputDto {
    timeSpanKey: string | undefined;
    serviceVouchers: AutomaticCheckServiceVoucherDto[] | undefined;
}

export class GetFamilyServiceVoucherReportDto implements IGetFamilyServiceVoucherReportDto {
    serviceVoucher!: ServiceVoucherDto;
    serviceTitle!: string | undefined;
    branchName!: string | undefined;
    planBillCode!: string | undefined;
    approverPhoneNumber!: string | undefined;
    seconderPhoneNumber!: string | undefined;
    regulatorPhoneNumber!: string | undefined;
    familyName!: string | undefined;

    constructor(data?: IGetFamilyServiceVoucherReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serviceVoucher = data["serviceVoucher"] ? ServiceVoucherDto.fromJS(data["serviceVoucher"]) : <any>undefined;
            this.serviceTitle = data["serviceTitle"];
            this.branchName = data["branchName"];
            this.planBillCode = data["planBillCode"];
            this.approverPhoneNumber = data["approverPhoneNumber"];
            this.seconderPhoneNumber = data["seconderPhoneNumber"];
            this.regulatorPhoneNumber = data["regulatorPhoneNumber"];
            this.familyName = data["familyName"];
        }
    }

    static fromJS(data: any): GetFamilyServiceVoucherReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFamilyServiceVoucherReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceVoucher"] = this.serviceVoucher ? this.serviceVoucher.toJSON() : <any>undefined;
        data["serviceTitle"] = this.serviceTitle;
        data["branchName"] = this.branchName;
        data["planBillCode"] = this.planBillCode;
        data["approverPhoneNumber"] = this.approverPhoneNumber;
        data["seconderPhoneNumber"] = this.seconderPhoneNumber;
        data["regulatorPhoneNumber"] = this.regulatorPhoneNumber;
        data["familyName"] = this.familyName;
        return data; 
    }
}

export interface IGetFamilyServiceVoucherReportDto {
    serviceVoucher: ServiceVoucherDto;
    serviceTitle: string | undefined;
    branchName: string | undefined;
    planBillCode: string | undefined;
    approverPhoneNumber: string | undefined;
    seconderPhoneNumber: string | undefined;
    regulatorPhoneNumber: string | undefined;
    familyName: string | undefined;
}

export class PagedResultDtoOfGetFamilyServiceVoucherReportDto implements IPagedResultDtoOfGetFamilyServiceVoucherReportDto {
    totalCount!: number;
    items!: GetFamilyServiceVoucherReportDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetFamilyServiceVoucherReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetFamilyServiceVoucherReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetFamilyServiceVoucherReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetFamilyServiceVoucherReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetFamilyServiceVoucherReportDto {
    totalCount: number;
    items: GetFamilyServiceVoucherReportDto[] | undefined;
}

export class GetClientCreditServiceDto implements IGetClientCreditServiceDto {
    remainCredit!: number | undefined;

    constructor(data?: IGetClientCreditServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.remainCredit = data["remainCredit"];
        }
    }

    static fromJS(data: any): GetClientCreditServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetClientCreditServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["remainCredit"] = this.remainCredit;
        return data; 
    }
}

export interface IGetClientCreditServiceDto {
    remainCredit: number | undefined;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    profilePictureId!: string | undefined;
    id!: number;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.profilePictureId = data["profilePictureId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    id: number;
}

export enum SubscriptionPaymentType {
    Manual = 0,
    RecurringAutomatic = 1,
    RecurringManual = 2,
}

export class EditionInfoDto implements IEditionInfoDto {
    displayName!: string | undefined;
    trialDayCount!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    isHighestEdition!: boolean;
    isFree!: boolean;
    id!: number;

    constructor(data?: IEditionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.displayName = data["displayName"];
            this.trialDayCount = data["trialDayCount"];
            this.monthlyPrice = data["monthlyPrice"];
            this.annualPrice = data["annualPrice"];
            this.isHighestEdition = data["isHighestEdition"];
            this.isFree = data["isFree"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EditionInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["trialDayCount"] = this.trialDayCount;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["isHighestEdition"] = this.isHighestEdition;
        data["isFree"] = this.isFree;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEditionInfoDto {
    displayName: string | undefined;
    trialDayCount: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    isHighestEdition: boolean;
    isFree: boolean;
    id: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    tenancyName!: string | undefined;
    name!: string | undefined;
    logoId!: string | undefined;
    logoFileType!: string | undefined;
    customCssId!: string | undefined;
    subscriptionEndDateUtc!: moment.Moment | undefined;
    isInTrialPeriod!: boolean;
    subscriptionPaymentType!: SubscriptionPaymentType;
    edition!: EditionInfoDto;
    creationTime!: moment.Moment;
    paymentPeriodType!: PaymentPeriodType;
    subscriptionDateString!: string | undefined;
    creationTimeString!: string | undefined;
    id!: number;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.logoId = data["logoId"];
            this.logoFileType = data["logoFileType"];
            this.customCssId = data["customCssId"];
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = data["isInTrialPeriod"];
            this.subscriptionPaymentType = data["subscriptionPaymentType"];
            this.edition = data["edition"] ? EditionInfoDto.fromJS(data["edition"]) : <any>undefined;
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.paymentPeriodType = data["paymentPeriodType"];
            this.subscriptionDateString = data["subscriptionDateString"];
            this.creationTimeString = data["creationTimeString"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["logoId"] = this.logoId;
        data["logoFileType"] = this.logoFileType;
        data["customCssId"] = this.customCssId;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["subscriptionPaymentType"] = this.subscriptionPaymentType;
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["subscriptionDateString"] = this.subscriptionDateString;
        data["creationTimeString"] = this.creationTimeString;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenantLoginInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    logoId: string | undefined;
    logoFileType: string | undefined;
    customCssId: string | undefined;
    subscriptionEndDateUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean;
    subscriptionPaymentType: SubscriptionPaymentType;
    edition: EditionInfoDto;
    creationTime: moment.Moment;
    paymentPeriodType: PaymentPeriodType;
    subscriptionDateString: string | undefined;
    creationTimeString: string | undefined;
    id: number;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version!: string | undefined;
    releaseDate!: moment.Moment;
    currency!: string | undefined;
    currencySign!: string | undefined;
    allowTenantsToChangeEmailSettings!: boolean;
    features!: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.version = data["version"];
            this.releaseDate = data["releaseDate"] ? moment(data["releaseDate"].toString()) : <any>undefined;
            this.currency = data["currency"];
            this.currencySign = data["currencySign"];
            this.allowTenantsToChangeEmailSettings = data["allowTenantsToChangeEmailSettings"];
            if (data["features"]) {
                this.features = {} as any;
                for (let key in data["features"]) {
                    if (data["features"].hasOwnProperty(key))
                        this.features![key] = data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        data["currency"] = this.currency;
        data["currencySign"] = this.currencySign;
        data["allowTenantsToChangeEmailSettings"] = this.allowTenantsToChangeEmailSettings;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    data["features"][key] = this.features[key];
            }
        }
        return data; 
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    currency: string | undefined;
    currencySign: string | undefined;
    allowTenantsToChangeEmailSettings: boolean;
    features: { [key: string]: boolean; } | undefined;
}

export class ThemeLayoutSettingsDto implements IThemeLayoutSettingsDto {
    layoutType!: string | undefined;

    constructor(data?: IThemeLayoutSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.layoutType = data["layoutType"];
        }
    }

    static fromJS(data: any): ThemeLayoutSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeLayoutSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["layoutType"] = this.layoutType;
        return data; 
    }
}

export interface IThemeLayoutSettingsDto {
    layoutType: string | undefined;
}

export class ThemeHeaderSettingsDto implements IThemeHeaderSettingsDto {
    desktopFixedHeader!: boolean;
    mobileFixedHeader!: boolean;
    headerSkin!: string | undefined;
    minimizeDesktopHeaderType!: string | undefined;
    headerMenuArrows!: boolean;

    constructor(data?: IThemeHeaderSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.desktopFixedHeader = data["desktopFixedHeader"];
            this.mobileFixedHeader = data["mobileFixedHeader"];
            this.headerSkin = data["headerSkin"];
            this.minimizeDesktopHeaderType = data["minimizeDesktopHeaderType"];
            this.headerMenuArrows = data["headerMenuArrows"];
        }
    }

    static fromJS(data: any): ThemeHeaderSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeHeaderSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["desktopFixedHeader"] = this.desktopFixedHeader;
        data["mobileFixedHeader"] = this.mobileFixedHeader;
        data["headerSkin"] = this.headerSkin;
        data["minimizeDesktopHeaderType"] = this.minimizeDesktopHeaderType;
        data["headerMenuArrows"] = this.headerMenuArrows;
        return data; 
    }
}

export interface IThemeHeaderSettingsDto {
    desktopFixedHeader: boolean;
    mobileFixedHeader: boolean;
    headerSkin: string | undefined;
    minimizeDesktopHeaderType: string | undefined;
    headerMenuArrows: boolean;
}

export class ThemeSubHeaderSettingsDto implements IThemeSubHeaderSettingsDto {
    fixedSubHeader!: boolean;
    subheaderStyle!: string | undefined;

    constructor(data?: IThemeSubHeaderSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fixedSubHeader = data["fixedSubHeader"];
            this.subheaderStyle = data["subheaderStyle"];
        }
    }

    static fromJS(data: any): ThemeSubHeaderSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeSubHeaderSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fixedSubHeader"] = this.fixedSubHeader;
        data["subheaderStyle"] = this.subheaderStyle;
        return data; 
    }
}

export interface IThemeSubHeaderSettingsDto {
    fixedSubHeader: boolean;
    subheaderStyle: string | undefined;
}

export class ThemeMenuSettingsDto implements IThemeMenuSettingsDto {
    position!: string | undefined;
    asideSkin!: string | undefined;
    fixedAside!: boolean;
    allowAsideMinimizing!: boolean;
    defaultMinimizedAside!: boolean;
    submenuToggle!: string | undefined;
    searchActive!: boolean;

    constructor(data?: IThemeMenuSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.position = data["position"];
            this.asideSkin = data["asideSkin"];
            this.fixedAside = data["fixedAside"];
            this.allowAsideMinimizing = data["allowAsideMinimizing"];
            this.defaultMinimizedAside = data["defaultMinimizedAside"];
            this.submenuToggle = data["submenuToggle"];
            this.searchActive = data["searchActive"];
        }
    }

    static fromJS(data: any): ThemeMenuSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeMenuSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["position"] = this.position;
        data["asideSkin"] = this.asideSkin;
        data["fixedAside"] = this.fixedAside;
        data["allowAsideMinimizing"] = this.allowAsideMinimizing;
        data["defaultMinimizedAside"] = this.defaultMinimizedAside;
        data["submenuToggle"] = this.submenuToggle;
        data["searchActive"] = this.searchActive;
        return data; 
    }
}

export interface IThemeMenuSettingsDto {
    position: string | undefined;
    asideSkin: string | undefined;
    fixedAside: boolean;
    allowAsideMinimizing: boolean;
    defaultMinimizedAside: boolean;
    submenuToggle: string | undefined;
    searchActive: boolean;
}

export class ThemeFooterSettingsDto implements IThemeFooterSettingsDto {
    fixedFooter!: boolean;

    constructor(data?: IThemeFooterSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fixedFooter = data["fixedFooter"];
        }
    }

    static fromJS(data: any): ThemeFooterSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeFooterSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fixedFooter"] = this.fixedFooter;
        return data; 
    }
}

export interface IThemeFooterSettingsDto {
    fixedFooter: boolean;
}

export class ThemeSettingsDto implements IThemeSettingsDto {
    theme!: string | undefined;
    layout!: ThemeLayoutSettingsDto;
    header!: ThemeHeaderSettingsDto;
    subHeader!: ThemeSubHeaderSettingsDto;
    menu!: ThemeMenuSettingsDto;
    footer!: ThemeFooterSettingsDto;

    constructor(data?: IThemeSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.theme = data["theme"];
            this.layout = data["layout"] ? ThemeLayoutSettingsDto.fromJS(data["layout"]) : <any>undefined;
            this.header = data["header"] ? ThemeHeaderSettingsDto.fromJS(data["header"]) : <any>undefined;
            this.subHeader = data["subHeader"] ? ThemeSubHeaderSettingsDto.fromJS(data["subHeader"]) : <any>undefined;
            this.menu = data["menu"] ? ThemeMenuSettingsDto.fromJS(data["menu"]) : <any>undefined;
            this.footer = data["footer"] ? ThemeFooterSettingsDto.fromJS(data["footer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ThemeSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        data["layout"] = this.layout ? this.layout.toJSON() : <any>undefined;
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        data["subHeader"] = this.subHeader ? this.subHeader.toJSON() : <any>undefined;
        data["menu"] = this.menu ? this.menu.toJSON() : <any>undefined;
        data["footer"] = this.footer ? this.footer.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IThemeSettingsDto {
    theme: string | undefined;
    layout: ThemeLayoutSettingsDto;
    header: ThemeHeaderSettingsDto;
    subHeader: ThemeSubHeaderSettingsDto;
    menu: ThemeMenuSettingsDto;
    footer: ThemeFooterSettingsDto;
}

export class UiCustomizationSettingsDto implements IUiCustomizationSettingsDto {
    baseSettings!: ThemeSettingsDto;
    isLeftMenuUsed!: boolean;
    isTopMenuUsed!: boolean;
    isTabMenuUsed!: boolean;
    allowMenuScroll!: boolean;

    constructor(data?: IUiCustomizationSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.baseSettings = data["baseSettings"] ? ThemeSettingsDto.fromJS(data["baseSettings"]) : <any>undefined;
            this.isLeftMenuUsed = data["isLeftMenuUsed"];
            this.isTopMenuUsed = data["isTopMenuUsed"];
            this.isTabMenuUsed = data["isTabMenuUsed"];
            this.allowMenuScroll = data["allowMenuScroll"];
        }
    }

    static fromJS(data: any): UiCustomizationSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UiCustomizationSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseSettings"] = this.baseSettings ? this.baseSettings.toJSON() : <any>undefined;
        data["isLeftMenuUsed"] = this.isLeftMenuUsed;
        data["isTopMenuUsed"] = this.isTopMenuUsed;
        data["isTabMenuUsed"] = this.isTabMenuUsed;
        data["allowMenuScroll"] = this.allowMenuScroll;
        return data; 
    }
}

export interface IUiCustomizationSettingsDto {
    baseSettings: ThemeSettingsDto;
    isLeftMenuUsed: boolean;
    isTopMenuUsed: boolean;
    isTabMenuUsed: boolean;
    allowMenuScroll: boolean;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    user!: UserLoginInfoDto;
    tenant!: TenantLoginInfoDto;
    application!: ApplicationInfoDto;
    theme!: UiCustomizationSettingsDto;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.user = data["user"] ? UserLoginInfoDto.fromJS(data["user"]) : <any>undefined;
            this.tenant = data["tenant"] ? TenantLoginInfoDto.fromJS(data["tenant"]) : <any>undefined;
            this.application = data["application"] ? ApplicationInfoDto.fromJS(data["application"]) : <any>undefined;
            this.theme = data["theme"] ? UiCustomizationSettingsDto.fromJS(data["theme"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["theme"] = this.theme ? this.theme.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetCurrentLoginInformationsOutput {
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
    application: ApplicationInfoDto;
    theme: UiCustomizationSettingsDto;
}

export class UpdateUserSignInTokenOutput implements IUpdateUserSignInTokenOutput {
    signInToken!: string | undefined;
    encodedUserId!: string | undefined;
    encodedTenantId!: string | undefined;

    constructor(data?: IUpdateUserSignInTokenOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.signInToken = data["signInToken"];
            this.encodedUserId = data["encodedUserId"];
            this.encodedTenantId = data["encodedTenantId"];
        }
    }

    static fromJS(data: any): UpdateUserSignInTokenOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserSignInTokenOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signInToken"] = this.signInToken;
        data["encodedUserId"] = this.encodedUserId;
        data["encodedTenantId"] = this.encodedTenantId;
        return data; 
    }
}

export interface IUpdateUserSignInTokenOutput {
    signInToken: string | undefined;
    encodedUserId: string | undefined;
    encodedTenantId: string | undefined;
}

export class SlaughterAgentDto implements ISlaughterAgentDto {
    fromHour!: string | undefined;
    toHour!: string | undefined;
    status!: boolean;
    slaughterhouseName!: string | undefined;
    sacrificeTypes!: string | undefined;
    contactRef!: number | undefined;
    id!: number;

    constructor(data?: ISlaughterAgentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fromHour = data["fromHour"];
            this.toHour = data["toHour"];
            this.status = data["status"];
            this.slaughterhouseName = data["slaughterhouseName"];
            this.sacrificeTypes = data["sacrificeTypes"];
            this.contactRef = data["contactRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SlaughterAgentDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlaughterAgentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromHour"] = this.fromHour;
        data["toHour"] = this.toHour;
        data["status"] = this.status;
        data["slaughterhouseName"] = this.slaughterhouseName;
        data["sacrificeTypes"] = this.sacrificeTypes;
        data["contactRef"] = this.contactRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISlaughterAgentDto {
    fromHour: string | undefined;
    toHour: string | undefined;
    status: boolean;
    slaughterhouseName: string | undefined;
    sacrificeTypes: string | undefined;
    contactRef: number | undefined;
    id: number;
}

export class GetSlaughterAgentForViewDto implements IGetSlaughterAgentForViewDto {
    slaughterAgent!: SlaughterAgentDto;
    contactFirstName!: string | undefined;

    constructor(data?: IGetSlaughterAgentForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.slaughterAgent = data["slaughterAgent"] ? SlaughterAgentDto.fromJS(data["slaughterAgent"]) : <any>undefined;
            this.contactFirstName = data["contactFirstName"];
        }
    }

    static fromJS(data: any): GetSlaughterAgentForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSlaughterAgentForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["slaughterAgent"] = this.slaughterAgent ? this.slaughterAgent.toJSON() : <any>undefined;
        data["contactFirstName"] = this.contactFirstName;
        return data; 
    }
}

export interface IGetSlaughterAgentForViewDto {
    slaughterAgent: SlaughterAgentDto;
    contactFirstName: string | undefined;
}

export class PagedResultDtoOfGetSlaughterAgentForViewDto implements IPagedResultDtoOfGetSlaughterAgentForViewDto {
    totalCount!: number;
    items!: GetSlaughterAgentForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSlaughterAgentForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetSlaughterAgentForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSlaughterAgentForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSlaughterAgentForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetSlaughterAgentForViewDto {
    totalCount: number;
    items: GetSlaughterAgentForViewDto[] | undefined;
}

export class CreateOrEditSlaughterAgentDto implements ICreateOrEditSlaughterAgentDto {
    fromHour!: string | undefined;
    toHour!: string | undefined;
    status!: boolean;
    slaughterhouseName!: string | undefined;
    sacrificeTypes!: string | undefined;
    contactRef!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSlaughterAgentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fromHour = data["fromHour"];
            this.toHour = data["toHour"];
            this.status = data["status"];
            this.slaughterhouseName = data["slaughterhouseName"];
            this.sacrificeTypes = data["sacrificeTypes"];
            this.contactRef = data["contactRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSlaughterAgentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSlaughterAgentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromHour"] = this.fromHour;
        data["toHour"] = this.toHour;
        data["status"] = this.status;
        data["slaughterhouseName"] = this.slaughterhouseName;
        data["sacrificeTypes"] = this.sacrificeTypes;
        data["contactRef"] = this.contactRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditSlaughterAgentDto {
    fromHour: string | undefined;
    toHour: string | undefined;
    status: boolean;
    slaughterhouseName: string | undefined;
    sacrificeTypes: string | undefined;
    contactRef: number | undefined;
    id: number | undefined;
}

export class GetSlaughterAgentForEditOutput implements IGetSlaughterAgentForEditOutput {
    slaughterAgent!: CreateOrEditSlaughterAgentDto;
    contactFirstName!: string | undefined;

    constructor(data?: IGetSlaughterAgentForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.slaughterAgent = data["slaughterAgent"] ? CreateOrEditSlaughterAgentDto.fromJS(data["slaughterAgent"]) : <any>undefined;
            this.contactFirstName = data["contactFirstName"];
        }
    }

    static fromJS(data: any): GetSlaughterAgentForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSlaughterAgentForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["slaughterAgent"] = this.slaughterAgent ? this.slaughterAgent.toJSON() : <any>undefined;
        data["contactFirstName"] = this.contactFirstName;
        return data; 
    }
}

export interface IGetSlaughterAgentForEditOutput {
    slaughterAgent: CreateOrEditSlaughterAgentDto;
    contactFirstName: string | undefined;
}

export class SlaughterAgentContactLookupTableDto implements ISlaughterAgentContactLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISlaughterAgentContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): SlaughterAgentContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlaughterAgentContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ISlaughterAgentContactLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfSlaughterAgentContactLookupTableDto implements IPagedResultDtoOfSlaughterAgentContactLookupTableDto {
    totalCount!: number;
    items!: SlaughterAgentContactLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSlaughterAgentContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(SlaughterAgentContactLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSlaughterAgentContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSlaughterAgentContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfSlaughterAgentContactLookupTableDto {
    totalCount: number;
    items: SlaughterAgentContactLookupTableDto[] | undefined;
}

export class SlaughterAgentSacrificeTypesLookupTableDto implements ISlaughterAgentSacrificeTypesLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISlaughterAgentSacrificeTypesLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): SlaughterAgentSacrificeTypesLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlaughterAgentSacrificeTypesLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ISlaughterAgentSacrificeTypesLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class SlaughteredDto implements ISlaughteredDto {
    weight!: number | undefined;
    unitPrice!: number | undefined;
    ratio!: number | undefined;
    userRef!: number | undefined;
    billSlaughteredRef!: number | undefined;
    id!: number;

    constructor(data?: ISlaughteredDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.weight = data["weight"];
            this.unitPrice = data["unitPrice"];
            this.ratio = data["ratio"];
            this.userRef = data["userRef"];
            this.billSlaughteredRef = data["billSlaughteredRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SlaughteredDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlaughteredDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weight"] = this.weight;
        data["unitPrice"] = this.unitPrice;
        data["ratio"] = this.ratio;
        data["userRef"] = this.userRef;
        data["billSlaughteredRef"] = this.billSlaughteredRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISlaughteredDto {
    weight: number | undefined;
    unitPrice: number | undefined;
    ratio: number | undefined;
    userRef: number | undefined;
    billSlaughteredRef: number | undefined;
    id: number;
}

export class GetSlaughteredForViewDto implements IGetSlaughteredForViewDto {
    slaughtered!: SlaughteredDto;
    userFullName!: string | undefined;
    billSlaughteredCode!: string | undefined;

    constructor(data?: IGetSlaughteredForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.slaughtered = data["slaughtered"] ? SlaughteredDto.fromJS(data["slaughtered"]) : <any>undefined;
            this.userFullName = data["userFullName"];
            this.billSlaughteredCode = data["billSlaughteredCode"];
        }
    }

    static fromJS(data: any): GetSlaughteredForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSlaughteredForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["slaughtered"] = this.slaughtered ? this.slaughtered.toJSON() : <any>undefined;
        data["userFullName"] = this.userFullName;
        data["billSlaughteredCode"] = this.billSlaughteredCode;
        return data; 
    }
}

export interface IGetSlaughteredForViewDto {
    slaughtered: SlaughteredDto;
    userFullName: string | undefined;
    billSlaughteredCode: string | undefined;
}

export class PagedResultDtoOfGetSlaughteredForViewDto implements IPagedResultDtoOfGetSlaughteredForViewDto {
    totalCount!: number;
    items!: GetSlaughteredForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSlaughteredForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetSlaughteredForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSlaughteredForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSlaughteredForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetSlaughteredForViewDto {
    totalCount: number;
    items: GetSlaughteredForViewDto[] | undefined;
}

export class CreateOrEditSlaughteredDto implements ICreateOrEditSlaughteredDto {
    weight!: number | undefined;
    unitPrice!: number | undefined;
    ratio!: number | undefined;
    userRef!: number | undefined;
    billSlaughteredRef!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSlaughteredDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.weight = data["weight"];
            this.unitPrice = data["unitPrice"];
            this.ratio = data["ratio"];
            this.userRef = data["userRef"];
            this.billSlaughteredRef = data["billSlaughteredRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSlaughteredDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSlaughteredDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weight"] = this.weight;
        data["unitPrice"] = this.unitPrice;
        data["ratio"] = this.ratio;
        data["userRef"] = this.userRef;
        data["billSlaughteredRef"] = this.billSlaughteredRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditSlaughteredDto {
    weight: number | undefined;
    unitPrice: number | undefined;
    ratio: number | undefined;
    userRef: number | undefined;
    billSlaughteredRef: number | undefined;
    id: number | undefined;
}

export class GetSlaughteredForEditOutput implements IGetSlaughteredForEditOutput {
    slaughtered!: CreateOrEditSlaughteredDto;
    userFullName!: string | undefined;
    billSlaughteredCode!: string | undefined;

    constructor(data?: IGetSlaughteredForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.slaughtered = data["slaughtered"] ? CreateOrEditSlaughteredDto.fromJS(data["slaughtered"]) : <any>undefined;
            this.userFullName = data["userFullName"];
            this.billSlaughteredCode = data["billSlaughteredCode"];
        }
    }

    static fromJS(data: any): GetSlaughteredForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSlaughteredForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["slaughtered"] = this.slaughtered ? this.slaughtered.toJSON() : <any>undefined;
        data["userFullName"] = this.userFullName;
        data["billSlaughteredCode"] = this.billSlaughteredCode;
        return data; 
    }
}

export interface IGetSlaughteredForEditOutput {
    slaughtered: CreateOrEditSlaughteredDto;
    userFullName: string | undefined;
    billSlaughteredCode: string | undefined;
}

export class SlaughteredContactLookupTableDto implements ISlaughteredContactLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISlaughteredContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): SlaughteredContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlaughteredContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ISlaughteredContactLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfSlaughteredContactLookupTableDto implements IPagedResultDtoOfSlaughteredContactLookupTableDto {
    totalCount!: number;
    items!: SlaughteredContactLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSlaughteredContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(SlaughteredContactLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSlaughteredContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSlaughteredContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfSlaughteredContactLookupTableDto {
    totalCount: number;
    items: SlaughteredContactLookupTableDto[] | undefined;
}

export class SlaughteredUserLookupTableDto implements ISlaughteredUserLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISlaughteredUserLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): SlaughteredUserLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlaughteredUserLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ISlaughteredUserLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfSlaughteredUserLookupTableDto implements IPagedResultDtoOfSlaughteredUserLookupTableDto {
    totalCount!: number;
    items!: SlaughteredUserLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSlaughteredUserLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(SlaughteredUserLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSlaughteredUserLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSlaughteredUserLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfSlaughteredUserLookupTableDto {
    totalCount: number;
    items: SlaughteredUserLookupTableDto[] | undefined;
}

export class SlaughteredBillSlaughteredLookupTableDto implements ISlaughteredBillSlaughteredLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ISlaughteredBillSlaughteredLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): SlaughteredBillSlaughteredLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlaughteredBillSlaughteredLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ISlaughteredBillSlaughteredLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfSlaughteredBillSlaughteredLookupTableDto implements IPagedResultDtoOfSlaughteredBillSlaughteredLookupTableDto {
    totalCount!: number;
    items!: SlaughteredBillSlaughteredLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSlaughteredBillSlaughteredLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(SlaughteredBillSlaughteredLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSlaughteredBillSlaughteredLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSlaughteredBillSlaughteredLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfSlaughteredBillSlaughteredLookupTableDto {
    totalCount: number;
    items: SlaughteredBillSlaughteredLookupTableDto[] | undefined;
}

export class SMSServiceConfigDto implements ISMSServiceConfigDto {
    smsServices!: SMSServices;
    value!: string | undefined;
    isActive!: boolean;
    id!: number;

    constructor(data?: ISMSServiceConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.smsServices = data["smsServices"];
            this.value = data["value"];
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SMSServiceConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new SMSServiceConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["smsServices"] = this.smsServices;
        data["value"] = this.value;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISMSServiceConfigDto {
    smsServices: SMSServices;
    value: string | undefined;
    isActive: boolean;
    id: number;
}

export class GetSMSServiceConfigForViewDto implements IGetSMSServiceConfigForViewDto {
    smsServiceConfig!: SMSServiceConfigDto;

    constructor(data?: IGetSMSServiceConfigForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.smsServiceConfig = data["smsServiceConfig"] ? SMSServiceConfigDto.fromJS(data["smsServiceConfig"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSMSServiceConfigForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSMSServiceConfigForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["smsServiceConfig"] = this.smsServiceConfig ? this.smsServiceConfig.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetSMSServiceConfigForViewDto {
    smsServiceConfig: SMSServiceConfigDto;
}

export class PagedResultDtoOfGetSMSServiceConfigForViewDto implements IPagedResultDtoOfGetSMSServiceConfigForViewDto {
    totalCount!: number;
    items!: GetSMSServiceConfigForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSMSServiceConfigForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetSMSServiceConfigForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSMSServiceConfigForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSMSServiceConfigForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetSMSServiceConfigForViewDto {
    totalCount: number;
    items: GetSMSServiceConfigForViewDto[] | undefined;
}

export class CreateOrEditSMSServiceConfigDto implements ICreateOrEditSMSServiceConfigDto {
    smsServices!: SMSServices;
    value!: string | undefined;
    isActive!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSMSServiceConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.smsServices = data["smsServices"];
            this.value = data["value"];
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSMSServiceConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSMSServiceConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["smsServices"] = this.smsServices;
        data["value"] = this.value;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditSMSServiceConfigDto {
    smsServices: SMSServices;
    value: string | undefined;
    isActive: boolean;
    id: number | undefined;
}

export class GetSMSServiceConfigForEditOutput implements IGetSMSServiceConfigForEditOutput {
    smsServiceConfig!: CreateOrEditSMSServiceConfigDto;

    constructor(data?: IGetSMSServiceConfigForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.smsServiceConfig = data["smsServiceConfig"] ? CreateOrEditSMSServiceConfigDto.fromJS(data["smsServiceConfig"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSMSServiceConfigForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSMSServiceConfigForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["smsServiceConfig"] = this.smsServiceConfig ? this.smsServiceConfig.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetSMSServiceConfigForEditOutput {
    smsServiceConfig: CreateOrEditSMSServiceConfigDto;
}

export class SourceDto implements ISourceDto {
    name!: string | undefined;
    accountCode!: string | undefined;
    description!: string | undefined;
    state!: boolean | undefined;
    isDefault!: boolean;
    shortcutKey!: string | undefined;
    id!: number;

    constructor(data?: ISourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.accountCode = data["accountCode"];
            this.description = data["description"];
            this.state = data["state"];
            this.isDefault = data["isDefault"];
            this.shortcutKey = data["shortcutKey"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new SourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["accountCode"] = this.accountCode;
        data["description"] = this.description;
        data["state"] = this.state;
        data["isDefault"] = this.isDefault;
        data["shortcutKey"] = this.shortcutKey;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISourceDto {
    name: string | undefined;
    accountCode: string | undefined;
    description: string | undefined;
    state: boolean | undefined;
    isDefault: boolean;
    shortcutKey: string | undefined;
    id: number;
}

export class GetSourceForViewDto implements IGetSourceForViewDto {
    source!: SourceDto;

    constructor(data?: IGetSourceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.source = data["source"] ? SourceDto.fromJS(data["source"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSourceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSourceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source ? this.source.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetSourceForViewDto {
    source: SourceDto;
}

export class PagedResultDtoOfGetSourceForViewDto implements IPagedResultDtoOfGetSourceForViewDto {
    totalCount!: number;
    items!: GetSourceForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSourceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetSourceForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSourceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSourceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetSourceForViewDto {
    totalCount: number;
    items: GetSourceForViewDto[] | undefined;
}

export class CreateOrEditSourceDto implements ICreateOrEditSourceDto {
    name!: string | undefined;
    accountCode!: string | undefined;
    description!: string | undefined;
    state!: boolean;
    isDefault!: boolean;
    shortcutKey!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.accountCode = data["accountCode"];
            this.description = data["description"];
            this.state = data["state"];
            this.isDefault = data["isDefault"];
            this.shortcutKey = data["shortcutKey"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["accountCode"] = this.accountCode;
        data["description"] = this.description;
        data["state"] = this.state;
        data["isDefault"] = this.isDefault;
        data["shortcutKey"] = this.shortcutKey;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditSourceDto {
    name: string | undefined;
    accountCode: string | undefined;
    description: string | undefined;
    state: boolean;
    isDefault: boolean;
    shortcutKey: string | undefined;
    id: number | undefined;
}

export class GetSourceForEditOutput implements IGetSourceForEditOutput {
    source!: CreateOrEditSourceDto;
    tags!: CreateOrEditTagDto[] | undefined;

    constructor(data?: IGetSourceForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.source = data["source"] ? CreateOrEditSourceDto.fromJS(data["source"]) : <any>undefined;
            if (Array.isArray(data["tags"])) {
                this.tags = [] as any;
                for (let item of data["tags"])
                    this.tags!.push(CreateOrEditTagDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSourceForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSourceForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source ? this.source.toJSON() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetSourceForEditOutput {
    source: CreateOrEditSourceDto;
    tags: CreateOrEditTagDto[] | undefined;
}

export class CreateOrEditSourceAndTagsDto implements ICreateOrEditSourceAndTagsDto {
    source!: CreateOrEditSourceDto;
    tags!: CreateOrEditTagDto[] | undefined;
    attributes!: CreateOrEditAttributeDto[] | undefined;

    constructor(data?: ICreateOrEditSourceAndTagsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.source = data["source"] ? CreateOrEditSourceDto.fromJS(data["source"]) : <any>undefined;
            if (Array.isArray(data["tags"])) {
                this.tags = [] as any;
                for (let item of data["tags"])
                    this.tags!.push(CreateOrEditTagDto.fromJS(item));
            }
            if (Array.isArray(data["attributes"])) {
                this.attributes = [] as any;
                for (let item of data["attributes"])
                    this.attributes!.push(CreateOrEditAttributeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrEditSourceAndTagsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSourceAndTagsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source ? this.source.toJSON() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        if (Array.isArray(this.attributes)) {
            data["attributes"] = [];
            for (let item of this.attributes)
                data["attributes"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateOrEditSourceAndTagsDto {
    source: CreateOrEditSourceDto;
    tags: CreateOrEditTagDto[] | undefined;
    attributes: CreateOrEditAttributeDto[] | undefined;
}

export class StateDto implements IStateDto {
    name!: string | undefined;
    isActive!: boolean | undefined;
    description!: string | undefined;
    countryId!: number;
    id!: number;

    constructor(data?: IStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.isActive = data["isActive"];
            this.description = data["description"];
            this.countryId = data["countryId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): StateDto {
        data = typeof data === 'object' ? data : {};
        let result = new StateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["description"] = this.description;
        data["countryId"] = this.countryId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IStateDto {
    name: string | undefined;
    isActive: boolean | undefined;
    description: string | undefined;
    countryId: number;
    id: number;
}

export class GetStateForViewDto implements IGetStateForViewDto {
    state!: StateDto;
    countryName!: string | undefined;

    constructor(data?: IGetStateForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.state = data["state"] ? StateDto.fromJS(data["state"]) : <any>undefined;
            this.countryName = data["countryName"];
        }
    }

    static fromJS(data: any): GetStateForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetStateForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state ? this.state.toJSON() : <any>undefined;
        data["countryName"] = this.countryName;
        return data; 
    }
}

export interface IGetStateForViewDto {
    state: StateDto;
    countryName: string | undefined;
}

export class PagedResultDtoOfGetStateForViewDto implements IPagedResultDtoOfGetStateForViewDto {
    totalCount!: number;
    items!: GetStateForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetStateForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetStateForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetStateForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetStateForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetStateForViewDto {
    totalCount: number;
    items: GetStateForViewDto[] | undefined;
}

export class CreateOrEditStateDto implements ICreateOrEditStateDto {
    name!: string | undefined;
    isActive!: boolean | undefined;
    description!: string | undefined;
    countryId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.isActive = data["isActive"];
            this.description = data["description"];
            this.countryId = data["countryId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditStateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["description"] = this.description;
        data["countryId"] = this.countryId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditStateDto {
    name: string | undefined;
    isActive: boolean | undefined;
    description: string | undefined;
    countryId: number;
    id: number | undefined;
}

export class GetStateForEditOutput implements IGetStateForEditOutput {
    state!: CreateOrEditStateDto;
    countryName!: string | undefined;

    constructor(data?: IGetStateForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.state = data["state"] ? CreateOrEditStateDto.fromJS(data["state"]) : <any>undefined;
            this.countryName = data["countryName"];
        }
    }

    static fromJS(data: any): GetStateForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetStateForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state ? this.state.toJSON() : <any>undefined;
        data["countryName"] = this.countryName;
        return data; 
    }
}

export interface IGetStateForEditOutput {
    state: CreateOrEditStateDto;
    countryName: string | undefined;
}

export class StateCountryLookupTableDto implements IStateCountryLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IStateCountryLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): StateCountryLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new StateCountryLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IStateCountryLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class StockHandlingDetailDto implements IStockHandlingDetailDto {
    number!: number | undefined;
    realNumber!: number | undefined;
    stockHandlingRef!: number;
    commodityRef!: number;
    id!: number;

    constructor(data?: IStockHandlingDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.number = data["number"];
            this.realNumber = data["realNumber"];
            this.stockHandlingRef = data["stockHandlingRef"];
            this.commodityRef = data["commodityRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): StockHandlingDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockHandlingDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["realNumber"] = this.realNumber;
        data["stockHandlingRef"] = this.stockHandlingRef;
        data["commodityRef"] = this.commodityRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface IStockHandlingDetailDto {
    number: number | undefined;
    realNumber: number | undefined;
    stockHandlingRef: number;
    commodityRef: number;
    id: number;
}

export class GetStockHandlingDetailForViewDto implements IGetStockHandlingDetailForViewDto {
    stockHandlingDetail!: StockHandlingDetailDto;
    stockHandlingTitle!: string | undefined;
    commodityTitle!: string | undefined;

    constructor(data?: IGetStockHandlingDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.stockHandlingDetail = data["stockHandlingDetail"] ? StockHandlingDetailDto.fromJS(data["stockHandlingDetail"]) : <any>undefined;
            this.stockHandlingTitle = data["stockHandlingTitle"];
            this.commodityTitle = data["commodityTitle"];
        }
    }

    static fromJS(data: any): GetStockHandlingDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetStockHandlingDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stockHandlingDetail"] = this.stockHandlingDetail ? this.stockHandlingDetail.toJSON() : <any>undefined;
        data["stockHandlingTitle"] = this.stockHandlingTitle;
        data["commodityTitle"] = this.commodityTitle;
        return data; 
    }
}

export interface IGetStockHandlingDetailForViewDto {
    stockHandlingDetail: StockHandlingDetailDto;
    stockHandlingTitle: string | undefined;
    commodityTitle: string | undefined;
}

export class PagedResultDtoOfGetStockHandlingDetailForViewDto implements IPagedResultDtoOfGetStockHandlingDetailForViewDto {
    totalCount!: number;
    items!: GetStockHandlingDetailForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetStockHandlingDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetStockHandlingDetailForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetStockHandlingDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetStockHandlingDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetStockHandlingDetailForViewDto {
    totalCount: number;
    items: GetStockHandlingDetailForViewDto[] | undefined;
}

export class CreateOrEditStockHandlingDetailDto implements ICreateOrEditStockHandlingDetailDto {
    number!: number | undefined;
    realNumber!: number | undefined;
    stockHandlingRef!: number;
    commodityRef!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditStockHandlingDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.number = data["number"];
            this.realNumber = data["realNumber"];
            this.stockHandlingRef = data["stockHandlingRef"];
            this.commodityRef = data["commodityRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditStockHandlingDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditStockHandlingDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["realNumber"] = this.realNumber;
        data["stockHandlingRef"] = this.stockHandlingRef;
        data["commodityRef"] = this.commodityRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditStockHandlingDetailDto {
    number: number | undefined;
    realNumber: number | undefined;
    stockHandlingRef: number;
    commodityRef: number;
    id: number | undefined;
}

export class GetStockHandlingDetailForEditOutput implements IGetStockHandlingDetailForEditOutput {
    stockHandlingDetail!: CreateOrEditStockHandlingDetailDto;
    stockHandlingTitle!: string | undefined;
    commodityTitle!: string | undefined;

    constructor(data?: IGetStockHandlingDetailForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.stockHandlingDetail = data["stockHandlingDetail"] ? CreateOrEditStockHandlingDetailDto.fromJS(data["stockHandlingDetail"]) : <any>undefined;
            this.stockHandlingTitle = data["stockHandlingTitle"];
            this.commodityTitle = data["commodityTitle"];
        }
    }

    static fromJS(data: any): GetStockHandlingDetailForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetStockHandlingDetailForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stockHandlingDetail"] = this.stockHandlingDetail ? this.stockHandlingDetail.toJSON() : <any>undefined;
        data["stockHandlingTitle"] = this.stockHandlingTitle;
        data["commodityTitle"] = this.commodityTitle;
        return data; 
    }
}

export interface IGetStockHandlingDetailForEditOutput {
    stockHandlingDetail: CreateOrEditStockHandlingDetailDto;
    stockHandlingTitle: string | undefined;
    commodityTitle: string | undefined;
}

export class StockHandlingDetailStockHandlingLookupTableDto implements IStockHandlingDetailStockHandlingLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IStockHandlingDetailStockHandlingLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): StockHandlingDetailStockHandlingLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockHandlingDetailStockHandlingLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IStockHandlingDetailStockHandlingLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfStockHandlingDetailStockHandlingLookupTableDto implements IPagedResultDtoOfStockHandlingDetailStockHandlingLookupTableDto {
    totalCount!: number;
    items!: StockHandlingDetailStockHandlingLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfStockHandlingDetailStockHandlingLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(StockHandlingDetailStockHandlingLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfStockHandlingDetailStockHandlingLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfStockHandlingDetailStockHandlingLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfStockHandlingDetailStockHandlingLookupTableDto {
    totalCount: number;
    items: StockHandlingDetailStockHandlingLookupTableDto[] | undefined;
}

export class StockHandlingDetailCommodityLookupTableDto implements IStockHandlingDetailCommodityLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IStockHandlingDetailCommodityLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): StockHandlingDetailCommodityLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockHandlingDetailCommodityLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IStockHandlingDetailCommodityLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfStockHandlingDetailCommodityLookupTableDto implements IPagedResultDtoOfStockHandlingDetailCommodityLookupTableDto {
    totalCount!: number;
    items!: StockHandlingDetailCommodityLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfStockHandlingDetailCommodityLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(StockHandlingDetailCommodityLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfStockHandlingDetailCommodityLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfStockHandlingDetailCommodityLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfStockHandlingDetailCommodityLookupTableDto {
    totalCount: number;
    items: StockHandlingDetailCommodityLookupTableDto[] | undefined;
}

export enum StockHandlingStatus {
    Processing = 1,
    Ended = 2,
}

export class StockHandlingDto implements IStockHandlingDto {
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    status!: StockHandlingStatus;
    title!: string | undefined;
    contactRef!: number | undefined;
    financialYearRef!: number | undefined;
    id!: number;

    constructor(data?: IStockHandlingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.status = data["status"];
            this.title = data["title"];
            this.contactRef = data["contactRef"];
            this.financialYearRef = data["financialYearRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): StockHandlingDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockHandlingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["title"] = this.title;
        data["contactRef"] = this.contactRef;
        data["financialYearRef"] = this.financialYearRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface IStockHandlingDto {
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    status: StockHandlingStatus;
    title: string | undefined;
    contactRef: number | undefined;
    financialYearRef: number | undefined;
    id: number;
}

export class GetStockHandlingForViewDto implements IGetStockHandlingForViewDto {
    stockHandling!: StockHandlingDto;
    contactFirstName!: string | undefined;
    financialYearTitleCode!: string | undefined;

    constructor(data?: IGetStockHandlingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.stockHandling = data["stockHandling"] ? StockHandlingDto.fromJS(data["stockHandling"]) : <any>undefined;
            this.contactFirstName = data["contactFirstName"];
            this.financialYearTitleCode = data["financialYearTitleCode"];
        }
    }

    static fromJS(data: any): GetStockHandlingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetStockHandlingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stockHandling"] = this.stockHandling ? this.stockHandling.toJSON() : <any>undefined;
        data["contactFirstName"] = this.contactFirstName;
        data["financialYearTitleCode"] = this.financialYearTitleCode;
        return data; 
    }
}

export interface IGetStockHandlingForViewDto {
    stockHandling: StockHandlingDto;
    contactFirstName: string | undefined;
    financialYearTitleCode: string | undefined;
}

export class PagedResultDtoOfGetStockHandlingForViewDto implements IPagedResultDtoOfGetStockHandlingForViewDto {
    totalCount!: number;
    items!: GetStockHandlingForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetStockHandlingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetStockHandlingForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetStockHandlingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetStockHandlingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetStockHandlingForViewDto {
    totalCount: number;
    items: GetStockHandlingForViewDto[] | undefined;
}

export class CreateOrEditStockHandlingDto implements ICreateOrEditStockHandlingDto {
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    status!: StockHandlingStatus;
    title!: string | undefined;
    contactRef!: number | undefined;
    financialYearRef!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditStockHandlingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.status = data["status"];
            this.title = data["title"];
            this.contactRef = data["contactRef"];
            this.financialYearRef = data["financialYearRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditStockHandlingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditStockHandlingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["title"] = this.title;
        data["contactRef"] = this.contactRef;
        data["financialYearRef"] = this.financialYearRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditStockHandlingDto {
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    status: StockHandlingStatus;
    title: string | undefined;
    contactRef: number | undefined;
    financialYearRef: number | undefined;
    id: number | undefined;
}

export class GetStockHandlingForEditOutput implements IGetStockHandlingForEditOutput {
    stockHandling!: CreateOrEditStockHandlingDto;
    contactFirstName!: string | undefined;
    financialYearTitleCode!: string | undefined;

    constructor(data?: IGetStockHandlingForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.stockHandling = data["stockHandling"] ? CreateOrEditStockHandlingDto.fromJS(data["stockHandling"]) : <any>undefined;
            this.contactFirstName = data["contactFirstName"];
            this.financialYearTitleCode = data["financialYearTitleCode"];
        }
    }

    static fromJS(data: any): GetStockHandlingForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetStockHandlingForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stockHandling"] = this.stockHandling ? this.stockHandling.toJSON() : <any>undefined;
        data["contactFirstName"] = this.contactFirstName;
        data["financialYearTitleCode"] = this.financialYearTitleCode;
        return data; 
    }
}

export interface IGetStockHandlingForEditOutput {
    stockHandling: CreateOrEditStockHandlingDto;
    contactFirstName: string | undefined;
    financialYearTitleCode: string | undefined;
}

export class GetStockHandlingAndDetailsForEditOutput implements IGetStockHandlingAndDetailsForEditOutput {
    stockHandling!: GetStockHandlingForEditOutput;
    stockHandlingDetails!: PagedResultDtoOfGetStockHandlingDetailForViewDto;

    constructor(data?: IGetStockHandlingAndDetailsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.stockHandling = data["stockHandling"] ? GetStockHandlingForEditOutput.fromJS(data["stockHandling"]) : <any>undefined;
            this.stockHandlingDetails = data["stockHandlingDetails"] ? PagedResultDtoOfGetStockHandlingDetailForViewDto.fromJS(data["stockHandlingDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetStockHandlingAndDetailsForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetStockHandlingAndDetailsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stockHandling"] = this.stockHandling ? this.stockHandling.toJSON() : <any>undefined;
        data["stockHandlingDetails"] = this.stockHandlingDetails ? this.stockHandlingDetails.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetStockHandlingAndDetailsForEditOutput {
    stockHandling: GetStockHandlingForEditOutput;
    stockHandlingDetails: PagedResultDtoOfGetStockHandlingDetailForViewDto;
}

export class CreateOrEditStockHandlingAndDetailsDto implements ICreateOrEditStockHandlingAndDetailsDto {
    stockHandling!: CreateOrEditStockHandlingDto;
    stockHandlingDetails!: CreateOrEditStockHandlingDetailDto[] | undefined;

    constructor(data?: ICreateOrEditStockHandlingAndDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.stockHandling = data["stockHandling"] ? CreateOrEditStockHandlingDto.fromJS(data["stockHandling"]) : <any>undefined;
            if (Array.isArray(data["stockHandlingDetails"])) {
                this.stockHandlingDetails = [] as any;
                for (let item of data["stockHandlingDetails"])
                    this.stockHandlingDetails!.push(CreateOrEditStockHandlingDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrEditStockHandlingAndDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditStockHandlingAndDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stockHandling"] = this.stockHandling ? this.stockHandling.toJSON() : <any>undefined;
        if (Array.isArray(this.stockHandlingDetails)) {
            data["stockHandlingDetails"] = [];
            for (let item of this.stockHandlingDetails)
                data["stockHandlingDetails"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateOrEditStockHandlingAndDetailsDto {
    stockHandling: CreateOrEditStockHandlingDto;
    stockHandlingDetails: CreateOrEditStockHandlingDetailDto[] | undefined;
}

export class StockHandlingContactLookupTableDto implements IStockHandlingContactLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IStockHandlingContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): StockHandlingContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockHandlingContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IStockHandlingContactLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfStockHandlingContactLookupTableDto implements IPagedResultDtoOfStockHandlingContactLookupTableDto {
    totalCount!: number;
    items!: StockHandlingContactLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfStockHandlingContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(StockHandlingContactLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfStockHandlingContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfStockHandlingContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfStockHandlingContactLookupTableDto {
    totalCount: number;
    items: StockHandlingContactLookupTableDto[] | undefined;
}

export class StockHandlingFinancialYearLookupTableDto implements IStockHandlingFinancialYearLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IStockHandlingFinancialYearLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): StockHandlingFinancialYearLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockHandlingFinancialYearLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IStockHandlingFinancialYearLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class StockTransactionDto implements IStockTransactionDto {
    formCode!: string | undefined;
    formDate!: moment.Moment | undefined;
    identityCode!: string | undefined;
    fileCode!: string | undefined;
    description!: string | undefined;
    accountCode!: string | undefined;
    serviceType!: ServiceTypes;
    price!: number | undefined;
    code!: string | undefined;
    branchRef!: number;
    regulatorContactRef!: number | undefined;
    seconderContactRef!: number | undefined;
    approverContactRef!: number | undefined;
    contactRef!: number | undefined;
    transferBranchRef!: number | undefined;
    transactionTypeRef!: number;
    familyRef!: number | undefined;
    id!: number;

    constructor(data?: IStockTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.formCode = data["formCode"];
            this.formDate = data["formDate"] ? moment(data["formDate"].toString()) : <any>undefined;
            this.identityCode = data["identityCode"];
            this.fileCode = data["fileCode"];
            this.description = data["description"];
            this.accountCode = data["accountCode"];
            this.serviceType = data["serviceType"];
            this.price = data["price"];
            this.code = data["code"];
            this.branchRef = data["branchRef"];
            this.regulatorContactRef = data["regulatorContactRef"];
            this.seconderContactRef = data["seconderContactRef"];
            this.approverContactRef = data["approverContactRef"];
            this.contactRef = data["contactRef"];
            this.transferBranchRef = data["transferBranchRef"];
            this.transactionTypeRef = data["transactionTypeRef"];
            this.familyRef = data["familyRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): StockTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formCode"] = this.formCode;
        data["formDate"] = this.formDate ? this.formDate.toISOString() : <any>undefined;
        data["identityCode"] = this.identityCode;
        data["fileCode"] = this.fileCode;
        data["description"] = this.description;
        data["accountCode"] = this.accountCode;
        data["serviceType"] = this.serviceType;
        data["price"] = this.price;
        data["code"] = this.code;
        data["branchRef"] = this.branchRef;
        data["regulatorContactRef"] = this.regulatorContactRef;
        data["seconderContactRef"] = this.seconderContactRef;
        data["approverContactRef"] = this.approverContactRef;
        data["contactRef"] = this.contactRef;
        data["transferBranchRef"] = this.transferBranchRef;
        data["transactionTypeRef"] = this.transactionTypeRef;
        data["familyRef"] = this.familyRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface IStockTransactionDto {
    formCode: string | undefined;
    formDate: moment.Moment | undefined;
    identityCode: string | undefined;
    fileCode: string | undefined;
    description: string | undefined;
    accountCode: string | undefined;
    serviceType: ServiceTypes;
    price: number | undefined;
    code: string | undefined;
    branchRef: number;
    regulatorContactRef: number | undefined;
    seconderContactRef: number | undefined;
    approverContactRef: number | undefined;
    contactRef: number | undefined;
    transferBranchRef: number | undefined;
    transactionTypeRef: number;
    familyRef: number | undefined;
    id: number;
}

export class GetStockTransactionForViewDto implements IGetStockTransactionForViewDto {
    stockTransaction!: StockTransactionDto;
    branchName!: string | undefined;
    regulatorContactName!: string | undefined;
    seconderContacName!: string | undefined;
    approverContactName!: string | undefined;
    contactName!: string | undefined;
    transferBranchName!: string | undefined;
    transactionTypeTitle!: string | undefined;
    familyName!: string | undefined;

    constructor(data?: IGetStockTransactionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.stockTransaction = data["stockTransaction"] ? StockTransactionDto.fromJS(data["stockTransaction"]) : <any>undefined;
            this.branchName = data["branchName"];
            this.regulatorContactName = data["regulatorContactName"];
            this.seconderContacName = data["seconderContacName"];
            this.approverContactName = data["approverContactName"];
            this.contactName = data["contactName"];
            this.transferBranchName = data["transferBranchName"];
            this.transactionTypeTitle = data["transactionTypeTitle"];
            this.familyName = data["familyName"];
        }
    }

    static fromJS(data: any): GetStockTransactionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetStockTransactionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stockTransaction"] = this.stockTransaction ? this.stockTransaction.toJSON() : <any>undefined;
        data["branchName"] = this.branchName;
        data["regulatorContactName"] = this.regulatorContactName;
        data["seconderContacName"] = this.seconderContacName;
        data["approverContactName"] = this.approverContactName;
        data["contactName"] = this.contactName;
        data["transferBranchName"] = this.transferBranchName;
        data["transactionTypeTitle"] = this.transactionTypeTitle;
        data["familyName"] = this.familyName;
        return data; 
    }
}

export interface IGetStockTransactionForViewDto {
    stockTransaction: StockTransactionDto;
    branchName: string | undefined;
    regulatorContactName: string | undefined;
    seconderContacName: string | undefined;
    approverContactName: string | undefined;
    contactName: string | undefined;
    transferBranchName: string | undefined;
    transactionTypeTitle: string | undefined;
    familyName: string | undefined;
}

export class PagedResultDtoOfGetStockTransactionForViewDto implements IPagedResultDtoOfGetStockTransactionForViewDto {
    totalCount!: number;
    items!: GetStockTransactionForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetStockTransactionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetStockTransactionForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetStockTransactionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetStockTransactionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetStockTransactionForViewDto {
    totalCount: number;
    items: GetStockTransactionForViewDto[] | undefined;
}

export class CreateOrEditStockTransactionDto implements ICreateOrEditStockTransactionDto {
    formCode!: string | undefined;
    formDate!: moment.Moment | undefined;
    identityCode!: string | undefined;
    fileCode!: string | undefined;
    description!: string | undefined;
    accountCode!: string | undefined;
    code!: string | undefined;
    serviceType!: ServiceTypes;
    price!: number | undefined;
    branchRef!: number;
    regulatorContactRef!: number | undefined;
    seconderContactRef!: number | undefined;
    approverContactRef!: number | undefined;
    contactRef!: number | undefined;
    transferBranchRef!: number | undefined;
    transactionTypeRef!: number;
    familyRef!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditStockTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.formCode = data["formCode"];
            this.formDate = data["formDate"] ? moment(data["formDate"].toString()) : <any>undefined;
            this.identityCode = data["identityCode"];
            this.fileCode = data["fileCode"];
            this.description = data["description"];
            this.accountCode = data["accountCode"];
            this.code = data["code"];
            this.serviceType = data["serviceType"];
            this.price = data["price"];
            this.branchRef = data["branchRef"];
            this.regulatorContactRef = data["regulatorContactRef"];
            this.seconderContactRef = data["seconderContactRef"];
            this.approverContactRef = data["approverContactRef"];
            this.contactRef = data["contactRef"];
            this.transferBranchRef = data["transferBranchRef"];
            this.transactionTypeRef = data["transactionTypeRef"];
            this.familyRef = data["familyRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditStockTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditStockTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formCode"] = this.formCode;
        data["formDate"] = this.formDate ? this.formDate.toISOString() : <any>undefined;
        data["identityCode"] = this.identityCode;
        data["fileCode"] = this.fileCode;
        data["description"] = this.description;
        data["accountCode"] = this.accountCode;
        data["code"] = this.code;
        data["serviceType"] = this.serviceType;
        data["price"] = this.price;
        data["branchRef"] = this.branchRef;
        data["regulatorContactRef"] = this.regulatorContactRef;
        data["seconderContactRef"] = this.seconderContactRef;
        data["approverContactRef"] = this.approverContactRef;
        data["contactRef"] = this.contactRef;
        data["transferBranchRef"] = this.transferBranchRef;
        data["transactionTypeRef"] = this.transactionTypeRef;
        data["familyRef"] = this.familyRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditStockTransactionDto {
    formCode: string | undefined;
    formDate: moment.Moment | undefined;
    identityCode: string | undefined;
    fileCode: string | undefined;
    description: string | undefined;
    accountCode: string | undefined;
    code: string | undefined;
    serviceType: ServiceTypes;
    price: number | undefined;
    branchRef: number;
    regulatorContactRef: number | undefined;
    seconderContactRef: number | undefined;
    approverContactRef: number | undefined;
    contactRef: number | undefined;
    transferBranchRef: number | undefined;
    transactionTypeRef: number;
    familyRef: number | undefined;
    id: number | undefined;
}

export class GetStockTransactionForEditOutput implements IGetStockTransactionForEditOutput {
    stockTransaction!: CreateOrEditStockTransactionDto;
    branchName!: string | undefined;
    regulatorContactName!: string | undefined;
    seconderContacName!: string | undefined;
    approverContactName!: string | undefined;
    contactName!: string | undefined;
    transferBranchName!: string | undefined;
    transactionTypeTitle!: string | undefined;
    transactionTypeIsAffected!: boolean | undefined;
    familyName!: string | undefined;

    constructor(data?: IGetStockTransactionForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.stockTransaction = data["stockTransaction"] ? CreateOrEditStockTransactionDto.fromJS(data["stockTransaction"]) : <any>undefined;
            this.branchName = data["branchName"];
            this.regulatorContactName = data["regulatorContactName"];
            this.seconderContacName = data["seconderContacName"];
            this.approverContactName = data["approverContactName"];
            this.contactName = data["contactName"];
            this.transferBranchName = data["transferBranchName"];
            this.transactionTypeTitle = data["transactionTypeTitle"];
            this.transactionTypeIsAffected = data["transactionTypeIsAffected"];
            this.familyName = data["familyName"];
        }
    }

    static fromJS(data: any): GetStockTransactionForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetStockTransactionForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stockTransaction"] = this.stockTransaction ? this.stockTransaction.toJSON() : <any>undefined;
        data["branchName"] = this.branchName;
        data["regulatorContactName"] = this.regulatorContactName;
        data["seconderContacName"] = this.seconderContacName;
        data["approverContactName"] = this.approverContactName;
        data["contactName"] = this.contactName;
        data["transferBranchName"] = this.transferBranchName;
        data["transactionTypeTitle"] = this.transactionTypeTitle;
        data["transactionTypeIsAffected"] = this.transactionTypeIsAffected;
        data["familyName"] = this.familyName;
        return data; 
    }
}

export interface IGetStockTransactionForEditOutput {
    stockTransaction: CreateOrEditStockTransactionDto;
    branchName: string | undefined;
    regulatorContactName: string | undefined;
    seconderContacName: string | undefined;
    approverContactName: string | undefined;
    contactName: string | undefined;
    transferBranchName: string | undefined;
    transactionTypeTitle: string | undefined;
    transactionTypeIsAffected: boolean | undefined;
    familyName: string | undefined;
}

export class TransactionDetailDto implements ITransactionDetailDto {
    code!: string | undefined;
    unitPrice!: number | undefined;
    amount!: number | undefined;
    description!: string | undefined;
    isRationOrPayment!: boolean;
    stockTransactionRef!: number;
    commodityRef!: number;
    id!: number;

    constructor(data?: ITransactionDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.unitPrice = data["unitPrice"];
            this.amount = data["amount"];
            this.description = data["description"];
            this.isRationOrPayment = data["isRationOrPayment"];
            this.stockTransactionRef = data["stockTransactionRef"];
            this.commodityRef = data["commodityRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TransactionDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["unitPrice"] = this.unitPrice;
        data["amount"] = this.amount;
        data["description"] = this.description;
        data["isRationOrPayment"] = this.isRationOrPayment;
        data["stockTransactionRef"] = this.stockTransactionRef;
        data["commodityRef"] = this.commodityRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITransactionDetailDto {
    code: string | undefined;
    unitPrice: number | undefined;
    amount: number | undefined;
    description: string | undefined;
    isRationOrPayment: boolean;
    stockTransactionRef: number;
    commodityRef: number;
    id: number;
}

export class GetTransactionDetailForViewDto implements IGetTransactionDetailForViewDto {
    transactionDetail!: TransactionDetailDto;
    stockTransactionFormCode!: string | undefined;
    commodityTitle!: string | undefined;

    constructor(data?: IGetTransactionDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transactionDetail = data["transactionDetail"] ? TransactionDetailDto.fromJS(data["transactionDetail"]) : <any>undefined;
            this.stockTransactionFormCode = data["stockTransactionFormCode"];
            this.commodityTitle = data["commodityTitle"];
        }
    }

    static fromJS(data: any): GetTransactionDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionDetail"] = this.transactionDetail ? this.transactionDetail.toJSON() : <any>undefined;
        data["stockTransactionFormCode"] = this.stockTransactionFormCode;
        data["commodityTitle"] = this.commodityTitle;
        return data; 
    }
}

export interface IGetTransactionDetailForViewDto {
    transactionDetail: TransactionDetailDto;
    stockTransactionFormCode: string | undefined;
    commodityTitle: string | undefined;
}

export class PagedResultDtoOfGetTransactionDetailForViewDto implements IPagedResultDtoOfGetTransactionDetailForViewDto {
    totalCount!: number;
    items!: GetTransactionDetailForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTransactionDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetTransactionDetailForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTransactionDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTransactionDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetTransactionDetailForViewDto {
    totalCount: number;
    items: GetTransactionDetailForViewDto[] | undefined;
}

export class GetStockTransactionAndTransactionDetailsForEditOutput implements IGetStockTransactionAndTransactionDetailsForEditOutput {
    stockTransaction!: GetStockTransactionForEditOutput;
    transactionDetails!: PagedResultDtoOfGetTransactionDetailForViewDto;

    constructor(data?: IGetStockTransactionAndTransactionDetailsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.stockTransaction = data["stockTransaction"] ? GetStockTransactionForEditOutput.fromJS(data["stockTransaction"]) : <any>undefined;
            this.transactionDetails = data["transactionDetails"] ? PagedResultDtoOfGetTransactionDetailForViewDto.fromJS(data["transactionDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetStockTransactionAndTransactionDetailsForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetStockTransactionAndTransactionDetailsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stockTransaction"] = this.stockTransaction ? this.stockTransaction.toJSON() : <any>undefined;
        data["transactionDetails"] = this.transactionDetails ? this.transactionDetails.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetStockTransactionAndTransactionDetailsForEditOutput {
    stockTransaction: GetStockTransactionForEditOutput;
    transactionDetails: PagedResultDtoOfGetTransactionDetailForViewDto;
}

export class CreateOrEditTransactionDetailDto implements ICreateOrEditTransactionDetailDto {
    code!: string | undefined;
    unitPrice!: number | undefined;
    amount!: number | undefined;
    description!: string | undefined;
    isRationOrPayment!: boolean;
    stockTransactionRef!: number | undefined;
    commodityRef!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTransactionDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.unitPrice = data["unitPrice"];
            this.amount = data["amount"];
            this.description = data["description"];
            this.isRationOrPayment = data["isRationOrPayment"];
            this.stockTransactionRef = data["stockTransactionRef"];
            this.commodityRef = data["commodityRef"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTransactionDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTransactionDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["unitPrice"] = this.unitPrice;
        data["amount"] = this.amount;
        data["description"] = this.description;
        data["isRationOrPayment"] = this.isRationOrPayment;
        data["stockTransactionRef"] = this.stockTransactionRef;
        data["commodityRef"] = this.commodityRef;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditTransactionDetailDto {
    code: string | undefined;
    unitPrice: number | undefined;
    amount: number | undefined;
    description: string | undefined;
    isRationOrPayment: boolean;
    stockTransactionRef: number | undefined;
    commodityRef: number;
    id: number | undefined;
}

export class CreateOrEditStockTransactionAndTransactionDetailsDto implements ICreateOrEditStockTransactionAndTransactionDetailsDto {
    stockTransaction!: CreateOrEditStockTransactionDto;
    transactionDetails!: CreateOrEditTransactionDetailDto[] | undefined;
    deleteTransactionDetailIds!: number[] | undefined;

    constructor(data?: ICreateOrEditStockTransactionAndTransactionDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.stockTransaction = data["stockTransaction"] ? CreateOrEditStockTransactionDto.fromJS(data["stockTransaction"]) : <any>undefined;
            if (Array.isArray(data["transactionDetails"])) {
                this.transactionDetails = [] as any;
                for (let item of data["transactionDetails"])
                    this.transactionDetails!.push(CreateOrEditTransactionDetailDto.fromJS(item));
            }
            if (Array.isArray(data["deleteTransactionDetailIds"])) {
                this.deleteTransactionDetailIds = [] as any;
                for (let item of data["deleteTransactionDetailIds"])
                    this.deleteTransactionDetailIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrEditStockTransactionAndTransactionDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditStockTransactionAndTransactionDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stockTransaction"] = this.stockTransaction ? this.stockTransaction.toJSON() : <any>undefined;
        if (Array.isArray(this.transactionDetails)) {
            data["transactionDetails"] = [];
            for (let item of this.transactionDetails)
                data["transactionDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.deleteTransactionDetailIds)) {
            data["deleteTransactionDetailIds"] = [];
            for (let item of this.deleteTransactionDetailIds)
                data["deleteTransactionDetailIds"].push(item);
        }
        return data; 
    }
}

export interface ICreateOrEditStockTransactionAndTransactionDetailsDto {
    stockTransaction: CreateOrEditStockTransactionDto;
    transactionDetails: CreateOrEditTransactionDetailDto[] | undefined;
    deleteTransactionDetailIds: number[] | undefined;
}

export class StockTransactionBranchLookupTableDto implements IStockTransactionBranchLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IStockTransactionBranchLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): StockTransactionBranchLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockTransactionBranchLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IStockTransactionBranchLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfStockTransactionBranchLookupTableDto implements IPagedResultDtoOfStockTransactionBranchLookupTableDto {
    totalCount!: number;
    items!: StockTransactionBranchLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfStockTransactionBranchLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(StockTransactionBranchLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfStockTransactionBranchLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfStockTransactionBranchLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfStockTransactionBranchLookupTableDto {
    totalCount: number;
    items: StockTransactionBranchLookupTableDto[] | undefined;
}

export class StockTransactionContactLookupTableDto implements IStockTransactionContactLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IStockTransactionContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): StockTransactionContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockTransactionContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IStockTransactionContactLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfStockTransactionContactLookupTableDto implements IPagedResultDtoOfStockTransactionContactLookupTableDto {
    totalCount!: number;
    items!: StockTransactionContactLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfStockTransactionContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(StockTransactionContactLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfStockTransactionContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfStockTransactionContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfStockTransactionContactLookupTableDto {
    totalCount: number;
    items: StockTransactionContactLookupTableDto[] | undefined;
}

export class StockTransactionTransactionTypeLookupTableDto implements IStockTransactionTransactionTypeLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    isAffected!: boolean | undefined;
    isTemporary!: boolean;

    constructor(data?: IStockTransactionTransactionTypeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.isAffected = data["isAffected"];
            this.isTemporary = data["isTemporary"];
        }
    }

    static fromJS(data: any): StockTransactionTransactionTypeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockTransactionTransactionTypeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["isAffected"] = this.isAffected;
        data["isTemporary"] = this.isTemporary;
        return data; 
    }
}

export interface IStockTransactionTransactionTypeLookupTableDto {
    id: number;
    displayName: string | undefined;
    isAffected: boolean | undefined;
    isTemporary: boolean;
}

export class StockTransactionFamilyLookupTableDto implements IStockTransactionFamilyLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    description!: string | undefined;
    code!: string | undefined;
    fileNumber!: string | undefined;
    connectorRef!: number | undefined;

    constructor(data?: IStockTransactionFamilyLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.code = data["code"];
            this.fileNumber = data["fileNumber"];
            this.connectorRef = data["connectorRef"];
        }
    }

    static fromJS(data: any): StockTransactionFamilyLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockTransactionFamilyLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["code"] = this.code;
        data["fileNumber"] = this.fileNumber;
        data["connectorRef"] = this.connectorRef;
        return data; 
    }
}

export interface IStockTransactionFamilyLookupTableDto {
    id: number;
    displayName: string | undefined;
    description: string | undefined;
    code: string | undefined;
    fileNumber: string | undefined;
    connectorRef: number | undefined;
}

export class PagedResultDtoOfStockTransactionFamilyLookupTableDto implements IPagedResultDtoOfStockTransactionFamilyLookupTableDto {
    totalCount!: number;
    items!: StockTransactionFamilyLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfStockTransactionFamilyLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(StockTransactionFamilyLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfStockTransactionFamilyLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfStockTransactionFamilyLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfStockTransactionFamilyLookupTableDto {
    totalCount: number;
    items: StockTransactionFamilyLookupTableDto[] | undefined;
}

export class StockTransactionMemberContactLookupTableDto implements IStockTransactionMemberContactLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IStockTransactionMemberContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): StockTransactionMemberContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockTransactionMemberContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IStockTransactionMemberContactLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfStockTransactionMemberContactLookupTableDto implements IPagedResultDtoOfStockTransactionMemberContactLookupTableDto {
    totalCount!: number;
    items!: StockTransactionMemberContactLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfStockTransactionMemberContactLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(StockTransactionMemberContactLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfStockTransactionMemberContactLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfStockTransactionMemberContactLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfStockTransactionMemberContactLookupTableDto {
    totalCount: number;
    items: StockTransactionMemberContactLookupTableDto[] | undefined;
}

export class StripeConfigurationDto implements IStripeConfigurationDto {
    publishableKey!: string | undefined;

    constructor(data?: IStripeConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.publishableKey = data["publishableKey"];
        }
    }

    static fromJS(data: any): StripeConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new StripeConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publishableKey"] = this.publishableKey;
        return data; 
    }
}

export interface IStripeConfigurationDto {
    publishableKey: string | undefined;
}

export class StripeCreatePaymentSessionInput implements IStripeCreatePaymentSessionInput {
    paymentId!: number;
    successUrl!: string | undefined;
    cancelUrl!: string | undefined;

    constructor(data?: IStripeCreatePaymentSessionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paymentId = data["paymentId"];
            this.successUrl = data["successUrl"];
            this.cancelUrl = data["cancelUrl"];
        }
    }

    static fromJS(data: any): StripeCreatePaymentSessionInput {
        data = typeof data === 'object' ? data : {};
        let result = new StripeCreatePaymentSessionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["successUrl"] = this.successUrl;
        data["cancelUrl"] = this.cancelUrl;
        return data; 
    }
}

export interface IStripeCreatePaymentSessionInput {
    paymentId: number;
    successUrl: string | undefined;
    cancelUrl: string | undefined;
}

export class StripePaymentResultOutput implements IStripePaymentResultOutput {
    paymentDone!: boolean;

    constructor(data?: IStripePaymentResultOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paymentDone = data["paymentDone"];
        }
    }

    static fromJS(data: any): StripePaymentResultOutput {
        data = typeof data === 'object' ? data : {};
        let result = new StripePaymentResultOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentDone"] = this.paymentDone;
        return data; 
    }
}

export interface IStripePaymentResultOutput {
    paymentDone: boolean;
}

export class SupportiveOrganizationDto implements ISupportiveOrganizationDto {
    name!: string | undefined;
    id!: number;

    constructor(data?: ISupportiveOrganizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SupportiveOrganizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupportiveOrganizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISupportiveOrganizationDto {
    name: string | undefined;
    id: number;
}

export class GetSupportiveOrganizationForViewDto implements IGetSupportiveOrganizationForViewDto {
    supportiveOrganization!: SupportiveOrganizationDto;

    constructor(data?: IGetSupportiveOrganizationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.supportiveOrganization = data["supportiveOrganization"] ? SupportiveOrganizationDto.fromJS(data["supportiveOrganization"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSupportiveOrganizationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSupportiveOrganizationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supportiveOrganization"] = this.supportiveOrganization ? this.supportiveOrganization.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetSupportiveOrganizationForViewDto {
    supportiveOrganization: SupportiveOrganizationDto;
}

export class PagedResultDtoOfGetSupportiveOrganizationForViewDto implements IPagedResultDtoOfGetSupportiveOrganizationForViewDto {
    totalCount!: number;
    items!: GetSupportiveOrganizationForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSupportiveOrganizationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetSupportiveOrganizationForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSupportiveOrganizationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSupportiveOrganizationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetSupportiveOrganizationForViewDto {
    totalCount: number;
    items: GetSupportiveOrganizationForViewDto[] | undefined;
}

export class CreateOrEditSupportiveOrganizationDto implements ICreateOrEditSupportiveOrganizationDto {
    name!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSupportiveOrganizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSupportiveOrganizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSupportiveOrganizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditSupportiveOrganizationDto {
    name: string | undefined;
    id: number | undefined;
}

export class GetSupportiveOrganizationForEditOutput implements IGetSupportiveOrganizationForEditOutput {
    supportiveOrganization!: CreateOrEditSupportiveOrganizationDto;

    constructor(data?: IGetSupportiveOrganizationForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.supportiveOrganization = data["supportiveOrganization"] ? CreateOrEditSupportiveOrganizationDto.fromJS(data["supportiveOrganization"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSupportiveOrganizationForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSupportiveOrganizationForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supportiveOrganization"] = this.supportiveOrganization ? this.supportiveOrganization.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetSupportiveOrganizationForEditOutput {
    supportiveOrganization: CreateOrEditSupportiveOrganizationDto;
}

export class GetTagForEditOutput implements IGetTagForEditOutput {
    tag!: CreateOrEditTagDto;

    constructor(data?: IGetTagForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tag = data["tag"] ? CreateOrEditTagDto.fromJS(data["tag"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTagForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTagForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag ? this.tag.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetTagForEditOutput {
    tag: CreateOrEditTagDto;
}

export class TemplateDataDto implements ITemplateDataDto {
    promotes!: string | undefined;
    specialOffers!: string | undefined;
    partners!: string | undefined;
    themTemplateId!: number;
    id!: number;

    constructor(data?: ITemplateDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.promotes = data["promotes"];
            this.specialOffers = data["specialOffers"];
            this.partners = data["partners"];
            this.themTemplateId = data["themTemplateId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TemplateDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["promotes"] = this.promotes;
        data["specialOffers"] = this.specialOffers;
        data["partners"] = this.partners;
        data["themTemplateId"] = this.themTemplateId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITemplateDataDto {
    promotes: string | undefined;
    specialOffers: string | undefined;
    partners: string | undefined;
    themTemplateId: number;
    id: number;
}

export class GetTemplateDataForViewDto implements IGetTemplateDataForViewDto {
    templateData!: TemplateDataDto;
    themTemplateCode!: string | undefined;

    constructor(data?: IGetTemplateDataForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.templateData = data["templateData"] ? TemplateDataDto.fromJS(data["templateData"]) : <any>undefined;
            this.themTemplateCode = data["themTemplateCode"];
        }
    }

    static fromJS(data: any): GetTemplateDataForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTemplateDataForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateData"] = this.templateData ? this.templateData.toJSON() : <any>undefined;
        data["themTemplateCode"] = this.themTemplateCode;
        return data; 
    }
}

export interface IGetTemplateDataForViewDto {
    templateData: TemplateDataDto;
    themTemplateCode: string | undefined;
}

export class PagedResultDtoOfGetTemplateDataForViewDto implements IPagedResultDtoOfGetTemplateDataForViewDto {
    totalCount!: number;
    items!: GetTemplateDataForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTemplateDataForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetTemplateDataForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTemplateDataForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTemplateDataForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetTemplateDataForViewDto {
    totalCount: number;
    items: GetTemplateDataForViewDto[] | undefined;
}

export class CreateOrEditTemplateDataDto implements ICreateOrEditTemplateDataDto {
    promotes!: string | undefined;
    specialOffers!: string | undefined;
    partners!: string | undefined;
    themTemplateId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTemplateDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.promotes = data["promotes"];
            this.specialOffers = data["specialOffers"];
            this.partners = data["partners"];
            this.themTemplateId = data["themTemplateId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTemplateDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTemplateDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["promotes"] = this.promotes;
        data["specialOffers"] = this.specialOffers;
        data["partners"] = this.partners;
        data["themTemplateId"] = this.themTemplateId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditTemplateDataDto {
    promotes: string | undefined;
    specialOffers: string | undefined;
    partners: string | undefined;
    themTemplateId: number;
    id: number | undefined;
}

export class GetTemplateDataForEditOutput implements IGetTemplateDataForEditOutput {
    templateData!: CreateOrEditTemplateDataDto;
    themTemplateCode!: string | undefined;

    constructor(data?: IGetTemplateDataForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.templateData = data["templateData"] ? CreateOrEditTemplateDataDto.fromJS(data["templateData"]) : <any>undefined;
            this.themTemplateCode = data["themTemplateCode"];
        }
    }

    static fromJS(data: any): GetTemplateDataForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTemplateDataForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateData"] = this.templateData ? this.templateData.toJSON() : <any>undefined;
        data["themTemplateCode"] = this.themTemplateCode;
        return data; 
    }
}

export interface IGetTemplateDataForEditOutput {
    templateData: CreateOrEditTemplateDataDto;
    themTemplateCode: string | undefined;
}

export class Promote implements IPromote {
    image!: string | undefined;
    url!: string | undefined;

    constructor(data?: IPromote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.image = data["image"];
            this.url = data["url"];
        }
    }

    static fromJS(data: any): Promote {
        data = typeof data === 'object' ? data : {};
        let result = new Promote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["image"] = this.image;
        data["url"] = this.url;
        return data; 
    }
}

export interface IPromote {
    image: string | undefined;
    url: string | undefined;
}

export class Partner implements IPartner {
    title!: string | undefined;
    image!: string | undefined;
    url!: string | undefined;

    constructor(data?: IPartner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.image = data["image"];
            this.url = data["url"];
        }
    }

    static fromJS(data: any): Partner {
        data = typeof data === 'object' ? data : {};
        let result = new Partner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["image"] = this.image;
        data["url"] = this.url;
        return data; 
    }
}

export interface IPartner {
    title: string | undefined;
    image: string | undefined;
    url: string | undefined;
}

export class SpecialOffer implements ISpecialOffer {
    title!: string | undefined;
    image!: string | undefined;
    description!: string | undefined;
    url!: string | undefined;
    color!: string | undefined;

    constructor(data?: ISpecialOffer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.image = data["image"];
            this.description = data["description"];
            this.url = data["url"];
            this.color = data["color"];
        }
    }

    static fromJS(data: any): SpecialOffer {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialOffer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["image"] = this.image;
        data["description"] = this.description;
        data["url"] = this.url;
        data["color"] = this.color;
        return data; 
    }
}

export interface ISpecialOffer {
    title: string | undefined;
    image: string | undefined;
    description: string | undefined;
    url: string | undefined;
    color: string | undefined;
}

export class CreateOrEditTemplateDataInfoAndBannerDto implements ICreateOrEditTemplateDataInfoAndBannerDto {
    templateDataId!: number | undefined;
    themeTemplateId!: number;
    banners!: CreateOrEditBannerDto[] | undefined;
    requiredBanners!: CreateOrEditBannerDto[] | undefined;
    promotes!: Promote[] | undefined;
    partners!: Partner[] | undefined;
    specialOffers!: SpecialOffer[] | undefined;

    constructor(data?: ICreateOrEditTemplateDataInfoAndBannerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.templateDataId = data["templateDataId"];
            this.themeTemplateId = data["themeTemplateId"];
            if (Array.isArray(data["banners"])) {
                this.banners = [] as any;
                for (let item of data["banners"])
                    this.banners!.push(CreateOrEditBannerDto.fromJS(item));
            }
            if (Array.isArray(data["requiredBanners"])) {
                this.requiredBanners = [] as any;
                for (let item of data["requiredBanners"])
                    this.requiredBanners!.push(CreateOrEditBannerDto.fromJS(item));
            }
            if (Array.isArray(data["promotes"])) {
                this.promotes = [] as any;
                for (let item of data["promotes"])
                    this.promotes!.push(Promote.fromJS(item));
            }
            if (Array.isArray(data["partners"])) {
                this.partners = [] as any;
                for (let item of data["partners"])
                    this.partners!.push(Partner.fromJS(item));
            }
            if (Array.isArray(data["specialOffers"])) {
                this.specialOffers = [] as any;
                for (let item of data["specialOffers"])
                    this.specialOffers!.push(SpecialOffer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrEditTemplateDataInfoAndBannerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTemplateDataInfoAndBannerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateDataId"] = this.templateDataId;
        data["themeTemplateId"] = this.themeTemplateId;
        if (Array.isArray(this.banners)) {
            data["banners"] = [];
            for (let item of this.banners)
                data["banners"].push(item.toJSON());
        }
        if (Array.isArray(this.requiredBanners)) {
            data["requiredBanners"] = [];
            for (let item of this.requiredBanners)
                data["requiredBanners"].push(item.toJSON());
        }
        if (Array.isArray(this.promotes)) {
            data["promotes"] = [];
            for (let item of this.promotes)
                data["promotes"].push(item.toJSON());
        }
        if (Array.isArray(this.partners)) {
            data["partners"] = [];
            for (let item of this.partners)
                data["partners"].push(item.toJSON());
        }
        if (Array.isArray(this.specialOffers)) {
            data["specialOffers"] = [];
            for (let item of this.specialOffers)
                data["specialOffers"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateOrEditTemplateDataInfoAndBannerDto {
    templateDataId: number | undefined;
    themeTemplateId: number;
    banners: CreateOrEditBannerDto[] | undefined;
    requiredBanners: CreateOrEditBannerDto[] | undefined;
    promotes: Promote[] | undefined;
    partners: Partner[] | undefined;
    specialOffers: SpecialOffer[] | undefined;
}

export class GetTemplateDataInfoForViewDto implements IGetTemplateDataInfoForViewDto {
    templateDataId!: number;
    bannerHeight!: number;
    bannerWidth!: number;
    promotes!: Promote[] | undefined;
    partners!: Partner[] | undefined;
    specialOffers!: SpecialOffer[] | undefined;
    banners!: PagedResultDtoOfCreateOrEditBannerDto;
    requiredBanners!: CreateOrEditBannerDto[] | undefined;

    constructor(data?: IGetTemplateDataInfoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.templateDataId = data["templateDataId"];
            this.bannerHeight = data["bannerHeight"];
            this.bannerWidth = data["bannerWidth"];
            if (Array.isArray(data["promotes"])) {
                this.promotes = [] as any;
                for (let item of data["promotes"])
                    this.promotes!.push(Promote.fromJS(item));
            }
            if (Array.isArray(data["partners"])) {
                this.partners = [] as any;
                for (let item of data["partners"])
                    this.partners!.push(Partner.fromJS(item));
            }
            if (Array.isArray(data["specialOffers"])) {
                this.specialOffers = [] as any;
                for (let item of data["specialOffers"])
                    this.specialOffers!.push(SpecialOffer.fromJS(item));
            }
            this.banners = data["banners"] ? PagedResultDtoOfCreateOrEditBannerDto.fromJS(data["banners"]) : <any>undefined;
            if (Array.isArray(data["requiredBanners"])) {
                this.requiredBanners = [] as any;
                for (let item of data["requiredBanners"])
                    this.requiredBanners!.push(CreateOrEditBannerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTemplateDataInfoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTemplateDataInfoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateDataId"] = this.templateDataId;
        data["bannerHeight"] = this.bannerHeight;
        data["bannerWidth"] = this.bannerWidth;
        if (Array.isArray(this.promotes)) {
            data["promotes"] = [];
            for (let item of this.promotes)
                data["promotes"].push(item.toJSON());
        }
        if (Array.isArray(this.partners)) {
            data["partners"] = [];
            for (let item of this.partners)
                data["partners"].push(item.toJSON());
        }
        if (Array.isArray(this.specialOffers)) {
            data["specialOffers"] = [];
            for (let item of this.specialOffers)
                data["specialOffers"].push(item.toJSON());
        }
        data["banners"] = this.banners ? this.banners.toJSON() : <any>undefined;
        if (Array.isArray(this.requiredBanners)) {
            data["requiredBanners"] = [];
            for (let item of this.requiredBanners)
                data["requiredBanners"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetTemplateDataInfoForViewDto {
    templateDataId: number;
    bannerHeight: number;
    bannerWidth: number;
    promotes: Promote[] | undefined;
    partners: Partner[] | undefined;
    specialOffers: SpecialOffer[] | undefined;
    banners: PagedResultDtoOfCreateOrEditBannerDto;
    requiredBanners: CreateOrEditBannerDto[] | undefined;
}

export class ShopBanner implements IShopBanner {
    image!: string | undefined;
    url!: string | undefined;
    alt!: string | undefined;
    time!: number | undefined;
    order!: number | undefined;

    constructor(data?: IShopBanner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.image = data["image"];
            this.url = data["url"];
            this.alt = data["alt"];
            this.time = data["time"];
            this.order = data["order"];
        }
    }

    static fromJS(data: any): ShopBanner {
        data = typeof data === 'object' ? data : {};
        let result = new ShopBanner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["image"] = this.image;
        data["url"] = this.url;
        data["alt"] = this.alt;
        data["time"] = this.time;
        data["order"] = this.order;
        return data; 
    }
}

export interface IShopBanner {
    image: string | undefined;
    url: string | undefined;
    alt: string | undefined;
    time: number | undefined;
    order: number | undefined;
}

export class GetTemplateDataForShopDto implements IGetTemplateDataForShopDto {
    banners!: ShopBanner[] | undefined;
    eventsBanner!: ShopBanner;
    deceasedBanner!: ShopBanner;
    promotes!: Promote[] | undefined;
    partners!: Partner[] | undefined;
    specialOffers!: SpecialOffer[] | undefined;

    constructor(data?: IGetTemplateDataForShopDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["banners"])) {
                this.banners = [] as any;
                for (let item of data["banners"])
                    this.banners!.push(ShopBanner.fromJS(item));
            }
            this.eventsBanner = data["eventsBanner"] ? ShopBanner.fromJS(data["eventsBanner"]) : <any>undefined;
            this.deceasedBanner = data["deceasedBanner"] ? ShopBanner.fromJS(data["deceasedBanner"]) : <any>undefined;
            if (Array.isArray(data["promotes"])) {
                this.promotes = [] as any;
                for (let item of data["promotes"])
                    this.promotes!.push(Promote.fromJS(item));
            }
            if (Array.isArray(data["partners"])) {
                this.partners = [] as any;
                for (let item of data["partners"])
                    this.partners!.push(Partner.fromJS(item));
            }
            if (Array.isArray(data["specialOffers"])) {
                this.specialOffers = [] as any;
                for (let item of data["specialOffers"])
                    this.specialOffers!.push(SpecialOffer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTemplateDataForShopDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTemplateDataForShopDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.banners)) {
            data["banners"] = [];
            for (let item of this.banners)
                data["banners"].push(item.toJSON());
        }
        data["eventsBanner"] = this.eventsBanner ? this.eventsBanner.toJSON() : <any>undefined;
        data["deceasedBanner"] = this.deceasedBanner ? this.deceasedBanner.toJSON() : <any>undefined;
        if (Array.isArray(this.promotes)) {
            data["promotes"] = [];
            for (let item of this.promotes)
                data["promotes"].push(item.toJSON());
        }
        if (Array.isArray(this.partners)) {
            data["partners"] = [];
            for (let item of this.partners)
                data["partners"].push(item.toJSON());
        }
        if (Array.isArray(this.specialOffers)) {
            data["specialOffers"] = [];
            for (let item of this.specialOffers)
                data["specialOffers"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetTemplateDataForShopDto {
    banners: ShopBanner[] | undefined;
    eventsBanner: ShopBanner;
    deceasedBanner: ShopBanner;
    promotes: Promote[] | undefined;
    partners: Partner[] | undefined;
    specialOffers: SpecialOffer[] | undefined;
}

export class TemplateDataThemTemplateLookupTableDto implements ITemplateDataThemTemplateLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ITemplateDataThemTemplateLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): TemplateDataThemTemplateLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateDataThemTemplateLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ITemplateDataThemTemplateLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class TenantListDto implements ITenantListDto {
    tenancyName!: string | undefined;
    name!: string | undefined;
    editionDisplayName!: string | undefined;
    connectionString!: string | undefined;
    isActive!: boolean;
    creationTime!: moment.Moment;
    subscriptionEndDateUtc!: moment.Moment | undefined;
    editionId!: number | undefined;
    isInTrialPeriod!: boolean;
    tenantId!: string | undefined;
    appId!: string | undefined;
    walletAppCode!: string | undefined;
    id!: number;

    constructor(data?: ITenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.editionDisplayName = data["editionDisplayName"];
            this.connectionString = data["connectionString"];
            this.isActive = data["isActive"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.editionId = data["editionId"];
            this.isInTrialPeriod = data["isInTrialPeriod"];
            this.tenantId = data["tenantId"];
            this.appId = data["appId"];
            this.walletAppCode = data["walletAppCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenantListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["editionDisplayName"] = this.editionDisplayName;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["editionId"] = this.editionId;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["tenantId"] = this.tenantId;
        data["appId"] = this.appId;
        data["walletAppCode"] = this.walletAppCode;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenantListDto {
    tenancyName: string | undefined;
    name: string | undefined;
    editionDisplayName: string | undefined;
    connectionString: string | undefined;
    isActive: boolean;
    creationTime: moment.Moment;
    subscriptionEndDateUtc: moment.Moment | undefined;
    editionId: number | undefined;
    isInTrialPeriod: boolean;
    tenantId: string | undefined;
    appId: string | undefined;
    walletAppCode: string | undefined;
    id: number;
}

export class PagedResultDtoOfTenantListDto implements IPagedResultDtoOfTenantListDto {
    totalCount!: number;
    items!: TenantListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(TenantListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTenantListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfTenantListDto {
    totalCount: number;
    items: TenantListDto[] | undefined;
}

export enum SMSConsoles {
    Kavenegar_1 = 1,
}

export class CreateTenantInput implements ICreateTenantInput {
    tenancyName!: string | undefined;
    name!: string | undefined;
    adminEmailAddress!: string | undefined;
    adminPassword!: string | undefined;
    connectionString!: string | undefined;
    smsConsoles!: SMSConsoles;
    smsConsoleAPIKey!: string | undefined;
    smsConsoleAPIKey2!: string | undefined;
    shouldChangePasswordOnNextLogin!: boolean;
    sendActivationEmail!: boolean;
    editionId!: number | undefined;
    isActive!: boolean;
    subscriptionEndDateUtc!: moment.Moment | undefined;
    isInTrialPeriod!: boolean;
    tenantId!: string | undefined;
    appId!: string | undefined;
    walletAppCode!: string | undefined;

    constructor(data?: ICreateTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.adminEmailAddress = data["adminEmailAddress"];
            this.adminPassword = data["adminPassword"];
            this.connectionString = data["connectionString"];
            this.smsConsoles = data["smsConsoles"];
            this.smsConsoleAPIKey = data["smsConsoleAPIKey"];
            this.smsConsoleAPIKey2 = data["smsConsoleAPIKey2"];
            this.shouldChangePasswordOnNextLogin = data["shouldChangePasswordOnNextLogin"];
            this.sendActivationEmail = data["sendActivationEmail"];
            this.editionId = data["editionId"];
            this.isActive = data["isActive"];
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = data["isInTrialPeriod"];
            this.tenantId = data["tenantId"];
            this.appId = data["appId"];
            this.walletAppCode = data["walletAppCode"];
        }
    }

    static fromJS(data: any): CreateTenantInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminPassword"] = this.adminPassword;
        data["connectionString"] = this.connectionString;
        data["smsConsoles"] = this.smsConsoles;
        data["smsConsoleAPIKey"] = this.smsConsoleAPIKey;
        data["smsConsoleAPIKey2"] = this.smsConsoleAPIKey2;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["tenantId"] = this.tenantId;
        data["appId"] = this.appId;
        data["walletAppCode"] = this.walletAppCode;
        return data; 
    }
}

export interface ICreateTenantInput {
    tenancyName: string | undefined;
    name: string | undefined;
    adminEmailAddress: string | undefined;
    adminPassword: string | undefined;
    connectionString: string | undefined;
    smsConsoles: SMSConsoles;
    smsConsoleAPIKey: string | undefined;
    smsConsoleAPIKey2: string | undefined;
    shouldChangePasswordOnNextLogin: boolean;
    sendActivationEmail: boolean;
    editionId: number | undefined;
    isActive: boolean;
    subscriptionEndDateUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean;
    tenantId: string | undefined;
    appId: string | undefined;
    walletAppCode: string | undefined;
}

export class TenantEditDto implements ITenantEditDto {
    tenancyName!: string | undefined;
    name!: string | undefined;
    connectionString!: string | undefined;
    smsConsoles!: SMSConsoles;
    smsConsoleAPIKey!: string | undefined;
    smsConsoleAPIKey2!: string | undefined;
    editionId!: number | undefined;
    isActive!: boolean;
    subscriptionEndDateUtc!: moment.Moment | undefined;
    isInTrialPeriod!: boolean;
    tenantId!: string | undefined;
    appId!: string | undefined;
    walletAppCode!: string | undefined;
    id!: number;

    constructor(data?: ITenantEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.connectionString = data["connectionString"];
            this.smsConsoles = data["smsConsoles"];
            this.smsConsoleAPIKey = data["smsConsoleAPIKey"];
            this.smsConsoleAPIKey2 = data["smsConsoleAPIKey2"];
            this.editionId = data["editionId"];
            this.isActive = data["isActive"];
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = data["isInTrialPeriod"];
            this.tenantId = data["tenantId"];
            this.appId = data["appId"];
            this.walletAppCode = data["walletAppCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenantEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["connectionString"] = this.connectionString;
        data["smsConsoles"] = this.smsConsoles;
        data["smsConsoleAPIKey"] = this.smsConsoleAPIKey;
        data["smsConsoleAPIKey2"] = this.smsConsoleAPIKey2;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["tenantId"] = this.tenantId;
        data["appId"] = this.appId;
        data["walletAppCode"] = this.walletAppCode;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenantEditDto {
    tenancyName: string | undefined;
    name: string | undefined;
    connectionString: string | undefined;
    smsConsoles: SMSConsoles;
    smsConsoleAPIKey: string | undefined;
    smsConsoleAPIKey2: string | undefined;
    editionId: number | undefined;
    isActive: boolean;
    subscriptionEndDateUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean;
    tenantId: string | undefined;
    appId: string | undefined;
    walletAppCode: string | undefined;
    id: number;
}

export class TenantViewDto implements ITenantViewDto {
    tenancyName!: string | undefined;
    name!: string | undefined;
    connectionString!: string | undefined;
    smsConsoles!: SMSConsoles;
    smsConsoleAPIKey!: string | undefined;
    smsConsoleAPIKey2!: string | undefined;
    editionId!: number | undefined;
    isActive!: boolean;
    subscriptionEndDateUtc!: moment.Moment | undefined;
    isInTrialPeriod!: boolean;
    tenantId!: string | undefined;
    appId!: string | undefined;
    walletAppCode!: string | undefined;

    constructor(data?: ITenantViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.connectionString = data["connectionString"];
            this.smsConsoles = data["smsConsoles"];
            this.smsConsoleAPIKey = data["smsConsoleAPIKey"];
            this.smsConsoleAPIKey2 = data["smsConsoleAPIKey2"];
            this.editionId = data["editionId"];
            this.isActive = data["isActive"];
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = data["isInTrialPeriod"];
            this.tenantId = data["tenantId"];
            this.appId = data["appId"];
            this.walletAppCode = data["walletAppCode"];
        }
    }

    static fromJS(data: any): TenantViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["connectionString"] = this.connectionString;
        data["smsConsoles"] = this.smsConsoles;
        data["smsConsoleAPIKey"] = this.smsConsoleAPIKey;
        data["smsConsoleAPIKey2"] = this.smsConsoleAPIKey2;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["tenantId"] = this.tenantId;
        data["appId"] = this.appId;
        data["walletAppCode"] = this.walletAppCode;
        return data; 
    }
}

export interface ITenantViewDto {
    tenancyName: string | undefined;
    name: string | undefined;
    connectionString: string | undefined;
    smsConsoles: SMSConsoles;
    smsConsoleAPIKey: string | undefined;
    smsConsoleAPIKey2: string | undefined;
    editionId: number | undefined;
    isActive: boolean;
    subscriptionEndDateUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean;
    tenantId: string | undefined;
    appId: string | undefined;
    walletAppCode: string | undefined;
}

export class GetTenantFeaturesEditOutput implements IGetTenantFeaturesEditOutput {
    featureValues!: NameValueDto[] | undefined;
    features!: FlatFeatureDto[] | undefined;

    constructor(data?: IGetTenantFeaturesEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
            if (Array.isArray(data["features"])) {
                this.features = [] as any;
                for (let item of data["features"])
                    this.features!.push(FlatFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTenantFeaturesEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTenantFeaturesEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetTenantFeaturesEditOutput {
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;
}

export class UpdateTenantFeaturesInput implements IUpdateTenantFeaturesInput {
    id!: number;
    featureValues!: NameValueDto[] | undefined;

    constructor(data?: IUpdateTenantFeaturesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (Array.isArray(data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateTenantFeaturesInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTenantFeaturesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateTenantFeaturesInput {
    id: number;
    featureValues: NameValueDto[] | undefined;
}

export class EntityDto implements IEntityDto {
    id!: number;

    constructor(data?: IEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IEntityDto {
    id: number;
}

export class MemberActivity implements IMemberActivity {
    name!: string | undefined;
    earnings!: string | undefined;
    cases!: number;
    closed!: number;
    rate!: string | undefined;

    constructor(data?: IMemberActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.earnings = data["earnings"];
            this.cases = data["cases"];
            this.closed = data["closed"];
            this.rate = data["rate"];
        }
    }

    static fromJS(data: any): MemberActivity {
        data = typeof data === 'object' ? data : {};
        let result = new MemberActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["earnings"] = this.earnings;
        data["cases"] = this.cases;
        data["closed"] = this.closed;
        data["rate"] = this.rate;
        return data; 
    }
}

export interface IMemberActivity {
    name: string | undefined;
    earnings: string | undefined;
    cases: number;
    closed: number;
    rate: string | undefined;
}

export class GetMemberActivityOutput implements IGetMemberActivityOutput {
    memberActivities!: MemberActivity[] | undefined;

    constructor(data?: IGetMemberActivityOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["memberActivities"])) {
                this.memberActivities = [] as any;
                for (let item of data["memberActivities"])
                    this.memberActivities!.push(MemberActivity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMemberActivityOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMemberActivityOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.memberActivities)) {
            data["memberActivities"] = [];
            for (let item of this.memberActivities)
                data["memberActivities"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetMemberActivityOutput {
    memberActivities: MemberActivity[] | undefined;
}

export enum SalesSummaryDatePeriod {
    Daily = 1,
    Weekly = 2,
    Monthly = 3,
}

export class SalesSummaryData implements ISalesSummaryData {
    period!: string | undefined;
    sales!: number;
    profit!: number;

    constructor(data?: ISalesSummaryData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.period = data["period"];
            this.sales = data["sales"];
            this.profit = data["profit"];
        }
    }

    static fromJS(data: any): SalesSummaryData {
        data = typeof data === 'object' ? data : {};
        let result = new SalesSummaryData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["period"] = this.period;
        data["sales"] = this.sales;
        data["profit"] = this.profit;
        return data; 
    }
}

export interface ISalesSummaryData {
    period: string | undefined;
    sales: number;
    profit: number;
}

export class GetDashboardDataOutput implements IGetDashboardDataOutput {
    totalProfit!: number;
    newFeedbacks!: number;
    newOrders!: number;
    newUsers!: number;
    salesSummary!: SalesSummaryData[] | undefined;
    totalSales!: number;
    revenue!: number;
    expenses!: number;
    growth!: number;
    transactionPercent!: number;
    newVisitPercent!: number;
    bouncePercent!: number;
    dailySales!: number[] | undefined;
    profitShares!: number[] | undefined;

    constructor(data?: IGetDashboardDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalProfit = data["totalProfit"];
            this.newFeedbacks = data["newFeedbacks"];
            this.newOrders = data["newOrders"];
            this.newUsers = data["newUsers"];
            if (Array.isArray(data["salesSummary"])) {
                this.salesSummary = [] as any;
                for (let item of data["salesSummary"])
                    this.salesSummary!.push(SalesSummaryData.fromJS(item));
            }
            this.totalSales = data["totalSales"];
            this.revenue = data["revenue"];
            this.expenses = data["expenses"];
            this.growth = data["growth"];
            this.transactionPercent = data["transactionPercent"];
            this.newVisitPercent = data["newVisitPercent"];
            this.bouncePercent = data["bouncePercent"];
            if (Array.isArray(data["dailySales"])) {
                this.dailySales = [] as any;
                for (let item of data["dailySales"])
                    this.dailySales!.push(item);
            }
            if (Array.isArray(data["profitShares"])) {
                this.profitShares = [] as any;
                for (let item of data["profitShares"])
                    this.profitShares!.push(item);
            }
        }
    }

    static fromJS(data: any): GetDashboardDataOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDashboardDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProfit"] = this.totalProfit;
        data["newFeedbacks"] = this.newFeedbacks;
        data["newOrders"] = this.newOrders;
        data["newUsers"] = this.newUsers;
        if (Array.isArray(this.salesSummary)) {
            data["salesSummary"] = [];
            for (let item of this.salesSummary)
                data["salesSummary"].push(item.toJSON());
        }
        data["totalSales"] = this.totalSales;
        data["revenue"] = this.revenue;
        data["expenses"] = this.expenses;
        data["growth"] = this.growth;
        data["transactionPercent"] = this.transactionPercent;
        data["newVisitPercent"] = this.newVisitPercent;
        data["bouncePercent"] = this.bouncePercent;
        if (Array.isArray(this.dailySales)) {
            data["dailySales"] = [];
            for (let item of this.dailySales)
                data["dailySales"].push(item);
        }
        if (Array.isArray(this.profitShares)) {
            data["profitShares"] = [];
            for (let item of this.profitShares)
                data["profitShares"].push(item);
        }
        return data; 
    }
}

export interface IGetDashboardDataOutput {
    totalProfit: number;
    newFeedbacks: number;
    newOrders: number;
    newUsers: number;
    salesSummary: SalesSummaryData[] | undefined;
    totalSales: number;
    revenue: number;
    expenses: number;
    growth: number;
    transactionPercent: number;
    newVisitPercent: number;
    bouncePercent: number;
    dailySales: number[] | undefined;
    profitShares: number[] | undefined;
}

export class GetTopStatsOutput implements IGetTopStatsOutput {
    totalProfit!: number;
    newFeedbacks!: number;
    newOrders!: number;
    newUsers!: number;

    constructor(data?: IGetTopStatsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalProfit = data["totalProfit"];
            this.newFeedbacks = data["newFeedbacks"];
            this.newOrders = data["newOrders"];
            this.newUsers = data["newUsers"];
        }
    }

    static fromJS(data: any): GetTopStatsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTopStatsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProfit"] = this.totalProfit;
        data["newFeedbacks"] = this.newFeedbacks;
        data["newOrders"] = this.newOrders;
        data["newUsers"] = this.newUsers;
        return data; 
    }
}

export interface IGetTopStatsOutput {
    totalProfit: number;
    newFeedbacks: number;
    newOrders: number;
    newUsers: number;
}

export class GetProfitShareOutput implements IGetProfitShareOutput {
    profitShares!: number[] | undefined;

    constructor(data?: IGetProfitShareOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["profitShares"])) {
                this.profitShares = [] as any;
                for (let item of data["profitShares"])
                    this.profitShares!.push(item);
            }
        }
    }

    static fromJS(data: any): GetProfitShareOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfitShareOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.profitShares)) {
            data["profitShares"] = [];
            for (let item of this.profitShares)
                data["profitShares"].push(item);
        }
        return data; 
    }
}

export interface IGetProfitShareOutput {
    profitShares: number[] | undefined;
}

export class GetDailySalesOutput implements IGetDailySalesOutput {
    dailySales!: number[] | undefined;

    constructor(data?: IGetDailySalesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["dailySales"])) {
                this.dailySales = [] as any;
                for (let item of data["dailySales"])
                    this.dailySales!.push(item);
            }
        }
    }

    static fromJS(data: any): GetDailySalesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDailySalesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dailySales)) {
            data["dailySales"] = [];
            for (let item of this.dailySales)
                data["dailySales"].push(item);
        }
        return data; 
    }
}

export interface IGetDailySalesOutput {
    dailySales: number[] | undefined;
}

export class GetSalesSummaryOutput implements IGetSalesSummaryOutput {
    totalSales!: number;
    revenue!: number;
    expenses!: number;
    growth!: number;
    salesSummary!: SalesSummaryData[] | undefined;

    constructor(data?: IGetSalesSummaryOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalSales = data["totalSales"];
            this.revenue = data["revenue"];
            this.expenses = data["expenses"];
            this.growth = data["growth"];
            if (Array.isArray(data["salesSummary"])) {
                this.salesSummary = [] as any;
                for (let item of data["salesSummary"])
                    this.salesSummary!.push(SalesSummaryData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSalesSummaryOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesSummaryOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalSales"] = this.totalSales;
        data["revenue"] = this.revenue;
        data["expenses"] = this.expenses;
        data["growth"] = this.growth;
        if (Array.isArray(this.salesSummary)) {
            data["salesSummary"] = [];
            for (let item of this.salesSummary)
                data["salesSummary"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetSalesSummaryOutput {
    totalSales: number;
    revenue: number;
    expenses: number;
    growth: number;
    salesSummary: SalesSummaryData[] | undefined;
}

export class RegionalStatCountry implements IRegionalStatCountry {
    countryName!: string | undefined;
    sales!: number;
    change!: number[] | undefined;
    averagePrice!: number;
    totalPrice!: number;

    constructor(data?: IRegionalStatCountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.countryName = data["countryName"];
            this.sales = data["sales"];
            if (Array.isArray(data["change"])) {
                this.change = [] as any;
                for (let item of data["change"])
                    this.change!.push(item);
            }
            this.averagePrice = data["averagePrice"];
            this.totalPrice = data["totalPrice"];
        }
    }

    static fromJS(data: any): RegionalStatCountry {
        data = typeof data === 'object' ? data : {};
        let result = new RegionalStatCountry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryName"] = this.countryName;
        data["sales"] = this.sales;
        if (Array.isArray(this.change)) {
            data["change"] = [];
            for (let item of this.change)
                data["change"].push(item);
        }
        data["averagePrice"] = this.averagePrice;
        data["totalPrice"] = this.totalPrice;
        return data; 
    }
}

export interface IRegionalStatCountry {
    countryName: string | undefined;
    sales: number;
    change: number[] | undefined;
    averagePrice: number;
    totalPrice: number;
}

export class GetRegionalStatsOutput implements IGetRegionalStatsOutput {
    stats!: RegionalStatCountry[] | undefined;

    constructor(data?: IGetRegionalStatsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["stats"])) {
                this.stats = [] as any;
                for (let item of data["stats"])
                    this.stats!.push(RegionalStatCountry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRegionalStatsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegionalStatsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.stats)) {
            data["stats"] = [];
            for (let item of this.stats)
                data["stats"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetRegionalStatsOutput {
    stats: RegionalStatCountry[] | undefined;
}

export class GetGeneralStatsOutput implements IGetGeneralStatsOutput {
    transactionPercent!: number;
    newVisitPercent!: number;
    bouncePercent!: number;

    constructor(data?: IGetGeneralStatsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transactionPercent = data["transactionPercent"];
            this.newVisitPercent = data["newVisitPercent"];
            this.bouncePercent = data["bouncePercent"];
        }
    }

    static fromJS(data: any): GetGeneralStatsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeneralStatsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionPercent"] = this.transactionPercent;
        data["newVisitPercent"] = this.newVisitPercent;
        data["bouncePercent"] = this.bouncePercent;
        return data; 
    }
}

export interface IGetGeneralStatsOutput {
    transactionPercent: number;
    newVisitPercent: number;
    bouncePercent: number;
}

export class GetNumberOfBillOutput implements IGetNumberOfBillOutput {
    totalBIll!: number;
    paidBill!: number;
    onApproveBill!: number;
    expiredBill!: number;
    cancelBill!: number;
    waitingForPaymentBill!: number;
    notApproveBill!: number;
    labelBill!: number;
    calligraphyBill!: number;
    stockBill!: number;
    transportBill!: number;
    inCeremonyBill!: number;

    constructor(data?: IGetNumberOfBillOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalBIll = data["totalBIll"];
            this.paidBill = data["paidBill"];
            this.onApproveBill = data["onApproveBill"];
            this.expiredBill = data["expiredBill"];
            this.cancelBill = data["cancelBill"];
            this.waitingForPaymentBill = data["waitingForPaymentBill"];
            this.notApproveBill = data["notApproveBill"];
            this.labelBill = data["labelBill"];
            this.calligraphyBill = data["calligraphyBill"];
            this.stockBill = data["stockBill"];
            this.transportBill = data["transportBill"];
            this.inCeremonyBill = data["inCeremonyBill"];
        }
    }

    static fromJS(data: any): GetNumberOfBillOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNumberOfBillOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalBIll"] = this.totalBIll;
        data["paidBill"] = this.paidBill;
        data["onApproveBill"] = this.onApproveBill;
        data["expiredBill"] = this.expiredBill;
        data["cancelBill"] = this.cancelBill;
        data["waitingForPaymentBill"] = this.waitingForPaymentBill;
        data["notApproveBill"] = this.notApproveBill;
        data["labelBill"] = this.labelBill;
        data["calligraphyBill"] = this.calligraphyBill;
        data["stockBill"] = this.stockBill;
        data["transportBill"] = this.transportBill;
        data["inCeremonyBill"] = this.inCeremonyBill;
        return data; 
    }
}

export interface IGetNumberOfBillOutput {
    totalBIll: number;
    paidBill: number;
    onApproveBill: number;
    expiredBill: number;
    cancelBill: number;
    waitingForPaymentBill: number;
    notApproveBill: number;
    labelBill: number;
    calligraphyBill: number;
    stockBill: number;
    transportBill: number;
    inCeremonyBill: number;
}

export class GetNUmberOfPlansOutput implements IGetNUmberOfPlansOutput {
    charityCount!: number;
    charityPrice!: string | undefined;
    sacrificeCount!: number;
    sacrificePrice!: string | undefined;
    flowerCrownCount!: number;
    flowerCrownPrice!: string | undefined;
    moneyBoxCount!: number;
    moneyBoxPrice!: string | undefined;

    constructor(data?: IGetNUmberOfPlansOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.charityCount = data["charityCount"];
            this.charityPrice = data["charityPrice"];
            this.sacrificeCount = data["sacrificeCount"];
            this.sacrificePrice = data["sacrificePrice"];
            this.flowerCrownCount = data["flowerCrownCount"];
            this.flowerCrownPrice = data["flowerCrownPrice"];
            this.moneyBoxCount = data["moneyBoxCount"];
            this.moneyBoxPrice = data["moneyBoxPrice"];
        }
    }

    static fromJS(data: any): GetNUmberOfPlansOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNUmberOfPlansOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["charityCount"] = this.charityCount;
        data["charityPrice"] = this.charityPrice;
        data["sacrificeCount"] = this.sacrificeCount;
        data["sacrificePrice"] = this.sacrificePrice;
        data["flowerCrownCount"] = this.flowerCrownCount;
        data["flowerCrownPrice"] = this.flowerCrownPrice;
        data["moneyBoxCount"] = this.moneyBoxCount;
        data["moneyBoxPrice"] = this.moneyBoxPrice;
        return data; 
    }
}

export interface IGetNUmberOfPlansOutput {
    charityCount: number;
    charityPrice: string | undefined;
    sacrificeCount: number;
    sacrificePrice: string | undefined;
    flowerCrownCount: number;
    flowerCrownPrice: string | undefined;
    moneyBoxCount: number;
    moneyBoxPrice: string | undefined;
}

export enum SubscriptionStartType {
    Free = 1,
    Trial = 2,
    Paid = 3,
}

export class RegisterTenantInput implements IRegisterTenantInput {
    tenancyName!: string | undefined;
    name!: string | undefined;
    adminEmailAddress!: string | undefined;
    adminPassword!: string | undefined;
    captchaResponse!: string | undefined;
    subscriptionStartType!: SubscriptionStartType;
    editionId!: number | undefined;
    tenantId!: string | undefined;
    appId!: string | undefined;
    walletAppCode!: string | undefined;

    constructor(data?: IRegisterTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.adminEmailAddress = data["adminEmailAddress"];
            this.adminPassword = data["adminPassword"];
            this.captchaResponse = data["captchaResponse"];
            this.subscriptionStartType = data["subscriptionStartType"];
            this.editionId = data["editionId"];
            this.tenantId = data["tenantId"];
            this.appId = data["appId"];
            this.walletAppCode = data["walletAppCode"];
        }
    }

    static fromJS(data: any): RegisterTenantInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminPassword"] = this.adminPassword;
        data["captchaResponse"] = this.captchaResponse;
        data["subscriptionStartType"] = this.subscriptionStartType;
        data["editionId"] = this.editionId;
        data["tenantId"] = this.tenantId;
        data["appId"] = this.appId;
        data["walletAppCode"] = this.walletAppCode;
        return data; 
    }
}

export interface IRegisterTenantInput {
    tenancyName: string | undefined;
    name: string | undefined;
    adminEmailAddress: string | undefined;
    adminPassword: string | undefined;
    captchaResponse: string | undefined;
    subscriptionStartType: SubscriptionStartType;
    editionId: number | undefined;
    tenantId: string | undefined;
    appId: string | undefined;
    walletAppCode: string | undefined;
}

export class RegisterTenantOutput implements IRegisterTenantOutput {
    tenantId!: number;
    tenancyName!: string | undefined;
    name!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    isTenantActive!: boolean;
    isActive!: boolean;
    isEmailConfirmationRequired!: boolean;

    constructor(data?: IRegisterTenantOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.isTenantActive = data["isTenantActive"];
            this.isActive = data["isActive"];
            this.isEmailConfirmationRequired = data["isEmailConfirmationRequired"];
        }
    }

    static fromJS(data: any): RegisterTenantOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterTenantOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["isTenantActive"] = this.isTenantActive;
        data["isActive"] = this.isActive;
        data["isEmailConfirmationRequired"] = this.isEmailConfirmationRequired;
        return data; 
    }
}

export interface IRegisterTenantOutput {
    tenantId: number;
    tenancyName: string | undefined;
    name: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    isTenantActive: boolean;
    isActive: boolean;
    isEmailConfirmationRequired: boolean;
}

export class IInputType implements IIInputType {
    readonly name!: string | undefined;
    readonly attributes!: { [key: string]: any; } | undefined;
    validator!: IValueValidator;

    constructor(data?: IIInputType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            (<any>this).name = data["name"];
            if (data["attributes"]) {
                (<any>this).attributes = {} as any;
                for (let key in data["attributes"]) {
                    if (data["attributes"].hasOwnProperty(key))
                        (<any>this).attributes![key] = data["attributes"][key];
                }
            }
            this.validator = data["validator"] ? IValueValidator.fromJS(data["validator"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IInputType {
        data = typeof data === 'object' ? data : {};
        let result = new IInputType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    data["attributes"][key] = this.attributes[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IIInputType {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
    validator: IValueValidator;
}

export class FlatFeatureSelectDto implements IFlatFeatureSelectDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    defaultValue!: string | undefined;
    inputType!: IInputType;
    textHtmlColor!: string | undefined;

    constructor(data?: IFlatFeatureSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.defaultValue = data["defaultValue"];
            this.inputType = data["inputType"] ? IInputType.fromJS(data["inputType"]) : <any>undefined;
            this.textHtmlColor = data["textHtmlColor"];
        }
    }

    static fromJS(data: any): FlatFeatureSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatFeatureSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : <any>undefined;
        data["textHtmlColor"] = this.textHtmlColor;
        return data; 
    }
}

export interface IFlatFeatureSelectDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    inputType: IInputType;
    textHtmlColor: string | undefined;
}

export class EditionWithFeaturesDto implements IEditionWithFeaturesDto {
    edition!: EditionSelectDto;
    featureValues!: NameValueDto[] | undefined;

    constructor(data?: IEditionWithFeaturesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.edition = data["edition"] ? EditionSelectDto.fromJS(data["edition"]) : <any>undefined;
            if (Array.isArray(data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditionWithFeaturesDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionWithFeaturesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IEditionWithFeaturesDto {
    edition: EditionSelectDto;
    featureValues: NameValueDto[] | undefined;
}

export class EditionsSelectOutput implements IEditionsSelectOutput {
    allFeatures!: FlatFeatureSelectDto[] | undefined;
    editionsWithFeatures!: EditionWithFeaturesDto[] | undefined;

    constructor(data?: IEditionsSelectOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["allFeatures"])) {
                this.allFeatures = [] as any;
                for (let item of data["allFeatures"])
                    this.allFeatures!.push(FlatFeatureSelectDto.fromJS(item));
            }
            if (Array.isArray(data["editionsWithFeatures"])) {
                this.editionsWithFeatures = [] as any;
                for (let item of data["editionsWithFeatures"])
                    this.editionsWithFeatures!.push(EditionWithFeaturesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditionsSelectOutput {
        data = typeof data === 'object' ? data : {};
        let result = new EditionsSelectOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.allFeatures)) {
            data["allFeatures"] = [];
            for (let item of this.allFeatures)
                data["allFeatures"].push(item.toJSON());
        }
        if (Array.isArray(this.editionsWithFeatures)) {
            data["editionsWithFeatures"] = [];
            for (let item of this.editionsWithFeatures)
                data["editionsWithFeatures"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IEditionsSelectOutput {
    allFeatures: FlatFeatureSelectDto[] | undefined;
    editionsWithFeatures: EditionWithFeaturesDto[] | undefined;
}

export class TenantUserManagementSettingsEditDto implements ITenantUserManagementSettingsEditDto {
    allowSelfRegistration!: boolean;
    isNewRegisteredUserActiveByDefault!: boolean;
    isEmailConfirmationRequiredForLogin!: boolean;
    useCaptchaOnRegistration!: boolean;
    useCaptchaOnLogin!: boolean;
    isCookieConsentEnabled!: boolean;
    isQuickThemeSelectEnabled!: boolean;
    sessionTimeOutSettings!: SessionTimeOutSettingsEditDto;

    constructor(data?: ITenantUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allowSelfRegistration = data["allowSelfRegistration"];
            this.isNewRegisteredUserActiveByDefault = data["isNewRegisteredUserActiveByDefault"];
            this.isEmailConfirmationRequiredForLogin = data["isEmailConfirmationRequiredForLogin"];
            this.useCaptchaOnRegistration = data["useCaptchaOnRegistration"];
            this.useCaptchaOnLogin = data["useCaptchaOnLogin"];
            this.isCookieConsentEnabled = data["isCookieConsentEnabled"];
            this.isQuickThemeSelectEnabled = data["isQuickThemeSelectEnabled"];
            this.sessionTimeOutSettings = data["sessionTimeOutSettings"] ? SessionTimeOutSettingsEditDto.fromJS(data["sessionTimeOutSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantUserManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantUserManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredUserActiveByDefault"] = this.isNewRegisteredUserActiveByDefault;
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        data["useCaptchaOnLogin"] = this.useCaptchaOnLogin;
        data["isCookieConsentEnabled"] = this.isCookieConsentEnabled;
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        data["sessionTimeOutSettings"] = this.sessionTimeOutSettings ? this.sessionTimeOutSettings.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ITenantUserManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredUserActiveByDefault: boolean;
    isEmailConfirmationRequiredForLogin: boolean;
    useCaptchaOnRegistration: boolean;
    useCaptchaOnLogin: boolean;
    isCookieConsentEnabled: boolean;
    isQuickThemeSelectEnabled: boolean;
    sessionTimeOutSettings: SessionTimeOutSettingsEditDto;
}

export class TenantEmailSettingsEditDto implements ITenantEmailSettingsEditDto {
    useHostDefaultEmailSettings!: boolean;
    defaultFromAddress!: string | undefined;
    defaultFromDisplayName!: string | undefined;
    smtpHost!: string | undefined;
    smtpPort!: number;
    smtpUserName!: string | undefined;
    smtpPassword!: string | undefined;
    smtpDomain!: string | undefined;
    smtpEnableSsl!: boolean;
    smtpUseDefaultCredentials!: boolean;

    constructor(data?: ITenantEmailSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.useHostDefaultEmailSettings = data["useHostDefaultEmailSettings"];
            this.defaultFromAddress = data["defaultFromAddress"];
            this.defaultFromDisplayName = data["defaultFromDisplayName"];
            this.smtpHost = data["smtpHost"];
            this.smtpPort = data["smtpPort"];
            this.smtpUserName = data["smtpUserName"];
            this.smtpPassword = data["smtpPassword"];
            this.smtpDomain = data["smtpDomain"];
            this.smtpEnableSsl = data["smtpEnableSsl"];
            this.smtpUseDefaultCredentials = data["smtpUseDefaultCredentials"];
        }
    }

    static fromJS(data: any): TenantEmailSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEmailSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["useHostDefaultEmailSettings"] = this.useHostDefaultEmailSettings;
        data["defaultFromAddress"] = this.defaultFromAddress;
        data["defaultFromDisplayName"] = this.defaultFromDisplayName;
        data["smtpHost"] = this.smtpHost;
        data["smtpPort"] = this.smtpPort;
        data["smtpUserName"] = this.smtpUserName;
        data["smtpPassword"] = this.smtpPassword;
        data["smtpDomain"] = this.smtpDomain;
        data["smtpEnableSsl"] = this.smtpEnableSsl;
        data["smtpUseDefaultCredentials"] = this.smtpUseDefaultCredentials;
        return data; 
    }
}

export interface ITenantEmailSettingsEditDto {
    useHostDefaultEmailSettings: boolean;
    defaultFromAddress: string | undefined;
    defaultFromDisplayName: string | undefined;
    smtpHost: string | undefined;
    smtpPort: number;
    smtpUserName: string | undefined;
    smtpPassword: string | undefined;
    smtpDomain: string | undefined;
    smtpEnableSsl: boolean;
    smtpUseDefaultCredentials: boolean;
}

export class LdapSettingsEditDto implements ILdapSettingsEditDto {
    isModuleEnabled!: boolean;
    isEnabled!: boolean;
    domain!: string | undefined;
    userName!: string | undefined;
    password!: string | undefined;

    constructor(data?: ILdapSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isModuleEnabled = data["isModuleEnabled"];
            this.isEnabled = data["isEnabled"];
            this.domain = data["domain"];
            this.userName = data["userName"];
            this.password = data["password"];
        }
    }

    static fromJS(data: any): LdapSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new LdapSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isModuleEnabled"] = this.isModuleEnabled;
        data["isEnabled"] = this.isEnabled;
        data["domain"] = this.domain;
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data; 
    }
}

export interface ILdapSettingsEditDto {
    isModuleEnabled: boolean;
    isEnabled: boolean;
    domain: string | undefined;
    userName: string | undefined;
    password: string | undefined;
}

export class TenantBillingSettingsEditDto implements ITenantBillingSettingsEditDto {
    legalName!: string | undefined;
    address!: string | undefined;
    taxVatNo!: string | undefined;

    constructor(data?: ITenantBillingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.legalName = data["legalName"];
            this.address = data["address"];
            this.taxVatNo = data["taxVatNo"];
        }
    }

    static fromJS(data: any): TenantBillingSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantBillingSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        data["taxVatNo"] = this.taxVatNo;
        return data; 
    }
}

export interface ITenantBillingSettingsEditDto {
    legalName: string | undefined;
    address: string | undefined;
    taxVatNo: string | undefined;
}

export class TenantOtherSettingsEditDto implements ITenantOtherSettingsEditDto {
    isQuickThemeSelectEnabled!: boolean;

    constructor(data?: ITenantOtherSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isQuickThemeSelectEnabled = data["isQuickThemeSelectEnabled"];
        }
    }

    static fromJS(data: any): TenantOtherSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantOtherSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        return data; 
    }
}

export interface ITenantOtherSettingsEditDto {
    isQuickThemeSelectEnabled: boolean;
}

export class TenantSettingsEditDto implements ITenantSettingsEditDto {
    general!: GeneralSettingsEditDto;
    userManagement!: TenantUserManagementSettingsEditDto;
    email!: TenantEmailSettingsEditDto;
    ldap!: LdapSettingsEditDto;
    security!: SecuritySettingsEditDto;
    billing!: TenantBillingSettingsEditDto;
    otherSettings!: TenantOtherSettingsEditDto;

    constructor(data?: ITenantSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.userManagement = new TenantUserManagementSettingsEditDto();
            this.security = new SecuritySettingsEditDto();
        }
    }

    init(data?: any) {
        if (data) {
            this.general = data["general"] ? GeneralSettingsEditDto.fromJS(data["general"]) : <any>undefined;
            this.userManagement = data["userManagement"] ? TenantUserManagementSettingsEditDto.fromJS(data["userManagement"]) : new TenantUserManagementSettingsEditDto();
            this.email = data["email"] ? TenantEmailSettingsEditDto.fromJS(data["email"]) : <any>undefined;
            this.ldap = data["ldap"] ? LdapSettingsEditDto.fromJS(data["ldap"]) : <any>undefined;
            this.security = data["security"] ? SecuritySettingsEditDto.fromJS(data["security"]) : new SecuritySettingsEditDto();
            this.billing = data["billing"] ? TenantBillingSettingsEditDto.fromJS(data["billing"]) : <any>undefined;
            this.otherSettings = data["otherSettings"] ? TenantOtherSettingsEditDto.fromJS(data["otherSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["ldap"] = this.ldap ? this.ldap.toJSON() : <any>undefined;
        data["security"] = this.security ? this.security.toJSON() : <any>undefined;
        data["billing"] = this.billing ? this.billing.toJSON() : <any>undefined;
        data["otherSettings"] = this.otherSettings ? this.otherSettings.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ITenantSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: TenantUserManagementSettingsEditDto;
    email: TenantEmailSettingsEditDto;
    ldap: LdapSettingsEditDto;
    security: SecuritySettingsEditDto;
    billing: TenantBillingSettingsEditDto;
    otherSettings: TenantOtherSettingsEditDto;
}

export class TenantSendTestEmailInput implements ITenantSendTestEmailInput {
    emailAddressTo!: string | undefined;
    emailAddressFrom!: string | undefined;

    constructor(data?: ITenantSendTestEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.emailAddressTo = data["emailAddressTo"];
            this.emailAddressFrom = data["emailAddressFrom"];
        }
    }

    static fromJS(data: any): TenantSendTestEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSendTestEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddressTo"] = this.emailAddressTo;
        data["emailAddressFrom"] = this.emailAddressFrom;
        return data; 
    }
}

export interface ITenantSendTestEmailInput {
    emailAddressTo: string | undefined;
    emailAddressFrom: string | undefined;
}

export class TermMappingDto implements ITermMappingDto {
    originalTerm!: string | undefined;
    mappedTerm!: string | undefined;
    isActive!: boolean;
    fontName!: string | undefined;
    id!: number;

    constructor(data?: ITermMappingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.originalTerm = data["originalTerm"];
            this.mappedTerm = data["mappedTerm"];
            this.isActive = data["isActive"];
            this.fontName = data["fontName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TermMappingDto {
        data = typeof data === 'object' ? data : {};
        let result = new TermMappingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalTerm"] = this.originalTerm;
        data["mappedTerm"] = this.mappedTerm;
        data["isActive"] = this.isActive;
        data["fontName"] = this.fontName;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITermMappingDto {
    originalTerm: string | undefined;
    mappedTerm: string | undefined;
    isActive: boolean;
    fontName: string | undefined;
    id: number;
}

export class GetTermMappingForViewDto implements IGetTermMappingForViewDto {
    termMapping!: TermMappingDto;

    constructor(data?: IGetTermMappingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termMapping = data["termMapping"] ? TermMappingDto.fromJS(data["termMapping"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTermMappingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTermMappingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termMapping"] = this.termMapping ? this.termMapping.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetTermMappingForViewDto {
    termMapping: TermMappingDto;
}

export class PagedResultDtoOfGetTermMappingForViewDto implements IPagedResultDtoOfGetTermMappingForViewDto {
    totalCount!: number;
    items!: GetTermMappingForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTermMappingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetTermMappingForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTermMappingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTermMappingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetTermMappingForViewDto {
    totalCount: number;
    items: GetTermMappingForViewDto[] | undefined;
}

export class CreateOrEditTermMappingDto implements ICreateOrEditTermMappingDto {
    originalTerm!: string | undefined;
    mappedTerm!: string | undefined;
    isActive!: boolean;
    fontName!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTermMappingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.originalTerm = data["originalTerm"];
            this.mappedTerm = data["mappedTerm"];
            this.isActive = data["isActive"];
            this.fontName = data["fontName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTermMappingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTermMappingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalTerm"] = this.originalTerm;
        data["mappedTerm"] = this.mappedTerm;
        data["isActive"] = this.isActive;
        data["fontName"] = this.fontName;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditTermMappingDto {
    originalTerm: string | undefined;
    mappedTerm: string | undefined;
    isActive: boolean;
    fontName: string | undefined;
    id: number | undefined;
}

export class GetTermMappingForEditOutput implements IGetTermMappingForEditOutput {
    termMapping!: CreateOrEditTermMappingDto;

    constructor(data?: IGetTermMappingForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termMapping = data["termMapping"] ? CreateOrEditTermMappingDto.fromJS(data["termMapping"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTermMappingForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTermMappingForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termMapping"] = this.termMapping ? this.termMapping.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetTermMappingForEditOutput {
    termMapping: CreateOrEditTermMappingDto;
}

export class ThemTemplateDto implements IThemTemplateDto {
    code!: string | undefined;
    title!: string | undefined;
    image!: string | undefined;
    default!: boolean;
    bannerHeight!: number;
    bannerWidth!: number;
    id!: number;

    constructor(data?: IThemTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.title = data["title"];
            this.image = data["image"];
            this.default = data["default"];
            this.bannerHeight = data["bannerHeight"];
            this.bannerWidth = data["bannerWidth"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ThemTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["title"] = this.title;
        data["image"] = this.image;
        data["default"] = this.default;
        data["bannerHeight"] = this.bannerHeight;
        data["bannerWidth"] = this.bannerWidth;
        data["id"] = this.id;
        return data; 
    }
}

export interface IThemTemplateDto {
    code: string | undefined;
    title: string | undefined;
    image: string | undefined;
    default: boolean;
    bannerHeight: number;
    bannerWidth: number;
    id: number;
}

export class GetThemTemplateForViewDto implements IGetThemTemplateForViewDto {
    themTemplate!: ThemTemplateDto;

    constructor(data?: IGetThemTemplateForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.themTemplate = data["themTemplate"] ? ThemTemplateDto.fromJS(data["themTemplate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetThemTemplateForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetThemTemplateForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["themTemplate"] = this.themTemplate ? this.themTemplate.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetThemTemplateForViewDto {
    themTemplate: ThemTemplateDto;
}

export class PagedResultDtoOfGetThemTemplateForViewDto implements IPagedResultDtoOfGetThemTemplateForViewDto {
    totalCount!: number;
    items!: GetThemTemplateForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetThemTemplateForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetThemTemplateForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetThemTemplateForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetThemTemplateForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetThemTemplateForViewDto {
    totalCount: number;
    items: GetThemTemplateForViewDto[] | undefined;
}

export class CreateOrEditThemTemplateDto implements ICreateOrEditThemTemplateDto {
    code!: string | undefined;
    title!: string | undefined;
    image!: string | undefined;
    default!: boolean;
    bannerHeight!: number;
    bannerWidth!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditThemTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.title = data["title"];
            this.image = data["image"];
            this.default = data["default"];
            this.bannerHeight = data["bannerHeight"];
            this.bannerWidth = data["bannerWidth"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditThemTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditThemTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["title"] = this.title;
        data["image"] = this.image;
        data["default"] = this.default;
        data["bannerHeight"] = this.bannerHeight;
        data["bannerWidth"] = this.bannerWidth;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditThemTemplateDto {
    code: string | undefined;
    title: string | undefined;
    image: string | undefined;
    default: boolean;
    bannerHeight: number;
    bannerWidth: number;
    id: number | undefined;
}

export class GetThemTemplateForEditOutput implements IGetThemTemplateForEditOutput {
    themTemplate!: CreateOrEditThemTemplateDto;

    constructor(data?: IGetThemTemplateForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.themTemplate = data["themTemplate"] ? CreateOrEditThemTemplateDto.fromJS(data["themTemplate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetThemTemplateForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetThemTemplateForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["themTemplate"] = this.themTemplate ? this.themTemplate.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetThemTemplateForEditOutput {
    themTemplate: CreateOrEditThemTemplateDto;
}

export enum SettingScopes {
    Application = 1,
    Tenant = 2,
    User = 4,
    All = 7,
}

export class ListResultDtoOfNameValueDto implements IListResultDtoOfNameValueDto {
    items!: NameValueDto[] | undefined;

    constructor(data?: IListResultDtoOfNameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfNameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfNameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfNameValueDto {
    items: NameValueDto[] | undefined;
}

export class VerifyPhoneNumberInput implements IVerifyPhoneNumberInput {
    name!: string | undefined;
    surname!: string | undefined;
    smsCode!: string | undefined;
    phoneNumber!: string | undefined;
    introducer!: string | undefined;

    constructor(data?: IVerifyPhoneNumberInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.smsCode = data["smsCode"];
            this.phoneNumber = data["phoneNumber"];
            this.introducer = data["introducer"];
        }
    }

    static fromJS(data: any): VerifyPhoneNumberInput {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyPhoneNumberInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["smsCode"] = this.smsCode;
        data["phoneNumber"] = this.phoneNumber;
        data["introducer"] = this.introducer;
        return data; 
    }
}

export interface IVerifyPhoneNumberInput {
    name: string | undefined;
    surname: string | undefined;
    smsCode: string | undefined;
    phoneNumber: string | undefined;
    introducer: string | undefined;
}

export class VerifyEmailInput implements IVerifyEmailInput {
    name!: string | undefined;
    surname!: string | undefined;
    code!: string | undefined;
    emailAddressTo!: string | undefined;
    introducer!: string | undefined;

    constructor(data?: IVerifyEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.code = data["code"];
            this.emailAddressTo = data["emailAddressTo"];
            this.introducer = data["introducer"];
        }
    }

    static fromJS(data: any): VerifyEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["code"] = this.code;
        data["emailAddressTo"] = this.emailAddressTo;
        data["introducer"] = this.introducer;
        return data; 
    }
}

export interface IVerifyEmailInput {
    name: string | undefined;
    surname: string | undefined;
    code: string | undefined;
    emailAddressTo: string | undefined;
    introducer: string | undefined;
}

export class LogInWithPassInput implements ILogInWithPassInput {
    userName!: string | undefined;
    password!: string | undefined;

    constructor(data?: ILogInWithPassInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userName = data["userName"];
            this.password = data["password"];
        }
    }

    static fromJS(data: any): LogInWithPassInput {
        data = typeof data === 'object' ? data : {};
        let result = new LogInWithPassInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data; 
    }
}

export interface ILogInWithPassInput {
    userName: string | undefined;
    password: string | undefined;
}

export class PasswordInputDto implements IPasswordInputDto {
    password!: string | undefined;
    phoneNumber!: string | undefined;

    constructor(data?: IPasswordInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.password = data["password"];
            this.phoneNumber = data["phoneNumber"];
        }
    }

    static fromJS(data: any): PasswordInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        data["phoneNumber"] = this.phoneNumber;
        return data; 
    }
}

export interface IPasswordInputDto {
    password: string | undefined;
    phoneNumber: string | undefined;
}

export class VerifyCodeForRestPassInputDto implements IVerifyCodeForRestPassInputDto {
    code!: string | undefined;

    constructor(data?: IVerifyCodeForRestPassInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
        }
    }

    static fromJS(data: any): VerifyCodeForRestPassInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyCodeForRestPassInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        return data; 
    }
}

export interface IVerifyCodeForRestPassInputDto {
    code: string | undefined;
}

export class ResetPasswordByEmailInput implements IResetPasswordByEmailInput {
    password!: string | undefined;
    emailAddress!: string | undefined;

    constructor(data?: IResetPasswordByEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.password = data["password"];
            this.emailAddress = data["emailAddress"];
        }
    }

    static fromJS(data: any): ResetPasswordByEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordByEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        data["emailAddress"] = this.emailAddress;
        return data; 
    }
}

export interface IResetPasswordByEmailInput {
    password: string | undefined;
    emailAddress: string | undefined;
}

export class ImpersonatedAuthenticateResultModel implements IImpersonatedAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;

    constructor(data?: IImpersonatedAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
        }
    }

    static fromJS(data: any): ImpersonatedAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonatedAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data; 
    }
}

export interface IImpersonatedAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress!: string | undefined;
    password!: string | undefined;
    twoFactorVerificationCode!: string | undefined;
    rememberClient!: boolean;
    twoFactorRememberClientToken!: string | undefined;
    singleSignIn!: boolean | undefined;
    returnUrl!: string | undefined;
    captchaResponse!: string | undefined;
    timeZone!: string | undefined;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userNameOrEmailAddress = data["userNameOrEmailAddress"];
            this.password = data["password"];
            this.twoFactorVerificationCode = data["twoFactorVerificationCode"];
            this.rememberClient = data["rememberClient"];
            this.twoFactorRememberClientToken = data["twoFactorRememberClientToken"];
            this.singleSignIn = data["singleSignIn"];
            this.returnUrl = data["returnUrl"];
            this.captchaResponse = data["captchaResponse"];
            this.timeZone = data["timeZone"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["twoFactorVerificationCode"] = this.twoFactorVerificationCode;
        data["rememberClient"] = this.rememberClient;
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["singleSignIn"] = this.singleSignIn;
        data["returnUrl"] = this.returnUrl;
        data["captchaResponse"] = this.captchaResponse;
        data["timeZone"] = this.timeZone;
        return data; 
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string | undefined;
    password: string | undefined;
    twoFactorVerificationCode: string | undefined;
    rememberClient: boolean;
    twoFactorRememberClientToken: string | undefined;
    singleSignIn: boolean | undefined;
    returnUrl: string | undefined;
    captchaResponse: string | undefined;
    timeZone: string | undefined;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    shouldResetPassword!: boolean;
    passwordResetCode!: string | undefined;
    userId!: number;
    requiresTwoFactorVerification!: boolean;
    twoFactorAuthProviders!: string[] | undefined;
    twoFactorRememberClientToken!: string | undefined;
    returnUrl!: string | undefined;
    refreshToken!: string | undefined;
    refreshTokenExpireInSeconds!: number;
    grantedPermissions!: string[] | undefined;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
            this.shouldResetPassword = data["shouldResetPassword"];
            this.passwordResetCode = data["passwordResetCode"];
            this.userId = data["userId"];
            this.requiresTwoFactorVerification = data["requiresTwoFactorVerification"];
            if (Array.isArray(data["twoFactorAuthProviders"])) {
                this.twoFactorAuthProviders = [] as any;
                for (let item of data["twoFactorAuthProviders"])
                    this.twoFactorAuthProviders!.push(item);
            }
            this.twoFactorRememberClientToken = data["twoFactorRememberClientToken"];
            this.returnUrl = data["returnUrl"];
            this.refreshToken = data["refreshToken"];
            this.refreshTokenExpireInSeconds = data["refreshTokenExpireInSeconds"];
            if (Array.isArray(data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of data["grantedPermissions"])
                    this.grantedPermissions!.push(item);
            }
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["shouldResetPassword"] = this.shouldResetPassword;
        data["passwordResetCode"] = this.passwordResetCode;
        data["userId"] = this.userId;
        data["requiresTwoFactorVerification"] = this.requiresTwoFactorVerification;
        if (Array.isArray(this.twoFactorAuthProviders)) {
            data["twoFactorAuthProviders"] = [];
            for (let item of this.twoFactorAuthProviders)
                data["twoFactorAuthProviders"].push(item);
        }
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["returnUrl"] = this.returnUrl;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpireInSeconds"] = this.refreshTokenExpireInSeconds;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data; 
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    shouldResetPassword: boolean;
    passwordResetCode: string | undefined;
    userId: number;
    requiresTwoFactorVerification: boolean;
    twoFactorAuthProviders: string[] | undefined;
    twoFactorRememberClientToken: string | undefined;
    returnUrl: string | undefined;
    refreshToken: string | undefined;
    refreshTokenExpireInSeconds: number;
    grantedPermissions: string[] | undefined;
}

export class RefreshTokenResult implements IRefreshTokenResult {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;

    constructor(data?: IRefreshTokenResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
        }
    }

    static fromJS(data: any): RefreshTokenResult {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data; 
    }
}

export interface IRefreshTokenResult {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
}

export class SendTwoFactorAuthCodeModel implements ISendTwoFactorAuthCodeModel {
    userId!: number;
    provider!: string | undefined;

    constructor(data?: ISendTwoFactorAuthCodeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.provider = data["provider"];
        }
    }

    static fromJS(data: any): SendTwoFactorAuthCodeModel {
        data = typeof data === 'object' ? data : {};
        let result = new SendTwoFactorAuthCodeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["provider"] = this.provider;
        return data; 
    }
}

export interface ISendTwoFactorAuthCodeModel {
    userId: number;
    provider: string | undefined;
}

export class SwitchedAccountAuthenticateResultModel implements ISwitchedAccountAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;

    constructor(data?: ISwitchedAccountAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
        }
    }

    static fromJS(data: any): SwitchedAccountAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchedAccountAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data; 
    }
}

export interface ISwitchedAccountAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name!: string | undefined;
    clientId!: string | undefined;
    additionalParams!: { [key: string]: string; } | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.clientId = data["clientId"];
            if (data["additionalParams"]) {
                this.additionalParams = {} as any;
                for (let key in data["additionalParams"]) {
                    if (data["additionalParams"].hasOwnProperty(key))
                        this.additionalParams![key] = data["additionalParams"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        if (this.additionalParams) {
            data["additionalParams"] = {};
            for (let key in this.additionalParams) {
                if (this.additionalParams.hasOwnProperty(key))
                    data["additionalParams"][key] = this.additionalParams[key];
            }
        }
        return data; 
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
    additionalParams: { [key: string]: string; } | undefined;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider!: string | undefined;
    providerKey!: string | undefined;
    providerAccessCode!: string | undefined;
    returnUrl!: string | undefined;
    singleSignIn!: boolean | undefined;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.authProvider = data["authProvider"];
            this.providerKey = data["providerKey"];
            this.providerAccessCode = data["providerAccessCode"];
            this.returnUrl = data["returnUrl"];
            this.singleSignIn = data["singleSignIn"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        return data; 
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string | undefined;
    providerKey: string | undefined;
    providerAccessCode: string | undefined;
    returnUrl: string | undefined;
    singleSignIn: boolean | undefined;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    waitingForActivation!: boolean;
    returnUrl!: string | undefined;
    refreshToken!: string | undefined;
    refreshTokenExpireInSeconds!: number;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
            this.waitingForActivation = data["waitingForActivation"];
            this.returnUrl = data["returnUrl"];
            this.refreshToken = data["refreshToken"];
            this.refreshTokenExpireInSeconds = data["refreshTokenExpireInSeconds"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        data["returnUrl"] = this.returnUrl;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpireInSeconds"] = this.refreshTokenExpireInSeconds;
        return data; 
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;
    returnUrl: string | undefined;
    refreshToken: string | undefined;
    refreshTokenExpireInSeconds: number;
}

export class GetTransactionDetailForEditOutput implements IGetTransactionDetailForEditOutput {
    transactionDetail!: CreateOrEditTransactionDetailDto;
    stockTransactionFormCode!: string | undefined;
    commodityTitle!: string | undefined;

    constructor(data?: IGetTransactionDetailForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transactionDetail = data["transactionDetail"] ? CreateOrEditTransactionDetailDto.fromJS(data["transactionDetail"]) : <any>undefined;
            this.stockTransactionFormCode = data["stockTransactionFormCode"];
            this.commodityTitle = data["commodityTitle"];
        }
    }

    static fromJS(data: any): GetTransactionDetailForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionDetailForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionDetail"] = this.transactionDetail ? this.transactionDetail.toJSON() : <any>undefined;
        data["stockTransactionFormCode"] = this.stockTransactionFormCode;
        data["commodityTitle"] = this.commodityTitle;
        return data; 
    }
}

export interface IGetTransactionDetailForEditOutput {
    transactionDetail: CreateOrEditTransactionDetailDto;
    stockTransactionFormCode: string | undefined;
    commodityTitle: string | undefined;
}

export class TransactionDetailStockTransactionLookupTableDto implements ITransactionDetailStockTransactionLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: ITransactionDetailStockTransactionLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): TransactionDetailStockTransactionLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionDetailStockTransactionLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ITransactionDetailStockTransactionLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfTransactionDetailStockTransactionLookupTableDto implements IPagedResultDtoOfTransactionDetailStockTransactionLookupTableDto {
    totalCount!: number;
    items!: TransactionDetailStockTransactionLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTransactionDetailStockTransactionLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(TransactionDetailStockTransactionLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTransactionDetailStockTransactionLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTransactionDetailStockTransactionLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfTransactionDetailStockTransactionLookupTableDto {
    totalCount: number;
    items: TransactionDetailStockTransactionLookupTableDto[] | undefined;
}

export class TransactionDetailCommodityLookupTableDto implements ITransactionDetailCommodityLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    unit!: Units;
    price!: number | undefined;

    constructor(data?: ITransactionDetailCommodityLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.unit = data["unit"];
            this.price = data["price"];
        }
    }

    static fromJS(data: any): TransactionDetailCommodityLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionDetailCommodityLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["unit"] = this.unit;
        data["price"] = this.price;
        return data; 
    }
}

export interface ITransactionDetailCommodityLookupTableDto {
    id: number;
    displayName: string | undefined;
    unit: Units;
    price: number | undefined;
}

export class PagedResultDtoOfTransactionDetailCommodityLookupTableDto implements IPagedResultDtoOfTransactionDetailCommodityLookupTableDto {
    totalCount!: number;
    items!: TransactionDetailCommodityLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTransactionDetailCommodityLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(TransactionDetailCommodityLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTransactionDetailCommodityLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTransactionDetailCommodityLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfTransactionDetailCommodityLookupTableDto {
    totalCount: number;
    items: TransactionDetailCommodityLookupTableDto[] | undefined;
}

export class TransactionTypeDto implements ITransactionTypeDto {
    title!: string | undefined;
    isAffected!: boolean | undefined;
    isTemporary!: boolean;
    code!: string | undefined;
    id!: number;

    constructor(data?: ITransactionTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.isAffected = data["isAffected"];
            this.isTemporary = data["isTemporary"];
            this.code = data["code"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TransactionTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["isAffected"] = this.isAffected;
        data["isTemporary"] = this.isTemporary;
        data["code"] = this.code;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITransactionTypeDto {
    title: string | undefined;
    isAffected: boolean | undefined;
    isTemporary: boolean;
    code: string | undefined;
    id: number;
}

export class GetTransactionTypeForViewDto implements IGetTransactionTypeForViewDto {
    transactionType!: TransactionTypeDto;
    editable!: boolean;

    constructor(data?: IGetTransactionTypeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transactionType = data["transactionType"] ? TransactionTypeDto.fromJS(data["transactionType"]) : <any>undefined;
            this.editable = data["editable"];
        }
    }

    static fromJS(data: any): GetTransactionTypeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionTypeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionType"] = this.transactionType ? this.transactionType.toJSON() : <any>undefined;
        data["editable"] = this.editable;
        return data; 
    }
}

export interface IGetTransactionTypeForViewDto {
    transactionType: TransactionTypeDto;
    editable: boolean;
}

export class PagedResultDtoOfGetTransactionTypeForViewDto implements IPagedResultDtoOfGetTransactionTypeForViewDto {
    totalCount!: number;
    items!: GetTransactionTypeForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTransactionTypeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetTransactionTypeForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTransactionTypeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTransactionTypeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetTransactionTypeForViewDto {
    totalCount: number;
    items: GetTransactionTypeForViewDto[] | undefined;
}

export class CreateOrEditTransactionTypeDto implements ICreateOrEditTransactionTypeDto {
    title!: string | undefined;
    isAffected!: boolean | undefined;
    isTemporary!: boolean;
    code!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTransactionTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.isAffected = data["isAffected"];
            this.isTemporary = data["isTemporary"];
            this.code = data["code"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTransactionTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTransactionTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["isAffected"] = this.isAffected;
        data["isTemporary"] = this.isTemporary;
        data["code"] = this.code;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditTransactionTypeDto {
    title: string | undefined;
    isAffected: boolean | undefined;
    isTemporary: boolean;
    code: string | undefined;
    id: number | undefined;
}

export class GetTransactionTypeForEditOutput implements IGetTransactionTypeForEditOutput {
    transactionType!: CreateOrEditTransactionTypeDto;

    constructor(data?: IGetTransactionTypeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transactionType = data["transactionType"] ? CreateOrEditTransactionTypeDto.fromJS(data["transactionType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTransactionTypeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionTypeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionType"] = this.transactionType ? this.transactionType.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetTransactionTypeForEditOutput {
    transactionType: CreateOrEditTransactionTypeDto;
}

export class UniversityDto implements IUniversityDto {
    title!: string | undefined;
    cityId!: number | undefined;
    state!: boolean;
    id!: number;

    constructor(data?: IUniversityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.cityId = data["cityId"];
            this.state = data["state"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UniversityDto {
        data = typeof data === 'object' ? data : {};
        let result = new UniversityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["cityId"] = this.cityId;
        data["state"] = this.state;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUniversityDto {
    title: string | undefined;
    cityId: number | undefined;
    state: boolean;
    id: number;
}

export class GetUniversityForViewDto implements IGetUniversityForViewDto {
    university!: UniversityDto;
    cityName!: string | undefined;

    constructor(data?: IGetUniversityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.university = data["university"] ? UniversityDto.fromJS(data["university"]) : <any>undefined;
            this.cityName = data["cityName"];
        }
    }

    static fromJS(data: any): GetUniversityForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUniversityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["university"] = this.university ? this.university.toJSON() : <any>undefined;
        data["cityName"] = this.cityName;
        return data; 
    }
}

export interface IGetUniversityForViewDto {
    university: UniversityDto;
    cityName: string | undefined;
}

export class PagedResultDtoOfGetUniversityForViewDto implements IPagedResultDtoOfGetUniversityForViewDto {
    totalCount!: number;
    items!: GetUniversityForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetUniversityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetUniversityForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetUniversityForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetUniversityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetUniversityForViewDto {
    totalCount: number;
    items: GetUniversityForViewDto[] | undefined;
}

export class CreateOrEditUniversityDto implements ICreateOrEditUniversityDto {
    title!: string | undefined;
    cityId!: number | undefined;
    state!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditUniversityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.cityId = data["cityId"];
            this.state = data["state"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditUniversityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditUniversityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["cityId"] = this.cityId;
        data["state"] = this.state;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditUniversityDto {
    title: string | undefined;
    cityId: number | undefined;
    state: boolean;
    id: number | undefined;
}

export class GetUniversityForEditOutput implements IGetUniversityForEditOutput {
    university!: CreateOrEditUniversityDto;
    cityName!: string | undefined;

    constructor(data?: IGetUniversityForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.university = data["university"] ? CreateOrEditUniversityDto.fromJS(data["university"]) : <any>undefined;
            this.cityName = data["cityName"];
        }
    }

    static fromJS(data: any): GetUniversityForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUniversityForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["university"] = this.university ? this.university.toJSON() : <any>undefined;
        data["cityName"] = this.cityName;
        return data; 
    }
}

export interface IGetUniversityForEditOutput {
    university: CreateOrEditUniversityDto;
    cityName: string | undefined;
}

export class UniversityCityLookupTableDto implements IUniversityCityLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IUniversityCityLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): UniversityCityLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new UniversityCityLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IUniversityCityLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class UserListRoleDto implements IUserListRoleDto {
    roleId!: number;
    roleName!: string | undefined;

    constructor(data?: IUserListRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.roleId = data["roleId"];
            this.roleName = data["roleName"];
        }
    }

    static fromJS(data: any): UserListRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        return data; 
    }
}

export interface IUserListRoleDto {
    roleId: number;
    roleName: string | undefined;
}

export class UserListDto implements IUserListDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    phoneNumber!: string | undefined;
    profilePictureId!: string | undefined;
    isEmailConfirmed!: boolean;
    roles!: UserListRoleDto[] | undefined;
    isActive!: boolean;
    creationTime!: moment.Moment;
    id!: number;

    constructor(data?: IUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.phoneNumber = data["phoneNumber"];
            this.profilePictureId = data["profilePictureId"];
            this.isEmailConfirmed = data["isEmailConfirmed"];
            if (Array.isArray(data["roles"])) {
                this.roles = [] as any;
                for (let item of data["roles"])
                    this.roles!.push(UserListRoleDto.fromJS(item));
            }
            this.isActive = data["isActive"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["profilePictureId"] = this.profilePictureId;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserListDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    profilePictureId: string | undefined;
    isEmailConfirmed: boolean;
    roles: UserListRoleDto[] | undefined;
    isActive: boolean;
    creationTime: moment.Moment;
    id: number;
}

export class PagedResultDtoOfUserListDto implements IPagedResultDtoOfUserListDto {
    totalCount!: number;
    items!: UserListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(UserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfUserListDto {
    totalCount: number;
    items: UserListDto[] | undefined;
}

export class UserEditDto implements IUserEditDto {
    id!: number | undefined;
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    phoneNumber!: string | undefined;
    password!: string | undefined;
    isActive!: boolean;
    shouldChangePasswordOnNextLogin!: boolean;
    isTwoFactorEnabled!: boolean;
    isLockoutEnabled!: boolean;

    constructor(data?: IUserEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.phoneNumber = data["phoneNumber"];
            this.password = data["password"];
            this.isActive = data["isActive"];
            this.shouldChangePasswordOnNextLogin = data["shouldChangePasswordOnNextLogin"];
            this.isTwoFactorEnabled = data["isTwoFactorEnabled"];
            this.isLockoutEnabled = data["isLockoutEnabled"];
        }
    }

    static fromJS(data: any): UserEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        data["isActive"] = this.isActive;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        return data; 
    }
}

export interface IUserEditDto {
    id: number | undefined;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    password: string | undefined;
    isActive: boolean;
    shouldChangePasswordOnNextLogin: boolean;
    isTwoFactorEnabled: boolean;
    isLockoutEnabled: boolean;
}

export class UserRoleDto implements IUserRoleDto {
    roleId!: number;
    roleName!: string | undefined;
    roleDisplayName!: string | undefined;
    isAssigned!: boolean;
    inheritedFromOrganizationUnit!: boolean;

    constructor(data?: IUserRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.roleId = data["roleId"];
            this.roleName = data["roleName"];
            this.roleDisplayName = data["roleDisplayName"];
            this.isAssigned = data["isAssigned"];
            this.inheritedFromOrganizationUnit = data["inheritedFromOrganizationUnit"];
        }
    }

    static fromJS(data: any): UserRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["roleDisplayName"] = this.roleDisplayName;
        data["isAssigned"] = this.isAssigned;
        data["inheritedFromOrganizationUnit"] = this.inheritedFromOrganizationUnit;
        return data; 
    }
}

export interface IUserRoleDto {
    roleId: number;
    roleName: string | undefined;
    roleDisplayName: string | undefined;
    isAssigned: boolean;
    inheritedFromOrganizationUnit: boolean;
}

export class GetUserForEditOutput implements IGetUserForEditOutput {
    profilePictureId!: string | undefined;
    user!: UserEditDto;
    roles!: UserRoleDto[] | undefined;
    allOrganizationUnits!: OrganizationUnitDto[] | undefined;
    memberedOrganizationUnits!: string[] | undefined;

    constructor(data?: IGetUserForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.profilePictureId = data["profilePictureId"];
            this.user = data["user"] ? UserEditDto.fromJS(data["user"]) : <any>undefined;
            if (Array.isArray(data["roles"])) {
                this.roles = [] as any;
                for (let item of data["roles"])
                    this.roles!.push(UserRoleDto.fromJS(item));
            }
            if (Array.isArray(data["allOrganizationUnits"])) {
                this.allOrganizationUnits = [] as any;
                for (let item of data["allOrganizationUnits"])
                    this.allOrganizationUnits!.push(OrganizationUnitDto.fromJS(item));
            }
            if (Array.isArray(data["memberedOrganizationUnits"])) {
                this.memberedOrganizationUnits = [] as any;
                for (let item of data["memberedOrganizationUnits"])
                    this.memberedOrganizationUnits!.push(item);
            }
        }
    }

    static fromJS(data: any): GetUserForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePictureId"] = this.profilePictureId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.allOrganizationUnits)) {
            data["allOrganizationUnits"] = [];
            for (let item of this.allOrganizationUnits)
                data["allOrganizationUnits"].push(item.toJSON());
        }
        if (Array.isArray(this.memberedOrganizationUnits)) {
            data["memberedOrganizationUnits"] = [];
            for (let item of this.memberedOrganizationUnits)
                data["memberedOrganizationUnits"].push(item);
        }
        return data; 
    }
}

export interface IGetUserForEditOutput {
    profilePictureId: string | undefined;
    user: UserEditDto;
    roles: UserRoleDto[] | undefined;
    allOrganizationUnits: OrganizationUnitDto[] | undefined;
    memberedOrganizationUnits: string[] | undefined;
}

export class GetUserPermissionsForEditOutput implements IGetUserPermissionsForEditOutput {
    permissions!: FlatPermissionDto[] | undefined;
    grantedPermissionNames!: string[] | undefined;

    constructor(data?: IGetUserPermissionsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["permissions"])) {
                this.permissions = [] as any;
                for (let item of data["permissions"])
                    this.permissions!.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetUserPermissionsForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserPermissionsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data; 
    }
}

export interface IGetUserPermissionsForEditOutput {
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class EntityDtoOfInt64 implements IEntityDtoOfInt64 {
    id!: number;

    constructor(data?: IEntityDtoOfInt64) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfInt64 {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfInt64();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IEntityDtoOfInt64 {
    id: number;
}

export class UpdateUserPermissionsInput implements IUpdateUserPermissionsInput {
    id!: number;
    grantedPermissionNames!: string[] | undefined;

    constructor(data?: IUpdateUserPermissionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (Array.isArray(data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateUserPermissionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserPermissionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data; 
    }
}

export interface IUpdateUserPermissionsInput {
    id: number;
    grantedPermissionNames: string[] | undefined;
}

export class CreateOrUpdateUserInput implements ICreateOrUpdateUserInput {
    user!: UserEditDto;
    assignedRoleNames!: string[] | undefined;
    sendActivationEmail!: boolean;
    setRandomPassword!: boolean;
    organizationUnits!: number[] | undefined;

    constructor(data?: ICreateOrUpdateUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.user = new UserEditDto();
        }
    }

    init(data?: any) {
        if (data) {
            this.user = data["user"] ? UserEditDto.fromJS(data["user"]) : new UserEditDto();
            if (Array.isArray(data["assignedRoleNames"])) {
                this.assignedRoleNames = [] as any;
                for (let item of data["assignedRoleNames"])
                    this.assignedRoleNames!.push(item);
            }
            this.sendActivationEmail = data["sendActivationEmail"];
            this.setRandomPassword = data["setRandomPassword"];
            if (Array.isArray(data["organizationUnits"])) {
                this.organizationUnits = [] as any;
                for (let item of data["organizationUnits"])
                    this.organizationUnits!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.assignedRoleNames)) {
            data["assignedRoleNames"] = [];
            for (let item of this.assignedRoleNames)
                data["assignedRoleNames"].push(item);
        }
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["setRandomPassword"] = this.setRandomPassword;
        if (Array.isArray(this.organizationUnits)) {
            data["organizationUnits"] = [];
            for (let item of this.organizationUnits)
                data["organizationUnits"].push(item);
        }
        return data; 
    }
}

export interface ICreateOrUpdateUserInput {
    user: UserEditDto;
    assignedRoleNames: string[] | undefined;
    sendActivationEmail: boolean;
    setRandomPassword: boolean;
    organizationUnits: number[] | undefined;
}

export class UserEntityDto implements IUserEntityDto {
    title!: string | undefined;
    description!: string | undefined;
    createdBy!: number;
    modefiedBy!: number | undefined;
    created!: moment.Moment;
    modified!: moment.Moment | undefined;
    state!: boolean | undefined;
    id!: number;

    constructor(data?: IUserEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.description = data["description"];
            this.createdBy = data["createdBy"];
            this.modefiedBy = data["modefiedBy"];
            this.created = data["created"] ? moment(data["created"].toString()) : <any>undefined;
            this.modified = data["modified"] ? moment(data["modified"].toString()) : <any>undefined;
            this.state = data["state"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["createdBy"] = this.createdBy;
        data["modefiedBy"] = this.modefiedBy;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["state"] = this.state;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserEntityDto {
    title: string | undefined;
    description: string | undefined;
    createdBy: number;
    modefiedBy: number | undefined;
    created: moment.Moment;
    modified: moment.Moment | undefined;
    state: boolean | undefined;
    id: number;
}

export class GetUserEntityForViewDto implements IGetUserEntityForViewDto {
    userEntity!: UserEntityDto;

    constructor(data?: IGetUserEntityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userEntity = data["userEntity"] ? UserEntityDto.fromJS(data["userEntity"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUserEntityForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserEntityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userEntity"] = this.userEntity ? this.userEntity.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetUserEntityForViewDto {
    userEntity: UserEntityDto;
}

export class PagedResultDtoOfGetUserEntityForViewDto implements IPagedResultDtoOfGetUserEntityForViewDto {
    totalCount!: number;
    items!: GetUserEntityForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetUserEntityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetUserEntityForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetUserEntityForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetUserEntityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetUserEntityForViewDto {
    totalCount: number;
    items: GetUserEntityForViewDto[] | undefined;
}

export class CreateOrEditUserEntityDto implements ICreateOrEditUserEntityDto {
    title!: string | undefined;
    description!: string | undefined;
    createdBy!: number;
    modefiedBy!: number | undefined;
    created!: moment.Moment;
    modified!: moment.Moment | undefined;
    state!: boolean | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditUserEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.description = data["description"];
            this.createdBy = data["createdBy"];
            this.modefiedBy = data["modefiedBy"];
            this.created = data["created"] ? moment(data["created"].toString()) : <any>undefined;
            this.modified = data["modified"] ? moment(data["modified"].toString()) : <any>undefined;
            this.state = data["state"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditUserEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditUserEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["createdBy"] = this.createdBy;
        data["modefiedBy"] = this.modefiedBy;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["state"] = this.state;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditUserEntityDto {
    title: string | undefined;
    description: string | undefined;
    createdBy: number;
    modefiedBy: number | undefined;
    created: moment.Moment;
    modified: moment.Moment | undefined;
    state: boolean | undefined;
    id: number | undefined;
}

export class GetUserEntityForEditOutput implements IGetUserEntityForEditOutput {
    userEntity!: CreateOrEditUserEntityDto;

    constructor(data?: IGetUserEntityForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userEntity = data["userEntity"] ? CreateOrEditUserEntityDto.fromJS(data["userEntity"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUserEntityForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserEntityForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userEntity"] = this.userEntity ? this.userEntity.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetUserEntityForEditOutput {
    userEntity: CreateOrEditUserEntityDto;
}

export class GetUserEntityValueForViewDto implements IGetUserEntityValueForViewDto {
    userEntityValue!: UserEntityValueDto;
    userEntityTitle!: string | undefined;

    constructor(data?: IGetUserEntityValueForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userEntityValue = data["userEntityValue"] ? UserEntityValueDto.fromJS(data["userEntityValue"]) : <any>undefined;
            this.userEntityTitle = data["userEntityTitle"];
        }
    }

    static fromJS(data: any): GetUserEntityValueForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserEntityValueForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userEntityValue"] = this.userEntityValue ? this.userEntityValue.toJSON() : <any>undefined;
        data["userEntityTitle"] = this.userEntityTitle;
        return data; 
    }
}

export interface IGetUserEntityValueForViewDto {
    userEntityValue: UserEntityValueDto;
    userEntityTitle: string | undefined;
}

export class PagedResultDtoOfGetUserEntityValueForViewDto implements IPagedResultDtoOfGetUserEntityValueForViewDto {
    totalCount!: number;
    items!: GetUserEntityValueForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetUserEntityValueForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetUserEntityValueForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetUserEntityValueForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetUserEntityValueForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetUserEntityValueForViewDto {
    totalCount: number;
    items: GetUserEntityValueForViewDto[] | undefined;
}

export class CreateOrEditUserEntityValueDto implements ICreateOrEditUserEntityValueDto {
    value!: string | undefined;
    description!: string | undefined;
    created!: moment.Moment;
    modified!: moment.Moment | undefined;
    createdBy!: number;
    modifiedBy!: number | undefined;
    state!: boolean | undefined;
    userEntityId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditUserEntityValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"];
            this.description = data["description"];
            this.created = data["created"] ? moment(data["created"].toString()) : <any>undefined;
            this.modified = data["modified"] ? moment(data["modified"].toString()) : <any>undefined;
            this.createdBy = data["createdBy"];
            this.modifiedBy = data["modifiedBy"];
            this.state = data["state"];
            this.userEntityId = data["userEntityId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditUserEntityValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditUserEntityValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["description"] = this.description;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["modifiedBy"] = this.modifiedBy;
        data["state"] = this.state;
        data["userEntityId"] = this.userEntityId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditUserEntityValueDto {
    value: string | undefined;
    description: string | undefined;
    created: moment.Moment;
    modified: moment.Moment | undefined;
    createdBy: number;
    modifiedBy: number | undefined;
    state: boolean | undefined;
    userEntityId: number;
    id: number | undefined;
}

export class GetUserEntityValueForEditOutput implements IGetUserEntityValueForEditOutput {
    userEntityValue!: CreateOrEditUserEntityValueDto;
    userEntityTitle!: string | undefined;

    constructor(data?: IGetUserEntityValueForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userEntityValue = data["userEntityValue"] ? CreateOrEditUserEntityValueDto.fromJS(data["userEntityValue"]) : <any>undefined;
            this.userEntityTitle = data["userEntityTitle"];
        }
    }

    static fromJS(data: any): GetUserEntityValueForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserEntityValueForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userEntityValue"] = this.userEntityValue ? this.userEntityValue.toJSON() : <any>undefined;
        data["userEntityTitle"] = this.userEntityTitle;
        return data; 
    }
}

export interface IGetUserEntityValueForEditOutput {
    userEntityValue: CreateOrEditUserEntityValueDto;
    userEntityTitle: string | undefined;
}

export class UserEntityValueUserEntityLookupTableDto implements IUserEntityValueUserEntityLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IUserEntityValueUserEntityLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): UserEntityValueUserEntityLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserEntityValueUserEntityLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IUserEntityValueUserEntityLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class PagedResultDtoOfUserEntityValueUserEntityLookupTableDto implements IPagedResultDtoOfUserEntityValueUserEntityLookupTableDto {
    totalCount!: number;
    items!: UserEntityValueUserEntityLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserEntityValueUserEntityLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(UserEntityValueUserEntityLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserEntityValueUserEntityLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserEntityValueUserEntityLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfUserEntityValueUserEntityLookupTableDto {
    totalCount: number;
    items: UserEntityValueUserEntityLookupTableDto[] | undefined;
}

export class LinkToUserInput implements ILinkToUserInput {
    tenancyName!: string | undefined;
    usernameOrEmailAddress!: string | undefined;
    password!: string | undefined;

    constructor(data?: ILinkToUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.usernameOrEmailAddress = data["usernameOrEmailAddress"];
            this.password = data["password"];
        }
    }

    static fromJS(data: any): LinkToUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new LinkToUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["usernameOrEmailAddress"] = this.usernameOrEmailAddress;
        data["password"] = this.password;
        return data; 
    }
}

export interface ILinkToUserInput {
    tenancyName: string | undefined;
    usernameOrEmailAddress: string | undefined;
    password: string | undefined;
}

export class LinkedUserDto implements ILinkedUserDto {
    tenantId!: number | undefined;
    tenancyName!: string | undefined;
    username!: string | undefined;
    id!: number;

    constructor(data?: ILinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.tenancyName = data["tenancyName"];
            this.username = data["username"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): LinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["username"] = this.username;
        data["id"] = this.id;
        return data; 
    }
}

export interface ILinkedUserDto {
    tenantId: number | undefined;
    tenancyName: string | undefined;
    username: string | undefined;
    id: number;
}

export class PagedResultDtoOfLinkedUserDto implements IPagedResultDtoOfLinkedUserDto {
    totalCount!: number;
    items!: LinkedUserDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(LinkedUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfLinkedUserDto {
    totalCount: number;
    items: LinkedUserDto[] | undefined;
}

export class ListResultDtoOfLinkedUserDto implements IListResultDtoOfLinkedUserDto {
    items!: LinkedUserDto[] | undefined;

    constructor(data?: IListResultDtoOfLinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(LinkedUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfLinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfLinkedUserDto {
    items: LinkedUserDto[] | undefined;
}

export class UnlinkUserInput implements IUnlinkUserInput {
    tenantId!: number | undefined;
    userId!: number;

    constructor(data?: IUnlinkUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
        }
    }

    static fromJS(data: any): UnlinkUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new UnlinkUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data; 
    }
}

export interface IUnlinkUserInput {
    tenantId: number | undefined;
    userId: number;
}

export class UserLoginAttemptDto implements IUserLoginAttemptDto {
    tenancyName!: string | undefined;
    userNameOrEmail!: string | undefined;
    clientIpAddress!: string | undefined;
    clientName!: string | undefined;
    browserInfo!: string | undefined;
    result!: string | undefined;
    creationTime!: moment.Moment;

    constructor(data?: IUserLoginAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.userNameOrEmail = data["userNameOrEmail"];
            this.clientIpAddress = data["clientIpAddress"];
            this.clientName = data["clientName"];
            this.browserInfo = data["browserInfo"];
            this.result = data["result"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserLoginAttemptDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginAttemptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userNameOrEmail"] = this.userNameOrEmail;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["result"] = this.result;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IUserLoginAttemptDto {
    tenancyName: string | undefined;
    userNameOrEmail: string | undefined;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    result: string | undefined;
    creationTime: moment.Moment;
}

export class ListResultDtoOfUserLoginAttemptDto implements IListResultDtoOfUserLoginAttemptDto {
    items!: UserLoginAttemptDto[] | undefined;

    constructor(data?: IListResultDtoOfUserLoginAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(UserLoginAttemptDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfUserLoginAttemptDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfUserLoginAttemptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfUserLoginAttemptDto {
    items: UserLoginAttemptDto[] | undefined;
}

export class VisitCountDto implements IVisitCountDto {
    count!: number;
    entityRef!: number;
    entity!: Entities;
    id!: number;

    constructor(data?: IVisitCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.count = data["count"];
            this.entityRef = data["entityRef"];
            this.entity = data["entity"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): VisitCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new VisitCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        data["entityRef"] = this.entityRef;
        data["entity"] = this.entity;
        data["id"] = this.id;
        return data; 
    }
}

export interface IVisitCountDto {
    count: number;
    entityRef: number;
    entity: Entities;
    id: number;
}

export class GetVisitCountForViewDto implements IGetVisitCountForViewDto {
    visitCount!: VisitCountDto;

    constructor(data?: IGetVisitCountForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.visitCount = data["visitCount"] ? VisitCountDto.fromJS(data["visitCount"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetVisitCountForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetVisitCountForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["visitCount"] = this.visitCount ? this.visitCount.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetVisitCountForViewDto {
    visitCount: VisitCountDto;
}

export class PagedResultDtoOfGetVisitCountForViewDto implements IPagedResultDtoOfGetVisitCountForViewDto {
    totalCount!: number;
    items!: GetVisitCountForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetVisitCountForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetVisitCountForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetVisitCountForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetVisitCountForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetVisitCountForViewDto {
    totalCount: number;
    items: GetVisitCountForViewDto[] | undefined;
}

export class CreateOrEditVisitCountDto implements ICreateOrEditVisitCountDto {
    count!: number;
    entityRef!: number;
    entity!: Entities;
    id!: number | undefined;

    constructor(data?: ICreateOrEditVisitCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.count = data["count"];
            this.entityRef = data["entityRef"];
            this.entity = data["entity"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditVisitCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditVisitCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        data["entityRef"] = this.entityRef;
        data["entity"] = this.entity;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditVisitCountDto {
    count: number;
    entityRef: number;
    entity: Entities;
    id: number | undefined;
}

export class GetVisitCountForEditOutput implements IGetVisitCountForEditOutput {
    visitCount!: CreateOrEditVisitCountDto;

    constructor(data?: IGetVisitCountForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.visitCount = data["visitCount"] ? CreateOrEditVisitCountDto.fromJS(data["visitCount"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetVisitCountForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetVisitCountForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["visitCount"] = this.visitCount ? this.visitCount.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetVisitCountForEditOutput {
    visitCount: CreateOrEditVisitCountDto;
}

export class VoucherDetailDto implements IVoucherDetailDto {
    code!: string | undefined;
    appointmentDate!: moment.Moment | undefined;
    amount!: number | undefined;
    dueDate!: moment.Moment | undefined;
    serviceVoucherRef!: number;
    approverRef!: number | undefined;
    approvedDateTime!: moment.Moment | undefined;
    id!: number;

    constructor(data?: IVoucherDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.appointmentDate = data["appointmentDate"] ? moment(data["appointmentDate"].toString()) : <any>undefined;
            this.amount = data["amount"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.serviceVoucherRef = data["serviceVoucherRef"];
            this.approverRef = data["approverRef"];
            this.approvedDateTime = data["approvedDateTime"] ? moment(data["approvedDateTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): VoucherDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["appointmentDate"] = this.appointmentDate ? this.appointmentDate.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["serviceVoucherRef"] = this.serviceVoucherRef;
        data["approverRef"] = this.approverRef;
        data["approvedDateTime"] = this.approvedDateTime ? this.approvedDateTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IVoucherDetailDto {
    code: string | undefined;
    appointmentDate: moment.Moment | undefined;
    amount: number | undefined;
    dueDate: moment.Moment | undefined;
    serviceVoucherRef: number;
    approverRef: number | undefined;
    approvedDateTime: moment.Moment | undefined;
    id: number;
}

export class GetVoucherDetailForViewDto implements IGetVoucherDetailForViewDto {
    voucherDetail!: VoucherDetailDto;
    serviceVoucherCode!: string | undefined;
    serviceTitle!: string | undefined;
    entity!: Entities;
    entityRefName!: string | undefined;
    approverServiceVoucherName!: string | undefined;
    approvedServiceVoucherDate!: moment.Moment | undefined;

    constructor(data?: IGetVoucherDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherDetail = data["voucherDetail"] ? VoucherDetailDto.fromJS(data["voucherDetail"]) : <any>undefined;
            this.serviceVoucherCode = data["serviceVoucherCode"];
            this.serviceTitle = data["serviceTitle"];
            this.entity = data["entity"];
            this.entityRefName = data["entityRefName"];
            this.approverServiceVoucherName = data["approverServiceVoucherName"];
            this.approvedServiceVoucherDate = data["approvedServiceVoucherDate"] ? moment(data["approvedServiceVoucherDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetVoucherDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetVoucherDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherDetail"] = this.voucherDetail ? this.voucherDetail.toJSON() : <any>undefined;
        data["serviceVoucherCode"] = this.serviceVoucherCode;
        data["serviceTitle"] = this.serviceTitle;
        data["entity"] = this.entity;
        data["entityRefName"] = this.entityRefName;
        data["approverServiceVoucherName"] = this.approverServiceVoucherName;
        data["approvedServiceVoucherDate"] = this.approvedServiceVoucherDate ? this.approvedServiceVoucherDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGetVoucherDetailForViewDto {
    voucherDetail: VoucherDetailDto;
    serviceVoucherCode: string | undefined;
    serviceTitle: string | undefined;
    entity: Entities;
    entityRefName: string | undefined;
    approverServiceVoucherName: string | undefined;
    approvedServiceVoucherDate: moment.Moment | undefined;
}

export class PagedResultDtoOfGetVoucherDetailForViewDto implements IPagedResultDtoOfGetVoucherDetailForViewDto {
    totalCount!: number;
    items!: GetVoucherDetailForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetVoucherDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetVoucherDetailForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetVoucherDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetVoucherDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetVoucherDetailForViewDto {
    totalCount: number;
    items: GetVoucherDetailForViewDto[] | undefined;
}

export class CreateOrEditVoucherDetailDto implements ICreateOrEditVoucherDetailDto {
    code!: string | undefined;
    appointmentDate!: moment.Moment | undefined;
    amount!: number | undefined;
    dueDate!: moment.Moment | undefined;
    serviceVoucherRef!: number;
    approverRef!: number | undefined;
    approvedDateTime!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditVoucherDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.appointmentDate = data["appointmentDate"] ? moment(data["appointmentDate"].toString()) : <any>undefined;
            this.amount = data["amount"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.serviceVoucherRef = data["serviceVoucherRef"];
            this.approverRef = data["approverRef"];
            this.approvedDateTime = data["approvedDateTime"] ? moment(data["approvedDateTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditVoucherDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditVoucherDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["appointmentDate"] = this.appointmentDate ? this.appointmentDate.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["serviceVoucherRef"] = this.serviceVoucherRef;
        data["approverRef"] = this.approverRef;
        data["approvedDateTime"] = this.approvedDateTime ? this.approvedDateTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditVoucherDetailDto {
    code: string | undefined;
    appointmentDate: moment.Moment | undefined;
    amount: number | undefined;
    dueDate: moment.Moment | undefined;
    serviceVoucherRef: number;
    approverRef: number | undefined;
    approvedDateTime: moment.Moment | undefined;
    id: number | undefined;
}

export class GetVoucherDetailForEditOutput implements IGetVoucherDetailForEditOutput {
    voucherDetail!: CreateOrEditVoucherDetailDto;
    serviceVoucherCode!: string | undefined;
    isTakeTurn!: boolean;

    constructor(data?: IGetVoucherDetailForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherDetail = data["voucherDetail"] ? CreateOrEditVoucherDetailDto.fromJS(data["voucherDetail"]) : <any>undefined;
            this.serviceVoucherCode = data["serviceVoucherCode"];
            this.isTakeTurn = data["isTakeTurn"];
        }
    }

    static fromJS(data: any): GetVoucherDetailForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetVoucherDetailForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherDetail"] = this.voucherDetail ? this.voucherDetail.toJSON() : <any>undefined;
        data["serviceVoucherCode"] = this.serviceVoucherCode;
        data["isTakeTurn"] = this.isTakeTurn;
        return data; 
    }
}

export interface IGetVoucherDetailForEditOutput {
    voucherDetail: CreateOrEditVoucherDetailDto;
    serviceVoucherCode: string | undefined;
    isTakeTurn: boolean;
}

export class VoucherDetailServiceVoucherLookupTableDto implements IVoucherDetailServiceVoucherLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    serviceTitle!: string | undefined;
    entity!: Entities;
    entityRefName!: string | undefined;
    isTakeTurn!: boolean;

    constructor(data?: IVoucherDetailServiceVoucherLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.serviceTitle = data["serviceTitle"];
            this.entity = data["entity"];
            this.entityRefName = data["entityRefName"];
            this.isTakeTurn = data["isTakeTurn"];
        }
    }

    static fromJS(data: any): VoucherDetailServiceVoucherLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherDetailServiceVoucherLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["serviceTitle"] = this.serviceTitle;
        data["entity"] = this.entity;
        data["entityRefName"] = this.entityRefName;
        data["isTakeTurn"] = this.isTakeTurn;
        return data; 
    }
}

export interface IVoucherDetailServiceVoucherLookupTableDto {
    id: number;
    displayName: string | undefined;
    serviceTitle: string | undefined;
    entity: Entities;
    entityRefName: string | undefined;
    isTakeTurn: boolean;
}

export class PagedResultDtoOfVoucherDetailServiceVoucherLookupTableDto implements IPagedResultDtoOfVoucherDetailServiceVoucherLookupTableDto {
    totalCount!: number;
    items!: VoucherDetailServiceVoucherLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfVoucherDetailServiceVoucherLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(VoucherDetailServiceVoucherLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfVoucherDetailServiceVoucherLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfVoucherDetailServiceVoucherLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfVoucherDetailServiceVoucherLookupTableDto {
    totalCount: number;
    items: VoucherDetailServiceVoucherLookupTableDto[] | undefined;
}

export enum ClassName {
    Test = 1,
}

export class WageDto implements IWageDto {
    title!: string | undefined;
    className!: ClassName;
    description!: string | undefined;
    created!: moment.Moment;
    createdBy!: number;
    modified!: moment.Moment | undefined;
    modifiedBy!: number | undefined;
    state!: boolean;
    id!: number;

    constructor(data?: IWageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.className = data["className"];
            this.description = data["description"];
            this.created = data["created"] ? moment(data["created"].toString()) : <any>undefined;
            this.createdBy = data["createdBy"];
            this.modified = data["modified"] ? moment(data["modified"].toString()) : <any>undefined;
            this.modifiedBy = data["modifiedBy"];
            this.state = data["state"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): WageDto {
        data = typeof data === 'object' ? data : {};
        let result = new WageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["className"] = this.className;
        data["description"] = this.description;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["state"] = this.state;
        data["id"] = this.id;
        return data; 
    }
}

export interface IWageDto {
    title: string | undefined;
    className: ClassName;
    description: string | undefined;
    created: moment.Moment;
    createdBy: number;
    modified: moment.Moment | undefined;
    modifiedBy: number | undefined;
    state: boolean;
    id: number;
}

export class GetWageForViewDto implements IGetWageForViewDto {
    wage!: WageDto;

    constructor(data?: IGetWageForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.wage = data["wage"] ? WageDto.fromJS(data["wage"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetWageForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetWageForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wage"] = this.wage ? this.wage.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetWageForViewDto {
    wage: WageDto;
}

export class PagedResultDtoOfGetWageForViewDto implements IPagedResultDtoOfGetWageForViewDto {
    totalCount!: number;
    items!: GetWageForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetWageForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetWageForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetWageForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetWageForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetWageForViewDto {
    totalCount: number;
    items: GetWageForViewDto[] | undefined;
}

export class CreateOrEditWageDto implements ICreateOrEditWageDto {
    title!: string | undefined;
    className!: ClassName;
    description!: string | undefined;
    created!: moment.Moment;
    createdBy!: number;
    modified!: moment.Moment | undefined;
    modifiedBy!: number | undefined;
    state!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditWageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.className = data["className"];
            this.description = data["description"];
            this.created = data["created"] ? moment(data["created"].toString()) : <any>undefined;
            this.createdBy = data["createdBy"];
            this.modified = data["modified"] ? moment(data["modified"].toString()) : <any>undefined;
            this.modifiedBy = data["modifiedBy"];
            this.state = data["state"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditWageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditWageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["className"] = this.className;
        data["description"] = this.description;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["state"] = this.state;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditWageDto {
    title: string | undefined;
    className: ClassName;
    description: string | undefined;
    created: moment.Moment;
    createdBy: number;
    modified: moment.Moment | undefined;
    modifiedBy: number | undefined;
    state: boolean;
    id: number | undefined;
}

export class GetWageForEditOutput implements IGetWageForEditOutput {
    wage!: CreateOrEditWageDto;

    constructor(data?: IGetWageForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.wage = data["wage"] ? CreateOrEditWageDto.fromJS(data["wage"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetWageForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetWageForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wage"] = this.wage ? this.wage.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetWageForEditOutput {
    wage: CreateOrEditWageDto;
}

export class GetLatestWebLogsOutput implements IGetLatestWebLogsOutput {
    latestWebLogLines!: string[] | undefined;

    constructor(data?: IGetLatestWebLogsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["latestWebLogLines"])) {
                this.latestWebLogLines = [] as any;
                for (let item of data["latestWebLogLines"])
                    this.latestWebLogLines!.push(item);
            }
        }
    }

    static fromJS(data: any): GetLatestWebLogsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLatestWebLogsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.latestWebLogLines)) {
            data["latestWebLogLines"] = [];
            for (let item of this.latestWebLogLines)
                data["latestWebLogLines"].push(item);
        }
        return data; 
    }
}

export interface IGetLatestWebLogsOutput {
    latestWebLogLines: string[] | undefined;
}

export class WizardStepDto implements IWizardStepDto {
    planType!: Plans;
    steps!: string | undefined;
    wizardPath!: PathToWizard;
    id!: number;

    constructor(data?: IWizardStepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.planType = data["planType"];
            this.steps = data["steps"];
            this.wizardPath = data["wizardPath"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): WizardStepDto {
        data = typeof data === 'object' ? data : {};
        let result = new WizardStepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planType"] = this.planType;
        data["steps"] = this.steps;
        data["wizardPath"] = this.wizardPath;
        data["id"] = this.id;
        return data; 
    }
}

export interface IWizardStepDto {
    planType: Plans;
    steps: string | undefined;
    wizardPath: PathToWizard;
    id: number;
}

export class GetWizardStepForViewDto implements IGetWizardStepForViewDto {
    wizardStep!: WizardStepDto;

    constructor(data?: IGetWizardStepForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.wizardStep = data["wizardStep"] ? WizardStepDto.fromJS(data["wizardStep"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetWizardStepForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetWizardStepForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wizardStep"] = this.wizardStep ? this.wizardStep.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetWizardStepForViewDto {
    wizardStep: WizardStepDto;
}

export class PagedResultDtoOfGetWizardStepForViewDto implements IPagedResultDtoOfGetWizardStepForViewDto {
    totalCount!: number;
    items!: GetWizardStepForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetWizardStepForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetWizardStepForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetWizardStepForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetWizardStepForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetWizardStepForViewDto {
    totalCount: number;
    items: GetWizardStepForViewDto[] | undefined;
}

export class GetWizardStepForEditOutput implements IGetWizardStepForEditOutput {
    wizardStep!: CreateOrEditWizardStepDto;

    constructor(data?: IGetWizardStepForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.wizardStep = data["wizardStep"] ? CreateOrEditWizardStepDto.fromJS(data["wizardStep"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetWizardStepForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetWizardStepForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wizardStep"] = this.wizardStep ? this.wizardStep.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetWizardStepForEditOutput {
    wizardStep: CreateOrEditWizardStepDto;
}

export class AdditionalData implements IAdditionalData {
    paypal!: { [key: string]: string; };
    stripe!: { [key: string]: string; };

    constructor(data?: IAdditionalData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["Paypal"]) {
                this.paypal = {} as any;
                for (let key in data["Paypal"]) {
                    if (data["Paypal"].hasOwnProperty(key))
                        this.paypal![key] = data["Paypal"][key];
                }
            }
            if (data["Stripe"]) {
                this.stripe = {} as any;
                for (let key in data["Stripe"]) {
                    if (data["Stripe"].hasOwnProperty(key))
                        this.stripe![key] = data["Stripe"][key];
                }
            }
        }
    }

    static fromJS(data: any): AdditionalData {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.paypal) {
            data["Paypal"] = {};
            for (let key in this.paypal) {
                if (this.paypal.hasOwnProperty(key))
                    data["Paypal"][key] = this.paypal[key];
            }
        }
        if (this.stripe) {
            data["Stripe"] = {};
            for (let key in this.stripe) {
                if (this.stripe.hasOwnProperty(key))
                    data["Stripe"][key] = this.stripe[key];
            }
        }
        return data; 
    }
}

export interface IAdditionalData {
    paypal: { [key: string]: string; };
    stripe: { [key: string]: string; };
}

export class ApiException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader(); 
            reader.onload = event => { 
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob); 
        }
    });
}